export const laneInfo={
    "level1":{
     "lane1":[
        {
            "x": -0.1407405138015747,
            "y": 0.006439857184886932,
            "z": -419.77880859375
        },
        {
            "x": -0.14091870188713074,
            "y": 0.006433375179767609,
            "z": -419.6216125488281
        },
        {
            "x": -0.14109700918197632,
            "y": 0.006426915526390076,
            "z": -419.46435546875
        },
        {
            "x": -0.14127543568611145,
            "y": 0.006420411169528961,
            "z": -419.3069152832031
        },
        {
            "x": -0.14145374298095703,
            "y": 0.0064139291644096375,
            "z": -419.1496887207031
        },
        {
            "x": -0.14163196086883545,
            "y": 0.006407454609870911,
            "z": -418.9924621582031
        },
        {
            "x": -0.14181029796600342,
            "y": 0.006400957703590393,
            "z": -418.8351135253906
        },
        {
            "x": -0.1419885754585266,
            "y": 0.006394483149051666,
            "z": -418.6778869628906
        },
        {
            "x": -0.14216691255569458,
            "y": 0.006387986242771149,
            "z": -418.5205383300781
        },
        {
            "x": -0.1423453390598297,
            "y": 0.006381511688232422,
            "z": -418.3632507324219
        },
        {
            "x": -0.14252349734306335,
            "y": 0.006375022232532501,
            "z": -418.2059631347656
        },
        {
            "x": -0.1427018940448761,
            "y": 0.006368547677993774,
            "z": -418.0486755371094
        },
        {
            "x": -0.1428801417350769,
            "y": 0.006362065672874451,
            "z": -417.89141845703125
        },
        {
            "x": -0.1430584192276001,
            "y": 0.00635557621717453,
            "z": -417.7342224121094
        },
        {
            "x": -0.14323684573173523,
            "y": 0.006349094212055206,
            "z": -417.5767517089844
        },
        {
            "x": -0.1434151530265808,
            "y": 0.006342612206935883,
            "z": -417.4195251464844
        },
        {
            "x": -0.143593430519104,
            "y": 0.006336122751235962,
            "z": -417.2622375488281
        },
        {
            "x": -0.1437716782093048,
            "y": 0.006329648196697235,
            "z": -417.1049499511719
        },
        {
            "x": -0.1439499855041504,
            "y": 0.006323173642158508,
            "z": -416.9477233886719
        },
        {
            "x": -0.14412838220596313,
            "y": 0.006316676735877991,
            "z": -416.7902526855469
        },
        {
            "x": -0.14430665969848633,
            "y": 0.006310194730758667,
            "z": -416.633056640625
        },
        {
            "x": -0.14448493719100952,
            "y": 0.006303697824478149,
            "z": -416.475830078125
        },
        {
            "x": -0.14466318488121033,
            "y": 0.00629725307226181,
            "z": -416.3185729980469
        },
        {
            "x": -0.14484143257141113,
            "y": 0.006290756165981293,
            "z": -416.1613464355469
        },
        {
            "x": -0.1450197696685791,
            "y": 0.006284259259700775,
            "z": -416.0040283203125
        },
        {
            "x": -0.14519810676574707,
            "y": 0.006277814507484436,
            "z": -415.8467102050781
        },
        {
            "x": -0.14537641406059265,
            "y": 0.0062713176012039185,
            "z": -415.689453125
        },
        {
            "x": -0.14555472135543823,
            "y": 0.006264820694923401,
            "z": -415.5321350097656
        },
        {
            "x": -0.14573296904563904,
            "y": 0.006258346140384674,
            "z": -415.3749084472656
        },
        {
            "x": -0.14591124653816223,
            "y": 0.006251901388168335,
            "z": -415.2176208496094
        },
        {
            "x": -0.14608964323997498,
            "y": 0.006245382130146027,
            "z": -415.06024169921875
        },
        {
            "x": -0.14626798033714294,
            "y": 0.006238885223865509,
            "z": -414.9029846191406
        },
        {
            "x": -0.14644628763198853,
            "y": 0.006232410669326782,
            "z": -414.7456970214844
        },
        {
            "x": -0.1466245949268341,
            "y": 0.00622597336769104,
            "z": -414.5884094238281
        },
        {
            "x": -0.1468028426170349,
            "y": 0.006219439208507538,
            "z": -414.4311828613281
        },
        {
            "x": -0.14698123931884766,
            "y": 0.006212949752807617,
            "z": -414.2737731933594
        },
        {
            "x": -0.14715954661369324,
            "y": 0.0062064677476882935,
            "z": -414.1165466308594
        },
        {
            "x": -0.14733782410621643,
            "y": 0.006200000643730164,
            "z": -413.95928955078125
        },
        {
            "x": -0.14751610159873962,
            "y": 0.006193496286869049,
            "z": -413.8019714355469
        },
        {
            "x": -0.1476944088935852,
            "y": 0.006187021732330322,
            "z": -413.64471435546875
        },
        {
            "x": -0.1478727161884308,
            "y": 0.0061805397272109985,
            "z": -413.4873962402344
        },
        {
            "x": -0.14805108308792114,
            "y": 0.006174065172672272,
            "z": -413.3301086425781
        },
        {
            "x": -0.14822936058044434,
            "y": 0.006167598068714142,
            "z": -413.1728210449219
        },
        {
            "x": -0.14834809303283691,
            "y": 0.006163261830806732,
            "z": -413.0680236816406
        },
        {
            "x": -0.1485264003276825,
            "y": 0.006156787276268005,
            "z": -412.9107360839844
        },
        {
            "x": -0.1487046480178833,
            "y": 0.006150305271148682,
            "z": -412.7535400390625
        },
        {
            "x": -0.14888310432434082,
            "y": 0.006143800914287567,
            "z": -412.59613037109375
        },
        {
            "x": -0.1490614116191864,
            "y": 0.0061373040080070496,
            "z": -412.4388732910156
        },
        {
            "x": -0.1492396891117096,
            "y": 0.00613083690404892,
            "z": -412.2816467285156
        },
        {
            "x": -0.149417906999588,
            "y": 0.006124392151832581,
            "z": -412.1242980957031
        },
        {
            "x": -0.14959624409675598,
            "y": 0.006117887794971466,
            "z": -411.9670715332031
        },
        {
            "x": -0.14977458119392395,
            "y": 0.0061113908886909485,
            "z": -411.8097229003906
        },
        {
            "x": -0.14995288848876953,
            "y": 0.006104901432991028,
            "z": -411.6524353027344
        },
        {
            "x": -0.1501312255859375,
            "y": 0.006098411977291107,
            "z": -411.49517822265625
        },
        {
            "x": -0.15030953288078308,
            "y": 0.006091944873332977,
            "z": -411.3378601074219
        },
        {
            "x": -0.15048784017562866,
            "y": 0.006085455417633057,
            "z": -411.18060302734375
        },
        {
            "x": -0.15066608786582947,
            "y": 0.006078973412513733,
            "z": -411.02337646484375
        },
        {
            "x": -0.150844544172287,
            "y": 0.006072506308555603,
            "z": -410.8659362792969
        },
        {
            "x": -0.1510227918624878,
            "y": 0.0060660094022750854,
            "z": -410.7087097167969
        },
        {
            "x": -0.1512010395526886,
            "y": 0.006059534847736359,
            "z": -410.5514221191406
        },
        {
            "x": -0.15137940645217896,
            "y": 0.006053030490875244,
            "z": -410.3941345214844
        },
        {
            "x": -0.15155762434005737,
            "y": 0.006046578288078308,
            "z": -410.2369079589844
        },
        {
            "x": -0.1517360508441925,
            "y": 0.006040073931217194,
            "z": -410.0794982910156
        },
        {
            "x": -0.1519143283367157,
            "y": 0.006033584475517273,
            "z": -409.9222717285156
        },
        {
            "x": -0.1520926058292389,
            "y": 0.006027117371559143,
            "z": -409.7649841308594
        },
        {
            "x": -0.15227079391479492,
            "y": 0.006020650267601013,
            "z": -409.6077880859375
        },
        {
            "x": -0.1524491012096405,
            "y": 0.006014145910739899,
            "z": -409.4505615234375
        },
        {
            "x": -0.15262746810913086,
            "y": 0.006007656455039978,
            "z": -409.2932434082031
        },
        {
            "x": -0.15280577540397644,
            "y": 0.006001166999340057,
            "z": -409.1358947753906
        },
        {
            "x": -0.15298405289649963,
            "y": 0.005994684994220734,
            "z": -408.9786682128906
        },
        {
            "x": -0.1531623899936676,
            "y": 0.00598820298910141,
            "z": -408.8213195800781
        },
        {
            "x": -0.15334069728851318,
            "y": 0.005981743335723877,
            "z": -408.6640930175781
        },
        {
            "x": -0.1535188853740692,
            "y": 0.0059752389788627625,
            "z": -408.5068664550781
        },
        {
            "x": -0.15369734168052673,
            "y": 0.005968764424324036,
            "z": -408.3494567871094
        },
        {
            "x": -0.15387561917304993,
            "y": 0.005962282419204712,
            "z": -408.1921691894531
        },
        {
            "x": -0.15405389666557312,
            "y": 0.005955785512924194,
            "z": -408.0348815917969
        },
        {
            "x": -0.1542322337627411,
            "y": 0.005949303507804871,
            "z": -407.8775939941406
        },
        {
            "x": -0.1544104516506195,
            "y": 0.005942828953266144,
            "z": -407.7203674316406
        },
        {
            "x": -0.15458893775939941,
            "y": 0.005936339497566223,
            "z": -407.56292724609375
        },
        {
            "x": -0.15476718544960022,
            "y": 0.005929872393608093,
            "z": -407.40570068359375
        },
        {
            "x": -0.1549454629421234,
            "y": 0.005923382937908173,
            "z": -407.24847412109375
        },
        {
            "x": -0.15512380003929138,
            "y": 0.005916893482208252,
            "z": -407.09112548828125
        },
        {
            "x": -0.1553020477294922,
            "y": 0.005910433828830719,
            "z": -406.93389892578125
        },
        {
            "x": -0.15548035502433777,
            "y": 0.005903922021389008,
            "z": -406.77655029296875
        },
        {
            "x": -0.1556587517261505,
            "y": 0.005897440016269684,
            "z": -406.6192321777344
        },
        {
            "x": -0.1558370292186737,
            "y": 0.005890980362892151,
            "z": -406.4620056152344
        },
        {
            "x": -0.15595591068267822,
            "y": 0.005886659026145935,
            "z": -406.357177734375
        },
        {
            "x": -0.15613609552383423,
            "y": 0.005880087614059448,
            "z": -406.199951171875
        },
        {
            "x": -0.15631434321403503,
            "y": 0.005873620510101318,
            "z": -406.042724609375
        },
        {
            "x": -0.15649279952049255,
            "y": 0.005867131054401398,
            "z": -405.8852844238281
        },
        {
            "x": -0.15667107701301575,
            "y": 0.00586063414812088,
            "z": -405.7280578613281
        },
        {
            "x": -0.15684932470321655,
            "y": 0.005854152143001556,
            "z": -405.5708312988281
        },
        {
            "x": -0.15702766180038452,
            "y": 0.00584769994020462,
            "z": -405.4134826660156
        },
        {
            "x": -0.15720593929290771,
            "y": 0.005841188132762909,
            "z": -405.2562561035156
        },
        {
            "x": -0.15738433599472046,
            "y": 0.005834691226482391,
            "z": -405.0989074707031
        },
        {
            "x": -0.15756264328956604,
            "y": 0.0058282166719436646,
            "z": -404.94158935546875
        },
        {
            "x": -0.15774083137512207,
            "y": 0.0058217719197273254,
            "z": -404.78436279296875
        },
        {
            "x": -0.15791916847229004,
            "y": 0.005815282464027405,
            "z": -404.62701416015625
        },
        {
            "x": -0.158097505569458,
            "y": 0.005808785557746887,
            "z": -404.46978759765625
        },
        {
            "x": -0.15827572345733643,
            "y": 0.00580228865146637,
            "z": -404.31256103515625
        },
        {
            "x": -0.15845420956611633,
            "y": 0.005795828998088837,
            "z": -404.1551513671875
        },
        {
            "x": -0.15863242745399475,
            "y": 0.005789309740066528,
            "z": -403.9978942871094
        },
        {
            "x": -0.1588107943534851,
            "y": 0.0057828426361083984,
            "z": -403.84063720703125
        },
        {
            "x": -0.1589891016483307,
            "y": 0.005776353180408478,
            "z": -403.6833190917969
        },
        {
            "x": -0.1591673195362091,
            "y": 0.005769886076450348,
            "z": -403.5260925292969
        },
        {
            "x": -0.159345805644989,
            "y": 0.00576338917016983,
            "z": -403.36865234375
        },
        {
            "x": -0.15952399373054504,
            "y": 0.005756895989179611,
            "z": -403.21142578125
        },
        {
            "x": -0.15970230102539062,
            "y": 0.005750410258769989,
            "z": -403.05419921875
        },
        {
            "x": -0.15988057851791382,
            "y": 0.005743924528360367,
            "z": -402.89697265625
        },
        {
            "x": -0.16005879640579224,
            "y": 0.005737472325563431,
            "z": -402.73974609375
        },
        {
            "x": -0.1602371335029602,
            "y": 0.00573098286986351,
            "z": -402.5823974609375
        },
        {
            "x": -0.16041550040245056,
            "y": 0.0057244859635829926,
            "z": -402.425048828125
        },
        {
            "x": -0.16059380769729614,
            "y": 0.00571800023317337,
            "z": -402.2678527832031
        },
        {
            "x": -0.16077202558517456,
            "y": 0.0057115331292152405,
            "z": -402.11053466796875
        },
        {
            "x": -0.16095033288002014,
            "y": 0.005705051124095917,
            "z": -401.9532470703125
        },
        {
            "x": -0.16112861037254333,
            "y": 0.005698554217815399,
            "z": -401.7960205078125
        },
        {
            "x": -0.16130700707435608,
            "y": 0.005692079663276672,
            "z": -401.6386413574219
        },
        {
            "x": -0.16148525476455688,
            "y": 0.005685627460479736,
            "z": -401.48138427734375
        },
        {
            "x": -0.16166359186172485,
            "y": 0.005679100751876831,
            "z": -401.3240966796875
        },
        {
            "x": -0.16184189915657043,
            "y": 0.005672618746757507,
            "z": -401.16680908203125
        },
        {
            "x": -0.16202020645141602,
            "y": 0.005666136741638184,
            "z": -401.00958251953125
        },
        {
            "x": -0.16219863295555115,
            "y": 0.005659651011228561,
            "z": -400.8521728515625
        },
        {
            "x": -0.16237688064575195,
            "y": 0.0056531839072704315,
            "z": -400.6949157714844
        },
        {
            "x": -0.16255512833595276,
            "y": 0.005646690726280212,
            "z": -400.53765869140625
        },
        {
            "x": -0.16273343563079834,
            "y": 0.005640201270580292,
            "z": -400.38037109375
        },
        {
            "x": -0.16291174292564392,
            "y": 0.005633730441331863,
            "z": -400.22308349609375
        },
        {
            "x": -0.16309010982513428,
            "y": 0.005627237260341644,
            "z": -400.0657958984375
        },
        {
            "x": -0.16326844692230225,
            "y": 0.005620751529932022,
            "z": -399.9084777832031
        },
        {
            "x": -0.16344669461250305,
            "y": 0.005614280700683594,
            "z": -399.751220703125
        },
        {
            "x": -0.16356554627418518,
            "y": 0.005609970539808273,
            "z": -399.64642333984375
        },
        {
            "x": -0.1637437343597412,
            "y": 0.005603469908237457,
            "z": -399.4891357421875
        },
        {
            "x": -0.16392207145690918,
            "y": 0.0055969879031181335,
            "z": -399.33197021484375
        },
        {
            "x": -0.16410043835639954,
            "y": 0.005590494722127914,
            "z": -399.174560546875
        },
        {
            "x": -0.16427874565124512,
            "y": 0.005584042519330978,
            "z": -399.0173034667969
        },
        {
            "x": -0.16445699334144592,
            "y": 0.005577534437179565,
            "z": -398.8600769042969
        },
        {
            "x": -0.1646353006362915,
            "y": 0.005571052432060242,
            "z": -398.7027587890625
        },
        {
            "x": -0.16481363773345947,
            "y": 0.005564603954553604,
            "z": -398.5455017089844
        },
        {
            "x": -0.16499194502830505,
            "y": 0.005558084696531296,
            "z": -398.38818359375
        },
        {
            "x": -0.1651703119277954,
            "y": 0.005551610141992569,
            "z": -398.23089599609375
        },
        {
            "x": -0.165348619222641,
            "y": 0.005545113235712051,
            "z": -398.0736083984375
        },
        {
            "x": -0.16552689671516418,
            "y": 0.00553864985704422,
            "z": -397.916259765625
        },
        {
            "x": -0.16570517420768738,
            "y": 0.005532149225473404,
            "z": -397.759033203125
        },
        {
            "x": -0.16588345170021057,
            "y": 0.005525670945644379,
            "z": -397.601806640625
        },
        {
            "x": -0.1660618782043457,
            "y": 0.005519215017557144,
            "z": -397.44439697265625
        },
        {
            "x": -0.1662401556968689,
            "y": 0.005512714385986328,
            "z": -397.2871398925781
        },
        {
            "x": -0.16641846299171448,
            "y": 0.005506232380867004,
            "z": -397.1298522949219
        },
        {
            "x": -0.16659674048423767,
            "y": 0.005499739199876785,
            "z": -396.97259521484375
        },
        {
            "x": -0.16677501797676086,
            "y": 0.0054932571947574615,
            "z": -396.8153381347656
        },
        {
            "x": -0.1669534146785736,
            "y": 0.005486778914928436,
            "z": -396.6579284667969
        },
        {
            "x": -0.1671317219734192,
            "y": 0.005480289459228516,
            "z": -396.50067138671875
        },
        {
            "x": -0.16730999946594238,
            "y": 0.005473803728818893,
            "z": -396.3434143066406
        },
        {
            "x": -0.1674881875514984,
            "y": 0.005467347800731659,
            "z": -396.1861877441406
        },
        {
            "x": -0.1676664650440216,
            "y": 0.005460847169160843,
            "z": -396.0289611816406
        },
        {
            "x": -0.16784480214118958,
            "y": 0.005454361438751221,
            "z": -395.87164306640625
        },
        {
            "x": -0.16802310943603516,
            "y": 0.0054478831589221954,
            "z": -395.71429443359375
        },
        {
            "x": -0.16820144653320312,
            "y": 0.005441393703222275,
            "z": -395.55712890625
        },
        {
            "x": -0.1683797836303711,
            "y": 0.005434904247522354,
            "z": -395.3997802734375
        },
        {
            "x": -0.1685580611228943,
            "y": 0.00542842224240303,
            "z": -395.2425537109375
        },
        {
            "x": -0.16873633861541748,
            "y": 0.005421943962574005,
            "z": -395.0853271484375
        },
        {
            "x": -0.1689147651195526,
            "y": 0.0054154470562934875,
            "z": -394.9278869628906
        },
        {
            "x": -0.16909301280975342,
            "y": 0.00540899857878685,
            "z": -394.7706604003906
        },
        {
            "x": -0.169271320104599,
            "y": 0.005402490496635437,
            "z": -394.6133728027344
        },
        {
            "x": -0.1694495677947998,
            "y": 0.005396012216806412,
            "z": -394.4560546875
        },
        {
            "x": -0.169627845287323,
            "y": 0.005389537662267685,
            "z": -394.2988586425781
        },
        {
            "x": -0.1698063313961029,
            "y": 0.005383055657148361,
            "z": -394.14141845703125
        },
        {
            "x": -0.1699846088886261,
            "y": 0.005376551300287247,
            "z": -393.98419189453125
        },
        {
            "x": -0.17016282677650452,
            "y": 0.005370080471038818,
            "z": -393.82696533203125
        },
        {
            "x": -0.17034119367599487,
            "y": 0.005363617092370987,
            "z": -393.66961669921875
        },
        {
            "x": -0.17051944136619568,
            "y": 0.005357135087251663,
            "z": -393.51239013671875
        },
        {
            "x": -0.17069777846336365,
            "y": 0.005350623279809952,
            "z": -393.3550720214844
        },
        {
            "x": -0.170876145362854,
            "y": 0.005344141274690628,
            "z": -393.1977233886719
        },
        {
            "x": -0.1710544228553772,
            "y": 0.005337655544281006,
            "z": -393.0404968261719
        },
        {
            "x": -0.1711742877960205,
            "y": 0.0053332895040512085,
            "z": -392.9356689453125
        },
        {
            "x": -0.1713535189628601,
            "y": 0.0053267814218997955,
            "z": -392.7784423828125
        },
        {
            "x": -0.1715317666530609,
            "y": 0.005320299416780472,
            "z": -392.6212158203125
        },
        {
            "x": -0.17171019315719604,
            "y": 0.005313824862241745,
            "z": -392.4637756347656
        },
        {
            "x": -0.17188847064971924,
            "y": 0.005307350307703018,
            "z": -392.3065490722656
        },
        {
            "x": -0.17206671833992004,
            "y": 0.0053008608520030975,
            "z": -392.1493225097656
        },
        {
            "x": -0.1722450852394104,
            "y": 0.005294356495141983,
            "z": -391.9919738769531
        },
        {
            "x": -0.1724233329296112,
            "y": 0.005287915468215942,
            "z": -391.83477783203125
        },
        {
            "x": -0.17260167002677917,
            "y": 0.005281426012516022,
            "z": -391.6773681640625
        },
        {
            "x": -0.17278000712394714,
            "y": 0.005274936556816101,
            "z": -391.52008056640625
        },
        {
            "x": -0.17295828461647034,
            "y": 0.005268432199954987,
            "z": -391.36285400390625
        },
        {
            "x": -0.1731366217136383,
            "y": 0.0052619390189647675,
            "z": -391.20550537109375
        },
        {
            "x": -0.1733148992061615,
            "y": 0.0052554793655872345,
            "z": -391.04827880859375
        },
        {
            "x": -0.1734931468963623,
            "y": 0.005248997360467911,
            "z": -390.89105224609375
        },
        {
            "x": -0.17367160320281982,
            "y": 0.005242500454187393,
            "z": -390.7336120605469
        },
        {
            "x": -0.17384988069534302,
            "y": 0.005236014723777771,
            "z": -390.5763854980469
        },
        {
            "x": -0.174028217792511,
            "y": 0.005229532718658447,
            "z": -390.41912841796875
        },
        {
            "x": -0.1742064356803894,
            "y": 0.005223065614700317,
            "z": -390.2618103027344
        },
        {
            "x": -0.17438477277755737,
            "y": 0.0052165687084198,
            "z": -390.1045837402344
        },
        {
            "x": -0.17456316947937012,
            "y": 0.005210116505622864,
            "z": -389.9471435546875
        },
        {
            "x": -0.1747414767742157,
            "y": 0.005203627049922943,
            "z": -389.7899169921875
        },
        {
            "x": -0.17491969466209412,
            "y": 0.005197122693061829,
            "z": -389.6326904296875
        },
        {
            "x": -0.17509791254997253,
            "y": 0.005190636962652206,
            "z": -389.4754333496094
        },
        {
            "x": -0.17527619004249573,
            "y": 0.005184151232242584,
            "z": -389.3182067871094
        },
        {
            "x": -0.17545455694198608,
            "y": 0.005177699029445648,
            "z": -389.160888671875
        },
        {
            "x": -0.17563286423683167,
            "y": 0.0051712095737457275,
            "z": -389.0035705566406
        },
        {
            "x": -0.17581114172935486,
            "y": 0.00516471266746521,
            "z": -388.8463134765625
        },
        {
            "x": -0.17598947882652283,
            "y": 0.00515824556350708,
            "z": -388.68902587890625
        },
        {
            "x": -0.17616772651672363,
            "y": 0.005151759833097458,
            "z": -388.5317687988281
        },
        {
            "x": -0.1763460338115692,
            "y": 0.005145251750946045,
            "z": -388.37451171875
        },
        {
            "x": -0.17652443051338196,
            "y": 0.005138766020536423,
            "z": -388.21710205078125
        },
        {
            "x": -0.17670273780822754,
            "y": 0.0051322877407073975,
            "z": -388.05987548828125
        },
        {
            "x": -0.17688098549842834,
            "y": 0.005125835537910461,
            "z": -387.90252685546875
        },
        {
            "x": -0.1770593225955963,
            "y": 0.0051193200051784515,
            "z": -387.7452697753906
        },
        {
            "x": -0.17723757028579712,
            "y": 0.005112841725349426,
            "z": -387.5880432128906
        },
        {
            "x": -0.17741599678993225,
            "y": 0.005106355994939804,
            "z": -387.4306335449219
        },
        {
            "x": -0.17759433388710022,
            "y": 0.005099892616271973,
            "z": -387.27337646484375
        },
        {
            "x": -0.17777255177497864,
            "y": 0.005093377083539963,
            "z": -387.11614990234375
        },
        {
            "x": -0.17795085906982422,
            "y": 0.005086902529001236,
            "z": -386.9588317871094
        },
        {
            "x": -0.17812910676002502,
            "y": 0.005080427974462509,
            "z": -386.80157470703125
        },
        {
            "x": -0.17830750346183777,
            "y": 0.0050739385187625885,
            "z": -386.6442565917969
        },
        {
            "x": -0.17848581075668335,
            "y": 0.005067456513643265,
            "z": -386.4869384765625
        },
        {
            "x": -0.17866414785385132,
            "y": 0.005060967057943344,
            "z": -386.3296813964844
        },
        {
            "x": -0.1787828803062439,
            "y": 0.005056660622358322,
            "z": -386.224853515625
        },
        {
            "x": -0.1789611577987671,
            "y": 0.005050167441368103,
            "z": -386.067626953125
        },
        {
            "x": -0.17913946509361267,
            "y": 0.005043685436248779,
            "z": -385.910400390625
        },
        {
            "x": -0.17931786179542542,
            "y": 0.005037207156419754,
            "z": -385.75299072265625
        },
        {
            "x": -0.1794961392879486,
            "y": 0.005030736327171326,
            "z": -385.5957336425781
        },
        {
            "x": -0.1796744167804718,
            "y": 0.005024231970310211,
            "z": -385.4385070800781
        },
        {
            "x": -0.17985272407531738,
            "y": 0.005017753690481186,
            "z": -385.28118896484375
        },
        {
            "x": -0.18003100156784058,
            "y": 0.005011286586523056,
            "z": -385.1239013671875
        },
        {
            "x": -0.18020933866500854,
            "y": 0.005004778504371643,
            "z": -384.96661376953125
        },
        {
            "x": -0.18038764595985413,
            "y": 0.004998315125703812,
            "z": -384.8092956542969
        },
        {
            "x": -0.1805659830570221,
            "y": 0.004991825670003891,
            "z": -384.65203857421875
        },
        {
            "x": -0.18074432015419006,
            "y": 0.004985347390174866,
            "z": -384.4947204589844
        },
        {
            "x": -0.18092253804206848,
            "y": 0.004978857934474945,
            "z": -384.3374328613281
        },
        {
            "x": -0.18110084533691406,
            "y": 0.004972372204065323,
            "z": -384.1802062988281
        },
        {
            "x": -0.18127930164337158,
            "y": 0.004965882748365402,
            "z": -384.02276611328125
        },
        {
            "x": -0.18145751953125,
            "y": 0.004959456622600555,
            "z": -383.8655090332031
        },
        {
            "x": -0.18163585662841797,
            "y": 0.004952915012836456,
            "z": -383.708251953125
        },
        {
            "x": -0.18181416392326355,
            "y": 0.004946444183588028,
            "z": -383.55096435546875
        },
        {
            "x": -0.18199241161346436,
            "y": 0.004939951002597809,
            "z": -383.39373779296875
        },
        {
            "x": -0.1821708381175995,
            "y": 0.004933495074510574,
            "z": -383.236328125
        },
        {
            "x": -0.1823490858078003,
            "y": 0.004926983267068863,
            "z": -383.0791015625
        },
        {
            "x": -0.18252739310264587,
            "y": 0.004920508712530136,
            "z": -382.9218444824219
        },
        {
            "x": -0.1827055811882019,
            "y": 0.0049140192568302155,
            "z": -382.7646179199219
        },
        {
            "x": -0.1828838586807251,
            "y": 0.004907567054033279,
            "z": -382.6073913574219
        },
        {
            "x": -0.18306219577789307,
            "y": 0.004901077598333359,
            "z": -382.4501037597656
        },
        {
            "x": -0.18324056267738342,
            "y": 0.004894580692052841,
            "z": -382.292724609375
        },
        {
            "x": -0.18341881036758423,
            "y": 0.004888094961643219,
            "z": -382.135498046875
        },
        {
            "x": -0.18359720706939697,
            "y": 0.00488165020942688,
            "z": -381.9781799316406
        },
        {
            "x": -0.1837754249572754,
            "y": 0.004875149577856064,
            "z": -381.8209533691406
        },
        {
            "x": -0.183953657746315,
            "y": 0.004868645220994949,
            "z": -381.6636962890625
        },
        {
            "x": -0.18413209915161133,
            "y": 0.004862163215875626,
            "z": -381.5062561035156
        },
        {
            "x": -0.18431033194065094,
            "y": 0.004855703562498093,
            "z": -381.3490295410156
        },
        {
            "x": -0.18448860943317413,
            "y": 0.004849221557378769,
            "z": -381.1917419433594
        },
        {
            "x": -0.1846669465303421,
            "y": 0.0048427097499370575,
            "z": -381.0344543457031
        },
        {
            "x": -0.18484513461589813,
            "y": 0.004836224019527435,
            "z": -380.8772277832031
        },
        {
            "x": -0.18502330780029297,
            "y": 0.004829756915569305,
            "z": -380.7197570800781
        },
        {
            "x": -0.18520158529281616,
            "y": 0.004823267459869385,
            "z": -380.56256103515625
        },
        {
            "x": -0.18538005650043488,
            "y": 0.004816774278879166,
            "z": -380.40533447265625
        },
        {
            "x": -0.185557559132576,
            "y": 0.004810314625501633,
            "z": -380.2479553222656
        },
        {
            "x": -0.18573316931724548,
            "y": 0.004803851246833801,
            "z": -380.0907897949219
        },
        {
            "x": -0.1859074831008911,
            "y": 0.004797335714101791,
            "z": -379.9334411621094
        },
        {
            "x": -0.18608437478542328,
            "y": 0.004790849983692169,
            "z": -379.7760925292969
        },
        {
            "x": -0.18625769019126892,
            "y": 0.004784353077411652,
            "z": -379.6188659667969
        },
        {
            "x": -0.18636740744113922,
            "y": 0.00478002056479454,
            "z": -379.5140686035156
        },
        {
            "x": -0.18651707470417023,
            "y": 0.004773475229740143,
            "z": -379.35687255859375
        },
        {
            "x": -0.1866551786661148,
            "y": 0.004767019301652908,
            "z": -379.19964599609375
        },
        {
            "x": -0.186798557639122,
            "y": 0.004760533571243286,
            "z": -379.042236328125
        },
        {
            "x": -0.1869121640920639,
            "y": 0.004754051566123962,
            "z": -378.8851013183594
        },
        {
            "x": -0.18695305287837982,
            "y": 0.004747588187456131,
            "z": -378.72802734375
        },
        {
            "x": -0.18690688908100128,
            "y": 0.004741102457046509,
            "z": -378.57080078125
        },
        {
            "x": -0.18682987987995148,
            "y": 0.004734627902507782,
            "z": -378.4136047363281
        },
        {
            "x": -0.18670286238193512,
            "y": 0.004728108644485474,
            "z": -378.25640869140625
        },
        {
            "x": -0.1864067167043686,
            "y": 0.004721637815237045,
            "z": -378.0994567871094
        },
        {
            "x": -0.18585453927516937,
            "y": 0.0047151632606983185,
            "z": -377.9426574707031
        },
        {
            "x": -0.1850963681936264,
            "y": 0.0047086551785469055,
            "z": -377.7855529785156
        },
        {
            "x": -0.1842096596956253,
            "y": 0.0047021545469760895,
            "z": -377.6286315917969
        },
        {
            "x": -0.18306760489940643,
            "y": 0.0046956948935985565,
            "z": -377.4720153808594
        },
        {
            "x": -0.1815008670091629,
            "y": 0.004689231514930725,
            "z": -377.3153076171875
        },
        {
            "x": -0.17954275012016296,
            "y": 0.004682738333940506,
            "z": -377.15863037109375
        },
        {
            "x": -0.17731201648712158,
            "y": 0.004676263779401779,
            "z": -377.00177001953125
        },
        {
            "x": -0.17478710412979126,
            "y": 0.0046697817742824554,
            "z": -376.8451843261719
        },
        {
            "x": -0.17176565527915955,
            "y": 0.004663288593292236,
            "z": -376.68890380859375
        },
        {
            "x": -0.1682167947292328,
            "y": 0.004656795412302017,
            "z": -376.5323181152344
        },
        {
            "x": -0.16428804397583008,
            "y": 0.004650302231311798,
            "z": -376.37567138671875
        },
        {
            "x": -0.16008082032203674,
            "y": 0.004643827676773071,
            "z": -376.21905517578125
        },
        {
            "x": -0.15543413162231445,
            "y": 0.004637356847524643,
            "z": -376.062744140625
        },
        {
            "x": -0.1502208411693573,
            "y": 0.004630859941244125,
            "z": -375.90655517578125
        },
        {
            "x": -0.14450693130493164,
            "y": 0.004624374210834503,
            "z": -375.75006103515625
        },
        {
            "x": -0.13847199082374573,
            "y": 0.004617910832166672,
            "z": -375.5933532714844
        },
        {
            "x": -0.132118821144104,
            "y": 0.004611440002918243,
            "z": -375.4369201660156
        },
        {
            "x": -0.12526240944862366,
            "y": 0.0046049319207668304,
            "z": -375.2806701660156
        },
        {
            "x": -0.11784553527832031,
            "y": 0.0045984722673892975,
            "z": -375.12451171875
        },
        {
            "x": -0.10999757051467896,
            "y": 0.004591979086399078,
            "z": -374.968017578125
        },
        {
            "x": -0.10185936093330383,
            "y": 0.004585467278957367,
            "z": -374.811279296875
        },
        {
            "x": -0.0933586061000824,
            "y": 0.004579015076160431,
            "z": -374.6551513671875
        },
        {
            "x": -0.08431917428970337,
            "y": 0.004572529345750809,
            "z": -374.4990539550781
        },
        {
            "x": -0.07475444674491882,
            "y": 0.004566039890050888,
            "z": -374.3427734375
        },
        {
            "x": -0.0648326575756073,
            "y": 0.004559576511383057,
            "z": -374.1863098144531
        },
        {
            "x": -0.054626911878585815,
            "y": 0.0045530907809734344,
            "z": -374.02984619140625
        },
        {
            "x": -0.04400151968002319,
            "y": 0.004546578973531723,
            "z": -373.873779296875
        },
        {
            "x": -0.032833218574523926,
            "y": 0.00454011932015419,
            "z": -373.7178649902344
        },
        {
            "x": -0.021181970834732056,
            "y": 0.004533637315034866,
            "z": -373.5615539550781
        },
        {
            "x": -0.009254515171051025,
            "y": 0.0045271702110767365,
            "z": -373.40521240234375
        },
        {
            "x": 0.002988100051879883,
            "y": 0.004520677030086517,
            "z": -373.2490539550781
        },
        {
            "x": 0.01570606231689453,
            "y": 0.004514213651418686,
            "z": -373.0931701660156
        },
        {
            "x": 0.02896180748939514,
            "y": 0.0045076943933963776,
            "z": -372.9372253417969
        },
        {
            "x": 0.038024693727493286,
            "y": 0.004503384232521057,
            "z": -372.8331604003906
        },
        {
            "x": 0.0518287718296051,
            "y": 0.004496891051530838,
            "z": -372.6769714355469
        },
        {
            "x": 0.06594231724739075,
            "y": 0.004490431398153305,
            "z": -372.52105712890625
        },
        {
            "x": 0.08054733276367188,
            "y": 0.004483915865421295,
            "z": -372.3652038574219
        },
        {
            "x": 0.09565684199333191,
            "y": 0.004477445036172867,
            "z": -372.20941162109375
        },
        {
            "x": 0.11113107204437256,
            "y": 0.004470948129892349,
            "z": -372.0533752441406
        },
        {
            "x": 0.1268557906150818,
            "y": 0.004464481025934219,
            "z": -371.89739990234375
        },
        {
            "x": 0.1429494321346283,
            "y": 0.004457999020814896,
            "z": -371.7417297363281
        },
        {
            "x": 0.15954691171646118,
            "y": 0.00445149838924408,
            "z": -371.586181640625
        },
        {
            "x": 0.17661190032958984,
            "y": 0.004445027559995651,
            "z": -371.43035888671875
        },
        {
            "x": 0.1939745843410492,
            "y": 0.004438519477844238,
            "z": -371.2744445800781
        },
        {
            "x": 0.2116006314754486,
            "y": 0.004432052373886108,
            "z": -371.11871337890625
        },
        {
            "x": 0.22962087392807007,
            "y": 0.00442558154463768,
            "z": -370.96337890625
        },
        {
            "x": 0.2481447160243988,
            "y": 0.004419095814228058,
            "z": -370.8079833984375
        },
        {
            "x": 0.26710110902786255,
            "y": 0.004412606358528137,
            "z": -370.6522216796875
        },
        {
            "x": 0.286281555891037,
            "y": 0.0044061169028282166,
            "z": -370.49652099609375
        },
        {
            "x": 0.30575937032699585,
            "y": 0.004399631172418594,
            "z": -370.34112548828125
        },
        {
            "x": 0.3256811201572418,
            "y": 0.004393137991428375,
            "z": -370.1859436035156
        },
        {
            "x": 0.34608736634254456,
            "y": 0.0043866559863090515,
            "z": -370.0306396484375
        },
        {
            "x": 0.3668433427810669,
            "y": 0.004380173981189728,
            "z": -369.8750305175781
        },
        {
            "x": 0.38779860734939575,
            "y": 0.0043737031519412994,
            "z": -369.71966552734375
        },
        {
            "x": 0.40909314155578613,
            "y": 0.004367228597402573,
            "z": -369.5646667480469
        },
        {
            "x": 0.4308634400367737,
            "y": 0.004360750317573547,
            "z": -369.4096984863281
        },
        {
            "x": 0.4530649781227112,
            "y": 0.004354257136583328,
            "z": -369.25457763671875
        },
        {
            "x": 0.47553327679634094,
            "y": 0.0043477751314640045,
            "z": -369.0992126464844
        },
        {
            "x": 0.49824589490890503,
            "y": 0.004341296851634979,
            "z": -368.94415283203125
        },
        {
            "x": 0.52134108543396,
            "y": 0.0043348148465156555,
            "z": -368.7893981933594
        },
        {
            "x": 0.5449212193489075,
            "y": 0.004328344017267227,
            "z": -368.6344909667969
        },
        {
            "x": 0.5688399076461792,
            "y": 0.004321839660406113,
            "z": -368.4794616699219
        },
        {
            "x": 0.5929692983627319,
            "y": 0.004315361380577087,
            "z": -368.32452392578125
        },
        {
            "x": 0.6174142956733704,
            "y": 0.0043089017271995544,
            "z": -368.169677734375
        },
        {
            "x": 0.6422593593597412,
            "y": 0.004302419722080231,
            "z": -368.0151672363281
        },
        {
            "x": 0.6675407886505127,
            "y": 0.004295907914638519,
            "z": -367.8604736328125
        },
        {
            "x": 0.6931047439575195,
            "y": 0.004289440810680389,
            "z": -367.70562744140625
        },
        {
            "x": 0.718870222568512,
            "y": 0.004282958805561066,
            "z": -367.551025390625
        },
        {
            "x": 0.7450062036514282,
            "y": 0.0042764730751514435,
            "z": -367.3964538574219
        },
        {
            "x": 0.771536111831665,
            "y": 0.00426999107003212,
            "z": -367.2421875
        },
        {
            "x": 0.7984496355056763,
            "y": 0.004263509064912796,
            "z": -367.08770751953125
        },
        {
            "x": 0.8256096839904785,
            "y": 0.004257030785083771,
            "z": -366.9330749511719
        },
        {
            "x": 0.852975606918335,
            "y": 0.004250559955835342,
            "z": -366.7787780761719
        },
        {
            "x": 0.8807317018508911,
            "y": 0.00424407422542572,
            "z": -366.6246337890625
        },
        {
            "x": 0.9089070558547974,
            "y": 0.004237566143274307,
            "z": -366.4704284667969
        },
        {
            "x": 0.9373873472213745,
            "y": 0.004231102764606476,
            "z": -366.316162109375
        },
        {
            "x": 0.9564886093139648,
            "y": 0.004226773977279663,
            "z": -366.2132873535156
        },
        {
            "x": 0.9853056073188782,
            "y": 0.004220247268676758,
            "z": -366.0592956542969
        },
        {
            "x": 1.0144906044006348,
            "y": 0.00421375036239624,
            "z": -365.9054870605469
        },
        {
            "x": 1.0441367626190186,
            "y": 0.004207253456115723,
            "z": -365.75140380859375
        },
        {
            "x": 1.0740363597869873,
            "y": 0.004200771450996399,
            "z": -365.5973815917969
        },
        {
            "x": 1.104122281074524,
            "y": 0.004194293171167374,
            "z": -365.44342041015625
        },
        {
            "x": 1.1344895362854004,
            "y": 0.004187833517789841,
            "z": -365.2896728515625
        },
        {
            "x": 1.165224313735962,
            "y": 0.004181332886219025,
            "z": -365.1361389160156
        },
        {
            "x": 1.1963635683059692,
            "y": 0.00417482852935791,
            "z": -364.9823303222656
        },
        {
            "x": 1.227717638015747,
            "y": 0.004168346524238586,
            "z": -364.8284912109375
        },
        {
            "x": 1.259238839149475,
            "y": 0.0041618794202804565,
            "z": -364.6748962402344
        },
        {
            "x": 1.2910919189453125,
            "y": 0.004155423492193222,
            "z": -364.5214538574219
        },
        {
            "x": 1.3233110904693604,
            "y": 0.004148911684751511,
            "z": -364.3681335449219
        },
        {
            "x": 1.3558485507965088,
            "y": 0.004142448306083679,
            "z": -364.21466064453125
        },
        {
            "x": 1.3886091709136963,
            "y": 0.004135925322771072,
            "z": -364.0610046386719
        },
        {
            "x": 1.4215540885925293,
            "y": 0.004129476845264435,
            "z": -363.90777587890625
        },
        {
            "x": 1.4548369646072388,
            "y": 0.004123002290725708,
            "z": -363.7546081542969
        },
        {
            "x": 1.4884834289550781,
            "y": 0.004116501659154892,
            "z": -363.6014709472656
        },
        {
            "x": 1.5223805904388428,
            "y": 0.004110012203454971,
            "z": -363.44830322265625
        },
        {
            "x": 1.5565009117126465,
            "y": 0.004103522747755051,
            "z": -363.294921875
        },
        {
            "x": 1.5908013582229614,
            "y": 0.00409703329205513,
            "z": -363.1419982910156
        },
        {
            "x": 1.6254431009292603,
            "y": 0.004090558737516403,
            "z": -362.9892578125
        },
        {
            "x": 1.660430669784546,
            "y": 0.004084084182977676,
            "z": -362.8363342285156
        },
        {
            "x": 1.6956266164779663,
            "y": 0.00407758355140686,
            "z": -362.683349609375
        },
        {
            "x": 1.7310128211975098,
            "y": 0.0040711089968681335,
            "z": -362.530517578125
        },
        {
            "x": 1.7666587829589844,
            "y": 0.004064615815877914,
            "z": -362.3778381347656
        },
        {
            "x": 1.8026323318481445,
            "y": 0.004058137536048889,
            "z": -362.22528076171875
        },
        {
            "x": 1.8389356136322021,
            "y": 0.004051659256219864,
            "z": -362.0725402832031
        },
        {
            "x": 1.8753641843795776,
            "y": 0.0040451958775520325,
            "z": -361.9198913574219
        },
        {
            "x": 1.9119932651519775,
            "y": 0.00403871014714241,
            "z": -361.76739501953125
        },
        {
            "x": 1.948951244354248,
            "y": 0.004032202064990997,
            "z": -361.614990234375
        },
        {
            "x": 1.9862122535705566,
            "y": 0.004025720059871674,
            "z": -361.4626159667969
        },
        {
            "x": 2.0237231254577637,
            "y": 0.004019260406494141,
            "z": -361.31011962890625
        },
        {
            "x": 2.061375141143799,
            "y": 0.004012778401374817,
            "z": -361.15771484375
        },
        {
            "x": 2.0992064476013184,
            "y": 0.004006281495094299,
            "z": -361.0055847167969
        },
        {
            "x": 2.1374104022979736,
            "y": 0.003999810665845871,
            "z": -360.8534240722656
        },
        {
            "x": 2.1758687496185303,
            "y": 0.003993295133113861,
            "z": -360.7012939453125
        },
        {
            "x": 2.214515209197998,
            "y": 0.00398683175444603,
            "z": -360.54913330078125
        },
        {
            "x": 2.2533087730407715,
            "y": 0.003980372101068497,
            "z": -360.39703369140625
        },
        {
            "x": 2.2923390865325928,
            "y": 0.003973867744207382,
            "z": -360.24517822265625
        },
        {
            "x": 2.3317060470581055,
            "y": 0.003967393189668655,
            "z": -360.0933532714844
        },
        {
            "x": 2.3713138103485107,
            "y": 0.003960900008678436,
            "z": -359.9413757324219
        },
        {
            "x": 2.4110751152038574,
            "y": 0.003954444080591202,
            "z": -359.7895202636719
        },
        {
            "x": 2.43764591217041,
            "y": 0.0039501190185546875,
            "z": -359.6883850097656
        },
        {
            "x": 2.4777159690856934,
            "y": 0.003943633288145065,
            "z": -359.5367736816406
        },
        {
            "x": 2.518066167831421,
            "y": 0.00393715500831604,
            "z": -359.3852844238281
        },
        {
            "x": 2.5587308406829834,
            "y": 0.0039306506514549255,
            "z": -359.23345947265625
        },
        {
            "x": 2.599473237991333,
            "y": 0.003924176096916199,
            "z": -359.08184814453125
        },
        {
            "x": 2.64037823677063,
            "y": 0.003917686641216278,
            "z": -358.930419921875
        },
        {
            "x": 2.681556463241577,
            "y": 0.003911219537258148,
            "z": -358.7790832519531
        },
        {
            "x": 2.7230093479156494,
            "y": 0.0039047300815582275,
            "z": -358.627685546875
        },
        {
            "x": 2.76468563079834,
            "y": 0.003898240625858307,
            "z": -358.47625732421875
        },
        {
            "x": 2.806483507156372,
            "y": 0.003891739994287491,
            "z": -358.3248291015625
        },
        {
            "x": 2.8484177589416504,
            "y": 0.0038852766156196594,
            "z": -358.1737365722656
        },
        {
            "x": 2.8906350135803223,
            "y": 0.003878813236951828,
            "z": -358.0226135253906
        },
        {
            "x": 2.9330942630767822,
            "y": 0.0038723163306713104,
            "z": -357.8714599609375
        },
        {
            "x": 2.9757065773010254,
            "y": 0.0038658082485198975,
            "z": -357.72039794921875
        },
        {
            "x": 3.0184924602508545,
            "y": 0.0038593411445617676,
            "z": -357.56915283203125
        },
        {
            "x": 3.0614147186279297,
            "y": 0.003852851688861847,
            "z": -357.4183654785156
        },
        {
            "x": 3.104626178741455,
            "y": 0.0038463734090328217,
            "z": -357.2674560546875
        },
        {
            "x": 3.1480624675750732,
            "y": 0.003839891403913498,
            "z": -357.11651611328125
        },
        {
            "x": 3.191586494445801,
            "y": 0.003833424299955368,
            "z": -356.9656982421875
        },
        {
            "x": 3.2353169918060303,
            "y": 0.0038269199430942535,
            "z": -356.8147277832031
        },
        {
            "x": 3.2791874408721924,
            "y": 0.00382043793797493,
            "z": -356.6642150878906
        },
        {
            "x": 3.3233096599578857,
            "y": 0.0038139335811138153,
            "z": -356.51361083984375
        },
        {
            "x": 3.3676249980926514,
            "y": 0.0038074851036071777,
            "z": -356.3629150390625
        },
        {
            "x": 3.4120287895202637,
            "y": 0.0038009844720363617,
            "z": -356.21240234375
        },
        {
            "x": 3.456613540649414,
            "y": 0.003794517368078232,
            "z": -356.06182861328125
        },
        {
            "x": 3.5014266967773438,
            "y": 0.0037880390882492065,
            "z": -355.9113464355469
        },
        {
            "x": 3.5464227199554443,
            "y": 0.0037815310060977936,
            "z": -355.7610168457031
        },
        {
            "x": 3.591613292694092,
            "y": 0.0037750303745269775,
            "z": -355.6105041503906
        },
        {
            "x": 3.6368556022644043,
            "y": 0.0037685781717300415,
            "z": -355.46014404296875
        },
        {
            "x": 3.682263135910034,
            "y": 0.0037620849907398224,
            "z": -355.30999755859375
        },
        {
            "x": 3.727952241897583,
            "y": 0.0037555955350399017,
            "z": -355.15966796875
        },
        {
            "x": 3.773780345916748,
            "y": 0.003749113529920578,
            "z": -355.0094909667969
        },
        {
            "x": 3.819739580154419,
            "y": 0.0037426352500915527,
            "z": -354.8592529296875
        },
        {
            "x": 3.865804433822632,
            "y": 0.0037361569702625275,
            "z": -354.70916748046875
        },
        {
            "x": 3.912027597427368,
            "y": 0.0037296637892723083,
            "z": -354.5591735839844
        },
        {
            "x": 3.958524703979492,
            "y": 0.0037231668829917908,
            "z": -354.4090576171875
        },
        {
            "x": 4.005119800567627,
            "y": 0.0037167035043239594,
            "z": -354.25909423828125
        },
        {
            "x": 4.051808834075928,
            "y": 0.0037102364003658295,
            "z": -354.109130859375
        },
        {
            "x": 4.098653316497803,
            "y": 0.003703717142343521,
            "z": -353.9591369628906
        },
        {
            "x": 4.1456379890441895,
            "y": 0.0036972500383853912,
            "z": -353.8094482421875
        },
        {
            "x": 4.192848205566406,
            "y": 0.0036907829344272614,
            "z": -353.6596984863281
        },
        {
            "x": 4.240206718444824,
            "y": 0.0036842860281467438,
            "z": -353.509765625
        },
        {
            "x": 4.287595748901367,
            "y": 0.00367780402302742,
            "z": -353.36004638671875
        },
        {
            "x": 4.319255352020264,
            "y": 0.0036734603345394135,
            "z": -353.2602844238281
        },
        {
            "x": 4.3668999671936035,
            "y": 0.003666941076517105,
            "z": -353.1107482910156
        },
        {
            "x": 4.414713382720947,
            "y": 0.003660440444946289,
            "z": -352.96124267578125
        },
        {
            "x": 4.462743282318115,
            "y": 0.003653962165117264,
            "z": -352.8114318847656
        },
        {
            "x": 4.51077938079834,
            "y": 0.00364748015999794,
            "z": -352.66192626953125
        },
        {
            "x": 4.5589280128479,
            "y": 0.003640994429588318,
            "z": -352.5124816894531
        },
        {
            "x": 4.6072821617126465,
            "y": 0.003634512424468994,
            "z": -352.363037109375
        },
        {
            "x": 4.655760765075684,
            "y": 0.003628026694059372,
            "z": -352.213623046875
        },
        {
            "x": 4.704388618469238,
            "y": 0.0036215223371982574,
            "z": -352.0640869140625
        },
        {
            "x": 4.75307035446167,
            "y": 0.003615051507949829,
            "z": -351.91473388671875
        },
        {
            "x": 4.801848888397217,
            "y": 0.0036085695028305054,
            "z": -351.7655334472656
        },
        {
            "x": 4.850849151611328,
            "y": 0.003602106124162674,
            "z": -351.6161804199219
        },
        {
            "x": 4.899930477142334,
            "y": 0.003595612943172455,
            "z": -351.4670104980469
        },
        {
            "x": 4.949092388153076,
            "y": 0.0035891011357307434,
            "z": -351.3178405761719
        },
        {
            "x": 4.998407363891602,
            "y": 0.0035826265811920166,
            "z": -351.16851806640625
        },
        {
            "x": 5.047779560089111,
            "y": 0.0035761557519435883,
            "z": -351.01947021484375
        },
        {
            "x": 5.097326755523682,
            "y": 0.0035696811974048615,
            "z": -350.870361328125
        },
        {
            "x": 5.14699649810791,
            "y": 0.0035631731152534485,
            "z": -350.72125244140625
        },
        {
            "x": 5.196721076965332,
            "y": 0.0035566985607147217,
            "z": -350.572265625
        },
        {
            "x": 5.246577262878418,
            "y": 0.003550183027982712,
            "z": -350.4231262207031
        },
        {
            "x": 5.2964982986450195,
            "y": 0.0035437382757663727,
            "z": -350.2742919921875
        },
        {
            "x": 5.346553802490234,
            "y": 0.0035503632389009,
            "z": -350.1253662109375
        },
        {
            "x": 5.396707534790039,
            "y": 0.0037590833380818367,
            "z": -349.9764709472656
        },
        {
            "x": 5.446916580200195,
            "y": 0.004279328044503927,
            "z": -349.82757568359375
        },
        {
            "x": 5.4972381591796875,
            "y": 0.005119341425597668,
            "z": -349.67877197265625
        },
        {
            "x": 5.547707557678223,
            "y": 0.0062617892399430275,
            "z": -349.5299377441406
        },
        {
            "x": 5.598251819610596,
            "y": 0.007701379247009754,
            "z": -349.3811950683594
        },
        {
            "x": 5.648892402648926,
            "y": 0.009436249732971191,
            "z": -349.2323913574219
        },
        {
            "x": 5.699571132659912,
            "y": 0.011472491547465324,
            "z": -349.0837097167969
        },
        {
            "x": 5.750324249267578,
            "y": 0.013792196288704872,
            "z": -348.9350891113281
        },
        {
            "x": 5.801259994506836,
            "y": 0.016395501792430878,
            "z": -348.786376953125
        },
        {
            "x": 5.852231025695801,
            "y": 0.019273562356829643,
            "z": -348.63775634765625
        },
        {
            "x": 5.903286457061768,
            "y": 0.022438116371631622,
            "z": -348.4891052246094
        },
        {
            "x": 5.9543890953063965,
            "y": 0.02586880326271057,
            "z": -348.3405456542969
        },
        {
            "x": 6.005564212799072,
            "y": 0.029560547322034836,
            "z": -348.1921081542969
        },
        {
            "x": 6.056913375854492,
            "y": 0.03351740539073944,
            "z": -348.0434875488281
        },
        {
            "x": 6.108269691467285,
            "y": 0.037737295031547546,
            "z": -347.89501953125
        },
        {
            "x": 6.159675121307373,
            "y": 0.04220755770802498,
            "z": -347.7466125488281
        },
        {
            "x": 6.211152076721191,
            "y": 0.04692438989877701,
            "z": -347.5982360839844
        },
        {
            "x": 6.2627153396606445,
            "y": 0.05188172683119774,
            "z": -347.4498596191406
        },
        {
            "x": 6.3143768310546875,
            "y": 0.05709050968289375,
            "z": -347.30145263671875
        },
        {
            "x": 6.366098403930664,
            "y": 0.06253416836261749,
            "z": -347.153076171875
        },
        {
            "x": 6.41783332824707,
            "y": 0.06820353865623474,
            "z": -347.0047607421875
        },
        {
            "x": 6.452341556549072,
            "y": 0.07210662961006165,
            "z": -346.90606689453125
        },
        {
            "x": 6.504202365875244,
            "y": 0.07815472781658173,
            "z": -346.7577819824219
        },
        {
            "x": 6.556125640869141,
            "y": 0.08441942930221558,
            "z": -346.6095886230469
        },
        {
            "x": 6.608150482177734,
            "y": 0.09090659022331238,
            "z": -346.4612121582031
        },
        {
            "x": 6.660154342651367,
            "y": 0.09760209918022156,
            "z": -346.3130798339844
        },
        {
            "x": 6.712217330932617,
            "y": 0.10450255870819092,
            "z": -346.16497802734375
        },
        {
            "x": 6.764364719390869,
            "y": 0.1116064190864563,
            "z": -346.0168762207031
        },
        {
            "x": 6.816564083099365,
            "y": 0.11890500783920288,
            "z": -345.8688049316406
        },
        {
            "x": 6.868827819824219,
            "y": 0.12640710175037384,
            "z": -345.7206115722656
        },
        {
            "x": 6.92111349105835,
            "y": 0.1340973675251007,
            "z": -345.5725402832031
        },
        {
            "x": 6.973416805267334,
            "y": 0.14196528494358063,
            "z": -345.4245300292969
        },
        {
            "x": 7.025826930999756,
            "y": 0.150019109249115,
            "z": -345.2764587402344
        },
        {
            "x": 7.078226089477539,
            "y": 0.1582457423210144,
            "z": -345.1285400390625
        },
        {
            "x": 7.130667209625244,
            "y": 0.16664721071720123,
            "z": -344.9805908203125
        },
        {
            "x": 7.183187484741211,
            "y": 0.17522329092025757,
            "z": -344.83251953125
        },
        {
            "x": 7.235692977905273,
            "y": 0.18395154178142548,
            "z": -344.6846618652344
        },
        {
            "x": 7.288271427154541,
            "y": 0.19284288585186005,
            "z": -344.5367431640625
        },
        {
            "x": 7.3408732414245605,
            "y": 0.20189368724822998,
            "z": -344.38885498046875
        },
        {
            "x": 7.393477916717529,
            "y": 0.21108810603618622,
            "z": -344.2409973144531
        },
        {
            "x": 7.446173191070557,
            "y": 0.22043746709823608,
            "z": -344.093017578125
        },
        {
            "x": 7.498863697052002,
            "y": 0.22992125153541565,
            "z": -343.94525146484375
        },
        {
            "x": 7.551578998565674,
            "y": 0.2395460605621338,
            "z": -343.79742431640625
        },
        {
            "x": 7.604289531707764,
            "y": 0.249299094080925,
            "z": -343.649658203125
        },
        {
            "x": 7.657027721405029,
            "y": 0.2591792345046997,
            "z": -343.501953125
        },
        {
            "x": 7.7098212242126465,
            "y": 0.2691928744316101,
            "z": -343.3541259765625
        },
        {
            "x": 7.762638568878174,
            "y": 0.279327392578125,
            "z": -343.206298828125
        },
        {
            "x": 7.815443515777588,
            "y": 0.2895703911781311,
            "z": -343.05865478515625
        },
        {
            "x": 7.868305206298828,
            "y": 0.2999328374862671,
            "z": -342.91082763671875
        },
        {
            "x": 7.921151161193848,
            "y": 0.310394823551178,
            "z": -342.76312255859375
        },
        {
            "x": 7.973993301391602,
            "y": 0.32096248865127563,
            "z": -342.615478515625
        },
        {
            "x": 8.026947021484375,
            "y": 0.3316439390182495,
            "z": -342.46759033203125
        },
        {
            "x": 8.079822540283203,
            "y": 0.3424016237258911,
            "z": -342.3199462890625
        },
        {
            "x": 8.132723808288574,
            "y": 0.3532547950744629,
            "z": -342.1722106933594
        },
        {
            "x": 8.185636520385742,
            "y": 0.3641929030418396,
            "z": -342.02459716796875
        },
        {
            "x": 8.238558769226074,
            "y": 0.3752126097679138,
            "z": -341.876953125
        },
        {
            "x": 8.29154109954834,
            "y": 0.3863239288330078,
            "z": -341.72906494140625
        },
        {
            "x": 8.344443321228027,
            "y": 0.3974919021129608,
            "z": -341.5814208984375
        },
        {
            "x": 8.397350311279297,
            "y": 0.40873053669929504,
            "z": -341.4338073730469
        },
        {
            "x": 8.450308799743652,
            "y": 0.4200438857078552,
            "z": -341.2860412597656
        },
        {
            "x": 8.503219604492188,
            "y": 0.4314059019088745,
            "z": -341.1383972167969
        },
        {
            "x": 8.556172370910645,
            "y": 0.44283413887023926,
            "z": -340.9906311035156
        },
        {
            "x": 8.609110832214355,
            "y": 0.454315721988678,
            "z": -340.8428649902344
        },
        {
            "x": 8.662004470825195,
            "y": 0.4658339023590088,
            "z": -340.69525146484375
        },
        {
            "x": 8.697271347045898,
            "y": 0.47353777289390564,
            "z": -340.5968322753906
        },
        {
            "x": 8.75015640258789,
            "y": 0.485127329826355,
            "z": -340.4491882324219
        },
        {
            "x": 8.803030014038086,
            "y": 0.49675452709198,
            "z": -340.3014831542969
        },
        {
            "x": 8.855961799621582,
            "y": 0.5084265470504761,
            "z": -340.1536560058594
        },
        {
            "x": 8.90881061553955,
            "y": 0.5201113224029541,
            "z": -340.0059814453125
        },
        {
            "x": 8.961651802062988,
            "y": 0.5318201184272766,
            "z": -339.8583068847656
        },
        {
            "x": 9.01450252532959,
            "y": 0.5435564517974854,
            "z": -339.71051025390625
        },
        {
            "x": 9.067290306091309,
            "y": 0.5552976131439209,
            "z": -339.56280517578125
        },
        {
            "x": 9.120094299316406,
            "y": 0.56705641746521,
            "z": -339.4150390625
        },
        {
            "x": 9.172871589660645,
            "y": 0.5788187384605408,
            "z": -339.2673034667969
        },
        {
            "x": 9.225611686706543,
            "y": 0.5905791521072388,
            "z": -339.11956787109375
        },
        {
            "x": 9.278346061706543,
            "y": 0.6023445129394531,
            "z": -338.9718017578125
        },
        {
            "x": 9.331008911132812,
            "y": 0.6140958666801453,
            "z": -338.8240661621094
        },
        {
            "x": 9.383650779724121,
            "y": 0.6258354187011719,
            "z": -338.67633056640625
        },
        {
            "x": 9.43636417388916,
            "y": 0.6375768184661865,
            "z": -338.5283508300781
        },
        {
            "x": 9.48896312713623,
            "y": 0.6492835283279419,
            "z": -338.380615234375
        },
        {
            "x": 9.541523933410645,
            "y": 0.6609693765640259,
            "z": -338.2327880859375
        },
        {
            "x": 9.594046592712402,
            "y": 0.6726272702217102,
            "z": -338.08489990234375
        },
        {
            "x": 9.646539688110352,
            "y": 0.6842484474182129,
            "z": -337.93707275390625
        },
        {
            "x": 9.699073791503906,
            "y": 0.6958494782447815,
            "z": -337.7890625
        },
        {
            "x": 9.751486778259277,
            "y": 0.7073959112167358,
            "z": -337.64117431640625
        },
        {
            "x": 9.80384349822998,
            "y": 0.7188960313796997,
            "z": -337.4932861328125
        },
        {
            "x": 9.856173515319824,
            "y": 0.7303465008735657,
            "z": -337.34539794921875
        },
        {
            "x": 9.908474922180176,
            "y": 0.7417420744895935,
            "z": -337.197509765625
        },
        {
            "x": 9.96076488494873,
            "y": 0.7530889511108398,
            "z": -337.0494384765625
        },
        {
            "x": 10.012985229492188,
            "y": 0.764376163482666,
            "z": -336.9013366699219
        },
        {
            "x": 10.065123558044434,
            "y": 0.7755885124206543,
            "z": -336.7533264160156
        },
        {
            "x": 10.117215156555176,
            "y": 0.786730170249939,
            "z": -336.6052551269531
        },
        {
            "x": 10.169266700744629,
            "y": 0.7977967262268066,
            "z": -336.45721435546875
        },
        {
            "x": 10.221250534057617,
            "y": 0.8087860345840454,
            "z": -336.3091125488281
        },
        {
            "x": 10.273232460021973,
            "y": 0.8197016716003418,
            "z": -336.16082763671875
        },
        {
            "x": 10.325085639953613,
            "y": 0.8305153846740723,
            "z": -336.0127258300781
        },
        {
            "x": 10.376919746398926,
            "y": 0.8412399291992188,
            "z": -335.8645324707031
        },
        {
            "x": 10.428716659545898,
            "y": 0.8518741726875305,
            "z": -335.71624755859375
        },
        {
            "x": 10.480400085449219,
            "y": 0.8624000549316406,
            "z": -335.5680236816406
        },
        {
            "x": 10.532064437866211,
            "y": 0.8728319406509399,
            "z": -335.4195861816406
        },
        {
            "x": 10.583625793457031,
            "y": 0.88314288854599,
            "z": -335.2712707519531
        },
        {
            "x": 10.63513469696045,
            "y": 0.893341064453125,
            "z": -335.1229553222656
        },
        {
            "x": 10.686619758605957,
            "y": 0.9034297466278076,
            "z": -334.9744567871094
        },
        {
            "x": 10.737970352172852,
            "y": 0.9133894443511963,
            "z": -334.8260192871094
        },
        {
            "x": 10.789244651794434,
            "y": 0.9232242107391357,
            "z": -334.677490234375
        },
        {
            "x": 10.840461730957031,
            "y": 0.9329276084899902,
            "z": -334.529052734375
        },
        {
            "x": 10.891622543334961,
            "y": 0.9424956440925598,
            "z": -334.3805236816406
        },
        {
            "x": 10.925680160522461,
            "y": 0.9487939476966858,
            "z": -334.28143310546875
        },
        {
            "x": 10.976666450500488,
            "y": 0.9581283330917358,
            "z": -334.1328430175781
        },
        {
            "x": 11.027555465698242,
            "y": 0.9673141241073608,
            "z": -333.9842224121094
        },
        {
            "x": 11.078412055969238,
            "y": 0.9763494729995728,
            "z": -333.8354797363281
        },
        {
            "x": 11.129203796386719,
            "y": 0.9852267503738403,
            "z": -333.686767578125
        },
        {
            "x": 11.17988109588623,
            "y": 0.9939472675323486,
            "z": -333.5379943847656
        },
        {
            "x": 11.230470657348633,
            "y": 1.002509355545044,
            "z": -333.3891296386719
        },
        {
            "x": 11.280927658081055,
            "y": 1.010890007019043,
            "z": -333.2402648925781
        },
        {
            "x": 11.331366539001465,
            "y": 1.0191049575805664,
            "z": -333.0913391113281
        },
        {
            "x": 11.381708145141602,
            "y": 1.027146339416504,
            "z": -332.94232177734375
        },
        {
            "x": 11.431922912597656,
            "y": 1.0350075960159302,
            "z": -332.7933044433594
        },
        {
            "x": 11.482008934020996,
            "y": 1.0426750183105469,
            "z": -332.6442565917969
        },
        {
            "x": 11.531997680664062,
            "y": 1.050149917602539,
            "z": -332.4952392578125
        },
        {
            "x": 11.581918716430664,
            "y": 1.0574332475662231,
            "z": -332.34619140625
        },
        {
            "x": 11.631824493408203,
            "y": 1.0645320415496826,
            "z": -332.1967468261719
        },
        {
            "x": 11.681502342224121,
            "y": 1.0714111328125,
            "z": -332.0475158691406
        },
        {
            "x": 11.731067657470703,
            "y": 1.0780835151672363,
            "z": -331.8982849121094
        },
        {
            "x": 11.780557632446289,
            "y": 1.0845459699630737,
            "z": -331.7490234375
        },
        {
            "x": 11.829961776733398,
            "y": 1.090795874595642,
            "z": -331.5996398925781
        },
        {
            "x": 11.879268646240234,
            "y": 1.0968244075775146,
            "z": -331.4501037597656
        },
        {
            "x": 11.92836856842041,
            "y": 1.10262131690979,
            "z": -331.30059814453125
        },
        {
            "x": 11.977359771728516,
            "y": 1.1081914901733398,
            "z": -331.151123046875
        },
        {
            "x": 12.026253700256348,
            "y": 1.113527536392212,
            "z": -331.001708984375
        },
        {
            "x": 12.07507610321045,
            "y": 1.1186238527297974,
            "z": -330.85205078125
        },
        {
            "x": 12.123751640319824,
            "y": 1.1234798431396484,
            "z": -330.70233154296875
        },
        {
            "x": 12.172289848327637,
            "y": 1.128091812133789,
            "z": -330.552490234375
        },
        {
            "x": 12.220664024353027,
            "y": 1.1324496269226074,
            "z": -330.40283203125
        },
        {
            "x": 12.26899242401123,
            "y": 1.1365504264831543,
            "z": -330.2529602050781
        },
        {
            "x": 12.317167282104492,
            "y": 1.1403896808624268,
            "z": -330.10308837890625
        },
        {
            "x": 12.365139961242676,
            "y": 1.1439661979675293,
            "z": -329.9531555175781
        },
        {
            "x": 12.413023948669434,
            "y": 1.147280216217041,
            "z": -329.80303955078125
        },
        {
            "x": 12.46075439453125,
            "y": 1.1503102779388428,
            "z": -329.653076171875
        },
        {
            "x": 12.50839900970459,
            "y": 1.1530640125274658,
            "z": -329.50299072265625
        },
        {
            "x": 12.555887222290039,
            "y": 1.1555403470993042,
            "z": -329.3528137207031
        },
        {
            "x": 12.603140830993652,
            "y": 1.1577316522598267,
            "z": -329.2026062011719
        },
        {
            "x": 12.650328636169434,
            "y": 1.1596276760101318,
            "z": -329.0522766113281
        },
        {
            "x": 12.697345733642578,
            "y": 1.1612251996994019,
            "z": -328.9020690917969
        },
        {
            "x": 12.744245529174805,
            "y": 1.1625275611877441,
            "z": -328.7517395019531
        },
        {
            "x": 12.790976524353027,
            "y": 1.1635308265686035,
            "z": -328.6011657714844
        },
        {
            "x": 12.837474822998047,
            "y": 1.1642181873321533,
            "z": -328.45074462890625
        },
        {
            "x": 12.8838529586792,
            "y": 1.1645917892456055,
            "z": -328.30029296875
        },
        {
            "x": 12.930159568786621,
            "y": 1.1646519899368286,
            "z": -328.1496887207031
        },
        {
            "x": 12.976255416870117,
            "y": 1.1643975973129272,
            "z": -327.9989929199219
        },
        {
            "x": 13.006855010986328,
            "y": 1.1640455722808838,
            "z": -327.8985290527344
        },
        {
            "x": 13.052578926086426,
            "y": 1.1632661819458008,
            "z": -327.7478942871094
        },
        {
            "x": 13.098180770874023,
            "y": 1.1621835231781006,
            "z": -327.5972900390625
        },
        {
            "x": 13.143732070922852,
            "y": 1.1607904434204102,
            "z": -327.4463195800781
        },
        {
            "x": 13.189020156860352,
            "y": 1.1590979099273682,
            "z": -327.2954406738281
        },
        {
            "x": 13.234086036682129,
            "y": 1.1571147441864014,
            "z": -327.1445617675781
        },
        {
            "x": 13.278992652893066,
            "y": 1.1548449993133545,
            "z": -326.9935302734375
        },
        {
            "x": 13.32374382019043,
            "y": 1.152287483215332,
            "z": -326.8426513671875
        },
        {
            "x": 13.368385314941406,
            "y": 1.1494414806365967,
            "z": -326.6914978027344
        },
        {
            "x": 13.412779808044434,
            "y": 1.1463217735290527,
            "z": -326.5401916503906
        },
        {
            "x": 13.456893920898438,
            "y": 1.1429369449615479,
            "z": -326.3890686035156
        },
        {
            "x": 13.500882148742676,
            "y": 1.139280080795288,
            "z": -326.2379455566406
        },
        {
            "x": 13.544722557067871,
            "y": 1.1353574991226196,
            "z": -326.08673095703125
        },
        {
            "x": 13.588371276855469,
            "y": 1.1311753988265991,
            "z": -325.93536376953125
        },
        {
            "x": 13.63181209564209,
            "y": 1.1267359256744385,
            "z": -325.78375244140625
        },
        {
            "x": 13.674972534179688,
            "y": 1.1220530271530151,
            "z": -325.6323547363281
        },
        {
            "x": 13.718000411987305,
            "y": 1.1171190738677979,
            "z": -325.4809875488281
        },
        {
            "x": 13.760876655578613,
            "y": 1.1119427680969238,
            "z": -325.32940673828125
        },
        {
            "x": 13.803496360778809,
            "y": 1.1065316200256348,
            "z": -325.1777648925781
        },
        {
            "x": 13.845881462097168,
            "y": 1.1008813381195068,
            "z": -325.02593994140625
        },
        {
            "x": 13.888025283813477,
            "y": 1.095009446144104,
            "z": -324.8743896484375
        },
        {
            "x": 13.930033683776855,
            "y": 1.0889135599136353,
            "z": -324.7227478027344
        },
        {
            "x": 13.971846580505371,
            "y": 1.082594394683838,
            "z": -324.57086181640625
        },
        {
            "x": 14.013354301452637,
            "y": 1.0760619640350342,
            "z": -324.41900634765625
        },
        {
            "x": 14.054628372192383,
            "y": 1.069313883781433,
            "z": -324.2670593261719
        },
        {
            "x": 14.095746994018555,
            "y": 1.0623629093170166,
            "z": -324.1151428222656
        },
        {
            "x": 14.136676788330078,
            "y": 1.0552120208740234,
            "z": -323.96319580078125
        },
        {
            "x": 14.17737865447998,
            "y": 1.0478533506393433,
            "z": -323.81097412109375
        },
        {
            "x": 14.217730522155762,
            "y": 1.0403046607971191,
            "z": -323.6588439941406
        },
        {
            "x": 14.257864952087402,
            "y": 1.0325753688812256,
            "z": -323.5068359375
        },
        {
            "x": 14.297903060913086,
            "y": 1.024651288986206,
            "z": -323.3544921875
        },
        {
            "x": 14.33768081665039,
            "y": 1.0165505409240723,
            "z": -323.20220947265625
        },
        {
            "x": 14.377156257629395,
            "y": 1.0082619190216064,
            "z": -323.0497131347656
        },
        {
            "x": 14.41633415222168,
            "y": 0.9998116493225098,
            "z": -322.8973693847656
        },
        {
            "x": 14.455301284790039,
            "y": 0.9912057518959045,
            "z": -322.74505615234375
        },
        {
            "x": 14.494157791137695,
            "y": 0.9824199676513672,
            "z": -322.5924377441406
        },
        {
            "x": 14.532698631286621,
            "y": 0.9734702110290527,
            "z": -322.43975830078125
        },
        {
            "x": 14.570884704589844,
            "y": 0.9643760919570923,
            "z": -322.2871398925781
        },
        {
            "x": 14.608854293823242,
            "y": 0.9551346302032471,
            "z": -322.13446044921875
        },
        {
            "x": 14.646638870239258,
            "y": 0.9457534551620483,
            "z": -321.9819030761719
        },
        {
            "x": 14.684215545654297,
            "y": 0.9362103939056396,
            "z": -321.8289794921875
        },
        {
            "x": 14.721452713012695,
            "y": 0.9265303611755371,
            "z": -321.67596435546875
        },
        {
            "x": 14.758340835571289,
            "y": 0.9167320728302002,
            "z": -321.5230407714844
        },
        {
            "x": 14.782803535461426,
            "y": 0.9101366996765137,
            "z": -321.4212646484375
        },
        {
            "x": 14.819389343261719,
            "y": 0.9001244902610779,
            "z": -321.268310546875
        },
        {
            "x": 14.855701446533203,
            "y": 0.8899868726730347,
            "z": -321.1152038574219
        },
        {
            "x": 14.891705513000488,
            "y": 0.8797220587730408,
            "z": -320.96185302734375
        },
        {
            "x": 14.92733383178711,
            "y": 0.8693603873252869,
            "z": -320.8087158203125
        },
        {
            "x": 14.962759017944336,
            "y": 0.8588986396789551,
            "z": -320.6556701660156
        },
        {
            "x": 14.998007774353027,
            "y": 0.8483172655105591,
            "z": -320.5022888183594
        },
        {
            "x": 15.032915115356445,
            "y": 0.8376355171203613,
            "z": -320.3488464355469
        },
        {
            "x": 15.067456245422363,
            "y": 0.826858639717102,
            "z": -320.1953430175781
        },
        {
            "x": 15.101719856262207,
            "y": 0.8160009384155273,
            "z": -320.04193115234375
        },
        {
            "x": 15.135795593261719,
            "y": 0.8050559759140015,
            "z": -319.8884582519531
        },
        {
            "x": 15.16961669921875,
            "y": 0.794013500213623,
            "z": -319.7347106933594
        },
        {
            "x": 15.203023910522461,
            "y": 0.7828989028930664,
            "z": -319.58099365234375
        },
        {
            "x": 15.236063003540039,
            "y": 0.7717228531837463,
            "z": -319.4273376464844
        },
        {
            "x": 15.268919944763184,
            "y": 0.7604703903198242,
            "z": -319.2735595703125
        },
        {
            "x": 15.301556587219238,
            "y": 0.7491512298583984,
            "z": -319.1197204589844
        },
        {
            "x": 15.33383560180664,
            "y": 0.7377615571022034,
            "z": -318.9656677246094
        },
        {
            "x": 15.365701675415039,
            "y": 0.7263240814208984,
            "z": -318.8116455078125
        },
        {
            "x": 15.397272109985352,
            "y": 0.7148461937904358,
            "z": -318.65771484375
        },
        {
            "x": 15.428680419921875,
            "y": 0.7033060789108276,
            "z": -318.50360107421875
        },
        {
            "x": 15.45975399017334,
            "y": 0.6917217969894409,
            "z": -318.349365234375
        },
        {
            "x": 15.490389823913574,
            "y": 0.6801003217697144,
            "z": -318.195068359375
        },
        {
            "x": 15.520665168762207,
            "y": 0.6684551239013672,
            "z": -318.0408630371094
        },
        {
            "x": 15.5507173538208,
            "y": 0.656784176826477,
            "z": -317.88671875
        },
        {
            "x": 15.580543518066406,
            "y": 0.6450684070587158,
            "z": -317.7322692871094
        },
        {
            "x": 15.609973907470703,
            "y": 0.6333202719688416,
            "z": -317.57757568359375
        },
        {
            "x": 15.638947486877441,
            "y": 0.6215721368789673,
            "z": -317.42303466796875
        },
        {
            "x": 15.667646408081055,
            "y": 0.6098129749298096,
            "z": -317.2684631347656
        },
        {
            "x": 15.696113586425781,
            "y": 0.5980480313301086,
            "z": -317.11395263671875
        },
        {
            "x": 15.724235534667969,
            "y": 0.5862646102905273,
            "z": -316.9591369628906
        },
        {
            "x": 15.751938819885254,
            "y": 0.5744662284851074,
            "z": -316.8040771484375
        },
        {
            "x": 15.77922534942627,
            "y": 0.5626997947692871,
            "z": -316.6493225097656
        },
        {
            "x": 15.806269645690918,
            "y": 0.5509417653083801,
            "z": -316.4945068359375
        },
        {
            "x": 15.833059310913086,
            "y": 0.5391830205917358,
            "z": -316.33953857421875
        },
        {
            "x": 15.859407424926758,
            "y": 0.5274374485015869,
            "z": -316.18438720703125
        },
        {
            "x": 15.885336875915527,
            "y": 0.5157065391540527,
            "z": -316.029052734375
        },
        {
            "x": 15.91091537475586,
            "y": 0.5040258169174194,
            "z": -315.8740539550781
        },
        {
            "x": 15.936256408691406,
            "y": 0.4923704266548157,
            "z": -315.7189636230469
        },
        {
            "x": 15.961241722106934,
            "y": 0.48072549700737,
            "z": -315.5634460449219
        },
        {
            "x": 15.985733032226562,
            "y": 0.4691293239593506,
            "z": -315.4080505371094
        },
        {
            "x": 16.00983428955078,
            "y": 0.45758169889450073,
            "z": -315.2525939941406
        },
        {
            "x": 16.033679962158203,
            "y": 0.4460814595222473,
            "z": -315.09716796875
        },
        {
            "x": 16.057207107543945,
            "y": 0.4346272349357605,
            "z": -314.9416198730469
        },
        {
            "x": 16.072647094726562,
            "y": 0.42701470851898193,
            "z": -314.83782958984375
        },
        {
            "x": 16.09537696838379,
            "y": 0.4156535267829895,
            "z": -314.6820983886719
        },
        {
            "x": 16.117721557617188,
            "y": 0.40436801314353943,
            "z": -314.5265197753906
        },
        {
            "x": 16.139850616455078,
            "y": 0.3931318521499634,
            "z": -314.37066650390625
        },
        {
            "x": 16.161603927612305,
            "y": 0.3819653391838074,
            "z": -314.2148132324219
        },
        {
            "x": 16.1828556060791,
            "y": 0.3708712160587311,
            "z": -314.05877685546875
        },
        {
            "x": 16.203641891479492,
            "y": 0.3598634898662567,
            "z": -313.90277099609375
        },
        {
            "x": 16.2241268157959,
            "y": 0.3489536643028259,
            "z": -313.7469177246094
        },
        {
            "x": 16.244346618652344,
            "y": 0.33810779452323914,
            "z": -313.59075927734375
        },
        {
            "x": 16.264089584350586,
            "y": 0.32734566926956177,
            "z": -313.43438720703125
        },
        {
            "x": 16.283273696899414,
            "y": 0.31669947504997253,
            "z": -313.2781677246094
        },
        {
            "x": 16.302108764648438,
            "y": 0.3061562776565552,
            "z": -313.1219482421875
        },
        {
            "x": 16.32067108154297,
            "y": 0.29571831226348877,
            "z": -312.96575927734375
        },
        {
            "x": 16.338830947875977,
            "y": 0.2853742837905884,
            "z": -312.8092956542969
        },
        {
            "x": 16.3564453125,
            "y": 0.27513378858566284,
            "z": -312.6524963378906
        },
        {
            "x": 16.373579025268555,
            "y": 0.2650384306907654,
            "z": -312.49615478515625
        },
        {
            "x": 16.39044189453125,
            "y": 0.2550618052482605,
            "z": -312.33978271484375
        },
        {
            "x": 16.406967163085938,
            "y": 0.24519643187522888,
            "z": -312.1830749511719
        },
        {
            "x": 16.422943115234375,
            "y": 0.23546075820922852,
            "z": -312.0262756347656
        },
        {
            "x": 16.438398361206055,
            "y": 0.22585538029670715,
            "z": -311.8692932128906
        },
        {
            "x": 16.4534854888916,
            "y": 0.21641238033771515,
            "z": -311.71282958984375
        },
        {
            "x": 16.468286514282227,
            "y": 0.20709921419620514,
            "z": -311.5560302734375
        },
        {
            "x": 16.482601165771484,
            "y": 0.197922945022583,
            "z": -311.3990173339844
        },
        {
            "x": 16.49632453918457,
            "y": 0.1889050006866455,
            "z": -311.2419738769531
        },
        {
            "x": 16.509611129760742,
            "y": 0.18004800379276276,
            "z": -311.0851135253906
        },
        {
            "x": 16.522613525390625,
            "y": 0.17134855687618256,
            "z": -310.92816162109375
        },
        {
            "x": 16.53520965576172,
            "y": 0.16280493140220642,
            "z": -310.7710266113281
        },
        {
            "x": 16.547212600708008,
            "y": 0.1544237583875656,
            "z": -310.6136474609375
        },
        {
            "x": 16.558679580688477,
            "y": 0.14622817933559418,
            "z": -310.4565734863281
        },
        {
            "x": 16.569801330566406,
            "y": 0.13821306824684143,
            "z": -310.299560546875
        },
        {
            "x": 16.58060073852539,
            "y": 0.1303630769252777,
            "z": -310.14215087890625
        },
        {
            "x": 16.59084129333496,
            "y": 0.12269827723503113,
            "z": -309.9847106933594
        },
        {
            "x": 16.600488662719727,
            "y": 0.11522391438484192,
            "z": -309.8272705078125
        },
        {
            "x": 16.60970115661621,
            "y": 0.10795100033283234,
            "z": -309.6700439453125
        },
        {
            "x": 16.61860466003418,
            "y": 0.10087577253580093,
            "z": -309.5127868652344
        },
        {
            "x": 16.627037048339844,
            "y": 0.09398604184389114,
            "z": -309.35504150390625
        },
        {
            "x": 16.634841918945312,
            "y": 0.08730554580688477,
            "z": -309.1973876953125
        },
        {
            "x": 16.64211654663086,
            "y": 0.08084315061569214,
            "z": -309.0400085449219
        },
        {
            "x": 16.649070739746094,
            "y": 0.07459448277950287,
            "z": -308.882568359375
        },
        {
            "x": 16.655614852905273,
            "y": 0.06855970621109009,
            "z": -308.7249450683594
        },
        {
            "x": 16.661556243896484,
            "y": 0.06273764371871948,
            "z": -308.56707763671875
        },
        {
            "x": 16.66689109802246,
            "y": 0.05714499577879906,
            "z": -308.409423828125
        },
        {
            "x": 16.671825408935547,
            "y": 0.05179212987422943,
            "z": -308.251953125
        },
        {
            "x": 16.6749324798584,
            "y": 0.048355624079704285,
            "z": -308.14691162109375
        },
        {
            "x": 16.679183959960938,
            "y": 0.04338174685835838,
            "z": -307.98907470703125
        },
        {
            "x": 16.682781219482422,
            "y": 0.038649290800094604,
            "z": -307.8312072753906
        },
        {
            "x": 16.68579864501953,
            "y": 0.03416737914085388,
            "z": -307.6733093261719
        },
        {
            "x": 16.688465118408203,
            "y": 0.029939018189907074,
            "z": -307.5157470703125
        },
        {
            "x": 16.690738677978516,
            "y": 0.025954611599445343,
            "z": -307.35797119140625
        },
        {
            "x": 16.692392349243164,
            "y": 0.02222064882516861,
            "z": -307.1999816894531
        },
        {
            "x": 16.693382263183594,
            "y": 0.018759284168481827,
            "z": -307.0421447753906
        },
        {
            "x": 16.69394302368164,
            "y": 0.015561661683022976,
            "z": -306.8844299316406
        },
        {
            "x": 16.69416046142578,
            "y": 0.012626269832253456,
            "z": -306.7265930175781
        },
        {
            "x": 16.693830490112305,
            "y": 0.009959117509424686,
            "z": -306.5685729980469
        },
        {
            "x": 16.692787170410156,
            "y": 0.007575731724500656,
            "z": -306.4104919433594
        },
        {
            "x": 16.69121742248535,
            "y": 0.005473697558045387,
            "z": -306.25274658203125
        },
        {
            "x": 16.68931007385254,
            "y": 0.003652512561529875,
            "z": -306.0950927734375
        },
        {
            "x": 16.68692970275879,
            "y": 0.002112601650878787,
            "z": -305.93695068359375
        },
        {
            "x": 16.683849334716797,
            "y": 0.000874296179972589,
            "z": -305.7789306640625
        },
        {
            "x": 16.680143356323242,
            "y": -7.075117900967598e-05,
            "z": -305.62109375
        },
        {
            "x": 16.676042556762695,
            "y": -0.0007196667138487101,
            "z": -305.4635009765625
        },
        {
            "x": 16.67155647277832,
            "y": -0.0010686253663152456,
            "z": -305.3057861328125
        },
        {
            "x": 16.666410446166992,
            "y": -0.0011310838162899017,
            "z": -305.1476135253906
        },
        {
            "x": 16.660573959350586,
            "y": -0.0011348649859428406,
            "z": -304.98974609375
        },
        {
            "x": 16.654247283935547,
            "y": -0.0011386647820472717,
            "z": -304.8321533203125
        },
        {
            "x": 16.64757537841797,
            "y": -0.0011424757540225983,
            "z": -304.6746520996094
        },
        {
            "x": 16.64033317565918,
            "y": -0.0011462531983852386,
            "z": -304.51678466796875
        },
        {
            "x": 16.632368087768555,
            "y": -0.0011500455439090729,
            "z": -304.35888671875
        },
        {
            "x": 16.62380599975586,
            "y": -0.0011538490653038025,
            "z": -304.2012023925781
        },
        {
            "x": 16.614887237548828,
            "y": -0.0011576302349567413,
            "z": -304.0438232421875
        },
        {
            "x": 16.605480194091797,
            "y": -0.0011614374816417694,
            "z": -303.8860778808594
        },
        {
            "x": 16.595382690429688,
            "y": -0.001165233552455902,
            "z": -303.7283630371094
        },
        {
            "x": 16.5846004486084,
            "y": -0.0011690296232700348,
            "z": -303.57080078125
        },
        {
            "x": 16.573360443115234,
            "y": -0.001172821968793869,
            "z": -303.413330078125
        },
        {
            "x": 16.56174087524414,
            "y": -0.0011766105890274048,
            "z": -303.2560119628906
        },
        {
            "x": 16.549482345581055,
            "y": -0.0011804178357124329,
            "z": -303.0983581542969
        },
        {
            "x": 16.53648567199707,
            "y": -0.0011841990053653717,
            "z": -302.94085693359375
        },
        {
            "x": 16.52294158935547,
            "y": -0.0011879801750183105,
            "z": -302.78363037109375
        },
        {
            "x": 16.50900650024414,
            "y": -0.0011917836964130402,
            "z": -302.62640380859375
        },
        {
            "x": 16.49455451965332,
            "y": -0.0011955611407756805,
            "z": -302.4691467285156
        },
        {
            "x": 16.47936248779297,
            "y": -0.0011993683874607086,
            "z": -302.3117980957031
        },
        {
            "x": 16.4635066986084,
            "y": -0.0012031570076942444,
            "z": -302.1546325683594
        },
        {
            "x": 16.447227478027344,
            "y": -0.001206967979669571,
            "z": -301.997802734375
        },
        {
            "x": 16.430513381958008,
            "y": -0.001210734248161316,
            "z": -301.8408203125
        },
        {
            "x": 16.413105010986328,
            "y": -0.0012145377695560455,
            "z": -301.68353271484375
        },
        {
            "x": 16.394969940185547,
            "y": -0.0012183450162410736,
            "z": -301.5265808105469
        },
        {
            "x": 16.382570266723633,
            "y": -0.0012208744883537292,
            "z": -301.42218017578125
        },
        {
            "x": 16.363679885864258,
            "y": -0.0012246966361999512,
            "z": -301.2656555175781
        },
        {
            "x": 16.34429359436035,
            "y": -0.0012284964323043823,
            "z": -301.10888671875
        },
        {
            "x": 16.32411766052246,
            "y": -0.0012322776019573212,
            "z": -300.951904296875
        },
        {
            "x": 16.303260803222656,
            "y": -0.0012360848486423492,
            "z": -300.7953186035156
        },
        {
            "x": 16.281963348388672,
            "y": -0.001239880919456482,
            "z": -300.6391296386719
        },
        {
            "x": 16.2602481842041,
            "y": -0.0012436769902706146,
            "z": -300.4826965332031
        },
        {
            "x": 16.23785972595215,
            "y": -0.001247461885213852,
            "z": -300.32623291015625
        },
        {
            "x": 16.214683532714844,
            "y": -0.001251261681318283,
            "z": -300.1697692871094
        },
        {
            "x": 16.190956115722656,
            "y": -0.0012550465762615204,
            "z": -300.0137634277344
        },
        {
            "x": 16.166872024536133,
            "y": -0.0012588389217853546,
            "z": -299.85791015625
        },
        {
            "x": 16.142196655273438,
            "y": -0.0012626349925994873,
            "z": -299.7017517089844
        },
        {
            "x": 16.116762161254883,
            "y": -0.0012664273381233215,
            "z": -299.54571533203125
        },
        {
            "x": 16.090654373168945,
            "y": -0.0012702271342277527,
            "z": -299.3899841308594
        },
        {
            "x": 16.064090728759766,
            "y": -0.0012740157544612885,
            "z": -299.234375
        },
        {
            "x": 16.037113189697266,
            "y": -0.0012778230011463165,
            "z": -299.0788879394531
        },
        {
            "x": 16.00941276550293,
            "y": -0.0012816041707992554,
            "z": -298.92315673828125
        },
        {
            "x": 15.980939865112305,
            "y": -0.0012853778898715973,
            "z": -298.7676696777344
        },
        {
            "x": 15.951945304870605,
            "y": -0.0012891776859760284,
            "z": -298.61260986328125
        },
        {
            "x": 15.922545433044434,
            "y": -0.001292988657951355,
            "z": -298.4574890136719
        },
        {
            "x": 15.892570495605469,
            "y": -0.0012967810034751892,
            "z": -298.30230712890625
        },
        {
            "x": 15.861824035644531,
            "y": -0.001300577074289322,
            "z": -298.1471862792969
        },
        {
            "x": 15.830399513244629,
            "y": -0.0013043507933616638,
            "z": -297.9924011230469
        },
        {
            "x": 15.79855728149414,
            "y": -0.0013081654906272888,
            "z": -297.8380126953125
        },
        {
            "x": 15.766246795654297,
            "y": -0.0013119503855705261,
            "z": -297.68341064453125
        },
        {
            "x": 15.733211517333984,
            "y": -0.0013157613575458527,
            "z": -297.5286865234375
        },
        {
            "x": 15.699432373046875,
            "y": -0.001319538801908493,
            "z": -297.37432861328125
        },
        {
            "x": 15.665118217468262,
            "y": -0.0013233236968517303,
            "z": -297.22027587890625
        },
        {
            "x": 15.630428314208984,
            "y": -0.00132712721824646,
            "z": -297.06640625
        },
        {
            "x": 15.59514045715332,
            "y": -0.0013309232890605927,
            "z": -296.9123840332031
        },
        {
            "x": 15.5590238571167,
            "y": -0.0013346970081329346,
            "z": -296.7582702636719
        },
        {
            "x": 15.522289276123047,
            "y": -0.0013384930789470673,
            "z": -296.604736328125
        },
        {
            "x": 15.485137939453125,
            "y": -0.0013422928750514984,
            "z": -296.45147705078125
        },
        {
            "x": 15.447518348693848,
            "y": -0.001346088945865631,
            "z": -296.298095703125
        },
        {
            "x": 15.409202575683594,
            "y": -0.0013498887419700623,
            "z": -296.1447448730469
        },
        {
            "x": 15.370049476623535,
            "y": -0.001353677362203598,
            "z": -295.99139404296875
        },
        {
            "x": 15.330412864685059,
            "y": -0.0013574808835983276,
            "z": -295.8387145996094
        },
        {
            "x": 15.290428161621094,
            "y": -0.0013612713664770126,
            "z": -295.6861877441406
        },
        {
            "x": 15.249835014343262,
            "y": -0.00136505626142025,
            "z": -295.5334167480469
        },
        {
            "x": 15.208451271057129,
            "y": -0.001368846744298935,
            "z": -295.38079833984375
        },
        {
            "x": 15.166379928588867,
            "y": -0.0013726428151130676,
            "z": -295.228515625
        },
        {
            "x": 15.123906135559082,
            "y": -0.0013764295727014542,
            "z": -295.0765686035156
        },
        {
            "x": 15.081013679504395,
            "y": -0.0013802293688058853,
            "z": -294.9246520996094
        },
        {
            "x": 15.052045822143555,
            "y": -0.0013827569782733917,
            "z": -294.82342529296875
        },
        {
            "x": 15.007920265197754,
            "y": -0.001386566087603569,
            "z": -294.6715393066406
        },
        {
            "x": 14.963165283203125,
            "y": -0.0013903509825468063,
            "z": -294.5201721191406
        },
        {
            "x": 14.91800308227539,
            "y": -0.0013941489160060883,
            "z": -294.3689270019531
        },
        {
            "x": 14.872380256652832,
            "y": -0.0013979393988847733,
            "z": -294.2178039550781
        },
        {
            "x": 14.826057434082031,
            "y": -0.0014017373323440552,
            "z": -294.066650390625
        },
        {
            "x": 14.778952598571777,
            "y": -0.0014055240899324417,
            "z": -293.915771484375
        },
        {
            "x": 14.731346130371094,
            "y": -0.0014092978090047836,
            "z": -293.7653503417969
        },
        {
            "x": 14.683337211608887,
            "y": -0.0014131013303995132,
            "z": -293.61505126953125
        },
        {
            "x": 14.634797096252441,
            "y": -0.0014168880879878998,
            "z": -293.46466064453125
        },
        {
            "x": 14.5855073928833,
            "y": -0.0014206897467374802,
            "z": -293.314453125
        },
        {
            "x": 14.535514831542969,
            "y": -0.001424495130777359,
            "z": -293.1645202636719
        },
        {
            "x": 14.485139846801758,
            "y": -0.0014282893389463425,
            "z": -293.0151672363281
        },
        {
            "x": 14.434358596801758,
            "y": -0.001432068645954132,
            "z": -292.8658142089844
        },
        {
            "x": 14.3828763961792,
            "y": -0.0014358609914779663,
            "z": -292.7162170410156
        },
        {
            "x": 14.33066177368164,
            "y": -0.001439664512872696,
            "z": -292.5669860839844
        },
        {
            "x": 14.277844429016113,
            "y": -0.0014434438198804855,
            "z": -292.418212890625
        },
        {
            "x": 14.224699020385742,
            "y": -0.0014472324401140213,
            "z": -292.2697448730469
        },
        {
            "x": 14.17109203338623,
            "y": -0.0014510247856378555,
            "z": -292.1213073730469
        },
        {
            "x": 14.116697311401367,
            "y": -0.0014548301696777344,
            "z": -291.9726867675781
        },
        {
            "x": 14.061626434326172,
            "y": -0.0015035539399832487,
            "z": -291.8245544433594
        },
        {
            "x": 14.006085395812988,
            "y": -0.0020057461224496365,
            "z": -291.67694091796875
        },
        {
            "x": 13.95021915435791,
            "y": -0.003092193976044655,
            "z": -291.5295715332031
        },
        {
            "x": 13.893814086914062,
            "y": -0.0047605000436306,
            "z": -291.3821105957031
        },
        {
            "x": 13.836591720581055,
            "y": -0.007020690478384495,
            "z": -291.2347106933594
        },
        {
            "x": 13.778722763061523,
            "y": -0.00983396265655756,
            "z": -291.087646484375
        },
        {
            "x": 13.720519065856934,
            "y": -0.013183284550905228,
            "z": -290.941162109375
        },
        {
            "x": 13.661911010742188,
            "y": -0.017072705551981926,
            "z": -290.794677734375
        },
        {
            "x": 13.602716445922852,
            "y": -0.021509788930416107,
            "z": -290.6483459472656
        },
        {
            "x": 13.542803764343262,
            "y": -0.026460565626621246,
            "z": -290.5022277832031
        },
        {
            "x": 13.482211112976074,
            "y": -0.03191519156098366,
            "z": -290.3562927246094
        },
        {
            "x": 13.421360969543457,
            "y": -0.03784637898206711,
            "z": -290.2110290527344
        },
        {
            "x": 13.360116958618164,
            "y": -0.04428330436348915,
            "z": -290.0657958984375
        },
        {
            "x": 13.298235893249512,
            "y": -0.05119882896542549,
            "z": -289.9205322265625
        },
        {
            "x": 13.235686302185059,
            "y": -0.058571066707372665,
            "z": -289.7756652832031
        },
        {
            "x": 13.172575950622559,
            "y": -0.06638964265584946,
            "z": -289.6310729980469
        },
        {
            "x": 13.109271049499512,
            "y": -0.07464560866355896,
            "z": -289.48699951171875
        },
        {
            "x": 13.045536041259766,
            "y": -0.0833345577120781,
            "z": -289.3429260253906
        },
        {
            "x": 12.981115341186523,
            "y": -0.09245556592941284,
            "z": -289.1988830566406
        },
        {
            "x": 12.916206359863281,
            "y": -0.10196635127067566,
            "z": -289.0552978515625
        },
        {
            "x": 12.850907325744629,
            "y": -0.11187679320573807,
            "z": -288.912109375
        },
        {
            "x": 12.785354614257812,
            "y": -0.12216991186141968,
            "z": -288.7690124511719
        },
        {
            "x": 12.71938419342041,
            "y": -0.13283821940422058,
            "z": -288.6261291503906
        },
        {
            "x": 12.67509937286377,
            "y": -0.14015358686447144,
            "z": -288.5309143066406
        },
        {
            "x": 12.608346939086914,
            "y": -0.15141622722148895,
            "z": -288.3885498046875
        },
        {
            "x": 12.541400909423828,
            "y": -0.1630060225725174,
            "z": -288.2464599609375
        },
        {
            "x": 12.473997116088867,
            "y": -0.17495352029800415,
            "z": -288.10418701171875
        },
        {
            "x": 12.40625286102295,
            "y": -0.18721604347229004,
            "z": -287.9623107910156
        },
        {
            "x": 12.33829116821289,
            "y": -0.19977325201034546,
            "z": -287.8208312988281
        },
        {
            "x": 12.269977569580078,
            "y": -0.21264579892158508,
            "z": -287.6792297363281
        },
        {
            "x": 12.201462745666504,
            "y": -0.22578367590904236,
            "z": -287.5380554199219
        },
        {
            "x": 12.132822036743164,
            "y": -0.23920246958732605,
            "z": -287.3969421386719
        },
        {
            "x": 12.064010620117188,
            "y": -0.2528943419456482,
            "z": -287.2559509277344
        },
        {
            "x": 11.995170593261719,
            "y": -0.26681968569755554,
            "z": -287.11517333984375
        },
        {
            "x": 11.926228523254395,
            "y": -0.280998170375824,
            "z": -286.9742736816406
        },
        {
            "x": 11.85722827911377,
            "y": -0.29540109634399414,
            "z": -286.83367919921875
        },
        {
            "x": 11.788163185119629,
            "y": -0.31002843379974365,
            "z": -286.69305419921875
        },
        {
            "x": 11.718886375427246,
            "y": -0.3248884677886963,
            "z": -286.5523681640625
        },
        {
            "x": 11.649669647216797,
            "y": -0.3399237096309662,
            "z": -286.4118957519531
        },
        {
            "x": 11.580334663391113,
            "y": -0.35515591502189636,
            "z": -286.27142333984375
        },
        {
            "x": 11.510942459106445,
            "y": -0.37056732177734375,
            "z": -286.13104248046875
        },
        {
            "x": 11.441532135009766,
            "y": -0.38613876700401306,
            "z": -285.9907531738281
        },
        {
            "x": 11.371973037719727,
            "y": -0.4018874168395996,
            "z": -285.850341796875
        },
        {
            "x": 11.302411079406738,
            "y": -0.41776737570762634,
            "z": -285.71002197265625
        },
        {
            "x": 11.232763290405273,
            "y": -0.43378061056137085,
            "z": -285.5699768066406
        },
        {
            "x": 11.163073539733887,
            "y": -0.4499192237854004,
            "z": -285.4298400878906
        },
        {
            "x": 11.093316078186035,
            "y": -0.4661695063114166,
            "z": -285.289794921875
        },
        {
            "x": 11.023480415344238,
            "y": -0.48253223299980164,
            "z": -285.1496887207031
        },
        {
            "x": 10.953596115112305,
            "y": -0.49898749589920044,
            "z": -285.0096435546875
        },
        {
            "x": 10.883670806884766,
            "y": -0.5155196189880371,
            "z": -284.8697204589844
        },
        {
            "x": 10.81370735168457,
            "y": -0.5321233868598938,
            "z": -284.7297668457031
        },
        {
            "x": 10.743698120117188,
            "y": -0.5487850904464722,
            "z": -284.5898742675781
        },
        {
            "x": 10.673664093017578,
            "y": -0.5654984712600708,
            "z": -284.45001220703125
        },
        {
            "x": 10.603506088256836,
            "y": -0.5822656154632568,
            "z": -284.31005859375
        },
        {
            "x": 10.533388137817383,
            "y": -0.5990473031997681,
            "z": -284.1702880859375
        },
        {
            "x": 10.463218688964844,
            "y": -0.6158463954925537,
            "z": -284.0304260253906
        },
        {
            "x": 10.393007278442383,
            "y": -0.632652759552002,
            "z": -283.89068603515625
        },
        {
            "x": 10.322799682617188,
            "y": -0.649450421333313,
            "z": -283.7509765625
        },
        {
            "x": 10.252452850341797,
            "y": -0.6662554740905762,
            "z": -283.611083984375
        },
        {
            "x": 10.182194709777832,
            "y": -0.6830111742019653,
            "z": -283.4714050292969
        },
        {
            "x": 10.111922264099121,
            "y": -0.6997284889221191,
            "z": -283.331787109375
        },
        {
            "x": 10.041581153869629,
            "y": -0.7164168357849121,
            "z": -283.1919860839844
        },
        {
            "x": 9.971245765686035,
            "y": -0.7330359816551208,
            "z": -283.0523986816406
        },
        {
            "x": 9.900898933410645,
            "y": -0.7495916485786438,
            "z": -282.91265869140625
        },
        {
            "x": 9.830523490905762,
            "y": -0.7660778760910034,
            "z": -282.7728576660156
        },
        {
            "x": 9.760231971740723,
            "y": -0.7824574708938599,
            "z": -282.6332702636719
        },
        {
            "x": 9.713306427001953,
            "y": -0.7933285236358643,
            "z": -282.5400695800781
        },
        {
            "x": 9.642911911010742,
            "y": -0.8095449209213257,
            "z": -282.400390625
        },
        {
            "x": 9.572554588317871,
            "y": -0.8256382942199707,
            "z": -282.2607421875
        },
        {
            "x": 9.502098083496094,
            "y": -0.8416210412979126,
            "z": -282.1208190917969
        },
        {
            "x": 9.431724548339844,
            "y": -0.8574462532997131,
            "z": -281.98114013671875
        },
        {
            "x": 9.3613920211792,
            "y": -0.8731215596199036,
            "z": -281.8414306640625
        },
        {
            "x": 9.291010856628418,
            "y": -0.888647198677063,
            "z": -281.7016296386719
        },
        {
            "x": 9.220690727233887,
            "y": -0.9039878845214844,
            "z": -281.5618591308594
        },
        {
            "x": 9.150395393371582,
            "y": -0.9191544055938721,
            "z": -281.4219970703125
        },
        {
            "x": 9.080096244812012,
            "y": -0.9341306686401367,
            "z": -281.2820739746094
        },
        {
            "x": 9.009867668151855,
            "y": -0.9489026069641113,
            "z": -281.1421813964844
        },
        {
            "x": 8.939613342285156,
            "y": -0.9634565114974976,
            "z": -281.0022277832031
        },
        {
            "x": 8.869451522827148,
            "y": -0.9777793884277344,
            "z": -280.8623352050781
        },
        {
            "x": 8.79932975769043,
            "y": -0.9918677806854248,
            "z": -280.7223205566406
        },
        {
            "x": 8.729146003723145,
            "y": -1.0057337284088135,
            "z": -280.58209228515625
        },
        {
            "x": 8.659107208251953,
            "y": -1.0193113088607788,
            "z": -280.44207763671875
        },
        {
            "x": 8.589098930358887,
            "y": -1.0326266288757324,
            "z": -280.30194091796875
        },
        {
            "x": 8.519137382507324,
            "y": -1.0456676483154297,
            "z": -280.1617126464844
        },
        {
            "x": 8.44926643371582,
            "y": -1.058409571647644,
            "z": -280.02154541015625
        },
        {
            "x": 8.37935733795166,
            "y": -1.0708637237548828,
            "z": -279.8811340332031
        },
        {
            "x": 8.309651374816895,
            "y": -1.0829826593399048,
            "z": -279.7408752441406
        },
        {
            "x": 8.23996639251709,
            "y": -1.0947892665863037,
            "z": -279.6004638671875
        },
        {
            "x": 8.170384407043457,
            "y": -1.1062595844268799,
            "z": -279.4601135253906
        },
        {
            "x": 8.100851058959961,
            "y": -1.1173837184906006,
            "z": -279.319580078125
        },
        {
            "x": 8.031405448913574,
            "y": -1.1281481981277466,
            "z": -279.178955078125
        },
        {
            "x": 7.962021827697754,
            "y": -1.1385531425476074,
            "z": -279.03826904296875
        },
        {
            "x": 7.892766952514648,
            "y": -1.148576259613037,
            "z": -278.8975830078125
        },
        {
            "x": 7.823546886444092,
            "y": -1.1582164764404297,
            "z": -278.7566833496094
        },
        {
            "x": 7.7544965744018555,
            "y": -1.1674355268478394,
            "z": -278.6158752441406
        },
        {
            "x": 7.685553073883057,
            "y": -1.1762501001358032,
            "z": -278.4749755859375
        },
        {
            "x": 7.616621017456055,
            "y": -1.184656023979187,
            "z": -278.3338317871094
        },
        {
            "x": 7.547937870025635,
            "y": -1.1926158666610718,
            "z": -278.19281005859375
        },
        {
            "x": 7.479307174682617,
            "y": -1.2001233100891113,
            "z": -278.0516052246094
        },
        {
            "x": 7.41082239151001,
            "y": -1.2071783542633057,
            "z": -277.9103088378906
        },
        {
            "x": 7.342464447021484,
            "y": -1.2137689590454102,
            "z": -277.7690124511719
        },
        {
            "x": 7.274193286895752,
            "y": -1.2198903560638428,
            "z": -277.62744140625
        },
        {
            "x": 7.206122875213623,
            "y": -1.2254990339279175,
            "z": -277.48602294921875
        },
        {
            "x": 7.138224124908447,
            "y": -1.2306108474731445,
            "z": -277.344482421875
        },
        {
            "x": 7.070398330688477,
            "y": -1.2352213859558105,
            "z": -277.2027587890625
        },
        {
            "x": 7.0028076171875,
            "y": -1.2393078804016113,
            "z": -277.06103515625
        },
        {
            "x": 6.935293674468994,
            "y": -1.2428462505340576,
            "z": -276.9191589355469
        },
        {
            "x": 6.867980003356934,
            "y": -1.2458428144454956,
            "z": -276.7771911621094
        },
        {
            "x": 6.800865173339844,
            "y": -1.248288631439209,
            "z": -276.63519287109375
        },
        {
            "x": 6.756216526031494,
            "y": -1.2496010065078735,
            "z": -276.5404968261719
        },
        {
            "x": 6.6894354820251465,
            "y": -1.2510864734649658,
            "z": -276.39837646484375
        },
        {
            "x": 6.622823715209961,
            "y": -1.25199294090271,
            "z": -276.25616455078125
        },
        {
            "x": 6.556344509124756,
            "y": -1.252309799194336,
            "z": -276.1136779785156
        },
        {
            "x": 6.4901123046875,
            "y": -1.2519996166229248,
            "z": -275.9712829589844
        },
        {
            "x": 6.424111366271973,
            "y": -1.2510998249053955,
            "z": -275.828857421875
        },
        {
            "x": 6.358212471008301,
            "y": -1.2496192455291748,
            "z": -275.6861267089844
        },
        {
            "x": 6.29263162612915,
            "y": -1.2475719451904297,
            "z": -275.54351806640625
        },
        {
            "x": 6.227181434631348,
            "y": -1.2449393272399902,
            "z": -275.4006652832031
        },
        {
            "x": 6.162012577056885,
            "y": -1.2417593002319336,
            "z": -275.2577819824219
        },
        {
            "x": 6.097060680389404,
            "y": -1.2380461692810059,
            "z": -275.1148681640625
        },
        {
            "x": 6.032355308532715,
            "y": -1.2338054180145264,
            "z": -274.9718017578125
        },
        {
            "x": 5.967883586883545,
            "y": -1.2290306091308594,
            "z": -274.8287048339844
        },
        {
            "x": 5.903730392456055,
            "y": -1.2237548828125,
            "z": -274.6855773925781
        },
        {
            "x": 5.839668273925781,
            "y": -1.2179759740829468,
            "z": -274.5420837402344
        },
        {
            "x": 5.77598237991333,
            "y": -1.2117283344268799,
            "z": -274.3988037109375
        },
        {
            "x": 5.712471008300781,
            "y": -1.2049851417541504,
            "z": -274.2552490234375
        },
        {
            "x": 5.649289608001709,
            "y": -1.1977853775024414,
            "z": -274.11175537109375
        },
        {
            "x": 5.586353778839111,
            "y": -1.1901357173919678,
            "z": -273.9680480957031
        },
        {
            "x": 5.523608684539795,
            "y": -1.1820435523986816,
            "z": -273.8242492675781
        },
        {
            "x": 5.461239337921143,
            "y": -1.173519253730774,
            "z": -273.680419921875
        },
        {
            "x": 5.3991594314575195,
            "y": -1.164578914642334,
            "z": -273.53656005859375
        },
        {
            "x": 5.337338447570801,
            "y": -1.1552315950393677,
            "z": -273.39251708984375
        },
        {
            "x": 5.275820732116699,
            "y": -1.1454973220825195,
            "z": -273.24853515625
        },
        {
            "x": 5.214561939239502,
            "y": -1.1353611946105957,
            "z": -273.104248046875
        },
        {
            "x": 5.15358304977417,
            "y": -1.1248507499694824,
            "z": -272.9599304199219
        },
        {
            "x": 5.092919826507568,
            "y": -1.1139812469482422,
            "z": -272.81549072265625
        },
        {
            "x": 5.032537937164307,
            "y": -1.1027674674987793,
            "z": -272.6710510253906
        },
        {
            "x": 4.972480773925781,
            "y": -1.0912039279937744,
            "z": -272.52642822265625
        },
        {
            "x": 4.912738800048828,
            "y": -1.0793142318725586,
            "z": -272.3818359375
        },
        {
            "x": 4.853267192840576,
            "y": -1.067091941833496,
            "z": -272.23687744140625
        },
        {
            "x": 4.794145107269287,
            "y": -1.0545823574066162,
            "z": -272.09210205078125
        },
        {
            "x": 4.735328674316406,
            "y": -1.0417633056640625,
            "z": -271.9470520019531
        },
        {
            "x": 4.6768012046813965,
            "y": -1.0286567211151123,
            "z": -271.80194091796875
        },
        {
            "x": 4.6186933517456055,
            "y": -1.0152854919433594,
            "z": -271.65679931640625
        },
        {
            "x": 4.5607757568359375,
            "y": -1.0016353130340576,
            "z": -271.5113830566406
        },
        {
            "x": 4.503324508666992,
            "y": -0.9877507090568542,
            "z": -271.3660583496094
        },
        {
            "x": 4.44612979888916,
            "y": -0.9736108779907227,
            "z": -271.2205505371094
        },
        {
            "x": 4.389300346374512,
            "y": -0.9592432975769043,
            "z": -271.0749206542969
        },
        {
            "x": 4.332760810852051,
            "y": -0.9446560144424438,
            "z": -270.92919921875
        },
        {
            "x": 4.276620864868164,
            "y": -0.929866373538971,
            "z": -270.78338623046875
        },
        {
            "x": 4.220734596252441,
            "y": -0.9148571491241455,
            "z": -270.63739013671875
        },
        {
            "x": 4.165274143218994,
            "y": -0.8996797800064087,
            "z": -270.49139404296875
        },
        {
            "x": 4.128490924835205,
            "y": -0.8894646167755127,
            "z": -270.3939514160156
        },
        {
            "x": 4.073568344116211,
            "y": -0.8739948272705078,
            "z": -270.2477722167969
        },
        {
            "x": 4.0190582275390625,
            "y": -0.8583686351776123,
            "z": -270.1014709472656
        },
        {
            "x": 3.9647793769836426,
            "y": -0.8425787687301636,
            "z": -269.9549255371094
        },
        {
            "x": 3.910984754562378,
            "y": -0.8266710042953491,
            "z": -269.80841064453125
        },
        {
            "x": 3.8574676513671875,
            "y": -0.8106297254562378,
            "z": -269.6617736816406
        },
        {
            "x": 3.8043582439422607,
            "y": -0.794469952583313,
            "z": -269.5149230957031
        },
        {
            "x": 3.751552104949951,
            "y": -0.7782050371170044,
            "z": -269.3680725097656
        },
        {
            "x": 3.699147939682007,
            "y": -0.7618508338928223,
            "z": -269.2210388183594
        },
        {
            "x": 3.647036552429199,
            "y": -0.745396614074707,
            "z": -269.0737609863281
        },
        {
            "x": 3.595369577407837,
            "y": -0.7288892269134521,
            "z": -268.9266052246094
        },
        {
            "x": 3.5439934730529785,
            "y": -0.712299108505249,
            "z": -268.7790832519531
        },
        {
            "x": 3.493055820465088,
            "y": -0.6956831216812134,
            "z": -268.6316833496094
        },
        {
            "x": 3.4424359798431396,
            "y": -0.6790102124214172,
            "z": -268.4840087890625
        },
        {
            "x": 3.3921761512756348,
            "y": -0.6623034477233887,
            "z": -268.3362121582031
        },
        {
            "x": 3.3423280715942383,
            "y": -0.6455798149108887,
            "z": -268.1883544921875
        },
        {
            "x": 3.292811155319214,
            "y": -0.6288527250289917,
            "z": -268.0404052734375
        },
        {
            "x": 3.243709087371826,
            "y": -0.6121248006820679,
            "z": -267.89227294921875
        },
        {
            "x": 3.1949310302734375,
            "y": -0.5954110622406006,
            "z": -267.74407958984375
        },
        {
            "x": 3.146542549133301,
            "y": -0.5787062644958496,
            "z": -267.5955810546875
        },
        {
            "x": 3.0984883308410645,
            "y": -0.5620431303977966,
            "z": -267.44708251953125
        },
        {
            "x": 3.0508999824523926,
            "y": -0.5454413890838623,
            "z": -267.2986145019531
        },
        {
            "x": 3.0036144256591797,
            "y": -0.5288769602775574,
            "z": -267.14990234375
        },
        {
            "x": 2.9567668437957764,
            "y": -0.5123952627182007,
            "z": -267.00115966796875
        },
        {
            "x": 2.9102277755737305,
            "y": -0.49596521258354187,
            "z": -266.8520812988281
        },
        {
            "x": 2.864072322845459,
            "y": -0.4796287417411804,
            "z": -266.7030029296875
        },
        {
            "x": 2.818335771560669,
            "y": -0.4633914828300476,
            "z": -266.5538024902344
        },
        {
            "x": 2.7728962898254395,
            "y": -0.4472540616989136,
            "z": -266.4043273925781
        },
        {
            "x": 2.7279210090637207,
            "y": -0.431244820356369,
            "z": -266.2549133300781
        },
        {
            "x": 2.683259963989258,
            "y": -0.415363073348999,
            "z": -266.1053466796875
        },
        {
            "x": 2.638984441757202,
            "y": -0.3996008038520813,
            "z": -265.9554138183594
        },
        {
            "x": 2.5950934886932373,
            "y": -0.38401007652282715,
            "z": -265.80560302734375
        },
        {
            "x": 2.5516111850738525,
            "y": -0.36858031153678894,
            "z": -265.6556396484375
        },
        {
            "x": 2.5084614753723145,
            "y": -0.3533064126968384,
            "z": -265.50543212890625
        },
        {
            "x": 2.4657137393951416,
            "y": -0.33823245763778687,
            "z": -265.3553161621094
        },
        {
            "x": 2.4232985973358154,
            "y": -0.3233240842819214,
            "z": -265.2047119140625
        },
        {
            "x": 2.3812947273254395,
            "y": -0.3086475729942322,
            "z": -265.0543518066406
        },
        {
            "x": 2.339726209640503,
            "y": -0.2941795587539673,
            "z": -264.9037780761719
        },
        {
            "x": 2.2984185218811035,
            "y": -0.27991920709609985,
            "z": -264.7529602050781
        },
        {
            "x": 2.25760817527771,
            "y": -0.2659159004688263,
            "z": -264.6022033691406
        },
        {
            "x": 2.2170636653900146,
            "y": -0.2521405518054962,
            "z": -264.45111083984375
        },
        {
            "x": 2.1769540309906006,
            "y": -0.23863066732883453,
            "z": -264.3000183105469
        },
        {
            "x": 2.1372101306915283,
            "y": -0.2253793179988861,
            "z": -264.14874267578125
        },
        {
            "x": 2.1109085083007812,
            "y": -0.21671119332313538,
            "z": -264.0479431152344
        },
        {
            "x": 2.0718462467193604,
            "y": -0.20394259691238403,
            "z": -263.89654541015625
        },
        {
            "x": 2.0330698490142822,
            "y": -0.19145451486110687,
            "z": -263.7450256347656
        },
        {
            "x": 1.9946599006652832,
            "y": -0.17926979064941406,
            "z": -263.5932312011719
        },
        {
            "x": 1.956655502319336,
            "y": -0.16741502285003662,
            "z": -263.44146728515625
        },
        {
            "x": 1.919021725654602,
            "y": -0.155890554189682,
            "z": -263.28961181640625
        },
        {
            "x": 1.8817697763442993,
            "y": -0.14468812942504883,
            "z": -263.1374816894531
        },
        {
            "x": 1.8448400497436523,
            "y": -0.13384124636650085,
            "z": -262.98541259765625
        },
        {
            "x": 1.8083468675613403,
            "y": -0.12335997074842453,
            "z": -262.8330383300781
        },
        {
            "x": 1.7721433639526367,
            "y": -0.11323846876621246,
            "z": -262.6805725097656
        },
        {
            "x": 1.7363879680633545,
            "y": -0.10350936651229858,
            "z": -262.5281982421875
        },
        {
            "x": 1.700966715812683,
            "y": -0.0941530093550682,
            "z": -262.37542724609375
        },
        {
            "x": 1.6658899784088135,
            "y": -0.08522346615791321,
            "z": -262.2228088378906
        },
        {
            "x": 1.6312403678894043,
            "y": -0.07670137286186218,
            "z": -262.07000732421875
        },
        {
            "x": 1.5968388319015503,
            "y": -0.06858707964420319,
            "z": -261.9168395996094
        },
        {
            "x": 1.5629132986068726,
            "y": -0.06091688945889473,
            "z": -261.763916015625
        },
        {
            "x": 1.5292925834655762,
            "y": -0.05369912460446358,
            "z": -261.6107177734375
        },
        {
            "x": 1.4960373640060425,
            "y": -0.046938955783843994,
            "z": -261.45751953125
        },
        {
            "x": 1.4631927013397217,
            "y": -0.04063867777585983,
            "z": -261.30413818359375
        },
        {
            "x": 1.430597186088562,
            "y": -0.03480440378189087,
            "z": -261.15057373046875
        },
        {
            "x": 1.3984994888305664,
            "y": -0.029483461752533913,
            "z": -260.9971618652344
        },
        {
            "x": 1.3666870594024658,
            "y": -0.02465398795902729,
            "z": -260.843505859375
        },
        {
            "x": 1.3352550268173218,
            "y": -0.020331591367721558,
            "z": -260.6899108886719
        },
        {
            "x": 1.3041834831237793,
            "y": -0.016520217061042786,
            "z": -260.5360412597656
        },
        {
            "x": 1.2734119892120361,
            "y": -0.013254206627607346,
            "z": -260.38214111328125
        },
        {
            "x": 1.2430678606033325,
            "y": -0.010528797283768654,
            "z": -260.2281799316406
        },
        {
            "x": 1.2130153179168701,
            "y": -0.008349122479557991,
            "z": -260.0740966796875
        },
        {
            "x": 1.1833243370056152,
            "y": -0.006725414656102657,
            "z": -259.9200134277344
        },
        {
            "x": 1.1540260314941406,
            "y": -0.005690516903996468,
            "z": -259.76580810546875
        },
        {
            "x": 1.1250112056732178,
            "y": -0.005238455720245838,
            "z": -259.6116027832031
        },
        {
            "x": 1.0963802337646484,
            "y": -0.005201684311032295,
            "z": -259.45709228515625
        },
        {
            "x": 1.06806218624115,
            "y": -0.00520140677690506,
            "z": -259.3026428222656
        },
        {
            "x": 1.0401110649108887,
            "y": -0.005201123654842377,
            "z": -259.148193359375
        },
        {
            "x": 1.0125317573547363,
            "y": -0.005200836807489395,
            "z": -258.9936218261719
        },
        {
            "x": 0.9852415919303894,
            "y": -0.005200564861297607,
            "z": -258.83905029296875
        },
        {
            "x": 0.9583150148391724,
            "y": -0.005200270563364029,
            "z": -258.68426513671875
        },
        {
            "x": 0.9317241311073303,
            "y": -0.005199989303946495,
            "z": -258.529541015625
        },
        {
            "x": 0.9054742455482483,
            "y": -0.005199706181883812,
            "z": -258.3748474121094
        },
        {
            "x": 0.8795775175094604,
            "y": -0.005199413746595383,
            "z": -258.21990966796875
        },
        {
            "x": 0.8539485931396484,
            "y": -0.005199136212468147,
            "z": -258.0649719238281
        },
        {
            "x": 0.8287070393562317,
            "y": -0.005198845639824867,
            "z": -257.9100341796875
        },
        {
            "x": 0.8037692904472351,
            "y": -0.005198558792471886,
            "z": -257.7549133300781
        },
        {
            "x": 0.7791457176208496,
            "y": -0.0051982831209897995,
            "z": -257.59991455078125
        },
        {
            "x": 0.7629510164260864,
            "y": -0.00519808754324913,
            "z": -257.49652099609375
        },
        {
            "x": 0.7388890981674194,
            "y": -0.005197806283831596,
            "z": -257.34136962890625
        },
        {
            "x": 0.7151280045509338,
            "y": -0.005197519436478615,
            "z": -257.1862487792969
        },
        {
            "x": 0.691714882850647,
            "y": -0.005197241902351379,
            "z": -257.0308532714844
        },
        {
            "x": 0.6685800552368164,
            "y": -0.005196958780288696,
            "z": -256.87554931640625
        },
        {
            "x": 0.6458061933517456,
            "y": -0.005196673795580864,
            "z": -256.7202453613281
        },
        {
            "x": 0.6233452558517456,
            "y": -0.005196385085582733,
            "z": -256.564697265625
        },
        {
            "x": 0.6011365652084351,
            "y": -0.0051960814744234085,
            "z": -256.4093017578125
        },
        {
            "x": 0.5793072581291199,
            "y": -0.005195803940296173,
            "z": -256.2537841796875
        },
        {
            "x": 0.5577515363693237,
            "y": -0.005195530131459236,
            "z": -256.09814453125
        },
        {
            "x": 0.5364854335784912,
            "y": -0.005195247009396553,
            "z": -255.94261169433594
        },
        {
            "x": 0.515571653842926,
            "y": -0.005194973200559616,
            "z": -255.7869110107422
        },
        {
            "x": 0.49491724371910095,
            "y": -0.005194682627916336,
            "z": -255.63124084472656
        },
        {
            "x": 0.47457802295684814,
            "y": -0.0051943957805633545,
            "z": -255.4755859375
        },
        {
            "x": 0.4545523524284363,
            "y": -0.005194120109081268,
            "z": -255.31967163085938
        },
        {
            "x": 0.43477335572242737,
            "y": -0.00519382581114769,
            "z": -255.1638641357422
        },
        {
            "x": 0.41533470153808594,
            "y": -0.005193544551730156,
            "z": -255.00804138183594
        },
        {
            "x": 0.39620158076286316,
            "y": -0.005193259567022324,
            "z": -254.85211181640625
        },
        {
            "x": 0.37730419635772705,
            "y": -0.005192957818508148,
            "z": -254.6962432861328
        },
        {
            "x": 0.3587370216846466,
            "y": -0.005192698910832405,
            "z": -254.5401611328125
        },
        {
            "x": 0.3404614329338074,
            "y": -0.005192410200834274,
            "z": -254.3841552734375
        },
        {
            "x": 0.32243281602859497,
            "y": -0.005192119628190994,
            "z": -254.22817993164062
        },
        {
            "x": 0.3047568202018738,
            "y": -0.005191842094063759,
            "z": -254.07220458984375
        },
        {
            "x": 0.2873128354549408,
            "y": -0.00519154779613018,
            "z": -253.91610717773438
        },
        {
            "x": 0.27012699842453003,
            "y": -0.005191272124648094,
            "z": -253.75997924804688
        },
        {
            "x": 0.2532893419265747,
            "y": -0.005190985277295113,
            "z": -253.60377502441406
        },
        {
            "x": 0.2366729974746704,
            "y": -0.005190709605813026,
            "z": -253.4476318359375
        },
        {
            "x": 0.22031906247138977,
            "y": -0.005190415307879448,
            "z": -253.29139709472656
        },
        {
            "x": 0.20430389046669006,
            "y": -0.005190134048461914,
            "z": -253.13516235351562
        },
        {
            "x": 0.18849435448646545,
            "y": -0.005189845338463783,
            "z": -252.97885131835938
        },
        {
            "x": 0.17295429110527039,
            "y": -0.005189569666981697,
            "z": -252.82244873046875
        },
        {
            "x": 0.15774095058441162,
            "y": -0.005189279094338417,
            "z": -252.6661376953125
        },
        {
            "x": 0.1427171230316162,
            "y": -0.00518900528550148,
            "z": -252.5097198486328
        },
        {
            "x": 0.12799662351608276,
            "y": -0.0051887147128582,
            "z": -252.35336303710938
        },
        {
            "x": 0.11357191205024719,
            "y": -0.005188420414924622,
            "z": -252.1969757080078
        },
        {
            "x": 0.09931698441505432,
            "y": -0.00518815778195858,
            "z": -252.04034423828125
        },
        {
            "x": 0.08537554740905762,
            "y": -0.005187857896089554,
            "z": -251.88397216796875
        },
        {
            "x": 0.07172945141792297,
            "y": -0.005187567323446274,
            "z": -251.7275390625
        },
        {
            "x": 0.058252304792404175,
            "y": -0.005187297239899635,
            "z": -251.5709228515625
        },
        {
            "x": 0.04507455229759216,
            "y": -0.005187012255191803,
            "z": -251.41445922851562
        },
        {
            "x": 0.03216797113418579,
            "y": -0.005186732858419418,
            "z": -251.25782775878906
        },
        {
            "x": 0.019446372985839844,
            "y": -0.005186436697840691,
            "z": -251.10116577148438
        },
        {
            "x": 0.00701788067817688,
            "y": -0.005186164751648903,
            "z": -250.9446563720703
        },
        {
            "x": -0.00111311674118042,
            "y": -0.005185967311263084,
            "z": -250.8402862548828
        },
        {
            "x": -0.01315203309059143,
            "y": -0.0051856860518455505,
            "z": -250.68365478515625
        },
        {
            "x": -0.02495989203453064,
            "y": -0.005185393616557121,
            "z": -250.52706909179688
        },
        {
            "x": -0.036485329270362854,
            "y": -0.005185117945075035,
            "z": -250.37025451660156
        },
        {
            "x": -0.04780268669128418,
            "y": -0.005184819921851158,
            "z": -250.21360778808594
        },
        {
            "x": -0.058896079659461975,
            "y": -0.005184546113014221,
            "z": -250.05694580078125
        },
        {
            "x": -0.0697031170129776,
            "y": -0.005184262990951538,
            "z": -249.900146484375
        },
        {
            "x": -0.080307736992836,
            "y": -0.0051839761435985565,
            "z": -249.74339294433594
        },
        {
            "x": -0.09071590006351471,
            "y": -0.0051836781203746796,
            "z": -249.5866241455078
        },
        {
            "x": -0.10082519054412842,
            "y": -0.005183406174182892,
            "z": -249.4298095703125
        },
        {
            "x": -0.11072582006454468,
            "y": -0.005183128640055656,
            "z": -249.27301025390625
        },
        {
            "x": -0.12045197188854218,
            "y": -0.005182845517992973,
            "z": -249.11614990234375
        },
        {
            "x": -0.12988872826099396,
            "y": -0.0051825568079948425,
            "z": -248.95938110351562
        },
        {
            "x": -0.13909634947776794,
            "y": -0.005182279273867607,
            "z": -248.8025665283203
        },
        {
            "x": -0.14815154671669006,
            "y": -0.005181990563869476,
            "z": -248.6455535888672
        },
        {
            "x": -0.15693271160125732,
            "y": -0.005181707441806793,
            "z": -248.48876953125
        },
        {
            "x": -0.16548031568527222,
            "y": -0.005181413143873215,
            "z": -248.3318634033203
        },
        {
            "x": -0.17386889457702637,
            "y": -0.005181141197681427,
            "z": -248.17491149902344
        },
        {
            "x": -0.18200883269309998,
            "y": -0.0051808468997478485,
            "z": -248.01806640625
        },
        {
            "x": -0.1899079829454422,
            "y": -0.005180561915040016,
            "z": -247.86102294921875
        },
        {
            "x": -0.1976456195116043,
            "y": -0.005180280655622482,
            "z": -247.70408630371094
        },
        {
            "x": -0.205161452293396,
            "y": -0.005179999396204948,
            "z": -247.54722595214844
        },
        {
            "x": -0.21241404116153717,
            "y": -0.005179721862077713,
            "z": -247.39035034179688
        },
        {
            "x": -0.21950462460517883,
            "y": -0.0051794275641441345,
            "z": -247.23333740234375
        },
        {
            "x": -0.2264205664396286,
            "y": -0.00517914816737175,
            "z": -247.0763397216797
        },
        {
            "x": -0.23306381702423096,
            "y": -0.005178868770599365,
            "z": -246.9193115234375
        },
        {
            "x": -0.2395152747631073,
            "y": -0.005178587511181831,
            "z": -246.76234436035156
        },
        {
            "x": -0.24582144618034363,
            "y": -0.005178295075893402,
            "z": -246.6052703857422
        },
        {
            "x": -0.25187990069389343,
            "y": -0.005178011953830719,
            "z": -246.4483184814453
        },
        {
            "x": -0.2577090561389923,
            "y": -0.005177730694413185,
            "z": -246.29135131835938
        },
        {
            "x": -0.26340994238853455,
            "y": -0.0051774438470602036,
            "z": -246.13412475585938
        },
        {
            "x": -0.2688923478126526,
            "y": -0.00517716258764267,
            "z": -245.97715759277344
        },
        {
            "x": -0.2741367816925049,
            "y": -0.005176883190870285,
            "z": -245.8201141357422
        },
        {
            "x": -0.27922701835632324,
            "y": -0.0051765888929367065,
            "z": -245.66297912597656
        },
        {
            "x": -0.28414440155029297,
            "y": -0.005176307633519173,
            "z": -245.50596618652344
        },
        {
            "x": -0.2888251841068268,
            "y": -0.005176028236746788,
            "z": -245.34878540039062
        },
        {
            "x": -0.29331907629966736,
            "y": -0.0051757339388132095,
            "z": -245.1917266845703
        },
        {
            "x": -0.2976725995540619,
            "y": -0.005175461992621422,
            "z": -245.03468322753906
        },
        {
            "x": -0.3018062114715576,
            "y": -0.005175171419978142,
            "z": -244.87757873535156
        },
        {
            "x": -0.30572232604026794,
            "y": -0.005174892023205757,
            "z": -244.72052001953125
        },
        {
            "x": -0.3095107674598694,
            "y": -0.005174599587917328,
            "z": -244.5632781982422
        },
        {
            "x": -0.31311744451522827,
            "y": -0.0051743146032094955,
            "z": -244.40614318847656
        },
        {
            "x": -0.3164879381656647,
            "y": -0.00517403706908226,
            "z": -244.2491455078125
        },
        {
            "x": -0.3186422288417816,
            "y": -0.005173839628696442,
            "z": -244.14442443847656
        },
        {
            "x": -0.32177016139030457,
            "y": -0.005173558369278908,
            "z": -243.9873046875
        },
        {
            "x": -0.32470574975013733,
            "y": -0.005173284560441971,
            "z": -243.83029174804688
        },
        {
            "x": -0.3274245858192444,
            "y": -0.005173006094992161,
            "z": -243.6730194091797
        },
        {
            "x": -0.3299972712993622,
            "y": -0.005172706209123135,
            "z": -243.51589965820312
        },
        {
            "x": -0.3324262797832489,
            "y": -0.005172427743673325,
            "z": -243.3588104248047
        },
        {
            "x": -0.3346390426158905,
            "y": -0.005172139964997768,
            "z": -243.20162963867188
        },
        {
            "x": -0.3366664946079254,
            "y": -0.005171853117644787,
            "z": -243.0444793701172
        },
        {
            "x": -0.338578462600708,
            "y": -0.005171574652194977,
            "z": -242.88723754882812
        },
        {
            "x": -0.3403131365776062,
            "y": -0.005171285942196846,
            "z": -242.73004150390625
        },
        {
            "x": -0.34184134006500244,
            "y": -0.005171008408069611,
            "z": -242.5729522705078
        },
        {
            "x": -0.3432406187057495,
            "y": -0.005170723423361778,
            "z": -242.41566467285156
        },
        {
            "x": -0.3445146083831787,
            "y": -0.0051704393699765205,
            "z": -242.25856018066406
        },
        {
            "x": -0.3456181287765503,
            "y": -0.005170156247913837,
            "z": -242.1014404296875
        },
        {
            "x": -0.34660470485687256,
            "y": -0.005169861018657684,
            "z": -241.94407653808594
        },
        {
            "x": -0.3475230932235718,
            "y": -0.005169580690562725,
            "z": -241.78688049316406
        },
        {
            "x": -0.34834054112434387,
            "y": -0.005169298499822617,
            "z": -241.62965393066406
        },
        {
            "x": -0.34912246465682983,
            "y": -0.005169008858501911,
            "z": -241.47235107421875
        },
        {
            "x": -0.3499632477760315,
            "y": -0.0051687369123101234,
            "z": -241.31507873535156
        },
        {
            "x": -0.35083234310150146,
            "y": -0.005168447270989418,
            "z": -241.1576385498047
        },
        {
            "x": -0.35176315903663635,
            "y": -0.005168159492313862,
            "z": -241.00030517578125
        },
        {
            "x": -0.35287806391716003,
            "y": -0.0051678819581866264,
            "z": -240.84295654296875
        },
        {
            "x": -0.3541759252548218,
            "y": -0.00516759417951107,
            "z": -240.68560791015625
        },
        {
            "x": -0.3556177318096161,
            "y": -0.005167307332158089,
            "z": -240.52828979492188
        },
        {
            "x": -0.3573169708251953,
            "y": -0.00516702514141798,
            "z": -240.37074279785156
        },
        {
            "x": -0.35929733514785767,
            "y": -0.005166750401258469,
            "z": -240.2132568359375
        },
        {
            "x": -0.36146336793899536,
            "y": -0.005166466347873211,
            "z": -240.05592346191406
        },
        {
            "x": -0.36387598514556885,
            "y": -0.005153852514922619,
            "z": -239.8983612060547
        },
        {
            "x": -0.3666192293167114,
            "y": -0.004972516559064388,
            "z": -239.74095153808594
        },
        {
            "x": -0.3696131110191345,
            "y": -0.004538020584732294,
            "z": -239.58363342285156
        },
        {
            "x": -0.3728075623512268,
            "y": -0.003851695917546749,
            "z": -239.4260711669922
        },
        {
            "x": -0.3763155937194824,
            "y": -0.0029245298355817795,
            "z": -239.26861572265625
        },
        {
            "x": -0.38014519214630127,
            "y": -0.001759401522576809,
            "z": -239.1112060546875
        },
        {
            "x": -0.38417476415634155,
            "y": -0.00035535567440092564,
            "z": -238.953857421875
        },
        {
            "x": -0.3884581923484802,
            "y": 0.0012867297045886517,
            "z": -238.7964630126953
        },
        {
            "x": -0.39309778809547424,
            "y": 0.003159424290060997,
            "z": -238.6388702392578
        },
        {
            "x": -0.3979928493499756,
            "y": 0.0052532022818923,
            "z": -238.4816131591797
        },
        {
            "x": -0.4030849039554596,
            "y": 0.007572558242827654,
            "z": -238.32431030273438
        },
        {
            "x": -0.4085105359554291,
            "y": 0.010119514539837837,
            "z": -238.16683959960938
        },
        {
            "x": -0.4142598509788513,
            "y": 0.012878144159913063,
            "z": -238.0095672607422
        },
        {
            "x": -0.420215368270874,
            "y": 0.01584877260029316,
            "z": -237.8522491455078
        },
        {
            "x": -0.4264296889305115,
            "y": 0.01903313212096691,
            "z": -237.69482421875
        },
        {
            "x": -0.43300700187683105,
            "y": 0.022426394745707512,
            "z": -237.53756713867188
        },
        {
            "x": -0.4375436305999756,
            "y": 0.02479724958539009,
            "z": -237.43275451660156
        },
        {
            "x": -0.4445037245750427,
            "y": 0.028521794825792313,
            "z": -237.2755889892578
        },
        {
            "x": -0.45176464319229126,
            "y": 0.032450854778289795,
            "z": -237.11831665039062
        },
        {
            "x": -0.459386944770813,
            "y": 0.036576490849256516,
            "z": -236.9609375
        },
        {
            "x": -0.4672292470932007,
            "y": 0.0408841148018837,
            "z": -236.80381774902344
        },
        {
            "x": -0.47530534863471985,
            "y": 0.045380912721157074,
            "z": -236.6466522216797
        },
        {
            "x": -0.4837580919265747,
            "y": 0.050071295350790024,
            "z": -236.4893798828125
        },
        {
            "x": -0.4924919903278351,
            "y": 0.0549343079328537,
            "z": -236.3323211669922
        },
        {
            "x": -0.501431941986084,
            "y": 0.05997650697827339,
            "z": -236.17515563964844
        },
        {
            "x": -0.5107004642486572,
            "y": 0.06519526243209839,
            "z": -236.0179443359375
        },
        {
            "x": -0.5203142762184143,
            "y": 0.07058386504650116,
            "z": -235.8609161376953
        },
        {
            "x": -0.5301430225372314,
            "y": 0.07614059746265411,
            "z": -235.70382690429688
        },
        {
            "x": -0.5402430295944214,
            "y": 0.08185900002717972,
            "z": -235.54678344726562
        },
        {
            "x": -0.55070960521698,
            "y": 0.08773522078990936,
            "z": -235.38978576660156
        },
        {
            "x": -0.561445951461792,
            "y": 0.09377766400575638,
            "z": -235.23272705078125
        },
        {
            "x": -0.5724060535430908,
            "y": 0.09996829181909561,
            "z": -235.0757598876953
        },
        {
            "x": -0.5837268829345703,
            "y": 0.10630886256694794,
            "z": -234.9188232421875
        },
        {
            "x": -0.5953494906425476,
            "y": 0.11279289424419403,
            "z": -234.761962890625
        },
        {
            "x": -0.607185423374176,
            "y": 0.11942391842603683,
            "z": -234.60511779785156
        },
        {
            "x": -0.6193760633468628,
            "y": 0.1262037754058838,
            "z": -234.44808959960938
        },
        {
            "x": -0.6318883895874023,
            "y": 0.1331077516078949,
            "z": -234.2913360595703
        },
        {
            "x": -0.6446094512939453,
            "y": 0.14014247059822083,
            "z": -234.13461303710938
        },
        {
            "x": -0.6576458215713501,
            "y": 0.14731493592262268,
            "z": -233.97784423828125
        },
        {
            "x": -0.6710468530654907,
            "y": 0.1546102613210678,
            "z": -233.82118225097656
        },
        {
            "x": -0.6846896409988403,
            "y": 0.16202887892723083,
            "z": -233.6644744873047
        },
        {
            "x": -0.6985927820205688,
            "y": 0.1695694774389267,
            "z": -233.50772094726562
        },
        {
            "x": -0.7128762602806091,
            "y": 0.17722420394420624,
            "z": -233.3511199951172
        },
        {
            "x": -0.7274352312088013,
            "y": 0.18499349057674408,
            "z": -233.1945037841797
        },
        {
            "x": -0.7422189116477966,
            "y": 0.19286662340164185,
            "z": -233.0379638671875
        },
        {
            "x": -0.7573745250701904,
            "y": 0.2008470594882965,
            "z": -232.88145446777344
        },
        {
            "x": -0.7728559970855713,
            "y": 0.20893803238868713,
            "z": -232.724853515625
        },
        {
            "x": -0.7885388731956482,
            "y": 0.21711847186088562,
            "z": -232.56845092773438
        },
        {
            "x": -0.80458664894104,
            "y": 0.22539982199668884,
            "z": -232.41195678710938
        },
        {
            "x": -0.82095867395401,
            "y": 0.23376807570457458,
            "z": -232.25559997558594
        },
        {
            "x": -0.8375437259674072,
            "y": 0.24222353100776672,
            "z": -232.0992889404297
        },
        {
            "x": -0.8544988632202148,
            "y": 0.2507798969745636,
            "z": -231.94277954101562
        },
        {
            "x": -0.8717715740203857,
            "y": 0.2594015300273895,
            "z": -231.7865753173828
        },
        {
            "x": -0.889260470867157,
            "y": 0.26809966564178467,
            "z": -231.63038635253906
        },
        {
            "x": -0.9070894718170166,
            "y": 0.27688419818878174,
            "z": -231.47409057617188
        },
        {
            "x": -0.9252755641937256,
            "y": 0.28573161363601685,
            "z": -231.31800842285156
        },
        {
            "x": -0.9436943531036377,
            "y": 0.294649600982666,
            "z": -231.16184997558594
        },
        {
            "x": -0.9624165296554565,
            "y": 0.3036361336708069,
            "z": -231.00564575195312
        },
        {
            "x": -0.9815038442611694,
            "y": 0.31267642974853516,
            "z": -230.84967041015625
        },
        {
            "x": -0.9943646788597107,
            "y": 0.31873470544815063,
            "z": -230.7457275390625
        },
        {
            "x": -1.0138540267944336,
            "y": 0.3278670907020569,
            "z": -230.58978271484375
        },
        {
            "x": -1.0337307453155518,
            "y": 0.33705535531044006,
            "z": -230.43385314941406
        },
        {
            "x": -1.0539231300354004,
            "y": 0.34629809856414795,
            "z": -230.2778778076172
        },
        {
            "x": -1.0743262767791748,
            "y": 0.3555760979652405,
            "z": -230.12208557128906
        },
        {
            "x": -1.09510338306427,
            "y": 0.36489829421043396,
            "z": -229.9662628173828
        },
        {
            "x": -1.1161986589431763,
            "y": 0.3742605745792389,
            "z": -229.81048583984375
        },
        {
            "x": -1.1375118494033813,
            "y": 0.38365256786346436,
            "z": -229.65480041503906
        },
        {
            "x": -1.1592117547988892,
            "y": 0.39308521151542664,
            "z": -229.4990234375
        },
        {
            "x": -1.1812093257904053,
            "y": 0.40253889560699463,
            "z": -229.3433837890625
        },
        {
            "x": -1.2034244537353516,
            "y": 0.41201263666152954,
            "z": -229.18783569335938
        },
        {
            "x": -1.2260353565216064,
            "y": 0.42151695489883423,
            "z": -229.03219604492188
        },
        {
            "x": -1.24893057346344,
            "y": 0.4310271739959717,
            "z": -228.87680053710938
        },
        {
            "x": -1.2720577716827393,
            "y": 0.44055360555648804,
            "z": -228.7213897705078
        },
        {
            "x": -1.2955833673477173,
            "y": 0.4501032829284668,
            "z": -228.5657958984375
        },
        {
            "x": -1.319385051727295,
            "y": 0.4596439599990845,
            "z": -228.41053771972656
        },
        {
            "x": -1.3434300422668457,
            "y": 0.46919316053390503,
            "z": -228.2552032470703
        },
        {
            "x": -1.3678438663482666,
            "y": 0.4787450432777405,
            "z": -228.0998992919922
        },
        {
            "x": -1.3925254344940186,
            "y": 0.4882827401161194,
            "z": -227.94480895996094
        },
        {
            "x": -1.417506217956543,
            "y": 0.49783116579055786,
            "z": -227.78944396972656
        },
        {
            "x": -1.4428224563598633,
            "y": 0.5073573589324951,
            "z": -227.6343536376953
        },
        {
            "x": -1.468406319618225,
            "y": 0.5168634057044983,
            "z": -227.47938537597656
        },
        {
            "x": -1.494246244430542,
            "y": 0.5263583660125732,
            "z": -227.32437133789062
        },
        {
            "x": -1.5204675197601318,
            "y": 0.5358311533927917,
            "z": -227.16943359375
        },
        {
            "x": -1.5469613075256348,
            "y": 0.5452806353569031,
            "z": -227.01449584960938
        },
        {
            "x": -1.573717713356018,
            "y": 0.554706335067749,
            "z": -226.85955810546875
        },
        {
            "x": -1.6008284091949463,
            "y": 0.5640946626663208,
            "z": -226.70477294921875
        },
        {
            "x": -1.628206491470337,
            "y": 0.5734496712684631,
            "z": -226.5500030517578
        },
        {
            "x": -1.6558468341827393,
            "y": 0.5827646255493164,
            "z": -226.39529418945312
        },
        {
            "x": -1.6838446855545044,
            "y": 0.5920366048812866,
            "z": -226.24066162109375
        },
        {
            "x": -1.7121039628982544,
            "y": 0.601271390914917,
            "z": -226.08596801757812
        },
        {
            "x": -1.7406415939331055,
            "y": 0.6104508638381958,
            "z": -225.931396484375
        },
        {
            "x": -1.7695389986038208,
            "y": 0.6195780038833618,
            "z": -225.77688598632812
        },
        {
            "x": -1.7986496686935425,
            "y": 0.6286468505859375,
            "z": -225.62245178222656
        },
        {
            "x": -1.8280742168426514,
            "y": 0.6376591324806213,
            "z": -225.46804809570312
        },
        {
            "x": -1.8578639030456543,
            "y": 0.6466147303581238,
            "z": -225.31358337402344
        },
        {
            "x": -1.8878310918807983,
            "y": 0.6554920077323914,
            "z": -225.15933227539062
        },
        {
            "x": -1.918144941329956,
            "y": 0.6643035411834717,
            "z": -225.00509643554688
        },
        {
            "x": -1.9487636089324951,
            "y": 0.6730446815490723,
            "z": -224.85086059570312
        },
        {
            "x": -1.9795916080474854,
            "y": 0.6817021369934082,
            "z": -224.69677734375
        },
        {
            "x": -2.010798454284668,
            "y": 0.6902874708175659,
            "z": -224.5426025390625
        },
        {
            "x": -2.0422568321228027,
            "y": 0.6987848877906799,
            "z": -224.38856506347656
        },
        {
            "x": -2.0739400386810303,
            "y": 0.7071924209594727,
            "z": -224.23460388183594
        },
        {
            "x": -2.095273017883301,
            "y": 0.7127469778060913,
            "z": -224.13198852539062
        },
        {
            "x": -2.127467632293701,
            "y": 0.7209969758987427,
            "z": -223.9781951904297
        },
        {
            "x": -2.1599040031433105,
            "y": 0.7291549444198608,
            "z": -223.8243865966797
        },
        {
            "x": -2.1927287578582764,
            "y": 0.7372221946716309,
            "z": -223.67044067382812
        },
        {
            "x": -2.2257442474365234,
            "y": 0.7451694011688232,
            "z": -223.51681518554688
        },
        {
            "x": -2.2590243816375732,
            "y": 0.7530137300491333,
            "z": -223.36317443847656
        },
        {
            "x": -2.2926461696624756,
            "y": 0.7607520818710327,
            "z": -223.2095184326172
        },
        {
            "x": -2.3264594078063965,
            "y": 0.7683700323104858,
            "z": -223.0560302734375
        },
        {
            "x": -2.3606035709381104,
            "y": 0.7758744955062866,
            "z": -222.90245056152344
        },
        {
            "x": -2.3950326442718506,
            "y": 0.7832549810409546,
            "z": -222.74900817871094
        },
        {
            "x": -2.4296481609344482,
            "y": 0.7905089855194092,
            "z": -222.59564208984375
        },
        {
            "x": -2.4646053314208984,
            "y": 0.7976411581039429,
            "z": -222.44223022460938
        },
        {
            "x": -2.499795913696289,
            "y": 0.804630696773529,
            "z": -222.2890167236328
        },
        {
            "x": -2.535217046737671,
            "y": 0.8114873170852661,
            "z": -222.13580322265625
        },
        {
            "x": -2.5709943771362305,
            "y": 0.818213701248169,
            "z": -221.98252868652344
        },
        {
            "x": -2.60693097114563,
            "y": 0.8247895240783691,
            "z": -221.82948303222656
        },
        {
            "x": -2.6431562900543213,
            "y": 0.8312181830406189,
            "z": -221.67637634277344
        },
        {
            "x": -2.6796679496765137,
            "y": 0.8374975323677063,
            "z": -221.5233917236328
        },
        {
            "x": -2.7163567543029785,
            "y": 0.8436230421066284,
            "z": -221.37051391601562
        },
        {
            "x": -2.7533950805664062,
            "y": 0.8496026992797852,
            "z": -221.21743774414062
        },
        {
            "x": -2.7906224727630615,
            "y": 0.8554061651229858,
            "z": -221.064697265625
        },
        {
            "x": -2.8280696868896484,
            "y": 0.8610487580299377,
            "z": -220.9119415283203
        },
        {
            "x": -2.8658039569854736,
            "y": 0.866525411605835,
            "z": -220.75929260253906
        },
        {
            "x": -2.903726100921631,
            "y": 0.8718317747116089,
            "z": -220.60671997070312
        },
        {
            "x": -2.941941738128662,
            "y": 0.8769634366035461,
            "z": -220.45401000976562
        },
        {
            "x": -2.9804108142852783,
            "y": 0.8819166421890259,
            "z": -220.3014373779297
        },
        {
            "x": -3.0190370082855225,
            "y": 0.886687159538269,
            "z": -220.1489715576172
        },
        {
            "x": -3.0579605102539062,
            "y": 0.8912788033485413,
            "z": -219.9964599609375
        },
        {
            "x": -3.097078561782837,
            "y": 0.8956719636917114,
            "z": -219.84413146972656
        },
        {
            "x": -3.1364052295684814,
            "y": 0.8998746871948242,
            "z": -219.6918182373047
        },
        {
            "x": -3.1760454177856445,
            "y": 0.9038886427879333,
            "z": -219.53941345214844
        },
        {
            "x": -3.2158050537109375,
            "y": 0.9077001810073853,
            "z": -219.38720703125
        },
        {
            "x": -3.25583815574646,
            "y": 0.9113051891326904,
            "z": -219.23500061035156
        },
        {
            "x": -3.296079158782959,
            "y": 0.9147034287452698,
            "z": -219.08290100097656
        },
        {
            "x": -3.336491823196411,
            "y": 0.9178935289382935,
            "z": -218.9308624267578
        },
        {
            "x": -3.377208948135376,
            "y": 0.9208763837814331,
            "z": -218.77870178222656
        },
        {
            "x": -3.4180305004119873,
            "y": 0.9236319065093994,
            "z": -218.6267852783203
        },
        {
            "x": -3.459088087081909,
            "y": 0.9261684417724609,
            "z": -218.47488403320312
        },
        {
            "x": -3.500370502471924,
            "y": 0.9284839034080505,
            "z": -218.32301330566406
        },
        {
            "x": -3.5417728424072266,
            "y": 0.9305728673934937,
            "z": -218.1712646484375
        },
        {
            "x": -3.58345365524292,
            "y": 0.9324270486831665,
            "z": -218.01943969726562
        },
        {
            "x": -3.6253013610839844,
            "y": 0.934045672416687,
            "z": -217.86770629882812
        },
        {
            "x": -3.667304277420044,
            "y": 0.9354278445243835,
            "z": -217.7161102294922
        },
        {
            "x": -3.6954293251037598,
            "y": 0.9362167119979858,
            "z": -217.61505126953125
        },
        {
            "x": -3.737724542617798,
            "y": 0.9371907711029053,
            "z": -217.4635467529297
        },
        {
            "x": -3.780214548110962,
            "y": 0.9379207491874695,
            "z": -217.3120574951172
        },
        {
            "x": -3.8229448795318604,
            "y": 0.9384028911590576,
            "z": -217.16046142578125
        },
        {
            "x": -3.8657517433166504,
            "y": 0.9386246204376221,
            "z": -217.00909423828125
        },
        {
            "x": -3.9087631702423096,
            "y": 0.9385873079299927,
            "z": -216.85780334472656
        },
        {
            "x": -3.9519429206848145,
            "y": 0.9382956027984619,
            "z": -216.70639038085938
        },
        {
            "x": -3.9952552318573,
            "y": 0.937753438949585,
            "z": -216.55516052246094
        },
        {
            "x": -4.03877592086792,
            "y": 0.9369561672210693,
            "z": -216.40391540527344
        },
        {
            "x": -4.082413673400879,
            "y": 0.9359102249145508,
            "z": -216.252685546875
        },
        {
            "x": -4.12620210647583,
            "y": 0.9346247911453247,
            "z": -216.10159301757812
        },
        {
            "x": -4.170142650604248,
            "y": 0.9331012964248657,
            "z": -215.95045471191406
        },
        {
            "x": -4.214189529418945,
            "y": 0.9313393235206604,
            "z": -215.79945373535156
        },
        {
            "x": -4.258393287658691,
            "y": 0.9293425679206848,
            "z": -215.6485137939453
        },
        {
            "x": -4.3027544021606445,
            "y": 0.9271167516708374,
            "z": -215.49742126464844
        },
        {
            "x": -4.347214698791504,
            "y": 0.9246709942817688,
            "z": -215.3465576171875
        },
        {
            "x": -4.3917951583862305,
            "y": 0.9219993352890015,
            "z": -215.1957244873047
        },
        {
            "x": -4.436500549316406,
            "y": 0.9191063642501831,
            "z": -215.04486083984375
        },
        {
            "x": -4.481303691864014,
            "y": 0.9160028100013733,
            "z": -214.89413452148438
        },
        {
            "x": -4.5262627601623535,
            "y": 0.912685215473175,
            "z": -214.7432403564453
        },
        {
            "x": -4.57129430770874,
            "y": 0.909162700176239,
            "z": -214.5925750732422
        },
        {
            "x": -4.6164116859436035,
            "y": 0.9054328203201294,
            "z": -214.4419708251953
        },
        {
            "x": -4.661630153656006,
            "y": 0.9015044569969177,
            "z": -214.29136657714844
        },
        {
            "x": -4.706945896148682,
            "y": 0.8973819017410278,
            "z": -214.1408233642578
        },
        {
            "x": -4.752369403839111,
            "y": 0.8930609226226807,
            "z": -213.990234375
        },
        {
            "x": -4.7978949546813965,
            "y": 0.8885464668273926,
            "z": -213.83963012695312
        },
        {
            "x": -4.843453884124756,
            "y": 0.8838510513305664,
            "z": -213.689208984375
        },
        {
            "x": -4.88911771774292,
            "y": 0.8789715766906738,
            "z": -213.53868103027344
        },
        {
            "x": -4.934844017028809,
            "y": 0.873913586139679,
            "z": -213.38829040527344
        },
        {
            "x": -4.980615615844727,
            "y": 0.8686774969100952,
            "z": -213.23793029785156
        },
        {
            "x": -5.026516437530518,
            "y": 0.8632646799087524,
            "z": -213.08741760253906
        },
        {
            "x": -5.072404384613037,
            "y": 0.8576904535293579,
            "z": -212.93710327148438
        },
        {
            "x": -5.118370056152344,
            "y": 0.8519490957260132,
            "z": -212.78677368164062
        },
        {
            "x": -5.1643853187561035,
            "y": 0.846042275428772,
            "z": -212.63645935058594
        },
        {
            "x": -5.210412502288818,
            "y": 0.839980959892273,
            "z": -212.48622131347656
        },
        {
            "x": -5.256551265716553,
            "y": 0.8337587118148804,
            "z": -212.3358154296875
        },
        {
            "x": -5.302650451660156,
            "y": 0.827393651008606,
            "z": -212.1856231689453
        },
        {
            "x": -5.34879207611084,
            "y": 0.820877194404602,
            "z": -212.0354461669922
        },
        {
            "x": -5.394975662231445,
            "y": 0.8142136931419373,
            "z": -211.88519287109375
        },
        {
            "x": -5.44115686416626,
            "y": 0.8074153065681458,
            "z": -211.73501586914062
        },
        {
            "x": -5.487376689910889,
            "y": 0.8004763722419739,
            "z": -211.5847930908203
        },
        {
            "x": -5.5336079597473145,
            "y": 0.7933993339538574,
            "z": -211.43455505371094
        },
        {
            "x": -5.579809188842773,
            "y": 0.786198616027832,
            "z": -211.28445434570312
        },
        {
            "x": -5.610613822937012,
            "y": 0.7813312411308289,
            "z": -211.18438720703125
        },
        {
            "x": -5.6568121910095215,
            "y": 0.7739197015762329,
            "z": -211.03428649902344
        },
        {
            "x": -5.7029948234558105,
            "y": 0.7663893699645996,
            "z": -210.8842010498047
        },
        {
            "x": -5.749225616455078,
            "y": 0.7587339878082275,
            "z": -210.73391723632812
        },
        {
            "x": -5.795377254486084,
            "y": 0.7509762048721313,
            "z": -210.5838623046875
        },
        {
            "x": -5.841509819030762,
            "y": 0.7431029081344604,
            "z": -210.43374633789062
        },
        {
            "x": -5.887638568878174,
            "y": 0.735119104385376,
            "z": -210.2835693359375
        },
        {
            "x": -5.933706283569336,
            "y": 0.7270381450653076,
            "z": -210.13348388671875
        },
        {
            "x": -5.979770660400391,
            "y": 0.718853235244751,
            "z": -209.9832763671875
        },
        {
            "x": -6.025768756866455,
            "y": 0.710570216178894,
            "z": -209.8330535888672
        },
        {
            "x": -6.0716962814331055,
            "y": 0.702200174331665,
            "z": -209.6829376220703
        },
        {
            "x": -6.117611885070801,
            "y": 0.6937353610992432,
            "z": -209.53271484375
        },
        {
            "x": -6.163421630859375,
            "y": 0.685191810131073,
            "z": -209.382568359375
        },
        {
            "x": -6.209179401397705,
            "y": 0.6765650510787964,
            "z": -209.2324676513672
        },
        {
            "x": -6.254904270172119,
            "y": 0.6678483486175537,
            "z": -209.0821075439453
        },
        {
            "x": -6.300511837005615,
            "y": 0.6590675115585327,
            "z": -208.93190002441406
        },
        {
            "x": -6.34604549407959,
            "y": 0.6502143144607544,
            "z": -208.7816925048828
        },
        {
            "x": -6.3914947509765625,
            "y": 0.641289234161377,
            "z": -208.6313934326172
        },
        {
            "x": -6.436843395233154,
            "y": 0.6323033571243286,
            "z": -208.48117065429688
        },
        {
            "x": -6.482142925262451,
            "y": 0.6232459545135498,
            "z": -208.33071899414062
        },
        {
            "x": -6.527307033538818,
            "y": 0.6141424179077148,
            "z": -208.18043518066406
        },
        {
            "x": -6.572348594665527,
            "y": 0.6049836874008179,
            "z": -208.03012084960938
        },
        {
            "x": -6.617292404174805,
            "y": 0.5957744121551514,
            "z": -207.8798065185547
        },
        {
            "x": -6.662092685699463,
            "y": 0.5865204930305481,
            "z": -207.7294464111328
        },
        {
            "x": -6.706813335418701,
            "y": 0.577214241027832,
            "z": -207.57894897460938
        },
        {
            "x": -6.751414775848389,
            "y": 0.5678679347038269,
            "z": -207.42843627929688
        },
        {
            "x": -6.795831680297852,
            "y": 0.5584906339645386,
            "z": -207.2779541015625
        },
        {
            "x": -6.8401713371276855,
            "y": 0.5490727424621582,
            "z": -207.12734985351562
        },
        {
            "x": -6.884298324584961,
            "y": 0.5396339893341064,
            "z": -206.97682189941406
        },
        {
            "x": -6.9283037185668945,
            "y": 0.5301668643951416,
            "z": -206.82620239257812
        },
        {
            "x": -6.97220516204834,
            "y": 0.5206656455993652,
            "z": -206.6754150390625
        },
        {
            "x": -7.015881061553955,
            "y": 0.5111563801765442,
            "z": -206.5247344970703
        },
        {
            "x": -7.059437274932861,
            "y": 0.5016288757324219,
            "z": -206.37399291992188
        },
        {
            "x": -7.1027913093566895,
            "y": 0.49208855628967285,
            "z": -206.22315979003906
        },
        {
            "x": -7.145987510681152,
            "y": 0.48254257440567017,
            "z": -206.0723419189453
        },
        {
            "x": -7.189029693603516,
            "y": 0.472980260848999,
            "z": -205.9213409423828
        },
        {
            "x": -7.2318572998046875,
            "y": 0.46342623233795166,
            "z": -205.7704315185547
        },
        {
            "x": -7.2744879722595215,
            "y": 0.4538756310939789,
            "z": -205.6194610595703
        },
        {
            "x": -7.316939353942871,
            "y": 0.44432127475738525,
            "z": -205.46832275390625
        },
        {
            "x": -7.359194278717041,
            "y": 0.43478405475616455,
            "z": -205.31727600097656
        },
        {
            "x": -7.40123176574707,
            "y": 0.4252529442310333,
            "z": -205.16607666015625
        },
        {
            "x": -7.443103790283203,
            "y": 0.41573601961135864,
            "z": -205.01480102539062
        },
        {
            "x": -7.484692573547363,
            "y": 0.4062468409538269,
            "z": -204.8636016845703
        },
        {
            "x": -7.512301921844482,
            "y": 0.39993029832839966,
            "z": -204.76272583007812
        },
        {
            "x": -7.553567409515381,
            "y": 0.39047837257385254,
            "z": -204.6114044189453
        },
        {
            "x": -7.594544887542725,
            "y": 0.3810569643974304,
            "z": -204.45999145507812
        },
        {
            "x": -7.635385990142822,
            "y": 0.371652215719223,
            "z": -204.30833435058594
        },
        {
            "x": -7.675926685333252,
            "y": 0.3622978925704956,
            "z": -204.15684509277344
        },
        {
            "x": -7.716217994689941,
            "y": 0.35297927260398865,
            "z": -204.00521850585938
        },
        {
            "x": -7.756313323974609,
            "y": 0.3436993360519409,
            "z": -203.8534698486328
        },
        {
            "x": -7.796092510223389,
            "y": 0.33447033166885376,
            "z": -203.70176696777344
        },
        {
            "x": -7.835689544677734,
            "y": 0.32528388500213623,
            "z": -203.5498809814453
        },
        {
            "x": -7.874978065490723,
            "y": 0.31615185737609863,
            "z": -203.39793395996094
        },
        {
            "x": -7.913987159729004,
            "y": 0.3070805072784424,
            "z": -203.2459716796875
        },
        {
            "x": -7.9527668952941895,
            "y": 0.29806387424468994,
            "z": -203.09385681152344
        },
        {
            "x": -7.991220951080322,
            "y": 0.28911513090133667,
            "z": -202.9417724609375
        },
        {
            "x": -8.029457092285156,
            "y": 0.28023290634155273,
            "z": -202.7896270751953
        },
        {
            "x": -8.067384719848633,
            "y": 0.27141237258911133,
            "z": -202.63722229003906
        },
        {
            "x": -8.10501766204834,
            "y": 0.26267510652542114,
            "z": -202.4849090576172
        },
        {
            "x": -8.142363548278809,
            "y": 0.2540137767791748,
            "z": -202.33251953125
        },
        {
            "x": -8.179399490356445,
            "y": 0.24542969465255737,
            "z": -202.17999267578125
        },
        {
            "x": -8.216155052185059,
            "y": 0.23693639039993286,
            "z": -202.0275115966797
        },
        {
            "x": -8.25259017944336,
            "y": 0.22851915657520294,
            "z": -201.87469482421875
        },
        {
            "x": -8.288735389709473,
            "y": 0.2202027440071106,
            "z": -201.72201538085938
        },
        {
            "x": -8.32452392578125,
            "y": 0.211981862783432,
            "z": -201.5692901611328
        },
        {
            "x": -8.360010147094727,
            "y": 0.20385664701461792,
            "z": -201.41639709472656
        },
        {
            "x": -8.395179748535156,
            "y": 0.1958378553390503,
            "z": -201.26351928710938
        },
        {
            "x": -8.430004119873047,
            "y": 0.18791627883911133,
            "z": -201.1103973388672
        },
        {
            "x": -8.46457576751709,
            "y": 0.18010160326957703,
            "z": -200.9572296142578
        },
        {
            "x": -8.498712539672852,
            "y": 0.1724073439836502,
            "z": -200.80410766601562
        },
        {
            "x": -8.532580375671387,
            "y": 0.16482284665107727,
            "z": -200.65074157714844
        },
        {
            "x": -8.566078186035156,
            "y": 0.1573629081249237,
            "z": -200.49745178222656
        },
        {
            "x": -8.59920597076416,
            "y": 0.1500224471092224,
            "z": -200.34405517578125
        },
        {
            "x": -8.632076263427734,
            "y": 0.14280106127262115,
            "z": -200.1904296875
        },
        {
            "x": -8.664478302001953,
            "y": 0.13571996986865997,
            "z": -200.036865234375
        },
        {
            "x": -8.696603775024414,
            "y": 0.12876655161380768,
            "z": -199.8831329345703
        },
        {
            "x": -8.728337287902832,
            "y": 0.12195062637329102,
            "z": -199.7294158935547
        },
        {
            "x": -8.759692192077637,
            "y": 0.11527472734451294,
            "z": -199.5756072998047
        },
        {
            "x": -8.790762901306152,
            "y": 0.10873817652463913,
            "z": -199.42153930664062
        },
        {
            "x": -8.821348190307617,
            "y": 0.10235612094402313,
            "z": -199.26759338378906
        },
        {
            "x": -8.851642608642578,
            "y": 0.09612087905406952,
            "z": -199.11355590820312
        },
        {
            "x": -8.8815279006958,
            "y": 0.09003587812185287,
            "z": -198.95936584472656
        },
        {
            "x": -8.911020278930664,
            "y": 0.08411479741334915,
            "z": -198.80516052246094
        },
        {
            "x": -8.940179824829102,
            "y": 0.07835038006305695,
            "z": -198.6508026123047
        },
        {
            "x": -8.96889591217041,
            "y": 0.07274697721004486,
            "z": -198.49635314941406
        },
        {
            "x": -8.997288703918457,
            "y": 0.06731362640857697,
            "z": -198.34193420410156
        },
        {
            "x": -9.015949249267578,
            "y": 0.0637928694486618,
            "z": -198.23895263671875
        },
        {
            "x": -9.043609619140625,
            "y": 0.058647241443395615,
            "z": -198.08438110351562
        },
        {
            "x": -9.070958137512207,
            "y": 0.05367645248770714,
            "z": -197.9297637939453
        },
        {
            "x": -9.097838401794434,
            "y": 0.04888692870736122,
            "z": -197.77493286132812
        },
        {
            "x": -9.124350547790527,
            "y": 0.04428314417600632,
            "z": -197.6201171875
        },
        {
            "x": -9.150452613830566,
            "y": 0.03986513242125511,
            "z": -197.46530151367188
        },
        {
            "x": -9.176127433776855,
            "y": 0.0356312058866024,
            "z": -197.31027221679688
        },
        {
            "x": -9.201454162597656,
            "y": 0.031600598245859146,
            "z": -197.1552734375
        },
        {
            "x": -9.226298332214355,
            "y": 0.02776288241147995,
            "z": -197.00013732910156
        },
        {
            "x": -9.250797271728516,
            "y": 0.024122187867760658,
            "z": -196.84487915039062
        },
        {
            "x": -9.27485466003418,
            "y": 0.020686496049165726,
            "z": -196.68971252441406
        },
        {
            "x": -9.29845142364502,
            "y": 0.017461461946368217,
            "z": -196.5343017578125
        },
        {
            "x": -9.321704864501953,
            "y": 0.014447133056819439,
            "z": -196.3789520263672
        },
        {
            "x": -9.344459533691406,
            "y": 0.011644434183835983,
            "z": -196.2235870361328
        },
        {
            "x": -9.366878509521484,
            "y": 0.009051928296685219,
            "z": -196.06790161132812
        },
        {
            "x": -9.38883113861084,
            "y": 0.006691006477922201,
            "z": -195.912353515625
        },
        {
            "x": -9.410306930541992,
            "y": 0.004551263526082039,
            "z": -195.75669860839844
        },
        {
            "x": -9.431452751159668,
            "y": 0.002635773504152894,
            "z": -195.6009979248047
        },
        {
            "x": -9.452077865600586,
            "y": 0.0009487508796155453,
            "z": -195.4453125
        },
        {
            "x": -9.472330093383789,
            "y": -0.0004999684169888496,
            "z": -195.28929138183594
        },
        {
            "x": -9.492152214050293,
            "y": -0.0017107953317463398,
            "z": -195.13351440429688
        },
        {
            "x": -9.51147174835205,
            "y": -0.002684692619368434,
            "z": -194.9775848388672
        },
        {
            "x": -9.530458450317383,
            "y": -0.003418270032852888,
            "z": -194.8216552734375
        },
        {
            "x": -9.548921585083008,
            "y": -0.0038981959223747253,
            "z": -194.66567993164062
        },
        {
            "x": -9.566978454589844,
            "y": -0.004129295703023672,
            "z": -194.50949096679688
        },
        {
            "x": -9.584651947021484,
            "y": -0.004159810487180948,
            "z": -194.35333251953125
        },
        {
            "x": -9.601786613464355,
            "y": -0.004162720404565334,
            "z": -194.19717407226562
        },
        {
            "x": -9.618577003479004,
            "y": -0.0041656349785625935,
            "z": -194.0408477783203
        },
        {
            "x": -9.63487434387207,
            "y": -0.004168545827269554,
            "z": -193.8846435546875
        },
        {
            "x": -9.650707244873047,
            "y": -0.00417146272957325,
            "z": -193.7283477783203
        },
        {
            "x": -9.666214942932129,
            "y": -0.004174376837909222,
            "z": -193.57180786132812
        },
        {
            "x": -9.68114185333252,
            "y": -0.0041772834956645966,
            "z": -193.41543579101562
        },
        {
            "x": -9.695694923400879,
            "y": -0.004180202726274729,
            "z": -193.2589569091797
        },
        {
            "x": -9.709824562072754,
            "y": -0.004183114040642977,
            "z": -193.10247802734375
        },
        {
            "x": -9.723432540893555,
            "y": -0.004186030477285385,
            "z": -192.94593811035156
        },
        {
            "x": -9.736708641052246,
            "y": -0.00418893713504076,
            "z": -192.78921508789062
        },
        {
            "x": -9.749456405639648,
            "y": -0.0041918521746993065,
            "z": -192.63267517089844
        },
        {
            "x": -9.761756896972656,
            "y": -0.004194766283035278,
            "z": -192.47601318359375
        },
        {
            "x": -9.773706436157227,
            "y": -0.0041976794600486755,
            "z": -192.31930541992188
        },
        {
            "x": -9.785093307495117,
            "y": -0.004200596362352371,
            "z": -192.1626434326172
        },
        {
            "x": -9.796102523803711,
            "y": -0.004203509539365768,
            "z": -192.00579833984375
        },
        {
            "x": -9.806689262390137,
            "y": -0.004206418059766293,
            "z": -191.8489990234375
        },
        {
            "x": -9.816743850708008,
            "y": -0.004209328442811966,
            "z": -191.69223022460938
        },
        {
            "x": -9.823257446289062,
            "y": -0.004211274906992912,
            "z": -191.58767700195312
        },
        {
            "x": -9.832659721374512,
            "y": -0.004214185755699873,
            "z": -191.43089294433594
        },
        {
            "x": -9.841535568237305,
            "y": -0.004217096604406834,
            "z": -191.27403259277344
        },
        {
            "x": -9.850080490112305,
            "y": -0.004220010247081518,
            "z": -191.116943359375
        },
        {
            "x": -9.858114242553711,
            "y": -0.004222923889756203,
            "z": -190.96009826660156
        },
        {
            "x": -9.865679740905762,
            "y": -0.0042258379980921745,
            "z": -190.8031768798828
        },
        {
            "x": -9.872910499572754,
            "y": -0.004228753969073296,
            "z": -190.64610290527344
        },
        {
            "x": -9.879595756530762,
            "y": -0.004231662955135107,
            "z": -190.4891815185547
        },
        {
            "x": -9.885862350463867,
            "y": -0.004234576132148504,
            "z": -190.3320770263672
        },
        {
            "x": -9.891762733459473,
            "y": -0.004237491637468338,
            "z": -190.1750030517578
        },
        {
            "x": -9.897120475769043,
            "y": -0.004240404348820448,
            "z": -190.01800537109375
        },
        {
            "x": -9.902113914489746,
            "y": -0.004243317525833845,
            "z": -189.86080932617188
        },
        {
            "x": -9.906670570373535,
            "y": -0.004246230237185955,
            "z": -189.7038116455078
        },
        {
            "x": -9.910709381103516,
            "y": -0.004249147139489651,
            "z": -189.54676818847656
        },
        {
            "x": -9.91442584991455,
            "y": -0.004252059385180473,
            "z": -189.3894805908203
        },
        {
            "x": -9.917661666870117,
            "y": -0.004254968836903572,
            "z": -189.23245239257812
        },
        {
            "x": -9.920401573181152,
            "y": -0.004257882945239544,
            "z": -189.07530212402344
        },
        {
            "x": -9.922822952270508,
            "y": -0.00426079286262393,
            "z": -188.91815185546875
        },
        {
            "x": -9.92474365234375,
            "y": -0.004263707436621189,
            "z": -188.76107788085938
        },
        {
            "x": -9.926212310791016,
            "y": -0.00426662340760231,
            "z": -188.60372924804688
        },
        {
            "x": -9.927336692810059,
            "y": -0.00426953611895442,
            "z": -188.44662475585938
        },
        {
            "x": -9.927940368652344,
            "y": -0.004272441379725933,
            "z": -188.28955078125
        },
        {
            "x": -9.928132057189941,
            "y": -0.004275355488061905,
            "z": -188.1324005126953
        },
        {
            "x": -9.927964210510254,
            "y": -0.004278272390365601,
            "z": -187.97531127929688
        },
        {
            "x": -9.927234649658203,
            "y": -0.004281184170395136,
            "z": -187.818115234375
        },
        {
            "x": -9.926125526428223,
            "y": -0.0042841010726988316,
            "z": -187.66085815429688
        },
        {
            "x": -9.92462158203125,
            "y": -0.004287011921405792,
            "z": -187.5037841796875
        },
        {
            "x": -9.92255973815918,
            "y": -0.004289924167096615,
            "z": -187.3466033935547
        },
        {
            "x": -9.920133590698242,
            "y": -0.004292838275432587,
            "z": -187.18948364257812
        },
        {
            "x": -9.917265892028809,
            "y": -0.004295755177736282,
            "z": -187.03244018554688
        },
        {
            "x": -9.913866996765137,
            "y": -0.004298665560781956,
            "z": -186.8751678466797
        },
        {
            "x": -9.910128593444824,
            "y": -0.004301577806472778,
            "z": -186.7180633544922
        },
        {
            "x": -9.905891418457031,
            "y": -0.004304655361920595,
            "z": -186.56097412109375
        },
        {
            "x": -9.901158332824707,
            "y": -0.0044136010110378265,
            "z": -186.40386962890625
        },
        {
            "x": -9.896089553833008,
            "y": -0.004758857656270266,
            "z": -186.24684143066406
        },
        {
            "x": -9.890488624572754,
            "y": -0.0053251138888299465,
            "z": -186.08966064453125
        },
        {
            "x": -9.884429931640625,
            "y": -0.006113347131758928,
            "z": -185.9326629638672
        },
        {
            "x": -9.87801742553711,
            "y": -0.0071129146963357925,
            "z": -185.77569580078125
        },
        {
            "x": -9.87105655670166,
            "y": -0.008322259411215782,
            "z": -185.61865234375
        },
        {
            "x": -9.863697052001953,
            "y": -0.009739052504301071,
            "z": -185.461669921875
        },
        {
            "x": -9.855925559997559,
            "y": -0.011367268860340118,
            "z": -185.30470275878906
        },
        {
            "x": -9.847611427307129,
            "y": -0.01319598313421011,
            "z": -185.14772033691406
        },
        {
            "x": -9.838947296142578,
            "y": -0.015220757573843002,
            "z": -184.9908447265625
        },
        {
            "x": -9.832934379577637,
            "y": -0.016681162640452385,
            "z": -184.88632202148438
        },
        {
            "x": -9.823447227478027,
            "y": -0.019033949822187424,
            "z": -184.7295379638672
        },
        {
            "x": -9.813589096069336,
            "y": -0.021576642990112305,
            "z": -184.57272338867188
        },
        {
            "x": -9.80329704284668,
            "y": -0.024309206753969193,
            "z": -184.41580200195312
        },
        {
            "x": -9.792468070983887,
            "y": -0.027230463922023773,
            "z": -184.2590789794922
        },
        {
            "x": -9.781311988830566,
            "y": -0.030332284048199654,
            "z": -184.10238647460938
        },
        {
            "x": -9.769662857055664,
            "y": -0.03361270949244499,
            "z": -183.94566345214844
        },
        {
            "x": -9.757547378540039,
            "y": -0.03706763684749603,
            "z": -183.78903198242188
        },
        {
            "x": -9.745074272155762,
            "y": -0.040703464299440384,
            "z": -183.63233947753906
        },
        {
            "x": -9.732073783874512,
            "y": -0.04450777918100357,
            "z": -183.4757537841797
        },
        {
            "x": -9.718680381774902,
            "y": -0.0484761968255043,
            "z": -183.31922912597656
        },
        {
            "x": -9.7048978805542,
            "y": -0.052609898149967194,
            "z": -183.16265869140625
        },
        {
            "x": -9.690569877624512,
            "y": -0.05690845474600792,
            "z": -183.00625610351562
        },
        {
            "x": -9.675904273986816,
            "y": -0.06136397644877434,
            "z": -182.84986877441406
        },
        {
            "x": -9.660776138305664,
            "y": -0.06597770005464554,
            "z": -182.693359375
        },
        {
            "x": -9.645177841186523,
            "y": -0.07073835283517838,
            "z": -182.53704833984375
        },
        {
            "x": -9.62923812866211,
            "y": -0.07565411925315857,
            "z": -182.3807830810547
        },
        {
            "x": -9.612789154052734,
            "y": -0.08071526885032654,
            "z": -182.22457885742188
        },
        {
            "x": -9.595935821533203,
            "y": -0.08591762185096741,
            "z": -182.06842041015625
        },
        {
            "x": -9.578707695007324,
            "y": -0.09126390516757965,
            "z": -181.9121551513672
        },
        {
            "x": -9.56096076965332,
            "y": -0.09674634784460068,
            "z": -181.756103515625
        },
        {
            "x": -9.542868614196777,
            "y": -0.10236294567584991,
            "z": -181.60012817382812
        },
        {
            "x": -9.524348258972168,
            "y": -0.1081070601940155,
            "z": -181.44422912597656
        },
        {
            "x": -9.505355834960938,
            "y": -0.1139802485704422,
            "z": -181.2883758544922
        },
        {
            "x": -9.486016273498535,
            "y": -0.11998607218265533,
            "z": -181.13241577148438
        },
        {
            "x": -9.466187477111816,
            "y": -0.12611281871795654,
            "z": -180.97657775878906
        },
        {
            "x": -9.445972442626953,
            "y": -0.13235509395599365,
            "z": -180.8208465576172
        },
        {
            "x": -9.425390243530273,
            "y": -0.13871505856513977,
            "z": -180.66510009765625
        },
        {
            "x": -9.404309272766113,
            "y": -0.14518694579601288,
            "z": -180.50955200195312
        },
        {
            "x": -9.382898330688477,
            "y": -0.15176978707313538,
            "z": -180.35403442382812
        },
        {
            "x": -9.3610258102417,
            "y": -0.15846645832061768,
            "z": -180.19834899902344
        },
        {
            "x": -9.338740348815918,
            "y": -0.16525869071483612,
            "z": -180.04295349121094
        },
        {
            "x": -9.316121101379395,
            "y": -0.17215637862682343,
            "z": -179.8875274658203
        },
        {
            "x": -9.293009757995605,
            "y": -0.17915156483650208,
            "z": -179.73220825195312
        },
        {
            "x": -9.269552230834961,
            "y": -0.18623918294906616,
            "z": -179.5769805908203
        },
        {
            "x": -9.24569320678711,
            "y": -0.19342581927776337,
            "z": -179.421630859375
        },
        {
            "x": -9.221383094787598,
            "y": -0.2006947100162506,
            "z": -179.2665557861328
        },
        {
            "x": -9.19676685333252,
            "y": -0.20804956555366516,
            "z": -179.1115264892578
        },
        {
            "x": -9.171696662902832,
            "y": -0.21549084782600403,
            "z": -178.95648193359375
        },
        {
            "x": -9.146245956420898,
            "y": -0.22300736606121063,
            "z": -178.8015899658203
        },
        {
            "x": -9.120448112487793,
            "y": -0.23060545325279236,
            "z": -178.6466522216797
        },
        {
            "x": -9.094175338745117,
            "y": -0.23827892541885376,
            "z": -178.49180603027344
        },
        {
            "x": -9.067605972290039,
            "y": -0.24601735174655914,
            "z": -178.3371124267578
        },
        {
            "x": -9.049688339233398,
            "y": -0.25121304392814636,
            "z": -178.23402404785156
        },
        {
            "x": -9.022412300109863,
            "y": -0.25906258821487427,
            "z": -178.0794677734375
        },
        {
            "x": -8.994834899902344,
            "y": -0.2669747471809387,
            "z": -177.92494201660156
        },
        {
            "x": -8.966817855834961,
            "y": -0.274955153465271,
            "z": -177.77032470703125
        },
        {
            "x": -8.938440322875977,
            "y": -0.2829834818840027,
            "z": -177.61595153808594
        },
        {
            "x": -8.909756660461426,
            "y": -0.2910638451576233,
            "z": -177.461669921875
        },
        {
            "x": -8.880605697631836,
            "y": -0.29920098185539246,
            "z": -177.30735778808594
        },
        {
            "x": -8.851165771484375,
            "y": -0.3073802590370178,
            "z": -177.15318298339844
        },
        {
            "x": -8.821342468261719,
            "y": -0.3156079947948456,
            "z": -176.99900817871094
        },
        {
            "x": -8.79110050201416,
            "y": -0.3238790035247803,
            "z": -176.8448944091797
        },
        {
            "x": -8.760602951049805,
            "y": -0.33218103647232056,
            "z": -176.6909637451172
        },
        {
            "x": -8.729660034179688,
            "y": -0.34052449464797974,
            "z": -176.5369873046875
        },
        {
            "x": -8.698423385620117,
            "y": -0.3488941788673401,
            "z": -176.3831787109375
        },
        {
            "x": -8.666845321655273,
            "y": -0.3572923541069031,
            "z": -176.2294464111328
        },
        {
            "x": -8.634827613830566,
            "y": -0.3657280206680298,
            "z": -176.0756378173828
        },
        {
            "x": -8.602580070495605,
            "y": -0.37417542934417725,
            "z": -175.92202758789062
        },
        {
            "x": -8.569923400878906,
            "y": -0.3826444745063782,
            "z": -175.76849365234375
        },
        {
            "x": -8.536927223205566,
            "y": -0.3911329209804535,
            "z": -175.614990234375
        },
        {
            "x": -8.503652572631836,
            "y": -0.3996301293373108,
            "z": -175.46163940429688
        },
        {
            "x": -8.469942092895508,
            "y": -0.4081500768661499,
            "z": -175.3081512451172
        },
        {
            "x": -8.436017990112305,
            "y": -0.41666579246520996,
            "z": -175.1549072265625
        },
        {
            "x": -8.401708602905273,
            "y": -0.4251856207847595,
            "z": -175.0017852783203
        },
        {
            "x": -8.367085456848145,
            "y": -0.43370872735977173,
            "z": -174.8486785888672
        },
        {
            "x": -8.332183837890625,
            "y": -0.4422275722026825,
            "z": -174.69569396972656
        },
        {
            "x": -8.296876907348633,
            "y": -0.4507488012313843,
            "z": -174.54266357421875
        },
        {
            "x": -8.261311531066895,
            "y": -0.45926210284233093,
            "z": -174.3897247314453
        },
        {
            "x": -8.225424766540527,
            "y": -0.4677577018737793,
            "z": -174.23696899414062
        },
        {
            "x": -8.189205169677734,
            "y": -0.4762464165687561,
            "z": -174.0841522216797
        },
        {
            "x": -8.152748107910156,
            "y": -0.4847126305103302,
            "z": -173.9314727783203
        },
        {
            "x": -8.115914344787598,
            "y": -0.4931585192680359,
            "z": -173.77890014648438
        },
        {
            "x": -8.078797340393066,
            "y": -0.5015910863876343,
            "z": -173.62623596191406
        },
        {
            "x": -8.041403770446777,
            "y": -0.5099871158599854,
            "z": -173.47378540039062
        },
        {
            "x": -8.003706932067871,
            "y": -0.518358051776886,
            "z": -173.3213653564453
        },
        {
            "x": -7.965751647949219,
            "y": -0.5266949534416199,
            "z": -173.1689910888672
        },
        {
            "x": -7.927459716796875,
            "y": -0.5349939465522766,
            "z": -173.01675415039062
        },
        {
            "x": -7.8888936042785645,
            "y": -0.5432653427124023,
            "z": -172.86439514160156
        },
        {
            "x": -7.850080966949463,
            "y": -0.5514830350875854,
            "z": -172.7123260498047
        },
        {
            "x": -7.8109846115112305,
            "y": -0.5596568584442139,
            "z": -172.56028747558594
        },
        {
            "x": -7.7716169357299805,
            "y": -0.5677876472473145,
            "z": -172.40821838378906
        },
        {
            "x": -7.731958389282227,
            "y": -0.575862467288971,
            "z": -172.25633239746094
        },
        {
            "x": -7.692060947418213,
            "y": -0.583889365196228,
            "z": -172.10438537597656
        },
        {
            "x": -7.6518683433532715,
            "y": -0.59185791015625,
            "z": -171.95252990722656
        },
        {
            "x": -7.6114373207092285,
            "y": -0.5997602939605713,
            "z": -171.80081176757812
        },
        {
            "x": -7.58437442779541,
            "y": -0.6049948930740356,
            "z": -171.69973754882812
        },
        {
            "x": -7.543521404266357,
            "y": -0.6127890348434448,
            "z": -171.5481414794922
        },
        {
            "x": -7.502432346343994,
            "y": -0.6205158829689026,
            "z": -171.39657592773438
        },
        {
            "x": -7.461067199707031,
            "y": -0.6281799077987671,
            "z": -171.24493408203125
        },
        {
            "x": -7.419478893280029,
            "y": -0.6357609033584595,
            "z": -171.09352111816406
        },
        {
            "x": -7.377699375152588,
            "y": -0.6432631015777588,
            "z": -170.94215393066406
        },
        {
            "x": -7.335601329803467,
            "y": -0.6506878137588501,
            "z": -170.79075622558594
        },
        {
            "x": -7.2933430671691895,
            "y": -0.6580238342285156,
            "z": -170.63951110839844
        },
        {
            "x": -7.250827312469482,
            "y": -0.665277898311615,
            "z": -170.48825073242188
        },
        {
            "x": -7.208070278167725,
            "y": -0.6724412441253662,
            "z": -170.33705139160156
        },
        {
            "x": -7.165162563323975,
            "y": -0.6795035600662231,
            "z": -170.18600463867188
        },
        {
            "x": -7.1219611167907715,
            "y": -0.6864755749702454,
            "z": -170.03488159179688
        },
        {
            "x": -7.078607082366943,
            "y": -0.6933445930480957,
            "z": -169.88389587402344
        },
        {
            "x": -7.035040378570557,
            "y": -0.7001094818115234,
            "z": -169.73301696777344
        },
        {
            "x": -6.991196632385254,
            "y": -0.7067736387252808,
            "z": -169.58200073242188
        },
        {
            "x": -6.9472432136535645,
            "y": -0.713321328163147,
            "z": -169.4312286376953
        },
        {
            "x": -6.9030442237854,
            "y": -0.7197593450546265,
            "z": -169.28042602539062
        },
        {
            "x": -6.8586883544921875,
            "y": -0.7260827422142029,
            "z": -169.1296844482422
        },
        {
            "x": -6.814130783081055,
            "y": -0.7322814464569092,
            "z": -168.9790496826172
        },
        {
            "x": -6.769334316253662,
            "y": -0.7383671998977661,
            "z": -168.8282470703125
        },
        {
            "x": -6.724443435668945,
            "y": -0.7443203926086426,
            "z": -168.67771911621094
        },
        {
            "x": -6.679335594177246,
            "y": -0.750146746635437,
            "z": -168.52725219726562
        },
        {
            "x": -6.634098052978516,
            "y": -0.755837082862854,
            "z": -168.37677001953125
        },
        {
            "x": -6.588663578033447,
            "y": -0.7613940834999084,
            "z": -168.2263946533203
        },
        {
            "x": -6.543044090270996,
            "y": -0.7668184041976929,
            "z": -168.07591247558594
        },
        {
            "x": -6.497278213500977,
            "y": -0.7721027135848999,
            "z": -167.9254913330078
        },
        {
            "x": -6.451352119445801,
            "y": -0.7772340774536133,
            "z": -167.7752227783203
        },
        {
            "x": -6.405275821685791,
            "y": -0.7822229862213135,
            "z": -167.62486267089844
        },
        {
            "x": -6.359067916870117,
            "y": -0.78705894947052,
            "z": -167.4746856689453
        },
        {
            "x": -6.312729358673096,
            "y": -0.7917428016662598,
            "z": -167.32452392578125
        },
        {
            "x": -6.266184329986572,
            "y": -0.7962700128555298,
            "z": -167.17420959472656
        },
        {
            "x": -6.2195634841918945,
            "y": -0.800632119178772,
            "z": -167.02413940429688
        },
        {
            "x": -6.1728105545043945,
            "y": -0.80483478307724,
            "z": -166.8740234375
        },
        {
            "x": -6.1259074211120605,
            "y": -0.8088719844818115,
            "z": -166.72396850585938
        },
        {
            "x": -6.078917980194092,
            "y": -0.8127331733703613,
            "z": -166.57395935058594
        },
        {
            "x": -6.031740665435791,
            "y": -0.8164259791374207,
            "z": -166.42384338378906
        },
        {
            "x": -5.984509468078613,
            "y": -0.8199398517608643,
            "z": -166.27391052246094
        },
        {
            "x": -5.937173843383789,
            "y": -0.823276698589325,
            "z": -166.12399291992188
        },
        {
            "x": -5.8896894454956055,
            "y": -0.826427161693573,
            "z": -165.9740447998047
        },
        {
            "x": -5.8421525955200195,
            "y": -0.8293904066085815,
            "z": -165.82423400878906
        },
        {
            "x": -5.7944793701171875,
            "y": -0.832168698310852,
            "z": -165.67431640625
        },
        {
            "x": -5.746726036071777,
            "y": -0.83475661277771,
            "z": -165.52444458007812
        },
        {
            "x": -5.698917388916016,
            "y": -0.8371413946151733,
            "z": -165.37469482421875
        },
        {
            "x": -5.6669816970825195,
            "y": -0.8386222124099731,
            "z": -165.27487182617188
        },
        {
            "x": -5.619039058685303,
            "y": -0.8406796455383301,
            "z": -165.12513732910156
        },
        {
            "x": -5.571004390716553,
            "y": -0.8425277471542358,
            "z": -164.97544860839844
        },
        {
            "x": -5.522838592529297,
            "y": -0.8441711664199829,
            "z": -164.8255615234375
        },
        {
            "x": -5.4746809005737305,
            "y": -0.8456040024757385,
            "z": -164.6759033203125
        },
        {
            "x": -5.426445007324219,
            "y": -0.8468256592750549,
            "z": -164.52626037597656
        },
        {
            "x": -5.378131866455078,
            "y": -0.8478268384933472,
            "z": -164.3765106201172
        },
        {
            "x": -5.329787731170654,
            "y": -0.848606526851654,
            "z": -164.22691345214844
        },
        {
            "x": -5.28136682510376,
            "y": -0.8491660356521606,
            "z": -164.07720947265625
        },
        {
            "x": -5.232903480529785,
            "y": -0.8495019674301147,
            "z": -163.92752075195312
        },
        {
            "x": -5.184426307678223,
            "y": -0.8496028184890747,
            "z": -163.7779541015625
        },
        {
            "x": -5.1358819007873535,
            "y": -0.8494717478752136,
            "z": -163.62828063964844
        },
        {
            "x": -5.087343692779541,
            "y": -0.8491148948669434,
            "z": -163.47874450683594
        },
        {
            "x": -5.038763999938965,
            "y": -0.8485337495803833,
            "z": -163.3291778564453
        },
        {
            "x": -4.990119934082031,
            "y": -0.8477256298065186,
            "z": -163.179443359375
        },
        {
            "x": -4.941525936126709,
            "y": -0.8466973304748535,
            "z": -163.0299072265625
        },
        {
            "x": -4.892889499664307,
            "y": -0.8454549312591553,
            "z": -162.88035583496094
        },
        {
            "x": -4.844241142272949,
            "y": -0.8440017700195312,
            "z": -162.73077392578125
        },
        {
            "x": -4.795623302459717,
            "y": -0.8423353433609009,
            "z": -162.58126831054688
        },
        {
            "x": -4.746928691864014,
            "y": -0.8404579758644104,
            "z": -162.4315643310547
        },
        {
            "x": -4.698307991027832,
            "y": -0.8383824825286865,
            "z": -162.2820587158203
        },
        {
            "x": -4.649693489074707,
            "y": -0.8361085653305054,
            "z": -162.13255310058594
        },
        {
            "x": -4.60110330581665,
            "y": -0.8336341381072998,
            "z": -161.98304748535156
        },
        {
            "x": -4.552536487579346,
            "y": -0.8309639692306519,
            "z": -161.83352661132812
        },
        {
            "x": -4.503950595855713,
            "y": -0.8281038999557495,
            "z": -161.6839141845703
        },
        {
            "x": -4.455390453338623,
            "y": -0.825057327747345,
            "z": -161.5342559814453
        },
        {
            "x": -4.406897068023682,
            "y": -0.8218256235122681,
            "z": -161.3847198486328
        },
        {
            "x": -4.358414173126221,
            "y": -0.8184091448783875,
            "z": -161.23507690429688
        },
        {
            "x": -4.309994220733643,
            "y": -0.8148183226585388,
            "z": -161.0854949951172
        },
        {
            "x": -4.2616400718688965,
            "y": -0.8110553026199341,
            "z": -160.93594360351562
        },
        {
            "x": -4.213255882263184,
            "y": -0.8071131706237793,
            "z": -160.78614807128906
        },
        {
            "x": -4.165003776550293,
            "y": -0.8030044436454773,
            "z": -160.6365509033203
        },
        {
            "x": -4.116786956787109,
            "y": -0.79873126745224,
            "z": -160.4868621826172
        },
        {
            "x": -4.068631649017334,
            "y": -0.7942976951599121,
            "z": -160.33718872070312
        },
        {
            "x": -4.020576477050781,
            "y": -0.7897061109542847,
            "z": -160.1875457763672
        },
        {
            "x": -3.9725162982940674,
            "y": -0.7849497199058533,
            "z": -160.0376739501953
        },
        {
            "x": -3.9246199131011963,
            "y": -0.7800490856170654,
            "z": -159.8880157470703
        },
        {
            "x": -3.8767971992492676,
            "y": -0.7750008702278137,
            "z": -159.73831176757812
        },
        {
            "x": -3.829035997390747,
            "y": -0.7698017358779907,
            "z": -159.58847045898438
        },
        {
            "x": -3.7814111709594727,
            "y": -0.7644606828689575,
            "z": -159.43870544433594
        },
        {
            "x": -3.733833074569702,
            "y": -0.7589776515960693,
            "z": -159.28883361816406
        },
        {
            "x": -3.686371088027954,
            "y": -0.7533589005470276,
            "z": -159.13890075683594
        },
        {
            "x": -3.639025926589966,
            "y": -0.7476114630699158,
            "z": -158.9890899658203
        },
        {
            "x": -3.6075427532196045,
            "y": -0.7437037229537964,
            "z": -158.88917541503906
        },
        {
            "x": -3.560412883758545,
            "y": -0.7377406358718872,
            "z": -158.7393035888672
        },
        {
            "x": -3.5133635997772217,
            "y": -0.7316522598266602,
            "z": -158.58937072753906
        },
        {
            "x": -3.4664204120635986,
            "y": -0.725430965423584,
            "z": -158.43922424316406
        },
        {
            "x": -3.4196319580078125,
            "y": -0.7191005349159241,
            "z": -158.28924560546875
        },
        {
            "x": -3.372995615005493,
            "y": -0.7126551866531372,
            "z": -158.13922119140625
        },
        {
            "x": -3.326464891433716,
            "y": -0.7060942053794861,
            "z": -157.98902893066406
        },
        {
            "x": -3.2800941467285156,
            "y": -0.6994251012802124,
            "z": -157.83892822265625
        },
        {
            "x": -3.233865261077881,
            "y": -0.6926473379135132,
            "z": -157.6886749267578
        },
        {
            "x": -3.1877548694610596,
            "y": -0.685767412185669,
            "z": -157.5384063720703
        },
        {
            "x": -3.141859292984009,
            "y": -0.6787928342819214,
            "z": -157.38818359375
        },
        {
            "x": -3.096076726913452,
            "y": -0.67171311378479,
            "z": -157.23777770996094
        },
        {
            "x": -3.050487995147705,
            "y": -0.6645462512969971,
            "z": -157.0874481201172
        },
        {
            "x": -3.0050840377807617,
            "y": -0.6572906970977783,
            "z": -156.9370880126953
        },
        {
            "x": -2.9597694873809814,
            "y": -0.6499396562576294,
            "z": -156.78648376464844
        },
        {
            "x": -2.9147255420684814,
            "y": -0.6425102949142456,
            "z": -156.63601684570312
        },
        {
            "x": -2.869824171066284,
            "y": -0.6349994540214539,
            "z": -156.4854736328125
        },
        {
            "x": -2.825122833251953,
            "y": -0.6274106502532959,
            "z": -156.3348388671875
        },
        {
            "x": -2.7806265354156494,
            "y": -0.6197508573532104,
            "z": -156.18421936035156
        },
        {
            "x": -2.7362630367279053,
            "y": -0.6120076775550842,
            "z": -156.03335571289062
        },
        {
            "x": -2.692187547683716,
            "y": -0.6042064428329468,
            "z": -155.88262939453125
        },
        {
            "x": -2.6482691764831543,
            "y": -0.5963394641876221,
            "z": -155.73182678222656
        },
        {
            "x": -2.604602575302124,
            "y": -0.5884116888046265,
            "z": -155.58096313476562
        },
        {
            "x": -2.5611276626586914,
            "y": -0.5804234743118286,
            "z": -155.4300537109375
        },
        {
            "x": -2.5178520679473877,
            "y": -0.5723750591278076,
            "z": -155.2790069580078
        },
        {
            "x": -2.4748101234436035,
            "y": -0.5642737150192261,
            "z": -155.12789916992188
        },
        {
            "x": -2.431989908218384,
            "y": -0.5561292171478271,
            "z": -154.97682189941406
        },
        {
            "x": -2.3894190788269043,
            "y": -0.5479303598403931,
            "z": -154.8255615234375
        },
        {
            "x": -2.3470799922943115,
            "y": -0.5396946668624878,
            "z": -154.67437744140625
        },
        {
            "x": -2.3050081729888916,
            "y": -0.5314187407493591,
            "z": -154.52308654785156
        },
        {
            "x": -2.26310658454895,
            "y": -0.5230944156646729,
            "z": -154.3715362548828
        },
        {
            "x": -2.221508026123047,
            "y": -0.5147455930709839,
            "z": -154.22010803222656
        },
        {
            "x": -2.1801838874816895,
            "y": -0.506363034248352,
            "z": -154.06858825683594
        },
        {
            "x": -2.139070510864258,
            "y": -0.49795305728912354,
            "z": -153.9169921875
        },
        {
            "x": -2.098283052444458,
            "y": -0.48952198028564453,
            "z": -153.765380859375
        },
        {
            "x": -2.057676315307617,
            "y": -0.4810565114021301,
            "z": -153.6134796142578
        },
        {
            "x": -2.0174083709716797,
            "y": -0.47258320450782776,
            "z": -153.46173095703125
        },
        {
            "x": -1.9774338006973267,
            "y": -0.4640948474407196,
            "z": -153.3098907470703
        },
        {
            "x": -1.937659740447998,
            "y": -0.4555877447128296,
            "z": -153.15789794921875
        },
        {
            "x": -1.8982605934143066,
            "y": -0.447077214717865,
            "z": -153.0059051513672
        },
        {
            "x": -1.8590762615203857,
            "y": -0.4385548532009125,
            "z": -152.85377502441406
        },
        {
            "x": -1.8202179670333862,
            "y": -0.43002837896347046,
            "z": -152.7015380859375
        },
        {
            "x": -1.781673789024353,
            "y": -0.4215085506439209,
            "z": -152.54933166503906
        },
        {
            "x": -1.756126880645752,
            "y": -0.41582924127578735,
            "z": -152.4478302001953
        },
        {
            "x": -1.71811842918396,
            "y": -0.40731507539749146,
            "z": -152.29550170898438
        },
        {
            "x": -1.6803748607635498,
            "y": -0.398809015750885,
            "z": -152.1431121826172
        },
        {
            "x": -1.6429133415222168,
            "y": -0.3903023600578308,
            "z": -151.99041748046875
        },
        {
            "x": -1.6058375835418701,
            "y": -0.38182127475738525,
            "z": -151.83782958984375
        },
        {
            "x": -1.5690363645553589,
            "y": -0.3733576536178589,
            "z": -151.6852264404297
        },
        {
            "x": -1.5325944423675537,
            "y": -0.36490732431411743,
            "z": -151.53237915039062
        },
        {
            "x": -1.4964423179626465,
            "y": -0.35648655891418457,
            "z": -151.3795928955078
        },
        {
            "x": -1.4606561660766602,
            "y": -0.348087340593338,
            "z": -151.22665405273438
        },
        {
            "x": -1.4251905679702759,
            "y": -0.33971738815307617,
            "z": -151.07359313964844
        },
        {
            "x": -1.390069842338562,
            "y": -0.33138522505760193,
            "z": -150.92054748535156
        },
        {
            "x": -1.3553255796432495,
            "y": -0.3230821490287781,
            "z": -150.767333984375
        },
        {
            "x": -1.3208928108215332,
            "y": -0.31482499837875366,
            "z": -150.6141357421875
        },
        {
            "x": -1.286876916885376,
            "y": -0.30660825967788696,
            "z": -150.46083068847656
        },
        {
            "x": -1.253136157989502,
            "y": -0.2984265089035034,
            "z": -150.30728149414062
        },
        {
            "x": -1.219800353050232,
            "y": -0.29030221700668335,
            "z": -150.1538543701172
        },
        {
            "x": -1.1868584156036377,
            "y": -0.2822279930114746,
            "z": -150.000244140625
        },
        {
            "x": -1.154221773147583,
            "y": -0.2742066979408264,
            "z": -149.84661865234375
        },
        {
            "x": -1.1220425367355347,
            "y": -0.26624494791030884,
            "z": -149.69290161132812
        },
        {
            "x": -1.0901328325271606,
            "y": -0.25833219289779663,
            "z": -149.53897094726562
        },
        {
            "x": -1.0586899518966675,
            "y": -0.25049567222595215,
            "z": -149.3851318359375
        },
        {
            "x": -1.027634620666504,
            "y": -0.2427242547273636,
            "z": -149.23117065429688
        },
        {
            "x": -0.9969173073768616,
            "y": -0.23502039909362793,
            "z": -149.0771484375
        },
        {
            "x": -0.9666686058044434,
            "y": -0.22738996148109436,
            "z": -148.92308044433594
        },
        {
            "x": -0.9367274641990662,
            "y": -0.21983109414577484,
            "z": -148.76881408691406
        },
        {
            "x": -0.9072413444519043,
            "y": -0.21235063672065735,
            "z": -148.6144561767578
        },
        {
            "x": -0.8781594634056091,
            "y": -0.20495566725730896,
            "z": -148.46009826660156
        },
        {
            "x": -0.8494332432746887,
            "y": -0.1976396143436432,
            "z": -148.3056182861328
        },
        {
            "x": -0.8212161660194397,
            "y": -0.19041788578033447,
            "z": -148.1510772705078
        },
        {
            "x": -0.7933254241943359,
            "y": -0.18328648805618286,
            "z": -147.9965057373047
        },
        {
            "x": -0.7658892869949341,
            "y": -0.17624032497406006,
            "z": -147.84169006347656
        },
        {
            "x": -0.7388561964035034,
            "y": -0.16929736733436584,
            "z": -147.68695068359375
        },
        {
            "x": -0.712242603302002,
            "y": -0.1624545156955719,
            "z": -147.53208923339844
        },
        {
            "x": -0.6861163973808289,
            "y": -0.1557157188653946,
            "z": -147.3771514892578
        },
        {
            "x": -0.6603407859802246,
            "y": -0.1490834504365921,
            "z": -147.22219848632812
        },
        {
            "x": -0.6350535750389099,
            "y": -0.14255118370056152,
            "z": -147.06695556640625
        },
        {
            "x": -0.6101799011230469,
            "y": -0.13614098727703094,
            "z": -146.91184997558594
        },
        {
            "x": -0.5857650637626648,
            "y": -0.12984707951545715,
            "z": -146.75669860839844
        },
        {
            "x": -0.5618060231208801,
            "y": -0.12366536259651184,
            "z": -146.60130310058594
        },
        {
            "x": -0.538230299949646,
            "y": -0.11760744452476501,
            "z": -146.44598388671875
        },
        {
            "x": -0.5151925086975098,
            "y": -0.11167246103286743,
            "z": -146.29046630859375
        },
        {
            "x": -0.49253028631210327,
            "y": -0.1058659553527832,
            "z": -146.13491821289062
        },
        {
            "x": -0.4703703820705414,
            "y": -0.10019274055957794,
            "z": -145.9793701171875
        },
        {
            "x": -0.45587992668151855,
            "y": -0.09648305922746658,
            "z": -145.87564086914062
        },
        {
            "x": -0.4344382882118225,
            "y": -0.09103484451770782,
            "z": -145.72000122070312
        },
        {
            "x": -0.4135235846042633,
            "y": -0.0857233852148056,
            "z": -145.56427001953125
        },
        {
            "x": -0.3930225968360901,
            "y": -0.08054544776678085,
            "z": -145.4082794189453
        },
        {
            "x": -0.372985303401947,
            "y": -0.07552029192447662,
            "z": -145.25245666503906
        },
        {
            "x": -0.3535117506980896,
            "y": -0.07064467668533325,
            "z": -145.09649658203125
        },
        {
            "x": -0.33439621329307556,
            "y": -0.065914586186409,
            "z": -144.94044494628906
        },
        {
            "x": -0.31584233045578003,
            "y": -0.06134017929434776,
            "z": -144.78440856933594
        },
        {
            "x": -0.297728031873703,
            "y": -0.05691983178257942,
            "z": -144.62820434570312
        },
        {
            "x": -0.2800722122192383,
            "y": -0.05266229808330536,
            "z": -144.47193908691406
        },
        {
            "x": -0.2629881799221039,
            "y": -0.048568520694971085,
            "z": -144.31573486328125
        },
        {
            "x": -0.24626749753952026,
            "y": -0.044634848833084106,
            "z": -144.15933227539062
        },
        {
            "x": -0.23013204336166382,
            "y": -0.04087357223033905,
            "z": -144.0030059814453
        },
        {
            "x": -0.21446996927261353,
            "y": -0.037287503480911255,
            "z": -143.84661865234375
        },
        {
            "x": -0.19923779368400574,
            "y": -0.03386980667710304,
            "z": -143.6899871826172
        },
        {
            "x": -0.1846003532409668,
            "y": -0.03063170239329338,
            "z": -143.5334930419922
        },
        {
            "x": -0.17034931480884552,
            "y": -0.027573369443416595,
            "z": -143.37693786621094
        },
        {
            "x": -0.15668608248233795,
            "y": -0.024703074246644974,
            "z": -143.2202911376953
        },
        {
            "x": -0.143503800034523,
            "y": -0.022017735987901688,
            "z": -143.0636444091797
        },
        {
            "x": -0.13075301051139832,
            "y": -0.019516542553901672,
            "z": -142.9067840576172
        },
        {
            "x": -0.11862576007843018,
            "y": -0.017211023718118668,
            "z": -142.7500762939453
        },
        {
            "x": -0.10690277814865112,
            "y": -0.015105227008461952,
            "z": -142.59332275390625
        },
        {
            "x": -0.09575176984071732,
            "y": -0.013195819221436977,
            "z": -142.43653869628906
        },
        {
            "x": -0.0851030945777893,
            "y": -0.01148492656648159,
            "z": -142.2797088623047
        },
        {
            "x": -0.07488405704498291,
            "y": -0.009976206347346306,
            "z": -142.12274169921875
        },
        {
            "x": -0.06530413031578064,
            "y": -0.008680754341185093,
            "z": -141.96575927734375
        },
        {
            "x": -0.056136421859264374,
            "y": -0.007593369577080011,
            "z": -141.808837890625
        },
        {
            "x": -0.04751570522785187,
            "y": -0.006715571507811546,
            "z": -141.65176391601562
        },
        {
            "x": -0.03944700211286545,
            "y": -0.006052828393876553,
            "z": -141.49476623535156
        },
        {
            "x": -0.03181144595146179,
            "y": -0.005615155678242445,
            "z": -141.3377685546875
        },
        {
            "x": -0.02479282021522522,
            "y": -0.005401713773608208,
            "z": -141.1805419921875
        },
        {
            "x": -0.01821628212928772,
            "y": -0.005388743244111538,
            "z": -141.0234832763672
        },
        {
            "x": -0.01216191053390503,
            "y": -0.0053953672759234905,
            "z": -140.86634826660156
        },
        {
            "x": -0.006718680262565613,
            "y": -0.00540199363604188,
            "z": -140.7091827392578
        },
        {
            "x": -0.0016758888959884644,
            "y": -0.005408617667853832,
            "z": -140.55206298828125
        },
        {
            "x": 0.002755671739578247,
            "y": -0.005415251944214106,
            "z": -140.39474487304688
        },
        {
            "x": 0.006702929735183716,
            "y": -0.005421871319413185,
            "z": -140.23760986328125
        },
        {
            "x": 0.010155245661735535,
            "y": -0.005428500007838011,
            "z": -140.08042907714844
        },
        {
            "x": 0.013000443577766418,
            "y": -0.0054351263679564,
            "z": -139.9231719970703
        },
        {
            "x": 0.015444532036781311,
            "y": -0.005441753193736076,
            "z": -139.76602172851562
        },
        {
            "x": 0.017341598868370056,
            "y": -0.0054483795538544655,
            "z": -139.60873413085938
        },
        {
            "x": 0.018759682774543762,
            "y": -0.00545501010492444,
            "z": -139.45143127441406
        },
        {
            "x": 0.019807890057563782,
            "y": -0.005461632739752531,
            "z": -139.2942352294922
        },
        {
            "x": 0.020260587334632874,
            "y": -0.005466048140078783,
            "z": -139.1894073486328
        },
        {
            "x": 0.020719558000564575,
            "y": -0.005472674034535885,
            "z": -139.03221130371094
        },
        {
            "x": 0.020954012870788574,
            "y": -0.005479301791638136,
            "z": -138.87498474121094
        },
        {
            "x": 0.020974725484848022,
            "y": -0.005485932808369398,
            "z": -138.71755981445312
        },
        {
            "x": 0.020937979221343994,
            "y": -0.005492556374520063,
            "z": -138.5603485107422
        },
        {
            "x": 0.0208120197057724,
            "y": -0.005499179475009441,
            "z": -138.40310668945312
        },
        {
            "x": 0.020648345351219177,
            "y": -0.005505807232111692,
            "z": -138.2457733154297
        },
        {
            "x": 0.020477324724197388,
            "y": -0.005512432660907507,
            "z": -138.0885467529297
        },
        {
            "x": 0.020289182662963867,
            "y": -0.005519059486687183,
            "z": -137.9312286376953
        },
        {
            "x": 0.02009826898574829,
            "y": -0.005525689572095871,
            "z": -137.7738800048828
        },
        {
            "x": 0.019904538989067078,
            "y": -0.005532316863536835,
            "z": -137.6166534423828
        },
        {
            "x": 0.019707486033439636,
            "y": -0.005538942292332649,
            "z": -137.4593048095703
        },
        {
            "x": 0.01950925588607788,
            "y": -0.0055455672554671764,
            "z": -137.3020782470703
        },
        {
            "x": 0.01930864155292511,
            "y": -0.005552192218601704,
            "z": -137.1448516845703
        },
        {
            "x": 0.019105970859527588,
            "y": -0.005558823235332966,
            "z": -136.9874267578125
        },
        {
            "x": 0.018901854753494263,
            "y": -0.0055654472671449184,
            "z": -136.8302001953125
        },
        {
            "x": 0.018695414066314697,
            "y": -0.005572076421231031,
            "z": -136.67291259765625
        },
        {
            "x": 0.018487364053726196,
            "y": -0.005578699987381697,
            "z": -136.51564025878906
        },
        {
            "x": 0.018277287483215332,
            "y": -0.005585324484854937,
            "z": -136.35841369628906
        },
        {
            "x": 0.01806500554084778,
            "y": -0.005591961555182934,
            "z": -136.2009735107422
        },
        {
            "x": 0.017851367592811584,
            "y": -0.005598585586994886,
            "z": -136.0437469482422
        },
        {
            "x": 0.017635315656661987,
            "y": -0.005605208221822977,
            "z": -135.8865203857422
        },
        {
            "x": 0.0174177885055542,
            "y": -0.005611831322312355,
            "z": -135.72926330566406
        },
        {
            "x": 0.017198100686073303,
            "y": -0.005618455819785595,
            "z": -135.57203674316406
        },
        {
            "x": 0.016976267099380493,
            "y": -0.005625085439532995,
            "z": -135.4147186279297
        },
        {
            "x": 0.01675283908843994,
            "y": -0.00563171599060297,
            "z": -135.2573699951172
        },
        {
            "x": 0.01652713119983673,
            "y": -0.005638339556753635,
            "z": -135.1001434326172
        },
        {
            "x": 0.01629975438117981,
            "y": -0.005644965451210737,
            "z": -134.9427947998047
        },
        {
            "x": 0.016070351004600525,
            "y": -0.00565158948302269,
            "z": -134.7855682373047
        },
        {
            "x": 0.015838950872421265,
            "y": -0.005658214911818504,
            "z": -134.6283416748047
        },
        {
            "x": 0.015605568885803223,
            "y": -0.0056648473255336285,
            "z": -134.4709014892578
        },
        {
            "x": 0.015370115637779236,
            "y": -0.005671472754329443,
            "z": -134.31365966796875
        },
        {
            "x": 0.015133082866668701,
            "y": -0.005678100045770407,
            "z": -134.1563720703125
        },
        {
            "x": 0.014893725514411926,
            "y": -0.0056847273372113705,
            "z": -133.99908447265625
        },
        {
            "x": 0.014652594923973083,
            "y": -0.005691351369023323,
            "z": -133.84185791015625
        },
        {
            "x": 0.014409318566322327,
            "y": -0.005697983782738447,
            "z": -133.6844482421875
        },
        {
            "x": 0.014164075255393982,
            "y": -0.005704609211534262,
            "z": -133.52719116210938
        },
        {
            "x": 0.01391725242137909,
            "y": -0.005711232777684927,
            "z": -133.36996459960938
        },
        {
            "x": 0.013667881488800049,
            "y": -0.005717862863093615,
            "z": -133.212646484375
        },
        {
            "x": 0.013416990637779236,
            "y": -0.005724485497921705,
            "z": -133.05538940429688
        },
        {
            "x": 0.013163834810256958,
            "y": -0.005731117445975542,
            "z": -132.8980712890625
        },
        {
            "x": 0.012908637523651123,
            "y": -0.005731276702135801,
            "z": -132.74075317382812
        },
        {
            "x": 0.012651756405830383,
            "y": -0.005496910773217678,
            "z": -132.58349609375
        },
        {
            "x": 0.01247820258140564,
            "y": -0.0051292297430336475,
            "z": -132.47866821289062
        },
        {
            "x": 0.012217000126838684,
            "y": -0.004245862830430269,
            "z": -132.3214111328125
        },
        {
            "x": 0.011954635381698608,
            "y": -0.002978603821247816,
            "z": -132.1641845703125
        },
        {
            "x": 0.011689960956573486,
            "y": -0.0013424220960587263,
            "z": -132.00674438476562
        },
        {
            "x": 0.011423751711845398,
            "y": 0.0006502070464193821,
            "z": -131.8494873046875
        },
        {
            "x": 0.011155262589454651,
            "y": 0.00300031341612339,
            "z": -131.6922607421875
        },
        {
            "x": 0.010884985327720642,
            "y": 0.005701009649783373,
            "z": -131.53494262695312
        },
        {
            "x": 0.010612428188323975,
            "y": 0.008731888607144356,
            "z": -131.37774658203125
        },
        {
            "x": 0.010338112711906433,
            "y": 0.012087649665772915,
            "z": -131.22042846679688
        },
        {
            "x": 0.010061502456665039,
            "y": 0.01576549932360649,
            "z": -131.0631103515625
        },
        {
            "x": 0.009783029556274414,
            "y": 0.019754678010940552,
            "z": -130.9059295654297
        },
        {
            "x": 0.009502530097961426,
            "y": 0.0240432508289814,
            "z": -130.74862670898438
        },
        {
            "x": 0.009219974279403687,
            "y": 0.028616759926080704,
            "z": -130.59146118164062
        },
        {
            "x": 0.008935660123825073,
            "y": 0.033475112169981,
            "z": -130.43429565429688
        },
        {
            "x": 0.008648619055747986,
            "y": 0.03861925005912781,
            "z": -130.27691650390625
        },
        {
            "x": 0.008360251784324646,
            "y": 0.04401732608675957,
            "z": -130.11978149414062
        },
        {
            "x": 0.008069410920143127,
            "y": 0.04967087507247925,
            "z": -129.96261596679688
        },
        {
            "x": 0.007776826620101929,
            "y": 0.055573176592588425,
            "z": -129.80538940429688
        },
        {
            "x": 0.007482096552848816,
            "y": 0.06171591952443123,
            "z": -129.6482696533203
        },
        {
            "x": 0.007185086607933044,
            "y": 0.06809313595294952,
            "z": -129.49098205566406
        },
        {
            "x": 0.006886377930641174,
            "y": 0.07468143850564957,
            "z": -129.33387756347656
        },
        {
            "x": 0.006585568189620972,
            "y": 0.08148149400949478,
            "z": -129.17677307128906
        },
        {
            "x": 0.006282821297645569,
            "y": 0.08848884701728821,
            "z": -129.0196990966797
        },
        {
            "x": 0.005977794528007507,
            "y": 0.09568826854228973,
            "z": -128.8626251220703
        },
        {
            "x": 0.005670830607414246,
            "y": 0.10307484865188599,
            "z": -128.70545959472656
        },
        {
            "x": 0.005361467599868774,
            "y": 0.11063877493143082,
            "z": -128.5482940673828
        },
        {
            "x": 0.005050525069236755,
            "y": 0.11837019771337509,
            "z": -128.39125061035156
        },
        {
            "x": 0.004737094044685364,
            "y": 0.12626275420188904,
            "z": -128.23411560058594
        },
        {
            "x": 0.004422038793563843,
            "y": 0.1342986524105072,
            "z": -128.0771026611328
        },
        {
            "x": 0.004104629158973694,
            "y": 0.14247530698776245,
            "z": -127.92008209228516
        },
        {
            "x": 0.0037850290536880493,
            "y": 0.15079867839813232,
            "z": -127.76287078857422
        },
        {
            "x": 0.003463536500930786,
            "y": 0.1592341959476471,
            "z": -127.60585021972656
        },
        {
            "x": 0.0031400322914123535,
            "y": 0.16778689622879028,
            "z": -127.44878387451172
        },
        {
            "x": 0.002814382314682007,
            "y": 0.17644420266151428,
            "z": -127.29173278808594
        },
        {
            "x": 0.002486705780029297,
            "y": 0.18519918620586395,
            "z": -127.1347427368164
        },
        {
            "x": 0.0021566152572631836,
            "y": 0.19405223429203033,
            "z": -126.97757720947266
        },
        {
            "x": 0.0018248111009597778,
            "y": 0.2029733657836914,
            "z": -126.82059478759766
        },
        {
            "x": 0.0014909356832504272,
            "y": 0.21196594834327698,
            "z": -126.66361999511719
        },
        {
            "x": 0.0011547207832336426,
            "y": 0.2210284173488617,
            "z": -126.50653839111328
        },
        {
            "x": 0.0008166283369064331,
            "y": 0.23013797402381897,
            "z": -126.34957885742188
        },
        {
            "x": 0.00047619640827178955,
            "y": 0.23929771780967712,
            "z": -126.19249725341797
        },
        {
            "x": 0.00013381242752075195,
            "y": 0.24849337339401245,
            "z": -126.0354232788086
        },
        {
            "x": -0.00021065771579742432,
            "y": 0.25771036744117737,
            "z": -125.87847900390625
        },
        {
            "x": -0.0004412829875946045,
            "y": 0.2638665735721588,
            "z": -125.7738265991211
        },
        {
            "x": -0.0007892847061157227,
            "y": 0.27310964465141296,
            "z": -125.61688232421875
        },
        {
            "x": -0.001139119267463684,
            "y": 0.2823573648929596,
            "z": -125.45990753173828
        },
        {
            "x": -0.0014917850494384766,
            "y": 0.29161185026168823,
            "z": -125.3027572631836
        },
        {
            "x": -0.0018458515405654907,
            "y": 0.3008405566215515,
            "z": -125.14581298828125
        },
        {
            "x": -0.002202257513999939,
            "y": 0.31004834175109863,
            "z": -124.98885345458984
        },
        {
            "x": -0.002560749650001526,
            "y": 0.3192306160926819,
            "z": -124.831787109375
        },
        {
            "x": -0.002921462059020996,
            "y": 0.32836610078811646,
            "z": -124.67483520507812
        },
        {
            "x": -0.0032842308282852173,
            "y": 0.3374609351158142,
            "z": -124.51774597167969
        },
        {
            "x": -0.003649294376373291,
            "y": 0.34649771451950073,
            "z": -124.3606948852539
        },
        {
            "x": -0.004016071557998657,
            "y": 0.35546284914016724,
            "z": -124.2037124633789
        },
        {
            "x": -0.004385426640510559,
            "y": 0.3643583655357361,
            "z": -124.04661560058594
        },
        {
            "x": -0.004756510257720947,
            "y": 0.3731653690338135,
            "z": -123.88963317871094
        },
        {
            "x": -0.0051298439502716064,
            "y": 0.38188105821609497,
            "z": -123.73265075683594
        },
        {
            "x": -0.005505591630935669,
            "y": 0.3905056118965149,
            "z": -123.5754623413086
        },
        {
            "x": -0.005883172154426575,
            "y": 0.3990079164505005,
            "z": -123.41847229003906
        },
        {
            "x": -0.006262913346290588,
            "y": 0.40739548206329346,
            "z": -123.26142120361328
        },
        {
            "x": -0.006644710898399353,
            "y": 0.41565757989883423,
            "z": -123.1043472290039
        },
        {
            "x": -0.007028684020042419,
            "y": 0.4237803816795349,
            "z": -122.94732666015625
        },
        {
            "x": -0.007415086030960083,
            "y": 0.43176472187042236,
            "z": -122.79012298583984
        },
        {
            "x": -0.007803335785865784,
            "y": 0.43958762288093567,
            "z": -122.6330795288086
        },
        {
            "x": -0.008193492889404297,
            "y": 0.4472495913505554,
            "z": -122.47603607177734
        },
        {
            "x": -0.008585959672927856,
            "y": 0.4547407627105713,
            "z": -122.3189926147461
        },
        {
            "x": -0.008980408310890198,
            "y": 0.46204662322998047,
            "z": -122.16197967529297
        },
        {
            "x": -0.009377360343933105,
            "y": 0.46917080879211426,
            "z": -122.00480651855469
        },
        {
            "x": -0.009776294231414795,
            "y": 0.47609904408454895,
            "z": -121.84764862060547
        },
        {
            "x": -0.010177180171012878,
            "y": 0.4828181266784668,
            "z": -121.69055938720703
        },
        {
            "x": -0.010580465197563171,
            "y": 0.4893192648887634,
            "z": -121.53336334228516
        },
        {
            "x": -0.010985523462295532,
            "y": 0.495594322681427,
            "z": -121.37626647949219
        },
        {
            "x": -0.011392876505851746,
            "y": 0.5016394853591919,
            "z": -121.21916198730469
        },
        {
            "x": -0.011802539229393005,
            "y": 0.5074523091316223,
            "z": -121.06185913085938
        },
        {
            "x": -0.01221410185098648,
            "y": 0.5129982233047485,
            "z": -120.90473937988281
        },
        {
            "x": -0.012627758085727692,
            "y": 0.5182899236679077,
            "z": -120.7475357055664
        },
        {
            "x": -0.01304347813129425,
            "y": 0.5233156681060791,
            "z": -120.59034729003906
        },
        {
            "x": -0.013461276888847351,
            "y": 0.5280662178993225,
            "z": -120.43319702148438
        },
        {
            "x": -0.013881556689739227,
            "y": 0.5325255393981934,
            "z": -120.27583312988281
        },
        {
            "x": -0.01430358737707138,
            "y": 0.5366872549057007,
            "z": -120.11868286132812
        },
        {
            "x": -0.01472751796245575,
            "y": 0.5405490398406982,
            "z": -119.96151733398438
        },
        {
            "x": -0.015153773128986359,
            "y": 0.5441045761108398,
            "z": -119.8042221069336
        },
        {
            "x": -0.01558201014995575,
            "y": 0.5473247170448303,
            "z": -119.64704895019531
        },
        {
            "x": -0.016012363135814667,
            "y": 0.5502192974090576,
            "z": -119.48976135253906
        },
        {
            "x": -0.0164448544383049,
            "y": 0.5527783632278442,
            "z": -119.33245086669922
        },
        {
            "x": -0.01687905192375183,
            "y": 0.5549917221069336,
            "z": -119.17526245117188
        },
        {
            "x": -0.017169758677482605,
            "y": 0.5562573671340942,
            "z": -119.0704574584961
        },
        {
            "x": -0.01760934293270111,
            "y": 0.5578665137290955,
            "z": -118.9132308959961
        },
        {
            "x": -0.01804884523153305,
            "y": 0.5591086149215698,
            "z": -118.75602722167969
        },
        {
            "x": -0.01849111169576645,
            "y": 0.5599592328071594,
            "z": -118.59862518310547
        },
        {
            "x": -0.018934667110443115,
            "y": 0.5604215264320374,
            "z": -118.44139862060547
        },
        {
            "x": -0.01938015967607498,
            "y": 0.5604903101921082,
            "z": -118.28418731689453
        },
        {
            "x": -0.019827961921691895,
            "y": 0.560163140296936,
            "z": -118.12686920166016
        },
        {
            "x": -0.020277373492717743,
            "y": 0.559432327747345,
            "z": -117.96965789794922
        },
        {
            "x": -0.0207289457321167,
            "y": 0.5583183765411377,
            "z": -117.8123550415039
        },
        {
            "x": -0.021182507276535034,
            "y": 0.5568336248397827,
            "z": -117.65502166748047
        },
        {
            "x": -0.021637558937072754,
            "y": 0.5549876689910889,
            "z": -117.4978256225586
        },
        {
            "x": -0.02209484577178955,
            "y": 0.5527734160423279,
            "z": -117.34051513671875
        },
        {
            "x": -0.022553689777851105,
            "y": 0.5502129793167114,
            "z": -117.18331909179688
        },
        {
            "x": -0.02301427721977234,
            "y": 0.5473169088363647,
            "z": -117.02611541748047
        },
        {
            "x": -0.02347715198993683,
            "y": 0.5440899133682251,
            "z": -116.86874389648438
        },
        {
            "x": -0.023941367864608765,
            "y": 0.5405371189117432,
            "z": -116.71156311035156
        },
        {
            "x": -0.024407394230365753,
            "y": 0.5366697311401367,
            "z": -116.5543441772461
        },
        {
            "x": -0.024875111877918243,
            "y": 0.532501757144928,
            "z": -116.39710998535156
        },
        {
            "x": -0.0253443643450737,
            "y": 0.5280438661575317,
            "z": -116.23997497558594
        },
        {
            "x": -0.025815866887569427,
            "y": 0.5232862830162048,
            "z": -116.0826187133789
        },
        {
            "x": -0.026288367807865143,
            "y": 0.5182569026947021,
            "z": -115.92548370361328
        },
        {
            "x": -0.02676244080066681,
            "y": 0.5129622220993042,
            "z": -115.76836395263672
        },
        {
            "x": -0.02723804861307144,
            "y": 0.5074102878570557,
            "z": -115.6112289428711
        },
        {
            "x": -0.02771516889333725,
            "y": 0.5016024112701416,
            "z": -115.4541015625
        },
        {
            "x": -0.02819395810365677,
            "y": 0.4955477714538574,
            "z": -115.29690551757812
        },
        {
            "x": -0.028674177825450897,
            "y": 0.4892624020576477,
            "z": -115.13972473144531
        },
        {
            "x": -0.029155515134334564,
            "y": 0.4827587604522705,
            "z": -114.98263549804688
        },
        {
            "x": -0.029638327658176422,
            "y": 0.47603219747543335,
            "z": -114.82545471191406
        },
        {
            "x": -0.03012218326330185,
            "y": 0.4691005349159241,
            "z": -114.66837310791016
        },
        {
            "x": -0.030607230961322784,
            "y": 0.4619731903076172,
            "z": -114.51131439208984
        },
        {
            "x": -0.031093858182430267,
            "y": 0.4546507000923157,
            "z": -114.35407257080078
        },
        {
            "x": -0.03158101439476013,
            "y": 0.44715380668640137,
            "z": -114.19702911376953
        },
        {
            "x": -0.032069265842437744,
            "y": 0.4394807815551758,
            "z": -114.03993225097656
        },
        {
            "x": -0.03255847841501236,
            "y": 0.431646466255188,
            "z": -113.88284301757812
        },
        {
            "x": -0.03304830193519592,
            "y": 0.42366328835487366,
            "z": -113.72581481933594
        },
        {
            "x": -0.03353935480117798,
            "y": 0.41552281379699707,
            "z": -113.568603515625
        },
        {
            "x": -0.03403051197528839,
            "y": 0.40725499391555786,
            "z": -113.41160583496094
        },
        {
            "x": -0.03452214598655701,
            "y": 0.39886027574539185,
            "z": -113.25460052490234
        },
        {
            "x": -0.03501443564891815,
            "y": 0.39034223556518555,
            "z": -113.09749603271484
        },
        {
            "x": -0.0355067253112793,
            "y": 0.38172006607055664,
            "z": -112.94051361083984
        },
        {
            "x": -0.03599940240383148,
            "y": 0.37298834323883057,
            "z": -112.7834243774414
        },
        {
            "x": -0.03649209439754486,
            "y": 0.3641647696495056,
            "z": -112.62633514404297
        },
        {
            "x": -0.03698429465293884,
            "y": 0.35526537895202637,
            "z": -112.46936798095703
        },
        {
            "x": -0.03731219470500946,
            "y": 0.34928879141807556,
            "z": -112.36470794677734
        },
        {
            "x": -0.03780372440814972,
            "y": 0.3402678370475769,
            "z": -112.2077407836914
        },
        {
            "x": -0.03829464316368103,
            "y": 0.3311861753463745,
            "z": -112.05077362060547
        },
        {
            "x": -0.038785144686698914,
            "y": 0.32204222679138184,
            "z": -111.89360809326172
        },
        {
            "x": -0.0392739474773407,
            "y": 0.3128661811351776,
            "z": -111.73665618896484
        },
        {
            "x": -0.03976140171289444,
            "y": 0.30365604162216187,
            "z": -111.57970428466797
        },
        {
            "x": -0.04024747014045715,
            "y": 0.29441431164741516,
            "z": -111.42263793945312
        },
        {
            "x": -0.040731288492679596,
            "y": 0.28516262769699097,
            "z": -111.26567840576172
        },
        {
            "x": -0.04121295362710953,
            "y": 0.27589643001556396,
            "z": -111.1086196899414
        },
        {
            "x": -0.04169195145368576,
            "y": 0.26663124561309814,
            "z": -110.9515609741211
        },
        {
            "x": -0.04216756671667099,
            "y": 0.257381796836853,
            "z": -110.79460144042969
        },
        {
            "x": -0.04263990372419357,
            "y": 0.24814295768737793,
            "z": -110.63752746582031
        },
        {
            "x": -0.04310757666826248,
            "y": 0.23894014954566956,
            "z": -110.48059844970703
        },
        {
            "x": -0.04357051104307175,
            "y": 0.22977204620838165,
            "z": -110.32363891601562
        },
        {
            "x": -0.04402858018875122,
            "y": 0.22063595056533813,
            "z": -110.16646575927734
        },
        {
            "x": -0.04447995871305466,
            "y": 0.21156424283981323,
            "z": -110.00948333740234
        },
        {
            "x": -0.044924184679985046,
            "y": 0.20255300402641296,
            "z": -109.85245513916016
        },
        {
            "x": -0.04536016285419464,
            "y": 0.19361278414726257,
            "z": -109.69542694091797
        },
        {
            "x": -0.04578683525323868,
            "y": 0.1847546398639679,
            "z": -109.53844451904297
        },
        {
            "x": -0.04620344936847687,
            "y": 0.1759713590145111,
            "z": -109.38123321533203
        },
        {
            "x": -0.04660683125257492,
            "y": 0.1672995686531067,
            "z": -109.22422790527344
        },
        {
            "x": -0.04699601233005524,
            "y": 0.15873412787914276,
            "z": -109.06723022460938
        },
        {
            "x": -0.047368817031383514,
            "y": 0.1502811163663864,
            "z": -108.91020965576172
        },
        {
            "x": -0.04772253334522247,
            "y": 0.141949862241745,
            "z": -108.753173828125
        },
        {
            "x": -0.04805321246385574,
            "y": 0.1337485909461975,
            "z": -108.59605407714844
        },
        {
            "x": -0.04835667461156845,
            "y": 0.12568943202495575,
            "z": -108.43891906738281
        },
        {
            "x": -0.048627689480781555,
            "y": 0.11778279393911362,
            "z": -108.2818603515625
        },
        {
            "x": -0.04887274652719498,
            "y": 0.1100286990404129,
            "z": -108.12471771240234
        },
        {
            "x": -0.04932927340269089,
            "y": 0.10245787352323532,
            "z": -107.96784973144531
        },
        {
            "x": -0.05071873962879181,
            "y": 0.09507302194833755,
            "z": -107.81112670898438
        },
        {
            "x": -0.05330877751111984,
            "y": 0.08786320686340332,
            "z": -107.65423583984375
        },
        {
            "x": -0.05705320090055466,
            "y": 0.08085393905639648,
            "z": -107.49756622314453
        },
        {
            "x": -0.061907824128866196,
            "y": 0.07404579222202301,
            "z": -107.34080505371094
        },
        {
            "x": -0.06780789792537689,
            "y": 0.06745249778032303,
            "z": -107.1840591430664
        },
        {
            "x": -0.0746590793132782,
            "y": 0.06107989326119423,
            "z": -107.02740478515625
        },
        {
            "x": -0.08241468667984009,
            "y": 0.054925110191106796,
            "z": -106.87054443359375
        },
        {
            "x": -0.09099961072206497,
            "y": 0.04901702702045441,
            "z": -106.7138900756836
        },
        {
            "x": -0.10036170482635498,
            "y": 0.04336056113243103,
            "z": -106.5572738647461
        },
        {
            "x": -0.11042942851781845,
            "y": 0.0379524901509285,
            "z": -106.40055847167969
        },
        {
            "x": -0.12113388627767563,
            "y": 0.032807856798172,
            "z": -106.24394989013672
        },
        {
            "x": -0.1324271261692047,
            "y": 0.027933530509471893,
            "z": -106.0872573852539
        },
        {
            "x": -0.14426705241203308,
            "y": 0.02334723249077797,
            "z": -105.93059539794922
        },
        {
            "x": -0.15657144784927368,
            "y": 0.019049452617764473,
            "z": -105.77403259277344
        },
        {
            "x": -0.1650010049343109,
            "y": 0.01634359359741211,
            "z": -105.66966247558594
        },
        {
            "x": -0.17799171805381775,
            "y": 0.01255173422396183,
            "z": -105.51311492919922
        },
        {
            "x": -0.1913166642189026,
            "y": 0.009069154039025307,
            "z": -105.35658264160156
        },
        {
            "x": -0.20495881140232086,
            "y": 0.005900212563574314,
            "z": -105.19985961914062
        },
        {
            "x": -0.21883875131607056,
            "y": 0.003065061755478382,
            "z": -105.04331970214844
        },
        {
            "x": -0.23294296860694885,
            "y": 0.0005779180210083723,
            "z": -104.88679504394531
        },
        {
            "x": -0.24723577499389648,
            "y": -0.0015669201966375113,
            "z": -104.73016357421875
        },
        {
            "x": -0.2616642713546753,
            "y": -0.0033580344170331955,
            "z": -104.5736312866211
        },
        {
            "x": -0.27621203660964966,
            "y": -0.004786038771271706,
            "z": -104.41700744628906
        },
        {
            "x": -0.2908475697040558,
            "y": -0.005828777328133583,
            "z": -104.2603530883789
        },
        {
            "x": -0.30552446842193604,
            "y": -0.006492213346064091,
            "z": -104.10380554199219
        },
        {
            "x": -0.320242315530777,
            "y": -0.006768593564629555,
            "z": -103.9471206665039
        },
        {
            "x": -0.33495089411735535,
            "y": -0.006787101738154888,
            "z": -103.79058837890625
        },
        {
            "x": -0.349638968706131,
            "y": -0.006793145556002855,
            "z": -103.63401794433594
        },
        {
            "x": -0.36430349946022034,
            "y": -0.0067991879768669605,
            "z": -103.47726440429688
        },
        {
            "x": -0.3788899779319763,
            "y": -0.00680523319169879,
            "z": -103.32068634033203
        },
        {
            "x": -0.39340442419052124,
            "y": -0.006811277009546757,
            "z": -103.16403198242188
        },
        {
            "x": -0.4078225791454315,
            "y": -0.006817319896072149,
            "z": -103.00738525390625
        },
        {
            "x": -0.42212799191474915,
            "y": -0.006823360919952393,
            "z": -102.85076904296875
        },
        {
            "x": -0.4363282322883606,
            "y": -0.006829402409493923,
            "z": -102.69391632080078
        },
        {
            "x": -0.4503733515739441,
            "y": -0.006835452280938625,
            "z": -102.53726959228516
        },
        {
            "x": -0.4642671048641205,
            "y": -0.006841491907835007,
            "z": -102.38059997558594
        },
        {
            "x": -0.47800421714782715,
            "y": -0.006847534328699112,
            "z": -102.22391510009766
        },
        {
            "x": -0.49157583713531494,
            "y": -0.006853568833321333,
            "z": -102.06720733642578
        },
        {
            "x": -0.5049808025360107,
            "y": -0.0068596163764595985,
            "z": -101.91038513183594
        },
        {
            "x": -0.5181958079338074,
            "y": -0.006865662056952715,
            "z": -101.7535400390625
        },
        {
            "x": -0.5312103629112244,
            "y": -0.006871701218187809,
            "z": -101.5967788696289
        },
        {
            "x": -0.5440382957458496,
            "y": -0.00687774270772934,
            "z": -101.43989562988281
        },
        {
            "x": -0.5566573143005371,
            "y": -0.006883794441819191,
            "z": -101.2831039428711
        },
        {
            "x": -0.5690565705299377,
            "y": -0.00688982754945755,
            "z": -101.12627410888672
        },
        {
            "x": -0.5812590718269348,
            "y": -0.006895875092595816,
            "z": -100.96924591064453
        },
        {
            "x": -0.5932292938232422,
            "y": -0.006901915185153484,
            "z": -100.81239318847656
        },
        {
            "x": -0.6049853563308716,
            "y": -0.0069079650565981865,
            "z": -100.65547180175781
        },
        {
            "x": -0.6165065765380859,
            "y": -0.006914001889526844,
            "z": -100.49851989746094
        },
        {
            "x": -0.627798318862915,
            "y": -0.0069200424477458,
            "z": -100.34161376953125
        },
        {
            "x": -0.6388768553733826,
            "y": -0.006926096975803375,
            "z": -100.18448638916016
        },
        {
            "x": -0.6497118473052979,
            "y": -0.006932137068361044,
            "z": -100.02753448486328
        },
        {
            "x": -0.6603038311004639,
            "y": -0.006938174366950989,
            "z": -99.87057495117188
        },
        {
            "x": -0.670666515827179,
            "y": -0.006944215856492519,
            "z": -99.7135009765625
        },
        {
            "x": -0.6807891726493835,
            "y": -0.0069502610713243484,
            "z": -99.55651092529297
        },
        {
            "x": -0.6906828880310059,
            "y": -0.006956303492188454,
            "z": -99.3993911743164
        },
        {
            "x": -0.7003330588340759,
            "y": -0.006962345913052559,
            "z": -99.24226379394531
        },
        {
            "x": -0.70973801612854,
            "y": -0.006968394387513399,
            "z": -99.08523559570312
        },
        {
            "x": -0.7158786058425903,
            "y": -0.006972417235374451,
            "z": -98.98053741455078
        },
        {
            "x": -0.7248849868774414,
            "y": -0.006978456862270832,
            "z": -98.823486328125
        },
        {
            "x": -0.7336527109146118,
            "y": -0.006984497420489788,
            "z": -98.66641235351562
        },
        {
            "x": -0.7421956062316895,
            "y": -0.006990546826273203,
            "z": -98.50912475585938
        },
        {
            "x": -0.7504903078079224,
            "y": -0.006996585987508297,
            "z": -98.3520278930664
        },
        {
            "x": -0.7585399150848389,
            "y": -0.007002628408372402,
            "z": -98.19491577148438
        },
        {
            "x": -0.7663595080375671,
            "y": -0.007008674554526806,
            "z": -98.03766632080078
        },
        {
            "x": -0.7739389538764954,
            "y": -0.006992587819695473,
            "z": -97.88053131103516
        },
        {
            "x": -0.7812911868095398,
            "y": -0.006836171727627516,
            "z": -97.7232666015625
        },
        {
            "x": -0.7884019613265991,
            "y": -0.00650739436969161,
            "z": -97.56600952148438
        },
        {
            "x": -0.7952741384506226,
            "y": -0.006013772916048765,
            "z": -97.4088363647461
        },
        {
            "x": -0.8019219040870667,
            "y": -0.005360166076570749,
            "z": -97.25153350830078
        },
        {
            "x": -0.8083367347717285,
            "y": -0.004550809506326914,
            "z": -97.09432983398438
        },
        {
            "x": -0.8145143389701843,
            "y": -0.003583592362701893,
            "z": -96.93714141845703
        },
        {
            "x": -0.8204696774482727,
            "y": -0.002463099081069231,
            "z": -96.77973175048828
        },
        {
            "x": -0.826194167137146,
            "y": -0.0011979658156633377,
            "z": -96.62250518798828
        },
        {
            "x": -0.8316958546638489,
            "y": 0.00021023466251790524,
            "z": -96.46524810791016
        },
        {
            "x": -0.8369666934013367,
            "y": 0.0017624266911298037,
            "z": -96.30795288085938
        },
        {
            "x": -0.8420136570930481,
            "y": 0.0034523354843258858,
            "z": -96.15071868896484
        },
        {
            "x": -0.8468470573425293,
            "y": 0.005277044139802456,
            "z": -95.9932861328125
        },
        {
            "x": -0.8514561653137207,
            "y": 0.0072289202362298965,
            "z": -95.8360366821289
        },
        {
            "x": -0.8558458089828491,
            "y": 0.009310247376561165,
            "z": -95.67877960205078
        },
        {
            "x": -0.8600156903266907,
            "y": 0.011516224592924118,
            "z": -95.52153778076172
        },
        {
            "x": -0.8639721274375916,
            "y": 0.0138412369415164,
            "z": -95.36428833007812
        },
        {
            "x": -0.8677210211753845,
            "y": 0.016283687204122543,
            "z": -95.20691680908203
        },
        {
            "x": -0.8712522387504578,
            "y": 0.01884145848453045,
            "z": -95.049560546875
        },
        {
            "x": -0.8745682239532471,
            "y": 0.021509014070034027,
            "z": -94.89229583740234
        },
        {
            "x": -0.8776810765266418,
            "y": 0.024283912032842636,
            "z": -94.73491668701172
        },
        {
            "x": -0.8805855512619019,
            "y": 0.02715892158448696,
            "z": -94.5776596069336
        },
        {
            "x": -0.8832851052284241,
            "y": 0.0301352608948946,
            "z": -94.42039489746094
        },
        {
            "x": -0.8857814073562622,
            "y": 0.03321311995387077,
            "z": -94.26292419433594
        },
        {
            "x": -0.8880736827850342,
            "y": 0.03637886419892311,
            "z": -94.10566711425781
        },
        {
            "x": -0.8901693820953369,
            "y": 0.03963455930352211,
            "z": -93.9483413696289
        },
        {
            "x": -0.892060399055481,
            "y": 0.04297725856304169,
            "z": -93.79102325439453
        },
        {
            "x": -0.8937535285949707,
            "y": 0.04640264809131622,
            "z": -93.6337661743164
        },
        {
            "x": -0.8952561020851135,
            "y": 0.049910981208086014,
            "z": -93.47631072998047
        },
        {
            "x": -0.8965670466423035,
            "y": 0.053489912301301956,
            "z": -93.31903076171875
        },
        {
            "x": -0.8976837992668152,
            "y": 0.05714165046811104,
            "z": -93.16178131103516
        },
        {
            "x": -0.8986026048660278,
            "y": 0.060866374522447586,
            "z": -93.00440979003906
        },
        {
            "x": -0.8993329405784607,
            "y": 0.0646534264087677,
            "z": -92.84715270996094
        },
        {
            "x": -0.8998664617538452,
            "y": 0.06850449740886688,
            "z": -92.68978118896484
        },
        {
            "x": -0.9001719355583191,
            "y": 0.07241542637348175,
            "z": -92.53239440917969
        },
        {
            "x": -0.9001544117927551,
            "y": 0.07638156414031982,
            "z": -92.37506103515625
        },
        {
            "x": -0.8999318480491638,
            "y": 0.07905471324920654,
            "z": -92.27014923095703
        },
        {
            "x": -0.8992247581481934,
            "y": 0.08310716599225998,
            "z": -92.11275482177734
        },
        {
            "x": -0.897995114326477,
            "y": 0.08720754086971283,
            "z": -91.95536804199219
        },
        {
            "x": -0.8962394595146179,
            "y": 0.09135684370994568,
            "z": -91.79779052734375
        },
        {
            "x": -0.893957257270813,
            "y": 0.09554104506969452,
            "z": -91.6404037475586
        },
        {
            "x": -0.8911462426185608,
            "y": 0.09976226836442947,
            "z": -91.4830093383789
        },
        {
            "x": -0.8877885341644287,
            "y": 0.10402083396911621,
            "z": -91.3255386352539
        },
        {
            "x": -0.8838917016983032,
            "y": 0.10830630362033844,
            "z": -91.16817474365234
        },
        {
            "x": -0.8794542551040649,
            "y": 0.11262072622776031,
            "z": -91.0107421875
        },
        {
            "x": -0.874464213848114,
            "y": 0.11695881187915802,
            "z": -90.85330963134766
        },
        {
            "x": -0.8689266443252563,
            "y": 0.12131468951702118,
            "z": -90.69599151611328
        },
        {
            "x": -0.8628445267677307,
            "y": 0.1256898194551468,
            "z": -90.53858184814453
        },
        {
            "x": -0.8562256097793579,
            "y": 0.1300744116306305,
            "z": -90.38133239746094
        },
        {
            "x": -0.8490583896636963,
            "y": 0.13446882367134094,
            "z": -90.22408294677734
        },
        {
            "x": -0.841301679611206,
            "y": 0.13887529075145721,
            "z": -90.06666564941406
        },
        {
            "x": -0.8330144882202148,
            "y": 0.1432785838842392,
            "z": -89.90947723388672
        },
        {
            "x": -0.8241762518882751,
            "y": 0.14768275618553162,
            "z": -89.75226593017578
        },
        {
            "x": -0.8147917985916138,
            "y": 0.1520831137895584,
            "z": -89.59506225585938
        },
        {
            "x": -0.8048473596572876,
            "y": 0.15647345781326294,
            "z": -89.4379653930664
        },
        {
            "x": -0.7943356037139893,
            "y": 0.1608584225177765,
            "z": -89.28071594238281
        },
        {
            "x": -0.7832942605018616,
            "y": 0.16522347927093506,
            "z": -89.12369537353516
        },
        {
            "x": -0.7717052102088928,
            "y": 0.16957038640975952,
            "z": -88.96672058105469
        },
        {
            "x": -0.7595393657684326,
            "y": 0.1738954782485962,
            "z": -88.80976867675781
        },
        {
            "x": -0.7468369007110596,
            "y": 0.17819583415985107,
            "z": -88.6528549194336
        },
        {
            "x": -0.7335859537124634,
            "y": 0.18247029185295105,
            "z": -88.49591064453125
        },
        {
            "x": -0.7197918891906738,
            "y": 0.18671360611915588,
            "z": -88.3389892578125
        },
        {
            "x": -0.705452561378479,
            "y": 0.19091735780239105,
            "z": -88.18222045898438
        },
        {
            "x": -0.6905664205551147,
            "y": 0.19508498907089233,
            "z": -88.02540588378906
        },
        {
            "x": -0.6751618385314941,
            "y": 0.199208065867424,
            "z": -87.86873626708984
        },
        {
            "x": -0.6592351198196411,
            "y": 0.20328563451766968,
            "z": -87.71212768554688
        },
        {
            "x": -0.6427356004714966,
            "y": 0.20731690526008606,
            "z": -87.55538177490234
        },
        {
            "x": -0.6257360577583313,
            "y": 0.21129070222377777,
            "z": -87.39889526367188
        },
        {
            "x": -0.6082197427749634,
            "y": 0.2152099609375,
            "z": -87.24242401123047
        },
        {
            "x": -0.5901907682418823,
            "y": 0.21907006204128265,
            "z": -87.08598327636719
        },
        {
            "x": -0.5716458559036255,
            "y": 0.22286349534988403,
            "z": -86.9296646118164
        },
        {
            "x": -0.5525778532028198,
            "y": 0.22659480571746826,
            "z": -86.77320098876953
        },
        {
            "x": -0.5330456495285034,
            "y": 0.2302515208721161,
            "z": -86.61701202392578
        },
        {
            "x": -0.5130244493484497,
            "y": 0.23383545875549316,
            "z": -86.46086883544922
        },
        {
            "x": -0.4924985468387604,
            "y": 0.23734205961227417,
            "z": -86.30470275878906
        },
        {
            "x": -0.47151923179626465,
            "y": 0.24076521396636963,
            "z": -86.1487045288086
        },
        {
            "x": -0.4500637352466583,
            "y": 0.244107186794281,
            "z": -85.99266815185547
        },
        {
            "x": -0.42815274000167847,
            "y": 0.2473621964454651,
            "z": -85.83668518066406
        },
        {
            "x": -0.4058026075363159,
            "y": 0.25052112340927124,
            "z": -85.6808853149414
        },
        {
            "x": -0.3906596899032593,
            "y": 0.25257477164268494,
            "z": -85.57703399658203
        },
        {
            "x": -0.3675996661186218,
            "y": 0.2555757761001587,
            "z": -85.42134857177734
        },
        {
            "x": -0.3441053330898285,
            "y": 0.2584737539291382,
            "z": -85.26570129394531
        },
        {
            "x": -0.32017016410827637,
            "y": 0.2612707018852234,
            "z": -85.10993957519531
        },
        {
            "x": -0.2958783209323883,
            "y": 0.26395732164382935,
            "z": -84.95442962646484
        },
        {
            "x": -0.27120476961135864,
            "y": 0.26653409004211426,
            "z": -84.79898834228516
        },
        {
            "x": -0.24613595008850098,
            "y": 0.26899534463882446,
            "z": -84.64350891113281
        },
        {
            "x": -0.22072100639343262,
            "y": 0.2713358998298645,
            "z": -84.48818969726562
        },
        {
            "x": -0.19494982063770294,
            "y": 0.27355754375457764,
            "z": -84.33283996582031
        },
        {
            "x": -0.1688469648361206,
            "y": 0.2756553888320923,
            "z": -84.17754364013672
        },
        {
            "x": -0.1424439549446106,
            "y": 0.27762049436569214,
            "z": -84.02241516113281
        },
        {
            "x": -0.1157175600528717,
            "y": 0.2794538140296936,
            "z": -83.86723327636719
        },
        {
            "x": -0.08872772008180618,
            "y": 0.2811517119407654,
            "z": -83.71221923828125
        },
        {
            "x": -0.06147129088640213,
            "y": 0.28271210193634033,
            "z": -83.55725860595703
        },
        {
            "x": -0.03392069414258003,
            "y": 0.28412914276123047,
            "z": -83.40214538574219
        },
        {
            "x": -0.006166815757751465,
            "y": 0.285396933555603,
            "z": -83.24728393554688
        },
        {
            "x": 0.021819382905960083,
            "y": 0.28651732206344604,
            "z": -83.0924072265625
        },
        {
            "x": 0.05000336468219757,
            "y": 0.2874864339828491,
            "z": -82.93756866455078
        },
        {
            "x": 0.07836511731147766,
            "y": 0.2882961630821228,
            "z": -82.78284454345703
        },
        {
            "x": 0.10693274438381195,
            "y": 0.2889450192451477,
            "z": -82.62794494628906
        },
        {
            "x": 0.13561150431632996,
            "y": 0.28943151235580444,
            "z": -82.4732894897461
        },
        {
            "x": 0.16441842913627625,
            "y": 0.28975293040275574,
            "z": -82.31867218017578
        },
        {
            "x": 0.19333431124687195,
            "y": 0.2897889018058777,
            "z": -82.16409301757812
        },
        {
            "x": 0.22234417498111725,
            "y": 0.2893443703651428,
            "z": -82.0095443725586
        },
        {
            "x": 0.25144195556640625,
            "y": 0.28842905163764954,
            "z": -81.85491943359375
        },
        {
            "x": 0.28059133887290955,
            "y": 0.28705233335494995,
            "z": -81.70030975341797
        },
        {
            "x": 0.30975380539894104,
            "y": 0.28521406650543213,
            "z": -81.54583740234375
        },
        {
            "x": 0.3389470875263214,
            "y": 0.28292012214660645,
            "z": -81.3912582397461
        },
        {
            "x": 0.36811184883117676,
            "y": 0.2801949381828308,
            "z": -81.23682403564453
        },
        {
            "x": 0.39724448323249817,
            "y": 0.2770455479621887,
            "z": -81.0823974609375
        },
        {
            "x": 0.42636871337890625,
            "y": 0.2734679579734802,
            "z": -80.92776489257812
        },
        {
            "x": 0.4553811550140381,
            "y": 0.2694777846336365,
            "z": -80.77334594726562
        },
        {
            "x": 0.48432058095932007,
            "y": 0.26508915424346924,
            "z": -80.6188735961914
        },
        {
            "x": 0.5131458640098572,
            "y": 0.2603135108947754,
            "z": -80.46440124511719
        },
        {
            "x": 0.5418255925178528,
            "y": 0.25515443086624146,
            "z": -80.30998992919922
        },
        {
            "x": 0.5703860521316528,
            "y": 0.24960707128047943,
            "z": -80.15535736083984
        },
        {
            "x": 0.5987357497215271,
            "y": 0.24370673298835754,
            "z": -80.00093078613281
        },
        {
            "x": 0.626896321773529,
            "y": 0.2374553084373474,
            "z": -79.84648895263672
        },
        {
            "x": 0.6548632383346558,
            "y": 0.2308521568775177,
            "z": -79.69192504882812
        },
        {
            "x": 0.6825692057609558,
            "y": 0.22390922904014587,
            "z": -79.53746032714844
        },
        {
            "x": 0.7100425958633423,
            "y": 0.21663710474967957,
            "z": -79.38285827636719
        },
        {
            "x": 0.7372469305992126,
            "y": 0.209049791097641,
            "z": -79.2282485961914
        },
        {
            "x": 0.7641403675079346,
            "y": 0.2011575698852539,
            "z": -79.07371520996094
        },
        {
            "x": 0.7818881273269653,
            "y": 0.19572046399116516,
            "z": -78.9706802368164
        },
        {
            "x": 0.8082550764083862,
            "y": 0.1873304843902588,
            "z": -78.81607055664062
        },
        {
            "x": 0.8342776298522949,
            "y": 0.17865639925003052,
            "z": -78.66146087646484
        },
        {
            "x": 0.8599703311920166,
            "y": 0.1696847379207611,
            "z": -78.50660705566406
        },
        {
            "x": 0.885256826877594,
            "y": 0.16045935451984406,
            "z": -78.3519058227539
        },
        {
            "x": 0.9101506471633911,
            "y": 0.1509784460067749,
            "z": -78.19718170166016
        },
        {
            "x": 0.9346539378166199,
            "y": 0.14124199748039246,
            "z": -78.04228973388672
        },
        {
            "x": 0.9587005376815796,
            "y": 0.1312623918056488,
            "z": -77.88746643066406
        },
        {
            "x": 0.9823217391967773,
            "y": 0.12104687839746475,
            "z": -77.73250579833984
        },
        {
            "x": 1.0054912567138672,
            "y": 0.11061014235019684,
            "z": -77.57750701904297
        },
        {
            "x": 1.028176188468933,
            "y": 0.09996746480464935,
            "z": -77.42255401611328
        },
        {
            "x": 1.0503703355789185,
            "y": 0.08910384774208069,
            "z": -77.26744079589844
        },
        {
            "x": 1.072050929069519,
            "y": 0.07805261760950089,
            "z": -77.11238861083984
        },
        {
            "x": 1.093225121498108,
            "y": 0.06681472063064575,
            "z": -76.95728302001953
        },
        {
            "x": 1.113906741142273,
            "y": 0.05538482964038849,
            "z": -76.80192565917969
        },
        {
            "x": 1.1340004205703735,
            "y": 0.04379454255104065,
            "z": -76.64672088623047
        },
        {
            "x": 1.1535475254058838,
            "y": 0.032038331031799316,
            "z": -76.49140167236328
        },
        {
            "x": 1.1725373268127441,
            "y": 0.02013082429766655,
            "z": -76.33604431152344
        },
        {
            "x": 1.1909596920013428,
            "y": 0.008084656670689583,
            "z": -76.1806869506836
        },
        {
            "x": 1.2088063955307007,
            "y": -0.004115553572773933,
            "z": -76.02505493164062
        },
        {
            "x": 1.2260262966156006,
            "y": -0.01642739772796631,
            "z": -75.86958312988281
        },
        {
            "x": 1.2426527738571167,
            "y": -0.028855111449956894,
            "z": -75.71407318115234
        },
        {
            "x": 1.258679986000061,
            "y": -0.041390661150217056,
            "z": -75.55851745605469
        },
        {
            "x": 1.2740793228149414,
            "y": -0.05402740463614464,
            "z": -75.40289306640625
        },
        {
            "x": 1.2888455390930176,
            "y": -0.0667649507522583,
            "z": -75.24713134765625
        },
        {
            "x": 1.302991509437561,
            "y": -0.07958406209945679,
            "z": -75.09130859375
        },
        {
            "x": 1.3164974451065063,
            "y": -0.09246756136417389,
            "z": -74.93553161621094
        },
        {
            "x": 1.3293637037277222,
            "y": -0.10542471706867218,
            "z": -74.77962493896484
        },
        {
            "x": 1.3415507078170776,
            "y": -0.11842996627092361,
            "z": -74.623779296875
        },
        {
            "x": 1.3530932664871216,
            "y": -0.13148055970668793,
            "z": -74.46788024902344
        },
        {
            "x": 1.3639999628067017,
            "y": -0.14458639919757843,
            "z": -74.31173706054688
        },
        {
            "x": 1.374229073524475,
            "y": -0.15770438313484192,
            "z": -74.15575408935547
        },
        {
            "x": 1.3837705850601196,
            "y": -0.17084725201129913,
            "z": -73.99967956542969
        },
        {
            "x": 1.392656683921814,
            "y": -0.18400147557258606,
            "z": -73.84358215332031
        },
        {
            "x": 1.4008738994598389,
            "y": -0.19715306162834167,
            "z": -73.68749237060547
        },
        {
            "x": 1.4084303379058838,
            "y": -0.21031531691551208,
            "z": -73.53117370605469
        },
        {
            "x": 1.4152872562408447,
            "y": -0.22344452142715454,
            "z": -73.3750228881836
        },
        {
            "x": 1.4214744567871094,
            "y": -0.23654893040657043,
            "z": -73.2188491821289
        },
        {
            "x": 1.4269928932189941,
            "y": -0.2496301829814911,
            "z": -73.0625228881836
        },
        {
            "x": 1.43184232711792,
            "y": -0.26265954971313477,
            "z": -72.90628814697266
        },
        {
            "x": 1.436004638671875,
            "y": -0.2756454050540924,
            "z": -72.74993133544922
        },
        {
            "x": 1.43948495388031,
            "y": -0.2885708808898926,
            "z": -72.59355163574219
        },
        {
            "x": 1.4422972202301025,
            "y": -0.3014190196990967,
            "z": -72.43724822998047
        },
        {
            "x": 1.4437917470932007,
            "y": -0.3099423050880432,
            "z": -72.33303833007812
        },
        {
            "x": 1.4454771280288696,
            "y": -0.32265403866767883,
            "z": -72.17670440673828
        },
        {
            "x": 1.4464963674545288,
            "y": -0.3352736532688141,
            "z": -72.0203628540039
        },
        {
            "x": 1.446860671043396,
            "y": -0.3478083908557892,
            "z": -71.86380767822266
        },
        {
            "x": 1.4465564489364624,
            "y": -0.3602139949798584,
            "z": -71.70744323730469
        },
        {
            "x": 1.4455677270889282,
            "y": -0.3724978268146515,
            "z": -71.55106353759766
        },
        {
            "x": 1.4439115524291992,
            "y": -0.38466137647628784,
            "z": -71.39459991455078
        },
        {
            "x": 1.4415770769119263,
            "y": -0.39667922258377075,
            "z": -71.23822021484375
        },
        {
            "x": 1.4385298490524292,
            "y": -0.40855616331100464,
            "z": -71.08177185058594
        },
        {
            "x": 1.4347599744796753,
            "y": -0.4202723503112793,
            "z": -70.92533111572266
        },
        {
            "x": 1.4302773475646973,
            "y": -0.4318173825740814,
            "z": -70.7690200805664
        },
        {
            "x": 1.4250558614730835,
            "y": -0.44319796562194824,
            "z": -70.61257934570312
        },
        {
            "x": 1.4190891981124878,
            "y": -0.4543866515159607,
            "z": -70.45629119873047
        },
        {
            "x": 1.412343978881836,
            "y": -0.46537721157073975,
            "z": -70.30004119873047
        },
        {
            "x": 1.4048116207122803,
            "y": -0.47618162631988525,
            "z": -70.14360809326172
        },
        {
            "x": 1.396500587463379,
            "y": -0.4867638647556305,
            "z": -69.9874038696289
        },
        {
            "x": 1.3873897790908813,
            "y": -0.49713099002838135,
            "z": -69.83120727539062
        },
        {
            "x": 1.377432107925415,
            "y": -0.5072625875473022,
            "z": -69.67504119873047
        },
        {
            "x": 1.366644263267517,
            "y": -0.517155110836029,
            "z": -69.51898193359375
        },
        {
            "x": 1.354995846748352,
            "y": -0.5268152952194214,
            "z": -69.3627700805664
        },
        {
            "x": 1.3425027132034302,
            "y": -0.5362104773521423,
            "z": -69.20682525634766
        },
        {
            "x": 1.3291035890579224,
            "y": -0.5453314781188965,
            "z": -69.05094909667969
        },
        {
            "x": 1.3148118257522583,
            "y": -0.5541813373565674,
            "z": -68.89514923095703
        },
        {
            "x": 1.2996125221252441,
            "y": -0.5627511143684387,
            "z": -68.73943328857422
        },
        {
            "x": 1.283482313156128,
            "y": -0.571037769317627,
            "z": -68.58369445800781
        },
        {
            "x": 1.2663735151290894,
            "y": -0.5790141820907593,
            "z": -68.42807006835938
        },
        {
            "x": 1.2483150959014893,
            "y": -0.586676836013794,
            "z": -68.27265167236328
        },
        {
            "x": 1.2292739152908325,
            "y": -0.5940298438072205,
            "z": -68.11721801757812
        },
        {
            "x": 1.2092604637145996,
            "y": -0.6010540723800659,
            "z": -67.96202850341797
        },
        {
            "x": 1.1881994009017944,
            "y": -0.6077327728271484,
            "z": -67.80697631835938
        },
        {
            "x": 1.1660773754119873,
            "y": -0.61407470703125,
            "z": -67.65186309814453
        },
        {
            "x": 1.1429452896118164,
            "y": -0.6200582981109619,
            "z": -67.4970932006836
        },
        {
            "x": 1.1187567710876465,
            "y": -0.6256852149963379,
            "z": -67.34243774414062
        },
        {
            "x": 1.0934511423110962,
            "y": -0.6309317350387573,
            "z": -67.18795776367188
        },
        {
            "x": 1.0670487880706787,
            "y": -0.6357948780059814,
            "z": -67.03370666503906
        },
        {
            "x": 1.0395076274871826,
            "y": -0.6402791738510132,
            "z": -66.87947845458984
        },
        {
            "x": 1.0108798742294312,
            "y": -0.6443649530410767,
            "z": -66.72563171386719
        },
        {
            "x": 0.9810771346092224,
            "y": -0.6480363607406616,
            "z": -66.57201385498047
        },
        {
            "x": 0.9500761032104492,
            "y": -0.6512932181358337,
            "z": -66.41852569580078
        },
        {
            "x": 0.9179290533065796,
            "y": -0.6541388630867004,
            "z": -66.26539611816406
        },
        {
            "x": 0.8845818638801575,
            "y": -0.6566736102104187,
            "z": -66.11241912841797
        },
        {
            "x": 0.8499882817268372,
            "y": -0.6589295864105225,
            "z": -65.9597396850586
        },
        {
            "x": 0.814181387424469,
            "y": -0.660902738571167,
            "z": -65.80742645263672
        },
        {
            "x": 0.7896520495414734,
            "y": -0.6620661020278931,
            "z": -65.7060775756836
        },
        {
            "x": 0.7517861723899841,
            "y": -0.6635628342628479,
            "z": -65.55428314208984
        },
        {
            "x": 0.7126441597938538,
            "y": -0.6647617816925049,
            "z": -65.40282440185547
        },
        {
            "x": 0.6721979379653931,
            "y": -0.6656646728515625,
            "z": -65.25151824951172
        },
        {
            "x": 0.6305292248725891,
            "y": -0.6662632822990417,
            "z": -65.10076141357422
        },
        {
            "x": 0.5875530242919922,
            "y": -0.6665449738502502,
            "z": -64.95037841796875
        },
        {
            "x": 0.5432430505752563,
            "y": -0.6665055155754089,
            "z": -64.80028533935547
        },
        {
            "x": 0.4976777136325836,
            "y": -0.6661534309387207,
            "z": -64.65067291259766
        },
        {
            "x": 0.4507890045642853,
            "y": -0.6654933094978333,
            "z": -64.5013656616211
        },
        {
            "x": 0.40257763862609863,
            "y": -0.6645239591598511,
            "z": -64.3525161743164
        },
        {
            "x": 0.3530885577201843,
            "y": -0.6632522940635681,
            "z": -64.20418548583984
        },
        {
            "x": 0.30225473642349243,
            "y": -0.6616891026496887,
            "z": -64.05616760253906
        },
        {
            "x": 0.2501882314682007,
            "y": -0.6598433256149292,
            "z": -63.90873718261719
        },
        {
            "x": 0.19683372974395752,
            "y": -0.6577130556106567,
            "z": -63.76176071166992
        },
        {
            "x": 0.1420932114124298,
            "y": -0.6552994251251221,
            "z": -63.61506271362305
        },
        {
            "x": 0.08619428426027298,
            "y": -0.6526223421096802,
            "z": -63.469024658203125
        },
        {
            "x": 0.02903904765844345,
            "y": -0.6496833562850952,
            "z": -63.32339859008789
        },
        {
            "x": -0.029336534440517426,
            "y": -0.6464844346046448,
            "z": -63.178279876708984
        },
        {
            "x": -0.0889132171869278,
            "y": -0.6430293917655945,
            "z": -63.033660888671875
        },
        {
            "x": -0.14970697462558746,
            "y": -0.6393266916275024,
            "z": -62.88934326171875
        },
        {
            "x": -0.21154402196407318,
            "y": -0.6353904604911804,
            "z": -62.745635986328125
        },
        {
            "x": -0.2744605541229248,
            "y": -0.6312181949615479,
            "z": -62.60240173339844
        },
        {
            "x": -0.33845028281211853,
            "y": -0.6268122792243958,
            "z": -62.45960998535156
        },
        {
            "x": -0.4034048616886139,
            "y": -0.622185468673706,
            "z": -62.31721878051758
        },
        {
            "x": -0.4693249762058258,
            "y": -0.6173403263092041,
            "z": -62.175132751464844
        },
        {
            "x": -0.5361188650131226,
            "y": -0.6122816205024719,
            "z": -62.03340530395508
        },
        {
            "x": -0.6036770343780518,
            "y": -0.607014536857605,
            "z": -61.89210891723633
        },
        {
            "x": -0.6720019578933716,
            "y": -0.6015442609786987,
            "z": -61.750999450683594
        },
        {
            "x": -0.7409005165100098,
            "y": -0.5958834290504456,
            "z": -61.610225677490234
        },
        {
            "x": -0.8103466629981995,
            "y": -0.5900310277938843,
            "z": -61.46965408325195
        },
        {
            "x": -0.8803408741950989,
            "y": -0.5839800834655762,
            "z": -61.32905197143555
        },
        {
            "x": -0.9505738019943237,
            "y": -0.5777574777603149,
            "z": -61.1887092590332
        },
        {
            "x": -1.0210490226745605,
            "y": -0.5713582634925842,
            "z": -61.04833221435547
        },
        {
            "x": -1.091619610786438,
            "y": -0.5647879838943481,
            "z": -60.907894134521484
        },
        {
            "x": -1.1621125936508179,
            "y": -0.5580480098724365,
            "z": -60.76736068725586
        },
        {
            "x": -1.2325111627578735,
            "y": -0.5511395335197449,
            "z": -60.62644958496094
        },
        {
            "x": -1.3024712800979614,
            "y": -0.544084370136261,
            "z": -60.485416412353516
        },
        {
            "x": -1.3719154596328735,
            "y": -0.5368786454200745,
            "z": -60.34400177001953
        },
        {
            "x": -1.4407002925872803,
            "y": -0.5295147895812988,
            "z": -60.201988220214844
        },
        {
            "x": -1.5085530281066895,
            "y": -0.5220165252685547,
            "z": -60.05951690673828
        },
        {
            "x": -1.5753835439682007,
            "y": -0.5143776535987854,
            "z": -59.91627883911133
        },
        {
            "x": -1.6409331560134888,
            "y": -0.5066094398498535,
            "z": -59.77231216430664
        },
        {
            "x": -1.7048726081848145,
            "y": -0.4987165927886963,
            "z": -59.62755584716797
        },
        {
            "x": -1.7465684413909912,
            "y": -0.49338966608047485,
            "z": -59.530555725097656
        },
        {
            "x": -1.807555079460144,
            "y": -0.485307514667511,
            "z": -59.38426971435547
        },
        {
            "x": -1.8663346767425537,
            "y": -0.47711658477783203,
            "z": -59.2369499206543
        },
        {
            "x": -1.9229309558868408,
            "y": -0.468835711479187,
            "z": -59.088783264160156
        },
        {
            "x": -1.977682113647461,
            "y": -0.4605022668838501,
            "z": -58.9405632019043
        },
        {
            "x": -2.031106948852539,
            "y": -0.45209580659866333,
            "z": -58.7919807434082
        },
        {
            "x": -2.083277940750122,
            "y": -0.4436091482639313,
            "z": -58.64286422729492
        },
        {
            "x": -2.1341989040374756,
            "y": -0.4350631535053253,
            "z": -58.49346923828125
        },
        {
            "x": -2.183983325958252,
            "y": -0.4264522194862366,
            "z": -58.34360122680664
        },
        {
            "x": -2.2326302528381348,
            "y": -0.41778838634490967,
            "z": -58.19340515136719
        },
        {
            "x": -2.2801077365875244,
            "y": -0.40908050537109375,
            "z": -58.042964935302734
        },
        {
            "x": -2.3265345096588135,
            "y": -0.4003225862979889,
            "z": -57.892086029052734
        },
        {
            "x": -2.371875047683716,
            "y": -0.3915358781814575,
            "z": -57.74102783203125
        },
        {
            "x": -2.4161930084228516,
            "y": -0.38271844387054443,
            "z": -57.58969497680664
        },
        {
            "x": -2.459541082382202,
            "y": -0.37386322021484375,
            "z": -57.43788146972656
        },
        {
            "x": -2.501845121383667,
            "y": -0.36499929428100586,
            "z": -57.28599166870117
        },
        {
            "x": -2.5432069301605225,
            "y": -0.35611891746520996,
            "z": -57.13380813598633
        },
        {
            "x": -2.583630084991455,
            "y": -0.3472297191619873,
            "z": -56.981380462646484
        },
        {
            "x": -2.623094081878662,
            "y": -0.33834126591682434,
            "z": -56.82878875732422
        },
        {
            "x": -2.6616926193237305,
            "y": -0.32944345474243164,
            "z": -56.675758361816406
        },
        {
            "x": -2.6993556022644043,
            "y": -0.32056570053100586,
            "z": -56.522727966308594
        },
        {
            "x": -2.7361514568328857,
            "y": -0.3116866946220398,
            "z": -56.36949920654297
        },
        {
            "x": -2.7720654010772705,
            "y": -0.30267924070358276,
            "z": -56.216068267822266
        },
        {
            "x": -2.807117462158203,
            "y": -0.2935263514518738,
            "z": -56.06245422363281
        },
        {
            "x": -2.8413631916046143,
            "y": -0.2842342257499695,
            "z": -55.9085807800293
        },
        {
            "x": -2.874788522720337,
            "y": -0.27481600642204285,
            "z": -55.75453186035156
        },
        {
            "x": -2.907366991043091,
            "y": -0.26528528332710266,
            "z": -55.60041427612305
        },
        {
            "x": -2.9391512870788574,
            "y": -0.2556353211402893,
            "z": -55.446048736572266
        },
        {
            "x": -2.970120906829834,
            "y": -0.24589130282402039,
            "z": -55.291629791259766
        },
        {
            "x": -3.0003106594085693,
            "y": -0.23605509102344513,
            "z": -55.1370849609375
        },
        {
            "x": -3.02976655960083,
            "y": -0.22612017393112183,
            "z": -54.98219299316406
        },
        {
            "x": -3.0583865642547607,
            "y": -0.21611890196800232,
            "z": -54.827354431152344
        },
        {
            "x": -3.0862677097320557,
            "y": -0.20604641735553741,
            "z": -54.6723518371582
        },
        {
            "x": -3.113405227661133,
            "y": -0.19591321051120758,
            "z": -54.5172004699707
        },
        {
            "x": -3.1397833824157715,
            "y": -0.18573200702667236,
            "z": -54.36200714111328
        },
        {
            "x": -3.165438175201416,
            "y": -0.17549189925193787,
            "z": -54.20647430419922
        },
        {
            "x": -3.1903250217437744,
            "y": -0.16523024439811707,
            "z": -54.05104446411133
        },
        {
            "x": -3.214498996734619,
            "y": -0.15494120121002197,
            "z": -53.895503997802734
        },
        {
            "x": -3.237969398498535,
            "y": -0.1446249783039093,
            "z": -53.73973846435547
        },
        {
            "x": -3.260676622390747,
            "y": -0.13430586457252502,
            "z": -53.583988189697266
        },
        {
            "x": -3.2826972007751465,
            "y": -0.12397676706314087,
            "z": -53.42803955078125
        },
        {
            "x": -3.304011583328247,
            "y": -0.11365392059087753,
            "z": -53.271995544433594
        },
        {
            "x": -3.324618339538574,
            "y": -0.10334575176239014,
            "z": -53.115943908691406
        },
        {
            "x": -3.337937116622925,
            "y": -0.09609320759773254,
            "z": -53.011871337890625
        },
        {
            "x": -3.357360363006592,
            "y": -0.08419308066368103,
            "z": -52.85576248168945
        },
        {
            "x": -3.3760733604431152,
            "y": -0.07110239565372467,
            "z": -52.699676513671875
        },
        {
            "x": -3.394096851348877,
            "y": -0.05686023831367493,
            "z": -52.54340744018555
        },
        {
            "x": -3.4113900661468506,
            "y": -0.04162603244185448,
            "z": -52.387351989746094
        },
        {
            "x": -3.428001642227173,
            "y": -0.025489546358585358,
            "z": -52.231327056884766
        },
        {
            "x": -3.4439339637756348,
            "y": -0.0085291787981987,
            "z": -52.0752067565918
        },
        {
            "x": -3.45916748046875,
            "y": 0.00915435329079628,
            "z": -51.919212341308594
        },
        {
            "x": -3.473708152770996,
            "y": 0.027486786246299744,
            "z": -51.763126373291016
        },
        {
            "x": -3.4875833988189697,
            "y": 0.046349093317985535,
            "z": -51.607051849365234
        },
        {
            "x": -3.5007686614990234,
            "y": 0.06563957035541534,
            "z": -51.4510612487793
        },
        {
            "x": -3.5133001804351807,
            "y": 0.08529603481292725,
            "z": -51.29495620727539
        },
        {
            "x": -3.52512264251709,
            "y": 0.10520245134830475,
            "z": -51.13895034790039
        },
        {
            "x": -3.536285877227783,
            "y": 0.12527289986610413,
            "z": -50.98290252685547
        },
        {
            "x": -3.546795129776001,
            "y": 0.1454390585422516,
            "z": -50.826637268066406
        },
        {
            "x": -3.5566318035125732,
            "y": 0.16556578874588013,
            "z": -50.67051315307617
        },
        {
            "x": -3.5657851696014404,
            "y": 0.1855834424495697,
            "z": -50.514305114746094
        },
        {
            "x": -3.574270009994507,
            "y": 0.20539899170398712,
            "z": -50.35801315307617
        },
        {
            "x": -3.5820963382720947,
            "y": 0.22491422295570374,
            "z": -50.20170974731445
        },
        {
            "x": -3.5892646312713623,
            "y": 0.2440718114376068,
            "z": -50.04512023925781
        },
        {
            "x": -3.595754384994507,
            "y": 0.26271873712539673,
            "z": -49.888648986816406
        },
        {
            "x": -3.601559638977051,
            "y": 0.2807823419570923,
            "z": -49.732086181640625
        },
        {
            "x": -3.606703281402588,
            "y": 0.29818516969680786,
            "z": -49.575408935546875
        },
        {
            "x": -3.6111838817596436,
            "y": 0.31483274698257446,
            "z": -49.41865158081055
        },
        {
            "x": -3.6149868965148926,
            "y": 0.33063632249832153,
            "z": -49.26167678833008
        },
        {
            "x": -3.6181018352508545,
            "y": 0.34545981884002686,
            "z": -49.104583740234375
        },
        {
            "x": -3.620534896850586,
            "y": 0.3592343330383301,
            "z": -48.947486877441406
        },
        {
            "x": -3.6222991943359375,
            "y": 0.37188541889190674,
            "z": -48.7901725769043
        },
        {
            "x": -3.623375654220581,
            "y": 0.3832998275756836,
            "z": -48.63285446166992
        },
        {
            "x": -3.623631477355957,
            "y": 0.39333802461624146,
            "z": -48.47526931762695
        },
        {
            "x": -3.6228063106536865,
            "y": 0.4019763469696045,
            "z": -48.31716537475586
        },
        {
            "x": -3.620624303817749,
            "y": 0.4090903103351593,
            "z": -48.15908432006836
        },
        {
            "x": -3.617022752761841,
            "y": 0.41473495960235596,
            "z": -48.0008544921875
        },
        {
            "x": -3.6118452548980713,
            "y": 0.41964977979660034,
            "z": -47.84260559082031
        },
        {
            "x": -3.6051392555236816,
            "y": 0.42333459854125977,
            "z": -47.68440246582031
        },
        {
            "x": -3.596811294555664,
            "y": 0.4257720410823822,
            "z": -47.52599334716797
        },
        {
            "x": -3.5868611335754395,
            "y": 0.42703622579574585,
            "z": -47.36784744262695
        },
        {
            "x": -3.5751419067382812,
            "y": 0.4271683692932129,
            "z": -47.20976257324219
        },
        {
            "x": -3.5616538524627686,
            "y": 0.4262951910495758,
            "z": -47.05167770385742
        },
        {
            "x": -3.5463993549346924,
            "y": 0.42450574040412903,
            "z": -46.89383316040039
        },
        {
            "x": -3.5293233394622803,
            "y": 0.4218798577785492,
            "z": -46.736061096191406
        },
        {
            "x": -3.5103118419647217,
            "y": 0.4184727072715759,
            "z": -46.5784912109375
        },
        {
            "x": -3.489424228668213,
            "y": 0.4143996238708496,
            "z": -46.42125701904297
        },
        {
            "x": -3.474485158920288,
            "y": 0.41136685013771057,
            "z": -46.31657409667969
        },
        {
            "x": -3.4504005908966064,
            "y": 0.40636077523231506,
            "z": -46.159812927246094
        },
        {
            "x": -3.424407482147217,
            "y": 0.4009111523628235,
            "z": -46.00336837768555
        },
        {
            "x": -3.3965048789978027,
            "y": 0.3950973153114319,
            "z": -45.84707260131836
        },
        {
            "x": -3.366786241531372,
            "y": 0.38901516795158386,
            "z": -45.69133758544922
        },
        {
            "x": -3.3351998329162598,
            "y": 0.38273486495018005,
            "z": -45.536014556884766
        },
        {
            "x": -3.30181884765625,
            "y": 0.37634164094924927,
            "z": -45.38100814819336
        },
        {
            "x": -3.266789674758911,
            "y": 0.3699272871017456,
            "z": -45.226531982421875
        },
        {
            "x": -3.2301511764526367,
            "y": 0.3635631799697876,
            "z": -45.072391510009766
        },
        {
            "x": -3.191988945007324,
            "y": 0.3573402762413025,
            "z": -44.91870880126953
        },
        {
            "x": -3.152482748031616,
            "y": 0.3513438105583191,
            "z": -44.76556396484375
        },
        {
            "x": -3.1117324829101562,
            "y": 0.34564173221588135,
            "z": -44.61271286010742
        },
        {
            "x": -3.069941997528076,
            "y": 0.34032177925109863,
            "z": -44.46036911010742
        },
        {
            "x": -3.0272064208984375,
            "y": 0.335472971200943,
            "z": -44.308406829833984
        },
        {
            "x": -2.9836628437042236,
            "y": 0.3311694264411926,
            "z": -44.156585693359375
        },
        {
            "x": -2.939603090286255,
            "y": 0.3274911642074585,
            "z": -44.005252838134766
        },
        {
            "x": -2.8951289653778076,
            "y": 0.3245095908641815,
            "z": -43.85410690307617
        },
        {
            "x": -2.8504111766815186,
            "y": 0.32232871651649475,
            "z": -43.70315933227539
        },
        {
            "x": -2.8056585788726807,
            "y": 0.3210287392139435,
            "z": -43.55241775512695
        },
        {
            "x": -2.760960102081299,
            "y": 0.3206711411476135,
            "z": -43.40157699584961
        },
        {
            "x": -2.7165839672088623,
            "y": 0.32133665680885315,
            "z": -43.25099563598633
        },
        {
            "x": -2.6726393699645996,
            "y": 0.3231341540813446,
            "z": -43.10042190551758
        },
        {
            "x": -2.629269599914551,
            "y": 0.32613199949264526,
            "z": -42.949806213378906
        },
        {
            "x": -2.5865845680236816,
            "y": 0.32973676919937134,
            "z": -42.79913330078125
        },
        {
            "x": -2.544671058654785,
            "y": 0.333260178565979,
            "z": -42.64824295043945
        },
        {
            "x": -2.503667116165161,
            "y": 0.3366783857345581,
            "z": -42.4971809387207
        },
        {
            "x": -2.4637012481689453,
            "y": 0.33998537063598633,
            "z": -42.346012115478516
        },
        {
            "x": -2.4247641563415527,
            "y": 0.3431854248046875,
            "z": -42.194522857666016
        },
        {
            "x": -2.3869824409484863,
            "y": 0.34627121686935425,
            "z": -42.042911529541016
        },
        {
            "x": -2.350398302078247,
            "y": 0.349239706993103,
            "z": -41.89104080200195
        },
        {
            "x": -2.315025568008423,
            "y": 0.35208994150161743,
            "z": -41.738712310791016
        },
        {
            "x": -2.280956983566284,
            "y": 0.35481494665145874,
            "z": -41.58632278442383
        },
        {
            "x": -2.248152732849121,
            "y": 0.3574163317680359,
            "z": -41.43360137939453
        },
        {
            "x": -2.216662883758545,
            "y": 0.35988739132881165,
            "z": -41.280609130859375
        },
        {
            "x": -2.1865220069885254,
            "y": 0.3622218370437622,
            "z": -41.12742233276367
        },
        {
            "x": -2.157655954360962,
            "y": 0.3644241988658905,
            "z": -40.973777770996094
        },
        {
            "x": -2.1301302909851074,
            "y": 0.3664856553077698,
            "z": -40.82008361816406
        },
        {
            "x": -2.1039059162139893,
            "y": 0.3684034049510956,
            "z": -40.6661491394043
        },
        {
            "x": -2.0790016651153564,
            "y": 0.37017208337783813,
            "z": -40.51188278198242
        },
        {
            "x": -2.0553650856018066,
            "y": 0.37179136276245117,
            "z": -40.35749435424805
        },
        {
            "x": -2.032972812652588,
            "y": 0.37325963377952576,
            "z": -40.20281982421875
        },
        {
            "x": -2.0118117332458496,
            "y": 0.3745705485343933,
            "z": -40.04792785644531
        },
        {
            "x": -1.991920828819275,
            "y": 0.37571585178375244,
            "z": -39.892974853515625
        },
        {
            "x": -1.9792965650558472,
            "y": 0.3763912320137024,
            "z": -39.78956604003906
        },
        {
            "x": -1.9613513946533203,
            "y": 0.37726497650146484,
            "z": -39.634334564208984
        },
        {
            "x": -1.944568395614624,
            "y": 0.37796515226364136,
            "z": -39.47894287109375
        },
        {
            "x": -1.9288804531097412,
            "y": 0.3784946799278259,
            "z": -39.32319259643555
        },
        {
            "x": -1.9142460823059082,
            "y": 0.378848671913147,
            "z": -39.16747283935547
        },
        {
            "x": -1.9005564451217651,
            "y": 0.379023015499115,
            "z": -39.01169204711914
        },
        {
            "x": -1.8880891799926758,
            "y": 0.3790091276168823,
            "z": -38.8558464050293
        },
        {
            "x": -1.8768161535263062,
            "y": 0.378814697265625,
            "z": -38.70005798339844
        },
        {
            "x": -1.8668664693832397,
            "y": 0.3784431219100952,
            "z": -38.54421615600586
        },
        {
            "x": -1.8584043979644775,
            "y": 0.3778964877128601,
            "z": -38.388397216796875
        },
        {
            "x": -1.8516199588775635,
            "y": 0.37717318534851074,
            "z": -38.232704162597656
        },
        {
            "x": -1.8465514183044434,
            "y": 0.3762829899787903,
            "z": -38.07693099975586
        },
        {
            "x": -1.8432985544204712,
            "y": 0.37523072957992554,
            "z": -37.921287536621094
        },
        {
            "x": -1.8419315814971924,
            "y": 0.3740180730819702,
            "z": -37.76566696166992
        },
        {
            "x": -1.8425692319869995,
            "y": 0.37264078855514526,
            "z": -37.609886169433594
        },
        {
            "x": -1.845154047012329,
            "y": 0.3711127042770386,
            "z": -37.45432662963867
        },
        {
            "x": -1.8496818542480469,
            "y": 0.3694348931312561,
            "z": -37.29875564575195
        },
        {
            "x": -1.8561495542526245,
            "y": 0.3676106333732605,
            "z": -37.14323425292969
        },
        {
            "x": -1.864592432975769,
            "y": 0.3656380772590637,
            "z": -36.987831115722656
        },
        {
            "x": -1.8748950958251953,
            "y": 0.36352330446243286,
            "z": -36.83230209350586
        },
        {
            "x": -1.8869765996932983,
            "y": 0.36127567291259766,
            "z": -36.67705535888672
        },
        {
            "x": -1.9007878303527832,
            "y": 0.3588949739933014,
            "z": -36.52189636230469
        },
        {
            "x": -1.9163299798965454,
            "y": 0.3563787341117859,
            "z": -36.3668327331543
        },
        {
            "x": -1.933451533317566,
            "y": 0.3537367284297943,
            "z": -36.21187973022461
        },
        {
            "x": -1.9520881175994873,
            "y": 0.350970059633255,
            "z": -36.05694580078125
        },
        {
            "x": -1.9721572399139404,
            "y": 0.34808361530303955,
            "z": -35.902130126953125
        },
        {
            "x": -1.9936362504959106,
            "y": 0.34507685899734497,
            "z": -35.747535705566406
        },
        {
            "x": -2.0164082050323486,
            "y": 0.3419552445411682,
            "z": -35.59296417236328
        },
        {
            "x": -2.0403757095336914,
            "y": 0.3387255370616913,
            "z": -35.43863296508789
        },
        {
            "x": -2.0654852390289307,
            "y": 0.3353891968727112,
            "z": -35.284420013427734
        },
        {
            "x": -2.0917584896087646,
            "y": 0.3319401144981384,
            "z": -35.130149841308594
        },
        {
            "x": -2.1190133094787598,
            "y": 0.32839515805244446,
            "z": -34.9762077331543
        },
        {
            "x": -2.1472387313842773,
            "y": 0.3247515559196472,
            "z": -34.822330474853516
        },
        {
            "x": -2.1763644218444824,
            "y": 0.3210142254829407,
            "z": -34.66858673095703
        },
        {
            "x": -2.2063727378845215,
            "y": 0.3171834647655487,
            "z": -34.5150260925293
        },
        {
            "x": -2.2372255325317383,
            "y": 0.31325966119766235,
            "z": -34.36138916015625
        },
        {
            "x": -2.268794536590576,
            "y": 0.30925673246383667,
            "z": -34.208072662353516
        },
        {
            "x": -2.301084518432617,
            "y": 0.3051726818084717,
            "z": -34.054866790771484
        },
        {
            "x": -2.334101676940918,
            "y": 0.30100443959236145,
            "z": -33.90167236328125
        },
        {
            "x": -2.3677377700805664,
            "y": 0.29676371812820435,
            "z": -33.74869918823242
        },
        {
            "x": -2.4019980430603027,
            "y": 0.29244861006736755,
            "z": -33.595726013183594
        },
        {
            "x": -2.4368298053741455,
            "y": 0.2880652844905853,
            "z": -33.442874908447266
        },
        {
            "x": -2.4722037315368652,
            "y": 0.28361666202545166,
            "z": -33.29021453857422
        },
        {
            "x": -2.4960756301879883,
            "y": 0.2806158661842346,
            "z": -33.1884880065918
        },
        {
            "x": -2.532278537750244,
            "y": 0.2760629653930664,
            "z": -33.03588104248047
        },
        {
            "x": -2.5687308311462402,
            "y": 0.27143776416778564,
            "z": -32.88288879394531
        },
        {
            "x": -2.6049747467041016,
            "y": 0.2667432427406311,
            "z": -32.729408264160156
        },
        {
            "x": -2.6407642364501953,
            "y": 0.2619991898536682,
            "z": -32.575958251953125
        },
        {
            "x": -2.676081418991089,
            "y": 0.2572038769721985,
            "z": -32.4223518371582
        },
        {
            "x": -2.7108733654022217,
            "y": 0.25235486030578613,
            "z": -32.26845932006836
        },
        {
            "x": -2.7450246810913086,
            "y": 0.2474629431962967,
            "z": -32.11445617675781
        },
        {
            "x": -2.778522491455078,
            "y": 0.24252569675445557,
            "z": -31.960163116455078
        },
        {
            "x": -2.8112711906433105,
            "y": 0.2375487983226776,
            "z": -31.805620193481445
        },
        {
            "x": -2.8431458473205566,
            "y": 0.23253805935382843,
            "z": -31.650938034057617
        },
        {
            "x": -2.8741209506988525,
            "y": 0.22749018669128418,
            "z": -31.495878219604492
        },
        {
            "x": -2.904083728790283,
            "y": 0.22241683304309845,
            "z": -31.340669631958008
        },
        {
            "x": -2.9329850673675537,
            "y": 0.21731773018836975,
            "z": -31.185195922851562
        },
        {
            "x": -2.960751533508301,
            "y": 0.21218888461589813,
            "z": -31.029239654541016
        },
        {
            "x": -2.9872405529022217,
            "y": 0.2070479393005371,
            "z": -30.873205184936523
        },
        {
            "x": -3.0124566555023193,
            "y": 0.20189014077186584,
            "z": -30.716854095458984
        },
        {
            "x": -3.036327600479126,
            "y": 0.19672134518623352,
            "z": -30.56023597717285
        },
        {
            "x": -3.0587565898895264,
            "y": 0.19154706597328186,
            "z": -30.40342140197754
        },
        {
            "x": -3.0797297954559326,
            "y": 0.18636292219161987,
            "z": -30.246156692504883
        },
        {
            "x": -3.0991930961608887,
            "y": 0.18118640780448914,
            "z": -30.08888053894043
        },
        {
            "x": -3.1171462535858154,
            "y": 0.17601464688777924,
            "z": -29.93140411376953
        },
        {
            "x": -3.1335396766662598,
            "y": 0.17085197567939758,
            "z": -29.77375030517578
        },
        {
            "x": -3.14836049079895,
            "y": 0.1657024770975113,
            "z": -29.615936279296875
        },
        {
            "x": -3.16166090965271,
            "y": 0.16039928793907166,
            "z": -29.457910537719727
        },
        {
            "x": -3.1734416484832764,
            "y": 0.15397915244102478,
            "z": -29.299835205078125
        },
        {
            "x": -3.183692693710327,
            "y": 0.14623737335205078,
            "z": -29.1418399810791
        },
        {
            "x": -3.1924445629119873,
            "y": 0.13724485039710999,
            "z": -28.983736038208008
        },
        {
            "x": -3.199767827987671,
            "y": 0.12714621424674988,
            "z": -28.82577133178711
        },
        {
            "x": -3.2057137489318848,
            "y": 0.11602708697319031,
            "z": -28.66785430908203
        },
        {
            "x": -3.2103171348571777,
            "y": 0.10395412147045135,
            "z": -28.509809494018555
        },
        {
            "x": -3.2135913372039795,
            "y": 0.0910344123840332,
            "z": -28.35203742980957
        },
        {
            "x": -3.2156453132629395,
            "y": 0.07737261801958084,
            "z": -28.194292068481445
        },
        {
            "x": -3.216531753540039,
            "y": 0.0630657821893692,
            "z": -28.036643981933594
        },
        {
            "x": -3.2163026332855225,
            "y": 0.04820957034826279,
            "z": -27.87915802001953
        },
        {
            "x": -3.214966058731079,
            "y": 0.03285355120897293,
            "z": -27.721553802490234
        },
        {
            "x": -3.212634325027466,
            "y": 0.017153160646557808,
            "z": -27.564258575439453
        },
        {
            "x": -3.209352970123291,
            "y": 0.001179325394332409,
            "z": -27.40704345703125
        },
        {
            "x": -3.2051730155944824,
            "y": -0.0149899423122406,
            "z": -27.249799728393555
        },
        {
            "x": -3.200115442276001,
            "y": -0.0312405563890934,
            "z": -27.09274673461914
        },
        {
            "x": -3.1942508220672607,
            "y": -0.04749853536486626,
            "z": -26.935653686523438
        },
        {
            "x": -3.1876027584075928,
            "y": -0.06367024034261703,
            "z": -26.778535842895508
        },
        {
            "x": -3.1800615787506104,
            "y": -0.0796596109867096,
            "z": -26.6214542388916
        },
        {
            "x": -3.174492835998535,
            "y": -0.09016378223896027,
            "z": -26.51674461364746
        },
        {
            "x": -3.1653456687927246,
            "y": -0.10564441978931427,
            "z": -26.359594345092773
        },
        {
            "x": -3.1551096439361572,
            "y": -0.12070517241954803,
            "z": -26.202381134033203
        },
        {
            "x": -3.1436853408813477,
            "y": -0.13525556027889252,
            "z": -26.044940948486328
        },
        {
            "x": -3.131033420562744,
            "y": -0.149155855178833,
            "z": -25.88770294189453
        },
        {
            "x": -3.117131471633911,
            "y": -0.16234731674194336,
            "z": -25.730464935302734
        },
        {
            "x": -3.1019186973571777,
            "y": -0.17474520206451416,
            "z": -25.573116302490234
        },
        {
            "x": -3.085355520248413,
            "y": -0.18622685968875885,
            "z": -25.415882110595703
        },
        {
            "x": -3.0673444271087646,
            "y": -0.196682870388031,
            "z": -25.25860023498535
        },
        {
            "x": -3.0478758811950684,
            "y": -0.20604419708251953,
            "z": -25.101377487182617
        },
        {
            "x": -3.026916742324829,
            "y": -0.2142120748758316,
            "z": -24.944311141967773
        },
        {
            "x": -3.00439715385437,
            "y": -0.22109010815620422,
            "z": -24.787229537963867
        },
        {
            "x": -2.98022198677063,
            "y": -0.22652162611484528,
            "z": -24.630428314208984
        },
        {
            "x": -2.9544012546539307,
            "y": -0.23047135770320892,
            "z": -24.473758697509766
        },
        {
            "x": -2.926879405975342,
            "y": -0.23334920406341553,
            "z": -24.317169189453125
        },
        {
            "x": -2.897639513015747,
            "y": -0.2360275834798813,
            "z": -24.161026000976562
        },
        {
            "x": -2.8665640354156494,
            "y": -0.23780596256256104,
            "z": -24.005123138427734
        },
        {
            "x": -2.8336691856384277,
            "y": -0.23807108402252197,
            "z": -23.84951400756836
        },
        {
            "x": -2.798977851867676,
            "y": -0.2369104027748108,
            "z": -23.694360733032227
        },
        {
            "x": -2.7623844146728516,
            "y": -0.23440396785736084,
            "z": -23.539392471313477
        },
        {
            "x": -2.723897695541382,
            "y": -0.2306000143289566,
            "z": -23.3851375579834
        },
        {
            "x": -2.6838433742523193,
            "y": -0.22566190361976624,
            "z": -23.231843948364258
        },
        {
            "x": -2.6431708335876465,
            "y": -0.2196871042251587,
            "z": -23.0794677734375
        },
        {
            "x": -2.6019513607025146,
            "y": -0.21273931860923767,
            "z": -22.927297592163086
        },
        {
            "x": -2.5601162910461426,
            "y": -0.20486018061637878,
            "z": -22.77522087097168
        },
        {
            "x": -2.5177054405212402,
            "y": -0.19618666172027588,
            "z": -22.623340606689453
        },
        {
            "x": -2.4747416973114014,
            "y": -0.18681195378303528,
            "z": -22.471763610839844
        },
        {
            "x": -2.431185245513916,
            "y": -0.17680853605270386,
            "z": -22.320310592651367
        },
        {
            "x": -2.38710880279541,
            "y": -0.16626065969467163,
            "z": -22.16920280456543
        },
        {
            "x": -2.3425583839416504,
            "y": -0.15527725219726562,
            "z": -22.018314361572266
        },
        {
            "x": -2.297536611557007,
            "y": -0.1439320296049118,
            "z": -21.867456436157227
        },
        {
            "x": -2.2522246837615967,
            "y": -0.13233916461467743,
            "z": -21.716999053955078
        },
        {
            "x": -2.2066359519958496,
            "y": -0.12057164311408997,
            "z": -21.566679000854492
        },
        {
            "x": -2.160893678665161,
            "y": -0.10872886329889297,
            "z": -21.41651153564453
        },
        {
            "x": -2.115117073059082,
            "y": -0.09699228405952454,
            "z": -21.26652717590332
        },
        {
            "x": -2.0693464279174805,
            "y": -0.08552399277687073,
            "z": -21.11644172668457
        },
        {
            "x": -2.023818254470825,
            "y": -0.07444494962692261,
            "z": -20.96659278869629
        },
        {
            "x": -1.9785910844802856,
            "y": -0.0638289600610733,
            "z": -20.816749572753906
        },
        {
            "x": -1.9337538480758667,
            "y": -0.05376953259110451,
            "z": -20.666767120361328
        },
        {
            "x": -1.8895055055618286,
            "y": -0.044401489198207855,
            "z": -20.51680564880371
        },
        {
            "x": -1.8458764553070068,
            "y": -0.035780783742666245,
            "z": -20.366636276245117
        },
        {
            "x": -1.8029956817626953,
            "y": -0.028006458654999733,
            "z": -20.21630096435547
        },
        {
            "x": -1.7610207796096802,
            "y": -0.02122192084789276,
            "z": -20.065881729125977
        },
        {
            "x": -1.733550786972046,
            "y": -0.017274469137191772,
            "z": -19.965482711791992
        },
        {
            "x": -1.6931620836257935,
            "y": -0.012278629466891289,
            "z": -19.814693450927734
        },
        {
            "x": -1.6538664102554321,
            "y": -0.008540243841707706,
            "z": -19.66365623474121
        },
        {
            "x": -1.6156206130981445,
            "y": -0.006094817072153091,
            "z": -19.51215934753418
        },
        {
            "x": -1.5785510540008545,
            "y": -0.005039973650127649,
            "z": -19.360591888427734
        },
        {
            "x": -1.5426762104034424,
            "y": -0.005000002682209015,
            "z": -19.20872688293457
        },
        {
            "x": -1.5079785585403442,
            "y": -0.004999985918402672,
            "z": -19.05648422241211
        },
        {
            "x": -1.4744735956192017,
            "y": -0.004999998956918716,
            "z": -18.90406036376953
        },
        {
            "x": -1.4421254396438599,
            "y": -0.004999995231628418,
            "z": -18.751298904418945
        },
        {
            "x": -1.4109857082366943,
            "y": -0.005000002682209015,
            "z": -18.59823989868164
        },
        {
            "x": -1.3809733390808105,
            "y": -0.00499998964369297,
            "z": -18.445032119750977
        },
        {
            "x": -1.3520381450653076,
            "y": -0.004999995231628418,
            "z": -18.291461944580078
        },
        {
            "x": -1.3241833448410034,
            "y": -0.005000002682209015,
            "z": -18.137765884399414
        },
        {
            "x": -1.2973601818084717,
            "y": -0.005000004544854164,
            "z": -17.983827590942383
        },
        {
            "x": -1.2714353799819946,
            "y": -0.005000004544854164,
            "z": -17.82949447631836
        },
        {
            "x": -1.246427059173584,
            "y": -0.00499998964369297,
            "z": -17.67512321472168
        },
        {
            "x": -1.222275733947754,
            "y": -0.004999998956918716,
            "z": -17.520524978637695
        },
        {
            "x": -1.1988774538040161,
            "y": -0.004999982193112373,
            "z": -17.365732192993164
        },
        {
            "x": -1.176179051399231,
            "y": -0.0049999915063381195,
            "z": -17.21080780029297
        },
        {
            "x": -1.1540825366973877,
            "y": -0.004999998956918716,
            "z": -17.055540084838867
        },
        {
            "x": -1.1325803995132446,
            "y": -0.005000000819563866,
            "z": -16.900325775146484
        },
        {
            "x": -1.1115550994873047,
            "y": -0.005000000819563866,
            "z": -16.74495506286621
        },
        {
            "x": -1.090932846069336,
            "y": -0.005000010132789612,
            "z": -16.589454650878906
        },
        {
            "x": -1.070647120475769,
            "y": -0.005000002682209015,
            "z": -16.433837890625
        },
        {
            "x": -1.0506207942962646,
            "y": -0.004999995231628418,
            "z": -16.27802276611328
        },
        {
            "x": -1.0307695865631104,
            "y": -0.004999998956918716,
            "z": -16.122106552124023
        },
        {
            "x": -1.0110355615615845,
            "y": -0.004999995231628418,
            "z": -15.966190338134766
        },
        {
            "x": -0.9912903308868408,
            "y": -0.005000004544854164,
            "z": -15.810072898864746
        },
        {
            "x": -0.9716390371322632,
            "y": -0.004999998956918716,
            "z": -15.65437126159668
        },
        {
            "x": -0.9527400732040405,
            "y": -0.005000008270144463,
            "z": -15.499167442321777
        },
        {
            "x": -0.9346523880958557,
            "y": -0.004999998956918716,
            "z": -15.343548774719238
        },
        {
            "x": -0.9172490835189819,
            "y": -0.005000000819563866,
            "z": -15.187902450561523
        },
        {
            "x": -0.9003878831863403,
            "y": -0.004999995231628418,
            "z": -15.031997680664062
        },
        {
            "x": -0.8839205503463745,
            "y": -0.004999995231628418,
            "z": -14.875922203063965
        },
        {
            "x": -0.8677247762680054,
            "y": -0.005000006407499313,
            "z": -14.719746589660645
        },
        {
            "x": -0.8516546487808228,
            "y": -0.004999997094273567,
            "z": -14.56324577331543
        },
        {
            "x": -0.8356795907020569,
            "y": -0.004999995231628418,
            "z": -14.406889915466309
        },
        {
            "x": -0.8197506666183472,
            "y": -0.005000002682209015,
            "z": -14.250504493713379
        },
        {
            "x": -0.8038366436958313,
            "y": -0.005000004544854164,
            "z": -14.09399127960205
        },
        {
            "x": -0.7879427671432495,
            "y": -0.005000006407499313,
            "z": -13.937569618225098
        },
        {
            "x": -0.7720334529876709,
            "y": -0.004999998956918716,
            "z": -13.781033515930176
        },
        {
            "x": -0.7561062574386597,
            "y": -0.005000004544854164,
            "z": -13.62448787689209
        },
        {
            "x": -0.7401609420776367,
            "y": -0.004999978467822075,
            "z": -13.468036651611328
        },
        {
            "x": -0.7295092344284058,
            "y": -0.004999998956918716,
            "z": -13.363729476928711
        },
        {
            "x": -0.7134947180747986,
            "y": -0.004999995231628418,
            "z": -13.207265853881836
        },
        {
            "x": -0.6974260210990906,
            "y": -0.005000000819563866,
            "z": -13.05080509185791
        },
        {
            "x": -0.6812799572944641,
            "y": -0.005000002682209015,
            "z": -12.894142150878906
        },
        {
            "x": -0.6650928854942322,
            "y": -0.004999995231628418,
            "z": -12.737686157226562
        },
        {
            "x": -0.6488471031188965,
            "y": -0.005000000819563866,
            "z": -12.581235885620117
        },
        {
            "x": -0.6325299739837646,
            "y": -0.004999998956918716,
            "z": -12.424681663513184
        },
        {
            "x": -0.6161625981330872,
            "y": -0.004999987781047821,
            "z": -12.268243789672852
        },
        {
            "x": -0.5997220277786255,
            "y": -0.00499998964369297,
            "z": -12.111712455749512
        },
        {
            "x": -0.5832231044769287,
            "y": -0.004999998956918716,
            "z": -11.955190658569336
        },
        {
            "x": -0.5666772723197937,
            "y": -0.0049999915063381195,
            "z": -11.798739433288574
        },
        {
            "x": -0.54971843957901,
            "y": -0.004999993368983269,
            "z": -11.64162826538086
        },
        {
            "x": -0.5319544672966003,
            "y": -0.004999998956918716,
            "z": -11.484600067138672
        },
        {
            "x": -0.5134546160697937,
            "y": -0.004999984055757523,
            "z": -11.32772159576416
        },
        {
            "x": -0.49426084756851196,
            "y": -0.005000006407499313,
            "z": -11.170796394348145
        },
        {
            "x": -0.47446200251579285,
            "y": -0.004999998956918716,
            "z": -11.014220237731934
        },
        {
            "x": -0.4541296064853668,
            "y": -0.005000000819563866,
            "z": -10.857730865478516
        },
        {
            "x": -0.4333369731903076,
            "y": -0.005000004544854164,
            "z": -10.70136833190918
        },
        {
            "x": -0.41215240955352783,
            "y": -0.004999998956918716,
            "z": -10.545186996459961
        },
        {
            "x": -0.3906049430370331,
            "y": -0.004999997094273567,
            "z": -10.38891887664795
        },
        {
            "x": -0.36882951855659485,
            "y": -0.004999997094273567,
            "z": -10.232959747314453
        },
        {
            "x": -0.34703508019447327,
            "y": -0.005000000819563866,
            "z": -10.077520370483398
        },
        {
            "x": -0.3259297311306,
            "y": -0.005000000819563866,
            "z": -9.92249584197998
        },
        {
            "x": -0.3055870831012726,
            "y": -0.004999995231628418,
            "z": -9.767382621765137
        },
        {
            "x": -0.2859826385974884,
            "y": -0.0049999915063381195,
            "z": -9.612078666687012
        },
        {
            "x": -0.2671324610710144,
            "y": -0.004999998956918716,
            "z": -9.456683158874512
        },
        {
            "x": -0.249088853597641,
            "y": -0.005000000819563866,
            "z": -9.30129623413086
        },
        {
            "x": -0.23178653419017792,
            "y": -0.004999995231628418,
            "z": -9.145709037780762
        },
        {
            "x": -0.21524685621261597,
            "y": -0.004999993368983269,
            "z": -8.99014949798584
        },
        {
            "x": -0.1994682401418686,
            "y": -0.004999995231628418,
            "z": -8.834502220153809
        },
        {
            "x": -0.18443414568901062,
            "y": -0.004999997094273567,
            "z": -8.678571701049805
        },
        {
            "x": -0.17014896869659424,
            "y": -0.004999998956918716,
            "z": -8.5227632522583
        },
        {
            "x": -0.15657676756381989,
            "y": -0.005000004544854164,
            "z": -8.366819381713867
        },
        {
            "x": -0.1437377780675888,
            "y": -0.005000000819563866,
            "z": -8.210796356201172
        },
        {
            "x": -0.13159728050231934,
            "y": -0.005000006407499313,
            "z": -8.054756164550781
        },
        {
            "x": -0.12010639160871506,
            "y": -0.005000002682209015,
            "z": -7.898443698883057
        },
        {
            "x": -0.10927528887987137,
            "y": -0.004999995231628418,
            "z": -7.742256164550781
        },
        {
            "x": -0.09907399117946625,
            "y": -0.005000002682209015,
            "z": -7.585960865020752
        },
        {
            "x": -0.08935873955488205,
            "y": -0.004999997094273567,
            "z": -7.429375171661377
        },
        {
            "x": -0.07998549193143845,
            "y": -0.004999985918402672,
            "z": -7.272705554962158
        },
        {
            "x": -0.07077764719724655,
            "y": -0.004999993368983269,
            "z": -7.1157402992248535
        },
        {
            "x": -0.061558280140161514,
            "y": -0.004999998956918716,
            "z": -6.958581924438477
        },
        {
            "x": -0.05215049162507057,
            "y": -0.005000000819563866,
            "z": -6.801341533660889
        },
        {
            "x": -0.04567897692322731,
            "y": -0.004999997094273567,
            "z": -6.696416854858398
        },
        {
            "x": -0.035594671964645386,
            "y": -0.004999995231628418,
            "z": -6.539206504821777
        },
        {
            "x": -0.025871384888887405,
            "y": -0.005000002682209015,
            "z": -6.383388042449951
        },
        {
            "x": -0.017791185528039932,
            "y": -0.005000000819563866,
            "z": -6.228173732757568
        },
        {
            "x": -0.011693719774484634,
            "y": -0.005000002682209015,
            "z": -6.073075771331787
        },
        {
            "x": -0.00742326769977808,
            "y": -0.005000002682209015,
            "z": -5.917820930480957
        },
        {
            "x": -0.00477240327745676,
            "y": -0.005000000819563866,
            "z": -5.761809349060059
        },
        {
            "x": -0.0027278722263872623,
            "y": -0.004999997094273567,
            "z": -5.604854106903076
        },
        {
            "x": -0.0008419672958552837,
            "y": -0.005000000819563866,
            "z": -5.447674751281738
        },
        {
            "x": 0.0009175371378660202,
            "y": -0.004999993368983269,
            "z": -5.290485858917236
        },
        {
            "x": 0.0025556478649377823,
            "y": -0.005000002682209015,
            "z": -5.1333909034729
        },
        {
            "x": 0.003890019841492176,
            "y": -0.00499998964369297,
            "z": -4.976963043212891
        },
        {
            "x": 0.003789516631513834,
            "y": -0.004999997094273567,
            "z": -4.821375370025635
        },
        {
            "x": 0.002262534573674202,
            "y": -0.005000002682209015,
            "z": -4.665586471557617
        },
        {
            "x": -0.0004910952411592007,
            "y": -0.005000000819563866,
            "z": -4.509397983551025
        },
        {
            "x": -0.004268284887075424,
            "y": -0.004999998956918716,
            "z": -4.353211402893066
        },
        {
            "x": -0.008901751600205898,
            "y": -0.005000000819563866,
            "z": -4.196764945983887
        },
        {
            "x": -0.01415647380053997,
            "y": -0.004999997094273567,
            "z": -4.040121555328369
        },
        {
            "x": -0.01982799917459488,
            "y": -0.005000006407499313,
            "z": -3.8833322525024414
        },
        {
            "x": -0.02572360262274742,
            "y": -0.004999995231628418,
            "z": -3.7261199951171875
        },
        {
            "x": -0.03161264955997467,
            "y": -0.004999995231628418,
            "z": -3.5689141750335693
        },
        {
            "x": -0.03752996772527695,
            "y": -0.004999995231628418,
            "z": -3.412099599838257
        },
        {
            "x": -0.04382932558655739,
            "y": -0.005000000819563866,
            "z": -3.2553625106811523
        },
        {
            "x": -0.05040200427174568,
            "y": -0.004999997094273567,
            "z": -3.098482131958008
        },
        {
            "x": -0.057105861604213715,
            "y": -0.005000000819563866,
            "z": -2.941326141357422
        },
        {
            "x": -0.06376656889915466,
            "y": -0.005000004544854164,
            "z": -2.784001350402832
        },
        {
            "x": -0.07022297382354736,
            "y": -0.005000002682209015,
            "z": -2.6265861988067627
        },
        {
            "x": -0.07632250338792801,
            "y": -0.004999993368983269,
            "z": -2.46887469291687
        },
        {
            "x": -0.08192043006420135,
            "y": -0.004999998956918716,
            "z": -2.3112733364105225
        },
        {
            "x": -0.08717342466115952,
            "y": -0.005000010132789612,
            "z": -2.1538779735565186
        },
        {
            "x": -0.09230063855648041,
            "y": -0.004999993368983269,
            "z": -1.9965028762817383
        },
        {
            "x": -0.09748563170433044,
            "y": -0.004999995231628418,
            "z": -1.8395421504974365
        },
        {
            "x": -0.10294023901224136,
            "y": -0.005000004544854164,
            "z": -1.6827389001846313
        },
        {
            "x": -0.10883454978466034,
            "y": -0.005000002682209015,
            "z": -1.5261369943618774
        },
        {
            "x": -0.1153152734041214,
            "y": -0.005000000819563866,
            "z": -1.3697725534439087
        },
        {
            "x": -0.12252173572778702,
            "y": -0.004999997094273567,
            "z": -1.2133684158325195
        },
        {
            "x": -0.1305728256702423,
            "y": -0.004999993368983269,
            "z": -1.057237982749939
        },
        {
            "x": -0.1392120122909546,
            "y": -0.005000004544854164,
            "z": -0.900418758392334
        },
        {
            "x": -0.14778076112270355,
            "y": -0.0049999915063381195,
            "z": -0.743076503276825
        },
        {
            "x": -0.1560336947441101,
            "y": -0.004999997094273567,
            "z": -0.5855301022529602
        },
        {
            "x": -0.16357696056365967,
            "y": -0.004999995231628418,
            "z": -0.42726725339889526
        },
        {
            "x": -0.16973553597927094,
            "y": -0.004999998956918716,
            "z": -0.26792025566101074
        },
        {
            "x": -0.1732308268547058,
            "y": -0.004999995231628418,
            "z": -0.10668467730283737
        },
        {
            "x": -0.1730637103319168,
            "y": -0.004999995231628418,
            "z": 0.0014032245380803943
        }
    ],
    "lane2":[
        {
            "x": -0.056939512491226196,
            "y": 0.009486839175224304,
            "z": -419.77874755859375
        },
        {
            "x": -0.057117730379104614,
            "y": 0.009480364620685577,
            "z": -419.6215515136719
        },
        {
            "x": -0.057296037673950195,
            "y": 0.009473875164985657,
            "z": -419.46429443359375
        },
        {
            "x": -0.05747446417808533,
            "y": 0.009467385709285736,
            "z": -419.3068542480469
        },
        {
            "x": -0.05765277147293091,
            "y": 0.009460903704166412,
            "z": -419.1496276855469
        },
        {
            "x": -0.057830989360809326,
            "y": 0.009454421699047089,
            "z": -418.9924011230469
        },
        {
            "x": -0.05800935626029968,
            "y": 0.009447939693927765,
            "z": -418.8350524902344
        },
        {
            "x": -0.05818760395050049,
            "y": 0.009441465139389038,
            "z": -418.67779541015625
        },
        {
            "x": -0.05836594104766846,
            "y": 0.009434960782527924,
            "z": -418.52044677734375
        },
        {
            "x": -0.0585443377494812,
            "y": 0.009428486227989197,
            "z": -418.3631591796875
        },
        {
            "x": -0.058722496032714844,
            "y": 0.009422019124031067,
            "z": -418.20587158203125
        },
        {
            "x": -0.05890095233917236,
            "y": 0.00941552221775055,
            "z": -418.048583984375
        },
        {
            "x": -0.059079140424728394,
            "y": 0.009409032762050629,
            "z": -417.8913269042969
        },
        {
            "x": -0.05925741791725159,
            "y": 0.009402580559253693,
            "z": -417.7341003417969
        },
        {
            "x": -0.05943584442138672,
            "y": 0.009396061301231384,
            "z": -417.57666015625
        },
        {
            "x": -0.0596141517162323,
            "y": 0.009389594197273254,
            "z": -417.41943359375
        },
        {
            "x": -0.05979242920875549,
            "y": 0.009383097290992737,
            "z": -417.26214599609375
        },
        {
            "x": -0.059970706701278687,
            "y": 0.00937662273645401,
            "z": -417.1048583984375
        },
        {
            "x": -0.06014901399612427,
            "y": 0.009370125830173492,
            "z": -416.9476318359375
        },
        {
            "x": -0.0603274405002594,
            "y": 0.009363643825054169,
            "z": -416.7901611328125
        },
        {
            "x": -0.06050571799278259,
            "y": 0.009357169270515442,
            "z": -416.6329650878906
        },
        {
            "x": -0.06068393588066101,
            "y": 0.009350672364234924,
            "z": -416.4757385253906
        },
        {
            "x": -0.060862183570861816,
            "y": 0.009344220161437988,
            "z": -416.3184814453125
        },
        {
            "x": -0.06104043126106262,
            "y": 0.009337715804576874,
            "z": -416.1612548828125
        },
        {
            "x": -0.06121879816055298,
            "y": 0.00933123379945755,
            "z": -416.0039367675781
        },
        {
            "x": -0.06139710545539856,
            "y": 0.00932476669549942,
            "z": -415.84661865234375
        },
        {
            "x": -0.06157538294792175,
            "y": 0.009318321943283081,
            "z": -415.6893615722656
        },
        {
            "x": -0.06175372004508972,
            "y": 0.009311787784099579,
            "z": -415.53204345703125
        },
        {
            "x": -0.06193196773529053,
            "y": 0.009305320680141449,
            "z": -415.37481689453125
        },
        {
            "x": -0.06211024522781372,
            "y": 0.009298861026763916,
            "z": -415.217529296875
        },
        {
            "x": -0.06228867173194885,
            "y": 0.009292364120483398,
            "z": -415.0601501464844
        },
        {
            "x": -0.062466979026794434,
            "y": 0.009285859763622284,
            "z": -414.90289306640625
        },
        {
            "x": -0.06264534592628479,
            "y": 0.009279385209083557,
            "z": -414.74560546875
        },
        {
            "x": -0.0628235936164856,
            "y": 0.009272933006286621,
            "z": -414.58831787109375
        },
        {
            "x": -0.06300187110900879,
            "y": 0.00926642119884491,
            "z": -414.43109130859375
        },
        {
            "x": -0.06318023800849915,
            "y": 0.009259916841983795,
            "z": -414.273681640625
        },
        {
            "x": -0.06335854530334473,
            "y": 0.009253449738025665,
            "z": -414.116455078125
        },
        {
            "x": -0.06353679299354553,
            "y": 0.00924699753522873,
            "z": -413.9591979980469
        },
        {
            "x": -0.06371510028839111,
            "y": 0.009240493178367615,
            "z": -413.8018798828125
        },
        {
            "x": -0.0638934075832367,
            "y": 0.009233996272087097,
            "z": -413.6446228027344
        },
        {
            "x": -0.06407174468040466,
            "y": 0.009227514266967773,
            "z": -413.4873046875
        },
        {
            "x": -0.06425014138221741,
            "y": 0.00922103226184845,
            "z": -413.33001708984375
        },
        {
            "x": -0.06442835927009583,
            "y": 0.009214580059051514,
            "z": -413.1727294921875
        },
        {
            "x": -0.06454715132713318,
            "y": 0.009210236370563507,
            "z": -413.06793212890625
        },
        {
            "x": -0.06472539901733398,
            "y": 0.009203799068927765,
            "z": -412.91064453125
        },
        {
            "x": -0.06490367650985718,
            "y": 0.009197287261486053,
            "z": -412.7534484863281
        },
        {
            "x": -0.06508210301399231,
            "y": 0.009190790355205536,
            "z": -412.5960388183594
        },
        {
            "x": -0.06526046991348267,
            "y": 0.009184285998344421,
            "z": -412.43878173828125
        },
        {
            "x": -0.06543871760368347,
            "y": 0.00917784869670868,
            "z": -412.28155517578125
        },
        {
            "x": -0.06561693549156189,
            "y": 0.009171366691589355,
            "z": -412.12420654296875
        },
        {
            "x": -0.06579527258872986,
            "y": 0.009164847433567047,
            "z": -411.96697998046875
        },
        {
            "x": -0.06597360968589783,
            "y": 0.00915837287902832,
            "z": -411.80963134765625
        },
        {
            "x": -0.06615188717842102,
            "y": 0.0091518834233284,
            "z": -411.65234375
        },
        {
            "x": -0.0663301944732666,
            "y": 0.009145408868789673,
            "z": -411.4950866699219
        },
        {
            "x": -0.06650853157043457,
            "y": 0.009138904511928558,
            "z": -411.3377685546875
        },
        {
            "x": -0.06668683886528015,
            "y": 0.009132437407970428,
            "z": -411.1805114746094
        },
        {
            "x": -0.06686508655548096,
            "y": 0.009125962853431702,
            "z": -411.0232849121094
        },
        {
            "x": -0.06704354286193848,
            "y": 0.009119480848312378,
            "z": -410.8658447265625
        },
        {
            "x": -0.06722179055213928,
            "y": 0.009112976491451263,
            "z": -410.7086181640625
        },
        {
            "x": -0.06740006804466248,
            "y": 0.009106524288654327,
            "z": -410.55133056640625
        },
        {
            "x": -0.06757840514183044,
            "y": 0.009100012481212616,
            "z": -410.39404296875
        },
        {
            "x": -0.06775662302970886,
            "y": 0.00909356027841568,
            "z": -410.23681640625
        },
        {
            "x": -0.06793507933616638,
            "y": 0.009087041020393372,
            "z": -410.07940673828125
        },
        {
            "x": -0.06811332702636719,
            "y": 0.009080566465854645,
            "z": -409.92218017578125
        },
        {
            "x": -0.06829160451889038,
            "y": 0.009074099361896515,
            "z": -409.764892578125
        },
        {
            "x": -0.06846979260444641,
            "y": 0.009067624807357788,
            "z": -409.6076965332031
        },
        {
            "x": -0.06864809989929199,
            "y": 0.009061120450496674,
            "z": -409.4504699707031
        },
        {
            "x": -0.06882646679878235,
            "y": 0.009054630994796753,
            "z": -409.29315185546875
        },
        {
            "x": -0.06900477409362793,
            "y": 0.009048156440258026,
            "z": -409.13580322265625
        },
        {
            "x": -0.06918308138847351,
            "y": 0.009041659533977509,
            "z": -408.97857666015625
        },
        {
            "x": -0.0693613588809967,
            "y": 0.009035177528858185,
            "z": -408.82122802734375
        },
        {
            "x": -0.06953966617584229,
            "y": 0.009028702974319458,
            "z": -408.66400146484375
        },
        {
            "x": -0.0697178840637207,
            "y": 0.009022220969200134,
            "z": -408.50677490234375
        },
        {
            "x": -0.06989634037017822,
            "y": 0.009015746414661407,
            "z": -408.349365234375
        },
        {
            "x": -0.07007461786270142,
            "y": 0.009009256958961487,
            "z": -408.1921081542969
        },
        {
            "x": -0.070252925157547,
            "y": 0.009002774953842163,
            "z": -408.0348205566406
        },
        {
            "x": -0.07043123245239258,
            "y": 0.008996278047561646,
            "z": -407.8775329589844
        },
        {
            "x": -0.070609450340271,
            "y": 0.008989796042442322,
            "z": -407.7203063964844
        },
        {
            "x": -0.0707879364490509,
            "y": 0.008983314037322998,
            "z": -407.5628662109375
        },
        {
            "x": -0.0709662139415741,
            "y": 0.008976846933364868,
            "z": -407.4056396484375
        },
        {
            "x": -0.07114449143409729,
            "y": 0.008970357477664948,
            "z": -407.2484130859375
        },
        {
            "x": -0.07132279872894287,
            "y": 0.008963890373706818,
            "z": -407.091064453125
        },
        {
            "x": -0.07150104641914368,
            "y": 0.008957408368587494,
            "z": -406.933837890625
        },
        {
            "x": -0.07167935371398926,
            "y": 0.00895092636346817,
            "z": -406.7764587402344
        },
        {
            "x": -0.07185778021812439,
            "y": 0.008944422006607056,
            "z": -406.619140625
        },
        {
            "x": -0.0720360279083252,
            "y": 0.008937947452068329,
            "z": -406.4619140625
        },
        {
            "x": -0.07215490937232971,
            "y": 0.00893363356590271,
            "z": -406.3570861816406
        },
        {
            "x": -0.07233509421348572,
            "y": 0.00892706960439682,
            "z": -406.1998596191406
        },
        {
            "x": -0.0725134015083313,
            "y": 0.008920587599277496,
            "z": -406.0426330566406
        },
        {
            "x": -0.07269185781478882,
            "y": 0.008914098143577576,
            "z": -405.8852233886719
        },
        {
            "x": -0.07287004590034485,
            "y": 0.008907623589038849,
            "z": -405.72796630859375
        },
        {
            "x": -0.07304832339286804,
            "y": 0.008901119232177734,
            "z": -405.57073974609375
        },
        {
            "x": -0.07322666049003601,
            "y": 0.008894667029380798,
            "z": -405.41339111328125
        },
        {
            "x": -0.0734049379825592,
            "y": 0.00888817012310028,
            "z": -405.25616455078125
        },
        {
            "x": -0.07358327507972717,
            "y": 0.008881665766239166,
            "z": -405.09881591796875
        },
        {
            "x": -0.07376164197921753,
            "y": 0.00887519121170044,
            "z": -404.9414978027344
        },
        {
            "x": -0.07393983006477356,
            "y": 0.008868739008903503,
            "z": -404.7842712402344
        },
        {
            "x": -0.07411813735961914,
            "y": 0.008862234652042389,
            "z": -404.6269226074219
        },
        {
            "x": -0.0742965042591095,
            "y": 0.008855767548084259,
            "z": -404.4696960449219
        },
        {
            "x": -0.07447472214698792,
            "y": 0.008849270641803741,
            "z": -404.3124694824219
        },
        {
            "x": -0.07465320825576782,
            "y": 0.00884278118610382,
            "z": -404.1550598144531
        },
        {
            "x": -0.07483142614364624,
            "y": 0.008836314082145691,
            "z": -403.9978332519531
        },
        {
            "x": -0.07500976324081421,
            "y": 0.00882982462644577,
            "z": -403.8405456542969
        },
        {
            "x": -0.07518807053565979,
            "y": 0.008823327720165253,
            "z": -403.6832275390625
        },
        {
            "x": -0.0753663182258606,
            "y": 0.00881689041852951,
            "z": -403.5260009765625
        },
        {
            "x": -0.07554474472999573,
            "y": 0.008810371160507202,
            "z": -403.3685607910156
        },
        {
            "x": -0.07572299242019653,
            "y": 0.008803874254226685,
            "z": -403.2113342285156
        },
        {
            "x": -0.07590129971504211,
            "y": 0.00879739224910736,
            "z": -403.0541076660156
        },
        {
            "x": -0.07607948780059814,
            "y": 0.008790932595729828,
            "z": -402.8968505859375
        },
        {
            "x": -0.07625773549079895,
            "y": 0.008784450590610504,
            "z": -402.7396240234375
        },
        {
            "x": -0.0764361023902893,
            "y": 0.00877796858549118,
            "z": -402.5823059082031
        },
        {
            "x": -0.07661446928977966,
            "y": 0.008771464228630066,
            "z": -402.4249572753906
        },
        {
            "x": -0.07679274678230286,
            "y": 0.008764997124671936,
            "z": -402.2677307128906
        },
        {
            "x": -0.07697105407714844,
            "y": 0.008758537471294403,
            "z": -402.11041259765625
        },
        {
            "x": -0.07714933156967163,
            "y": 0.008752025663852692,
            "z": -401.9531555175781
        },
        {
            "x": -0.07732760906219482,
            "y": 0.008745528757572174,
            "z": -401.7959289550781
        },
        {
            "x": -0.07750600576400757,
            "y": 0.008739076554775238,
            "z": -401.6385192871094
        },
        {
            "x": -0.07768425345420837,
            "y": 0.008732616901397705,
            "z": -401.4812927246094
        },
        {
            "x": -0.07786259055137634,
            "y": 0.0087260901927948,
            "z": -401.323974609375
        },
        {
            "x": -0.07804089784622192,
            "y": 0.00871960073709488,
            "z": -401.16668701171875
        },
        {
            "x": -0.07821917533874512,
            "y": 0.008713118731975555,
            "z": -401.00946044921875
        },
        {
            "x": -0.07839757204055786,
            "y": 0.008706629276275635,
            "z": -400.85205078125
        },
        {
            "x": -0.07857587933540344,
            "y": 0.008700147271156311,
            "z": -400.6947937011719
        },
        {
            "x": -0.07875412702560425,
            "y": 0.008693665266036987,
            "z": -400.5375671386719
        },
        {
            "x": -0.07893240451812744,
            "y": 0.008687213063240051,
            "z": -400.3802490234375
        },
        {
            "x": -0.07911071181297302,
            "y": 0.00868070125579834,
            "z": -400.2229919433594
        },
        {
            "x": -0.07928910851478577,
            "y": 0.008674204349517822,
            "z": -400.0657043457031
        },
        {
            "x": -0.07946741580963135,
            "y": 0.008667722344398499,
            "z": -399.9083557128906
        },
        {
            "x": -0.07964572310447693,
            "y": 0.008661270141601562,
            "z": -399.7511291503906
        },
        {
            "x": -0.07976454496383667,
            "y": 0.008656933903694153,
            "z": -399.6463317871094
        },
        {
            "x": -0.07994276285171509,
            "y": 0.008650451898574829,
            "z": -399.4890441894531
        },
        {
            "x": -0.08012107014656067,
            "y": 0.0086439847946167,
            "z": -399.3318786621094
        },
        {
            "x": -0.08029940724372864,
            "y": 0.008637480437755585,
            "z": -399.1744689941406
        },
        {
            "x": -0.08047771453857422,
            "y": 0.008631020784378052,
            "z": -399.0172119140625
        },
        {
            "x": -0.08065596222877502,
            "y": 0.008624523878097534,
            "z": -398.8599548339844
        },
        {
            "x": -0.0808342695236206,
            "y": 0.00861804187297821,
            "z": -398.7026672363281
        },
        {
            "x": -0.08101260662078857,
            "y": 0.00861157476902008,
            "z": -398.5453796386719
        },
        {
            "x": -0.08119097352027893,
            "y": 0.008605070412158966,
            "z": -398.3880920410156
        },
        {
            "x": -0.08136928081512451,
            "y": 0.008598573505878448,
            "z": -398.23077392578125
        },
        {
            "x": -0.08154761791229248,
            "y": 0.008592113852500916,
            "z": -398.0735168457031
        },
        {
            "x": -0.08172589540481567,
            "y": 0.008585646748542786,
            "z": -397.9161682128906
        },
        {
            "x": -0.08190420269966125,
            "y": 0.008579127490520477,
            "z": -397.7589416503906
        },
        {
            "x": -0.08208248019218445,
            "y": 0.008572638034820557,
            "z": -397.6017150878906
        },
        {
            "x": -0.08226087689399719,
            "y": 0.00856618583202362,
            "z": -397.4443054199219
        },
        {
            "x": -0.08243915438652039,
            "y": 0.0085596963763237,
            "z": -397.2870178222656
        },
        {
            "x": -0.08261746168136597,
            "y": 0.008553236722946167,
            "z": -397.1297607421875
        },
        {
            "x": -0.08279573917388916,
            "y": 0.008546717464923859,
            "z": -396.9725036621094
        },
        {
            "x": -0.08297404646873474,
            "y": 0.008540228009223938,
            "z": -396.81524658203125
        },
        {
            "x": -0.08315238356590271,
            "y": 0.008533775806427002,
            "z": -396.6578063964844
        },
        {
            "x": -0.08333072066307068,
            "y": 0.008527286350727081,
            "z": -396.5005798339844
        },
        {
            "x": -0.08350899815559387,
            "y": 0.008520767092704773,
            "z": -396.3433532714844
        },
        {
            "x": -0.08368721604347229,
            "y": 0.008514314889907837,
            "z": -396.1861267089844
        },
        {
            "x": -0.0838654637336731,
            "y": 0.00850781798362732,
            "z": -396.0289001464844
        },
        {
            "x": -0.08404383063316345,
            "y": 0.008501335978507996,
            "z": -395.87158203125
        },
        {
            "x": -0.08422216773033142,
            "y": 0.008494846522808075,
            "z": -395.7142333984375
        },
        {
            "x": -0.08440044522285461,
            "y": 0.008488379418849945,
            "z": -395.55706787109375
        },
        {
            "x": -0.08457878232002258,
            "y": 0.008481889963150024,
            "z": -395.39971923828125
        },
        {
            "x": -0.08475705981254578,
            "y": 0.008475378155708313,
            "z": -395.24249267578125
        },
        {
            "x": -0.08493533730506897,
            "y": 0.00846891850233078,
            "z": -395.08526611328125
        },
        {
            "x": -0.0851137638092041,
            "y": 0.00846242904663086,
            "z": -394.92779541015625
        },
        {
            "x": -0.0852920413017273,
            "y": 0.00845596194267273,
            "z": -394.77056884765625
        },
        {
            "x": -0.08547031879425049,
            "y": 0.008449465036392212,
            "z": -394.61328125
        },
        {
            "x": -0.0856485664844513,
            "y": 0.008442997932434082,
            "z": -394.4559631347656
        },
        {
            "x": -0.08582687377929688,
            "y": 0.008436493575572968,
            "z": -394.29876708984375
        },
        {
            "x": -0.0860053300857544,
            "y": 0.00843001902103424,
            "z": -394.1413269042969
        },
        {
            "x": -0.08618360757827759,
            "y": 0.00842352956533432,
            "z": -393.9841003417969
        },
        {
            "x": -0.0863618552684784,
            "y": 0.008417055010795593,
            "z": -393.8268737792969
        },
        {
            "x": -0.08654022216796875,
            "y": 0.00841059535741806,
            "z": -393.6695251464844
        },
        {
            "x": -0.08671841025352478,
            "y": 0.008404120802879333,
            "z": -393.5122985839844
        },
        {
            "x": -0.08689680695533752,
            "y": 0.008397608995437622,
            "z": -393.35498046875
        },
        {
            "x": -0.08707517385482788,
            "y": 0.008391119539737701,
            "z": -393.1976318359375
        },
        {
            "x": -0.08725345134735107,
            "y": 0.008384637534618378,
            "z": -393.0404052734375
        },
        {
            "x": -0.087373286485672,
            "y": 0.008380278944969177,
            "z": -392.9355773925781
        },
        {
            "x": -0.08755254745483398,
            "y": 0.008373759686946869,
            "z": -392.7783508300781
        },
        {
            "x": -0.0877307653427124,
            "y": 0.008367277681827545,
            "z": -392.6211242675781
        },
        {
            "x": -0.08790919184684753,
            "y": 0.008360795676708221,
            "z": -392.46368408203125
        },
        {
            "x": -0.08808746933937073,
            "y": 0.008354328572750092,
            "z": -392.3064880371094
        },
        {
            "x": -0.08826571702957153,
            "y": 0.008347824215888977,
            "z": -392.14923095703125
        },
        {
            "x": -0.08844408392906189,
            "y": 0.008341342210769653,
            "z": -391.99188232421875
        },
        {
            "x": -0.08862236142158508,
            "y": 0.008334867656230927,
            "z": -391.83465576171875
        },
        {
            "x": -0.08880069851875305,
            "y": 0.0083283931016922,
            "z": -391.6772766113281
        },
        {
            "x": -0.08897900581359863,
            "y": 0.008321896195411682,
            "z": -391.5199890136719
        },
        {
            "x": -0.08915728330612183,
            "y": 0.008315406739711761,
            "z": -391.3627624511719
        },
        {
            "x": -0.0893356204032898,
            "y": 0.008308939635753632,
            "z": -391.2054138183594
        },
        {
            "x": -0.08951392769813538,
            "y": 0.008302457630634308,
            "z": -391.0481872558594
        },
        {
            "x": -0.08969217538833618,
            "y": 0.00829596072435379,
            "z": -390.8909606933594
        },
        {
            "x": -0.08987060189247131,
            "y": 0.00828947126865387,
            "z": -390.7335205078125
        },
        {
            "x": -0.0900489091873169,
            "y": 0.008282996714115143,
            "z": -390.5762939453125
        },
        {
            "x": -0.09022721648216248,
            "y": 0.008276514708995819,
            "z": -390.4190368652344
        },
        {
            "x": -0.09040546417236328,
            "y": 0.00827004760503769,
            "z": -390.26171875
        },
        {
            "x": -0.09058377146720886,
            "y": 0.008263543248176575,
            "z": -390.1044921875
        },
        {
            "x": -0.090762197971344,
            "y": 0.008257098495960236,
            "z": -389.9470520019531
        },
        {
            "x": -0.09094047546386719,
            "y": 0.008250609040260315,
            "z": -389.7898254394531
        },
        {
            "x": -0.09111875295639038,
            "y": 0.008244097232818604,
            "z": -389.6325988769531
        },
        {
            "x": -0.0912969708442688,
            "y": 0.00823761522769928,
            "z": -389.475341796875
        },
        {
            "x": -0.09147524833679199,
            "y": 0.008231125771999359,
            "z": -389.318115234375
        },
        {
            "x": -0.09165361523628235,
            "y": 0.008224710822105408,
            "z": -389.1607971191406
        },
        {
            "x": -0.09183189272880554,
            "y": 0.008218184113502502,
            "z": -389.00347900390625
        },
        {
            "x": -0.09201020002365112,
            "y": 0.008211687207221985,
            "z": -388.8462219238281
        },
        {
            "x": -0.09218847751617432,
            "y": 0.008205220103263855,
            "z": -388.68890380859375
        },
        {
            "x": -0.09236672520637512,
            "y": 0.008198738098144531,
            "z": -388.5316467285156
        },
        {
            "x": -0.09254500269889832,
            "y": 0.00819224864244461,
            "z": -388.3744201660156
        },
        {
            "x": -0.09272348880767822,
            "y": 0.0081857368350029,
            "z": -388.2170104980469
        },
        {
            "x": -0.09290173649787903,
            "y": 0.008179277181625366,
            "z": -388.0597839355469
        },
        {
            "x": -0.09308001399040222,
            "y": 0.00817280262708664,
            "z": -387.9024353027344
        },
        {
            "x": -0.0932583212852478,
            "y": 0.008166328072547913,
            "z": -387.74517822265625
        },
        {
            "x": -0.093436598777771,
            "y": 0.008159823715686798,
            "z": -387.58795166015625
        },
        {
            "x": -0.09361499547958374,
            "y": 0.008153356611728668,
            "z": -387.4305419921875
        },
        {
            "x": -0.09379333257675171,
            "y": 0.008146844804286957,
            "z": -387.2732849121094
        },
        {
            "x": -0.09397155046463013,
            "y": 0.00814037024974823,
            "z": -387.1160583496094
        },
        {
            "x": -0.09414985775947571,
            "y": 0.008133888244628906,
            "z": -386.958740234375
        },
        {
            "x": -0.09432819485664368,
            "y": 0.008127398788928986,
            "z": -386.8014831542969
        },
        {
            "x": -0.09450650215148926,
            "y": 0.008120924234390259,
            "z": -386.6441650390625
        },
        {
            "x": -0.09468480944633484,
            "y": 0.008114449679851532,
            "z": -386.4868469238281
        },
        {
            "x": -0.0948631763458252,
            "y": 0.008107945322990417,
            "z": -386.32958984375
        },
        {
            "x": -0.09498190879821777,
            "y": 0.008103623986244202,
            "z": -386.2247619628906
        },
        {
            "x": -0.09516018629074097,
            "y": 0.008097156882286072,
            "z": -386.0675354003906
        },
        {
            "x": -0.09533846378326416,
            "y": 0.008090652525424957,
            "z": -385.9103088378906
        },
        {
            "x": -0.0955168604850769,
            "y": 0.008084170520305634,
            "z": -385.7528991699219
        },
        {
            "x": -0.09569516777992249,
            "y": 0.008077703416347504,
            "z": -385.59564208984375
        },
        {
            "x": -0.09587341547012329,
            "y": 0.00807122141122818,
            "z": -385.43841552734375
        },
        {
            "x": -0.09605172276496887,
            "y": 0.00806473195552826,
            "z": -385.2810974121094
        },
        {
            "x": -0.09622997045516968,
            "y": 0.008058235049247742,
            "z": -385.1238098144531
        },
        {
            "x": -0.09640833735466003,
            "y": 0.008051760494709015,
            "z": -384.9665222167969
        },
        {
            "x": -0.09658664464950562,
            "y": 0.008045285940170288,
            "z": -384.8092041015625
        },
        {
            "x": -0.0967649519443512,
            "y": 0.008038803935050964,
            "z": -384.6519470214844
        },
        {
            "x": -0.09694328904151917,
            "y": 0.00803232192993164,
            "z": -384.4946594238281
        },
        {
            "x": -0.09712153673171997,
            "y": 0.008025839924812317,
            "z": -384.3373718261719
        },
        {
            "x": -0.09729984402656555,
            "y": 0.008019357919692993,
            "z": -384.1801452636719
        },
        {
            "x": -0.09747827053070068,
            "y": 0.008012853562831879,
            "z": -384.022705078125
        },
        {
            "x": -0.0976564884185791,
            "y": 0.00800640881061554,
            "z": -383.8654479980469
        },
        {
            "x": -0.09783485531806946,
            "y": 0.007999897003173828,
            "z": -383.70819091796875
        },
        {
            "x": -0.09801313281059265,
            "y": 0.007993422448635101,
            "z": -383.5509033203125
        },
        {
            "x": -0.09819141030311584,
            "y": 0.007986925542354584,
            "z": -383.3936767578125
        },
        {
            "x": -0.09836980700492859,
            "y": 0.007980450987815857,
            "z": -383.23626708984375
        },
        {
            "x": -0.09854808449745178,
            "y": 0.00797395408153534,
            "z": -383.0790100097656
        },
        {
            "x": -0.09872639179229736,
            "y": 0.007967479526996613,
            "z": -382.9217529296875
        },
        {
            "x": -0.0989045798778534,
            "y": 0.007960990071296692,
            "z": -382.7645263671875
        },
        {
            "x": -0.09908288717269897,
            "y": 0.007954537868499756,
            "z": -382.6072998046875
        },
        {
            "x": -0.09926116466522217,
            "y": 0.007948070764541626,
            "z": -382.45001220703125
        },
        {
            "x": -0.09943953156471252,
            "y": 0.007941558957099915,
            "z": -382.2926330566406
        },
        {
            "x": -0.09961780905723572,
            "y": 0.007935069501399994,
            "z": -382.1354064941406
        },
        {
            "x": -0.09979617595672607,
            "y": 0.007928624749183655,
            "z": -381.97808837890625
        },
        {
            "x": -0.09997445344924927,
            "y": 0.007922127842903137,
            "z": -381.82086181640625
        },
        {
            "x": -0.10015267133712769,
            "y": 0.007915616035461426,
            "z": -381.6636047363281
        },
        {
            "x": -0.10033106803894043,
            "y": 0.007909141480922699,
            "z": -381.50616455078125
        },
        {
            "x": -0.10050931572914124,
            "y": 0.007902689278125763,
            "z": -381.34893798828125
        },
        {
            "x": -0.10068762302398682,
            "y": 0.007896184921264648,
            "z": -381.191650390625
        },
        {
            "x": -0.1008659303188324,
            "y": 0.007889695465564728,
            "z": -381.03436279296875
        },
        {
            "x": -0.10104411840438843,
            "y": 0.007883206009864807,
            "z": -380.87713623046875
        },
        {
            "x": -0.10122227668762207,
            "y": 0.007876761257648468,
            "z": -380.71966552734375
        },
        {
            "x": -0.10140064358711243,
            "y": 0.007870286703109741,
            "z": -380.5624694824219
        },
        {
            "x": -0.10157904028892517,
            "y": 0.007863752543926239,
            "z": -380.4052429199219
        },
        {
            "x": -0.10175657272338867,
            "y": 0.007857285439968109,
            "z": -380.24786376953125
        },
        {
            "x": -0.10193219780921936,
            "y": 0.007850848138332367,
            "z": -380.0906982421875
        },
        {
            "x": -0.1021064817905426,
            "y": 0.007844306528568268,
            "z": -379.933349609375
        },
        {
            "x": -0.10228338837623596,
            "y": 0.00783780962228775,
            "z": -379.7760009765625
        },
        {
            "x": -0.1024567186832428,
            "y": 0.007831327617168427,
            "z": -379.6188049316406
        },
        {
            "x": -0.10256540775299072,
            "y": 0.007827021181583405,
            "z": -379.51397705078125
        },
        {
            "x": -0.10271608829498291,
            "y": 0.007820457220077515,
            "z": -379.3568115234375
        },
        {
            "x": -0.10285419225692749,
            "y": 0.007814019918441772,
            "z": -379.1995849609375
        },
        {
            "x": -0.10299751162528992,
            "y": 0.007807493209838867,
            "z": -379.0421447753906
        },
        {
            "x": -0.10311108827590942,
            "y": 0.007801048457622528,
            "z": -378.8850402832031
        },
        {
            "x": -0.10315200686454773,
            "y": 0.0077945515513420105,
            "z": -378.72802734375
        },
        {
            "x": -0.10310578346252441,
            "y": 0.007788106799125671,
            "z": -378.57080078125
        },
        {
            "x": -0.10302883386611938,
            "y": 0.00778159499168396,
            "z": -378.41363525390625
        },
        {
            "x": -0.1029018759727478,
            "y": 0.007775112986564636,
            "z": -378.25653076171875
        },
        {
            "x": -0.10260593891143799,
            "y": 0.007768616080284119,
            "z": -378.0997009277344
        },
        {
            "x": -0.1020541787147522,
            "y": 0.007762156426906586,
            "z": -377.9429931640625
        },
        {
            "x": -0.10129654407501221,
            "y": 0.007755644619464874,
            "z": -377.7860107421875
        },
        {
            "x": -0.10041037201881409,
            "y": 0.007749132812023163,
            "z": -377.6291809082031
        },
        {
            "x": -0.09926971793174744,
            "y": 0.0077427104115486145,
            "z": -377.47271728515625
        },
        {
            "x": -0.09770515561103821,
            "y": 0.007736213505268097,
            "z": -377.3162536621094
        },
        {
            "x": -0.09574931859970093,
            "y": 0.007729709148406982,
            "z": -377.1597900390625
        },
        {
            "x": -0.09352052211761475,
            "y": 0.0077232494950294495,
            "z": -377.0030517578125
        },
        {
            "x": -0.0909990668296814,
            "y": 0.007716767489910126,
            "z": -376.8466491699219
        },
        {
            "x": -0.08798310160636902,
            "y": 0.007710263133049011,
            "z": -376.6906433105469
        },
        {
            "x": -0.08444002270698547,
            "y": 0.0077037811279296875,
            "z": -376.5343322753906
        },
        {
            "x": -0.08051532506942749,
            "y": 0.007697306573390961,
            "z": -376.3778381347656
        },
        {
            "x": -0.07631301879882812,
            "y": 0.007690824568271637,
            "z": -376.221435546875
        },
        {
            "x": -0.07167473435401917,
            "y": 0.007684379816055298,
            "z": -376.0653991699219
        },
        {
            "x": -0.06647151708602905,
            "y": 0.007677838206291199,
            "z": -375.9095153808594
        },
        {
            "x": -0.06076538562774658,
            "y": 0.007671363651752472,
            "z": -375.7532653808594
        },
        {
            "x": -0.05473607778549194,
            "y": 0.007664881646633148,
            "z": -375.59661865234375
        },
        {
            "x": -0.048392027616500854,
            "y": 0.007658444344997406,
            "z": -375.4404296875
        },
        {
            "x": -0.041549086570739746,
            "y": 0.007651910185813904,
            "z": -375.2845153808594
        },
        {
            "x": -0.03414517641067505,
            "y": 0.007645465433597565,
            "z": -375.128662109375
        },
        {
            "x": -0.02630576491355896,
            "y": 0.00763896107673645,
            "z": -374.9723205566406
        },
        {
            "x": -0.01817592978477478,
            "y": 0.0076324790716171265,
            "z": -374.81573486328125
        },
        {
            "x": -0.0096893310546875,
            "y": 0.007625989615917206,
            "z": -374.6598205566406
        },
        {
            "x": -0.0006673336029052734,
            "y": 0.007619529962539673,
            "z": -374.5040283203125
        },
        {
            "x": 0.008883148431777954,
            "y": 0.007613018155097961,
            "z": -374.3479919433594
        },
        {
            "x": 0.01879599690437317,
            "y": 0.0076065585017204285,
            "z": -374.1916809082031
        },
        {
            "x": 0.028989136219024658,
            "y": 0.007600083947181702,
            "z": -374.0353698730469
        },
        {
            "x": 0.03959527611732483,
            "y": 0.007593587040901184,
            "z": -373.8796691894531
        },
        {
            "x": 0.050743430852890015,
            "y": 0.007587097585201263,
            "z": -373.7239990234375
        },
        {
            "x": 0.06238099932670593,
            "y": 0.0075806379318237305,
            "z": -373.56787109375
        },
        {
            "x": 0.074297696352005,
            "y": 0.007574133574962616,
            "z": -373.41168212890625
        },
        {
            "x": 0.08652251958847046,
            "y": 0.007567666471004486,
            "z": -373.2557373046875
        },
        {
            "x": 0.09921669960021973,
            "y": 0.007561199367046356,
            "z": -373.1001281738281
        },
        {
            "x": 0.11245197057723999,
            "y": 0.007554680109024048,
            "z": -372.9444580078125
        },
        {
            "x": 0.12150552868843079,
            "y": 0.007550343871116638,
            "z": -372.84051513671875
        },
        {
            "x": 0.13529741764068604,
            "y": 0.0075438618659973145,
            "z": -372.6844177246094
        },
        {
            "x": 0.14939075708389282,
            "y": 0.007537409663200378,
            "z": -372.5287170410156
        },
        {
            "x": 0.16396892070770264,
            "y": 0.007530882954597473,
            "z": -372.3731689453125
        },
        {
            "x": 0.17905586957931519,
            "y": 0.007524438202381134,
            "z": -372.2176208496094
        },
        {
            "x": 0.19451650977134705,
            "y": 0.0075179338455200195,
            "z": -372.0617370605469
        },
        {
            "x": 0.21022433042526245,
            "y": 0.007511459290981293,
            "z": -371.9058837890625
        },
        {
            "x": 0.22629192471504211,
            "y": 0.007504992187023163,
            "z": -371.75048828125
        },
        {
            "x": 0.24286076426506042,
            "y": 0.007498465478420258,
            "z": -371.5951843261719
        },
        {
            "x": 0.2599046528339386,
            "y": 0.0074920207262039185,
            "z": -371.4395751953125
        },
        {
            "x": 0.2772535979747772,
            "y": 0.007485494017601013,
            "z": -371.2837829589844
        },
        {
            "x": 0.29485762119293213,
            "y": 0.007479049265384674,
            "z": -371.1282653808594
        },
        {
            "x": 0.3128471076488495,
            "y": 0.00747256726026535,
            "z": -370.9731750488281
        },
        {
            "x": 0.33134204149246216,
            "y": 0.0074660927057266235,
            "z": -370.8180236816406
        },
        {
            "x": 0.3502803444862366,
            "y": 0.007459595799446106,
            "z": -370.662353515625
        },
        {
            "x": 0.3694438934326172,
            "y": 0.007453098893165588,
            "z": -370.5068359375
        },
        {
            "x": 0.38889408111572266,
            "y": 0.0074466317892074585,
            "z": -370.3516845703125
        },
        {
            "x": 0.40878185629844666,
            "y": 0.007440127432346344,
            "z": -370.1967468261719
        },
        {
            "x": 0.4291616976261139,
            "y": 0.007433652877807617,
            "z": -370.04168701171875
        },
        {
            "x": 0.44990116357803345,
            "y": 0.007427148520946503,
            "z": -369.88616943359375
        },
        {
            "x": 0.4708344340324402,
            "y": 0.007420673966407776,
            "z": -369.7309875488281
        },
        {
            "x": 0.4920961558818817,
            "y": 0.007414229214191437,
            "z": -369.576171875
        },
        {
            "x": 0.5138320922851562,
            "y": 0.007407762110233307,
            "z": -369.4214782714844
        },
        {
            "x": 0.5360103845596313,
            "y": 0.0074012503027915955,
            "z": -369.26654052734375
        },
        {
            "x": 0.5584613084793091,
            "y": 0.007394768297672272,
            "z": -369.1112976074219
        },
        {
            "x": 0.5811463594436646,
            "y": 0.007388271391391754,
            "z": -368.9563903808594
        },
        {
            "x": 0.6042048335075378,
            "y": 0.007381804287433624,
            "z": -368.8018798828125
        },
        {
            "x": 0.6277526617050171,
            "y": 0.007375344634056091,
            "z": -368.6471862792969
        },
        {
            "x": 0.6516512632369995,
            "y": 0.00736883282661438,
            "z": -368.4923400878906
        },
        {
            "x": 0.6757597923278809,
            "y": 0.007362358272075653,
            "z": -368.3375244140625
        },
        {
            "x": 0.7001721858978271,
            "y": 0.007355876266956329,
            "z": -368.182861328125
        },
        {
            "x": 0.7249785661697388,
            "y": 0.007349386811256409,
            "z": -368.0285949707031
        },
        {
            "x": 0.7502316832542419,
            "y": 0.007342897355556488,
            "z": -367.8740539550781
        },
        {
            "x": 0.775776743888855,
            "y": 0.007336415350437164,
            "z": -367.7193298339844
        },
        {
            "x": 0.8015155792236328,
            "y": 0.0073299407958984375,
            "z": -367.5648498535156
        },
        {
            "x": 0.8276140093803406,
            "y": 0.007323466241359711,
            "z": -367.4105529785156
        },
        {
            "x": 0.8541067838668823,
            "y": 0.007316999137401581,
            "z": -367.2565002441406
        },
        {
            "x": 0.8809956312179565,
            "y": 0.00731050968170166,
            "z": -367.10211181640625
        },
        {
            "x": 0.9081367254257202,
            "y": 0.007304005324840546,
            "z": -366.9476318359375
        },
        {
            "x": 0.9354698657989502,
            "y": 0.007297538220882416,
            "z": -366.79351806640625
        },
        {
            "x": 0.9631856083869934,
            "y": 0.007291056215763092,
            "z": -366.63958740234375
        },
        {
            "x": 0.9913261532783508,
            "y": 0.007284566760063171,
            "z": -366.485595703125
        },
        {
            "x": 1.0197856426239014,
            "y": 0.007278114557266235,
            "z": -366.3314208984375
        },
        {
            "x": 1.0388720035552979,
            "y": 0.007273748517036438,
            "z": -366.2286376953125
        },
        {
            "x": 1.067657470703125,
            "y": 0.00726725161075592,
            "z": -366.0747985839844
        },
        {
            "x": 1.0968011617660522,
            "y": 0.007260754704475403,
            "z": -365.92120361328125
        },
        {
            "x": 1.1264125108718872,
            "y": 0.007254213094711304,
            "z": -365.7673034667969
        },
        {
            "x": 1.156290888786316,
            "y": 0.007247753441333771,
            "z": -365.6134033203125
        },
        {
            "x": 1.186352252960205,
            "y": 0.007241293787956238,
            "z": -365.4596252441406
        },
        {
            "x": 1.216681718826294,
            "y": 0.007234826683998108,
            "z": -365.3059997558594
        },
        {
            "x": 1.2473748922348022,
            "y": 0.00722832977771759,
            "z": -365.15264892578125
        },
        {
            "x": 1.278485655784607,
            "y": 0.0072218626737594604,
            "z": -364.9990234375
        },
        {
            "x": 1.3098193407058716,
            "y": 0.007215358316898346,
            "z": -364.84527587890625
        },
        {
            "x": 1.341310739517212,
            "y": 0.007208876311779022,
            "z": -364.69183349609375
        },
        {
            "x": 1.3731216192245483,
            "y": 0.007202401757240295,
            "z": -364.53857421875
        },
        {
            "x": 1.405302882194519,
            "y": 0.007195919752120972,
            "z": -364.385498046875
        },
        {
            "x": 1.4378159046173096,
            "y": 0.007189445197582245,
            "z": -364.23211669921875
        },
        {
            "x": 1.4705545902252197,
            "y": 0.007182948291301727,
            "z": -364.07855224609375
        },
        {
            "x": 1.5034639835357666,
            "y": 0.0071764737367630005,
            "z": -363.9255065917969
        },
        {
            "x": 1.5367038249969482,
            "y": 0.007169991731643677,
            "z": -363.77252197265625
        },
        {
            "x": 1.5703158378601074,
            "y": 0.007163509726524353,
            "z": -363.61956787109375
        },
        {
            "x": 1.6041921377182007,
            "y": 0.007156983017921448,
            "z": -363.4664306640625
        },
        {
            "x": 1.63828706741333,
            "y": 0.007150523364543915,
            "z": -363.3132019042969
        },
        {
            "x": 1.6725490093231201,
            "y": 0.007144026458263397,
            "z": -363.1604309082031
        },
        {
            "x": 1.7071478366851807,
            "y": 0.007137559354305267,
            "z": -363.00787353515625
        },
        {
            "x": 1.742106556892395,
            "y": 0.007131054997444153,
            "z": -362.8551025390625
        },
        {
            "x": 1.7772819995880127,
            "y": 0.007124565541744232,
            "z": -362.7021789550781
        },
        {
            "x": 1.8126378059387207,
            "y": 0.007118113338947296,
            "z": -362.5494689941406
        },
        {
            "x": 1.8482420444488525,
            "y": 0.007111631333827972,
            "z": -362.3970031738281
        },
        {
            "x": 1.8841749429702759,
            "y": 0.007105126976966858,
            "z": -362.2445983886719
        },
        {
            "x": 1.920457124710083,
            "y": 0.007098667323589325,
            "z": -362.0919494628906
        },
        {
            "x": 1.956862449645996,
            "y": 0.007092207670211792,
            "z": -361.93939208984375
        },
        {
            "x": 1.9934546947479248,
            "y": 0.007085680961608887,
            "z": -361.7870788574219
        },
        {
            "x": 2.0303702354431152,
            "y": 0.007079221308231354,
            "z": -361.63482666015625
        },
        {
            "x": 2.0675981044769287,
            "y": 0.007072709500789642,
            "z": -361.48260498046875
        },
        {
            "x": 2.105088233947754,
            "y": 0.0070662349462509155,
            "z": -361.3302001953125
        },
        {
            "x": 2.142714738845825,
            "y": 0.007059767842292786,
            "z": -361.1778869628906
        },
        {
            "x": 2.1805076599121094,
            "y": 0.007053278386592865,
            "z": -361.02587890625
        },
        {
            "x": 2.21867036819458,
            "y": 0.007046803832054138,
            "z": -360.8739013671875
        },
        {
            "x": 2.2571005821228027,
            "y": 0.007040299475193024,
            "z": -360.7218933105469
        },
        {
            "x": 2.2957279682159424,
            "y": 0.007033839821815491,
            "z": -360.5697937011719
        },
        {
            "x": 2.3344900608062744,
            "y": 0.007027380168437958,
            "z": -360.4178161621094
        },
        {
            "x": 2.3734779357910156,
            "y": 0.007020860910415649,
            "z": -360.2661437988281
        },
        {
            "x": 2.412809133529663,
            "y": 0.007014408707618713,
            "z": -360.1144714355469
        },
        {
            "x": 2.452392339706421,
            "y": 0.007007889449596405,
            "z": -359.96258544921875
        },
        {
            "x": 2.492133378982544,
            "y": 0.007001414895057678,
            "z": -359.810791015625
        },
        {
            "x": 2.518683433532715,
            "y": 0.006997108459472656,
            "z": -359.7097473144531
        },
        {
            "x": 2.5587122440338135,
            "y": 0.006990619003772736,
            "z": -359.55828857421875
        },
        {
            "x": 2.5990257263183594,
            "y": 0.006984159350395203,
            "z": -359.40692138671875
        },
        {
            "x": 2.639669418334961,
            "y": 0.006977647542953491,
            "z": -359.2551574707031
        },
        {
            "x": 2.6803886890411377,
            "y": 0.006971172988414764,
            "z": -359.1036682128906
        },
        {
            "x": 2.721259117126465,
            "y": 0.00696466863155365,
            "z": -358.95233154296875
        },
        {
            "x": 2.762396812438965,
            "y": 0.006958223879337311,
            "z": -358.8011169433594
        },
        {
            "x": 2.8038175106048584,
            "y": 0.00695173442363739,
            "z": -358.6498718261719
        },
        {
            "x": 2.8454740047454834,
            "y": 0.006945230066776276,
            "z": -358.49853515625
        },
        {
            "x": 2.88724946975708,
            "y": 0.006938740611076355,
            "z": -358.34716796875
        },
        {
            "x": 2.929147720336914,
            "y": 0.006932258605957031,
            "z": -358.19622802734375
        },
        {
            "x": 2.9713263511657715,
            "y": 0.006925813853740692,
            "z": -358.04522705078125
        },
        {
            "x": 3.0137579441070557,
            "y": 0.006919309496879578,
            "z": -357.8941955566406
        },
        {
            "x": 3.05635142326355,
            "y": 0.006912820041179657,
            "z": -357.7431945800781
        },
        {
            "x": 3.0991108417510986,
            "y": 0.006906323134899139,
            "z": -357.592041015625
        },
        {
            "x": 3.1419944763183594,
            "y": 0.0068998783826828,
            "z": -357.44134521484375
        },
        {
            "x": 3.1851706504821777,
            "y": 0.006893366575241089,
            "z": -357.2906188964844
        },
        {
            "x": 3.228586196899414,
            "y": 0.006886884570121765,
            "z": -357.1397399902344
        },
        {
            "x": 3.2720892429351807,
            "y": 0.006880424916744232,
            "z": -356.9889831542969
        },
        {
            "x": 3.315791368484497,
            "y": 0.006873928010463715,
            "z": -356.838134765625
        },
        {
            "x": 3.359624147415161,
            "y": 0.0068674236536026,
            "z": -356.687744140625
        },
        {
            "x": 3.4037137031555176,
            "y": 0.006860949099063873,
            "z": -356.5372314453125
        },
        {
            "x": 3.448012590408325,
            "y": 0.00685448944568634,
            "z": -356.3865966796875
        },
        {
            "x": 3.4923934936523438,
            "y": 0.006847992539405823,
            "z": -356.2361145019531
        },
        {
            "x": 3.536945343017578,
            "y": 0.006841495633125305,
            "z": -356.0857238769531
        },
        {
            "x": 3.581721782684326,
            "y": 0.006835021078586578,
            "z": -355.93536376953125
        },
        {
            "x": 3.626692295074463,
            "y": 0.006828516721725464,
            "z": -355.78509521484375
        },
        {
            "x": 3.671868324279785,
            "y": 0.006822027266025543,
            "z": -355.6346130371094
        },
        {
            "x": 3.7170848846435547,
            "y": 0.006815552711486816,
            "z": -355.4843444824219
        },
        {
            "x": 3.7624588012695312,
            "y": 0.006809070706367493,
            "z": -355.3343200683594
        },
        {
            "x": 3.808115243911743,
            "y": 0.006802581250667572,
            "z": -355.1841125488281
        },
        {
            "x": 3.8539233207702637,
            "y": 0.006796106696128845,
            "z": -355.03399658203125
        },
        {
            "x": 3.8998641967773438,
            "y": 0.006789609789848328,
            "z": -354.8838195800781
        },
        {
            "x": 3.9459025859832764,
            "y": 0.006783150136470795,
            "z": -354.7337951660156
        },
        {
            "x": 3.9920921325683594,
            "y": 0.006776660680770874,
            "z": -354.5838928222656
        },
        {
            "x": 4.0385613441467285,
            "y": 0.0067701563239097595,
            "z": -354.4338684082031
        },
        {
            "x": 4.08513879776001,
            "y": 0.0067636966705322266,
            "z": -354.2839660644531
        },
        {
            "x": 4.131809711456299,
            "y": 0.0067572221159935,
            "z": -354.13409423828125
        },
        {
            "x": 4.178623676300049,
            "y": 0.006750732660293579,
            "z": -353.98419189453125
        },
        {
            "x": 4.225577354431152,
            "y": 0.0067442357540130615,
            "z": -353.8345947265625
        },
        {
            "x": 4.272762298583984,
            "y": 0.006737768650054932,
            "z": -353.6849060058594
        },
        {
            "x": 4.320106029510498,
            "y": 0.006731286644935608,
            "z": -353.5350341796875
        },
        {
            "x": 4.3674774169921875,
            "y": 0.006724812090396881,
            "z": -353.3853454589844
        },
        {
            "x": 4.399116039276123,
            "y": 0.006720453500747681,
            "z": -353.28570556640625
        },
        {
            "x": 4.4467315673828125,
            "y": 0.006713949143886566,
            "z": -353.13623046875
        },
        {
            "x": 4.49452018737793,
            "y": 0.006707444787025452,
            "z": -352.9867858886719
        },
        {
            "x": 4.542537212371826,
            "y": 0.006700970232486725,
            "z": -352.8370361328125
        },
        {
            "x": 4.590552806854248,
            "y": 0.006694503128528595,
            "z": -352.6875915527344
        },
        {
            "x": 4.638674259185791,
            "y": 0.0066879913210868835,
            "z": -352.5382385253906
        },
        {
            "x": 4.686999797821045,
            "y": 0.006681531667709351,
            "z": -352.38885498046875
        },
        {
            "x": 4.735458850860596,
            "y": 0.006675019860267639,
            "z": -352.2395324707031
        },
        {
            "x": 4.7840752601623535,
            "y": 0.006668545305728912,
            "z": -352.0900573730469
        },
        {
            "x": 4.83273458480835,
            "y": 0.006662048399448395,
            "z": -351.94073486328125
        },
        {
            "x": 4.88148307800293,
            "y": 0.006655551493167877,
            "z": -351.7916259765625
        },
        {
            "x": 4.9304609298706055,
            "y": 0.006649099290370941,
            "z": -351.64239501953125
        },
        {
            "x": 4.979527473449707,
            "y": 0.00664258748292923,
            "z": -351.49322509765625
        },
        {
            "x": 5.0286736488342285,
            "y": 0.006636105477809906,
            "z": -351.3440856933594
        },
        {
            "x": 5.077969074249268,
            "y": 0.006629623472690582,
            "z": -351.19482421875
        },
        {
            "x": 5.127312183380127,
            "y": 0.0066231489181518555,
            "z": -351.0458679199219
        },
        {
            "x": 5.176839828491211,
            "y": 0.006616666913032532,
            "z": -350.8968200683594
        },
        {
            "x": 5.226493835449219,
            "y": 0.006610147655010223,
            "z": -350.7477722167969
        },
        {
            "x": 5.27620792388916,
            "y": 0.006603702902793884,
            "z": -350.5987854003906
        },
        {
            "x": 5.326039791107178,
            "y": 0.006597176194190979,
            "z": -350.4497375488281
        },
        {
            "x": 5.3759379386901855,
            "y": 0.00659073144197464,
            "z": -350.3009338378906
        },
        {
            "x": 5.425976276397705,
            "y": 0.006597389001399279,
            "z": -350.152099609375
        },
        {
            "x": 5.47611665725708,
            "y": 0.006806198041886091,
            "z": -350.00323486328125
        },
        {
            "x": 5.526307582855225,
            "y": 0.007326476741582155,
            "z": -349.8544006347656
        },
        {
            "x": 5.57660436630249,
            "y": 0.00816625077277422,
            "z": -349.7056884765625
        },
        {
            "x": 5.627050876617432,
            "y": 0.00930836796760559,
            "z": -349.556884765625
        },
        {
            "x": 5.677581787109375,
            "y": 0.010747699998319149,
            "z": -349.408203125
        },
        {
            "x": 5.728207111358643,
            "y": 0.012482315301895142,
            "z": -349.25946044921875
        },
        {
            "x": 5.778869152069092,
            "y": 0.014517975971102715,
            "z": -349.11077880859375
        },
        {
            "x": 5.829599380493164,
            "y": 0.01683679409325123,
            "z": -348.9622802734375
        },
        {
            "x": 5.8805155754089355,
            "y": 0.019439231604337692,
            "z": -348.8135986328125
        },
        {
            "x": 5.931473255157471,
            "y": 0.022316792979836464,
            "z": -348.6650390625
        },
        {
            "x": 5.982516765594482,
            "y": 0.025480754673480988,
            "z": -348.51641845703125
        },
        {
            "x": 6.033600807189941,
            "y": 0.0289103202521801,
            "z": -348.3678894042969
        },
        {
            "x": 6.084754467010498,
            "y": 0.03260064870119095,
            "z": -348.21954345703125
        },
        {
            "x": 6.136086940765381,
            "y": 0.03655638545751572,
            "z": -348.0709533691406
        },
        {
            "x": 6.187432289123535,
            "y": 0.040775544941425323,
            "z": -347.9225158691406
        },
        {
            "x": 6.238825798034668,
            "y": 0.04524491727352142,
            "z": -347.774169921875
        },
        {
            "x": 6.290285587310791,
            "y": 0.04996025189757347,
            "z": -347.62579345703125
        },
        {
            "x": 6.341830253601074,
            "y": 0.054915957152843475,
            "z": -347.47747802734375
        },
        {
            "x": 6.393479824066162,
            "y": 0.06012368202209473,
            "z": -347.3291320800781
        },
        {
            "x": 6.445191383361816,
            "y": 0.06556645035743713,
            "z": -347.1807556152344
        },
        {
            "x": 6.496912956237793,
            "y": 0.07123447954654694,
            "z": -347.0325012207031
        },
        {
            "x": 6.53140926361084,
            "y": 0.07513640820980072,
            "z": -346.93377685546875
        },
        {
            "x": 6.583254814147949,
            "y": 0.08118283748626709,
            "z": -346.78558349609375
        },
        {
            "x": 6.635166645050049,
            "y": 0.08744624257087708,
            "z": -346.637451171875
        },
        {
            "x": 6.687185287475586,
            "y": 0.09393271803855896,
            "z": -346.48907470703125
        },
        {
            "x": 6.739173889160156,
            "y": 0.10062641650438309,
            "z": -346.3409729003906
        },
        {
            "x": 6.791224479675293,
            "y": 0.10752537101507187,
            "z": -346.19293212890625
        },
        {
            "x": 6.843357086181641,
            "y": 0.11462722718715668,
            "z": -346.04486083984375
        },
        {
            "x": 6.8955464363098145,
            "y": 0.12192463874816895,
            "z": -345.89678955078125
        },
        {
            "x": 6.947805404663086,
            "y": 0.12942613661289215,
            "z": -345.7486572265625
        },
        {
            "x": 7.000079154968262,
            "y": 0.13711485266685486,
            "z": -345.6005859375
        },
        {
            "x": 7.052369594573975,
            "y": 0.14498089253902435,
            "z": -345.45263671875
        },
        {
            "x": 7.1047682762146,
            "y": 0.153033047914505,
            "z": -345.3045654296875
        },
        {
            "x": 7.15716028213501,
            "y": 0.16125871241092682,
            "z": -345.15667724609375
        },
        {
            "x": 7.209596157073975,
            "y": 0.16965943574905396,
            "z": -345.0087585449219
        },
        {
            "x": 7.262105941772461,
            "y": 0.17823389172554016,
            "z": -344.8607177734375
        },
        {
            "x": 7.314602851867676,
            "y": 0.18696078658103943,
            "z": -344.7128601074219
        },
        {
            "x": 7.367170810699463,
            "y": 0.19585037231445312,
            "z": -344.56500244140625
        },
        {
            "x": 7.419770240783691,
            "y": 0.2049008011817932,
            "z": -344.4170837402344
        },
        {
            "x": 7.47236442565918,
            "y": 0.2140936553478241,
            "z": -344.269287109375
        },
        {
            "x": 7.525053024291992,
            "y": 0.22344186902046204,
            "z": -344.121337890625
        },
        {
            "x": 7.57773494720459,
            "y": 0.23292413353919983,
            "z": -343.97357177734375
        },
        {
            "x": 7.630445957183838,
            "y": 0.2425483763217926,
            "z": -343.8257751464844
        },
        {
            "x": 7.683152675628662,
            "y": 0.2523007094860077,
            "z": -343.6780090332031
        },
        {
            "x": 7.735884666442871,
            "y": 0.2621796429157257,
            "z": -343.5303039550781
        },
        {
            "x": 7.788674354553223,
            "y": 0.2721927762031555,
            "z": -343.3824768066406
        },
        {
            "x": 7.841484069824219,
            "y": 0.2823256850242615,
            "z": -343.2347106933594
        },
        {
            "x": 7.894285678863525,
            "y": 0.29256805777549744,
            "z": -343.0870666503906
        },
        {
            "x": 7.947144031524658,
            "y": 0.30292999744415283,
            "z": -342.9392395019531
        },
        {
            "x": 7.9999871253967285,
            "y": 0.31339138746261597,
            "z": -342.7915954589844
        },
        {
            "x": 8.05282211303711,
            "y": 0.3239580988883972,
            "z": -342.6438903808594
        },
        {
            "x": 8.105772018432617,
            "y": 0.334638774394989,
            "z": -342.4960021972656
        },
        {
            "x": 8.158645629882812,
            "y": 0.34539592266082764,
            "z": -342.3484191894531
        },
        {
            "x": 8.211549758911133,
            "y": 0.3562493622303009,
            "z": -342.2006530761719
        },
        {
            "x": 8.264452934265137,
            "y": 0.36718595027923584,
            "z": -342.0530700683594
        },
        {
            "x": 8.317375183105469,
            "y": 0.3782058656215668,
            "z": -341.9053955078125
        },
        {
            "x": 8.370360374450684,
            "y": 0.3893173933029175,
            "z": -341.757568359375
        },
        {
            "x": 8.423260688781738,
            "y": 0.40048524737358093,
            "z": -341.6098937988281
        },
        {
            "x": 8.476164817810059,
            "y": 0.41172346472740173,
            "z": -341.4622802734375
        },
        {
            "x": 8.52912425994873,
            "y": 0.42303702235221863,
            "z": -341.314453125
        },
        {
            "x": 8.582033157348633,
            "y": 0.4343984127044678,
            "z": -341.1668701171875
        },
        {
            "x": 8.634988784790039,
            "y": 0.4458274841308594,
            "z": -341.01910400390625
        },
        {
            "x": 8.687929153442383,
            "y": 0.4573092758655548,
            "z": -340.871337890625
        },
        {
            "x": 8.740819931030273,
            "y": 0.46882715821266174,
            "z": -340.7237548828125
        },
        {
            "x": 8.77608871459961,
            "y": 0.4765315055847168,
            "z": -340.62530517578125
        },
        {
            "x": 8.828975677490234,
            "y": 0.48812130093574524,
            "z": -340.4776611328125
        },
        {
            "x": 8.881853103637695,
            "y": 0.49974939227104187,
            "z": -340.3299560546875
        },
        {
            "x": 8.934783935546875,
            "y": 0.5114215612411499,
            "z": -340.18212890625
        },
        {
            "x": 8.98763656616211,
            "y": 0.5231069326400757,
            "z": -340.0343933105469
        },
        {
            "x": 9.040482521057129,
            "y": 0.534816563129425,
            "z": -339.88671875
        },
        {
            "x": 9.09333610534668,
            "y": 0.546553909778595,
            "z": -339.7389221191406
        },
        {
            "x": 9.146125793457031,
            "y": 0.5582958459854126,
            "z": -339.5912170410156
        },
        {
            "x": 9.198933601379395,
            "y": 0.5700551271438599,
            "z": -339.4434509277344
        },
        {
            "x": 9.251712799072266,
            "y": 0.5818177461624146,
            "z": -339.29571533203125
        },
        {
            "x": 9.304462432861328,
            "y": 0.5935800075531006,
            "z": -339.1479797363281
        },
        {
            "x": 9.35720443725586,
            "y": 0.6053470373153687,
            "z": -339.0001525878906
        },
        {
            "x": 9.409870147705078,
            "y": 0.6170994639396667,
            "z": -338.8524169921875
        },
        {
            "x": 9.462514877319336,
            "y": 0.6288394927978516,
            "z": -338.7046813964844
        },
        {
            "x": 9.515233039855957,
            "y": 0.6405820846557617,
            "z": -338.5566711425781
        },
        {
            "x": 9.567842483520508,
            "y": 0.652290940284729,
            "z": -338.4089050292969
        },
        {
            "x": 9.620409965515137,
            "y": 0.6639784574508667,
            "z": -338.2610168457031
        },
        {
            "x": 9.67293930053711,
            "y": 0.6756377816200256,
            "z": -338.1131896972656
        },
        {
            "x": 9.72543716430664,
            "y": 0.6872599124908447,
            "z": -337.9653625488281
        },
        {
            "x": 9.77797794342041,
            "y": 0.6988624930381775,
            "z": -337.8172912597656
        },
        {
            "x": 9.830405235290527,
            "y": 0.7104117274284363,
            "z": -337.66937255859375
        },
        {
            "x": 9.882768630981445,
            "y": 0.7219135761260986,
            "z": -337.521484375
        },
        {
            "x": 9.935104370117188,
            "y": 0.7333650588989258,
            "z": -337.37353515625
        },
        {
            "x": 9.987412452697754,
            "y": 0.7447620630264282,
            "z": -337.2256164550781
        },
        {
            "x": 10.039714813232422,
            "y": 0.756111741065979,
            "z": -337.0775146484375
        },
        {
            "x": 10.091949462890625,
            "y": 0.7674016952514648,
            "z": -336.9294128417969
        },
        {
            "x": 10.144098281860352,
            "y": 0.7786165475845337,
            "z": -336.7813720703125
        },
        {
            "x": 10.196195602416992,
            "y": 0.7897595167160034,
            "z": -336.63330078125
        },
        {
            "x": 10.248260498046875,
            "y": 0.8008286952972412,
            "z": -336.4851989746094
        },
        {
            "x": 10.300257682800293,
            "y": 0.8118205666542053,
            "z": -336.33709716796875
        },
        {
            "x": 10.352252006530762,
            "y": 0.8227390050888062,
            "z": -336.188720703125
        },
        {
            "x": 10.40411376953125,
            "y": 0.8335542678833008,
            "z": -336.04058837890625
        },
        {
            "x": 10.455957412719727,
            "y": 0.8442808389663696,
            "z": -335.89239501953125
        },
        {
            "x": 10.507769584655762,
            "y": 0.8549182415008545,
            "z": -335.7440490722656
        },
        {
            "x": 10.559467315673828,
            "y": 0.8654472827911377,
            "z": -335.59576416015625
        },
        {
            "x": 10.611144065856934,
            "y": 0.8758813738822937,
            "z": -335.44732666015625
        },
        {
            "x": 10.662717819213867,
            "y": 0.8861942291259766,
            "z": -335.29901123046875
        },
        {
            "x": 10.714237213134766,
            "y": 0.8963947892189026,
            "z": -335.1506042480469
        },
        {
            "x": 10.765742301940918,
            "y": 0.906487226486206,
            "z": -335.0020751953125
        },
        {
            "x": 10.81711196899414,
            "y": 0.9164503216743469,
            "z": -334.85357666015625
        },
        {
            "x": 10.868396759033203,
            "y": 0.9262875318527222,
            "z": -334.70501708984375
        },
        {
            "x": 10.919622421264648,
            "y": 0.9359925985336304,
            "z": -334.5565490722656
        },
        {
            "x": 10.970800399780273,
            "y": 0.9455634355545044,
            "z": -334.4079895019531
        },
        {
            "x": 11.004875183105469,
            "y": 0.9518648386001587,
            "z": -334.308837890625
        },
        {
            "x": 11.055880546569824,
            "y": 0.9612027406692505,
            "z": -334.16015625
        },
        {
            "x": 11.10678482055664,
            "y": 0.9703912734985352,
            "z": -334.01153564453125
        },
        {
            "x": 11.157649993896484,
            "y": 0.979427695274353,
            "z": -333.86273193359375
        },
        {
            "x": 11.208459854125977,
            "y": 0.9883081912994385,
            "z": -333.7139892578125
        },
        {
            "x": 11.259160041809082,
            "y": 0.997032642364502,
            "z": -333.565185546875
        },
        {
            "x": 11.309771537780762,
            "y": 1.0055981874465942,
            "z": -333.41619873046875
        },
        {
            "x": 11.36023998260498,
            "y": 1.0139806270599365,
            "z": -333.2673034667969
        },
        {
            "x": 11.410693168640137,
            "y": 1.02219820022583,
            "z": -333.11834716796875
        },
        {
            "x": 11.461057662963867,
            "y": 1.030242919921875,
            "z": -332.9692687988281
        },
        {
            "x": 11.511301040649414,
            "y": 1.038108468055725,
            "z": -332.8201599121094
        },
        {
            "x": 11.561402320861816,
            "y": 1.0457782745361328,
            "z": -332.6710510253906
        },
        {
            "x": 11.611403465270996,
            "y": 1.0532549619674683,
            "z": -332.5220031738281
        },
        {
            "x": 11.66134262084961,
            "y": 1.060540795326233,
            "z": -332.3728942871094
        },
        {
            "x": 11.711274147033691,
            "y": 1.067643165588379,
            "z": -332.2234191894531
        },
        {
            "x": 11.760978698730469,
            "y": 1.0745255947113037,
            "z": -332.0740966796875
        },
        {
            "x": 11.810561180114746,
            "y": 1.081200361251831,
            "z": -331.9247741699219
        },
        {
            "x": 11.860064506530762,
            "y": 1.0876644849777222,
            "z": -331.7755126953125
        },
        {
            "x": 11.909496307373047,
            "y": 1.0939176082611084,
            "z": -331.62603759765625
        },
        {
            "x": 11.958830833435059,
            "y": 1.0999492406845093,
            "z": -331.47637939453125
        },
        {
            "x": 12.007952690124512,
            "y": 1.1057490110397339,
            "z": -331.32684326171875
        },
        {
            "x": 12.056962966918945,
            "y": 1.111321210861206,
            "z": -331.17730712890625
        },
        {
            "x": 12.10586929321289,
            "y": 1.116658329963684,
            "z": -331.0278625488281
        },
        {
            "x": 12.15472412109375,
            "y": 1.1217578649520874,
            "z": -330.87811279296875
        },
        {
            "x": 12.203428268432617,
            "y": 1.1266165971755981,
            "z": -330.7283020019531
        },
        {
            "x": 12.25199031829834,
            "y": 1.1312305927276611,
            "z": -330.578369140625
        },
        {
            "x": 12.30038070678711,
            "y": 1.135589838027954,
            "z": -330.42864990234375
        },
        {
            "x": 12.34873104095459,
            "y": 1.1396923065185547,
            "z": -330.2786865234375
        },
        {
            "x": 12.39693832397461,
            "y": 1.1435341835021973,
            "z": -330.12872314453125
        },
        {
            "x": 12.444940567016602,
            "y": 1.1471127271652222,
            "z": -329.978759765625
        },
        {
            "x": 12.492844581604004,
            "y": 1.1504278182983398,
            "z": -329.8285217285156
        },
        {
            "x": 12.540593147277832,
            "y": 1.153458833694458,
            "z": -329.6785583496094
        },
        {
            "x": 12.588266372680664,
            "y": 1.1562142372131348,
            "z": -329.5283508300781
        },
        {
            "x": 12.63578987121582,
            "y": 1.1586921215057373,
            "z": -329.3780822753906
        },
        {
            "x": 12.68307113647461,
            "y": 1.1608844995498657,
            "z": -329.227783203125
        },
        {
            "x": 12.730277061462402,
            "y": 1.1627812385559082,
            "z": -329.0773620605469
        },
        {
            "x": 12.777318000793457,
            "y": 1.1643792390823364,
            "z": -328.9271240234375
        },
        {
            "x": 12.824251174926758,
            "y": 1.165682315826416,
            "z": -328.77667236328125
        },
        {
            "x": 12.871018409729004,
            "y": 1.1666862964630127,
            "z": -328.6259765625
        },
        {
            "x": 12.91754150390625,
            "y": 1.1673736572265625,
            "z": -328.4754638671875
        },
        {
            "x": 12.963935852050781,
            "y": 1.1677473783493042,
            "z": -328.3249816894531
        },
        {
            "x": 13.010271072387695,
            "y": 1.1678074598312378,
            "z": -328.1742858886719
        },
        {
            "x": 13.056406021118164,
            "y": 1.1675527095794678,
            "z": -328.0234375
        },
        {
            "x": 13.087029457092285,
            "y": 1.1672000885009766,
            "z": -327.92291259765625
        },
        {
            "x": 13.132776260375977,
            "y": 1.1664202213287354,
            "z": -327.7721862792969
        },
        {
            "x": 13.178400039672852,
            "y": 1.1653368473052979,
            "z": -327.6214904785156
        },
        {
            "x": 13.223978996276855,
            "y": 1.163942813873291,
            "z": -327.470458984375
        },
        {
            "x": 13.269307136535645,
            "y": 1.1622486114501953,
            "z": -327.3194580078125
        },
        {
            "x": 13.314406394958496,
            "y": 1.1602637767791748,
            "z": -327.16845703125
        },
        {
            "x": 13.359333038330078,
            "y": 1.1579928398132324,
            "z": -327.0173645019531
        },
        {
            "x": 13.404109954833984,
            "y": 1.1554338932037354,
            "z": -326.8664245605469
        },
        {
            "x": 13.448786735534668,
            "y": 1.1525852680206299,
            "z": -326.7151184082031
        },
        {
            "x": 13.493220329284668,
            "y": 1.1494626998901367,
            "z": -326.5636901855469
        },
        {
            "x": 13.53736400604248,
            "y": 1.1460754871368408,
            "z": -326.4124755859375
        },
        {
            "x": 13.581374168395996,
            "y": 1.1424167156219482,
            "z": -326.26123046875
        },
        {
            "x": 13.62524127960205,
            "y": 1.1384915113449097,
            "z": -326.10992431640625
        },
        {
            "x": 13.66893196105957,
            "y": 1.134305477142334,
            "z": -325.9584045410156
        },
        {
            "x": 13.712409019470215,
            "y": 1.1298620700836182,
            "z": -325.8066711425781
        },
        {
            "x": 13.755594253540039,
            "y": 1.125176191329956,
            "z": -325.65521240234375
        },
        {
            "x": 13.798644065856934,
            "y": 1.1202396154403687,
            "z": -325.5037841796875
        },
        {
            "x": 13.84155559539795,
            "y": 1.1150588989257812,
            "z": -325.3520812988281
        },
        {
            "x": 13.884218215942383,
            "y": 1.1096422672271729,
            "z": -325.2002868652344
        },
        {
            "x": 13.926636695861816,
            "y": 1.1039873361587524,
            "z": -325.04833984375
        },
        {
            "x": 13.96880054473877,
            "y": 1.0981124639511108,
            "z": -324.8966979980469
        },
        {
            "x": 14.010839462280273,
            "y": 1.0920121669769287,
            "z": -324.7449645996094
        },
        {
            "x": 14.052693367004395,
            "y": 1.0856866836547852,
            "z": -324.5929260253906
        },
        {
            "x": 14.094240188598633,
            "y": 1.0791478157043457,
            "z": -324.4409484863281
        },
        {
            "x": 14.135541915893555,
            "y": 1.0723952054977417,
            "z": -324.28887939453125
        },
        {
            "x": 14.176682472229004,
            "y": 1.0654401779174805,
            "z": -324.13690185546875
        },
        {
            "x": 14.217646598815918,
            "y": 1.0582833290100098,
            "z": -323.98480224609375
        },
        {
            "x": 14.25839614868164,
            "y": 1.0509161949157715,
            "z": -323.8323974609375
        },
        {
            "x": 14.298781394958496,
            "y": 1.0433610677719116,
            "z": -323.68017578125
        },
        {
            "x": 14.338937759399414,
            "y": 1.0356273651123047,
            "z": -323.52801513671875
        },
        {
            "x": 14.37900447845459,
            "y": 1.0276975631713867,
            "z": -323.3756103515625
        },
        {
            "x": 14.418822288513184,
            "y": 1.0195882320404053,
            "z": -323.22314453125
        },
        {
            "x": 14.458341598510742,
            "y": 1.0112905502319336,
            "z": -323.07049560546875
        },
        {
            "x": 14.497550964355469,
            "y": 1.002833604812622,
            "z": -322.91802978515625
        },
        {
            "x": 14.536537170410156,
            "y": 0.9942229986190796,
            "z": -322.7656555175781
        },
        {
            "x": 14.57542896270752,
            "y": 0.9854294061660767,
            "z": -322.6128845214844
        },
        {
            "x": 14.61401653289795,
            "y": 0.9764688014984131,
            "z": -322.46002197265625
        },
        {
            "x": 14.652239799499512,
            "y": 0.9673659205436707,
            "z": -322.3072814941406
        },
        {
            "x": 14.69023323059082,
            "y": 0.9581185579299927,
            "z": -322.1545104980469
        },
        {
            "x": 14.728042602539062,
            "y": 0.9487310647964478,
            "z": -322.0018005371094
        },
        {
            "x": 14.765661239624023,
            "y": 0.9391769170761108,
            "z": -321.8487243652344
        },
        {
            "x": 14.802943229675293,
            "y": 0.9294852018356323,
            "z": -321.6955261230469
        },
        {
            "x": 14.839862823486328,
            "y": 0.9196788668632507,
            "z": -321.54248046875
        },
        {
            "x": 14.864337921142578,
            "y": 0.9130799770355225,
            "z": -321.4406433105469
        },
        {
            "x": 14.900954246520996,
            "y": 0.9030592441558838,
            "z": -321.28759765625
        },
        {
            "x": 14.937308311462402,
            "y": 0.8929094076156616,
            "z": -321.13427734375
        },
        {
            "x": 14.973356246948242,
            "y": 0.882632315158844,
            "z": -320.9807434082031
        },
        {
            "x": 15.009014129638672,
            "y": 0.8722621202468872,
            "z": -320.8274841308594
        },
        {
            "x": 15.044461250305176,
            "y": 0.8617937564849854,
            "z": -320.67431640625
        },
        {
            "x": 15.079747200012207,
            "y": 0.8512014746665955,
            "z": -320.52081298828125
        },
        {
            "x": 15.114699363708496,
            "y": 0.8405054807662964,
            "z": -320.36712646484375
        },
        {
            "x": 15.149277687072754,
            "y": 0.8297169208526611,
            "z": -320.2135009765625
        },
        {
            "x": 15.183565139770508,
            "y": 0.8188523054122925,
            "z": -320.0599670410156
        },
        {
            "x": 15.217670440673828,
            "y": 0.807897686958313,
            "z": -319.9063720703125
        },
        {
            "x": 15.251533508300781,
            "y": 0.796841561794281,
            "z": -319.7524108886719
        },
        {
            "x": 15.284982681274414,
            "y": 0.7857121229171753,
            "z": -319.5984802246094
        },
        {
            "x": 15.318052291870117,
            "y": 0.7745260000228882,
            "z": -319.4447021484375
        },
        {
            "x": 15.350932121276855,
            "y": 0.763266384601593,
            "z": -319.29083251953125
        },
        {
            "x": 15.3836030960083,
            "y": 0.7519345283508301,
            "z": -319.1368408203125
        },
        {
            "x": 15.415926933288574,
            "y": 0.7405290603637695,
            "z": -318.9825439453125
        },
        {
            "x": 15.447829246520996,
            "y": 0.7290784120559692,
            "z": -318.828369140625
        },
        {
            "x": 15.479424476623535,
            "y": 0.7175921201705933,
            "z": -318.67431640625
        },
        {
            "x": 15.510860443115234,
            "y": 0.7060413360595703,
            "z": -318.5200500488281
        },
        {
            "x": 15.541976928710938,
            "y": 0.6944414377212524,
            "z": -318.3656005859375
        },
        {
            "x": 15.572653770446777,
            "y": 0.6828042268753052,
            "z": -318.21112060546875
        },
        {
            "x": 15.602957725524902,
            "y": 0.6711480617523193,
            "z": -318.0567626953125
        },
        {
            "x": 15.63303279876709,
            "y": 0.6594685912132263,
            "z": -317.9024963378906
        },
        {
            "x": 15.662893295288086,
            "y": 0.6477385759353638,
            "z": -317.74786376953125
        },
        {
            "x": 15.692365646362305,
            "y": 0.6359727382659912,
            "z": -317.5929260253906
        },
        {
            "x": 15.7213773727417,
            "y": 0.6242102384567261,
            "z": -317.4382019042969
        },
        {
            "x": 15.75009822845459,
            "y": 0.6124426126480103,
            "z": -317.2835388183594
        },
        {
            "x": 15.778594017028809,
            "y": 0.600665807723999,
            "z": -317.12884521484375
        },
        {
            "x": 15.806756019592285,
            "y": 0.5888650417327881,
            "z": -316.97381591796875
        },
        {
            "x": 15.83449935913086,
            "y": 0.5770494937896729,
            "z": -316.81854248046875
        },
        {
            "x": 15.861812591552734,
            "y": 0.5652714371681213,
            "z": -316.66363525390625
        },
        {
            "x": 15.88887882232666,
            "y": 0.5535043478012085,
            "z": -316.5086975097656
        },
        {
            "x": 15.915701866149902,
            "y": 0.5417305827140808,
            "z": -316.353515625
        },
        {
            "x": 15.94209098815918,
            "y": 0.5299659967422485,
            "z": -316.1980895996094
        },
        {
            "x": 15.96805477142334,
            "y": 0.5182204246520996,
            "z": -316.0426025390625
        },
        {
            "x": 15.993656158447266,
            "y": 0.5065298676490784,
            "z": -315.8874816894531
        },
        {
            "x": 16.019023895263672,
            "y": 0.4948623776435852,
            "z": -315.732177734375
        },
        {
            "x": 16.044050216674805,
            "y": 0.48319900035858154,
            "z": -315.5764465332031
        },
        {
            "x": 16.06857681274414,
            "y": 0.47158512473106384,
            "z": -315.4207763671875
        },
        {
            "x": 16.092700958251953,
            "y": 0.4600260257720947,
            "z": -315.2652282714844
        },
        {
            "x": 16.1165714263916,
            "y": 0.44851580262184143,
            "z": -315.109619140625
        },
        {
            "x": 16.140127182006836,
            "y": 0.437045156955719,
            "z": -314.953857421875
        },
        {
            "x": 16.155595779418945,
            "y": 0.42941948771476746,
            "z": -314.8498840332031
        },
        {
            "x": 16.178359985351562,
            "y": 0.4180416464805603,
            "z": -314.6939697265625
        },
        {
            "x": 16.200727462768555,
            "y": 0.4067455530166626,
            "z": -314.5382385253906
        },
        {
            "x": 16.222875595092773,
            "y": 0.3954983353614807,
            "z": -314.3822326660156
        },
        {
            "x": 16.24466323852539,
            "y": 0.38431406021118164,
            "z": -314.22607421875
        },
        {
            "x": 16.26595115661621,
            "y": 0.3732009828090668,
            "z": -314.06982421875
        },
        {
            "x": 16.286762237548828,
            "y": 0.3621803820133209,
            "z": -313.9136047363281
        },
        {
            "x": 16.30726432800293,
            "y": 0.35126131772994995,
            "z": -313.75762939453125
        },
        {
            "x": 16.3275146484375,
            "y": 0.3404002785682678,
            "z": -313.6012268066406
        },
        {
            "x": 16.347291946411133,
            "y": 0.32961881160736084,
            "z": -313.444580078125
        },
        {
            "x": 16.366504669189453,
            "y": 0.3189568817615509,
            "z": -313.2881164550781
        },
        {
            "x": 16.385358810424805,
            "y": 0.30840376019477844,
            "z": -313.1317443847656
        },
        {
            "x": 16.403942108154297,
            "y": 0.29795408248901367,
            "z": -312.97540283203125
        },
        {
            "x": 16.422134399414062,
            "y": 0.2875921130180359,
            "z": -312.81866455078125
        },
        {
            "x": 16.43977928161621,
            "y": 0.27733367681503296,
            "z": -312.6615905761719
        },
        {
            "x": 16.456932067871094,
            "y": 0.2672267556190491,
            "z": -312.50506591796875
        },
        {
            "x": 16.47381019592285,
            "y": 0.2572406828403473,
            "z": -312.3485412597656
        },
        {
            "x": 16.490360260009766,
            "y": 0.24736009538173676,
            "z": -312.1915588378906
        },
        {
            "x": 16.50636863708496,
            "y": 0.2376057207584381,
            "z": -312.03448486328125
        },
        {
            "x": 16.521846771240234,
            "y": 0.22798629105091095,
            "z": -311.8772888183594
        },
        {
            "x": 16.536951065063477,
            "y": 0.21853476762771606,
            "z": -311.7206726074219
        },
        {
            "x": 16.551769256591797,
            "y": 0.20920932292938232,
            "z": -311.5636291503906
        },
        {
            "x": 16.56610870361328,
            "y": 0.20001542568206787,
            "z": -311.4063415527344
        },
        {
            "x": 16.579858779907227,
            "y": 0.19098159670829773,
            "z": -311.2490539550781
        },
        {
            "x": 16.59316062927246,
            "y": 0.1821148693561554,
            "z": -311.0920104980469
        },
        {
            "x": 16.606176376342773,
            "y": 0.17340627312660217,
            "z": -310.9348449707031
        },
        {
            "x": 16.618793487548828,
            "y": 0.16484752297401428,
            "z": -310.7774353027344
        },
        {
            "x": 16.630823135375977,
            "y": 0.1564498394727707,
            "z": -310.6197509765625
        },
        {
            "x": 16.642301559448242,
            "y": 0.14824262261390686,
            "z": -310.46246337890625
        },
        {
            "x": 16.6534366607666,
            "y": 0.14021983742713928,
            "z": -310.3052978515625
        },
        {
            "x": 16.66425323486328,
            "y": 0.132358118891716,
            "z": -310.147705078125
        },
        {
            "x": 16.67451286315918,
            "y": 0.12467770278453827,
            "z": -309.98992919921875
        },
        {
            "x": 16.68417739868164,
            "y": 0.11719030886888504,
            "z": -309.8321533203125
        },
        {
            "x": 16.693401336669922,
            "y": 0.1099095419049263,
            "z": -309.6747741699219
        },
        {
            "x": 16.702314376831055,
            "y": 0.10282574594020844,
            "z": -309.517333984375
        },
        {
            "x": 16.710765838623047,
            "y": 0.09592255204916,
            "z": -309.3592834472656
        },
        {
            "x": 16.718584060668945,
            "y": 0.08922868967056274,
            "z": -309.20135498046875
        },
        {
            "x": 16.72587013244629,
            "y": 0.08275764435529709,
            "z": -309.043701171875
        },
        {
            "x": 16.732831954956055,
            "y": 0.07650259137153625,
            "z": -308.8861083984375
        },
        {
            "x": 16.7393856048584,
            "y": 0.07045723497867584,
            "z": -308.72821044921875
        },
        {
            "x": 16.74534034729004,
            "y": 0.06462277472019196,
            "z": -308.5700378417969
        },
        {
            "x": 16.75068473815918,
            "y": 0.059020739048719406,
            "z": -308.4120178222656
        },
        {
            "x": 16.755624771118164,
            "y": 0.05366254225373268,
            "z": -308.2544250488281
        },
        {
            "x": 16.75873374938965,
            "y": 0.05022139102220535,
            "z": -308.14923095703125
        },
        {
            "x": 16.76299476623535,
            "y": 0.04523783549666405,
            "z": -307.9910888671875
        },
        {
            "x": 16.766599655151367,
            "y": 0.04049531742930412,
            "z": -307.8329162597656
        },
        {
            "x": 16.769622802734375,
            "y": 0.036006808280944824,
            "z": -307.6747741699219
        },
        {
            "x": 16.77229118347168,
            "y": 0.03177402913570404,
            "z": -307.5170593261719
        },
        {
            "x": 16.774568557739258,
            "y": 0.027782907709479332,
            "z": -307.3590393066406
        },
        {
            "x": 16.776226043701172,
            "y": 0.02404070273041725,
            "z": -307.20062255859375
        },
        {
            "x": 16.777217864990234,
            "y": 0.020573094487190247,
            "z": -307.04248046875
        },
        {
            "x": 16.77777862548828,
            "y": 0.01737193576991558,
            "z": -306.88458251953125
        },
        {
            "x": 16.777999877929688,
            "y": 0.014432523399591446,
            "z": -306.7265625
        },
        {
            "x": 16.777667999267578,
            "y": 0.011759737506508827,
            "z": -306.56817626953125
        },
        {
            "x": 16.776620864868164,
            "y": 0.009371373802423477,
            "z": -306.4097900390625
        },
        {
            "x": 16.775049209594727,
            "y": 0.00726657547056675,
            "z": -306.2518310546875
        },
        {
            "x": 16.77313995361328,
            "y": 0.005443362519145012,
            "z": -306.0939636230469
        },
        {
            "x": 16.770755767822266,
            "y": 0.003900669515132904,
            "z": -305.9355163574219
        },
        {
            "x": 16.76766586303711,
            "y": 0.0026595918461680412,
            "z": -305.7771301269531
        },
        {
            "x": 16.763954162597656,
            "y": 0.0017130323685705662,
            "z": -305.6189880371094
        },
        {
            "x": 16.75984764099121,
            "y": 0.001063541742041707,
            "z": -305.4612121582031
        },
        {
            "x": 16.755353927612305,
            "y": 0.0007142936810851097,
            "z": -305.3032531738281
        },
        {
            "x": 16.750194549560547,
            "y": 0.0006517320871353149,
            "z": -305.1447448730469
        },
        {
            "x": 16.744348526000977,
            "y": 0.0006479471921920776,
            "z": -304.98651123046875
        },
        {
            "x": 16.738012313842773,
            "y": 0.0006441548466682434,
            "z": -304.8287353515625
        },
        {
            "x": 16.731334686279297,
            "y": 0.00064033642411232,
            "z": -304.67095947265625
        },
        {
            "x": 16.72407341003418,
            "y": 0.0006365403532981873,
            "z": -304.5128173828125
        },
        {
            "x": 16.71609115600586,
            "y": 0.000632748007774353,
            "z": -304.3544921875
        },
        {
            "x": 16.7075138092041,
            "y": 0.0006289556622505188,
            "z": -304.196533203125
        },
        {
            "x": 16.698585510253906,
            "y": 0.0006251782178878784,
            "z": -304.0389709472656
        },
        {
            "x": 16.689159393310547,
            "y": 0.0006213672459125519,
            "z": -303.88092041015625
        },
        {
            "x": 16.67903709411621,
            "y": 0.0006175749003887177,
            "z": -303.7227783203125
        },
        {
            "x": 16.668231964111328,
            "y": 0.0006137900054454803,
            "z": -303.5649108886719
        },
        {
            "x": 16.656978607177734,
            "y": 0.0006099827587604523,
            "z": -303.4072570800781
        },
        {
            "x": 16.645341873168945,
            "y": 0.0006062090396881104,
            "z": -303.24969482421875
        },
        {
            "x": 16.6330509185791,
            "y": 0.0006024092435836792,
            "z": -303.0916748046875
        },
        {
            "x": 16.620025634765625,
            "y": 0.000598609447479248,
            "z": -302.93377685546875
        },
        {
            "x": 16.606460571289062,
            "y": 0.0005948320031166077,
            "z": -302.7763366699219
        },
        {
            "x": 16.59250831604004,
            "y": 0.0005910210311412811,
            "z": -302.6189270019531
        },
        {
            "x": 16.57802391052246,
            "y": 0.0005872622132301331,
            "z": -302.4613037109375
        },
        {
            "x": 16.562793731689453,
            "y": 0.0005834400653839111,
            "z": -302.3035583496094
        },
        {
            "x": 16.546905517578125,
            "y": 0.0005796477198600769,
            "z": -302.14605712890625
        },
        {
            "x": 16.530607223510742,
            "y": 0.0005758441984653473,
            "z": -301.98907470703125
        },
        {
            "x": 16.51386260986328,
            "y": 0.0005720667541027069,
            "z": -301.8317565917969
        },
        {
            "x": 16.49641227722168,
            "y": 0.0005682818591594696,
            "z": -301.6741027832031
        },
        {
            "x": 16.478233337402344,
            "y": 0.0005644671618938446,
            "z": -301.5168151855469
        },
        {
            "x": 16.46581268310547,
            "y": 0.0005619488656520844,
            "z": -301.4122009277344
        },
        {
            "x": 16.4468994140625,
            "y": 0.0005581043660640717,
            "z": -301.2554931640625
        },
        {
            "x": 16.427473068237305,
            "y": 0.0005543194711208344,
            "z": -301.0984191894531
        },
        {
            "x": 16.407245635986328,
            "y": 0.0005505308508872986,
            "z": -300.9410095214844
        },
        {
            "x": 16.3863468170166,
            "y": 0.0005467236042022705,
            "z": -300.78411865234375
        },
        {
            "x": 16.365020751953125,
            "y": 0.0005429387092590332,
            "z": -300.627685546875
        },
        {
            "x": 16.3432674407959,
            "y": 0.0005391351878643036,
            "z": -300.4710388183594
        },
        {
            "x": 16.320825576782227,
            "y": 0.0005353502929210663,
            "z": -300.3141784667969
        },
        {
            "x": 16.297592163085938,
            "y": 0.0005315579473972321,
            "z": -300.1573486328125
        },
        {
            "x": 16.273822784423828,
            "y": 0.0005277693271636963,
            "z": -300.00103759765625
        },
        {
            "x": 16.24970817565918,
            "y": 0.0005239658057689667,
            "z": -299.8450012207031
        },
        {
            "x": 16.2249755859375,
            "y": 0.0005201734602451324,
            "z": -299.6884765625
        },
        {
            "x": 16.19947624206543,
            "y": 0.0005163811147212982,
            "z": -299.5320129394531
        },
        {
            "x": 16.173315048217773,
            "y": 0.0005125813186168671,
            "z": -299.3759765625
        },
        {
            "x": 16.146717071533203,
            "y": 0.0005087964236736298,
            "z": -299.2201843261719
        },
        {
            "x": 16.119691848754883,
            "y": 0.0005050003528594971,
            "z": -299.06439208984375
        },
        {
            "x": 16.0919189453125,
            "y": 0.0005012154579162598,
            "z": -298.9082946777344
        },
        {
            "x": 16.063373565673828,
            "y": 0.0004974380135536194,
            "z": -298.75238037109375
        },
        {
            "x": 16.034334182739258,
            "y": 0.0004936382174491882,
            "z": -298.5970764160156
        },
        {
            "x": 16.004892349243164,
            "y": 0.0004898235201835632,
            "z": -298.4417419433594
        },
        {
            "x": 15.974848747253418,
            "y": 0.000486031174659729,
            "z": -298.28619384765625
        },
        {
            "x": 15.944019317626953,
            "y": 0.0004822388291358948,
            "z": -298.1307067871094
        },
        {
            "x": 15.912529945373535,
            "y": 0.0004784390330314636,
            "z": -297.9755859375
        },
        {
            "x": 15.880650520324707,
            "y": 0.0004746653139591217,
            "z": -297.8209533691406
        },
        {
            "x": 15.848278999328613,
            "y": 0.00047086551785469055,
            "z": -297.6661071777344
        },
        {
            "x": 15.815155982971191,
            "y": 0.00046704337000846863,
            "z": -297.5110168457031
        },
        {
            "x": 15.781292915344238,
            "y": 0.0004632622003555298,
            "z": -297.3562316894531
        },
        {
            "x": 15.746926307678223,
            "y": 0.00045948848128318787,
            "z": -297.2019348144531
        },
        {
            "x": 15.71218490600586,
            "y": 0.0004556886851787567,
            "z": -297.0478210449219
        },
        {
            "x": 15.676815032958984,
            "y": 0.0004518777132034302,
            "z": -296.8934631347656
        },
        {
            "x": 15.640602111816406,
            "y": 0.0004481002688407898,
            "z": -296.73895263671875
        },
        {
            "x": 15.603792190551758,
            "y": 0.00044431909918785095,
            "z": -296.5850830078125
        },
        {
            "x": 15.566594123840332,
            "y": 0.00044052302837371826,
            "z": -296.4316101074219
        },
        {
            "x": 15.528901100158691,
            "y": 0.0004367120563983917,
            "z": -296.2779541015625
        },
        {
            "x": 15.490488052368164,
            "y": 0.0004329197108745575,
            "z": -296.12420654296875
        },
        {
            "x": 15.451234817504883,
            "y": 0.00042912736535072327,
            "z": -295.9704895019531
        },
        {
            "x": 15.411537170410156,
            "y": 0.00042534247040748596,
            "z": -295.8175354003906
        },
        {
            "x": 15.37149429321289,
            "y": 0.0004215352237224579,
            "z": -295.664794921875
        },
        {
            "x": 15.330808639526367,
            "y": 0.0004177503287792206,
            "z": -295.51171875
        },
        {
            "x": 15.289310455322266,
            "y": 0.0004139617085456848,
            "z": -295.358642578125
        },
        {
            "x": 15.247154235839844,
            "y": 0.0004101693630218506,
            "z": -295.2060241699219
        },
        {
            "x": 15.204621315002441,
            "y": 0.0004063807427883148,
            "z": -295.05389404296875
        },
        {
            "x": 15.161652565002441,
            "y": 0.0004025883972644806,
            "z": -294.9017333984375
        },
        {
            "x": 15.132615089416504,
            "y": 0.00040005147457122803,
            "z": -294.8002624511719
        },
        {
            "x": 15.088369369506836,
            "y": 0.00039623305201530457,
            "z": -294.6479797363281
        },
        {
            "x": 15.043523788452148,
            "y": 0.0003924518823623657,
            "z": -294.4962463378906
        },
        {
            "x": 14.998306274414062,
            "y": 0.00038864463567733765,
            "z": -294.3448486328125
        },
        {
            "x": 14.952594757080078,
            "y": 0.00038487836718559265,
            "z": -294.19342041015625
        },
        {
            "x": 14.906149864196777,
            "y": 0.00038106366991996765,
            "z": -294.0419006347656
        },
        {
            "x": 14.858925819396973,
            "y": 0.00037728622555732727,
            "z": -293.8905944824219
        },
        {
            "x": 14.811241149902344,
            "y": 0.00037351250648498535,
            "z": -293.7399597167969
        },
        {
            "x": 14.763167381286621,
            "y": 0.00036968663334846497,
            "z": -293.5894470214844
        },
        {
            "x": 14.714524269104004,
            "y": 0.00036592409014701843,
            "z": -293.4387512207031
        },
        {
            "x": 14.665098190307617,
            "y": 0.0003621242940425873,
            "z": -293.2881164550781
        },
        {
            "x": 14.614996910095215,
            "y": 0.00035831332206726074,
            "z": -293.13787841796875
        },
        {
            "x": 14.564553260803223,
            "y": 0.00035451725125312805,
            "z": -292.98828125
        },
        {
            "x": 14.513689041137695,
            "y": 0.00035073235630989075,
            "z": -292.83868408203125
        },
        {
            "x": 14.462080955505371,
            "y": 0.00034693628549575806,
            "z": -292.688720703125
        },
        {
            "x": 14.409728050231934,
            "y": 0.00034314021468162537,
            "z": -292.53912353515625
        },
        {
            "x": 14.356810569763184,
            "y": 0.0003393702208995819,
            "z": -292.3900451660156
        },
        {
            "x": 14.303596496582031,
            "y": 0.00033558160066604614,
            "z": -292.24139404296875
        },
        {
            "x": 14.249890327453613,
            "y": 0.0003317892551422119,
            "z": -292.0926513671875
        },
        {
            "x": 14.195352554321289,
            "y": 0.0003279857337474823,
            "z": -291.9436950683594
        },
        {
            "x": 14.140145301818848,
            "y": 0.0002789737191051245,
            "z": -291.795166015625
        },
        {
            "x": 14.084512710571289,
            "y": -0.000224309042096138,
            "z": -291.6473083496094
        },
        {
            "x": 14.028570175170898,
            "y": -0.001312533626332879,
            "z": -291.499755859375
        },
        {
            "x": 13.97204303741455,
            "y": -0.0029849351849406958,
            "z": -291.35198974609375
        },
        {
            "x": 13.914665222167969,
            "y": -0.005251506343483925,
            "z": -291.2041320800781
        },
        {
            "x": 13.856667518615723,
            "y": -0.008071310818195343,
            "z": -291.0567321777344
        },
        {
            "x": 13.798380851745605,
            "y": -0.011425563134253025,
            "z": -290.9100646972656
        },
        {
            "x": 13.739683151245117,
            "y": -0.015321538783609867,
            "z": -290.7633972167969
        },
        {
            "x": 13.680347442626953,
            "y": -0.01976948231458664,
            "z": -290.6166687011719
        },
        {
            "x": 13.620278358459473,
            "y": -0.024733353406190872,
            "z": -290.4701843261719
        },
        {
            "x": 13.559557914733887,
            "y": -0.030199600383639336,
            "z": -290.323974609375
        },
        {
            "x": 13.498629570007324,
            "y": -0.036138854920864105,
            "z": -290.1784973144531
        },
        {
            "x": 13.437289237976074,
            "y": -0.04258615896105766,
            "z": -290.03302001953125
        },
        {
            "x": 13.375259399414062,
            "y": -0.04951867088675499,
            "z": -289.8874206542969
        },
        {
            "x": 13.312554359436035,
            "y": -0.056909430772066116,
            "z": -289.7422180175781
        },
        {
            "x": 13.249336242675781,
            "y": -0.06474174559116364,
            "z": -289.5973205566406
        },
        {
            "x": 13.185957908630371,
            "y": -0.07300745695829391,
            "z": -289.45306396484375
        },
        {
            "x": 13.122109413146973,
            "y": -0.08171199262142181,
            "z": -289.30877685546875
        },
        {
            "x": 13.057538986206055,
            "y": -0.09085439890623093,
            "z": -289.1643981933594
        },
        {
            "x": 12.992500305175781,
            "y": -0.10038450360298157,
            "z": -289.0205383300781
        },
        {
            "x": 12.927120208740234,
            "y": -0.11030755937099457,
            "z": -288.8771667480469
        },
        {
            "x": 12.861494064331055,
            "y": -0.12061236798763275,
            "z": -288.73394775390625
        },
        {
            "x": 12.79539966583252,
            "y": -0.13130083680152893,
            "z": -288.59075927734375
        },
        {
            "x": 12.751028060913086,
            "y": -0.1386309415102005,
            "z": -288.4953918457031
        },
        {
            "x": 12.684178352355957,
            "y": -0.14991016685962677,
            "z": -288.352783203125
        },
        {
            "x": 12.617166519165039,
            "y": -0.1615113615989685,
            "z": -288.2105407714844
        },
        {
            "x": 12.549664497375488,
            "y": -0.17347654700279236,
            "z": -288.0680847167969
        },
        {
            "x": 12.481815338134766,
            "y": -0.18575839698314667,
            "z": -287.92596435546875
        },
        {
            "x": 12.41379451751709,
            "y": -0.19832652807235718,
            "z": -287.78436279296875
        },
        {
            "x": 12.345396041870117,
            "y": -0.21121515333652496,
            "z": -287.6426086425781
        },
        {
            "x": 12.27681827545166,
            "y": -0.22436529397964478,
            "z": -287.5013122558594
        },
        {
            "x": 12.208149909973145,
            "y": -0.2377898246049881,
            "z": -287.3601379394531
        },
        {
            "x": 12.139290809631348,
            "y": -0.2514913082122803,
            "z": -287.218994140625
        },
        {
            "x": 12.070428848266602,
            "y": -0.26542094349861145,
            "z": -287.0782165527344
        },
        {
            "x": 12.001463890075684,
            "y": -0.2796044647693634,
            "z": -286.9372863769531
        },
        {
            "x": 11.932435989379883,
            "y": -0.29401320219039917,
            "z": -286.7966003417969
        },
        {
            "x": 11.863349914550781,
            "y": -0.30864545702934265,
            "z": -286.6559753417969
        },
        {
            "x": 11.794047355651855,
            "y": -0.32351118326187134,
            "z": -286.51519775390625
        },
        {
            "x": 11.724810600280762,
            "y": -0.3385503888130188,
            "z": -286.37469482421875
        },
        {
            "x": 11.655450820922852,
            "y": -0.3537885546684265,
            "z": -286.234130859375
        },
        {
            "x": 11.586041450500488,
            "y": -0.3692038357257843,
            "z": -286.0937805175781
        },
        {
            "x": 11.516615867614746,
            "y": -0.38477861881256104,
            "z": -285.95343017578125
        },
        {
            "x": 11.447041511535645,
            "y": -0.40053099393844604,
            "z": -285.81298828125
        },
        {
            "x": 11.377446174621582,
            "y": -0.4164186120033264,
            "z": -285.6726379394531
        },
        {
            "x": 11.307778358459473,
            "y": -0.4324362277984619,
            "z": -285.532470703125
        },
        {
            "x": 11.238076210021973,
            "y": -0.44857800006866455,
            "z": -285.39239501953125
        },
        {
            "x": 11.168301582336426,
            "y": -0.4648323655128479,
            "z": -285.2522888183594
        },
        {
            "x": 11.098450660705566,
            "y": -0.48119884729385376,
            "z": -285.1121520996094
        },
        {
            "x": 11.028550148010254,
            "y": -0.4976579546928406,
            "z": -284.97210693359375
        },
        {
            "x": 10.958605766296387,
            "y": -0.5141944289207458,
            "z": -284.8320617675781
        },
        {
            "x": 10.888636589050293,
            "y": -0.5307996273040771,
            "z": -284.6921691894531
        },
        {
            "x": 10.818613052368164,
            "y": -0.5474649667739868,
            "z": -284.5522155761719
        },
        {
            "x": 10.748564720153809,
            "y": -0.5641815662384033,
            "z": -284.412353515625
        },
        {
            "x": 10.678399085998535,
            "y": -0.5809505581855774,
            "z": -284.2723693847656
        },
        {
            "x": 10.608264923095703,
            "y": -0.5977356433868408,
            "z": -284.13250732421875
        },
        {
            "x": 10.5380859375,
            "y": -0.6145374178886414,
            "z": -283.99273681640625
        },
        {
            "x": 10.467869758605957,
            "y": -0.6313451528549194,
            "z": -283.8529357910156
        },
        {
            "x": 10.397655487060547,
            "y": -0.6481444835662842,
            "z": -283.7131652832031
        },
        {
            "x": 10.327291488647461,
            "y": -0.6649532318115234,
            "z": -283.5732727050781
        },
        {
            "x": 10.257034301757812,
            "y": -0.6817091703414917,
            "z": -283.4336242675781
        },
        {
            "x": 10.186763763427734,
            "y": -0.6984260082244873,
            "z": -283.2940368652344
        },
        {
            "x": 10.116409301757812,
            "y": -0.7151172161102295,
            "z": -283.1541748046875
        },
        {
            "x": 10.046072006225586,
            "y": -0.7317367792129517,
            "z": -283.0145263671875
        },
        {
            "x": 9.975727081298828,
            "y": -0.7482917308807373,
            "z": -282.8748474121094
        },
        {
            "x": 9.905349731445312,
            "y": -0.7647788524627686,
            "z": -282.73504638671875
        },
        {
            "x": 9.835066795349121,
            "y": -0.781156063079834,
            "z": -282.5954284667969
        },
        {
            "x": 9.788125038146973,
            "y": -0.7920308113098145,
            "z": -282.502197265625
        },
        {
            "x": 9.717732429504395,
            "y": -0.8082467317581177,
            "z": -282.3625183105469
        },
        {
            "x": 9.647379875183105,
            "y": -0.8243391513824463,
            "z": -282.2228698730469
        },
        {
            "x": 9.576921463012695,
            "y": -0.8403223752975464,
            "z": -282.0830078125
        },
        {
            "x": 9.506552696228027,
            "y": -0.8561460971832275,
            "z": -281.9433288574219
        },
        {
            "x": 9.43622875213623,
            "y": -0.871819257736206,
            "z": -281.80364990234375
        },
        {
            "x": 9.365854263305664,
            "y": -0.8873436450958252,
            "z": -281.663818359375
        },
        {
            "x": 9.295539855957031,
            "y": -0.9026826620101929,
            "z": -281.5240783691406
        },
        {
            "x": 9.22525691986084,
            "y": -0.9178466796875,
            "z": -281.3842468261719
        },
        {
            "x": 9.154966354370117,
            "y": -0.9328206777572632,
            "z": -281.24432373046875
        },
        {
            "x": 9.084749221801758,
            "y": -0.9475904107093811,
            "z": -281.1044921875
        },
        {
            "x": 9.014506340026855,
            "y": -0.9621418118476868,
            "z": -280.96453857421875
        },
        {
            "x": 8.944357872009277,
            "y": -0.9764614701271057,
            "z": -280.82464599609375
        },
        {
            "x": 8.874250411987305,
            "y": -0.9905469417572021,
            "z": -280.6847229003906
        },
        {
            "x": 8.804076194763184,
            "y": -1.0044114589691162,
            "z": -280.5444641113281
        },
        {
            "x": 8.734060287475586,
            "y": -1.0179839134216309,
            "z": -280.404541015625
        },
        {
            "x": 8.664069175720215,
            "y": -1.0312957763671875,
            "z": -280.264404296875
        },
        {
            "x": 8.594115257263184,
            "y": -1.0443353652954102,
            "z": -280.1241760253906
        },
        {
            "x": 8.524271011352539,
            "y": -1.0570721626281738,
            "z": -279.9841003417969
        },
        {
            "x": 8.454379081726074,
            "y": -1.0695230960845947,
            "z": -279.84368896484375
        },
        {
            "x": 8.384708404541016,
            "y": -1.0816359519958496,
            "z": -279.7035217285156
        },
        {
            "x": 8.31503677368164,
            "y": -1.093440055847168,
            "z": -279.5631408691406
        },
        {
            "x": 8.2454833984375,
            "y": -1.104905605316162,
            "z": -279.42279052734375
        },
        {
            "x": 8.175965309143066,
            "y": -1.1160268783569336,
            "z": -279.2823486328125
        },
        {
            "x": 8.10655403137207,
            "y": -1.1267856359481812,
            "z": -279.1418151855469
        },
        {
            "x": 8.037198066711426,
            "y": -1.1371862888336182,
            "z": -279.00115966796875
        },
        {
            "x": 7.967971324920654,
            "y": -1.1472053527832031,
            "z": -278.8605041503906
        },
        {
            "x": 7.898775100708008,
            "y": -1.1568419933319092,
            "z": -278.7196350097656
        },
        {
            "x": 7.829761505126953,
            "y": -1.166055679321289,
            "z": -278.5789489746094
        },
        {
            "x": 7.760848522186279,
            "y": -1.1748661994934082,
            "z": -278.4380798339844
        },
        {
            "x": 7.691951274871826,
            "y": -1.183267593383789,
            "z": -278.2970275878906
        },
        {
            "x": 7.623305797576904,
            "y": -1.1912227869033813,
            "z": -278.1560363769531
        },
        {
            "x": 7.554706573486328,
            "y": -1.1987266540527344,
            "z": -278.0149230957031
        },
        {
            "x": 7.486260890960693,
            "y": -1.2057771682739258,
            "z": -277.87371826171875
        },
        {
            "x": 7.417938232421875,
            "y": -1.2123641967773438,
            "z": -277.7325134277344
        },
        {
            "x": 7.349706649780273,
            "y": -1.2184816598892212,
            "z": -277.5910339355469
        },
        {
            "x": 7.281675338745117,
            "y": -1.224086880683899,
            "z": -277.44964599609375
        },
        {
            "x": 7.2138237953186035,
            "y": -1.2291951179504395,
            "z": -277.3082275390625
        },
        {
            "x": 7.146033763885498,
            "y": -1.2338027954101562,
            "z": -277.16656494140625
        },
        {
            "x": 7.078492164611816,
            "y": -1.2378859519958496,
            "z": -277.02496337890625
        },
        {
            "x": 7.011012077331543,
            "y": -1.241422176361084,
            "z": -276.88311767578125
        },
        {
            "x": 6.943756103515625,
            "y": -1.2444158792495728,
            "z": -276.74127197265625
        },
        {
            "x": 6.876679420471191,
            "y": -1.2468600273132324,
            "z": -276.5993347167969
        },
        {
            "x": 6.832068920135498,
            "y": -1.248171091079712,
            "z": -276.5047607421875
        },
        {
            "x": 6.7653374671936035,
            "y": -1.24965500831604,
            "z": -276.36273193359375
        },
        {
            "x": 6.698775291442871,
            "y": -1.2505605220794678,
            "z": -276.2206726074219
        },
        {
            "x": 6.632348537445068,
            "y": -1.250876784324646,
            "z": -276.0782470703125
        },
        {
            "x": 6.566164970397949,
            "y": -1.2505664825439453,
            "z": -275.93597412109375
        },
        {
            "x": 6.500219345092773,
            "y": -1.2496671676635742,
            "z": -275.7936706542969
        },
        {
            "x": 6.434366226196289,
            "y": -1.2481873035430908,
            "z": -275.6510314941406
        },
        {
            "x": 6.368842601776123,
            "y": -1.2461415529251099,
            "z": -275.508544921875
        },
        {
            "x": 6.303447246551514,
            "y": -1.2435104846954346,
            "z": -275.3658447265625
        },
        {
            "x": 6.238334655761719,
            "y": -1.240333080291748,
            "z": -275.22308349609375
        },
        {
            "x": 6.1734395027160645,
            "y": -1.2366228103637695,
            "z": -275.0802917480469
        },
        {
            "x": 6.10879373550415,
            "y": -1.2323858737945557,
            "z": -274.9373474121094
        },
        {
            "x": 6.044375419616699,
            "y": -1.2276146411895752,
            "z": -274.79437255859375
        },
        {
            "x": 5.9802937507629395,
            "y": -1.2223443984985352,
            "z": -274.6513977050781
        },
        {
            "x": 5.916274070739746,
            "y": -1.216569185256958,
            "z": -274.50799560546875
        },
        {
            "x": 5.852657318115234,
            "y": -1.2103279829025269,
            "z": -274.3648681640625
        },
        {
            "x": 5.78919792175293,
            "y": -1.203589916229248,
            "z": -274.2214660644531
        },
        {
            "x": 5.726092338562012,
            "y": -1.1963984966278076,
            "z": -274.078125
        },
        {
            "x": 5.663205623626709,
            "y": -1.1887545585632324,
            "z": -273.9345703125
        },
        {
            "x": 5.600531578063965,
            "y": -1.1806714534759521,
            "z": -273.7908630371094
        },
        {
            "x": 5.538217544555664,
            "y": -1.172154426574707,
            "z": -273.6471862792969
        },
        {
            "x": 5.47620964050293,
            "y": -1.163224220275879,
            "z": -273.5035095214844
        },
        {
            "x": 5.414445400238037,
            "y": -1.1538851261138916,
            "z": -273.359619140625
        },
        {
            "x": 5.353000640869141,
            "y": -1.1441622972488403,
            "z": -273.21575927734375
        },
        {
            "x": 5.291800022125244,
            "y": -1.1340354681015015,
            "z": -273.0716247558594
        },
        {
            "x": 5.230893611907959,
            "y": -1.123537302017212,
            "z": -272.9274597167969
        },
        {
            "x": 5.17028284072876,
            "y": -1.1126770973205566,
            "z": -272.783203125
        },
        {
            "x": 5.109979629516602,
            "y": -1.1014777421951294,
            "z": -272.6388854980469
        },
        {
            "x": 5.049978733062744,
            "y": -1.0899248123168945,
            "z": -272.4944152832031
        },
        {
            "x": 4.990312576293945,
            "y": -1.078049898147583,
            "z": -272.3500061035156
        },
        {
            "x": 4.930902004241943,
            "y": -1.0658401250839233,
            "z": -272.2052307128906
        },
        {
            "x": 4.871849060058594,
            "y": -1.053344964981079,
            "z": -272.0605773925781
        },
        {
            "x": 4.81309700012207,
            "y": -1.0405397415161133,
            "z": -271.9156799316406
        },
        {
            "x": 4.754642009735107,
            "y": -1.027449131011963,
            "z": -271.7707824707031
        },
        {
            "x": 4.696603775024414,
            "y": -1.0140938758850098,
            "z": -271.6258239746094
        },
        {
            "x": 4.6387505531311035,
            "y": -1.0004585981369019,
            "z": -271.4805908203125
        },
        {
            "x": 4.581376552581787,
            "y": -0.9865926504135132,
            "z": -271.33538818359375
        },
        {
            "x": 4.5242390632629395,
            "y": -0.9724666476249695,
            "z": -271.1900634765625
        },
        {
            "x": 4.467483997344971,
            "y": -0.9581179618835449,
            "z": -271.0446472167969
        },
        {
            "x": 4.411005020141602,
            "y": -0.9435461759567261,
            "z": -270.8990478515625
        },
        {
            "x": 4.354946136474609,
            "y": -0.928777813911438,
            "z": -270.75347900390625
        },
        {
            "x": 4.299115180969238,
            "y": -0.9137831330299377,
            "z": -270.6075744628906
        },
        {
            "x": 4.243735313415527,
            "y": -0.8986279368400574,
            "z": -270.4618225097656
        },
        {
            "x": 4.206989765167236,
            "y": -0.8884230852127075,
            "z": -270.364501953125
        },
        {
            "x": 4.152138710021973,
            "y": -0.8729733228683472,
            "z": -270.218505859375
        },
        {
            "x": 4.0976972579956055,
            "y": -0.857366681098938,
            "z": -270.0723876953125
        },
        {
            "x": 4.043486595153809,
            "y": -0.8415966033935547,
            "z": -269.926025390625
        },
        {
            "x": 3.9897642135620117,
            "y": -0.8257101774215698,
            "z": -269.77972412109375
        },
        {
            "x": 3.9363090991973877,
            "y": -0.8096874952316284,
            "z": -269.6332092285156
        },
        {
            "x": 3.883274555206299,
            "y": -0.7935502529144287,
            "z": -269.48663330078125
        },
        {
            "x": 3.8305273056030273,
            "y": -0.7773035764694214,
            "z": -269.3398742675781
        },
        {
            "x": 3.7782034873962402,
            "y": -0.7609744071960449,
            "z": -269.193115234375
        },
        {
            "x": 3.726144790649414,
            "y": -0.744536817073822,
            "z": -269.04595947265625
        },
        {
            "x": 3.674558162689209,
            "y": -0.7280548214912415,
            "z": -268.89898681640625
        },
        {
            "x": 3.623236894607544,
            "y": -0.7114825248718262,
            "z": -268.75164794921875
        },
        {
            "x": 3.5723798274993896,
            "y": -0.6948928236961365,
            "z": -268.6044921875
        },
        {
            "x": 3.521810293197632,
            "y": -0.6782364249229431,
            "z": -268.4570007324219
        },
        {
            "x": 3.471632480621338,
            "y": -0.6615569591522217,
            "z": -268.3094482421875
        },
        {
            "x": 3.4218406677246094,
            "y": -0.6448521614074707,
            "z": -268.1617126464844
        },
        {
            "x": 3.3723950386047363,
            "y": -0.6281492710113525,
            "z": -268.01397705078125
        },
        {
            "x": 3.3233556747436523,
            "y": -0.6114426851272583,
            "z": -267.8660583496094
        },
        {
            "x": 3.274641752243042,
            "y": -0.5947507619857788,
            "z": -267.7180480957031
        },
        {
            "x": 3.226320266723633,
            "y": -0.5780693292617798,
            "z": -267.5697937011719
        },
        {
            "x": 3.178321123123169,
            "y": -0.5614253282546997,
            "z": -267.4214172363281
        },
        {
            "x": 3.130812644958496,
            "y": -0.5448512434959412,
            "z": -267.2732238769531
        },
        {
            "x": 3.0835742950439453,
            "y": -0.5283035039901733,
            "z": -267.1246337890625
        },
        {
            "x": 3.036802291870117,
            "y": -0.5118483304977417,
            "z": -266.97613525390625
        },
        {
            "x": 2.9903151988983154,
            "y": -0.49543678760528564,
            "z": -266.82720947265625
        },
        {
            "x": 2.944232702255249,
            "y": -0.47912633419036865,
            "z": -266.6783752441406
        },
        {
            "x": 2.8985493183135986,
            "y": -0.4629078507423401,
            "z": -266.52935791015625
        },
        {
            "x": 2.8531744480133057,
            "y": -0.44679367542266846,
            "z": -266.3800964355469
        },
        {
            "x": 2.8082587718963623,
            "y": -0.4308057129383087,
            "z": -266.2308654785156
        },
        {
            "x": 2.763657569885254,
            "y": -0.41494518518447876,
            "z": -266.0815124511719
        },
        {
            "x": 2.7194466590881348,
            "y": -0.3992060124874115,
            "z": -265.93182373046875
        },
        {
            "x": 2.675607681274414,
            "y": -0.3836338520050049,
            "z": -265.7821960449219
        },
        {
            "x": 2.6321940422058105,
            "y": -0.3682284951210022,
            "z": -265.6324462890625
        },
        {
            "x": 2.589089870452881,
            "y": -0.352970689535141,
            "z": -265.4823913574219
        },
        {
            "x": 2.5464107990264893,
            "y": -0.337921142578125,
            "z": -265.33251953125
        },
        {
            "x": 2.5040440559387207,
            "y": -0.3230300545692444,
            "z": -265.18206787109375
        },
        {
            "x": 2.462101459503174,
            "y": -0.30837520956993103,
            "z": -265.0319519042969
        },
        {
            "x": 2.4205901622772217,
            "y": -0.29392707347869873,
            "z": -264.881591796875
        },
        {
            "x": 2.3793327808380127,
            "y": -0.27968427538871765,
            "z": -264.73095703125
        },
        {
            "x": 2.3385848999023438,
            "y": -0.26570233702659607,
            "z": -264.58038330078125
        },
        {
            "x": 2.2980809211730957,
            "y": -0.25194093585014343,
            "z": -264.4294738769531
        },
        {
            "x": 2.258039712905884,
            "y": -0.2384544312953949,
            "z": -264.2786560058594
        },
        {
            "x": 2.2183375358581543,
            "y": -0.2252170890569687,
            "z": -264.1275329589844
        },
        {
            "x": 2.1920716762542725,
            "y": -0.21656084060668945,
            "z": -264.02685546875
        },
        {
            "x": 2.153067111968994,
            "y": -0.20381136238574982,
            "z": -263.8757019042969
        },
        {
            "x": 2.1143364906311035,
            "y": -0.1913381665945053,
            "z": -263.7243347167969
        },
        {
            "x": 2.0759828090667725,
            "y": -0.1791716367006302,
            "z": -263.57275390625
        },
        {
            "x": 2.0380196571350098,
            "y": -0.1673298180103302,
            "z": -263.421142578125
        },
        {
            "x": 2.0004477500915527,
            "y": -0.15582449734210968,
            "z": -263.2695617675781
        },
        {
            "x": 1.963236689567566,
            "y": -0.14463457465171814,
            "z": -263.11761474609375
        },
        {
            "x": 1.9263551235198975,
            "y": -0.1338021606206894,
            "z": -262.9657287597656
        },
        {
            "x": 1.8899205923080444,
            "y": -0.12333779782056808,
            "z": -262.8135986328125
        },
        {
            "x": 1.8537518978118896,
            "y": -0.11322631686925888,
            "z": -262.66131591796875
        },
        {
            "x": 1.8180525302886963,
            "y": -0.10351266711950302,
            "z": -262.5091857910156
        },
        {
            "x": 1.7826695442199707,
            "y": -0.09416677057743073,
            "z": -262.3565368652344
        },
        {
            "x": 1.7476451396942139,
            "y": -0.0852508544921875,
            "z": -262.2041320800781
        },
        {
            "x": 1.7130398750305176,
            "y": -0.07673987746238708,
            "z": -262.0515441894531
        },
        {
            "x": 1.6786752939224243,
            "y": -0.06863453984260559,
            "z": -261.8985290527344
        },
        {
            "x": 1.6448047161102295,
            "y": -0.060977041721343994,
            "z": -261.745849609375
        },
        {
            "x": 1.6112140417099,
            "y": -0.053766049444675446,
            "z": -261.5928039550781
        },
        {
            "x": 1.5780093669891357,
            "y": -0.0470164455473423,
            "z": -261.4398498535156
        },
        {
            "x": 1.5452051162719727,
            "y": -0.040724147111177444,
            "z": -261.2866516113281
        },
        {
            "x": 1.5126475095748901,
            "y": -0.034896936267614365,
            "z": -261.1332702636719
        },
        {
            "x": 1.4805959463119507,
            "y": -0.029584122821688652,
            "z": -260.98004150390625
        },
        {
            "x": 1.448818564414978,
            "y": -0.02476024255156517,
            "z": -260.82659912109375
        },
        {
            "x": 1.4174336194992065,
            "y": -0.02044457197189331,
            "z": -260.6732177734375
        },
        {
            "x": 1.3863945007324219,
            "y": -0.016637451946735382,
            "z": -260.5195617675781
        },
        {
            "x": 1.3556607961654663,
            "y": -0.01337587833404541,
            "z": -260.36578369140625
        },
        {
            "x": 1.3253599405288696,
            "y": -0.010654703713953495,
            "z": -260.2120361328125
        },
        {
            "x": 1.2953369617462158,
            "y": -0.008477438241243362,
            "z": -260.0581359863281
        },
        {
            "x": 1.2656906843185425,
            "y": -0.006856444291770458,
            "z": -259.90423583984375
        },
        {
            "x": 1.23642098903656,
            "y": -0.005823038052767515,
            "z": -259.7502136230469
        },
        {
            "x": 1.207443118095398,
            "y": -0.005371829029172659,
            "z": -259.59619140625
        },
        {
            "x": 1.1788498163223267,
            "y": -0.005335196852684021,
            "z": -259.44189453125
        },
        {
            "x": 1.1505588293075562,
            "y": -0.005334924906492233,
            "z": -259.28759765625
        },
        {
            "x": 1.122648000717163,
            "y": -0.005334667861461639,
            "z": -259.1333923339844
        },
        {
            "x": 1.0950980186462402,
            "y": -0.0053343698382377625,
            "z": -258.9789733886719
        },
        {
            "x": 1.0678389072418213,
            "y": -0.005334094166755676,
            "z": -258.8245544433594
        },
        {
            "x": 1.0409489870071411,
            "y": -0.005333803594112396,
            "z": -258.6700134277344
        },
        {
            "x": 1.014380931854248,
            "y": -0.00533352792263031,
            "z": -258.5154113769531
        },
        {
            "x": 0.9881687164306641,
            "y": -0.0053332410752773285,
            "z": -258.36090087890625
        },
        {
            "x": 0.9622987508773804,
            "y": -0.00533294677734375,
            "z": -258.2061462402344
        },
        {
            "x": 0.9366956949234009,
            "y": -0.005332667380571365,
            "z": -258.0513916015625
        },
        {
            "x": 0.9114872217178345,
            "y": -0.005332369357347488,
            "z": -257.8966369628906
        },
        {
            "x": 0.8865736722946167,
            "y": -0.005332078784704208,
            "z": -257.74169921875
        },
        {
            "x": 0.8619810342788696,
            "y": -0.005331814289093018,
            "z": -257.5868225097656
        },
        {
            "x": 0.8458074331283569,
            "y": -0.005331624299287796,
            "z": -257.4836120605469
        },
        {
            "x": 0.8217654228210449,
            "y": -0.005331322550773621,
            "z": -257.3285827636719
        },
        {
            "x": 0.7980345487594604,
            "y": -0.005331054329872131,
            "z": -257.1736755371094
        },
        {
            "x": 0.7746476531028748,
            "y": -0.005330756306648254,
            "z": -257.0184326171875
        },
        {
            "x": 0.7515332698822021,
            "y": -0.00533047690987587,
            "z": -256.8632507324219
        },
        {
            "x": 0.7287902235984802,
            "y": -0.005330197513103485,
            "z": -256.70819091796875
        },
        {
            "x": 0.706349790096283,
            "y": -0.005329906940460205,
            "z": -256.5527648925781
        },
        {
            "x": 0.6841634511947632,
            "y": -0.005329608917236328,
            "z": -256.39752197265625
        },
        {
            "x": 0.6623608469963074,
            "y": -0.0053293295204639435,
            "z": -256.2422180175781
        },
        {
            "x": 0.6408240795135498,
            "y": -0.005329053848981857,
            "z": -256.0867004394531
        },
        {
            "x": 0.619583010673523,
            "y": -0.00532878190279007,
            "z": -255.93136596679688
        },
        {
            "x": 0.5986925363540649,
            "y": -0.005328502506017685,
            "z": -255.7758331298828
        },
        {
            "x": 0.5780545473098755,
            "y": -0.0053282007575035095,
            "z": -255.62030029296875
        },
        {
            "x": 0.5577390193939209,
            "y": -0.005327925086021423,
            "z": -255.4647979736328
        },
        {
            "x": 0.5377341508865356,
            "y": -0.005327638238668442,
            "z": -255.30906677246094
        },
        {
            "x": 0.5179725885391235,
            "y": -0.005327355116605759,
            "z": -255.15338134765625
        },
        {
            "x": 0.49855852127075195,
            "y": -0.00532706081867218,
            "z": -254.99778747558594
        },
        {
            "x": 0.47944074869155884,
            "y": -0.005326796323060989,
            "z": -254.84194946289062
        },
        {
            "x": 0.46056219935417175,
            "y": -0.005326475948095322,
            "z": -254.6862335205078
        },
        {
            "x": 0.44201716780662537,
            "y": -0.005326233804225922,
            "z": -254.53033447265625
        },
        {
            "x": 0.42375490069389343,
            "y": -0.005325932055711746,
            "z": -254.37445068359375
        },
        {
            "x": 0.40574541687965393,
            "y": -0.00532565638422966,
            "z": -254.21864318847656
        },
        {
            "x": 0.38808727264404297,
            "y": -0.00532536581158638,
            "z": -254.0628204345703
        },
        {
            "x": 0.37065571546554565,
            "y": -0.005325067788362503,
            "z": -253.90682983398438
        },
        {
            "x": 0.3534908592700958,
            "y": -0.005324799567461014,
            "z": -253.75091552734375
        },
        {
            "x": 0.33666834235191345,
            "y": -0.005324512720108032,
            "z": -253.5948486328125
        },
        {
            "x": 0.32006534934043884,
            "y": -0.0053242407739162445,
            "z": -253.43881225585938
        },
        {
            "x": 0.3037286698818207,
            "y": -0.005323957651853561,
            "z": -253.2827606201172
        },
        {
            "x": 0.28772974014282227,
            "y": -0.005323667079210281,
            "z": -253.12667846679688
        },
        {
            "x": 0.27193158864974976,
            "y": -0.005323365330696106,
            "z": -252.97048950195312
        },
        {
            "x": 0.256407767534256,
            "y": -0.005323097109794617,
            "z": -252.81422424316406
        },
        {
            "x": 0.2412087321281433,
            "y": -0.005322795361280441,
            "z": -252.65806579589844
        },
        {
            "x": 0.2261960208415985,
            "y": -0.0053225308656692505,
            "z": -252.50177001953125
        },
        {
            "x": 0.2114921510219574,
            "y": -0.005322251468896866,
            "z": -252.34559631347656
        },
        {
            "x": 0.19707906246185303,
            "y": -0.005321945995092392,
            "z": -252.1893310546875
        },
        {
            "x": 0.1828346848487854,
            "y": -0.0053216852247715,
            "z": -252.03280639648438
        },
        {
            "x": 0.16890886425971985,
            "y": -0.005321383476257324,
            "z": -251.87660217285156
        },
        {
            "x": 0.15527239441871643,
            "y": -0.005321096628904343,
            "z": -251.72027587890625
        },
        {
            "x": 0.14180466532707214,
            "y": -0.005320828408002853,
            "z": -251.56378173828125
        },
        {
            "x": 0.12864193320274353,
            "y": -0.005320541560649872,
            "z": -251.40750122070312
        },
        {
            "x": 0.1157442033290863,
            "y": -0.005320258438587189,
            "z": -251.25096130371094
        },
        {
            "x": 0.1030331552028656,
            "y": -0.005319971591234207,
            "z": -251.0944366455078
        },
        {
            "x": 0.09061720967292786,
            "y": -0.005319695919752121,
            "z": -250.93809509277344
        },
        {
            "x": 0.08249393105506897,
            "y": -0.005319502204656601,
            "z": -250.83383178710938
        },
        {
            "x": 0.07046118378639221,
            "y": -0.005319222807884216,
            "z": -250.6772918701172
        },
        {
            "x": 0.05866488814353943,
            "y": -0.005318924784660339,
            "z": -250.52085876464844
        },
        {
            "x": 0.04715085029602051,
            "y": -0.005318645387887955,
            "z": -250.36419677734375
        },
        {
            "x": 0.035838931798934937,
            "y": -0.005318347364664078,
            "z": -250.2075958251953
        },
        {
            "x": 0.02475544810295105,
            "y": -0.005318071693181992,
            "z": -250.05108642578125
        },
        {
            "x": 0.013958752155303955,
            "y": -0.005317796021699905,
            "z": -249.89442443847656
        },
        {
            "x": 0.003361135721206665,
            "y": -0.0053174979984760284,
            "z": -249.73779296875
        },
        {
            "x": -0.007039278745651245,
            "y": -0.0053171999752521515,
            "z": -249.58116149902344
        },
        {
            "x": -0.01713871955871582,
            "y": -0.005316935479640961,
            "z": -249.42446899414062
        },
        {
            "x": -0.027032911777496338,
            "y": -0.005316663533449173,
            "z": -249.26779174804688
        },
        {
            "x": -0.03675258159637451,
            "y": -0.005316384136676788,
            "z": -249.11102294921875
        },
        {
            "x": -0.046179741621017456,
            "y": -0.00531608983874321,
            "z": -248.95443725585938
        },
        {
            "x": -0.05538129806518555,
            "y": -0.005315806716680527,
            "z": -248.79769897460938
        },
        {
            "x": -0.06443127989768982,
            "y": -0.005315516144037247,
            "z": -248.64076232910156
        },
        {
            "x": -0.07320369780063629,
            "y": -0.005315236747264862,
            "z": -248.48416137695312
        },
        {
            "x": -0.08174647390842438,
            "y": -0.005314938724040985,
            "z": -248.3273162841797
        },
        {
            "x": -0.09012970328330994,
            "y": -0.005314674228429794,
            "z": -248.1704864501953
        },
        {
            "x": -0.09826123714447021,
            "y": -0.0053143687546253204,
            "z": -248.01380920410156
        },
        {
            "x": -0.10615575313568115,
            "y": -0.005314089357852936,
            "z": -247.85684204101562
        },
        {
            "x": -0.11388920247554779,
            "y": -0.005313802510499954,
            "z": -247.69998168945312
        },
        {
            "x": -0.1213972419500351,
            "y": -0.005313526839017868,
            "z": -247.5432891845703
        },
        {
            "x": -0.12864495813846588,
            "y": -0.00531325489282608,
            "z": -247.38650512695312
        },
        {
            "x": -0.13573136925697327,
            "y": -0.005312945693731308,
            "z": -247.22959899902344
        },
        {
            "x": -0.14264284074306488,
            "y": -0.00531267374753952,
            "z": -247.0727081298828
        },
        {
            "x": -0.1492801457643509,
            "y": -0.005312398076057434,
            "z": -246.91583251953125
        },
        {
            "x": -0.1557280719280243,
            "y": -0.005312103778123856,
            "z": -246.75892639160156
        },
        {
            "x": -0.16203033924102783,
            "y": -0.005311831831932068,
            "z": -246.6019744873047
        },
        {
            "x": -0.16808295249938965,
            "y": -0.005311548709869385,
            "z": -246.44517517089844
        },
        {
            "x": -0.1739092767238617,
            "y": -0.005311261862516403,
            "z": -246.28826904296875
        },
        {
            "x": -0.179607093334198,
            "y": -0.005310967564582825,
            "z": -246.13111877441406
        },
        {
            "x": -0.18508435785770416,
            "y": -0.0053106918931007385,
            "z": -245.97430419921875
        },
        {
            "x": -0.19032537937164307,
            "y": -0.0053104013204574585,
            "z": -245.81736755371094
        },
        {
            "x": -0.19541332125663757,
            "y": -0.0053101107478141785,
            "z": -245.66029357910156
        },
        {
            "x": -0.20032687485218048,
            "y": -0.005309838801622391,
            "z": -245.50343322753906
        },
        {
            "x": -0.20500463247299194,
            "y": -0.0053095705807209015,
            "z": -245.34634399414062
        },
        {
            "x": -0.20949603617191315,
            "y": -0.005309268832206726,
            "z": -245.18936157226562
        },
        {
            "x": -0.21384672820568085,
            "y": -0.005309000611305237,
            "z": -245.0324249267578
        },
        {
            "x": -0.21797753870487213,
            "y": -0.005308698862791061,
            "z": -244.8754119873047
        },
        {
            "x": -0.2218913435935974,
            "y": -0.005308419466018677,
            "z": -244.71844482421875
        },
        {
            "x": -0.22567766904830933,
            "y": -0.005308140069246292,
            "z": -244.56130981445312
        },
        {
            "x": -0.22928205132484436,
            "y": -0.005307856947183609,
            "z": -244.404296875
        },
        {
            "x": -0.23264989256858826,
            "y": -0.005307558923959732,
            "z": -244.2473907470703
        },
        {
            "x": -0.23480325937271118,
            "y": -0.005307372659444809,
            "z": -244.14271545410156
        },
        {
            "x": -0.23792937397956848,
            "y": -0.005307093262672424,
            "z": -243.98570251464844
        },
        {
            "x": -0.24086299538612366,
            "y": -0.00530681386590004,
            "z": -243.82879638671875
        },
        {
            "x": -0.24358007311820984,
            "y": -0.0053065381944179535,
            "z": -243.67160034179688
        },
        {
            "x": -0.24615149199962616,
            "y": -0.0053062401711940765,
            "z": -243.51455688476562
        },
        {
            "x": -0.24857917428016663,
            "y": -0.005305957049131393,
            "z": -243.3575439453125
        },
        {
            "x": -0.25079020857810974,
            "y": -0.00530567392706871,
            "z": -243.20050048828125
        },
        {
            "x": -0.2528168261051178,
            "y": -0.005305394530296326,
            "z": -243.04344177246094
        },
        {
            "x": -0.2547280490398407,
            "y": -0.005305100232362747,
            "z": -242.8862762451172
        },
        {
            "x": -0.25646117329597473,
            "y": -0.005304817110300064,
            "z": -242.72918701171875
        },
        {
            "x": -0.2579886019229889,
            "y": -0.005304545164108276,
            "z": -242.57215881347656
        },
        {
            "x": -0.25938743352890015,
            "y": -0.005304250866174698,
            "z": -242.41493225097656
        },
        {
            "x": -0.26066073775291443,
            "y": -0.005303964018821716,
            "z": -242.25791931152344
        },
        {
            "x": -0.26176363229751587,
            "y": -0.00530368834733963,
            "z": -242.1008758544922
        },
        {
            "x": -0.2627499997615814,
            "y": -0.005303386598825455,
            "z": -241.94354248046875
        },
        {
            "x": -0.2636680603027344,
            "y": -0.00530310720205307,
            "z": -241.7864227294922
        },
        {
            "x": -0.26448529958724976,
            "y": -0.005302824079990387,
            "z": -241.62924194335938
        },
        {
            "x": -0.2652673125267029,
            "y": -0.0053025297820568085,
            "z": -241.471923828125
        },
        {
            "x": -0.2661082446575165,
            "y": -0.005302261561155319,
            "z": -241.3146209716797
        },
        {
            "x": -0.2669773995876312,
            "y": -0.005301967263221741,
            "z": -241.15716552734375
        },
        {
            "x": -0.26790863275527954,
            "y": -0.005301687866449356,
            "z": -240.99977111816406
        },
        {
            "x": -0.2690243422985077,
            "y": -0.0053014084696769714,
            "z": -240.84228515625
        },
        {
            "x": -0.27032265067100525,
            "y": -0.005301132798194885,
            "z": -240.68490600585938
        },
        {
            "x": -0.2717655301094055,
            "y": -0.005300834774971008,
            "z": -240.52743530273438
        },
        {
            "x": -0.2734665274620056,
            "y": -0.005300555378198624,
            "z": -240.36973571777344
        },
        {
            "x": -0.2754482328891754,
            "y": -0.0053002797067165375,
            "z": -240.212158203125
        },
        {
            "x": -0.27761584520339966,
            "y": -0.005299992859363556,
            "z": -240.05471801757812
        },
        {
            "x": -0.28003111481666565,
            "y": -0.005287317559123039,
            "z": -239.89698791503906
        },
        {
            "x": -0.2827770709991455,
            "y": -0.005105666816234589,
            "z": -239.73941040039062
        },
        {
            "x": -0.2857726514339447,
            "y": -0.004670740105211735,
            "z": -239.5819854736328
        },
        {
            "x": -0.28897011280059814,
            "y": -0.003983624279499054,
            "z": -239.42430114746094
        },
        {
            "x": -0.2924823462963104,
            "y": -0.003055217210203409,
            "z": -239.26666259765625
        },
        {
            "x": -0.2963152825832367,
            "y": -0.0018889515195041895,
            "z": -239.10910034179688
        },
        {
            "x": -0.3003474473953247,
            "y": -0.0004838109016418457,
            "z": -238.95162963867188
        },
        {
            "x": -0.3046351671218872,
            "y": 0.0011600400321185589,
            "z": -238.7941131591797
        },
        {
            "x": -0.309280663728714,
            "y": 0.0030352286994457245,
            "z": -238.6363067626953
        },
        {
            "x": -0.3141787648200989,
            "y": 0.005130474921315908,
            "z": -238.47894287109375
        },
        {
            "x": -0.31927478313446045,
            "y": 0.007451728917658329,
            "z": -238.321533203125
        },
        {
            "x": -0.3247077465057373,
            "y": 0.01000228151679039,
            "z": -238.16384887695312
        },
        {
            "x": -0.330462247133255,
            "y": 0.012763558886945248,
            "z": -238.00640869140625
        },
        {
            "x": -0.33642154932022095,
            "y": 0.015736136585474014,
            "z": -237.84901428222656
        },
        {
            "x": -0.3426430821418762,
            "y": 0.01892438903450966,
            "z": -237.69142150878906
        },
        {
            "x": -0.3492278456687927,
            "y": 0.02232162281870842,
            "z": -237.53396606445312
        },
        {
            "x": -0.353767454624176,
            "y": 0.024694088846445084,
            "z": -237.42910766601562
        },
        {
            "x": -0.3607323467731476,
            "y": 0.02842136099934578,
            "z": -237.27182006835938
        },
        {
            "x": -0.3680020272731781,
            "y": 0.03235524520277977,
            "z": -237.11436462402344
        },
        {
            "x": -0.3756325840950012,
            "y": 0.036485470831394196,
            "z": -236.95680236816406
        },
        {
            "x": -0.3834792971611023,
            "y": 0.04079565405845642,
            "z": -236.79959106445312
        },
        {
            "x": -0.3915643095970154,
            "y": 0.04529748857021332,
            "z": -236.6422576904297
        },
        {
            "x": -0.40002813935279846,
            "y": 0.04999413713812828,
            "z": -236.4847869873047
        },
        {
            "x": -0.4087681770324707,
            "y": 0.05486069247126579,
            "z": -236.32762145996094
        },
        {
            "x": -0.4177152216434479,
            "y": 0.059907007962465286,
            "z": -236.17031860351562
        },
        {
            "x": -0.4269964098930359,
            "y": 0.0651330053806305,
            "z": -236.01287841796875
        },
        {
            "x": -0.43661874532699585,
            "y": 0.07052647322416306,
            "z": -235.85572814941406
        },
        {
            "x": -0.4464549720287323,
            "y": 0.07608754932880402,
            "z": -235.6985321044922
        },
        {
            "x": -0.4565659761428833,
            "y": 0.08181224763393402,
            "z": -235.54129028320312
        },
        {
            "x": -0.46704497933387756,
            "y": 0.08769555389881134,
            "z": -235.3841094970703
        },
        {
            "x": -0.4777891933917999,
            "y": 0.09374251961708069,
            "z": -235.22694396972656
        },
        {
            "x": -0.4887595772743225,
            "y": 0.09993904829025269,
            "z": -235.06980895996094
        },
        {
            "x": -0.5000954866409302,
            "y": 0.10628821700811386,
            "z": -234.9126739501953
        },
        {
            "x": -0.5117271542549133,
            "y": 0.11277738213539124,
            "z": -234.7556915283203
        },
        {
            "x": -0.5235731601715088,
            "y": 0.1194140613079071,
            "z": -234.59872436523438
        },
        {
            "x": -0.5357792377471924,
            "y": 0.12620264291763306,
            "z": -234.44149780273438
        },
        {
            "x": -0.5483037829399109,
            "y": 0.13311342895030975,
            "z": -234.2845916748047
        },
        {
            "x": -0.5610337257385254,
            "y": 0.14015315473079681,
            "z": -234.12774658203125
        },
        {
            "x": -0.5740860104560852,
            "y": 0.14733436703681946,
            "z": -233.97080993652344
        },
        {
            "x": -0.587502121925354,
            "y": 0.15463799238204956,
            "z": -233.81394958496094
        },
        {
            "x": -0.601155161857605,
            "y": 0.16206228733062744,
            "z": -233.65711975097656
        },
        {
            "x": -0.6150723099708557,
            "y": 0.16961058974266052,
            "z": -233.50021362304688
        },
        {
            "x": -0.6293743252754211,
            "y": 0.17727530002593994,
            "z": -233.3434295654297
        },
        {
            "x": -0.6439446210861206,
            "y": 0.18505071103572845,
            "z": -233.18667602539062
        },
        {
            "x": -0.6587430238723755,
            "y": 0.19293175637722015,
            "z": -233.03001403808594
        },
        {
            "x": -0.6739165782928467,
            "y": 0.2009216696023941,
            "z": -232.873291015625
        },
        {
            "x": -0.6894123554229736,
            "y": 0.20902016758918762,
            "z": -232.716552734375
        },
        {
            "x": -0.7051095366477966,
            "y": 0.2172081023454666,
            "z": -232.5599822998047
        },
        {
            "x": -0.7211782932281494,
            "y": 0.22550027072429657,
            "z": -232.4033203125
        },
        {
            "x": -0.7375648617744446,
            "y": 0.23387615382671356,
            "z": -232.24681091308594
        },
        {
            "x": -0.7541645765304565,
            "y": 0.24233907461166382,
            "z": -232.0903778076172
        },
        {
            "x": -0.7711418867111206,
            "y": 0.25090667605400085,
            "z": -231.93362426757812
        },
        {
            "x": -0.7884306311607361,
            "y": 0.2595364451408386,
            "z": -231.7772979736328
        },
        {
            "x": -0.8059320449829102,
            "y": 0.268240749835968,
            "z": -231.62103271484375
        },
        {
            "x": -0.8237860202789307,
            "y": 0.27703768014907837,
            "z": -231.4644775390625
        },
        {
            "x": -0.84199059009552,
            "y": 0.28589412569999695,
            "z": -231.30824279785156
        },
        {
            "x": -0.8604228496551514,
            "y": 0.2948186695575714,
            "z": -231.1519775390625
        },
        {
            "x": -0.8791696429252625,
            "y": 0.3038170039653778,
            "z": -230.9955596923828
        },
        {
            "x": -0.8982774615287781,
            "y": 0.31286710500717163,
            "z": -230.83941650390625
        },
        {
            "x": -0.9111455678939819,
            "y": 0.31892871856689453,
            "z": -230.73541259765625
        },
        {
            "x": -0.9306566715240479,
            "y": 0.32807135581970215,
            "z": -230.5792999267578
        },
        {
            "x": -0.9505568742752075,
            "y": 0.3372705280780792,
            "z": -230.42318725585938
        },
        {
            "x": -0.970767617225647,
            "y": 0.34652167558670044,
            "z": -230.26705932617188
        },
        {
            "x": -0.991192102432251,
            "y": 0.3558094799518585,
            "z": -230.11109924316406
        },
        {
            "x": -1.01199471950531,
            "y": 0.3651431202888489,
            "z": -229.955078125
        },
        {
            "x": -1.0331079959869385,
            "y": 0.3745134174823761,
            "z": -229.79917907714844
        },
        {
            "x": -1.0544424057006836,
            "y": 0.3839148283004761,
            "z": -229.64334106445312
        },
        {
            "x": -1.0761672258377075,
            "y": 0.3933582603931427,
            "z": -229.4873809814453
        },
        {
            "x": -1.0981861352920532,
            "y": 0.4028210937976837,
            "z": -229.33160400390625
        },
        {
            "x": -1.1204233169555664,
            "y": 0.41230422258377075,
            "z": -229.1759033203125
        },
        {
            "x": -1.1430623531341553,
            "y": 0.42182040214538574,
            "z": -229.0200653076172
        },
        {
            "x": -1.1659774780273438,
            "y": 0.431338906288147,
            "z": -228.8645477294922
        },
        {
            "x": -1.1891268491744995,
            "y": 0.4408743977546692,
            "z": -228.70896911621094
        },
        {
            "x": -1.212682843208313,
            "y": 0.4504365026950836,
            "z": -228.5531768798828
        },
        {
            "x": -1.2365041971206665,
            "y": 0.45998504757881165,
            "z": -228.3977813720703
        },
        {
            "x": -1.2605743408203125,
            "y": 0.4695442318916321,
            "z": -228.2423095703125
        },
        {
            "x": -1.2850161790847778,
            "y": 0.4791071116924286,
            "z": -228.0867919921875
        },
        {
            "x": -1.309719443321228,
            "y": 0.48865312337875366,
            "z": -227.93157958984375
        },
        {
            "x": -1.3347257375717163,
            "y": 0.4982113242149353,
            "z": -227.77606201171875
        },
        {
            "x": -1.3600724935531616,
            "y": 0.5077489614486694,
            "z": -227.62078857421875
        },
        {
            "x": -1.3856781721115112,
            "y": 0.5172631144523621,
            "z": -227.46568298339844
        },
        {
            "x": -1.4115464687347412,
            "y": 0.5267685651779175,
            "z": -227.31048583984375
        },
        {
            "x": -1.437798261642456,
            "y": 0.5362522006034851,
            "z": -227.15536499023438
        },
        {
            "x": -1.4643105268478394,
            "y": 0.5457083582878113,
            "z": -227.00033569335938
        },
        {
            "x": -1.4911003112792969,
            "y": 0.5551458597183228,
            "z": -226.84519958496094
        },
        {
            "x": -1.518241047859192,
            "y": 0.5645444393157959,
            "z": -226.69024658203125
        },
        {
            "x": -1.5456405878067017,
            "y": 0.5739067196846008,
            "z": -226.5353546142578
        },
        {
            "x": -1.5733144283294678,
            "y": 0.5832328796386719,
            "z": -226.38046264648438
        },
        {
            "x": -1.601341724395752,
            "y": 0.5925147533416748,
            "z": -226.22567749023438
        },
        {
            "x": -1.629622459411621,
            "y": 0.6017565131187439,
            "z": -226.07086181640625
        },
        {
            "x": -1.658195972442627,
            "y": 0.6109473705291748,
            "z": -225.91607666015625
        },
        {
            "x": -1.687121868133545,
            "y": 0.6200835704803467,
            "z": -225.7614288330078
        },
        {
            "x": -1.7162559032440186,
            "y": 0.629159688949585,
            "z": -225.6068572998047
        },
        {
            "x": -1.745718240737915,
            "y": 0.6381833553314209,
            "z": -225.45225524902344
        },
        {
            "x": -1.7755317687988281,
            "y": 0.6471461057662964,
            "z": -225.2976837158203
        },
        {
            "x": -1.8055278062820435,
            "y": 0.6560318470001221,
            "z": -225.1432647705078
        },
        {
            "x": -1.8358790874481201,
            "y": 0.6648541688919067,
            "z": -224.98883056640625
        },
        {
            "x": -1.866518259048462,
            "y": 0.6736012697219849,
            "z": -224.8345184326172
        },
        {
            "x": -1.8973801136016846,
            "y": 0.682267963886261,
            "z": -224.68026733398438
        },
        {
            "x": -1.9286223649978638,
            "y": 0.6908630132675171,
            "z": -224.52590942382812
        },
        {
            "x": -1.9601020812988281,
            "y": 0.6993663311004639,
            "z": -224.3717803955078
        },
        {
            "x": -1.9918228387832642,
            "y": 0.7077838182449341,
            "z": -224.21763610839844
        },
        {
            "x": -2.0131800174713135,
            "y": 0.7133446931838989,
            "z": -224.11488342285156
        },
        {
            "x": -2.0453989505767822,
            "y": 0.7216007709503174,
            "z": -223.9609832763672
        },
        {
            "x": -2.077866315841675,
            "y": 0.7297663688659668,
            "z": -223.80703735351562
        },
        {
            "x": -2.1107306480407715,
            "y": 0.7378432750701904,
            "z": -223.6529083251953
        },
        {
            "x": -2.1437695026397705,
            "y": 0.7457960844039917,
            "z": -223.49916076660156
        },
        {
            "x": -2.17708158493042,
            "y": 0.7536477446556091,
            "z": -223.34536743164062
        },
        {
            "x": -2.2107388973236084,
            "y": 0.7613943815231323,
            "z": -223.19155883789062
        },
        {
            "x": -2.244579792022705,
            "y": 0.769018292427063,
            "z": -223.03793334960938
        },
        {
            "x": -2.2787585258483887,
            "y": 0.776530385017395,
            "z": -222.8842010498047
        },
        {
            "x": -2.313220500946045,
            "y": 0.7839178442955017,
            "z": -222.73060607910156
        },
        {
            "x": -2.3478660583496094,
            "y": 0.7911781072616577,
            "z": -222.57711791992188
        },
        {
            "x": -2.3828604221343994,
            "y": 0.7983177900314331,
            "z": -222.42355346679688
        },
        {
            "x": -2.418077230453491,
            "y": 0.8053123354911804,
            "z": -222.2702178955078
        },
        {
            "x": -2.4535346031188965,
            "y": 0.8121759295463562,
            "z": -222.11683654785156
        },
        {
            "x": -2.489344835281372,
            "y": 0.8189084529876709,
            "z": -221.9634246826172
        },
        {
            "x": -2.5253076553344727,
            "y": 0.8254888653755188,
            "z": -221.81027221679688
        },
        {
            "x": -2.5615692138671875,
            "y": 0.8319239616394043,
            "z": -221.65701293945312
        },
        {
            "x": -2.5981080532073975,
            "y": 0.8382078409194946,
            "z": -221.50392150878906
        },
        {
            "x": -2.634831428527832,
            "y": 0.84433913230896,
            "z": -221.3508758544922
        },
        {
            "x": -2.671907663345337,
            "y": 0.8503247499465942,
            "z": -221.19766235351562
        },
        {
            "x": -2.709155559539795,
            "y": 0.8561313152313232,
            "z": -221.04483032226562
        },
        {
            "x": -2.7466442584991455,
            "y": 0.8617801070213318,
            "z": -220.8919219970703
        },
        {
            "x": -2.784412384033203,
            "y": 0.867261528968811,
            "z": -220.73915100097656
        },
        {
            "x": -2.8223588466644287,
            "y": 0.8725712299346924,
            "z": -220.58642578125
        },
        {
            "x": -2.8606081008911133,
            "y": 0.8777072429656982,
            "z": -220.43360900878906
        },
        {
            "x": -2.899111747741699,
            "y": 0.8826647400856018,
            "z": -220.2808837890625
        },
        {
            "x": -2.9377646446228027,
            "y": 0.8874384760856628,
            "z": -220.1283416748047
        },
        {
            "x": -2.9767255783081055,
            "y": 0.8920344114303589,
            "z": -219.97567749023438
        },
        {
            "x": -3.0158703327178955,
            "y": 0.8964303731918335,
            "z": -219.8232421875
        },
        {
            "x": -3.055232286453247,
            "y": 0.9006367921829224,
            "z": -219.6707763671875
        },
        {
            "x": -3.0949037075042725,
            "y": 0.904653787612915,
            "z": -219.51824951171875
        },
        {
            "x": -3.1346888542175293,
            "y": 0.908467710018158,
            "z": -219.365966796875
        },
        {
            "x": -3.1747591495513916,
            "y": 0.9120758771896362,
            "z": -219.21360778808594
        },
        {
            "x": -3.2150211334228516,
            "y": 0.9154757261276245,
            "z": -219.06143188476562
        },
        {
            "x": -3.255469799041748,
            "y": 0.9186685681343079,
            "z": -218.9092559814453
        },
        {
            "x": -3.296217679977417,
            "y": 0.9216535091400146,
            "z": -218.75697326660156
        },
        {
            "x": -3.337064266204834,
            "y": 0.9244105815887451,
            "z": -218.60499572753906
        },
        {
            "x": -3.378157615661621,
            "y": 0.926949143409729,
            "z": -218.45294189453125
        },
        {
            "x": -3.419456720352173,
            "y": 0.9292653799057007,
            "z": -218.30099487304688
        },
        {
            "x": -3.46089243888855,
            "y": 0.9313560724258423,
            "z": -218.14913940429688
        },
        {
            "x": -3.502608299255371,
            "y": 0.9332115650177002,
            "z": -217.99717712402344
        },
        {
            "x": -3.5444726943969727,
            "y": 0.9348306655883789,
            "z": -217.8453826904297
        },
        {
            "x": -3.5865118503570557,
            "y": 0.9362139105796814,
            "z": -217.6936492919922
        },
        {
            "x": -3.614657402038574,
            "y": 0.9370031356811523,
            "z": -217.592529296875
        },
        {
            "x": -3.6569743156433105,
            "y": 0.9379776120185852,
            "z": -217.44093322753906
        },
        {
            "x": -3.699496269226074,
            "y": 0.9387080073356628,
            "z": -217.28933715820312
        },
        {
            "x": -3.7422494888305664,
            "y": 0.9391902685165405,
            "z": -217.13768005371094
        },
        {
            "x": -3.7850804328918457,
            "y": 0.9394118785858154,
            "z": -216.9862060546875
        },
        {
            "x": -3.8281216621398926,
            "y": 0.9393744468688965,
            "z": -216.83480834960938
        },
        {
            "x": -3.8713204860687256,
            "y": 0.9390824437141418,
            "z": -216.683349609375
        },
        {
            "x": -3.9146640300750732,
            "y": 0.9385396838188171,
            "z": -216.53199768066406
        },
        {
            "x": -3.958203077316284,
            "y": 0.9377418756484985,
            "z": -216.3806915283203
        },
        {
            "x": -4.001865863800049,
            "y": 0.9366951584815979,
            "z": -216.22938537597656
        },
        {
            "x": -4.045680999755859,
            "y": 0.9354088306427002,
            "z": -216.07818603515625
        },
        {
            "x": -4.089632034301758,
            "y": 0.9338847398757935,
            "z": -215.92701721191406
        },
        {
            "x": -4.133708953857422,
            "y": 0.9321215152740479,
            "z": -215.77590942382812
        },
        {
            "x": -4.177933216094971,
            "y": 0.9301236867904663,
            "z": -215.62490844726562
        },
        {
            "x": -4.222311973571777,
            "y": 0.9278967380523682,
            "z": -215.47373962402344
        },
        {
            "x": -4.2667975425720215,
            "y": 0.925449550151825,
            "z": -215.32281494140625
        },
        {
            "x": -4.311392307281494,
            "y": 0.9227768182754517,
            "z": -215.17190551757812
        },
        {
            "x": -4.3561201095581055,
            "y": 0.9198822975158691,
            "z": -215.02098083496094
        },
        {
            "x": -4.400936126708984,
            "y": 0.9167776703834534,
            "z": -214.87020874023438
        },
        {
            "x": -4.445912837982178,
            "y": 0.9134587049484253,
            "z": -214.71925354003906
        },
        {
            "x": -4.490967750549316,
            "y": 0.9099341630935669,
            "z": -214.56851196289062
        },
        {
            "x": -4.536096572875977,
            "y": 0.9062033295631409,
            "z": -214.41786193847656
        },
        {
            "x": -4.581338405609131,
            "y": 0.9022728204727173,
            "z": -214.26718139648438
        },
        {
            "x": -4.6266679763793945,
            "y": 0.8981490135192871,
            "z": -214.1166229248047
        },
        {
            "x": -4.672104358673096,
            "y": 0.8938266038894653,
            "z": -213.96597290039062
        },
        {
            "x": -4.71764612197876,
            "y": 0.889310359954834,
            "z": -213.8153076171875
        },
        {
            "x": -4.7632155418396,
            "y": 0.8846136927604675,
            "z": -213.6648406982422
        },
        {
            "x": -4.808892250061035,
            "y": 0.8797328472137451,
            "z": -213.51429748535156
        },
        {
            "x": -4.8546319007873535,
            "y": 0.8746731877326965,
            "z": -213.36386108398438
        },
        {
            "x": -4.900414943695068,
            "y": 0.8694356679916382,
            "z": -213.2134552001953
        },
        {
            "x": -4.946322917938232,
            "y": 0.864021897315979,
            "z": -213.06292724609375
        },
        {
            "x": -4.992220878601074,
            "y": 0.8584462404251099,
            "z": -212.91256713867188
        },
        {
            "x": -5.038197994232178,
            "y": 0.8527033925056458,
            "z": -212.76220703125
        },
        {
            "x": -5.084216594696045,
            "y": 0.8467960357666016,
            "z": -212.6118927001953
        },
        {
            "x": -5.13025426864624,
            "y": 0.8407332897186279,
            "z": -212.4615936279297
        },
        {
            "x": -5.176394462585449,
            "y": 0.8345105648040771,
            "z": -212.31118774414062
        },
        {
            "x": -5.2225022315979,
            "y": 0.8281443119049072,
            "z": -212.1609649658203
        },
        {
            "x": -5.268651485443115,
            "y": 0.8216268420219421,
            "z": -212.01077270507812
        },
        {
            "x": -5.314835548400879,
            "y": 0.8149630427360535,
            "z": -211.86050415039062
        },
        {
            "x": -5.361018657684326,
            "y": 0.8081643581390381,
            "z": -211.71034240722656
        },
        {
            "x": -5.407245635986328,
            "y": 0.8012243509292603,
            "z": -211.5601043701172
        },
        {
            "x": -5.453476428985596,
            "y": 0.794147253036499,
            "z": -211.4098663330078
        },
        {
            "x": -5.499677658081055,
            "y": 0.7869464159011841,
            "z": -211.259765625
        },
        {
            "x": -5.530483722686768,
            "y": 0.782078742980957,
            "z": -211.15968322753906
        },
        {
            "x": -5.576679229736328,
            "y": 0.774667501449585,
            "z": -211.00958251953125
        },
        {
            "x": -5.622861385345459,
            "y": 0.7671374082565308,
            "z": -210.85951232910156
        },
        {
            "x": -5.66909122467041,
            "y": 0.7594820261001587,
            "z": -210.70924377441406
        },
        {
            "x": -5.715237617492676,
            "y": 0.7517249584197998,
            "z": -210.55917358398438
        },
        {
            "x": -5.761368274688721,
            "y": 0.743851900100708,
            "z": -210.40908813476562
        },
        {
            "x": -5.807490348815918,
            "y": 0.7358691692352295,
            "z": -210.25892639160156
        },
        {
            "x": -5.85355281829834,
            "y": 0.727789044380188,
            "z": -210.1088104248047
        },
        {
            "x": -5.8996124267578125,
            "y": 0.7196049690246582,
            "z": -209.95864868164062
        },
        {
            "x": -5.945598602294922,
            "y": 0.7113239169120789,
            "z": -209.80848693847656
        },
        {
            "x": -5.991522789001465,
            "y": 0.7029545307159424,
            "z": -209.65838623046875
        },
        {
            "x": -6.03742790222168,
            "y": 0.6944916248321533,
            "z": -209.50819396972656
        },
        {
            "x": -6.08322811126709,
            "y": 0.6859498023986816,
            "z": -209.35806274414062
        },
        {
            "x": -6.128974914550781,
            "y": 0.6773250102996826,
            "z": -209.20799255371094
        },
        {
            "x": -6.174688816070557,
            "y": 0.6686105132102966,
            "z": -209.05767822265625
        },
        {
            "x": -6.220284461975098,
            "y": 0.6598318219184875,
            "z": -208.90753173828125
        },
        {
            "x": -6.26580286026001,
            "y": 0.6509814262390137,
            "z": -208.75733947753906
        },
        {
            "x": -6.311240196228027,
            "y": 0.642058789730072,
            "z": -208.6071014404297
        },
        {
            "x": -6.356573104858398,
            "y": 0.6330759525299072,
            "z": -208.4569091796875
        },
        {
            "x": -6.401859283447266,
            "y": 0.6240212321281433,
            "z": -208.3065185546875
        },
        {
            "x": -6.447007179260254,
            "y": 0.614920973777771,
            "z": -208.15626525878906
        },
        {
            "x": -6.492030143737793,
            "y": 0.6057658195495605,
            "z": -208.0060272216797
        },
        {
            "x": -6.536959171295166,
            "y": 0.5965597629547119,
            "z": -207.85574340820312
        },
        {
            "x": -6.581735610961914,
            "y": 0.5873106122016907,
            "z": -207.7054901123047
        },
        {
            "x": -6.62644100189209,
            "y": 0.5780075788497925,
            "z": -207.5550537109375
        },
        {
            "x": -6.671019077301025,
            "y": 0.5686660408973694,
            "z": -207.40460205078125
        },
        {
            "x": -6.715415954589844,
            "y": 0.5592929124832153,
            "z": -207.25418090820312
        },
        {
            "x": -6.759733200073242,
            "y": 0.549879789352417,
            "z": -207.10366821289062
        },
        {
            "x": -6.803834915161133,
            "y": 0.5404463410377502,
            "z": -206.95321655273438
        },
        {
            "x": -6.847822189331055,
            "y": 0.5309832096099854,
            "z": -206.80267333984375
        },
        {
            "x": -6.891695022583008,
            "y": 0.5214881300926208,
            "z": -206.65196228027344
        },
        {
            "x": -6.935349941253662,
            "y": 0.5119833946228027,
            "z": -206.50137329101562
        },
        {
            "x": -6.978878498077393,
            "y": 0.5024620890617371,
            "z": -206.35072326660156
        },
        {
            "x": -7.022207736968994,
            "y": 0.4929271936416626,
            "z": -206.19998168945312
        },
        {
            "x": -7.065378665924072,
            "y": 0.48338669538497925,
            "z": -206.0492401123047
        },
        {
            "x": -7.108388423919678,
            "y": 0.4738316535949707,
            "z": -205.8983612060547
        },
        {
            "x": -7.151192665100098,
            "y": 0.4642826318740845,
            "z": -205.7475128173828
        },
        {
            "x": -7.193789958953857,
            "y": 0.45473963022232056,
            "z": -205.59669494628906
        },
        {
            "x": -7.236215591430664,
            "y": 0.44519108533859253,
            "z": -205.44564819335938
        },
        {
            "x": -7.278440475463867,
            "y": 0.4356606602668762,
            "z": -205.29469299316406
        },
        {
            "x": -7.320444583892822,
            "y": 0.4261370897293091,
            "z": -205.14361572265625
        },
        {
            "x": -7.362289905548096,
            "y": 0.4166262149810791,
            "z": -204.992431640625
        },
        {
            "x": -7.403841018676758,
            "y": 0.40714582800865173,
            "z": -204.84136962890625
        },
        {
            "x": -7.431432723999023,
            "y": 0.4008331894874573,
            "z": -204.7405548095703
        },
        {
            "x": -7.472665786743164,
            "y": 0.39138874411582947,
            "z": -204.58937072753906
        },
        {
            "x": -7.513604640960693,
            "y": 0.3819761276245117,
            "z": -204.4381103515625
        },
        {
            "x": -7.554420471191406,
            "y": 0.37257733941078186,
            "z": -204.28651428222656
        },
        {
            "x": -7.594919681549072,
            "y": 0.36323267221450806,
            "z": -204.13519287109375
        },
        {
            "x": -7.635182857513428,
            "y": 0.3539206385612488,
            "z": -203.9836883544922
        },
        {
            "x": -7.675238132476807,
            "y": 0.3446497321128845,
            "z": -203.83209228515625
        },
        {
            "x": -7.714982509613037,
            "y": 0.33542877435684204,
            "z": -203.6804962158203
        },
        {
            "x": -7.754547119140625,
            "y": 0.3262500762939453,
            "z": -203.52874755859375
        },
        {
            "x": -7.7937912940979,
            "y": 0.3171285092830658,
            "z": -203.37696838378906
        },
        {
            "x": -7.832772254943848,
            "y": 0.308063805103302,
            "z": -203.22512817382812
        },
        {
            "x": -7.871507167816162,
            "y": 0.2990573048591614,
            "z": -203.0731658935547
        },
        {
            "x": -7.909930229187012,
            "y": 0.2901160717010498,
            "z": -202.92120361328125
        },
        {
            "x": -7.948127269744873,
            "y": 0.2812427282333374,
            "z": -202.76922607421875
        },
        {
            "x": -7.986011028289795,
            "y": 0.272432416677475,
            "z": -202.61700439453125
        },
        {
            "x": -8.023614883422852,
            "y": 0.2637021541595459,
            "z": -202.4647979736328
        },
        {
            "x": -8.0609130859375,
            "y": 0.2550516724586487,
            "z": -202.3125762939453
        },
        {
            "x": -8.097917556762695,
            "y": 0.24647527933120728,
            "z": -202.16021728515625
        },
        {
            "x": -8.134629249572754,
            "y": 0.23799191415309906,
            "z": -202.0078887939453
        },
        {
            "x": -8.171024322509766,
            "y": 0.22958411276340485,
            "z": -201.85525512695312
        },
        {
            "x": -8.207135200500488,
            "y": 0.2212754786014557,
            "z": -201.7027130126953
        },
        {
            "x": -8.242876052856445,
            "y": 0.2130657434463501,
            "z": -201.55018615722656
        },
        {
            "x": -8.278329849243164,
            "y": 0.20494776964187622,
            "z": -201.39744567871094
        },
        {
            "x": -8.313453674316406,
            "y": 0.19693972170352936,
            "z": -201.24476623535156
        },
        {
            "x": -8.34824275970459,
            "y": 0.18902656435966492,
            "z": -201.09181213378906
        },
        {
            "x": -8.382774353027344,
            "y": 0.18122069537639618,
            "z": -200.93882751464844
        },
        {
            "x": -8.416864395141602,
            "y": 0.17353694140911102,
            "z": -200.78590393066406
        },
        {
            "x": -8.450700759887695,
            "y": 0.16595962643623352,
            "z": -200.63270568847656
        },
        {
            "x": -8.484149932861328,
            "y": 0.15851059556007385,
            "z": -200.4796142578125
        },
        {
            "x": -8.517243385314941,
            "y": 0.15117767453193665,
            "z": -200.3263702392578
        },
        {
            "x": -8.550070762634277,
            "y": 0.14396584033966064,
            "z": -200.17294311523438
        },
        {
            "x": -8.582428932189941,
            "y": 0.1368943154811859,
            "z": -200.0195770263672
        },
        {
            "x": -8.614522933959961,
            "y": 0.12994810938835144,
            "z": -199.8660125732422
        },
        {
            "x": -8.646207809448242,
            "y": 0.12314267456531525,
            "z": -199.7125244140625
        },
        {
            "x": -8.677530288696289,
            "y": 0.11647370457649231,
            "z": -199.55886840820312
        },
        {
            "x": -8.708556175231934,
            "y": 0.10994654893875122,
            "z": -199.40501403808594
        },
        {
            "x": -8.739102363586426,
            "y": 0.10357305407524109,
            "z": -199.2512969970703
        },
        {
            "x": -8.76936149597168,
            "y": 0.09734496474266052,
            "z": -199.09742736816406
        },
        {
            "x": -8.799198150634766,
            "y": 0.09126991033554077,
            "z": -198.9434814453125
        },
        {
            "x": -8.828660011291504,
            "y": 0.08535492420196533,
            "z": -198.78941345214844
        },
        {
            "x": -8.857775688171387,
            "y": 0.07959946990013123,
            "z": -198.6353302001953
        },
        {
            "x": -8.886452674865723,
            "y": 0.0740034282207489,
            "z": -198.48104858398438
        },
        {
            "x": -8.914813041687012,
            "y": 0.0685768723487854,
            "z": -198.3268280029297
        },
        {
            "x": -8.933440208435059,
            "y": 0.06506223976612091,
            "z": -198.22402954101562
        },
        {
            "x": -8.961066246032715,
            "y": 0.0599229522049427,
            "z": -198.0696563720703
        },
        {
            "x": -8.98837661743164,
            "y": 0.05495910719037056,
            "z": -197.9152374267578
        },
        {
            "x": -9.015216827392578,
            "y": 0.050177205353975296,
            "z": -197.76065063476562
        },
        {
            "x": -9.041699409484863,
            "y": 0.04557860642671585,
            "z": -197.60601806640625
        },
        {
            "x": -9.067756652832031,
            "y": 0.04116830602288246,
            "z": -197.45147705078125
        },
        {
            "x": -9.093400955200195,
            "y": 0.03693953529000282,
            "z": -197.29661560058594
        },
        {
            "x": -9.118690490722656,
            "y": 0.03291485086083412,
            "z": -197.14186096191406
        },
        {
            "x": -9.143494606018066,
            "y": 0.02908342517912388,
            "z": -196.98695373535156
        },
        {
            "x": -9.16796588897705,
            "y": 0.025446979328989983,
            "z": -196.8318634033203
        },
        {
            "x": -9.191981315612793,
            "y": 0.022017478942871094,
            "z": -196.67698669433594
        },
        {
            "x": -9.215547561645508,
            "y": 0.018796632066369057,
            "z": -196.52175903320312
        },
        {
            "x": -9.238767623901367,
            "y": 0.015786755830049515,
            "z": -196.36666870117188
        },
        {
            "x": -9.26148509979248,
            "y": 0.012988806702196598,
            "z": -196.21153259277344
        },
        {
            "x": -9.283878326416016,
            "y": 0.010399384424090385,
            "z": -196.05599975585938
        },
        {
            "x": -9.305791854858398,
            "y": 0.008042876608669758,
            "z": -195.90077209472656
        },
        {
            "x": -9.327238082885742,
            "y": 0.005906084552407265,
            "z": -195.7453155517578
        },
        {
            "x": -9.348355293273926,
            "y": 0.0039934441447257996,
            "z": -195.58982849121094
        },
        {
            "x": -9.368945121765137,
            "y": 0.0023095100186765194,
            "z": -195.43441772460938
        },
        {
            "x": -9.389174461364746,
            "y": 0.0008626196067780256,
            "z": -195.27857971191406
        },
        {
            "x": -9.408960342407227,
            "y": -0.00034595467150211334,
            "z": -195.12306213378906
        },
        {
            "x": -9.428254127502441,
            "y": -0.001318315276876092,
            "z": -194.9673614501953
        },
        {
            "x": -9.447216033935547,
            "y": -0.002050792332738638,
            "z": -194.8116455078125
        },
        {
            "x": -9.465643882751465,
            "y": -0.0025296348612755537,
            "z": -194.6559600830078
        },
        {
            "x": -9.483678817749023,
            "y": -0.0027603134512901306,
            "z": -194.49993896484375
        },
        {
            "x": -9.501322746276855,
            "y": -0.0027907155454158783,
            "z": -194.34405517578125
        },
        {
            "x": -9.51842975616455,
            "y": -0.00279361754655838,
            "z": -194.1881561279297
        },
        {
            "x": -9.535200119018555,
            "y": -0.002796543762087822,
            "z": -194.03199768066406
        },
        {
            "x": -9.551467895507812,
            "y": -0.0027994588017463684,
            "z": -193.8760986328125
        },
        {
            "x": -9.567279815673828,
            "y": -0.0028023719787597656,
            "z": -193.71998596191406
        },
        {
            "x": -9.582762718200684,
            "y": -0.002805277705192566,
            "z": -193.56369018554688
        },
        {
            "x": -9.59766674041748,
            "y": -0.0028081927448511124,
            "z": -193.40760803222656
        },
        {
            "x": -9.612203598022461,
            "y": -0.002811107784509659,
            "z": -193.25131225585938
        },
        {
            "x": -9.626306533813477,
            "y": -0.0028140153735876083,
            "z": -193.09510803222656
        },
        {
            "x": -9.639894485473633,
            "y": -0.0028169434517621994,
            "z": -192.9387969970703
        },
        {
            "x": -9.653154373168945,
            "y": -0.0028198454529047012,
            "z": -192.78225708007812
        },
        {
            "x": -9.665878295898438,
            "y": -0.0028227530419826508,
            "z": -192.62600708007812
        },
        {
            "x": -9.678162574768066,
            "y": -0.002825675532221794,
            "z": -192.4695587158203
        },
        {
            "x": -9.690093040466309,
            "y": -0.00282859243452549,
            "z": -192.31307983398438
        },
        {
            "x": -9.701458930969238,
            "y": -0.00283149816095829,
            "z": -192.15667724609375
        },
        {
            "x": -9.712457656860352,
            "y": -0.002834407612681389,
            "z": -192.00003051757812
        },
        {
            "x": -9.723023414611816,
            "y": -0.002837318927049637,
            "z": -191.843505859375
        },
        {
            "x": -9.733064651489258,
            "y": -0.0028402339667081833,
            "z": -191.68695068359375
        },
        {
            "x": -9.739570617675781,
            "y": -0.002842182293534279,
            "z": -191.58251953125
        },
        {
            "x": -9.748956680297852,
            "y": -0.0028450898826122284,
            "z": -191.42601013183594
        },
        {
            "x": -9.757818222045898,
            "y": -0.002847997471690178,
            "z": -191.26939392089844
        },
        {
            "x": -9.766352653503418,
            "y": -0.002850918099284172,
            "z": -191.11248779296875
        },
        {
            "x": -9.774372100830078,
            "y": -0.0028538350015878677,
            "z": -190.95594787597656
        },
        {
            "x": -9.781927108764648,
            "y": -0.002856738865375519,
            "z": -190.7991943359375
        },
        {
            "x": -9.78914737701416,
            "y": -0.0028596539050340652,
            "z": -190.64236450195312
        },
        {
            "x": -9.795821189880371,
            "y": -0.0028625596314668655,
            "z": -190.48574829101562
        },
        {
            "x": -9.802082061767578,
            "y": -0.0028654802590608597,
            "z": -190.3288116455078
        },
        {
            "x": -9.807971954345703,
            "y": -0.0028683915734291077,
            "z": -190.17198181152344
        },
        {
            "x": -9.813319206237793,
            "y": -0.002871312201023102,
            "z": -190.0152587890625
        },
        {
            "x": -9.818307876586914,
            "y": -0.002874225378036499,
            "z": -189.85824584960938
        },
        {
            "x": -9.822854995727539,
            "y": -0.002877127379179001,
            "z": -189.7015380859375
        },
        {
            "x": -9.826889038085938,
            "y": -0.0028800517320632935,
            "z": -189.54469299316406
        },
        {
            "x": -9.830601692199707,
            "y": -0.0028829630464315414,
            "z": -189.38758850097656
        },
        {
            "x": -9.833830833435059,
            "y": -0.00288587249815464,
            "z": -189.23086547851562
        },
        {
            "x": -9.836567878723145,
            "y": -0.002888783812522888,
            "z": -189.0739288330078
        },
        {
            "x": -9.83898639678955,
            "y": -0.002891693264245987,
            "z": -188.91696166992188
        },
        {
            "x": -9.840902328491211,
            "y": -0.0028946083039045334,
            "z": -188.76019287109375
        },
        {
            "x": -9.842369079589844,
            "y": -0.0028975270688533783,
            "z": -188.60302734375
        },
        {
            "x": -9.843493461608887,
            "y": -0.002900436520576477,
            "z": -188.4461669921875
        },
        {
            "x": -9.844096183776855,
            "y": -0.0029033422470092773,
            "z": -188.2893524169922
        },
        {
            "x": -9.844286918640137,
            "y": -0.0029062535613775253,
            "z": -188.13238525390625
        },
        {
            "x": -9.84411907196045,
            "y": -0.002909170463681221,
            "z": -187.9755401611328
        },
        {
            "x": -9.843389511108398,
            "y": -0.0029120855033397675,
            "z": -187.81861877441406
        },
        {
            "x": -9.84228229522705,
            "y": -0.0029149986803531647,
            "z": -187.66152954101562
        },
        {
            "x": -9.840781211853027,
            "y": -0.002917913720011711,
            "z": -187.50474548339844
        },
        {
            "x": -9.838722229003906,
            "y": -0.002920825034379959,
            "z": -187.34780883789062
        },
        {
            "x": -9.836299896240234,
            "y": -0.0029237400740385056,
            "z": -187.19085693359375
        },
        {
            "x": -9.8334379196167,
            "y": -0.002926664426922798,
            "z": -187.03411865234375
        },
        {
            "x": -9.830042839050293,
            "y": -0.002929573878645897,
            "z": -186.8770751953125
        },
        {
            "x": -9.826309204101562,
            "y": -0.002932479605078697,
            "z": -186.72015380859375
        },
        {
            "x": -9.822081565856934,
            "y": -0.0029355506412684917,
            "z": -186.56336975097656
        },
        {
            "x": -9.817352294921875,
            "y": -0.0030445149168372154,
            "z": -186.40646362304688
        },
        {
            "x": -9.812292098999023,
            "y": -0.003389391116797924,
            "z": -186.24966430664062
        },
        {
            "x": -9.806700706481934,
            "y": -0.00395477470010519,
            "z": -186.09278869628906
        },
        {
            "x": -9.80064868927002,
            "y": -0.004742239601910114,
            "z": -185.9359588623047
        },
        {
            "x": -9.794246673583984,
            "y": -0.005740345921367407,
            "z": -185.7792510986328
        },
        {
            "x": -9.787297248840332,
            "y": -0.006947686895728111,
            "z": -185.62246704101562
        },
        {
            "x": -9.779948234558105,
            "y": -0.00836312584578991,
            "z": -185.46566772460938
        },
        {
            "x": -9.77219009399414,
            "y": -0.009988564066588879,
            "z": -185.30897521972656
        },
        {
            "x": -9.763887405395508,
            "y": -0.011814548633992672,
            "z": -185.15225219726562
        },
        {
            "x": -9.755234718322754,
            "y": -0.013837072066962719,
            "z": -184.99554443359375
        },
        {
            "x": -9.749231338500977,
            "y": -0.01529491227120161,
            "z": -184.89122009277344
        },
        {
            "x": -9.739760398864746,
            "y": -0.017643973231315613,
            "z": -184.73468017578125
        },
        {
            "x": -9.729912757873535,
            "y": -0.020183894783258438,
            "z": -184.57803344726562
        },
        {
            "x": -9.71963882446289,
            "y": -0.02291160821914673,
            "z": -184.4214324951172
        },
        {
            "x": -9.708827018737793,
            "y": -0.025828856974840164,
            "z": -184.26492309570312
        },
        {
            "x": -9.697685241699219,
            "y": -0.028926828876137733,
            "z": -184.10842895507812
        },
        {
            "x": -9.686057090759277,
            "y": -0.03220130503177643,
            "z": -183.9519805908203
        },
        {
            "x": -9.673956871032715,
            "y": -0.035652220249176025,
            "z": -183.7955322265625
        },
        {
            "x": -9.66150188446045,
            "y": -0.03928274288773537,
            "z": -183.6390838623047
        },
        {
            "x": -9.64852523803711,
            "y": -0.04308050870895386,
            "z": -183.48277282714844
        },
        {
            "x": -9.635146141052246,
            "y": -0.04704465717077255,
            "z": -183.326416015625
        },
        {
            "x": -9.621386528015137,
            "y": -0.05117136240005493,
            "z": -183.17010498046875
        },
        {
            "x": -9.607081413269043,
            "y": -0.05546349659562111,
            "z": -183.01394653320312
        },
        {
            "x": -9.592432975769043,
            "y": -0.059913914650678635,
            "z": -182.85772705078125
        },
        {
            "x": -9.577330589294434,
            "y": -0.06451938301324844,
            "z": -182.70152282714844
        },
        {
            "x": -9.561751365661621,
            "y": -0.06927408277988434,
            "z": -182.54542541503906
        },
        {
            "x": -9.5458345413208,
            "y": -0.07418323308229446,
            "z": -182.38938903808594
        },
        {
            "x": -9.529415130615234,
            "y": -0.07923560589551926,
            "z": -182.23342895507812
        },
        {
            "x": -9.512580871582031,
            "y": -0.08443230390548706,
            "z": -182.0774383544922
        },
        {
            "x": -9.495379447937012,
            "y": -0.08976995199918747,
            "z": -181.9214324951172
        },
        {
            "x": -9.4776611328125,
            "y": -0.09524410218000412,
            "z": -181.76565551757812
        },
        {
            "x": -9.459588050842285,
            "y": -0.10085433721542358,
            "z": -181.6098175048828
        },
        {
            "x": -9.441102027893066,
            "y": -0.1065884381532669,
            "z": -181.45419311523438
        },
        {
            "x": -9.422131538391113,
            "y": -0.1124543845653534,
            "z": -181.2985382080078
        },
        {
            "x": -9.402819633483887,
            "y": -0.11845231056213379,
            "z": -181.14279174804688
        },
        {
            "x": -9.383024215698242,
            "y": -0.1245686411857605,
            "z": -180.9872283935547
        },
        {
            "x": -9.36283016204834,
            "y": -0.13080430030822754,
            "z": -180.83164978027344
        },
        {
            "x": -9.34228229522705,
            "y": -0.13715405762195587,
            "z": -180.67616271972656
        },
        {
            "x": -9.3212308883667,
            "y": -0.1436166614294052,
            "z": -180.52084350585938
        },
        {
            "x": -9.299844741821289,
            "y": -0.1501920223236084,
            "z": -180.365478515625
        },
        {
            "x": -9.278009414672852,
            "y": -0.1568773090839386,
            "z": -180.2100830078125
        },
        {
            "x": -9.255748748779297,
            "y": -0.1636618822813034,
            "z": -180.0548553466797
        },
        {
            "x": -9.233160972595215,
            "y": -0.17054994404315948,
            "z": -179.89967346191406
        },
        {
            "x": -9.210087776184082,
            "y": -0.1775340586900711,
            "z": -179.7445831298828
        },
        {
            "x": -9.186653137207031,
            "y": -0.18461431562900543,
            "z": -179.5895233154297
        },
        {
            "x": -9.162834167480469,
            "y": -0.19178929924964905,
            "z": -179.43441772460938
        },
        {
            "x": -9.138555526733398,
            "y": -0.19904887676239014,
            "z": -179.27957153320312
        },
        {
            "x": -9.113966941833496,
            "y": -0.20639513432979584,
            "z": -179.1247100830078
        },
        {
            "x": -9.08893871307373,
            "y": -0.21382436156272888,
            "z": -178.9699249267578
        },
        {
            "x": -9.06351375579834,
            "y": -0.22133293747901917,
            "z": -178.81517028808594
        },
        {
            "x": -9.037753105163574,
            "y": -0.2289201021194458,
            "z": -178.6604766845703
        },
        {
            "x": -9.011519432067871,
            "y": -0.23658275604248047,
            "z": -178.50584411621094
        },
        {
            "x": -8.984976768493652,
            "y": -0.24431301653385162,
            "z": -178.351318359375
        },
        {
            "x": -8.96708869934082,
            "y": -0.2495003342628479,
            "z": -178.24838256835938
        },
        {
            "x": -8.939848899841309,
            "y": -0.2573395371437073,
            "z": -178.09405517578125
        },
        {
            "x": -8.912300109863281,
            "y": -0.2652430832386017,
            "z": -177.93966674804688
        },
        {
            "x": -8.884328842163086,
            "y": -0.27321088314056396,
            "z": -177.78530883789062
        },
        {
            "x": -8.855979919433594,
            "y": -0.2812311053276062,
            "z": -177.63108825683594
        },
        {
            "x": -8.8273344039917,
            "y": -0.28930050134658813,
            "z": -177.47702026367188
        },
        {
            "x": -8.798224449157715,
            "y": -0.29742640256881714,
            "z": -177.3229217529297
        },
        {
            "x": -8.768814086914062,
            "y": -0.3055976629257202,
            "z": -177.1688995361328
        },
        {
            "x": -8.739035606384277,
            "y": -0.313812792301178,
            "z": -177.0149688720703
        },
        {
            "x": -8.708826065063477,
            "y": -0.3220750093460083,
            "z": -176.8610076904297
        },
        {
            "x": -8.678366661071777,
            "y": -0.33036693930625916,
            "z": -176.70726013183594
        },
        {
            "x": -8.647466659545898,
            "y": -0.33869868516921997,
            "z": -176.55349731445312
        },
        {
            "x": -8.616259574890137,
            "y": -0.3470607101917267,
            "z": -176.39984130859375
        },
        {
            "x": -8.58472728729248,
            "y": -0.35544663667678833,
            "z": -176.24635314941406
        },
        {
            "x": -8.552743911743164,
            "y": -0.3638732135295868,
            "z": -176.09268188476562
        },
        {
            "x": -8.520533561706543,
            "y": -0.3723110556602478,
            "z": -175.9392547607422
        },
        {
            "x": -8.487921714782715,
            "y": -0.3807680904865265,
            "z": -175.7859344482422
        },
        {
            "x": -8.454955101013184,
            "y": -0.3892490863800049,
            "z": -175.632568359375
        },
        {
            "x": -8.421724319458008,
            "y": -0.397735059261322,
            "z": -175.4794158935547
        },
        {
            "x": -8.388052940368652,
            "y": -0.4062454402446747,
            "z": -175.3260955810547
        },
        {
            "x": -8.354161262512207,
            "y": -0.41475266218185425,
            "z": -175.1730194091797
        },
        {
            "x": -8.31989860534668,
            "y": -0.42326074838638306,
            "z": -175.02011108398438
        },
        {
            "x": -8.285306930541992,
            "y": -0.4317764639854431,
            "z": -174.8671417236328
        },
        {
            "x": -8.250449180603027,
            "y": -0.4402843713760376,
            "z": -174.71432495117188
        },
        {
            "x": -8.215181350708008,
            "y": -0.4487963914871216,
            "z": -174.56149291992188
        },
        {
            "x": -8.179651260375977,
            "y": -0.4573015868663788,
            "z": -174.40869140625
        },
        {
            "x": -8.143811225891113,
            "y": -0.46578603982925415,
            "z": -174.25613403320312
        },
        {
            "x": -8.107620239257812,
            "y": -0.47426772117614746,
            "z": -174.1034393310547
        },
        {
            "x": -8.071207046508789,
            "y": -0.4827237129211426,
            "z": -173.95095825195312
        },
        {
            "x": -8.03441333770752,
            "y": -0.49116051197052,
            "z": -173.7985382080078
        },
        {
            "x": -7.997329235076904,
            "y": -0.49958568811416626,
            "z": -173.64598083496094
        },
        {
            "x": -7.959982395172119,
            "y": -0.5079712867736816,
            "z": -173.49374389648438
        },
        {
            "x": -7.922313690185547,
            "y": -0.5163357257843018,
            "z": -173.34141540527344
        },
        {
            "x": -7.884402751922607,
            "y": -0.5246628522872925,
            "z": -173.18922424316406
        },
        {
            "x": -7.846149921417236,
            "y": -0.5329533815383911,
            "z": -173.03717041015625
        },
        {
            "x": -7.807615756988525,
            "y": -0.5412179827690125,
            "z": -172.8849334716797
        },
        {
            "x": -7.768849849700928,
            "y": -0.5494258403778076,
            "z": -172.7330322265625
        },
        {
            "x": -7.729781150817871,
            "y": -0.557593822479248,
            "z": -172.58111572265625
        },
        {
            "x": -7.690455913543701,
            "y": -0.5657156109809875,
            "z": -172.42921447753906
        },
        {
            "x": -7.650834560394287,
            "y": -0.5737829208374023,
            "z": -172.27748107910156
        },
        {
            "x": -7.610970497131348,
            "y": -0.5818032026290894,
            "z": -172.12564086914062
        },
        {
            "x": -7.570822238922119,
            "y": -0.589762806892395,
            "z": -171.9739532470703
        },
        {
            "x": -7.53041934967041,
            "y": -0.5976596474647522,
            "z": -171.8223419189453
        },
        {
            "x": -7.503383159637451,
            "y": -0.6028891801834106,
            "z": -171.72134399414062
        },
        {
            "x": -7.462570667266846,
            "y": -0.6106755137443542,
            "z": -171.56993103027344
        },
        {
            "x": -7.4215087890625,
            "y": -0.618397057056427,
            "z": -171.41845703125
        },
        {
            "x": -7.380186080932617,
            "y": -0.6260533332824707,
            "z": -171.26698303222656
        },
        {
            "x": -7.338628768920898,
            "y": -0.6336285471916199,
            "z": -171.1156768798828
        },
        {
            "x": -7.296884536743164,
            "y": -0.6411243677139282,
            "z": -170.96444702148438
        },
        {
            "x": -7.254824638366699,
            "y": -0.6485422849655151,
            "z": -170.81317138671875
        },
        {
            "x": -7.212593078613281,
            "y": -0.6558735966682434,
            "z": -170.6620330810547
        },
        {
            "x": -7.170117378234863,
            "y": -0.6631207466125488,
            "z": -170.5109100341797
        },
        {
            "x": -7.127389430999756,
            "y": -0.6702791452407837,
            "z": -170.3597869873047
        },
        {
            "x": -7.084517002105713,
            "y": -0.6773358583450317,
            "z": -170.20887756347656
        },
        {
            "x": -7.041348934173584,
            "y": -0.6843021512031555,
            "z": -170.05789184570312
        },
        {
            "x": -6.99802303314209,
            "y": -0.6911667585372925,
            "z": -169.90699768066406
        },
        {
            "x": -6.954494953155518,
            "y": -0.6979254484176636,
            "z": -169.75625610351562
        },
        {
            "x": -6.910677433013916,
            "y": -0.7045856714248657,
            "z": -169.60533142089844
        },
        {
            "x": -6.866755962371826,
            "y": -0.7111285328865051,
            "z": -169.4546356201172
        },
        {
            "x": -6.8225884437561035,
            "y": -0.7175619602203369,
            "z": -169.303955078125
        },
        {
            "x": -6.778260231018066,
            "y": -0.7238813042640686,
            "z": -169.15330505371094
        },
        {
            "x": -6.733736991882324,
            "y": -0.7300751209259033,
            "z": -169.00279235839844
        },
        {
            "x": -6.688962459564209,
            "y": -0.7361577749252319,
            "z": -168.85208129882812
        },
        {
            "x": -6.644104480743408,
            "y": -0.742106556892395,
            "z": -168.70167541503906
        },
        {
            "x": -6.599023342132568,
            "y": -0.7479293942451477,
            "z": -168.55128479003906
        },
        {
            "x": -6.553812026977539,
            "y": -0.753616452217102,
            "z": -168.40087890625
        },
        {
            "x": -6.508409023284912,
            "y": -0.7591694593429565,
            "z": -168.25059509277344
        },
        {
            "x": -6.462810039520264,
            "y": -0.7645912170410156,
            "z": -168.10020446777344
        },
        {
            "x": -6.417076110839844,
            "y": -0.7698718309402466,
            "z": -167.9498748779297
        },
        {
            "x": -6.3711724281311035,
            "y": -0.7750004529953003,
            "z": -167.79966735839844
        },
        {
            "x": -6.32512092590332,
            "y": -0.7799868583679199,
            "z": -167.64939880371094
        },
        {
            "x": -6.278939247131348,
            "y": -0.7848197817802429,
            "z": -167.49929809570312
        },
        {
            "x": -6.2326178550720215,
            "y": -0.7895017862319946,
            "z": -167.34921264648438
        },
        {
            "x": -6.186101913452148,
            "y": -0.7940260767936707,
            "z": -167.19898986816406
        },
        {
            "x": -6.139500141143799,
            "y": -0.7983863949775696,
            "z": -167.04898071289062
        },
        {
            "x": -6.092771530151367,
            "y": -0.8025867938995361,
            "z": -166.89892578125
        },
        {
            "x": -6.045888423919678,
            "y": -0.8066221475601196,
            "z": -166.74896240234375
        },
        {
            "x": -5.998917579650879,
            "y": -0.8104815483093262,
            "z": -166.5989990234375
        },
        {
            "x": -5.95176362991333,
            "y": -0.8141724467277527,
            "z": -166.44894409179688
        },
        {
            "x": -5.904548645019531,
            "y": -0.8176850080490112,
            "z": -166.299072265625
        },
        {
            "x": -5.857234477996826,
            "y": -0.8210203647613525,
            "z": -166.14923095703125
        },
        {
            "x": -5.8097662925720215,
            "y": -0.8241695165634155,
            "z": -165.99932861328125
        },
        {
            "x": -5.7622456550598145,
            "y": -0.8271316289901733,
            "z": -165.8495635986328
        },
        {
            "x": -5.714590549468994,
            "y": -0.8299087882041931,
            "z": -165.69970703125
        },
        {
            "x": -5.6668500900268555,
            "y": -0.8324958086013794,
            "z": -165.54986572265625
        },
        {
            "x": -5.619060516357422,
            "y": -0.8348796367645264,
            "z": -165.40017700195312
        },
        {
            "x": -5.58713436126709,
            "y": -0.836359977722168,
            "z": -165.30038452148438
        },
        {
            "x": -5.539202690124512,
            "y": -0.8384166955947876,
            "z": -165.15069580078125
        },
        {
            "x": -5.491183757781982,
            "y": -0.8402639627456665,
            "z": -165.00103759765625
        },
        {
            "x": -5.443028926849365,
            "y": -0.8419069647789001,
            "z": -164.8511962890625
        },
        {
            "x": -5.39488410949707,
            "y": -0.8433393239974976,
            "z": -164.70156860351562
        },
        {
            "x": -5.346658229827881,
            "y": -0.8445605635643005,
            "z": -164.55197143554688
        },
        {
            "x": -5.298356533050537,
            "y": -0.8455613851547241,
            "z": -164.4022674560547
        },
        {
            "x": -5.250022888183594,
            "y": -0.8463407158851624,
            "z": -164.25265502929688
        },
        {
            "x": -5.2016096115112305,
            "y": -0.8469001054763794,
            "z": -164.10299682617188
        },
        {
            "x": -5.153156280517578,
            "y": -0.8472357988357544,
            "z": -163.95335388183594
        },
        {
            "x": -5.104684829711914,
            "y": -0.8473364114761353,
            "z": -163.80381774902344
        },
        {
            "x": -5.056148052215576,
            "y": -0.8472052812576294,
            "z": -163.65414428710938
        },
        {
            "x": -5.007616996765137,
            "y": -0.8468483090400696,
            "z": -163.50462341308594
        },
        {
            "x": -4.959040641784668,
            "y": -0.84626704454422,
            "z": -163.35507202148438
        },
        {
            "x": -4.910400390625,
            "y": -0.8454588055610657,
            "z": -163.2053680419922
        },
        {
            "x": -4.861808776855469,
            "y": -0.8444304466247559,
            "z": -163.0558319091797
        },
        {
            "x": -4.813179016113281,
            "y": -0.8431881666183472,
            "z": -162.9062957763672
        },
        {
            "x": -4.764530181884766,
            "y": -0.8417348861694336,
            "z": -162.7567138671875
        },
        {
            "x": -4.715914726257324,
            "y": -0.8400683403015137,
            "z": -162.6072235107422
        },
        {
            "x": -4.6672210693359375,
            "y": -0.8381908535957336,
            "z": -162.45751953125
        },
        {
            "x": -4.618599891662598,
            "y": -0.8361152410507202,
            "z": -162.30799865722656
        },
        {
            "x": -4.56998348236084,
            "y": -0.8338411450386047,
            "z": -162.15850830078125
        },
        {
            "x": -4.521389007568359,
            "y": -0.8313663005828857,
            "z": -162.00894165039062
        },
        {
            "x": -4.472822666168213,
            "y": -0.8286961317062378,
            "z": -161.85946655273438
        },
        {
            "x": -4.424232006072998,
            "y": -0.825835645198822,
            "z": -161.7098388671875
        },
        {
            "x": -4.375668525695801,
            "y": -0.8227887153625488,
            "z": -161.56016540527344
        },
        {
            "x": -4.3271684646606445,
            "y": -0.819556474685669,
            "z": -161.4105987548828
        },
        {
            "x": -4.27868127822876,
            "y": -0.8161395788192749,
            "z": -161.26092529296875
        },
        {
            "x": -4.230253219604492,
            "y": -0.812548041343689,
            "z": -161.11135864257812
        },
        {
            "x": -4.181890964508057,
            "y": -0.8087842464447021,
            "z": -160.96176147460938
        },
        {
            "x": -4.133500576019287,
            "y": -0.8048414587974548,
            "z": -160.8119659423828
        },
        {
            "x": -4.085236549377441,
            "y": -0.8007316589355469,
            "z": -160.66233825683594
        },
        {
            "x": -4.037013530731201,
            "y": -0.796457827091217,
            "z": -160.51260375976562
        },
        {
            "x": -3.988845109939575,
            "y": -0.7920230031013489,
            "z": -160.3629150390625
        },
        {
            "x": -3.9407804012298584,
            "y": -0.7874302864074707,
            "z": -160.21322631835938
        },
        {
            "x": -3.8927066326141357,
            "y": -0.7826724648475647,
            "z": -160.0633087158203
        },
        {
            "x": -3.8447961807250977,
            "y": -0.7777703404426575,
            "z": -159.91358947753906
        },
        {
            "x": -3.7969613075256348,
            "y": -0.7727207541465759,
            "z": -159.76385498046875
        },
        {
            "x": -3.749183177947998,
            "y": -0.7675197124481201,
            "z": -159.61398315429688
        },
        {
            "x": -3.701545000076294,
            "y": -0.7621769905090332,
            "z": -159.4641571044922
        },
        {
            "x": -3.6539499759674072,
            "y": -0.7566919326782227,
            "z": -159.31423950195312
        },
        {
            "x": -3.6064720153808594,
            "y": -0.7510712146759033,
            "z": -159.1642608642578
        },
        {
            "x": -3.559109687805176,
            "y": -0.7453216314315796,
            "z": -159.014404296875
        },
        {
            "x": -3.527611494064331,
            "y": -0.7414119839668274,
            "z": -158.9144287109375
        },
        {
            "x": -3.480466604232788,
            "y": -0.7354469299316406,
            "z": -158.76451110839844
        },
        {
            "x": -3.4333975315093994,
            "y": -0.7293558120727539,
            "z": -158.614501953125
        },
        {
            "x": -3.38643217086792,
            "y": -0.723131537437439,
            "z": -158.4643096923828
        },
        {
            "x": -3.339625597000122,
            "y": -0.7167985439300537,
            "z": -158.31423950195312
        },
        {
            "x": -3.2929623126983643,
            "y": -0.710349440574646,
            "z": -158.1641082763672
        },
        {
            "x": -3.246415853500366,
            "y": -0.7037861347198486,
            "z": -158.01390075683594
        },
        {
            "x": -3.2000174522399902,
            "y": -0.6971130967140198,
            "z": -157.86370849609375
        },
        {
            "x": -3.1537668704986572,
            "y": -0.6903319358825684,
            "z": -157.71340942382812
        },
        {
            "x": -3.1076323986053467,
            "y": -0.6834483742713928,
            "z": -157.5630340576172
        },
        {
            "x": -3.061706781387329,
            "y": -0.6764692068099976,
            "z": -157.4127197265625
        },
        {
            "x": -3.0159056186676025,
            "y": -0.6693865060806274,
            "z": -157.2622528076172
        },
        {
            "x": -2.9702847003936768,
            "y": -0.6622146368026733,
            "z": -157.11181640625
        },
        {
            "x": -2.924858331680298,
            "y": -0.6549554467201233,
            "z": -156.9613800048828
        },
        {
            "x": -2.879514217376709,
            "y": -0.6475993990898132,
            "z": -156.81068420410156
        },
        {
            "x": -2.8344409465789795,
            "y": -0.6401652097702026,
            "z": -156.6601104736328
        },
        {
            "x": -2.78951358795166,
            "y": -0.6326500177383423,
            "z": -156.50949096679688
        },
        {
            "x": -2.744776964187622,
            "y": -0.625055193901062,
            "z": -156.35873413085938
        },
        {
            "x": -2.7002577781677246,
            "y": -0.6173914074897766,
            "z": -156.20802307128906
        },
        {
            "x": -2.655857563018799,
            "y": -0.6096417903900146,
            "z": -156.0570526123047
        },
        {
            "x": -2.61175274848938,
            "y": -0.6018352508544922,
            "z": -155.90621948242188
        },
        {
            "x": -2.5678040981292725,
            "y": -0.5939627885818481,
            "z": -155.7552947998047
        },
        {
            "x": -2.5241005420684814,
            "y": -0.5860282778739929,
            "z": -155.60430908203125
        },
        {
            "x": -2.480600357055664,
            "y": -0.5780354142189026,
            "z": -155.45333862304688
        },
        {
            "x": -2.437283515930176,
            "y": -0.569979190826416,
            "z": -155.30213928222656
        },
        {
            "x": -2.394214153289795,
            "y": -0.5618727207183838,
            "z": -155.15090942382812
        },
        {
            "x": -2.3513565063476562,
            "y": -0.5537210702896118,
            "z": -154.99972534179688
        },
        {
            "x": -2.3087501525878906,
            "y": -0.5455151796340942,
            "z": -154.84832763671875
        },
        {
            "x": -2.266378879547119,
            "y": -0.5372732877731323,
            "z": -154.697021484375
        },
        {
            "x": -2.22426438331604,
            "y": -0.5289890766143799,
            "z": -154.5455780029297
        },
        {
            "x": -2.182335138320923,
            "y": -0.5206591486930847,
            "z": -154.39395141601562
        },
        {
            "x": -2.140692949295044,
            "y": -0.5123015642166138,
            "z": -154.2423553466797
        },
        {
            "x": -2.099334478378296,
            "y": -0.5039119720458984,
            "z": -154.0906982421875
        },
        {
            "x": -2.05818510055542,
            "y": -0.495494544506073,
            "z": -153.93898010253906
        },
        {
            "x": -2.0173540115356445,
            "y": -0.4870545268058777,
            "z": -153.78721618652344
        },
        {
            "x": -1.97671639919281,
            "y": -0.47858262062072754,
            "z": -153.63519287109375
        },
        {
            "x": -1.9364025592803955,
            "y": -0.47009962797164917,
            "z": -153.48326110839844
        },
        {
            "x": -1.8963948488235474,
            "y": -0.46160414814949036,
            "z": -153.33131408691406
        },
        {
            "x": -1.8565794229507446,
            "y": -0.4530881643295288,
            "z": -153.17913818359375
        },
        {
            "x": -1.8171385526657104,
            "y": -0.4445686340332031,
            "z": -153.02699279785156
        },
        {
            "x": -1.7779202461242676,
            "y": -0.43603891134262085,
            "z": -152.87472534179688
        },
        {
            "x": -1.739013433456421,
            "y": -0.4275017976760864,
            "z": -152.72230529785156
        },
        {
            "x": -1.7004375457763672,
            "y": -0.41897493600845337,
            "z": -152.56997680664062
        },
        {
            "x": -1.6748601198196411,
            "y": -0.41328877210617065,
            "z": -152.46835327148438
        },
        {
            "x": -1.6368062496185303,
            "y": -0.40476447343826294,
            "z": -152.3158416748047
        },
        {
            "x": -1.5990288257598877,
            "y": -0.39625084400177,
            "z": -152.16331481933594
        },
        {
            "x": -1.5615170001983643,
            "y": -0.38773274421691895,
            "z": -152.01040649414062
        },
        {
            "x": -1.5244084596633911,
            "y": -0.3792440891265869,
            "z": -151.85769653320312
        },
        {
            "x": -1.4875608682632446,
            "y": -0.3707698583602905,
            "z": -151.7049102783203
        },
        {
            "x": -1.4510771036148071,
            "y": -0.36230987310409546,
            "z": -151.5518798828125
        },
        {
            "x": -1.4148880243301392,
            "y": -0.35388046503067017,
            "z": -151.39894104003906
        },
        {
            "x": -1.3790515661239624,
            "y": -0.3454694449901581,
            "z": -151.24578857421875
        },
        {
            "x": -1.343552827835083,
            "y": -0.33709168434143066,
            "z": -151.0925750732422
        },
        {
            "x": -1.3083816766738892,
            "y": -0.32874757051467896,
            "z": -150.93931579589844
        },
        {
            "x": -1.2735992670059204,
            "y": -0.32043537497520447,
            "z": -150.78591918945312
        },
        {
            "x": -1.2391246557235718,
            "y": -0.3121682405471802,
            "z": -150.63255310058594
        },
        {
            "x": -1.2050610780715942,
            "y": -0.3039399981498718,
            "z": -150.47901916503906
        },
        {
            "x": -1.1712862253189087,
            "y": -0.2957500219345093,
            "z": -150.32533264160156
        },
        {
            "x": -1.1378986835479736,
            "y": -0.2876131236553192,
            "z": -150.17166137695312
        },
        {
            "x": -1.1049225330352783,
            "y": -0.27953052520751953,
            "z": -150.0178985595703
        },
        {
            "x": -1.0722407102584839,
            "y": -0.2714981734752655,
            "z": -149.86404418945312
        },
        {
            "x": -1.0400159358978271,
            "y": -0.26352518796920776,
            "z": -149.7101287841797
        },
        {
            "x": -1.0080724954605103,
            "y": -0.255604088306427,
            "z": -149.55601501464844
        },
        {
            "x": -0.9765782356262207,
            "y": -0.24775481224060059,
            "z": -149.40191650390625
        },
        {
            "x": -0.9454887509346008,
            "y": -0.23997485637664795,
            "z": -149.247802734375
        },
        {
            "x": -0.9147244691848755,
            "y": -0.23225924372673035,
            "z": -149.0935516357422
        },
        {
            "x": -0.884434700012207,
            "y": -0.22461846470832825,
            "z": -148.9392547607422
        },
        {
            "x": -0.8544561862945557,
            "y": -0.21705026924610138,
            "z": -148.78480529785156
        },
        {
            "x": -0.8249210119247437,
            "y": -0.20955735445022583,
            "z": -148.6301727294922
        },
        {
            "x": -0.7958069443702698,
            "y": -0.2021542489528656,
            "z": -148.4756622314453
        },
        {
            "x": -0.7670323848724365,
            "y": -0.1948259174823761,
            "z": -148.32090759277344
        },
        {
            "x": -0.7387776374816895,
            "y": -0.18759462237358093,
            "z": -148.16619873046875
        },
        {
            "x": -0.7108489871025085,
            "y": -0.18045353889465332,
            "z": -148.01141357421875
        },
        {
            "x": -0.6833671927452087,
            "y": -0.17339572310447693,
            "z": -147.8563232421875
        },
        {
            "x": -0.6563029885292053,
            "y": -0.1664448380470276,
            "z": -147.70140075683594
        },
        {
            "x": -0.629641592502594,
            "y": -0.1595897227525711,
            "z": -147.5462646484375
        },
        {
            "x": -0.6034817099571228,
            "y": -0.15284231305122375,
            "z": -147.39112854003906
        },
        {
            "x": -0.5776663422584534,
            "y": -0.14619985222816467,
            "z": -147.23593139648438
        },
        {
            "x": -0.5523361563682556,
            "y": -0.13965655863285065,
            "z": -147.08042907714844
        },
        {
            "x": -0.5274329781532288,
            "y": -0.13323882222175598,
            "z": -146.9251251220703
        },
        {
            "x": -0.5029726624488831,
            "y": -0.1269332617521286,
            "z": -146.76966857910156
        },
        {
            "x": -0.478982537984848,
            "y": -0.12074358761310577,
            "z": -146.61410522460938
        },
        {
            "x": -0.4553678035736084,
            "y": -0.11467569321393967,
            "z": -146.45851135253906
        },
        {
            "x": -0.43229150772094727,
            "y": -0.10873087495565414,
            "z": -146.302734375
        },
        {
            "x": -0.40959984064102173,
            "y": -0.1029168963432312,
            "z": -146.14697265625
        },
        {
            "x": -0.3873974084854126,
            "y": -0.09723284840583801,
            "z": -145.9911651611328
        },
        {
            "x": -0.37288692593574524,
            "y": -0.09351809322834015,
            "z": -145.8872833251953
        },
        {
            "x": -0.3514147400856018,
            "y": -0.08806219696998596,
            "z": -145.73141479492188
        },
        {
            "x": -0.33045992255210876,
            "y": -0.08274062722921371,
            "z": -145.57537841796875
        },
        {
            "x": -0.30993330478668213,
            "y": -0.0775562971830368,
            "z": -145.419189453125
        },
        {
            "x": -0.2898576259613037,
            "y": -0.07252159714698792,
            "z": -145.26304626464844
        },
        {
            "x": -0.27035385370254517,
            "y": -0.06763850152492523,
            "z": -145.10687255859375
        },
        {
            "x": -0.2512092888355255,
            "y": -0.0629013180732727,
            "z": -144.95059204101562
        },
        {
            "x": -0.2326190173625946,
            "y": -0.05831800028681755,
            "z": -144.7942352294922
        },
        {
            "x": -0.21448203921318054,
            "y": -0.05389222130179405,
            "z": -144.63783264160156
        },
        {
            "x": -0.19679133594036102,
            "y": -0.04962633550167084,
            "z": -144.48129272460938
        },
        {
            "x": -0.17968054115772247,
            "y": -0.04552624374628067,
            "z": -144.32481384277344
        },
        {
            "x": -0.16293367743492126,
            "y": -0.0415865033864975,
            "z": -144.1681671142578
        },
        {
            "x": -0.14676573872566223,
            "y": -0.03781777247786522,
            "z": -144.0115203857422
        },
        {
            "x": -0.13108322024345398,
            "y": -0.03422711417078972,
            "z": -143.85491943359375
        },
        {
            "x": -0.11582091450691223,
            "y": -0.03080274537205696,
            "z": -143.69802856445312
        },
        {
            "x": -0.1011594757437706,
            "y": -0.027559421956539154,
            "z": -143.54124450683594
        },
        {
            "x": -0.08688663691282272,
            "y": -0.0244965348392725,
            "z": -143.3844451904297
        },
        {
            "x": -0.07319509238004684,
            "y": -0.021620385348796844,
            "z": -143.2274932861328
        },
        {
            "x": -0.05999483913183212,
            "y": -0.018931493163108826,
            "z": -143.0706329345703
        },
        {
            "x": -0.047218479216098785,
            "y": -0.016425391659140587,
            "z": -142.9134521484375
        },
        {
            "x": -0.03507047891616821,
            "y": -0.014116059057414532,
            "z": -142.7564697265625
        },
        {
            "x": -0.023329779505729675,
            "y": -0.012007181532680988,
            "z": -142.59945678710938
        },
        {
            "x": -0.012155100703239441,
            "y": -0.010093817487359047,
            "z": -142.44236755371094
        },
        {
            "x": -0.001491740345954895,
            "y": -0.00838067289441824,
            "z": -142.28530883789062
        },
        {
            "x": 0.008747398853302002,
            "y": -0.006869146600365639,
            "z": -142.12803649902344
        },
        {
            "x": 0.01834486424922943,
            "y": -0.005571414716541767,
            "z": -141.97076416015625
        },
        {
            "x": 0.027526184916496277,
            "y": -0.004482532851397991,
            "z": -141.8135986328125
        },
        {
            "x": 0.036165669560432434,
            "y": -0.0036029419861733913,
            "z": -141.6562042236328
        },
        {
            "x": 0.044245779514312744,
            "y": -0.0029394140001386404,
            "z": -141.4989776611328
        },
        {
            "x": 0.05189579725265503,
            "y": -0.0025010344106703997,
            "z": -141.34169006347656
        },
        {
            "x": 0.058928266167640686,
            "y": -0.002287273993715644,
            "z": -141.18414306640625
        },
        {
            "x": 0.06551408767700195,
            "y": -0.002274337224662304,
            "z": -141.02685546875
        },
        {
            "x": 0.07158146798610687,
            "y": -0.0022809510119259357,
            "z": -140.869384765625
        },
        {
            "x": 0.0770331472158432,
            "y": -0.0022875810973346233,
            "z": -140.7119903564453
        },
        {
            "x": 0.08208450675010681,
            "y": -0.0022942107170820236,
            "z": -140.55459594726562
        },
        {
            "x": 0.0865253210067749,
            "y": -0.002300835680216551,
            "z": -140.3969268798828
        },
        {
            "x": 0.09047776460647583,
            "y": -0.0023074550554156303,
            "z": -140.23960876464844
        },
        {
            "x": 0.09393717348575592,
            "y": -0.002314091194421053,
            "z": -140.0821075439453
        },
        {
            "x": 0.09678728878498077,
            "y": -0.002320714760571718,
            "z": -139.92457580566406
        },
        {
            "x": 0.09923507273197174,
            "y": -0.0023273443803191185,
            "z": -139.76718139648438
        },
        {
            "x": 0.10113577544689178,
            "y": -0.0023339632898569107,
            "z": -139.6095733642578
        },
        {
            "x": 0.10255558788776398,
            "y": -0.0023406012915074825,
            "z": -139.4520721435547
        },
        {
            "x": 0.10360537469387054,
            "y": -0.0023472229950129986,
            "z": -139.29464721679688
        },
        {
            "x": 0.10405868291854858,
            "y": -0.0023516458459198475,
            "z": -139.18971252441406
        },
        {
            "x": 0.10451790690422058,
            "y": -0.0023582549765706062,
            "z": -139.0323944091797
        },
        {
            "x": 0.1047525703907013,
            "y": -0.0023648864589631557,
            "z": -138.8750457763672
        },
        {
            "x": 0.10477331280708313,
            "y": -0.002371520269662142,
            "z": -138.71754455566406
        },
        {
            "x": 0.10473659634590149,
            "y": -0.002378139179199934,
            "z": -138.56028747558594
        },
        {
            "x": 0.10461054742336273,
            "y": -0.002384769730269909,
            "z": -138.4030303955078
        },
        {
            "x": 0.10444687306880951,
            "y": -0.002391402143985033,
            "z": -138.2456817626953
        },
        {
            "x": 0.10427582263946533,
            "y": -0.002398023847490549,
            "z": -138.0884552001953
        },
        {
            "x": 0.1040877103805542,
            "y": -0.0024046516045928,
            "z": -137.9311065673828
        },
        {
            "x": 0.10389678180217743,
            "y": -0.0024112779647111893,
            "z": -137.77377319335938
        },
        {
            "x": 0.10370305180549622,
            "y": -0.0024179043248295784,
            "z": -137.61654663085938
        },
        {
            "x": 0.10350601375102997,
            "y": -0.0024245334789156914,
            "z": -137.45919799804688
        },
        {
            "x": 0.10330778360366821,
            "y": -0.002431157510727644,
            "z": -137.30197143554688
        },
        {
            "x": 0.10310718417167664,
            "y": -0.002437780611217022,
            "z": -137.1447296142578
        },
        {
            "x": 0.10290449857711792,
            "y": -0.0024444134905934334,
            "z": -136.9873046875
        },
        {
            "x": 0.10270039737224579,
            "y": -0.0024510412476956844,
            "z": -136.830078125
        },
        {
            "x": 0.10249391198158264,
            "y": -0.002457668539136648,
            "z": -136.67279052734375
        },
        {
            "x": 0.10228587687015533,
            "y": -0.002464293036609888,
            "z": -136.51551818847656
        },
        {
            "x": 0.10207580029964447,
            "y": -0.0024709110148251057,
            "z": -136.3582763671875
        },
        {
            "x": 0.10186350345611572,
            "y": -0.0024775490164756775,
            "z": -136.20083618164062
        },
        {
            "x": 0.10164985060691833,
            "y": -0.0024841749109327793,
            "z": -136.0436248779297
        },
        {
            "x": 0.10143384337425232,
            "y": -0.002490800339728594,
            "z": -135.88638305664062
        },
        {
            "x": 0.10121628642082214,
            "y": -0.0024974197149276733,
            "z": -135.72914123535156
        },
        {
            "x": 0.10099659860134125,
            "y": -0.002504047006368637,
            "z": -135.57191467285156
        },
        {
            "x": 0.10077476501464844,
            "y": -0.0025106766261160374,
            "z": -135.41458129882812
        },
        {
            "x": 0.10055135190486908,
            "y": -0.0025172969326376915,
            "z": -135.2572479248047
        },
        {
            "x": 0.1003255844116211,
            "y": -0.0025239307433366776,
            "z": -135.1000213623047
        },
        {
            "x": 0.10009822249412537,
            "y": -0.0025305566377937794,
            "z": -134.9426727294922
        },
        {
            "x": 0.09986884891986847,
            "y": -0.002537183463573456,
            "z": -134.7854461669922
        },
        {
            "x": 0.09963738918304443,
            "y": -0.002543802373111248,
            "z": -134.6282196044922
        },
        {
            "x": 0.09940402209758759,
            "y": -0.0025504366494715214,
            "z": -134.4707794189453
        },
        {
            "x": 0.0991685688495636,
            "y": -0.0025570583529770374,
            "z": -134.3135528564453
        },
        {
            "x": 0.09893152117729187,
            "y": -0.0025636903010308743,
            "z": -134.15626525878906
        },
        {
            "x": 0.0986921638250351,
            "y": -0.0025703166611492634,
            "z": -133.9989776611328
        },
        {
            "x": 0.09845101833343506,
            "y": -0.002576937898993492,
            "z": -133.8417510986328
        },
        {
            "x": 0.09820780158042908,
            "y": -0.0025835740379989147,
            "z": -133.68431091308594
        },
        {
            "x": 0.09796254336833954,
            "y": -0.0025901938788592815,
            "z": -133.52708435058594
        },
        {
            "x": 0.09771570563316345,
            "y": -0.002596819307655096,
            "z": -133.36985778808594
        },
        {
            "x": 0.09746633470058441,
            "y": -0.00260344659909606,
            "z": -133.21249389648438
        },
        {
            "x": 0.0972154289484024,
            "y": -0.002610074821859598,
            "z": -133.05526733398438
        },
        {
            "x": 0.09696228802204132,
            "y": -0.002616706769913435,
            "z": -132.89793395996094
        },
        {
            "x": 0.09670710563659668,
            "y": -0.0026168006006628275,
            "z": -132.7406005859375
        },
        {
            "x": 0.09645020961761475,
            "y": -0.0023822435177862644,
            "z": -132.5833740234375
        },
        {
            "x": 0.0962756872177124,
            "y": -0.002014489844441414,
            "z": -132.47854614257812
        },
        {
            "x": 0.09601546823978424,
            "y": -0.0011308505199849606,
            "z": -132.3212890625
        },
        {
            "x": 0.09575313329696655,
            "y": 0.00013655098155140877,
            "z": -132.1640625
        },
        {
            "x": 0.09548842906951904,
            "y": 0.0017729455139487982,
            "z": -132.00662231445312
        },
        {
            "x": 0.09522221982479095,
            "y": 0.003765600500628352,
            "z": -131.84938049316406
        },
        {
            "x": 0.09495373070240021,
            "y": 0.006115895230323076,
            "z": -131.69216918945312
        },
        {
            "x": 0.0946834534406662,
            "y": 0.008816801942884922,
            "z": -131.53485107421875
        },
        {
            "x": 0.09441091120243073,
            "y": 0.011847622692584991,
            "z": -131.37765502929688
        },
        {
            "x": 0.0941365659236908,
            "y": 0.015203596092760563,
            "z": -131.22035217285156
        },
        {
            "x": 0.0938599556684494,
            "y": 0.018881596624851227,
            "z": -131.06304931640625
        },
        {
            "x": 0.09358149766921997,
            "y": 0.022870613262057304,
            "z": -130.90586853027344
        },
        {
            "x": 0.09330101311206818,
            "y": 0.027159210294485092,
            "z": -130.74856567382812
        },
        {
            "x": 0.09301847219467163,
            "y": 0.03173273429274559,
            "z": -130.59140014648438
        },
        {
            "x": 0.09273415803909302,
            "y": 0.036591410636901855,
            "z": -130.43423461914062
        },
        {
            "x": 0.09244708716869354,
            "y": 0.04173530638217926,
            "z": -130.27688598632812
        },
        {
            "x": 0.0921587198972702,
            "y": 0.047133367508649826,
            "z": -130.1197509765625
        },
        {
            "x": 0.09186793863773346,
            "y": 0.05278691649436951,
            "z": -129.96255493164062
        },
        {
            "x": 0.09157530963420868,
            "y": 0.05868925899267197,
            "z": -129.80535888671875
        },
        {
            "x": 0.09128060936927795,
            "y": 0.06483198702335358,
            "z": -129.64825439453125
        },
        {
            "x": 0.09098359942436218,
            "y": 0.07120949029922485,
            "z": -129.49095153808594
        },
        {
            "x": 0.09068489074707031,
            "y": 0.07779746502637863,
            "z": -129.33384704589844
        },
        {
            "x": 0.09038408100605011,
            "y": 0.08459755778312683,
            "z": -129.1767578125
        },
        {
            "x": 0.0900813490152359,
            "y": 0.09160523116588593,
            "z": -129.01966857910156
        },
        {
            "x": 0.08977632224559784,
            "y": 0.0988042801618576,
            "z": -128.86260986328125
        },
        {
            "x": 0.08946935832500458,
            "y": 0.10619120299816132,
            "z": -128.7054443359375
        },
        {
            "x": 0.08915998041629791,
            "y": 0.11375515908002853,
            "z": -128.5482635498047
        },
        {
            "x": 0.08884905278682709,
            "y": 0.12148617208003998,
            "z": -128.39122009277344
        },
        {
            "x": 0.0885356217622757,
            "y": 0.12937872111797333,
            "z": -128.23411560058594
        },
        {
            "x": 0.08822058141231537,
            "y": 0.13741502165794373,
            "z": -128.0770721435547
        },
        {
            "x": 0.08790315687656403,
            "y": 0.14559128880500793,
            "z": -127.92008209228516
        },
        {
            "x": 0.08758355677127838,
            "y": 0.1539146453142166,
            "z": -127.76286315917969
        },
        {
            "x": 0.08726204931735992,
            "y": 0.16235056519508362,
            "z": -127.60585021972656
        },
        {
            "x": 0.08693856000900269,
            "y": 0.1709032654762268,
            "z": -127.44877624511719
        },
        {
            "x": 0.08661286532878876,
            "y": 0.1795606017112732,
            "z": -127.2917251586914
        },
        {
            "x": 0.08628520369529724,
            "y": 0.18831518292427063,
            "z": -127.1347427368164
        },
        {
            "x": 0.08595511317253113,
            "y": 0.19716867804527283,
            "z": -126.97756958007812
        },
        {
            "x": 0.08562329411506653,
            "y": 0.2060898095369339,
            "z": -126.82059478759766
        },
        {
            "x": 0.08528944849967957,
            "y": 0.21508198976516724,
            "z": -126.66361999511719
        },
        {
            "x": 0.0849532037973404,
            "y": 0.22414495050907135,
            "z": -126.50653076171875
        },
        {
            "x": 0.08461509644985199,
            "y": 0.2332545518875122,
            "z": -126.34957122802734
        },
        {
            "x": 0.08427467942237854,
            "y": 0.24241408705711365,
            "z": -126.19249725341797
        },
        {
            "x": 0.0839323103427887,
            "y": 0.25160980224609375,
            "z": -126.03543090820312
        },
        {
            "x": 0.08358782529830933,
            "y": 0.26082706451416016,
            "z": -125.87847137451172
        },
        {
            "x": 0.08335718512535095,
            "y": 0.26698288321495056,
            "z": -125.77383422851562
        },
        {
            "x": 0.08300922811031342,
            "y": 0.2762262225151062,
            "z": -125.61687469482422
        },
        {
            "x": 0.08265936374664307,
            "y": 0.2854740023612976,
            "z": -125.45990753173828
        },
        {
            "x": 0.08230669796466827,
            "y": 0.2947285771369934,
            "z": -125.30274963378906
        },
        {
            "x": 0.08195264637470245,
            "y": 0.30395740270614624,
            "z": -125.14580535888672
        },
        {
            "x": 0.08159621059894562,
            "y": 0.31316518783569336,
            "z": -124.98883819580078
        },
        {
            "x": 0.08123770356178284,
            "y": 0.32234758138656616,
            "z": -124.83177947998047
        },
        {
            "x": 0.08087700605392456,
            "y": 0.3314831554889679,
            "z": -124.67481994628906
        },
        {
            "x": 0.08051425218582153,
            "y": 0.3405776619911194,
            "z": -124.51773071289062
        },
        {
            "x": 0.08014915883541107,
            "y": 0.349615216255188,
            "z": -124.36067199707031
        },
        {
            "x": 0.0797823965549469,
            "y": 0.35858017206192017,
            "z": -124.20368957519531
        },
        {
            "x": 0.0794130265712738,
            "y": 0.3674760162830353,
            "z": -124.04659271240234
        },
        {
            "x": 0.07904194295406342,
            "y": 0.3762829303741455,
            "z": -123.88960266113281
        },
        {
            "x": 0.07866860926151276,
            "y": 0.3849983215332031,
            "z": -123.73263549804688
        },
        {
            "x": 0.0782928466796875,
            "y": 0.39362359046936035,
            "z": -123.57542419433594
        },
        {
            "x": 0.0779152661561966,
            "y": 0.4021258056163788,
            "z": -123.4184341430664
        },
        {
            "x": 0.07753549516201019,
            "y": 0.4105137288570404,
            "z": -123.2613754272461
        },
        {
            "x": 0.07715368270874023,
            "y": 0.4187757074832916,
            "z": -123.10430145263672
        },
        {
            "x": 0.07676970958709717,
            "y": 0.4268988370895386,
            "z": -122.94728088378906
        },
        {
            "x": 0.07638336718082428,
            "y": 0.4348830580711365,
            "z": -122.7900619506836
        },
        {
            "x": 0.07599508762359619,
            "y": 0.4427061080932617,
            "z": -122.63301849365234
        },
        {
            "x": 0.07560491561889648,
            "y": 0.45036837458610535,
            "z": -122.47598266601562
        },
        {
            "x": 0.07521244883537292,
            "y": 0.457859069108963,
            "z": -122.3189468383789
        },
        {
            "x": 0.07481800019741058,
            "y": 0.4651654362678528,
            "z": -122.16191101074219
        },
        {
            "x": 0.07442103326320648,
            "y": 0.4722897410392761,
            "z": -122.0047378540039
        },
        {
            "x": 0.0740220695734024,
            "y": 0.47921812534332275,
            "z": -121.84757995605469
        },
        {
            "x": 0.07362121343612671,
            "y": 0.485937237739563,
            "z": -121.69046783447266
        },
        {
            "x": 0.07321786880493164,
            "y": 0.4924386441707611,
            "z": -121.53327178955078
        },
        {
            "x": 0.07281282544136047,
            "y": 0.4987136721611023,
            "z": -121.37616729736328
        },
        {
            "x": 0.07240548729896545,
            "y": 0.5047585964202881,
            "z": -121.21906280517578
        },
        {
            "x": 0.0719957947731018,
            "y": 0.5105718970298767,
            "z": -121.0617446899414
        },
        {
            "x": 0.07158420979976654,
            "y": 0.5161178112030029,
            "z": -120.90462493896484
        },
        {
            "x": 0.07117050886154175,
            "y": 0.5214096307754517,
            "z": -120.74742126464844
        },
        {
            "x": 0.07075479626655579,
            "y": 0.526435375213623,
            "z": -120.59022521972656
        },
        {
            "x": 0.0703369677066803,
            "y": 0.5311859846115112,
            "z": -120.43306732177734
        },
        {
            "x": 0.06991669535636902,
            "y": 0.5356450080871582,
            "z": -120.27571868896484
        },
        {
            "x": 0.06949466466903687,
            "y": 0.5398070812225342,
            "z": -120.11853790283203
        },
        {
            "x": 0.0690707266330719,
            "y": 0.5436687469482422,
            "z": -119.96137237548828
        },
        {
            "x": 0.06864441931247711,
            "y": 0.5472242832183838,
            "z": -119.80406951904297
        },
        {
            "x": 0.06821620464324951,
            "y": 0.5504443049430847,
            "z": -119.64686584472656
        },
        {
            "x": 0.06778584420681,
            "y": 0.5533388257026672,
            "z": -119.48957824707031
        },
        {
            "x": 0.06735332310199738,
            "y": 0.5558977127075195,
            "z": -119.33226776123047
        },
        {
            "x": 0.06691911816596985,
            "y": 0.5581110715866089,
            "z": -119.17506408691406
        },
        {
            "x": 0.06662838160991669,
            "y": 0.5593766570091248,
            "z": -119.07025909423828
        },
        {
            "x": 0.06618881225585938,
            "y": 0.5609855651855469,
            "z": -118.91304016113281
        },
        {
            "x": 0.06574927270412445,
            "y": 0.5622276067733765,
            "z": -118.75581359863281
        },
        {
            "x": 0.06530699133872986,
            "y": 0.5630780458450317,
            "z": -118.59840393066406
        },
        {
            "x": 0.06486344337463379,
            "y": 0.5635401010513306,
            "z": -118.44117736816406
        },
        {
            "x": 0.06441789865493774,
            "y": 0.5636086463928223,
            "z": -118.28394317626953
        },
        {
            "x": 0.06397008895874023,
            "y": 0.563281238079071,
            "z": -118.1266098022461
        },
        {
            "x": 0.06352068483829498,
            "y": 0.5625500679016113,
            "z": -117.9693832397461
        },
        {
            "x": 0.06306906044483185,
            "y": 0.5614359378814697,
            "z": -117.81208038330078
        },
        {
            "x": 0.06261546909809113,
            "y": 0.5599508285522461,
            "z": -117.65474700927734
        },
        {
            "x": 0.0621604323387146,
            "y": 0.5581046342849731,
            "z": -117.49755096435547
        },
        {
            "x": 0.061703160405159,
            "y": 0.5558899641036987,
            "z": -117.34021759033203
        },
        {
            "x": 0.061244264245033264,
            "y": 0.5533292293548584,
            "z": -117.18302154541016
        },
        {
            "x": 0.06078368425369263,
            "y": 0.5504328012466431,
            "z": -117.02581787109375
        },
        {
            "x": 0.06032080948352814,
            "y": 0.5472055077552795,
            "z": -116.8684310913086
        },
        {
            "x": 0.05985654890537262,
            "y": 0.5436521768569946,
            "z": -116.71123504638672
        },
        {
            "x": 0.059390515089035034,
            "y": 0.5397845506668091,
            "z": -116.55401611328125
        },
        {
            "x": 0.058922767639160156,
            "y": 0.5356162786483765,
            "z": -116.39677429199219
        },
        {
            "x": 0.058453530073165894,
            "y": 0.5311579704284668,
            "z": -116.23963165283203
        },
        {
            "x": 0.05798201262950897,
            "y": 0.5263999104499817,
            "z": -116.08226776123047
        },
        {
            "x": 0.05750951170921326,
            "y": 0.5213702917098999,
            "z": -115.92512512207031
        },
        {
            "x": 0.057035401463508606,
            "y": 0.5160752534866333,
            "z": -115.76799774169922
        },
        {
            "x": 0.05655977129936218,
            "y": 0.5105229616165161,
            "z": -115.6108627319336
        },
        {
            "x": 0.05608266592025757,
            "y": 0.5047146677970886,
            "z": -115.4537353515625
        },
        {
            "x": 0.05560387670993805,
            "y": 0.49866002798080444,
            "z": -115.29653930664062
        },
        {
            "x": 0.05512362718582153,
            "y": 0.4923740029335022,
            "z": -115.13934326171875
        },
        {
            "x": 0.05464227497577667,
            "y": 0.4858698844909668,
            "z": -114.98224639892578
        },
        {
            "x": 0.05415944755077362,
            "y": 0.47914308309555054,
            "z": -114.82505798339844
        },
        {
            "x": 0.05367559194564819,
            "y": 0.4722111225128174,
            "z": -114.66797637939453
        },
        {
            "x": 0.053190574049949646,
            "y": 0.4650838077068329,
            "z": -114.51091003417969
        },
        {
            "x": 0.05270390212535858,
            "y": 0.45776066184043884,
            "z": -114.3536605834961
        },
        {
            "x": 0.052216723561286926,
            "y": 0.45026344060897827,
            "z": -114.19661712646484
        },
        {
            "x": 0.05172845721244812,
            "y": 0.4425899386405945,
            "z": -114.03951263427734
        },
        {
            "x": 0.0512392520904541,
            "y": 0.4347555637359619,
            "z": -113.88243103027344
        },
        {
            "x": 0.050749391317367554,
            "y": 0.42677193880081177,
            "z": -113.72539520263672
        },
        {
            "x": 0.05025838315486908,
            "y": 0.41863176226615906,
            "z": -113.56819152832031
        },
        {
            "x": 0.04976719617843628,
            "y": 0.4103631377220154,
            "z": -113.41117095947266
        },
        {
            "x": 0.049275562167167664,
            "y": 0.40196841955184937,
            "z": -113.25416564941406
        },
        {
            "x": 0.048783257603645325,
            "y": 0.39345017075538635,
            "z": -113.09706115722656
        },
        {
            "x": 0.04829096794128418,
            "y": 0.38482820987701416,
            "z": -112.94007873535156
        },
        {
            "x": 0.0477982759475708,
            "y": 0.37609589099884033,
            "z": -112.78298950195312
        },
        {
            "x": 0.047305598855018616,
            "y": 0.36727261543273926,
            "z": -112.62590026855469
        },
        {
            "x": 0.046813368797302246,
            "y": 0.35837268829345703,
            "z": -112.46893310546875
        },
        {
            "x": 0.046485498547554016,
            "y": 0.35239601135253906,
            "z": -112.36427307128906
        },
        {
            "x": 0.04599393904209137,
            "y": 0.34337496757507324,
            "z": -112.20730590820312
        },
        {
            "x": 0.045503050088882446,
            "y": 0.3342932164669037,
            "z": -112.05032348632812
        },
        {
            "x": 0.04501253366470337,
            "y": 0.32514917850494385,
            "z": -111.89317321777344
        },
        {
            "x": 0.04452374577522278,
            "y": 0.315973162651062,
            "z": -111.73621368408203
        },
        {
            "x": 0.044036269187927246,
            "y": 0.30676278471946716,
            "z": -111.5792465209961
        },
        {
            "x": 0.04355020821094513,
            "y": 0.29752105474472046,
            "z": -111.42218780517578
        },
        {
            "x": 0.04306642711162567,
            "y": 0.28826963901519775,
            "z": -111.2652359008789
        },
        {
            "x": 0.04258471727371216,
            "y": 0.2790032625198364,
            "z": -111.1081771850586
        },
        {
            "x": 0.04210573434829712,
            "y": 0.26973819732666016,
            "z": -110.95111846923828
        },
        {
            "x": 0.041630133986473083,
            "y": 0.2604891359806061,
            "z": -110.7941665649414
        },
        {
            "x": 0.04115782678127289,
            "y": 0.25125089287757874,
            "z": -110.6371078491211
        },
        {
            "x": 0.04069016873836517,
            "y": 0.24204783141613007,
            "z": -110.48016357421875
        },
        {
            "x": 0.04022720456123352,
            "y": 0.23287996649742126,
            "z": -110.32321166992188
        },
        {
            "x": 0.03976915776729584,
            "y": 0.22374413907527924,
            "z": -110.16604614257812
        },
        {
            "x": 0.0393177792429924,
            "y": 0.21467271447181702,
            "z": -110.00906372070312
        },
        {
            "x": 0.038873590528964996,
            "y": 0.2056618630886078,
            "z": -109.85203552246094
        },
        {
            "x": 0.038437604904174805,
            "y": 0.19672200083732605,
            "z": -109.69501495361328
        },
        {
            "x": 0.03801095485687256,
            "y": 0.1878643035888672,
            "z": -109.53803253173828
        },
        {
            "x": 0.03759437054395676,
            "y": 0.17908132076263428,
            "z": -109.38082885742188
        },
        {
            "x": 0.0371910035610199,
            "y": 0.17041030526161194,
            "z": -109.2238540649414
        },
        {
            "x": 0.03680184483528137,
            "y": 0.16184549033641815,
            "z": -109.06686401367188
        },
        {
            "x": 0.03642906993627548,
            "y": 0.1533929854631424,
            "z": -108.90984344482422
        },
        {
            "x": 0.036075375974178314,
            "y": 0.1450631320476532,
            "z": -108.75283813476562
        },
        {
            "x": 0.03574474900960922,
            "y": 0.1368623971939087,
            "z": -108.5957260131836
        },
        {
            "x": 0.0354413166642189,
            "y": 0.12880408763885498,
            "z": -108.43860626220703
        },
        {
            "x": 0.03517031669616699,
            "y": 0.12089917808771133,
            "z": -108.28158569335938
        },
        {
            "x": 0.03492525964975357,
            "y": 0.11314474046230316,
            "z": -108.12442016601562
        },
        {
            "x": 0.03446756303310394,
            "y": 0.10555952042341232,
            "z": -107.96724700927734
        },
        {
            "x": 0.03307271748781204,
            "y": 0.09814619272947311,
            "z": -107.80992126464844
        },
        {
            "x": 0.03047221153974533,
            "y": 0.09090717881917953,
            "z": -107.65240478515625
        },
        {
            "x": 0.026713363826274872,
            "y": 0.08387096226215363,
            "z": -107.4951171875
        },
        {
            "x": 0.021841228008270264,
            "y": 0.0770387351512909,
            "z": -107.33779907226562
        },
        {
            "x": 0.0159214586019516,
            "y": 0.0704234316945076,
            "z": -107.18052673339844
        },
        {
            "x": 0.009048722684383392,
            "y": 0.06403084844350815,
            "z": -107.02337646484375
        },
        {
            "x": 0.0012704581022262573,
            "y": 0.0578581877052784,
            "z": -106.8660659790039
        },
        {
            "x": -0.00733763724565506,
            "y": 0.05193448066711426,
            "z": -106.708984375
        },
        {
            "x": -0.01672270894050598,
            "y": 0.046264223754405975,
            "z": -106.5519790649414
        },
        {
            "x": -0.026813574135303497,
            "y": 0.04084383696317673,
            "z": -106.39490509033203
        },
        {
            "x": -0.037539757788181305,
            "y": 0.03568890690803528,
            "z": -106.23796844482422
        },
        {
            "x": -0.048854000866413116,
            "y": 0.030805809423327446,
            "z": -106.08100128173828
        },
        {
            "x": -0.0607142336666584,
            "y": 0.026211775839328766,
            "z": -105.924072265625
        },
        {
            "x": -0.07303648442029953,
            "y": 0.02190793678164482,
            "z": -105.76728820800781
        },
        {
            "x": -0.08147749304771423,
            "y": 0.01919858530163765,
            "z": -105.66277313232422
        },
        {
            "x": -0.09448391944169998,
            "y": 0.0154022928327322,
            "z": -105.50603485107422
        },
        {
            "x": -0.1078227311372757,
            "y": 0.011916261166334152,
            "z": -105.34932708740234
        },
        {
            "x": -0.12147747725248337,
            "y": 0.00874457135796547,
            "z": -105.19245147705078
        },
        {
            "x": -0.1353679597377777,
            "y": 0.005907546263188124,
            "z": -105.03580474853516
        },
        {
            "x": -0.14948108792304993,
            "y": 0.0034190129954367876,
            "z": -104.87918090820312
        },
        {
            "x": -0.16378122568130493,
            "y": 0.0012732737231999636,
            "z": -104.72246551513672
        },
        {
            "x": -0.17821532487869263,
            "y": -0.0005183534231036901,
            "z": -104.56587219238281
        },
        {
            "x": -0.19276736676692963,
            "y": -0.001946471631526947,
            "z": -104.4092025756836
        },
        {
            "x": -0.2074054479598999,
            "y": -0.0029891913291066885,
            "z": -104.25253295898438
        },
        {
            "x": -0.22208377718925476,
            "y": -0.00365247530862689,
            "z": -104.09596252441406
        },
        {
            "x": -0.23680174350738525,
            "y": -0.003928651101887226,
            "z": -103.93927764892578
        },
        {
            "x": -0.25150972604751587,
            "y": -0.003947085700929165,
            "z": -103.78274536132812
        },
        {
            "x": -0.266196072101593,
            "y": -0.003953131381422281,
            "z": -103.62620544433594
        },
        {
            "x": -0.2808581590652466,
            "y": -0.003959175664931536,
            "z": -103.46947479248047
        },
        {
            "x": -0.2954410910606384,
            "y": -0.003965220879763365,
            "z": -103.31292724609375
        },
        {
            "x": -0.309951514005661,
            "y": -0.003971264697611332,
            "z": -103.15632629394531
        },
        {
            "x": -0.32436439394950867,
            "y": -0.003977301996201277,
            "z": -102.99972534179688
        },
        {
            "x": -0.3386642038822174,
            "y": -0.0039833467453718185,
            "z": -102.84317016601562
        },
        {
            "x": -0.3528580665588379,
            "y": -0.003989390097558498,
            "z": -102.6864013671875
        },
        {
            "x": -0.36689645051956177,
            "y": -0.003995434381067753,
            "z": -102.52983093261719
        },
        {
            "x": -0.3807828724384308,
            "y": -0.004001474007964134,
            "z": -102.37324523925781
        },
        {
            "x": -0.3945123255252838,
            "y": -0.00400751456618309,
            "z": -102.21664428710938
        },
        {
            "x": -0.4080759882926941,
            "y": -0.00401355279609561,
            "z": -102.06002807617188
        },
        {
            "x": -0.4214727282524109,
            "y": -0.004019598476588726,
            "z": -101.90330505371094
        },
        {
            "x": -0.43467918038368225,
            "y": -0.004025644157081842,
            "z": -101.74656677246094
        },
        {
            "x": -0.447685182094574,
            "y": -0.004031685180962086,
            "z": -101.58990478515625
        },
        {
            "x": -0.4605042636394501,
            "y": -0.004037726670503616,
            "z": -101.43312072753906
        },
        {
            "x": -0.47311457991600037,
            "y": -0.0040437690913677216,
            "z": -101.27644348144531
        },
        {
            "x": -0.48550474643707275,
            "y": -0.004049815237522125,
            "z": -101.1197280883789
        },
        {
            "x": -0.4976983070373535,
            "y": -0.004055859055370092,
            "z": -100.96281433105469
        },
        {
            "x": -0.5096595287322998,
            "y": -0.004061899147927761,
            "z": -100.80607604980469
        },
        {
            "x": -0.5214066505432129,
            "y": -0.004067945294082165,
            "z": -100.64926147460938
        },
        {
            "x": -0.5329189896583557,
            "y": -0.0040739839896559715,
            "z": -100.49243927001953
        },
        {
            "x": -0.5442018508911133,
            "y": -0.004080028273165226,
            "z": -100.33564758300781
        },
        {
            "x": -0.5552717447280884,
            "y": -0.004086075350642204,
            "z": -100.17864227294922
        },
        {
            "x": -0.566098153591156,
            "y": -0.004092115443199873,
            "z": -100.02183532714844
        },
        {
            "x": -0.5766815543174744,
            "y": -0.0040981583297252655,
            "z": -99.864990234375
        },
        {
            "x": -0.5870360136032104,
            "y": -0.004104201681911945,
            "z": -99.70804595947266
        },
        {
            "x": -0.5971505045890808,
            "y": -0.004110243171453476,
            "z": -99.5511703491211
        },
        {
            "x": -0.6070362329483032,
            "y": -0.00411628745496273,
            "z": -99.3941879272461
        },
        {
            "x": -0.6166784763336182,
            "y": -0.004122333601117134,
            "z": -99.2371826171875
        },
        {
            "x": -0.6260759234428406,
            "y": -0.004128374624997377,
            "z": -99.08028411865234
        },
        {
            "x": -0.6322113275527954,
            "y": -0.004132399335503578,
            "z": -98.97567749023438
        },
        {
            "x": -0.6412104964256287,
            "y": -0.004138440825045109,
            "z": -98.8187484741211
        },
        {
            "x": -0.6499711871147156,
            "y": -0.004144483245909214,
            "z": -98.66180419921875
        },
        {
            "x": -0.6585071086883545,
            "y": -0.00415052892640233,
            "z": -98.50464630126953
        },
        {
            "x": -0.6667951941490173,
            "y": -0.004156571812927723,
            "z": -98.34767150878906
        },
        {
            "x": -0.6748383641242981,
            "y": -0.004162612371146679,
            "z": -98.19068145751953
        },
        {
            "x": -0.6826515197753906,
            "y": -0.004168652929365635,
            "z": -98.0335693359375
        },
        {
            "x": -0.6902248859405518,
            "y": -0.00415255269035697,
            "z": -97.87655639648438
        },
        {
            "x": -0.6975712180137634,
            "y": -0.003996176645159721,
            "z": -97.71942901611328
        },
        {
            "x": -0.7046759724617004,
            "y": -0.0036675366573035717,
            "z": -97.56230163574219
        },
        {
            "x": -0.7115427255630493,
            "y": -0.0031742218416184187,
            "z": -97.4052505493164
        },
        {
            "x": -0.7181851863861084,
            "y": -0.00252107298001647,
            "z": -97.24807739257812
        },
        {
            "x": -0.7245948910713196,
            "y": -0.0017122766003012657,
            "z": -97.09099578857422
        },
        {
            "x": -0.730767548084259,
            "y": -0.0007457155734300613,
            "z": -96.93392944335938
        },
        {
            "x": -0.7367181777954102,
            "y": 0.00037396885454654694,
            "z": -96.77664184570312
        },
        {
            "x": -0.7424381375312805,
            "y": 0.001638183370232582,
            "z": -96.61954498291016
        },
        {
            "x": -0.7479356527328491,
            "y": 0.003045367542654276,
            "z": -96.46239471435547
        },
        {
            "x": -0.7532022595405579,
            "y": 0.004596466198563576,
            "z": -96.30523681640625
        },
        {
            "x": -0.7582453489303589,
            "y": 0.006285140290856361,
            "z": -96.14812469482422
        },
        {
            "x": -0.7630752325057983,
            "y": 0.008108524605631828,
            "z": -95.99081420898438
        },
        {
            "x": -0.7676807641983032,
            "y": 0.010058972984552383,
            "z": -95.83367919921875
        },
        {
            "x": -0.7720670700073242,
            "y": 0.01213882677257061,
            "z": -95.6765365600586
        },
        {
            "x": -0.7762337923049927,
            "y": 0.014343219809234142,
            "z": -95.51941680908203
        },
        {
            "x": -0.7801873683929443,
            "y": 0.01666657254099846,
            "z": -95.36227416992188
        },
        {
            "x": -0.7839335799217224,
            "y": 0.019107282161712646,
            "z": -95.20502471923828
        },
        {
            "x": -0.7874621748924255,
            "y": 0.02166331186890602,
            "z": -95.04778289794922
        },
        {
            "x": -0.790775716304779,
            "y": 0.024328995496034622,
            "z": -94.890625
        },
        {
            "x": -0.7938863635063171,
            "y": 0.027101965621113777,
            "z": -94.73336791992188
        },
        {
            "x": -0.7967888116836548,
            "y": 0.029974982142448425,
            "z": -94.57621002197266
        },
        {
            "x": -0.7994863390922546,
            "y": 0.03294924646615982,
            "z": -94.4190673828125
        },
        {
            "x": -0.8019809722900391,
            "y": 0.036025017499923706,
            "z": -94.26171112060547
        },
        {
            "x": -0.8042716979980469,
            "y": 0.03918862342834473,
            "z": -94.10455322265625
        },
        {
            "x": -0.8063660264015198,
            "y": 0.04244216904044151,
            "z": -93.94734191894531
        },
        {
            "x": -0.808255672454834,
            "y": 0.04578268527984619,
            "z": -93.79013061523438
        },
        {
            "x": -0.809947669506073,
            "y": 0.04920576512813568,
            "z": -93.63297271728516
        },
        {
            "x": -0.8114492297172546,
            "y": 0.052711762487888336,
            "z": -93.47562408447266
        },
        {
            "x": -0.8127593398094177,
            "y": 0.05628834664821625,
            "z": -93.3184585571289
        },
        {
            "x": -0.8138753175735474,
            "y": 0.05993780493736267,
            "z": -93.16130828857422
        },
        {
            "x": -0.814793586730957,
            "y": 0.0636601448059082,
            "z": -93.00403594970703
        },
        {
            "x": -0.8155233860015869,
            "y": 0.06744469702243805,
            "z": -92.84687042236328
        },
        {
            "x": -0.816056489944458,
            "y": 0.07129287719726562,
            "z": -92.68962097167969
        },
        {
            "x": -0.8163617253303528,
            "y": 0.07520037889480591,
            "z": -92.53237915039062
        },
        {
            "x": -0.8163442611694336,
            "y": 0.0791618824005127,
            "z": -92.37522888183594
        },
        {
            "x": -0.8161211013793945,
            "y": 0.08183105289936066,
            "z": -92.27046966552734
        },
        {
            "x": -0.8154160976409912,
            "y": 0.08587674796581268,
            "z": -92.11334228515625
        },
        {
            "x": -0.814188539981842,
            "y": 0.08997013419866562,
            "z": -91.95623016357422
        },
        {
            "x": -0.8124361038208008,
            "y": 0.09411206841468811,
            "z": -91.79893493652344
        },
        {
            "x": -0.8101580142974854,
            "y": 0.09828867763280869,
            "z": -91.6418228149414
        },
        {
            "x": -0.8073522448539734,
            "y": 0.1025020107626915,
            "z": -91.48473358154297
        },
        {
            "x": -0.8040005564689636,
            "y": 0.10675286501646042,
            "z": -91.32754516601562
        },
        {
            "x": -0.8001108765602112,
            "y": 0.11103057861328125,
            "z": -91.17046356201172
        },
        {
            "x": -0.7956815361976624,
            "y": 0.11533717811107635,
            "z": -91.01331329345703
        },
        {
            "x": -0.7907006144523621,
            "y": 0.11966723203659058,
            "z": -90.85618591308594
        },
        {
            "x": -0.7851735353469849,
            "y": 0.12401485443115234,
            "z": -90.69916534423828
        },
        {
            "x": -0.7791028022766113,
            "y": 0.1283818483352661,
            "z": -90.54204559326172
        },
        {
            "x": -0.772496223449707,
            "y": 0.1327582597732544,
            "z": -90.38507843017578
        },
        {
            "x": -0.7653419971466064,
            "y": 0.13714465498924255,
            "z": -90.2281265258789
        },
        {
            "x": -0.7575997114181519,
            "y": 0.14154291152954102,
            "z": -90.07099914550781
        },
        {
            "x": -0.7493281960487366,
            "y": 0.14593791961669922,
            "z": -89.91410827636719
        },
        {
            "x": -0.7405065298080444,
            "y": 0.15033377707004547,
            "z": -89.7571792602539
        },
        {
            "x": -0.7311399579048157,
            "y": 0.15472573041915894,
            "z": -89.60028839111328
        },
        {
            "x": -0.7212140560150146,
            "y": 0.15910789370536804,
            "z": -89.44348907470703
        },
        {
            "x": -0.7107219099998474,
            "y": 0.16348469257354736,
            "z": -89.28651428222656
        },
        {
            "x": -0.6997012495994568,
            "y": 0.1678415834903717,
            "z": -89.12979125976562
        },
        {
            "x": -0.688133180141449,
            "y": 0.17218053340911865,
            "z": -88.97310638427734
        },
        {
            "x": -0.6759902834892273,
            "y": 0.1764974743127823,
            "z": -88.81644439697266
        },
        {
            "x": -0.6633114814758301,
            "y": 0.1807897984981537,
            "z": -88.65983581542969
        },
        {
            "x": -0.6500850319862366,
            "y": 0.18505632877349854,
            "z": -88.50316619873047
        },
        {
            "x": -0.6363166570663452,
            "y": 0.18929165601730347,
            "z": -88.34654235839844
        },
        {
            "x": -0.6220036149024963,
            "y": 0.19348767399787903,
            "z": -88.1900634765625
        },
        {
            "x": -0.6071442365646362,
            "y": 0.19764775037765503,
            "z": -88.03353118896484
        },
        {
            "x": -0.5917677879333496,
            "y": 0.201763316988945,
            "z": -87.87715148925781
        },
        {
            "x": -0.5758696794509888,
            "y": 0.2058335542678833,
            "z": -87.72081756591797
        },
        {
            "x": -0.5593993067741394,
            "y": 0.20985764265060425,
            "z": -87.56436157226562
        },
        {
            "x": -0.5424299240112305,
            "y": 0.2138243317604065,
            "z": -87.40814208984375
        },
        {
            "x": -0.5249443054199219,
            "y": 0.21773667633533478,
            "z": -87.25194549560547
        },
        {
            "x": -0.5069462656974792,
            "y": 0.22159011662006378,
            "z": -87.09577178955078
        },
        {
            "x": -0.4884331524372101,
            "y": 0.22537696361541748,
            "z": -86.9397201538086
        },
        {
            "x": -0.4693976938724518,
            "y": 0.22910186648368835,
            "z": -86.78353118896484
        },
        {
            "x": -0.44989797472953796,
            "y": 0.23275244235992432,
            "z": -86.62760925292969
        },
        {
            "x": -0.429909884929657,
            "y": 0.23633041977882385,
            "z": -86.47172546386719
        },
        {
            "x": -0.40941739082336426,
            "y": 0.23983120918273926,
            "z": -86.31581115722656
        },
        {
            "x": -0.3884710967540741,
            "y": 0.24324895441532135,
            "z": -86.16006469726562
        },
        {
            "x": -0.3670494258403778,
            "y": 0.24658559262752533,
            "z": -86.00426483154297
        },
        {
            "x": -0.3451721668243408,
            "y": 0.2498355209827423,
            "z": -85.84852600097656
        },
        {
            "x": -0.322855681180954,
            "y": 0.25298961997032166,
            "z": -85.69295501708984
        },
        {
            "x": -0.307734876871109,
            "y": 0.2550402283668518,
            "z": -85.58926391601562
        },
        {
            "x": -0.2847084403038025,
            "y": 0.25803685188293457,
            "z": -85.43378448486328
        },
        {
            "x": -0.2612466514110565,
            "y": 0.2609306871891022,
            "z": -85.27837371826172
        },
        {
            "x": -0.23734448850154877,
            "y": 0.2637237310409546,
            "z": -85.12281036376953
        },
        {
            "x": -0.21308483183383942,
            "y": 0.26640671491622925,
            "z": -84.96752166748047
        },
        {
            "x": -0.18844330310821533,
            "y": 0.26898008584976196,
            "z": -84.8122787475586
        },
        {
            "x": -0.1634051352739334,
            "y": 0.27143821120262146,
            "z": -84.65697479248047
        },
        {
            "x": -0.13802073895931244,
            "y": 0.2737758755683899,
            "z": -84.5018539428711
        },
        {
            "x": -0.11227943748235703,
            "y": 0.2759948968887329,
            "z": -84.34668731689453
        },
        {
            "x": -0.0862056165933609,
            "y": 0.27809029817581177,
            "z": -84.19155883789062
        },
        {
            "x": -0.05983005836606026,
            "y": 0.2800532579421997,
            "z": -84.03659057617188
        },
        {
            "x": -0.033130060881376266,
            "y": 0.28188472986221313,
            "z": -83.88156127929688
        },
        {
            "x": -0.006166145205497742,
            "y": 0.28358086943626404,
            "z": -83.72669982910156
        },
        {
            "x": 0.02106642723083496,
            "y": 0.285139799118042,
            "z": -83.57186889648438
        },
        {
            "x": 0.04859372228384018,
            "y": 0.28655558824539185,
            "z": -83.41688537597656
        },
        {
            "x": 0.07632610946893692,
            "y": 0.28782227635383606,
            "z": -83.26214599609375
        },
        {
            "x": 0.10429223626852036,
            "y": 0.28894177079200745,
            "z": -83.10738372802734
        },
        {
            "x": 0.13245752453804016,
            "y": 0.28991013765335083,
            "z": -82.95264434814453
        },
        {
            "x": 0.16080227494239807,
            "y": 0.29071927070617676,
            "z": -82.79801177978516
        },
        {
            "x": 0.18935488164424896,
            "y": 0.29136770963668823,
            "z": -82.64319610595703
        },
        {
            "x": 0.21802014112472534,
            "y": 0.2918538451194763,
            "z": -82.48861694335938
        },
        {
            "x": 0.24681532382965088,
            "y": 0.2921750843524933,
            "z": -82.33406829833984
        },
        {
            "x": 0.2757221460342407,
            "y": 0.2922106981277466,
            "z": -82.17953491210938
        },
        {
            "x": 0.30472514033317566,
            "y": 0.2917659878730774,
            "z": -82.02501678466797
        },
        {
            "x": 0.3338180184364319,
            "y": 0.29085057973861694,
            "z": -81.87040710449219
        },
        {
            "x": 0.3629637360572815,
            "y": 0.2894738018512726,
            "z": -81.71583557128906
        },
        {
            "x": 0.39212566614151,
            "y": 0.2876351773738861,
            "z": -81.56136322021484
        },
        {
            "x": 0.4213193953037262,
            "y": 0.28534096479415894,
            "z": -81.40677642822266
        },
        {
            "x": 0.4504874348640442,
            "y": 0.2826152443885803,
            "z": -81.25233459472656
        },
        {
            "x": 0.47962507605552673,
            "y": 0.27946504950523376,
            "z": -81.09786987304688
        },
        {
            "x": 0.508755624294281,
            "y": 0.2758863568305969,
            "z": -80.94319152832031
        },
        {
            "x": 0.5377770066261292,
            "y": 0.27189475297927856,
            "z": -80.78874969482422
        },
        {
            "x": 0.5667269229888916,
            "y": 0.2675043046474457,
            "z": -80.63420867919922
        },
        {
            "x": 0.5955654978752136,
            "y": 0.2627262473106384,
            "z": -80.47966766357422
        },
        {
            "x": 0.624260425567627,
            "y": 0.2575641870498657,
            "z": -80.3251724243164
        },
        {
            "x": 0.6528372764587402,
            "y": 0.2520133852958679,
            "z": -80.17046356201172
        },
        {
            "x": 0.6812059879302979,
            "y": 0.24610893428325653,
            "z": -80.01593017578125
        },
        {
            "x": 0.7093862295150757,
            "y": 0.2398529052734375,
            "z": -79.86137390136719
        },
        {
            "x": 0.7373753190040588,
            "y": 0.23324424028396606,
            "z": -79.70668029785156
        },
        {
            "x": 0.7651054859161377,
            "y": 0.2262951135635376,
            "z": -79.55207824707031
        },
        {
            "x": 0.7926041483879089,
            "y": 0.21901613473892212,
            "z": -79.3973388671875
        },
        {
            "x": 0.8198353052139282,
            "y": 0.2114211618900299,
            "z": -79.2425765991211
        },
        {
            "x": 0.8467571139335632,
            "y": 0.20352034270763397,
            "z": -79.08787536621094
        },
        {
            "x": 0.8645256757736206,
            "y": 0.19807715713977814,
            "z": -78.98473358154297
        },
        {
            "x": 0.8909217119216919,
            "y": 0.1896773874759674,
            "z": -78.8299560546875
        },
        {
            "x": 0.9169764518737793,
            "y": 0.18099233508110046,
            "z": -78.67515563964844
        },
        {
            "x": 0.9427016973495483,
            "y": 0.1720091700553894,
            "z": -78.52009582519531
        },
        {
            "x": 0.9680222868919373,
            "y": 0.16277125477790833,
            "z": -78.36518859863281
        },
        {
            "x": 0.992950975894928,
            "y": 0.1532769650220871,
            "z": -78.21024322509766
        },
        {
            "x": 1.0174897909164429,
            "y": 0.14352616667747498,
            "z": -78.05513000488281
        },
        {
            "x": 1.0415725708007812,
            "y": 0.13353145122528076,
            "z": -77.90007019042969
        },
        {
            "x": 1.0652307271957397,
            "y": 0.12329981476068497,
            "z": -77.74488067626953
        },
        {
            "x": 1.0884379148483276,
            "y": 0.11284606903791428,
            "z": -77.58961486816406
        },
        {
            "x": 1.111160159111023,
            "y": 0.10218563675880432,
            "z": -77.43441009521484
        },
        {
            "x": 1.133392333984375,
            "y": 0.09130333364009857,
            "z": -77.27903747558594
        },
        {
            "x": 1.1551109552383423,
            "y": 0.08023259788751602,
            "z": -77.12370300292969
        },
        {
            "x": 1.1763231754302979,
            "y": 0.06897437572479248,
            "z": -76.96831512451172
        },
        {
            "x": 1.1970431804656982,
            "y": 0.057523343712091446,
            "z": -76.81268310546875
        },
        {
            "x": 1.2171745300292969,
            "y": 0.045911118388175964,
            "z": -76.65718841552734
        },
        {
            "x": 1.2367593050003052,
            "y": 0.03413216769695282,
            "z": -76.50157165527344
        },
        {
            "x": 1.2557862997055054,
            "y": 0.022201232612133026,
            "z": -76.34590911865234
        },
        {
            "x": 1.2742455005645752,
            "y": 0.010131053626537323,
            "z": -76.19022369384766
        },
        {
            "x": 1.2921278476715088,
            "y": -0.0020939409732818604,
            "z": -76.0343017578125
        },
        {
            "x": 1.3093832731246948,
            "y": -0.014431134797632694,
            "z": -75.87850189208984
        },
        {
            "x": 1.3260445594787598,
            "y": -0.02688482776284218,
            "z": -75.72266387939453
        },
        {
            "x": 1.3421053886413574,
            "y": -0.03944690525531769,
            "z": -75.5667724609375
        },
        {
            "x": 1.3575375080108643,
            "y": -0.0521107017993927,
            "z": -75.41083526611328
        },
        {
            "x": 1.3723359107971191,
            "y": -0.06487569212913513,
            "z": -75.25472259521484
        },
        {
            "x": 1.3865125179290771,
            "y": -0.07772283256053925,
            "z": -75.09857177734375
        },
        {
            "x": 1.4000484943389893,
            "y": -0.09063474088907242,
            "z": -74.94245910644531
        },
        {
            "x": 1.412942886352539,
            "y": -0.10362046211957932,
            "z": -74.78620147705078
        },
        {
            "x": 1.4251571893692017,
            "y": -0.11665482074022293,
            "z": -74.62999725341797
        },
        {
            "x": 1.4367258548736572,
            "y": -0.1297348439693451,
            "z": -74.47374725341797
        },
        {
            "x": 1.4476571083068848,
            "y": -0.14287018775939941,
            "z": -74.3172607421875
        },
        {
            "x": 1.4579092264175415,
            "y": -0.15601778030395508,
            "z": -74.16091918945312
        },
        {
            "x": 1.4674726724624634,
            "y": -0.16919082403182983,
            "z": -74.00450134277344
        },
        {
            "x": 1.4763790369033813,
            "y": -0.18237513303756714,
            "z": -73.84803771972656
        },
        {
            "x": 1.4846150875091553,
            "y": -0.19555677473545074,
            "z": -73.69158172607422
        },
        {
            "x": 1.4921889305114746,
            "y": -0.20874929428100586,
            "z": -73.534912109375
        },
        {
            "x": 1.4990618228912354,
            "y": -0.22190895676612854,
            "z": -73.3783950805664
        },
        {
            "x": 1.505263090133667,
            "y": -0.23504354059696198,
            "z": -73.22185516357422
        },
        {
            "x": 1.5107942819595337,
            "y": -0.24815493822097778,
            "z": -73.06517028808594
        },
        {
            "x": 1.515655279159546,
            "y": -0.26121458411216736,
            "z": -72.90858459472656
        },
        {
            "x": 1.5198267698287964,
            "y": -0.27423006296157837,
            "z": -72.75186157226562
        },
        {
            "x": 1.5233150720596313,
            "y": -0.28718507289886475,
            "z": -72.59512329101562
        },
        {
            "x": 1.5261337757110596,
            "y": -0.3000626266002655,
            "z": -72.43846130371094
        },
        {
            "x": 1.5276317596435547,
            "y": -0.3086051940917969,
            "z": -72.3340072631836
        },
        {
            "x": 1.5293209552764893,
            "y": -0.32134607434272766,
            "z": -72.17733001708984
        },
        {
            "x": 1.530342698097229,
            "y": -0.3339943289756775,
            "z": -72.0206298828125
        },
        {
            "x": 1.530707836151123,
            "y": -0.3465575873851776,
            "z": -71.86370849609375
        },
        {
            "x": 1.530402660369873,
            "y": -0.35899096727371216,
            "z": -71.70700073242188
        },
        {
            "x": 1.5294116735458374,
            "y": -0.37130236625671387,
            "z": -71.5502700805664
        },
        {
            "x": 1.5277516841888428,
            "y": -0.3834940791130066,
            "z": -71.3934326171875
        },
        {
            "x": 1.5254119634628296,
            "y": -0.39553993940353394,
            "z": -71.23670196533203
        },
        {
            "x": 1.5223573446273804,
            "y": -0.40744519233703613,
            "z": -71.07986450195312
        },
        {
            "x": 1.518578052520752,
            "y": -0.4191902279853821,
            "z": -70.92304992675781
        },
        {
            "x": 1.5140845775604248,
            "y": -0.4307639002799988,
            "z": -70.7663345336914
        },
        {
            "x": 1.508849859237671,
            "y": -0.44217318296432495,
            "z": -70.60951232910156
        },
        {
            "x": 1.5028672218322754,
            "y": -0.45339077711105347,
            "z": -70.45281982421875
        },
        {
            "x": 1.4961044788360596,
            "y": -0.46441012620925903,
            "z": -70.296142578125
        },
        {
            "x": 1.4885519742965698,
            "y": -0.47524338960647583,
            "z": -70.1393051147461
        },
        {
            "x": 1.4802184104919434,
            "y": -0.48585426807403564,
            "z": -69.98268127441406
        },
        {
            "x": 1.4710819721221924,
            "y": -0.49625006318092346,
            "z": -69.82604217529297
        },
        {
            "x": 1.4610964059829712,
            "y": -0.5064102411270142,
            "z": -69.66942596435547
        },
        {
            "x": 1.4502774477005005,
            "y": -0.5163310766220093,
            "z": -69.5129165649414
        },
        {
            "x": 1.4385950565338135,
            "y": -0.5260194540023804,
            "z": -69.35626220703125
        },
        {
            "x": 1.4260646104812622,
            "y": -0.535442590713501,
            "z": -69.19984436035156
        },
        {
            "x": 1.4126243591308594,
            "y": -0.5445911288261414,
            "z": -69.04349517822266
        },
        {
            "x": 1.3982884883880615,
            "y": -0.5534682869911194,
            "z": -68.88720703125
        },
        {
            "x": 1.3830411434173584,
            "y": -0.5620649456977844,
            "z": -68.73099517822266
        },
        {
            "x": 1.366858959197998,
            "y": -0.5703779458999634,
            "z": -68.57476806640625
        },
        {
            "x": 1.3496936559677124,
            "y": -0.5783804059028625,
            "z": -68.41862487792969
        },
        {
            "x": 1.3315750360488892,
            "y": -0.5860685110092163,
            "z": -68.26268768310547
        },
        {
            "x": 1.3124693632125854,
            "y": -0.5934463143348694,
            "z": -68.10673522949219
        },
        {
            "x": 1.292386531829834,
            "y": -0.6004946231842041,
            "z": -67.95101165771484
        },
        {
            "x": 1.2712512016296387,
            "y": -0.6071966886520386,
            "z": -67.79539489746094
        },
        {
            "x": 1.2490496635437012,
            "y": -0.6135611534118652,
            "z": -67.63972473144531
        },
        {
            "x": 1.2258330583572388,
            "y": -0.6195664405822754,
            "z": -67.48440551757812
        },
        {
            "x": 1.2015546560287476,
            "y": -0.6252139806747437,
            "z": -67.32916259765625
        },
        {
            "x": 1.1761529445648193,
            "y": -0.630480170249939,
            "z": -67.17408752441406
        },
        {
            "x": 1.1496493816375732,
            "y": -0.6353617310523987,
            "z": -67.01925659179688
        },
        {
            "x": 1.1220000982284546,
            "y": -0.6398634314537048,
            "z": -66.86441802978516
        },
        {
            "x": 1.0932581424713135,
            "y": -0.6439652442932129,
            "z": -66.7099609375
        },
        {
            "x": 1.0633352994918823,
            "y": -0.6476510763168335,
            "z": -66.55573272705078
        },
        {
            "x": 1.0322074890136719,
            "y": -0.6509210467338562,
            "z": -66.40161895751953
        },
        {
            "x": 0.9999264478683472,
            "y": -0.6537783145904541,
            "z": -66.24783325195312
        },
        {
            "x": 0.966438353061676,
            "y": -0.6563236117362976,
            "z": -66.0942153930664
        },
        {
            "x": 0.9316965341567993,
            "y": -0.6585890054702759,
            "z": -65.94087219238281
        },
        {
            "x": 0.8957348465919495,
            "y": -0.6605706214904785,
            "z": -65.78791809082031
        },
        {
            "x": 0.8710962533950806,
            "y": -0.6617389917373657,
            "z": -65.68610382080078
        },
        {
            "x": 0.8330615758895874,
            "y": -0.6632422208786011,
            "z": -65.53365325927734
        },
        {
            "x": 0.7937449812889099,
            "y": -0.6644463539123535,
            "z": -65.38150787353516
        },
        {
            "x": 0.7531165480613708,
            "y": -0.6653530597686768,
            "z": -65.2295150756836
        },
        {
            "x": 0.711258053779602,
            "y": -0.6659542918205261,
            "z": -65.07807159423828
        },
        {
            "x": 0.6680809259414673,
            "y": -0.6662369966506958,
            "z": -64.92698669433594
        },
        {
            "x": 0.6235650777816772,
            "y": -0.6661972403526306,
            "z": -64.77619934082031
        },
        {
            "x": 0.5777881741523743,
            "y": -0.6658433079719543,
            "z": -64.62589263916016
        },
        {
            "x": 0.5306811928749084,
            "y": -0.665179967880249,
            "z": -64.47589111328125
        },
        {
            "x": 0.48224079608917236,
            "y": -0.6642057299613953,
            "z": -64.32633209228516
        },
        {
            "x": 0.4325167238712311,
            "y": -0.6629278659820557,
            "z": -64.17729949951172
        },
        {
            "x": 0.3814469277858734,
            "y": -0.6613572835922241,
            "z": -64.02859497070312
        },
        {
            "x": 0.3291342258453369,
            "y": -0.6595026254653931,
            "z": -63.88046646118164
        },
        {
            "x": 0.2755299210548401,
            "y": -0.6573621034622192,
            "z": -63.7327995300293
        },
        {
            "x": 0.2205381840467453,
            "y": -0.6549372673034668,
            "z": -63.58543014526367
        },
        {
            "x": 0.16438078880310059,
            "y": -0.6522477269172668,
            "z": -63.438716888427734
        },
        {
            "x": 0.10697036981582642,
            "y": -0.649295449256897,
            "z": -63.292442321777344
        },
        {
            "x": 0.04833052307367325,
            "y": -0.646081805229187,
            "z": -63.146663665771484
        },
        {
            "x": -0.011499244719743729,
            "y": -0.6426119804382324,
            "z": -63.00143051147461
        },
        {
            "x": -0.07255320996046066,
            "y": -0.6388932466506958,
            "z": -62.85649108886719
        },
        {
            "x": -0.13464123010635376,
            "y": -0.6349409818649292,
            "z": -62.71220779418945
        },
        {
            "x": -0.19780538976192474,
            "y": -0.6307521462440491,
            "z": -62.56840896606445
        },
        {
            "x": -0.26203653216362,
            "y": -0.6263294219970703,
            "z": -62.42508316040039
        },
        {
            "x": -0.32722175121307373,
            "y": -0.6216861009597778,
            "z": -62.28218460083008
        },
        {
            "x": -0.3933623135089874,
            "y": -0.6168245077133179,
            "z": -62.13961410522461
        },
        {
            "x": -0.46036040782928467,
            "y": -0.6117502450942993,
            "z": -61.99746322631836
        },
        {
            "x": -0.5281077027320862,
            "y": -0.6064683198928833,
            "z": -61.85576629638672
        },
        {
            "x": -0.5966007113456726,
            "y": -0.6009844541549683,
            "z": -61.71430969238281
        },
        {
            "x": -0.6656478643417358,
            "y": -0.5953112840652466,
            "z": -61.57323455810547
        },
        {
            "x": -0.7352160811424255,
            "y": -0.5894484519958496,
            "z": -61.432411193847656
        },
        {
            "x": -0.8053041696548462,
            "y": -0.5833893418312073,
            "z": -61.29161834716797
        },
        {
            "x": -0.8756030201911926,
            "y": -0.5771607756614685,
            "z": -61.15114212036133
        },
        {
            "x": -0.9461092948913574,
            "y": -0.5707586407661438,
            "z": -61.010704040527344
        },
        {
            "x": -1.0166748762130737,
            "y": -0.5641887187957764,
            "z": -60.87028121948242
        },
        {
            "x": -1.0871236324310303,
            "y": -0.557452917098999,
            "z": -60.729835510253906
        },
        {
            "x": -1.1574389934539795,
            "y": -0.550552487373352,
            "z": -60.589088439941406
        },
        {
            "x": -1.2272677421569824,
            "y": -0.5435104966163635,
            "z": -60.44831466674805
        },
        {
            "x": -1.2965447902679443,
            "y": -0.5363220572471619,
            "z": -60.307254791259766
        },
        {
            "x": -1.365107536315918,
            "y": -0.5289819240570068,
            "z": -60.16569137573242
        },
        {
            "x": -1.4327012300491333,
            "y": -0.5215121507644653,
            "z": -60.023765563964844
        },
        {
            "x": -1.4992212057113647,
            "y": -0.5139088034629822,
            "z": -59.881195068359375
        },
        {
            "x": -1.564419150352478,
            "y": -0.5061821937561035,
            "z": -59.73800277709961
        },
        {
            "x": -1.627966046333313,
            "y": -0.4983377754688263,
            "z": -59.594139099121094
        },
        {
            "x": -1.669377326965332,
            "y": -0.49304723739624023,
            "z": -59.497798919677734
        },
        {
            "x": -1.7299110889434814,
            "y": -0.48502519726753235,
            "z": -59.352603912353516
        },
        {
            "x": -1.7882156372070312,
            "y": -0.47690021991729736,
            "z": -59.20646286010742
        },
        {
            "x": -1.8444141149520874,
            "y": -0.4686774015426636,
            "z": -59.0593376159668
        },
        {
            "x": -1.8988873958587646,
            "y": -0.4603862464427948,
            "z": -58.911869049072266
        },
        {
            "x": -1.9520727396011353,
            "y": -0.4520174264907837,
            "z": -58.763954162597656
        },
        {
            "x": -2.0040156841278076,
            "y": -0.44356775283813477,
            "z": -58.6154899597168
        },
        {
            "x": -2.054722547531128,
            "y": -0.4350576400756836,
            "z": -58.46672058105469
        },
        {
            "x": -2.1043026447296143,
            "y": -0.42648208141326904,
            "z": -58.31747817993164
        },
        {
            "x": -2.152756452560425,
            "y": -0.41785261034965515,
            "z": -58.167869567871094
        },
        {
            "x": -2.2000527381896973,
            "y": -0.40917783975601196,
            "z": -58.018001556396484
        },
        {
            "x": -2.246303081512451,
            "y": -0.400453120470047,
            "z": -57.86769485473633
        },
        {
            "x": -2.291478157043457,
            "y": -0.3916985094547272,
            "z": -57.717193603515625
        },
        {
            "x": -2.3356404304504395,
            "y": -0.3829120397567749,
            "z": -57.56639099121094
        },
        {
            "x": -2.378838300704956,
            "y": -0.37408745288848877,
            "z": -57.41510009765625
        },
        {
            "x": -2.420997142791748,
            "y": -0.3652539849281311,
            "z": -57.26373291015625
        },
        {
            "x": -2.4622230529785156,
            "y": -0.35640275478363037,
            "z": -57.1120491027832
        },
        {
            "x": -2.5025131702423096,
            "y": -0.3475428819656372,
            "z": -56.96012496948242
        },
        {
            "x": -2.5418527126312256,
            "y": -0.33868229389190674,
            "z": -56.80801010131836
        },
        {
            "x": -2.5803306102752686,
            "y": -0.32981228828430176,
            "z": -56.65546417236328
        },
        {
            "x": -2.617877960205078,
            "y": -0.32096195220947266,
            "z": -56.502899169921875
        },
        {
            "x": -2.6545631885528564,
            "y": -0.3121095597743988,
            "z": -56.35013198852539
        },
        {
            "x": -2.690370798110962,
            "y": -0.3031286597251892,
            "z": -56.1971549987793
        },
        {
            "x": -2.7253212928771973,
            "y": -0.2940021753311157,
            "z": -56.043983459472656
        },
        {
            "x": -2.7594690322875977,
            "y": -0.2847365438938141,
            "z": -55.89055252075195
        },
        {
            "x": -2.792799711227417,
            "y": -0.27534493803977966,
            "z": -55.7369384765625
        },
        {
            "x": -2.825287103652954,
            "y": -0.265840619802475,
            "z": -55.583255767822266
        },
        {
            "x": -2.856984853744507,
            "y": -0.25621697306632996,
            "z": -55.42930603027344
        },
        {
            "x": -2.8878695964813232,
            "y": -0.24649962782859802,
            "z": -55.27531433105469
        },
        {
            "x": -2.9179790019989014,
            "y": -0.23668944835662842,
            "z": -55.12118148803711
        },
        {
            "x": -2.947357177734375,
            "y": -0.2267807126045227,
            "z": -54.96669387817383
        },
        {
            "x": -2.9759013652801514,
            "y": -0.21680577099323273,
            "z": -54.81226348876953
        },
        {
            "x": -3.003711700439453,
            "y": -0.20675906538963318,
            "z": -54.65765380859375
        },
        {
            "x": -3.0307788848876953,
            "y": -0.19665193557739258,
            "z": -54.502906799316406
        },
        {
            "x": -3.0570902824401855,
            "y": -0.18649637699127197,
            "z": -54.34809875488281
        },
        {
            "x": -3.0826799869537354,
            "y": -0.1762823611497879,
            "z": -54.192970275878906
        },
        {
            "x": -3.1075055599212646,
            "y": -0.16604596376419067,
            "z": -54.037925720214844
        },
        {
            "x": -3.131620168685913,
            "y": -0.15578213334083557,
            "z": -53.88276672363281
        },
        {
            "x": -3.15503191947937,
            "y": -0.14549165964126587,
            "z": -53.72739028930664
        },
        {
            "x": -3.1776843070983887,
            "y": -0.13519760966300964,
            "z": -53.572021484375
        },
        {
            "x": -3.199650526046753,
            "y": -0.12489378452301025,
            "z": -53.416446685791016
        },
        {
            "x": -3.2209150791168213,
            "y": -0.11459523439407349,
            "z": -53.26076889038086
        },
        {
            "x": -3.241471767425537,
            "y": -0.10431217402219772,
            "z": -53.105098724365234
        },
        {
            "x": -3.2547597885131836,
            "y": -0.09707573801279068,
            "z": -53.00127029418945
        },
        {
            "x": -3.2741382122039795,
            "y": -0.0852024108171463,
            "z": -52.845523834228516
        },
        {
            "x": -3.2928078174591064,
            "y": -0.07214143872261047,
            "z": -52.68979263305664
        },
        {
            "x": -3.3107900619506836,
            "y": -0.05793088302016258,
            "z": -52.53388214111328
        },
        {
            "x": -3.3280436992645264,
            "y": -0.04273116588592529,
            "z": -52.37818908691406
        },
        {
            "x": -3.3446176052093506,
            "y": -0.026630744338035583,
            "z": -52.22251510620117
        },
        {
            "x": -3.360513687133789,
            "y": -0.009708555415272713,
            "z": -52.066749572753906
        },
        {
            "x": -3.3757126331329346,
            "y": 0.007935671135783195,
            "z": -51.91110610961914
        },
        {
            "x": -3.3902204036712646,
            "y": 0.026226921007037163,
            "z": -51.755374908447266
        },
        {
            "x": -3.4040639400482178,
            "y": 0.04504690691828728,
            "z": -51.59965133666992
        },
        {
            "x": -3.4172203540802,
            "y": 0.06429433822631836,
            "z": -51.44401168823242
        },
        {
            "x": -3.429723024368286,
            "y": 0.08390668034553528,
            "z": -51.28826141357422
        },
        {
            "x": -3.4415194988250732,
            "y": 0.10376861691474915,
            "z": -51.13260269165039
        },
        {
            "x": -3.452657461166382,
            "y": 0.12379338592290878,
            "z": -50.97690963745117
        },
        {
            "x": -3.4631433486938477,
            "y": 0.14391469955444336,
            "z": -50.82099533081055
        },
        {
            "x": -3.4729573726654053,
            "y": 0.1639951765537262,
            "z": -50.66523361206055
        },
        {
            "x": -3.4820899963378906,
            "y": 0.1839679479598999,
            "z": -50.50936508178711
        },
        {
            "x": -3.4905552864074707,
            "y": 0.20373782515525818,
            "z": -50.35343551635742
        },
        {
            "x": -3.498363733291626,
            "y": 0.22320862114429474,
            "z": -50.19748306274414
        },
        {
            "x": -3.5055155754089355,
            "y": 0.24232205748558044,
            "z": -50.041255950927734
        },
        {
            "x": -3.5119900703430176,
            "y": 0.26092541217803955,
            "z": -49.88515090942383
        },
        {
            "x": -3.517782211303711,
            "y": 0.27894720435142517,
            "z": -49.728946685791016
        },
        {
            "x": -3.522913932800293,
            "y": 0.296308696269989,
            "z": -49.57263946533203
        },
        {
            "x": -3.527384042739868,
            "y": 0.3129172921180725,
            "z": -49.41624450683594
        },
        {
            "x": -3.531177520751953,
            "y": 0.3286826014518738,
            "z": -49.25963592529297
        },
        {
            "x": -3.534285545349121,
            "y": 0.34347042441368103,
            "z": -49.1029167175293
        },
        {
            "x": -3.536712646484375,
            "y": 0.3572115898132324,
            "z": -48.94619369506836
        },
        {
            "x": -3.538472890853882,
            "y": 0.36983126401901245,
            "z": -48.78926086425781
        },
        {
            "x": -3.539546489715576,
            "y": 0.3812163472175598,
            "z": -48.63233184814453
        },
        {
            "x": -3.539801836013794,
            "y": 0.39122122526168823,
            "z": -48.47526550292969
        },
        {
            "x": -3.53898024559021,
            "y": 0.3998214602470398,
            "z": -48.31784439086914
        },
        {
            "x": -3.536808729171753,
            "y": 0.4069000482559204,
            "z": -48.1605339050293
        },
        {
            "x": -3.5332260131835938,
            "y": 0.4125153422355652,
            "z": -48.00310134887695
        },
        {
            "x": -3.5280749797821045,
            "y": 0.4174041748046875,
            "z": -47.84567642211914
        },
        {
            "x": -3.5214052200317383,
            "y": 0.42106831073760986,
            "z": -47.68832778930664
        },
        {
            "x": -3.5131242275238037,
            "y": 0.42349153757095337,
            "z": -47.53080368041992
        },
        {
            "x": -3.5032312870025635,
            "y": 0.4247480034828186,
            "z": -47.373565673828125
        },
        {
            "x": -3.4915812015533447,
            "y": 0.42487847805023193,
            "z": -47.21641159057617
        },
        {
            "x": -3.478174924850464,
            "y": 0.4240100383758545,
            "z": -47.05928421020508
        },
        {
            "x": -3.4630143642425537,
            "y": 0.42223113775253296,
            "z": -46.90241241455078
        },
        {
            "x": -3.4460461139678955,
            "y": 0.41962140798568726,
            "z": -46.74563217163086
        },
        {
            "x": -3.4271559715270996,
            "y": 0.41623544692993164,
            "z": -46.58906936645508
        },
        {
            "x": -3.406403064727783,
            "y": 0.4121883511543274,
            "z": -46.432857513427734
        },
        {
            "x": -3.3915607929229736,
            "y": 0.40917515754699707,
            "z": -46.3288459777832
        },
        {
            "x": -3.3676328659057617,
            "y": 0.4042012095451355,
            "z": -46.1731071472168
        },
        {
            "x": -3.3418078422546387,
            "y": 0.3987866938114166,
            "z": -46.017677307128906
        },
        {
            "x": -3.3140838146209717,
            "y": 0.3930099606513977,
            "z": -45.86238098144531
        },
        {
            "x": -3.2845540046691895,
            "y": 0.3869662284851074,
            "z": -45.707637786865234
        },
        {
            "x": -3.2531614303588867,
            "y": 0.3807244300842285,
            "z": -45.55326843261719
        },
        {
            "x": -3.2199788093566895,
            "y": 0.37436917424201965,
            "z": -45.39918518066406
        },
        {
            "x": -3.1851489543914795,
            "y": 0.3679913878440857,
            "z": -45.245582580566406
        },
        {
            "x": -3.148707628250122,
            "y": 0.36166149377822876,
            "z": -45.0922737121582
        },
        {
            "x": -3.1107351779937744,
            "y": 0.3554697036743164,
            "z": -44.939353942871094
        },
        {
            "x": -3.07140851020813,
            "y": 0.3495006561279297,
            "z": -44.786903381347656
        },
        {
            "x": -3.0308241844177246,
            "y": 0.34382206201553345,
            "z": -44.634674072265625
        },
        {
            "x": -2.989182472229004,
            "y": 0.33852124214172363,
            "z": -44.482879638671875
        },
        {
            "x": -2.946575164794922,
            "y": 0.3336874842643738,
            "z": -44.33136749267578
        },
        {
            "x": -2.9031360149383545,
            "y": 0.3293946087360382,
            "z": -44.17990493774414
        },
        {
            "x": -2.8591551780700684,
            "y": 0.3257233202457428,
            "z": -44.02885055541992
        },
        {
            "x": -2.8147342205047607,
            "y": 0.32274574041366577,
            "z": -43.877891540527344
        },
        {
            "x": -2.7700421810150146,
            "y": 0.32056689262390137,
            "z": -43.727027893066406
        },
        {
            "x": -2.725287914276123,
            "y": 0.3192673623561859,
            "z": -43.57627868652344
        },
        {
            "x": -2.6805617809295654,
            "y": 0.318910151720047,
            "z": -43.42534637451172
        },
        {
            "x": -2.6361334323883057,
            "y": 0.31957706809043884,
            "z": -43.27458572387695
        },
        {
            "x": -2.5921125411987305,
            "y": 0.3213786482810974,
            "z": -43.12375259399414
        },
        {
            "x": -2.548647403717041,
            "y": 0.3243837058544159,
            "z": -42.97280502319336
        },
        {
            "x": -2.5058529376983643,
            "y": 0.3279975950717926,
            "z": -42.821746826171875
        },
        {
            "x": -2.463815689086914,
            "y": 0.3315313756465912,
            "z": -42.670413970947266
        },
        {
            "x": -2.422677516937256,
            "y": 0.3349606692790985,
            "z": -42.51884841918945
        },
        {
            "x": -2.382567882537842,
            "y": 0.33827951550483704,
            "z": -42.36713790893555
        },
        {
            "x": -2.343479633331299,
            "y": 0.3414918780326843,
            "z": -42.215065002441406
        },
        {
            "x": -2.305543899536133,
            "y": 0.3445901572704315,
            "z": -42.06283187866211
        },
        {
            "x": -2.2688045501708984,
            "y": 0.34757116436958313,
            "z": -41.910316467285156
        },
        {
            "x": -2.2332763671875,
            "y": 0.3504338264465332,
            "z": -41.757320404052734
        },
        {
            "x": -2.199054002761841,
            "y": 0.35317105054855347,
            "z": -41.60424041748047
        },
        {
            "x": -2.166100263595581,
            "y": 0.35578417778015137,
            "z": -41.45082473754883
        },
        {
            "x": -2.1344668865203857,
            "y": 0.3582664132118225,
            "z": -41.29713439941406
        },
        {
            "x": -2.1041862964630127,
            "y": 0.36061155796051025,
            "z": -41.14323806762695
        },
        {
            "x": -2.0751867294311523,
            "y": 0.36282405257225037,
            "z": -40.98888397216797
        },
        {
            "x": -2.0475354194641113,
            "y": 0.3648947775363922,
            "z": -40.83449172973633
        },
        {
            "x": -2.021192789077759,
            "y": 0.3668211102485657,
            "z": -40.67986297607422
        },
        {
            "x": -1.9961758852005005,
            "y": 0.36859768629074097,
            "z": -40.52489471435547
        },
        {
            "x": -1.9724358320236206,
            "y": 0.3702239692211151,
            "z": -40.36982727050781
        },
        {
            "x": -1.949945092201233,
            "y": 0.3716985583305359,
            "z": -40.214481353759766
        },
        {
            "x": -1.9286954402923584,
            "y": 0.37301480770111084,
            "z": -40.05893325805664
        },
        {
            "x": -1.90872061252594,
            "y": 0.374164879322052,
            "z": -39.90332794189453
        },
        {
            "x": -1.896045207977295,
            "y": 0.37484294176101685,
            "z": -39.799503326416016
        },
        {
            "x": -1.8780275583267212,
            "y": 0.3757200241088867,
            "z": -39.643638610839844
        },
        {
            "x": -1.8611787557601929,
            "y": 0.3764228820800781,
            "z": -39.48763656616211
        },
        {
            "x": -1.8454318046569824,
            "y": 0.37695425748825073,
            "z": -39.331302642822266
        },
        {
            "x": -1.8307468891143799,
            "y": 0.3773093819618225,
            "z": -39.175052642822266
        },
        {
            "x": -1.817009449005127,
            "y": 0.37748414278030396,
            "z": -39.01872253417969
        },
        {
            "x": -1.8044899702072144,
            "y": 0.37747007608413696,
            "z": -38.86222457885742
        },
        {
            "x": -1.793168306350708,
            "y": 0.377274751663208,
            "z": -38.70576858520508
        },
        {
            "x": -1.783170461654663,
            "y": 0.376901239156723,
            "z": -38.549163818359375
        },
        {
            "x": -1.7746635675430298,
            "y": 0.3763514757156372,
            "z": -38.39250946044922
        },
        {
            "x": -1.7678395509719849,
            "y": 0.375623881816864,
            "z": -38.23591613769531
        },
        {
            "x": -1.7627397775650024,
            "y": 0.37472808361053467,
            "z": -38.07918167114258
        },
        {
            "x": -1.7594658136367798,
            "y": 0.373668909072876,
            "z": -37.92253494262695
        },
        {
            "x": -1.7580903768539429,
            "y": 0.3724480867385864,
            "z": -37.76588439941406
        },
        {
            "x": -1.7587320804595947,
            "y": 0.3710613250732422,
            "z": -37.609046936035156
        },
        {
            "x": -1.7613343000411987,
            "y": 0.36952275037765503,
            "z": -37.45242691040039
        },
        {
            "x": -1.765892744064331,
            "y": 0.3678334653377533,
            "z": -37.29580307006836
        },
        {
            "x": -1.7724040746688843,
            "y": 0.3659968376159668,
            "z": -37.13923645019531
        },
        {
            "x": -1.7809020280838013,
            "y": 0.3640112280845642,
            "z": -36.98281478881836
        },
        {
            "x": -1.7912698984146118,
            "y": 0.36188292503356934,
            "z": -36.8262939453125
        },
        {
            "x": -1.803425669670105,
            "y": 0.35962140560150146,
            "z": -36.67009735107422
        },
        {
            "x": -1.8173190355300903,
            "y": 0.3572264611721039,
            "z": -36.51401901245117
        },
        {
            "x": -1.8329483270645142,
            "y": 0.35469597578048706,
            "z": -36.35808181762695
        },
        {
            "x": -1.850162148475647,
            "y": 0.3520396947860718,
            "z": -36.20229721069336
        },
        {
            "x": -1.868894100189209,
            "y": 0.3492587208747864,
            "z": -36.046566009521484
        },
        {
            "x": -1.889060616493225,
            "y": 0.34635815024375916,
            "z": -35.89099884033203
        },
        {
            "x": -1.9106382131576538,
            "y": 0.3433375358581543,
            "z": -35.73570251464844
        },
        {
            "x": -1.933509111404419,
            "y": 0.340202271938324,
            "z": -35.5804557800293
        },
        {
            "x": -1.9575749635696411,
            "y": 0.33695924282073975,
            "z": -35.42549133300781
        },
        {
            "x": -1.9827814102172852,
            "y": 0.333609938621521,
            "z": -35.27067565917969
        },
        {
            "x": -2.009150266647339,
            "y": 0.33014822006225586,
            "z": -35.1158447265625
        },
        {
            "x": -2.0364990234375,
            "y": 0.32659095525741577,
            "z": -34.96137237548828
        },
        {
            "x": -2.0648157596588135,
            "y": 0.322935551404953,
            "z": -34.80699920654297
        },
        {
            "x": -2.0940306186676025,
            "y": 0.31918662786483765,
            "z": -34.65278625488281
        },
        {
            "x": -2.1241254806518555,
            "y": 0.31534475088119507,
            "z": -34.498779296875
        },
        {
            "x": -2.155061960220337,
            "y": 0.3114103078842163,
            "z": -34.344730377197266
        },
        {
            "x": -2.1867120265960693,
            "y": 0.30739694833755493,
            "z": -34.191009521484375
        },
        {
            "x": -2.219081401824951,
            "y": 0.3033028841018677,
            "z": -34.03743362426758
        },
        {
            "x": -2.252174139022827,
            "y": 0.2991250157356262,
            "z": -33.88389205932617
        },
        {
            "x": -2.2858834266662598,
            "y": 0.2948750853538513,
            "z": -33.730587005615234
        },
        {
            "x": -2.3202133178710938,
            "y": 0.290551096200943,
            "z": -33.57729721069336
        },
        {
            "x": -2.3551135063171387,
            "y": 0.28615912795066833,
            "z": -33.42414474487305
        },
        {
            "x": -2.390552520751953,
            "y": 0.28170228004455566,
            "z": -33.271202087402344
        },
        {
            "x": -2.4144651889801025,
            "y": 0.27869629859924316,
            "z": -33.169307708740234
        },
        {
            "x": -2.4507148265838623,
            "y": 0.2741374969482422,
            "z": -33.016502380371094
        },
        {
            "x": -2.4871511459350586,
            "y": 0.269514262676239,
            "z": -32.86357498168945
        },
        {
            "x": -2.523346185684204,
            "y": 0.26482608914375305,
            "z": -32.71030807495117
        },
        {
            "x": -2.5590782165527344,
            "y": 0.26008960604667664,
            "z": -32.557098388671875
        },
        {
            "x": -2.594332456588745,
            "y": 0.2553028464317322,
            "z": -32.403770446777344
        },
        {
            "x": -2.6290535926818848,
            "y": 0.25046366453170776,
            "z": -32.250186920166016
        },
        {
            "x": -2.6631267070770264,
            "y": 0.2455829381942749,
            "z": -32.09653854370117
        },
        {
            "x": -2.6965396404266357,
            "y": 0.24065816402435303,
            "z": -31.94263458251953
        },
        {
            "x": -2.7291975021362305,
            "y": 0.23569518327713013,
            "z": -31.788524627685547
        },
        {
            "x": -2.7609751224517822,
            "y": 0.23069965839385986,
            "z": -31.63431167602539
        },
        {
            "x": -2.79184627532959,
            "y": 0.22566863894462585,
            "z": -31.47977066040039
        },
        {
            "x": -2.821702003479004,
            "y": 0.22061342000961304,
            "z": -31.325117111206055
        },
        {
            "x": -2.8504927158355713,
            "y": 0.21553388237953186,
            "z": -31.170238494873047
        },
        {
            "x": -2.8781447410583496,
            "y": 0.21042609214782715,
            "z": -31.014921188354492
        },
        {
            "x": -2.90451979637146,
            "y": 0.20530728995800018,
            "z": -30.859561920166016
        },
        {
            "x": -2.929621458053589,
            "y": 0.20017291605472565,
            "z": -30.703916549682617
        },
        {
            "x": -2.953380584716797,
            "y": 0.19502843916416168,
            "z": -30.548036575317383
        },
        {
            "x": -2.9756996631622314,
            "y": 0.1898794323205948,
            "z": -30.391986846923828
        },
        {
            "x": -2.996567964553833,
            "y": 0.18472132086753845,
            "z": -30.235511779785156
        },
        {
            "x": -3.0159318447113037,
            "y": 0.17957116663455963,
            "z": -30.079038619995117
        },
        {
            "x": -3.033792495727539,
            "y": 0.1744261234998703,
            "z": -29.922374725341797
        },
        {
            "x": -3.050100803375244,
            "y": 0.16929033398628235,
            "z": -29.765541076660156
        },
        {
            "x": -3.064844846725464,
            "y": 0.16416756808757782,
            "z": -29.608543395996094
        },
        {
            "x": -3.0780766010284424,
            "y": 0.1588917076587677,
            "z": -29.451337814331055
        },
        {
            "x": -3.089796304702759,
            "y": 0.15250402688980103,
            "z": -29.294078826904297
        },
        {
            "x": -3.0999953746795654,
            "y": 0.14480051398277283,
            "z": -29.136882781982422
        },
        {
            "x": -3.108704090118408,
            "y": 0.13585156202316284,
            "z": -28.979555130004883
        },
        {
            "x": -3.115992546081543,
            "y": 0.12580059468746185,
            "z": -28.822349548339844
        },
        {
            "x": -3.12191104888916,
            "y": 0.11473232507705688,
            "z": -28.665159225463867
        },
        {
            "x": -3.126493453979492,
            "y": 0.10271212458610535,
            "z": -28.507814407348633
        },
        {
            "x": -3.129753589630127,
            "y": 0.08984705805778503,
            "z": -28.35071563720703
        },
        {
            "x": -3.1317994594573975,
            "y": 0.076240673661232,
            "z": -28.19361686706543
        },
        {
            "x": -3.1326823234558105,
            "y": 0.06198914721608162,
            "z": -28.03658103942871
        },
        {
            "x": -3.1324539184570312,
            "y": 0.047187190502882004,
            "z": -27.87967300415039
        },
        {
            "x": -3.13112211227417,
            "y": 0.03188464790582657,
            "z": -27.72262191772461
        },
        {
            "x": -3.128798007965088,
            "y": 0.016236217692494392,
            "z": -27.56584930419922
        },
        {
            "x": -3.1255269050598145,
            "y": 0.0003123881760984659,
            "z": -27.40912628173828
        },
        {
            "x": -3.1213600635528564,
            "y": -0.01580863818526268,
            "z": -27.252351760864258
        },
        {
            "x": -3.116316080093384,
            "y": -0.03201401233673096,
            "z": -27.09573745727539
        },
        {
            "x": -3.1104674339294434,
            "y": -0.04822881147265434,
            "z": -26.939062118530273
        },
        {
            "x": -3.1038379669189453,
            "y": -0.06435512006282806,
            "z": -26.782384872436523
        },
        {
            "x": -3.096320390701294,
            "y": -0.0802944079041481,
            "z": -26.625795364379883
        },
        {
            "x": -3.090768814086914,
            "y": -0.09076571464538574,
            "z": -26.521408081054688
        },
        {
            "x": -3.081653356552124,
            "y": -0.10619252920150757,
            "z": -26.364805221557617
        },
        {
            "x": -3.0714564323425293,
            "y": -0.12119577080011368,
            "z": -26.208187103271484
        },
        {
            "x": -3.06007719039917,
            "y": -0.1356879323720932,
            "z": -26.051372528076172
        },
        {
            "x": -3.0474772453308105,
            "y": -0.1495310664176941,
            "z": -25.89478302001953
        },
        {
            "x": -3.0336339473724365,
            "y": -0.16266584396362305,
            "z": -25.73821258544922
        },
        {
            "x": -3.018488883972168,
            "y": -0.17500829696655273,
            "z": -25.581562042236328
        },
        {
            "x": -3.0020031929016113,
            "y": -0.18643581867218018,
            "z": -25.425058364868164
        },
        {
            "x": -2.9840774536132812,
            "y": -0.1968415379524231,
            "z": -25.268524169921875
        },
        {
            "x": -2.9647045135498047,
            "y": -0.20615625381469727,
            "z": -25.11207389831543
        },
        {
            "x": -2.9438531398773193,
            "y": -0.21428154408931732,
            "z": -24.9558162689209
        },
        {
            "x": -2.9214537143707275,
            "y": -0.22112205624580383,
            "z": -24.79956817626953
        },
        {
            "x": -2.897408962249756,
            "y": -0.22652333974838257,
            "z": -24.643617630004883
        },
        {
            "x": -2.871735095977783,
            "y": -0.23044970631599426,
            "z": -24.48784065246582
        },
        {
            "x": -2.8443715572357178,
            "y": -0.23331063985824585,
            "z": -24.33214569091797
        },
        {
            "x": -2.8153061866760254,
            "y": -0.23597289621829987,
            "z": -24.176939010620117
        },
        {
            "x": -2.7844178676605225,
            "y": -0.23773983120918274,
            "z": -24.02197265625
        },
        {
            "x": -2.7517292499542236,
            "y": -0.23800241947174072,
            "z": -23.867334365844727
        },
        {
            "x": -2.7172536849975586,
            "y": -0.23684826493263245,
            "z": -23.713150024414062
        },
        {
            "x": -2.680896043777466,
            "y": -0.2343570590019226,
            "z": -23.559179306030273
        },
        {
            "x": -2.6426541805267334,
            "y": -0.23057657480239868,
            "z": -23.405908584594727
        },
        {
            "x": -2.602781295776367,
            "y": -0.2256598174571991,
            "z": -23.25330924987793
        },
        {
            "x": -2.5621912479400635,
            "y": -0.2196965366601944,
            "z": -23.101245880126953
        },
        {
            "x": -2.5210537910461426,
            "y": -0.21276190876960754,
            "z": -22.949378967285156
        },
        {
            "x": -2.479304552078247,
            "y": -0.2048984169960022,
            "z": -22.7976131439209
        },
        {
            "x": -2.436981678009033,
            "y": -0.19624248147010803,
            "z": -22.646045684814453
        },
        {
            "x": -2.3941073417663574,
            "y": -0.18688689172267914,
            "z": -22.49478530883789
        },
        {
            "x": -2.3506388664245605,
            "y": -0.1769031584262848,
            "z": -22.343637466430664
        },
        {
            "x": -2.3066439628601074,
            "y": -0.1663745641708374,
            "z": -22.192808151245117
        },
        {
            "x": -2.2621679306030273,
            "y": -0.15540926158428192,
            "z": -22.042173385620117
        },
        {
            "x": -2.2172112464904785,
            "y": -0.14408035576343536,
            "z": -21.89153480529785
        },
        {
            "x": -2.171952724456787,
            "y": -0.13250088691711426,
            "z": -21.741252899169922
        },
        {
            "x": -2.126401662826538,
            "y": -0.12074311077594757,
            "z": -21.5910587310791
        },
        {
            "x": -2.0806820392608643,
            "y": -0.10890607535839081,
            "z": -21.44096565246582
        },
        {
            "x": -2.03490948677063,
            "y": -0.09717074036598206,
            "z": -21.290996551513672
        },
        {
            "x": -1.989123821258545,
            "y": -0.08569881319999695,
            "z": -21.140859603881836
        },
        {
            "x": -1.9435608386993408,
            "y": -0.07461157441139221,
            "z": -20.990896224975586
        },
        {
            "x": -1.8982795476913452,
            "y": -0.06398320198059082,
            "z": -20.840869903564453
        },
        {
            "x": -1.8533687591552734,
            "y": -0.05390777066349983,
            "z": -20.690645217895508
        },
        {
            "x": -1.8090291023254395,
            "y": -0.04452080652117729,
            "z": -20.540372848510742
        },
        {
            "x": -1.7652920484542847,
            "y": -0.0358792319893837,
            "z": -20.389833450317383
        },
        {
            "x": -1.7222912311553955,
            "y": -0.02808368392288685,
            "z": -20.23907470703125
        },
        {
            "x": -1.6801836490631104,
            "y": -0.021278463304042816,
            "z": -20.088178634643555
        },
        {
            "x": -1.6526200771331787,
            "y": -0.017317883670330048,
            "z": -19.98744010925293
        },
        {
            "x": -1.6120853424072266,
            "y": -0.012304977513849735,
            "z": -19.836105346679688
        },
        {
            "x": -1.5726380348205566,
            "y": -0.00855281576514244,
            "z": -19.684484481811523
        },
        {
            "x": -1.5342391729354858,
            "y": -0.006098359823226929,
            "z": -19.53238296508789
        },
        {
            "x": -1.4970178604125977,
            "y": -0.0050399997271597385,
            "z": -19.38019561767578
        },
        {
            "x": -1.4609922170639038,
            "y": -0.00500000175088644,
            "z": -19.227691650390625
        },
        {
            "x": -1.4261471033096313,
            "y": -0.004999999422580004,
            "z": -19.074800491333008
        },
        {
            "x": -1.392502784729004,
            "y": -0.005000002216547728,
            "z": -18.92173957824707
        },
        {
            "x": -1.360019564628601,
            "y": -0.004999994300305843,
            "z": -18.768342971801758
        },
        {
            "x": -1.3287534713745117,
            "y": -0.00500000175088644,
            "z": -18.61466407775879
        },
        {
            "x": -1.2986226081848145,
            "y": -0.005000000353902578,
            "z": -18.460851669311523
        },
        {
            "x": -1.2695770263671875,
            "y": -0.0049999975599348545,
            "z": -18.306697845458984
        },
        {
            "x": -1.2416207790374756,
            "y": -0.00500000175088644,
            "z": -18.152441024780273
        },
        {
            "x": -1.2147051095962524,
            "y": -0.005000004079192877,
            "z": -17.997974395751953
        },
        {
            "x": -1.1886950731277466,
            "y": -0.004999999888241291,
            "z": -17.843130111694336
        },
        {
            "x": -1.1636124849319458,
            "y": -0.005000000819563866,
            "z": -17.68830108642578
        },
        {
            "x": -1.139392375946045,
            "y": -0.00500000175088644,
            "z": -17.533260345458984
        },
        {
            "x": -1.1159336566925049,
            "y": -0.005000000819563866,
            "z": -17.378067016601562
        },
        {
            "x": -1.0931832790374756,
            "y": -0.00500000175088644,
            "z": -17.22279167175293
        },
        {
            "x": -1.0710405111312866,
            "y": -0.004999994765967131,
            "z": -17.067197799682617
        },
        {
            "x": -1.049498200416565,
            "y": -0.004999998956918716,
            "z": -16.91169548034668
        },
        {
            "x": -1.0284401178359985,
            "y": -0.004999999422580004,
            "z": -16.756084442138672
        },
        {
            "x": -1.0077910423278809,
            "y": -0.005000004079192877,
            "z": -16.60038185119629
        },
        {
            "x": -0.9874845147132874,
            "y": -0.004999998491257429,
            "z": -16.444602966308594
        },
        {
            "x": -0.9674420356750488,
            "y": -0.004999999888241291,
            "z": -16.28866195678711
        },
        {
            "x": -0.9475803375244141,
            "y": -0.005000000353902578,
            "z": -16.132661819458008
        },
        {
            "x": -0.9278414845466614,
            "y": -0.004999998025596142,
            "z": -15.976709365844727
        },
        {
            "x": -0.9080974459648132,
            "y": -0.005000005010515451,
            "z": -15.820602416992188
        },
        {
            "x": -0.8884264230728149,
            "y": -0.005000002216547728,
            "z": -15.664742469787598
        },
        {
            "x": -0.8694695830345154,
            "y": -0.005000004079192877,
            "z": -15.509064674377441
        },
        {
            "x": -0.851334273815155,
            "y": -0.005000002216547728,
            "z": -15.353034973144531
        },
        {
            "x": -0.8338940143585205,
            "y": -0.005000004079192877,
            "z": -15.19705867767334
        },
        {
            "x": -0.8170053362846375,
            "y": -0.004999997094273567,
            "z": -15.040898323059082
        },
        {
            "x": -0.800518274307251,
            "y": -0.004999998491257429,
            "z": -14.884637832641602
        },
        {
            "x": -0.7843103408813477,
            "y": -0.005000000819563866,
            "z": -14.728343963623047
        },
        {
            "x": -0.768234372138977,
            "y": -0.005000001285225153,
            "z": -14.571786880493164
        },
        {
            "x": -0.7522560358047485,
            "y": -0.005000002682209015,
            "z": -14.415398597717285
        },
        {
            "x": -0.7363249659538269,
            "y": -0.005000000353902578,
            "z": -14.258993148803711
        },
        {
            "x": -0.7204099297523499,
            "y": -0.0049999975599348545,
            "z": -14.102469444274902
        },
        {
            "x": -0.7045157551765442,
            "y": -0.005000000819563866,
            "z": -13.946045875549316
        },
        {
            "x": -0.6886072754859924,
            "y": -0.005000002216547728,
            "z": -13.78951644897461
        },
        {
            "x": -0.6726812720298767,
            "y": -0.004999999422580004,
            "z": -13.632983207702637
        },
        {
            "x": -0.6567376255989075,
            "y": -0.004999991971999407,
            "z": -13.476548194885254
        },
        {
            "x": -0.6460883617401123,
            "y": -0.004999998491257429,
            "z": -13.3722562789917
        },
        {
            "x": -0.6300755739212036,
            "y": -0.004999998956918716,
            "z": -13.215819358825684
        },
        {
            "x": -0.6140098571777344,
            "y": -0.004999999888241291,
            "z": -13.059386253356934
        },
        {
            "x": -0.5978670716285706,
            "y": -0.004999997094273567,
            "z": -12.902755737304688
        },
        {
            "x": -0.581683337688446,
            "y": -0.004999999422580004,
            "z": -12.746331214904785
        },
        {
            "x": -0.5654407143592834,
            "y": -0.004999999422580004,
            "z": -12.589911460876465
        },
        {
            "x": -0.5491270422935486,
            "y": -0.004999998025596142,
            "z": -12.433392524719238
        },
        {
            "x": -0.5327631831169128,
            "y": -0.004999994300305843,
            "z": -12.276986122131348
        },
        {
            "x": -0.5163259506225586,
            "y": -0.004999999888241291,
            "z": -12.120489120483398
        },
        {
            "x": -0.4998302459716797,
            "y": -0.004999999888241291,
            "z": -11.963996887207031
        },
        {
            "x": -0.48328956961631775,
            "y": -0.0049999975599348545,
            "z": -11.80759334564209
        },
        {
            "x": -0.46636906266212463,
            "y": -0.004999999888241291,
            "z": -11.650835990905762
        },
        {
            "x": -0.44865235686302185,
            "y": -0.00500000175088644,
            "z": -11.49422550201416
        },
        {
            "x": -0.43019771575927734,
            "y": -0.004999994300305843,
            "z": -11.337732315063477
        },
        {
            "x": -0.41104620695114136,
            "y": -0.00500000175088644,
            "z": -11.181153297424316
        },
        {
            "x": -0.39128628373146057,
            "y": -0.0050000036135315895,
            "z": -11.024883270263672
        },
        {
            "x": -0.3709890842437744,
            "y": -0.004999999422580004,
            "z": -10.86866569519043
        },
        {
            "x": -0.3502277135848999,
            "y": -0.005000001285225153,
            "z": -10.71253776550293
        },
        {
            "x": -0.32906994223594666,
            "y": -0.005000002216547728,
            "z": -10.55655288696289
        },
        {
            "x": -0.30754467844963074,
            "y": -0.004999999888241291,
            "z": -10.400447845458984
        },
        {
            "x": -0.2857867181301117,
            "y": -0.004999995697289705,
            "z": -10.244612693786621
        },
        {
            "x": -0.2639727294445038,
            "y": -0.004999998956918716,
            "z": -10.089034080505371
        },
        {
            "x": -0.24281291663646698,
            "y": -0.005000000819563866,
            "z": -9.93360710144043
        },
        {
            "x": -0.22241678833961487,
            "y": -0.004999998025596142,
            "z": -9.778088569641113
        },
        {
            "x": -0.2027606964111328,
            "y": -0.004999997094273567,
            "z": -9.62237548828125
        },
        {
            "x": -0.18386095762252808,
            "y": -0.004999998491257429,
            "z": -9.466568946838379
        },
        {
            "x": -0.16576959192752838,
            "y": -0.004999999422580004,
            "z": -9.310770988464355
        },
        {
            "x": -0.14842164516448975,
            "y": -0.005000000819563866,
            "z": -9.154775619506836
        },
        {
            "x": -0.1318386048078537,
            "y": -0.004999999888241291,
            "z": -8.99880599975586
        },
        {
            "x": -0.11601920425891876,
            "y": -0.00500000175088644,
            "z": -8.842756271362305
        },
        {
            "x": -0.10094636678695679,
            "y": -0.004999999888241291,
            "z": -8.686426162719727
        },
        {
            "x": -0.08662498742341995,
            "y": -0.00500000175088644,
            "z": -8.530223846435547
        },
        {
            "x": -0.07301902770996094,
            "y": -0.005000000819563866,
            "z": -8.373892784118652
        },
        {
            "x": -0.060149021446704865,
            "y": -0.004999998956918716,
            "z": -8.217491149902344
        },
        {
            "x": -0.047979746013879776,
            "y": -0.005000000819563866,
            "z": -8.06108283996582
        },
        {
            "x": -0.0364626944065094,
            "y": -0.005000006407499313,
            "z": -7.904413223266602
        },
        {
            "x": -0.02560802921652794,
            "y": -0.004999999888241291,
            "z": -7.747884273529053
        },
        {
            "x": -0.015386532992124557,
            "y": -0.00500000175088644,
            "z": -7.591280937194824
        },
        {
            "x": -0.00565685797482729,
            "y": -0.004999999888241291,
            "z": -7.434463977813721
        },
        {
            "x": 0.003724943846464157,
            "y": -0.004999998956918716,
            "z": -7.277651309967041
        },
        {
            "x": 0.012935674749314785,
            "y": -0.005000000819563866,
            "z": -7.120636940002441
        },
        {
            "x": 0.022152159363031387,
            "y": -0.00500000175088644,
            "z": -6.963527679443359
        },
        {
            "x": 0.03155102580785751,
            "y": -0.005000000819563866,
            "z": -6.806435585021973
        },
        {
            "x": 0.03801316022872925,
            "y": -0.004999999888241291,
            "z": -6.701664924621582
        },
        {
            "x": 0.04808769375085831,
            "y": -0.004999999888241291,
            "z": -6.544607639312744
        },
        {
            "x": 0.057845376431941986,
            "y": -0.004999999888241291,
            "z": -6.388228416442871
        },
        {
            "x": 0.0659782662987709,
            "y": -0.005000000819563866,
            "z": -6.231997966766357
        },
        {
            "x": 0.07211562991142273,
            "y": -0.005000002682209015,
            "z": -6.0758819580078125
        },
        {
            "x": 0.07641302049160004,
            "y": -0.005000000819563866,
            "z": -5.9196577072143555
        },
        {
            "x": 0.07907574623823166,
            "y": -0.005000002682209015,
            "z": -5.7629852294921875
        },
        {
            "x": 0.08112207055091858,
            "y": -0.004999999888241291,
            "z": -5.605897903442383
        },
        {
            "x": 0.0830087885260582,
            "y": -0.004999999888241291,
            "z": -5.448647975921631
        },
        {
            "x": 0.08476905524730682,
            "y": -0.004999999888241291,
            "z": -5.291392803192139
        },
        {
            "x": 0.08640784025192261,
            "y": -0.005000000819563866,
            "z": -5.134232521057129
        },
        {
            "x": 0.0877457857131958,
            "y": -0.004999999888241291,
            "z": -4.977345943450928
        },
        {
            "x": 0.08764466643333435,
            "y": -0.004999998956918716,
            "z": -4.820933818817139
        },
        {
            "x": 0.08611088991165161,
            "y": -0.005000002682209015,
            "z": -4.664425373077393
        },
        {
            "x": 0.08334668725728989,
            "y": -0.004999998025596142,
            "z": -4.507626533508301
        },
        {
            "x": 0.07955746352672577,
            "y": -0.004999998956918716,
            "z": -4.3509392738342285
        },
        {
            "x": 0.07491252571344376,
            "y": -0.004999999888241291,
            "z": -4.194108009338379
        },
        {
            "x": 0.06964859366416931,
            "y": -0.004999994300305843,
            "z": -4.0371880531311035
        },
        {
            "x": 0.06397102773189545,
            "y": -0.005000002682209015,
            "z": -3.8802294731140137
        },
        {
            "x": 0.05807337537407875,
            "y": -0.00500000175088644,
            "z": -3.7229628562927246
        },
        {
            "x": 0.052185941487550735,
            "y": -0.004999998956918716,
            "z": -3.5657992362976074
        },
        {
            "x": 0.04626283422112465,
            "y": -0.004999997094273567,
            "z": -3.4088339805603027
        },
        {
            "x": 0.03995616361498833,
            "y": -0.004999999888241291,
            "z": -3.251912832260132
        },
        {
            "x": 0.03337904065847397,
            "y": -0.004999997094273567,
            "z": -3.094926595687866
        },
        {
            "x": 0.02667449228465557,
            "y": -0.005000000819563866,
            "z": -2.9377553462982178
        },
        {
            "x": 0.020016608759760857,
            "y": -0.004999999888241291,
            "z": -2.780496120452881
        },
        {
            "x": 0.013566581532359123,
            "y": -0.005000002682209015,
            "z": -2.6232385635375977
        },
        {
            "x": 0.007476308383047581,
            "y": -0.005000000819563866,
            "z": -2.465768814086914
        },
        {
            "x": 0.0018867647740989923,
            "y": -0.00500000175088644,
            "z": -2.3083994388580322
        },
        {
            "x": -0.0033621080219745636,
            "y": -0.005000006407499313,
            "z": -2.1511282920837402
        },
        {
            "x": -0.008488863706588745,
            "y": -0.004999996162950993,
            "z": -1.9937665462493896
        },
        {
            "x": -0.013676835224032402,
            "y": -0.004999998956918716,
            "z": -1.8367152214050293
        },
        {
            "x": -0.019138246774673462,
            "y": -0.004999999888241291,
            "z": -1.67971932888031
        },
        {
            "x": -0.025043180212378502,
            "y": -0.00500000175088644,
            "z": -1.5228350162506104
        },
        {
            "x": -0.031538769602775574,
            "y": -0.004999998956918716,
            "z": -1.366111159324646
        },
        {
            "x": -0.038764674216508865,
            "y": -0.004999997094273567,
            "z": -1.2092853784561157
        },
        {
            "x": -0.04683835804462433,
            "y": -0.0050000036135315895,
            "z": -1.0527191162109375
        },
        {
            "x": -0.055482085794210434,
            "y": -0.004999999888241291,
            "z": -0.8958144783973694
        },
        {
            "x": -0.06404462456703186,
            "y": -0.004999994300305843,
            "z": -0.7385867238044739
        },
        {
            "x": -0.07228413969278336,
            "y": -0.0050000036135315895,
            "z": -0.5812992453575134
        },
        {
            "x": -0.07980165630578995,
            "y": -0.004999993368983269,
            "z": -0.4235776364803314
        },
        {
            "x": -0.0859210267663002,
            "y": -0.004999998025596142,
            "z": -0.2652702033519745
        },
        {
            "x": -0.08937754482030869,
            "y": -0.004999998025596142,
            "z": -0.1060025617480278
        },
        {
            "x": -0.08921219408512115,
            "y": -0.00500000175088644,
            "z": 0.0004955600015819073
        }
    ],
    "lane3":[
        {
            "x": 0.026861518621444702,
            "y": 0.012533821165561676,
            "z": -419.77862548828125
        },
        {
            "x": 0.02668321132659912,
            "y": 0.012527339160442352,
            "z": -419.62139892578125
        },
        {
            "x": 0.026504844427108765,
            "y": 0.012520834803581238,
            "z": -419.46417236328125
        },
        {
            "x": 0.026326477527618408,
            "y": 0.012514404952526093,
            "z": -419.3067626953125
        },
        {
            "x": 0.026148229837417603,
            "y": 0.012507885694503784,
            "z": -419.1495056152344
        },
        {
            "x": 0.02596995234489441,
            "y": 0.012501396238803864,
            "z": -418.99224853515625
        },
        {
            "x": 0.025791645050048828,
            "y": 0.01249491423368454,
            "z": -418.8349304199219
        },
        {
            "x": 0.025613367557525635,
            "y": 0.012488432228565216,
            "z": -418.6777038574219
        },
        {
            "x": 0.025435030460357666,
            "y": 0.012481942772865295,
            "z": -418.5203552246094
        },
        {
            "x": 0.025256693363189697,
            "y": 0.012475468218326569,
            "z": -418.363037109375
        },
        {
            "x": 0.02507847547531128,
            "y": 0.012468993663787842,
            "z": -418.205810546875
        },
        {
            "x": 0.024900108575820923,
            "y": 0.012462511658668518,
            "z": -418.0484619140625
        },
        {
            "x": 0.024721860885620117,
            "y": 0.012456007301807404,
            "z": -417.8912353515625
        },
        {
            "x": 0.024543583393096924,
            "y": 0.012449562549591064,
            "z": -417.7340087890625
        },
        {
            "x": 0.024365127086639404,
            "y": 0.012443050742149353,
            "z": -417.57659912109375
        },
        {
            "x": 0.0241868793964386,
            "y": 0.01243659108877182,
            "z": -417.4193420410156
        },
        {
            "x": 0.02400854229927063,
            "y": 0.012430079281330109,
            "z": -417.2620544433594
        },
        {
            "x": 0.023830264806747437,
            "y": 0.012423604726791382,
            "z": -417.1047668457031
        },
        {
            "x": 0.023651987314224243,
            "y": 0.012417137622833252,
            "z": -416.9475402832031
        },
        {
            "x": 0.023473501205444336,
            "y": 0.012410618364810944,
            "z": -416.7900695800781
        },
        {
            "x": 0.02329525351524353,
            "y": 0.012404143810272217,
            "z": -416.6328430175781
        },
        {
            "x": 0.0231170654296875,
            "y": 0.012397654354572296,
            "z": -416.4756164550781
        },
        {
            "x": 0.02293872833251953,
            "y": 0.01239117980003357,
            "z": -416.3183898925781
        },
        {
            "x": 0.02276057004928589,
            "y": 0.012384720146656036,
            "z": -416.1611328125
        },
        {
            "x": 0.022582173347473145,
            "y": 0.012378230690956116,
            "z": -416.0038146972656
        },
        {
            "x": 0.022403836250305176,
            "y": 0.012371726334095001,
            "z": -415.84649658203125
        },
        {
            "x": 0.022225558757781982,
            "y": 0.012365281581878662,
            "z": -415.6892395019531
        },
        {
            "x": 0.022047221660614014,
            "y": 0.012358754873275757,
            "z": -415.5319519042969
        },
        {
            "x": 0.021868973970413208,
            "y": 0.012352272868156433,
            "z": -415.3747253417969
        },
        {
            "x": 0.02169063687324524,
            "y": 0.012345843017101288,
            "z": -415.2174377441406
        },
        {
            "x": 0.02151229977607727,
            "y": 0.012339338660240173,
            "z": -415.0600280761719
        },
        {
            "x": 0.02133399248123169,
            "y": 0.012332834303379059,
            "z": -414.9028015136719
        },
        {
            "x": 0.021155625581741333,
            "y": 0.012326344847679138,
            "z": -414.7455139160156
        },
        {
            "x": 0.020977318286895752,
            "y": 0.01231992244720459,
            "z": -414.5882263183594
        },
        {
            "x": 0.020799070596694946,
            "y": 0.012313395738601685,
            "z": -414.4309997558594
        },
        {
            "x": 0.02062070369720459,
            "y": 0.01230689138174057,
            "z": -414.2735900878906
        },
        {
            "x": 0.020442485809326172,
            "y": 0.012300409376621246,
            "z": -414.1163024902344
        },
        {
            "x": 0.02026417851448059,
            "y": 0.012294001877307892,
            "z": -413.9590759277344
        },
        {
            "x": 0.02008587121963501,
            "y": 0.012287452816963196,
            "z": -413.8017883300781
        },
        {
            "x": 0.01990756392478943,
            "y": 0.012280970811843872,
            "z": -413.6445007324219
        },
        {
            "x": 0.019729197025299072,
            "y": 0.012274488806724548,
            "z": -413.4872131347656
        },
        {
            "x": 0.01955088973045349,
            "y": 0.012267984449863434,
            "z": -413.3298645019531
        },
        {
            "x": 0.019372612237930298,
            "y": 0.012261562049388885,
            "z": -413.1726379394531
        },
        {
            "x": 0.019253849983215332,
            "y": 0.012257203459739685,
            "z": -413.0678405761719
        },
        {
            "x": 0.01907557249069214,
            "y": 0.01225077360868454,
            "z": -412.9105529785156
        },
        {
            "x": 0.018897294998168945,
            "y": 0.012244239449501038,
            "z": -412.7533264160156
        },
        {
            "x": 0.018718868494033813,
            "y": 0.012237779796123505,
            "z": -412.5959167480469
        },
        {
            "x": 0.018540561199188232,
            "y": 0.012231267988681793,
            "z": -412.43865966796875
        },
        {
            "x": 0.018362224102020264,
            "y": 0.012224867939949036,
            "z": -412.2814636230469
        },
        {
            "x": 0.018184006214141846,
            "y": 0.01221831887960434,
            "z": -412.1241149902344
        },
        {
            "x": 0.018005728721618652,
            "y": 0.012211821973323822,
            "z": -411.9668884277344
        },
        {
            "x": 0.017827361822128296,
            "y": 0.012205339968204498,
            "z": -411.8095397949219
        },
        {
            "x": 0.017649054527282715,
            "y": 0.012198850512504578,
            "z": -411.6522521972656
        },
        {
            "x": 0.01747080683708191,
            "y": 0.012192390859127045,
            "z": -411.4949645996094
        },
        {
            "x": 0.017292439937591553,
            "y": 0.012185908854007721,
            "z": -411.337646484375
        },
        {
            "x": 0.01711413264274597,
            "y": 0.012179411947727203,
            "z": -411.1803894042969
        },
        {
            "x": 0.016935914754867554,
            "y": 0.012172937393188477,
            "z": -411.0231628417969
        },
        {
            "x": 0.016757428646087646,
            "y": 0.012166440486907959,
            "z": -410.86572265625
        },
        {
            "x": 0.016579151153564453,
            "y": 0.012159951031208038,
            "z": -410.7085266113281
        },
        {
            "x": 0.01640087366104126,
            "y": 0.012153483927249908,
            "z": -410.5512390136719
        },
        {
            "x": 0.01622253656387329,
            "y": 0.012146987020969391,
            "z": -410.3939514160156
        },
        {
            "x": 0.016044318675994873,
            "y": 0.012140519917011261,
            "z": -410.2367248535156
        },
        {
            "x": 0.015865862369537354,
            "y": 0.012134023010730743,
            "z": -410.0793151855469
        },
        {
            "x": 0.015687674283981323,
            "y": 0.012127570807933807,
            "z": -409.9220886230469
        },
        {
            "x": 0.015509337186813354,
            "y": 0.012121051549911499,
            "z": -409.7648010253906
        },
        {
            "x": 0.015331178903579712,
            "y": 0.01211460679769516,
            "z": -409.6075744628906
        },
        {
            "x": 0.01515287160873413,
            "y": 0.012108102440834045,
            "z": -409.4503479003906
        },
        {
            "x": 0.014974534511566162,
            "y": 0.012101620435714722,
            "z": -409.2930603027344
        },
        {
            "x": 0.014796197414398193,
            "y": 0.012095138430595398,
            "z": -409.13568115234375
        },
        {
            "x": 0.014617919921875,
            "y": 0.012088663876056671,
            "z": -408.9784851074219
        },
        {
            "x": 0.014439582824707031,
            "y": 0.012082159519195557,
            "z": -408.8211364746094
        },
        {
            "x": 0.014261335134506226,
            "y": 0.012075692415237427,
            "z": -408.6639099121094
        },
        {
            "x": 0.014083057641983032,
            "y": 0.012069202959537506,
            "z": -408.5066833496094
        },
        {
            "x": 0.013904541730880737,
            "y": 0.01206275075674057,
            "z": -408.3492431640625
        },
        {
            "x": 0.013726413249969482,
            "y": 0.012056224048137665,
            "z": -408.1919860839844
        },
        {
            "x": 0.013548105955123901,
            "y": 0.012049756944179535,
            "z": -408.0346984863281
        },
        {
            "x": 0.013369768857955933,
            "y": 0.012043260037899017,
            "z": -407.8774108886719
        },
        {
            "x": 0.013191550970077515,
            "y": 0.012036800384521484,
            "z": -407.7201843261719
        },
        {
            "x": 0.013013094663619995,
            "y": 0.012030310928821564,
            "z": -407.5627746582031
        },
        {
            "x": 0.012834817171096802,
            "y": 0.012023821473121643,
            "z": -407.4054870605469
        },
        {
            "x": 0.012656480073928833,
            "y": 0.01201733946800232,
            "z": -407.2483215332031
        },
        {
            "x": 0.012478172779083252,
            "y": 0.01201087236404419,
            "z": -407.0909729003906
        },
        {
            "x": 0.012299925088882446,
            "y": 0.012004353106021881,
            "z": -406.9337463378906
        },
        {
            "x": 0.012121707201004028,
            "y": 0.011997923254966736,
            "z": -406.7763977050781
        },
        {
            "x": 0.011943280696868896,
            "y": 0.011991403996944427,
            "z": -406.6190490722656
        },
        {
            "x": 0.011765003204345703,
            "y": 0.011984936892986298,
            "z": -406.4618225097656
        },
        {
            "x": 0.011646121740341187,
            "y": 0.011980608105659485,
            "z": -406.3570251464844
        },
        {
            "x": 0.011465877294540405,
            "y": 0.011974051594734192,
            "z": -406.1997985839844
        },
        {
            "x": 0.011287599802017212,
            "y": 0.011967577040195465,
            "z": -406.0425720214844
        },
        {
            "x": 0.011109113693237305,
            "y": 0.011961109936237335,
            "z": -405.8851623535156
        },
        {
            "x": 0.010930955410003662,
            "y": 0.011954613029956818,
            "z": -405.7278747558594
        },
        {
            "x": 0.010752737522125244,
            "y": 0.01194809377193451,
            "z": -405.5706481933594
        },
        {
            "x": 0.0105743408203125,
            "y": 0.011941604316234589,
            "z": -405.41326904296875
        },
        {
            "x": 0.010396093130111694,
            "y": 0.011935174465179443,
            "z": -405.25604248046875
        },
        {
            "x": 0.01021769642829895,
            "y": 0.011928640305995941,
            "z": -405.09869384765625
        },
        {
            "x": 0.010039359331130981,
            "y": 0.011922158300876617,
            "z": -404.94140625
        },
        {
            "x": 0.009861141443252563,
            "y": 0.011915720999240875,
            "z": -404.7841491699219
        },
        {
            "x": 0.00968274474143982,
            "y": 0.01190921664237976,
            "z": -404.6268310546875
        },
        {
            "x": 0.009504497051239014,
            "y": 0.011902734637260437,
            "z": -404.4696044921875
        },
        {
            "x": 0.00932621955871582,
            "y": 0.01189623773097992,
            "z": -404.3123779296875
        },
        {
            "x": 0.009147793054580688,
            "y": 0.01188977062702179,
            "z": -404.1549072265625
        },
        {
            "x": 0.00896957516670227,
            "y": 0.011883318424224854,
            "z": -403.9977111816406
        },
        {
            "x": 0.00879126787185669,
            "y": 0.011876784265041351,
            "z": -403.84039306640625
        },
        {
            "x": 0.008612900972366333,
            "y": 0.011870302259922028,
            "z": -403.68310546875
        },
        {
            "x": 0.008434683084487915,
            "y": 0.01186387985944748,
            "z": -403.52587890625
        },
        {
            "x": 0.008256196975708008,
            "y": 0.01185733824968338,
            "z": -403.36846923828125
        },
        {
            "x": 0.00807797908782959,
            "y": 0.011850856244564056,
            "z": -403.21124267578125
        },
        {
            "x": 0.007899641990661621,
            "y": 0.011844366788864136,
            "z": -403.05401611328125
        },
        {
            "x": 0.0077214837074279785,
            "y": 0.011837907135486603,
            "z": -402.896728515625
        },
        {
            "x": 0.0075432658195495605,
            "y": 0.011831440031528473,
            "z": -402.739501953125
        },
        {
            "x": 0.007364869117736816,
            "y": 0.011824943125247955,
            "z": -402.5821838378906
        },
        {
            "x": 0.007186532020568848,
            "y": 0.01181843876838684,
            "z": -402.42486572265625
        },
        {
            "x": 0.007008254528045654,
            "y": 0.011811979115009308,
            "z": -402.267578125
        },
        {
            "x": 0.006829947233200073,
            "y": 0.011805534362792969,
            "z": -402.11029052734375
        },
        {
            "x": 0.00665166974067688,
            "y": 0.01179899275302887,
            "z": -401.95306396484375
        },
        {
            "x": 0.006473332643508911,
            "y": 0.011792503297328949,
            "z": -401.79583740234375
        },
        {
            "x": 0.006294906139373779,
            "y": 0.011786065995693207,
            "z": -401.638427734375
        },
        {
            "x": 0.006116747856140137,
            "y": 0.01177956908941269,
            "z": -401.481201171875
        },
        {
            "x": 0.005938410758972168,
            "y": 0.01177304983139038,
            "z": -401.3238525390625
        },
        {
            "x": 0.005760073661804199,
            "y": 0.011766582727432251,
            "z": -401.16656494140625
        },
        {
            "x": 0.0055818259716033936,
            "y": 0.01176009327173233,
            "z": -401.00933837890625
        },
        {
            "x": 0.005403399467468262,
            "y": 0.011753596365451813,
            "z": -400.8519287109375
        },
        {
            "x": 0.005225092172622681,
            "y": 0.011747114360332489,
            "z": -400.6947021484375
        },
        {
            "x": 0.005046814680099487,
            "y": 0.011740639805793762,
            "z": -400.5374755859375
        },
        {
            "x": 0.004868596792221069,
            "y": 0.011734187602996826,
            "z": -400.380126953125
        },
        {
            "x": 0.004690229892730713,
            "y": 0.011727660894393921,
            "z": -400.222900390625
        },
        {
            "x": 0.004511892795562744,
            "y": 0.011721193790435791,
            "z": -400.0655517578125
        },
        {
            "x": 0.004333555698394775,
            "y": 0.011714689433574677,
            "z": -399.90826416015625
        },
        {
            "x": 0.004155278205871582,
            "y": 0.011708244681358337,
            "z": -399.7509765625
        },
        {
            "x": 0.004036515951156616,
            "y": 0.01170390099287033,
            "z": -399.64617919921875
        },
        {
            "x": 0.003858238458633423,
            "y": 0.011697433888912201,
            "z": -399.48895263671875
        },
        {
            "x": 0.0036799609661102295,
            "y": 0.011690959334373474,
            "z": -399.33172607421875
        },
        {
            "x": 0.0035016238689422607,
            "y": 0.01168445497751236,
            "z": -399.17431640625
        },
        {
            "x": 0.0033232569694519043,
            "y": 0.01167798787355423,
            "z": -399.01708984375
        },
        {
            "x": 0.0031450092792510986,
            "y": 0.011671483516693115,
            "z": -398.85986328125
        },
        {
            "x": 0.0029667317867279053,
            "y": 0.01166505366563797,
            "z": -398.7025146484375
        },
        {
            "x": 0.0027884244918823242,
            "y": 0.011658519506454468,
            "z": -398.54522705078125
        },
        {
            "x": 0.0026100575923919678,
            "y": 0.011652044951915741,
            "z": -398.387939453125
        },
        {
            "x": 0.002431720495223999,
            "y": 0.011645540595054626,
            "z": -398.23065185546875
        },
        {
            "x": 0.0022534728050231934,
            "y": 0.011639103293418884,
            "z": -398.0733642578125
        },
        {
            "x": 0.002075105905532837,
            "y": 0.01163259893655777,
            "z": -397.916015625
        },
        {
            "x": 0.0018968582153320312,
            "y": 0.011626102030277252,
            "z": -397.7587890625
        },
        {
            "x": 0.0017185807228088379,
            "y": 0.011619627475738525,
            "z": -397.6015625
        },
        {
            "x": 0.001540154218673706,
            "y": 0.011613152921199799,
            "z": -397.4441833496094
        },
        {
            "x": 0.0013618171215057373,
            "y": 0.011606656014919281,
            "z": -397.28692626953125
        },
        {
            "x": 0.0011835694313049316,
            "y": 0.011600218713283539,
            "z": -397.129638671875
        },
        {
            "x": 0.0010052621364593506,
            "y": 0.01159367710351944,
            "z": -396.9723815917969
        },
        {
            "x": 0.0008269846439361572,
            "y": 0.01158720999956131,
            "z": -396.81512451171875
        },
        {
            "x": 0.0006485879421234131,
            "y": 0.011580735445022583,
            "z": -396.6576843261719
        },
        {
            "x": 0.00047028064727783203,
            "y": 0.011574245989322662,
            "z": -396.5004577636719
        },
        {
            "x": 0.00029203295707702637,
            "y": 0.011567749083042145,
            "z": -396.3432312011719
        },
        {
            "x": 0.0001138150691986084,
            "y": 0.011561274528503418,
            "z": -396.1860046386719
        },
        {
            "x": -6.440281867980957e-05,
            "y": 0.011554807424545288,
            "z": -396.0287780761719
        },
        {
            "x": -0.0002427995204925537,
            "y": 0.01154831051826477,
            "z": -395.8714599609375
        },
        {
            "x": -0.00042113661766052246,
            "y": 0.011541813611984253,
            "z": -395.714111328125
        },
        {
            "x": -0.0005994439125061035,
            "y": 0.01153535395860672,
            "z": -395.55694580078125
        },
        {
            "x": -0.0007777810096740723,
            "y": 0.0115288645029068,
            "z": -395.39959716796875
        },
        {
            "x": -0.0009560585021972656,
            "y": 0.011522360146045685,
            "z": -395.24237060546875
        },
        {
            "x": -0.0011343955993652344,
            "y": 0.01151593029499054,
            "z": -395.0851745605469
        },
        {
            "x": -0.0013127624988555908,
            "y": 0.011509411036968231,
            "z": -394.9277038574219
        },
        {
            "x": -0.0014910399913787842,
            "y": 0.01150292158126831,
            "z": -394.7704772949219
        },
        {
            "x": -0.0016693472862243652,
            "y": 0.011496439576148987,
            "z": -394.6131896972656
        },
        {
            "x": -0.0018475651741027832,
            "y": 0.011490002274513245,
            "z": -394.4559020996094
        },
        {
            "x": -0.0020259320735931396,
            "y": 0.011483505368232727,
            "z": -394.2986755371094
        },
        {
            "x": -0.0022043585777282715,
            "y": 0.011477015912532806,
            "z": -394.1412658691406
        },
        {
            "x": -0.0023826658725738525,
            "y": 0.011470504105091095,
            "z": -393.9840393066406
        },
        {
            "x": -0.002560913562774658,
            "y": 0.011464022099971771,
            "z": -393.8268127441406
        },
        {
            "x": -0.002739250659942627,
            "y": 0.011457554996013641,
            "z": -393.6694641113281
        },
        {
            "x": -0.002917468547821045,
            "y": 0.011451087892055511,
            "z": -393.51220703125
        },
        {
            "x": -0.0030958056449890137,
            "y": 0.011444568634033203,
            "z": -393.3548583984375
        },
        {
            "x": -0.003274202346801758,
            "y": 0.011438094079494476,
            "z": -393.197509765625
        },
        {
            "x": -0.003452479839324951,
            "y": 0.011431604623794556,
            "z": -393.040283203125
        },
        {
            "x": -0.0035713613033294678,
            "y": 0.011427335441112518,
            "z": -392.93548583984375
        },
        {
            "x": -0.0037515461444854736,
            "y": 0.011420756578445435,
            "z": -392.77825927734375
        },
        {
            "x": -0.003929793834686279,
            "y": 0.011414244771003723,
            "z": -392.62103271484375
        },
        {
            "x": -0.004108160734176636,
            "y": 0.01140778511762619,
            "z": -392.46356201171875
        },
        {
            "x": -0.0042864978313446045,
            "y": 0.011401303112506866,
            "z": -392.306396484375
        },
        {
            "x": -0.00446474552154541,
            "y": 0.011394843459129333,
            "z": -392.14910888671875
        },
        {
            "x": -0.004643082618713379,
            "y": 0.011388331651687622,
            "z": -391.99176025390625
        },
        {
            "x": -0.004821360111236572,
            "y": 0.011381871998310089,
            "z": -391.83453369140625
        },
        {
            "x": -0.004999697208404541,
            "y": 0.011375337839126587,
            "z": -391.67718505859375
        },
        {
            "x": -0.0051780641078948975,
            "y": 0.011368878185749054,
            "z": -391.5198974609375
        },
        {
            "x": -0.005356341600418091,
            "y": 0.011362388730049133,
            "z": -391.3626708984375
        },
        {
            "x": -0.005534648895263672,
            "y": 0.011355936527252197,
            "z": -391.2052917480469
        },
        {
            "x": -0.005712926387786865,
            "y": 0.011349424719810486,
            "z": -391.0480651855469
        },
        {
            "x": -0.005891203880310059,
            "y": 0.011342950165271759,
            "z": -390.890869140625
        },
        {
            "x": -0.00606963038444519,
            "y": 0.011336445808410645,
            "z": -390.7333984375
        },
        {
            "x": -0.006247907876968384,
            "y": 0.0113300159573555,
            "z": -390.576171875
        },
        {
            "x": -0.0064261555671691895,
            "y": 0.011323489248752594,
            "z": -390.41888427734375
        },
        {
            "x": -0.006604492664337158,
            "y": 0.01131700724363327,
            "z": -390.2615966796875
        },
        {
            "x": -0.0067827701568603516,
            "y": 0.01131051778793335,
            "z": -390.1043701171875
        },
        {
            "x": -0.006961166858673096,
            "y": 0.011304043233394623,
            "z": -389.94696044921875
        },
        {
            "x": -0.007139474153518677,
            "y": 0.01129758358001709,
            "z": -389.78973388671875
        },
        {
            "x": -0.00731775164604187,
            "y": 0.011291079223155975,
            "z": -389.6324768066406
        },
        {
            "x": -0.0074959397315979,
            "y": 0.011284589767456055,
            "z": -389.4752197265625
        },
        {
            "x": -0.007674217224121094,
            "y": 0.011278107762336731,
            "z": -389.3179931640625
        },
        {
            "x": -0.007852643728256226,
            "y": 0.011271648108959198,
            "z": -389.16070556640625
        },
        {
            "x": -0.008030891418457031,
            "y": 0.011265166103839874,
            "z": -389.00335693359375
        },
        {
            "x": -0.008209228515625,
            "y": 0.01125866174697876,
            "z": -388.84613037109375
        },
        {
            "x": -0.008387476205825806,
            "y": 0.011252172291278839,
            "z": -388.68878173828125
        },
        {
            "x": -0.008565753698348999,
            "y": 0.011245697736740112,
            "z": -388.53155517578125
        },
        {
            "x": -0.008744031190872192,
            "y": 0.01123923808336258,
            "z": -388.37432861328125
        },
        {
            "x": -0.008922457695007324,
            "y": 0.011232726275920868,
            "z": -388.2169189453125
        },
        {
            "x": -0.00910070538520813,
            "y": 0.011226251721382141,
            "z": -388.05963134765625
        },
        {
            "x": -0.009279042482376099,
            "y": 0.011219769716262817,
            "z": -387.90234375
        },
        {
            "x": -0.009457319974899292,
            "y": 0.011213287711143494,
            "z": -387.74505615234375
        },
        {
            "x": -0.009635627269744873,
            "y": 0.011206798255443573,
            "z": -387.58782958984375
        },
        {
            "x": -0.00981399416923523,
            "y": 0.011200323700904846,
            "z": -387.430419921875
        },
        {
            "x": -0.009992361068725586,
            "y": 0.011193826794624329,
            "z": -387.273193359375
        },
        {
            "x": -0.010170578956604004,
            "y": 0.011187367141246796,
            "z": -387.115966796875
        },
        {
            "x": -0.010348856449127197,
            "y": 0.011180870234966278,
            "z": -386.9586181640625
        },
        {
            "x": -0.010527223348617554,
            "y": 0.01117437332868576,
            "z": -386.8013916015625
        },
        {
            "x": -0.01070547103881836,
            "y": 0.011167898774147034,
            "z": -386.64404296875
        },
        {
            "x": -0.010883837938308716,
            "y": 0.01116141676902771,
            "z": -386.48675537109375
        },
        {
            "x": -0.011062145233154297,
            "y": 0.011154919862747192,
            "z": -386.3294677734375
        },
        {
            "x": -0.011180907487869263,
            "y": 0.011150605976581573,
            "z": -386.22467041015625
        },
        {
            "x": -0.011359184980392456,
            "y": 0.011144138872623444,
            "z": -386.06744384765625
        },
        {
            "x": -0.01153746247291565,
            "y": 0.011137627065181732,
            "z": -385.91021728515625
        },
        {
            "x": -0.011715859174728394,
            "y": 0.011131145060062408,
            "z": -385.7528076171875
        },
        {
            "x": -0.011894136667251587,
            "y": 0.011124685406684875,
            "z": -385.5955505371094
        },
        {
            "x": -0.012072384357452393,
            "y": 0.011118195950984955,
            "z": -385.43829345703125
        },
        {
            "x": -0.012250751256942749,
            "y": 0.011111699044704437,
            "z": -385.281005859375
        },
        {
            "x": -0.012428998947143555,
            "y": 0.011105217039585114,
            "z": -385.12371826171875
        },
        {
            "x": -0.012607365846633911,
            "y": 0.011098742485046387,
            "z": -384.9664306640625
        },
        {
            "x": -0.012785643339157104,
            "y": 0.01109224557876587,
            "z": -384.80908203125
        },
        {
            "x": -0.012964010238647461,
            "y": 0.011085771024227142,
            "z": -384.65185546875
        },
        {
            "x": -0.013142257928848267,
            "y": 0.011079289019107819,
            "z": -384.4945068359375
        },
        {
            "x": -0.013320565223693848,
            "y": 0.011072851717472076,
            "z": -384.3372497558594
        },
        {
            "x": -0.013498872518539429,
            "y": 0.011066332459449768,
            "z": -384.1800537109375
        },
        {
            "x": -0.01367729902267456,
            "y": 0.01105983555316925,
            "z": -384.0225830078125
        },
        {
            "x": -0.013855576515197754,
            "y": 0.011053390800952911,
            "z": -383.8653564453125
        },
        {
            "x": -0.014033854007720947,
            "y": 0.011046893894672394,
            "z": -383.70806884765625
        },
        {
            "x": -0.014212161302566528,
            "y": 0.011040382087230682,
            "z": -383.55078125
        },
        {
            "x": -0.014390379190444946,
            "y": 0.011033900082111359,
            "z": -383.3935546875
        },
        {
            "x": -0.01456877589225769,
            "y": 0.011027440428733826,
            "z": -383.23614501953125
        },
        {
            "x": -0.014747053384780884,
            "y": 0.011020943522453308,
            "z": -383.07891845703125
        },
        {
            "x": -0.01492542028427124,
            "y": 0.01101444661617279,
            "z": -382.92169189453125
        },
        {
            "x": -0.01510360836982727,
            "y": 0.011007972061634064,
            "z": -382.76446533203125
        },
        {
            "x": -0.015281885862350464,
            "y": 0.01100149005651474,
            "z": -382.60723876953125
        },
        {
            "x": -0.015460163354873657,
            "y": 0.010995030403137207,
            "z": -382.44989013671875
        },
        {
            "x": -0.0156385600566864,
            "y": 0.010988518595695496,
            "z": -382.29254150390625
        },
        {
            "x": -0.01581677794456482,
            "y": 0.010982044041156769,
            "z": -382.13531494140625
        },
        {
            "x": -0.015995115041732788,
            "y": 0.010975584387779236,
            "z": -381.97796630859375
        },
        {
            "x": -0.016173362731933594,
            "y": 0.010969094932079315,
            "z": -381.82073974609375
        },
        {
            "x": -0.016351640224456787,
            "y": 0.010962612926959991,
            "z": -381.6634826660156
        },
        {
            "x": -0.016530096530914307,
            "y": 0.010956116020679474,
            "z": -381.5060729980469
        },
        {
            "x": -0.0167083740234375,
            "y": 0.010949671268463135,
            "z": -381.3488464355469
        },
        {
            "x": -0.01688668131828308,
            "y": 0.010943137109279633,
            "z": -381.1915588378906
        },
        {
            "x": -0.017064958810806274,
            "y": 0.0109366774559021,
            "z": -381.0342712402344
        },
        {
            "x": -0.017243146896362305,
            "y": 0.010930180549621582,
            "z": -380.8770446777344
        },
        {
            "x": -0.017421334981918335,
            "y": 0.01092374324798584,
            "z": -380.7195739746094
        },
        {
            "x": -0.017599672079086304,
            "y": 0.010917246341705322,
            "z": -380.5623474121094
        },
        {
            "x": -0.01777803897857666,
            "y": 0.010910719633102417,
            "z": -380.4051208496094
        },
        {
            "x": -0.01795560121536255,
            "y": 0.010904267430305481,
            "z": -380.2477722167969
        },
        {
            "x": -0.018131136894226074,
            "y": 0.010897830128669739,
            "z": -380.0905456542969
        },
        {
            "x": -0.018305540084838867,
            "y": 0.010891303420066833,
            "z": -379.9332580566406
        },
        {
            "x": -0.018482446670532227,
            "y": 0.010884784162044525,
            "z": -379.7759094238281
        },
        {
            "x": -0.0186556875705719,
            "y": 0.010878331959247589,
            "z": -379.6186828613281
        },
        {
            "x": -0.018764406442642212,
            "y": 0.010874032974243164,
            "z": -379.5138854980469
        },
        {
            "x": -0.018915027379989624,
            "y": 0.010867439210414886,
            "z": -379.3567199707031
        },
        {
            "x": -0.019053131341934204,
            "y": 0.010860979557037354,
            "z": -379.1994934082031
        },
        {
            "x": -0.019196540117263794,
            "y": 0.010854490101337433,
            "z": -379.04205322265625
        },
        {
            "x": -0.019310086965560913,
            "y": 0.010848022997379303,
            "z": -378.8849792480469
        },
        {
            "x": -0.01935085654258728,
            "y": 0.010841503739356995,
            "z": -378.7279968261719
        },
        {
            "x": -0.019304752349853516,
            "y": 0.010835081338882446,
            "z": -378.5708312988281
        },
        {
            "x": -0.0192277729511261,
            "y": 0.010828562080860138,
            "z": -378.4136657714844
        },
        {
            "x": -0.019100874662399292,
            "y": 0.010822117328643799,
            "z": -378.2566223144531
        },
        {
            "x": -0.01880517601966858,
            "y": 0.010815605521202087,
            "z": -378.09991455078125
        },
        {
            "x": -0.018253833055496216,
            "y": 0.01080913096666336,
            "z": -377.943359375
        },
        {
            "x": -0.017496615648269653,
            "y": 0.01080264151096344,
            "z": -377.78643798828125
        },
        {
            "x": -0.016610920429229736,
            "y": 0.010796107351779938,
            "z": -377.62969970703125
        },
        {
            "x": -0.01547175645828247,
            "y": 0.010789699852466583,
            "z": -377.4734802246094
        },
        {
            "x": -0.01390928030014038,
            "y": 0.010783202946186066,
            "z": -377.3171691894531
        },
        {
            "x": -0.011955738067626953,
            "y": 0.010776698589324951,
            "z": -377.1609191894531
        },
        {
            "x": -0.009728819131851196,
            "y": 0.01077020913362503,
            "z": -377.00433349609375
        },
        {
            "x": -0.007210880517959595,
            "y": 0.010763727128505707,
            "z": -376.8481140136719
        },
        {
            "x": -0.00420030951499939,
            "y": 0.01075727492570877,
            "z": -376.6924133300781
        },
        {
            "x": -0.0006628334522247314,
            "y": 0.01075076311826706,
            "z": -376.536376953125
        },
        {
            "x": 0.0032578110694885254,
            "y": 0.010744325816631317,
            "z": -376.3800048828125
        },
        {
            "x": 0.007455199956893921,
            "y": 0.010737836360931396,
            "z": -376.2237548828125
        },
        {
            "x": 0.012085199356079102,
            "y": 0.01073136180639267,
            "z": -376.0680236816406
        },
        {
            "x": 0.017278432846069336,
            "y": 0.010724842548370361,
            "z": -375.91241455078125
        },
        {
            "x": 0.022976696491241455,
            "y": 0.010718375444412231,
            "z": -375.7563781738281
        },
        {
            "x": 0.029000401496887207,
            "y": 0.010711871087551117,
            "z": -375.5998840332031
        },
        {
            "x": 0.03533536195755005,
            "y": 0.010705403983592987,
            "z": -375.4439392089844
        },
        {
            "x": 0.04216495156288147,
            "y": 0.01069890707731247,
            "z": -375.288330078125
        },
        {
            "x": 0.04955589771270752,
            "y": 0.010692447423934937,
            "z": -375.13275146484375
        },
        {
            "x": 0.05738678574562073,
            "y": 0.010685965418815613,
            "z": -374.9765625
        },
        {
            "x": 0.06550827622413635,
            "y": 0.01067950576543808,
            "z": -374.8201904296875
        },
        {
            "x": 0.07398077845573425,
            "y": 0.010672971606254578,
            "z": -374.66455078125
        },
        {
            "x": 0.08298540115356445,
            "y": 0.010666504502296448,
            "z": -374.5090026855469
        },
        {
            "x": 0.09252160787582397,
            "y": 0.01066000759601593,
            "z": -374.35321044921875
        },
        {
            "x": 0.10242560505867004,
            "y": 0.010653547942638397,
            "z": -374.19708251953125
        },
        {
            "x": 0.11260613799095154,
            "y": 0.01064707338809967,
            "z": -374.04095458984375
        },
        {
            "x": 0.12319311499595642,
            "y": 0.01064058393239975,
            "z": -373.885498046875
        },
        {
            "x": 0.1343211531639099,
            "y": 0.010634094476699829,
            "z": -373.7301025390625
        },
        {
            "x": 0.14594516158103943,
            "y": 0.010627642273902893,
            "z": -373.57415771484375
        },
        {
            "x": 0.15785104036331177,
            "y": 0.0106210857629776,
            "z": -373.4181213378906
        },
        {
            "x": 0.17005807161331177,
            "y": 0.010614655911922455,
            "z": -373.26239013671875
        },
        {
            "x": 0.18272855877876282,
            "y": 0.010608211159706116,
            "z": -373.10711669921875
        },
        {
            "x": 0.19594347476959229,
            "y": 0.010601677000522614,
            "z": -372.9516296386719
        },
        {
            "x": 0.20498770475387573,
            "y": 0.01059732586145401,
            "z": -372.8478088378906
        },
        {
            "x": 0.2187674343585968,
            "y": 0.01059083640575409,
            "z": -372.69183349609375
        },
        {
            "x": 0.2328403890132904,
            "y": 0.010584376752376556,
            "z": -372.536376953125
        },
        {
            "x": 0.24739190936088562,
            "y": 0.010577872395515442,
            "z": -372.3811340332031
        },
        {
            "x": 0.26245635747909546,
            "y": 0.010571420192718506,
            "z": -372.2257995605469
        },
        {
            "x": 0.2779034972190857,
            "y": 0.010564930737018585,
            "z": -372.07000732421875
        },
        {
            "x": 0.2935943901538849,
            "y": 0.010558456182479858,
            "z": -371.9143981933594
        },
        {
            "x": 0.3096359968185425,
            "y": 0.010551966726779938,
            "z": -371.7592468261719
        },
        {
            "x": 0.32617610692977905,
            "y": 0.010545454919338226,
            "z": -371.60418701171875
        },
        {
            "x": 0.3431990444660187,
            "y": 0.010538987815380096,
            "z": -371.44879150390625
        },
        {
            "x": 0.3605342209339142,
            "y": 0.010532490909099579,
            "z": -371.2931213378906
        },
        {
            "x": 0.3781163990497589,
            "y": 0.010526031255722046,
            "z": -371.13775634765625
        },
        {
            "x": 0.396075040102005,
            "y": 0.010519534349441528,
            "z": -370.98291015625
        },
        {
            "x": 0.41454121470451355,
            "y": 0.01051308959722519,
            "z": -370.8280334472656
        },
        {
            "x": 0.43346142768859863,
            "y": 0.010506592690944672,
            "z": -370.6725158691406
        },
        {
            "x": 0.45260801911354065,
            "y": 0.010500110685825348,
            "z": -370.51715087890625
        },
        {
            "x": 0.4720306098461151,
            "y": 0.01049361377954483,
            "z": -370.3621826171875
        },
        {
            "x": 0.49188458919525146,
            "y": 0.010487101972103119,
            "z": -370.20751953125
        },
        {
            "x": 0.5122380256652832,
            "y": 0.01048065721988678,
            "z": -370.0527038574219
        },
        {
            "x": 0.5329610109329224,
            "y": 0.010474145412445068,
            "z": -369.8973083496094
        },
        {
            "x": 0.5538723468780518,
            "y": 0.010467670857906342,
            "z": -369.74224853515625
        },
        {
            "x": 0.5751012563705444,
            "y": 0.010461218655109406,
            "z": -369.58770751953125
        },
        {
            "x": 0.5968029499053955,
            "y": 0.010454706847667694,
            "z": -369.4332580566406
        },
        {
            "x": 0.6189578771591187,
            "y": 0.010448247194290161,
            "z": -369.2784423828125
        },
        {
            "x": 0.641391396522522,
            "y": 0.010441765189170837,
            "z": -369.1233825683594
        },
        {
            "x": 0.6640492677688599,
            "y": 0.01043526828289032,
            "z": -368.9686279296875
        },
        {
            "x": 0.6870710849761963,
            "y": 0.010428786277770996,
            "z": -368.8143615722656
        },
        {
            "x": 0.7105863094329834,
            "y": 0.01042233407497406,
            "z": -368.6598815917969
        },
        {
            "x": 0.7344650030136108,
            "y": 0.01041584461927414,
            "z": -368.5051574707031
        },
        {
            "x": 0.7585525512695312,
            "y": 0.010409355163574219,
            "z": -368.35052490234375
        },
        {
            "x": 0.7829324007034302,
            "y": 0.010402865707874298,
            "z": -368.1960144042969
        },
        {
            "x": 0.8077001571655273,
            "y": 0.010396398603916168,
            "z": -368.0419921875
        },
        {
            "x": 0.8329248428344727,
            "y": 0.010389909148216248,
            "z": -367.88763427734375
        },
        {
            "x": 0.8584513664245605,
            "y": 0.010383404791355133,
            "z": -367.7330322265625
        },
        {
            "x": 0.8841634392738342,
            "y": 0.01037692278623581,
            "z": -367.5787353515625
        },
        {
            "x": 0.9102244973182678,
            "y": 0.010370448231697083,
            "z": -367.42462158203125
        },
        {
            "x": 0.9366800785064697,
            "y": 0.010363981127738953,
            "z": -367.2707824707031
        },
        {
            "x": 0.9635441303253174,
            "y": 0.010357491672039032,
            "z": -367.1165771484375
        },
        {
            "x": 0.9906662702560425,
            "y": 0.010350987315177917,
            "z": -366.962158203125
        },
        {
            "x": 1.0179667472839355,
            "y": 0.01034456491470337,
            "z": -366.8082580566406
        },
        {
            "x": 1.0456422567367554,
            "y": 0.010338053107261658,
            "z": -366.654541015625
        },
        {
            "x": 1.073747992515564,
            "y": 0.010331548750400543,
            "z": -366.500732421875
        },
        {
            "x": 1.102186918258667,
            "y": 0.010325103998184204,
            "z": -366.3466796875
        },
        {
            "x": 1.12125825881958,
            "y": 0.010320715606212616,
            "z": -366.2439880371094
        },
        {
            "x": 1.1500118970870972,
            "y": 0.010314233601093292,
            "z": -366.09033203125
        },
        {
            "x": 1.1791143417358398,
            "y": 0.010307751595973969,
            "z": -365.9369201660156
        },
        {
            "x": 1.208690881729126,
            "y": 0.01030120998620987,
            "z": -365.7832336425781
        },
        {
            "x": 1.2385483980178833,
            "y": 0.01029476523399353,
            "z": -365.62939453125
        },
        {
            "x": 1.2685853242874146,
            "y": 0.01028827577829361,
            "z": -365.47576904296875
        },
        {
            "x": 1.2988767623901367,
            "y": 0.010281816124916077,
            "z": -365.32232666015625
        },
        {
            "x": 1.3295283317565918,
            "y": 0.010275319218635559,
            "z": -365.1692199707031
        },
        {
            "x": 1.3606107234954834,
            "y": 0.010268881916999817,
            "z": -365.01568603515625
        },
        {
            "x": 1.3919239044189453,
            "y": 0.01026240736246109,
            "z": -364.862060546875
        },
        {
            "x": 1.4233856201171875,
            "y": 0.010255888104438782,
            "z": -364.708740234375
        },
        {
            "x": 1.455154299736023,
            "y": 0.010249406099319458,
            "z": -364.5556945800781
        },
        {
            "x": 1.487297773361206,
            "y": 0.010242901742458344,
            "z": -364.4028015136719
        },
        {
            "x": 1.5197861194610596,
            "y": 0.010236456990242004,
            "z": -364.24951171875
        },
        {
            "x": 1.5525031089782715,
            "y": 0.010229967534542084,
            "z": -364.0960998535156
        },
        {
            "x": 1.5853772163391113,
            "y": 0.01022346317768097,
            "z": -363.94317626953125
        },
        {
            "x": 1.6185743808746338,
            "y": 0.010216966271400452,
            "z": -363.79046630859375
        },
        {
            "x": 1.6521517038345337,
            "y": 0.010210514068603516,
            "z": -363.6376037597656
        },
        {
            "x": 1.6860072612762451,
            "y": 0.010203979909420013,
            "z": -363.48455810546875
        },
        {
            "x": 1.7200766801834106,
            "y": 0.01019749790430069,
            "z": -363.3314514160156
        },
        {
            "x": 1.7542996406555176,
            "y": 0.01019103080034256,
            "z": -363.1788635253906
        },
        {
            "x": 1.788856029510498,
            "y": 0.010184526443481445,
            "z": -363.0264892578125
        },
        {
            "x": 1.823785662651062,
            "y": 0.010178051888942719,
            "z": -362.8738708496094
        },
        {
            "x": 1.8589413166046143,
            "y": 0.010171554982662201,
            "z": -362.72100830078125
        },
        {
            "x": 1.8942662477493286,
            "y": 0.010165110230445862,
            "z": -362.5684509277344
        },
        {
            "x": 1.9298291206359863,
            "y": 0.010158635675907135,
            "z": -362.4161682128906
        },
        {
            "x": 1.9657206535339355,
            "y": 0.01015213131904602,
            "z": -362.263916015625
        },
        {
            "x": 2.001981735229492,
            "y": 0.010145679116249084,
            "z": -362.1113586425781
        },
        {
            "x": 2.0383641719818115,
            "y": 0.010139189660549164,
            "z": -361.9588928222656
        },
        {
            "x": 2.0749199390411377,
            "y": 0.01013268530368805,
            "z": -361.80670166015625
        },
        {
            "x": 2.1117935180664062,
            "y": 0.010126210749149323,
            "z": -361.6546325683594
        },
        {
            "x": 2.1489877700805664,
            "y": 0.010119698941707611,
            "z": -361.5025634765625
        },
        {
            "x": 2.1864571571350098,
            "y": 0.010113224387168884,
            "z": -361.3502502441406
        },
        {
            "x": 2.224057912826538,
            "y": 0.010106757283210754,
            "z": -361.19805908203125
        },
        {
            "x": 2.261812686920166,
            "y": 0.01010027527809143,
            "z": -361.04620361328125
        },
        {
            "x": 2.299933671951294,
            "y": 0.010093793272972107,
            "z": -360.8943786621094
        },
        {
            "x": 2.3383357524871826,
            "y": 0.01008729636669159,
            "z": -360.7424621582031
        },
        {
            "x": 2.3769443035125732,
            "y": 0.01008085161447525,
            "z": -360.5904235839844
        },
        {
            "x": 2.415675163269043,
            "y": 0.01007436215877533,
            "z": -360.4385986328125
        },
        {
            "x": 2.454620361328125,
            "y": 0.010067887604236603,
            "z": -360.2870788574219
        },
        {
            "x": 2.4939160346984863,
            "y": 0.010061413049697876,
            "z": -360.13555908203125
        },
        {
            "x": 2.533474922180176,
            "y": 0.010054908692836761,
            "z": -359.9837646484375
        },
        {
            "x": 2.573195695877075,
            "y": 0.010048411786556244,
            "z": -359.8320007324219
        },
        {
            "x": 2.599724769592285,
            "y": 0.010044105350971222,
            "z": -359.7310791015625
        },
        {
            "x": 2.6397128105163574,
            "y": 0.010037600994110107,
            "z": -359.5797424316406
        },
        {
            "x": 2.6799888610839844,
            "y": 0.010031148791313171,
            "z": -359.4285583496094
        },
        {
            "x": 2.720611333847046,
            "y": 0.01002463698387146,
            "z": -359.27685546875
        },
        {
            "x": 2.761308193206787,
            "y": 0.01001816987991333,
            "z": -359.12542724609375
        },
        {
            "x": 2.8021442890167236,
            "y": 0.010011687874794006,
            "z": -358.9742431640625
        },
        {
            "x": 2.8432416915893555,
            "y": 0.010005198419094086,
            "z": -358.8232116699219
        },
        {
            "x": 2.884629726409912,
            "y": 0.009998738765716553,
            "z": -358.67205810546875
        },
        {
            "x": 2.926266670227051,
            "y": 0.009992219507694244,
            "z": -358.5207824707031
        },
        {
            "x": 2.9680192470550537,
            "y": 0.00998573750257492,
            "z": -358.3694763183594
        },
        {
            "x": 3.009880781173706,
            "y": 0.009979255497455597,
            "z": -358.2186584472656
        },
        {
            "x": 3.052021026611328,
            "y": 0.009972788393497467,
            "z": -358.0678405761719
        },
        {
            "x": 3.0944254398345947,
            "y": 0.00996629148721695,
            "z": -357.9169006347656
        },
        {
            "x": 3.137000560760498,
            "y": 0.009959839284420013,
            "z": -357.76593017578125
        },
        {
            "x": 3.1797327995300293,
            "y": 0.009953320026397705,
            "z": -357.6148681640625
        },
        {
            "x": 3.222578287124634,
            "y": 0.009946897625923157,
            "z": -357.46435546875
        },
        {
            "x": 3.265719413757324,
            "y": 0.009940318763256073,
            "z": -357.313720703125
        },
        {
            "x": 3.309114456176758,
            "y": 0.00993388146162033,
            "z": -357.16290283203125
        },
        {
            "x": 3.3525960445404053,
            "y": 0.009927406907081604,
            "z": -357.01226806640625
        },
        {
            "x": 3.396270513534546,
            "y": 0.009920910000801086,
            "z": -356.8614807128906
        },
        {
            "x": 3.4400646686553955,
            "y": 0.009914427995681763,
            "z": -356.7112121582031
        },
        {
            "x": 3.484121561050415,
            "y": 0.009907960891723633,
            "z": -356.5608215332031
        },
        {
            "x": 3.5284042358398438,
            "y": 0.009901471436023712,
            "z": -356.41021728515625
        },
        {
            "x": 3.5727624893188477,
            "y": 0.009894981980323792,
            "z": -356.2598571777344
        },
        {
            "x": 3.617281436920166,
            "y": 0.009888485074043274,
            "z": -356.1095275878906
        },
        {
            "x": 3.6620209217071533,
            "y": 0.009882040321826935,
            "z": -355.9593505859375
        },
        {
            "x": 3.7069664001464844,
            "y": 0.009875521063804626,
            "z": -355.8091735839844
        },
        {
            "x": 3.7521286010742188,
            "y": 0.009869039058685303,
            "z": -355.65869140625
        },
        {
            "x": 3.79731822013855,
            "y": 0.009862527251243591,
            "z": -355.508544921875
        },
        {
            "x": 3.8426592350006104,
            "y": 0.009856045246124268,
            "z": -355.3586120605469
        },
        {
            "x": 3.888282537460327,
            "y": 0.009849578142166138,
            "z": -355.2085266113281
        },
        {
            "x": 3.934070110321045,
            "y": 0.009843103587627411,
            "z": -355.0584411621094
        },
        {
            "x": 3.9799928665161133,
            "y": 0.009836621582508087,
            "z": -354.9083557128906
        },
        {
            "x": 4.026005268096924,
            "y": 0.00983014702796936,
            "z": -354.7583923339844
        },
        {
            "x": 4.072161674499512,
            "y": 0.009823650121688843,
            "z": -354.608642578125
        },
        {
            "x": 4.1186017990112305,
            "y": 0.009817183017730713,
            "z": -354.4587097167969
        },
        {
            "x": 4.165162563323975,
            "y": 0.009810663759708405,
            "z": -354.308837890625
        },
        {
            "x": 4.211814880371094,
            "y": 0.009804219007492065,
            "z": -354.15899658203125
        },
        {
            "x": 4.258599281311035,
            "y": 0.009797751903533936,
            "z": -354.0092468261719
        },
        {
            "x": 4.305521011352539,
            "y": 0.009791232645511627,
            "z": -353.8597106933594
        },
        {
            "x": 4.352680683135986,
            "y": 0.009784765541553497,
            "z": -353.7101135253906
        },
        {
            "x": 4.400009632110596,
            "y": 0.00977829098701477,
            "z": -353.56024169921875
        },
        {
            "x": 4.44736385345459,
            "y": 0.009771808981895447,
            "z": -353.41070556640625
        },
        {
            "x": 4.4789814949035645,
            "y": 0.009767457842826843,
            "z": -353.31109619140625
        },
        {
            "x": 4.526567459106445,
            "y": 0.009760908782482147,
            "z": -353.1617126464844
        },
        {
            "x": 4.574331283569336,
            "y": 0.009754449129104614,
            "z": -353.0123596191406
        },
        {
            "x": 4.622335910797119,
            "y": 0.009747974574565887,
            "z": -352.8626403808594
        },
        {
            "x": 4.670331001281738,
            "y": 0.00974150002002716,
            "z": -352.7132263183594
        },
        {
            "x": 4.718425273895264,
            "y": 0.009734980762004852,
            "z": -352.56396484375
        },
        {
            "x": 4.766721248626709,
            "y": 0.009728558361530304,
            "z": -352.4146728515625
        },
        {
            "x": 4.81516170501709,
            "y": 0.009722039103507996,
            "z": -352.26544189453125
        },
        {
            "x": 4.863766193389893,
            "y": 0.009715557098388672,
            "z": -352.115966796875
        },
        {
            "x": 4.912404537200928,
            "y": 0.009709037840366364,
            "z": -351.9667053222656
        },
        {
            "x": 4.961121559143066,
            "y": 0.009702548384666443,
            "z": -351.8177185058594
        },
        {
            "x": 5.010077953338623,
            "y": 0.009696073830127716,
            "z": -351.6685485839844
        },
        {
            "x": 5.059128761291504,
            "y": 0.009689562022686005,
            "z": -351.5193786621094
        },
        {
            "x": 5.108260631561279,
            "y": 0.009683117270469666,
            "z": -351.3703308105469
        },
        {
            "x": 5.157535552978516,
            "y": 0.009676627814769745,
            "z": -351.22113037109375
        },
        {
            "x": 5.206851482391357,
            "y": 0.009670145809650421,
            "z": -351.072265625
        },
        {
            "x": 5.256358623504639,
            "y": 0.009663641452789307,
            "z": -350.92327880859375
        },
        {
            "x": 5.305996417999268,
            "y": 0.00965716689825058,
            "z": -350.7742919921875
        },
        {
            "x": 5.35569953918457,
            "y": 0.00965069979429245,
            "z": -350.62530517578125
        },
        {
            "x": 5.405507564544678,
            "y": 0.009644187986850739,
            "z": -350.47637939453125
        },
        {
            "x": 5.455382823944092,
            "y": 0.009637720882892609,
            "z": -350.3276062011719
        },
        {
            "x": 5.505402565002441,
            "y": 0.009644401259720325,
            "z": -350.1788330078125
        },
        {
            "x": 5.555530548095703,
            "y": 0.009853349067270756,
            "z": -350.0299377441406
        },
        {
            "x": 5.605704307556152,
            "y": 0.01037372462451458,
            "z": -349.8811950683594
        },
        {
            "x": 5.655974864959717,
            "y": 0.011213274672627449,
            "z": -349.7325744628906
        },
        {
            "x": 5.706399440765381,
            "y": 0.012355068698525429,
            "z": -349.5838317871094
        },
        {
            "x": 5.756916522979736,
            "y": 0.013794157654047012,
            "z": -349.4352111816406
        },
        {
            "x": 5.807527542114258,
            "y": 0.015528570860624313,
            "z": -349.2864685058594
        },
        {
            "x": 5.858170986175537,
            "y": 0.017563659697771072,
            "z": -349.1378479003906
        },
        {
            "x": 5.908878803253174,
            "y": 0.019881639629602432,
            "z": -348.98944091796875
        },
        {
            "x": 5.959775924682617,
            "y": 0.02248322032392025,
            "z": -348.8408203125
        },
        {
            "x": 6.010720729827881,
            "y": 0.02536030113697052,
            "z": -348.6922912597656
        },
        {
            "x": 6.0617523193359375,
            "y": 0.028523705899715424,
            "z": -348.543701171875
        },
        {
            "x": 6.112817764282227,
            "y": 0.03195220232009888,
            "z": -348.3952331542969
        },
        {
            "x": 6.163949489593506,
            "y": 0.035641152411699295,
            "z": -348.2469482421875
        },
        {
            "x": 6.215265274047852,
            "y": 0.039595749229192734,
            "z": -348.098388671875
        },
        {
            "x": 6.266599178314209,
            "y": 0.04381423071026802,
            "z": -347.9500427246094
        },
        {
            "x": 6.317981719970703,
            "y": 0.04828272759914398,
            "z": -347.8016662597656
        },
        {
            "x": 6.369423866271973,
            "y": 0.05299660935997963,
            "z": -347.6533203125
        },
        {
            "x": 6.420950412750244,
            "y": 0.057950690388679504,
            "z": -347.505126953125
        },
        {
            "x": 6.472587585449219,
            "y": 0.06315737217664719,
            "z": -347.35675048828125
        },
        {
            "x": 6.524289131164551,
            "y": 0.06859929859638214,
            "z": -347.20843505859375
        },
        {
            "x": 6.575997352600098,
            "y": 0.0742659866809845,
            "z": -347.0602111816406
        },
        {
            "x": 6.610482692718506,
            "y": 0.07816676795482635,
            "z": -346.9615173339844
        },
        {
            "x": 6.662312984466553,
            "y": 0.08421152085065842,
            "z": -346.8133850097656
        },
        {
            "x": 6.7142133712768555,
            "y": 0.09047368168830872,
            "z": -346.665283203125
        },
        {
            "x": 6.766224384307861,
            "y": 0.09695945680141449,
            "z": -346.5169372558594
        },
        {
            "x": 6.818199157714844,
            "y": 0.10365137457847595,
            "z": -346.3688659667969
        },
        {
            "x": 6.870236396789551,
            "y": 0.11054885387420654,
            "z": -346.2208557128906
        },
        {
            "x": 6.922353744506836,
            "y": 0.11764870584011078,
            "z": -346.07281494140625
        },
        {
            "x": 6.974534511566162,
            "y": 0.12494495511054993,
            "z": -345.9247741699219
        },
        {
            "x": 7.026787757873535,
            "y": 0.13244590163230896,
            "z": -345.7766418457031
        },
        {
            "x": 7.0790510177612305,
            "y": 0.1401330828666687,
            "z": -345.6286315917969
        },
        {
            "x": 7.1313276290893555,
            "y": 0.14799726009368896,
            "z": -345.4807434082031
        },
        {
            "x": 7.183715343475342,
            "y": 0.1560477763414383,
            "z": -345.33270263671875
        },
        {
            "x": 7.236100196838379,
            "y": 0.1642724871635437,
            "z": -345.184814453125
        },
        {
            "x": 7.288529872894287,
            "y": 0.17267245054244995,
            "z": -345.0369567871094
        },
        {
            "x": 7.341030597686768,
            "y": 0.1812453269958496,
            "z": -344.8888854980469
        },
        {
            "x": 7.393517971038818,
            "y": 0.18997085094451904,
            "z": -344.74102783203125
        },
        {
            "x": 7.446074962615967,
            "y": 0.19885867834091187,
            "z": -344.5932312011719
        },
        {
            "x": 7.498672008514404,
            "y": 0.20790880918502808,
            "z": -344.4453125
        },
        {
            "x": 7.5512566566467285,
            "y": 0.2171001136302948,
            "z": -344.29754638671875
        },
        {
            "x": 7.603938579559326,
            "y": 0.226447194814682,
            "z": -344.14959716796875
        },
        {
            "x": 7.656610488891602,
            "y": 0.23592793941497803,
            "z": -344.00189208984375
        },
        {
            "x": 7.709319114685059,
            "y": 0.24555161595344543,
            "z": -343.85406494140625
        },
        {
            "x": 7.762021541595459,
            "y": 0.2553032636642456,
            "z": -343.7063293457031
        },
        {
            "x": 7.814747333526611,
            "y": 0.2651810348033905,
            "z": -343.55865478515625
        },
        {
            "x": 7.867534160614014,
            "y": 0.2751936614513397,
            "z": -343.41082763671875
        },
        {
            "x": 7.920334339141846,
            "y": 0.28532493114471436,
            "z": -343.2630615234375
        },
        {
            "x": 7.973132133483887,
            "y": 0.29556673765182495,
            "z": -343.11541748046875
        },
        {
            "x": 8.02598762512207,
            "y": 0.30592820048332214,
            "z": -342.9676513671875
        },
        {
            "x": 8.078826904296875,
            "y": 0.31638896465301514,
            "z": -342.8199768066406
        },
        {
            "x": 8.131658554077148,
            "y": 0.32695472240448,
            "z": -342.67230224609375
        },
        {
            "x": 8.184603691101074,
            "y": 0.3376346826553345,
            "z": -342.52447509765625
        },
        {
            "x": 8.237472534179688,
            "y": 0.34839123487472534,
            "z": -342.3768310546875
        },
        {
            "x": 8.29037857055664,
            "y": 0.3592450022697449,
            "z": -342.2291259765625
        },
        {
            "x": 8.343274116516113,
            "y": 0.37018004059791565,
            "z": -342.08154296875
        },
        {
            "x": 8.396197319030762,
            "y": 0.38120022416114807,
            "z": -341.9338684082031
        },
        {
            "x": 8.449182510375977,
            "y": 0.3923119306564331,
            "z": -341.7860107421875
        },
        {
            "x": 8.502083778381348,
            "y": 0.4034796357154846,
            "z": -341.6383361816406
        },
        {
            "x": 8.554986000061035,
            "y": 0.4147174656391144,
            "z": -341.4906921386719
        },
        {
            "x": 8.607946395874023,
            "y": 0.42603129148483276,
            "z": -341.3429260253906
        },
        {
            "x": 8.660850524902344,
            "y": 0.4373920261859894,
            "z": -341.1953430175781
        },
        {
            "x": 8.713810920715332,
            "y": 0.4488219916820526,
            "z": -341.047607421875
        },
        {
            "x": 8.766752243041992,
            "y": 0.4603039622306824,
            "z": -340.89984130859375
        },
        {
            "x": 8.819642066955566,
            "y": 0.47182154655456543,
            "z": -340.7521667480469
        },
        {
            "x": 8.854912757873535,
            "y": 0.4795264005661011,
            "z": -340.6537780761719
        },
        {
            "x": 8.907798767089844,
            "y": 0.49111640453338623,
            "z": -340.506103515625
        },
        {
            "x": 8.960680961608887,
            "y": 0.5027453899383545,
            "z": -340.35833740234375
        },
        {
            "x": 9.013612747192383,
            "y": 0.5144176483154297,
            "z": -340.21051025390625
        },
        {
            "x": 9.06646728515625,
            "y": 0.5261035561561584,
            "z": -340.0628356933594
        },
        {
            "x": 9.119317054748535,
            "y": 0.5378141403198242,
            "z": -339.9151611328125
        },
        {
            "x": 9.172176361083984,
            "y": 0.5495524406433105,
            "z": -339.767333984375
        },
        {
            "x": 9.224969863891602,
            "y": 0.5612952709197998,
            "z": -339.61962890625
        },
        {
            "x": 9.277778625488281,
            "y": 0.5730550289154053,
            "z": -339.47186279296875
        },
        {
            "x": 9.330559730529785,
            "y": 0.5848178863525391,
            "z": -339.3241271972656
        },
        {
            "x": 9.383317947387695,
            "y": 0.5965820550918579,
            "z": -339.1763610839844
        },
        {
            "x": 9.436065673828125,
            "y": 0.6083506941795349,
            "z": -339.02850341796875
        },
        {
            "x": 9.488737106323242,
            "y": 0.620104193687439,
            "z": -338.8807373046875
        },
        {
            "x": 9.541383743286133,
            "y": 0.6318447589874268,
            "z": -338.7330017089844
        },
        {
            "x": 9.594108581542969,
            "y": 0.6435885429382324,
            "z": -338.58502197265625
        },
        {
            "x": 9.646728515625,
            "y": 0.6552995443344116,
            "z": -338.43719482421875
        },
        {
            "x": 9.699302673339844,
            "y": 0.666988730430603,
            "z": -338.2892761230469
        },
        {
            "x": 9.751838684082031,
            "y": 0.6786494255065918,
            "z": -338.14141845703125
        },
        {
            "x": 9.804340362548828,
            "y": 0.6902725696563721,
            "z": -337.99359130859375
        },
        {
            "x": 9.856887817382812,
            "y": 0.7018766403198242,
            "z": -337.8454895019531
        },
        {
            "x": 9.90932846069336,
            "y": 0.7134286165237427,
            "z": -337.69757080078125
        },
        {
            "x": 9.961700439453125,
            "y": 0.7249321937561035,
            "z": -337.54962158203125
        },
        {
            "x": 10.0140380859375,
            "y": 0.7363846898078918,
            "z": -337.40167236328125
        },
        {
            "x": 10.066354751586914,
            "y": 0.7477832436561584,
            "z": -337.25372314453125
        },
        {
            "x": 10.118669509887695,
            "y": 0.7591357231140137,
            "z": -337.1056213378906
        },
        {
            "x": 10.170917510986328,
            "y": 0.7704284191131592,
            "z": -336.9574890136719
        },
        {
            "x": 10.223078727722168,
            "y": 0.781645655632019,
            "z": -336.8093566894531
        },
        {
            "x": 10.275181770324707,
            "y": 0.7927898168563843,
            "z": -336.6612854003906
        },
        {
            "x": 10.327259063720703,
            "y": 0.8038617372512817,
            "z": -336.5131530761719
        },
        {
            "x": 10.37926959991455,
            "y": 0.8148561716079712,
            "z": -336.3650207519531
        },
        {
            "x": 10.431276321411133,
            "y": 0.8257774114608765,
            "z": -336.2166442871094
        },
        {
            "x": 10.483146667480469,
            "y": 0.8365942239761353,
            "z": -336.0684509277344
        },
        {
            "x": 10.53499984741211,
            "y": 0.8473228216171265,
            "z": -335.9201965332031
        },
        {
            "x": 10.586827278137207,
            "y": 0.8579634428024292,
            "z": -335.7718505859375
        },
        {
            "x": 10.638541221618652,
            "y": 0.8684954643249512,
            "z": -335.6235046386719
        },
        {
            "x": 10.690229415893555,
            "y": 0.8789318799972534,
            "z": -335.4750061035156
        },
        {
            "x": 10.741812705993652,
            "y": 0.8892465829849243,
            "z": -335.32666015625
        },
        {
            "x": 10.79334545135498,
            "y": 0.8994495868682861,
            "z": -335.17828369140625
        },
        {
            "x": 10.844868659973145,
            "y": 0.9095457196235657,
            "z": -335.0296630859375
        },
        {
            "x": 10.896255493164062,
            "y": 0.9195122122764587,
            "z": -334.881103515625
        },
        {
            "x": 10.947555541992188,
            "y": 0.9293518662452698,
            "z": -334.7325439453125
        },
        {
            "x": 10.998788833618164,
            "y": 0.9390585422515869,
            "z": -334.58404541015625
        },
        {
            "x": 11.049983978271484,
            "y": 0.9486322402954102,
            "z": -334.4354248046875
        },
        {
            "x": 11.084074974060059,
            "y": 0.9549366235733032,
            "z": -334.3362121582031
        },
        {
            "x": 11.135099411010742,
            "y": 0.964277982711792,
            "z": -334.1875305175781
        },
        {
            "x": 11.186019897460938,
            "y": 0.9734691977500916,
            "z": -334.0387878417969
        },
        {
            "x": 11.23689079284668,
            "y": 0.9825068712234497,
            "z": -333.8900146484375
        },
        {
            "x": 11.2877197265625,
            "y": 0.9913904666900635,
            "z": -333.7411804199219
        },
        {
            "x": 11.338443756103516,
            "y": 1.0001187324523926,
            "z": -333.5923156738281
        },
        {
            "x": 11.389077186584473,
            "y": 1.008687973022461,
            "z": -333.4432373046875
        },
        {
            "x": 11.439555168151855,
            "y": 1.0170722007751465,
            "z": -333.29437255859375
        },
        {
            "x": 11.490025520324707,
            "y": 1.025292158126831,
            "z": -333.14532470703125
        },
        {
            "x": 11.540412902832031,
            "y": 1.0333402156829834,
            "z": -332.9962158203125
        },
        {
            "x": 11.590682983398438,
            "y": 1.0412101745605469,
            "z": -332.8470458984375
        },
        {
            "x": 11.640801429748535,
            "y": 1.048882246017456,
            "z": -332.6978454589844
        },
        {
            "x": 11.690814018249512,
            "y": 1.0563606023788452,
            "z": -332.54876708984375
        },
        {
            "x": 11.740772247314453,
            "y": 1.06364905834198,
            "z": -332.39959716796875
        },
        {
            "x": 11.790727615356445,
            "y": 1.0707547664642334,
            "z": -332.2500305175781
        },
        {
            "x": 11.840460777282715,
            "y": 1.0776408910751343,
            "z": -332.1006774902344
        },
        {
            "x": 11.890059471130371,
            "y": 1.084317684173584,
            "z": -331.9512634277344
        },
        {
            "x": 11.939577102661133,
            "y": 1.0907835960388184,
            "z": -331.80194091796875
        },
        {
            "x": 11.989032745361328,
            "y": 1.0970399379730225,
            "z": -331.6524353027344
        },
        {
            "x": 12.038395881652832,
            "y": 1.1030747890472412,
            "z": -331.502685546875
        },
        {
            "x": 12.087542533874512,
            "y": 1.1088770627975464,
            "z": -331.35308837890625
        },
        {
            "x": 12.13657283782959,
            "y": 1.1144514083862305,
            "z": -331.2034606933594
        },
        {
            "x": 12.185490608215332,
            "y": 1.1197896003723145,
            "z": -331.0539855957031
        },
        {
            "x": 12.234375953674316,
            "y": 1.1248923540115356,
            "z": -330.9041748046875
        },
        {
            "x": 12.283110618591309,
            "y": 1.129753828048706,
            "z": -330.75421142578125
        },
        {
            "x": 12.331693649291992,
            "y": 1.134369969367981,
            "z": -330.604248046875
        },
        {
            "x": 12.38010025024414,
            "y": 1.138730525970459,
            "z": -330.4544677734375
        },
        {
            "x": 12.428474426269531,
            "y": 1.1428346633911133,
            "z": -330.304443359375
        },
        {
            "x": 12.476715087890625,
            "y": 1.1466788053512573,
            "z": -330.1543884277344
        },
        {
            "x": 12.524746894836426,
            "y": 1.1502594947814941,
            "z": -330.0043029785156
        },
        {
            "x": 12.572670936584473,
            "y": 1.1535758972167969,
            "z": -329.85406494140625
        },
        {
            "x": 12.620438575744629,
            "y": 1.1566076278686523,
            "z": -329.7039794921875
        },
        {
            "x": 12.668137550354004,
            "y": 1.1593644618988037,
            "z": -329.5537414550781
        },
        {
            "x": 12.715697288513184,
            "y": 1.161844253540039,
            "z": -329.4032897949219
        },
        {
            "x": 12.763006210327148,
            "y": 1.1640377044677734,
            "z": -329.2529296875
        },
        {
            "x": 12.81023120880127,
            "y": 1.1659348011016846,
            "z": -329.1024475097656
        },
        {
            "x": 12.857294082641602,
            "y": 1.16753351688385,
            "z": -328.9521179199219
        },
        {
            "x": 12.90425968170166,
            "y": 1.168837308883667,
            "z": -328.80157470703125
        },
        {
            "x": 12.951064109802246,
            "y": 1.1698417663574219,
            "z": -328.6507568359375
        },
        {
            "x": 12.997613906860352,
            "y": 1.1705293655395508,
            "z": -328.5001525878906
        },
        {
            "x": 13.044025421142578,
            "y": 1.170902967453003,
            "z": -328.349609375
        },
        {
            "x": 13.090386390686035,
            "y": 1.170962929725647,
            "z": -328.1988525390625
        },
        {
            "x": 13.13656234741211,
            "y": 1.1707078218460083,
            "z": -328.0478820800781
        },
        {
            "x": 13.167207717895508,
            "y": 1.1703547239303589,
            "z": -327.947265625
        },
        {
            "x": 13.212979316711426,
            "y": 1.16957426071167,
            "z": -327.79644775390625
        },
        {
            "x": 13.258624076843262,
            "y": 1.1684901714324951,
            "z": -327.6457214355469
        },
        {
            "x": 13.304232597351074,
            "y": 1.1670949459075928,
            "z": -327.49456787109375
        },
        {
            "x": 13.349597930908203,
            "y": 1.165399193763733,
            "z": -327.34344482421875
        },
        {
            "x": 13.394731521606445,
            "y": 1.1634128093719482,
            "z": -327.1922912597656
        },
        {
            "x": 13.439680099487305,
            "y": 1.1611405611038208,
            "z": -327.04119873046875
        },
        {
            "x": 13.484478950500488,
            "y": 1.15857994556427,
            "z": -326.8901062011719
        },
        {
            "x": 13.529192924499512,
            "y": 1.155728816986084,
            "z": -326.73870849609375
        },
        {
            "x": 13.573667526245117,
            "y": 1.152603268623352,
            "z": -326.587158203125
        },
        {
            "x": 13.617839813232422,
            "y": 1.1492136716842651,
            "z": -326.43585205078125
        },
        {
            "x": 13.661870956420898,
            "y": 1.1455528736114502,
            "z": -326.2845153808594
        },
        {
            "x": 13.705764770507812,
            "y": 1.141625165939331,
            "z": -326.13311767578125
        },
        {
            "x": 13.749494552612305,
            "y": 1.137434959411621,
            "z": -325.9814758300781
        },
        {
            "x": 13.793010711669922,
            "y": 1.13298761844635,
            "z": -325.8296203613281
        },
        {
            "x": 13.836219787597656,
            "y": 1.1282987594604492,
            "z": -325.6780700683594
        },
        {
            "x": 13.879291534423828,
            "y": 1.1233596801757812,
            "z": -325.52655029296875
        },
        {
            "x": 13.922240257263184,
            "y": 1.118174433708191,
            "z": -325.37469482421875
        },
        {
            "x": 13.964943885803223,
            "y": 1.1127523183822632,
            "z": -325.2227783203125
        },
        {
            "x": 14.007396697998047,
            "y": 1.1070926189422607,
            "z": -325.0707092285156
        },
        {
            "x": 14.049580574035645,
            "y": 1.10121488571167,
            "z": -324.9189758300781
        },
        {
            "x": 14.09164810180664,
            "y": 1.0951101779937744,
            "z": -324.7671203613281
        },
        {
            "x": 14.133545875549316,
            "y": 1.0887782573699951,
            "z": -324.61492919921875
        },
        {
            "x": 14.175131797790527,
            "y": 1.08223295211792,
            "z": -324.46282958984375
        },
        {
            "x": 14.216460227966309,
            "y": 1.075475811958313,
            "z": -324.3106994628906
        },
        {
            "x": 14.257623672485352,
            "y": 1.0685169696807861,
            "z": -324.1585998535156
        },
        {
            "x": 14.298622131347656,
            "y": 1.0613539218902588,
            "z": -324.0063781738281
        },
        {
            "x": 14.339415550231934,
            "y": 1.0539783239364624,
            "z": -323.8537902832031
        },
        {
            "x": 14.37983512878418,
            "y": 1.0464167594909668,
            "z": -323.7014465332031
        },
        {
            "x": 14.420016288757324,
            "y": 1.0386786460876465,
            "z": -323.5492248535156
        },
        {
            "x": 14.46010971069336,
            "y": 1.0307430028915405,
            "z": -323.39666748046875
        },
        {
            "x": 14.499968528747559,
            "y": 1.0226250886917114,
            "z": -323.24407958984375
        },
        {
            "x": 14.539531707763672,
            "y": 1.0143184661865234,
            "z": -323.0912780761719
        },
        {
            "x": 14.578770637512207,
            "y": 1.005854845046997,
            "z": -322.9386291503906
        },
        {
            "x": 14.617777824401855,
            "y": 0.9972394108772278,
            "z": -322.78619384765625
        },
        {
            "x": 14.656702995300293,
            "y": 0.988438069820404,
            "z": -322.63330078125
        },
        {
            "x": 14.695337295532227,
            "y": 0.9794665575027466,
            "z": -322.4802551269531
        },
        {
            "x": 14.733597755432129,
            "y": 0.9703548550605774,
            "z": -322.3273620605469
        },
        {
            "x": 14.77161693572998,
            "y": 0.9611014723777771,
            "z": -322.17449951171875
        },
        {
            "x": 14.809450149536133,
            "y": 0.9517077207565308,
            "z": -322.0216979980469
        },
        {
            "x": 14.847112655639648,
            "y": 0.9421423673629761,
            "z": -321.8684387207031
        },
        {
            "x": 14.88443660736084,
            "y": 0.9324392080307007,
            "z": -321.71502685546875
        },
        {
            "x": 14.92138671875,
            "y": 0.9226246476173401,
            "z": -321.5618896484375
        },
        {
            "x": 14.945874214172363,
            "y": 0.9160221815109253,
            "z": -321.4599609375
        },
        {
            "x": 14.982522010803223,
            "y": 0.905992865562439,
            "z": -321.30682373046875
        },
        {
            "x": 15.018919944763184,
            "y": 0.8958309888839722,
            "z": -321.1533203125
        },
        {
            "x": 15.055011749267578,
            "y": 0.8855416178703308,
            "z": -320.9996032714844
        },
        {
            "x": 15.090697288513184,
            "y": 0.8751628398895264,
            "z": -320.84619140625
        },
        {
            "x": 15.126168251037598,
            "y": 0.8646879196166992,
            "z": -320.6929626464844
        },
        {
            "x": 15.161491394042969,
            "y": 0.8540844917297363,
            "z": -320.539306640625
        },
        {
            "x": 15.196488380432129,
            "y": 0.8433744311332703,
            "z": -320.3854064941406
        },
        {
            "x": 15.231103897094727,
            "y": 0.8325741291046143,
            "z": -320.2315979003906
        },
        {
            "x": 15.265411376953125,
            "y": 0.8217025995254517,
            "z": -320.0780029296875
        },
        {
            "x": 15.299546241760254,
            "y": 0.8107382655143738,
            "z": -319.92425537109375
        },
        {
            "x": 15.333452224731445,
            "y": 0.7996684908866882,
            "z": -319.7701110839844
        },
        {
            "x": 15.366945266723633,
            "y": 0.7885242104530334,
            "z": -319.615966796875
        },
        {
            "x": 15.400044441223145,
            "y": 0.7773280739784241,
            "z": -319.4620666503906
        },
        {
            "x": 15.43294620513916,
            "y": 0.7660611867904663,
            "z": -319.3080749511719
        },
        {
            "x": 15.465653419494629,
            "y": 0.7547167539596558,
            "z": -319.1539306640625
        },
        {
            "x": 15.498022079467773,
            "y": 0.743295431137085,
            "z": -318.9994201660156
        },
        {
            "x": 15.529962539672852,
            "y": 0.7318317890167236,
            "z": -318.8450622558594
        },
        {
            "x": 15.561578750610352,
            "y": 0.7203369736671448,
            "z": -318.6908874511719
        },
        {
            "x": 15.593045234680176,
            "y": 0.7087756395339966,
            "z": -318.5364990234375
        },
        {
            "x": 15.624201774597168,
            "y": 0.6971599459648132,
            "z": -318.3818359375
        },
        {
            "x": 15.65492057800293,
            "y": 0.6855069994926453,
            "z": -318.2271423339844
        },
        {
            "x": 15.685253143310547,
            "y": 0.673839807510376,
            "z": -318.0726318359375
        },
        {
            "x": 15.715350151062012,
            "y": 0.6621518135070801,
            "z": -317.9182434082031
        },
        {
            "x": 15.745246887207031,
            "y": 0.650407612323761,
            "z": -317.763427734375
        },
        {
            "x": 15.774765014648438,
            "y": 0.6386240720748901,
            "z": -317.6082458496094
        },
        {
            "x": 15.803811073303223,
            "y": 0.6268472671508789,
            "z": -317.453369140625
        },
        {
            "x": 15.832554817199707,
            "y": 0.6150710582733154,
            "z": -317.298583984375
        },
        {
            "x": 15.861075401306152,
            "y": 0.6032825708389282,
            "z": -317.14373779296875
        },
        {
            "x": 15.889280319213867,
            "y": 0.5914642810821533,
            "z": -316.9884948730469
        },
        {
            "x": 15.91706371307373,
            "y": 0.5796315670013428,
            "z": -316.83294677734375
        },
        {
            "x": 15.944403648376465,
            "y": 0.5678418874740601,
            "z": -316.6778869628906
        },
        {
            "x": 15.971490859985352,
            "y": 0.5560657382011414,
            "z": -316.5228576660156
        },
        {
            "x": 15.9983491897583,
            "y": 0.5442769527435303,
            "z": -316.3674621582031
        },
        {
            "x": 16.024782180786133,
            "y": 0.5324934720993042,
            "z": -316.2117919921875
        },
        {
            "x": 16.050777435302734,
            "y": 0.5207332372665405,
            "z": -316.0561218261719
        },
        {
            "x": 16.076396942138672,
            "y": 0.5090328454971313,
            "z": -315.90087890625
        },
        {
            "x": 16.10179328918457,
            "y": 0.49735310673713684,
            "z": -315.74542236328125
        },
        {
            "x": 16.126859664916992,
            "y": 0.48567140102386475,
            "z": -315.58941650390625
        },
        {
            "x": 16.15142250061035,
            "y": 0.474039763212204,
            "z": -315.43353271484375
        },
        {
            "x": 16.175573348999023,
            "y": 0.462469220161438,
            "z": -315.27783203125
        },
        {
            "x": 16.199459075927734,
            "y": 0.4509490132331848,
            "z": -315.1221008300781
        },
        {
            "x": 16.223054885864258,
            "y": 0.43946197628974915,
            "z": -314.9660339355469
        },
        {
            "x": 16.238548278808594,
            "y": 0.43182313442230225,
            "z": -314.8619079589844
        },
        {
            "x": 16.26134490966797,
            "y": 0.42042866349220276,
            "z": -314.70574951171875
        },
        {
            "x": 16.283733367919922,
            "y": 0.40912196040153503,
            "z": -314.54986572265625
        },
        {
            "x": 16.305906295776367,
            "y": 0.3978637456893921,
            "z": -314.39373779296875
        },
        {
            "x": 16.327728271484375,
            "y": 0.38666167855262756,
            "z": -314.2373352050781
        },
        {
            "x": 16.349050521850586,
            "y": 0.3755296766757965,
            "z": -314.080810546875
        },
        {
            "x": 16.369884490966797,
            "y": 0.36449626088142395,
            "z": -313.9244079589844
        },
        {
            "x": 16.390405654907227,
            "y": 0.353567898273468,
            "z": -313.7683410644531
        },
        {
            "x": 16.410682678222656,
            "y": 0.34269171953201294,
            "z": -313.61163330078125
        },
        {
            "x": 16.430496215820312,
            "y": 0.33189094066619873,
            "z": -313.45477294921875
        },
        {
            "x": 16.449737548828125,
            "y": 0.3212132453918457,
            "z": -313.298095703125
        },
        {
            "x": 16.468610763549805,
            "y": 0.3106502592563629,
            "z": -313.1415710449219
        },
        {
            "x": 16.487211227416992,
            "y": 0.3001888394355774,
            "z": -312.98504638671875
        },
        {
            "x": 16.505435943603516,
            "y": 0.2898089289665222,
            "z": -312.8280029296875
        },
        {
            "x": 16.523113250732422,
            "y": 0.2795325517654419,
            "z": -312.6706848144531
        },
        {
            "x": 16.540287017822266,
            "y": 0.26941409707069397,
            "z": -312.51397705078125
        },
        {
            "x": 16.55718231201172,
            "y": 0.2594186067581177,
            "z": -312.35723876953125
        },
        {
            "x": 16.57375717163086,
            "y": 0.24952277541160583,
            "z": -312.2000732421875
        },
        {
            "x": 16.589792251586914,
            "y": 0.23974978923797607,
            "z": -312.0426940917969
        },
        {
            "x": 16.605295181274414,
            "y": 0.23011624813079834,
            "z": -311.8852844238281
        },
        {
            "x": 16.620410919189453,
            "y": 0.22065624594688416,
            "z": -311.728515625
        },
        {
            "x": 16.63525390625,
            "y": 0.21131853759288788,
            "z": -311.5713195800781
        },
        {
            "x": 16.64961814880371,
            "y": 0.2021070122718811,
            "z": -311.4136657714844
        },
        {
            "x": 16.663393020629883,
            "y": 0.19305726885795593,
            "z": -311.2561340332031
        },
        {
            "x": 16.67671012878418,
            "y": 0.18418088555335999,
            "z": -311.098876953125
        },
        {
            "x": 16.689739227294922,
            "y": 0.17546314001083374,
            "z": -310.94158935546875
        },
        {
            "x": 16.702377319335938,
            "y": 0.1668892800807953,
            "z": -310.78387451171875
        },
        {
            "x": 16.714431762695312,
            "y": 0.15847505629062653,
            "z": -310.6258850097656
        },
        {
            "x": 16.725929260253906,
            "y": 0.15025627613067627,
            "z": -310.4683532714844
        },
        {
            "x": 16.737070083618164,
            "y": 0.14222580194473267,
            "z": -310.31103515625
        },
        {
            "x": 16.74790382385254,
            "y": 0.13435238599777222,
            "z": -310.1531677246094
        },
        {
            "x": 16.758188247680664,
            "y": 0.12665638327598572,
            "z": -309.9950866699219
        },
        {
            "x": 16.767868041992188,
            "y": 0.11915597319602966,
            "z": -309.8370666503906
        },
        {
            "x": 16.777101516723633,
            "y": 0.11186738312244415,
            "z": -309.67950439453125
        },
        {
            "x": 16.786027908325195,
            "y": 0.10477501153945923,
            "z": -309.5218505859375
        },
        {
            "x": 16.79449462890625,
            "y": 0.09785840660333633,
            "z": -309.36346435546875
        },
        {
            "x": 16.80232810974121,
            "y": 0.091151162981987,
            "z": -309.2052307128906
        },
        {
            "x": 16.809621810913086,
            "y": 0.08467153459787369,
            "z": -309.0473937988281
        },
        {
            "x": 16.81659507751465,
            "y": 0.0784100666642189,
            "z": -308.8896179199219
        },
        {
            "x": 16.823156356811523,
            "y": 0.07235419750213623,
            "z": -308.7314147949219
        },
        {
            "x": 16.829124450683594,
            "y": 0.06650737673044205,
            "z": -308.57293701171875
        },
        {
            "x": 16.8344783782959,
            "y": 0.06089594215154648,
            "z": -308.4146728515625
        },
        {
            "x": 16.83942222595215,
            "y": 0.05553245171904564,
            "z": -308.25689697265625
        },
        {
            "x": 16.84253692626953,
            "y": 0.05208665505051613,
            "z": -308.15155029296875
        },
        {
            "x": 16.846805572509766,
            "y": 0.047093458473682404,
            "z": -307.99310302734375
        },
        {
            "x": 16.850421905517578,
            "y": 0.04234091937541962,
            "z": -307.83453369140625
        },
        {
            "x": 16.85344696044922,
            "y": 0.03784584254026413,
            "z": -307.6762390136719
        },
        {
            "x": 16.856117248535156,
            "y": 0.03360862284898758,
            "z": -307.5183410644531
        },
        {
            "x": 16.858400344848633,
            "y": 0.029610807076096535,
            "z": -307.3600158691406
        },
        {
            "x": 16.86005973815918,
            "y": 0.02586040459573269,
            "z": -307.2012634277344
        },
        {
            "x": 16.861053466796875,
            "y": 0.022386573255062103,
            "z": -307.0428161621094
        },
        {
            "x": 16.861614227294922,
            "y": 0.01918189227581024,
            "z": -306.884765625
        },
        {
            "x": 16.861835479736328,
            "y": 0.016238488256931305,
            "z": -306.72650146484375
        },
        {
            "x": 16.86150360107422,
            "y": 0.013560120016336441,
            "z": -306.5677795410156
        },
        {
            "x": 16.860454559326172,
            "y": 0.01116679422557354,
            "z": -306.4090270996094
        },
        {
            "x": 16.8588809967041,
            "y": 0.0090592410415411,
            "z": -306.2508850097656
        },
        {
            "x": 16.856969833374023,
            "y": 0.007234024349600077,
            "z": -306.0928039550781
        },
        {
            "x": 16.854578018188477,
            "y": 0.005688594188541174,
            "z": -305.9340515136719
        },
        {
            "x": 16.851482391357422,
            "y": 0.004444765858352184,
            "z": -305.7752990722656
        },
        {
            "x": 16.847766876220703,
            "y": 0.0034967500250786543,
            "z": -305.6169128417969
        },
        {
            "x": 16.84365463256836,
            "y": 0.0028466989751905203,
            "z": -305.45892333984375
        },
        {
            "x": 16.839153289794922,
            "y": 0.0024972008541226387,
            "z": -305.3006896972656
        },
        {
            "x": 16.833980560302734,
            "y": 0.002434574067592621,
            "z": -305.14178466796875
        },
        {
            "x": 16.828123092651367,
            "y": 0.002430759370326996,
            "z": -304.9832458496094
        },
        {
            "x": 16.821781158447266,
            "y": 0.0024269744753837585,
            "z": -304.82525634765625
        },
        {
            "x": 16.815092086791992,
            "y": 0.0024231672286987305,
            "z": -304.6672668457031
        },
        {
            "x": 16.80781364440918,
            "y": 0.0024193301796913147,
            "z": -304.5087585449219
        },
        {
            "x": 16.79981231689453,
            "y": 0.0024155601859092712,
            "z": -304.3500671386719
        },
        {
            "x": 16.791223526000977,
            "y": 0.00241176038980484,
            "z": -304.1918640136719
        },
        {
            "x": 16.78228187561035,
            "y": 0.002407968044281006,
            "z": -304.03411865234375
        },
        {
            "x": 16.772836685180664,
            "y": 0.0024042055010795593,
            "z": -303.8757629394531
        },
        {
            "x": 16.762691497802734,
            "y": 0.0024003982543945312,
            "z": -303.71722412109375
        },
        {
            "x": 16.751863479614258,
            "y": 0.002396613359451294,
            "z": -303.5590515136719
        },
        {
            "x": 16.740598678588867,
            "y": 0.002392806112766266,
            "z": -303.40118408203125
        },
        {
            "x": 16.72893714904785,
            "y": 0.0023890361189842224,
            "z": -303.24334716796875
        },
        {
            "x": 16.716617584228516,
            "y": 0.0023852139711380005,
            "z": -303.0849609375
        },
        {
            "x": 16.703563690185547,
            "y": 0.00238143652677536,
            "z": -302.92669677734375
        },
        {
            "x": 16.689979553222656,
            "y": 0.002377644181251526,
            "z": -302.76904296875
        },
        {
            "x": 16.67600440979004,
            "y": 0.002373836934566498,
            "z": -302.61138916015625
        },
        {
            "x": 16.661489486694336,
            "y": 0.0023700445890426636,
            "z": -302.45343017578125
        },
        {
            "x": 16.646223068237305,
            "y": 0.0023662522435188293,
            "z": -302.2952880859375
        },
        {
            "x": 16.63030433654785,
            "y": 0.002362459897994995,
            "z": -302.1374816894531
        },
        {
            "x": 16.613988876342773,
            "y": 0.002358667552471161,
            "z": -301.98028564453125
        },
        {
            "x": 16.597209930419922,
            "y": 0.0023548826575279236,
            "z": -301.82269287109375
        },
        {
            "x": 16.579713821411133,
            "y": 0.0023510605096817017,
            "z": -301.6646423339844
        },
        {
            "x": 16.56149673461914,
            "y": 0.002347297966480255,
            "z": -301.5069580078125
        },
        {
            "x": 16.549057006835938,
            "y": 0.002344772219657898,
            "z": -301.40228271484375
        },
        {
            "x": 16.53011703491211,
            "y": 0.0023409128189086914,
            "z": -301.2453308105469
        },
        {
            "x": 16.510652542114258,
            "y": 0.002337150275707245,
            "z": -301.0879821777344
        },
        {
            "x": 16.49036979675293,
            "y": 0.002333313226699829,
            "z": -300.93011474609375
        },
        {
            "x": 16.46942901611328,
            "y": 0.0023295357823371887,
            "z": -300.77288818359375
        },
        {
            "x": 16.448074340820312,
            "y": 0.0023257434368133545,
            "z": -300.61627197265625
        },
        {
            "x": 16.426286697387695,
            "y": 0.0023219361901283264,
            "z": -300.4593200683594
        },
        {
            "x": 16.40378761291504,
            "y": 0.002318158745765686,
            "z": -300.3020935058594
        },
        {
            "x": 16.380495071411133,
            "y": 0.0023143738508224487,
            "z": -300.14483642578125
        },
        {
            "x": 16.356687545776367,
            "y": 0.0023105889558792114,
            "z": -299.9883117675781
        },
        {
            "x": 16.332542419433594,
            "y": 0.0023067891597747803,
            "z": -299.83209228515625
        },
        {
            "x": 16.307754516601562,
            "y": 0.0023029744625091553,
            "z": -299.6752014160156
        },
        {
            "x": 16.28218650817871,
            "y": 0.002299197018146515,
            "z": -299.518310546875
        },
        {
            "x": 16.255970001220703,
            "y": 0.0022954270243644714,
            "z": -299.3619689941406
        },
        {
            "x": 16.229341506958008,
            "y": 0.0022916123270988464,
            "z": -299.2059326171875
        },
        {
            "x": 16.2022647857666,
            "y": 0.002287827432155609,
            "z": -299.0498962402344
        },
        {
            "x": 16.174419403076172,
            "y": 0.002284020185470581,
            "z": -298.89337158203125
        },
        {
            "x": 16.14580535888672,
            "y": 0.00228022038936615,
            "z": -298.7370910644531
        },
        {
            "x": 16.116722106933594,
            "y": 0.0022764354944229126,
            "z": -298.58154296875
        },
        {
            "x": 16.087238311767578,
            "y": 0.0022726431488990784,
            "z": -298.4259948730469
        },
        {
            "x": 16.0571231842041,
            "y": 0.002268850803375244,
            "z": -298.2701416015625
        },
        {
            "x": 16.026214599609375,
            "y": 0.00226505845785141,
            "z": -298.11419677734375
        },
        {
            "x": 15.994658470153809,
            "y": 0.002261243760585785,
            "z": -297.9587707519531
        },
        {
            "x": 15.962737083435059,
            "y": 0.0022574812173843384,
            "z": -297.803955078125
        },
        {
            "x": 15.930306434631348,
            "y": 0.0022536590695381165,
            "z": -297.6487731933594
        },
        {
            "x": 15.897096633911133,
            "y": 0.0022498443722724915,
            "z": -297.4932556152344
        },
        {
            "x": 15.863150596618652,
            "y": 0.002246081829071045,
            "z": -297.33807373046875
        },
        {
            "x": 15.828730583190918,
            "y": 0.0022422894835472107,
            "z": -297.1835632324219
        },
        {
            "x": 15.793939590454102,
            "y": 0.0022385045886039734,
            "z": -297.0292663574219
        },
        {
            "x": 15.758485794067383,
            "y": 0.0022346973419189453,
            "z": -296.8745422363281
        },
        {
            "x": 15.722176551818848,
            "y": 0.002230897545814514,
            "z": -296.7195739746094
        },
        {
            "x": 15.68528938293457,
            "y": 0.0022271201014518738,
            "z": -296.5654296875
        },
        {
            "x": 15.648046493530273,
            "y": 0.0022233501076698303,
            "z": -296.4117736816406
        },
        {
            "x": 15.610280990600586,
            "y": 0.0022195354104042053,
            "z": -296.2577819824219
        },
        {
            "x": 15.571767807006836,
            "y": 0.002215735614299774,
            "z": -296.1036682128906
        },
        {
            "x": 15.532416343688965,
            "y": 0.00221194326877594,
            "z": -295.9495544433594
        },
        {
            "x": 15.492656707763672,
            "y": 0.0022081732749938965,
            "z": -295.79638671875
        },
        {
            "x": 15.452558517456055,
            "y": 0.0022043511271476746,
            "z": -295.6434020996094
        },
        {
            "x": 15.411778450012207,
            "y": 0.0022005662322044373,
            "z": -295.4899597167969
        },
        {
            "x": 15.370165824890137,
            "y": 0.002196766436100006,
            "z": -295.33648681640625
        },
        {
            "x": 15.327921867370605,
            "y": 0.0021929964423179626,
            "z": -295.1835632324219
        },
        {
            "x": 15.285331726074219,
            "y": 0.0021891817450523376,
            "z": -295.0312194824219
        },
        {
            "x": 15.242287635803223,
            "y": 0.0021853819489479065,
            "z": -294.8787841796875
        },
        {
            "x": 15.213180541992188,
            "y": 0.002182871103286743,
            "z": -294.77703857421875
        },
        {
            "x": 15.168814659118652,
            "y": 0.0021790266036987305,
            "z": -294.6243591308594
        },
        {
            "x": 15.123876571655273,
            "y": 0.002175264060497284,
            "z": -294.4723205566406
        },
        {
            "x": 15.078605651855469,
            "y": 0.002171449363231659,
            "z": -294.3207702636719
        },
        {
            "x": 15.032805442810059,
            "y": 0.0021676719188690186,
            "z": -294.16900634765625
        },
        {
            "x": 14.986238479614258,
            "y": 0.0021638795733451843,
            "z": -294.0171203613281
        },
        {
            "x": 14.938894271850586,
            "y": 0.002160079777240753,
            "z": -293.86541748046875
        },
        {
            "x": 14.891130447387695,
            "y": 0.0021563172340393066,
            "z": -293.71453857421875
        },
        {
            "x": 14.842991828918457,
            "y": 0.002152465283870697,
            "z": -293.5638427734375
        },
        {
            "x": 14.794245719909668,
            "y": 0.002148732542991638,
            "z": -293.412841796875
        },
        {
            "x": 14.7446870803833,
            "y": 0.002144940197467804,
            "z": -293.26177978515625
        },
        {
            "x": 14.694473266601562,
            "y": 0.002141118049621582,
            "z": -293.1111755371094
        },
        {
            "x": 14.643960952758789,
            "y": 0.0021373331546783447,
            "z": -292.9613952636719
        },
        {
            "x": 14.59301471710205,
            "y": 0.0021335557103157043,
            "z": -292.8115539550781
        },
        {
            "x": 14.541279792785645,
            "y": 0.0021297410130500793,
            "z": -292.6612243652344
        },
        {
            "x": 14.488789558410645,
            "y": 0.002125971019268036,
            "z": -292.51123046875
        },
        {
            "x": 14.435772895812988,
            "y": 0.0021221935749053955,
            "z": -292.3618469238281
        },
        {
            "x": 14.382489204406738,
            "y": 0.0021183863282203674,
            "z": -292.2130432128906
        },
        {
            "x": 14.328682899475098,
            "y": 0.002114593982696533,
            "z": -292.06402587890625
        },
        {
            "x": 14.274003028869629,
            "y": 0.002110779285430908,
            "z": -291.9146423339844
        },
        {
            "x": 14.218658447265625,
            "y": 0.0020614718087017536,
            "z": -291.7657775878906
        },
        {
            "x": 14.162935256958008,
            "y": 0.0015570768155157566,
            "z": -291.6176452636719
        },
        {
            "x": 14.106915473937988,
            "y": 0.0004670117050409317,
            "z": -291.4698791503906
        },
        {
            "x": 14.05026626586914,
            "y": -0.0012096210848540068,
            "z": -291.3218078613281
        },
        {
            "x": 13.992733001708984,
            "y": -0.003482619533315301,
            "z": -291.17352294921875
        },
        {
            "x": 13.93460750579834,
            "y": -0.006308965850621462,
            "z": -291.02587890625
        },
        {
            "x": 13.876238822937012,
            "y": -0.009668175131082535,
            "z": -290.8790283203125
        },
        {
            "x": 13.817447662353516,
            "y": -0.01357080228626728,
            "z": -290.7320556640625
        },
        {
            "x": 13.757972717285156,
            "y": -0.01802963763475418,
            "z": -290.5849914550781
        },
        {
            "x": 13.697747230529785,
            "y": -0.02300664782524109,
            "z": -290.4381103515625
        },
        {
            "x": 13.636900901794434,
            "y": -0.028484569862484932,
            "z": -290.2916564941406
        },
        {
            "x": 13.57589340209961,
            "y": -0.03443193808197975,
            "z": -290.1459655761719
        },
        {
            "x": 13.51445484161377,
            "y": -0.04088964685797691,
            "z": -290.0002136230469
        },
        {
            "x": 13.452277183532715,
            "y": -0.0478392019867897,
            "z": -289.8542785644531
        },
        {
            "x": 13.389416694641113,
            "y": -0.05524856597185135,
            "z": -289.7087097167969
        },
        {
            "x": 13.326089859008789,
            "y": -0.06309463083744049,
            "z": -289.5635986328125
        },
        {
            "x": 13.262639045715332,
            "y": -0.07137010991573334,
            "z": -289.419189453125
        },
        {
            "x": 13.198678016662598,
            "y": -0.08009036630392075,
            "z": -289.2746276855469
        },
        {
            "x": 13.133956909179688,
            "y": -0.08925417065620422,
            "z": -289.1298828125
        },
        {
            "x": 13.068788528442383,
            "y": -0.09880362451076508,
            "z": -288.98577880859375
        },
        {
            "x": 13.003325462341309,
            "y": -0.10873930156230927,
            "z": -288.84222412109375
        },
        {
            "x": 12.937627792358398,
            "y": -0.11905589699745178,
            "z": -288.6988220214844
        },
        {
            "x": 12.871408462524414,
            "y": -0.12976452708244324,
            "z": -288.55535888671875
        },
        {
            "x": 12.826950073242188,
            "y": -0.13710936903953552,
            "z": -288.4598083496094
        },
        {
            "x": 12.760002136230469,
            "y": -0.14840520918369293,
            "z": -288.3169860839844
        },
        {
            "x": 12.692927360534668,
            "y": -0.16001786291599274,
            "z": -288.1746520996094
        },
        {
            "x": 12.625325202941895,
            "y": -0.1720007359981537,
            "z": -288.0319519042969
        },
        {
            "x": 12.557369232177734,
            "y": -0.1843019723892212,
            "z": -287.8896179199219
        },
        {
            "x": 12.489290237426758,
            "y": -0.19688108563423157,
            "z": -287.74786376953125
        },
        {
            "x": 12.420807838439941,
            "y": -0.2097858041524887,
            "z": -287.60595703125
        },
        {
            "x": 12.352166175842285,
            "y": -0.22294814884662628,
            "z": -287.4645080566406
        },
        {
            "x": 12.28347110748291,
            "y": -0.2363785058259964,
            "z": -287.32330322265625
        },
        {
            "x": 12.214563369750977,
            "y": -0.2500896453857422,
            "z": -287.18206787109375
        },
        {
            "x": 12.14568042755127,
            "y": -0.2640235722064972,
            "z": -287.0412292480469
        },
        {
            "x": 12.076691627502441,
            "y": -0.27821213006973267,
            "z": -286.9002990722656
        },
        {
            "x": 12.007638931274414,
            "y": -0.2926267385482788,
            "z": -286.759521484375
        },
        {
            "x": 11.938528060913086,
            "y": -0.30726394057273865,
            "z": -286.6188659667969
        },
        {
            "x": 11.869199752807617,
            "y": -0.322135329246521,
            "z": -286.4779968261719
        },
        {
            "x": 11.799945831298828,
            "y": -0.3371785581111908,
            "z": -286.3374938964844
        },
        {
            "x": 11.730559349060059,
            "y": -0.3524227738380432,
            "z": -286.1968994140625
        },
        {
            "x": 11.6611328125,
            "y": -0.36784183979034424,
            "z": -286.05645751953125
        },
        {
            "x": 11.591692924499512,
            "y": -0.3834199905395508,
            "z": -285.9161071777344
        },
        {
            "x": 11.522102355957031,
            "y": -0.39917615056037903,
            "z": -285.7756042480469
        },
        {
            "x": 11.452473640441895,
            "y": -0.41507142782211304,
            "z": -285.63525390625
        },
        {
            "x": 11.382787704467773,
            "y": -0.43109339475631714,
            "z": -285.4949951171875
        },
        {
            "x": 11.31307315826416,
            "y": -0.44723832607269287,
            "z": -285.3548889160156
        },
        {
            "x": 11.243279457092285,
            "y": -0.46349674463272095,
            "z": -285.21478271484375
        },
        {
            "x": 11.17341423034668,
            "y": -0.47986701130867004,
            "z": -285.0745849609375
        },
        {
            "x": 11.103497505187988,
            "y": -0.49633005261421204,
            "z": -284.93450927734375
        },
        {
            "x": 11.033534049987793,
            "y": -0.5128707885742188,
            "z": -284.7944641113281
        },
        {
            "x": 10.963557243347168,
            "y": -0.5294775366783142,
            "z": -284.654541015625
        },
        {
            "x": 10.89352035522461,
            "y": -0.5461463332176208,
            "z": -284.5145568847656
        },
        {
            "x": 10.823457717895508,
            "y": -0.5628663301467896,
            "z": -284.3746337890625
        },
        {
            "x": 10.75328540802002,
            "y": -0.5796371102333069,
            "z": -284.23468017578125
        },
        {
            "x": 10.683137893676758,
            "y": -0.5964255332946777,
            "z": -284.0947570800781
        },
        {
            "x": 10.612946510314941,
            "y": -0.6132301092147827,
            "z": -283.9549560546875
        },
        {
            "x": 10.542726516723633,
            "y": -0.6300390958786011,
            "z": -283.81512451171875
        },
        {
            "x": 10.472503662109375,
            "y": -0.6468400955200195,
            "z": -283.6753845214844
        },
        {
            "x": 10.402125358581543,
            "y": -0.663652777671814,
            "z": -283.53546142578125
        },
        {
            "x": 10.331865310668945,
            "y": -0.6804088950157166,
            "z": -283.39581298828125
        },
        {
            "x": 10.261597633361816,
            "y": -0.6971250772476196,
            "z": -283.2561950683594
        },
        {
            "x": 10.191230773925781,
            "y": -0.713819146156311,
            "z": -283.1163635253906
        },
        {
            "x": 10.120890617370605,
            "y": -0.7304391860961914,
            "z": -282.9766845703125
        },
        {
            "x": 10.050549507141113,
            "y": -0.7469935417175293,
            "z": -282.8370056152344
        },
        {
            "x": 9.980167388916016,
            "y": -0.7634814381599426,
            "z": -282.6972351074219
        },
        {
            "x": 9.909895896911621,
            "y": -0.7798562049865723,
            "z": -282.55755615234375
        },
        {
            "x": 9.862937927246094,
            "y": -0.7907346487045288,
            "z": -282.4643859863281
        },
        {
            "x": 9.792548179626465,
            "y": -0.8069500923156738,
            "z": -282.32464599609375
        },
        {
            "x": 9.722197532653809,
            "y": -0.8230416774749756,
            "z": -282.1850280761719
        },
        {
            "x": 9.65173625946045,
            "y": -0.8390251398086548,
            "z": -282.0451965332031
        },
        {
            "x": 9.581374168395996,
            "y": -0.8548474311828613,
            "z": -281.9054870605469
        },
        {
            "x": 9.51105785369873,
            "y": -0.8705185055732727,
            "z": -281.7657775878906
        },
        {
            "x": 9.440689086914062,
            "y": -0.8860417008399963,
            "z": -281.62603759765625
        },
        {
            "x": 9.370383262634277,
            "y": -0.9013789892196655,
            "z": -281.48626708984375
        },
        {
            "x": 9.300110816955566,
            "y": -0.9165403842926025,
            "z": -281.3464660644531
        },
        {
            "x": 9.22983169555664,
            "y": -0.9315122365951538,
            "z": -281.20660400390625
        },
        {
            "x": 9.159622192382812,
            "y": -0.9462797045707703,
            "z": -281.0667419433594
        },
        {
            "x": 9.089391708374023,
            "y": -0.9608285427093506,
            "z": -280.9268493652344
        },
        {
            "x": 9.019258499145508,
            "y": -0.9751449823379517,
            "z": -280.7869567871094
        },
        {
            "x": 8.949165344238281,
            "y": -0.9892275333404541,
            "z": -280.6470642089844
        },
        {
            "x": 8.878998756408691,
            "y": -1.003090500831604,
            "z": -280.5068359375
        },
        {
            "x": 8.809006690979004,
            "y": -1.016657829284668,
            "z": -280.3669128417969
        },
        {
            "x": 8.739033699035645,
            "y": -1.0299663543701172,
            "z": -280.2268371582031
        },
        {
            "x": 8.669087409973145,
            "y": -1.0430042743682861,
            "z": -280.0866394042969
        },
        {
            "x": 8.59926986694336,
            "y": -1.0557358264923096,
            "z": -279.9466247558594
        },
        {
            "x": 8.529394149780273,
            "y": -1.0681836605072021,
            "z": -279.8062744140625
        },
        {
            "x": 8.459757804870605,
            "y": -1.08029043674469,
            "z": -279.6661376953125
        },
        {
            "x": 8.39009952545166,
            "y": -1.0920917987823486,
            "z": -279.5257873535156
        },
        {
            "x": 8.320573806762695,
            "y": -1.1035528182983398,
            "z": -279.3854675292969
        },
        {
            "x": 8.251070976257324,
            "y": -1.114671230316162,
            "z": -279.2450866699219
        },
        {
            "x": 8.181695938110352,
            "y": -1.1254241466522217,
            "z": -279.1046142578125
        },
        {
            "x": 8.112367630004883,
            "y": -1.1358203887939453,
            "z": -278.9639892578125
        },
        {
            "x": 8.043169021606445,
            "y": -1.145835280418396,
            "z": -278.82342529296875
        },
        {
            "x": 7.973995208740234,
            "y": -1.155468225479126,
            "z": -278.6826171875
        },
        {
            "x": 7.905020713806152,
            "y": -1.1646766662597656,
            "z": -278.5419921875
        },
        {
            "x": 7.836136341094971,
            "y": -1.1734832525253296,
            "z": -278.4012145996094
        },
        {
            "x": 7.767274856567383,
            "y": -1.1818798780441284,
            "z": -278.26019287109375
        },
        {
            "x": 7.698665618896484,
            "y": -1.1898304224014282,
            "z": -278.1192932128906
        },
        {
            "x": 7.630099296569824,
            "y": -1.1973305940628052,
            "z": -277.97821044921875
        },
        {
            "x": 7.56169319152832,
            "y": -1.2043766975402832,
            "z": -277.8371276855469
        },
        {
            "x": 7.493405818939209,
            "y": -1.2109601497650146,
            "z": -277.69598388671875
        },
        {
            "x": 7.425214767456055,
            "y": -1.2170735597610474,
            "z": -277.5545654296875
        },
        {
            "x": 7.3572211265563965,
            "y": -1.2226753234863281,
            "z": -277.41326904296875
        },
        {
            "x": 7.289416313171387,
            "y": -1.2277796268463135,
            "z": -277.2719421386719
        },
        {
            "x": 7.2216620445251465,
            "y": -1.2323846817016602,
            "z": -277.13037109375
        },
        {
            "x": 7.154170989990234,
            "y": -1.236464262008667,
            "z": -276.9888916015625
        },
        {
            "x": 7.086724281311035,
            "y": -1.2399983406066895,
            "z": -276.8470764160156
        },
        {
            "x": 7.019526481628418,
            "y": -1.242989182472229,
            "z": -276.7054138183594
        },
        {
            "x": 6.952486991882324,
            "y": -1.245431661605835,
            "z": -276.56353759765625
        },
        {
            "x": 6.907914161682129,
            "y": -1.2467411756515503,
            "z": -276.4690246582031
        },
        {
            "x": 6.841232776641846,
            "y": -1.2482236623764038,
            "z": -276.3271179199219
        },
        {
            "x": 6.774720668792725,
            "y": -1.2491283416748047,
            "z": -276.1851501464844
        },
        {
            "x": 6.708345413208008,
            "y": -1.2494436502456665,
            "z": -276.0428771972656
        },
        {
            "x": 6.642211437225342,
            "y": -1.2491333484649658,
            "z": -275.90069580078125
        },
        {
            "x": 6.576321125030518,
            "y": -1.2482342720031738,
            "z": -275.7584533691406
        },
        {
            "x": 6.510514259338379,
            "y": -1.2467552423477173,
            "z": -275.615966796875
        },
        {
            "x": 6.445046424865723,
            "y": -1.2447106838226318,
            "z": -275.47357177734375
        },
        {
            "x": 6.379706859588623,
            "y": -1.242081642150879,
            "z": -275.3309631347656
        },
        {
            "x": 6.314650535583496,
            "y": -1.2389063835144043,
            "z": -275.1883239746094
        },
        {
            "x": 6.24981164932251,
            "y": -1.235199213027954,
            "z": -275.0456848144531
        },
        {
            "x": 6.185225963592529,
            "y": -1.2309658527374268,
            "z": -274.90289306640625
        },
        {
            "x": 6.120860576629639,
            "y": -1.2261979579925537,
            "z": -274.760009765625
        },
        {
            "x": 6.056851863861084,
            "y": -1.220933437347412,
            "z": -274.6172180175781
        },
        {
            "x": 5.992874622344971,
            "y": -1.2151618003845215,
            "z": -274.47393798828125
        },
        {
            "x": 5.929326057434082,
            "y": -1.2089269161224365,
            "z": -274.3309326171875
        },
        {
            "x": 5.8659186363220215,
            "y": -1.2021939754486084,
            "z": -274.1876525878906
        },
        {
            "x": 5.802888870239258,
            "y": -1.1950109004974365,
            "z": -274.0444641113281
        },
        {
            "x": 5.74005126953125,
            "y": -1.1873726844787598,
            "z": -273.9010314941406
        },
        {
            "x": 5.6774492263793945,
            "y": -1.1792986392974854,
            "z": -273.75750732421875
        },
        {
            "x": 5.6151909828186035,
            "y": -1.1707887649536133,
            "z": -273.61395263671875
        },
        {
            "x": 5.5532546043396,
            "y": -1.1618685722351074,
            "z": -273.4704284667969
        },
        {
            "x": 5.491545677185059,
            "y": -1.1525375843048096,
            "z": -273.32666015625
        },
        {
            "x": 5.430174350738525,
            "y": -1.1428261995315552,
            "z": -273.1829528808594
        },
        {
            "x": 5.369032382965088,
            "y": -1.1327086687088013,
            "z": -273.0389709472656
        },
        {
            "x": 5.30819845199585,
            "y": -1.122222661972046,
            "z": -272.8949890136719
        },
        {
            "x": 5.247640609741211,
            "y": -1.1113718748092651,
            "z": -272.7508544921875
        },
        {
            "x": 5.18741512298584,
            "y": -1.100186824798584,
            "z": -272.60675048828125
        },
        {
            "x": 5.127471446990967,
            "y": -1.0886445045471191,
            "z": -272.4624328613281
        },
        {
            "x": 5.067880153656006,
            "y": -1.076784372329712,
            "z": -272.31817626953125
        },
        {
            "x": 5.00853157043457,
            "y": -1.0645869970321655,
            "z": -272.17352294921875
        },
        {
            "x": 4.94954776763916,
            "y": -1.0521063804626465,
            "z": -272.0290222167969
        },
        {
            "x": 4.890859603881836,
            "y": -1.0393147468566895,
            "z": -271.8843078613281
        },
        {
            "x": 4.832476615905762,
            "y": -1.0262402296066284,
            "z": -271.7395935058594
        },
        {
            "x": 4.774508476257324,
            "y": -1.0129010677337646,
            "z": -271.5948181152344
        },
        {
            "x": 4.716719150543213,
            "y": -0.9992806315422058,
            "z": -271.4497375488281
        },
        {
            "x": 4.659423828125,
            "y": -0.9854333400726318,
            "z": -271.30474853515625
        },
        {
            "x": 4.602342128753662,
            "y": -0.9713210463523865,
            "z": -271.1595458984375
        },
        {
            "x": 4.5456624031066895,
            "y": -0.9569911956787109,
            "z": -271.01434326171875
        },
        {
            "x": 4.489243984222412,
            "y": -0.9424350261688232,
            "z": -270.868896484375
        },
        {
            "x": 4.433265686035156,
            "y": -0.9276877641677856,
            "z": -270.7235107421875
        },
        {
            "x": 4.377490043640137,
            "y": -0.9127076864242554,
            "z": -270.5777587890625
        },
        {
            "x": 4.32219123840332,
            "y": -0.8975745439529419,
            "z": -270.4322204589844
        },
        {
            "x": 4.285483360290527,
            "y": -0.8873801827430725,
            "z": -270.33502197265625
        },
        {
            "x": 4.230703353881836,
            "y": -0.8719502687454224,
            "z": -270.1892395019531
        },
        {
            "x": 4.176331043243408,
            "y": -0.8563631772994995,
            "z": -270.0433044433594
        },
        {
            "x": 4.122188568115234,
            "y": -0.8406130075454712,
            "z": -269.8971252441406
        },
        {
            "x": 4.068538665771484,
            "y": -0.8247479200363159,
            "z": -269.7509765625
        },
        {
            "x": 4.015146255493164,
            "y": -0.8087437152862549,
            "z": -269.6046447753906
        },
        {
            "x": 3.9621851444244385,
            "y": -0.7926288843154907,
            "z": -269.4582824707031
        },
        {
            "x": 3.9094979763031006,
            "y": -0.7764005661010742,
            "z": -269.3116760253906
        },
        {
            "x": 3.8572545051574707,
            "y": -0.7600963711738586,
            "z": -269.1651306152344
        },
        {
            "x": 3.805248498916626,
            "y": -0.7436754107475281,
            "z": -269.0181579589844
        },
        {
            "x": 3.753741502761841,
            "y": -0.7272188663482666,
            "z": -268.87139892578125
        },
        {
            "x": 3.70247483253479,
            "y": -0.7106643915176392,
            "z": -268.7242126464844
        },
        {
            "x": 3.6516988277435303,
            "y": -0.6941009759902954,
            "z": -268.5773010253906
        },
        {
            "x": 3.601179599761963,
            "y": -0.6774610280990601,
            "z": -268.4299621582031
        },
        {
            "x": 3.551083564758301,
            "y": -0.660808801651001,
            "z": -268.28265380859375
        },
        {
            "x": 3.5013480186462402,
            "y": -0.644122838973999,
            "z": -268.1350402832031
        },
        {
            "x": 3.4519741535186768,
            "y": -0.6274441480636597,
            "z": -267.987548828125
        },
        {
            "x": 3.4029977321624756,
            "y": -0.6107590198516846,
            "z": -267.83978271484375
        },
        {
            "x": 3.3543474674224854,
            "y": -0.5940888524055481,
            "z": -267.6919860839844
        },
        {
            "x": 3.30609393119812,
            "y": -0.5774308443069458,
            "z": -267.5439453125
        },
        {
            "x": 3.2581496238708496,
            "y": -0.5608059167861938,
            "z": -267.395751953125
        },
        {
            "x": 3.2107200622558594,
            "y": -0.5442595481872559,
            "z": -267.247802734375
        },
        {
            "x": 3.16352915763855,
            "y": -0.5277284383773804,
            "z": -267.099365234375
        },
        {
            "x": 3.116832733154297,
            "y": -0.5112997889518738,
            "z": -266.95111083984375
        },
        {
            "x": 3.0703978538513184,
            "y": -0.4949067234992981,
            "z": -266.8023376464844
        },
        {
            "x": 3.0243890285491943,
            "y": -0.47862231731414795,
            "z": -266.65374755859375
        },
        {
            "x": 2.9787583351135254,
            "y": -0.4624226689338684,
            "z": -266.5048828125
        },
        {
            "x": 2.9334487915039062,
            "y": -0.44633176922798157,
            "z": -266.3558349609375
        },
        {
            "x": 2.888592481613159,
            "y": -0.43036502599716187,
            "z": -266.2068176269531
        },
        {
            "x": 2.844050645828247,
            "y": -0.4145258069038391,
            "z": -266.0576477050781
        },
        {
            "x": 2.7999043464660645,
            "y": -0.3988097310066223,
            "z": -265.9081726074219
        },
        {
            "x": 2.756117820739746,
            "y": -0.383256196975708,
            "z": -265.75872802734375
        },
        {
            "x": 2.7127726078033447,
            "y": -0.36787518858909607,
            "z": -265.6092529296875
        },
        {
            "x": 2.6697134971618652,
            "y": -0.3526334762573242,
            "z": -265.4593505859375
        },
        {
            "x": 2.627103805541992,
            "y": -0.3376084268093109,
            "z": -265.3097229003906
        },
        {
            "x": 2.5847859382629395,
            "y": -0.32273465394973755,
            "z": -265.1594543457031
        },
        {
            "x": 2.542905330657959,
            "y": -0.3081015348434448,
            "z": -265.009521484375
        },
        {
            "x": 2.5014541149139404,
            "y": -0.2936745882034302,
            "z": -264.859375
        },
        {
            "x": 2.460247039794922,
            "y": -0.27944934368133545,
            "z": -264.70892333984375
        },
        {
            "x": 2.4195609092712402,
            "y": -0.26548877358436584,
            "z": -264.5586242675781
        },
        {
            "x": 2.379101514816284,
            "y": -0.2517426609992981,
            "z": -264.4078369140625
        },
        {
            "x": 2.339125871658325,
            "y": -0.23827821016311646,
            "z": -264.25726318359375
        },
        {
            "x": 2.2994649410247803,
            "y": -0.22505486011505127,
            "z": -264.1063232421875
        },
        {
            "x": 2.2732386589050293,
            "y": -0.2164117842912674,
            "z": -264.00579833984375
        },
        {
            "x": 2.2342920303344727,
            "y": -0.20368137955665588,
            "z": -263.8548583984375
        },
        {
            "x": 2.195603132247925,
            "y": -0.19122186303138733,
            "z": -263.7036437988281
        },
        {
            "x": 2.1573100090026855,
            "y": -0.17907467484474182,
            "z": -263.5523376464844
        },
        {
            "x": 2.11938738822937,
            "y": -0.1672457456588745,
            "z": -263.40087890625
        },
        {
            "x": 2.081873655319214,
            "y": -0.15575847029685974,
            "z": -263.2495422363281
        },
        {
            "x": 2.0447072982788086,
            "y": -0.1445821225643158,
            "z": -263.09771728515625
        },
        {
            "x": 2.007874011993408,
            "y": -0.1337641179561615,
            "z": -262.946044921875
        },
        {
            "x": 1.9714938402175903,
            "y": -0.12331561744213104,
            "z": -262.794189453125
        },
        {
            "x": 1.9353641271591187,
            "y": -0.11321517080068588,
            "z": -262.64202880859375
        },
        {
            "x": 1.8997204303741455,
            "y": -0.10351692885160446,
            "z": -262.4901123046875
        },
        {
            "x": 1.8643757104873657,
            "y": -0.09418141096830368,
            "z": -262.337646484375
        },
        {
            "x": 1.829400658607483,
            "y": -0.08527824282646179,
            "z": -262.1854553222656
        },
        {
            "x": 1.7948397397994995,
            "y": -0.07677839696407318,
            "z": -262.0330810546875
        },
        {
            "x": 1.7605153322219849,
            "y": -0.06868279725313187,
            "z": -261.8802490234375
        },
        {
            "x": 1.726696252822876,
            "y": -0.061037175357341766,
            "z": -261.727783203125
        },
        {
            "x": 1.693138599395752,
            "y": -0.05383366346359253,
            "z": -261.57489013671875
        },
        {
            "x": 1.659984827041626,
            "y": -0.04709457978606224,
            "z": -261.42218017578125
        },
        {
            "x": 1.627217173576355,
            "y": -0.04080962762236595,
            "z": -261.2691955566406
        },
        {
            "x": 1.5947010517120361,
            "y": -0.03499003127217293,
            "z": -261.115966796875
        },
        {
            "x": 1.562695860862732,
            "y": -0.029685283079743385,
            "z": -260.96295166015625
        },
        {
            "x": 1.5309503078460693,
            "y": -0.024866487830877304,
            "z": -260.8096923828125
        },
        {
            "x": 1.4996123313903809,
            "y": -0.02055753767490387,
            "z": -260.6565246582031
        },
        {
            "x": 1.4686055183410645,
            "y": -0.016754690557718277,
            "z": -260.5030517578125
        },
        {
            "x": 1.4379123449325562,
            "y": -0.013497814536094666,
            "z": -260.3494567871094
        },
        {
            "x": 1.4076521396636963,
            "y": -0.010780616663396358,
            "z": -260.1958923339844
        },
        {
            "x": 1.377658724784851,
            "y": -0.008605759590864182,
            "z": -260.04217529296875
        },
        {
            "x": 1.3480571508407593,
            "y": -0.006987496744841337,
            "z": -259.8885192871094
        },
        {
            "x": 1.3188157081604004,
            "y": -0.005955556873232126,
            "z": -259.734619140625
        },
        {
            "x": 1.2898750305175781,
            "y": -0.005505183711647987,
            "z": -259.5807800292969
        },
        {
            "x": 1.2613193988800049,
            "y": -0.005468718707561493,
            "z": -259.42669677734375
        },
        {
            "x": 1.2330557107925415,
            "y": -0.005468461662530899,
            "z": -259.2725830078125
        },
        {
            "x": 1.205185055732727,
            "y": -0.005468197166919708,
            "z": -259.11859130859375
        },
        {
            "x": 1.1776642799377441,
            "y": -0.00546790286898613,
            "z": -258.9643249511719
        },
        {
            "x": 1.150436282157898,
            "y": -0.005467616021633148,
            "z": -258.8100891113281
        },
        {
            "x": 1.1235826015472412,
            "y": -0.005467325448989868,
            "z": -258.6557312011719
        },
        {
            "x": 1.097037672996521,
            "y": -0.0054670460522174835,
            "z": -258.50128173828125
        },
        {
            "x": 1.070863127708435,
            "y": -0.0054667554795742035,
            "z": -258.3470153808594
        },
        {
            "x": 1.0450201034545898,
            "y": -0.005466490983963013,
            "z": -258.1923828125
        },
        {
            "x": 1.019443154335022,
            "y": -0.005466200411319733,
            "z": -258.0378112792969
        },
        {
            "x": 0.9942700862884521,
            "y": -0.0054659247398376465,
            "z": -257.88323974609375
        },
        {
            "x": 0.969377875328064,
            "y": -0.005465596914291382,
            "z": -257.7284240722656
        },
        {
            "x": 0.9448162317276001,
            "y": -0.005465339869260788,
            "z": -257.57379150390625
        },
        {
            "x": 0.9286637306213379,
            "y": -0.005465149879455566,
            "z": -257.4706726074219
        },
        {
            "x": 0.9046415686607361,
            "y": -0.0054648444056510925,
            "z": -257.3157958984375
        },
        {
            "x": 0.8809412717819214,
            "y": -0.0054645836353302,
            "z": -257.16107177734375
        },
        {
            "x": 0.8575804829597473,
            "y": -0.005464281886816025,
            "z": -257.0060119628906
        },
        {
            "x": 0.8344864845275879,
            "y": -0.005463995039463043,
            "z": -256.8509521484375
        },
        {
            "x": 0.8117743730545044,
            "y": -0.005463719367980957,
            "z": -256.6961364746094
        },
        {
            "x": 0.7893543243408203,
            "y": -0.005463436245918274,
            "z": -256.5408935546875
        },
        {
            "x": 0.7671905159950256,
            "y": -0.005463156849145889,
            "z": -256.3857421875
        },
        {
            "x": 0.7454164028167725,
            "y": -0.005462858825922012,
            "z": -256.2306823730469
        },
        {
            "x": 0.7238966226577759,
            "y": -0.005462586879730225,
            "z": -256.07525634765625
        },
        {
            "x": 0.7026806473731995,
            "y": -0.005462314933538437,
            "z": -255.92013549804688
        },
        {
            "x": 0.6818132996559143,
            "y": -0.005462020635604858,
            "z": -255.76475524902344
        },
        {
            "x": 0.6611918210983276,
            "y": -0.0054617151618003845,
            "z": -255.60934448242188
        },
        {
            "x": 0.6409019827842712,
            "y": -0.005461458116769791,
            "z": -255.4540557861328
        },
        {
            "x": 0.620915949344635,
            "y": -0.005461156368255615,
            "z": -255.29843139648438
        },
        {
            "x": 0.6011717915534973,
            "y": -0.005460869520902634,
            "z": -255.1428985595703
        },
        {
            "x": 0.581782341003418,
            "y": -0.005460582673549652,
            "z": -254.98751831054688
        },
        {
            "x": 0.5626798272132874,
            "y": -0.005460314452648163,
            "z": -254.831787109375
        },
        {
            "x": 0.5438202023506165,
            "y": -0.005460001528263092,
            "z": -254.6762237548828
        },
        {
            "x": 0.525297224521637,
            "y": -0.005459759384393692,
            "z": -254.52053833007812
        },
        {
            "x": 0.5070483684539795,
            "y": -0.005459457635879517,
            "z": -254.36473083496094
        },
        {
            "x": 0.4890580475330353,
            "y": -0.005459189414978027,
            "z": -254.20912170410156
        },
        {
            "x": 0.4714193344116211,
            "y": -0.005458895117044449,
            "z": -254.05345153808594
        },
        {
            "x": 0.45400017499923706,
            "y": -0.005458611994981766,
            "z": -253.89756774902344
        },
        {
            "x": 0.436854749917984,
            "y": -0.005458328872919083,
            "z": -253.7418212890625
        },
        {
            "x": 0.4200490117073059,
            "y": -0.0054580457508563995,
            "z": -253.58595275878906
        },
        {
            "x": 0.4034576714038849,
            "y": -0.005457770079374313,
            "z": -253.4300079345703
        },
        {
            "x": 0.3871399462223053,
            "y": -0.005457498133182526,
            "z": -253.2741241455078
        },
        {
            "x": 0.37115567922592163,
            "y": -0.005457185208797455,
            "z": -253.1181640625
        },
        {
            "x": 0.3553687334060669,
            "y": -0.005456894636154175,
            "z": -252.9621124267578
        },
        {
            "x": 0.3398626744747162,
            "y": -0.005456622689962387,
            "z": -252.8060302734375
        },
        {
            "x": 0.3246765434741974,
            "y": -0.005456320941448212,
            "z": -252.6500244140625
        },
        {
            "x": 0.3096749484539032,
            "y": -0.005456048995256424,
            "z": -252.49383544921875
        },
        {
            "x": 0.2949877381324768,
            "y": -0.005455777049064636,
            "z": -252.3378448486328
        },
        {
            "x": 0.28058627247810364,
            "y": -0.005455467849969864,
            "z": -252.1816864013672
        },
        {
            "x": 0.2663523852825165,
            "y": -0.005455199629068375,
            "z": -252.0252685546875
        },
        {
            "x": 0.25244224071502686,
            "y": -0.005454901605844498,
            "z": -251.86924743652344
        },
        {
            "x": 0.23881596326828003,
            "y": -0.00545462965965271,
            "z": -251.71302795410156
        },
        {
            "x": 0.22535893321037292,
            "y": -0.005454357713460922,
            "z": -251.55665588378906
        },
        {
            "x": 0.2122105062007904,
            "y": -0.005454078316688538,
            "z": -251.40057373046875
        },
        {
            "x": 0.1993216872215271,
            "y": -0.005453780293464661,
            "z": -251.24412536621094
        },
        {
            "x": 0.18662050366401672,
            "y": -0.0054534971714019775,
            "z": -251.0877227783203
        },
        {
            "x": 0.17421770095825195,
            "y": -0.005453228950500488,
            "z": -250.93154907226562
        },
        {
            "x": 0.16610047221183777,
            "y": -0.005453038960695267,
            "z": -250.82737731933594
        },
        {
            "x": 0.1540749967098236,
            "y": -0.005452737212181091,
            "z": -250.67091369628906
        },
        {
            "x": 0.1422891914844513,
            "y": -0.005452461540699005,
            "z": -250.51461791992188
        },
        {
            "x": 0.13078641891479492,
            "y": -0.005452197045087814,
            "z": -250.35812377929688
        },
        {
            "x": 0.11948105692863464,
            "y": -0.005451865494251251,
            "z": -250.2015838623047
        },
        {
            "x": 0.1084069311618805,
            "y": -0.005451604723930359,
            "z": -250.04522705078125
        },
        {
            "x": 0.09762164950370789,
            "y": -0.0054513439536094666,
            "z": -249.8887481689453
        },
        {
            "x": 0.08702951669692993,
            "y": -0.005451023578643799,
            "z": -249.73219299316406
        },
        {
            "x": 0.07663735747337341,
            "y": -0.005450721830129623,
            "z": -249.57566833496094
        },
        {
            "x": 0.06654864549636841,
            "y": -0.0054504722356796265,
            "z": -249.41915893554688
        },
        {
            "x": 0.05665960907936096,
            "y": -0.0054501816630363464,
            "z": -249.26254272460938
        },
        {
            "x": 0.046947747468948364,
            "y": -0.005449917167425156,
            "z": -249.10592651367188
        },
        {
            "x": 0.03753012418746948,
            "y": -0.005449619144201279,
            "z": -248.94949340820312
        },
        {
            "x": 0.028333336114883423,
            "y": -0.0054493248462677,
            "z": -248.79283142089844
        },
        {
            "x": 0.01928982138633728,
            "y": -0.005449030548334122,
            "z": -248.63600158691406
        },
        {
            "x": 0.010526180267333984,
            "y": -0.005448751151561737,
            "z": -248.4795379638672
        },
        {
            "x": 0.0019885599613189697,
            "y": -0.00544845312833786,
            "z": -248.32281494140625
        },
        {
            "x": -0.0063893795013427734,
            "y": -0.005448192358016968,
            "z": -248.16607666015625
        },
        {
            "x": -0.01451370120048523,
            "y": -0.005447898060083389,
            "z": -248.00955200195312
        },
        {
            "x": -0.022402793169021606,
            "y": -0.005447611212730408,
            "z": -247.85267639160156
        },
        {
            "x": -0.03013169765472412,
            "y": -0.005447320640087128,
            "z": -247.6959228515625
        },
        {
            "x": -0.03763338923454285,
            "y": -0.005447059869766235,
            "z": -247.53933715820312
        },
        {
            "x": -0.04487554728984833,
            "y": -0.005446791648864746,
            "z": -247.3826904296875
        },
        {
            "x": -0.05195853114128113,
            "y": -0.005446478724479675,
            "z": -247.2258758544922
        },
        {
            "x": -0.05886417627334595,
            "y": -0.005446195602416992,
            "z": -247.069091796875
        },
        {
            "x": -0.06549620628356934,
            "y": -0.005445931106805801,
            "z": -246.91236877441406
        },
        {
            "x": -0.07194091379642487,
            "y": -0.005445618182420731,
            "z": -246.75552368164062
        },
        {
            "x": -0.07823865115642548,
            "y": -0.005445361137390137,
            "z": -246.5986785888672
        },
        {
            "x": -0.08428619801998138,
            "y": -0.005445078015327454,
            "z": -246.4420166015625
        },
        {
            "x": -0.0901091992855072,
            "y": -0.0054447948932647705,
            "z": -246.2852020263672
        },
        {
            "x": -0.09580370783805847,
            "y": -0.005444489419460297,
            "z": -246.12815856933594
        },
        {
            "x": -0.10127660632133484,
            "y": -0.005444210022687912,
            "z": -245.97145080566406
        },
        {
            "x": -0.10651406645774841,
            "y": -0.0054439157247543335,
            "z": -245.8146209716797
        },
        {
            "x": -0.11159943044185638,
            "y": -0.00544363260269165,
            "z": -245.6576385498047
        },
        {
            "x": -0.11650960147380829,
            "y": -0.005443386733531952,
            "z": -245.50086975097656
        },
        {
            "x": -0.12118363380432129,
            "y": -0.005443103611469269,
            "z": -245.3439178466797
        },
        {
            "x": -0.12567274272441864,
            "y": -0.005442801862955093,
            "z": -245.18698120117188
        },
        {
            "x": -0.13002105057239532,
            "y": -0.005442533642053604,
            "z": -245.0301513671875
        },
        {
            "x": -0.13414835929870605,
            "y": -0.005442231893539429,
            "z": -244.873291015625
        },
        {
            "x": -0.13805998861789703,
            "y": -0.005441941320896149,
            "z": -244.7163848876953
        },
        {
            "x": -0.14184466004371643,
            "y": -0.005441676825284958,
            "z": -244.55934143066406
        },
        {
            "x": -0.14544615149497986,
            "y": -0.005441393703222275,
            "z": -244.40245056152344
        },
        {
            "x": -0.14881177246570587,
            "y": -0.0054410845041275024,
            "z": -244.24566650390625
        },
        {
            "x": -0.15096403658390045,
            "y": -0.005440901964902878,
            "z": -244.14100646972656
        },
        {
            "x": -0.15408873558044434,
            "y": -0.005440622568130493,
            "z": -243.9840850830078
        },
        {
            "x": -0.15702036023139954,
            "y": -0.005440331995487213,
            "z": -243.8272705078125
        },
        {
            "x": -0.159735307097435,
            "y": -0.005440056324005127,
            "z": -243.6702117919922
        },
        {
            "x": -0.1623058021068573,
            "y": -0.005439788103103638,
            "z": -243.51321411132812
        },
        {
            "x": -0.16473212838172913,
            "y": -0.005439486354589462,
            "z": -243.35629272460938
        },
        {
            "x": -0.1669413447380066,
            "y": -0.005439210683107376,
            "z": -243.19937133789062
        },
        {
            "x": -0.16896691918373108,
            "y": -0.0054389312863349915,
            "z": -243.0424041748047
        },
        {
            "x": -0.17087742686271667,
            "y": -0.005438629537820816,
            "z": -242.8852996826172
        },
        {
            "x": -0.17260929942131042,
            "y": -0.005438350141048431,
            "z": -242.72833251953125
        },
        {
            "x": -0.17413577437400818,
            "y": -0.005438078194856644,
            "z": -242.5714111328125
        },
        {
            "x": -0.17553412914276123,
            "y": -0.005437780171632767,
            "z": -242.4142303466797
        },
        {
            "x": -0.17680679261684418,
            "y": -0.005437478423118591,
            "z": -242.25729370117188
        },
        {
            "x": -0.17790910601615906,
            "y": -0.005437210202217102,
            "z": -242.10032653808594
        },
        {
            "x": -0.17889516055583954,
            "y": -0.005436919629573822,
            "z": -241.9430389404297
        },
        {
            "x": -0.1798129677772522,
            "y": -0.005436636507511139,
            "z": -241.7859649658203
        },
        {
            "x": -0.18062998354434967,
            "y": -0.00543634220957756,
            "z": -241.62879943847656
        },
        {
            "x": -0.18141210079193115,
            "y": -0.005436055362224579,
            "z": -241.47149658203125
        },
        {
            "x": -0.18225312232971191,
            "y": -0.005435783416032791,
            "z": -241.3141632080078
        },
        {
            "x": -0.1831223964691162,
            "y": -0.005435489118099213,
            "z": -241.1566925048828
        },
        {
            "x": -0.18405403196811676,
            "y": -0.005435220897197723,
            "z": -240.99925231933594
        },
        {
            "x": -0.1851705014705658,
            "y": -0.005434926599264145,
            "z": -240.8416748046875
        },
        {
            "x": -0.1864694058895111,
            "y": -0.005434662103652954,
            "z": -240.68417358398438
        },
        {
            "x": -0.18791340291500092,
            "y": -0.005434367805719376,
            "z": -240.52658081054688
        },
        {
            "x": -0.18961599469184875,
            "y": -0.005434088408946991,
            "z": -240.36874389648438
        },
        {
            "x": -0.19159920513629913,
            "y": -0.005433797836303711,
            "z": -240.21104431152344
        },
        {
            "x": -0.19376841187477112,
            "y": -0.005433518439531326,
            "z": -240.05349731445312
        },
        {
            "x": -0.19618597626686096,
            "y": -0.005420805886387825,
            "z": -239.8956298828125
        },
        {
            "x": -0.1989346742630005,
            "y": -0.005238862708210945,
            "z": -239.73788452148438
        },
        {
            "x": -0.2019323706626892,
            "y": -0.00480343122035265,
            "z": -239.58035278320312
        },
        {
            "x": -0.20513255894184113,
            "y": -0.004115592688322067,
            "z": -239.4225311279297
        },
        {
            "x": -0.2086487114429474,
            "y": -0.0031860112212598324,
            "z": -239.2647247314453
        },
        {
            "x": -0.21248501539230347,
            "y": -0.0020186228211969137,
            "z": -239.10699462890625
        },
        {
            "x": -0.2165198028087616,
            "y": -0.0006124090868979692,
            "z": -238.94943237304688
        },
        {
            "x": -0.22081239521503448,
            "y": 0.0010334332473576069,
            "z": -238.791748046875
        },
        {
            "x": -0.2254628837108612,
            "y": 0.002910749986767769,
            "z": -238.6337890625
        },
        {
            "x": -0.23036429286003113,
            "y": 0.005007544998079538,
            "z": -238.47628784179688
        },
        {
            "x": -0.2354649007320404,
            "y": 0.007331028580665588,
            "z": -238.31875610351562
        },
        {
            "x": -0.24090439081192017,
            "y": 0.009884800761938095,
            "z": -238.16085815429688
        },
        {
            "x": -0.24666380882263184,
            "y": 0.012648544274270535,
            "z": -238.0032958984375
        },
        {
            "x": -0.2526279091835022,
            "y": 0.015623648650944233,
            "z": -237.8457794189453
        },
        {
            "x": -0.2588558495044708,
            "y": 0.018815316259860992,
            "z": -237.68800354003906
        },
        {
            "x": -0.2654477655887604,
            "y": 0.02221636101603508,
            "z": -237.53036499023438
        },
        {
            "x": -0.26999062299728394,
            "y": 0.024590570479631424,
            "z": -237.4254608154297
        },
        {
            "x": -0.2769610285758972,
            "y": 0.02832094021141529,
            "z": -237.26803588867188
        },
        {
            "x": -0.28423938155174255,
            "y": 0.03225964307785034,
            "z": -237.1103973388672
        },
        {
            "x": -0.29187750816345215,
            "y": 0.036394067108631134,
            "z": -236.95269775390625
        },
        {
            "x": -0.29972970485687256,
            "y": 0.04070741683244705,
            "z": -236.79537963867188
        },
        {
            "x": -0.3078232705593109,
            "y": 0.04521406814455986,
            "z": -236.6378631591797
        },
        {
            "x": -0.31629690527915955,
            "y": 0.04991631582379341,
            "z": -236.48019409179688
        },
        {
            "x": -0.3250434994697571,
            "y": 0.05478660389780998,
            "z": -236.32290649414062
        },
        {
            "x": -0.33399856090545654,
            "y": 0.05983751639723778,
            "z": -236.1654815673828
        },
        {
            "x": -0.3432910442352295,
            "y": 0.06506997346878052,
            "z": -236.00784301757812
        },
        {
            "x": -0.352922260761261,
            "y": 0.07046855986118317,
            "z": -235.85055541992188
        },
        {
            "x": -0.36276599764823914,
            "y": 0.07603395730257034,
            "z": -235.69322204589844
        },
        {
            "x": -0.372888445854187,
            "y": 0.08176523447036743,
            "z": -235.5358123779297
        },
        {
            "x": -0.38337939977645874,
            "y": 0.08765532076358795,
            "z": -235.3784637451172
        },
        {
            "x": -0.3941313624382019,
            "y": 0.09370678663253784,
            "z": -235.22117614746094
        },
        {
            "x": -0.4051126539707184,
            "y": 0.09990952163934708,
            "z": -235.0639190673828
        },
        {
            "x": -0.41646313667297363,
            "y": 0.10626696795225143,
            "z": -234.9065704345703
        },
        {
            "x": -0.42810380458831787,
            "y": 0.1127612441778183,
            "z": -234.7494354248047
        },
        {
            "x": -0.439960241317749,
            "y": 0.1194038987159729,
            "z": -234.59234619140625
        },
        {
            "x": -0.4521831274032593,
            "y": 0.12620186805725098,
            "z": -234.43487548828125
        },
        {
            "x": -0.4647179841995239,
            "y": 0.13311845064163208,
            "z": -234.27784729003906
        },
        {
            "x": -0.47745686769485474,
            "y": 0.14016315340995789,
            "z": -234.12091064453125
        },
        {
            "x": -0.49052613973617554,
            "y": 0.14735379815101624,
            "z": -233.96376037597656
        },
        {
            "x": -0.5039559602737427,
            "y": 0.1546650379896164,
            "z": -233.80673217773438
        },
        {
            "x": -0.517619252204895,
            "y": 0.16209498047828674,
            "z": -233.64979553222656
        },
        {
            "x": -0.5315525531768799,
            "y": 0.1696520745754242,
            "z": -233.49270629882812
        },
        {
            "x": -0.5458717346191406,
            "y": 0.1773260235786438,
            "z": -233.33570861816406
        },
        {
            "x": -0.5604519844055176,
            "y": 0.1851067841053009,
            "z": -233.17889404296875
        },
        {
            "x": -0.5752658843994141,
            "y": 0.19299614429473877,
            "z": -233.0220489501953
        },
        {
            "x": -0.5904593467712402,
            "y": 0.20099669694900513,
            "z": -232.8651123046875
        },
        {
            "x": -0.6059665679931641,
            "y": 0.209101140499115,
            "z": -232.70826721191406
        },
        {
            "x": -0.6216786503791809,
            "y": 0.21729695796966553,
            "z": -232.5515594482422
        },
        {
            "x": -0.6377688646316528,
            "y": 0.22560033202171326,
            "z": -232.3946533203125
        },
        {
            "x": -0.654169499874115,
            "y": 0.23398339748382568,
            "z": -232.23802185058594
        },
        {
            "x": -0.6707830429077148,
            "y": 0.24245336651802063,
            "z": -232.08148193359375
        },
        {
            "x": -0.6877831220626831,
            "y": 0.25103262066841125,
            "z": -231.92449951171875
        },
        {
            "x": -0.7050881385803223,
            "y": 0.2596704959869385,
            "z": -231.7680206298828
        },
        {
            "x": -0.7226027250289917,
            "y": 0.26838141679763794,
            "z": -231.61163330078125
        },
        {
            "x": -0.740480899810791,
            "y": 0.27719026803970337,
            "z": -231.45486450195312
        },
        {
            "x": -0.7587038278579712,
            "y": 0.2860557436943054,
            "z": -231.2984619140625
        },
        {
            "x": -0.7771496176719666,
            "y": 0.2949868440628052,
            "z": -231.14210510253906
        },
        {
            "x": -0.7959208488464355,
            "y": 0.3039970397949219,
            "z": -230.9854736328125
        },
        {
            "x": -0.815048336982727,
            "y": 0.31305640935897827,
            "z": -230.8291778564453
        },
        {
            "x": -0.8279253244400024,
            "y": 0.319122314453125,
            "z": -230.72509765625
        },
        {
            "x": -0.8474573493003845,
            "y": 0.32827475666999817,
            "z": -230.56883239746094
        },
        {
            "x": -0.8673839569091797,
            "y": 0.3374861776828766,
            "z": -230.41250610351562
        },
        {
            "x": -0.8876100778579712,
            "y": 0.3467443585395813,
            "z": -230.25625610351562
        },
        {
            "x": -0.9080550074577332,
            "y": 0.3560415208339691,
            "z": -230.1001434326172
        },
        {
            "x": -0.9288842082023621,
            "y": 0.36538705229759216,
            "z": -229.94393920898438
        },
        {
            "x": -0.9500153064727783,
            "y": 0.3747653365135193,
            "z": -229.7878875732422
        },
        {
            "x": -0.9713711738586426,
            "y": 0.38417619466781616,
            "z": -229.63189697265625
        },
        {
            "x": -0.9931237697601318,
            "y": 0.3936317563056946,
            "z": -229.47573852539062
        },
        {
            "x": -1.0151607990264893,
            "y": 0.4031023383140564,
            "z": -229.31982421875
        },
        {
            "x": -1.0374199151992798,
            "y": 0.41259488463401794,
            "z": -229.16397094726562
        },
        {
            "x": -1.0600906610488892,
            "y": 0.42212432622909546,
            "z": -229.00791931152344
        },
        {
            "x": -1.083022117614746,
            "y": 0.43164974451065063,
            "z": -228.85227966308594
        },
        {
            "x": -1.1061934232711792,
            "y": 0.44119423627853394,
            "z": -228.69654846191406
        },
        {
            "x": -1.1297835111618042,
            "y": 0.45077016949653625,
            "z": -228.54054260253906
        },
        {
            "x": -1.153620958328247,
            "y": 0.4603252410888672,
            "z": -228.38504028320312
        },
        {
            "x": -1.1777162551879883,
            "y": 0.4698944091796875,
            "z": -228.22940063476562
        },
        {
            "x": -1.2021887302398682,
            "y": 0.4794691801071167,
            "z": -228.07369995117188
        },
        {
            "x": -1.2269134521484375,
            "y": 0.4890235364437103,
            "z": -227.9183349609375
        },
        {
            "x": -1.2519466876983643,
            "y": 0.49859195947647095,
            "z": -227.76268005371094
        },
        {
            "x": -1.2773222923278809,
            "y": 0.5081405639648438,
            "z": -227.60720825195312
        },
        {
            "x": -1.3029499053955078,
            "y": 0.5176628232002258,
            "z": -227.45199584960938
        },
        {
            "x": -1.3288429975509644,
            "y": 0.5271773934364319,
            "z": -227.296630859375
        },
        {
            "x": -1.3551263809204102,
            "y": 0.5366723537445068,
            "z": -227.14132690429688
        },
        {
            "x": -1.3816598653793335,
            "y": 0.5461360812187195,
            "z": -226.98617553710938
        },
        {
            "x": -1.4084792137145996,
            "y": 0.5555839538574219,
            "z": -226.83087158203125
        },
        {
            "x": -1.435651183128357,
            "y": 0.5649933815002441,
            "z": -226.67575073242188
        },
        {
            "x": -1.4630717039108276,
            "y": 0.5743628740310669,
            "z": -226.52072143554688
        },
        {
            "x": -1.490778923034668,
            "y": 0.5837002992630005,
            "z": -226.3656463623047
        },
        {
            "x": -1.5188344717025757,
            "y": 0.5929914712905884,
            "z": -226.210693359375
        },
        {
            "x": -1.5471385717391968,
            "y": 0.6022407412528992,
            "z": -226.05575561523438
        },
        {
            "x": -1.5757474899291992,
            "y": 0.611443042755127,
            "z": -225.90078735351562
        },
        {
            "x": -1.6047022342681885,
            "y": 0.6205883026123047,
            "z": -225.7459716796875
        },
        {
            "x": -1.633859395980835,
            "y": 0.6296716332435608,
            "z": -225.59129333496094
        },
        {
            "x": -1.6633579730987549,
            "y": 0.6387063264846802,
            "z": -225.43649291992188
        },
        {
            "x": -1.6932011842727661,
            "y": 0.6476779580116272,
            "z": -225.28175354003906
        },
        {
            "x": -1.7232218980789185,
            "y": 0.6565709114074707,
            "z": -225.12722778320312
        },
        {
            "x": -1.7536087036132812,
            "y": 0.6654036045074463,
            "z": -224.97262573242188
        },
        {
            "x": -1.7842731475830078,
            "y": 0.6741578578948975,
            "z": -224.81817626953125
        },
        {
            "x": -1.8151683807373047,
            "y": 0.6828339099884033,
            "z": -224.66375732421875
        },
        {
            "x": -1.846442699432373,
            "y": 0.6914377808570862,
            "z": -224.5092315673828
        },
        {
            "x": -1.8779475688934326,
            "y": 0.699947714805603,
            "z": -224.35496520996094
        },
        {
            "x": -1.9097061157226562,
            "y": 0.7083752155303955,
            "z": -224.2006378173828
        },
        {
            "x": -1.9310846328735352,
            "y": 0.7139416933059692,
            "z": -224.09779357910156
        },
        {
            "x": -1.9633275270462036,
            "y": 0.7222037315368652,
            "z": -223.9438018798828
        },
        {
            "x": -1.9958291053771973,
            "y": 0.7303779125213623,
            "z": -223.78964233398438
        },
        {
            "x": -2.028729200363159,
            "y": 0.7384635210037231,
            "z": -223.6353759765625
        },
        {
            "x": -2.0617899894714355,
            "y": 0.7464215159416199,
            "z": -223.48153686523438
        },
        {
            "x": -2.095140218734741,
            "y": 0.7542822360992432,
            "z": -223.3275604248047
        },
        {
            "x": -2.128833532333374,
            "y": 0.7620370984077454,
            "z": -223.17359924316406
        },
        {
            "x": -2.162696599960327,
            "y": 0.7696658372879028,
            "z": -223.01986694335938
        },
        {
            "x": -2.1969151496887207,
            "y": 0.7771866917610168,
            "z": -222.86593627929688
        },
        {
            "x": -2.2314083576202393,
            "y": 0.7845807075500488,
            "z": -222.71221923828125
        },
        {
            "x": -2.266080379486084,
            "y": 0.791846513748169,
            "z": -222.55862426757812
        },
        {
            "x": -2.3011138439178467,
            "y": 0.7989940047264099,
            "z": -222.40487670898438
        },
        {
            "x": -2.336354970932007,
            "y": 0.8059933185577393,
            "z": -222.25144958496094
        },
        {
            "x": -2.3718490600585938,
            "y": 0.8128638863563538,
            "z": -222.097900390625
        },
        {
            "x": -2.4076967239379883,
            "y": 0.819603443145752,
            "z": -221.9443359375
        },
        {
            "x": -2.44368052482605,
            "y": 0.8261876106262207,
            "z": -221.7910919189453
        },
        {
            "x": -2.4799821376800537,
            "y": 0.8326296806335449,
            "z": -221.6376495361328
        },
        {
            "x": -2.5165493488311768,
            "y": 0.8389184474945068,
            "z": -221.48443603515625
        },
        {
            "x": -2.5533030033111572,
            "y": 0.845054566860199,
            "z": -221.3312530517578
        },
        {
            "x": -2.5904171466827393,
            "y": 0.8510462045669556,
            "z": -221.17788696289062
        },
        {
            "x": -2.627690553665161,
            "y": 0.8568567037582397,
            "z": -221.02496337890625
        },
        {
            "x": -2.665215253829956,
            "y": 0.8625108003616333,
            "z": -220.8719024658203
        },
        {
            "x": -2.703016996383667,
            "y": 0.8679971694946289,
            "z": -220.71897888183594
        },
        {
            "x": -2.740988254547119,
            "y": 0.8733102083206177,
            "z": -220.56617736816406
        },
        {
            "x": -2.7792768478393555,
            "y": 0.8784513473510742,
            "z": -220.4132080078125
        },
        {
            "x": -2.817807197570801,
            "y": 0.8834121823310852,
            "z": -220.26036071777344
        },
        {
            "x": -2.85649037361145,
            "y": 0.8881896138191223,
            "z": -220.10768127441406
        },
        {
            "x": -2.8954920768737793,
            "y": 0.8927901983261108,
            "z": -219.95486450195312
        },
        {
            "x": -2.9346580505371094,
            "y": 0.8971883654594421,
            "z": -219.80235290527344
        },
        {
            "x": -2.9740540981292725,
            "y": 0.9013983011245728,
            "z": -219.6497802734375
        },
        {
            "x": -3.0137617588043213,
            "y": 0.9054189920425415,
            "z": -219.49710083007812
        },
        {
            "x": -3.0535695552825928,
            "y": 0.909234881401062,
            "z": -219.3447265625
        },
        {
            "x": -3.0936765670776367,
            "y": 0.9128462076187134,
            "z": -219.19224548339844
        },
        {
            "x": -3.133962869644165,
            "y": 0.9162480235099792,
            "z": -219.03997802734375
        },
        {
            "x": -3.174443483352661,
            "y": 0.9194432497024536,
            "z": -218.8876495361328
        },
        {
            "x": -3.215228319168091,
            "y": 0.9224308729171753,
            "z": -218.73524475097656
        },
        {
            "x": -3.2560935020446777,
            "y": 0.9251888990402222,
            "z": -218.5832061767578
        },
        {
            "x": -3.2972230911254883,
            "y": 0.9277296662330627,
            "z": -218.43101501464844
        },
        {
            "x": -3.338545560836792,
            "y": 0.9300470352172852,
            "z": -218.2789764404297
        },
        {
            "x": -3.3800137042999268,
            "y": 0.9321392774581909,
            "z": -218.1269989013672
        },
        {
            "x": -3.4217588901519775,
            "y": 0.9339958429336548,
            "z": -217.9749298095703
        },
        {
            "x": -3.4636456966400146,
            "y": 0.9356156587600708,
            "z": -217.82305908203125
        },
        {
            "x": -3.505721092224121,
            "y": 0.937000036239624,
            "z": -217.6711883544922
        },
        {
            "x": -3.5338809490203857,
            "y": 0.9377895593643188,
            "z": -217.5700225830078
        },
        {
            "x": -3.5762195587158203,
            "y": 0.9387643933296204,
            "z": -217.41835021972656
        },
        {
            "x": -3.618772029876709,
            "y": 0.9394951462745667,
            "z": -217.2666473388672
        },
        {
            "x": -3.6615500450134277,
            "y": 0.9399775862693787,
            "z": -217.11488342285156
        },
        {
            "x": -3.7044050693511963,
            "y": 0.9401991367340088,
            "z": -216.96334838867188
        },
        {
            "x": -3.747473955154419,
            "y": 0.9401614665985107,
            "z": -216.8118438720703
        },
        {
            "x": -3.790693998336792,
            "y": 0.939869225025177,
            "z": -216.6603240966797
        },
        {
            "x": -3.8340682983398438,
            "y": 0.9393259286880493,
            "z": -216.50885009765625
        },
        {
            "x": -3.8776259422302246,
            "y": 0.9385275840759277,
            "z": -216.35748291015625
        },
        {
            "x": -3.921313762664795,
            "y": 0.9374802112579346,
            "z": -216.20608520507812
        },
        {
            "x": -3.9651553630828857,
            "y": 0.9361929893493652,
            "z": -216.0548095703125
        },
        {
            "x": -4.009124279022217,
            "y": 0.9346681833267212,
            "z": -215.903564453125
        },
        {
            "x": -4.0532307624816895,
            "y": 0.9329035878181458,
            "z": -215.7523651123047
        },
        {
            "x": -4.097466468811035,
            "y": 0.9309051036834717,
            "z": -215.60133361816406
        },
        {
            "x": -4.14186954498291,
            "y": 0.9286768436431885,
            "z": -215.4500732421875
        },
        {
            "x": -4.18638277053833,
            "y": 0.9262279868125916,
            "z": -215.29904174804688
        },
        {
            "x": -4.230992317199707,
            "y": 0.9235541820526123,
            "z": -215.14808654785156
        },
        {
            "x": -4.275737762451172,
            "y": 0.9206584095954895,
            "z": -214.99710083007812
        },
        {
            "x": -4.3205695152282715,
            "y": 0.9175525903701782,
            "z": -214.84628295898438
        },
        {
            "x": -4.365564823150635,
            "y": 0.9142321348190308,
            "z": -214.69525146484375
        },
        {
            "x": -4.410639762878418,
            "y": 0.9107058644294739,
            "z": -214.54446411132812
        },
        {
            "x": -4.455780982971191,
            "y": 0.9069738984107971,
            "z": -214.39376831054688
        },
        {
            "x": -4.501042366027832,
            "y": 0.9030416011810303,
            "z": -214.24301147460938
        },
        {
            "x": -4.546382904052734,
            "y": 0.8989166617393494,
            "z": -214.09242248535156
        },
        {
            "x": -4.591836452484131,
            "y": 0.8945925235748291,
            "z": -213.94171142578125
        },
        {
            "x": -4.637392520904541,
            "y": 0.8900747299194336,
            "z": -213.791015625
        },
        {
            "x": -4.682971477508545,
            "y": 0.885377049446106,
            "z": -213.64051818847656
        },
        {
            "x": -4.728669166564941,
            "y": 0.8804937601089478,
            "z": -213.48988342285156
        },
        {
            "x": -4.774415016174316,
            "y": 0.8754332065582275,
            "z": -213.3394317626953
        },
        {
            "x": -4.820209980010986,
            "y": 0.8701943159103394,
            "z": -213.18899536132812
        },
        {
            "x": -4.86613130569458,
            "y": 0.8647787570953369,
            "z": -213.03843688964844
        },
        {
            "x": -4.912034511566162,
            "y": 0.8592026233673096,
            "z": -212.88804626464844
        },
        {
            "x": -4.95802640914917,
            "y": 0.8534576296806335,
            "z": -212.73764038085938
        },
        {
            "x": -5.0040507316589355,
            "y": 0.847549557685852,
            "z": -212.58729553222656
        },
        {
            "x": -5.05009126663208,
            "y": 0.8414862155914307,
            "z": -212.43699645996094
        },
        {
            "x": -5.096238613128662,
            "y": 0.8352625370025635,
            "z": -212.28656005859375
        },
        {
            "x": -5.142356872558594,
            "y": 0.8288946747779846,
            "z": -212.1363067626953
        },
        {
            "x": -5.18850564956665,
            "y": 0.8223771452903748,
            "z": -211.9861297607422
        },
        {
            "x": -5.2346930503845215,
            "y": 0.8157127499580383,
            "z": -211.8358154296875
        },
        {
            "x": -5.280880451202393,
            "y": 0.8089134693145752,
            "z": -211.6856689453125
        },
        {
            "x": -5.327106952667236,
            "y": 0.8019733428955078,
            "z": -211.53541564941406
        },
        {
            "x": -5.373342990875244,
            "y": 0.7948955297470093,
            "z": -211.3851776123047
        },
        {
            "x": -5.419543743133545,
            "y": 0.7876945734024048,
            "z": -211.2350616455078
        },
        {
            "x": -5.450350284576416,
            "y": 0.7828266024589539,
            "z": -211.13497924804688
        },
        {
            "x": -5.496545314788818,
            "y": 0.7754155397415161,
            "z": -210.98489379882812
        },
        {
            "x": -5.542724609375,
            "y": 0.7678858041763306,
            "z": -210.83482360839844
        },
        {
            "x": -5.588953971862793,
            "y": 0.7602304220199585,
            "z": -210.68455505371094
        },
        {
            "x": -5.635095596313477,
            "y": 0.7524741291999817,
            "z": -210.53451538085938
        },
        {
            "x": -5.681224346160889,
            "y": 0.7446013689041138,
            "z": -210.38441467285156
        },
        {
            "x": -5.727340221405029,
            "y": 0.7366196513175964,
            "z": -210.23426818847656
        },
        {
            "x": -5.773397445678711,
            "y": 0.7285404205322266,
            "z": -210.0841827392578
        },
        {
            "x": -5.819451808929443,
            "y": 0.7203572988510132,
            "z": -209.9340362548828
        },
        {
            "x": -5.8654279708862305,
            "y": 0.7120779752731323,
            "z": -209.78392028808594
        },
        {
            "x": -5.911347389221191,
            "y": 0.7037093639373779,
            "z": -209.6338348388672
        },
        {
            "x": -5.957241535186768,
            "y": 0.6952483654022217,
            "z": -209.48365783691406
        },
        {
            "x": -6.00303316116333,
            "y": 0.6867082118988037,
            "z": -209.33355712890625
        },
        {
            "x": -6.048768043518066,
            "y": 0.678085446357727,
            "z": -209.1835174560547
        },
        {
            "x": -6.094470024108887,
            "y": 0.6693731546401978,
            "z": -209.0332489013672
        },
        {
            "x": -6.140054702758789,
            "y": 0.6605966091156006,
            "z": -208.88314819335938
        },
        {
            "x": -6.185558319091797,
            "y": 0.6517490148544312,
            "z": -208.73301696777344
        },
        {
            "x": -6.230983257293701,
            "y": 0.6428288221359253,
            "z": -208.5828094482422
        },
        {
            "x": -6.276300430297852,
            "y": 0.633849024772644,
            "z": -208.43267822265625
        },
        {
            "x": -6.321572780609131,
            "y": 0.624796986579895,
            "z": -208.28231811523438
        },
        {
            "x": -6.366705417633057,
            "y": 0.6156999468803406,
            "z": -208.13214111328125
        },
        {
            "x": -6.411710739135742,
            "y": 0.6065484285354614,
            "z": -207.98194885253906
        },
        {
            "x": -6.456623077392578,
            "y": 0.5973456501960754,
            "z": -207.83172607421875
        },
        {
            "x": -6.501375675201416,
            "y": 0.5881012678146362,
            "z": -207.68153381347656
        },
        {
            "x": -6.546065807342529,
            "y": 0.5788014531135559,
            "z": -207.53115844726562
        },
        {
            "x": -6.590621471405029,
            "y": 0.5694646239280701,
            "z": -207.38076782226562
        },
        {
            "x": -6.634997844696045,
            "y": 0.5600956678390503,
            "z": -207.2304229736328
        },
        {
            "x": -6.679293155670166,
            "y": 0.5506871938705444,
            "z": -207.07998657226562
        },
        {
            "x": -6.723370552062988,
            "y": 0.5412591695785522,
            "z": -206.92962646484375
        },
        {
            "x": -6.767338275909424,
            "y": 0.5318000316619873,
            "z": -206.77915954589844
        },
        {
            "x": -6.811182975769043,
            "y": 0.5223110914230347,
            "z": -206.6285400390625
        },
        {
            "x": -6.854817867279053,
            "y": 0.5128108263015747,
            "z": -206.47802734375
        },
        {
            "x": -6.898317337036133,
            "y": 0.5032956600189209,
            "z": -206.3274383544922
        },
        {
            "x": -6.94162130355835,
            "y": 0.4937663674354553,
            "z": -206.17678833007812
        },
        {
            "x": -6.984767436981201,
            "y": 0.4842313528060913,
            "z": -206.0261688232422
        },
        {
            "x": -7.027745246887207,
            "y": 0.4746834933757782,
            "z": -205.87538146972656
        },
        {
            "x": -7.070527076721191,
            "y": 0.4651394784450531,
            "z": -205.72462463378906
        },
        {
            "x": -7.113090515136719,
            "y": 0.4556041359901428,
            "z": -205.57391357421875
        },
        {
            "x": -7.155489921569824,
            "y": 0.44606131315231323,
            "z": -205.42294311523438
        },
        {
            "x": -7.197684288024902,
            "y": 0.4365377426147461,
            "z": -205.27210998535156
        },
        {
            "x": -7.239655494689941,
            "y": 0.42702168226242065,
            "z": -205.12115478515625
        },
        {
            "x": -7.281474590301514,
            "y": 0.417516827583313,
            "z": -204.97007751464844
        },
        {
            "x": -7.322987079620361,
            "y": 0.40804529190063477,
            "z": -204.8191375732422
        },
        {
            "x": -7.350561618804932,
            "y": 0.4017365574836731,
            "z": -204.71839904785156
        },
        {
            "x": -7.391761779785156,
            "y": 0.3922995626926422,
            "z": -204.56732177734375
        },
        {
            "x": -7.4326629638671875,
            "y": 0.38289570808410645,
            "z": -204.4162139892578
        },
        {
            "x": -7.473453521728516,
            "y": 0.3735029101371765,
            "z": -204.2647247314453
        },
        {
            "x": -7.51391077041626,
            "y": 0.36416783928871155,
            "z": -204.11355590820312
        },
        {
            "x": -7.554145336151123,
            "y": 0.3548624515533447,
            "z": -203.96217346191406
        },
        {
            "x": -7.5941619873046875,
            "y": 0.34560060501098633,
            "z": -203.8107147216797
        },
        {
            "x": -7.633872032165527,
            "y": 0.33638763427734375,
            "z": -203.65924072265625
        },
        {
            "x": -7.673402309417725,
            "y": 0.3272167444229126,
            "z": -203.50759887695312
        },
        {
            "x": -7.712601184844971,
            "y": 0.31810563802719116,
            "z": -203.3560028076172
        },
        {
            "x": -7.751554489135742,
            "y": 0.30904749035835266,
            "z": -203.2042694091797
        },
        {
            "x": -7.790246486663818,
            "y": 0.30005115270614624,
            "z": -203.05250549316406
        },
        {
            "x": -7.828637599945068,
            "y": 0.29111742973327637,
            "z": -202.90066528320312
        },
        {
            "x": -7.866795539855957,
            "y": 0.2822530269622803,
            "z": -202.7488250732422
        },
        {
            "x": -7.904636383056641,
            "y": 0.27345287799835205,
            "z": -202.59677124023438
        },
        {
            "x": -7.9422101974487305,
            "y": 0.2647296190261841,
            "z": -202.44471740722656
        },
        {
            "x": -7.979461669921875,
            "y": 0.256089985370636,
            "z": -202.2926788330078
        },
        {
            "x": -8.016433715820312,
            "y": 0.2475212812423706,
            "z": -202.14044189453125
        },
        {
            "x": -8.053101539611816,
            "y": 0.2390478551387787,
            "z": -201.98829650878906
        },
        {
            "x": -8.089455604553223,
            "y": 0.23064947128295898,
            "z": -201.83583068847656
        },
        {
            "x": -8.125534057617188,
            "y": 0.22234857082366943,
            "z": -201.6834259033203
        },
        {
            "x": -8.161226272583008,
            "y": 0.214150071144104,
            "z": -201.53111267089844
        },
        {
            "x": -8.196648597717285,
            "y": 0.20603927969932556,
            "z": -201.3784942626953
        },
        {
            "x": -8.231724739074707,
            "y": 0.19804200530052185,
            "z": -201.2260284423828
        },
        {
            "x": -8.266477584838867,
            "y": 0.19013722240924835,
            "z": -201.0732421875
        },
        {
            "x": -8.300970077514648,
            "y": 0.18234017491340637,
            "z": -200.92042541503906
        },
        {
            "x": -8.335013389587402,
            "y": 0.17466691136360168,
            "z": -200.7677001953125
        },
        {
            "x": -8.368819236755371,
            "y": 0.16709676384925842,
            "z": -200.61465454101562
        },
        {
            "x": -8.40221881866455,
            "y": 0.15965865552425385,
            "z": -200.46177673339844
        },
        {
            "x": -8.435279846191406,
            "y": 0.15233325958251953,
            "z": -200.30868530273438
        },
        {
            "x": -8.468063354492188,
            "y": 0.14513099193572998,
            "z": -200.15545654296875
        },
        {
            "x": -8.50037956237793,
            "y": 0.1380690038204193,
            "z": -200.00230407714844
        },
        {
            "x": -8.532437324523926,
            "y": 0.13113000988960266,
            "z": -199.84889221191406
        },
        {
            "x": -8.56407642364502,
            "y": 0.12433505803346634,
            "z": -199.69564819335938
        },
        {
            "x": -8.595366477966309,
            "y": 0.11767300218343735,
            "z": -199.54214477539062
        },
        {
            "x": -8.626348495483398,
            "y": 0.11115522682666779,
            "z": -199.3885040283203
        },
        {
            "x": -8.656853675842285,
            "y": 0.10479030758142471,
            "z": -199.23500061035156
        },
        {
            "x": -8.687078475952148,
            "y": 0.0985693633556366,
            "z": -199.08131408691406
        },
        {
            "x": -8.716866493225098,
            "y": 0.09250424802303314,
            "z": -198.9276123046875
        },
        {
            "x": -8.746299743652344,
            "y": 0.08659534901380539,
            "z": -198.773681640625
        },
        {
            "x": -8.775368690490723,
            "y": 0.08084885776042938,
            "z": -198.6198272705078
        },
        {
            "x": -8.804010391235352,
            "y": 0.07526016235351562,
            "z": -198.4657745361328
        },
        {
            "x": -8.832334518432617,
            "y": 0.06984039396047592,
            "z": -198.31173706054688
        },
        {
            "x": -8.850930213928223,
            "y": 0.0663318857550621,
            "z": -198.20913696289062
        },
        {
            "x": -8.878522872924805,
            "y": 0.061198920011520386,
            "z": -198.054931640625
        },
        {
            "x": -8.905795097351074,
            "y": 0.056242022663354874,
            "z": -197.90074157714844
        },
        {
            "x": -8.932592391967773,
            "y": 0.051467735320329666,
            "z": -197.7463836669922
        },
        {
            "x": -8.959046363830566,
            "y": 0.046874284744262695,
            "z": -197.59193420410156
        },
        {
            "x": -8.985057830810547,
            "y": 0.042471691966056824,
            "z": -197.43765258789062
        },
        {
            "x": -9.010672569274902,
            "y": 0.03824807330965996,
            "z": -197.28297424316406
        },
        {
            "x": -9.03592586517334,
            "y": 0.03422928601503372,
            "z": -197.12843322753906
        },
        {
            "x": -9.060691833496094,
            "y": 0.03040415048599243,
            "z": -196.97377014160156
        },
        {
            "x": -9.08513355255127,
            "y": 0.02677195891737938,
            "z": -196.81886291503906
        },
        {
            "x": -9.109105110168457,
            "y": 0.02334863692522049,
            "z": -196.6642608642578
        },
        {
            "x": -9.132643699645996,
            "y": 0.02013193815946579,
            "z": -196.50924682617188
        },
        {
            "x": -9.155830383300781,
            "y": 0.01712653413414955,
            "z": -196.35435485839844
        },
        {
            "x": -9.178511619567871,
            "y": 0.01433330588042736,
            "z": -196.19947814941406
        },
        {
            "x": -9.200878143310547,
            "y": 0.011746982112526894,
            "z": -196.04412841796875
        },
        {
            "x": -9.22275161743164,
            "y": 0.009394880384206772,
            "z": -195.88917541503906
        },
        {
            "x": -9.244170188903809,
            "y": 0.007261006627231836,
            "z": -195.73390197753906
        },
        {
            "x": -9.265256881713867,
            "y": 0.005351196508854628,
            "z": -195.57867431640625
        },
        {
            "x": -9.285810470581055,
            "y": 0.0036703557707369328,
            "z": -195.42352294921875
        },
        {
            "x": -9.306015968322754,
            "y": 0.0022252611815929413,
            "z": -195.2678680419922
        },
        {
            "x": -9.325769424438477,
            "y": 0.00101892848033458,
            "z": -195.11260986328125
        },
        {
            "x": -9.3450345993042,
            "y": 4.8090238124132156e-05,
            "z": -194.9571533203125
        },
        {
            "x": -9.363970756530762,
            "y": -0.0006832934450358152,
            "z": -194.80160522460938
        },
        {
            "x": -9.382365226745605,
            "y": -0.0011610430665314198,
            "z": -194.64622497558594
        },
        {
            "x": -9.400379180908203,
            "y": -0.001391313737258315,
            "z": -194.4904022216797
        },
        {
            "x": -9.417991638183594,
            "y": -0.0014216043055057526,
            "z": -194.3347625732422
        },
        {
            "x": -9.435072898864746,
            "y": -0.0014245137572288513,
            "z": -194.1791229248047
        },
        {
            "x": -9.451824188232422,
            "y": -0.0014274492859840393,
            "z": -194.02316284179688
        },
        {
            "x": -9.468060493469238,
            "y": -0.0014303773641586304,
            "z": -193.86752319335938
        },
        {
            "x": -9.483853340148926,
            "y": -0.0014332830905914307,
            "z": -193.7116241455078
        },
        {
            "x": -9.499313354492188,
            "y": -0.0014361850917339325,
            "z": -193.55555725097656
        },
        {
            "x": -9.514188766479492,
            "y": -0.0014391019940376282,
            "z": -193.39976501464844
        },
        {
            "x": -9.528709411621094,
            "y": -0.0014420077204704285,
            "z": -193.24363708496094
        },
        {
            "x": -9.542787551879883,
            "y": -0.0014449208974838257,
            "z": -193.08770751953125
        },
        {
            "x": -9.556355476379395,
            "y": -0.001447834074497223,
            "z": -192.93162536621094
        },
        {
            "x": -9.569597244262695,
            "y": -0.001450754702091217,
            "z": -192.77529907226562
        },
        {
            "x": -9.582298278808594,
            "y": -0.0014536641538143158,
            "z": -192.61935424804688
        },
        {
            "x": -9.594568252563477,
            "y": -0.0014565810561180115,
            "z": -192.46307373046875
        },
        {
            "x": -9.60647964477539,
            "y": -0.0014594867825508118,
            "z": -192.30685424804688
        },
        {
            "x": -9.61782455444336,
            "y": -0.001462392508983612,
            "z": -192.15072631835938
        },
        {
            "x": -9.628812789916992,
            "y": -0.0014652982354164124,
            "z": -191.99424743652344
        },
        {
            "x": -9.639359474182129,
            "y": -0.0014682337641716003,
            "z": -191.8380126953125
        },
        {
            "x": -9.649385452270508,
            "y": -0.0014711394906044006,
            "z": -191.6816864013672
        },
        {
            "x": -9.6558837890625,
            "y": -0.0014730729162693024,
            "z": -191.577392578125
        },
        {
            "x": -9.665251731872559,
            "y": -0.0014759860932826996,
            "z": -191.42117309570312
        },
        {
            "x": -9.674101829528809,
            "y": -0.0014789067208766937,
            "z": -191.26475524902344
        },
        {
            "x": -9.682623863220215,
            "y": -0.0014818236231803894,
            "z": -191.10806274414062
        },
        {
            "x": -9.690629005432129,
            "y": -0.0014847442507743835,
            "z": -190.95181274414062
        },
        {
            "x": -9.698174476623535,
            "y": -0.00148763507604599,
            "z": -190.7952423095703
        },
        {
            "x": -9.705384254455566,
            "y": -0.0014905519783496857,
            "z": -190.63865661621094
        },
        {
            "x": -9.712044715881348,
            "y": -0.0014934726059436798,
            "z": -190.4822998046875
        },
        {
            "x": -9.718299865722656,
            "y": -0.0014963895082473755,
            "z": -190.32554626464844
        },
        {
            "x": -9.724180221557617,
            "y": -0.001499280333518982,
            "z": -190.1689910888672
        },
        {
            "x": -9.72951889038086,
            "y": -0.0015022121369838715,
            "z": -190.0125274658203
        },
        {
            "x": -9.734500885009766,
            "y": -0.001505136489868164,
            "z": -189.85568237304688
        },
        {
            "x": -9.739041328430176,
            "y": -0.0015080198645591736,
            "z": -189.6992645263672
        },
        {
            "x": -9.743069648742676,
            "y": -0.0015109367668628693,
            "z": -189.5426483154297
        },
        {
            "x": -9.746776580810547,
            "y": -0.001513853669166565,
            "z": -189.3857421875
        },
        {
            "x": -9.75,
            "y": -0.0015167780220508575,
            "z": -189.2292938232422
        },
        {
            "x": -9.752735137939453,
            "y": -0.001519676297903061,
            "z": -189.0725555419922
        },
        {
            "x": -9.755148887634277,
            "y": -0.0015226006507873535,
            "z": -188.91580200195312
        },
        {
            "x": -9.757061958312988,
            "y": -0.0015255101025104523,
            "z": -188.75930786132812
        },
        {
            "x": -9.758525848388672,
            "y": -0.0015284307301044464,
            "z": -188.60232543945312
        },
        {
            "x": -9.759649276733398,
            "y": -0.0015313364565372467,
            "z": -188.4456787109375
        },
        {
            "x": -9.76025104522705,
            "y": -0.0015342459082603455,
            "z": -188.28916931152344
        },
        {
            "x": -9.760441780090332,
            "y": -0.0015371665358543396,
            "z": -188.13235473632812
        },
        {
            "x": -9.760272979736328,
            "y": -0.0015400685369968414,
            "z": -187.9757843017578
        },
        {
            "x": -9.759547233581543,
            "y": -0.0015429817140102386,
            "z": -187.81912231445312
        },
        {
            "x": -9.758440017700195,
            "y": -0.0015458948910236359,
            "z": -187.66221618652344
        },
        {
            "x": -9.756941795349121,
            "y": -0.001548808068037033,
            "z": -187.50570678710938
        },
        {
            "x": -9.75488567352295,
            "y": -0.0015517175197601318,
            "z": -187.34901428222656
        },
        {
            "x": -9.752466201782227,
            "y": -0.0015546418726444244,
            "z": -187.1922607421875
        },
        {
            "x": -9.74960994720459,
            "y": -0.001557566225528717,
            "z": -187.03579711914062
        },
        {
            "x": -9.746219635009766,
            "y": -0.0015604831278324127,
            "z": -186.8789825439453
        },
        {
            "x": -9.742490768432617,
            "y": -0.0015633925795555115,
            "z": -186.72225952148438
        },
        {
            "x": -9.738269805908203,
            "y": -0.0015664664097130299,
            "z": -186.5657958984375
        },
        {
            "x": -9.73354721069336,
            "y": -0.0016754185780882835,
            "z": -186.40908813476562
        },
        {
            "x": -9.728495597839355,
            "y": -0.0020199071150273085,
            "z": -186.25250244140625
        },
        {
            "x": -9.72291374206543,
            "y": -0.0025844136252999306,
            "z": -186.09591674804688
        },
        {
            "x": -9.716869354248047,
            "y": -0.00337109062820673,
            "z": -185.93927001953125
        },
        {
            "x": -9.710477828979492,
            "y": -0.004367724061012268,
            "z": -185.78280639648438
        },
        {
            "x": -9.703540802001953,
            "y": -0.005573039408773184,
            "z": -185.6262969970703
        },
        {
            "x": -9.696196556091309,
            "y": -0.00698712095618248,
            "z": -185.4696807861328
        },
        {
            "x": -9.688454627990723,
            "y": -0.008609764277935028,
            "z": -185.31324768066406
        },
        {
            "x": -9.680163383483887,
            "y": -0.010433005169034004,
            "z": -185.15676879882812
        },
        {
            "x": -9.671523094177246,
            "y": -0.012453285977244377,
            "z": -185.00027465820312
        },
        {
            "x": -9.665528297424316,
            "y": -0.01390853151679039,
            "z": -184.89613342285156
        },
        {
            "x": -9.656074523925781,
            "y": -0.016253884881734848,
            "z": -184.73985290527344
        },
        {
            "x": -9.646240234375,
            "y": -0.018791019916534424,
            "z": -184.5833740234375
        },
        {
            "x": -9.635984420776367,
            "y": -0.021513868123292923,
            "z": -184.4270477294922
        },
        {
            "x": -9.625186920166016,
            "y": -0.02442709170281887,
            "z": -184.27078247070312
        },
        {
            "x": -9.614058494567871,
            "y": -0.02752121351659298,
            "z": -184.11448669433594
        },
        {
            "x": -9.602453231811523,
            "y": -0.030789736658334732,
            "z": -183.9583282470703
        },
        {
            "x": -9.59036636352539,
            "y": -0.034236617386341095,
            "z": -183.80206298828125
        },
        {
            "x": -9.57793140411377,
            "y": -0.037861842662096024,
            "z": -183.64585876464844
        },
        {
            "x": -9.564976692199707,
            "y": -0.041653044521808624,
            "z": -183.4897918701172
        },
        {
            "x": -9.55161190032959,
            "y": -0.04561293125152588,
            "z": -183.3336181640625
        },
        {
            "x": -9.537875175476074,
            "y": -0.049732599407434464,
            "z": -183.17758178710938
        },
        {
            "x": -9.523591995239258,
            "y": -0.05401832237839699,
            "z": -183.0216522216797
        },
        {
            "x": -9.508960723876953,
            "y": -0.05846360698342323,
            "z": -182.86563110351562
        },
        {
            "x": -9.493887901306152,
            "y": -0.06306082010269165,
            "z": -182.709716796875
        },
        {
            "x": -9.478327751159668,
            "y": -0.0678095817565918,
            "z": -182.55381774902344
        },
        {
            "x": -9.462432861328125,
            "y": -0.07271209359169006,
            "z": -182.39796447753906
        },
        {
            "x": -9.44604206085205,
            "y": -0.07775569707155228,
            "z": -182.24227905273438
        },
        {
            "x": -9.429224967956543,
            "y": -0.08294672518968582,
            "z": -182.0864715576172
        },
        {
            "x": -9.412052154541016,
            "y": -0.0882757306098938,
            "z": -181.93072509765625
        },
        {
            "x": -9.394360542297363,
            "y": -0.09374158084392548,
            "z": -181.7751922607422
        },
        {
            "x": -9.376310348510742,
            "y": -0.09934544563293457,
            "z": -181.61952209472656
        },
        {
            "x": -9.357856750488281,
            "y": -0.10506953299045563,
            "z": -181.4641876220703
        },
        {
            "x": -9.338909149169922,
            "y": -0.1109282374382019,
            "z": -181.30870056152344
        },
        {
            "x": -9.319622993469238,
            "y": -0.11691825091838837,
            "z": -181.15316772460938
        },
        {
            "x": -9.299861907958984,
            "y": -0.12302415072917938,
            "z": -180.99786376953125
        },
        {
            "x": -9.279688835144043,
            "y": -0.12925317883491516,
            "z": -180.8424835205078
        },
        {
            "x": -9.259173393249512,
            "y": -0.1355927586555481,
            "z": -180.68724060058594
        },
        {
            "x": -9.238153457641602,
            "y": -0.14204604923725128,
            "z": -180.53213500976562
        },
        {
            "x": -9.216791152954102,
            "y": -0.14861392974853516,
            "z": -180.376953125
        },
        {
            "x": -9.194993019104004,
            "y": -0.15528783202171326,
            "z": -180.22183227539062
        },
        {
            "x": -9.172759056091309,
            "y": -0.16206473112106323,
            "z": -180.06675720214844
        },
        {
            "x": -9.150201797485352,
            "y": -0.16894316673278809,
            "z": -179.9117889404297
        },
        {
            "x": -9.127166748046875,
            "y": -0.17591620981693268,
            "z": -179.75698852539062
        },
        {
            "x": -9.103754997253418,
            "y": -0.18298907577991486,
            "z": -179.60205078125
        },
        {
            "x": -9.079976081848145,
            "y": -0.19015245139598846,
            "z": -179.4472198486328
        },
        {
            "x": -9.0557279586792,
            "y": -0.19740267097949982,
            "z": -179.29254150390625
        },
        {
            "x": -9.031168937683105,
            "y": -0.20474034547805786,
            "z": -179.1378936767578
        },
        {
            "x": -9.006182670593262,
            "y": -0.2121574878692627,
            "z": -178.9833526611328
        },
        {
            "x": -8.98078441619873,
            "y": -0.21965813636779785,
            "z": -178.82876586914062
        },
        {
            "x": -8.955060005187988,
            "y": -0.2272343933582306,
            "z": -178.67430114746094
        },
        {
            "x": -8.928864479064941,
            "y": -0.23488621413707733,
            "z": -178.51988220214844
        },
        {
            "x": -8.902349472045898,
            "y": -0.24260832369327545,
            "z": -178.3655242919922
        },
        {
            "x": -8.884490013122559,
            "y": -0.2477872371673584,
            "z": -178.26275634765625
        },
        {
            "x": -8.85728645324707,
            "y": -0.25561612844467163,
            "z": -178.10861206054688
        },
        {
            "x": -8.829768180847168,
            "y": -0.2635110020637512,
            "z": -177.9544219970703
        },
        {
            "x": -8.801840782165527,
            "y": -0.2714662253856659,
            "z": -177.80030822753906
        },
        {
            "x": -8.773520469665527,
            "y": -0.2794783413410187,
            "z": -177.64622497558594
        },
        {
            "x": -8.744915008544922,
            "y": -0.2875367999076843,
            "z": -177.49237060546875
        },
        {
            "x": -8.715845108032227,
            "y": -0.2956514358520508,
            "z": -177.3385009765625
        },
        {
            "x": -8.686463356018066,
            "y": -0.3038146495819092,
            "z": -177.1846160888672
        },
        {
            "x": -8.656730651855469,
            "y": -0.31201717257499695,
            "z": -177.03091430664062
        },
        {
            "x": -8.626554489135742,
            "y": -0.3202705979347229,
            "z": -176.87713623046875
        },
        {
            "x": -8.596132278442383,
            "y": -0.32855239510536194,
            "z": -176.72357177734375
        },
        {
            "x": -8.565274238586426,
            "y": -0.33687251806259155,
            "z": -176.57000732421875
        },
        {
            "x": -8.534096717834473,
            "y": -0.34522679448127747,
            "z": -176.41650390625
        },
        {
            "x": -8.50261116027832,
            "y": -0.35360053181648254,
            "z": -176.26324462890625
        },
        {
            "x": -8.470661163330078,
            "y": -0.36201798915863037,
            "z": -176.1097412109375
        },
        {
            "x": -8.43848705291748,
            "y": -0.37044626474380493,
            "z": -175.9564666748047
        },
        {
            "x": -8.405922889709473,
            "y": -0.3788912892341614,
            "z": -175.8033905029297
        },
        {
            "x": -8.372984886169434,
            "y": -0.38736486434936523,
            "z": -175.650146484375
        },
        {
            "x": -8.339798927307129,
            "y": -0.39583951234817505,
            "z": -175.49720764160156
        },
        {
            "x": -8.306164741516113,
            "y": -0.4043404161930084,
            "z": -175.34405517578125
        },
        {
            "x": -8.272307395935059,
            "y": -0.4128391146659851,
            "z": -175.19113159179688
        },
        {
            "x": -8.238091468811035,
            "y": -0.4213353991508484,
            "z": -175.03842163085938
        },
        {
            "x": -8.203530311584473,
            "y": -0.4298437833786011,
            "z": -174.88558959960938
        },
        {
            "x": -8.168718338012695,
            "y": -0.43834078311920166,
            "z": -174.7329864501953
        },
        {
            "x": -8.133488655090332,
            "y": -0.4468435049057007,
            "z": -174.580322265625
        },
        {
            "x": -8.097990989685059,
            "y": -0.4553406238555908,
            "z": -174.4276580810547
        },
        {
            "x": -8.0621976852417,
            "y": -0.4638139009475708,
            "z": -174.27528381347656
        },
        {
            "x": -8.02603816986084,
            "y": -0.4722885489463806,
            "z": -174.1227264404297
        },
        {
            "x": -7.989668369293213,
            "y": -0.48073437809944153,
            "z": -173.97042846679688
        },
        {
            "x": -7.952914237976074,
            "y": -0.4891620874404907,
            "z": -173.81817626953125
        },
        {
            "x": -7.915863037109375,
            "y": -0.4975798428058624,
            "z": -173.66575622558594
        },
        {
            "x": -7.878561973571777,
            "y": -0.5059550404548645,
            "z": -173.51370239257812
        },
        {
            "x": -7.8409223556518555,
            "y": -0.5143129825592041,
            "z": -173.3614959716797
        },
        {
            "x": -7.803056240081787,
            "y": -0.5226304531097412,
            "z": -173.20948791503906
        },
        {
            "x": -7.7648420333862305,
            "y": -0.5309125185012817,
            "z": -173.0575714111328
        },
        {
            "x": -7.726339340209961,
            "y": -0.5391702055931091,
            "z": -172.9054718017578
        },
        {
            "x": -7.687620639801025,
            "y": -0.5473681688308716,
            "z": -172.75375366210938
        },
        {
            "x": -7.648579120635986,
            "y": -0.5555304288864136,
            "z": -172.60194396972656
        },
        {
            "x": -7.609297752380371,
            "y": -0.563643217086792,
            "z": -172.45021057128906
        },
        {
            "x": -7.569713115692139,
            "y": -0.5717029571533203,
            "z": -172.29861450195312
        },
        {
            "x": -7.529881000518799,
            "y": -0.579716682434082,
            "z": -172.14691162109375
        },
        {
            "x": -7.489777088165283,
            "y": -0.5876674056053162,
            "z": -171.99537658691406
        },
        {
            "x": -7.449403285980225,
            "y": -0.5955585837364197,
            "z": -171.8438720703125
        },
        {
            "x": -7.422392845153809,
            "y": -0.6007828712463379,
            "z": -171.74298095703125
        },
        {
            "x": -7.38162088394165,
            "y": -0.608561635017395,
            "z": -171.5917205810547
        },
        {
            "x": -7.340587615966797,
            "y": -0.616277813911438,
            "z": -171.44036865234375
        },
        {
            "x": -7.299306392669678,
            "y": -0.6239262819290161,
            "z": -171.2890167236328
        },
        {
            "x": -7.257780075073242,
            "y": -0.6314958333969116,
            "z": -171.13783264160156
        },
        {
            "x": -7.2160725593566895,
            "y": -0.6389851570129395,
            "z": -170.9867401123047
        },
        {
            "x": -7.174049377441406,
            "y": -0.6463965177536011,
            "z": -170.8355712890625
        },
        {
            "x": -7.1318464279174805,
            "y": -0.6537229418754578,
            "z": -170.68455505371094
        },
        {
            "x": -7.089410781860352,
            "y": -0.660963237285614,
            "z": -170.5335693359375
        },
        {
            "x": -7.046711444854736,
            "y": -0.6681166887283325,
            "z": -170.38255310058594
        },
        {
            "x": -7.003872394561768,
            "y": -0.6751676797866821,
            "z": -170.2317657470703
        },
        {
            "x": -6.960740089416504,
            "y": -0.6821284294128418,
            "z": -170.08090209960938
        },
        {
            "x": -6.9174418449401855,
            "y": -0.6889886260032654,
            "z": -169.9300994873047
        },
        {
            "x": -6.8739519119262695,
            "y": -0.6957411766052246,
            "z": -169.77947998046875
        },
        {
            "x": -6.830160140991211,
            "y": -0.702397346496582,
            "z": -169.62864685058594
        },
        {
            "x": -6.786271572113037,
            "y": -0.7089354395866394,
            "z": -169.4780731201172
        },
        {
            "x": -6.742135047912598,
            "y": -0.7153642177581787,
            "z": -169.3275146484375
        },
        {
            "x": -6.697834014892578,
            "y": -0.7216795682907104,
            "z": -169.1769561767578
        },
        {
            "x": -6.653345108032227,
            "y": -0.7278684973716736,
            "z": -169.0265655517578
        },
        {
            "x": -6.608592987060547,
            "y": -0.7339479923248291,
            "z": -168.87591552734375
        },
        {
            "x": -6.56376838684082,
            "y": -0.7398923635482788,
            "z": -168.72560119628906
        },
        {
            "x": -6.518712997436523,
            "y": -0.7457117438316345,
            "z": -168.57530212402344
        },
        {
            "x": -6.4735283851623535,
            "y": -0.7513954639434814,
            "z": -168.42501831054688
        },
        {
            "x": -6.42815637588501,
            "y": -0.756944477558136,
            "z": -168.2748260498047
        },
        {
            "x": -6.382578372955322,
            "y": -0.7623637914657593,
            "z": -168.12449645996094
        },
        {
            "x": -6.336876392364502,
            "y": -0.7676407098770142,
            "z": -167.97425842285156
        },
        {
            "x": -6.290995121002197,
            "y": -0.772766649723053,
            "z": -167.8241424560547
        },
        {
            "x": -6.244967460632324,
            "y": -0.7777503728866577,
            "z": -167.6739501953125
        },
        {
            "x": -6.198812961578369,
            "y": -0.7825804352760315,
            "z": -167.52392578125
        },
        {
            "x": -6.152509689331055,
            "y": -0.7872605323791504,
            "z": -167.3739013671875
        },
        {
            "x": -6.106021881103516,
            "y": -0.7917819619178772,
            "z": -167.22377014160156
        },
        {
            "x": -6.059439182281494,
            "y": -0.7961404323577881,
            "z": -167.07382202148438
        },
        {
            "x": -6.0127339363098145,
            "y": -0.800338625907898,
            "z": -166.92385864257812
        },
        {
            "x": -5.965871810913086,
            "y": -0.8043720126152039,
            "z": -166.77392578125
        },
        {
            "x": -5.918919086456299,
            "y": -0.8082298040390015,
            "z": -166.62403869628906
        },
        {
            "x": -5.871789455413818,
            "y": -0.8119187951087952,
            "z": -166.47406005859375
        },
        {
            "x": -5.824589729309082,
            "y": -0.8154301047325134,
            "z": -166.32424926757812
        },
        {
            "x": -5.777297496795654,
            "y": -0.818763792514801,
            "z": -166.17446899414062
        },
        {
            "x": -5.729846000671387,
            "y": -0.8219117522239685,
            "z": -166.0246124267578
        },
        {
            "x": -5.682341575622559,
            "y": -0.8248727321624756,
            "z": -165.8748779296875
        },
        {
            "x": -5.63470458984375,
            "y": -0.8276486992835999,
            "z": -165.72509765625
        },
        {
            "x": -5.586978435516357,
            "y": -0.830234944820404,
            "z": -165.5753173828125
        },
        {
            "x": -5.539205551147461,
            "y": -0.8326176404953003,
            "z": -165.42567443847656
        },
        {
            "x": -5.507287979125977,
            "y": -0.8340976238250732,
            "z": -165.3258819580078
        },
        {
            "x": -5.459369659423828,
            "y": -0.8361536264419556,
            "z": -165.17625427246094
        },
        {
            "x": -5.4113664627075195,
            "y": -0.8380001783370972,
            "z": -165.02664184570312
        },
        {
            "x": -5.363220691680908,
            "y": -0.8396426439285278,
            "z": -164.8768310546875
        },
        {
            "x": -5.315090656280518,
            "y": -0.8410745859146118,
            "z": -164.72726440429688
        },
        {
            "x": -5.266873836517334,
            "y": -0.8422954678535461,
            "z": -164.5776824951172
        },
        {
            "x": -5.218583106994629,
            "y": -0.8432959318161011,
            "z": -164.42800903320312
        },
        {
            "x": -5.170260906219482,
            "y": -0.8440749049186707,
            "z": -164.2784423828125
        },
        {
            "x": -5.121854305267334,
            "y": -0.8446340560913086,
            "z": -164.12881469726562
        },
        {
            "x": -5.07341194152832,
            "y": -0.844969630241394,
            "z": -163.9792022705078
        },
        {
            "x": -5.0249457359313965,
            "y": -0.8450700044631958,
            "z": -163.8296661376953
        },
        {
            "x": -4.976417064666748,
            "y": -0.8449387550354004,
            "z": -163.68002319335938
        },
        {
            "x": -4.927892208099365,
            "y": -0.8445817232131958,
            "z": -163.530517578125
        },
        {
            "x": -4.87932014465332,
            "y": -0.8440004587173462,
            "z": -163.3809814453125
        },
        {
            "x": -4.83068323135376,
            "y": -0.8431921005249023,
            "z": -163.23129272460938
        },
        {
            "x": -4.782094955444336,
            "y": -0.8421636819839478,
            "z": -163.08177185058594
        },
        {
            "x": -4.733471393585205,
            "y": -0.8409214615821838,
            "z": -162.93223571777344
        },
        {
            "x": -4.684822082519531,
            "y": -0.8394680023193359,
            "z": -162.7826690673828
        },
        {
            "x": -4.636208534240723,
            "y": -0.8378013968467712,
            "z": -162.6331787109375
        },
        {
            "x": -4.587515354156494,
            "y": -0.8359237909317017,
            "z": -162.4834747314453
        },
        {
            "x": -4.538895130157471,
            "y": -0.8338481783866882,
            "z": -162.33396911621094
        },
        {
            "x": -4.4902753829956055,
            "y": -0.8315738439559937,
            "z": -162.18446350097656
        },
        {
            "x": -4.441677093505859,
            "y": -0.8290985822677612,
            "z": -162.03488159179688
        },
        {
            "x": -4.393111228942871,
            "y": -0.8264284133911133,
            "z": -161.88540649414062
        },
        {
            "x": -4.344514846801758,
            "y": -0.8235674500465393,
            "z": -161.73574829101562
        },
        {
            "x": -4.2959489822387695,
            "y": -0.820520281791687,
            "z": -161.58607482910156
        },
        {
            "x": -4.247442245483398,
            "y": -0.8172874450683594,
            "z": -161.43650817871094
        },
        {
            "x": -4.19895076751709,
            "y": -0.8138701915740967,
            "z": -161.2868194580078
        },
        {
            "x": -4.150515079498291,
            "y": -0.8102779388427734,
            "z": -161.13722229003906
        },
        {
            "x": -4.102145195007324,
            "y": -0.8065135478973389,
            "z": -160.98760986328125
        },
        {
            "x": -4.053747177124023,
            "y": -0.8025699257850647,
            "z": -160.8377685546875
        },
        {
            "x": -4.005472183227539,
            "y": -0.7984591126441956,
            "z": -160.68809509277344
        },
        {
            "x": -3.9572432041168213,
            "y": -0.794184684753418,
            "z": -160.5383758544922
        },
        {
            "x": -3.9090607166290283,
            "y": -0.7897484302520752,
            "z": -160.38861083984375
        },
        {
            "x": -3.8609859943389893,
            "y": -0.7851547002792358,
            "z": -160.2388916015625
        },
        {
            "x": -3.812898874282837,
            "y": -0.7803955078125,
            "z": -160.08895874023438
        },
        {
            "x": -3.764975070953369,
            "y": -0.7754918932914734,
            "z": -159.93919372558594
        },
        {
            "x": -3.717127561569214,
            "y": -0.7704408168792725,
            "z": -159.78939819335938
        },
        {
            "x": -3.669332504272461,
            "y": -0.7652378082275391,
            "z": -159.63946533203125
        },
        {
            "x": -3.6216814517974854,
            "y": -0.7598935961723328,
            "z": -159.4896240234375
        },
        {
            "x": -3.5740697383880615,
            "y": -0.7544065713882446,
            "z": -159.3396453857422
        },
        {
            "x": -3.5265753269195557,
            "y": -0.7487838268280029,
            "z": -159.18963623046875
        },
        {
            "x": -3.4791955947875977,
            "y": -0.7430320382118225,
            "z": -159.03970336914062
        },
        {
            "x": -3.4476816654205322,
            "y": -0.7391204833984375,
            "z": -158.939697265625
        },
        {
            "x": -3.400522470474243,
            "y": -0.7331535220146179,
            "z": -158.7897186279297
        },
        {
            "x": -3.35343337059021,
            "y": -0.7270597219467163,
            "z": -158.6396484375
        },
        {
            "x": -3.3064465522766113,
            "y": -0.7208324670791626,
            "z": -158.48936462402344
        },
        {
            "x": -3.2596216201782227,
            "y": -0.714496910572052,
            "z": -158.33926391601562
        },
        {
            "x": -3.2129313945770264,
            "y": -0.7080440521240234,
            "z": -158.1890411376953
        },
        {
            "x": -3.1663687229156494,
            "y": -0.7014783620834351,
            "z": -158.0387725830078
        },
        {
            "x": -3.119943380355835,
            "y": -0.694801390171051,
            "z": -157.8885040283203
        },
        {
            "x": -3.0736703872680664,
            "y": -0.688016951084137,
            "z": -157.73812866210938
        },
        {
            "x": -3.027512550354004,
            "y": -0.6811297535896301,
            "z": -157.5876922607422
        },
        {
            "x": -2.9815566539764404,
            "y": -0.6741459369659424,
            "z": -157.43727111816406
        },
        {
            "x": -2.9357364177703857,
            "y": -0.6670602560043335,
            "z": -157.28672790527344
        },
        {
            "x": -2.8900837898254395,
            "y": -0.6598833203315735,
            "z": -157.13619995117188
        },
        {
            "x": -2.844635009765625,
            "y": -0.6526204943656921,
            "z": -156.98568725585938
        },
        {
            "x": -2.7992608547210693,
            "y": -0.6452595591545105,
            "z": -156.83489990234375
        },
        {
            "x": -2.7541584968566895,
            "y": -0.6378204822540283,
            "z": -156.68421936035156
        },
        {
            "x": -2.709205389022827,
            "y": -0.6303009390830994,
            "z": -156.53350830078125
        },
        {
            "x": -2.664433479309082,
            "y": -0.622700035572052,
            "z": -156.38262939453125
        },
        {
            "x": -2.619891405105591,
            "y": -0.6150323152542114,
            "z": -156.2318572998047
        },
        {
            "x": -2.5754544734954834,
            "y": -0.607276201248169,
            "z": -156.0807647705078
        },
        {
            "x": -2.531320571899414,
            "y": -0.5994645357131958,
            "z": -155.9298095703125
        },
        {
            "x": -2.4873411655426025,
            "y": -0.5915864706039429,
            "z": -155.77880859375
        },
        {
            "x": -2.4436001777648926,
            "y": -0.583645224571228,
            "z": -155.627685546875
        },
        {
            "x": -2.4000749588012695,
            "y": -0.5756475925445557,
            "z": -155.4766082763672
        },
        {
            "x": -2.356717109680176,
            "y": -0.5675837993621826,
            "z": -155.3252716064453
        },
        {
            "x": -2.313620090484619,
            "y": -0.5594720840454102,
            "z": -155.1739501953125
        },
        {
            "x": -2.2707250118255615,
            "y": -0.5513132810592651,
            "z": -155.02261352539062
        },
        {
            "x": -2.2280826568603516,
            "y": -0.5431004762649536,
            "z": -154.87110900878906
        },
        {
            "x": -2.1856799125671387,
            "y": -0.5348523855209351,
            "z": -154.71969604492188
        },
        {
            "x": -2.1435229778289795,
            "y": -0.5265598297119141,
            "z": -154.56809997558594
        },
        {
            "x": -2.1015660762786865,
            "y": -0.51822429895401,
            "z": -154.41635131835938
        },
        {
            "x": -2.059879779815674,
            "y": -0.5098578333854675,
            "z": -154.26461791992188
        },
        {
            "x": -2.0184872150421143,
            "y": -0.501461386680603,
            "z": -154.11282348632812
        },
        {
            "x": -1.9773013591766357,
            "y": -0.4930364787578583,
            "z": -153.9609832763672
        },
        {
            "x": -1.936427354812622,
            "y": -0.48458749055862427,
            "z": -153.80905151367188
        },
        {
            "x": -1.8957589864730835,
            "y": -0.4761091470718384,
            "z": -153.6569061279297
        },
        {
            "x": -1.8553987741470337,
            "y": -0.4676164388656616,
            "z": -153.50479125976562
        },
        {
            "x": -1.8153576850891113,
            "y": -0.45911383628845215,
            "z": -153.3527069091797
        },
        {
            "x": -1.775500774383545,
            "y": -0.45058903098106384,
            "z": -153.2003936767578
        },
        {
            "x": -1.736018419265747,
            "y": -0.44206053018569946,
            "z": -153.048095703125
        },
        {
            "x": -1.6967658996582031,
            "y": -0.4335233271121979,
            "z": -152.89569091796875
        },
        {
            "x": -1.657810926437378,
            "y": -0.4249756336212158,
            "z": -152.7430877685547
        },
        {
            "x": -1.6192033290863037,
            "y": -0.41644176840782166,
            "z": -152.5906219482422
        },
        {
            "x": -1.5935949087142944,
            "y": -0.41074877977371216,
            "z": -152.48887634277344
        },
        {
            "x": -1.5554957389831543,
            "y": -0.40221428871154785,
            "z": -152.336181640625
        },
        {
            "x": -1.517684817314148,
            "y": -0.39369308948516846,
            "z": -152.1835174560547
        },
        {
            "x": -1.480122685432434,
            "y": -0.3851635456085205,
            "z": -152.03042602539062
        },
        {
            "x": -1.4429807662963867,
            "y": -0.3766672909259796,
            "z": -151.87757873535156
        },
        {
            "x": -1.4060869216918945,
            "y": -0.3681824505329132,
            "z": -151.72459411621094
        },
        {
            "x": -1.3695616722106934,
            "y": -0.3597128391265869,
            "z": -151.57138061523438
        },
        {
            "x": -1.3333357572555542,
            "y": -0.3512747883796692,
            "z": -151.4182891845703
        },
        {
            "x": -1.2974485158920288,
            "y": -0.3428519368171692,
            "z": -151.264892578125
        },
        {
            "x": -1.2619163990020752,
            "y": -0.3344663381576538,
            "z": -151.11155700683594
        },
        {
            "x": -1.2266948223114014,
            "y": -0.32611024379730225,
            "z": -150.95809936523438
        },
        {
            "x": -1.191874384880066,
            "y": -0.3177889883518219,
            "z": -150.8045196533203
        },
        {
            "x": -1.157358169555664,
            "y": -0.30951187014579773,
            "z": -150.6509552001953
        },
        {
            "x": -1.1232467889785767,
            "y": -0.30127209424972534,
            "z": -150.49720764160156
        },
        {
            "x": -1.0894379615783691,
            "y": -0.2930739223957062,
            "z": -150.3433837890625
        },
        {
            "x": -1.0559985637664795,
            "y": -0.28492438793182373,
            "z": -150.189453125
        },
        {
            "x": -1.022988200187683,
            "y": -0.2768334150314331,
            "z": -150.03555297851562
        },
        {
            "x": -0.9902611970901489,
            "y": -0.26879000663757324,
            "z": -149.88148498535156
        },
        {
            "x": -0.957990825176239,
            "y": -0.26080575585365295,
            "z": -149.7273406982422
        },
        {
            "x": -0.9260136485099792,
            "y": -0.252876341342926,
            "z": -149.57305908203125
        },
        {
            "x": -0.8944681882858276,
            "y": -0.2450142800807953,
            "z": -149.41871643066406
        },
        {
            "x": -0.8633443713188171,
            "y": -0.23722584545612335,
            "z": -149.26443481445312
        },
        {
            "x": -0.8325331211090088,
            "y": -0.22949844598770142,
            "z": -149.10995483398438
        },
        {
            "x": -0.802202045917511,
            "y": -0.2218473106622696,
            "z": -148.9554443359375
        },
        {
            "x": -0.7721864581108093,
            "y": -0.21426978707313538,
            "z": -148.80079650878906
        },
        {
            "x": -0.7426021695137024,
            "y": -0.20676444470882416,
            "z": -148.6459197998047
        },
        {
            "x": -0.7134557962417603,
            "y": -0.1993531584739685,
            "z": -148.49122619628906
        },
        {
            "x": -0.6846328377723694,
            "y": -0.19201257824897766,
            "z": -148.3362274169922
        },
        {
            "x": -0.656340479850769,
            "y": -0.18477170169353485,
            "z": -148.18130493164062
        },
        {
            "x": -0.6283738017082214,
            "y": -0.17762091755867004,
            "z": -148.02630615234375
        },
        {
            "x": -0.6008463501930237,
            "y": -0.17055144906044006,
            "z": -147.87094116210938
        },
        {
            "x": -0.5737511515617371,
            "y": -0.16359266638755798,
            "z": -147.71585083007812
        },
        {
            "x": -0.5470418930053711,
            "y": -0.15672525763511658,
            "z": -147.56045532226562
        },
        {
            "x": -0.520848274230957,
            "y": -0.149969220161438,
            "z": -147.40512084960938
        },
        {
            "x": -0.49499303102493286,
            "y": -0.14331656694412231,
            "z": -147.2496795654297
        },
        {
            "x": -0.46961987018585205,
            "y": -0.13676224648952484,
            "z": -147.09388732910156
        },
        {
            "x": -0.44468724727630615,
            "y": -0.1303369402885437,
            "z": -146.9384307861328
        },
        {
            "x": -0.42018139362335205,
            "y": -0.12401972711086273,
            "z": -146.7826690673828
        },
        {
            "x": -0.3961601257324219,
            "y": -0.1178220808506012,
            "z": -146.6269073486328
        },
        {
            "x": -0.372506320476532,
            "y": -0.111744225025177,
            "z": -146.47105407714844
        },
        {
            "x": -0.3493915796279907,
            "y": -0.10578957200050354,
            "z": -146.31503295898438
        },
        {
            "x": -0.32667049765586853,
            "y": -0.09996810555458069,
            "z": -146.15904235839844
        },
        {
            "x": -0.3044254779815674,
            "y": -0.09427323192358017,
            "z": -146.00294494628906
        },
        {
            "x": -0.2898949384689331,
            "y": -0.0905533879995346,
            "z": -145.89892578125
        },
        {
            "x": -0.2683921456336975,
            "y": -0.0850897878408432,
            "z": -145.74282836914062
        },
        {
            "x": -0.24739721417427063,
            "y": -0.07975810766220093,
            "z": -145.58648681640625
        },
        {
            "x": -0.22684502601623535,
            "y": -0.07456739246845245,
            "z": -145.43011474609375
        },
        {
            "x": -0.2067309468984604,
            "y": -0.06952314078807831,
            "z": -145.27366638183594
        },
        {
            "x": -0.18719696998596191,
            "y": -0.06463254988193512,
            "z": -145.1172637939453
        },
        {
            "x": -0.1680232584476471,
            "y": -0.05988825112581253,
            "z": -144.96072387695312
        },
        {
            "x": -0.14939652383327484,
            "y": -0.05529601499438286,
            "z": -144.80406188964844
        },
        {
            "x": -0.13123686611652374,
            "y": -0.0508648119866848,
            "z": -144.64747619628906
        },
        {
            "x": -0.11351120471954346,
            "y": -0.04659057408571243,
            "z": -144.4906005859375
        },
        {
            "x": -0.09637370705604553,
            "y": -0.042484160512685776,
            "z": -144.3339080810547
        },
        {
            "x": -0.07960058003664017,
            "y": -0.03853835538029671,
            "z": -144.177001953125
        },
        {
            "x": -0.06340017169713974,
            "y": -0.03476213291287422,
            "z": -144.0200653076172
        },
        {
            "x": -0.047697216272354126,
            "y": -0.03116687759757042,
            "z": -143.86326599121094
        },
        {
            "x": -0.032404690980911255,
            "y": -0.027735844254493713,
            "z": -143.70602416992188
        },
        {
            "x": -0.017719268798828125,
            "y": -0.024487294256687164,
            "z": -143.5489959716797
        },
        {
            "x": -0.0034245848655700684,
            "y": -0.021419836208224297,
            "z": -143.39195251464844
        },
        {
            "x": 0.010295316576957703,
            "y": -0.018537815660238266,
            "z": -143.2346649169922
        },
        {
            "x": 0.02351352572441101,
            "y": -0.015845371410250664,
            "z": -143.07760620117188
        },
        {
            "x": 0.03631548583507538,
            "y": -0.013334340415894985,
            "z": -142.9201202392578
        },
        {
            "x": 0.048484206199645996,
            "y": -0.011021198704838753,
            "z": -142.76287841796875
        },
        {
            "x": 0.06024263799190521,
            "y": -0.00890923198312521,
            "z": -142.6056365966797
        },
        {
            "x": 0.07144106924533844,
            "y": -0.006991909816861153,
            "z": -142.4481964111328
        },
        {
            "x": 0.08211910724639893,
            "y": -0.005276490934193134,
            "z": -142.29092407226562
        },
        {
            "x": 0.09237831830978394,
            "y": -0.0037621452938765287,
            "z": -142.1333465576172
        },
        {
            "x": 0.10199342668056488,
            "y": -0.0024621346965432167,
            "z": -141.9757843017578
        },
        {
            "x": 0.11118833720684052,
            "y": -0.0013717464171350002,
            "z": -141.81838989257812
        },
        {
            "x": 0.1198466420173645,
            "y": -0.0004903338849544525,
            "z": -141.66062927246094
        },
        {
            "x": 0.1279381960630417,
            "y": 0.0001739818835631013,
            "z": -141.50318908691406
        },
        {
            "x": 0.13560271263122559,
            "y": 0.0006130741676315665,
            "z": -141.34561157226562
        },
        {
            "x": 0.1426490843296051,
            "y": 0.0008271568221971393,
            "z": -141.18775939941406
        },
        {
            "x": 0.14924411475658417,
            "y": 0.0008400809019804001,
            "z": -141.03024291992188
        },
        {
            "x": 0.1553245633840561,
            "y": 0.0008334610611200333,
            "z": -140.87242126464844
        },
        {
            "x": 0.16078469157218933,
            "y": 0.0008268337696790695,
            "z": -140.71478271484375
        },
        {
            "x": 0.16584467887878418,
            "y": 0.0008201971650123596,
            "z": -140.55712890625
        },
        {
            "x": 0.1702948361635208,
            "y": 0.0008135810494422913,
            "z": -140.39915466308594
        },
        {
            "x": 0.17425240576267242,
            "y": 0.0008069649338722229,
            "z": -140.24159240722656
        },
        {
            "x": 0.17771899700164795,
            "y": 0.0008003208786249161,
            "z": -140.0837860107422
        },
        {
            "x": 0.18057407438755035,
            "y": 0.0007936954498291016,
            "z": -139.9259796142578
        },
        {
            "x": 0.1830255389213562,
            "y": 0.000787070021033287,
            "z": -139.76834106445312
        },
        {
            "x": 0.1849299520254135,
            "y": 0.0007804408669471741,
            "z": -139.61044311523438
        },
        {
            "x": 0.1863514631986618,
            "y": 0.0007738135755062103,
            "z": -139.4527587890625
        },
        {
            "x": 0.18740281462669373,
            "y": 0.0007671918720006943,
            "z": -139.29510498046875
        },
        {
            "x": 0.18785683810710907,
            "y": 0.0007627662271261215,
            "z": -139.19000244140625
        },
        {
            "x": 0.18831627070903778,
            "y": 0.0007561538368463516,
            "z": -139.0325927734375
        },
        {
            "x": 0.18855109810829163,
            "y": 0.0007495246827602386,
            "z": -138.87510681152344
        },
        {
            "x": 0.18857188522815704,
            "y": 0.0007428880780935287,
            "z": -138.71755981445312
        },
        {
            "x": 0.18853513896465302,
            "y": 0.0007362775504589081,
            "z": -138.56027221679688
        },
        {
            "x": 0.18840910494327545,
            "y": 0.0007296428084373474,
            "z": -138.4029541015625
        },
        {
            "x": 0.18824540078639984,
            "y": 0.0007230062037706375,
            "z": -138.24560546875
        },
        {
            "x": 0.18807433545589447,
            "y": 0.0007163845002651215,
            "z": -138.08836364746094
        },
        {
            "x": 0.18788619339466095,
            "y": 0.0007097553461790085,
            "z": -137.93101501464844
        },
        {
            "x": 0.18769530951976776,
            "y": 0.0007031280547380447,
            "z": -137.773681640625
        },
        {
            "x": 0.18750153481960297,
            "y": 0.0006965026259422302,
            "z": -137.616455078125
        },
        {
            "x": 0.18730449676513672,
            "y": 0.000689871609210968,
            "z": -137.4591064453125
        },
        {
            "x": 0.18710626661777496,
            "y": 0.0006832480430603027,
            "z": -137.30186462402344
        },
        {
            "x": 0.1869056522846222,
            "y": 0.0006766263395547867,
            "z": -137.14463806152344
        },
        {
            "x": 0.18670301139354706,
            "y": 0.0006699971854686737,
            "z": -136.98719787597656
        },
        {
            "x": 0.18649885058403015,
            "y": 0.000663362443447113,
            "z": -136.82997131347656
        },
        {
            "x": 0.1862923949956894,
            "y": 0.0006567332893610001,
            "z": -136.6726837158203
        },
        {
            "x": 0.18608437478542328,
            "y": 0.0006501134485006332,
            "z": -136.51539611816406
        },
        {
            "x": 0.185874342918396,
            "y": 0.0006434954702854156,
            "z": -136.35813903808594
        },
        {
            "x": 0.18566204607486725,
            "y": 0.0006368663161993027,
            "z": -136.20069885253906
        },
        {
            "x": 0.18544840812683105,
            "y": 0.0006302371621131897,
            "z": -136.04347229003906
        },
        {
            "x": 0.18523235619068146,
            "y": 0.0006236117333173752,
            "z": -135.88624572753906
        },
        {
            "x": 0.1850147843360901,
            "y": 0.0006169863045215607,
            "z": -135.72901916503906
        },
        {
            "x": 0.18479512631893158,
            "y": 0.0006103627383708954,
            "z": -135.57179260253906
        },
        {
            "x": 0.18457327783107758,
            "y": 0.0006037317216396332,
            "z": -135.41444396972656
        },
        {
            "x": 0.18434984982013702,
            "y": 0.0005971100181341171,
            "z": -135.2571258544922
        },
        {
            "x": 0.18412412703037262,
            "y": 0.0005904771387577057,
            "z": -135.09988403320312
        },
        {
            "x": 0.1838967502117157,
            "y": 0.0005838498473167419,
            "z": -134.9425506591797
        },
        {
            "x": 0.1836673468351364,
            "y": 0.0005772225558757782,
            "z": -134.7853240966797
        },
        {
            "x": 0.18343590199947357,
            "y": 0.0005706008523702621,
            "z": -134.62808227539062
        },
        {
            "x": 0.18320252001285553,
            "y": 0.0005639716982841492,
            "z": -134.4706573486328
        },
        {
            "x": 0.18296706676483154,
            "y": 0.0005573462694883347,
            "z": -134.3134307861328
        },
        {
            "x": 0.1827300488948822,
            "y": 0.0005507282912731171,
            "z": -134.15611267089844
        },
        {
            "x": 0.18249067664146423,
            "y": 0.0005440954118967056,
            "z": -133.9988250732422
        },
        {
            "x": 0.182249516248703,
            "y": 0.0005374755710363388,
            "z": -133.8416290283203
        },
        {
            "x": 0.18200626969337463,
            "y": 0.000530831515789032,
            "z": -133.68418884277344
        },
        {
            "x": 0.18176104128360748,
            "y": 0.0005242228507995605,
            "z": -133.52696228027344
        },
        {
            "x": 0.1815142184495926,
            "y": 0.0005175955593585968,
            "z": -133.36972045898438
        },
        {
            "x": 0.18126483261585236,
            "y": 0.0005109738558530807,
            "z": -133.21237182617188
        },
        {
            "x": 0.18101394176483154,
            "y": 0.0005043316632509232,
            "z": -133.05514526367188
        },
        {
            "x": 0.18076078593730927,
            "y": 0.0004976950585842133,
            "z": -132.89781188964844
        },
        {
            "x": 0.18050554394721985,
            "y": 0.0004976688651368022,
            "z": -132.740478515625
        },
        {
            "x": 0.1802487075328827,
            "y": 0.0007324323523789644,
            "z": -132.58323669433594
        },
        {
            "x": 0.18007414042949677,
            "y": 0.0011002847459167242,
            "z": -132.47840881347656
        },
        {
            "x": 0.1798139363527298,
            "y": 0.0019841669127345085,
            "z": -132.32119750976562
        },
        {
            "x": 0.17955158650875092,
            "y": 0.0032517039217054844,
            "z": -132.16397094726562
        },
        {
            "x": 0.1792868822813034,
            "y": 0.004888320807367563,
            "z": -132.0065155029297
        },
        {
            "x": 0.1790207028388977,
            "y": 0.0068809958174824715,
            "z": -131.8492889404297
        },
        {
            "x": 0.17875221371650696,
            "y": 0.009231475181877613,
            "z": -131.69207763671875
        },
        {
            "x": 0.17848193645477295,
            "y": 0.011932594701647758,
            "z": -131.53475952148438
        },
        {
            "x": 0.17820940911769867,
            "y": 0.014963347464799881,
            "z": -131.3775634765625
        },
        {
            "x": 0.17793503403663635,
            "y": 0.018319539725780487,
            "z": -131.22027587890625
        },
        {
            "x": 0.17765843868255615,
            "y": 0.021997690200805664,
            "z": -131.06295776367188
        },
        {
            "x": 0.17737998068332672,
            "y": 0.025986548513174057,
            "z": -130.9058074951172
        },
        {
            "x": 0.17709949612617493,
            "y": 0.030275169759988785,
            "z": -130.74850463867188
        },
        {
            "x": 0.176816925406456,
            "y": 0.034848712384700775,
            "z": -130.5913543701172
        },
        {
            "x": 0.17653267085552216,
            "y": 0.03970771282911301,
            "z": -130.43417358398438
        },
        {
            "x": 0.17624561488628387,
            "y": 0.04485135152935982,
            "z": -130.27682495117188
        },
        {
            "x": 0.17595723271369934,
            "y": 0.05024941265583038,
            "z": -130.1197052001953
        },
        {
            "x": 0.17566640675067902,
            "y": 0.05590295419096947,
            "z": -129.9625244140625
        },
        {
            "x": 0.17537382245063782,
            "y": 0.06180534511804581,
            "z": -129.80532836914062
        },
        {
            "x": 0.1750790923833847,
            "y": 0.06794805824756622,
            "z": -129.64822387695312
        },
        {
            "x": 0.17478208243846893,
            "y": 0.07432584464550018,
            "z": -129.49093627929688
        },
        {
            "x": 0.17448338866233826,
            "y": 0.0809134989976883,
            "z": -129.33383178710938
        },
        {
            "x": 0.17418259382247925,
            "y": 0.08771361410617828,
            "z": -129.17672729492188
        },
        {
            "x": 0.17387984693050385,
            "y": 0.09472160041332245,
            "z": -129.0196533203125
        },
        {
            "x": 0.1735748052597046,
            "y": 0.10192029178142548,
            "z": -128.8625946044922
        },
        {
            "x": 0.17326782643795013,
            "y": 0.10930754989385605,
            "z": -128.7054443359375
        },
        {
            "x": 0.17295849323272705,
            "y": 0.11687153577804565,
            "z": -128.5482635498047
        },
        {
            "x": 0.17264753580093384,
            "y": 0.12460216134786606,
            "z": -128.3912353515625
        },
        {
            "x": 0.17233413457870483,
            "y": 0.13249467313289642,
            "z": -128.23410034179688
        },
        {
            "x": 0.1720190942287445,
            "y": 0.14053134620189667,
            "z": -128.0770721435547
        },
        {
            "x": 0.17170166969299316,
            "y": 0.14870727062225342,
            "z": -127.9200668334961
        },
        {
            "x": 0.17138205468654633,
            "y": 0.1570306122303009,
            "z": -127.76286315917969
        },
        {
            "x": 0.17106053233146667,
            "y": 0.16546693444252014,
            "z": -127.60585021972656
        },
        {
            "x": 0.17073704302310944,
            "y": 0.17401961982250214,
            "z": -127.44877624511719
        },
        {
            "x": 0.1704113632440567,
            "y": 0.1826769858598709,
            "z": -127.2917251586914
        },
        {
            "x": 0.17008370161056519,
            "y": 0.1914311647415161,
            "z": -127.13475036621094
        },
        {
            "x": 0.16975359618663788,
            "y": 0.20028512179851532,
            "z": -126.97757720947266
        },
        {
            "x": 0.16942177712917328,
            "y": 0.20920626819133759,
            "z": -126.82060241699219
        },
        {
            "x": 0.1690879613161087,
            "y": 0.21819806098937988,
            "z": -126.66362762451172
        },
        {
            "x": 0.16875171661376953,
            "y": 0.227261483669281,
            "z": -126.50652313232422
        },
        {
            "x": 0.16841359436511993,
            "y": 0.23637112975120544,
            "z": -126.34955596923828
        },
        {
            "x": 0.16807317733764648,
            "y": 0.24553069472312927,
            "z": -126.1924819946289
        },
        {
            "x": 0.16773079335689545,
            "y": 0.25472646951675415,
            "z": -126.0354232788086
        },
        {
            "x": 0.16738630831241608,
            "y": 0.26394355297088623,
            "z": -125.87846374511719
        },
        {
            "x": 0.1671556830406189,
            "y": 0.2700994312763214,
            "z": -125.7738265991211
        },
        {
            "x": 0.16680775582790375,
            "y": 0.2793428301811218,
            "z": -125.61686706542969
        },
        {
            "x": 0.16645784676074982,
            "y": 0.288590669631958,
            "z": -125.45990753173828
        },
        {
            "x": 0.16610519587993622,
            "y": 0.2978453040122986,
            "z": -125.30274963378906
        },
        {
            "x": 0.1657511442899704,
            "y": 0.3070744276046753,
            "z": -125.14579772949219
        },
        {
            "x": 0.16539466381072998,
            "y": 0.31628209352493286,
            "z": -124.98883056640625
        },
        {
            "x": 0.1650361716747284,
            "y": 0.32546454668045044,
            "z": -124.83177185058594
        },
        {
            "x": 0.1646755039691925,
            "y": 0.33460018038749695,
            "z": -124.67479705810547
        },
        {
            "x": 0.16431273519992828,
            "y": 0.343694806098938,
            "z": -124.51771545410156
        },
        {
            "x": 0.16394762694835663,
            "y": 0.35273200273513794,
            "z": -124.36065673828125
        },
        {
            "x": 0.16358083486557007,
            "y": 0.36169755458831787,
            "z": -124.20366668701172
        },
        {
            "x": 0.16321147978305817,
            "y": 0.37059345841407776,
            "z": -124.04656982421875
        },
        {
            "x": 0.16284039616584778,
            "y": 0.3794000744819641,
            "z": -123.88958740234375
        },
        {
            "x": 0.16246704757213593,
            "y": 0.38811618089675903,
            "z": -123.73259735107422
        },
        {
            "x": 0.16209131479263306,
            "y": 0.3967413902282715,
            "z": -123.57539367675781
        },
        {
            "x": 0.16171370446681976,
            "y": 0.4052436947822571,
            "z": -123.41840362548828
        },
        {
            "x": 0.16133394837379456,
            "y": 0.41363173723220825,
            "z": -123.26133728027344
        },
        {
            "x": 0.1609521061182022,
            "y": 0.4218940734863281,
            "z": -123.10426330566406
        },
        {
            "x": 0.16056811809539795,
            "y": 0.4300166964530945,
            "z": -122.94725036621094
        },
        {
            "x": 0.16018174588680267,
            "y": 0.438001424074173,
            "z": -122.79002380371094
        },
        {
            "x": 0.15979346632957458,
            "y": 0.44582459330558777,
            "z": -122.63297271728516
        },
        {
            "x": 0.15940329432487488,
            "y": 0.4534866213798523,
            "z": -122.47593688964844
        },
        {
            "x": 0.15901082754135132,
            "y": 0.46097779273986816,
            "z": -122.31887817382812
        },
        {
            "x": 0.15861636400222778,
            "y": 0.4682844281196594,
            "z": -122.16182708740234
        },
        {
            "x": 0.1582193821668625,
            "y": 0.475408673286438,
            "z": -122.0046615600586
        },
        {
            "x": 0.1578204184770584,
            "y": 0.4823371469974518,
            "z": -121.84748840332031
        },
        {
            "x": 0.15741956233978271,
            "y": 0.4890563488006592,
            "z": -121.69039154052734
        },
        {
            "x": 0.15701621770858765,
            "y": 0.49555787444114685,
            "z": -121.53318786621094
        },
        {
            "x": 0.15661115944385529,
            "y": 0.5018329620361328,
            "z": -121.37608337402344
        },
        {
            "x": 0.15620380640029907,
            "y": 0.5078781247138977,
            "z": -121.2189712524414
        },
        {
            "x": 0.15579412877559662,
            "y": 0.5136913061141968,
            "z": -121.06163787841797
        },
        {
            "x": 0.15538252890110016,
            "y": 0.5192372798919678,
            "z": -120.9045181274414
        },
        {
            "x": 0.15496884286403656,
            "y": 0.524528980255127,
            "z": -120.74730682373047
        },
        {
            "x": 0.15455308556556702,
            "y": 0.529555082321167,
            "z": -120.59009552001953
        },
        {
            "x": 0.15413524210453033,
            "y": 0.5343053340911865,
            "z": -120.43294525146484
        },
        {
            "x": 0.15371496975421906,
            "y": 0.5387647151947021,
            "z": -120.27557373046875
        },
        {
            "x": 0.15329290926456451,
            "y": 0.5429267883300781,
            "z": -120.11839294433594
        },
        {
            "x": 0.15286898612976074,
            "y": 0.5467882752418518,
            "z": -119.96121978759766
        },
        {
            "x": 0.15244267880916595,
            "y": 0.5503437519073486,
            "z": -119.80391693115234
        },
        {
            "x": 0.15201441943645477,
            "y": 0.5535639524459839,
            "z": -119.64669799804688
        },
        {
            "x": 0.15158405900001526,
            "y": 0.5564583539962769,
            "z": -119.48941040039062
        },
        {
            "x": 0.15115150809288025,
            "y": 0.5590171813964844,
            "z": -119.33209228515625
        },
        {
            "x": 0.15071727335453033,
            "y": 0.5612305402755737,
            "z": -119.17486572265625
        },
        {
            "x": 0.15042656660079956,
            "y": 0.5624959468841553,
            "z": -119.07006072998047
        },
        {
            "x": 0.14998693764209747,
            "y": 0.5641047954559326,
            "z": -118.91283416748047
        },
        {
            "x": 0.14954741299152374,
            "y": 0.5653467178344727,
            "z": -118.75559997558594
        },
        {
            "x": 0.14910514652729034,
            "y": 0.5661967992782593,
            "z": -118.59817504882812
        },
        {
            "x": 0.1486615687608719,
            "y": 0.566658616065979,
            "z": -118.44093322753906
        },
        {
            "x": 0.14821600914001465,
            "y": 0.5667270421981812,
            "z": -118.28369903564453
        },
        {
            "x": 0.14776816964149475,
            "y": 0.5663994550704956,
            "z": -118.12635803222656
        },
        {
            "x": 0.1473187655210495,
            "y": 0.5656678676605225,
            "z": -117.96913146972656
        },
        {
            "x": 0.14686711132526398,
            "y": 0.5645533800125122,
            "z": -117.81181335449219
        },
        {
            "x": 0.14641350507736206,
            "y": 0.5630680322647095,
            "z": -117.65447998046875
        },
        {
            "x": 0.14595845341682434,
            "y": 0.5612215995788574,
            "z": -117.49726867675781
        },
        {
            "x": 0.14550115168094635,
            "y": 0.5590064525604248,
            "z": -117.33992767333984
        },
        {
            "x": 0.14504225552082062,
            "y": 0.5564454793930054,
            "z": -117.1827163696289
        },
        {
            "x": 0.14458167552947998,
            "y": 0.5535487532615662,
            "z": -117.0255126953125
        },
        {
            "x": 0.14411872625350952,
            "y": 0.5503209829330444,
            "z": -116.86811065673828
        },
        {
            "x": 0.1436544805765152,
            "y": 0.5467673540115356,
            "z": -116.7109146118164
        },
        {
            "x": 0.14318841695785522,
            "y": 0.5428993701934814,
            "z": -116.5536880493164
        },
        {
            "x": 0.14272066950798035,
            "y": 0.5387307405471802,
            "z": -116.39644622802734
        },
        {
            "x": 0.1422513872385025,
            "y": 0.5342720150947571,
            "z": -116.23928833007812
        },
        {
            "x": 0.14177986979484558,
            "y": 0.5295138359069824,
            "z": -116.0819320678711
        },
        {
            "x": 0.14130732417106628,
            "y": 0.5244836807250977,
            "z": -115.92477416992188
        },
        {
            "x": 0.14083325862884521,
            "y": 0.5191881060600281,
            "z": -115.76763153076172
        },
        {
            "x": 0.1403576135635376,
            "y": 0.5136356353759766,
            "z": -115.6104965209961
        },
        {
            "x": 0.1398804783821106,
            "y": 0.5078268051147461,
            "z": -115.45335388183594
        },
        {
            "x": 0.1394016593694687,
            "y": 0.5017719268798828,
            "z": -115.29615783691406
        },
        {
            "x": 0.13892140984535217,
            "y": 0.4954856038093567,
            "z": -115.13895416259766
        },
        {
            "x": 0.1384400725364685,
            "y": 0.48898112773895264,
            "z": -114.98184967041016
        },
        {
            "x": 0.13795721530914307,
            "y": 0.4822538197040558,
            "z": -114.82466125488281
        },
        {
            "x": 0.13747335970401764,
            "y": 0.4753217101097107,
            "z": -114.66758728027344
        },
        {
            "x": 0.1369883269071579,
            "y": 0.4681938886642456,
            "z": -114.51051330566406
        },
        {
            "x": 0.13650165498256683,
            "y": 0.4608704447746277,
            "z": -114.35326385498047
        },
        {
            "x": 0.13601447641849518,
            "y": 0.4533730745315552,
            "z": -114.19620513916016
        },
        {
            "x": 0.1355261504650116,
            "y": 0.4456992745399475,
            "z": -114.03910064697266
        },
        {
            "x": 0.13503699004650116,
            "y": 0.43786466121673584,
            "z": -113.88200378417969
        },
        {
            "x": 0.1345471292734146,
            "y": 0.42988115549087524,
            "z": -113.72498321533203
        },
        {
            "x": 0.13405609130859375,
            "y": 0.4217401146888733,
            "z": -113.56775665283203
        },
        {
            "x": 0.13356488943099976,
            "y": 0.4134714901447296,
            "z": -113.4107437133789
        },
        {
            "x": 0.13307330012321472,
            "y": 0.4050769805908203,
            "z": -113.25374603271484
        },
        {
            "x": 0.13258096575737,
            "y": 0.39655810594558716,
            "z": -113.09663391113281
        },
        {
            "x": 0.13208867609500885,
            "y": 0.38793569803237915,
            "z": -112.93964385986328
        },
        {
            "x": 0.13159595429897308,
            "y": 0.3792034685611725,
            "z": -112.78255462646484
        },
        {
            "x": 0.1311032772064209,
            "y": 0.3703800439834595,
            "z": -112.62545776367188
        },
        {
            "x": 0.13061106204986572,
            "y": 0.3614797592163086,
            "z": -112.46847534179688
        },
        {
            "x": 0.1302831768989563,
            "y": 0.3555032014846802,
            "z": -112.36383056640625
        },
        {
            "x": 0.12979163229465485,
            "y": 0.3464820384979248,
            "z": -112.20686340332031
        },
        {
            "x": 0.12930069863796234,
            "y": 0.33740025758743286,
            "z": -112.04988098144531
        },
        {
            "x": 0.12881021201610565,
            "y": 0.32825616002082825,
            "z": -111.8927230834961
        },
        {
            "x": 0.12832140922546387,
            "y": 0.319080114364624,
            "z": -111.73577880859375
        },
        {
            "x": 0.12783396244049072,
            "y": 0.3098697364330292,
            "z": -111.57881164550781
        },
        {
            "x": 0.12734785676002502,
            "y": 0.30062803626060486,
            "z": -111.42174530029297
        },
        {
            "x": 0.12686410546302795,
            "y": 0.29137665033340454,
            "z": -111.26480102539062
        },
        {
            "x": 0.12638242542743683,
            "y": 0.2821108102798462,
            "z": -111.10774993896484
        },
        {
            "x": 0.1259034276008606,
            "y": 0.27284538745880127,
            "z": -110.95067596435547
        },
        {
            "x": 0.12542781233787537,
            "y": 0.26359647512435913,
            "z": -110.79373168945312
        },
        {
            "x": 0.12495550513267517,
            "y": 0.254358172416687,
            "z": -110.63666534423828
        },
        {
            "x": 0.12448789179325104,
            "y": 0.24515551328659058,
            "z": -110.479736328125
        },
        {
            "x": 0.12402492761611938,
            "y": 0.23598787188529968,
            "z": -110.3227767944336
        },
        {
            "x": 0.12356690317392349,
            "y": 0.22685229778289795,
            "z": -110.16561889648438
        },
        {
            "x": 0.12311553210020065,
            "y": 0.217781201004982,
            "z": -110.00865173339844
        },
        {
            "x": 0.12267135828733444,
            "y": 0.20877069234848022,
            "z": -109.85162353515625
        },
        {
            "x": 0.12223539501428604,
            "y": 0.19983123242855072,
            "z": -109.6946029663086
        },
        {
            "x": 0.12180876731872559,
            "y": 0.19097396731376648,
            "z": -109.53763580322266
        },
        {
            "x": 0.12139217555522919,
            "y": 0.18219147622585297,
            "z": -109.38044738769531
        },
        {
            "x": 0.12098883837461472,
            "y": 0.17352107167243958,
            "z": -109.22345733642578
        },
        {
            "x": 0.12059970945119858,
            "y": 0.16495686769485474,
            "z": -109.06649017333984
        },
        {
            "x": 0.12022694945335388,
            "y": 0.1565050631761551,
            "z": -108.90947723388672
        },
        {
            "x": 0.11987326294183731,
            "y": 0.14817598462104797,
            "z": -108.75247955322266
        },
        {
            "x": 0.1195426881313324,
            "y": 0.13997620344161987,
            "z": -108.59539031982422
        },
        {
            "x": 0.11923927068710327,
            "y": 0.13191893696784973,
            "z": -108.43829345703125
        },
        {
            "x": 0.11896833032369614,
            "y": 0.12401517480611801,
            "z": -108.28128814697266
        },
        {
            "x": 0.11872325092554092,
            "y": 0.11626023054122925,
            "z": -108.1241226196289
        },
        {
            "x": 0.11826442927122116,
            "y": 0.10866130888462067,
            "z": -107.96665954589844
        },
        {
            "x": 0.11686423420906067,
            "y": 0.10121968388557434,
            "z": -107.80873107910156
        },
        {
            "x": 0.11425315588712692,
            "y": 0.09395094215869904,
            "z": -107.65055847167969
        },
        {
            "x": 0.11048002541065216,
            "y": 0.0868881493806839,
            "z": -107.49267578125
        },
        {
            "x": 0.10559011995792389,
            "y": 0.08003149926662445,
            "z": -107.33480072021484
        },
        {
            "x": 0.0996508002281189,
            "y": 0.07339434325695038,
            "z": -107.177001953125
        },
        {
            "x": 0.09275636821985245,
            "y": 0.06698162853717804,
            "z": -107.01934051513672
        },
        {
            "x": 0.08495596796274185,
            "y": 0.06079154461622238,
            "z": -106.86158752441406
        },
        {
            "x": 0.07632429897785187,
            "y": 0.05485191196203232,
            "z": -106.7040786743164
        },
        {
            "x": 0.06691603362560272,
            "y": 0.049167733639478683,
            "z": -106.54668426513672
        },
        {
            "x": 0.05680249631404877,
            "y": 0.04373530298471451,
            "z": -106.3892593383789
        },
        {
            "x": 0.04605431854724884,
            "y": 0.038569942116737366,
            "z": -106.23200988769531
        },
        {
            "x": 0.03471910208463669,
            "y": 0.0336780771613121,
            "z": -106.07473754882812
        },
        {
            "x": 0.02283884584903717,
            "y": 0.029076440259814262,
            "z": -105.91754150390625
        },
        {
            "x": 0.010498471558094025,
            "y": 0.024766407907009125,
            "z": -105.76052856445312
        },
        {
            "x": 0.0020460039377212524,
            "y": 0.022053580731153488,
            "z": -105.65586853027344
        },
        {
            "x": -0.010976158082485199,
            "y": 0.01825285330414772,
            "z": -105.49894714355469
        },
        {
            "x": -0.024328850209712982,
            "y": 0.014763366430997849,
            "z": -105.34207916259766
        },
        {
            "x": -0.03799615055322647,
            "y": 0.01158891711384058,
            "z": -105.18505096435547
        },
        {
            "x": -0.05189717561006546,
            "y": 0.00875004567205906,
            "z": -105.0282974243164
        },
        {
            "x": -0.0660192221403122,
            "y": 0.00626011285930872,
            "z": -104.87157440185547
        },
        {
            "x": -0.08032667636871338,
            "y": 0.004113458562642336,
            "z": -104.71477508544922
        },
        {
            "x": -0.09476644545793533,
            "y": 0.002321331761777401,
            "z": -104.5581283569336
        },
        {
            "x": -0.10932272672653198,
            "y": 0.0008931037737056613,
            "z": -104.40139770507812
        },
        {
            "x": -0.12396330386400223,
            "y": -0.00014959345571696758,
            "z": -104.24470520019531
        },
        {
            "x": -0.13864310085773468,
            "y": -0.0008127356413751841,
            "z": -104.08811950683594
        },
        {
            "x": -0.15336117148399353,
            "y": -0.0010887098032981157,
            "z": -103.93144989013672
        },
        {
            "x": -0.16806858777999878,
            "y": -0.0011070724576711655,
            "z": -103.77491760253906
        },
        {
            "x": -0.18275325000286102,
            "y": -0.0011131223291158676,
            "z": -103.6183853149414
        },
        {
            "x": -0.1974128782749176,
            "y": -0.0011191628873348236,
            "z": -103.46167755126953
        },
        {
            "x": -0.21199223399162292,
            "y": -0.0011252015829086304,
            "z": -103.30518341064453
        },
        {
            "x": -0.226498544216156,
            "y": -0.0011312421411275864,
            "z": -103.14861297607422
        },
        {
            "x": -0.24090617895126343,
            "y": -0.0011372864246368408,
            "z": -102.99207305908203
        },
        {
            "x": -0.2552003860473633,
            "y": -0.0011433325707912445,
            "z": -102.8355712890625
        },
        {
            "x": -0.2693879008293152,
            "y": -0.0011493731290102005,
            "z": -102.67887878417969
        },
        {
            "x": -0.28341954946517944,
            "y": -0.0011554248631000519,
            "z": -102.52236938476562
        },
        {
            "x": -0.2972986698150635,
            "y": -0.0011614542454481125,
            "z": -102.36587524414062
        },
        {
            "x": -0.3110203742980957,
            "y": -0.0011675041168928146,
            "z": -102.20935821533203
        },
        {
            "x": -0.32457613945007324,
            "y": -0.0011735353618860245,
            "z": -102.05284118652344
        },
        {
            "x": -0.33796459436416626,
            "y": -0.0011795833706855774,
            "z": -101.89620971679688
        },
        {
            "x": -0.3511625826358795,
            "y": -0.0011856239289045334,
            "z": -101.73957061767578
        },
        {
            "x": -0.3641600012779236,
            "y": -0.0011916663497686386,
            "z": -101.58301544189453
        },
        {
            "x": -0.3769702911376953,
            "y": -0.0011976994574069977,
            "z": -101.42634582519531
        },
        {
            "x": -0.38957175612449646,
            "y": -0.0012037493288516998,
            "z": -101.26976776123047
        },
        {
            "x": -0.40195295214653015,
            "y": -0.0012097954750061035,
            "z": -101.1131820678711
        },
        {
            "x": -0.41413745284080505,
            "y": -0.0012158416211605072,
            "z": -100.95637512207031
        },
        {
            "x": -0.42608970403671265,
            "y": -0.0012218859046697617,
            "z": -100.79975891113281
        },
        {
            "x": -0.4378279447555542,
            "y": -0.0012279357761144638,
            "z": -100.64307403564453
        },
        {
            "x": -0.4493313133716583,
            "y": -0.001233970746397972,
            "z": -100.48635864257812
        },
        {
            "x": -0.46060532331466675,
            "y": -0.001240011304616928,
            "z": -100.3296890258789
        },
        {
            "x": -0.4716665744781494,
            "y": -0.0012460630387067795,
            "z": -100.17280578613281
        },
        {
            "x": -0.4824844002723694,
            "y": -0.0012520961463451385,
            "z": -100.01612854003906
        },
        {
            "x": -0.493059366941452,
            "y": -0.0012581441551446915,
            "z": -99.85941314697266
        },
        {
            "x": -0.5034054517745972,
            "y": -0.0012641903012990952,
            "z": -99.70258331298828
        },
        {
            "x": -0.5135118365287781,
            "y": -0.001270228996872902,
            "z": -99.54584503173828
        },
        {
            "x": -0.5233895182609558,
            "y": -0.0012762676924467087,
            "z": -99.38899230957031
        },
        {
            "x": -0.53302401304245,
            "y": -0.0012823250144720078,
            "z": -99.23210144042969
        },
        {
            "x": -0.5424137711524963,
            "y": -0.0012883581221103668,
            "z": -99.0753402709961
        },
        {
            "x": -0.54854416847229,
            "y": -0.0012923851609230042,
            "z": -98.97080993652344
        },
        {
            "x": -0.5575360655784607,
            "y": -0.001298423856496811,
            "z": -98.81402587890625
        },
        {
            "x": -0.5662896633148193,
            "y": -0.0013044625520706177,
            "z": -98.65719604492188
        },
        {
            "x": -0.5748186707496643,
            "y": -0.0013105180114507675,
            "z": -98.50016021728516
        },
        {
            "x": -0.5831000804901123,
            "y": -0.0013165529817342758,
            "z": -98.34332275390625
        },
        {
            "x": -0.591136634349823,
            "y": -0.0013225898146629333,
            "z": -98.18645477294922
        },
        {
            "x": -0.5989435911178589,
            "y": -0.0013286378234624863,
            "z": -98.02947235107422
        },
        {
            "x": -0.6065108180046082,
            "y": -0.0013125159312039614,
            "z": -97.8725814819336
        },
        {
            "x": -0.6138511896133423,
            "y": -0.001156179467216134,
            "z": -97.71558380126953
        },
        {
            "x": -0.6209502220153809,
            "y": -0.0008276836015284061,
            "z": -97.55857849121094
        },
        {
            "x": -0.6278113722801208,
            "y": -0.00033468008041381836,
            "z": -97.40164947509766
        },
        {
            "x": -0.6344484090805054,
            "y": 0.00031802349258214235,
            "z": -97.24461364746094
        },
        {
            "x": -0.6408530473709106,
            "y": 0.0011262614279985428,
            "z": -97.08765411376953
        },
        {
            "x": -0.647020697593689,
            "y": 0.0020921644754707813,
            "z": -96.93070983886719
        },
        {
            "x": -0.6529667377471924,
            "y": 0.0032110409811139107,
            "z": -96.77354431152344
        },
        {
            "x": -0.6586822271347046,
            "y": 0.004474326968193054,
            "z": -96.61658477783203
        },
        {
            "x": -0.6641755104064941,
            "y": 0.005880499258637428,
            "z": -96.45956420898438
        },
        {
            "x": -0.6694379448890686,
            "y": 0.007430508267134428,
            "z": -96.3025131225586
        },
        {
            "x": -0.6744771003723145,
            "y": 0.00911794789135456,
            "z": -96.14552307128906
        },
        {
            "x": -0.6793033480644226,
            "y": 0.010940002277493477,
            "z": -95.98833465576172
        },
        {
            "x": -0.6839053630828857,
            "y": 0.012889022938907146,
            "z": -95.83131408691406
        },
        {
            "x": -0.6882883310317993,
            "y": 0.01496740709990263,
            "z": -95.67430877685547
        },
        {
            "x": -0.6924519538879395,
            "y": 0.017170216888189316,
            "z": -95.51728820800781
        },
        {
            "x": -0.6964025497436523,
            "y": 0.019491899758577347,
            "z": -95.36026763916016
        },
        {
            "x": -0.7001460194587708,
            "y": 0.0219308789819479,
            "z": -95.20314025878906
        },
        {
            "x": -0.7036719918251038,
            "y": 0.024485159665346146,
            "z": -95.0459976196289
        },
        {
            "x": -0.7069832682609558,
            "y": 0.02714897319674492,
            "z": -94.88896179199219
        },
        {
            "x": -0.710091769695282,
            "y": 0.029920000582933426,
            "z": -94.7318115234375
        },
        {
            "x": -0.7129920721054077,
            "y": 0.03279103711247444,
            "z": -94.57478332519531
        },
        {
            "x": -0.71568763256073,
            "y": 0.035763222724199295,
            "z": -94.41773986816406
        },
        {
            "x": -0.7181805372238159,
            "y": 0.03883691504597664,
            "z": -94.26049041748047
        },
        {
            "x": -0.7204697132110596,
            "y": 0.04199839010834694,
            "z": -94.10344696044922
        },
        {
            "x": -0.7225626707077026,
            "y": 0.045249778777360916,
            "z": -93.94633483886719
        },
        {
            "x": -0.7244510054588318,
            "y": 0.0485881008207798,
            "z": -93.78922271728516
        },
        {
            "x": -0.7261417508125305,
            "y": 0.05200887471437454,
            "z": -93.63218688964844
        },
        {
            "x": -0.7276423573493958,
            "y": 0.05551254004240036,
            "z": -93.47493743896484
        },
        {
            "x": -0.7289516925811768,
            "y": 0.05908677726984024,
            "z": -93.31787872314453
        },
        {
            "x": -0.7300667762756348,
            "y": 0.0627339631319046,
            "z": -93.16082763671875
        },
        {
            "x": -0.7309845089912415,
            "y": 0.06645390391349792,
            "z": -93.003662109375
        },
        {
            "x": -0.7317138314247131,
            "y": 0.0702359527349472,
            "z": -92.84659576416016
        },
        {
            "x": -0.7322466373443604,
            "y": 0.07408127188682556,
            "z": -92.6894760131836
        },
        {
            "x": -0.7325514554977417,
            "y": 0.07798531651496887,
            "z": -92.53236389160156
        },
        {
            "x": -0.7325340509414673,
            "y": 0.08194218575954437,
            "z": -92.37540435791016
        },
        {
            "x": -0.7323102355003357,
            "y": 0.08460739254951477,
            "z": -92.27080535888672
        },
        {
            "x": -0.7316073775291443,
            "y": 0.08864632248878479,
            "z": -92.11393737792969
        },
        {
            "x": -0.7303820848464966,
            "y": 0.092732734978199,
            "z": -91.95709228515625
        },
        {
            "x": -0.7286327481269836,
            "y": 0.09686727821826935,
            "z": -91.8000717163086
        },
        {
            "x": -0.7263588309288025,
            "y": 0.10103631019592285,
            "z": -91.64324188232422
        },
        {
            "x": -0.723558247089386,
            "y": 0.10524174571037292,
            "z": -91.48645782470703
        },
        {
            "x": -0.7202126979827881,
            "y": 0.10948488116264343,
            "z": -91.32955169677734
        },
        {
            "x": -0.7163301706314087,
            "y": 0.11375483125448227,
            "z": -91.17276763916016
        },
        {
            "x": -0.7119088768959045,
            "y": 0.1180536225438118,
            "z": -91.0158920288086
        },
        {
            "x": -0.7069369554519653,
            "y": 0.12237563729286194,
            "z": -90.85904693603516
        },
        {
            "x": -0.7014204859733582,
            "y": 0.1267150193452835,
            "z": -90.70233154296875
        },
        {
            "x": -0.6953609585762024,
            "y": 0.13107386231422424,
            "z": -90.54550170898438
        },
        {
            "x": -0.6887670159339905,
            "y": 0.1354420781135559,
            "z": -90.38883209228516
        },
        {
            "x": -0.6816256046295166,
            "y": 0.13982045650482178,
            "z": -90.23217010498047
        },
        {
            "x": -0.673897922039032,
            "y": 0.14421050250530243,
            "z": -90.07533264160156
        },
        {
            "x": -0.6656419038772583,
            "y": 0.14859721064567566,
            "z": -89.91873168945312
        },
        {
            "x": -0.6568368673324585,
            "y": 0.15298479795455933,
            "z": -89.7621078491211
        },
        {
            "x": -0.6474881172180176,
            "y": 0.15736833214759827,
            "z": -89.60551452636719
        },
        {
            "x": -0.6375807523727417,
            "y": 0.16174229979515076,
            "z": -89.44900512695312
        },
        {
            "x": -0.6271082162857056,
            "y": 0.16611096262931824,
            "z": -89.29232788085938
        },
        {
            "x": -0.6161081790924072,
            "y": 0.17045968770980835,
            "z": -89.1358871459961
        },
        {
            "x": -0.6045610308647156,
            "y": 0.1747906655073166,
            "z": -88.9794921875
        },
        {
            "x": -0.5924411416053772,
            "y": 0.17909947037696838,
            "z": -88.82313537597656
        },
        {
            "x": -0.579785943031311,
            "y": 0.1833837479352951,
            "z": -88.66681671142578
        },
        {
            "x": -0.566584050655365,
            "y": 0.18764235079288483,
            "z": -88.51043701171875
        },
        {
            "x": -0.5528414845466614,
            "y": 0.19186972081661224,
            "z": -88.35411071777344
        },
        {
            "x": -0.5385546684265137,
            "y": 0.1960580050945282,
            "z": -88.19791412353516
        },
        {
            "x": -0.523722231388092,
            "y": 0.20021051168441772,
            "z": -88.04166412353516
        },
        {
            "x": -0.5083737373352051,
            "y": 0.2043185532093048,
            "z": -87.88556671142578
        },
        {
            "x": -0.4925042390823364,
            "y": 0.20838147401809692,
            "z": -87.72952270507812
        },
        {
            "x": -0.4760630130767822,
            "y": 0.21239835023880005,
            "z": -87.57333374023438
        },
        {
            "x": -0.45912373065948486,
            "y": 0.21635796129703522,
            "z": -87.41738891601562
        },
        {
            "x": -0.441668838262558,
            "y": 0.22026339173316956,
            "z": -87.26146697998047
        },
        {
            "x": -0.4237018823623657,
            "y": 0.22411015629768372,
            "z": -87.1055679321289
        },
        {
            "x": -0.40522050857543945,
            "y": 0.22789041697978973,
            "z": -86.94977569580078
        },
        {
            "x": -0.38621756434440613,
            "y": 0.23160891234874725,
            "z": -86.79385375976562
        },
        {
            "x": -0.3667503297328949,
            "y": 0.23525337874889374,
            "z": -86.63819885253906
        },
        {
            "x": -0.34679532051086426,
            "y": 0.23882538080215454,
            "z": -86.48257446289062
        },
        {
            "x": -0.3263363540172577,
            "y": 0.24232035875320435,
            "z": -86.32691192626953
        },
        {
            "x": -0.30542293190956116,
            "y": 0.24573266506195068,
            "z": -86.17140197753906
        },
        {
            "x": -0.2840351462364197,
            "y": 0.24906399846076965,
            "z": -86.0158462524414
        },
        {
            "x": -0.26219162344932556,
            "y": 0.25230884552001953,
            "z": -85.8603515625
        },
        {
            "x": -0.2399088442325592,
            "y": 0.25545811653137207,
            "z": -85.70502471923828
        },
        {
            "x": -0.22481006383895874,
            "y": 0.25750571489334106,
            "z": -85.60147857666016
        },
        {
            "x": -0.20181727409362793,
            "y": 0.2604978680610657,
            "z": -85.44622802734375
        },
        {
            "x": -0.17838802933692932,
            "y": 0.26338762044906616,
            "z": -85.29103088378906
        },
        {
            "x": -0.15451887249946594,
            "y": 0.266176700592041,
            "z": -85.13568115234375
        },
        {
            "x": -0.1302913874387741,
            "y": 0.26885607838630676,
            "z": -84.98060607910156
        },
        {
            "x": -0.10568182170391083,
            "y": 0.2714260518550873,
            "z": -84.8255615234375
        },
        {
            "x": -0.08067436516284943,
            "y": 0.27388104796409607,
            "z": -84.67044830322266
        },
        {
            "x": -0.05532050132751465,
            "y": 0.2762158215045929,
            "z": -84.51551055908203
        },
        {
            "x": -0.02960909903049469,
            "y": 0.2784322500228882,
            "z": -84.36052703857422
        },
        {
            "x": -0.003564313054084778,
            "y": 0.28052520751953125,
            "z": -84.20557403564453
        },
        {
            "x": 0.022783823311328888,
            "y": 0.2824860215187073,
            "z": -84.05077362060547
        },
        {
            "x": 0.04945741593837738,
            "y": 0.2843155860900879,
            "z": -83.8958969116211
        },
        {
            "x": 0.0763954371213913,
            "y": 0.2860100269317627,
            "z": -83.74116516113281
        },
        {
            "x": 0.10360411554574966,
            "y": 0.28756749629974365,
            "z": -83.58648681640625
        },
        {
            "x": 0.1311081051826477,
            "y": 0.28898197412490845,
            "z": -83.43163299560547
        },
        {
            "x": 0.1588190197944641,
            "y": 0.2902476191520691,
            "z": -83.27700805664062
        },
        {
            "x": 0.18676508963108063,
            "y": 0.29136621952056885,
            "z": -83.12235260009766
        },
        {
            "x": 0.21491160988807678,
            "y": 0.29233384132385254,
            "z": -82.96772003173828
        },
        {
            "x": 0.24323944747447968,
            "y": 0.2931423783302307,
            "z": -82.81318664550781
        },
        {
            "x": 0.2717769742012024,
            "y": 0.29379037022590637,
            "z": -82.658447265625
        },
        {
            "x": 0.3004288077354431,
            "y": 0.29427623748779297,
            "z": -82.50395202636719
        },
        {
            "x": 0.3292121887207031,
            "y": 0.29459720849990845,
            "z": -82.34945678710938
        },
        {
            "x": 0.3581099510192871,
            "y": 0.2946324944496155,
            "z": -82.1949691772461
        },
        {
            "x": 0.38710612058639526,
            "y": 0.29418760538101196,
            "z": -82.04048919677734
        },
        {
            "x": 0.41619396209716797,
            "y": 0.29327213764190674,
            "z": -81.88591766357422
        },
        {
            "x": 0.4453360140323639,
            "y": 0.2918952703475952,
            "z": -81.73136138916016
        },
        {
            "x": 0.474497526884079,
            "y": 0.2900562882423401,
            "z": -81.5768814086914
        },
        {
            "x": 0.5036916732788086,
            "y": 0.2877618074417114,
            "z": -81.42230224609375
        },
        {
            "x": 0.5328629612922668,
            "y": 0.28503549098968506,
            "z": -81.26782989501953
        },
        {
            "x": 0.5620056986808777,
            "y": 0.2818845510482788,
            "z": -81.11334228515625
        },
        {
            "x": 0.5911426544189453,
            "y": 0.2783047556877136,
            "z": -80.9586410522461
        },
        {
            "x": 0.6201727390289307,
            "y": 0.27431172132492065,
            "z": -80.80413818359375
        },
        {
            "x": 0.6491333246231079,
            "y": 0.2699194848537445,
            "z": -80.6495361328125
        },
        {
            "x": 0.6779851913452148,
            "y": 0.26513898372650146,
            "z": -80.49492645263672
        },
        {
            "x": 0.7066951990127563,
            "y": 0.2599738836288452,
            "z": -80.34036254882812
        },
        {
            "x": 0.7352885603904724,
            "y": 0.2544196844100952,
            "z": -80.18556213378906
        },
        {
            "x": 0.7636762857437134,
            "y": 0.24851109087467194,
            "z": -80.03092193603516
        },
        {
            "x": 0.7918761968612671,
            "y": 0.2422505021095276,
            "z": -79.87625122070312
        },
        {
            "x": 0.8198875188827515,
            "y": 0.23563632369041443,
            "z": -79.72145080566406
        },
        {
            "x": 0.8476417064666748,
            "y": 0.22868098318576813,
            "z": -79.56670379638672
        },
        {
            "x": 0.8751657009124756,
            "y": 0.22139516472816467,
            "z": -79.41182708740234
        },
        {
            "x": 0.9024235606193542,
            "y": 0.21379253268241882,
            "z": -79.25691986083984
        },
        {
            "x": 0.9293738007545471,
            "y": 0.20588311553001404,
            "z": -79.10205841064453
        },
        {
            "x": 0.9471611380577087,
            "y": 0.20043379068374634,
            "z": -78.998779296875
        },
        {
            "x": 0.9735884070396423,
            "y": 0.19202429056167603,
            "z": -78.84383392333984
        },
        {
            "x": 0.9996755123138428,
            "y": 0.1833282709121704,
            "z": -78.68883514404297
        },
        {
            "x": 1.0254331827163696,
            "y": 0.1743335872888565,
            "z": -78.5335922241211
        },
        {
            "x": 1.0507878065109253,
            "y": 0.1650831401348114,
            "z": -78.37847137451172
        },
        {
            "x": 1.0757513046264648,
            "y": 0.1555754542350769,
            "z": -78.22331237792969
        },
        {
            "x": 1.100325584411621,
            "y": 0.1458103358745575,
            "z": -78.06797790527344
        },
        {
            "x": 1.124444603919983,
            "y": 0.13580048084259033,
            "z": -77.91268157958984
        },
        {
            "x": 1.1481397151947021,
            "y": 0.1255527287721634,
            "z": -77.75724029541016
        },
        {
            "x": 1.1713844537734985,
            "y": 0.11508198082447052,
            "z": -77.60173034667969
        },
        {
            "x": 1.194144368171692,
            "y": 0.1044037863612175,
            "z": -77.44627380371094
        },
        {
            "x": 1.2164143323898315,
            "y": 0.09350278973579407,
            "z": -77.2906265258789
        },
        {
            "x": 1.238171100616455,
            "y": 0.08241255581378937,
            "z": -77.13502502441406
        },
        {
            "x": 1.259421706199646,
            "y": 0.07113400101661682,
            "z": -76.97936248779297
        },
        {
            "x": 1.280179500579834,
            "y": 0.05966182425618172,
            "z": -76.82342529296875
        },
        {
            "x": 1.3003485202789307,
            "y": 0.04802766442298889,
            "z": -76.66764068603516
        },
        {
            "x": 1.3199710845947266,
            "y": 0.036225974559783936,
            "z": -76.51173400878906
        },
        {
            "x": 1.3390353918075562,
            "y": 0.024271618574857712,
            "z": -76.35576629638672
        },
        {
            "x": 1.357531189918518,
            "y": 0.012177428230643272,
            "z": -76.19978332519531
        },
        {
            "x": 1.375449538230896,
            "y": -7.235445082187653e-05,
            "z": -76.04353332519531
        },
        {
            "x": 1.3927398920059204,
            "y": -0.01243460364639759,
            "z": -75.8874282836914
        },
        {
            "x": 1.4094363451004028,
            "y": -0.024914579465985298,
            "z": -75.73125457763672
        },
        {
            "x": 1.4255311489105225,
            "y": -0.03750317171216011,
            "z": -75.57504272460938
        },
        {
            "x": 1.440995693206787,
            "y": -0.050193723291158676,
            "z": -75.41876983642578
        },
        {
            "x": 1.4558262825012207,
            "y": -0.06298646330833435,
            "z": -75.26232147216797
        },
        {
            "x": 1.4700337648391724,
            "y": -0.07586164772510529,
            "z": -75.10582733154297
        },
        {
            "x": 1.4835991859436035,
            "y": -0.08880162239074707,
            "z": -74.94937896728516
        },
        {
            "x": 1.4965218305587769,
            "y": -0.10181593149900436,
            "z": -74.79276275634766
        },
        {
            "x": 1.5087636709213257,
            "y": -0.11487971246242523,
            "z": -74.6362075805664
        },
        {
            "x": 1.5203580856323242,
            "y": -0.12798887491226196,
            "z": -74.47962188720703
        },
        {
            "x": 1.5313138961791992,
            "y": -0.14115369319915771,
            "z": -74.32278442382812
        },
        {
            "x": 1.5415892601013184,
            "y": -0.15433122217655182,
            "z": -74.16609191894531
        },
        {
            "x": 1.5511746406555176,
            "y": -0.16753444075584412,
            "z": -74.00930786132812
        },
        {
            "x": 1.5601013898849487,
            "y": -0.18074853718280792,
            "z": -73.85247802734375
        },
        {
            "x": 1.5683563947677612,
            "y": -0.1939605325460434,
            "z": -73.69569396972656
        },
        {
            "x": 1.5759477615356445,
            "y": -0.20718327164649963,
            "z": -73.53864288330078
        },
        {
            "x": 1.5828362703323364,
            "y": -0.22037312388420105,
            "z": -73.38177490234375
        },
        {
            "x": 1.5890520811080933,
            "y": -0.2335381805896759,
            "z": -73.22486877441406
        },
        {
            "x": 1.5945959091186523,
            "y": -0.24667972326278687,
            "z": -73.06781768798828
        },
        {
            "x": 1.5994681119918823,
            "y": -0.2597696781158447,
            "z": -72.9108657836914
        },
        {
            "x": 1.6036489009857178,
            "y": -0.27281448245048523,
            "z": -72.75379180908203
        },
        {
            "x": 1.6071451902389526,
            "y": -0.28579896688461304,
            "z": -72.59668731689453
        },
        {
            "x": 1.6099704504013062,
            "y": -0.2987062633037567,
            "z": -72.43968200683594
        },
        {
            "x": 1.6114720106124878,
            "y": -0.3072681725025177,
            "z": -72.33499145507812
        },
        {
            "x": 1.6131649017333984,
            "y": -0.320037841796875,
            "z": -72.17794799804688
        },
        {
            "x": 1.6141889095306396,
            "y": -0.3327150344848633,
            "z": -72.02088928222656
        },
        {
            "x": 1.6145551204681396,
            "y": -0.3453068435192108,
            "z": -71.86361694335938
        },
        {
            "x": 1.6142488718032837,
            "y": -0.35776764154434204,
            "z": -71.70655822753906
        },
        {
            "x": 1.6132557392120361,
            "y": -0.370106965303421,
            "z": -71.54946899414062
        },
        {
            "x": 1.611592173576355,
            "y": -0.3823268413543701,
            "z": -71.39227294921875
        },
        {
            "x": 1.609247088432312,
            "y": -0.3944004774093628,
            "z": -71.23517608642578
        },
        {
            "x": 1.6061848402023315,
            "y": -0.4063339829444885,
            "z": -71.0779800415039
        },
        {
            "x": 1.6023963689804077,
            "y": -0.41810816526412964,
            "z": -70.92076110839844
        },
        {
            "x": 1.5978916883468628,
            "y": -0.4297102093696594,
            "z": -70.76365661621094
        },
        {
            "x": 1.5926439762115479,
            "y": -0.44114816188812256,
            "z": -70.6064453125
        },
        {
            "x": 1.5866456031799316,
            "y": -0.45239490270614624,
            "z": -70.4493408203125
        },
        {
            "x": 1.5798650979995728,
            "y": -0.463442862033844,
            "z": -70.2922592163086
        },
        {
            "x": 1.572292685508728,
            "y": -0.4743049144744873,
            "z": -70.13500213623047
        },
        {
            "x": 1.5639362335205078,
            "y": -0.48494473099708557,
            "z": -69.97794342041016
        },
        {
            "x": 1.554774522781372,
            "y": -0.49536895751953125,
            "z": -69.82087707519531
        },
        {
            "x": 1.5447605848312378,
            "y": -0.505557656288147,
            "z": -69.663818359375
        },
        {
            "x": 1.5339103937149048,
            "y": -0.5155070424079895,
            "z": -69.50685119628906
        },
        {
            "x": 1.5221939086914062,
            "y": -0.5252236127853394,
            "z": -69.34973907470703
        },
        {
            "x": 1.5096263885498047,
            "y": -0.5346745252609253,
            "z": -69.19286346435547
        },
        {
            "x": 1.496145248413086,
            "y": -0.5438507795333862,
            "z": -69.0360336303711
        },
        {
            "x": 1.4817646741867065,
            "y": -0.5527552366256714,
            "z": -68.87925720214844
        },
        {
            "x": 1.4664700031280518,
            "y": -0.5613785982131958,
            "z": -68.72257232666016
        },
        {
            "x": 1.4502357244491577,
            "y": -0.5697182416915894,
            "z": -68.56583404541016
        },
        {
            "x": 1.433013916015625,
            "y": -0.5777466893196106,
            "z": -68.40918731689453
        },
        {
            "x": 1.4148354530334473,
            "y": -0.5854600071907043,
            "z": -68.25271606445312
        },
        {
            "x": 1.395665168762207,
            "y": -0.5928626656532288,
            "z": -68.09623718261719
        },
        {
            "x": 1.375512719154358,
            "y": -0.5999351739883423,
            "z": -67.93997192382812
        },
        {
            "x": 1.354303240776062,
            "y": -0.6066603660583496,
            "z": -67.78382873535156
        },
        {
            "x": 1.3320220708847046,
            "y": -0.6130475997924805,
            "z": -67.62759399414062
        },
        {
            "x": 1.3087207078933716,
            "y": -0.6190745830535889,
            "z": -67.47169494628906
        },
        {
            "x": 1.2843525409698486,
            "y": -0.624742865562439,
            "z": -67.31587982177734
        },
        {
            "x": 1.2588547468185425,
            "y": -0.630028486251831,
            "z": -67.16024017333984
        },
        {
            "x": 1.232250452041626,
            "y": -0.6349285244941711,
            "z": -67.00481414794922
        },
        {
            "x": 1.204492449760437,
            "y": -0.6394476890563965,
            "z": -66.84935760498047
        },
        {
            "x": 1.1756361722946167,
            "y": -0.6435655355453491,
            "z": -66.69429016113281
        },
        {
            "x": 1.1455941200256348,
            "y": -0.6472656726837158,
            "z": -66.53944396972656
        },
        {
            "x": 1.1143385171890259,
            "y": -0.6505489349365234,
            "z": -66.38469696044922
        },
        {
            "x": 1.0819239616394043,
            "y": -0.6534177660942078,
            "z": -66.23027038574219
        },
        {
            "x": 1.0482956171035767,
            "y": -0.6559735536575317,
            "z": -66.07601928710938
        },
        {
            "x": 1.0134046077728271,
            "y": -0.6582484841346741,
            "z": -65.92201232910156
        },
        {
            "x": 0.9772881865501404,
            "y": -0.66023850440979,
            "z": -65.76839447021484
        },
        {
            "x": 0.9525401592254639,
            "y": -0.6614118814468384,
            "z": -65.66613006591797
        },
        {
            "x": 0.9143368005752563,
            "y": -0.6629215478897095,
            "z": -65.51300811767578
        },
        {
            "x": 0.8748456239700317,
            "y": -0.6641309261322021,
            "z": -65.36019134521484
        },
        {
            "x": 0.8340357542037964,
            "y": -0.6650415658950806,
            "z": -65.20752716064453
        },
        {
            "x": 0.7919865250587463,
            "y": -0.6656452417373657,
            "z": -65.05538940429688
        },
        {
            "x": 0.7486087083816528,
            "y": -0.6659290790557861,
            "z": -64.90359497070312
        },
        {
            "x": 0.7038879990577698,
            "y": -0.6658889651298523,
            "z": -64.75210571289062
        },
        {
            "x": 0.6578982472419739,
            "y": -0.665533185005188,
            "z": -64.60111236572266
        },
        {
            "x": 0.6105731725692749,
            "y": -0.66486656665802,
            "z": -64.45040893554688
        },
        {
            "x": 0.5619048476219177,
            "y": -0.6638875007629395,
            "z": -64.30014038085938
        },
        {
            "x": 0.5119447112083435,
            "y": -0.662603497505188,
            "z": -64.15040588378906
        },
        {
            "x": 0.4606388509273529,
            "y": -0.6610255241394043,
            "z": -64.00101470947266
        },
        {
            "x": 0.40808114409446716,
            "y": -0.6591619253158569,
            "z": -63.852195739746094
        },
        {
            "x": 0.35422584414482117,
            "y": -0.6570112109184265,
            "z": -63.70383834838867
        },
        {
            "x": 0.2989828884601593,
            "y": -0.6545751690864563,
            "z": -63.55579376220703
        },
        {
            "x": 0.24256832897663116,
            "y": -0.6518731713294983,
            "z": -63.40841293334961
        },
        {
            "x": 0.18490278720855713,
            "y": -0.6489075422286987,
            "z": -63.2614860534668
        },
        {
            "x": 0.12599729001522064,
            "y": -0.645679235458374,
            "z": -63.115047454833984
        },
        {
            "x": 0.06591593474149704,
            "y": -0.6421946287155151,
            "z": -62.969200134277344
        },
        {
            "x": 0.004601724445819855,
            "y": -0.6384599208831787,
            "z": -62.823646545410156
        },
        {
            "x": -0.05773648992180824,
            "y": -0.6344915628433228,
            "z": -62.67878341674805
        },
        {
            "x": -0.12115130573511124,
            "y": -0.6302859783172607,
            "z": -62.53441619873047
        },
        {
            "x": -0.18562224507331848,
            "y": -0.6258466243743896,
            "z": -62.39055252075195
        },
        {
            "x": -0.2510373294353485,
            "y": -0.6211867332458496,
            "z": -62.24714279174805
        },
        {
            "x": -0.3173982501029968,
            "y": -0.6163089275360107,
            "z": -62.10411071777344
        },
        {
            "x": -0.3846013844013214,
            "y": -0.6112189292907715,
            "z": -61.961517333984375
        },
        {
            "x": -0.45253780484199524,
            "y": -0.6059221029281616,
            "z": -61.819419860839844
        },
        {
            "x": -0.5212013125419617,
            "y": -0.6004244685173035,
            "z": -61.677616119384766
        },
        {
            "x": -0.5903929471969604,
            "y": -0.5947393178939819,
            "z": -61.5362434387207
        },
        {
            "x": -0.6600848436355591,
            "y": -0.5888659954071045,
            "z": -61.39516830444336
        },
        {
            "x": -0.7302701473236084,
            "y": -0.5827983617782593,
            "z": -61.254180908203125
        },
        {
            "x": -0.8006297945976257,
            "y": -0.5765643119812012,
            "z": -61.113582611083984
        },
        {
            "x": -0.8711687922477722,
            "y": -0.5701590776443481,
            "z": -60.97308349609375
        },
        {
            "x": -0.9417327046394348,
            "y": -0.5635892152786255,
            "z": -60.83266067504883
        },
        {
            "x": -1.0121320486068726,
            "y": -0.5568580627441406,
            "z": -60.69231414794922
        },
        {
            "x": -1.0823643207550049,
            "y": -0.5499657392501831,
            "z": -60.55173873901367
        },
        {
            "x": -1.152066707611084,
            "y": -0.5429364442825317,
            "z": -60.411216735839844
        },
        {
            "x": -1.2211719751358032,
            "y": -0.5357656478881836,
            "z": -60.270503997802734
        },
        {
            "x": -1.2895169258117676,
            "y": -0.5284488201141357,
            "z": -60.129390716552734
        },
        {
            "x": -1.3568466901779175,
            "y": -0.5210081338882446,
            "z": -59.98801803588867
        },
        {
            "x": -1.4230577945709229,
            "y": -0.5134400725364685,
            "z": -59.84611511230469
        },
        {
            "x": -1.487906813621521,
            "y": -0.505754828453064,
            "z": -59.70368194580078
        },
        {
            "x": -1.5510575771331787,
            "y": -0.4979591965675354,
            "z": -59.56071853637695
        },
        {
            "x": -1.592185616493225,
            "y": -0.492704838514328,
            "z": -59.46503829956055
        },
        {
            "x": -1.652267575263977,
            "y": -0.48474276065826416,
            "z": -59.32093048095703
        },
        {
            "x": -1.7100940942764282,
            "y": -0.4766842722892761,
            "z": -59.175987243652344
        },
        {
            "x": -1.7658950090408325,
            "y": -0.4685194194316864,
            "z": -59.029903411865234
        },
        {
            "x": -1.8200939893722534,
            "y": -0.460269957780838,
            "z": -58.8831787109375
        },
        {
            "x": -1.8730367422103882,
            "y": -0.45193925499916077,
            "z": -58.73593521118164
        },
        {
            "x": -1.92475426197052,
            "y": -0.4435262084007263,
            "z": -58.58810806274414
        },
        {
            "x": -1.9752438068389893,
            "y": -0.43505245447158813,
            "z": -58.439979553222656
        },
        {
            "x": -2.024620294570923,
            "y": -0.4265121519565582,
            "z": -58.29134750366211
        },
        {
            "x": -2.0728838443756104,
            "y": -0.41791653633117676,
            "z": -58.142333984375
        },
        {
            "x": -2.1199960708618164,
            "y": -0.40927544236183167,
            "z": -57.993045806884766
        },
        {
            "x": -2.1660709381103516,
            "y": -0.40058380365371704,
            "z": -57.84330749511719
        },
        {
            "x": -2.2110824584960938,
            "y": -0.39186087250709534,
            "z": -57.69335174560547
        },
        {
            "x": -2.255086898803711,
            "y": -0.3831058740615845,
            "z": -57.5430908203125
        },
        {
            "x": -2.298133611679077,
            "y": -0.3743121027946472,
            "z": -57.3923225402832
        },
        {
            "x": -2.340149402618408,
            "y": -0.3655086159706116,
            "z": -57.24147033691406
        },
        {
            "x": -2.381237506866455,
            "y": -0.35668691992759705,
            "z": -57.09029769897461
        },
        {
            "x": -2.4213972091674805,
            "y": -0.3478557765483856,
            "z": -56.93886947631836
        },
        {
            "x": -2.4606103897094727,
            "y": -0.339023619890213,
            "z": -56.78723907470703
        },
        {
            "x": -2.498967170715332,
            "y": -0.33018141984939575,
            "z": -56.635169982910156
        },
        {
            "x": -2.536400079727173,
            "y": -0.3213581442832947,
            "z": -56.48307418823242
        },
        {
            "x": -2.572974681854248,
            "y": -0.3125324845314026,
            "z": -56.33076477050781
        },
        {
            "x": -2.6086747646331787,
            "y": -0.3035784363746643,
            "z": -56.17824935913086
        },
        {
            "x": -2.643524646759033,
            "y": -0.2944781482219696,
            "z": -56.0255241394043
        },
        {
            "x": -2.67757511138916,
            "y": -0.2852388918399811,
            "z": -55.872528076171875
        },
        {
            "x": -2.7108094692230225,
            "y": -0.27587422728538513,
            "z": -55.71935272216797
        },
        {
            "x": -2.7432074546813965,
            "y": -0.26639610528945923,
            "z": -55.566097259521484
        },
        {
            "x": -2.77481746673584,
            "y": -0.25679901242256165,
            "z": -55.412567138671875
        },
        {
            "x": -2.8056178092956543,
            "y": -0.2471080720424652,
            "z": -55.259002685546875
        },
        {
            "x": -2.8356473445892334,
            "y": -0.23732396960258484,
            "z": -55.10527420043945
        },
        {
            "x": -2.8649466037750244,
            "y": -0.22744165360927582,
            "z": -54.95119857788086
        },
        {
            "x": -2.893415927886963,
            "y": -0.21749278903007507,
            "z": -54.797176361083984
        },
        {
            "x": -2.921154499053955,
            "y": -0.20747186243534088,
            "z": -54.642967224121094
        },
        {
            "x": -2.9481515884399414,
            "y": -0.19739103317260742,
            "z": -54.48862075805664
        },
        {
            "x": -2.9743971824645996,
            "y": -0.1872609406709671,
            "z": -54.334197998046875
        },
        {
            "x": -2.999922752380371,
            "y": -0.1770724654197693,
            "z": -54.17946243286133
        },
        {
            "x": -3.0246853828430176,
            "y": -0.16686195135116577,
            "z": -54.02480697631836
        },
        {
            "x": -3.048740863800049,
            "y": -0.1566234529018402,
            "z": -53.870025634765625
        },
        {
            "x": -3.0720937252044678,
            "y": -0.14635874330997467,
            "z": -53.71504211425781
        },
        {
            "x": -3.0946919918060303,
            "y": -0.1360892802476883,
            "z": -53.56005096435547
        },
        {
            "x": -3.116605043411255,
            "y": -0.125810444355011,
            "z": -53.404850006103516
        },
        {
            "x": -3.137817859649658,
            "y": -0.11553680896759033,
            "z": -53.249549865722656
        },
        {
            "x": -3.158324718475342,
            "y": -0.10527874529361725,
            "z": -53.09425735473633
        },
        {
            "x": -3.1715829372406006,
            "y": -0.09805842489004135,
            "z": -52.99066925048828
        },
        {
            "x": -3.190915822982788,
            "y": -0.0862119197845459,
            "z": -52.83528518676758
        },
        {
            "x": -3.2095417976379395,
            "y": -0.0731806755065918,
            "z": -52.67991256713867
        },
        {
            "x": -3.227482795715332,
            "y": -0.059001751244068146,
            "z": -52.524356842041016
        },
        {
            "x": -3.244696617126465,
            "y": -0.04383653402328491,
            "z": -52.36902618408203
        },
        {
            "x": -3.261232852935791,
            "y": -0.02777218632400036,
            "z": -52.213706970214844
        },
        {
            "x": -3.2770931720733643,
            "y": -0.010888195596635342,
            "z": -52.05829620361328
        },
        {
            "x": -3.29225754737854,
            "y": 0.006716718897223473,
            "z": -51.90299606323242
        },
        {
            "x": -3.306732416152954,
            "y": 0.024966785684227943,
            "z": -51.747623443603516
        },
        {
            "x": -3.320544481277466,
            "y": 0.04374442249536514,
            "z": -51.59225082397461
        },
        {
            "x": -3.3336715698242188,
            "y": 0.06294883042573929,
            "z": -51.43696212768555
        },
        {
            "x": -3.3461458683013916,
            "y": 0.08251702785491943,
            "z": -51.28156661987305
        },
        {
            "x": -3.3579154014587402,
            "y": 0.10233449935913086,
            "z": -51.126258850097656
        },
        {
            "x": -3.369028329849243,
            "y": 0.12231357395648956,
            "z": -50.970916748046875
        },
        {
            "x": -3.379491090774536,
            "y": 0.14239002764225006,
            "z": -50.81535720825195
        },
        {
            "x": -3.389281988143921,
            "y": 0.1624242663383484,
            "z": -50.659950256347656
        },
        {
            "x": -3.3983943462371826,
            "y": 0.18235217034816742,
            "z": -50.50442886352539
        },
        {
            "x": -3.4068403244018555,
            "y": 0.20207637548446655,
            "z": -50.34886169433594
        },
        {
            "x": -3.4146311283111572,
            "y": 0.22150272130966187,
            "z": -50.193267822265625
        },
        {
            "x": -3.421766757965088,
            "y": 0.2405720204114914,
            "z": -50.03739547729492
        },
        {
            "x": -3.4282259941101074,
            "y": 0.2591317892074585,
            "z": -49.881649017333984
        },
        {
            "x": -3.434004783630371,
            "y": 0.27711179852485657,
            "z": -49.725807189941406
        },
        {
            "x": -3.439124584197998,
            "y": 0.2944319248199463,
            "z": -49.56986618041992
        },
        {
            "x": -3.4435839653015137,
            "y": 0.31100162863731384,
            "z": -49.41383743286133
        },
        {
            "x": -3.447368621826172,
            "y": 0.3267286419868469,
            "z": -49.25759506225586
        },
        {
            "x": -3.4504690170288086,
            "y": 0.3414808213710785,
            "z": -49.101253509521484
        },
        {
            "x": -3.452890634536743,
            "y": 0.35518863797187805,
            "z": -48.94490051269531
        },
        {
            "x": -3.4546468257904053,
            "y": 0.36777690052986145,
            "z": -48.78835678100586
        },
        {
            "x": -3.4557180404663086,
            "y": 0.3791327476501465,
            "z": -48.63181686401367
        },
        {
            "x": -3.45597243309021,
            "y": 0.3891042470932007,
            "z": -48.47526168823242
        },
        {
            "x": -3.4551544189453125,
            "y": 0.39766648411750793,
            "z": -48.31852722167969
        },
        {
            "x": -3.452993869781494,
            "y": 0.40470969676971436,
            "z": -48.161983489990234
        },
        {
            "x": -3.449429512023926,
            "y": 0.41029563546180725,
            "z": -48.005348205566406
        },
        {
            "x": -3.444305419921875,
            "y": 0.4151584506034851,
            "z": -47.84874725341797
        },
        {
            "x": -3.4376718997955322,
            "y": 0.41880202293395996,
            "z": -47.69225311279297
        },
        {
            "x": -3.4294378757476807,
            "y": 0.4212109446525574,
            "z": -47.535621643066406
        },
        {
            "x": -3.4196014404296875,
            "y": 0.42245978116989136,
            "z": -47.37928009033203
        },
        {
            "x": -3.408020496368408,
            "y": 0.4225885570049286,
            "z": -47.22306823730469
        },
        {
            "x": -3.394695997238159,
            "y": 0.42172491550445557,
            "z": -47.06689453125
        },
        {
            "x": -3.379629373550415,
            "y": 0.41995659470558167,
            "z": -46.9109992980957
        },
        {
            "x": -3.3627686500549316,
            "y": 0.4173630475997925,
            "z": -46.755210876464844
        },
        {
            "x": -3.3439998626708984,
            "y": 0.4139982759952545,
            "z": -46.59965133666992
        },
        {
            "x": -3.3233819007873535,
            "y": 0.40997716784477234,
            "z": -46.444454193115234
        },
        {
            "x": -3.3086373805999756,
            "y": 0.4069835841655731,
            "z": -46.34113311767578
        },
        {
            "x": -3.284865140914917,
            "y": 0.40204179286956787,
            "z": -46.186405181884766
        },
        {
            "x": -3.259209156036377,
            "y": 0.3966623544692993,
            "z": -46.031986236572266
        },
        {
            "x": -3.231663465499878,
            "y": 0.3909227252006531,
            "z": -45.87769317626953
        },
        {
            "x": -3.202322483062744,
            "y": 0.38491740822792053,
            "z": -45.723934173583984
        },
        {
            "x": -3.171123743057251,
            "y": 0.37871408462524414,
            "z": -45.570518493652344
        },
        {
            "x": -3.138139486312866,
            "y": 0.3723968267440796,
            "z": -45.4173583984375
        },
        {
            "x": -3.1035094261169434,
            "y": 0.36605557799339294,
            "z": -45.26463317871094
        },
        {
            "x": -3.067265748977661,
            "y": 0.3597599267959595,
            "z": -45.11215591430664
        },
        {
            "x": -3.029481887817383,
            "y": 0.3535992503166199,
            "z": -44.96000289916992
        },
        {
            "x": -2.9903342723846436,
            "y": 0.34765756130218506,
            "z": -44.80824279785156
        },
        {
            "x": -2.949915647506714,
            "y": 0.34200239181518555,
            "z": -44.656639099121094
        },
        {
            "x": -2.9084229469299316,
            "y": 0.3367207646369934,
            "z": -44.50538635253906
        },
        {
            "x": -2.8659441471099854,
            "y": 0.33190199732780457,
            "z": -44.35433578491211
        },
        {
            "x": -2.8226089477539062,
            "y": 0.3276197910308838,
            "z": -44.2032356262207
        },
        {
            "x": -2.778707504272461,
            "y": 0.3239555358886719,
            "z": -44.05244445800781
        },
        {
            "x": -2.734340190887451,
            "y": 0.3209819197654724,
            "z": -43.90167236328125
        },
        {
            "x": -2.68967342376709,
            "y": 0.3188050389289856,
            "z": -43.750892639160156
        },
        {
            "x": -2.6449167728424072,
            "y": 0.31750595569610596,
            "z": -43.60013961791992
        },
        {
            "x": -2.600162982940674,
            "y": 0.3171491324901581,
            "z": -43.44911193847656
        },
        {
            "x": -2.555682897567749,
            "y": 0.31781747937202454,
            "z": -43.29817581176758
        },
        {
            "x": -2.5115857124328613,
            "y": 0.3196231722831726,
            "z": -43.14707946777344
        },
        {
            "x": -2.4680254459381104,
            "y": 0.3226354122161865,
            "z": -42.99580001831055
        },
        {
            "x": -2.425122022628784,
            "y": 0.32625842094421387,
            "z": -42.8443603515625
        },
        {
            "x": -2.382960557937622,
            "y": 0.32980257272720337,
            "z": -42.69257736206055
        },
        {
            "x": -2.3416879177093506,
            "y": 0.3332430124282837,
            "z": -42.5405158996582
        },
        {
            "x": -2.30143404006958,
            "y": 0.33657366037368774,
            "z": -42.38826370239258
        },
        {
            "x": -2.262194871902466,
            "y": 0.33979836106300354,
            "z": -42.23560333251953
        },
        {
            "x": -2.224104881286621,
            "y": 0.3429091274738312,
            "z": -42.08275604248047
        },
        {
            "x": -2.1872103214263916,
            "y": 0.34590262174606323,
            "z": -41.929595947265625
        },
        {
            "x": -2.151526927947998,
            "y": 0.34877777099609375,
            "z": -41.77592849731445
        },
        {
            "x": -2.1171507835388184,
            "y": 0.3515271544456482,
            "z": -41.62215805053711
        },
        {
            "x": -2.084047794342041,
            "y": 0.35415205359458923,
            "z": -41.468048095703125
        },
        {
            "x": -2.0522704124450684,
            "y": 0.35664546489715576,
            "z": -41.313663482666016
        },
        {
            "x": -2.021851062774658,
            "y": 0.3590012788772583,
            "z": -41.1590576171875
        },
        {
            "x": -1.9927173852920532,
            "y": 0.36122387647628784,
            "z": -41.003990173339844
        },
        {
            "x": -1.9649405479431152,
            "y": 0.3633039593696594,
            "z": -40.84889221191406
        },
        {
            "x": -1.9384794235229492,
            "y": 0.36523881554603577,
            "z": -40.693565368652344
        },
        {
            "x": -1.9133498668670654,
            "y": 0.3670232892036438,
            "z": -40.537906646728516
        },
        {
            "x": -1.8895065784454346,
            "y": 0.36865657567977905,
            "z": -40.38216781616211
        },
        {
            "x": -1.8669170141220093,
            "y": 0.3701375126838684,
            "z": -40.226131439208984
        },
        {
            "x": -1.845578908920288,
            "y": 0.37145912647247314,
            "z": -40.069942474365234
        },
        {
            "x": -1.8255199193954468,
            "y": 0.37261390686035156,
            "z": -39.91368103027344
        },
        {
            "x": -1.8127933740615845,
            "y": 0.3732946217060089,
            "z": -39.8094367980957
        },
        {
            "x": -1.7947033643722534,
            "y": 0.37417513132095337,
            "z": -39.6529426574707
        },
        {
            "x": -1.7777889966964722,
            "y": 0.3748806118965149,
            "z": -39.496337890625
        },
        {
            "x": -1.7619832754135132,
            "y": 0.3754138648509979,
            "z": -39.33942413330078
        },
        {
            "x": -1.7472479343414307,
            "y": 0.37577009201049805,
            "z": -39.18263244628906
        },
        {
            "x": -1.7334625720977783,
            "y": 0.3759452700614929,
            "z": -39.0257453918457
        },
        {
            "x": -1.7208911180496216,
            "y": 0.3759310841560364,
            "z": -38.86860656738281
        },
        {
            "x": -1.709520697593689,
            "y": 0.37573474645614624,
            "z": -38.71147918701172
        },
        {
            "x": -1.6994744539260864,
            "y": 0.37535935640335083,
            "z": -38.55411911010742
        },
        {
            "x": -1.6909226179122925,
            "y": 0.3748064637184143,
            "z": -38.39662551879883
        },
        {
            "x": -1.6840592622756958,
            "y": 0.3740745782852173,
            "z": -38.239131927490234
        },
        {
            "x": -1.6789278984069824,
            "y": 0.37317317724227905,
            "z": -38.0814323425293
        },
        {
            "x": -1.6756329536437988,
            "y": 0.37210705876350403,
            "z": -37.92377853393555
        },
        {
            "x": -1.6742491722106934,
            "y": 0.37087804079055786,
            "z": -37.7661018371582
        },
        {
            "x": -1.6748948097229004,
            "y": 0.3694818913936615,
            "z": -37.60820388793945
        },
        {
            "x": -1.6775144338607788,
            "y": 0.3679327368736267,
            "z": -37.450523376464844
        },
        {
            "x": -1.6821036338806152,
            "y": 0.3662319779396057,
            "z": -37.292842864990234
        },
        {
            "x": -1.6886588335037231,
            "y": 0.3643829822540283,
            "z": -37.13523864746094
        },
        {
            "x": -1.6972118616104126,
            "y": 0.3623843789100647,
            "z": -36.97779846191406
        },
        {
            "x": -1.7076449394226074,
            "y": 0.3602425456047058,
            "z": -36.820289611816406
        },
        {
            "x": -1.7198748588562012,
            "y": 0.3579670786857605,
            "z": -36.66313552856445
        },
        {
            "x": -1.733850359916687,
            "y": 0.35555794835090637,
            "z": -36.506141662597656
        },
        {
            "x": -1.7495670318603516,
            "y": 0.35301315784454346,
            "z": -36.34933090209961
        },
        {
            "x": -1.7668726444244385,
            "y": 0.3503425717353821,
            "z": -36.192710876464844
        },
        {
            "x": -1.7856999635696411,
            "y": 0.34754741191864014,
            "z": -36.036190032958984
        },
        {
            "x": -1.8059639930725098,
            "y": 0.34463268518447876,
            "z": -35.87986373901367
        },
        {
            "x": -1.8276399374008179,
            "y": 0.341598242521286,
            "z": -35.72385787963867
        },
        {
            "x": -1.8506098985671997,
            "y": 0.33844929933547974,
            "z": -35.56794357299805
        },
        {
            "x": -1.8747743368148804,
            "y": 0.3351929187774658,
            "z": -35.41233825683594
        },
        {
            "x": -1.9000777006149292,
            "y": 0.3318306803703308,
            "z": -35.25693893432617
        },
        {
            "x": -1.9265424013137817,
            "y": 0.3283563256263733,
            "z": -35.10154342651367
        },
        {
            "x": -1.9539848566055298,
            "y": 0.3247867226600647,
            "z": -34.94654083251953
        },
        {
            "x": -1.982392430305481,
            "y": 0.3211195170879364,
            "z": -34.79167175292969
        },
        {
            "x": -2.011697292327881,
            "y": 0.31735900044441223,
            "z": -34.63698196411133
        },
        {
            "x": -2.0418784618377686,
            "y": 0.3135060667991638,
            "z": -34.4825325012207
        },
        {
            "x": -2.0728986263275146,
            "y": 0.3095608949661255,
            "z": -34.32806396484375
        },
        {
            "x": -2.1046302318573,
            "y": 0.3055371642112732,
            "z": -34.1739501953125
        },
        {
            "x": -2.137078046798706,
            "y": 0.3014330267906189,
            "z": -34.02000427246094
        },
        {
            "x": -2.1702466011047363,
            "y": 0.2972456216812134,
            "z": -33.86610794067383
        },
        {
            "x": -2.204028367996216,
            "y": 0.2929863929748535,
            "z": -33.71247100830078
        },
        {
            "x": -2.2384285926818848,
            "y": 0.28865358233451843,
            "z": -33.55887222290039
        },
        {
            "x": -2.273397207260132,
            "y": 0.28425294160842896,
            "z": -33.40541458129883
        },
        {
            "x": -2.308901071548462,
            "y": 0.2797878682613373,
            "z": -33.252201080322266
        },
        {
            "x": -2.332855463027954,
            "y": 0.27677667140960693,
            "z": -33.15011978149414
        },
        {
            "x": -2.3691511154174805,
            "y": 0.27221202850341797,
            "z": -32.99711990356445
        },
        {
            "x": -2.405571699142456,
            "y": 0.26759073138237,
            "z": -32.844268798828125
        },
        {
            "x": -2.4417173862457275,
            "y": 0.2629089057445526,
            "z": -32.691200256347656
        },
        {
            "x": -2.4773919582366943,
            "y": 0.25818005204200745,
            "z": -32.53824234008789
        },
        {
            "x": -2.5125832557678223,
            "y": 0.25340187549591064,
            "z": -32.385189056396484
        },
        {
            "x": -2.5472331047058105,
            "y": 0.24857249855995178,
            "z": -32.23191452026367
        },
        {
            "x": -2.581228017807007,
            "y": 0.2437029331922531,
            "z": -32.07862091064453
        },
        {
            "x": -2.6145570278167725,
            "y": 0.23879064619541168,
            "z": -31.925106048583984
        },
        {
            "x": -2.647123336791992,
            "y": 0.23384156823158264,
            "z": -31.77143096923828
        },
        {
            "x": -2.6788034439086914,
            "y": 0.22886133193969727,
            "z": -31.61768913269043
        },
        {
            "x": -2.7095723152160645,
            "y": 0.22384704649448395,
            "z": -31.463659286499023
        },
        {
            "x": -2.7393202781677246,
            "y": 0.2188100516796112,
            "z": -31.309566497802734
        },
        {
            "x": -2.7679998874664307,
            "y": 0.21375009417533875,
            "z": -31.155284881591797
        },
        {
            "x": -2.7955381870269775,
            "y": 0.20866331458091736,
            "z": -31.0006046295166
        },
        {
            "x": -2.8217992782592773,
            "y": 0.20356670022010803,
            "z": -30.84592056274414
        },
        {
            "x": -2.8467860221862793,
            "y": 0.19845572113990784,
            "z": -30.690980911254883
        },
        {
            "x": -2.8704330921173096,
            "y": 0.19333556294441223,
            "z": -30.53584098815918
        },
        {
            "x": -2.8926424980163574,
            "y": 0.18821188807487488,
            "z": -30.380558013916016
        },
        {
            "x": -2.913405656814575,
            "y": 0.18307974934577942,
            "z": -30.224870681762695
        },
        {
            "x": -2.9326705932617188,
            "y": 0.1779559999704361,
            "z": -30.069196701049805
        },
        {
            "x": -2.9504387378692627,
            "y": 0.17283768951892853,
            "z": -29.913347244262695
        },
        {
            "x": -2.9666614532470703,
            "y": 0.1677287369966507,
            "z": -29.7573299407959
        },
        {
            "x": -2.9813289642333984,
            "y": 0.16263264417648315,
            "z": -29.601152420043945
        },
        {
            "x": -2.9944918155670166,
            "y": 0.15738415718078613,
            "z": -29.444765090942383
        },
        {
            "x": -3.006150722503662,
            "y": 0.15102900564670563,
            "z": -29.2883243560791
        },
        {
            "x": -3.0162978172302246,
            "y": 0.1433635652065277,
            "z": -29.13192367553711
        },
        {
            "x": -3.024963617324829,
            "y": 0.13445833325386047,
            "z": -28.975378036499023
        },
        {
            "x": -3.032216787338257,
            "y": 0.12445493787527084,
            "z": -28.818923950195312
        },
        {
            "x": -3.038107395172119,
            "y": 0.11343761533498764,
            "z": -28.662466049194336
        },
        {
            "x": -3.0426697731018066,
            "y": 0.10147027671337128,
            "z": -28.50581932067871
        },
        {
            "x": -3.0459165573120117,
            "y": 0.08865971118211746,
            "z": -28.349395751953125
        },
        {
            "x": -3.0479536056518555,
            "y": 0.07510878145694733,
            "z": -28.192941665649414
        },
        {
            "x": -3.048833131790161,
            "y": 0.06091249734163284,
            "z": -28.036516189575195
        },
        {
            "x": -3.048605442047119,
            "y": 0.04616469889879227,
            "z": -27.880186080932617
        },
        {
            "x": -3.0472779273986816,
            "y": 0.030915817245841026,
            "z": -27.72369384765625
        },
        {
            "x": -3.044961929321289,
            "y": 0.01531953550875187,
            "z": -27.56743812561035
        },
        {
            "x": -3.041701316833496,
            "y": -0.0005543881561607122,
            "z": -27.411212921142578
        },
        {
            "x": -3.0375466346740723,
            "y": -0.01662737876176834,
            "z": -27.25490379333496
        },
        {
            "x": -3.0325164794921875,
            "y": -0.032787613570690155,
            "z": -27.098726272583008
        },
        {
            "x": -3.0266835689544678,
            "y": -0.048959244042634964,
            "z": -26.942468643188477
        },
        {
            "x": -3.0200724601745605,
            "y": -0.06504003703594208,
            "z": -26.786235809326172
        },
        {
            "x": -3.0125787258148193,
            "y": -0.08092914521694183,
            "z": -26.630138397216797
        },
        {
            "x": -3.007044553756714,
            "y": -0.0913676917552948,
            "z": -26.52607536315918
        },
        {
            "x": -2.9979608058929443,
            "y": -0.1067405492067337,
            "z": -26.37001609802246
        },
        {
            "x": -2.9878029823303223,
            "y": -0.12168630212545395,
            "z": -26.213993072509766
        },
        {
            "x": -2.9764692783355713,
            "y": -0.13612030446529388,
            "z": -26.05780792236328
        },
        {
            "x": -2.9639203548431396,
            "y": -0.14990617334842682,
            "z": -25.9018611907959
        },
        {
            "x": -2.95013689994812,
            "y": -0.16298428177833557,
            "z": -25.745960235595703
        },
        {
            "x": -2.9350593090057373,
            "y": -0.1752714216709137,
            "z": -25.59000587463379
        },
        {
            "x": -2.9186501502990723,
            "y": -0.1866447925567627,
            "z": -25.434234619140625
        },
        {
            "x": -2.900810480117798,
            "y": -0.1970001757144928,
            "z": -25.27845001220703
        },
        {
            "x": -2.88153338432312,
            "y": -0.206268310546875,
            "z": -25.122770309448242
        },
        {
            "x": -2.8607897758483887,
            "y": -0.21435099840164185,
            "z": -24.96731948852539
        },
        {
            "x": -2.838510036468506,
            "y": -0.22115401923656464,
            "z": -24.811908721923828
        },
        {
            "x": -2.814596176147461,
            "y": -0.22652503848075867,
            "z": -24.656803131103516
        },
        {
            "x": -2.7890689373016357,
            "y": -0.23042801022529602,
            "z": -24.501922607421875
        },
        {
            "x": -2.7618634700775146,
            "y": -0.23327207565307617,
            "z": -24.347122192382812
        },
        {
            "x": -2.732973337173462,
            "y": -0.23591820895671844,
            "z": -24.192852020263672
        },
        {
            "x": -2.7022719383239746,
            "y": -0.23767369985580444,
            "z": -24.0388240814209
        },
        {
            "x": -2.6697888374328613,
            "y": -0.23793376982212067,
            "z": -23.88515853881836
        },
        {
            "x": -2.6355302333831787,
            "y": -0.2367861568927765,
            "z": -23.731937408447266
        },
        {
            "x": -2.599407434463501,
            "y": -0.23431017994880676,
            "z": -23.578968048095703
        },
        {
            "x": -2.5614113807678223,
            "y": -0.23055315017700195,
            "z": -23.426679611206055
        },
        {
            "x": -2.521719217300415,
            "y": -0.22565773129463196,
            "z": -23.2747802734375
        },
        {
            "x": -2.4812116622924805,
            "y": -0.2197059988975525,
            "z": -23.123022079467773
        },
        {
            "x": -2.4401566982269287,
            "y": -0.2127845585346222,
            "z": -22.971458435058594
        },
        {
            "x": -2.3984928131103516,
            "y": -0.20493662357330322,
            "z": -22.820005416870117
        },
        {
            "x": -2.3562586307525635,
            "y": -0.19629833102226257,
            "z": -22.66875457763672
        },
        {
            "x": -2.3134732246398926,
            "y": -0.18696185946464539,
            "z": -22.517807006835938
        },
        {
            "x": -2.2700915336608887,
            "y": -0.17699770629405975,
            "z": -22.36696434020996
        },
        {
            "x": -2.2261788845062256,
            "y": -0.1664884388446808,
            "z": -22.216413497924805
        },
        {
            "x": -2.1817774772644043,
            "y": -0.1555413007736206,
            "z": -22.0660343170166
        },
        {
            "x": -2.1368861198425293,
            "y": -0.14422862231731415,
            "z": -21.915611267089844
        },
        {
            "x": -2.0916802883148193,
            "y": -0.1326625496149063,
            "z": -21.765504837036133
        },
        {
            "x": -2.0461676120758057,
            "y": -0.12091458588838577,
            "z": -21.615434646606445
        },
        {
            "x": -2.000469923019409,
            "y": -0.10908321291208267,
            "z": -21.465417861938477
        },
        {
            "x": -1.9547021389007568,
            "y": -0.0973491370677948,
            "z": -21.315465927124023
        },
        {
            "x": -1.9089009761810303,
            "y": -0.08587363362312317,
            "z": -21.165279388427734
        },
        {
            "x": -1.863303303718567,
            "y": -0.07477816939353943,
            "z": -21.015199661254883
        },
        {
            "x": -1.8179680109024048,
            "y": -0.06413743644952774,
            "z": -20.864994049072266
        },
        {
            "x": -1.7729835510253906,
            "y": -0.05404599756002426,
            "z": -20.714519500732422
        },
        {
            "x": -1.7285525798797607,
            "y": -0.04464009776711464,
            "z": -20.563940048217773
        },
        {
            "x": -1.684707522392273,
            "y": -0.03597765415906906,
            "z": -20.413026809692383
        },
        {
            "x": -1.6415865421295166,
            "y": -0.02816087380051613,
            "z": -20.261850357055664
        },
        {
            "x": -1.5993460416793823,
            "y": -0.021334974095225334,
            "z": -20.110475540161133
        },
        {
            "x": -1.5716887712478638,
            "y": -0.01736123114824295,
            "z": -20.009397506713867
        },
        {
            "x": -1.5310086011886597,
            "y": -0.012331316247582436,
            "z": -19.857519149780273
        },
        {
            "x": -1.4914096593856812,
            "y": -0.008565371856093407,
            "z": -19.705312728881836
        },
        {
            "x": -1.4528576135635376,
            "y": -0.0061018806882202625,
            "z": -19.55260467529297
        },
        {
            "x": -1.4154841899871826,
            "y": -0.0050400299951434135,
            "z": -19.399795532226562
        },
        {
            "x": -1.3793083429336548,
            "y": -0.005000002682209015,
            "z": -19.24665641784668
        },
        {
            "x": -1.344315767288208,
            "y": -0.005000000353902578,
            "z": -19.093116760253906
        },
        {
            "x": -1.3105322122573853,
            "y": -0.005000003147870302,
            "z": -18.939424514770508
        },
        {
            "x": -1.277913212776184,
            "y": -0.00500000175088644,
            "z": -18.785385131835938
        },
        {
            "x": -1.2465208768844604,
            "y": -0.00500000175088644,
            "z": -18.631088256835938
        },
        {
            "x": -1.2162712812423706,
            "y": -0.005000002216547728,
            "z": -18.47667121887207
        },
        {
            "x": -1.1871157884597778,
            "y": -0.004999999422580004,
            "z": -18.321929931640625
        },
        {
            "x": -1.1590584516525269,
            "y": -0.005000000819563866,
            "z": -18.1671142578125
        },
        {
            "x": -1.1320502758026123,
            "y": -0.005000002216547728,
            "z": -18.012117385864258
        },
        {
            "x": -1.105954647064209,
            "y": -0.004999998025596142,
            "z": -17.856765747070312
        },
        {
            "x": -1.080797791481018,
            "y": -0.00500000175088644,
            "z": -17.70147705078125
        },
        {
            "x": -1.0565087795257568,
            "y": -0.004999999888241291,
            "z": -17.545997619628906
        },
        {
            "x": -1.0329893827438354,
            "y": -0.00500000175088644,
            "z": -17.390405654907227
        },
        {
            "x": -1.0101873874664307,
            "y": -0.005000000819563866,
            "z": -17.23477554321289
        },
        {
            "x": -0.9879982471466064,
            "y": -0.004999999422580004,
            "z": -17.078855514526367
        },
        {
            "x": -0.96641606092453,
            "y": -0.004999999888241291,
            "z": -16.923063278198242
        },
        {
            "x": -0.9453253746032715,
            "y": -0.005000000353902578,
            "z": -16.767210006713867
        },
        {
            "x": -0.9246492385864258,
            "y": -0.004999998491257429,
            "z": -16.61130714416504
        },
        {
            "x": -0.9043220281600952,
            "y": -0.005000002216547728,
            "z": -16.455368041992188
        },
        {
            "x": -0.8842630982398987,
            "y": -0.004999998956918716,
            "z": -16.299301147460938
        },
        {
            "x": -0.8643908500671387,
            "y": -0.004999999422580004,
            "z": -16.143217086791992
        },
        {
            "x": -0.8446473479270935,
            "y": -0.005000000819563866,
            "z": -15.987228393554688
        },
        {
            "x": -0.8249046206474304,
            "y": -0.005000000353902578,
            "z": -15.831130981445312
        },
        {
            "x": -0.8052138686180115,
            "y": -0.005000000353902578,
            "z": -15.675113677978516
        },
        {
            "x": -0.786199152469635,
            "y": -0.005000003147870302,
            "z": -15.518960952758789
        },
        {
            "x": -0.7680160999298096,
            "y": -0.005000001285225153,
            "z": -15.36252212524414
        },
        {
            "x": -0.7505389451980591,
            "y": -0.005000002216547728,
            "z": -15.206215858459473
        },
        {
            "x": -0.733622670173645,
            "y": -0.004999999888241291,
            "z": -15.049799919128418
        },
        {
            "x": -0.7171160578727722,
            "y": -0.005000005010515451,
            "z": -14.893353462219238
        },
        {
            "x": -0.7008959054946899,
            "y": -0.005000000819563866,
            "z": -14.736942291259766
        },
        {
            "x": -0.6848139762878418,
            "y": -0.005000001285225153,
            "z": -14.580327033996582
        },
        {
            "x": -0.6688323020935059,
            "y": -0.00500000175088644,
            "z": -14.423906326293945
        },
        {
            "x": -0.6528992652893066,
            "y": -0.005000000353902578,
            "z": -14.26748275756836
        },
        {
            "x": -0.6369831562042236,
            "y": -0.004999999422580004,
            "z": -14.110946655273438
        },
        {
            "x": -0.621088981628418,
            "y": -0.004999998956918716,
            "z": -13.954522132873535
        },
        {
            "x": -0.6051810383796692,
            "y": -0.005000003147870302,
            "z": -13.79800033569336
        },
        {
            "x": -0.5892562866210938,
            "y": -0.005000000353902578,
            "z": -13.641477584838867
        },
        {
            "x": -0.5733144283294678,
            "y": -0.005000000353902578,
            "z": -13.48505973815918
        },
        {
            "x": -0.5626675486564636,
            "y": -0.005000003147870302,
            "z": -13.380783081054688
        },
        {
            "x": -0.5466564297676086,
            "y": -0.00500000175088644,
            "z": -13.224373817443848
        },
        {
            "x": -0.530593752861023,
            "y": -0.004999998956918716,
            "z": -13.06796646118164
        },
        {
            "x": -0.5144540667533875,
            "y": -0.004999999888241291,
            "z": -12.911368370056152
        },
        {
            "x": -0.49827367067337036,
            "y": -0.004999998491257429,
            "z": -12.754977226257324
        },
        {
            "x": -0.48203447461128235,
            "y": -0.005000000353902578,
            "z": -12.598589897155762
        },
        {
            "x": -0.46572422981262207,
            "y": -0.004999998956918716,
            "z": -12.442102432250977
        },
        {
            "x": -0.44936367869377136,
            "y": -0.00500000175088644,
            "z": -12.28572940826416
        },
        {
            "x": -0.4329299032688141,
            "y": -0.00500000175088644,
            "z": -12.129263877868652
        },
        {
            "x": -0.41643741726875305,
            "y": -0.004999998956918716,
            "z": -11.97280216217041
        },
        {
            "x": -0.3999018371105194,
            "y": -0.005000001285225153,
            "z": -11.816447257995605
        },
        {
            "x": -0.38301971554756165,
            "y": -0.00500000175088644,
            "z": -11.66004467010498
        },
        {
            "x": -0.36535030603408813,
            "y": -0.00500000175088644,
            "z": -11.503851890563965
        },
        {
            "x": -0.3469408452510834,
            "y": -0.004999999888241291,
            "z": -11.34774112701416
        },
        {
            "x": -0.3278316557407379,
            "y": -0.004999999888241291,
            "z": -11.191509246826172
        },
        {
            "x": -0.3081105649471283,
            "y": -0.005000002682209015,
            "z": -11.035547256469727
        },
        {
            "x": -0.287848562002182,
            "y": -0.0049999975599348545,
            "z": -10.879599571228027
        },
        {
            "x": -0.2671184241771698,
            "y": -0.005000001285225153,
            "z": -10.723706245422363
        },
        {
            "x": -0.24598747491836548,
            "y": -0.005000003147870302,
            "z": -10.567919731140137
        },
        {
            "x": -0.22448447346687317,
            "y": -0.005000000819563866,
            "z": -10.41197681427002
        },
        {
            "x": -0.20274388790130615,
            "y": -0.004999998491257429,
            "z": -10.256265640258789
        },
        {
            "x": -0.1809103935956955,
            "y": -0.004999999888241291,
            "z": -10.100546836853027
        },
        {
            "x": -0.15969598293304443,
            "y": -0.005000000819563866,
            "z": -9.944719314575195
        },
        {
            "x": -0.13924640417099,
            "y": -0.004999999888241291,
            "z": -9.788792610168457
        },
        {
            "x": -0.11953868716955185,
            "y": -0.004999998956918716,
            "z": -9.632671356201172
        },
        {
            "x": -0.1005893275141716,
            "y": -0.005000001285225153,
            "z": -9.476454734802246
        },
        {
            "x": -0.08245030790567398,
            "y": -0.004999999422580004,
            "z": -9.320245742797852
        },
        {
            "x": -0.06505667418241501,
            "y": -0.005000000819563866,
            "z": -9.16384220123291
        },
        {
            "x": -0.048430297523736954,
            "y": -0.005000000819563866,
            "z": -9.007465362548828
        },
        {
            "x": -0.03257010877132416,
            "y": -0.004999999888241291,
            "z": -8.8510103225708
        },
        {
            "x": -0.017458530142903328,
            "y": -0.005000000819563866,
            "z": -8.694279670715332
        },
        {
            "x": -0.0031009470112621784,
            "y": -0.004999999888241291,
            "z": -8.537683486938477
        },
        {
            "x": 0.010538734495639801,
            "y": -0.00500000175088644,
            "z": -8.380965232849121
        },
        {
            "x": 0.023439791053533554,
            "y": -0.00500000175088644,
            "z": -8.224184036254883
        },
        {
            "x": 0.035637807101011276,
            "y": -0.004999998025596142,
            "z": -8.06740665435791
        },
        {
            "x": 0.047181032598018646,
            "y": -0.00500000175088644,
            "z": -7.9103827476501465
        },
        {
            "x": 0.05805925279855728,
            "y": -0.004999998956918716,
            "z": -7.753512382507324
        },
        {
            "x": 0.06830094754695892,
            "y": -0.004999999888241291,
            "z": -7.5966010093688965
        },
        {
            "x": 0.07804504781961441,
            "y": -0.00500000175088644,
            "z": -7.439552307128906
        },
        {
            "x": 0.08743540942668915,
            "y": -0.005000002682209015,
            "z": -7.282596588134766
        },
        {
            "x": 0.09664901345968246,
            "y": -0.005000002682209015,
            "z": -7.125532627105713
        },
        {
            "x": 0.10586260259151459,
            "y": -0.00500000175088644,
            "z": -6.968472957611084
        },
        {
            "x": 0.11525251716375351,
            "y": -0.005000002682209015,
            "z": -6.811530113220215
        },
        {
            "x": 0.12170521914958954,
            "y": -0.00500000175088644,
            "z": -6.706913471221924
        },
        {
            "x": 0.1317700743675232,
            "y": -0.0050000036135315895,
            "z": -6.550008773803711
        },
        {
            "x": 0.14156219363212585,
            "y": -0.005000000819563866,
            "z": -6.393066883087158
        },
        {
            "x": 0.1497477889060974,
            "y": -0.00500000175088644,
            "z": -6.235820770263672
        },
        {
            "x": 0.15592500567436218,
            "y": -0.00500000175088644,
            "z": -6.0786871910095215
        },
        {
            "x": 0.16024935245513916,
            "y": -0.004999999888241291,
            "z": -5.921492099761963
        },
        {
            "x": 0.1629239171743393,
            "y": -0.004999998956918716,
            "z": -5.764160633087158
        },
        {
            "x": 0.16497202217578888,
            "y": -0.004999999888241291,
            "z": -5.606941223144531
        },
        {
            "x": 0.16685958206653595,
            "y": -0.004999999888241291,
            "z": -5.449620723724365
        },
        {
            "x": 0.16862058639526367,
            "y": -0.004999999888241291,
            "z": -5.292298316955566
        },
        {
            "x": 0.17026004195213318,
            "y": -0.005000000819563866,
            "z": -5.135073661804199
        },
        {
            "x": 0.1716015338897705,
            "y": -0.005000000819563866,
            "z": -4.97772741317749
        },
        {
            "x": 0.17149978876113892,
            "y": -0.004999999888241291,
            "z": -4.820489883422852
        },
        {
            "x": 0.16995926201343536,
            "y": -0.00500000175088644,
            "z": -4.663262844085693
        },
        {
            "x": 0.16718439757823944,
            "y": -0.004999998025596142,
            "z": -4.505853652954102
        },
        {
            "x": 0.16338320076465607,
            "y": -0.00500000175088644,
            "z": -4.348667144775391
        },
        {
            "x": 0.1587267816066742,
            "y": -0.005000000819563866,
            "z": -4.191450595855713
        },
        {
            "x": 0.15345361828804016,
            "y": -0.004999998025596142,
            "z": -4.034253120422363
        },
        {
            "x": 0.14777003228664398,
            "y": -0.005000002682209015,
            "z": -3.877126932144165
        },
        {
            "x": 0.14187034964561462,
            "y": -0.00500000175088644,
            "z": -3.7198050022125244
        },
        {
            "x": 0.13598451018333435,
            "y": -0.005000000819563866,
            "z": -3.5626840591430664
        },
        {
            "x": 0.13005560636520386,
            "y": -0.004999999888241291,
            "z": -3.4055681228637695
        },
        {
            "x": 0.12374159693717957,
            "y": -0.005000000819563866,
            "z": -3.2484629154205322
        },
        {
            "x": 0.11716003715991974,
            "y": -0.004999998025596142,
            "z": -3.0913708209991455
        },
        {
            "x": 0.11045482754707336,
            "y": -0.005000000819563866,
            "z": -2.9341843128204346
        },
        {
            "x": 0.10379976779222488,
            "y": -0.005000000819563866,
            "z": -2.776991128921509
        },
        {
            "x": 0.09735610336065292,
            "y": -0.00500000175088644,
            "z": -2.6198906898498535
        },
        {
            "x": 0.09127510339021683,
            "y": -0.00500000175088644,
            "z": -2.4626624584198
        },
        {
            "x": 0.08569395542144775,
            "y": -0.005000000819563866,
            "z": -2.305525302886963
        },
        {
            "x": 0.0804491937160492,
            "y": -0.005000002682209015,
            "z": -2.1483774185180664
        },
        {
            "x": 0.07532289624214172,
            "y": -0.00500000175088644,
            "z": -1.9910300970077515
        },
        {
            "x": 0.07013193517923355,
            "y": -0.005000002682209015,
            "z": -1.8338872194290161
        },
        {
            "x": 0.06466372311115265,
            "y": -0.00500000175088644,
            "z": -1.6766992807388306
        },
        {
            "x": 0.058748167008161545,
            "y": -0.005000000819563866,
            "z": -1.5195322036743164
        },
        {
            "x": 0.052237704396247864,
            "y": -0.005000000819563866,
            "z": -1.362448811531067
        },
        {
            "x": 0.04499233141541481,
            "y": -0.00500000175088644,
            "z": -1.2052013874053955
        },
        {
            "x": 0.036896079778671265,
            "y": -0.004999999888241291,
            "z": -1.04819917678833
        },
        {
            "x": 0.02824779972434044,
            "y": -0.005000000819563866,
            "z": -0.8912093043327332
        },
        {
            "x": 0.01969149149954319,
            "y": -0.005000000819563866,
            "z": -0.7340964674949646
        },
        {
            "x": 0.0114654041826725,
            "y": -0.005000000819563866,
            "z": -0.5770688652992249
        },
        {
            "x": 0.003973661456257105,
            "y": -0.005000000819563866,
            "z": -0.4198884963989258
        },
        {
            "x": -0.002106514759361744,
            "y": -0.00500000175088644,
            "z": -0.26262107491493225
        },
        {
            "x": -0.005524271633476019,
            "y": -0.004999999888241291,
            "z": -0.10532331466674805
        },
        {
            "x": -0.005360716488212347,
            "y": -0.004999999888241291,
            "z": -0.0004154423368163407
        }
    ],
    "lane4":[
        {
            "x": 0.1106625497341156,
            "y": 0.015580788254737854,
            "z": -419.77850341796875
        },
        {
            "x": 0.11048424243927002,
            "y": 0.015574336051940918,
            "z": -419.62127685546875
        },
        {
            "x": 0.11030599474906921,
            "y": 0.015567824244499207,
            "z": -419.4640197753906
        },
        {
            "x": 0.11012765765190125,
            "y": 0.015561416745185852,
            "z": -419.3066101074219
        },
        {
            "x": 0.10994932055473328,
            "y": 0.015554860234260559,
            "z": -419.1493835449219
        },
        {
            "x": 0.10977095365524292,
            "y": 0.015548378229141235,
            "z": -418.9921569824219
        },
        {
            "x": 0.10959267616271973,
            "y": 0.015541911125183105,
            "z": -418.8348083496094
        },
        {
            "x": 0.10941439867019653,
            "y": 0.015535414218902588,
            "z": -418.6775817871094
        },
        {
            "x": 0.10923606157302856,
            "y": 0.015528932213783264,
            "z": -418.5202331542969
        },
        {
            "x": 0.10905769467353821,
            "y": 0.015522435307502747,
            "z": -418.3629150390625
        },
        {
            "x": 0.10887947678565979,
            "y": 0.015515953302383423,
            "z": -418.2057189941406
        },
        {
            "x": 0.10870108008384705,
            "y": 0.015509486198425293,
            "z": -418.0483703613281
        },
        {
            "x": 0.10852280259132385,
            "y": 0.015502989292144775,
            "z": -417.8911437988281
        },
        {
            "x": 0.10834461450576782,
            "y": 0.015496522188186646,
            "z": -417.7339172363281
        },
        {
            "x": 0.10816618800163269,
            "y": 0.015490040183067322,
            "z": -417.5764465332031
        },
        {
            "x": 0.10798782110214233,
            "y": 0.015483558177947998,
            "z": -417.4192199707031
        },
        {
            "x": 0.10780960321426392,
            "y": 0.015477046370506287,
            "z": -417.2619323730469
        },
        {
            "x": 0.10763126611709595,
            "y": 0.015470579266548157,
            "z": -417.1046447753906
        },
        {
            "x": 0.10745307803153992,
            "y": 0.01546412706375122,
            "z": -416.9474182128906
        },
        {
            "x": 0.10727453231811523,
            "y": 0.01545761525630951,
            "z": -416.7900085449219
        },
        {
            "x": 0.10709622502326965,
            "y": 0.015451118350028992,
            "z": -416.6327819824219
        },
        {
            "x": 0.1069180965423584,
            "y": 0.015444651246070862,
            "z": -416.47552490234375
        },
        {
            "x": 0.10673984885215759,
            "y": 0.015438199043273926,
            "z": -416.3182678222656
        },
        {
            "x": 0.10656154155731201,
            "y": 0.015431702136993408,
            "z": -416.1610412597656
        },
        {
            "x": 0.10638320446014404,
            "y": 0.015425220131874084,
            "z": -416.0037536621094
        },
        {
            "x": 0.10620492696762085,
            "y": 0.015418753027915955,
            "z": -415.84637451171875
        },
        {
            "x": 0.1060265600681305,
            "y": 0.015412241220474243,
            "z": -415.68914794921875
        },
        {
            "x": 0.10584819316864014,
            "y": 0.015405744314193726,
            "z": -415.5318298339844
        },
        {
            "x": 0.10566997528076172,
            "y": 0.015399262309074402,
            "z": -415.3746032714844
        },
        {
            "x": 0.10549163818359375,
            "y": 0.015392839908599854,
            "z": -415.21734619140625
        },
        {
            "x": 0.10531333088874817,
            "y": 0.015386298298835754,
            "z": -415.0599365234375
        },
        {
            "x": 0.10513508319854736,
            "y": 0.01537981629371643,
            "z": -414.9026794433594
        },
        {
            "x": 0.10495662689208984,
            "y": 0.015373319387435913,
            "z": -414.74542236328125
        },
        {
            "x": 0.10477834939956665,
            "y": 0.015366911888122559,
            "z": -414.588134765625
        },
        {
            "x": 0.10460016131401062,
            "y": 0.015360385179519653,
            "z": -414.4308776855469
        },
        {
            "x": 0.10442176461219788,
            "y": 0.015353873372077942,
            "z": -414.2734680175781
        },
        {
            "x": 0.1042434573173523,
            "y": 0.015347391366958618,
            "z": -414.1162109375
        },
        {
            "x": 0.10406515002250671,
            "y": 0.015341013669967651,
            "z": -413.958984375
        },
        {
            "x": 0.10388690233230591,
            "y": 0.015334412455558777,
            "z": -413.8016662597656
        },
        {
            "x": 0.10370853543281555,
            "y": 0.015327945351600647,
            "z": -413.6444091796875
        },
        {
            "x": 0.10353025794029236,
            "y": 0.015321463346481323,
            "z": -413.487060546875
        },
        {
            "x": 0.10335192084312439,
            "y": 0.015315011143684387,
            "z": -413.32977294921875
        },
        {
            "x": 0.10317361354827881,
            "y": 0.015308544039726257,
            "z": -413.17254638671875
        },
        {
            "x": 0.103054940700531,
            "y": 0.01530417799949646,
            "z": -413.0677490234375
        },
        {
            "x": 0.10287657380104065,
            "y": 0.015297770500183105,
            "z": -412.91046142578125
        },
        {
            "x": 0.10269835591316223,
            "y": 0.015291213989257812,
            "z": -412.75323486328125
        },
        {
            "x": 0.10251984000205994,
            "y": 0.015284746885299683,
            "z": -412.5958251953125
        },
        {
            "x": 0.10234159231185913,
            "y": 0.015278249979019165,
            "z": -412.4385681152344
        },
        {
            "x": 0.10216334462165833,
            "y": 0.015271857380867004,
            "z": -412.28131103515625
        },
        {
            "x": 0.10198497772216797,
            "y": 0.015265315771102905,
            "z": -412.1240234375
        },
        {
            "x": 0.10180678963661194,
            "y": 0.015258803963661194,
            "z": -411.9667663574219
        },
        {
            "x": 0.1016283631324768,
            "y": 0.01525232195854187,
            "z": -411.8094482421875
        },
        {
            "x": 0.101450115442276,
            "y": 0.01524585485458374,
            "z": -411.6521301269531
        },
        {
            "x": 0.10127174854278564,
            "y": 0.015239372849464417,
            "z": -411.494873046875
        },
        {
            "x": 0.10109347105026245,
            "y": 0.015232890844345093,
            "z": -411.3375244140625
        },
        {
            "x": 0.10091516375541687,
            "y": 0.015226393938064575,
            "z": -411.1802978515625
        },
        {
            "x": 0.10073688626289368,
            "y": 0.015219926834106445,
            "z": -411.0230712890625
        },
        {
            "x": 0.10055845975875854,
            "y": 0.015213429927825928,
            "z": -410.8656311035156
        },
        {
            "x": 0.10038018226623535,
            "y": 0.01520693302154541,
            "z": -410.7084045410156
        },
        {
            "x": 0.10020193457603455,
            "y": 0.015200480818748474,
            "z": -410.5511169433594
        },
        {
            "x": 0.1000235378742218,
            "y": 0.015193969011306763,
            "z": -410.3938293457031
        },
        {
            "x": 0.09984531998634338,
            "y": 0.015187479555606842,
            "z": -410.2366027832031
        },
        {
            "x": 0.09966692328453064,
            "y": 0.015181012451648712,
            "z": -410.0791931152344
        },
        {
            "x": 0.09948870539665222,
            "y": 0.015174537897109985,
            "z": -409.9219665527344
        },
        {
            "x": 0.09931036829948425,
            "y": 0.015168018639087677,
            "z": -409.76470947265625
        },
        {
            "x": 0.09913215041160583,
            "y": 0.015161596238613129,
            "z": -409.60748291015625
        },
        {
            "x": 0.09895384311676025,
            "y": 0.015155084431171417,
            "z": -409.45025634765625
        },
        {
            "x": 0.09877553582191467,
            "y": 0.015148632228374481,
            "z": -409.2929382324219
        },
        {
            "x": 0.09859707951545715,
            "y": 0.015142157673835754,
            "z": -409.1355895996094
        },
        {
            "x": 0.09841898083686829,
            "y": 0.01513567566871643,
            "z": -408.9783630371094
        },
        {
            "x": 0.09824058413505554,
            "y": 0.015129134058952332,
            "z": -408.8210144042969
        },
        {
            "x": 0.09806233644485474,
            "y": 0.015122652053833008,
            "z": -408.6637878417969
        },
        {
            "x": 0.09788405895233154,
            "y": 0.015116184949874878,
            "z": -408.5065612792969
        },
        {
            "x": 0.09770551323890686,
            "y": 0.015109732747077942,
            "z": -408.34912109375
        },
        {
            "x": 0.097527414560318,
            "y": 0.015103213489055634,
            "z": -408.19189453125
        },
        {
            "x": 0.09734907746315002,
            "y": 0.015096746385097504,
            "z": -408.03460693359375
        },
        {
            "x": 0.09717071056365967,
            "y": 0.015090234577655792,
            "z": -407.8773193359375
        },
        {
            "x": 0.09699255228042603,
            "y": 0.01508377492427826,
            "z": -407.7200927734375
        },
        {
            "x": 0.0968141257762909,
            "y": 0.015077292919158936,
            "z": -407.5626525878906
        },
        {
            "x": 0.09663581848144531,
            "y": 0.015070810914039612,
            "z": -407.4053955078125
        },
        {
            "x": 0.09645748138427734,
            "y": 0.015064314007759094,
            "z": -407.2481994628906
        },
        {
            "x": 0.09627920389175415,
            "y": 0.015057854354381561,
            "z": -407.0908508300781
        },
        {
            "x": 0.09610092639923096,
            "y": 0.01505136489868164,
            "z": -406.9336242675781
        },
        {
            "x": 0.09592267870903015,
            "y": 0.015044867992401123,
            "z": -406.77630615234375
        },
        {
            "x": 0.09574416279792786,
            "y": 0.015038378536701202,
            "z": -406.61895751953125
        },
        {
            "x": 0.09556597471237183,
            "y": 0.015031911432743073,
            "z": -406.46173095703125
        },
        {
            "x": 0.09544721245765686,
            "y": 0.015027612447738647,
            "z": -406.3569030761719
        },
        {
            "x": 0.0952669084072113,
            "y": 0.01502101868391037,
            "z": -406.1996765136719
        },
        {
            "x": 0.09508860111236572,
            "y": 0.015014588832855225,
            "z": -406.0424499511719
        },
        {
            "x": 0.0949101448059082,
            "y": 0.01500808447599411,
            "z": -405.885009765625
        },
        {
            "x": 0.0947318971157074,
            "y": 0.015001580119132996,
            "z": -405.727783203125
        },
        {
            "x": 0.0945536196231842,
            "y": 0.014995075762271881,
            "z": -405.570556640625
        },
        {
            "x": 0.09437534213066101,
            "y": 0.01498858630657196,
            "z": -405.4132080078125
        },
        {
            "x": 0.09419703483581543,
            "y": 0.014982208609580994,
            "z": -405.2559814453125
        },
        {
            "x": 0.09401869773864746,
            "y": 0.01497562974691391,
            "z": -405.0986328125
        },
        {
            "x": 0.0938403308391571,
            "y": 0.01496914029121399,
            "z": -404.9413146972656
        },
        {
            "x": 0.09366202354431152,
            "y": 0.01496269553899765,
            "z": -404.78411865234375
        },
        {
            "x": 0.09348371624946594,
            "y": 0.014956213533878326,
            "z": -404.6267395019531
        },
        {
            "x": 0.09330546855926514,
            "y": 0.014949731528759003,
            "z": -404.4695129394531
        },
        {
            "x": 0.09312719106674194,
            "y": 0.014943212270736694,
            "z": -404.3122863769531
        },
        {
            "x": 0.09294870495796204,
            "y": 0.014936752617359161,
            "z": -404.15484619140625
        },
        {
            "x": 0.09277048707008362,
            "y": 0.014930278062820435,
            "z": -403.9975891113281
        },
        {
            "x": 0.09259214997291565,
            "y": 0.014923758804798126,
            "z": -403.8403015136719
        },
        {
            "x": 0.09241390228271484,
            "y": 0.0149172842502594,
            "z": -403.6830139160156
        },
        {
            "x": 0.09223568439483643,
            "y": 0.014910846948623657,
            "z": -403.5257873535156
        },
        {
            "x": 0.0920572280883789,
            "y": 0.014904297888278961,
            "z": -403.36834716796875
        },
        {
            "x": 0.09187904000282288,
            "y": 0.014897875487804413,
            "z": -403.21112060546875
        },
        {
            "x": 0.09170061349868774,
            "y": 0.014891348779201508,
            "z": -403.05389404296875
        },
        {
            "x": 0.09152248501777649,
            "y": 0.014884889125823975,
            "z": -402.8966369628906
        },
        {
            "x": 0.0913442075252533,
            "y": 0.014878392219543457,
            "z": -402.7394104003906
        },
        {
            "x": 0.09116581082344055,
            "y": 0.014871902763843536,
            "z": -402.5820617675781
        },
        {
            "x": 0.09098750352859497,
            "y": 0.014865405857563019,
            "z": -402.42474365234375
        },
        {
            "x": 0.09080922603607178,
            "y": 0.014858938753604889,
            "z": -402.2674865722656
        },
        {
            "x": 0.09063094854354858,
            "y": 0.014852471649646759,
            "z": -402.1101989746094
        },
        {
            "x": 0.09045261144638062,
            "y": 0.014845989644527435,
            "z": -401.9529724121094
        },
        {
            "x": 0.09027433395385742,
            "y": 0.014839492738246918,
            "z": -401.79571533203125
        },
        {
            "x": 0.09009593725204468,
            "y": 0.014833062887191772,
            "z": -401.6382751464844
        },
        {
            "x": 0.08991771936416626,
            "y": 0.014826588332653046,
            "z": -401.4810791015625
        },
        {
            "x": 0.08973941206932068,
            "y": 0.014820009469985962,
            "z": -401.3237609863281
        },
        {
            "x": 0.08956107497215271,
            "y": 0.014813549816608429,
            "z": -401.1664733886719
        },
        {
            "x": 0.08938276767730713,
            "y": 0.014807075262069702,
            "z": -401.0092468261719
        },
        {
            "x": 0.089204341173172,
            "y": 0.014800578355789185,
            "z": -400.8518371582031
        },
        {
            "x": 0.0890260636806488,
            "y": 0.014794088900089264,
            "z": -400.694580078125
        },
        {
            "x": 0.08884778618812561,
            "y": 0.014787636697292328,
            "z": -400.537353515625
        },
        {
            "x": 0.08866947889328003,
            "y": 0.014781184494495392,
            "z": -400.3800354003906
        },
        {
            "x": 0.08849126100540161,
            "y": 0.01477465033531189,
            "z": -400.2227478027344
        },
        {
            "x": 0.0883127748966217,
            "y": 0.014768168330192566,
            "z": -400.0654602050781
        },
        {
            "x": 0.08813446760177612,
            "y": 0.014761678874492645,
            "z": -399.90814208984375
        },
        {
            "x": 0.08795627951622009,
            "y": 0.01475522667169571,
            "z": -399.7508850097656
        },
        {
            "x": 0.08783751726150513,
            "y": 0.0147508904337883,
            "z": -399.6460876464844
        },
        {
            "x": 0.08765915036201477,
            "y": 0.014744393527507782,
            "z": -399.48883056640625
        },
        {
            "x": 0.08748093247413635,
            "y": 0.014737971127033234,
            "z": -399.3316345214844
        },
        {
            "x": 0.087302565574646,
            "y": 0.01473146677017212,
            "z": -399.1742248535156
        },
        {
            "x": 0.0871242880821228,
            "y": 0.014724962413311005,
            "z": -399.0169372558594
        },
        {
            "x": 0.08694595098495483,
            "y": 0.01471845805644989,
            "z": -398.8597412109375
        },
        {
            "x": 0.08676764369010925,
            "y": 0.014712080359458923,
            "z": -398.7024230957031
        },
        {
            "x": 0.08658942580223083,
            "y": 0.01470552384853363,
            "z": -398.5451354980469
        },
        {
            "x": 0.08641105890274048,
            "y": 0.014699019491672516,
            "z": -398.3878479003906
        },
        {
            "x": 0.0862327516078949,
            "y": 0.014692522585391998,
            "z": -398.2304992675781
        },
        {
            "x": 0.08605438470840454,
            "y": 0.014686062932014465,
            "z": -398.0732727050781
        },
        {
            "x": 0.08587604761123657,
            "y": 0.014679580926895142,
            "z": -397.9159240722656
        },
        {
            "x": 0.08569782972335815,
            "y": 0.014673084020614624,
            "z": -397.7586975097656
        },
        {
            "x": 0.08551952242851257,
            "y": 0.014666624367237091,
            "z": -397.6014709472656
        },
        {
            "x": 0.08534115552902222,
            "y": 0.014660187065601349,
            "z": -397.4440612792969
        },
        {
            "x": 0.08516281843185425,
            "y": 0.014653675258159637,
            "z": -397.28680419921875
        },
        {
            "x": 0.08498454093933105,
            "y": 0.01464717835187912,
            "z": -397.1295166015625
        },
        {
            "x": 0.08480623364448547,
            "y": 0.014640666544437408,
            "z": -396.9722595214844
        },
        {
            "x": 0.08462795615196228,
            "y": 0.014634199440479279,
            "z": -396.81500244140625
        },
        {
            "x": 0.08444952964782715,
            "y": 0.014627739787101746,
            "z": -396.6575927734375
        },
        {
            "x": 0.08427125215530396,
            "y": 0.01462121307849884,
            "z": -396.5003356933594
        },
        {
            "x": 0.08409303426742554,
            "y": 0.014614738523960114,
            "z": -396.3431091308594
        },
        {
            "x": 0.08391478657722473,
            "y": 0.014608293771743774,
            "z": -396.1858825683594
        },
        {
            "x": 0.08373662829399109,
            "y": 0.01460178941488266,
            "z": -396.0286560058594
        },
        {
            "x": 0.08355826139450073,
            "y": 0.014595314860343933,
            "z": -395.871337890625
        },
        {
            "x": 0.08337980508804321,
            "y": 0.014588795602321625,
            "z": -395.7139892578125
        },
        {
            "x": 0.0832015872001648,
            "y": 0.014582328498363495,
            "z": -395.55682373046875
        },
        {
            "x": 0.08302319049835205,
            "y": 0.014575853943824768,
            "z": -395.39947509765625
        },
        {
            "x": 0.08284497261047363,
            "y": 0.014569364488124847,
            "z": -395.24224853515625
        },
        {
            "x": 0.08266660571098328,
            "y": 0.014562912285327911,
            "z": -395.08502197265625
        },
        {
            "x": 0.08248820900917053,
            "y": 0.014556385576725006,
            "z": -394.9275817871094
        },
        {
            "x": 0.08230996131896973,
            "y": 0.014549925923347473,
            "z": -394.7703552246094
        },
        {
            "x": 0.08213165402412415,
            "y": 0.014543421566486359,
            "z": -394.61309814453125
        },
        {
            "x": 0.08195343613624573,
            "y": 0.014536961913108826,
            "z": -394.455810546875
        },
        {
            "x": 0.0817750096321106,
            "y": 0.014530494809150696,
            "z": -394.298583984375
        },
        {
            "x": 0.08159664273262024,
            "y": 0.014523983001708984,
            "z": -394.14111328125
        },
        {
            "x": 0.08141833543777466,
            "y": 0.014517471194267273,
            "z": -393.98388671875
        },
        {
            "x": 0.08124017715454102,
            "y": 0.01451101154088974,
            "z": -393.82666015625
        },
        {
            "x": 0.08106178045272827,
            "y": 0.014504581689834595,
            "z": -393.6693115234375
        },
        {
            "x": 0.0808834433555603,
            "y": 0.014498062431812286,
            "z": -393.5121154785156
        },
        {
            "x": 0.08070513606071472,
            "y": 0.014491528272628784,
            "z": -393.35479736328125
        },
        {
            "x": 0.08052673935890198,
            "y": 0.014485098421573639,
            "z": -393.19744873046875
        },
        {
            "x": 0.08034852147102356,
            "y": 0.014478586614131927,
            "z": -393.04022216796875
        },
        {
            "x": 0.08022871613502502,
            "y": 0.014474265277385712,
            "z": -392.93536376953125
        },
        {
            "x": 0.08004951477050781,
            "y": 0.014467753469944,
            "z": -392.77813720703125
        },
        {
            "x": 0.07987120747566223,
            "y": 0.014461219310760498,
            "z": -392.62091064453125
        },
        {
            "x": 0.0796927809715271,
            "y": 0.014454767107963562,
            "z": -392.4635009765625
        },
        {
            "x": 0.0795145332813263,
            "y": 0.014448307454586029,
            "z": -392.3062744140625
        },
        {
            "x": 0.07933619618415833,
            "y": 0.014441817998886108,
            "z": -392.1490173339844
        },
        {
            "x": 0.07915779948234558,
            "y": 0.014435306191444397,
            "z": -391.9916687011719
        },
        {
            "x": 0.07897961139678955,
            "y": 0.014428883790969849,
            "z": -391.8344421386719
        },
        {
            "x": 0.0788012444972992,
            "y": 0.014422327280044556,
            "z": -391.6770935058594
        },
        {
            "x": 0.07862293720245361,
            "y": 0.014415882527828217,
            "z": -391.519775390625
        },
        {
            "x": 0.07844462990760803,
            "y": 0.014409355819225311,
            "z": -391.362548828125
        },
        {
            "x": 0.07826638221740723,
            "y": 0.014402933418750763,
            "z": -391.2051696777344
        },
        {
            "x": 0.07808807492256165,
            "y": 0.014396406710147858,
            "z": -391.0479736328125
        },
        {
            "x": 0.07790982723236084,
            "y": 0.014389961957931519,
            "z": -390.8907470703125
        },
        {
            "x": 0.07773137092590332,
            "y": 0.014383435249328613,
            "z": -390.7333068847656
        },
        {
            "x": 0.07755306363105774,
            "y": 0.01437697559595108,
            "z": -390.5760803222656
        },
        {
            "x": 0.07737478613853455,
            "y": 0.014370471239089966,
            "z": -390.4187927246094
        },
        {
            "x": 0.07719650864601135,
            "y": 0.014364004135131836,
            "z": -390.2615051269531
        },
        {
            "x": 0.07701820135116577,
            "y": 0.014357492327690125,
            "z": -390.1042785644531
        },
        {
            "x": 0.07683983445167542,
            "y": 0.014351025223731995,
            "z": -389.9468078613281
        },
        {
            "x": 0.07666149735450745,
            "y": 0.014344565570354462,
            "z": -389.78961181640625
        },
        {
            "x": 0.07648321986198425,
            "y": 0.01433805376291275,
            "z": -389.63238525390625
        },
        {
            "x": 0.07630500197410583,
            "y": 0.014331579208374023,
            "z": -389.4751281738281
        },
        {
            "x": 0.07612678408622742,
            "y": 0.014325089752674103,
            "z": -389.3179016113281
        },
        {
            "x": 0.07594841718673706,
            "y": 0.014318645000457764,
            "z": -389.16058349609375
        },
        {
            "x": 0.07577016949653625,
            "y": 0.014312170445919037,
            "z": -389.0032653808594
        },
        {
            "x": 0.07559177279472351,
            "y": 0.014305636286735535,
            "z": -388.84600830078125
        },
        {
            "x": 0.07541340589523315,
            "y": 0.014299191534519196,
            "z": -388.6886901855469
        },
        {
            "x": 0.07523524761199951,
            "y": 0.014292672276496887,
            "z": -388.5314636230469
        },
        {
            "x": 0.07505691051483154,
            "y": 0.014286205172538757,
            "z": -388.37420654296875
        },
        {
            "x": 0.07487848401069641,
            "y": 0.01427970826625824,
            "z": -388.216796875
        },
        {
            "x": 0.07470020651817322,
            "y": 0.014273211359977722,
            "z": -388.0595397949219
        },
        {
            "x": 0.07452192902565002,
            "y": 0.014266759157180786,
            "z": -387.9022521972656
        },
        {
            "x": 0.07434359192848206,
            "y": 0.014260247349739075,
            "z": -387.7449645996094
        },
        {
            "x": 0.07416534423828125,
            "y": 0.014253772795200348,
            "z": -387.5877380371094
        },
        {
            "x": 0.07398691773414612,
            "y": 0.014247305691242218,
            "z": -387.4303283691406
        },
        {
            "x": 0.07380867004394531,
            "y": 0.014240823686122894,
            "z": -387.2730712890625
        },
        {
            "x": 0.07363036274909973,
            "y": 0.01423434168100357,
            "z": -387.1158447265625
        },
        {
            "x": 0.07345205545425415,
            "y": 0.014227844774723053,
            "z": -386.9585266113281
        },
        {
            "x": 0.07327380776405334,
            "y": 0.014221347868442535,
            "z": -386.80126953125
        },
        {
            "x": 0.07309544086456299,
            "y": 0.014214873313903809,
            "z": -386.6439514160156
        },
        {
            "x": 0.07291710376739502,
            "y": 0.014208376407623291,
            "z": -386.48663330078125
        },
        {
            "x": 0.07273879647254944,
            "y": 0.01420188695192337,
            "z": -386.3293762207031
        },
        {
            "x": 0.07262000441551208,
            "y": 0.014197595417499542,
            "z": -386.2245788574219
        },
        {
            "x": 0.07244172692298889,
            "y": 0.014191098511219025,
            "z": -386.06732177734375
        },
        {
            "x": 0.07226356863975525,
            "y": 0.014184623956680298,
            "z": -385.91009521484375
        },
        {
            "x": 0.07208505272865295,
            "y": 0.014178134500980377,
            "z": -385.752685546875
        },
        {
            "x": 0.07190686464309692,
            "y": 0.01417165994644165,
            "z": -385.5954284667969
        },
        {
            "x": 0.07172849774360657,
            "y": 0.014165148138999939,
            "z": -385.4382019042969
        },
        {
            "x": 0.07155025005340576,
            "y": 0.014158666133880615,
            "z": -385.2808837890625
        },
        {
            "x": 0.07137194275856018,
            "y": 0.01415223628282547,
            "z": -385.1236267089844
        },
        {
            "x": 0.07119354605674744,
            "y": 0.014145709574222565,
            "z": -384.9663391113281
        },
        {
            "x": 0.07101526856422424,
            "y": 0.014139264822006226,
            "z": -384.8089904785156
        },
        {
            "x": 0.07083699107170105,
            "y": 0.014132760465145111,
            "z": -384.6517333984375
        },
        {
            "x": 0.07065868377685547,
            "y": 0.01412627100944519,
            "z": -384.4944152832031
        },
        {
            "x": 0.07048040628433228,
            "y": 0.014119841158390045,
            "z": -384.3371276855469
        },
        {
            "x": 0.0703020691871643,
            "y": 0.014113306999206543,
            "z": -384.179931640625
        },
        {
            "x": 0.07012367248535156,
            "y": 0.014106802642345428,
            "z": -384.0224914550781
        },
        {
            "x": 0.0699453353881836,
            "y": 0.01410038024187088,
            "z": -383.8652648925781
        },
        {
            "x": 0.06976708769798279,
            "y": 0.014093868434429169,
            "z": -383.7079772949219
        },
        {
            "x": 0.06958875060081482,
            "y": 0.014087356626987457,
            "z": -383.5506896972656
        },
        {
            "x": 0.06941059231758118,
            "y": 0.01408088207244873,
            "z": -383.3934631347656
        },
        {
            "x": 0.06923213601112366,
            "y": 0.0140744149684906,
            "z": -383.2360534667969
        },
        {
            "x": 0.06905388832092285,
            "y": 0.014067932963371277,
            "z": -383.0788269042969
        },
        {
            "x": 0.06887558102607727,
            "y": 0.014061443507671356,
            "z": -382.92156982421875
        },
        {
            "x": 0.06869736313819885,
            "y": 0.014054946601390839,
            "z": -382.76434326171875
        },
        {
            "x": 0.06851911544799805,
            "y": 0.014048516750335693,
            "z": -382.60711669921875
        },
        {
            "x": 0.06834080815315247,
            "y": 0.014041975140571594,
            "z": -382.4497985839844
        },
        {
            "x": 0.06816241145133972,
            "y": 0.014035522937774658,
            "z": -382.2924499511719
        },
        {
            "x": 0.06798413395881653,
            "y": 0.01402902603149414,
            "z": -382.1352233886719
        },
        {
            "x": 0.06780579686164856,
            "y": 0.01402255892753601,
            "z": -381.9778747558594
        },
        {
            "x": 0.06762760877609253,
            "y": 0.014016106724739075,
            "z": -381.8206481933594
        },
        {
            "x": 0.06744927167892456,
            "y": 0.014009594917297363,
            "z": -381.6634216308594
        },
        {
            "x": 0.06727084517478943,
            "y": 0.014003083109855652,
            "z": -381.5059814453125
        },
        {
            "x": 0.06709250807762146,
            "y": 0.0139966681599617,
            "z": -381.3487854003906
        },
        {
            "x": 0.06691426038742065,
            "y": 0.01399010419845581,
            "z": -381.1914978027344
        },
        {
            "x": 0.06673601269721985,
            "y": 0.013983644545078278,
            "z": -381.0341796875
        },
        {
            "x": 0.06655779480934143,
            "y": 0.01397714763879776,
            "z": -380.8769836425781
        },
        {
            "x": 0.0663796067237854,
            "y": 0.013970725238323212,
            "z": -380.7195129394531
        },
        {
            "x": 0.06620132923126221,
            "y": 0.013964198529720306,
            "z": -380.5622863769531
        },
        {
            "x": 0.06602293252944946,
            "y": 0.013957731425762177,
            "z": -380.405029296875
        },
        {
            "x": 0.06584540009498596,
            "y": 0.013951241970062256,
            "z": -380.2476806640625
        },
        {
            "x": 0.06566980481147766,
            "y": 0.013944819569587708,
            "z": -380.0904541015625
        },
        {
            "x": 0.06549540162086487,
            "y": 0.013938307762145996,
            "z": -379.9331359863281
        },
        {
            "x": 0.0653185248374939,
            "y": 0.013931795954704285,
            "z": -379.7757873535156
        },
        {
            "x": 0.06514531373977661,
            "y": 0.013925313949584961,
            "z": -379.61859130859375
        },
        {
            "x": 0.06503653526306152,
            "y": 0.01392102986574173,
            "z": -379.5137939453125
        },
        {
            "x": 0.06488600373268127,
            "y": 0.013914413750171661,
            "z": -379.35662841796875
        },
        {
            "x": 0.06474784016609192,
            "y": 0.013907968997955322,
            "z": -379.19940185546875
        },
        {
            "x": 0.0646044909954071,
            "y": 0.01390150934457779,
            "z": -379.0419921875
        },
        {
            "x": 0.06449088454246521,
            "y": 0.013895004987716675,
            "z": -378.8849182128906
        },
        {
            "x": 0.06445017457008362,
            "y": 0.013888485729694366,
            "z": -378.72796630859375
        },
        {
            "x": 0.06449621915817261,
            "y": 0.013882063329219818,
            "z": -378.57086181640625
        },
        {
            "x": 0.06457328796386719,
            "y": 0.013875618577003479,
            "z": -378.4136962890625
        },
        {
            "x": 0.06470006704330444,
            "y": 0.013869062066078186,
            "z": -378.2566833496094
        },
        {
            "x": 0.06499561667442322,
            "y": 0.01386260986328125,
            "z": -378.1001281738281
        },
        {
            "x": 0.06554648280143738,
            "y": 0.013856105506420135,
            "z": -377.9436950683594
        },
        {
            "x": 0.06630337238311768,
            "y": 0.013849623501300812,
            "z": -377.786865234375
        },
        {
            "x": 0.06718844175338745,
            "y": 0.013843119144439697,
            "z": -377.6302185058594
        },
        {
            "x": 0.06832623481750488,
            "y": 0.013836659491062164,
            "z": -377.47418212890625
        },
        {
            "x": 0.06988653540611267,
            "y": 0.013830192387104034,
            "z": -377.3181457519531
        },
        {
            "x": 0.07183796167373657,
            "y": 0.013823695480823517,
            "z": -377.16204833984375
        },
        {
            "x": 0.07406285405158997,
            "y": 0.013817198574543,
            "z": -377.0055847167969
        },
        {
            "x": 0.07657730579376221,
            "y": 0.013810709118843079,
            "z": -376.8495788574219
        },
        {
            "x": 0.07958248257637024,
            "y": 0.013804256916046143,
            "z": -376.69415283203125
        },
        {
            "x": 0.08311429619789124,
            "y": 0.013797752559185028,
            "z": -376.538330078125
        },
        {
            "x": 0.08703082799911499,
            "y": 0.01379133015871048,
            "z": -376.3821716308594
        },
        {
            "x": 0.0912233293056488,
            "y": 0.013784833252429962,
            "z": -376.2261047363281
        },
        {
            "x": 0.09584507346153259,
            "y": 0.01377832144498825,
            "z": -376.0706481933594
        },
        {
            "x": 0.1010282039642334,
            "y": 0.01377185434103012,
            "z": -375.9154052734375
        },
        {
            "x": 0.10671877861022949,
            "y": 0.013765402138233185,
            "z": -375.7594909667969
        },
        {
            "x": 0.11273682117462158,
            "y": 0.013758867979049683,
            "z": -375.6031799316406
        },
        {
            "x": 0.11906275153160095,
            "y": 0.013752371072769165,
            "z": -375.44744873046875
        },
        {
            "x": 0.12587887048721313,
            "y": 0.013745903968811035,
            "z": -375.2922058105469
        },
        {
            "x": 0.1332569718360901,
            "y": 0.013739444315433502,
            "z": -375.1368103027344
        },
        {
            "x": 0.14107927680015564,
            "y": 0.013732954859733582,
            "z": -374.9808044433594
        },
        {
            "x": 0.14919257164001465,
            "y": 0.013726487755775452,
            "z": -374.8245849609375
        },
        {
            "x": 0.1576509177684784,
            "y": 0.013719983398914337,
            "z": -374.66925048828125
        },
        {
            "x": 0.1666380763053894,
            "y": 0.013713501393795013,
            "z": -374.51397705078125
        },
        {
            "x": 0.17616006731987,
            "y": 0.013706997036933899,
            "z": -374.3584289550781
        },
        {
            "x": 0.18605521321296692,
            "y": 0.013700522482395172,
            "z": -374.2024230957031
        },
        {
            "x": 0.19622313976287842,
            "y": 0.013694070279598236,
            "z": -374.0464782714844
        },
        {
            "x": 0.20679083466529846,
            "y": 0.013687580823898315,
            "z": -373.8913269042969
        },
        {
            "x": 0.21789881587028503,
            "y": 0.013681106269359589,
            "z": -373.7362060546875
        },
        {
            "x": 0.22950926423072815,
            "y": 0.013674609363079071,
            "z": -373.5804443359375
        },
        {
            "x": 0.24140432476997375,
            "y": 0.013668112456798553,
            "z": -373.4245300292969
        },
        {
            "x": 0.25359371304512024,
            "y": 0.01366165280342102,
            "z": -373.26904296875
        },
        {
            "x": 0.26624032855033875,
            "y": 0.013655208051204681,
            "z": -373.11407470703125
        },
        {
            "x": 0.27943506836891174,
            "y": 0.013648666441440582,
            "z": -372.9588317871094
        },
        {
            "x": 0.2884697914123535,
            "y": 0.013644307851791382,
            "z": -372.8551025390625
        },
        {
            "x": 0.3022373616695404,
            "y": 0.013637833297252655,
            "z": -372.69927978515625
        },
        {
            "x": 0.316290020942688,
            "y": 0.013631366193294525,
            "z": -372.5440673828125
        },
        {
            "x": 0.33081474900245667,
            "y": 0.013624876737594604,
            "z": -372.38909912109375
        },
        {
            "x": 0.3458569049835205,
            "y": 0.013618409633636475,
            "z": -372.2340087890625
        },
        {
            "x": 0.3612902760505676,
            "y": 0.013611935079097748,
            "z": -372.0783386230469
        },
        {
            "x": 0.3769644498825073,
            "y": 0.013605467975139618,
            "z": -371.92291259765625
        },
        {
            "x": 0.3929799497127533,
            "y": 0.013598963618278503,
            "z": -371.7679748535156
        },
        {
            "x": 0.4094914197921753,
            "y": 0.013592451810836792,
            "z": -371.6131896972656
        },
        {
            "x": 0.42649343609809875,
            "y": 0.013585962355136871,
            "z": -371.4580078125
        },
        {
            "x": 0.44381487369537354,
            "y": 0.01357947289943695,
            "z": -371.30242919921875
        },
        {
            "x": 0.46137508749961853,
            "y": 0.013572998344898224,
            "z": -371.1472473144531
        },
        {
            "x": 0.47930294275283813,
            "y": 0.013566538691520691,
            "z": -370.9927062988281
        },
        {
            "x": 0.49774035811424255,
            "y": 0.013560064136981964,
            "z": -370.8380432128906
        },
        {
            "x": 0.5166425108909607,
            "y": 0.01355355978012085,
            "z": -370.6827087402344
        },
        {
            "x": 0.5357721447944641,
            "y": 0.013547122478485107,
            "z": -370.52752685546875
        },
        {
            "x": 0.5551670789718628,
            "y": 0.013540588319301605,
            "z": -370.37274169921875
        },
        {
            "x": 0.5749872326850891,
            "y": 0.013534091413021088,
            "z": -370.2183532714844
        },
        {
            "x": 0.5953141450881958,
            "y": 0.013527654111385345,
            "z": -370.06365966796875
        },
        {
            "x": 0.6160207390785217,
            "y": 0.013521172106266022,
            "z": -369.908447265625
        },
        {
            "x": 0.6369102001190186,
            "y": 0.013514652848243713,
            "z": -369.7535400390625
        },
        {
            "x": 0.65810626745224,
            "y": 0.013508215546607971,
            "z": -369.5992431640625
        },
        {
            "x": 0.6797738075256348,
            "y": 0.013501681387424469,
            "z": -369.44500732421875
        },
        {
            "x": 0.7019054889678955,
            "y": 0.01349523663520813,
            "z": -369.29034423828125
        },
        {
            "x": 0.724321722984314,
            "y": 0.01348876953125,
            "z": -369.1353759765625
        },
        {
            "x": 0.7469519972801208,
            "y": 0.013482257723808289,
            "z": -368.9808654785156
        },
        {
            "x": 0.7699369192123413,
            "y": 0.013475775718688965,
            "z": -368.82684326171875
        },
        {
            "x": 0.7934199571609497,
            "y": 0.013469301164150238,
            "z": -368.6725769042969
        },
        {
            "x": 0.8172785043716431,
            "y": 0.013462819159030914,
            "z": -368.5179748535156
        },
        {
            "x": 0.8413453102111816,
            "y": 0.0134563148021698,
            "z": -368.3634338378906
        },
        {
            "x": 0.8656924366950989,
            "y": 0.01344987004995346,
            "z": -368.20916748046875
        },
        {
            "x": 0.8904217481613159,
            "y": 0.013443417847156525,
            "z": -368.0553894042969
        },
        {
            "x": 0.9156181812286377,
            "y": 0.013436898589134216,
            "z": -367.9012451171875
        },
        {
            "x": 0.9411259293556213,
            "y": 0.013430401682853699,
            "z": -367.7467041015625
        },
        {
            "x": 0.9668110013008118,
            "y": 0.01342395693063736,
            "z": -367.59259033203125
        },
        {
            "x": 0.9928348064422607,
            "y": 0.013417422771453857,
            "z": -367.438720703125
        },
        {
            "x": 1.0192530155181885,
            "y": 0.013410970568656921,
            "z": -367.2850646972656
        },
        {
            "x": 1.0460927486419678,
            "y": 0.013404496014118195,
            "z": -367.1310119628906
        },
        {
            "x": 1.0731958150863647,
            "y": 0.013397976756095886,
            "z": -366.9767150878906
        },
        {
            "x": 1.1004637479782104,
            "y": 0.013391561806201935,
            "z": -366.8229675292969
        },
        {
            "x": 1.1280990839004517,
            "y": 0.013385042548179626,
            "z": -366.6695251464844
        },
        {
            "x": 1.1561696529388428,
            "y": 0.013378523290157318,
            "z": -366.515869140625
        },
        {
            "x": 1.1845877170562744,
            "y": 0.01337210088968277,
            "z": -366.3619079589844
        },
        {
            "x": 1.2036464214324951,
            "y": 0.013367757201194763,
            "z": -366.25927734375
        },
        {
            "x": 1.2323665618896484,
            "y": 0.013361193239688873,
            "z": -366.1058044433594
        },
        {
            "x": 1.261427640914917,
            "y": 0.013354726135730743,
            "z": -365.95263671875
        },
        {
            "x": 1.2909693717956543,
            "y": 0.013348221778869629,
            "z": -365.7991027832031
        },
        {
            "x": 1.3208059072494507,
            "y": 0.013341784477233887,
            "z": -365.64544677734375
        },
        {
            "x": 1.350818395614624,
            "y": 0.013335272669792175,
            "z": -365.49188232421875
        },
        {
            "x": 1.3810715675354004,
            "y": 0.013328827917575836,
            "z": -365.3386535644531
        },
        {
            "x": 1.4116816520690918,
            "y": 0.013322345912456512,
            "z": -365.1857604980469
        },
        {
            "x": 1.4427356719970703,
            "y": 0.013315878808498383,
            "z": -365.0323791503906
        },
        {
            "x": 1.4740285873413086,
            "y": 0.013309374451637268,
            "z": -364.87884521484375
        },
        {
            "x": 1.505460262298584,
            "y": 0.013302907347679138,
            "z": -364.7256774902344
        },
        {
            "x": 1.537186861038208,
            "y": 0.013296402990818024,
            "z": -364.5728454589844
        },
        {
            "x": 1.5692925453186035,
            "y": 0.0132899209856987,
            "z": -364.4200744628906
        },
        {
            "x": 1.6017565727233887,
            "y": 0.01328347623348236,
            "z": -364.2669372558594
        },
        {
            "x": 1.6344516277313232,
            "y": 0.01327696442604065,
            "z": -364.11358642578125
        },
        {
            "x": 1.667290210723877,
            "y": 0.013270474970340729,
            "z": -363.9608459472656
        },
        {
            "x": 1.7004444599151611,
            "y": 0.013263940811157227,
            "z": -363.808349609375
        },
        {
            "x": 1.73398756980896,
            "y": 0.013257518410682678,
            "z": -363.6556396484375
        },
        {
            "x": 1.767822504043579,
            "y": 0.013250991702079773,
            "z": -363.5027160644531
        },
        {
            "x": 1.8018662929534912,
            "y": 0.013244502246379852,
            "z": -363.34967041015625
        },
        {
            "x": 1.8360501527786255,
            "y": 0.013238035142421722,
            "z": -363.19732666015625
        },
        {
            "x": 1.8705639839172363,
            "y": 0.013231523334980011,
            "z": -363.0451354980469
        },
        {
            "x": 1.9054648876190186,
            "y": 0.013225071132183075,
            "z": -362.892578125
        },
        {
            "x": 1.9406001567840576,
            "y": 0.01321856677532196,
            "z": -362.7398376464844
        },
        {
            "x": 1.9758940935134888,
            "y": 0.013212084770202637,
            "z": -362.58740234375
        },
        {
            "x": 2.011415481567383,
            "y": 0.013205617666244507,
            "z": -362.435302734375
        },
        {
            "x": 2.047266721725464,
            "y": 0.013199128210544586,
            "z": -362.2832336425781
        },
        {
            "x": 2.0835065841674805,
            "y": 0.013192668557167053,
            "z": -362.1307678222656
        },
        {
            "x": 2.119865655899048,
            "y": 0.013186194002628326,
            "z": -361.9783935546875
        },
        {
            "x": 2.1563851833343506,
            "y": 0.013179711997509003,
            "z": -361.8263854980469
        },
        {
            "x": 2.193216562271118,
            "y": 0.013173237442970276,
            "z": -361.6744689941406
        },
        {
            "x": 2.230377435684204,
            "y": 0.013166680932044983,
            "z": -361.52252197265625
        },
        {
            "x": 2.2678260803222656,
            "y": 0.01316024363040924,
            "z": -361.37030029296875
        },
        {
            "x": 2.30540132522583,
            "y": 0.01315375417470932,
            "z": -361.21820068359375
        },
        {
            "x": 2.3431174755096436,
            "y": 0.0131472647190094,
            "z": -361.0665283203125
        },
        {
            "x": 2.3811967372894287,
            "y": 0.013140782713890076,
            "z": -360.91485595703125
        },
        {
            "x": 2.4195709228515625,
            "y": 0.013134293258190155,
            "z": -360.7630310058594
        },
        {
            "x": 2.458160638809204,
            "y": 0.013127855956554413,
            "z": -360.611083984375
        },
        {
            "x": 2.4968602657318115,
            "y": 0.013121351599693298,
            "z": -360.4593505859375
        },
        {
            "x": 2.5357635021209717,
            "y": 0.013114899396896362,
            "z": -360.3080139160156
        },
        {
            "x": 2.5750229358673096,
            "y": 0.013108387589454651,
            "z": -360.1566467285156
        },
        {
            "x": 2.6145577430725098,
            "y": 0.013101927936077118,
            "z": -360.00494384765625
        },
        {
            "x": 2.6542580127716064,
            "y": 0.013095453381538391,
            "z": -359.853271484375
        },
        {
            "x": 2.6807661056518555,
            "y": 0.01309109479188919,
            "z": -359.7524108886719
        },
        {
            "x": 2.720712661743164,
            "y": 0.013084612786769867,
            "z": -359.6012268066406
        },
        {
            "x": 2.7609519958496094,
            "y": 0.013078145682811737,
            "z": -359.4501953125
        },
        {
            "x": 2.801553726196289,
            "y": 0.013071626424789429,
            "z": -359.2985534667969
        },
        {
            "x": 2.8422279357910156,
            "y": 0.01306518167257309,
            "z": -359.1472473144531
        },
        {
            "x": 2.8830294609069824,
            "y": 0.013058699667453766,
            "z": -358.99615478515625
        },
        {
            "x": 2.924086093902588,
            "y": 0.013052180409431458,
            "z": -358.84527587890625
        },
        {
            "x": 2.965442180633545,
            "y": 0.013045735657215118,
            "z": -358.6942443847656
        },
        {
            "x": 3.007059097290039,
            "y": 0.013039223849773407,
            "z": -358.5430603027344
        },
        {
            "x": 3.0487887859344482,
            "y": 0.01303272694349289,
            "z": -358.391845703125
        },
        {
            "x": 3.090613842010498,
            "y": 0.013026274740695953,
            "z": -358.2411193847656
        },
        {
            "x": 3.132716417312622,
            "y": 0.013019777834415436,
            "z": -358.0904541015625
        },
        {
            "x": 3.175092935562134,
            "y": 0.013013295829296112,
            "z": -357.9396057128906
        },
        {
            "x": 3.2176501750946045,
            "y": 0.013006821274757385,
            "z": -357.7886962890625
        },
        {
            "x": 3.2603554725646973,
            "y": 0.01300027221441269,
            "z": -357.6377258300781
        },
        {
            "x": 3.3031625747680664,
            "y": 0.012993857264518738,
            "z": -357.48736572265625
        },
        {
            "x": 3.3462681770324707,
            "y": 0.01298733800649643,
            "z": -357.3368225097656
        },
        {
            "x": 3.3896422386169434,
            "y": 0.01298089325428009,
            "z": -357.1861267089844
        },
        {
            "x": 3.433102607727051,
            "y": 0.012974388897418976,
            "z": -357.0355224609375
        },
        {
            "x": 3.4767491817474365,
            "y": 0.012967891991138458,
            "z": -356.88482666015625
        },
        {
            "x": 3.520505666732788,
            "y": 0.012961424887180328,
            "z": -356.73468017578125
        },
        {
            "x": 3.5645294189453125,
            "y": 0.012954950332641602,
            "z": -356.58447265625
        },
        {
            "x": 3.608795642852783,
            "y": 0.012948468327522278,
            "z": -356.4339294433594
        },
        {
            "x": 3.6531314849853516,
            "y": 0.01294197142124176,
            "z": -356.2835998535156
        },
        {
            "x": 3.697617769241333,
            "y": 0.012935526669025421,
            "z": -356.13336181640625
        },
        {
            "x": 3.7423207759857178,
            "y": 0.012929104268550873,
            "z": -355.98333740234375
        },
        {
            "x": 3.7872395515441895,
            "y": 0.012922525405883789,
            "z": -355.8332214355469
        },
        {
            "x": 3.832388401031494,
            "y": 0.012916050851345062,
            "z": -355.6827697753906
        },
        {
            "x": 3.877551555633545,
            "y": 0.012909546494483948,
            "z": -355.5327453613281
        },
        {
            "x": 3.9228596687316895,
            "y": 0.01290304958820343,
            "z": -355.3829040527344
        },
        {
            "x": 3.9684505462646484,
            "y": 0.012896627187728882,
            "z": -355.2329406738281
        },
        {
            "x": 4.014216899871826,
            "y": 0.012890100479125977,
            "z": -355.08294677734375
        },
        {
            "x": 4.060122013092041,
            "y": 0.012883618474006653,
            "z": -354.93292236328125
        },
        {
            "x": 4.10610818862915,
            "y": 0.012877136468887329,
            "z": -354.78302001953125
        },
        {
            "x": 4.152231693267822,
            "y": 0.012870624661445618,
            "z": -354.6333923339844
        },
        {
            "x": 4.198642253875732,
            "y": 0.01286422461271286,
            "z": -354.4835510253906
        },
        {
            "x": 4.245186805725098,
            "y": 0.012857630848884583,
            "z": -354.3337097167969
        },
        {
            "x": 4.291818618774414,
            "y": 0.012851215898990631,
            "z": -354.1839294433594
        },
        {
            "x": 4.3385748863220215,
            "y": 0.012844718992710114,
            "z": -354.0343017578125
        },
        {
            "x": 4.385465145111084,
            "y": 0.012838222086429596,
            "z": -353.8848571777344
        },
        {
            "x": 4.4325995445251465,
            "y": 0.012831754982471466,
            "z": -353.7353210449219
        },
        {
            "x": 4.479913711547852,
            "y": 0.012825295329093933,
            "z": -353.5855407714844
        },
        {
            "x": 4.527250289916992,
            "y": 0.01281881332397461,
            "z": -353.4360046386719
        },
        {
            "x": 4.558847904205322,
            "y": 0.012814521789550781,
            "z": -353.33648681640625
        },
        {
            "x": 4.6064043045043945,
            "y": 0.012807920575141907,
            "z": -353.18719482421875
        },
        {
            "x": 4.6541428565979,
            "y": 0.01280142366886139,
            "z": -353.03790283203125
        },
        {
            "x": 4.702134609222412,
            "y": 0.012794964015483856,
            "z": -352.88818359375
        },
        {
            "x": 4.75010871887207,
            "y": 0.012788452208042145,
            "z": -352.7388610839844
        },
        {
            "x": 4.798174858093262,
            "y": 0.012781977653503418,
            "z": -352.5897216796875
        },
        {
            "x": 4.846443176269531,
            "y": 0.012775540351867676,
            "z": -352.4405212402344
        },
        {
            "x": 4.894864559173584,
            "y": 0.012769035995006561,
            "z": -352.2913513183594
        },
        {
            "x": 4.943458557128906,
            "y": 0.012762516736984253,
            "z": -352.1418762207031
        },
        {
            "x": 4.9920735359191895,
            "y": 0.012756019830703735,
            "z": -351.99267578125
        },
        {
            "x": 5.040760517120361,
            "y": 0.012749537825584412,
            "z": -351.84381103515625
        },
        {
            "x": 5.089694023132324,
            "y": 0.012743040919303894,
            "z": -351.6946716308594
        },
        {
            "x": 5.138731002807617,
            "y": 0.01273655891418457,
            "z": -351.54559326171875
        },
        {
            "x": 5.18784761428833,
            "y": 0.012730106711387634,
            "z": -351.3965759277344
        },
        {
            "x": 5.237102031707764,
            "y": 0.012723654508590698,
            "z": -351.2474365234375
        },
        {
            "x": 5.286389350891113,
            "y": 0.012717150151729584,
            "z": -351.0986328125
        },
        {
            "x": 5.335877895355225,
            "y": 0.01271064579486847,
            "z": -350.94970703125
        },
        {
            "x": 5.385498523712158,
            "y": 0.012704148888587952,
            "z": -350.80078125
        },
        {
            "x": 5.435191631317139,
            "y": 0.012697704136371613,
            "z": -350.6518249511719
        },
        {
            "x": 5.4849748611450195,
            "y": 0.012691162526607513,
            "z": -350.5029602050781
        },
        {
            "x": 5.534827709197998,
            "y": 0.012684725224971771,
            "z": -350.3542785644531
        },
        {
            "x": 5.584829330444336,
            "y": 0.01269141398370266,
            "z": -350.2055358886719
        },
        {
            "x": 5.634944915771484,
            "y": 0.012900492176413536,
            "z": -350.05670166015625
        },
        {
            "x": 5.685100555419922,
            "y": 0.013420965522527695,
            "z": -349.90802001953125
        },
        {
            "x": 5.735345363616943,
            "y": 0.014260298572480679,
            "z": -349.75946044921875
        },
        {
            "x": 5.785747528076172,
            "y": 0.015401746146380901,
            "z": -349.6108093261719
        },
        {
            "x": 5.836250305175781,
            "y": 0.016840659081935883,
            "z": -349.46221923828125
        },
        {
            "x": 5.886847496032715,
            "y": 0.018574796617031097,
            "z": -349.3134765625
        },
        {
            "x": 5.937473297119141,
            "y": 0.020609330385923386,
            "z": -349.1649169921875
        },
        {
            "x": 5.988159656524658,
            "y": 0.022926490753889084,
            "z": -349.0166015625
        },
        {
            "x": 6.039035797119141,
            "y": 0.025527222082018852,
            "z": -348.8680419921875
        },
        {
            "x": 6.089967727661133,
            "y": 0.028403764590620995,
            "z": -348.71954345703125
        },
        {
            "x": 6.140987873077393,
            "y": 0.031566642224788666,
            "z": -348.57098388671875
        },
        {
            "x": 6.1920342445373535,
            "y": 0.03499406576156616,
            "z": -348.422607421875
        },
        {
            "x": 6.2431440353393555,
            "y": 0.03868163749575615,
            "z": -348.27435302734375
        },
        {
            "x": 6.2944440841674805,
            "y": 0.042635127902030945,
            "z": -348.1258544921875
        },
        {
            "x": 6.345767498016357,
            "y": 0.04685289412736893,
            "z": -347.9775390625
        },
        {
            "x": 6.39713716506958,
            "y": 0.05132051557302475,
            "z": -347.8291320800781
        },
        {
            "x": 6.448562145233154,
            "y": 0.05603296682238579,
            "z": -347.6808776855469
        },
        {
            "x": 6.500070571899414,
            "y": 0.060985419899225235,
            "z": -347.5327453613281
        },
        {
            "x": 6.551694393157959,
            "y": 0.06619108468294144,
            "z": -347.3844299316406
        },
        {
            "x": 6.603386878967285,
            "y": 0.07163210213184357,
            "z": -347.2361145019531
        },
        {
            "x": 6.6550822257995605,
            "y": 0.07729743421077728,
            "z": -347.0879211425781
        },
        {
            "x": 6.689555644989014,
            "y": 0.08119712769985199,
            "z": -346.9892578125
        },
        {
            "x": 6.74137020111084,
            "y": 0.08724016696214676,
            "z": -346.8411560058594
        },
        {
            "x": 6.793259620666504,
            "y": 0.09350112080574036,
            "z": -346.693115234375
        },
        {
            "x": 6.845264434814453,
            "y": 0.09998622536659241,
            "z": -346.5447998046875
        },
        {
            "x": 6.897223472595215,
            "y": 0.10667635500431061,
            "z": -346.3967590332031
        },
        {
            "x": 6.949249267578125,
            "y": 0.11357235908508301,
            "z": -346.248779296875
        },
        {
            "x": 7.001350402832031,
            "y": 0.12067021429538727,
            "z": -346.10076904296875
        },
        {
            "x": 7.053522109985352,
            "y": 0.1279652714729309,
            "z": -345.9527587890625
        },
        {
            "x": 7.105769634246826,
            "y": 0.13546568155288696,
            "z": -345.8046875
        },
        {
            "x": 7.158022403717041,
            "y": 0.14315132796764374,
            "z": -345.6566467285156
        },
        {
            "x": 7.2102861404418945,
            "y": 0.1510135978460312,
            "z": -345.5087890625
        },
        {
            "x": 7.262661933898926,
            "y": 0.15906250476837158,
            "z": -345.36083984375
        },
        {
            "x": 7.315040111541748,
            "y": 0.16728626191616058,
            "z": -345.21295166015625
        },
        {
            "x": 7.367465019226074,
            "y": 0.17568549513816833,
            "z": -345.0650634765625
        },
        {
            "x": 7.4199538230896,
            "y": 0.18425676226615906,
            "z": -344.91705322265625
        },
        {
            "x": 7.472433567047119,
            "y": 0.19298090040683746,
            "z": -344.7692565917969
        },
        {
            "x": 7.524979114532471,
            "y": 0.2018670290708542,
            "z": -344.6214599609375
        },
        {
            "x": 7.577573776245117,
            "y": 0.21091680228710175,
            "z": -344.4735412597656
        },
        {
            "x": 7.630148410797119,
            "y": 0.22010652720928192,
            "z": -344.3258056640625
        },
        {
            "x": 7.682823657989502,
            "y": 0.22945255041122437,
            "z": -344.1778869628906
        },
        {
            "x": 7.735487461090088,
            "y": 0.23893174529075623,
            "z": -344.0301818847656
        },
        {
            "x": 7.788192272186279,
            "y": 0.24855485558509827,
            "z": -343.88238525390625
        },
        {
            "x": 7.840889930725098,
            "y": 0.2583059072494507,
            "z": -343.7346496582031
        },
        {
            "x": 7.893610000610352,
            "y": 0.2681823968887329,
            "z": -343.5870056152344
        },
        {
            "x": 7.946393013000488,
            "y": 0.2781945466995239,
            "z": -343.4391784667969
        },
        {
            "x": 7.999183177947998,
            "y": 0.28832417726516724,
            "z": -343.2914733886719
        },
        {
            "x": 8.05197811126709,
            "y": 0.29856544733047485,
            "z": -343.1438293457031
        },
        {
            "x": 8.104830741882324,
            "y": 0.30892640352249146,
            "z": -342.9960632324219
        },
        {
            "x": 8.157666206359863,
            "y": 0.31938663125038147,
            "z": -342.8483581542969
        },
        {
            "x": 8.210494041442871,
            "y": 0.32995134592056274,
            "z": -342.70074462890625
        },
        {
            "x": 8.263436317443848,
            "y": 0.34063059091567993,
            "z": -342.5528869628906
        },
        {
            "x": 8.316300392150879,
            "y": 0.35138654708862305,
            "z": -342.4053039550781
        },
        {
            "x": 8.369206428527832,
            "y": 0.36224058270454407,
            "z": -342.2575378417969
        },
        {
            "x": 8.422097206115723,
            "y": 0.37317416071891785,
            "z": -342.1099853515625
        },
        {
            "x": 8.475019454956055,
            "y": 0.38419458270072937,
            "z": -341.9622802734375
        },
        {
            "x": 8.52800464630127,
            "y": 0.3953064978122711,
            "z": -341.814453125
        },
        {
            "x": 8.580906867980957,
            "y": 0.4064740240573883,
            "z": -341.66680908203125
        },
        {
            "x": 8.633805274963379,
            "y": 0.4177114963531494,
            "z": -341.5191955566406
        },
        {
            "x": 8.686767578125,
            "y": 0.4290255308151245,
            "z": -341.3714294433594
        },
        {
            "x": 8.739667892456055,
            "y": 0.440385639667511,
            "z": -341.22381591796875
        },
        {
            "x": 8.792633056640625,
            "y": 0.45181649923324585,
            "z": -341.0760498046875
        },
        {
            "x": 8.845574378967285,
            "y": 0.46329861879348755,
            "z": -340.92828369140625
        },
        {
            "x": 8.898462295532227,
            "y": 0.47481590509414673,
            "z": -340.7806396484375
        },
        {
            "x": 8.933733940124512,
            "y": 0.4825212359428406,
            "z": -340.6821594238281
        },
        {
            "x": 8.986624717712402,
            "y": 0.4941115379333496,
            "z": -340.5345153808594
        },
        {
            "x": 9.039509773254395,
            "y": 0.5057414770126343,
            "z": -340.3868103027344
        },
        {
            "x": 9.092440605163574,
            "y": 0.5174137353897095,
            "z": -340.2389831542969
        },
        {
            "x": 9.145297050476074,
            "y": 0.529100239276886,
            "z": -340.0912780761719
        },
        {
            "x": 9.198153495788574,
            "y": 0.5408117771148682,
            "z": -339.9435729980469
        },
        {
            "x": 9.251015663146973,
            "y": 0.5525509119033813,
            "z": -339.7957458496094
        },
        {
            "x": 9.303813934326172,
            "y": 0.564294695854187,
            "z": -339.6480407714844
        },
        {
            "x": 9.356624603271484,
            "y": 0.5760548710823059,
            "z": -339.5002746582031
        },
        {
            "x": 9.409406661987305,
            "y": 0.5878180861473083,
            "z": -339.3525085449219
        },
        {
            "x": 9.462172508239746,
            "y": 0.5995841026306152,
            "z": -339.2047424316406
        },
        {
            "x": 9.51492691040039,
            "y": 0.6113543510437012,
            "z": -339.0568542480469
        },
        {
            "x": 9.56760311126709,
            "y": 0.6231088638305664,
            "z": -338.9090881347656
        },
        {
            "x": 9.62025260925293,
            "y": 0.6348499059677124,
            "z": -338.7613220214844
        },
        {
            "x": 9.672983169555664,
            "y": 0.6465950012207031,
            "z": -338.6133117675781
        },
        {
            "x": 9.725611686706543,
            "y": 0.6583080291748047,
            "z": -338.4654541015625
        },
        {
            "x": 9.778194427490234,
            "y": 0.6699990034103394,
            "z": -338.3175964355469
        },
        {
            "x": 9.83073616027832,
            "y": 0.6816611289978027,
            "z": -338.1696472167969
        },
        {
            "x": 9.883243560791016,
            "y": 0.6932852268218994,
            "z": -338.0218200683594
        },
        {
            "x": 9.935796737670898,
            "y": 0.7048908472061157,
            "z": -337.87371826171875
        },
        {
            "x": 9.988251686096191,
            "y": 0.7164456844329834,
            "z": -337.7257385253906
        },
        {
            "x": 10.040631294250488,
            "y": 0.7279508113861084,
            "z": -337.5777893066406
        },
        {
            "x": 10.092974662780762,
            "y": 0.7394043207168579,
            "z": -337.4298095703125
        },
        {
            "x": 10.145297050476074,
            "y": 0.7508043050765991,
            "z": -337.2818603515625
        },
        {
            "x": 10.197625160217285,
            "y": 0.7621596455574036,
            "z": -337.1336975097656
        },
        {
            "x": 10.249885559082031,
            "y": 0.7734550833702087,
            "z": -336.9855041503906
        },
        {
            "x": 10.302059173583984,
            "y": 0.7846747636795044,
            "z": -336.83740234375
        },
        {
            "x": 10.354167938232422,
            "y": 0.7958201766014099,
            "z": -336.6893310546875
        },
        {
            "x": 10.406257629394531,
            "y": 0.8068946599960327,
            "z": -336.5411376953125
        },
        {
            "x": 10.458280563354492,
            "y": 0.8178917169570923,
            "z": -336.3929443359375
        },
        {
            "x": 10.510300636291504,
            "y": 0.8288158178329468,
            "z": -336.2445373535156
        },
        {
            "x": 10.562178611755371,
            "y": 0.8396341800689697,
            "z": -336.0963134765625
        },
        {
            "x": 10.614042282104492,
            "y": 0.8503648042678833,
            "z": -335.94805908203125
        },
        {
            "x": 10.665885925292969,
            "y": 0.8610086441040039,
            "z": -335.7996520996094
        },
        {
            "x": 10.717616081237793,
            "y": 0.8715436458587646,
            "z": -335.6512451171875
        },
        {
            "x": 10.769315719604492,
            "y": 0.8819823265075684,
            "z": -335.50274658203125
        },
        {
            "x": 10.820907592773438,
            "y": 0.8922988772392273,
            "z": -335.3543395996094
        },
        {
            "x": 10.872452735900879,
            "y": 0.9025043249130249,
            "z": -335.2059326171875
        },
        {
            "x": 10.923995018005371,
            "y": 0.9126042127609253,
            "z": -335.0572814941406
        },
        {
            "x": 10.9753999710083,
            "y": 0.9225741624832153,
            "z": -334.9086608886719
        },
        {
            "x": 11.026712417602539,
            "y": 0.9324161410331726,
            "z": -334.7601013183594
        },
        {
            "x": 11.077957153320312,
            "y": 0.9421244263648987,
            "z": -334.6114807128906
        },
        {
            "x": 11.129168510437012,
            "y": 0.9517009854316711,
            "z": -334.4628601074219
        },
        {
            "x": 11.163274765014648,
            "y": 0.9580084085464478,
            "z": -334.3636169433594
        },
        {
            "x": 11.214319229125977,
            "y": 0.9673532247543335,
            "z": -334.21484375
        },
        {
            "x": 11.26525592803955,
            "y": 0.9765471816062927,
            "z": -334.06610107421875
        },
        {
            "x": 11.316133499145508,
            "y": 0.9855859875679016,
            "z": -333.91729736328125
        },
        {
            "x": 11.366978645324707,
            "y": 0.9944727420806885,
            "z": -333.76837158203125
        },
        {
            "x": 11.417726516723633,
            "y": 1.0032048225402832,
            "z": -333.61944580078125
        },
        {
            "x": 11.468382835388184,
            "y": 1.011777639389038,
            "z": -333.4703063964844
        },
        {
            "x": 11.518872261047363,
            "y": 1.0201635360717773,
            "z": -333.3214416503906
        },
        {
            "x": 11.569357872009277,
            "y": 1.028386116027832,
            "z": -333.1723327636719
        },
        {
            "x": 11.619767189025879,
            "y": 1.036437749862671,
            "z": -333.0231628417969
        },
        {
            "x": 11.670064926147461,
            "y": 1.0443116426467896,
            "z": -332.8738708496094
        },
        {
            "x": 11.72020149230957,
            "y": 1.0519862174987793,
            "z": -332.7246398925781
        },
        {
            "x": 11.770224571228027,
            "y": 1.0594662427902222,
            "z": -332.5755310058594
        },
        {
            "x": 11.820202827453613,
            "y": 1.066757321357727,
            "z": -332.42626953125
        },
        {
            "x": 11.870182037353516,
            "y": 1.0738662481307983,
            "z": -332.27667236328125
        },
        {
            "x": 11.919942855834961,
            "y": 1.0807561874389648,
            "z": -332.127197265625
        },
        {
            "x": 11.96955680847168,
            "y": 1.087435245513916,
            "z": -331.977783203125
        },
        {
            "x": 12.019087791442871,
            "y": 1.093902587890625,
            "z": -331.828369140625
        },
        {
            "x": 12.068572044372559,
            "y": 1.100162148475647,
            "z": -331.6788024902344
        },
        {
            "x": 12.117960929870605,
            "y": 1.1062002182006836,
            "z": -331.5289611816406
        },
        {
            "x": 12.167133331298828,
            "y": 1.1120052337646484,
            "z": -331.3793029785156
        },
        {
            "x": 12.216181755065918,
            "y": 1.1175816059112549,
            "z": -331.2296142578125
        },
        {
            "x": 12.265111923217773,
            "y": 1.1229209899902344,
            "z": -331.0801086425781
        },
        {
            "x": 12.314029693603516,
            "y": 1.1280268430709839,
            "z": -330.93017578125
        },
        {
            "x": 12.362792015075684,
            "y": 1.132891058921814,
            "z": -330.7801818847656
        },
        {
            "x": 12.411396980285645,
            "y": 1.1375091075897217,
            "z": -330.630126953125
        },
        {
            "x": 12.459821701049805,
            "y": 1.1418712139129639,
            "z": -330.48028564453125
        },
        {
            "x": 12.508217811584473,
            "y": 1.1459770202636719,
            "z": -330.3302001953125
        },
        {
            "x": 12.556492805480957,
            "y": 1.149823546409607,
            "z": -330.1800537109375
        },
        {
            "x": 12.60455322265625,
            "y": 1.1534063816070557,
            "z": -330.02984619140625
        },
        {
            "x": 12.652496337890625,
            "y": 1.156723976135254,
            "z": -329.8795471191406
        },
        {
            "x": 12.700281143188477,
            "y": 1.1597566604614258,
            "z": -329.7294616699219
        },
        {
            "x": 12.748008728027344,
            "y": 1.1625148057937622,
            "z": -329.5791015625
        },
        {
            "x": 12.795605659484863,
            "y": 1.1649961471557617,
            "z": -329.42852783203125
        },
        {
            "x": 12.842941284179688,
            "y": 1.1671909093856812,
            "z": -329.278076171875
        },
        {
            "x": 12.890183448791504,
            "y": 1.16908860206604,
            "z": -329.1275329589844
        },
        {
            "x": 12.93726921081543,
            "y": 1.1706876754760742,
            "z": -328.9771728515625
        },
        {
            "x": 12.984268188476562,
            "y": 1.1719921827316284,
            "z": -328.82647705078125
        },
        {
            "x": 13.031108856201172,
            "y": 1.1729974746704102,
            "z": -328.6755676269531
        },
        {
            "x": 13.077685356140137,
            "y": 1.173685073852539,
            "z": -328.5248718261719
        },
        {
            "x": 13.124114990234375,
            "y": 1.1740586757659912,
            "z": -328.3742980957031
        },
        {
            "x": 13.170500755310059,
            "y": 1.1741183996200562,
            "z": -328.223388671875
        },
        {
            "x": 13.216717720031738,
            "y": 1.1738628149032593,
            "z": -328.07232666015625
        },
        {
            "x": 13.247386932373047,
            "y": 1.1735093593597412,
            "z": -327.97161865234375
        },
        {
            "x": 13.293184280395508,
            "y": 1.1727283000946045,
            "z": -327.8207702636719
        },
        {
            "x": 13.338846206665039,
            "y": 1.171643614768982,
            "z": -327.6699523925781
        },
        {
            "x": 13.38448429107666,
            "y": 1.1702470779418945,
            "z": -327.5187072753906
        },
        {
            "x": 13.429888725280762,
            "y": 1.1685497760772705,
            "z": -327.367431640625
        },
        {
            "x": 13.475056648254395,
            "y": 1.1665616035461426,
            "z": -327.2161865234375
        },
        {
            "x": 13.520024299621582,
            "y": 1.1642882823944092,
            "z": -327.0649719238281
        },
        {
            "x": 13.564848899841309,
            "y": 1.1617259979248047,
            "z": -326.913818359375
        },
        {
            "x": 13.609599113464355,
            "y": 1.158872365951538,
            "z": -326.7622985839844
        },
        {
            "x": 13.654115676879883,
            "y": 1.1557438373565674,
            "z": -326.610595703125
        },
        {
            "x": 13.698315620422363,
            "y": 1.1523518562316895,
            "z": -326.459228515625
        },
        {
            "x": 13.7423677444458,
            "y": 1.1486890316009521,
            "z": -326.30780029296875
        },
        {
            "x": 13.786288261413574,
            "y": 1.1447588205337524,
            "z": -326.15631103515625
        },
        {
            "x": 13.830059051513672,
            "y": 1.1405645608901978,
            "z": -326.0045471191406
        },
        {
            "x": 13.873611450195312,
            "y": 1.136113166809082,
            "z": -325.8525390625
        },
        {
            "x": 13.916847229003906,
            "y": 1.131421446800232,
            "z": -325.7008972167969
        },
        {
            "x": 13.959940910339355,
            "y": 1.1264796257019043,
            "z": -325.5492858886719
        },
        {
            "x": 14.002925872802734,
            "y": 1.1212899684906006,
            "z": -325.3973083496094
        },
        {
            "x": 14.045670509338379,
            "y": 1.115862250328064,
            "z": -325.2452087402344
        },
        {
            "x": 14.088156700134277,
            "y": 1.1101980209350586,
            "z": -325.0930480957031
        },
        {
            "x": 14.13036060333252,
            "y": 1.1043174266815186,
            "z": -324.9412841796875
        },
        {
            "x": 14.17245864868164,
            "y": 1.0982081890106201,
            "z": -324.789306640625
        },
        {
            "x": 14.214395523071289,
            "y": 1.0918699502944946,
            "z": -324.6369934082031
        },
        {
            "x": 14.256022453308105,
            "y": 1.0853182077407837,
            "z": -324.4847106933594
        },
        {
            "x": 14.297379493713379,
            "y": 1.0785564184188843,
            "z": -324.33245849609375
        },
        {
            "x": 14.338563919067383,
            "y": 1.0715937614440918,
            "z": -324.1802978515625
        },
        {
            "x": 14.379595756530762,
            "y": 1.0644245147705078,
            "z": -324.0279541015625
        },
        {
            "x": 14.420435905456543,
            "y": 1.0570404529571533,
            "z": -323.8752136230469
        },
        {
            "x": 14.46088981628418,
            "y": 1.0494723320007324,
            "z": -323.72271728515625
        },
        {
            "x": 14.501092910766602,
            "y": 1.0417299270629883,
            "z": -323.5704345703125
        },
        {
            "x": 14.541214942932129,
            "y": 1.0337884426116943,
            "z": -323.41778564453125
        },
        {
            "x": 14.581114768981934,
            "y": 1.0256619453430176,
            "z": -323.2650146484375
        },
        {
            "x": 14.620721817016602,
            "y": 1.0173463821411133,
            "z": -323.1120300292969
        },
        {
            "x": 14.659991264343262,
            "y": 1.008876085281372,
            "z": -322.9592590332031
        },
        {
            "x": 14.699018478393555,
            "y": 1.000255823135376,
            "z": -322.8067932128906
        },
        {
            "x": 14.737977027893066,
            "y": 0.9914467334747314,
            "z": -322.6537780761719
        },
        {
            "x": 14.77665901184082,
            "y": 0.9824641942977905,
            "z": -322.50048828125
        },
        {
            "x": 14.814955711364746,
            "y": 0.9733437895774841,
            "z": -322.3474426269531
        },
        {
            "x": 14.852997779846191,
            "y": 0.9640843868255615,
            "z": -322.1944885253906
        },
        {
            "x": 14.890857696533203,
            "y": 0.9546843767166138,
            "z": -322.04156494140625
        },
        {
            "x": 14.92856216430664,
            "y": 0.9451078176498413,
            "z": -321.88812255859375
        },
        {
            "x": 14.965930938720703,
            "y": 0.9353931546211243,
            "z": -321.7345886230469
        },
        {
            "x": 15.002911567687988,
            "y": 0.9255703687667847,
            "z": -321.581298828125
        },
        {
            "x": 15.027412414550781,
            "y": 0.9189643859863281,
            "z": -321.4793395996094
        },
        {
            "x": 15.064090728759766,
            "y": 0.9089265465736389,
            "z": -321.3260192871094
        },
        {
            "x": 15.100532531738281,
            "y": 0.8987525701522827,
            "z": -321.17236328125
        },
        {
            "x": 15.136665344238281,
            "y": 0.8884509205818176,
            "z": -321.0184631347656
        },
        {
            "x": 15.172382354736328,
            "y": 0.8780635595321655,
            "z": -320.86492919921875
        },
        {
            "x": 15.207874298095703,
            "y": 0.8675819635391235,
            "z": -320.71160888671875
        },
        {
            "x": 15.243233680725098,
            "y": 0.8569675087928772,
            "z": -320.5577697753906
        },
        {
            "x": 15.278276443481445,
            "y": 0.8462433815002441,
            "z": -320.4037170410156
        },
        {
            "x": 15.312929153442383,
            "y": 0.8354313969612122,
            "z": -320.24969482421875
        },
        {
            "x": 15.347258567810059,
            "y": 0.8245529532432556,
            "z": -320.09600830078125
        },
        {
            "x": 15.381423950195312,
            "y": 0.8135788440704346,
            "z": -319.942138671875
        },
        {
            "x": 15.41537094116211,
            "y": 0.8024954795837402,
            "z": -319.7878112792969
        },
        {
            "x": 15.448909759521484,
            "y": 0.7913362979888916,
            "z": -319.6334533691406
        },
        {
            "x": 15.482039451599121,
            "y": 0.78013014793396,
            "z": -319.47943115234375
        },
        {
            "x": 15.514961242675781,
            "y": 0.7688559889793396,
            "z": -319.3253479003906
        },
        {
            "x": 15.547704696655273,
            "y": 0.7574989199638367,
            "z": -319.17095947265625
        },
        {
            "x": 15.580117225646973,
            "y": 0.7460618019104004,
            "z": -319.01629638671875
        },
        {
            "x": 15.612093925476074,
            "y": 0.7345851063728333,
            "z": -318.86175537109375
        },
        {
            "x": 15.643732070922852,
            "y": 0.7230818271636963,
            "z": -318.70745849609375
        },
        {
            "x": 15.675228118896484,
            "y": 0.7115098237991333,
            "z": -318.55291748046875
        },
        {
            "x": 15.706427574157715,
            "y": 0.6998783946037292,
            "z": -318.3980712890625
        },
        {
            "x": 15.737187385559082,
            "y": 0.6882097721099854,
            "z": -318.2431335449219
        },
        {
            "x": 15.767548561096191,
            "y": 0.6765315532684326,
            "z": -318.0885314941406
        },
        {
            "x": 15.797667503356934,
            "y": 0.6648350358009338,
            "z": -317.93402099609375
        },
        {
            "x": 15.82759952545166,
            "y": 0.6530766487121582,
            "z": -317.77899169921875
        },
        {
            "x": 15.85716438293457,
            "y": 0.6412754058837891,
            "z": -317.62359619140625
        },
        {
            "x": 15.886244773864746,
            "y": 0.6294842958450317,
            "z": -317.468505859375
        },
        {
            "x": 15.915007591247559,
            "y": 0.6176995038986206,
            "z": -317.3136291503906
        },
        {
            "x": 15.943556785583496,
            "y": 0.6058991551399231,
            "z": -317.15863037109375
        },
        {
            "x": 15.971803665161133,
            "y": 0.5940634608268738,
            "z": -317.0031433105469
        },
        {
            "x": 15.999628067016602,
            "y": 0.5822136402130127,
            "z": -316.8473815917969
        },
        {
            "x": 16.026994705200195,
            "y": 0.5704123377799988,
            "z": -316.69219970703125
        },
        {
            "x": 16.05410385131836,
            "y": 0.5586271286010742,
            "z": -316.5370178222656
        },
        {
            "x": 16.08099365234375,
            "y": 0.546823263168335,
            "z": -316.38140869140625
        },
        {
            "x": 16.10746955871582,
            "y": 0.5350208878517151,
            "z": -316.22552490234375
        },
        {
            "x": 16.133499145507812,
            "y": 0.5232459306716919,
            "z": -316.06964111328125
        },
        {
            "x": 16.159141540527344,
            "y": 0.5115358829498291,
            "z": -315.91424560546875
        },
        {
            "x": 16.1845645904541,
            "y": 0.4998438060283661,
            "z": -315.7586669921875
        },
        {
            "x": 16.209667205810547,
            "y": 0.4881437420845032,
            "z": -315.6023864746094
        },
        {
            "x": 16.234268188476562,
            "y": 0.47649431228637695,
            "z": -315.4462890625
        },
        {
            "x": 16.258441925048828,
            "y": 0.4649123549461365,
            "z": -315.2903747558594
        },
        {
            "x": 16.282350540161133,
            "y": 0.4533822238445282,
            "z": -315.134521484375
        },
        {
            "x": 16.305980682373047,
            "y": 0.4418787360191345,
            "z": -314.978271484375
        },
        {
            "x": 16.321500778198242,
            "y": 0.4342268109321594,
            "z": -314.87396240234375
        },
        {
            "x": 16.344329833984375,
            "y": 0.4228156805038452,
            "z": -314.7175598144531
        },
        {
            "x": 16.36673927307129,
            "y": 0.41149836778640747,
            "z": -314.5615539550781
        },
        {
            "x": 16.388933181762695,
            "y": 0.4002290368080139,
            "z": -314.4052734375
        },
        {
            "x": 16.410791397094727,
            "y": 0.3890093266963959,
            "z": -314.24859619140625
        },
        {
            "x": 16.432147979736328,
            "y": 0.37785834074020386,
            "z": -314.0918273925781
        },
        {
            "x": 16.453004837036133,
            "y": 0.3668121099472046,
            "z": -313.93524169921875
        },
        {
            "x": 16.473546981811523,
            "y": 0.35587453842163086,
            "z": -313.7790222167969
        },
        {
            "x": 16.493852615356445,
            "y": 0.34498316049575806,
            "z": -313.62213134765625
        },
        {
            "x": 16.513700485229492,
            "y": 0.33416303992271423,
            "z": -313.4649658203125
        },
        {
            "x": 16.53297233581543,
            "y": 0.3234695792198181,
            "z": -313.30804443359375
        },
        {
            "x": 16.551860809326172,
            "y": 0.312896728515625,
            "z": -313.1513977050781
        },
        {
            "x": 16.57048225402832,
            "y": 0.3024235963821411,
            "z": -312.9946594238281
        },
        {
            "x": 16.588743209838867,
            "y": 0.29202571511268616,
            "z": -312.8373718261719
        },
        {
            "x": 16.606447219848633,
            "y": 0.28173142671585083,
            "z": -312.6797790527344
        },
        {
            "x": 16.623641967773438,
            "y": 0.2716014087200165,
            "z": -312.5228271484375
        },
        {
            "x": 16.64055061340332,
            "y": 0.26159653067588806,
            "z": -312.36602783203125
        },
        {
            "x": 16.65715217590332,
            "y": 0.25168541073799133,
            "z": -312.2085876464844
        },
        {
            "x": 16.6732177734375,
            "y": 0.24189382791519165,
            "z": -312.0509033203125
        },
        {
            "x": 16.688745498657227,
            "y": 0.23224614560604095,
            "z": -311.8932800292969
        },
        {
            "x": 16.703874588012695,
            "y": 0.22277766466140747,
            "z": -311.7362976074219
        },
        {
            "x": 16.718732833862305,
            "y": 0.21342775225639343,
            "z": -311.57891845703125
        },
        {
            "x": 16.733129501342773,
            "y": 0.20419859886169434,
            "z": -311.42095947265625
        },
        {
            "x": 16.746929168701172,
            "y": 0.19513297080993652,
            "z": -311.2631530761719
        },
        {
            "x": 16.7602596282959,
            "y": 0.18624690175056458,
            "z": -311.1057434082031
        },
        {
            "x": 16.773303985595703,
            "y": 0.17751996219158173,
            "z": -310.94830322265625
        },
        {
            "x": 16.78596305847168,
            "y": 0.1689309924840927,
            "z": -310.790283203125
        },
        {
            "x": 16.79804039001465,
            "y": 0.16050028800964355,
            "z": -310.63201904296875
        },
        {
            "x": 16.809553146362305,
            "y": 0.1522698998451233,
            "z": -310.4742431640625
        },
        {
            "x": 16.820709228515625,
            "y": 0.14423172175884247,
            "z": -310.3167419433594
        },
        {
            "x": 16.831558227539062,
            "y": 0.13634660840034485,
            "z": -310.15869140625
        },
        {
            "x": 16.841861724853516,
            "y": 0.12863501906394958,
            "z": -310.000244140625
        },
        {
            "x": 16.851558685302734,
            "y": 0.1211216151714325,
            "z": -309.8419494628906
        },
        {
            "x": 16.860801696777344,
            "y": 0.11382520198822021,
            "z": -309.6842346191406
        },
        {
            "x": 16.869739532470703,
            "y": 0.10672427713871002,
            "z": -309.5263366699219
        },
        {
            "x": 16.87822151184082,
            "y": 0.09979422390460968,
            "z": -309.36773681640625
        },
        {
            "x": 16.886072158813477,
            "y": 0.09307365119457245,
            "z": -309.2091064453125
        },
        {
            "x": 16.89337730407715,
            "y": 0.0865854024887085,
            "z": -309.05108642578125
        },
        {
            "x": 16.900354385375977,
            "y": 0.08031751215457916,
            "z": -308.89312744140625
        },
        {
            "x": 16.906930923461914,
            "y": 0.07425111532211304,
            "z": -308.7347106933594
        },
        {
            "x": 16.91291046142578,
            "y": 0.06839196383953094,
            "z": -308.5758361816406
        },
        {
            "x": 16.91827392578125,
            "y": 0.06277111917734146,
            "z": -308.41729736328125
        },
        {
            "x": 16.923221588134766,
            "y": 0.057402353733778,
            "z": -308.25933837890625
        },
        {
            "x": 16.92634391784668,
            "y": 0.0539519302546978,
            "z": -308.15386962890625
        },
        {
            "x": 16.930618286132812,
            "y": 0.04894902557134628,
            "z": -307.9951477050781
        },
        {
            "x": 16.934242248535156,
            "y": 0.04418649151921272,
            "z": -307.83624267578125
        },
        {
            "x": 16.937271118164062,
            "y": 0.03968488797545433,
            "z": -307.67767333984375
        },
        {
            "x": 16.939945220947266,
            "y": 0.035443201661109924,
            "z": -307.51959228515625
        },
        {
            "x": 16.942230224609375,
            "y": 0.03143869340419769,
            "z": -307.36102294921875
        },
        {
            "x": 16.94389533996582,
            "y": 0.02768011763691902,
            "z": -307.201904296875
        },
        {
            "x": 16.94489097595215,
            "y": 0.024200059473514557,
            "z": -307.04315185546875
        },
        {
            "x": 16.945449829101562,
            "y": 0.020991861820220947,
            "z": -306.8849182128906
        },
        {
            "x": 16.94567108154297,
            "y": 0.01804444007575512,
            "z": -306.7264404296875
        },
        {
            "x": 16.945337295532227,
            "y": 0.015360472723841667,
            "z": -306.5673828125
        },
        {
            "x": 16.94428825378418,
            "y": 0.01296219602227211,
            "z": -306.40826416015625
        },
        {
            "x": 16.942712783813477,
            "y": 0.010851914063096046,
            "z": -306.2498779296875
        },
        {
            "x": 16.940797805786133,
            "y": 0.009024686180055141,
            "z": -306.0916748046875
        },
        {
            "x": 16.938404083251953,
            "y": 0.007476462982594967,
            "z": -305.9326171875
        },
        {
            "x": 16.935300827026367,
            "y": 0.00622995849698782,
            "z": -305.7734375
        },
        {
            "x": 16.931577682495117,
            "y": 0.005280445329844952,
            "z": -305.61480712890625
        },
        {
            "x": 16.927461624145508,
            "y": 0.004629874601960182,
            "z": -305.4566345214844
        },
        {
            "x": 16.92295265197754,
            "y": 0.00428007822483778,
            "z": -305.2981262207031
        },
        {
            "x": 16.917766571044922,
            "y": 0.004217378795146942,
            "z": -305.13885498046875
        },
        {
            "x": 16.911895751953125,
            "y": 0.004213571548461914,
            "z": -304.97998046875
        },
        {
            "x": 16.905546188354492,
            "y": 0.004209794104099274,
            "z": -304.82177734375
        },
        {
            "x": 16.898847579956055,
            "y": 0.004205986857414246,
            "z": -304.66357421875
        },
        {
            "x": 16.89155387878418,
            "y": 0.0042021796107292175,
            "z": -304.50469970703125
        },
        {
            "x": 16.883533477783203,
            "y": 0.00419839471578598,
            "z": -304.34564208984375
        },
        {
            "x": 16.87493133544922,
            "y": 0.004194580018520355,
            "z": -304.18719482421875
        },
        {
            "x": 16.865978240966797,
            "y": 0.004190780222415924,
            "z": -304.0292663574219
        },
        {
            "x": 16.85651397705078,
            "y": 0.0041870251297950745,
            "z": -303.8705749511719
        },
        {
            "x": 16.846342086791992,
            "y": 0.0041832104325294495,
            "z": -303.711669921875
        },
        {
            "x": 16.835493087768555,
            "y": 0.004179425537586212,
            "z": -303.55316162109375
        },
        {
            "x": 16.824214935302734,
            "y": 0.004175633192062378,
            "z": -303.3951110839844
        },
        {
            "x": 16.81253433227539,
            "y": 0.00417182594537735,
            "z": -303.2370300292969
        },
        {
            "x": 16.800188064575195,
            "y": 0.004168011248111725,
            "z": -303.0782470703125
        },
        {
            "x": 16.78710174560547,
            "y": 0.004164256155490875,
            "z": -302.91961669921875
        },
        {
            "x": 16.773494720458984,
            "y": 0.004160478711128235,
            "z": -302.7616882324219
        },
        {
            "x": 16.759506225585938,
            "y": 0.004156649112701416,
            "z": -302.6038513183594
        },
        {
            "x": 16.744956970214844,
            "y": 0.004152871668338776,
            "z": -302.4455261230469
        },
        {
            "x": 16.729652404785156,
            "y": 0.004149056971073151,
            "z": -302.2870178222656
        },
        {
            "x": 16.713703155517578,
            "y": 0.004145286977291107,
            "z": -302.12890625
        },
        {
            "x": 16.69736671447754,
            "y": 0.004141509532928467,
            "z": -301.9715270996094
        },
        {
            "x": 16.680557250976562,
            "y": 0.004137694835662842,
            "z": -301.8136291503906
        },
        {
            "x": 16.66301727294922,
            "y": 0.004133865237236023,
            "z": -301.65521240234375
        },
        {
            "x": 16.644758224487305,
            "y": 0.0041300952434539795,
            "z": -301.4971923828125
        },
        {
            "x": 16.632299423217773,
            "y": 0.004127591848373413,
            "z": -301.3923034667969
        },
        {
            "x": 16.61333656311035,
            "y": 0.00412372499704361,
            "z": -301.23516845703125
        },
        {
            "x": 16.593833923339844,
            "y": 0.004119977355003357,
            "z": -301.0774841308594
        },
        {
            "x": 16.573497772216797,
            "y": 0.0041161105036735535,
            "z": -300.9192199707031
        },
        {
            "x": 16.552509307861328,
            "y": 0.004112355411052704,
            "z": -300.76165771484375
        },
        {
            "x": 16.531129837036133,
            "y": 0.004108548164367676,
            "z": -300.6048278808594
        },
        {
            "x": 16.50930404663086,
            "y": 0.004104740917682648,
            "z": -300.4476318359375
        },
        {
            "x": 16.48674774169922,
            "y": 0.004100970923900604,
            "z": -300.2900085449219
        },
        {
            "x": 16.463397979736328,
            "y": 0.004097200930118561,
            "z": -300.1323547363281
        },
        {
            "x": 16.43955421447754,
            "y": 0.0040934160351753235,
            "z": -299.9755554199219
        },
        {
            "x": 16.415374755859375,
            "y": 0.004089608788490295,
            "z": -299.8191223144531
        },
        {
            "x": 16.390533447265625,
            "y": 0.0040857791900634766,
            "z": -299.66192626953125
        },
        {
            "x": 16.364896774291992,
            "y": 0.004082024097442627,
            "z": -299.5046081542969
        },
        {
            "x": 16.3386287689209,
            "y": 0.0040782541036605835,
            "z": -299.3479309082031
        },
        {
            "x": 16.31196403503418,
            "y": 0.004074409604072571,
            "z": -299.1917419433594
        },
        {
            "x": 16.284839630126953,
            "y": 0.004070647060871124,
            "z": -299.035400390625
        },
        {
            "x": 16.256919860839844,
            "y": 0.004066824913024902,
            "z": -298.8784484863281
        },
        {
            "x": 16.228239059448242,
            "y": 0.004063017666339874,
            "z": -298.7218017578125
        },
        {
            "x": 16.199106216430664,
            "y": 0.004059255123138428,
            "z": -298.5660095214844
        },
        {
            "x": 16.16958236694336,
            "y": 0.004055440425872803,
            "z": -298.41021728515625
        },
        {
            "x": 16.139400482177734,
            "y": 0.004051670432090759,
            "z": -298.2540283203125
        },
        {
            "x": 16.10840606689453,
            "y": 0.004047870635986328,
            "z": -298.09765625
        },
        {
            "x": 16.076786041259766,
            "y": 0.004044070839881897,
            "z": -297.94189453125
        },
        {
            "x": 16.044824600219727,
            "y": 0.00404028594493866,
            "z": -297.78692626953125
        },
        {
            "x": 16.012332916259766,
            "y": 0.004036463797092438,
            "z": -297.6314697265625
        },
        {
            "x": 15.97903823852539,
            "y": 0.0040326789021492004,
            "z": -297.4754943847656
        },
        {
            "x": 15.945008277893066,
            "y": 0.00402890145778656,
            "z": -297.3199768066406
        },
        {
            "x": 15.910538673400879,
            "y": 0.004025094211101532,
            "z": -297.16522216796875
        },
        {
            "x": 15.875694274902344,
            "y": 0.0040213242173194885,
            "z": -297.0107116699219
        },
        {
            "x": 15.840157508850098,
            "y": 0.0040175169706344604,
            "z": -296.8556213378906
        },
        {
            "x": 15.803750991821289,
            "y": 0.004013709723949432,
            "z": -296.70025634765625
        },
        {
            "x": 15.766789436340332,
            "y": 0.004009954631328583,
            "z": -296.5457763671875
        },
        {
            "x": 15.729496002197266,
            "y": 0.004006147384643555,
            "z": -296.39190673828125
        },
        {
            "x": 15.691661834716797,
            "y": 0.004002340137958527,
            "z": -296.2376708984375
        },
        {
            "x": 15.653048515319824,
            "y": 0.0039985403418540955,
            "z": -296.08306884765625
        },
        {
            "x": 15.613597869873047,
            "y": 0.003994762897491455,
            "z": -295.9286193847656
        },
        {
            "x": 15.573776245117188,
            "y": 0.0039910003542900085,
            "z": -295.7751770019531
        },
        {
            "x": 15.53361988067627,
            "y": 0.00398717075586319,
            "z": -295.62200927734375
        },
        {
            "x": 15.492748260498047,
            "y": 0.003983356058597565,
            "z": -295.46820068359375
        },
        {
            "x": 15.451019287109375,
            "y": 0.003979586064815521,
            "z": -295.3143005371094
        },
        {
            "x": 15.40869140625,
            "y": 0.003975808620452881,
            "z": -295.1611022949219
        },
        {
            "x": 15.366042137145996,
            "y": 0.003971986472606659,
            "z": -295.0085144042969
        },
        {
            "x": 15.322921752929688,
            "y": 0.003968164324760437,
            "z": -294.8558349609375
        },
        {
            "x": 15.293743133544922,
            "y": 0.003965705633163452,
            "z": -294.7538146972656
        },
        {
            "x": 15.249258041381836,
            "y": 0.003961816430091858,
            "z": -294.6007385253906
        },
        {
            "x": 15.204230308532715,
            "y": 0.003958091139793396,
            "z": -294.44842529296875
        },
        {
            "x": 15.158905029296875,
            "y": 0.003954276442527771,
            "z": -294.2966613769531
        },
        {
            "x": 15.113016128540039,
            "y": 0.003950469195842743,
            "z": -294.1446533203125
        },
        {
            "x": 15.066326141357422,
            "y": 0.003946684300899506,
            "z": -293.9923400878906
        },
        {
            "x": 15.018861770629883,
            "y": 0.003942869603633881,
            "z": -293.8402404785156
        },
        {
            "x": 14.971019744873047,
            "y": 0.003939114511013031,
            "z": -293.6891174316406
        },
        {
            "x": 14.922815322875977,
            "y": 0.003935284912586212,
            "z": -293.5381774902344
        },
        {
            "x": 14.873966217041016,
            "y": 0.0039315372705459595,
            "z": -293.3868713378906
        },
        {
            "x": 14.824273109436035,
            "y": 0.0039277225732803345,
            "z": -293.2353820800781
        },
        {
            "x": 14.773950576782227,
            "y": 0.003923922777175903,
            "z": -293.08447265625
        },
        {
            "x": 14.723367691040039,
            "y": 0.00392015278339386,
            "z": -292.9344787597656
        },
        {
            "x": 14.672341346740723,
            "y": 0.0039163753390312195,
            "z": -292.784423828125
        },
        {
            "x": 14.620479583740234,
            "y": 0.003912582993507385,
            "z": -292.63372802734375
        },
        {
            "x": 14.567851066589355,
            "y": 0.003908812999725342,
            "z": -292.48333740234375
        },
        {
            "x": 14.51473331451416,
            "y": 0.0039050206542015076,
            "z": -292.33367919921875
        },
        {
            "x": 14.461381912231445,
            "y": 0.003901183605194092,
            "z": -292.1846923828125
        },
        {
            "x": 14.407476425170898,
            "y": 0.0038973987102508545,
            "z": -292.035400390625
        },
        {
            "x": 14.352653503417969,
            "y": 0.0038935914635658264,
            "z": -291.8856201171875
        },
        {
            "x": 14.297171592712402,
            "y": 0.003843973856419325,
            "z": -291.73638916015625
        },
        {
            "x": 14.241355895996094,
            "y": 0.0033384363632649183,
            "z": -291.5880126953125
        },
        {
            "x": 14.185260772705078,
            "y": 0.0022465346846729517,
            "z": -291.4400634765625
        },
        {
            "x": 14.128490447998047,
            "y": 0.0005657076835632324,
            "z": -291.2916564941406
        },
        {
            "x": 14.070801734924316,
            "y": -0.0017137480899691582,
            "z": -291.1429748535156
        },
        {
            "x": 14.012545585632324,
            "y": -0.004546650219708681,
            "z": -290.9949645996094
        },
        {
            "x": 13.954097747802734,
            "y": -0.007910823449492455,
            "z": -290.847900390625
        },
        {
            "x": 13.895212173461914,
            "y": -0.011820106767117977,
            "z": -290.70074462890625
        },
        {
            "x": 13.835596084594727,
            "y": -0.01628982089459896,
            "z": -290.5533142089844
        },
        {
            "x": 13.775216102600098,
            "y": -0.0212799534201622,
            "z": -290.40606689453125
        },
        {
            "x": 13.714241981506348,
            "y": -0.026769526302814484,
            "z": -290.25927734375
        },
        {
            "x": 13.653155326843262,
            "y": -0.03272504359483719,
            "z": -290.1134033203125
        },
        {
            "x": 13.591621398925781,
            "y": -0.03919316083192825,
            "z": -289.96746826171875
        },
        {
            "x": 13.529292106628418,
            "y": -0.046159788966178894,
            "z": -289.8211364746094
        },
        {
            "x": 13.466278076171875,
            "y": -0.053587716072797775,
            "z": -289.6752014160156
        },
        {
            "x": 13.40284252166748,
            "y": -0.06144752353429794,
            "z": -289.52984619140625
        },
        {
            "x": 13.339319229125977,
            "y": -0.06973280757665634,
            "z": -289.38531494140625
        },
        {
            "x": 13.275245666503906,
            "y": -0.07846876233816147,
            "z": -289.240478515625
        },
        {
            "x": 13.21037483215332,
            "y": -0.0876539871096611,
            "z": -289.0953674316406
        },
        {
            "x": 13.145074844360352,
            "y": -0.09722278267145157,
            "z": -288.9510192871094
        },
        {
            "x": 13.079532623291016,
            "y": -0.10717107355594635,
            "z": -288.8072509765625
        },
        {
            "x": 13.01375961303711,
            "y": -0.1174994483590126,
            "z": -288.66375732421875
        },
        {
            "x": 12.947419166564941,
            "y": -0.12822824716567993,
            "z": -288.5199890136719
        },
        {
            "x": 12.902870178222656,
            "y": -0.1355879008769989,
            "z": -288.42425537109375
        },
        {
            "x": 12.83582592010498,
            "y": -0.1469002664089203,
            "z": -288.2812194824219
        },
        {
            "x": 12.768686294555664,
            "y": -0.15852436423301697,
            "z": -288.13873291015625
        },
        {
            "x": 12.700984954833984,
            "y": -0.1705249547958374,
            "z": -287.99578857421875
        },
        {
            "x": 12.63292407989502,
            "y": -0.1828455924987793,
            "z": -287.853271484375
        },
        {
            "x": 12.564787864685059,
            "y": -0.19543561339378357,
            "z": -287.7113952636719
        },
        {
            "x": 12.496219635009766,
            "y": -0.20835646986961365,
            "z": -287.5693359375
        },
        {
            "x": 12.42751407623291,
            "y": -0.2215310037136078,
            "z": -287.427734375
        },
        {
            "x": 12.358790397644043,
            "y": -0.23496723175048828,
            "z": -287.2864685058594
        },
        {
            "x": 12.289836883544922,
            "y": -0.24868802726268768,
            "z": -287.1451721191406
        },
        {
            "x": 12.220932960510254,
            "y": -0.26262620091438293,
            "z": -287.00421142578125
        },
        {
            "x": 12.151920318603516,
            "y": -0.2768198251724243,
            "z": -286.86328125
        },
        {
            "x": 12.082839012145996,
            "y": -0.29124024510383606,
            "z": -286.722412109375
        },
        {
            "x": 12.01370620727539,
            "y": -0.30588245391845703,
            "z": -286.5817565917969
        },
        {
            "x": 11.944353103637695,
            "y": -0.32075950503349304,
            "z": -286.4408264160156
        },
        {
            "x": 11.875081062316895,
            "y": -0.335806667804718,
            "z": -286.30029296875
        },
        {
            "x": 11.80566692352295,
            "y": -0.35105693340301514,
            "z": -286.1596374511719
        },
        {
            "x": 11.736224174499512,
            "y": -0.36647990345954895,
            "z": -286.01910400390625
        },
        {
            "x": 11.666769981384277,
            "y": -0.3820613622665405,
            "z": -285.8787841796875
        },
        {
            "x": 11.597163200378418,
            "y": -0.397821307182312,
            "z": -285.7382507324219
        },
        {
            "x": 11.52750015258789,
            "y": -0.41372430324554443,
            "z": -285.5978088378906
        },
        {
            "x": 11.457797050476074,
            "y": -0.42975062131881714,
            "z": -285.4575500488281
        },
        {
            "x": 11.388068199157715,
            "y": -0.4458986520767212,
            "z": -285.3173522949219
        },
        {
            "x": 11.318258285522461,
            "y": -0.462161123752594,
            "z": -285.1772155761719
        },
        {
            "x": 11.248376846313477,
            "y": -0.47853517532348633,
            "z": -285.03704833984375
        },
        {
            "x": 11.17844295501709,
            "y": -0.49500221014022827,
            "z": -284.89691162109375
        },
        {
            "x": 11.108463287353516,
            "y": -0.5115470886230469,
            "z": -284.7568664550781
        },
        {
            "x": 11.038479804992676,
            "y": -0.5281553864479065,
            "z": -284.61688232421875
        },
        {
            "x": 10.968428611755371,
            "y": -0.5448276996612549,
            "z": -284.4769287109375
        },
        {
            "x": 10.89835262298584,
            "y": -0.5615510940551758,
            "z": -284.3369445800781
        },
        {
            "x": 10.82817268371582,
            "y": -0.5783236622810364,
            "z": -284.19696044921875
        },
        {
            "x": 10.758009910583496,
            "y": -0.5951155424118042,
            "z": -284.0570068359375
        },
        {
            "x": 10.687807083129883,
            "y": -0.6119227409362793,
            "z": -283.9171447753906
        },
        {
            "x": 10.61758041381836,
            "y": -0.6287330985069275,
            "z": -283.7773742675781
        },
        {
            "x": 10.547351837158203,
            "y": -0.6455357074737549,
            "z": -283.6376037597656
        },
        {
            "x": 10.476957321166992,
            "y": -0.6623522043228149,
            "z": -283.49761962890625
        },
        {
            "x": 10.406696319580078,
            "y": -0.6791086196899414,
            "z": -283.3580017089844
        },
        {
            "x": 10.336431503295898,
            "y": -0.695824146270752,
            "z": -283.2183837890625
        },
        {
            "x": 10.26605224609375,
            "y": -0.7125211954116821,
            "z": -283.07855224609375
        },
        {
            "x": 10.195710182189941,
            "y": -0.7291415929794312,
            "z": -282.9388732910156
        },
        {
            "x": 10.125372886657715,
            "y": -0.7456952929496765,
            "z": -282.79913330078125
        },
        {
            "x": 10.054986000061035,
            "y": -0.7621840238571167,
            "z": -282.65936279296875
        },
        {
            "x": 9.984724998474121,
            "y": -0.7785564064979553,
            "z": -282.5197448730469
        },
        {
            "x": 9.937749862670898,
            "y": -0.7894384860992432,
            "z": -282.4264831542969
        },
        {
            "x": 9.867362976074219,
            "y": -0.80565345287323,
            "z": -282.2868347167969
        },
        {
            "x": 9.797015190124512,
            "y": -0.8217440843582153,
            "z": -282.14715576171875
        },
        {
            "x": 9.726551055908203,
            "y": -0.837727963924408,
            "z": -282.0072937011719
        },
        {
            "x": 9.656196594238281,
            "y": -0.8535487651824951,
            "z": -281.8676452636719
        },
        {
            "x": 9.58588981628418,
            "y": -0.8692177534103394,
            "z": -281.72796630859375
        },
        {
            "x": 9.515523910522461,
            "y": -0.8847397565841675,
            "z": -281.5882263183594
        },
        {
            "x": 9.445226669311523,
            "y": -0.9000752568244934,
            "z": -281.4484558105469
        },
        {
            "x": 9.374964714050293,
            "y": -0.9152342081069946,
            "z": -281.30865478515625
        },
        {
            "x": 9.304695129394531,
            "y": -0.9302037358283997,
            "z": -281.16888427734375
        },
        {
            "x": 9.234496116638184,
            "y": -0.9449689984321594,
            "z": -281.0290222167969
        },
        {
            "x": 9.164276123046875,
            "y": -0.9595153331756592,
            "z": -280.8891296386719
        },
        {
            "x": 9.094160079956055,
            "y": -0.9738284349441528,
            "z": -280.749267578125
        },
        {
            "x": 9.024081230163574,
            "y": -0.9879080057144165,
            "z": -280.609375
        },
        {
            "x": 8.953920364379883,
            "y": -1.0017694234848022,
            "z": -280.4692077636719
        },
        {
            "x": 8.883955001831055,
            "y": -1.0153316259384155,
            "z": -280.3293151855469
        },
        {
            "x": 8.813997268676758,
            "y": -1.0286369323730469,
            "z": -280.1892395019531
        },
        {
            "x": 8.744057655334473,
            "y": -1.041673183441162,
            "z": -280.0491027832031
        },
        {
            "x": 8.67426872253418,
            "y": -1.0543994903564453,
            "z": -279.90911865234375
        },
        {
            "x": 8.604410171508789,
            "y": -1.0668442249298096,
            "z": -279.7688293457031
        },
        {
            "x": 8.534806251525879,
            "y": -1.0789449214935303,
            "z": -279.6287536621094
        },
        {
            "x": 8.465164184570312,
            "y": -1.0907437801361084,
            "z": -279.4884338378906
        },
        {
            "x": 8.395665168762207,
            "y": -1.1021997928619385,
            "z": -279.34820556640625
        },
        {
            "x": 8.326179504394531,
            "y": -1.113315463066101,
            "z": -279.2077941894531
        },
        {
            "x": 8.25683879852295,
            "y": -1.1240627765655518,
            "z": -279.0674133300781
        },
        {
            "x": 8.187538146972656,
            "y": -1.1344544887542725,
            "z": -278.9268798828125
        },
        {
            "x": 8.118365287780762,
            "y": -1.1444652080535889,
            "z": -278.7863464355469
        },
        {
            "x": 8.049216270446777,
            "y": -1.1540945768356323,
            "z": -278.6455993652344
        },
        {
            "x": 7.980278968811035,
            "y": -1.1632976531982422,
            "z": -278.5050048828125
        },
        {
            "x": 7.911424160003662,
            "y": -1.172100305557251,
            "z": -278.36431884765625
        },
        {
            "x": 7.842599868774414,
            "y": -1.1804921627044678,
            "z": -278.2233581542969
        },
        {
            "x": 7.774027347564697,
            "y": -1.1884381771087646,
            "z": -278.0825500488281
        },
        {
            "x": 7.705491065979004,
            "y": -1.195934534072876,
            "z": -277.9415283203125
        },
        {
            "x": 7.637125492095947,
            "y": -1.2029763460159302,
            "z": -277.800537109375
        },
        {
            "x": 7.568873405456543,
            "y": -1.2095561027526855,
            "z": -277.6594543457031
        },
        {
            "x": 7.500722408294678,
            "y": -1.215665340423584,
            "z": -277.5181579589844
        },
        {
            "x": 7.432767868041992,
            "y": -1.2212636470794678,
            "z": -277.37689208984375
        },
        {
            "x": 7.365008354187012,
            "y": -1.226364254951477,
            "z": -277.2357177734375
        },
        {
            "x": 7.2972917556762695,
            "y": -1.230966329574585,
            "z": -277.0941467285156
        },
        {
            "x": 7.229849815368652,
            "y": -1.2350425720214844,
            "z": -276.9527587890625
        },
        {
            "x": 7.162436008453369,
            "y": -1.238574743270874,
            "z": -276.81109619140625
        },
        {
            "x": 7.095297336578369,
            "y": -1.2415626049041748,
            "z": -276.66949462890625
        },
        {
            "x": 7.028295040130615,
            "y": -1.2440032958984375,
            "z": -276.5277099609375
        },
        {
            "x": 6.98375940322876,
            "y": -1.2453113794326782,
            "z": -276.43328857421875
        },
        {
            "x": 6.917128562927246,
            "y": -1.2467924356460571,
            "z": -276.2914733886719
        },
        {
            "x": 6.850665092468262,
            "y": -1.2476959228515625,
            "z": -276.14959716796875
        },
        {
            "x": 6.7843427658081055,
            "y": -1.248010516166687,
            "z": -276.0074462890625
        },
        {
            "x": 6.718257904052734,
            "y": -1.2477000951766968,
            "z": -275.8653869628906
        },
        {
            "x": 6.6524224281311035,
            "y": -1.246801495552063,
            "z": -275.7232666015625
        },
        {
            "x": 6.5866618156433105,
            "y": -1.2453231811523438,
            "z": -275.58087158203125
        },
        {
            "x": 6.5212507247924805,
            "y": -1.2432799339294434,
            "z": -275.4385986328125
        },
        {
            "x": 6.455966949462891,
            "y": -1.2406525611877441,
            "z": -275.296142578125
        },
        {
            "x": 6.390966415405273,
            "y": -1.2374796867370605,
            "z": -275.1535949707031
        },
        {
            "x": 6.326184272766113,
            "y": -1.2337754964828491,
            "z": -275.0110778808594
        },
        {
            "x": 6.261658191680908,
            "y": -1.2295458316802979,
            "z": -274.868408203125
        },
        {
            "x": 6.197346210479736,
            "y": -1.2247812747955322,
            "z": -274.72564697265625
        },
        {
            "x": 6.133409023284912,
            "y": -1.21952223777771,
            "z": -274.58306884765625
        },
        {
            "x": 6.069476127624512,
            "y": -1.2137542963027954,
            "z": -274.4398498535156
        },
        {
            "x": 6.005995273590088,
            "y": -1.2075259685516357,
            "z": -274.2970275878906
        },
        {
            "x": 5.942638874053955,
            "y": -1.2007980346679688,
            "z": -274.15380859375
        },
        {
            "x": 5.879684925079346,
            "y": -1.193623423576355,
            "z": -274.01080322265625
        },
        {
            "x": 5.816896915435791,
            "y": -1.185990810394287,
            "z": -273.86749267578125
        },
        {
            "x": 5.754365921020508,
            "y": -1.177925705909729,
            "z": -273.7240905761719
        },
        {
            "x": 5.692163944244385,
            "y": -1.1694231033325195,
            "z": -273.5806884765625
        },
        {
            "x": 5.6302995681762695,
            "y": -1.160513162612915,
            "z": -273.4373474121094
        },
        {
            "x": 5.56864595413208,
            "y": -1.1511902809143066,
            "z": -273.2937316894531
        },
        {
            "x": 5.507348537445068,
            "y": -1.1414902210235596,
            "z": -273.15020751953125
        },
        {
            "x": 5.446264266967773,
            "y": -1.1313819885253906,
            "z": -273.00634765625
        },
        {
            "x": 5.38550329208374,
            "y": -1.120908260345459,
            "z": -272.862548828125
        },
        {
            "x": 5.324998378753662,
            "y": -1.1100666522979736,
            "z": -272.7184753417969
        },
        {
            "x": 5.264850616455078,
            "y": -1.098895788192749,
            "z": -272.5746154785156
        },
        {
            "x": 5.204963684082031,
            "y": -1.0873643159866333,
            "z": -272.430419921875
        },
        {
            "x": 5.145447731018066,
            "y": -1.0755188465118408,
            "z": -272.28631591796875
        },
        {
            "x": 5.086161136627197,
            "y": -1.0633338689804077,
            "z": -272.1418762207031
        },
        {
            "x": 5.027246952056885,
            "y": -1.050868034362793,
            "z": -271.99755859375
        },
        {
            "x": 4.96862268447876,
            "y": -1.0380899906158447,
            "z": -271.85296630859375
        },
        {
            "x": 4.910310745239258,
            "y": -1.025031328201294,
            "z": -271.70843505859375
        },
        {
            "x": 4.852414131164551,
            "y": -1.01170814037323,
            "z": -271.5638122558594
        },
        {
            "x": 4.794687747955322,
            "y": -0.9981026649475098,
            "z": -271.41888427734375
        },
        {
            "x": 4.737470626831055,
            "y": -0.9842740297317505,
            "z": -271.27410888671875
        },
        {
            "x": 4.680444717407227,
            "y": -0.9701755046844482,
            "z": -271.1289978027344
        },
        {
            "x": 4.623840808868408,
            "y": -0.9558645486831665,
            "z": -270.9840393066406
        },
        {
            "x": 4.5674824714660645,
            "y": -0.9413238763809204,
            "z": -270.8387451171875
        },
        {
            "x": 4.511585235595703,
            "y": -0.9265977144241333,
            "z": -270.6935729980469
        },
        {
            "x": 4.455864906311035,
            "y": -0.9116322994232178,
            "z": -270.5479431152344
        },
        {
            "x": 4.4006476402282715,
            "y": -0.8965212106704712,
            "z": -270.4026184082031
        },
        {
            "x": 4.363977432250977,
            "y": -0.8863372802734375,
            "z": -270.3055419921875
        },
        {
            "x": 4.309268474578857,
            "y": -0.8709272742271423,
            "z": -270.159912109375
        },
        {
            "x": 4.254964351654053,
            "y": -0.855359673500061,
            "z": -270.01416015625
        },
        {
            "x": 4.20089054107666,
            "y": -0.8396294116973877,
            "z": -269.8681640625
        },
        {
            "x": 4.147312641143799,
            "y": -0.8237855434417725,
            "z": -269.72222900390625
        },
        {
            "x": 4.093983173370361,
            "y": -0.8077999949455261,
            "z": -269.57611083984375
        },
        {
            "x": 4.04109525680542,
            "y": -0.7917076349258423,
            "z": -269.4299011230469
        },
        {
            "x": 3.9884684085845947,
            "y": -0.7754976749420166,
            "z": -269.2834777832031
        },
        {
            "x": 3.936305284500122,
            "y": -0.7592183947563171,
            "z": -269.13714599609375
        },
        {
            "x": 3.884352684020996,
            "y": -0.7428140640258789,
            "z": -268.9903564453125
        },
        {
            "x": 3.8329250812530518,
            "y": -0.7263829112052917,
            "z": -268.84381103515625
        },
        {
            "x": 3.7817134857177734,
            "y": -0.7098462581634521,
            "z": -268.6968078613281
        },
        {
            "x": 3.731018543243408,
            "y": -0.6933091878890991,
            "z": -268.55010986328125
        },
        {
            "x": 3.680549383163452,
            "y": -0.6766858100891113,
            "z": -268.40289306640625
        },
        {
            "x": 3.630535125732422,
            "y": -0.660060703754425,
            "z": -268.255859375
        },
        {
            "x": 3.5808558464050293,
            "y": -0.6433936357498169,
            "z": -268.1083984375
        },
        {
            "x": 3.5315535068511963,
            "y": -0.6267390847206116,
            "z": -267.9610900878906
        },
        {
            "x": 3.4826395511627197,
            "y": -0.6100752353668213,
            "z": -267.8135681152344
        },
        {
            "x": 3.434053421020508,
            "y": -0.5934270620346069,
            "z": -267.66595458984375
        },
        {
            "x": 3.3858675956726074,
            "y": -0.5767924189567566,
            "z": -267.5180969238281
        },
        {
            "x": 3.3379783630371094,
            "y": -0.5601866245269775,
            "z": -267.3700866699219
        },
        {
            "x": 3.2906277179718018,
            "y": -0.5436678528785706,
            "z": -267.222412109375
        },
        {
            "x": 3.2434847354888916,
            "y": -0.5271534323692322,
            "z": -267.0740966796875
        },
        {
            "x": 3.1968634128570557,
            "y": -0.5107513666152954,
            "z": -266.92608642578125
        },
        {
            "x": 3.1504809856414795,
            "y": -0.4943767189979553,
            "z": -266.7774963378906
        },
        {
            "x": 3.1045453548431396,
            "y": -0.47811833024024963,
            "z": -266.6291198730469
        },
        {
            "x": 3.0589675903320312,
            "y": -0.4619375467300415,
            "z": -266.48040771484375
        },
        {
            "x": 3.013723373413086,
            "y": -0.4458698630332947,
            "z": -266.33160400390625
        },
        {
            "x": 2.968926429748535,
            "y": -0.4299243688583374,
            "z": -266.18280029296875
        },
        {
            "x": 2.9244441986083984,
            "y": -0.41410648822784424,
            "z": -266.0338134765625
        },
        {
            "x": 2.8803627490997314,
            "y": -0.39841341972351074,
            "z": -265.884521484375
        },
        {
            "x": 2.836627960205078,
            "y": -0.3828786015510559,
            "z": -265.7352600097656
        },
        {
            "x": 2.793351173400879,
            "y": -0.3675219416618347,
            "z": -265.5860290527344
        },
        {
            "x": 2.7503373622894287,
            "y": -0.35229629278182983,
            "z": -265.4362487792969
        },
        {
            "x": 2.707796573638916,
            "y": -0.3372957408428192,
            "z": -265.28692626953125
        },
        {
            "x": 2.665527820587158,
            "y": -0.3224392533302307,
            "z": -265.1368103027344
        },
        {
            "x": 2.623708963394165,
            "y": -0.307827889919281,
            "z": -264.9870910644531
        },
        {
            "x": 2.5823183059692383,
            "y": -0.293422132730484,
            "z": -264.837158203125
        },
        {
            "x": 2.5411617755889893,
            "y": -0.27921444177627563,
            "z": -264.6869201660156
        },
        {
            "x": 2.500537157058716,
            "y": -0.2652752697467804,
            "z": -264.53680419921875
        },
        {
            "x": 2.4601223468780518,
            "y": -0.25154438614845276,
            "z": -264.3862609863281
        },
        {
            "x": 2.4202117919921875,
            "y": -0.2381020188331604,
            "z": -264.23590087890625
        },
        {
            "x": 2.3805925846099854,
            "y": -0.22489264607429504,
            "z": -264.0851135253906
        },
        {
            "x": 2.3544046878814697,
            "y": -0.21626269817352295,
            "z": -263.9847106933594
        },
        {
            "x": 2.3155171871185303,
            "y": -0.20355141162872314,
            "z": -263.8340148925781
        },
        {
            "x": 2.276870012283325,
            "y": -0.19110554456710815,
            "z": -263.6829833984375
        },
        {
            "x": 2.2386369705200195,
            "y": -0.17897772789001465,
            "z": -263.5318603515625
        },
        {
            "x": 2.2007553577423096,
            "y": -0.1671617031097412,
            "z": -263.3805847167969
        },
        {
            "x": 2.1633002758026123,
            "y": -0.15569250285625458,
            "z": -263.2294921875
        },
        {
            "x": 2.1261777877807617,
            "y": -0.14452967047691345,
            "z": -263.0778503417969
        },
        {
            "x": 2.0893924236297607,
            "y": -0.1337260603904724,
            "z": -262.9263916015625
        },
        {
            "x": 2.0530669689178467,
            "y": -0.12329345941543579,
            "z": -262.7747497558594
        },
        {
            "x": 2.0169758796691895,
            "y": -0.11320404708385468,
            "z": -262.62274169921875
        },
        {
            "x": 1.9813883304595947,
            "y": -0.10352123528718948,
            "z": -262.4710693359375
        },
        {
            "x": 1.9460817575454712,
            "y": -0.09419611096382141,
            "z": -262.3188171386719
        },
        {
            "x": 1.9111562967300415,
            "y": -0.08530566096305847,
            "z": -262.16680908203125
        },
        {
            "x": 1.8766392469406128,
            "y": -0.07681693136692047,
            "z": -262.0146179199219
        },
        {
            "x": 1.8423551321029663,
            "y": -0.06873105466365814,
            "z": -261.8620300292969
        },
        {
            "x": 1.8085880279541016,
            "y": -0.06109732389450073,
            "z": -261.7097473144531
        },
        {
            "x": 1.7750632762908936,
            "y": -0.05390128493309021,
            "z": -261.5569763183594
        },
        {
            "x": 1.741960048675537,
            "y": -0.047172706574201584,
            "z": -261.4045104980469
        },
        {
            "x": 1.7092293500900269,
            "y": -0.04089511185884476,
            "z": -261.2516784667969
        },
        {
            "x": 1.6767544746398926,
            "y": -0.035083163529634476,
            "z": -261.0986633300781
        },
        {
            "x": 1.644795536994934,
            "y": -0.02978643588721752,
            "z": -260.94586181640625
        },
        {
            "x": 1.6130820512771606,
            "y": -0.02497272938489914,
            "z": -260.7927551269531
        },
        {
            "x": 1.5817911624908447,
            "y": -0.02067052572965622,
            "z": -260.63983154296875
        },
        {
            "x": 1.550816535949707,
            "y": -0.016871929168701172,
            "z": -260.48651123046875
        },
        {
            "x": 1.5201642513275146,
            "y": -0.013619773089885712,
            "z": -260.3331298828125
        },
        {
            "x": 1.4899441003799438,
            "y": -0.010906492359936237,
            "z": -260.1798095703125
        },
        {
            "x": 1.4599806070327759,
            "y": -0.008734110742807388,
            "z": -260.0262145996094
        },
        {
            "x": 1.4304237365722656,
            "y": -0.007118548732250929,
            "z": -259.87274169921875
        },
        {
            "x": 1.4012106657028198,
            "y": -0.006088064983487129,
            "z": -259.7190246582031
        },
        {
            "x": 1.3723069429397583,
            "y": -0.005638530477881432,
            "z": -259.5653991699219
        },
        {
            "x": 1.343788981437683,
            "y": -0.0056022703647613525,
            "z": -259.4115295410156
        },
        {
            "x": 1.3155524730682373,
            "y": -0.00560200959444046,
            "z": -259.257568359375
        },
        {
            "x": 1.2877222299575806,
            "y": -0.005601704120635986,
            "z": -259.1037902832031
        },
        {
            "x": 1.2602307796478271,
            "y": -0.005601413547992706,
            "z": -258.94964599609375
        },
        {
            "x": 1.2330336570739746,
            "y": -0.00560113787651062,
            "z": -258.7956237792969
        },
        {
            "x": 1.2062164545059204,
            "y": -0.005600839853286743,
            "z": -258.6414794921875
        },
        {
            "x": 1.179694652557373,
            "y": -0.005600586533546448,
            "z": -258.48712158203125
        },
        {
            "x": 1.1535576581954956,
            "y": -0.005600281059741974,
            "z": -258.3331298828125
        },
        {
            "x": 1.1277415752410889,
            "y": -0.005600005388259888,
            "z": -258.17864990234375
        },
        {
            "x": 1.1021904945373535,
            "y": -0.005599722266197205,
            "z": -258.02423095703125
        },
        {
            "x": 1.0770528316497803,
            "y": -0.005599446594715118,
            "z": -257.8698425292969
        },
        {
            "x": 1.0521824359893799,
            "y": -0.005599126219749451,
            "z": -257.71514892578125
        },
        {
            "x": 1.0276515483856201,
            "y": -0.0055988505482673645,
            "z": -257.56072998046875
        },
        {
            "x": 1.0115199089050293,
            "y": -0.0055986493825912476,
            "z": -257.457763671875
        },
        {
            "x": 0.9875179529190063,
            "y": -0.0055983662605285645,
            "z": -257.30303955078125
        },
        {
            "x": 0.9638478755950928,
            "y": -0.005598098039627075,
            "z": -257.1485290527344
        },
        {
            "x": 0.9405134320259094,
            "y": -0.005597807466983795,
            "z": -256.99359130859375
        },
        {
            "x": 0.9174397587776184,
            "y": -0.005597539246082306,
            "z": -256.83868408203125
        },
        {
            "x": 0.8947584629058838,
            "y": -0.005597271025180817,
            "z": -256.6840515136719
        },
        {
            "x": 0.8723589181900024,
            "y": -0.00559697300195694,
            "z": -256.5289611816406
        },
        {
            "x": 0.8502175807952881,
            "y": -0.005596667528152466,
            "z": -256.3739929199219
        },
        {
            "x": 0.8284722566604614,
            "y": -0.0055963993072509766,
            "z": -256.2191162109375
        },
        {
            "x": 0.8069692850112915,
            "y": -0.0055961161851882935,
            "z": -256.0638122558594
        },
        {
            "x": 0.7857782244682312,
            "y": -0.0055958181619644165,
            "z": -255.90887451171875
        },
        {
            "x": 0.7649341225624084,
            "y": -0.00559554249048233,
            "z": -255.753662109375
        },
        {
            "x": 0.7443290948867798,
            "y": -0.005595244467258453,
            "z": -255.598388671875
        },
        {
            "x": 0.724064826965332,
            "y": -0.005594983696937561,
            "z": -255.44329833984375
        },
        {
            "x": 0.7040976881980896,
            "y": -0.00559467077255249,
            "z": -255.28781127929688
        },
        {
            "x": 0.6843711137771606,
            "y": -0.00559438019990921,
            "z": -255.13243103027344
        },
        {
            "x": 0.6650063991546631,
            "y": -0.00559408962726593,
            "z": -254.9772186279297
        },
        {
            "x": 0.6459190845489502,
            "y": -0.005593821406364441,
            "z": -254.82164001464844
        },
        {
            "x": 0.6270782351493835,
            "y": -0.005593545734882355,
            "z": -254.66622924804688
        },
        {
            "x": 0.6085773706436157,
            "y": -0.0055932775139808655,
            "z": -254.51072692871094
        },
        {
            "x": 0.5903418064117432,
            "y": -0.005592994391918182,
            "z": -254.3550262451172
        },
        {
            "x": 0.5723707675933838,
            "y": -0.005592696368694305,
            "z": -254.19960021972656
        },
        {
            "x": 0.5547515153884888,
            "y": -0.005592435598373413,
            "z": -254.04409790039062
        },
        {
            "x": 0.5373446941375732,
            "y": -0.005592167377471924,
            "z": -253.88833618164062
        },
        {
            "x": 0.5202186107635498,
            "y": -0.005591854453086853,
            "z": -253.7327423095703
        },
        {
            "x": 0.503429651260376,
            "y": -0.005591601133346558,
            "z": -253.5770263671875
        },
        {
            "x": 0.4868501126766205,
            "y": -0.005591303110122681,
            "z": -253.42120361328125
        },
        {
            "x": 0.47055116295814514,
            "y": -0.0055910199880599976,
            "z": -253.26548767089844
        },
        {
            "x": 0.4545815587043762,
            "y": -0.00559069961309433,
            "z": -253.10968017578125
        },
        {
            "x": 0.4388059973716736,
            "y": -0.0055904388427734375,
            "z": -252.9537353515625
        },
        {
            "x": 0.4233175814151764,
            "y": -0.005590155720710754,
            "z": -252.79782104492188
        },
        {
            "x": 0.40814438462257385,
            "y": -0.005589872598648071,
            "z": -252.64198303222656
        },
        {
            "x": 0.39315393567085266,
            "y": -0.005589582026004791,
            "z": -252.48590087890625
        },
        {
            "x": 0.37848329544067383,
            "y": -0.005589306354522705,
            "z": -252.330078125
        },
        {
            "x": 0.3640933930873871,
            "y": -0.005588985979557037,
            "z": -252.17404174804688
        },
        {
            "x": 0.34987005591392517,
            "y": -0.005588725209236145,
            "z": -252.01773071289062
        },
        {
            "x": 0.3359754979610443,
            "y": -0.005588449537754059,
            "z": -251.86190795898438
        },
        {
            "x": 0.3223596513271332,
            "y": -0.005588166415691376,
            "z": -251.70579528808594
        },
        {
            "x": 0.3089132010936737,
            "y": -0.005587883293628693,
            "z": -251.54954528808594
        },
        {
            "x": 0.2957785129547119,
            "y": -0.0055876001715660095,
            "z": -251.3936309814453
        },
        {
            "x": 0.2828992009162903,
            "y": -0.005587294697761536,
            "z": -251.2373046875
        },
        {
            "x": 0.27020788192749023,
            "y": -0.0055870190262794495,
            "z": -251.0810089111328
        },
        {
            "x": 0.2578175663948059,
            "y": -0.005586765706539154,
            "z": -250.92501831054688
        },
        {
            "x": 0.24970704317092896,
            "y": -0.005586564540863037,
            "z": -250.8208770751953
        },
        {
            "x": 0.237688809633255,
            "y": -0.005586251616477966,
            "z": -250.66453552246094
        },
        {
            "x": 0.22591450810432434,
            "y": -0.005585990846157074,
            "z": -250.50839233398438
        },
        {
            "x": 0.21442201733589172,
            "y": -0.0055857375264167786,
            "z": -250.35203552246094
        },
        {
            "x": 0.20312318205833435,
            "y": -0.00558539479970932,
            "z": -250.1956024169922
        },
        {
            "x": 0.19205960631370544,
            "y": -0.005585148930549622,
            "z": -250.03939819335938
        },
        {
            "x": 0.18128404021263123,
            "y": -0.0055848658084869385,
            "z": -249.88307189941406
        },
        {
            "x": 0.1706978976726532,
            "y": -0.005584537982940674,
            "z": -249.7265625
        },
        {
            "x": 0.16031500697135925,
            "y": -0.0055842772126197815,
            "z": -249.5701904296875
        },
        {
            "x": 0.1502356231212616,
            "y": -0.005584001541137695,
            "z": -249.413818359375
        },
        {
            "x": 0.1403520405292511,
            "y": -0.005583703517913818,
            "z": -249.25729370117188
        },
        {
            "x": 0.13064849376678467,
            "y": -0.005583442747592926,
            "z": -249.10081481933594
        },
        {
            "x": 0.12123951315879822,
            "y": -0.005583152174949646,
            "z": -248.94451904296875
        },
        {
            "x": 0.11204710602760315,
            "y": -0.005582854151725769,
            "z": -248.78794860839844
        },
        {
            "x": 0.1030113697052002,
            "y": -0.005582548677921295,
            "z": -248.6312713623047
        },
        {
            "x": 0.09425562620162964,
            "y": -0.005582265555858612,
            "z": -248.47491455078125
        },
        {
            "x": 0.08572357892990112,
            "y": -0.005581982433795929,
            "z": -248.31832885742188
        },
        {
            "x": 0.07735061645507812,
            "y": -0.0055817291140556335,
            "z": -248.1616668701172
        },
        {
            "x": 0.06923428177833557,
            "y": -0.0055814385414123535,
            "z": -248.0052947998047
        },
        {
            "x": 0.06135052442550659,
            "y": -0.005581125617027283,
            "z": -247.84852600097656
        },
        {
            "x": 0.053625524044036865,
            "y": -0.0055808573961257935,
            "z": -247.6918487548828
        },
        {
            "x": 0.04613044857978821,
            "y": -0.005580604076385498,
            "z": -247.535400390625
        },
        {
            "x": 0.03889384865760803,
            "y": -0.005580313503742218,
            "z": -247.37887573242188
        },
        {
            "x": 0.03181368112564087,
            "y": -0.005580015480518341,
            "z": -247.22213745117188
        },
        {
            "x": 0.024914473295211792,
            "y": -0.005579724907875061,
            "z": -247.06549072265625
        },
        {
            "x": 0.018287718296051025,
            "y": -0.005579464137554169,
            "z": -246.9088897705078
        },
        {
            "x": 0.011845648288726807,
            "y": -0.005579158663749695,
            "z": -246.7521209716797
        },
        {
            "x": 0.005552709102630615,
            "y": -0.0055788978934288025,
            "z": -246.59536743164062
        },
        {
            "x": -0.0004895031452178955,
            "y": -0.0055785998702049255,
            "z": -246.4388427734375
        },
        {
            "x": -0.00630912184715271,
            "y": -0.005578331649303436,
            "z": -246.2821044921875
        },
        {
            "x": -0.012000560760498047,
            "y": -0.005578033626079559,
            "z": -246.1251678466797
        },
        {
            "x": -0.017468899488449097,
            "y": -0.005577735602855682,
            "z": -245.96861267089844
        },
        {
            "x": -0.022702515125274658,
            "y": -0.005577445030212402,
            "z": -245.8118896484375
        },
        {
            "x": -0.027785569429397583,
            "y": -0.005577154457569122,
            "z": -245.65499877929688
        },
        {
            "x": -0.03269273042678833,
            "y": -0.0055769383907318115,
            "z": -245.49827575683594
        },
        {
            "x": -0.0373624712228775,
            "y": -0.005576632916927338,
            "z": -245.3414764404297
        },
        {
            "x": -0.04184944927692413,
            "y": -0.005576297640800476,
            "z": -245.1846466064453
        },
        {
            "x": -0.04619574546813965,
            "y": -0.005576044321060181,
            "z": -245.02786254882812
        },
        {
            "x": -0.05031929910182953,
            "y": -0.0055757611989974976,
            "z": -244.87115478515625
        },
        {
            "x": -0.054228514432907104,
            "y": -0.005575463175773621,
            "z": -244.71435546875
        },
        {
            "x": -0.058011993765830994,
            "y": -0.005575202405452728,
            "z": -244.55734252929688
        },
        {
            "x": -0.06161037087440491,
            "y": -0.005574911832809448,
            "z": -244.4005889892578
        },
        {
            "x": -0.0649736076593399,
            "y": -0.005574621260166168,
            "z": -244.24392700195312
        },
        {
            "x": -0.06712494790554047,
            "y": -0.005574434995651245,
            "z": -244.13931274414062
        },
        {
            "x": -0.07024836540222168,
            "y": -0.005574114620685577,
            "z": -243.98243713378906
        },
        {
            "x": -0.07317750155925751,
            "y": -0.005573876202106476,
            "z": -243.8257598876953
        },
        {
            "x": -0.07589070498943329,
            "y": -0.00557360053062439,
            "z": -243.6688232421875
        },
        {
            "x": -0.07846038043498993,
            "y": -0.0055733174085617065,
            "z": -243.5118865966797
        },
        {
            "x": -0.0808849185705185,
            "y": -0.0055730268359184265,
            "z": -243.35508728027344
        },
        {
            "x": -0.08309242129325867,
            "y": -0.00557275116443634,
            "z": -243.1982421875
        },
        {
            "x": -0.08511705696582794,
            "y": -0.005572453141212463,
            "z": -243.04135131835938
        },
        {
            "x": -0.0870266854763031,
            "y": -0.005572177469730377,
            "z": -242.8843231201172
        },
        {
            "x": -0.08875739574432373,
            "y": -0.005571886897087097,
            "z": -242.7274627685547
        },
        {
            "x": -0.09028305113315582,
            "y": -0.005571596324443817,
            "z": -242.57064819335938
        },
        {
            "x": -0.09168083965778351,
            "y": -0.005571313202381134,
            "z": -242.41354370117188
        },
        {
            "x": -0.09295284748077393,
            "y": -0.005571015179157257,
            "z": -242.2566680908203
        },
        {
            "x": -0.09405459463596344,
            "y": -0.005570739507675171,
            "z": -242.0997772216797
        },
        {
            "x": -0.09504033625125885,
            "y": -0.005570434033870697,
            "z": -241.94252014160156
        },
        {
            "x": -0.09595796465873718,
            "y": -0.005570165812969208,
            "z": -241.78550720214844
        },
        {
            "x": -0.09677468240261078,
            "y": -0.005569867789745331,
            "z": -241.62838745117188
        },
        {
            "x": -0.09755685925483704,
            "y": -0.005569592118263245,
            "z": -241.4710693359375
        },
        {
            "x": -0.09839800000190735,
            "y": -0.005569323897361755,
            "z": -241.313720703125
        },
        {
            "x": -0.09926737844944,
            "y": -0.0055690184235572815,
            "z": -241.15621948242188
        },
        {
            "x": -0.10019940137863159,
            "y": -0.005568742752075195,
            "z": -240.9987030029297
        },
        {
            "x": -0.10131664574146271,
            "y": -0.005568474531173706,
            "z": -240.84103393554688
        },
        {
            "x": -0.1026163250207901,
            "y": -0.005568183958530426,
            "z": -240.68345642089844
        },
        {
            "x": -0.10406114161014557,
            "y": -0.005567893385887146,
            "z": -240.52577209472656
        },
        {
            "x": -0.10576532781124115,
            "y": -0.00556761771440506,
            "z": -240.36778259277344
        },
        {
            "x": -0.10775038599967957,
            "y": -0.005567334592342377,
            "z": -240.20993041992188
        },
        {
            "x": -0.10992076992988586,
            "y": -0.0055670589208602905,
            "z": -240.05227661132812
        },
        {
            "x": -0.11234070360660553,
            "y": -0.005554292816668749,
            "z": -239.89425659179688
        },
        {
            "x": -0.11509247124195099,
            "y": -0.005372038576751947,
            "z": -239.73635864257812
        },
        {
            "x": -0.11809243261814117,
            "y": -0.0049360571429133415,
            "z": -239.5786895751953
        },
        {
            "x": -0.12129499018192291,
            "y": -0.004247579723596573,
            "z": -239.42074584960938
        },
        {
            "x": -0.12481525540351868,
            "y": -0.003316781483590603,
            "z": -239.2627410888672
        },
        {
            "x": -0.1286548674106598,
            "y": -0.0021482035517692566,
            "z": -239.1049041748047
        },
        {
            "x": -0.1326923817396164,
            "y": -0.0007409167010337114,
            "z": -238.94723510742188
        },
        {
            "x": -0.13698959350585938,
            "y": 0.0009068152867257595,
            "z": -238.78936767578125
        },
        {
            "x": -0.14164507389068604,
            "y": 0.00278627872467041,
            "z": -238.63125610351562
        },
        {
            "x": -0.1465499997138977,
            "y": 0.004884686321020126,
            "z": -238.4736328125
        },
        {
            "x": -0.15165497362613678,
            "y": 0.007210339419543743,
            "z": -238.3159637451172
        },
        {
            "x": -0.15710076689720154,
            "y": 0.009767169132828712,
            "z": -238.15789794921875
        },
        {
            "x": -0.16286537051200867,
            "y": 0.012533529661595821,
            "z": -238.00018310546875
        },
        {
            "x": -0.1688336431980133,
            "y": 0.015510855242609978,
            "z": -237.84255981445312
        },
        {
            "x": -0.17506833374500275,
            "y": 0.018706098198890686,
            "z": -237.6846160888672
        },
        {
            "x": -0.18166768550872803,
            "y": 0.022111106663942337,
            "z": -237.5268096923828
        },
        {
            "x": -0.1862131655216217,
            "y": 0.024487243965268135,
            "z": -237.42178344726562
        },
        {
            "x": -0.1931893676519394,
            "y": 0.028220320120453835,
            "z": -237.2642822265625
        },
        {
            "x": -0.20047752559185028,
            "y": 0.03216446563601494,
            "z": -237.10643005371094
        },
        {
            "x": -0.20812274515628815,
            "y": 0.036302875727415085,
            "z": -236.9485626220703
        },
        {
            "x": -0.21598021686077118,
            "y": 0.040619175881147385,
            "z": -236.7911376953125
        },
        {
            "x": -0.2240830361843109,
            "y": 0.0451311320066452,
            "z": -236.6334686279297
        },
        {
            "x": -0.23256570100784302,
            "y": 0.04983849078416824,
            "z": -236.4756317138672
        },
        {
            "x": -0.24131926894187927,
            "y": 0.05471273511648178,
            "z": -236.3181915283203
        },
        {
            "x": -0.2502827048301697,
            "y": 0.05976851284503937,
            "z": -236.16062927246094
        },
        {
            "x": -0.2595856487751007,
            "y": 0.06500694155693054,
            "z": -236.00282287597656
        },
        {
            "x": -0.2692263126373291,
            "y": 0.07041089236736298,
            "z": -235.84536743164062
        },
        {
            "x": -0.27907702326774597,
            "y": 0.07598038017749786,
            "z": -235.6879119873047
        },
        {
            "x": -0.28921085596084595,
            "y": 0.08171822130680084,
            "z": -235.53033447265625
        },
        {
            "x": -0.29971417784690857,
            "y": 0.08761540055274963,
            "z": -235.372802734375
        },
        {
            "x": -0.31047356128692627,
            "y": 0.09367106109857559,
            "z": -235.2154083251953
        },
        {
            "x": -0.32146570086479187,
            "y": 0.09987999498844147,
            "z": -235.0579833984375
        },
        {
            "x": -0.33283019065856934,
            "y": 0.10624536871910095,
            "z": -234.90045166015625
        },
        {
            "x": -0.34447988867759705,
            "y": 0.11274479329586029,
            "z": -234.74319458007812
        },
        {
            "x": -0.3563474118709564,
            "y": 0.1193937286734581,
            "z": -234.58595275878906
        },
        {
            "x": -0.36858585476875305,
            "y": 0.12620043754577637,
            "z": -234.42828369140625
        },
        {
            "x": -0.3811315596103668,
            "y": 0.13312309980392456,
            "z": -234.27110290527344
        },
        {
            "x": -0.39388060569763184,
            "y": 0.14017349481582642,
            "z": -234.11404418945312
        },
        {
            "x": -0.4069656729698181,
            "y": 0.14737290143966675,
            "z": -233.9567108154297
        },
        {
            "x": -0.4204105734825134,
            "y": 0.15469244122505188,
            "z": -233.79949951171875
        },
        {
            "x": -0.4340827465057373,
            "y": 0.1621273010969162,
            "z": -233.64248657226562
        },
        {
            "x": -0.44803279638290405,
            "y": 0.16969354450702667,
            "z": -233.4851837158203
        },
        {
            "x": -0.46236908435821533,
            "y": 0.17737671732902527,
            "z": -233.32801818847656
        },
        {
            "x": -0.4769592881202698,
            "y": 0.18516287207603455,
            "z": -233.17108154296875
        },
        {
            "x": -0.4917893409729004,
            "y": 0.19306091964244843,
            "z": -233.01405334472656
        },
        {
            "x": -0.5070022344589233,
            "y": 0.20107173919677734,
            "z": -232.85694885253906
        },
        {
            "x": -0.5225206613540649,
            "y": 0.20918211340904236,
            "z": -232.69996643066406
        },
        {
            "x": -0.538248598575592,
            "y": 0.21738624572753906,
            "z": -232.54312133789062
        },
        {
            "x": -0.5543595552444458,
            "y": 0.22570042312145233,
            "z": -232.38600158691406
        },
        {
            "x": -0.5707734823226929,
            "y": 0.23409026861190796,
            "z": -232.22923278808594
        },
        {
            "x": -0.5874015092849731,
            "y": 0.24256768822669983,
            "z": -232.07257080078125
        },
        {
            "x": -0.6044244766235352,
            "y": 0.25115853548049927,
            "z": -231.9154052734375
        },
        {
            "x": -0.6217448711395264,
            "y": 0.2598040997982025,
            "z": -231.7587432861328
        },
        {
            "x": -0.639273464679718,
            "y": 0.26852214336395264,
            "z": -231.60223388671875
        },
        {
            "x": -0.6571757197380066,
            "y": 0.27734288573265076,
            "z": -231.44529724121094
        },
        {
            "x": -0.6754170656204224,
            "y": 0.2862173914909363,
            "z": -231.2886962890625
        },
        {
            "x": -0.6938772797584534,
            "y": 0.29515546560287476,
            "z": -231.13223266601562
        },
        {
            "x": -0.7126712799072266,
            "y": 0.3041766285896301,
            "z": -230.97543334960938
        },
        {
            "x": -0.7318201065063477,
            "y": 0.3132461905479431,
            "z": -230.8189239501953
        },
        {
            "x": -0.7447051405906677,
            "y": 0.31931594014167786,
            "z": -230.71478271484375
        },
        {
            "x": -0.7642589807510376,
            "y": 0.3284786343574524,
            "z": -230.55836486816406
        },
        {
            "x": -0.7842130661010742,
            "y": 0.3377027213573456,
            "z": -230.4018096923828
        },
        {
            "x": -0.804451584815979,
            "y": 0.3469666540622711,
            "z": -230.2454833984375
        },
        {
            "x": -0.8249179124832153,
            "y": 0.3562735915184021,
            "z": -230.08917236328125
        },
        {
            "x": -0.8457746505737305,
            "y": 0.36563146114349365,
            "z": -229.9327850341797
        },
        {
            "x": -0.8669227361679077,
            "y": 0.37501734495162964,
            "z": -229.77659606933594
        },
        {
            "x": -0.8882989883422852,
            "y": 0.38443708419799805,
            "z": -229.62045288085938
        },
        {
            "x": -0.9100824594497681,
            "y": 0.3939061760902405,
            "z": -229.46408081054688
        },
        {
            "x": -0.932135283946991,
            "y": 0.40338361263275146,
            "z": -229.30804443359375
        },
        {
            "x": -0.9544156193733215,
            "y": 0.4128851592540741,
            "z": -229.15206909179688
        },
        {
            "x": -0.977116584777832,
            "y": 0.42242732644081116,
            "z": -228.99581909179688
        },
        {
            "x": -1.000065803527832,
            "y": 0.4319600462913513,
            "z": -228.8400115966797
        },
        {
            "x": -1.0232611894607544,
            "y": 0.44151461124420166,
            "z": -228.6841278076172
        },
        {
            "x": -1.046881914138794,
            "y": 0.4511029124259949,
            "z": -228.52793884277344
        },
        {
            "x": -1.0707367658615112,
            "y": 0.4606649577617645,
            "z": -228.37234497070312
        },
        {
            "x": -1.0948584079742432,
            "y": 0.47024455666542053,
            "z": -228.21649169921875
        },
        {
            "x": -1.119363784790039,
            "y": 0.47983217239379883,
            "z": -228.06060791015625
        },
        {
            "x": -1.1441051959991455,
            "y": 0.48939308524131775,
            "z": -227.90512084960938
        },
        {
            "x": -1.1691652536392212,
            "y": 0.49897170066833496,
            "z": -227.74929809570312
        },
        {
            "x": -1.1945750713348389,
            "y": 0.5085330605506897,
            "z": -227.5936279296875
        },
        {
            "x": -1.2202192544937134,
            "y": 0.518061637878418,
            "z": -227.43829345703125
        },
        {
            "x": -1.246139645576477,
            "y": 0.5275862216949463,
            "z": -227.28280639648438
        },
        {
            "x": -1.2724555730819702,
            "y": 0.5370929837226868,
            "z": -227.12730407714844
        },
        {
            "x": -1.2990119457244873,
            "y": 0.5465648174285889,
            "z": -226.97203063964844
        },
        {
            "x": -1.3258579969406128,
            "y": 0.5560221672058105,
            "z": -226.81655883789062
        },
        {
            "x": -1.353062629699707,
            "y": 0.5654428005218506,
            "z": -226.66123962402344
        },
        {
            "x": -1.3805030584335327,
            "y": 0.5748189687728882,
            "z": -226.506103515625
        },
        {
            "x": -1.4082422256469727,
            "y": 0.5841671228408813,
            "z": -226.350830078125
        },
        {
            "x": -1.436327576637268,
            "y": 0.593468189239502,
            "z": -226.19570922851562
        },
        {
            "x": -1.4646543264389038,
            "y": 0.6027250289916992,
            "z": -226.0406494140625
        },
        {
            "x": -1.493297815322876,
            "y": 0.6119382381439209,
            "z": -225.885498046875
        },
        {
            "x": -1.5222810506820679,
            "y": 0.6210925579071045,
            "z": -225.73052978515625
        },
        {
            "x": -1.5514616966247559,
            "y": 0.6301831603050232,
            "z": -225.5757293701172
        },
        {
            "x": -1.5809991359710693,
            "y": 0.6392297148704529,
            "z": -225.4207305908203
        },
        {
            "x": -1.6108677387237549,
            "y": 0.6482089161872864,
            "z": -225.26585388183594
        },
        {
            "x": -1.6409143209457397,
            "y": 0.6571095585823059,
            "z": -225.11119079589844
        },
        {
            "x": -1.6713398694992065,
            "y": 0.6659533977508545,
            "z": -224.95639038085938
        },
        {
            "x": -1.7020310163497925,
            "y": 0.6747153401374817,
            "z": -224.80178833007812
        },
        {
            "x": -1.732953667640686,
            "y": 0.6833990216255188,
            "z": -224.6472625732422
        },
        {
            "x": -1.7642650604248047,
            "y": 0.6920130252838135,
            "z": -224.4925537109375
        },
        {
            "x": -1.7957959175109863,
            "y": 0.7005298137664795,
            "z": -224.33815002441406
        },
        {
            "x": -1.827586054801941,
            "y": 0.7089657783508301,
            "z": -224.1836700439453
        },
        {
            "x": -1.8489878177642822,
            "y": 0.7145382165908813,
            "z": -224.0807342529297
        },
        {
            "x": -1.8812562227249146,
            "y": 0.7228066921234131,
            "z": -223.92660522460938
        },
        {
            "x": -1.913789987564087,
            "y": 0.7309890985488892,
            "z": -223.77230834960938
        },
        {
            "x": -1.9467264413833618,
            "y": 0.7390834093093872,
            "z": -223.6178436279297
        },
        {
            "x": -1.9798121452331543,
            "y": 0.7470474243164062,
            "z": -223.46389770507812
        },
        {
            "x": -2.0131990909576416,
            "y": 0.7549166679382324,
            "z": -223.30975341796875
        },
        {
            "x": -2.0469248294830322,
            "y": 0.7626790404319763,
            "z": -223.15562438964844
        },
        {
            "x": -2.0808117389678955,
            "y": 0.770313024520874,
            "z": -223.00180053710938
        },
        {
            "x": -2.115072250366211,
            "y": 0.7778429985046387,
            "z": -222.8477020263672
        },
        {
            "x": -2.149592876434326,
            "y": 0.7852429747581482,
            "z": -222.69383239746094
        },
        {
            "x": -2.184293270111084,
            "y": 0.7925145030021667,
            "z": -222.54010009765625
        },
        {
            "x": -2.219367504119873,
            "y": 0.7996702194213867,
            "z": -222.38619995117188
        },
        {
            "x": -2.2546327114105225,
            "y": 0.8066743612289429,
            "z": -222.23265075683594
        },
        {
            "x": -2.290161609649658,
            "y": 0.8135515451431274,
            "z": -222.0789794921875
        },
        {
            "x": -2.326045036315918,
            "y": 0.8202977776527405,
            "z": -221.92523193359375
        },
        {
            "x": -2.362053394317627,
            "y": 0.8268862962722778,
            "z": -221.7718963623047
        },
        {
            "x": -2.3983988761901855,
            "y": 0.8333361148834229,
            "z": -221.61827087402344
        },
        {
            "x": -2.4349944591522217,
            "y": 0.8396296501159668,
            "z": -221.46495056152344
        },
        {
            "x": -2.471774101257324,
            "y": 0.845770001411438,
            "z": -221.31166076660156
        },
        {
            "x": -2.508928060531616,
            "y": 0.851767897605896,
            "z": -221.15811157226562
        },
        {
            "x": -2.546229600906372,
            "y": 0.857582688331604,
            "z": -221.00506591796875
        },
        {
            "x": -2.583784818649292,
            "y": 0.8632413148880005,
            "z": -220.85189819335938
        },
        {
            "x": -2.6216213703155518,
            "y": 0.8687326908111572,
            "z": -220.69882202148438
        },
        {
            "x": -2.659615993499756,
            "y": 0.8740488886833191,
            "z": -220.54592895507812
        },
        {
            "x": -2.697949171066284,
            "y": 0.8791959285736084,
            "z": -220.3927764892578
        },
        {
            "x": -2.736504554748535,
            "y": 0.8841599225997925,
            "z": -220.23983764648438
        },
        {
            "x": -2.775216579437256,
            "y": 0.888940691947937,
            "z": -220.08705139160156
        },
        {
            "x": -2.8142547607421875,
            "y": 0.8935456275939941,
            "z": -219.93409729003906
        },
        {
            "x": -2.8534436225891113,
            "y": 0.8979461193084717,
            "z": -219.781494140625
        },
        {
            "x": -2.8928771018981934,
            "y": 0.9021599888801575,
            "z": -219.62875366210938
        },
        {
            "x": -2.9326162338256836,
            "y": 0.9061837196350098,
            "z": -219.47596740722656
        },
        {
            "x": -2.9724481105804443,
            "y": 0.9100018739700317,
            "z": -219.32351684570312
        },
        {
            "x": -3.012593984603882,
            "y": 0.9136164784431458,
            "z": -219.1708526611328
        },
        {
            "x": -3.0529086589813232,
            "y": 0.9170206189155579,
            "z": -219.0184783935547
        },
        {
            "x": -3.0934154987335205,
            "y": 0.920217752456665,
            "z": -218.86607360839844
        },
        {
            "x": -3.134235382080078,
            "y": 0.9232078790664673,
            "z": -218.71353149414062
        },
        {
            "x": -3.1751229763031006,
            "y": 0.925967276096344,
            "z": -218.5614013671875
        },
        {
            "x": -3.2162864208221436,
            "y": 0.9285100102424622,
            "z": -218.40908813476562
        },
        {
            "x": -3.2576377391815186,
            "y": 0.9308289289474487,
            "z": -218.25694274902344
        },
        {
            "x": -3.299131393432617,
            "y": 0.9329222440719604,
            "z": -218.10488891601562
        },
        {
            "x": -3.340907573699951,
            "y": 0.9347800612449646,
            "z": -217.95269775390625
        },
        {
            "x": -3.3828229904174805,
            "y": 0.9364008903503418,
            "z": -217.8007354736328
        },
        {
            "x": -3.424926519393921,
            "y": 0.9377859830856323,
            "z": -217.6487579345703
        },
        {
            "x": -3.4531044960021973,
            "y": 0.9385759830474854,
            "z": -217.5475311279297
        },
        {
            "x": -3.4954628944396973,
            "y": 0.939551055431366,
            "z": -217.39578247070312
        },
        {
            "x": -3.5380477905273438,
            "y": 0.9402823448181152,
            "z": -217.24395751953125
        },
        {
            "x": -3.580850601196289,
            "y": 0.9407649040222168,
            "z": -217.09210205078125
        },
        {
            "x": -3.623727798461914,
            "y": 0.9409863352775574,
            "z": -216.94049072265625
        },
        {
            "x": -3.6668264865875244,
            "y": 0.9409486055374146,
            "z": -216.7888946533203
        },
        {
            "x": -3.7100675106048584,
            "y": 0.9406560659408569,
            "z": -216.6372833251953
        },
        {
            "x": -3.7534728050231934,
            "y": 0.940112292766571,
            "z": -216.4857177734375
        },
        {
            "x": -3.797050952911377,
            "y": 0.9393133521080017,
            "z": -216.3342742919922
        },
        {
            "x": -3.840761661529541,
            "y": 0.9382652640342712,
            "z": -216.18280029296875
        },
        {
            "x": -3.884629726409912,
            "y": 0.936977207660675,
            "z": -216.03143310546875
        },
        {
            "x": -3.9286205768585205,
            "y": 0.9354515075683594,
            "z": -215.88011169433594
        },
        {
            "x": -3.972747802734375,
            "y": 0.9336857795715332,
            "z": -215.72882080078125
        },
        {
            "x": -4.017002582550049,
            "y": 0.9316863417625427,
            "z": -215.5777130126953
        },
        {
            "x": -4.061431884765625,
            "y": 0.9294567108154297,
            "z": -215.42637634277344
        },
        {
            "x": -4.105963706970215,
            "y": 0.9270066618919373,
            "z": -215.27529907226562
        },
        {
            "x": -4.150588035583496,
            "y": 0.924331784248352,
            "z": -215.12429809570312
        },
        {
            "x": -4.1953558921813965,
            "y": 0.9214345216751099,
            "z": -214.9732208251953
        },
        {
            "x": -4.240206718444824,
            "y": 0.9183272123336792,
            "z": -214.82235717773438
        },
        {
            "x": -4.28521728515625,
            "y": 0.9150054454803467,
            "z": -214.67124938964844
        },
        {
            "x": -4.330311298370361,
            "y": 0.9114775657653809,
            "z": -214.52041625976562
        },
        {
            "x": -4.3754706382751465,
            "y": 0.9077440500259399,
            "z": -214.36965942382812
        },
        {
            "x": -4.420743942260742,
            "y": 0.9038105010986328,
            "z": -214.2188720703125
        },
        {
            "x": -4.466097831726074,
            "y": 0.8996842503547668,
            "z": -214.06820678710938
        },
        {
            "x": -4.511569023132324,
            "y": 0.8953583240509033,
            "z": -213.91744995117188
        },
        {
            "x": -4.5571370124816895,
            "y": 0.8908392190933228,
            "z": -213.7667236328125
        },
        {
            "x": -4.602725982666016,
            "y": 0.8861403465270996,
            "z": -213.61618041992188
        },
        {
            "x": -4.648441314697266,
            "y": 0.8812551498413086,
            "z": -213.4654998779297
        },
        {
            "x": -4.694198131561279,
            "y": 0.8761933445930481,
            "z": -213.31500244140625
        },
        {
            "x": -4.740002632141113,
            "y": 0.8709533214569092,
            "z": -213.16453552246094
        },
        {
            "x": -4.785935878753662,
            "y": 0.8655362725257874,
            "z": -213.01393127441406
        },
        {
            "x": -4.831847190856934,
            "y": 0.8599589467048645,
            "z": -212.863525390625
        },
        {
            "x": -4.877850532531738,
            "y": 0.8542124629020691,
            "z": -212.71307373046875
        },
        {
            "x": -4.923880100250244,
            "y": 0.8483036160469055,
            "z": -212.56272888183594
        },
        {
            "x": -4.969927787780762,
            "y": 0.8422392010688782,
            "z": -212.4123992919922
        },
        {
            "x": -5.016086578369141,
            "y": 0.8360138535499573,
            "z": -212.2619171142578
        },
        {
            "x": -5.062206745147705,
            "y": 0.8296456336975098,
            "z": -212.11166381835938
        },
        {
            "x": -5.1083574295043945,
            "y": 0.8231277465820312,
            "z": -211.9614715576172
        },
        {
            "x": -5.1545515060424805,
            "y": 0.816462516784668,
            "z": -211.8111572265625
        },
        {
            "x": -5.200747013092041,
            "y": 0.809661865234375,
            "z": -211.6609649658203
        },
        {
            "x": -5.246968746185303,
            "y": 0.8027223348617554,
            "z": -211.51072692871094
        },
        {
            "x": -5.293209075927734,
            "y": 0.7956438064575195,
            "z": -211.36048889160156
        },
        {
            "x": -5.339409828186035,
            "y": 0.7884426712989807,
            "z": -211.21035766601562
        },
        {
            "x": -5.370218753814697,
            "y": 0.7835744619369507,
            "z": -211.11029052734375
        },
        {
            "x": -5.41641092300415,
            "y": 0.7761636972427368,
            "z": -210.960205078125
        },
        {
            "x": -5.462588787078857,
            "y": 0.7686342000961304,
            "z": -210.8101348876953
        },
        {
            "x": -5.508816719055176,
            "y": 0.7609788179397583,
            "z": -210.6598663330078
        },
        {
            "x": -5.5549540519714355,
            "y": 0.7532232999801636,
            "z": -210.5098419189453
        },
        {
            "x": -5.601079940795898,
            "y": 0.7453508377075195,
            "z": -210.3597412109375
        },
        {
            "x": -5.647190570831299,
            "y": 0.7373701333999634,
            "z": -210.2096405029297
        },
        {
            "x": -5.693242073059082,
            "y": 0.7292917966842651,
            "z": -210.05955505371094
        },
        {
            "x": -5.739291191101074,
            "y": 0.7211095094680786,
            "z": -209.909423828125
        },
        {
            "x": -5.7852559089660645,
            "y": 0.7128320932388306,
            "z": -209.75933837890625
        },
        {
            "x": -5.83117151260376,
            "y": 0.7044641971588135,
            "z": -209.60926818847656
        },
        {
            "x": -5.877055644989014,
            "y": 0.6960050463676453,
            "z": -209.45913696289062
        },
        {
            "x": -5.922837257385254,
            "y": 0.6874666213989258,
            "z": -209.30908203125
        },
        {
            "x": -5.968560695648193,
            "y": 0.678846001625061,
            "z": -209.15907287597656
        },
        {
            "x": -6.014251232147217,
            "y": 0.6701357364654541,
            "z": -209.00881958007812
        },
        {
            "x": -6.0598249435424805,
            "y": 0.6613613367080688,
            "z": -208.8587646484375
        },
        {
            "x": -6.105314254760742,
            "y": 0.6525166630744934,
            "z": -208.7086639404297
        },
        {
            "x": -6.150725841522217,
            "y": 0.6435988545417786,
            "z": -208.5585174560547
        },
        {
            "x": -6.196028232574463,
            "y": 0.6346220970153809,
            "z": -208.408447265625
        },
        {
            "x": -6.241286277770996,
            "y": 0.625572681427002,
            "z": -208.25811767578125
        },
        {
            "x": -6.286402702331543,
            "y": 0.6164789199829102,
            "z": -208.1079864501953
        },
        {
            "x": -6.331390380859375,
            "y": 0.6073309779167175,
            "z": -207.95787048339844
        },
        {
            "x": -6.37628698348999,
            "y": 0.5981314182281494,
            "z": -207.8076934814453
        },
        {
            "x": -6.421016216278076,
            "y": 0.588891863822937,
            "z": -207.65757751464844
        },
        {
            "x": -6.465691566467285,
            "y": 0.5795952081680298,
            "z": -207.50726318359375
        },
        {
            "x": -6.510223865509033,
            "y": 0.570263147354126,
            "z": -207.35696411132812
        },
        {
            "x": -6.554580211639404,
            "y": 0.56089848279953,
            "z": -207.20668029785156
        },
        {
            "x": -6.598853588104248,
            "y": 0.5514945983886719,
            "z": -207.05630493164062
        },
        {
            "x": -6.642904758453369,
            "y": 0.5420719981193542,
            "z": -206.90602111816406
        },
        {
            "x": -6.686854839324951,
            "y": 0.5326168537139893,
            "z": -206.75563049316406
        },
        {
            "x": -6.73067045211792,
            "y": 0.5231341123580933,
            "z": -206.6051025390625
        },
        {
            "x": -6.774284839630127,
            "y": 0.5136383175849915,
            "z": -206.4546661376953
        },
        {
            "x": -6.817756175994873,
            "y": 0.5041292905807495,
            "z": -206.30416870117188
        },
        {
            "x": -6.861035346984863,
            "y": 0.49460551142692566,
            "z": -206.15362548828125
        },
        {
            "x": -6.904156684875488,
            "y": 0.4850759506225586,
            "z": -206.00306701660156
        },
        {
            "x": -6.947102069854736,
            "y": 0.4755353033542633,
            "z": -205.8524169921875
        },
        {
            "x": -6.989861011505127,
            "y": 0.4659963548183441,
            "z": -205.7017364501953
        },
        {
            "x": -7.032390594482422,
            "y": 0.4564686417579651,
            "z": -205.55113220214844
        },
        {
            "x": -7.074764251708984,
            "y": 0.4469315707683563,
            "z": -205.4002685546875
        },
        {
            "x": -7.116929531097412,
            "y": 0.4374147653579712,
            "z": -205.24954223632812
        },
        {
            "x": -7.158866882324219,
            "y": 0.4279063045978546,
            "z": -205.09869384765625
        },
        {
            "x": -7.200659275054932,
            "y": 0.4184074401855469,
            "z": -204.9477081298828
        },
        {
            "x": -7.242132186889648,
            "y": 0.4089447259902954,
            "z": -204.79690551757812
        },
        {
            "x": -7.26969051361084,
            "y": 0.4026399254798889,
            "z": -204.6962432861328
        },
        {
            "x": -7.310857772827148,
            "y": 0.39321038126945496,
            "z": -204.54527282714844
        },
        {
            "x": -7.351720809936523,
            "y": 0.38381531834602356,
            "z": -204.39431762695312
        },
        {
            "x": -7.392485618591309,
            "y": 0.3744284510612488,
            "z": -204.242919921875
        },
        {
            "x": -7.432900905609131,
            "y": 0.36510300636291504,
            "z": -204.09188842773438
        },
        {
            "x": -7.473106861114502,
            "y": 0.35580432415008545,
            "z": -203.9406280517578
        },
        {
            "x": -7.51308536529541,
            "y": 0.3465515077114105,
            "z": -203.78932189941406
        },
        {
            "x": -7.552760601043701,
            "y": 0.33734655380249023,
            "z": -203.6379852294922
        },
        {
            "x": -7.592257976531982,
            "y": 0.32818344235420227,
            "z": -203.48646545410156
        },
        {
            "x": -7.631412029266357,
            "y": 0.31908273696899414,
            "z": -203.33505249023438
        },
        {
            "x": -7.670336723327637,
            "y": 0.3100312054157257,
            "z": -203.1834259033203
        },
        {
            "x": -7.708985328674316,
            "y": 0.3010450601577759,
            "z": -203.03184509277344
        },
        {
            "x": -7.747344493865967,
            "y": 0.29211878776550293,
            "z": -202.880126953125
        },
        {
            "x": -7.785464763641357,
            "y": 0.28326329588890076,
            "z": -202.7284393310547
        },
        {
            "x": -7.823261737823486,
            "y": 0.2744733691215515,
            "z": -202.5765380859375
        },
        {
            "x": -7.860805988311768,
            "y": 0.26575708389282227,
            "z": -202.4246063232422
        },
        {
            "x": -7.898010730743408,
            "y": 0.2571282982826233,
            "z": -202.27276611328125
        },
        {
            "x": -7.9349493980407715,
            "y": 0.24856729805469513,
            "z": -202.12066650390625
        },
        {
            "x": -7.971574783325195,
            "y": 0.24010378122329712,
            "z": -201.9687042236328
        },
        {
            "x": -8.007888793945312,
            "y": 0.23171484470367432,
            "z": -201.81639099121094
        },
        {
            "x": -8.043932914733887,
            "y": 0.22342170774936676,
            "z": -201.6641387939453
        },
        {
            "x": -8.07957649230957,
            "y": 0.21523435413837433,
            "z": -201.5120391845703
        },
        {
            "x": -8.114967346191406,
            "y": 0.2071308195590973,
            "z": -201.3595428466797
        },
        {
            "x": -8.149996757507324,
            "y": 0.19914427399635315,
            "z": -201.207275390625
        },
        {
            "x": -8.184713363647461,
            "y": 0.19124789535999298,
            "z": -201.05465698242188
        },
        {
            "x": -8.21916675567627,
            "y": 0.18345966935157776,
            "z": -200.90199279785156
        },
        {
            "x": -8.25316333770752,
            "y": 0.17579689621925354,
            "z": -200.74949645996094
        },
        {
            "x": -8.286937713623047,
            "y": 0.1682339310646057,
            "z": -200.59658813476562
        },
        {
            "x": -8.32028865814209,
            "y": 0.16080671548843384,
            "z": -200.44395446777344
        },
        {
            "x": -8.353316307067871,
            "y": 0.1534888744354248,
            "z": -200.291015625
        },
        {
            "x": -8.386055946350098,
            "y": 0.1462961733341217,
            "z": -200.13796997070312
        },
        {
            "x": -8.418328285217285,
            "y": 0.1392437219619751,
            "z": -199.9850311279297
        },
        {
            "x": -8.45035457611084,
            "y": 0.13231191039085388,
            "z": -199.831787109375
        },
        {
            "x": -8.481945991516113,
            "y": 0.12552744150161743,
            "z": -199.67877197265625
        },
        {
            "x": -8.513202667236328,
            "y": 0.11887232959270477,
            "z": -199.52542114257812
        },
        {
            "x": -8.544140815734863,
            "y": 0.11236391961574554,
            "z": -199.3720245361328
        },
        {
            "x": -8.574605941772461,
            "y": 0.10600753128528595,
            "z": -199.21868896484375
        },
        {
            "x": -8.6047945022583,
            "y": 0.09979376196861267,
            "z": -199.065185546875
        },
        {
            "x": -8.63453483581543,
            "y": 0.09373856335878372,
            "z": -198.9117431640625
        },
        {
            "x": -8.663939476013184,
            "y": 0.08783578872680664,
            "z": -198.7579803466797
        },
        {
            "x": -8.692963600158691,
            "y": 0.08209826052188873,
            "z": -198.60435485839844
        },
        {
            "x": -8.721567153930664,
            "y": 0.07651688158512115,
            "z": -198.4504852294922
        },
        {
            "x": -8.749855995178223,
            "y": 0.07110393047332764,
            "z": -198.29664611816406
        },
        {
            "x": -8.768420219421387,
            "y": 0.06760150194168091,
            "z": -198.1942138671875
        },
        {
            "x": -8.795979499816895,
            "y": 0.06247491389513016,
            "z": -198.04022216796875
        },
        {
            "x": -8.823214530944824,
            "y": 0.05752494931221008,
            "z": -197.88623046875
        },
        {
            "x": -8.849968910217285,
            "y": 0.05275826156139374,
            "z": -197.7321014404297
        },
        {
            "x": -8.876394271850586,
            "y": 0.048169974237680435,
            "z": -197.5778350830078
        },
        {
            "x": -8.902359962463379,
            "y": 0.043775081634521484,
            "z": -197.42381286621094
        },
        {
            "x": -8.927945137023926,
            "y": 0.03955661505460739,
            "z": -197.2693328857422
        },
        {
            "x": -8.953160285949707,
            "y": 0.03554374724626541,
            "z": -197.11500549316406
        },
        {
            "x": -8.977886199951172,
            "y": 0.03172488138079643,
            "z": -196.96058654785156
        },
        {
            "x": -9.002301216125488,
            "y": 0.02809695526957512,
            "z": -196.8058624267578
        },
        {
            "x": -9.026230812072754,
            "y": 0.02467980980873108,
            "z": -196.6515350341797
        },
        {
            "x": -9.049739837646484,
            "y": 0.02146724984049797,
            "z": -196.4967041015625
        },
        {
            "x": -9.072892189025879,
            "y": 0.01846630871295929,
            "z": -196.342041015625
        },
        {
            "x": -9.095535278320312,
            "y": 0.015677809715270996,
            "z": -196.1874237060547
        },
        {
            "x": -9.117878913879395,
            "y": 0.013094564899802208,
            "z": -196.0322723388672
        },
        {
            "x": -9.1397123336792,
            "y": 0.010746873915195465,
            "z": -195.87757873535156
        },
        {
            "x": -9.161101341247559,
            "y": 0.008615952916443348,
            "z": -195.72251892089844
        },
        {
            "x": -9.182158470153809,
            "y": 0.006708970293402672,
            "z": -195.5675048828125
        },
        {
            "x": -9.20267391204834,
            "y": 0.005031188018620014,
            "z": -195.41261291503906
        },
        {
            "x": -9.222858428955078,
            "y": 0.0035878894850611687,
            "z": -195.2571563720703
        },
        {
            "x": -9.242575645446777,
            "y": 0.0023838302586227655,
            "z": -195.1021728515625
        },
        {
            "x": -9.261815071105957,
            "y": 0.0014144921442493796,
            "z": -194.94692993164062
        },
        {
            "x": -9.28072452545166,
            "y": 0.0006842147558927536,
            "z": -194.79159545898438
        },
        {
            "x": -9.299084663391113,
            "y": 0.00020754127763211727,
            "z": -194.63648986816406
        },
        {
            "x": -9.31707763671875,
            "y": -2.2311927750706673e-05,
            "z": -194.48086547851562
        },
        {
            "x": -9.334662437438965,
            "y": -5.251169204711914e-05,
            "z": -194.3254852294922
        },
        {
            "x": -9.351716041564941,
            "y": -5.5417418479919434e-05,
            "z": -194.17005920410156
        },
        {
            "x": -9.368446350097656,
            "y": -5.835294723510742e-05,
            "z": -194.01431274414062
        },
        {
            "x": -9.384653091430664,
            "y": -6.128102540969849e-05,
            "z": -193.85899353027344
        },
        {
            "x": -9.400425910949707,
            "y": -6.41942024230957e-05,
            "z": -193.70326232910156
        },
        {
            "x": -9.415862083435059,
            "y": -6.7099928855896e-05,
            "z": -193.54742431640625
        },
        {
            "x": -9.430712699890137,
            "y": -7.000565528869629e-05,
            "z": -193.3919219970703
        },
        {
            "x": -9.44521427154541,
            "y": -7.291138172149658e-05,
            "z": -193.2359619140625
        },
        {
            "x": -9.459268569946289,
            "y": -7.581710815429688e-05,
            "z": -193.080322265625
        },
        {
            "x": -9.472817420959473,
            "y": -7.872283458709717e-05,
            "z": -192.92446899414062
        },
        {
            "x": -9.486041069030762,
            "y": -8.165836334228516e-05,
            "z": -192.76834106445312
        },
        {
            "x": -9.49871826171875,
            "y": -8.457154035568237e-05,
            "z": -192.6126708984375
        },
        {
            "x": -9.510973930358887,
            "y": -8.748471736907959e-05,
            "z": -192.4565887451172
        },
        {
            "x": -9.522866249084473,
            "y": -9.038299322128296e-05,
            "z": -192.30062866210938
        },
        {
            "x": -9.534192085266113,
            "y": -9.329617023468018e-05,
            "z": -192.14476013183594
        },
        {
            "x": -9.545166969299316,
            "y": -9.618699550628662e-05,
            "z": -191.98846435546875
        },
        {
            "x": -9.555694580078125,
            "y": -9.914487600326538e-05,
            "z": -191.83251953125
        },
        {
            "x": -9.565705299377441,
            "y": -0.00010204315185546875,
            "z": -191.67642211914062
        },
        {
            "x": -9.572196960449219,
            "y": -0.00010398030281066895,
            "z": -191.57223510742188
        },
        {
            "x": -9.581547737121582,
            "y": -0.00010687857866287231,
            "z": -191.41629028320312
        },
        {
            "x": -9.590385437011719,
            "y": -0.0001098141074180603,
            "z": -191.26011657714844
        },
        {
            "x": -9.598896980285645,
            "y": -0.00011269748210906982,
            "z": -191.1036376953125
        },
        {
            "x": -9.606886863708496,
            "y": -0.00011563301086425781,
            "z": -190.94766235351562
        },
        {
            "x": -9.614422798156738,
            "y": -0.0001185387372970581,
            "z": -190.7913055419922
        },
        {
            "x": -9.621623039245605,
            "y": -0.00012146681547164917,
            "z": -190.6349334716797
        },
        {
            "x": -9.628271102905273,
            "y": -0.00012439489364624023,
            "z": -190.4788818359375
        },
        {
            "x": -9.63451862335205,
            "y": -0.0001272931694984436,
            "z": -190.32229614257812
        },
        {
            "x": -9.640389442443848,
            "y": -0.00013017654418945312,
            "z": -190.16600036621094
        },
        {
            "x": -9.645720481872559,
            "y": -0.00013311952352523804,
            "z": -190.00978088378906
        },
        {
            "x": -9.650696754455566,
            "y": -0.00013606250286102295,
            "z": -189.85311889648438
        },
        {
            "x": -9.655226707458496,
            "y": -0.0001389235258102417,
            "z": -189.6969757080078
        },
        {
            "x": -9.659250259399414,
            "y": -0.00014181435108184814,
            "z": -189.54058837890625
        },
        {
            "x": -9.66295337677002,
            "y": -0.00014473497867584229,
            "z": -189.38388061523438
        },
        {
            "x": -9.666171073913574,
            "y": -0.0001476779580116272,
            "z": -189.2277069091797
        },
        {
            "x": -9.668902397155762,
            "y": -0.00015057623386383057,
            "z": -189.07118225097656
        },
        {
            "x": -9.67131233215332,
            "y": -0.0001534968614578247,
            "z": -188.91464233398438
        },
        {
            "x": -9.673221588134766,
            "y": -0.00015639513731002808,
            "z": -188.75843811035156
        },
        {
            "x": -9.674683570861816,
            "y": -0.00015932321548461914,
            "z": -188.60162353515625
        },
        {
            "x": -9.67580509185791,
            "y": -0.0001622512936592102,
            "z": -188.44522094726562
        },
        {
            "x": -9.676405906677246,
            "y": -0.00016514956951141357,
            "z": -188.28897094726562
        },
        {
            "x": -9.676596641540527,
            "y": -0.00016808509826660156,
            "z": -188.13233947753906
        },
        {
            "x": -9.676427841186523,
            "y": -0.00017098337411880493,
            "z": -187.97601318359375
        },
        {
            "x": -9.675703048706055,
            "y": -0.00017389655113220215,
            "z": -187.8196258544922
        },
        {
            "x": -9.67459774017334,
            "y": -0.00017680972814559937,
            "z": -187.66290283203125
        },
        {
            "x": -9.673102378845215,
            "y": -0.00017970800399780273,
            "z": -187.5066680908203
        },
        {
            "x": -9.671050071716309,
            "y": -0.00018262118101119995,
            "z": -187.35023498535156
        },
        {
            "x": -9.668632507324219,
            "y": -0.00018554925918579102,
            "z": -187.1936492919922
        },
        {
            "x": -9.665782928466797,
            "y": -0.00018847733736038208,
            "z": -187.03749084472656
        },
        {
            "x": -9.662396430969238,
            "y": -0.00019138306379318237,
            "z": -186.88088989257812
        },
        {
            "x": -9.658673286437988,
            "y": -0.00019431114196777344,
            "z": -186.72438049316406
        },
        {
            "x": -9.654459953308105,
            "y": -0.0001973744947463274,
            "z": -186.56820678710938
        },
        {
            "x": -9.64974308013916,
            "y": -0.0003063203766942024,
            "z": -186.4116973876953
        },
        {
            "x": -9.644700050354004,
            "y": -0.0006504433695226908,
            "z": -186.25534057617188
        },
        {
            "x": -9.639129638671875,
            "y": -0.001214069314301014,
            "z": -186.0990447998047
        },
        {
            "x": -9.633090019226074,
            "y": -0.0019999342039227486,
            "z": -185.9425811767578
        },
        {
            "x": -9.626708030700684,
            "y": -0.0029950758907943964,
            "z": -185.786376953125
        },
        {
            "x": -9.619784355163574,
            "y": -0.004198410082608461,
            "z": -185.630126953125
        },
        {
            "x": -9.612448692321777,
            "y": -0.005611095577478409,
            "z": -185.47369384765625
        },
        {
            "x": -9.604719161987305,
            "y": -0.007230979856103659,
            "z": -185.31752014160156
        },
        {
            "x": -9.596442222595215,
            "y": -0.009051475673913956,
            "z": -185.1613006591797
        },
        {
            "x": -9.587811470031738,
            "y": -0.011069482192397118,
            "z": -185.00498962402344
        },
        {
            "x": -9.581829071044922,
            "y": -0.01252218708395958,
            "z": -184.90103149414062
        },
        {
            "x": -9.572388648986816,
            "y": -0.014863792806863785,
            "z": -184.74501037597656
        },
        {
            "x": -9.562564849853516,
            "y": -0.017398130148649216,
            "z": -184.58872985839844
        },
        {
            "x": -9.552329063415527,
            "y": -0.020116101950407028,
            "z": -184.4326629638672
        },
        {
            "x": -9.541546821594238,
            "y": -0.02302534691989422,
            "z": -184.276611328125
        },
        {
            "x": -9.53043270111084,
            "y": -0.02611558511853218,
            "z": -184.12051391601562
        },
        {
            "x": -9.518848419189453,
            "y": -0.029378151521086693,
            "z": -183.96466064453125
        },
        {
            "x": -9.506776809692383,
            "y": -0.032821014523506165,
            "z": -183.80860900878906
        },
        {
            "x": -9.494359970092773,
            "y": -0.03644091635942459,
            "z": -183.65261840820312
        },
        {
            "x": -9.481427192687988,
            "y": -0.04022558033466339,
            "z": -183.496826171875
        },
        {
            "x": -9.46807861328125,
            "y": -0.04418119415640831,
            "z": -183.34080505371094
        },
        {
            "x": -9.454364776611328,
            "y": -0.04829384759068489,
            "z": -183.18505859375
        },
        {
            "x": -9.440103530883789,
            "y": -0.05257311463356018,
            "z": -183.02938842773438
        },
        {
            "x": -9.42548942565918,
            "y": -0.05701328068971634,
            "z": -182.87351989746094
        },
        {
            "x": -9.410442352294922,
            "y": -0.061602260917425156,
            "z": -182.7178955078125
        },
        {
            "x": -9.394904136657715,
            "y": -0.06634506583213806,
            "z": -182.5621795654297
        },
        {
            "x": -9.379030227661133,
            "y": -0.07124093174934387,
            "z": -182.40655517578125
        },
        {
            "x": -9.36266803741455,
            "y": -0.0762757658958435,
            "z": -182.2511444091797
        },
        {
            "x": -9.345870971679688,
            "y": -0.08146113902330399,
            "z": -182.0955047607422
        },
        {
            "x": -9.328726768493652,
            "y": -0.08678149431943893,
            "z": -181.94000244140625
        },
        {
            "x": -9.31106185913086,
            "y": -0.09223904460668564,
            "z": -181.78468322753906
        },
        {
            "x": -9.293030738830566,
            "y": -0.09783655405044556,
            "z": -181.6292266845703
        },
        {
            "x": -9.274609565734863,
            "y": -0.10355060547590256,
            "z": -181.47418212890625
        },
        {
            "x": -9.255685806274414,
            "y": -0.10940207540988922,
            "z": -181.31886291503906
        },
        {
            "x": -9.236424446105957,
            "y": -0.11538417637348175,
            "z": -181.16357421875
        },
        {
            "x": -9.216697692871094,
            "y": -0.12147966027259827,
            "z": -181.00851440429688
        },
        {
            "x": -9.196547508239746,
            "y": -0.1277020424604416,
            "z": -180.85330200195312
        },
        {
            "x": -9.176064491271973,
            "y": -0.13403142988681793,
            "z": -180.6983184814453
        },
        {
            "x": -9.155076026916504,
            "y": -0.14047542214393616,
            "z": -180.54344177246094
        },
        {
            "x": -9.13373851776123,
            "y": -0.14703582227230072,
            "z": -180.388427734375
        },
        {
            "x": -9.111976623535156,
            "y": -0.15369832515716553,
            "z": -180.2335662841797
        },
        {
            "x": -9.089768409729004,
            "y": -0.16046756505966187,
            "z": -180.07867431640625
        },
        {
            "x": -9.067243576049805,
            "y": -0.1673363745212555,
            "z": -179.92391967773438
        },
        {
            "x": -9.044243812561035,
            "y": -0.17429831624031067,
            "z": -179.7693634033203
        },
        {
            "x": -9.020858764648438,
            "y": -0.18136385083198547,
            "z": -179.61459350585938
        },
        {
            "x": -8.997116088867188,
            "y": -0.18851560354232788,
            "z": -179.46002197265625
        },
        {
            "x": -8.972901344299316,
            "y": -0.1957564800977707,
            "z": -179.30552673339844
        },
        {
            "x": -8.948370933532715,
            "y": -0.2030855417251587,
            "z": -179.15106201171875
        },
        {
            "x": -8.92342472076416,
            "y": -0.2104906141757965,
            "z": -178.99676513671875
        },
        {
            "x": -8.898055076599121,
            "y": -0.21798333525657654,
            "z": -178.8423614501953
        },
        {
            "x": -8.872367858886719,
            "y": -0.2255486249923706,
            "z": -178.6881103515625
        },
        {
            "x": -8.846207618713379,
            "y": -0.2331896424293518,
            "z": -178.53392028808594
        },
        {
            "x": -8.819722175598145,
            "y": -0.2409036010503769,
            "z": -178.3797149658203
        },
        {
            "x": -8.801892280578613,
            "y": -0.24607416987419128,
            "z": -178.2771453857422
        },
        {
            "x": -8.774724006652832,
            "y": -0.2538926601409912,
            "z": -178.12319946289062
        },
        {
            "x": -8.747236251831055,
            "y": -0.26177895069122314,
            "z": -177.9691925048828
        },
        {
            "x": -8.719353675842285,
            "y": -0.2697215676307678,
            "z": -177.81529235839844
        },
        {
            "x": -8.691061019897461,
            "y": -0.27772557735443115,
            "z": -177.661376953125
        },
        {
            "x": -8.662495613098145,
            "y": -0.2857730984687805,
            "z": -177.5077362060547
        },
        {
            "x": -8.633465766906738,
            "y": -0.29387643933296204,
            "z": -177.3540496826172
        },
        {
            "x": -8.604111671447754,
            "y": -0.30203163623809814,
            "z": -177.20033264160156
        },
        {
            "x": -8.574426651000977,
            "y": -0.3102215528488159,
            "z": -177.04685974121094
        },
        {
            "x": -8.544281959533691,
            "y": -0.3184661865234375,
            "z": -176.89324951171875
        },
        {
            "x": -8.513895988464355,
            "y": -0.3267378509044647,
            "z": -176.73988342285156
        },
        {
            "x": -8.48308277130127,
            "y": -0.33504629135131836,
            "z": -176.5865478515625
        },
        {
            "x": -8.451933860778809,
            "y": -0.34339290857315063,
            "z": -176.4331512451172
        },
        {
            "x": -8.42049503326416,
            "y": -0.35175439715385437,
            "z": -176.28013610839844
        },
        {
            "x": -8.388578414916992,
            "y": -0.36016273498535156,
            "z": -176.1267852783203
        },
        {
            "x": -8.35644245147705,
            "y": -0.3685814440250397,
            "z": -175.97372436523438
        },
        {
            "x": -8.323925018310547,
            "y": -0.3770144581794739,
            "z": -175.8208465576172
        },
        {
            "x": -8.291014671325684,
            "y": -0.3854805827140808,
            "z": -175.667724609375
        },
        {
            "x": -8.257874488830566,
            "y": -0.3939439654350281,
            "z": -175.51499938964844
        },
        {
            "x": -8.224276542663574,
            "y": -0.4024353623390198,
            "z": -175.3620147705078
        },
        {
            "x": -8.19045352935791,
            "y": -0.4109255373477936,
            "z": -175.20925903320312
        },
        {
            "x": -8.156285285949707,
            "y": -0.4194100499153137,
            "z": -175.05673217773438
        },
        {
            "x": -8.121753692626953,
            "y": -0.42791104316711426,
            "z": -174.904052734375
        },
        {
            "x": -8.086986541748047,
            "y": -0.43639716506004333,
            "z": -174.75164794921875
        },
        {
            "x": -8.051795959472656,
            "y": -0.444890558719635,
            "z": -174.59913635253906
        },
        {
            "x": -8.01633071899414,
            "y": -0.45337969064712524,
            "z": -174.44662475585938
        },
        {
            "x": -7.980586051940918,
            "y": -0.46184173226356506,
            "z": -174.29444885253906
        },
        {
            "x": -7.944455623626709,
            "y": -0.47030940651893616,
            "z": -174.1420135498047
        },
        {
            "x": -7.908130168914795,
            "y": -0.4787450432777405,
            "z": -173.98992919921875
        },
        {
            "x": -7.871414661407471,
            "y": -0.4871636629104614,
            "z": -173.8378143310547
        },
        {
            "x": -7.834396839141846,
            "y": -0.4955739676952362,
            "z": -173.68553161621094
        },
        {
            "x": -7.797142028808594,
            "y": -0.5039387941360474,
            "z": -173.53369140625
        },
        {
            "x": -7.759531021118164,
            "y": -0.5122902393341064,
            "z": -173.38160705566406
        },
        {
            "x": -7.721709251403809,
            "y": -0.5205979347229004,
            "z": -173.22975158691406
        },
        {
            "x": -7.683534145355225,
            "y": -0.5288715362548828,
            "z": -173.07798767089844
        },
        {
            "x": -7.645063877105713,
            "y": -0.537122368812561,
            "z": -172.92599487304688
        },
        {
            "x": -7.606391429901123,
            "y": -0.5453105568885803,
            "z": -172.77447509765625
        },
        {
            "x": -7.567377090454102,
            "y": -0.5534670352935791,
            "z": -172.62278747558594
        },
        {
            "x": -7.528139114379883,
            "y": -0.5615707635879517,
            "z": -172.47120666503906
        },
        {
            "x": -7.48859167098999,
            "y": -0.5696229934692383,
            "z": -172.3197479248047
        },
        {
            "x": -7.44879150390625,
            "y": -0.5776301622390747,
            "z": -172.16818237304688
        },
        {
            "x": -7.4087324142456055,
            "y": -0.5855719447135925,
            "z": -172.01681518554688
        },
        {
            "x": -7.368387222290039,
            "y": -0.5934575200080872,
            "z": -171.86541748046875
        },
        {
            "x": -7.341403961181641,
            "y": -0.5986767411231995,
            "z": -171.76461791992188
        },
        {
            "x": -7.300671100616455,
            "y": -0.606447696685791,
            "z": -171.61349487304688
        },
        {
            "x": -7.259666442871094,
            "y": -0.6141586303710938,
            "z": -171.46224975585938
        },
        {
            "x": -7.218426704406738,
            "y": -0.6217992305755615,
            "z": -171.31105041503906
        },
        {
            "x": -7.1769328117370605,
            "y": -0.6293630599975586,
            "z": -171.16000366210938
        },
        {
            "x": -7.135259628295898,
            "y": -0.6368460059165955,
            "z": -171.00901794433594
        },
        {
            "x": -7.0932745933532715,
            "y": -0.6442506313323975,
            "z": -170.85800170898438
        },
        {
            "x": -7.05109977722168,
            "y": -0.6515722274780273,
            "z": -170.7070770263672
        },
        {
            "x": -7.008703231811523,
            "y": -0.6588057279586792,
            "z": -170.5562286376953
        },
        {
            "x": -6.966032981872559,
            "y": -0.6659542918205261,
            "z": -170.4053192138672
        },
        {
            "x": -6.923228740692139,
            "y": -0.6729995608329773,
            "z": -170.25465393066406
        },
        {
            "x": -6.880130290985107,
            "y": -0.6799546480178833,
            "z": -170.10391235351562
        },
        {
            "x": -6.836860179901123,
            "y": -0.6868103742599487,
            "z": -169.9532012939453
        },
        {
            "x": -6.793407917022705,
            "y": -0.6935569643974304,
            "z": -169.80271911621094
        },
        {
            "x": -6.749643325805664,
            "y": -0.7002090811729431,
            "z": -169.65196228027344
        },
        {
            "x": -6.705786228179932,
            "y": -0.7067423462867737,
            "z": -169.50152587890625
        },
        {
            "x": -6.661680698394775,
            "y": -0.7131664156913757,
            "z": -169.35105895996094
        },
        {
            "x": -6.61740779876709,
            "y": -0.7194777727127075,
            "z": -169.20057678222656
        },
        {
            "x": -6.572953701019287,
            "y": -0.7256618738174438,
            "z": -169.05030822753906
        },
        {
            "x": -6.528223991394043,
            "y": -0.731738269329071,
            "z": -168.89974975585938
        },
        {
            "x": -6.483432292938232,
            "y": -0.7376782298088074,
            "z": -168.74952697753906
        },
        {
            "x": -6.438403129577637,
            "y": -0.7434940934181213,
            "z": -168.59933471679688
        },
        {
            "x": -6.393244743347168,
            "y": -0.7491743564605713,
            "z": -168.44912719726562
        },
        {
            "x": -6.347904682159424,
            "y": -0.7547194957733154,
            "z": -168.2990264892578
        },
        {
            "x": -6.302347183227539,
            "y": -0.7601363658905029,
            "z": -168.14878845214844
        },
        {
            "x": -6.256675720214844,
            "y": -0.7654094696044922,
            "z": -167.99864196777344
        },
        {
            "x": -6.210817813873291,
            "y": -0.7705328464508057,
            "z": -167.84861755371094
        },
        {
            "x": -6.16481351852417,
            "y": -0.7755138874053955,
            "z": -167.698486328125
        },
        {
            "x": -6.118687152862549,
            "y": -0.7803410291671753,
            "z": -167.54855346679688
        },
        {
            "x": -6.072401523590088,
            "y": -0.7850192785263062,
            "z": -167.39859008789062
        },
        {
            "x": -6.025941371917725,
            "y": -0.789537787437439,
            "z": -167.24855041503906
        },
        {
            "x": -5.979376792907715,
            "y": -0.7938944101333618,
            "z": -167.09864807128906
        },
        {
            "x": -5.932695388793945,
            "y": -0.7980904579162598,
            "z": -166.9487762451172
        },
        {
            "x": -5.885855197906494,
            "y": -0.8021218776702881,
            "z": -166.7989044189453
        },
        {
            "x": -5.838920593261719,
            "y": -0.8059780597686768,
            "z": -166.64907836914062
        },
        {
            "x": -5.791815280914307,
            "y": -0.8096650838851929,
            "z": -166.49917602539062
        },
        {
            "x": -5.744631290435791,
            "y": -0.8131752014160156,
            "z": -166.34942626953125
        },
        {
            "x": -5.697360515594482,
            "y": -0.8165072202682495,
            "z": -166.19970703125
        },
        {
            "x": -5.649925231933594,
            "y": -0.8196539878845215,
            "z": -166.04991149902344
        },
        {
            "x": -5.602437496185303,
            "y": -0.8226138353347778,
            "z": -165.90023803710938
        },
        {
            "x": -5.554819583892822,
            "y": -0.8253886699676514,
            "z": -165.75050354003906
        },
        {
            "x": -5.507105827331543,
            "y": -0.8279740810394287,
            "z": -165.6007537841797
        },
        {
            "x": -5.4593505859375,
            "y": -0.8303557634353638,
            "z": -165.451171875
        },
        {
            "x": -5.42744255065918,
            "y": -0.831835150718689,
            "z": -165.35142517089844
        },
        {
            "x": -5.379536151885986,
            "y": -0.8338906764984131,
            "z": -165.20181274414062
        },
        {
            "x": -5.331549167633057,
            "y": -0.8357363939285278,
            "z": -165.05226135253906
        },
        {
            "x": -5.283413410186768,
            "y": -0.8373783826828003,
            "z": -164.90248107910156
        },
        {
            "x": -5.235297203063965,
            "y": -0.8388097286224365,
            "z": -164.75294494628906
        },
        {
            "x": -5.187089920043945,
            "y": -0.8400304317474365,
            "z": -164.60337829589844
        },
        {
            "x": -5.138810157775879,
            "y": -0.8410303592681885,
            "z": -164.45375061035156
        },
        {
            "x": -5.090497970581055,
            "y": -0.841809093952179,
            "z": -164.3042449951172
        },
        {
            "x": -5.042099475860596,
            "y": -0.8423680067062378,
            "z": -164.15460205078125
        },
        {
            "x": -4.9936676025390625,
            "y": -0.8427033424377441,
            "z": -164.00503540039062
        },
        {
            "x": -4.9452056884765625,
            "y": -0.8428036570549011,
            "z": -163.8555145263672
        },
        {
            "x": -4.896686553955078,
            "y": -0.8426722288131714,
            "z": -163.70590209960938
        },
        {
            "x": -4.848167896270752,
            "y": -0.842315137386322,
            "z": -163.55642700195312
        },
        {
            "x": -4.799598217010498,
            "y": -0.8417338132858276,
            "z": -163.40689086914062
        },
        {
            "x": -4.750965595245361,
            "y": -0.840925395488739,
            "z": -163.25721740722656
        },
        {
            "x": -4.702380180358887,
            "y": -0.8398967981338501,
            "z": -163.1077117919922
        },
        {
            "x": -4.6537628173828125,
            "y": -0.838654637336731,
            "z": -162.95819091796875
        },
        {
            "x": -4.605113506317139,
            "y": -0.8372011184692383,
            "z": -162.80859375
        },
        {
            "x": -4.556502819061279,
            "y": -0.8355344533920288,
            "z": -162.6591339111328
        },
        {
            "x": -4.507809162139893,
            "y": -0.8336567878723145,
            "z": -162.50942993164062
        },
        {
            "x": -4.459188938140869,
            "y": -0.8315811157226562,
            "z": -162.3599395751953
        },
        {
            "x": -4.410567283630371,
            "y": -0.8293064832687378,
            "z": -162.2104034423828
        },
        {
            "x": -4.361964702606201,
            "y": -0.8268309235572815,
            "z": -162.06082153320312
        },
        {
            "x": -4.313399791717529,
            "y": -0.824160635471344,
            "z": -161.91134643554688
        },
        {
            "x": -4.264797687530518,
            "y": -0.8212992548942566,
            "z": -161.7616729736328
        },
        {
            "x": -4.21622896194458,
            "y": -0.8182518482208252,
            "z": -161.61199951171875
        },
        {
            "x": -4.1677165031433105,
            "y": -0.815018355846405,
            "z": -161.46238708496094
        },
        {
            "x": -4.119220733642578,
            "y": -0.8116008043289185,
            "z": -161.3126983642578
        },
        {
            "x": -4.07077693939209,
            "y": -0.8080078363418579,
            "z": -161.16307067871094
        },
        {
            "x": -4.022398948669434,
            "y": -0.804242730140686,
            "z": -161.013427734375
        },
        {
            "x": -3.973994731903076,
            "y": -0.8002983927726746,
            "z": -160.86358642578125
        },
        {
            "x": -3.925708055496216,
            "y": -0.7961865663528442,
            "z": -160.71388244628906
        },
        {
            "x": -3.877472400665283,
            "y": -0.7919114828109741,
            "z": -160.5641326904297
        },
        {
            "x": -3.8292763233184814,
            "y": -0.7874739170074463,
            "z": -160.41433715820312
        },
        {
            "x": -3.781191825866699,
            "y": -0.7828790545463562,
            "z": -160.2645721435547
        },
        {
            "x": -3.733091115951538,
            "y": -0.7781184911727905,
            "z": -160.11460876464844
        },
        {
            "x": -3.6851537227630615,
            "y": -0.7732133865356445,
            "z": -159.96478271484375
        },
        {
            "x": -3.637293577194214,
            "y": -0.7681609392166138,
            "z": -159.81497192382812
        },
        {
            "x": -3.5894815921783447,
            "y": -0.762955904006958,
            "z": -159.66497802734375
        },
        {
            "x": -3.5418174266815186,
            "y": -0.7576102018356323,
            "z": -159.5150909423828
        },
        {
            "x": -3.4941890239715576,
            "y": -0.7521211504936218,
            "z": -159.3650665283203
        },
        {
            "x": -3.446678400039673,
            "y": -0.7464964389801025,
            "z": -159.21498107910156
        },
        {
            "x": -3.3992817401885986,
            "y": -0.7407424449920654,
            "z": -159.06500244140625
        },
        {
            "x": -3.367753744125366,
            "y": -0.7368290424346924,
            "z": -158.96493530273438
        },
        {
            "x": -3.320578098297119,
            "y": -0.7308600544929504,
            "z": -158.81494140625
        },
        {
            "x": -3.2734694480895996,
            "y": -0.7247635126113892,
            "z": -158.664794921875
        },
        {
            "x": -3.2264606952667236,
            "y": -0.7185333967208862,
            "z": -158.51443481445312
        },
        {
            "x": -3.179617404937744,
            "y": -0.7121952772140503,
            "z": -158.36428833007812
        },
        {
            "x": -3.1329004764556885,
            "y": -0.7057386636734009,
            "z": -158.21397399902344
        },
        {
            "x": -3.0863215923309326,
            "y": -0.6991705894470215,
            "z": -158.0636749267578
        },
        {
            "x": -3.0398690700531006,
            "y": -0.6924896240234375,
            "z": -157.91329956054688
        },
        {
            "x": -2.9935741424560547,
            "y": -0.6857019662857056,
            "z": -157.76284790039062
        },
        {
            "x": -2.9473917484283447,
            "y": -0.6788110733032227,
            "z": -157.61231994628906
        },
        {
            "x": -2.9014065265655518,
            "y": -0.6718226075172424,
            "z": -157.46180725097656
        },
        {
            "x": -2.855567455291748,
            "y": -0.6647340059280396,
            "z": -157.31121826171875
        },
        {
            "x": -2.809882402420044,
            "y": -0.6575519442558289,
            "z": -157.1605682373047
        },
        {
            "x": -2.764411449432373,
            "y": -0.650285542011261,
            "z": -157.00999450683594
        },
        {
            "x": -2.7190074920654297,
            "y": -0.642919659614563,
            "z": -156.85910034179688
        },
        {
            "x": -2.6738758087158203,
            "y": -0.6354758143424988,
            "z": -156.7083282470703
        },
        {
            "x": -2.628896713256836,
            "y": -0.6279518604278564,
            "z": -156.55752563476562
        },
        {
            "x": -2.584089756011963,
            "y": -0.6203449368476868,
            "z": -156.4065399169922
        },
        {
            "x": -2.539524793624878,
            "y": -0.6126731634140015,
            "z": -156.25567626953125
        },
        {
            "x": -2.495051622390747,
            "y": -0.6049106121063232,
            "z": -156.10447692871094
        },
        {
            "x": -2.450888156890869,
            "y": -0.5970937609672546,
            "z": -155.95339965820312
        },
        {
            "x": -2.4068775177001953,
            "y": -0.5892101526260376,
            "z": -155.80230712890625
        },
        {
            "x": -2.363100051879883,
            "y": -0.5812621116638184,
            "z": -155.65106201171875
        },
        {
            "x": -2.319549560546875,
            "y": -0.5732598304748535,
            "z": -155.4998779296875
        },
        {
            "x": -2.276150941848755,
            "y": -0.5651884078979492,
            "z": -155.34840393066406
        },
        {
            "x": -2.2330260276794434,
            "y": -0.5570714473724365,
            "z": -155.19699096679688
        },
        {
            "x": -2.190093517303467,
            "y": -0.5489054322242737,
            "z": -155.04551696777344
        },
        {
            "x": -2.1474153995513916,
            "y": -0.540685772895813,
            "z": -154.89389038085938
        },
        {
            "x": -2.10498046875,
            "y": -0.532431423664093,
            "z": -154.74234008789062
        },
        {
            "x": -2.062781810760498,
            "y": -0.5241305828094482,
            "z": -154.5906219482422
        },
        {
            "x": -2.020796775817871,
            "y": -0.5157894492149353,
            "z": -154.4387664794922
        },
        {
            "x": -1.9790664911270142,
            "y": -0.5074141025543213,
            "z": -154.286865234375
        },
        {
            "x": -1.937639832496643,
            "y": -0.49901074171066284,
            "z": -154.13494873046875
        },
        {
            "x": -1.8964177370071411,
            "y": -0.49057838320732117,
            "z": -153.9829559326172
        },
        {
            "x": -1.85550057888031,
            "y": -0.4821203947067261,
            "z": -153.83087158203125
        },
        {
            "x": -1.8148012161254883,
            "y": -0.47363561391830444,
            "z": -153.6786346435547
        },
        {
            "x": -1.7743947505950928,
            "y": -0.4651331901550293,
            "z": -153.52633666992188
        },
        {
            "x": -1.7343205213546753,
            "y": -0.45662355422973633,
            "z": -153.37413024902344
        },
        {
            "x": -1.6944222450256348,
            "y": -0.4480898678302765,
            "z": -153.22164916992188
        },
        {
            "x": -1.6548982858657837,
            "y": -0.4395524263381958,
            "z": -153.06919860839844
        },
        {
            "x": -1.6156116724014282,
            "y": -0.4310077428817749,
            "z": -152.91665649414062
        },
        {
            "x": -1.5766081809997559,
            "y": -0.4224494397640228,
            "z": -152.7638702392578
        },
        {
            "x": -1.5379691123962402,
            "y": -0.41390860080718994,
            "z": -152.61129760742188
        },
        {
            "x": -1.5123299360275269,
            "y": -0.4082087278366089,
            "z": -152.50938415527344
        },
        {
            "x": -1.4741854667663574,
            "y": -0.39966410398483276,
            "z": -152.35653686523438
        },
        {
            "x": -1.4363409280776978,
            "y": -0.3911353349685669,
            "z": -152.2037353515625
        },
        {
            "x": -1.3987281322479248,
            "y": -0.38259434700012207,
            "z": -152.05044555664062
        },
        {
            "x": -1.3615530729293823,
            "y": -0.3740904927253723,
            "z": -151.89744567871094
        },
        {
            "x": -1.324613094329834,
            "y": -0.3655949831008911,
            "z": -151.74424743652344
        },
        {
            "x": -1.28804612159729,
            "y": -0.3571157455444336,
            "z": -151.59088134765625
        },
        {
            "x": -1.2517832517623901,
            "y": -0.3486691117286682,
            "z": -151.43763732910156
        },
        {
            "x": -1.2158455848693848,
            "y": -0.3402344286441803,
            "z": -151.2839813232422
        },
        {
            "x": -1.180280089378357,
            "y": -0.33184096217155457,
            "z": -151.13055419921875
        },
        {
            "x": -1.1450082063674927,
            "y": -0.32347291707992554,
            "z": -150.97686767578125
        },
        {
            "x": -1.1101497411727905,
            "y": -0.31514260172843933,
            "z": -150.8231201171875
        },
        {
            "x": -1.0755915641784668,
            "y": -0.3068554699420929,
            "z": -150.66937255859375
        },
        {
            "x": -1.0414323806762695,
            "y": -0.29860419034957886,
            "z": -150.51541137695312
        },
        {
            "x": -1.0075898170471191,
            "y": -0.2903978228569031,
            "z": -150.36141967773438
        },
        {
            "x": -0.9740985035896301,
            "y": -0.28223568201065063,
            "z": -150.20724487304688
        },
        {
            "x": -0.9410536885261536,
            "y": -0.2741363048553467,
            "z": -150.05319213867188
        },
        {
            "x": -0.9082816243171692,
            "y": -0.266081839799881,
            "z": -149.89891052246094
        },
        {
            "x": -0.8759656548500061,
            "y": -0.25808632373809814,
            "z": -149.7445526123047
        },
        {
            "x": -0.843954861164093,
            "y": -0.25014859437942505,
            "z": -149.59011840820312
        },
        {
            "x": -0.812358021736145,
            "y": -0.24227374792099,
            "z": -149.43551635742188
        },
        {
            "x": -0.7811999917030334,
            "y": -0.23447681963443756,
            "z": -149.2810821533203
        },
        {
            "x": -0.7503415942192078,
            "y": -0.2267376184463501,
            "z": -149.12635803222656
        },
        {
            "x": -0.7199693918228149,
            "y": -0.21907614171504974,
            "z": -148.9716339111328
        },
        {
            "x": -0.6899166107177734,
            "y": -0.21148927509784698,
            "z": -148.81678771972656
        },
        {
            "x": -0.6602831482887268,
            "y": -0.20397153496742249,
            "z": -148.6616668701172
        },
        {
            "x": -0.6311047077178955,
            "y": -0.1965520977973938,
            "z": -148.50680541992188
        },
        {
            "x": -0.6022331714630127,
            "y": -0.18919920921325684,
            "z": -148.35153198242188
        },
        {
            "x": -0.5739033222198486,
            "y": -0.18194878101348877,
            "z": -148.1964111328125
        },
        {
            "x": -0.5458984375,
            "y": -0.17478828132152557,
            "z": -148.04119873046875
        },
        {
            "x": -0.5183255672454834,
            "y": -0.1677071750164032,
            "z": -147.88558959960938
        },
        {
            "x": -0.4911992847919464,
            "y": -0.1607404500246048,
            "z": -147.7303009033203
        },
        {
            "x": -0.46444201469421387,
            "y": -0.15386076271533966,
            "z": -147.57461547851562
        },
        {
            "x": -0.4382147789001465,
            "y": -0.14709612727165222,
            "z": -147.41909790039062
        },
        {
            "x": -0.4123196303844452,
            "y": -0.14043325185775757,
            "z": -147.26341247558594
        },
        {
            "x": -0.38690370321273804,
            "y": -0.13386793434619904,
            "z": -147.10739135742188
        },
        {
            "x": -0.361941397190094,
            "y": -0.12743505835533142,
            "z": -146.95172119140625
        },
        {
            "x": -0.33739012479782104,
            "y": -0.12110619246959686,
            "z": -146.79566955566406
        },
        {
            "x": -0.3133377432823181,
            "y": -0.11490058153867722,
            "z": -146.6396942138672
        },
        {
            "x": -0.2896447777748108,
            "y": -0.10881271958351135,
            "z": -146.4835968017578
        },
        {
            "x": -0.2664916515350342,
            "y": -0.10284827649593353,
            "z": -146.3273162841797
        },
        {
            "x": -0.24374106526374817,
            "y": -0.09701931476593018,
            "z": -146.17111206054688
        },
        {
            "x": -0.22145351767539978,
            "y": -0.09131360054016113,
            "z": -146.01470947265625
        },
        {
            "x": -0.2069028913974762,
            "y": -0.08758869767189026,
            "z": -145.91055297851562
        },
        {
            "x": -0.18536952137947083,
            "y": -0.08211737871170044,
            "z": -145.75425720214844
        },
        {
            "x": -0.1643344759941101,
            "y": -0.07677558064460754,
            "z": -145.59759521484375
        },
        {
            "x": -0.1437567174434662,
            "y": -0.07157847285270691,
            "z": -145.4410400390625
        },
        {
            "x": -0.12360423058271408,
            "y": -0.0665246844291687,
            "z": -145.28431701660156
        },
        {
            "x": -0.10404005646705627,
            "y": -0.061626583337783813,
            "z": -145.12765502929688
        },
        {
            "x": -0.08483719080686569,
            "y": -0.05687516927719116,
            "z": -144.97085571289062
        },
        {
            "x": -0.06617402285337448,
            "y": -0.05227403715252876,
            "z": -144.8139190673828
        },
        {
            "x": -0.047991663217544556,
            "y": -0.04783737659454346,
            "z": -144.65711975097656
        },
        {
            "x": -0.030231043696403503,
            "y": -0.04355478286743164,
            "z": -144.49993896484375
        },
        {
            "x": -0.013066843152046204,
            "y": -0.039442066103219986,
            "z": -144.34298706054688
        },
        {
            "x": 0.00373251736164093,
            "y": -0.03549020737409592,
            "z": -144.18585205078125
        },
        {
            "x": 0.019965410232543945,
            "y": -0.03170647472143173,
            "z": -144.02859497070312
        },
        {
            "x": 0.03568887710571289,
            "y": -0.02810664288699627,
            "z": -143.87158203125
        },
        {
            "x": 0.05101151764392853,
            "y": -0.02466893196105957,
            "z": -143.71405029296875
        },
        {
            "x": 0.06572091579437256,
            "y": -0.021415166556835175,
            "z": -143.5567626953125
        },
        {
            "x": 0.08003745973110199,
            "y": -0.018343130126595497,
            "z": -143.39947509765625
        },
        {
            "x": 0.09378571808338165,
            "y": -0.015455246903002262,
            "z": -143.2418670654297
        },
        {
            "x": 0.10702189803123474,
            "y": -0.012759240344166756,
            "z": -143.08457946777344
        },
        {
            "x": 0.11984950304031372,
            "y": -0.010243291035294533,
            "z": -142.92677307128906
        },
        {
            "x": 0.13203898072242737,
            "y": -0.00792632345110178,
            "z": -142.76925659179688
        },
        {
            "x": 0.14381511509418488,
            "y": -0.005811271257698536,
            "z": -142.61178588867188
        },
        {
            "x": 0.1550372689962387,
            "y": -0.0038899974897503853,
            "z": -142.45401000976562
        },
        {
            "x": 0.16572996973991394,
            "y": -0.002172299660742283,
            "z": -142.29653930664062
        },
        {
            "x": 0.17600934207439423,
            "y": -0.0006551297847181559,
            "z": -142.1386260986328
        },
        {
            "x": 0.18564200401306152,
            "y": 0.0006471623200923204,
            "z": -141.98080444335938
        },
        {
            "x": 0.19485053420066833,
            "y": 0.0017390227876603603,
            "z": -141.82315063476562
        },
        {
            "x": 0.20352759957313538,
            "y": 0.0026222707238048315,
            "z": -141.6650848388672
        },
        {
            "x": 0.21163062751293182,
            "y": 0.00328737311065197,
            "z": -141.50741577148438
        },
        {
            "x": 0.21930958330631256,
            "y": 0.003727187402546406,
            "z": -141.34954833984375
        },
        {
            "x": 0.22636988759040833,
            "y": 0.003941585775464773,
            "z": -141.1913604736328
        },
        {
            "x": 0.23297414183616638,
            "y": 0.003954507410526276,
            "z": -141.03363037109375
        },
        {
            "x": 0.2390676885843277,
            "y": 0.003947876393795013,
            "z": -140.87547302246094
        },
        {
            "x": 0.24453623592853546,
            "y": 0.00394124910235405,
            "z": -140.71759033203125
        },
        {
            "x": 0.24960485100746155,
            "y": 0.003934606909751892,
            "z": -140.55966186523438
        },
        {
            "x": 0.25406432151794434,
            "y": 0.003927998244762421,
            "z": -140.4013671875
        },
        {
            "x": 0.25802701711654663,
            "y": 0.003921382129192352,
            "z": -140.2436065673828
        },
        {
            "x": 0.2615008056163788,
            "y": 0.003914721310138702,
            "z": -140.08543395996094
        },
        {
            "x": 0.26436084508895874,
            "y": 0.003908105194568634,
            "z": -139.92738342285156
        },
        {
            "x": 0.2668159604072571,
            "y": 0.0039014816284179688,
            "z": -139.76953125
        },
        {
            "x": 0.26872408390045166,
            "y": 0.0038948357105255127,
            "z": -139.61129760742188
        },
        {
            "x": 0.27014732360839844,
            "y": 0.0038882382214069366,
            "z": -139.45343017578125
        },
        {
            "x": 0.2712002992630005,
            "y": 0.003881610929965973,
            "z": -139.2955322265625
        },
        {
            "x": 0.2716548442840576,
            "y": 0.003877192735671997,
            "z": -139.1903076171875
        },
        {
            "x": 0.2721145749092102,
            "y": 0.0038705654442310333,
            "z": -139.03280639648438
        },
        {
            "x": 0.27234965562820435,
            "y": 0.0038639381527900696,
            "z": -138.87515258789062
        },
        {
            "x": 0.27237051725387573,
            "y": 0.003857303410768509,
            "z": -138.71754455566406
        },
        {
            "x": 0.27233371138572693,
            "y": 0.003850683569908142,
            "z": -138.56024169921875
        },
        {
            "x": 0.272207647562027,
            "y": 0.003844045102596283,
            "z": -138.4028778076172
        },
        {
            "x": 0.27204394340515137,
            "y": 0.003837417811155319,
            "z": -138.24551391601562
        },
        {
            "x": 0.27187293767929077,
            "y": 0.0038307830691337585,
            "z": -138.08827209472656
        },
        {
            "x": 0.2716847062110901,
            "y": 0.0038241595029830933,
            "z": -137.93092346191406
        },
        {
            "x": 0.2714937627315521,
            "y": 0.003817528486251831,
            "z": -137.77359008789062
        },
        {
            "x": 0.2713000774383545,
            "y": 0.0038109086453914642,
            "z": -137.61636352539062
        },
        {
            "x": 0.27110302448272705,
            "y": 0.003804277628660202,
            "z": -137.45899963378906
        },
        {
            "x": 0.2709048092365265,
            "y": 0.003797657787799835,
            "z": -137.30177307128906
        },
        {
            "x": 0.2707041800022125,
            "y": 0.0037910230457782745,
            "z": -137.14453125
        },
        {
            "x": 0.2705015540122986,
            "y": 0.003784395754337311,
            "z": -136.98709106445312
        },
        {
            "x": 0.27029740810394287,
            "y": 0.003777775913476944,
            "z": -136.82986450195312
        },
        {
            "x": 0.2700909376144409,
            "y": 0.003771137446165085,
            "z": -136.67257690429688
        },
        {
            "x": 0.2698829174041748,
            "y": 0.0037645287811756134,
            "z": -136.51528930664062
        },
        {
            "x": 0.26967284083366394,
            "y": 0.0037578940391540527,
            "z": -136.35806274414062
        },
        {
            "x": 0.2694604992866516,
            "y": 0.0037512704730033875,
            "z": -136.20062255859375
        },
        {
            "x": 0.2692468762397766,
            "y": 0.003744646906852722,
            "z": -136.04336547851562
        },
        {
            "x": 0.2690308094024658,
            "y": 0.0037380345165729523,
            "z": -135.8861541748047
        },
        {
            "x": 0.26881325244903564,
            "y": 0.0037313923239707947,
            "z": -135.72889709472656
        },
        {
            "x": 0.26859360933303833,
            "y": 0.0037247687578201294,
            "z": -135.57167053222656
        },
        {
            "x": 0.2683717906475067,
            "y": 0.003718145191669464,
            "z": -135.41432189941406
        },
        {
            "x": 0.2681483030319214,
            "y": 0.003711514174938202,
            "z": -135.2570037841797
        },
        {
            "x": 0.26792261004447937,
            "y": 0.0037048794329166412,
            "z": -135.09976196289062
        },
        {
            "x": 0.26769518852233887,
            "y": 0.003698255866765976,
            "z": -134.9424285888672
        },
        {
            "x": 0.26746582984924316,
            "y": 0.003691628575325012,
            "z": -134.7852020263672
        },
        {
            "x": 0.2672344148159027,
            "y": 0.003685012459754944,
            "z": -134.62796020507812
        },
        {
            "x": 0.2670010030269623,
            "y": 0.003678377717733383,
            "z": -134.4705352783203
        },
        {
            "x": 0.2667655944824219,
            "y": 0.003671746701002121,
            "z": -134.3132781982422
        },
        {
            "x": 0.26652854681015015,
            "y": 0.0036651454865932465,
            "z": -134.15599060058594
        },
        {
            "x": 0.2662891149520874,
            "y": 0.0036585181951522827,
            "z": -133.9987030029297
        },
        {
            "x": 0.26604801416397095,
            "y": 0.003651890903711319,
            "z": -133.8414764404297
        },
        {
            "x": 0.2658047676086426,
            "y": 0.003645244985818863,
            "z": -133.6840362548828
        },
        {
            "x": 0.26555949449539185,
            "y": 0.0036386363208293915,
            "z": -133.5268096923828
        },
        {
            "x": 0.26531264185905457,
            "y": 0.0036320053040981293,
            "z": -133.3695831298828
        },
        {
            "x": 0.2650633156299591,
            "y": 0.003625374287366867,
            "z": -133.2122344970703
        },
        {
            "x": 0.2648124098777771,
            "y": 0.0036187246441841125,
            "z": -133.0550079345703
        },
        {
            "x": 0.264559268951416,
            "y": 0.0036121048033237457,
            "z": -132.8976593017578
        },
        {
            "x": 0.264303982257843,
            "y": 0.0036121499724686146,
            "z": -132.74034118652344
        },
        {
            "x": 0.26404714584350586,
            "y": 0.003847112413495779,
            "z": -132.58311462402344
        },
        {
            "x": 0.2638726234436035,
            "y": 0.004215029068291187,
            "z": -132.47828674316406
        },
        {
            "x": 0.26361244916915894,
            "y": 0.005099243484437466,
            "z": -132.32106018066406
        },
        {
            "x": 0.2633500397205353,
            "y": 0.006366912741214037,
            "z": -132.16384887695312
        },
        {
            "x": 0.26308533549308777,
            "y": 0.008003601804375648,
            "z": -132.0064239501953
        },
        {
            "x": 0.26281917095184326,
            "y": 0.00999649241566658,
            "z": -131.8491973876953
        },
        {
            "x": 0.2625507116317749,
            "y": 0.012347180396318436,
            "z": -131.69198608398438
        },
        {
            "x": 0.2622804641723633,
            "y": 0.015048247762024403,
            "z": -131.53468322753906
        },
        {
            "x": 0.2620078921318054,
            "y": 0.018079234287142754,
            "z": -131.3774871826172
        },
        {
            "x": 0.2617335617542267,
            "y": 0.02143530175089836,
            "z": -131.22019958496094
        },
        {
            "x": 0.2614569365978241,
            "y": 0.02511359378695488,
            "z": -131.06289672851562
        },
        {
            "x": 0.26117846369743347,
            "y": 0.029102686792612076,
            "z": -130.90573120117188
        },
        {
            "x": 0.26089802384376526,
            "y": 0.03339134901762009,
            "z": -130.74844360351562
        },
        {
            "x": 0.26061537861824036,
            "y": 0.03796491399407387,
            "z": -130.59130859375
        },
        {
            "x": 0.26033109426498413,
            "y": 0.04282376170158386,
            "z": -130.4341278076172
        },
        {
            "x": 0.2600440979003906,
            "y": 0.04796764999628067,
            "z": -130.2767791748047
        },
        {
            "x": 0.2597557008266449,
            "y": 0.053365714848041534,
            "z": -130.11965942382812
        },
        {
            "x": 0.25946491956710815,
            "y": 0.05901927500963211,
            "z": -129.96246337890625
        },
        {
            "x": 0.25917232036590576,
            "y": 0.06492172926664352,
            "z": -129.8052978515625
        },
        {
            "x": 0.25887757539749146,
            "y": 0.07106442749500275,
            "z": -129.648193359375
        },
        {
            "x": 0.2585805654525757,
            "y": 0.07744188606739044,
            "z": -129.49090576171875
        },
        {
            "x": 0.2582818865776062,
            "y": 0.08402985334396362,
            "z": -129.33380126953125
        },
        {
            "x": 0.2579810321331024,
            "y": 0.0908300057053566,
            "z": -129.1767120361328
        },
        {
            "x": 0.257678359746933,
            "y": 0.09783762693405151,
            "z": -129.01963806152344
        },
        {
            "x": 0.25737327337265015,
            "y": 0.1050366461277008,
            "z": -128.86257934570312
        },
        {
            "x": 0.2570663392543793,
            "y": 0.11242353916168213,
            "z": -128.70541381835938
        },
        {
            "x": 0.2567570209503174,
            "y": 0.11998754739761353,
            "z": -128.54824829101562
        },
        {
            "x": 0.2564460337162018,
            "y": 0.12771853804588318,
            "z": -128.39122009277344
        },
        {
            "x": 0.25613266229629517,
            "y": 0.13561102747917175,
            "z": -128.2340850830078
        },
        {
            "x": 0.25581759214401245,
            "y": 0.14364728331565857,
            "z": -128.07705688476562
        },
        {
            "x": 0.2555001676082611,
            "y": 0.15182365477085114,
            "z": -127.92005920410156
        },
        {
            "x": 0.2551805377006531,
            "y": 0.16014698147773743,
            "z": -127.76285552978516
        },
        {
            "x": 0.2548590302467346,
            "y": 0.16858288645744324,
            "z": -127.60585021972656
        },
        {
            "x": 0.2545355558395386,
            "y": 0.17713555693626404,
            "z": -127.44877624511719
        },
        {
            "x": 0.25420987606048584,
            "y": 0.1857929825782776,
            "z": -127.2917251586914
        },
        {
            "x": 0.25388216972351074,
            "y": 0.1945475935935974,
            "z": -127.13475036621094
        },
        {
            "x": 0.2535521388053894,
            "y": 0.203401118516922,
            "z": -126.97756958007812
        },
        {
            "x": 0.2532202899456024,
            "y": 0.21232227981090546,
            "z": -126.82060241699219
        },
        {
            "x": 0.25288647413253784,
            "y": 0.22131454944610596,
            "z": -126.66362762451172
        },
        {
            "x": 0.2525501847267151,
            "y": 0.23037758469581604,
            "z": -126.50653076171875
        },
        {
            "x": 0.2522121071815491,
            "y": 0.23948727548122406,
            "z": -126.34956359863281
        },
        {
            "x": 0.2518717050552368,
            "y": 0.24864709377288818,
            "z": -126.1924819946289
        },
        {
            "x": 0.251529335975647,
            "y": 0.25784245133399963,
            "z": -126.03543090820312
        },
        {
            "x": 0.25118476152420044,
            "y": 0.2670600414276123,
            "z": -125.87847137451172
        },
        {
            "x": 0.25095421075820923,
            "y": 0.2732159495353699,
            "z": -125.7738265991211
        },
        {
            "x": 0.2506062388420105,
            "y": 0.2824593782424927,
            "z": -125.61686706542969
        },
        {
            "x": 0.25025635957717896,
            "y": 0.29170751571655273,
            "z": -125.45989227294922
        },
        {
            "x": 0.24990364909172058,
            "y": 0.30096206068992615,
            "z": -125.30274200439453
        },
        {
            "x": 0.24954964220523834,
            "y": 0.31019121408462524,
            "z": -125.14578247070312
        },
        {
            "x": 0.24919313192367554,
            "y": 0.3193992078304291,
            "z": -124.98881530761719
        },
        {
            "x": 0.24883468449115753,
            "y": 0.3285817503929138,
            "z": -124.83174896240234
        },
        {
            "x": 0.24847397208213806,
            "y": 0.3377172350883484,
            "z": -124.6747817993164
        },
        {
            "x": 0.24811120331287384,
            "y": 0.3468121886253357,
            "z": -124.51770782470703
        },
        {
            "x": 0.24774610996246338,
            "y": 0.3558492660522461,
            "z": -124.36064910888672
        },
        {
            "x": 0.24737931787967682,
            "y": 0.3648149073123932,
            "z": -124.20365905761719
        },
        {
            "x": 0.24700996279716492,
            "y": 0.3737104833126068,
            "z": -124.04656219482422
        },
        {
            "x": 0.24663887917995453,
            "y": 0.38251784443855286,
            "z": -123.88957214355469
        },
        {
            "x": 0.2462654411792755,
            "y": 0.3912338614463806,
            "z": -123.7325668334961
        },
        {
            "x": 0.24588976800441742,
            "y": 0.39985916018486023,
            "z": -123.57536315917969
        },
        {
            "x": 0.24551214277744293,
            "y": 0.4083618223667145,
            "z": -123.4183578491211
        },
        {
            "x": 0.2451324164867401,
            "y": 0.4167497754096985,
            "z": -123.26129150390625
        },
        {
            "x": 0.24475058913230896,
            "y": 0.4250117838382721,
            "z": -123.10423278808594
        },
        {
            "x": 0.24436655640602112,
            "y": 0.43313494324684143,
            "z": -122.94720458984375
        },
        {
            "x": 0.24398018419742584,
            "y": 0.4411197900772095,
            "z": -122.78997802734375
        },
        {
            "x": 0.24359187483787537,
            "y": 0.44894272089004517,
            "z": -122.6329345703125
        },
        {
            "x": 0.24320170283317566,
            "y": 0.4566052556037903,
            "z": -122.47588348388672
        },
        {
            "x": 0.2428092062473297,
            "y": 0.46409666538238525,
            "z": -122.31881713867188
        },
        {
            "x": 0.24241477251052856,
            "y": 0.4714028835296631,
            "z": -122.16177368164062
        },
        {
            "x": 0.24201776087284088,
            "y": 0.47852760553359985,
            "z": -122.00459289550781
        },
        {
            "x": 0.2416187971830368,
            "y": 0.4854561686515808,
            "z": -121.84739685058594
        },
        {
            "x": 0.2412179559469223,
            "y": 0.4921751320362091,
            "z": -121.69031524658203
        },
        {
            "x": 0.24081459641456604,
            "y": 0.498677134513855,
            "z": -121.53309631347656
        },
        {
            "x": 0.2404095083475113,
            "y": 0.5049524307250977,
            "z": -121.37599182128906
        },
        {
            "x": 0.24000214040279388,
            "y": 0.5109975337982178,
            "z": -121.21886444091797
        },
        {
            "x": 0.23959243297576904,
            "y": 0.5168107748031616,
            "z": -121.0615234375
        },
        {
            "x": 0.23918083310127258,
            "y": 0.5223568677902222,
            "z": -120.9043960571289
        },
        {
            "x": 0.2387671321630478,
            "y": 0.5276485681533813,
            "z": -120.7471923828125
        },
        {
            "x": 0.23835138976573944,
            "y": 0.5326747298240662,
            "z": -120.58997344970703
        },
        {
            "x": 0.23793356120586395,
            "y": 0.5374249815940857,
            "z": -120.43281555175781
        },
        {
            "x": 0.2375132441520691,
            "y": 0.5418843626976013,
            "z": -120.27542877197266
        },
        {
            "x": 0.23709116876125336,
            "y": 0.5460464358329773,
            "z": -120.11824798583984
        },
        {
            "x": 0.236667200922966,
            "y": 0.5499081015586853,
            "z": -119.9610595703125
        },
        {
            "x": 0.23624084889888763,
            "y": 0.5534635782241821,
            "z": -119.8037338256836
        },
        {
            "x": 0.23581261932849884,
            "y": 0.5566835403442383,
            "z": -119.64653015136719
        },
        {
            "x": 0.23538227379322052,
            "y": 0.5595778822898865,
            "z": -119.48922729492188
        },
        {
            "x": 0.23494970798492432,
            "y": 0.5621367692947388,
            "z": -119.33190155029297
        },
        {
            "x": 0.2345154732465744,
            "y": 0.5643500089645386,
            "z": -119.17467498779297
        },
        {
            "x": 0.23422472178936005,
            "y": 0.5656152963638306,
            "z": -119.06986236572266
        },
        {
            "x": 0.23378510773181915,
            "y": 0.5672239065170288,
            "z": -118.91262817382812
        },
        {
            "x": 0.23334552347660065,
            "y": 0.5684657096862793,
            "z": -118.75540161132812
        },
        {
            "x": 0.23290319740772247,
            "y": 0.5693155527114868,
            "z": -118.59795379638672
        },
        {
            "x": 0.23245961964130402,
            "y": 0.569777250289917,
            "z": -118.44071197509766
        },
        {
            "x": 0.23201413452625275,
            "y": 0.56984543800354,
            "z": -118.28346252441406
        },
        {
            "x": 0.23156623542308807,
            "y": 0.5695176124572754,
            "z": -118.1260986328125
        },
        {
            "x": 0.23111677169799805,
            "y": 0.5687856078147888,
            "z": -117.9688720703125
        },
        {
            "x": 0.2306651622056961,
            "y": 0.5676709413528442,
            "z": -117.81153869628906
        },
        {
            "x": 0.2302115261554718,
            "y": 0.5661852359771729,
            "z": -117.65420532226562
        },
        {
            "x": 0.2297563999891281,
            "y": 0.5643385648727417,
            "z": -117.49697875976562
        },
        {
            "x": 0.22929909825325012,
            "y": 0.5621230006217957,
            "z": -117.33964538574219
        },
        {
            "x": 0.22884024679660797,
            "y": 0.5595616698265076,
            "z": -117.18241882324219
        },
        {
            "x": 0.22837959229946136,
            "y": 0.5566647052764893,
            "z": -117.02519989013672
        },
        {
            "x": 0.22791670262813568,
            "y": 0.5534365773200989,
            "z": -116.86780548095703
        },
        {
            "x": 0.22745239734649658,
            "y": 0.5498825311660767,
            "z": -116.71060180664062
        },
        {
            "x": 0.22698628902435303,
            "y": 0.5460141897201538,
            "z": -116.55335235595703
        },
        {
            "x": 0.22651857137680054,
            "y": 0.5418452024459839,
            "z": -116.39611053466797
        },
        {
            "x": 0.2260492891073227,
            "y": 0.5373861789703369,
            "z": -116.23894500732422
        },
        {
            "x": 0.22557774186134338,
            "y": 0.5326275825500488,
            "z": -116.08158111572266
        },
        {
            "x": 0.2251051664352417,
            "y": 0.5275970697402954,
            "z": -115.9244155883789
        },
        {
            "x": 0.22463110089302063,
            "y": 0.5223011374473572,
            "z": -115.76728057861328
        },
        {
            "x": 0.2241554707288742,
            "y": 0.516748309135437,
            "z": -115.6101303100586
        },
        {
            "x": 0.22367827594280243,
            "y": 0.510939359664917,
            "z": -115.4530029296875
        },
        {
            "x": 0.22319942712783813,
            "y": 0.5048837065696716,
            "z": -115.2957763671875
        },
        {
            "x": 0.222719207406044,
            "y": 0.4985972046852112,
            "z": -115.1385726928711
        },
        {
            "x": 0.22223785519599915,
            "y": 0.49209272861480713,
            "z": -114.98146057128906
        },
        {
            "x": 0.2217549830675125,
            "y": 0.48536473512649536,
            "z": -114.82426452636719
        },
        {
            "x": 0.2212711125612259,
            "y": 0.4784321188926697,
            "z": -114.66718292236328
        },
        {
            "x": 0.22078609466552734,
            "y": 0.47130417823791504,
            "z": -114.5101089477539
        },
        {
            "x": 0.2202993780374527,
            "y": 0.46398040652275085,
            "z": -114.35285949707031
        },
        {
            "x": 0.21981221437454224,
            "y": 0.45648249983787537,
            "z": -114.19578552246094
        },
        {
            "x": 0.21932390332221985,
            "y": 0.4488086700439453,
            "z": -114.03868103027344
        },
        {
            "x": 0.21883469820022583,
            "y": 0.4409741461277008,
            "z": -113.881591796875
        },
        {
            "x": 0.21834483742713928,
            "y": 0.4329899847507477,
            "z": -113.72457122802734
        },
        {
            "x": 0.21785378456115723,
            "y": 0.42484867572784424,
            "z": -113.56732940673828
        },
        {
            "x": 0.21736259758472443,
            "y": 0.4165802001953125,
            "z": -113.41033172607422
        },
        {
            "x": 0.216870978474617,
            "y": 0.40818488597869873,
            "z": -113.2533187866211
        },
        {
            "x": 0.21637867391109467,
            "y": 0.39966583251953125,
            "z": -113.09619140625
        },
        {
            "x": 0.21588638424873352,
            "y": 0.39104345440864563,
            "z": -112.93920135498047
        },
        {
            "x": 0.21539366245269775,
            "y": 0.38231104612350464,
            "z": -112.78211212158203
        },
        {
            "x": 0.21490095555782318,
            "y": 0.3734872341156006,
            "z": -112.62501525878906
        },
        {
            "x": 0.2144087255001068,
            "y": 0.3645874857902527,
            "z": -112.46805572509766
        },
        {
            "x": 0.214080810546875,
            "y": 0.35861021280288696,
            "z": -112.36339569091797
        },
        {
            "x": 0.21358931064605713,
            "y": 0.34958916902542114,
            "z": -112.20642852783203
        },
        {
            "x": 0.21309839189052582,
            "y": 0.34050774574279785,
            "z": -112.0494613647461
        },
        {
            "x": 0.21260789036750793,
            "y": 0.33136293292045593,
            "z": -111.89227294921875
        },
        {
            "x": 0.21211910247802734,
            "y": 0.3221870958805084,
            "z": -111.7353286743164
        },
        {
            "x": 0.2116316854953766,
            "y": 0.312977135181427,
            "z": -111.578369140625
        },
        {
            "x": 0.2111455798149109,
            "y": 0.30373501777648926,
            "z": -111.42129516601562
        },
        {
            "x": 0.21066181361675262,
            "y": 0.294483482837677,
            "z": -111.26435089111328
        },
        {
            "x": 0.2101801335811615,
            "y": 0.28521794080734253,
            "z": -111.10730743408203
        },
        {
            "x": 0.20970113575458527,
            "y": 0.2759525775909424,
            "z": -110.95024108886719
        },
        {
            "x": 0.20922553539276123,
            "y": 0.2667035460472107,
            "z": -110.79329681396484
        },
        {
            "x": 0.20875324308872223,
            "y": 0.2574656307697296,
            "z": -110.63623046875
        },
        {
            "x": 0.2082856148481369,
            "y": 0.24826321005821228,
            "z": -110.47930908203125
        },
        {
            "x": 0.20782268047332764,
            "y": 0.23909558355808258,
            "z": -110.32234954833984
        },
        {
            "x": 0.20736466348171234,
            "y": 0.22996048629283905,
            "z": -110.16519165039062
        },
        {
            "x": 0.2069132924079895,
            "y": 0.22088968753814697,
            "z": -110.00822448730469
        },
        {
            "x": 0.20646913349628448,
            "y": 0.21187953650951385,
            "z": -109.85121154785156
        },
        {
            "x": 0.20603317022323608,
            "y": 0.2029402256011963,
            "z": -109.6941909790039
        },
        {
            "x": 0.20560654997825623,
            "y": 0.19408363103866577,
            "z": -109.5372314453125
        },
        {
            "x": 0.2051900327205658,
            "y": 0.18530164659023285,
            "z": -109.38005065917969
        },
        {
            "x": 0.20478668808937073,
            "y": 0.17663180828094482,
            "z": -109.22308349609375
        },
        {
            "x": 0.20439758896827698,
            "y": 0.16806825995445251,
            "z": -109.06611633300781
        },
        {
            "x": 0.20402485132217407,
            "y": 0.15961714088916779,
            "z": -108.90912628173828
        },
        {
            "x": 0.2036711871623993,
            "y": 0.15128865838050842,
            "z": -108.75213623046875
        },
        {
            "x": 0.20334060490131378,
            "y": 0.14309003949165344,
            "z": -108.5950698852539
        },
        {
            "x": 0.20303727686405182,
            "y": 0.1350337564945221,
            "z": -108.43798065185547
        },
        {
            "x": 0.2027663290500641,
            "y": 0.12713098526000977,
            "z": -108.28099822998047
        },
        {
            "x": 0.20252127945423126,
            "y": 0.11937589198350906,
            "z": -108.12381744384766
        },
        {
            "x": 0.20206134021282196,
            "y": 0.11176343262195587,
            "z": -107.96607208251953
        },
        {
            "x": 0.20065562427043915,
            "y": 0.10429258644580841,
            "z": -107.8075180053711
        },
        {
            "x": 0.19803428649902344,
            "y": 0.09699520468711853,
            "z": -107.64873504638672
        },
        {
            "x": 0.19424667954444885,
            "y": 0.08990529924631119,
            "z": -107.490234375
        },
        {
            "x": 0.1893390715122223,
            "y": 0.08302439004182816,
            "z": -107.33179473876953
        },
        {
            "x": 0.183380126953125,
            "y": 0.07636521756649017,
            "z": -107.17346954345703
        },
        {
            "x": 0.17646414041519165,
            "y": 0.06993253529071808,
            "z": -107.01531219482422
        },
        {
            "x": 0.1686408817768097,
            "y": 0.06372443586587906,
            "z": -106.85709381103516
        },
        {
            "x": 0.1599861979484558,
            "y": 0.05776933208107948,
            "z": -106.69918060302734
        },
        {
            "x": 0.15055496990680695,
            "y": 0.05207135155797005,
            "z": -106.54138946533203
        },
        {
            "x": 0.14041855931282043,
            "y": 0.04662676528096199,
            "z": -106.38361358642578
        },
        {
            "x": 0.1296483278274536,
            "y": 0.041450969874858856,
            "z": -106.22604370117188
        },
        {
            "x": 0.11829189956188202,
            "y": 0.03655022382736206,
            "z": -106.06847381591797
        },
        {
            "x": 0.10639188438653946,
            "y": 0.031941089779138565,
            "z": -105.91102600097656
        },
        {
            "x": 0.09403341263532639,
            "y": 0.02762487903237343,
            "z": -105.75376892089844
        },
        {
            "x": 0.08556947112083435,
            "y": 0.024908561259508133,
            "z": -105.64897155761719
        },
        {
            "x": 0.0725315734744072,
            "y": 0.021103395149111748,
            "z": -105.49186706542969
        },
        {
            "x": 0.05916501581668854,
            "y": 0.01761047914624214,
            "z": -105.3348388671875
        },
        {
            "x": 0.04548512399196625,
            "y": 0.014433261007070541,
            "z": -105.17766571044922
        },
        {
            "x": 0.03157360106706619,
            "y": 0.011592534370720387,
            "z": -105.0207748413086
        },
        {
            "x": 0.01744261384010315,
            "y": 0.009101223200559616,
            "z": -104.86396026611328
        },
        {
            "x": 0.0031278282403945923,
            "y": 0.006953638046979904,
            "z": -104.70708465576172
        },
        {
            "x": -0.011317543685436249,
            "y": 0.0051610274240374565,
            "z": -104.55036163330078
        },
        {
            "x": -0.025878101587295532,
            "y": 0.0037326840683817863,
            "z": -104.39360809326172
        },
        {
            "x": -0.04052116721868515,
            "y": 0.0026899944059550762,
            "z": -104.23687744140625
        },
        {
            "x": -0.055202417075634,
            "y": 0.002026994712650776,
            "z": -104.08027648925781
        },
        {
            "x": -0.06992058455944061,
            "y": 0.0017512415070086718,
            "z": -103.92359924316406
        },
        {
            "x": -0.0846274271607399,
            "y": 0.00173293799161911,
            "z": -103.76707458496094
        },
        {
            "x": -0.09931036829948425,
            "y": 0.0017268992960453033,
            "z": -103.61056518554688
        },
        {
            "x": -0.11396758258342743,
            "y": 0.0017208382487297058,
            "z": -103.45388793945312
        },
        {
            "x": -0.12854337692260742,
            "y": 0.001714814454317093,
            "z": -103.29741668701172
        },
        {
            "x": -0.14304564893245697,
            "y": 0.0017087720334529877,
            "z": -103.14090728759766
        },
        {
            "x": -0.1574479639530182,
            "y": 0.001702733337879181,
            "z": -102.98442077636719
        },
        {
            "x": -0.17173664271831512,
            "y": 0.0016966909170150757,
            "z": -102.82798767089844
        },
        {
            "x": -0.18591773509979248,
            "y": 0.001690637320280075,
            "z": -102.6713638305664
        },
        {
            "x": -0.1999426633119583,
            "y": 0.0016845948994159698,
            "z": -102.51493835449219
        },
        {
            "x": -0.21381443738937378,
            "y": 0.0016785673797130585,
            "z": -102.35850524902344
        },
        {
            "x": -0.22752848267555237,
            "y": 0.0016725026071071625,
            "z": -102.20207977294922
        },
        {
            "x": -0.24107626080513,
            "y": 0.0016664788126945496,
            "z": -102.045654296875
        },
        {
            "x": -0.25445646047592163,
            "y": 0.001660417765378952,
            "z": -101.88912200927734
        },
        {
            "x": -0.2676459550857544,
            "y": 0.0016543939709663391,
            "z": -101.73258209228516
        },
        {
            "x": -0.2806348204612732,
            "y": 0.0016483515501022339,
            "z": -101.57612609863281
        },
        {
            "x": -0.29343628883361816,
            "y": 0.0016423091292381287,
            "z": -101.41957092285156
        },
        {
            "x": -0.30602896213531494,
            "y": 0.001636255532503128,
            "z": -101.26309967041016
        },
        {
            "x": -0.3184010982513428,
            "y": 0.0016302168369293213,
            "z": -101.10662841796875
        },
        {
            "x": -0.3305765688419342,
            "y": 0.001624174416065216,
            "z": -100.94994354248047
        },
        {
            "x": -0.3425199091434479,
            "y": 0.001618124544620514,
            "z": -100.7934341430664
        },
        {
            "x": -0.3542492091655731,
            "y": 0.0016120672225952148,
            "z": -100.6368637084961
        },
        {
            "x": -0.36574360728263855,
            "y": 0.0016060471534729004,
            "z": -100.48028564453125
        },
        {
            "x": -0.37700891494750977,
            "y": 0.0016000159084796906,
            "z": -100.32373809814453
        },
        {
            "x": -0.38806140422821045,
            "y": 0.001593947410583496,
            "z": -100.16697692871094
        },
        {
            "x": -0.39887064695358276,
            "y": 0.0015879161655902863,
            "z": -100.01042175292969
        },
        {
            "x": -0.40943706035614014,
            "y": 0.0015818700194358826,
            "z": -99.85382843017578
        },
        {
            "x": -0.4197748899459839,
            "y": 0.0015758201479911804,
            "z": -99.6971206665039
        },
        {
            "x": -0.42987313866615295,
            "y": 0.0015697963535785675,
            "z": -99.54051208496094
        },
        {
            "x": -0.4397428333759308,
            "y": 0.0015637576580047607,
            "z": -99.38378143310547
        },
        {
            "x": -0.44936951994895935,
            "y": 0.0015576966106891632,
            "z": -99.22704315185547
        },
        {
            "x": -0.45875149965286255,
            "y": 0.0015516579151153564,
            "z": -99.07038116455078
        },
        {
            "x": -0.46487700939178467,
            "y": 0.0015476234257221222,
            "z": -98.96595001220703
        },
        {
            "x": -0.4738616347312927,
            "y": 0.001541588455438614,
            "z": -98.80928039550781
        },
        {
            "x": -0.4826081395149231,
            "y": 0.0015355534851551056,
            "z": -98.65259552001953
        },
        {
            "x": -0.4911302328109741,
            "y": 0.001529499888420105,
            "z": -98.49568176269531
        },
        {
            "x": -0.4994049668312073,
            "y": 0.0015234574675559998,
            "z": -98.33895874023438
        },
        {
            "x": -0.5074350237846375,
            "y": 0.0015174299478530884,
            "z": -98.1822280883789
        },
        {
            "x": -0.5152357220649719,
            "y": 0.0015113689005374908,
            "z": -98.0253677368164
        },
        {
            "x": -0.5227967500686646,
            "y": 0.0015274990582838655,
            "z": -97.86861419677734
        },
        {
            "x": -0.5301312208175659,
            "y": 0.001683809794485569,
            "z": -97.71174621582031
        },
        {
            "x": -0.5372243523597717,
            "y": 0.0020121687557548285,
            "z": -97.55486297607422
        },
        {
            "x": -0.5440798997879028,
            "y": 0.0025048558600246906,
            "z": -97.3980712890625
        },
        {
            "x": -0.5507116317749023,
            "y": 0.0031571276485919952,
            "z": -97.24114990234375
        },
        {
            "x": -0.5571112036705017,
            "y": 0.003964805975556374,
            "z": -97.08432006835938
        },
        {
            "x": -0.5632739067077637,
            "y": 0.0049300407990813255,
            "z": -96.92750549316406
        },
        {
            "x": -0.5692152380943298,
            "y": 0.006048108916729689,
            "z": -96.77046203613281
        },
        {
            "x": -0.5749263167381287,
            "y": 0.007310476619750261,
            "z": -96.6136245727539
        },
        {
            "x": -0.5804152488708496,
            "y": 0.008715631440281868,
            "z": -96.45671081542969
        },
        {
            "x": -0.5856736898422241,
            "y": 0.010264541953802109,
            "z": -96.29978942871094
        },
        {
            "x": -0.59070885181427,
            "y": 0.011950748041272163,
            "z": -96.14291381835938
        },
        {
            "x": -0.5955314040184021,
            "y": 0.01377148274332285,
            "z": -95.98585510253906
        },
        {
            "x": -0.6001298427581787,
            "y": 0.015719067305326462,
            "z": -95.8289566040039
        },
        {
            "x": -0.6045095920562744,
            "y": 0.017795996740460396,
            "z": -95.67205810546875
        },
        {
            "x": -0.6086700558662415,
            "y": 0.019997213035821915,
            "z": -95.51516723632812
        },
        {
            "x": -0.6126177310943604,
            "y": 0.022317232564091682,
            "z": -95.35826873779297
        },
        {
            "x": -0.6163584589958191,
            "y": 0.02475447952747345,
            "z": -95.20124053955078
        },
        {
            "x": -0.6198819279670715,
            "y": 0.02730700746178627,
            "z": -95.04421997070312
        },
        {
            "x": -0.6231908202171326,
            "y": 0.029968950897455215,
            "z": -94.88729095458984
        },
        {
            "x": -0.6262970566749573,
            "y": 0.032738037407398224,
            "z": -94.73026275634766
        },
        {
            "x": -0.6291953325271606,
            "y": 0.03560709208250046,
            "z": -94.57333374023438
        },
        {
            "x": -0.6318889856338501,
            "y": 0.03857719898223877,
            "z": -94.41641235351562
        },
        {
            "x": -0.6343802213668823,
            "y": 0.041648801416158676,
            "z": -94.25927734375
        },
        {
            "x": -0.6366676688194275,
            "y": 0.044808149337768555,
            "z": -94.10233306884766
        },
        {
            "x": -0.6387592554092407,
            "y": 0.04805738478899002,
            "z": -93.9453353881836
        },
        {
            "x": -0.6406462788581848,
            "y": 0.05139351263642311,
            "z": -93.788330078125
        },
        {
            "x": -0.6423358917236328,
            "y": 0.054811976850032806,
            "z": -93.63139343261719
        },
        {
            "x": -0.6438354849815369,
            "y": 0.058313313871622086,
            "z": -93.47425079345703
        },
        {
            "x": -0.645143985748291,
            "y": 0.06188518553972244,
            "z": -93.31730651855469
        },
        {
            "x": -0.6462583541870117,
            "y": 0.06553012132644653,
            "z": -93.16035461425781
        },
        {
            "x": -0.6471754908561707,
            "y": 0.06924767047166824,
            "z": -93.00328063964844
        },
        {
            "x": -0.6479042768478394,
            "y": 0.07302720844745636,
            "z": -92.84632873535156
        },
        {
            "x": -0.6484367251396179,
            "y": 0.0768696516752243,
            "z": -92.68932342529297
        },
        {
            "x": -0.6487412452697754,
            "y": 0.08077024668455124,
            "z": -92.53234100341797
        },
        {
            "x": -0.6487239599227905,
            "y": 0.08472248911857605,
            "z": -92.37557220458984
        },
        {
            "x": -0.6485004425048828,
            "y": 0.08738367259502411,
            "z": -92.27113342285156
        },
        {
            "x": -0.6477987766265869,
            "y": 0.0914158821105957,
            "z": -92.1145248413086
        },
        {
            "x": -0.6465755105018616,
            "y": 0.0954953134059906,
            "z": -91.95795440673828
        },
        {
            "x": -0.6448293924331665,
            "y": 0.09962249547243118,
            "z": -91.80120849609375
        },
        {
            "x": -0.6425595879554749,
            "y": 0.10378393530845642,
            "z": -91.6446762084961
        },
        {
            "x": -0.639764130115509,
            "y": 0.10798147320747375,
            "z": -91.48817443847656
        },
        {
            "x": -0.6364247798919678,
            "y": 0.11221689730882645,
            "z": -91.3315658569336
        },
        {
            "x": -0.6325494647026062,
            "y": 0.11647908389568329,
            "z": -91.17505645751953
        },
        {
            "x": -0.628136157989502,
            "y": 0.12077005207538605,
            "z": -91.01847839355469
        },
        {
            "x": -0.6231734752655029,
            "y": 0.1250840425491333,
            "z": -90.8619155883789
        },
        {
            "x": -0.6176673769950867,
            "y": 0.12941518425941467,
            "z": -90.70549774169922
        },
        {
            "x": -0.6116192936897278,
            "y": 0.13376589119434357,
            "z": -90.54896545410156
        },
        {
            "x": -0.6050376892089844,
            "y": 0.13812589645385742,
            "z": -90.39258575439453
        },
        {
            "x": -0.5979093313217163,
            "y": 0.1424962282180786,
            "z": -90.2362060546875
        },
        {
            "x": -0.5901960134506226,
            "y": 0.14687809348106384,
            "z": -90.07966613769531
        },
        {
            "x": -0.58195561170578,
            "y": 0.1512565165758133,
            "z": -89.9233627319336
        },
        {
            "x": -0.5731672644615173,
            "y": 0.15563581883907318,
            "z": -89.76702880859375
        },
        {
            "x": -0.5638363361358643,
            "y": 0.1600109338760376,
            "z": -89.6107406616211
        },
        {
            "x": -0.5539474487304688,
            "y": 0.16437670588493347,
            "z": -89.45452117919922
        },
        {
            "x": -0.5434945225715637,
            "y": 0.16873720288276672,
            "z": -89.29814147949219
        },
        {
            "x": -0.5325152277946472,
            "y": 0.1730777621269226,
            "z": -89.14199829101562
        },
        {
            "x": -0.5209891200065613,
            "y": 0.17740079760551453,
            "z": -88.98588562011719
        },
        {
            "x": -0.5088920593261719,
            "y": 0.1817014217376709,
            "z": -88.82981872558594
        },
        {
            "x": -0.49626049399375916,
            "y": 0.18597769737243652,
            "z": -88.67378997802734
        },
        {
            "x": -0.48308315873146057,
            "y": 0.19022837281227112,
            "z": -88.51770782470703
        },
        {
            "x": -0.4693664312362671,
            "y": 0.1944478154182434,
            "z": -88.3616714477539
        },
        {
            "x": -0.45510581135749817,
            "y": 0.1986282914876938,
            "z": -88.20575714111328
        },
        {
            "x": -0.44030019640922546,
            "y": 0.20277325809001923,
            "z": -88.04978942871094
        },
        {
            "x": -0.4249797463417053,
            "y": 0.20687377452850342,
            "z": -87.89398193359375
        },
        {
            "x": -0.4091389775276184,
            "y": 0.21092934906482697,
            "z": -87.73822021484375
        },
        {
            "x": -0.39272668957710266,
            "y": 0.21493904292583466,
            "z": -87.58230590820312
        },
        {
            "x": -0.3758176267147064,
            "y": 0.21889159083366394,
            "z": -87.42664337158203
        },
        {
            "x": -0.35839343070983887,
            "y": 0.22279012203216553,
            "z": -87.27098083496094
        },
        {
            "x": -0.3404574692249298,
            "y": 0.22663021087646484,
            "z": -87.1153564453125
        },
        {
            "x": -0.3220079243183136,
            "y": 0.23040388524532318,
            "z": -86.95984649658203
        },
        {
            "x": -0.30303746461868286,
            "y": 0.23411595821380615,
            "z": -86.80419158935547
        },
        {
            "x": -0.283602774143219,
            "y": 0.23775430023670197,
            "z": -86.6487808227539
        },
        {
            "x": -0.2636808753013611,
            "y": 0.24132031202316284,
            "z": -86.49342346191406
        },
        {
            "x": -0.24325528740882874,
            "y": 0.24480950832366943,
            "z": -86.33800506591797
        },
        {
            "x": -0.22237488627433777,
            "y": 0.24821636080741882,
            "z": -86.18274688720703
        },
        {
            "x": -0.2010209858417511,
            "y": 0.2515423893928528,
            "z": -86.02745056152344
        },
        {
            "x": -0.17921112477779388,
            "y": 0.25478219985961914,
            "z": -85.87218475341797
        },
        {
            "x": -0.15696199238300323,
            "y": 0.2579265832901001,
            "z": -85.71708679199219
        },
        {
            "x": -0.14188532531261444,
            "y": 0.25997114181518555,
            "z": -85.61369323730469
        },
        {
            "x": -0.11892613768577576,
            "y": 0.2629588842391968,
            "z": -85.45867919921875
        },
        {
            "x": -0.0955294594168663,
            "y": 0.26584452390670776,
            "z": -85.3036880493164
        },
        {
            "x": -0.0716932937502861,
            "y": 0.26862967014312744,
            "z": -85.14856719970703
        },
        {
            "x": -0.047497980296611786,
            "y": 0.2713054418563843,
            "z": -84.99368286132812
        },
        {
            "x": -0.022920385003089905,
            "y": 0.2738720178604126,
            "z": -84.83883666992188
        },
        {
            "x": 0.0020563602447509766,
            "y": 0.27632391452789307,
            "z": -84.68392944335938
        },
        {
            "x": 0.02737966924905777,
            "y": 0.2786557972431183,
            "z": -84.52918243408203
        },
        {
            "x": 0.053061217069625854,
            "y": 0.2808695137500763,
            "z": -84.37435913085938
        },
        {
            "x": 0.07907696813344955,
            "y": 0.28296011686325073,
            "z": -84.2195816040039
        },
        {
            "x": 0.10539763420820236,
            "y": 0.28491878509521484,
            "z": -84.06494903564453
        },
        {
            "x": 0.13204485177993774,
            "y": 0.28674644231796265,
            "z": -83.91022491455078
        },
        {
            "x": 0.15895694494247437,
            "y": 0.28843921422958374,
            "z": -83.75565338134766
        },
        {
            "x": 0.18614181876182556,
            "y": 0.2899952530860901,
            "z": -83.6010971069336
        },
        {
            "x": 0.21362243592739105,
            "y": 0.29140836000442505,
            "z": -83.44637298583984
        },
        {
            "x": 0.2413119226694107,
            "y": 0.29267293214797974,
            "z": -83.2918701171875
        },
        {
            "x": 0.2692378759384155,
            "y": 0.29379066824913025,
            "z": -83.1373291015625
        },
        {
            "x": 0.2973657250404358,
            "y": 0.29475754499435425,
            "z": -82.98280334472656
        },
        {
            "x": 0.3256765604019165,
            "y": 0.2955654561519623,
            "z": -82.8283462524414
        },
        {
            "x": 0.354199081659317,
            "y": 0.2962130308151245,
            "z": -82.6737060546875
        },
        {
            "x": 0.3828374743461609,
            "y": 0.29669857025146484,
            "z": -82.51927185058594
        },
        {
            "x": 0.4116089940071106,
            "y": 0.297019362449646,
            "z": -82.3648452758789
        },
        {
            "x": 0.4404977560043335,
            "y": 0.297054260969162,
            "z": -82.21040344238281
        },
        {
            "x": 0.46948710083961487,
            "y": 0.2966092526912689,
            "z": -82.05596160888672
        },
        {
            "x": 0.49856996536254883,
            "y": 0.29569366574287415,
            "z": -81.90142059326172
        },
        {
            "x": 0.5277084112167358,
            "y": 0.29431670904159546,
            "z": -81.74687957763672
        },
        {
            "x": 0.5568694472312927,
            "y": 0.2924773693084717,
            "z": -81.59239959716797
        },
        {
            "x": 0.5860641002655029,
            "y": 0.2901826500892639,
            "z": -81.43782043457031
        },
        {
            "x": 0.6152384877204895,
            "y": 0.28745579719543457,
            "z": -81.2833251953125
        },
        {
            "x": 0.6443862915039062,
            "y": 0.28430408239364624,
            "z": -81.12882232666016
        },
        {
            "x": 0.6735296249389648,
            "y": 0.2807231545448303,
            "z": -80.97409057617188
        },
        {
            "x": 0.702568531036377,
            "y": 0.27672868967056274,
            "z": -80.81952667236328
        },
        {
            "x": 0.7315397262573242,
            "y": 0.27233463525772095,
            "z": -80.66487121582031
        },
        {
            "x": 0.7604048252105713,
            "y": 0.2675517201423645,
            "z": -80.51020812988281
        },
        {
            "x": 0.7891300320625305,
            "y": 0.2623835802078247,
            "z": -80.35554504394531
        },
        {
            "x": 0.8177399039268494,
            "y": 0.2568259835243225,
            "z": -80.20065307617188
        },
        {
            "x": 0.8461464643478394,
            "y": 0.25091326236724854,
            "z": -80.0458984375
        },
        {
            "x": 0.8743662238121033,
            "y": 0.24464811384677887,
            "z": -79.89114379882812
        },
        {
            "x": 0.9023997783660889,
            "y": 0.2380283921957016,
            "z": -79.73621368408203
        },
        {
            "x": 0.9301779270172119,
            "y": 0.23106683790683746,
            "z": -79.58133697509766
        },
        {
            "x": 0.9577272534370422,
            "y": 0.22377415001392365,
            "z": -79.42630767822266
        },
        {
            "x": 0.9850119948387146,
            "y": 0.21616391837596893,
            "z": -79.27124786376953
        },
        {
            "x": 1.0119906663894653,
            "y": 0.2082458734512329,
            "z": -79.11621856689453
        },
        {
            "x": 1.0297977924346924,
            "y": 0.20279045403003693,
            "z": -79.01283264160156
        },
        {
            "x": 1.0562553405761719,
            "y": 0.19437116384506226,
            "z": -78.85770416259766
        },
        {
            "x": 1.0823744535446167,
            "y": 0.18566416203975677,
            "z": -78.70252227783203
        },
        {
            "x": 1.1081647872924805,
            "y": 0.1766580045223236,
            "z": -78.54708099365234
        },
        {
            "x": 1.133553385734558,
            "y": 0.1673949807882309,
            "z": -78.39176177978516
        },
        {
            "x": 1.1585516929626465,
            "y": 0.15787392854690552,
            "z": -78.23637390136719
        },
        {
            "x": 1.1831612586975098,
            "y": 0.14809450507164001,
            "z": -78.080810546875
        },
        {
            "x": 1.2073166370391846,
            "y": 0.1380694955587387,
            "z": -77.92529296875
        },
        {
            "x": 1.2310489416122437,
            "y": 0.12780562043190002,
            "z": -77.76960754394531
        },
        {
            "x": 1.2543309926986694,
            "y": 0.11731786280870438,
            "z": -77.61385345458984
        },
        {
            "x": 1.2771285772323608,
            "y": 0.10662193596363068,
            "z": -77.4581298828125
        },
        {
            "x": 1.299436330795288,
            "y": 0.09570221602916718,
            "z": -77.3022232055664
        },
        {
            "x": 1.3212311267852783,
            "y": 0.08459249138832092,
            "z": -77.14634704589844
        },
        {
            "x": 1.3425201177597046,
            "y": 0.07329359650611877,
            "z": -76.99040222167969
        },
        {
            "x": 1.3633160591125488,
            "y": 0.06180029362440109,
            "z": -76.83419036865234
        },
        {
            "x": 1.3835227489471436,
            "y": 0.05014419183135033,
            "z": -76.67810821533203
        },
        {
            "x": 1.4031829833984375,
            "y": 0.038319751620292664,
            "z": -76.52190399169922
        },
        {
            "x": 1.4222846031188965,
            "y": 0.026341963559389114,
            "z": -76.36561584472656
        },
        {
            "x": 1.4408169984817505,
            "y": 0.014223771169781685,
            "z": -76.20933532714844
        },
        {
            "x": 1.4587712287902832,
            "y": 0.001949204015545547,
            "z": -76.05276489257812
        },
        {
            "x": 1.4760971069335938,
            "y": -0.010438404977321625,
            "z": -75.8963394165039
        },
        {
            "x": 1.4928277730941772,
            "y": -0.022944055497646332,
            "z": -75.73985290527344
        },
        {
            "x": 1.5089564323425293,
            "y": -0.03555916249752045,
            "z": -75.58330535888672
        },
        {
            "x": 1.524454116821289,
            "y": -0.04827709123492241,
            "z": -75.42668914794922
        },
        {
            "x": 1.539316177368164,
            "y": -0.06109696999192238,
            "z": -75.2699203491211
        },
        {
            "x": 1.5535547733306885,
            "y": -0.07400017976760864,
            "z": -75.11308288574219
        },
        {
            "x": 1.567150354385376,
            "y": -0.08696888387203217,
            "z": -74.95628356933594
        },
        {
            "x": 1.5801010131835938,
            "y": -0.10001175105571747,
            "z": -74.7993392944336
        },
        {
            "x": 1.5923699140548706,
            "y": -0.11310434341430664,
            "z": -74.6424331665039
        },
        {
            "x": 1.6039907932281494,
            "y": -0.1262432336807251,
            "z": -74.48548889160156
        },
        {
            "x": 1.6149711608886719,
            "y": -0.13943755626678467,
            "z": -74.32830047607422
        },
        {
            "x": 1.6252690553665161,
            "y": -0.15264436602592468,
            "z": -74.1712646484375
        },
        {
            "x": 1.6348767280578613,
            "y": -0.16587777435779572,
            "z": -74.01412963867188
        },
        {
            "x": 1.6438238620758057,
            "y": -0.17912228405475616,
            "z": -73.85694122314453
        },
        {
            "x": 1.652097463607788,
            "y": -0.19236400723457336,
            "z": -73.69978332519531
        },
        {
            "x": 1.6597061157226562,
            "y": -0.20561696588993073,
            "z": -73.54237365722656
        },
        {
            "x": 1.666610598564148,
            "y": -0.2188376486301422,
            "z": -73.38514709472656
        },
        {
            "x": 1.6728405952453613,
            "y": -0.23203253746032715,
            "z": -73.2278823852539
        },
        {
            "x": 1.6783974170684814,
            "y": -0.24520422518253326,
            "z": -73.07048034667969
        },
        {
            "x": 1.6832808256149292,
            "y": -0.25832444429397583,
            "z": -72.91315460205078
        },
        {
            "x": 1.6874710321426392,
            "y": -0.27139925956726074,
            "z": -72.75572967529297
        },
        {
            "x": 1.690975308418274,
            "y": -0.2844131886959076,
            "z": -72.5982666015625
        },
        {
            "x": 1.6938071250915527,
            "y": -0.29734963178634644,
            "z": -72.4408950805664
        },
        {
            "x": 1.6953117847442627,
            "y": -0.30593085289001465,
            "z": -72.33596801757812
        },
        {
            "x": 1.6970088481903076,
            "y": -0.3187299370765686,
            "z": -72.1785659790039
        },
        {
            "x": 1.6980351209640503,
            "y": -0.3314354419708252,
            "z": -72.02115631103516
        },
        {
            "x": 1.6984020471572876,
            "y": -0.34405583143234253,
            "z": -71.86353302001953
        },
        {
            "x": 1.6980950832366943,
            "y": -0.3565446138381958,
            "z": -71.70611572265625
        },
        {
            "x": 1.6970998048782349,
            "y": -0.3689113259315491,
            "z": -71.54867553710938
        },
        {
            "x": 1.695432424545288,
            "y": -0.38115930557250977,
            "z": -71.39111328125
        },
        {
            "x": 1.6930817365646362,
            "y": -0.39326125383377075,
            "z": -71.23365783691406
        },
        {
            "x": 1.6900122165679932,
            "y": -0.4052230715751648,
            "z": -71.0760726928711
        },
        {
            "x": 1.686214566230774,
            "y": -0.4170258641242981,
            "z": -70.9184799194336
        },
        {
            "x": 1.6816987991333008,
            "y": -0.42865681648254395,
            "z": -70.760986328125
        },
        {
            "x": 1.6764378547668457,
            "y": -0.44012343883514404,
            "z": -70.6033706665039
        },
        {
            "x": 1.6704238653182983,
            "y": -0.4513988494873047,
            "z": -70.44586181640625
        },
        {
            "x": 1.6636255979537964,
            "y": -0.46247583627700806,
            "z": -70.28836822509766
        },
        {
            "x": 1.656032919883728,
            "y": -0.47336673736572266,
            "z": -70.13069152832031
        },
        {
            "x": 1.6476542949676514,
            "y": -0.4840349555015564,
            "z": -69.97322082519531
        },
        {
            "x": 1.6384669542312622,
            "y": -0.4944881200790405,
            "z": -69.81570434570312
        },
        {
            "x": 1.6284246444702148,
            "y": -0.5047054290771484,
            "z": -69.65821075439453
        },
        {
            "x": 1.6175438165664673,
            "y": -0.5146827697753906,
            "z": -69.50079345703125
        },
        {
            "x": 1.6057933568954468,
            "y": -0.5244275331497192,
            "z": -69.34321594238281
        },
        {
            "x": 1.593187928199768,
            "y": -0.5339066982269287,
            "z": -69.18588256835938
        },
        {
            "x": 1.579666256904602,
            "y": -0.5431102514266968,
            "z": -69.0285873413086
        },
        {
            "x": 1.5652415752410889,
            "y": -0.5520420074462891,
            "z": -68.8713150024414
        },
        {
            "x": 1.549898386001587,
            "y": -0.5606924295425415,
            "z": -68.71412658691406
        },
        {
            "x": 1.5336127281188965,
            "y": -0.5690584182739258,
            "z": -68.55691528320312
        },
        {
            "x": 1.5163344144821167,
            "y": -0.5771127939224243,
            "z": -68.39974212646484
        },
        {
            "x": 1.4980952739715576,
            "y": -0.5848517417907715,
            "z": -68.24275207519531
        },
        {
            "x": 1.4788602590560913,
            "y": -0.5922791957855225,
            "z": -68.08574676513672
        },
        {
            "x": 1.45863938331604,
            "y": -0.5993756055831909,
            "z": -67.92893981933594
        },
        {
            "x": 1.4373546838760376,
            "y": -0.6061243414878845,
            "z": -67.77225494384766
        },
        {
            "x": 1.4149940013885498,
            "y": -0.6125341057777405,
            "z": -67.61546325683594
        },
        {
            "x": 1.391608715057373,
            "y": -0.6185827255249023,
            "z": -67.45899963378906
        },
        {
            "x": 1.3671507835388184,
            "y": -0.6242716312408447,
            "z": -67.30261993408203
        },
        {
            "x": 1.3415569067001343,
            "y": -0.6295768022537231,
            "z": -67.14636993408203
        },
        {
            "x": 1.3148506879806519,
            "y": -0.6344954967498779,
            "z": -66.99036407470703
        },
        {
            "x": 1.2869855165481567,
            "y": -0.6390318870544434,
            "z": -66.83430480957031
        },
        {
            "x": 1.2580150365829468,
            "y": -0.6431658267974854,
            "z": -66.67861938476562
        },
        {
            "x": 1.2278521060943604,
            "y": -0.6468804478645325,
            "z": -66.52315521240234
        },
        {
            "x": 1.1964702606201172,
            "y": -0.6501767039299011,
            "z": -66.3677749633789
        },
        {
            "x": 1.16392183303833,
            "y": -0.6530572175979614,
            "z": -66.21272277832031
        },
        {
            "x": 1.1301518678665161,
            "y": -0.6556236147880554,
            "z": -66.05780792236328
        },
        {
            "x": 1.0951133966445923,
            "y": -0.6579079031944275,
            "z": -65.90316009521484
        },
        {
            "x": 1.0588421821594238,
            "y": -0.659906268119812,
            "z": -65.74888610839844
        },
        {
            "x": 1.0339839458465576,
            "y": -0.6610848307609558,
            "z": -65.64617156982422
        },
        {
            "x": 0.9956127405166626,
            "y": -0.6626008749008179,
            "z": -65.49236297607422
        },
        {
            "x": 0.9559469223022461,
            "y": -0.6638154983520508,
            "z": -65.33888244628906
        },
        {
            "x": 0.914953887462616,
            "y": -0.6647299528121948,
            "z": -65.1855239868164
        },
        {
            "x": 0.8727158904075623,
            "y": -0.6653362512588501,
            "z": -65.03270721435547
        },
        {
            "x": 0.8291371464729309,
            "y": -0.6656211614608765,
            "z": -64.88021087646484
        },
        {
            "x": 0.7842095494270325,
            "y": -0.665580689907074,
            "z": -64.72802734375
        },
        {
            "x": 0.7380093336105347,
            "y": -0.6652231216430664,
            "z": -64.57633209228516
        },
        {
            "x": 0.690466046333313,
            "y": -0.6645532250404358,
            "z": -64.42494201660156
        },
        {
            "x": 0.6415674686431885,
            "y": -0.6635693311691284,
            "z": -64.27395629882812
        },
        {
            "x": 0.5913735032081604,
            "y": -0.6622791290283203,
            "z": -64.12352752685547
        },
        {
            "x": 0.5398316979408264,
            "y": -0.6606936454772949,
            "z": -63.97344970703125
        },
        {
            "x": 0.48702651262283325,
            "y": -0.6588212251663208,
            "z": -63.823917388916016
        },
        {
            "x": 0.43292275071144104,
            "y": -0.6566603183746338,
            "z": -63.67488479614258
        },
        {
            "x": 0.3774285912513733,
            "y": -0.6542130708694458,
            "z": -63.52616500854492
        },
        {
            "x": 0.32075417041778564,
            "y": -0.6514984965324402,
            "z": -63.37810516357422
        },
        {
            "x": 0.26283350586891174,
            "y": -0.6485196352005005,
            "z": -63.230525970458984
        },
        {
            "x": 0.20366522669792175,
            "y": -0.645276665687561,
            "z": -63.08343505859375
        },
        {
            "x": 0.14332930743694305,
            "y": -0.6417771577835083,
            "z": -62.93696975708008
        },
        {
            "x": 0.08175487071275711,
            "y": -0.6380265355110168,
            "z": -62.790794372558594
        },
        {
            "x": 0.019167959690093994,
            "y": -0.6340421438217163,
            "z": -62.64535903930664
        },
        {
            "x": -0.044499024748802185,
            "y": -0.6298196315765381,
            "z": -62.50041580200195
        },
        {
            "x": -0.10920826345682144,
            "y": -0.625363826751709,
            "z": -62.35601806640625
        },
        {
            "x": -0.1748524010181427,
            "y": -0.6206874847412109,
            "z": -62.21210479736328
        },
        {
            "x": -0.24143368005752563,
            "y": -0.6157933473587036,
            "z": -62.068599700927734
        },
        {
            "x": -0.3088425099849701,
            "y": -0.6106876134872437,
            "z": -61.925567626953125
        },
        {
            "x": -0.3769680857658386,
            "y": -0.6053758859634399,
            "z": -61.783077239990234
        },
        {
            "x": -0.4457995891571045,
            "y": -0.5998647212982178,
            "z": -61.64091873168945
        },
        {
            "x": -0.5151390433311462,
            "y": -0.5941673517227173,
            "z": -61.4992561340332
        },
        {
            "x": -0.5849536061286926,
            "y": -0.5882835388183594,
            "z": -61.357933044433594
        },
        {
            "x": -0.6552344560623169,
            "y": -0.5822075009346008,
            "z": -61.21675109863281
        },
        {
            "x": -0.7256566286087036,
            "y": -0.5759678483009338,
            "z": -61.07603454589844
        },
        {
            "x": -0.796228289604187,
            "y": -0.569559633731842,
            "z": -60.93546676635742
        },
        {
            "x": -0.8667887449264526,
            "y": -0.5629898309707642,
            "z": -60.795047760009766
        },
        {
            "x": -0.9371404051780701,
            "y": -0.5562632083892822,
            "z": -60.6547966003418
        },
        {
            "x": -1.0072904825210571,
            "y": -0.5493788719177246,
            "z": -60.51438522338867
        },
        {
            "x": -1.076865315437317,
            "y": -0.5423623919487,
            "z": -60.37411880493164
        },
        {
            "x": -1.1457980871200562,
            "y": -0.5352094173431396,
            "z": -60.23375701904297
        },
        {
            "x": -1.2139244079589844,
            "y": -0.5279159545898438,
            "z": -60.09309387207031
        },
        {
            "x": -1.280991792678833,
            "y": -0.5205041766166687,
            "z": -59.9522705078125
        },
        {
            "x": -1.3468964099884033,
            "y": -0.5129711627960205,
            "z": -59.81102752685547
        },
        {
            "x": -1.4113940000534058,
            "y": -0.5053274631500244,
            "z": -59.66936492919922
        },
        {
            "x": -1.4741476774215698,
            "y": -0.49758079648017883,
            "z": -59.52729797363281
        },
        {
            "x": -1.5149959325790405,
            "y": -0.49236223101615906,
            "z": -59.43227005004883
        },
        {
            "x": -1.5746214389801025,
            "y": -0.48446065187454224,
            "z": -59.28926086425781
        },
        {
            "x": -1.6319725513458252,
            "y": -0.4764682352542877,
            "z": -59.145511627197266
        },
        {
            "x": -1.6873760223388672,
            "y": -0.46836143732070923,
            "z": -59.000457763671875
        },
        {
            "x": -1.7413004636764526,
            "y": -0.4601536989212036,
            "z": -58.8544807434082
        },
        {
            "x": -1.7939999103546143,
            "y": -0.45186126232147217,
            "z": -58.70791244506836
        },
        {
            "x": -1.8454904556274414,
            "y": -0.4434850215911865,
            "z": -58.56074142456055
        },
        {
            "x": -1.8957654237747192,
            "y": -0.4350472688674927,
            "z": -58.413238525390625
        },
        {
            "x": -1.9449384212493896,
            "y": -0.42654216289520264,
            "z": -58.26521682739258
        },
        {
            "x": -1.9930111169815063,
            "y": -0.41798049211502075,
            "z": -58.116798400878906
        },
        {
            "x": -2.0399386882781982,
            "y": -0.4093731641769409,
            "z": -57.96809387207031
        },
        {
            "x": -2.0858399868011475,
            "y": -0.4007142186164856,
            "z": -57.818912506103516
        },
        {
            "x": -2.130685567855835,
            "y": -0.392023503780365,
            "z": -57.66951370239258
        },
        {
            "x": -2.174532175064087,
            "y": -0.38329988718032837,
            "z": -57.51979446411133
        },
        {
            "x": -2.217428684234619,
            "y": -0.37453675270080566,
            "z": -57.36954879760742
        },
        {
            "x": -2.2593021392822266,
            "y": -0.3657630681991577,
            "z": -57.219207763671875
        },
        {
            "x": -2.3002519607543945,
            "y": -0.3569711446762085,
            "z": -57.068546295166016
        },
        {
            "x": -2.3402810096740723,
            "y": -0.34816867113113403,
            "z": -56.9176139831543
        },
        {
            "x": -2.3793675899505615,
            "y": -0.33936506509780884,
            "z": -56.76647186279297
        },
        {
            "x": -2.4176039695739746,
            "y": -0.3305506408214569,
            "z": -56.61487579345703
        },
        {
            "x": -2.454922914505005,
            "y": -0.32175412774086,
            "z": -56.4632453918457
        },
        {
            "x": -2.491384506225586,
            "y": -0.31295573711395264,
            "z": -56.311405181884766
        },
        {
            "x": -2.5269784927368164,
            "y": -0.30402809381484985,
            "z": -56.159339904785156
        },
        {
            "x": -2.56172776222229,
            "y": -0.29495418071746826,
            "z": -56.00706100463867
        },
        {
            "x": -2.59567928314209,
            "y": -0.28574156761169434,
            "z": -55.8545036315918
        },
        {
            "x": -2.628819227218628,
            "y": -0.2764035761356354,
            "z": -55.70176696777344
        },
        {
            "x": -2.6611270904541016,
            "y": -0.26695162057876587,
            "z": -55.54893112182617
        },
        {
            "x": -2.6926498413085938,
            "y": -0.25738096237182617,
            "z": -55.395835876464844
        },
        {
            "x": -2.7233660221099854,
            "y": -0.24771654605865479,
            "z": -55.24269485473633
        },
        {
            "x": -2.7533156871795654,
            "y": -0.23795850574970245,
            "z": -55.08937072753906
        },
        {
            "x": -2.782536029815674,
            "y": -0.22810262441635132,
            "z": -54.935707092285156
        },
        {
            "x": -2.8109304904937744,
            "y": -0.218179851770401,
            "z": -54.7820930480957
        },
        {
            "x": -2.838597536087036,
            "y": -0.20818468928337097,
            "z": -54.62827682495117
        },
        {
            "x": -2.8655245304107666,
            "y": -0.19813017547130585,
            "z": -54.474334716796875
        },
        {
            "x": -2.8917036056518555,
            "y": -0.18802551925182343,
            "z": -54.32030487060547
        },
        {
            "x": -2.9171650409698486,
            "y": -0.17786261439323425,
            "z": -54.16595458984375
        },
        {
            "x": -2.941864490509033,
            "y": -0.1676780879497528,
            "z": -54.01169204711914
        },
        {
            "x": -2.9658610820770264,
            "y": -0.15746471285820007,
            "z": -53.85729217529297
        },
        {
            "x": -2.9891555309295654,
            "y": -0.14722584187984467,
            "z": -53.70269775390625
        },
        {
            "x": -3.011699676513672,
            "y": -0.13698071241378784,
            "z": -53.54806900024414
        },
        {
            "x": -3.0335586071014404,
            "y": -0.1267274022102356,
            "z": -53.39325714111328
        },
        {
            "x": -3.054720401763916,
            "y": -0.1164785623550415,
            "z": -53.23833084106445
        },
        {
            "x": -3.075178861618042,
            "y": -0.10624498128890991,
            "z": -53.08340835571289
        },
        {
            "x": -3.0884056091308594,
            "y": -0.0990411564707756,
            "z": -52.98006057739258
        },
        {
            "x": -3.1076931953430176,
            "y": -0.08722146600484848,
            "z": -52.825042724609375
        },
        {
            "x": -3.1262762546539307,
            "y": -0.0742199569940567,
            "z": -52.6700325012207
        },
        {
            "x": -3.1441760063171387,
            "y": -0.060072656720876694,
            "z": -52.51483917236328
        },
        {
            "x": -3.1613495349884033,
            "y": -0.044941939413547516,
            "z": -52.35985565185547
        },
        {
            "x": -3.1778483390808105,
            "y": -0.028913674876093864,
            "z": -52.20489501953125
        },
        {
            "x": -3.1936721801757812,
            "y": -0.012067874893546104,
            "z": -52.04983901977539
        },
        {
            "x": -3.2088024616241455,
            "y": 0.005497720558196306,
            "z": -51.8948974609375
        },
        {
            "x": -3.2232441902160645,
            "y": 0.023706603795289993,
            "z": -51.73987579345703
        },
        {
            "x": -3.237025260925293,
            "y": 0.04244190454483032,
            "z": -51.58485412597656
        },
        {
            "x": -3.250122547149658,
            "y": 0.06160327047109604,
            "z": -51.42991638183594
        },
        {
            "x": -3.262568712234497,
            "y": 0.08112731575965881,
            "z": -51.274871826171875
        },
        {
            "x": -3.2743115425109863,
            "y": 0.10090029984712601,
            "z": -51.119911193847656
        },
        {
            "x": -3.2853989601135254,
            "y": 0.12083370983600616,
            "z": -50.964927673339844
        },
        {
            "x": -3.2958383560180664,
            "y": 0.14086531102657318,
            "z": -50.809715270996094
        },
        {
            "x": -3.305607318878174,
            "y": 0.1608532965183258,
            "z": -50.654666900634766
        },
        {
            "x": -3.3146984577178955,
            "y": 0.18073633313179016,
            "z": -50.49949645996094
        },
        {
            "x": -3.323125123977661,
            "y": 0.20041486620903015,
            "z": -50.34428787231445
        },
        {
            "x": -3.3308982849121094,
            "y": 0.21979676187038422,
            "z": -50.18904495239258
        },
        {
            "x": -3.338017702102661,
            "y": 0.23882195353507996,
            "z": -50.03353500366211
        },
        {
            "x": -3.344461679458618,
            "y": 0.25733816623687744,
            "z": -49.87814712524414
        },
        {
            "x": -3.350227117538452,
            "y": 0.2752763330936432,
            "z": -49.72266387939453
        },
        {
            "x": -3.355334758758545,
            "y": 0.29255515336990356,
            "z": -49.56709289550781
        },
        {
            "x": -3.3597841262817383,
            "y": 0.3090859055519104,
            "z": -49.41142654418945
        },
        {
            "x": -3.3635597229003906,
            "y": 0.32477468252182007,
            "z": -49.25556182861328
        },
        {
            "x": -3.3666529655456543,
            "y": 0.33949118852615356,
            "z": -49.09959030151367
        },
        {
            "x": -3.3690688610076904,
            "y": 0.3531656861305237,
            "z": -48.9436149597168
        },
        {
            "x": -3.3708207607269287,
            "y": 0.36572253704071045,
            "z": -48.787452697753906
        },
        {
            "x": -3.371889114379883,
            "y": 0.3770490884780884,
            "z": -48.63130187988281
        },
        {
            "x": -3.3721425533294678,
            "y": 0.38698720932006836,
            "z": -48.475257873535156
        },
        {
            "x": -3.371328353881836,
            "y": 0.3955114483833313,
            "z": -48.31920623779297
        },
        {
            "x": -3.369178533554077,
            "y": 0.4025193154811859,
            "z": -48.1634407043457
        },
        {
            "x": -3.365633010864258,
            "y": 0.4080759286880493,
            "z": -48.00760269165039
        },
        {
            "x": -3.360535144805908,
            "y": 0.4129127264022827,
            "z": -47.8518180847168
        },
        {
            "x": -3.353938341140747,
            "y": 0.4165356755256653,
            "z": -47.69618606567383
        },
        {
            "x": -3.3457508087158203,
            "y": 0.4189303517341614,
            "z": -47.540443420410156
        },
        {
            "x": -3.3359720706939697,
            "y": 0.4201715588569641,
            "z": -47.3849983215332
        },
        {
            "x": -3.324460029602051,
            "y": 0.42029863595962524,
            "z": -47.2297248840332
        },
        {
            "x": -3.3112170696258545,
            "y": 0.41943979263305664,
            "z": -47.07450866699219
        },
        {
            "x": -3.2962446212768555,
            "y": 0.41768205165863037,
            "z": -46.919578552246094
        },
        {
            "x": -3.279491424560547,
            "y": 0.4151046872138977,
            "z": -46.76477813720703
        },
        {
            "x": -3.260843515396118,
            "y": 0.4117611050605774,
            "z": -46.6102294921875
        },
        {
            "x": -3.240360736846924,
            "y": 0.40776604413986206,
            "z": -46.4560546875
        },
        {
            "x": -3.2257139682769775,
            "y": 0.40479207038879395,
            "z": -46.35340881347656
        },
        {
            "x": -3.2020978927612305,
            "y": 0.39988240599632263,
            "z": -46.199703216552734
        },
        {
            "x": -3.176610231399536,
            "y": 0.39453810453414917,
            "z": -46.04629898071289
        },
        {
            "x": -3.1492438316345215,
            "y": 0.3888355493545532,
            "z": -45.893009185791016
        },
        {
            "x": -3.120091199874878,
            "y": 0.38286858797073364,
            "z": -45.740230560302734
        },
        {
            "x": -3.0890862941741943,
            "y": 0.37670379877090454,
            "z": -45.5877799987793
        },
        {
            "x": -3.056300401687622,
            "y": 0.3704245090484619,
            "z": -45.43553161621094
        },
        {
            "x": -3.0218698978424072,
            "y": 0.36411982774734497,
            "z": -45.283695220947266
        },
        {
            "x": -2.985823154449463,
            "y": 0.35785841941833496,
            "z": -45.13203811645508
        },
        {
            "x": -2.948228597640991,
            "y": 0.35172879695892334,
            "z": -44.98065185546875
        },
        {
            "x": -2.9092600345611572,
            "y": 0.34581446647644043,
            "z": -44.82958984375
        },
        {
            "x": -2.8690073490142822,
            "y": 0.34018272161483765,
            "z": -44.67860412597656
        },
        {
            "x": -2.8276636600494385,
            "y": 0.3349202871322632,
            "z": -44.52789306640625
        },
        {
            "x": -2.785313129425049,
            "y": 0.33011651039123535,
            "z": -44.37730026245117
        },
        {
            "x": -2.7420825958251953,
            "y": 0.325844943523407,
            "z": -44.22657012939453
        },
        {
            "x": -2.6982600688934326,
            "y": 0.32218772172927856,
            "z": -44.076045989990234
        },
        {
            "x": -2.6539454460144043,
            "y": 0.31921809911727905,
            "z": -43.92544937133789
        },
        {
            "x": -2.609304666519165,
            "y": 0.3170431852340698,
            "z": -43.77476119995117
        },
        {
            "x": -2.5645453929901123,
            "y": 0.3157445788383484,
            "z": -43.624000549316406
        },
        {
            "x": -2.5197641849517822,
            "y": 0.31538811326026917,
            "z": -43.472877502441406
        },
        {
            "x": -2.475231885910034,
            "y": 0.31605789065361023,
            "z": -43.32176208496094
        },
        {
            "x": -2.431058406829834,
            "y": 0.3178677558898926,
            "z": -43.170406341552734
        },
        {
            "x": -2.3874032497406006,
            "y": 0.32088708877563477,
            "z": -43.018798828125
        },
        {
            "x": -2.344390869140625,
            "y": 0.3245192766189575,
            "z": -42.86697006225586
        },
        {
            "x": -2.302105188369751,
            "y": 0.32807379961013794,
            "z": -42.71474075317383
        },
        {
            "x": -2.260697841644287,
            "y": 0.3315253257751465,
            "z": -42.56218338012695
        },
        {
            "x": -2.2203004360198975,
            "y": 0.33486783504486084,
            "z": -42.40938949584961
        },
        {
            "x": -2.1809098720550537,
            "y": 0.33810487389564514,
            "z": -42.25614547729492
        },
        {
            "x": -2.1426661014556885,
            "y": 0.34122809767723083,
            "z": -42.10266876220703
        },
        {
            "x": -2.1056160926818848,
            "y": 0.3442341387271881,
            "z": -41.94887161254883
        },
        {
            "x": -2.069777488708496,
            "y": 0.3471216857433319,
            "z": -41.794532775878906
        },
        {
            "x": -2.035247325897217,
            "y": 0.3498832583427429,
            "z": -41.64007568359375
        },
        {
            "x": -2.001995086669922,
            "y": 0.3525199592113495,
            "z": -41.48527145385742
        },
        {
            "x": -1.9700744152069092,
            "y": 0.355024516582489,
            "z": -41.33018493652344
        },
        {
            "x": -1.9395157098770142,
            "y": 0.35739099979400635,
            "z": -41.174869537353516
        },
        {
            "x": -1.9102479219436646,
            "y": 0.3596237301826477,
            "z": -41.019100189208984
        },
        {
            "x": -1.8823455572128296,
            "y": 0.36171311140060425,
            "z": -40.8632926940918
        },
        {
            "x": -1.8557658195495605,
            "y": 0.36365655064582825,
            "z": -40.707271575927734
        },
        {
            "x": -1.8305236101150513,
            "y": 0.36544889211654663,
            "z": -40.5509147644043
        },
        {
            "x": -1.8065767288208008,
            "y": 0.3670891523361206,
            "z": -40.39449691772461
        },
        {
            "x": -1.7838886976242065,
            "y": 0.3685764670372009,
            "z": -40.23778533935547
        },
        {
            "x": -1.7624624967575073,
            "y": 0.36990344524383545,
            "z": -40.08094787597656
        },
        {
            "x": -1.7423192262649536,
            "y": 0.3710629642009735,
            "z": -39.924034118652344
        },
        {
            "x": -1.7295418977737427,
            "y": 0.37174636125564575,
            "z": -39.819366455078125
        },
        {
            "x": -1.7113791704177856,
            "y": 0.37263023853302,
            "z": -39.6622428894043
        },
        {
            "x": -1.694399356842041,
            "y": 0.37333834171295166,
            "z": -39.50503158569336
        },
        {
            "x": -1.6785343885421753,
            "y": 0.3738734722137451,
            "z": -39.347537994384766
        },
        {
            "x": -1.6637487411499023,
            "y": 0.3742308020591736,
            "z": -39.19020462036133
        },
        {
            "x": -1.6499154567718506,
            "y": 0.37440645694732666,
            "z": -39.032772064208984
        },
        {
            "x": -1.6372919082641602,
            "y": 0.3743920922279358,
            "z": -38.8749885559082
        },
        {
            "x": -1.6258727312088013,
            "y": 0.37419480085372925,
            "z": -38.717185974121094
        },
        {
            "x": -1.6157780885696411,
            "y": 0.37381744384765625,
            "z": -38.55906295776367
        },
        {
            "x": -1.6071815490722656,
            "y": 0.3732614815235138,
            "z": -38.4007453918457
        },
        {
            "x": -1.6002788543701172,
            "y": 0.37252527475357056,
            "z": -38.242347717285156
        },
        {
            "x": -1.5951160192489624,
            "y": 0.37161827087402344,
            "z": -38.083683013916016
        },
        {
            "x": -1.5917999744415283,
            "y": 0.37054526805877686,
            "z": -37.925025939941406
        },
        {
            "x": -1.5904078483581543,
            "y": 0.3693079948425293,
            "z": -37.76631546020508
        },
        {
            "x": -1.5910574197769165,
            "y": 0.3679024279117584,
            "z": -37.607357025146484
        },
        {
            "x": -1.5936946868896484,
            "y": 0.3663427531719208,
            "z": -37.4486198425293
        },
        {
            "x": -1.5983145236968994,
            "y": 0.36463046073913574,
            "z": -37.28988265991211
        },
        {
            "x": -1.6049134731292725,
            "y": 0.36276909708976746,
            "z": -37.13124084472656
        },
        {
            "x": -1.6135215759277344,
            "y": 0.3607574999332428,
            "z": -36.972782135009766
        },
        {
            "x": -1.6240198612213135,
            "y": 0.3586021065711975,
            "z": -36.81428146362305
        },
        {
            "x": -1.6363240480422974,
            "y": 0.35631275177001953,
            "z": -36.65617370605469
        },
        {
            "x": -1.6503815650939941,
            "y": 0.3538894057273865,
            "z": -36.498260498046875
        },
        {
            "x": -1.666185736656189,
            "y": 0.35133036971092224,
            "z": -36.340579986572266
        },
        {
            "x": -1.68358314037323,
            "y": 0.3486454486846924,
            "z": -36.1831169128418
        },
        {
            "x": -1.7025058269500732,
            "y": 0.3458360433578491,
            "z": -36.02581024169922
        },
        {
            "x": -1.7228679656982422,
            "y": 0.342907190322876,
            "z": -35.868736267089844
        },
        {
            "x": -1.7446420192718506,
            "y": 0.33985888957977295,
            "z": -35.71201705932617
        },
        {
            "x": -1.76771080493927,
            "y": 0.3366962969303131,
            "z": -35.55542755126953
        },
        {
            "x": -1.79197359085083,
            "y": 0.3334265947341919,
            "z": -35.39918899536133
        },
        {
            "x": -1.8173737525939941,
            "y": 0.33005136251449585,
            "z": -35.243194580078125
        },
        {
            "x": -1.8439345359802246,
            "y": 0.32656434178352356,
            "z": -35.08723831176758
        },
        {
            "x": -1.8714709281921387,
            "y": 0.3229825496673584,
            "z": -34.93170166015625
        },
        {
            "x": -1.8999693393707275,
            "y": 0.3193034529685974,
            "z": -34.77634048461914
        },
        {
            "x": -1.9293642044067383,
            "y": 0.3155313730239868,
            "z": -34.621177673339844
        },
        {
            "x": -1.9596315622329712,
            "y": 0.3116673231124878,
            "z": -34.46628952026367
        },
        {
            "x": -1.990735411643982,
            "y": 0.30771148204803467,
            "z": -34.3114013671875
        },
        {
            "x": -2.022548198699951,
            "y": 0.30367738008499146,
            "z": -34.156890869140625
        },
        {
            "x": -2.05507493019104,
            "y": 0.2995631992816925,
            "z": -34.00257110595703
        },
        {
            "x": -2.0883190631866455,
            "y": 0.29536616802215576,
            "z": -33.848323822021484
        },
        {
            "x": -2.12217378616333,
            "y": 0.2910977602005005,
            "z": -33.69435119628906
        },
        {
            "x": -2.156643867492676,
            "y": 0.28675606846809387,
            "z": -33.540443420410156
        },
        {
            "x": -2.191681146621704,
            "y": 0.28234678506851196,
            "z": -33.38668441772461
        },
        {
            "x": -2.22724986076355,
            "y": 0.2778734564781189,
            "z": -33.23318862915039
        },
        {
            "x": -2.2512452602386475,
            "y": 0.2748571038246155,
            "z": -33.13093948364258
        },
        {
            "x": -2.2875874042510986,
            "y": 0.27028653025627136,
            "z": -32.97774124145508
        },
        {
            "x": -2.3239922523498535,
            "y": 0.265667200088501,
            "z": -32.824951171875
        },
        {
            "x": -2.36008882522583,
            "y": 0.26099175214767456,
            "z": -32.672096252441406
        },
        {
            "x": -2.3957059383392334,
            "y": 0.25627049803733826,
            "z": -32.51938247680664
        },
        {
            "x": -2.430833578109741,
            "y": 0.2515008747577667,
            "z": -32.366607666015625
        },
        {
            "x": -2.4654128551483154,
            "y": 0.2466813623905182,
            "z": -32.213645935058594
        },
        {
            "x": -2.4993300437927246,
            "y": 0.24182294309139252,
            "z": -32.06070327758789
        },
        {
            "x": -2.532573938369751,
            "y": 0.23692314326763153,
            "z": -31.907577514648438
        },
        {
            "x": -2.5650486946105957,
            "y": 0.23198798298835754,
            "z": -31.754335403442383
        },
        {
            "x": -2.5966317653656006,
            "y": 0.22702302038669586,
            "z": -31.60106658935547
        },
        {
            "x": -2.6272974014282227,
            "y": 0.22202548384666443,
            "z": -31.447546005249023
        },
        {
            "x": -2.656938076019287,
            "y": 0.21700674295425415,
            "z": -31.294017791748047
        },
        {
            "x": -2.68550705909729,
            "y": 0.2119663506746292,
            "z": -31.140331268310547
        },
        {
            "x": -2.7129321098327637,
            "y": 0.20690050721168518,
            "z": -30.986286163330078
        },
        {
            "x": -2.7390782833099365,
            "y": 0.20182615518569946,
            "z": -30.8322811126709
        },
        {
            "x": -2.763951301574707,
            "y": 0.19673851132392883,
            "z": -30.678049087524414
        },
        {
            "x": -2.7874855995178223,
            "y": 0.19164279103279114,
            "z": -30.52364730834961
        },
        {
            "x": -2.8095853328704834,
            "y": 0.18654432892799377,
            "z": -30.36912727355957
        },
        {
            "x": -2.8302435874938965,
            "y": 0.181438148021698,
            "z": -30.2142276763916
        },
        {
            "x": -2.849409341812134,
            "y": 0.17634084820747375,
            "z": -30.05935287475586
        },
        {
            "x": -2.8670847415924072,
            "y": 0.17124930024147034,
            "z": -29.904321670532227
        },
        {
            "x": -2.8832225799560547,
            "y": 0.16616711020469666,
            "z": -29.74911880493164
        },
        {
            "x": -2.897812604904175,
            "y": 0.16109779477119446,
            "z": -29.593759536743164
        },
        {
            "x": -2.9109065532684326,
            "y": 0.15587672591209412,
            "z": -29.438194274902344
        },
        {
            "x": -2.9225056171417236,
            "y": 0.1495540738105774,
            "z": -29.282569885253906
        },
        {
            "x": -2.932600259780884,
            "y": 0.14192664623260498,
            "z": -29.12696647644043
        },
        {
            "x": -2.941222667694092,
            "y": 0.13306501507759094,
            "z": -28.97119903564453
        },
        {
            "x": -2.9484410285949707,
            "y": 0.12310934066772461,
            "z": -28.815502166748047
        },
        {
            "x": -2.9543044567108154,
            "y": 0.11214281618595123,
            "z": -28.659772872924805
        },
        {
            "x": -2.958845853805542,
            "y": 0.10022856295108795,
            "z": -28.503829956054688
        },
        {
            "x": -2.96207857131958,
            "y": 0.08747251331806183,
            "z": -28.34807777404785
        },
        {
            "x": -2.9641075134277344,
            "y": 0.0739767849445343,
            "z": -28.1922664642334
        },
        {
            "x": -2.9649837017059326,
            "y": 0.05983581393957138,
            "z": -28.036453247070312
        },
        {
            "x": -2.964756727218628,
            "y": 0.04514226317405701,
            "z": -27.880704879760742
        },
        {
            "x": -2.9634337425231934,
            "y": 0.02994723990559578,
            "z": -27.72476577758789
        },
        {
            "x": -2.961125612258911,
            "y": 0.014402912929654121,
            "z": -27.569032669067383
        },
        {
            "x": -2.9578754901885986,
            "y": -0.001421208493411541,
            "z": -27.413299560546875
        },
        {
            "x": -2.953732967376709,
            "y": -0.017446152865886688,
            "z": -27.257455825805664
        },
        {
            "x": -2.948716878890991,
            "y": -0.03356115520000458,
            "z": -27.10171890258789
        },
        {
            "x": -2.942899465560913,
            "y": -0.049689412117004395,
            "z": -26.945878982543945
        },
        {
            "x": -2.936307430267334,
            "y": -0.06572499871253967,
            "z": -26.790084838867188
        },
        {
            "x": -2.9288370609283447,
            "y": -0.08156391978263855,
            "z": -26.634477615356445
        },
        {
            "x": -2.9233200550079346,
            "y": -0.09196960180997849,
            "z": -26.530744552612305
        },
        {
            "x": -2.9142684936523438,
            "y": -0.10728852450847626,
            "z": -26.375226974487305
        },
        {
            "x": -2.9041495323181152,
            "y": -0.12217675894498825,
            "z": -26.219806671142578
        },
        {
            "x": -2.8928611278533936,
            "y": -0.1365526169538498,
            "z": -26.064245223999023
        },
        {
            "x": -2.880364179611206,
            "y": -0.15028120577335358,
            "z": -25.908937454223633
        },
        {
            "x": -2.8666396141052246,
            "y": -0.16330265998840332,
            "z": -25.753707885742188
        },
        {
            "x": -2.8516299724578857,
            "y": -0.17553448677062988,
            "z": -25.598451614379883
        },
        {
            "x": -2.8352973461151123,
            "y": -0.18685370683670044,
            "z": -25.44341278076172
        },
        {
            "x": -2.8175437450408936,
            "y": -0.19715872406959534,
            "z": -25.288373947143555
        },
        {
            "x": -2.7983622550964355,
            "y": -0.20638030767440796,
            "z": -25.133466720581055
        },
        {
            "x": -2.777726411819458,
            "y": -0.2144203931093216,
            "z": -24.97882843017578
        },
        {
            "x": -2.755566120147705,
            "y": -0.22118592262268066,
            "z": -24.824251174926758
        },
        {
            "x": -2.731783151626587,
            "y": -0.22652670741081238,
            "z": -24.66999053955078
        },
        {
            "x": -2.7064032554626465,
            "y": -0.23040631413459778,
            "z": -24.516000747680664
        },
        {
            "x": -2.679356098175049,
            "y": -0.2332334965467453,
            "z": -24.36210060119629
        },
        {
            "x": -2.6506404876708984,
            "y": -0.23586350679397583,
            "z": -24.208765029907227
        },
        {
            "x": -2.620126247406006,
            "y": -0.23760753870010376,
            "z": -24.055675506591797
        },
        {
            "x": -2.587848663330078,
            "y": -0.2378651201725006,
            "z": -23.902984619140625
        },
        {
            "x": -2.5538065433502197,
            "y": -0.23672406375408173,
            "z": -23.750730514526367
        },
        {
            "x": -2.5179190635681152,
            "y": -0.23426330089569092,
            "z": -23.5987548828125
        },
        {
            "x": -2.480168342590332,
            "y": -0.23052978515625,
            "z": -23.44745445251465
        },
        {
            "x": -2.440656900405884,
            "y": -0.22565564513206482,
            "z": -23.296249389648438
        },
        {
            "x": -2.4002323150634766,
            "y": -0.21971547603607178,
            "z": -23.144800186157227
        },
        {
            "x": -2.359259605407715,
            "y": -0.21280720829963684,
            "z": -22.99353790283203
        },
        {
            "x": -2.317681312561035,
            "y": -0.20497483015060425,
            "z": -22.842397689819336
        },
        {
            "x": -2.2755353450775146,
            "y": -0.1963542103767395,
            "z": -22.691465377807617
        },
        {
            "x": -2.232839345932007,
            "y": -0.18703684210777283,
            "z": -22.540830612182617
        },
        {
            "x": -2.189544916152954,
            "y": -0.1770922839641571,
            "z": -22.390289306640625
        },
        {
            "x": -2.145714044570923,
            "y": -0.16660234332084656,
            "z": -22.240020751953125
        },
        {
            "x": -2.101386785507202,
            "y": -0.15567338466644287,
            "z": -22.089895248413086
        },
        {
            "x": -2.056560516357422,
            "y": -0.14437690377235413,
            "z": -21.93968963623047
        },
        {
            "x": -2.0114080905914307,
            "y": -0.13282422721385956,
            "z": -21.789758682250977
        },
        {
            "x": -1.9659337997436523,
            "y": -0.12108608335256577,
            "z": -21.639814376831055
        },
        {
            "x": -1.9202579259872437,
            "y": -0.10926035046577454,
            "z": -21.489866256713867
        },
        {
            "x": -1.8744947910308838,
            "y": -0.09752753376960754,
            "z": -21.339929580688477
        },
        {
            "x": -1.8286781311035156,
            "y": -0.08604845404624939,
            "z": -21.189697265625
        },
        {
            "x": -1.7830452919006348,
            "y": -0.07494468986988068,
            "z": -21.039501190185547
        },
        {
            "x": -1.7376561164855957,
            "y": -0.0642915815114975,
            "z": -20.889118194580078
        },
        {
            "x": -1.6925982236862183,
            "y": -0.0541841983795166,
            "z": -20.73839569091797
        },
        {
            "x": -1.6480759382247925,
            "y": -0.0447593554854393,
            "z": -20.587505340576172
        },
        {
            "x": -1.6041227579116821,
            "y": -0.03607605770230293,
            "z": -20.436222076416016
        },
        {
            "x": -1.5608817338943481,
            "y": -0.028238043189048767,
            "z": -20.284626007080078
        },
        {
            "x": -1.5185085535049438,
            "y": -0.02139146625995636,
            "z": -20.132774353027344
        },
        {
            "x": -1.4907574653625488,
            "y": -0.017404556274414062,
            "z": -20.03135108947754
        },
        {
            "x": -1.4499317407608032,
            "y": -0.012357661500573158,
            "z": -19.878929138183594
        },
        {
            "x": -1.4101808071136475,
            "y": -0.008577913045883179,
            "z": -19.726139068603516
        },
        {
            "x": -1.3714755773544312,
            "y": -0.006105374079197645,
            "z": -19.572826385498047
        },
        {
            "x": -1.3339505195617676,
            "y": -0.005040046293288469,
            "z": -19.419395446777344
        },
        {
            "x": -1.2976242303848267,
            "y": -0.004999999888241291,
            "z": -19.2656192779541
        },
        {
            "x": -1.2624839544296265,
            "y": -0.005000009201467037,
            "z": -19.111433029174805
        },
        {
            "x": -1.2285608053207397,
            "y": -0.0050000036135315895,
            "z": -18.957107543945312
        },
        {
            "x": -1.195806860923767,
            "y": -0.005000002682209015,
            "z": -18.802425384521484
        },
        {
            "x": -1.1642884016036987,
            "y": -0.004999998956918716,
            "z": -18.647510528564453
        },
        {
            "x": -1.1339203119277954,
            "y": -0.005000002682209015,
            "z": -18.492488861083984
        },
        {
            "x": -1.1046544313430786,
            "y": -0.005000000819563866,
            "z": -18.3371639251709
        },
        {
            "x": -1.07649564743042,
            "y": -0.00500000175088644,
            "z": -18.181787490844727
        },
        {
            "x": -1.0493953227996826,
            "y": -0.005000002682209015,
            "z": -18.026262283325195
        },
        {
            "x": -1.023214340209961,
            "y": -0.004999998956918716,
            "z": -17.87040138244629
        },
        {
            "x": -0.9979830980300903,
            "y": -0.004999998025596142,
            "z": -17.71465301513672
        },
        {
            "x": -0.9736250638961792,
            "y": -0.004999997094273567,
            "z": -17.558732986450195
        },
        {
            "x": -0.9500455260276794,
            "y": -0.004999998025596142,
            "z": -17.40274429321289
        },
        {
            "x": -0.927191436290741,
            "y": -0.004999998025596142,
            "z": -17.24675750732422
        },
        {
            "x": -0.904956042766571,
            "y": -0.004999996162950993,
            "z": -17.090513229370117
        },
        {
            "x": -0.8833337426185608,
            "y": -0.00500000175088644,
            "z": -16.934429168701172
        },
        {
            "x": -0.8622104525566101,
            "y": -0.00500000175088644,
            "z": -16.778337478637695
        },
        {
            "x": -0.8415075540542603,
            "y": -0.005000004544854164,
            "z": -16.62223243713379
        },
        {
            "x": -0.8211594820022583,
            "y": -0.004999998956918716,
            "z": -16.466135025024414
        },
        {
            "x": -0.8010843992233276,
            "y": -0.005000005476176739,
            "z": -16.309940338134766
        },
        {
            "x": -0.7812012434005737,
            "y": -0.00500000175088644,
            "z": -16.153770446777344
        },
        {
            "x": -0.7614532113075256,
            "y": -0.00500000175088644,
            "z": -15.997745513916016
        },
        {
            "x": -0.7417118549346924,
            "y": -0.004999999888241291,
            "z": -15.841660499572754
        },
        {
            "x": -0.7220011353492737,
            "y": -0.004999997094273567,
            "z": -15.6854829788208
        },
        {
            "x": -0.7029286026954651,
            "y": -0.0050000036135315895,
            "z": -15.528857231140137
        },
        {
            "x": -0.6846978068351746,
            "y": -0.00500000175088644,
            "z": -15.372007369995117
        },
        {
            "x": -0.6671838164329529,
            "y": -0.005000006407499313,
            "z": -15.215372085571289
        },
        {
            "x": -0.6502399444580078,
            "y": -0.004999998025596142,
            "z": -15.058700561523438
        },
        {
            "x": -0.6337137222290039,
            "y": -0.00500000175088644,
            "z": -14.902069091796875
        },
        {
            "x": -0.617481529712677,
            "y": -0.004999998956918716,
            "z": -14.7455415725708
        },
        {
            "x": -0.6013937592506409,
            "y": -0.005000004544854164,
            "z": -14.588869094848633
        },
        {
            "x": -0.5854088068008423,
            "y": -0.00500000175088644,
            "z": -14.432415962219238
        },
        {
            "x": -0.5694736838340759,
            "y": -0.004999998956918716,
            "z": -14.275972366333008
        },
        {
            "x": -0.553556501865387,
            "y": -0.005000002682209015,
            "z": -14.119425773620605
        },
        {
            "x": -0.5376620888710022,
            "y": -0.005000004544854164,
            "z": -13.96299934387207
        },
        {
            "x": -0.5217546820640564,
            "y": -0.005000011064112186,
            "z": -13.806483268737793
        },
        {
            "x": -0.5058311223983765,
            "y": -0.004999998025596142,
            "z": -13.649971008300781
        },
        {
            "x": -0.4898911416530609,
            "y": -0.004999998025596142,
            "z": -13.493571281433105
        },
        {
            "x": -0.47924578189849854,
            "y": -0.004999999888241291,
            "z": -13.389309883117676
        },
        {
            "x": -0.4632372558116913,
            "y": -0.005000005476176739,
            "z": -13.232925415039062
        },
        {
            "x": -0.4471776485443115,
            "y": -0.004999996162950993,
            "z": -13.07654857635498
        },
        {
            "x": -0.4310412108898163,
            "y": -0.00500000175088644,
            "z": -12.91998291015625
        },
        {
            "x": -0.41486406326293945,
            "y": -0.005000005476176739,
            "z": -12.763623237609863
        },
        {
            "x": -0.398628294467926,
            "y": -0.00500000175088644,
            "z": -12.607267379760742
        },
        {
            "x": -0.38232138752937317,
            "y": -0.004999996162950993,
            "z": -12.450810432434082
        },
        {
            "x": -0.36596423387527466,
            "y": -0.005000002682209015,
            "z": -12.294471740722656
        },
        {
            "x": -0.3495337963104248,
            "y": -0.005000002682209015,
            "z": -12.13803768157959
        },
        {
            "x": -0.3330445885658264,
            "y": -0.004999998025596142,
            "z": -11.981607437133789
        },
        {
            "x": -0.31651416420936584,
            "y": -0.004999998956918716,
            "z": -11.825301170349121
        },
        {
            "x": -0.2996704876422882,
            "y": -0.004999998956918716,
            "z": -11.669254302978516
        },
        {
            "x": -0.28204840421676636,
            "y": -0.005000006407499313,
            "z": -11.513479232788086
        },
        {
            "x": -0.2636840343475342,
            "y": -0.005000000819563866,
            "z": -11.35775089263916
        },
        {
            "x": -0.24461710453033447,
            "y": -0.005000000819563866,
            "z": -11.201865196228027
        },
        {
            "x": -0.2249348759651184,
            "y": -0.004999998025596142,
            "z": -11.046210289001465
        },
        {
            "x": -0.204708069562912,
            "y": -0.004999998956918716,
            "z": -10.890533447265625
        },
        {
            "x": -0.18400917947292328,
            "y": -0.005000000819563866,
            "z": -10.734875679016113
        },
        {
            "x": -0.1629049926996231,
            "y": -0.0050000036135315895,
            "z": -10.579285621643066
        },
        {
            "x": -0.14142437279224396,
            "y": -0.004999998025596142,
            "z": -10.423505783081055
        },
        {
            "x": -0.11970111727714539,
            "y": -0.004999999888241291,
            "z": -10.26791763305664
        },
        {
            "x": -0.09784792363643646,
            "y": -0.00500000175088644,
            "z": -10.112060546875
        },
        {
            "x": -0.07657899707555771,
            "y": -0.005000004544854164,
            "z": -9.955831527709961
        },
        {
            "x": -0.056075941771268845,
            "y": -0.005000000819563866,
            "z": -9.7994966506958
        },
        {
            "x": -0.03631655499339104,
            "y": -0.004999997094273567,
            "z": -9.642965316772461
        },
        {
            "x": -0.017317621037364006,
            "y": -0.005000005476176739,
            "z": -9.486339569091797
        },
        {
            "x": 0.000869089737534523,
            "y": -0.005000000819563866,
            "z": -9.329721450805664
        },
        {
            "x": 0.018308274447917938,
            "y": -0.005000002682209015,
            "z": -9.172908782958984
        },
        {
            "x": 0.034978047013282776,
            "y": -0.00500000175088644,
            "z": -9.01612377166748
        },
        {
            "x": 0.05087907984852791,
            "y": -0.005000004544854164,
            "z": -8.859264373779297
        },
        {
            "x": 0.06602928787469864,
            "y": -0.00500000175088644,
            "z": -8.702134132385254
        },
        {
            "x": 0.08042309433221817,
            "y": -0.005000000819563866,
            "z": -8.54514217376709
        },
        {
            "x": 0.09409654140472412,
            "y": -0.004999998025596142,
            "z": -8.388035774230957
        },
        {
            "x": 0.10702862590551376,
            "y": -0.0050000036135315895,
            "z": -8.230876922607422
        },
        {
            "x": 0.11925533413887024,
            "y": -0.004999998025596142,
            "z": -8.073731422424316
        },
        {
            "x": 0.13082483410835266,
            "y": -0.0050000036135315895,
            "z": -7.916352272033691
        },
        {
            "x": 0.1417265385389328,
            "y": -0.005000007338821888,
            "z": -7.759140491485596
        },
        {
            "x": 0.15198847651481628,
            "y": -0.004999998956918716,
            "z": -7.601920127868652
        },
        {
            "x": 0.16174697875976562,
            "y": -0.005000004544854164,
            "z": -7.444640636444092
        },
        {
            "x": 0.17114587128162384,
            "y": -0.005000002682209015,
            "z": -7.28754186630249
        },
        {
            "x": 0.18036231398582458,
            "y": -0.005000004544854164,
            "z": -7.130429267883301
        },
        {
            "x": 0.1895730048418045,
            "y": -0.005000004544854164,
            "z": -6.973420143127441
        },
        {
            "x": 0.1989540457725525,
            "y": -0.005000002682209015,
            "z": -6.816624164581299
        },
        {
            "x": 0.20539739727973938,
            "y": -0.005000006407499313,
            "z": -6.712161064147949
        },
        {
            "x": 0.2154524326324463,
            "y": -0.005000000819563866,
            "z": -6.555408954620361
        },
        {
            "x": 0.2252790778875351,
            "y": -0.005000009201467037,
            "z": -6.397904396057129
        },
        {
            "x": 0.2335173338651657,
            "y": -0.004999999888241291,
            "z": -6.2396416664123535
        },
        {
            "x": 0.23973442614078522,
            "y": -0.004999999888241291,
            "z": -6.0814900398254395
        },
        {
            "x": 0.24408569931983948,
            "y": -0.00500000175088644,
            "z": -5.9233269691467285
        },
        {
            "x": 0.24677208065986633,
            "y": -0.005000000819563866,
            "z": -5.7653374671936035
        },
        {
            "x": 0.2488219439983368,
            "y": -0.004999997094273567,
            "z": -5.6079840660095215
        },
        {
            "x": 0.2507103383541107,
            "y": -0.004999998956918716,
            "z": -5.450592994689941
        },
        {
            "x": 0.2524721324443817,
            "y": -0.004999997094273567,
            "z": -5.293204307556152
        },
        {
            "x": 0.25411227345466614,
            "y": -0.005000002682209015,
            "z": -5.135915279388428
        },
        {
            "x": 0.2554573118686676,
            "y": -0.004999994300305843,
            "z": -4.9781084060668945
        },
        {
            "x": 0.2553549110889435,
            "y": -0.004999999888241291,
            "z": -4.820045471191406
        },
        {
            "x": 0.25380760431289673,
            "y": -0.00500000175088644,
            "z": -4.6620988845825195
        },
        {
            "x": 0.2510221302509308,
            "y": -0.004999998956918716,
            "z": -4.504079341888428
        },
        {
            "x": 0.24720893800258636,
            "y": -0.00500000175088644,
            "z": -4.3463945388793945
        },
        {
            "x": 0.24254098534584045,
            "y": -0.005000007338821888,
            "z": -4.1887922286987305
        },
        {
            "x": 0.2372586876153946,
            "y": -0.004999998956918716,
            "z": -4.031318187713623
        },
        {
            "x": 0.23156903684139252,
            "y": -0.005000002682209015,
            "z": -3.8740243911743164
        },
        {
            "x": 0.2256673276424408,
            "y": -0.005000000819563866,
            "z": -3.7166481018066406
        },
        {
            "x": 0.21978306770324707,
            "y": -0.005000000819563866,
            "z": -3.5595691204071045
        },
        {
            "x": 0.21384835243225098,
            "y": -0.004999998025596142,
            "z": -3.402301549911499
        },
        {
            "x": 0.2075270414352417,
            "y": -0.004999998025596142,
            "z": -3.2450132369995117
        },
        {
            "x": 0.2009410262107849,
            "y": -0.005000005476176739,
            "z": -3.087815523147583
        },
        {
            "x": 0.1942351907491684,
            "y": -0.004999998956918716,
            "z": -2.930612564086914
        },
        {
            "x": 0.18758292496204376,
            "y": -0.004999998025596142,
            "z": -2.773487091064453
        },
        {
            "x": 0.18114565312862396,
            "y": -0.005000005476176739,
            "z": -2.6165430545806885
        },
        {
            "x": 0.17507390677928925,
            "y": -0.004999998025596142,
            "z": -2.4595563411712646
        },
        {
            "x": 0.1695011407136917,
            "y": -0.0050000036135315895,
            "z": -2.3026511669158936
        },
        {
            "x": 0.16426049172878265,
            "y": -0.005000002682209015,
            "z": -2.1456267833709717
        },
        {
            "x": 0.15913468599319458,
            "y": -0.004999997094273567,
            "z": -1.9882932901382446
        },
        {
            "x": 0.15394069254398346,
            "y": -0.005000000819563866,
            "z": -1.8310593366622925
        },
        {
            "x": 0.14846567809581757,
            "y": -0.005000000819563866,
            "z": -1.6736786365509033
        },
        {
            "x": 0.14253950119018555,
            "y": -0.0050000036135315895,
            "z": -1.5162287950515747
        },
        {
            "x": 0.1360141634941101,
            "y": -0.005000002682209015,
            "z": -1.3587863445281982
        },
        {
            "x": 0.1287493109703064,
            "y": -0.005000005476176739,
            "z": -1.2011164426803589
        },
        {
            "x": 0.12063050270080566,
            "y": -0.004999997094273567,
            "z": -1.0436784029006958
        },
        {
            "x": 0.11197768896818161,
            "y": -0.005000005476176739,
            "z": -0.8866046071052551
        },
        {
            "x": 0.10342762619256973,
            "y": -0.004999999888241291,
            "z": -0.7296066284179688
        },
        {
            "x": 0.09521497040987015,
            "y": -0.004999998025596142,
            "z": -0.5728389620780945
        },
        {
            "x": 0.08774901926517487,
            "y": -0.004999998956918716,
            "z": -0.41620030999183655
        },
        {
            "x": 0.08170805126428604,
            "y": -0.004999998956918716,
            "z": -0.259973406791687
        },
        {
            "x": 0.07832901179790497,
            "y": -0.004999998956918716,
            "z": -0.10464692860841751
        },
        {
            "x": 0.0784907191991806,
            "y": -0.005000002682209015,
            "z": -0.0013302593724802136
        }
    ],
    "lane5":[
        {
            "x": 0.1623421013355255,
            "y": -0.005000000819563866,
            "z": -0.002249367767944932
        },
        {
            "x": 0.16218234598636627,
            "y": -0.004999997094273567,
            "z": -0.1039738729596138
        },
        {
            "x": 0.1655227094888687,
            "y": -0.004999995231628418,
            "z": -0.2573280930519104
        },
        {
            "x": 0.17152440547943115,
            "y": -0.004999995231628418,
            "z": -0.4125135838985443
        },
        {
            "x": 0.17896457016468048,
            "y": -0.005000017583370209,
            "z": -0.5686095356941223
        },
        {
            "x": 0.18716378509998322,
            "y": -0.004999997094273567,
            "z": -0.7251178026199341
        },
        {
            "x": 0.19570758938789368,
            "y": -0.005000006407499313,
            "z": -0.8820008039474487
        },
        {
            "x": 0.20436494052410126,
            "y": -0.004999995231628418,
            "z": -1.0391581058502197
        },
        {
            "x": 0.21250629425048828,
            "y": -0.005000010132789612,
            "z": -1.1970314979553223
        },
        {
            "x": 0.21979057788848877,
            "y": -0.005000002682209015,
            "z": -1.3551238775253296
        },
        {
            "x": 0.22633084654808044,
            "y": -0.005000000819563866,
            "z": -1.5129258632659912
        },
        {
            "x": 0.23226767778396606,
            "y": -0.005000004544854164,
            "z": -1.6706581115722656
        },
        {
            "x": 0.23774948716163635,
            "y": -0.005000004544854164,
            "z": -1.8282318115234375
        },
        {
            "x": 0.24294646084308624,
            "y": -0.004999997094273567,
            "z": -1.9855564832687378
        },
        {
            "x": 0.2480718344449997,
            "y": -0.005000002682209015,
            "z": -2.1428771018981934
        },
        {
            "x": 0.25330838561058044,
            "y": -0.005000004544854164,
            "z": -2.2997779846191406
        },
        {
            "x": 0.25887271761894226,
            "y": -0.005000002682209015,
            "z": -2.456450939178467
        },
        {
            "x": 0.2649352252483368,
            "y": -0.005000006407499313,
            "z": -2.6131954193115234
        },
        {
            "x": 0.27136608958244324,
            "y": -0.004999998956918716,
            "z": -2.7699828147888184
        },
        {
            "x": 0.2780155539512634,
            "y": -0.005000000819563866,
            "z": -2.92704176902771
        },
        {
            "x": 0.28472205996513367,
            "y": -0.005000006407499313,
            "z": -3.0842599868774414
        },
        {
            "x": 0.29131248593330383,
            "y": -0.004999998956918716,
            "z": -3.2415645122528076
        },
        {
            "x": 0.2976410984992981,
            "y": -0.004999995231628418,
            "z": -3.3990349769592285
        },
        {
            "x": 0.3035816252231598,
            "y": -0.004999998956918716,
            "z": -3.5564541816711426
        },
        {
            "x": 0.30946430563926697,
            "y": -0.005000000819563866,
            "z": -3.713491201400757
        },
        {
            "x": 0.31536805629730225,
            "y": -0.005000006407499313,
            "z": -3.8709218502044678
        },
        {
            "x": 0.32106372714042664,
            "y": -0.005000004544854164,
            "z": -4.028382778167725
        },
        {
            "x": 0.3263552486896515,
            "y": -0.005000008270144463,
            "z": -4.18613338470459
        },
        {
            "x": 0.33103469014167786,
            "y": -0.005000002682209015,
            "z": -4.34412145614624
        },
        {
            "x": 0.3348598778247833,
            "y": -0.005000011995434761,
            "z": -4.5023064613342285
        },
        {
            "x": 0.3376559317111969,
            "y": -0.005000002682209015,
            "z": -4.66093635559082
        },
        {
            "x": 0.33921000361442566,
            "y": -0.004999997094273567,
            "z": -4.819600582122803
        },
        {
            "x": 0.3393130898475647,
            "y": -0.004999995231628418,
            "z": -4.978489875793457
        },
        {
            "x": 0.3379644453525543,
            "y": -0.005000002682209015,
            "z": -5.136758327484131
        },
        {
            "x": 0.33632364869117737,
            "y": -0.004999995231628418,
            "z": -5.294111251831055
        },
        {
            "x": 0.33456113934516907,
            "y": -0.005000004544854164,
            "z": -5.451566696166992
        },
        {
            "x": 0.3326719105243683,
            "y": -0.004999995231628418,
            "z": -5.60902738571167
        },
        {
            "x": 0.33062028884887695,
            "y": -0.005000002682209015,
            "z": -5.766512870788574
        },
        {
            "x": 0.32792210578918457,
            "y": -0.005000002682209015,
            "z": -5.925159454345703
        },
        {
            "x": 0.323543906211853,
            "y": -0.004999997094273567,
            "z": -6.084291458129883
        },
        {
            "x": 0.31728696823120117,
            "y": -0.005000000819563866,
            "z": -6.2434611320495605
        },
        {
            "x": 0.3089960217475891,
            "y": -0.005000004544854164,
            "z": -6.402740955352783
        },
        {
            "x": 0.2991348206996918,
            "y": -0.004999997094273567,
            "z": -6.560810089111328
        },
        {
            "x": 0.28908950090408325,
            "y": -0.005000006407499313,
            "z": -6.717408657073975
        },
        {
            "x": 0.2826555371284485,
            "y": -0.005000002682209015,
            "z": -6.821719169616699
        },
        {
            "x": 0.2732834219932556,
            "y": -0.005000000819563866,
            "z": -6.978367328643799
        },
        {
            "x": 0.2640756070613861,
            "y": -0.004999997094273567,
            "z": -7.135327339172363
        },
        {
            "x": 0.2548563778400421,
            "y": -0.004999997094273567,
            "z": -7.292488098144531
        },
        {
            "x": 0.24544890224933624,
            "y": -0.005000000819563866,
            "z": -7.449728965759277
        },
        {
            "x": 0.23567603528499603,
            "y": -0.005000000819563866,
            "z": -7.607238292694092
        },
        {
            "x": 0.2253938764333725,
            "y": -0.005000004544854164,
            "z": -7.764767646789551
        },
        {
            "x": 0.21446865797042847,
            "y": -0.004999997094273567,
            "z": -7.9223198890686035
        },
        {
            "x": 0.20287291705608368,
            "y": -0.005000004544854164,
            "z": -8.080055236816406
        },
        {
            "x": 0.19061751663684845,
            "y": -0.004999998956918716,
            "z": -8.237569808959961
        },
        {
            "x": 0.17765435576438904,
            "y": -0.004999998956918716,
            "z": -8.39510726928711
        },
        {
            "x": 0.1639471799135208,
            "y": -0.004999998956918716,
            "z": -8.55260181427002
        },
        {
            "x": 0.14951711893081665,
            "y": -0.005000006407499313,
            "z": -8.709988594055176
        },
        {
            "x": 0.13432830572128296,
            "y": -0.005000006407499313,
            "z": -8.867518424987793
        },
        {
            "x": 0.11838643252849579,
            "y": -0.004999995231628418,
            "z": -9.024781227111816
        },
        {
            "x": 0.10167330503463745,
            "y": -0.005000006407499313,
            "z": -9.181973457336426
        },
        {
            "x": 0.0841885507106781,
            "y": -0.004999998956918716,
            "z": -9.339195251464844
        },
        {
            "x": 0.06595411896705627,
            "y": -0.005000021308660507,
            "z": -9.496223449707031
        },
        {
            "x": 0.04690562188625336,
            "y": -0.004999995231628418,
            "z": -9.653260231018066
        },
        {
            "x": 0.02709454484283924,
            "y": -0.004999998956918716,
            "z": -9.810199737548828
        },
        {
            "x": 0.006537983193993568,
            "y": -0.005000006407499313,
            "z": -9.966940879821777
        },
        {
            "x": -0.01478548999875784,
            "y": -0.004999998956918716,
            "z": -10.12357234954834
        },
        {
            "x": -0.03665843605995178,
            "y": -0.005000002682209015,
            "z": -10.279572486877441
        },
        {
            "x": -0.05836428701877594,
            "y": -0.004999995231628418,
            "z": -10.43503475189209
        },
        {
            "x": -0.07982254773378372,
            "y": -0.004999998956918716,
            "z": -10.590653419494629
        },
        {
            "x": -0.10090000182390213,
            "y": -0.005000017583370209,
            "z": -10.746045112609863
        },
        {
            "x": -0.12156759202480316,
            "y": -0.005000002682209015,
            "z": -10.901468276977539
        },
        {
            "x": -0.14175920188426971,
            "y": -0.004999995231628418,
            "z": -11.056873321533203
        },
        {
            "x": -0.16140258312225342,
            "y": -0.005000002682209015,
            "z": -11.2122220993042
        },
        {
            "x": -0.18042731285095215,
            "y": -0.004999998956918716,
            "z": -11.367761611938477
        },
        {
            "x": -0.19874656200408936,
            "y": -0.004999998956918716,
            "z": -11.52310848236084
        },
        {
            "x": -0.21632133424282074,
            "y": -0.004999995231628418,
            "z": -11.67846393585205
        },
        {
            "x": -0.23312661051750183,
            "y": -0.004999998956918716,
            "z": -11.834156036376953
        },
        {
            "x": -0.2496517449617386,
            "y": -0.0049999915063381195,
            "z": -11.990412712097168
        },
        {
            "x": -0.2661378085613251,
            "y": -0.005000006407499313,
            "z": -12.146812438964844
        },
        {
            "x": -0.28256478905677795,
            "y": -0.005000002682209015,
            "z": -12.303213119506836
        },
        {
            "x": -0.2989184856414795,
            "y": -0.005000002682209015,
            "z": -12.45952033996582
        },
        {
            "x": -0.3152219355106354,
            "y": -0.005000002682209015,
            "z": -12.615944862365723
        },
        {
            "x": -0.33145442605018616,
            "y": -0.005000010132789612,
            "z": -12.77226734161377
        },
        {
            "x": -0.3476283848285675,
            "y": -0.005000002682209015,
            "z": -12.928597450256348
        },
        {
            "x": -0.3637616038322449,
            "y": -0.004999998956918716,
            "z": -13.08513069152832
        },
        {
            "x": -0.3798181712627411,
            "y": -0.005000002682209015,
            "z": -13.241477966308594
        },
        {
            "x": -0.39582401514053345,
            "y": -0.004999995231628418,
            "z": -13.397836685180664
        },
        {
            "x": -0.40646785497665405,
            "y": -0.004999995231628418,
            "z": -13.502083778381348
        },
        {
            "x": -0.42240598797798157,
            "y": -0.005000006407499313,
            "z": -13.658465385437012
        },
        {
            "x": -0.43832826614379883,
            "y": -0.005000002682209015,
            "z": -13.814964294433594
        },
        {
            "x": -0.45423510670661926,
            "y": -0.005000006407499313,
            "z": -13.971475601196289
        },
        {
            "x": -0.4701297879219055,
            "y": -0.005000006407499313,
            "z": -14.127904891967773
        },
        {
            "x": -0.48604801297187805,
            "y": -0.004999998956918716,
            "z": -14.28446102142334
        },
        {
            "x": -0.5019852519035339,
            "y": -0.0049999915063381195,
            "z": -14.440925598144531
        },
        {
            "x": -0.5179733633995056,
            "y": -0.005000002682209015,
            "z": -14.59740924835205
        },
        {
            "x": -0.5340669751167297,
            "y": -0.005000002682209015,
            "z": -14.75413990020752
        },
        {
            "x": -0.5503114461898804,
            "y": -0.004999998956918716,
            "z": -14.910784721374512
        },
        {
            "x": -0.5668572783470154,
            "y": -0.004999995231628418,
            "z": -15.06760025024414
        },
        {
            "x": -0.5838285684585571,
            "y": -0.005000002682209015,
            "z": -15.224527359008789
        },
        {
            "x": -0.6013795137405396,
            "y": -0.005000002682209015,
            "z": -15.381491661071777
        },
        {
            "x": -0.6196581721305847,
            "y": -0.005000002682209015,
            "z": -15.538752555847168
        },
        {
            "x": -0.6387884020805359,
            "y": -0.005000002682209015,
            "z": -15.695852279663086
        },
        {
            "x": -0.6585190892219543,
            "y": -0.004999995231628418,
            "z": -15.852189064025879
        },
        {
            "x": -0.6782590746879578,
            "y": -0.004999998956918716,
            "z": -16.00826072692871
        },
        {
            "x": -0.6980116367340088,
            "y": -0.004999998956918716,
            "z": -16.164325714111328
        },
        {
            "x": -0.7179056406021118,
            "y": -0.005000010132789612,
            "z": -16.320579528808594
        },
        {
            "x": -0.7379969358444214,
            "y": -0.005000006407499313,
            "z": -16.476898193359375
        },
        {
            "x": -0.7583658695220947,
            "y": -0.005000006407499313,
            "z": -16.633155822753906
        },
        {
            "x": -0.7790955305099487,
            "y": -0.005000006407499313,
            "z": -16.789464950561523
        },
        {
            "x": -0.8002514243125916,
            "y": -0.005000002682209015,
            "z": -16.9457950592041
        },
        {
            "x": -0.8219137191772461,
            "y": -0.005000002682209015,
            "z": -17.102170944213867
        },
        {
            "x": -0.8441953659057617,
            "y": -0.005000002682209015,
            "z": -17.258739471435547
        },
        {
            "x": -0.8671015501022339,
            "y": -0.005000002682209015,
            "z": -17.41507911682129
        },
        {
            "x": -0.890741229057312,
            "y": -0.004999995231628418,
            "z": -17.571468353271484
        },
        {
            "x": -0.9151683449745178,
            "y": -0.004999998956918716,
            "z": -17.72783088684082
        },
        {
            "x": -0.9404738545417786,
            "y": -0.005000010132789612,
            "z": -17.88404083251953
        },
        {
            "x": -0.9667401909828186,
            "y": -0.004999998956918716,
            "z": -18.0404052734375
        },
        {
            "x": -0.9939327836036682,
            "y": -0.005000002682209015,
            "z": -18.19645881652832
        },
        {
            "x": -1.0221929550170898,
            "y": -0.004999998956918716,
            "z": -18.352397918701172
        },
        {
            "x": -1.0515689849853516,
            "y": -0.005000002682209015,
            "z": -18.508304595947266
        },
        {
            "x": -1.0820555686950684,
            "y": -0.004999998956918716,
            "z": -18.663930892944336
        },
        {
            "x": -1.1137003898620605,
            "y": -0.00500001385807991,
            "z": -18.819467544555664
        },
        {
            "x": -1.1465895175933838,
            "y": -0.004999998956918716,
            "z": -18.974788665771484
        },
        {
            "x": -1.180652141571045,
            "y": -0.005000006407499313,
            "z": -19.129749298095703
        },
        {
            "x": -1.215939998626709,
            "y": -0.004999995231628418,
            "z": -19.284582138061523
        },
        {
            "x": -1.2524163722991943,
            "y": -0.005040069110691547,
            "z": -19.438993453979492
        },
        {
            "x": -1.2900935411453247,
            "y": -0.006108851637691259,
            "z": -19.593046188354492
        },
        {
            "x": -1.3289520740509033,
            "y": -0.008590441197156906,
            "z": -19.746965408325195
        },
        {
            "x": -1.3688546419143677,
            "y": -0.012383982539176941,
            "z": -19.90033721923828
        },
        {
            "x": -1.4098258018493652,
            "y": -0.01744786463677883,
            "z": -20.053306579589844
        },
        {
            "x": -1.4376708269119263,
            "y": -0.021447934210300446,
            "z": -20.155071258544922
        },
        {
            "x": -1.4801768064498901,
            "y": -0.02831518091261387,
            "z": -20.30739974975586
        },
        {
            "x": -1.5235382318496704,
            "y": -0.03617441654205322,
            "z": -20.45941734313965
        },
        {
            "x": -1.5675992965698242,
            "y": -0.04487858712673187,
            "z": -20.61107063293457
        },
        {
            "x": -1.6122126579284668,
            "y": -0.05432236194610596,
            "z": -20.76227378845215
        },
        {
            "x": -1.657343864440918,
            "y": -0.06444571167230606,
            "z": -20.91324234008789
        },
        {
            "x": -1.7027872800827026,
            "y": -0.07511119544506073,
            "z": -21.063800811767578
        },
        {
            "x": -1.7484551668167114,
            "y": -0.08622325211763382,
            "z": -21.214109420776367
        },
        {
            "x": -1.7942873239517212,
            "y": -0.09770599007606506,
            "z": -21.364395141601562
        },
        {
            "x": -1.8400459289550781,
            "y": -0.10943751037120819,
            "z": -21.51432228088379
        },
        {
            "x": -1.8857002258300781,
            "y": -0.12125764787197113,
            "z": -21.664196014404297
        },
        {
            "x": -1.9311363697052002,
            "y": -0.13298600912094116,
            "z": -21.814014434814453
        },
        {
            "x": -1.976235270500183,
            "y": -0.14452522993087769,
            "z": -21.96376609802246
        },
        {
            "x": -2.0209970474243164,
            "y": -0.1558055281639099,
            "z": -22.113754272460938
        },
        {
            "x": -2.065249443054199,
            "y": -0.1667163372039795,
            "z": -22.263629913330078
        },
        {
            "x": -2.1089975833892822,
            "y": -0.17718686163425446,
            "z": -22.413616180419922
        },
        {
            "x": -2.1522057056427,
            "y": -0.18711191415786743,
            "z": -22.56385612487793
        },
        {
            "x": -2.1948118209838867,
            "y": -0.1964101493358612,
            "z": -22.714174270629883
        },
        {
            "x": -2.2368695735931396,
            "y": -0.20501309633255005,
            "z": -22.864788055419922
        },
        {
            "x": -2.278362989425659,
            "y": -0.2128298580646515,
            "z": -23.0156192779541
        },
        {
            "x": -2.319253921508789,
            "y": -0.21972499787807465,
            "z": -23.16657829284668
        },
        {
            "x": -2.359595537185669,
            "y": -0.22565358877182007,
            "z": -23.317716598510742
        },
        {
            "x": -2.398926019668579,
            "y": -0.23050642013549805,
            "z": -23.468229293823242
        },
        {
            "x": -2.4364309310913086,
            "y": -0.23421648144721985,
            "z": -23.61854362487793
        },
        {
            "x": -2.4720828533172607,
            "y": -0.23666200041770935,
            "z": -23.7695255279541
        },
        {
            "x": -2.505908727645874,
            "y": -0.23779645562171936,
            "z": -23.92081069946289
        },
        {
            "x": -2.537980794906616,
            "y": -0.23754136264324188,
            "z": -24.072526931762695
        },
        {
            "x": -2.568308115005493,
            "y": -0.23580878973007202,
            "z": -24.22467803955078
        },
        {
            "x": -2.5968480110168457,
            "y": -0.23319490253925323,
            "z": -24.377079010009766
        },
        {
            "x": -2.6237378120422363,
            "y": -0.23038458824157715,
            "z": -24.53008270263672
        },
        {
            "x": -2.648970365524292,
            "y": -0.2265283465385437,
            "z": -24.68317985534668
        },
        {
            "x": -2.6726231575012207,
            "y": -0.2212178111076355,
            "z": -24.836591720581055
        },
        {
            "x": -2.6946637630462646,
            "y": -0.21448972821235657,
            "z": -24.99033546447754
        },
        {
            "x": -2.715191125869751,
            "y": -0.20649227499961853,
            "z": -25.144166946411133
        },
        {
            "x": -2.7342774868011475,
            "y": -0.19731716811656952,
            "z": -25.298301696777344
        },
        {
            "x": -2.7519452571868896,
            "y": -0.18706250190734863,
            "z": -25.452592849731445
        },
        {
            "x": -2.768200635910034,
            "y": -0.17579743266105652,
            "z": -25.606901168823242
        },
        {
            "x": -2.783142566680908,
            "y": -0.1636209785938263,
            "z": -25.761459350585938
        },
        {
            "x": -2.7968077659606934,
            "y": -0.1506561040878296,
            "z": -25.916017532348633
        },
        {
            "x": -2.8092527389526367,
            "y": -0.13698476552963257,
            "z": -26.0706844329834
        },
        {
            "x": -2.8204963207244873,
            "y": -0.12266712635755539,
            "z": -26.225618362426758
        },
        {
            "x": -2.830575942993164,
            "y": -0.10783632099628448,
            "z": -26.380443572998047
        },
        {
            "x": -2.8395957946777344,
            "y": -0.09257134795188904,
            "z": -26.535411834716797
        },
        {
            "x": -2.845095634460449,
            "y": -0.08219854533672333,
            "z": -26.638818740844727
        },
        {
            "x": -2.8525421619415283,
            "y": -0.06640979647636414,
            "z": -26.793933868408203
        },
        {
            "x": -2.8591153621673584,
            "y": -0.05041955038905144,
            "z": -26.949291229248047
        },
        {
            "x": -2.864917516708374,
            "y": -0.034334443509578705,
            "z": -27.104713439941406
        },
        {
            "x": -2.869919776916504,
            "y": -0.018264664337038994,
            "z": -27.260013580322266
        },
        {
            "x": -2.874049186706543,
            "y": -0.0022880500182509422,
            "z": -27.41538429260254
        },
        {
            "x": -2.877289295196533,
            "y": 0.01348626147955656,
            "z": -27.570629119873047
        },
        {
            "x": -2.879589557647705,
            "y": 0.02897871658205986,
            "z": -27.72583770751953
        },
        {
            "x": -2.8809080123901367,
            "y": 0.044120077043771744,
            "z": -27.881223678588867
        },
        {
            "x": -2.881134033203125,
            "y": 0.058759380131959915,
            "z": -28.036396026611328
        },
        {
            "x": -2.8802614212036133,
            "y": 0.07284502685070038,
            "z": -28.191593170166016
        },
        {
            "x": -2.8782405853271484,
            "y": 0.08628544956445694,
            "z": -28.34676170349121
        },
        {
            "x": -2.8750221729278564,
            "y": 0.09898686408996582,
            "z": -28.501840591430664
        },
        {
            "x": -2.8705015182495117,
            "y": 0.11084824800491333,
            "z": -28.65708351135254
        },
        {
            "x": -2.8646647930145264,
            "y": 0.1217639148235321,
            "z": -28.812082290649414
        },
        {
            "x": -2.8574817180633545,
            "y": 0.13167177140712738,
            "z": -28.967021942138672
        },
        {
            "x": -2.8489022254943848,
            "y": 0.14048989117145538,
            "z": -29.122013092041016
        },
        {
            "x": -2.838859796524048,
            "y": 0.14807915687561035,
            "z": -29.27681541442871
        },
        {
            "x": -2.8273215293884277,
            "y": 0.1543693095445633,
            "z": -29.431625366210938
        },
        {
            "x": -2.8142967224121094,
            "y": 0.15956294536590576,
            "z": -29.586368560791016
        },
        {
            "x": -2.7997829914093018,
            "y": 0.1646054983139038,
            "z": -29.74091148376465
        },
        {
            "x": -2.783730983734131,
            "y": 0.16966086626052856,
            "z": -29.895292282104492
        },
        {
            "x": -2.7661476135253906,
            "y": 0.1747257113456726,
            "z": -30.049514770507812
        },
        {
            "x": -2.7470815181732178,
            "y": 0.17979657649993896,
            "z": -30.203582763671875
        },
        {
            "x": -2.7265284061431885,
            "y": 0.18487678468227386,
            "z": -30.357694625854492
        },
        {
            "x": -2.704537868499756,
            "y": 0.18995003402233124,
            "z": -30.51145362854004
        },
        {
            "x": -2.6811165809631348,
            "y": 0.19502133131027222,
            "z": -30.66511344909668
        },
        {
            "x": -2.6563570499420166,
            "y": 0.20008563995361328,
            "z": -30.81863784790039
        },
        {
            "x": -2.6303253173828125,
            "y": 0.2051377296447754,
            "z": -30.97197151184082
        },
        {
            "x": -2.6030139923095703,
            "y": 0.21018260717391968,
            "z": -31.125377655029297
        },
        {
            "x": -2.5745558738708496,
            "y": 0.2152034491300583,
            "z": -31.278467178344727
        },
        {
            "x": -2.545022487640381,
            "y": 0.22020399570465088,
            "z": -31.431442260742188
        },
        {
            "x": -2.5144598484039307,
            "y": 0.22518466413021088,
            "z": -31.584444046020508
        },
        {
            "x": -2.482974052429199,
            "y": 0.23013442754745483,
            "z": -31.737239837646484
        },
        {
            "x": -2.4505908489227295,
            "y": 0.23505565524101257,
            "z": -31.890050888061523
        },
        {
            "x": -2.4174318313598633,
            "y": 0.23994296789169312,
            "z": -32.04278564453125
        },
        {
            "x": -2.3835928440093994,
            "y": 0.2447902262210846,
            "z": -32.195377349853516
        },
        {
            "x": -2.3490846157073975,
            "y": 0.2495999038219452,
            "z": -32.3480224609375
        },
        {
            "x": -2.3140196800231934,
            "y": 0.25436094403266907,
            "z": -32.500526428222656
        },
        {
            "x": -2.2784602642059326,
            "y": 0.2590745687484741,
            "z": -32.652992248535156
        },
        {
            "x": -2.242412567138672,
            "y": 0.26374372839927673,
            "z": -32.805641174316406
        },
        {
            "x": -2.206023693084717,
            "y": 0.26836106181144714,
            "z": -32.9583625793457
        },
        {
            "x": -2.16963529586792,
            "y": 0.27293747663497925,
            "z": -33.11175537109375
        },
        {
            "x": -2.145598888397217,
            "y": 0.2759590148925781,
            "z": -33.21417999267578
        },
        {
            "x": -2.1099650859832764,
            "y": 0.2804405689239502,
            "z": -33.36796188354492
        },
        {
            "x": -2.074859142303467,
            "y": 0.2848585247993469,
            "z": -33.52201461791992
        },
        {
            "x": -2.0403194427490234,
            "y": 0.2892090678215027,
            "z": -33.676239013671875
        },
        {
            "x": -2.006391763687134,
            "y": 0.29348671436309814,
            "z": -33.830543518066406
        },
        {
            "x": -1.9730720520019531,
            "y": 0.29769331216812134,
            "z": -33.98513412475586
        },
        {
            "x": -1.9404665231704712,
            "y": 0.30181753635406494,
            "z": -34.13983154296875
        },
        {
            "x": -1.9085720777511597,
            "y": 0.3058620095252991,
            "z": -34.29473114013672
        },
        {
            "x": -1.877384901046753,
            "y": 0.30982860922813416,
            "z": -34.45003890991211
        },
        {
            "x": -1.8470308780670166,
            "y": 0.313703715801239,
            "z": -34.605369567871094
        },
        {
            "x": -1.8175463676452637,
            "y": 0.3174874186515808,
            "z": -34.76100540161133
        },
        {
            "x": -1.788956880569458,
            "y": 0.3211783170700073,
            "z": -34.9168701171875
        },
        {
            "x": -1.761326551437378,
            "y": 0.3247724175453186,
            "z": -35.07293701171875
        },
        {
            "x": -1.7346702814102173,
            "y": 0.3282720744609833,
            "z": -35.229454040527344
        },
        {
            "x": -1.7091732025146484,
            "y": 0.3316602408885956,
            "z": -35.386043548583984
        },
        {
            "x": -1.684812068939209,
            "y": 0.3349432945251465,
            "z": -35.54291534423828
        },
        {
            "x": -1.6616442203521729,
            "y": 0.3381195068359375,
            "z": -35.70017623901367
        },
        {
            "x": -1.6397720575332642,
            "y": 0.3411816656589508,
            "z": -35.85759735107422
        },
        {
            "x": -1.6193119287490845,
            "y": 0.3441246747970581,
            "z": -36.01543045043945
        },
        {
            "x": -1.6002939939498901,
            "y": 0.3469483256340027,
            "z": -36.17353057861328
        },
        {
            "x": -1.582804560661316,
            "y": 0.34964755177497864,
            "z": -36.331825256347656
        },
        {
            "x": -1.56691312789917,
            "y": 0.35222089290618896,
            "z": -36.490379333496094
        },
        {
            "x": -1.5527735948562622,
            "y": 0.35465842485427856,
            "z": -36.64921188354492
        },
        {
            "x": -1.5403951406478882,
            "y": 0.356961727142334,
            "z": -36.80827713012695
        },
        {
            "x": -1.5298314094543457,
            "y": 0.3591305911540985,
            "z": -36.9677619934082
        },
        {
            "x": -1.5211684703826904,
            "y": 0.36115527153015137,
            "z": -37.127235412597656
        },
        {
            "x": -1.5145255327224731,
            "y": 0.36302900314331055,
            "z": -37.28692626953125
        },
        {
            "x": -1.5098750591278076,
            "y": 0.36475276947021484,
            "z": -37.44671630859375
        },
        {
            "x": -1.5072203874588013,
            "y": 0.3663228750228882,
            "z": -37.60651397705078
        },
        {
            "x": -1.5065667629241943,
            "y": 0.36773791909217834,
            "z": -37.76652908325195
        },
        {
            "x": -1.5079673528671265,
            "y": 0.3689834177494049,
            "z": -37.926273345947266
        },
        {
            "x": -1.511304259300232,
            "y": 0.3700633943080902,
            "z": -38.08592987060547
        },
        {
            "x": -1.5164982080459595,
            "y": 0.37097594141960144,
            "z": -38.24555587768555
        },
        {
            "x": -1.5234405994415283,
            "y": 0.3717164695262909,
            "z": -38.40486145019531
        },
        {
            "x": -1.532081961631775,
            "y": 0.37227553129196167,
            "z": -38.56401062011719
        },
        {
            "x": -1.5422250032424927,
            "y": 0.37265485525131226,
            "z": -38.7228889465332
        },
        {
            "x": -1.5536926984786987,
            "y": 0.3728530704975128,
            "z": -38.881370544433594
        },
        {
            "x": -1.5663684606552124,
            "y": 0.3728675842285156,
            "z": -39.03980255126953
        },
        {
            "x": -1.5802496671676636,
            "y": 0.3726915121078491,
            "z": -39.197784423828125
        },
        {
            "x": -1.5950853824615479,
            "y": 0.3723331093788147,
            "z": -39.35565185546875
        },
        {
            "x": -1.6110094785690308,
            "y": 0.37179604172706604,
            "z": -39.513729095458984
        },
        {
            "x": -1.6280548572540283,
            "y": 0.37108534574508667,
            "z": -39.67155456542969
        },
        {
            "x": -1.6462900638580322,
            "y": 0.3701980710029602,
            "z": -39.82930374145508
        },
        {
            "x": -1.6591185331344604,
            "y": 0.36951202154159546,
            "z": -39.93437957763672
        },
        {
            "x": -1.679345726966858,
            "y": 0.36834776401519775,
            "z": -40.09194564819336
        },
        {
            "x": -1.7008605003356934,
            "y": 0.36701542139053345,
            "z": -40.24943923950195
        },
        {
            "x": -1.723647117614746,
            "y": 0.36552178859710693,
            "z": -40.406829833984375
        },
        {
            "x": -1.747697353363037,
            "y": 0.36387455463409424,
            "z": -40.56392288208008
        },
        {
            "x": -1.7730519771575928,
            "y": 0.3620743155479431,
            "z": -40.72097396850586
        },
        {
            "x": -1.7997502088546753,
            "y": 0.3601222634315491,
            "z": -40.87770080566406
        },
        {
            "x": -1.8277784585952759,
            "y": 0.35802361369132996,
            "z": -41.03419876098633
        },
        {
            "x": -1.8571796417236328,
            "y": 0.35578078031539917,
            "z": -41.1906852722168
        },
        {
            "x": -1.887878179550171,
            "y": 0.35340356826782227,
            "z": -41.34670639038086
        },
        {
            "x": -1.9199424982070923,
            "y": 0.35088789463043213,
            "z": -41.50249481201172
        },
        {
            "x": -1.9533441066741943,
            "y": 0.3482394218444824,
            "z": -41.657997131347656
        },
        {
            "x": -1.9880279302597046,
            "y": 0.34546560049057007,
            "z": -41.813140869140625
        },
        {
            "x": -2.024022102355957,
            "y": 0.3425656259059906,
            "z": -41.968143463134766
        },
        {
            "x": -2.0612268447875977,
            "y": 0.3395470976829529,
            "z": -42.122589111328125
        },
        {
            "x": -2.0996246337890625,
            "y": 0.33641141653060913,
            "z": -42.27668380737305
        },
        {
            "x": -2.1391661167144775,
            "y": 0.33316197991371155,
            "z": -42.43051528930664
        },
        {
            "x": -2.1797075271606445,
            "y": 0.32980769872665405,
            "z": -42.5838508605957
        },
        {
            "x": -2.2212493419647217,
            "y": 0.3263450264930725,
            "z": -42.736907958984375
        },
        {
            "x": -2.2636592388153076,
            "y": 0.32278013229370117,
            "z": -42.889583587646484
        },
        {
            "x": -2.306781053543091,
            "y": 0.3191388249397278,
            "z": -43.04179382324219
        },
        {
            "x": -2.350531578063965,
            "y": 0.3161122798919678,
            "z": -43.193729400634766
        },
        {
            "x": -2.3947813510894775,
            "y": 0.3142983019351959,
            "z": -43.34535217285156
        },
        {
            "x": -2.4393656253814697,
            "y": 0.31362712383270264,
            "z": -43.49664306640625
        },
        {
            "x": -2.4841742515563965,
            "y": 0.3139832019805908,
            "z": -43.64785385131836
        },
        {
            "x": -2.5289359092712402,
            "y": 0.31528133153915405,
            "z": -43.79862976074219
        },
        {
            "x": -2.5735509395599365,
            "y": 0.3174542784690857,
            "z": -43.949222564697266
        },
        {
            "x": -2.6178126335144043,
            "y": 0.32041990756988525,
            "z": -44.09965133666992
        },
        {
            "x": -2.6615560054779053,
            "y": 0.32407015562057495,
            "z": -44.24989700317383
        },
        {
            "x": -2.7046828269958496,
            "y": 0.3283310532569885,
            "z": -44.400264739990234
        },
        {
            "x": -2.7469050884246826,
            "y": 0.33311980962753296,
            "z": -44.55039978027344
        },
        {
            "x": -2.788099765777588,
            "y": 0.3383631110191345,
            "z": -44.70056915283203
        },
        {
            "x": -2.82818603515625,
            "y": 0.3439714014530182,
            "z": -44.850929260253906
        },
        {
            "x": -2.8669750690460205,
            "y": 0.3498583436012268,
            "z": -45.00130081176758
        },
        {
            "x": -2.9043800830841064,
            "y": 0.3559568226337433,
            "z": -45.151920318603516
        },
        {
            "x": -2.940230131149292,
            "y": 0.3621840476989746,
            "z": -45.30274963378906
        },
        {
            "x": -2.974461317062378,
            "y": 0.3684522211551666,
            "z": -45.45370864868164
        },
        {
            "x": -3.0070486068725586,
            "y": 0.37469351291656494,
            "z": -45.60503005981445
        },
        {
            "x": -3.0378596782684326,
            "y": 0.38081976771354675,
            "z": -45.75653076171875
        },
        {
            "x": -3.066824197769165,
            "y": 0.3867482841014862,
            "z": -45.908321380615234
        },
        {
            "x": -3.0940117835998535,
            "y": 0.392413854598999,
            "z": -46.060611724853516
        },
        {
            "x": -3.119330644607544,
            "y": 0.3977229595184326,
            "z": -46.21299743652344
        },
        {
            "x": -3.1427907943725586,
            "y": 0.4026005268096924,
            "z": -46.36568832397461
        },
        {
            "x": -3.157339572906494,
            "y": 0.4055548310279846,
            "z": -46.467655181884766
        },
        {
            "x": -3.177687406539917,
            "y": 0.40952393412590027,
            "z": -46.62081527709961
        },
        {
            "x": -3.196214199066162,
            "y": 0.41284632682800293,
            "z": -46.774356842041016
        },
        {
            "x": -3.2128591537475586,
            "y": 0.4154074788093567,
            "z": -46.92816162109375
        },
        {
            "x": -3.22773814201355,
            "y": 0.4171546697616577,
            "z": -47.08212661743164
        },
        {
            "x": -3.2408993244171143,
            "y": 0.4180087447166443,
            "z": -47.23638153076172
        },
        {
            "x": -3.2523419857025146,
            "y": 0.41788333654403687,
            "z": -47.390716552734375
        },
        {
            "x": -3.262064218521118,
            "y": 0.41664981842041016,
            "z": -47.545257568359375
        },
        {
            "x": -3.270204544067383,
            "y": 0.4142693877220154,
            "z": -47.70010757446289
        },
        {
            "x": -3.2767648696899414,
            "y": 0.4106670618057251,
            "z": -47.854888916015625
        },
        {
            "x": -3.2818360328674316,
            "y": 0.40585628151893616,
            "z": -48.009857177734375
        },
        {
            "x": -3.2853636741638184,
            "y": 0.40032899379730225,
            "z": -48.16489028930664
        },
        {
            "x": -3.2875020503997803,
            "y": 0.39335644245147705,
            "z": -48.319889068603516
        },
        {
            "x": -3.2883126735687256,
            "y": 0.3848702907562256,
            "z": -48.475257873535156
        },
        {
            "x": -3.288059949874878,
            "y": 0.37496551871299744,
            "z": -48.63078308105469
        },
        {
            "x": -3.286994218826294,
            "y": 0.3636682629585266,
            "z": -48.78654098510742
        },
        {
            "x": -3.2852466106414795,
            "y": 0.3511428236961365,
            "z": -48.94232940673828
        },
        {
            "x": -3.282836675643921,
            "y": 0.3375016748905182,
            "z": -49.097930908203125
        },
        {
            "x": -3.2797508239746094,
            "y": 0.32282084226608276,
            "z": -49.2535285949707
        },
        {
            "x": -3.275984287261963,
            "y": 0.3071703314781189,
            "z": -49.409019470214844
        },
        {
            "x": -3.271545171737671,
            "y": 0.29067856073379517,
            "z": -49.564327239990234
        },
        {
            "x": -3.266449213027954,
            "y": 0.2734410762786865,
            "z": -49.719520568847656
        },
        {
            "x": -3.260697364807129,
            "y": 0.25554466247558594,
            "z": -49.87464904785156
        },
        {
            "x": -3.2542684078216553,
            "y": 0.23707205057144165,
            "z": -50.0296745300293
        },
        {
            "x": -3.2471656799316406,
            "y": 0.2180909663438797,
            "z": -50.18482208251953
        },
        {
            "x": -3.239410161972046,
            "y": 0.19875353574752808,
            "z": -50.3397102355957
        },
        {
            "x": -3.2310030460357666,
            "y": 0.17912068963050842,
            "z": -50.494564056396484
        },
        {
            "x": -3.2219324111938477,
            "y": 0.15928250551223755,
            "z": -50.649383544921875
        },
        {
            "x": -3.212186098098755,
            "y": 0.1393408179283142,
            "z": -50.804073333740234
        },
        {
            "x": -3.201770067214966,
            "y": 0.11935403943061829,
            "z": -50.95893859863281
        },
        {
            "x": -3.1907079219818115,
            "y": 0.09946629405021667,
            "z": -51.113563537597656
        },
        {
            "x": -3.1789913177490234,
            "y": 0.07973779737949371,
            "z": -51.2681770324707
        },
        {
            "x": -3.1665737628936768,
            "y": 0.06025787070393562,
            "z": -51.42287063598633
        },
        {
            "x": -3.153505802154541,
            "y": 0.04113955795764923,
            "z": -51.577457427978516
        },
        {
            "x": -3.139756441116333,
            "y": 0.022446583956480026,
            "z": -51.732120513916016
        },
        {
            "x": -3.125347852706909,
            "y": 0.004278876353055239,
            "z": -51.88679122924805
        },
        {
            "x": -3.1102519035339355,
            "y": -0.013247393071651459,
            "z": -52.0413818359375
        },
        {
            "x": -3.0944645404815674,
            "y": -0.030054999515414238,
            "z": -52.196083068847656
        },
        {
            "x": -3.0780029296875,
            "y": -0.04604719206690788,
            "z": -52.35068893432617
        },
        {
            "x": -3.060868740081787,
            "y": -0.0611434280872345,
            "z": -52.50531005859375
        },
        {
            "x": -3.0430104732513428,
            "y": -0.07525910437107086,
            "z": -52.660152435302734
        },
        {
            "x": -3.024470329284668,
            "y": -0.08823089301586151,
            "z": -52.814796447753906
        },
        {
            "x": -3.0052268505096436,
            "y": -0.1000237911939621,
            "z": -52.96945571899414
        },
        {
            "x": -2.992032766342163,
            "y": -0.10721125453710556,
            "z": -53.07255935668945
        },
        {
            "x": -2.971623420715332,
            "y": -0.11741998046636581,
            "z": -53.22711181640625
        },
        {
            "x": -2.9505116939544678,
            "y": -0.12764450907707214,
            "z": -53.38166427612305
        },
        {
            "x": -2.928706645965576,
            "y": -0.137872576713562,
            "z": -53.536102294921875
        },
        {
            "x": -2.906217575073242,
            "y": -0.1480925977230072,
            "z": -53.69035339355469
        },
        {
            "x": -2.882982015609741,
            "y": -0.15830573439598083,
            "z": -53.84455871582031
        },
        {
            "x": -2.8590447902679443,
            "y": -0.16849389672279358,
            "z": -53.99857711791992
        },
        {
            "x": -2.834406614303589,
            "y": -0.17865316569805145,
            "z": -54.15245056152344
        },
        {
            "x": -2.8090102672576904,
            "y": -0.1887899935245514,
            "z": -54.3064079284668
        },
        {
            "x": -2.782898187637329,
            "y": -0.198868989944458,
            "z": -54.46004867553711
        },
        {
            "x": -2.7560415267944336,
            "y": -0.2088974118232727,
            "z": -54.61358642578125
        },
        {
            "x": -2.7284460067749023,
            "y": -0.21886681020259857,
            "z": -54.76700973510742
        },
        {
            "x": -2.7001264095306396,
            "y": -0.22876325249671936,
            "z": -54.92021179199219
        },
        {
            "x": -2.6709837913513184,
            "y": -0.2385929524898529,
            "z": -55.073463439941406
        },
        {
            "x": -2.6411144733428955,
            "y": -0.24832496047019958,
            "z": -55.22637939453125
        },
        {
            "x": -2.610483169555664,
            "y": -0.25796273350715637,
            "z": -55.37909698486328
        },
        {
            "x": -2.579047203063965,
            "y": -0.26750707626342773,
            "z": -55.531776428222656
        },
        {
            "x": -2.54682993888855,
            "y": -0.27693259716033936,
            "z": -55.68417739868164
        },
        {
            "x": -2.5137839317321777,
            "y": -0.2862442135810852,
            "z": -55.83647918701172
        },
        {
            "x": -2.4799306392669678,
            "y": -0.29543012380599976,
            "z": -55.98859405517578
        },
        {
            "x": -2.4452834129333496,
            "y": -0.30447760224342346,
            "z": -56.14043045043945
        },
        {
            "x": -2.409795045852661,
            "y": -0.3133789300918579,
            "z": -56.29204559326172
        },
        {
            "x": -2.3734445571899414,
            "y": -0.32215046882629395,
            "z": -56.443424224853516
        },
        {
            "x": -2.3362419605255127,
            "y": -0.3309195637702942,
            "z": -56.594581604003906
        },
        {
            "x": -2.298125743865967,
            "y": -0.3397062420845032,
            "z": -56.74570083618164
        },
        {
            "x": -2.2591636180877686,
            "y": -0.3484819531440735,
            "z": -56.896358489990234
        },
        {
            "x": -2.2192673683166504,
            "y": -0.35725510120391846,
            "z": -57.04678726196289
        },
        {
            "x": -2.178453207015991,
            "y": -0.3660178482532501,
            "z": -57.19695281982422
        },
        {
            "x": -2.1367249488830566,
            "y": -0.3747611343860626,
            "z": -57.346771240234375
        },
        {
            "x": -2.0939793586730957,
            "y": -0.3834936022758484,
            "z": -57.496490478515625
        },
        {
            "x": -2.050288200378418,
            "y": -0.3921862542629242,
            "z": -57.64567947387695
        },
        {
            "x": -2.0056092739105225,
            "y": -0.40084466338157654,
            "z": -57.794525146484375
        },
        {
            "x": -1.9598830938339233,
            "y": -0.4094706177711487,
            "z": -57.943138122558594
        },
        {
            "x": -1.9131369590759277,
            "y": -0.418044775724411,
            "z": -58.09126281738281
        },
        {
            "x": -1.8652573823928833,
            "y": -0.42657196521759033,
            "z": -58.23908996582031
        },
        {
            "x": -1.8162881135940552,
            "y": -0.4350419044494629,
            "z": -58.38648986816406
        },
        {
            "x": -1.7662266492843628,
            "y": -0.44344383478164673,
            "z": -58.53337097167969
        },
        {
            "x": -1.714964509010315,
            "y": -0.45178306102752686,
            "z": -58.67988967895508
        },
        {
            "x": -1.6625045537948608,
            "y": -0.4600377678871155,
            "z": -58.82578659057617
        },
        {
            "x": -1.6088579893112183,
            "y": -0.46820327639579773,
            "z": -58.971012115478516
        },
        {
            "x": -1.553851842880249,
            "y": -0.47625207901000977,
            "z": -59.115028381347656
        },
        {
            "x": -1.4969747066497803,
            "y": -0.48417866230010986,
            "z": -59.25759506225586
        },
        {
            "x": -1.4378039836883545,
            "y": -0.4920198619365692,
            "z": -59.399513244628906
        },
        {
            "x": -1.3972395658493042,
            "y": -0.49720215797424316,
            "z": -59.49387741088867
        },
        {
            "x": -1.3348783254623413,
            "y": -0.5049004554748535,
            "z": -59.63505935668945
        },
        {
            "x": -1.2707328796386719,
            "y": -0.5125024318695068,
            "z": -59.775943756103516
        },
        {
            "x": -1.20513916015625,
            "y": -0.5199999809265137,
            "z": -59.91652297973633
        },
        {
            "x": -1.1383305788040161,
            "y": -0.5273832082748413,
            "z": -60.056800842285156
        },
        {
            "x": -1.0704264640808105,
            "y": -0.5346528887748718,
            "z": -60.19700241088867
        },
        {
            "x": -1.0016613006591797,
            "y": -0.5417885780334473,
            "z": -60.3370246887207
        },
        {
            "x": -0.932218074798584,
            "y": -0.5487918853759766,
            "z": -60.47702407836914
        },
        {
            "x": -0.8621513247489929,
            "y": -0.5556681156158447,
            "z": -60.61726760864258
        },
        {
            "x": -0.7918440103530884,
            "y": -0.5623905658721924,
            "z": -60.7574348449707
        },
        {
            "x": -0.7212886810302734,
            "y": -0.5689600110054016,
            "z": -60.8978385925293
        },
        {
            "x": -0.6506860256195068,
            "y": -0.5753711462020874,
            "z": -61.038475036621094
        },
        {
            "x": -0.5801979303359985,
            "y": -0.5816166400909424,
            "z": -61.179317474365234
        },
        {
            "x": -0.5098235607147217,
            "y": -0.5877009630203247,
            "z": -61.3206901550293
        },
        {
            "x": -0.43988698720932007,
            "y": -0.5935952067375183,
            "z": -61.46226119995117
        },
        {
            "x": -0.3703988194465637,
            "y": -0.5993049144744873,
            "z": -61.60422897338867
        },
        {
            "x": -0.3013993799686432,
            "y": -0.6048296093940735,
            "z": -61.74673080444336
        },
        {
            "x": -0.23308473825454712,
            "y": -0.6101561784744263,
            "z": -61.88962173461914
        },
        {
            "x": -0.16547173261642456,
            "y": -0.6152775287628174,
            "z": -62.0330810546875
        },
        {
            "x": -0.09866933524608612,
            "y": -0.6201879978179932,
            "z": -62.17707443237305
        },
        {
            "x": -0.03279535099864006,
            "y": -0.6248809099197388,
            "z": -62.32147979736328
        },
        {
            "x": 0.032155297696590424,
            "y": -0.629353404045105,
            "z": -62.46642303466797
        },
        {
            "x": 0.09606986492872238,
            "y": -0.6335925459861755,
            "z": -62.61192321777344
        },
        {
            "x": 0.15890774130821228,
            "y": -0.6375930309295654,
            "z": -62.757938385009766
        },
        {
            "x": 0.2207423746585846,
            "y": -0.6413596868515015,
            "z": -62.90473937988281
        },
        {
            "x": 0.2813314199447632,
            "y": -0.6448739767074585,
            "z": -63.051815032958984
        },
        {
            "x": 0.3407638669013977,
            "y": -0.6481316089630127,
            "z": -63.199562072753906
        },
        {
            "x": 0.39893969893455505,
            "y": -0.6511237621307373,
            "z": -63.3477897644043
        },
        {
            "x": 0.45587265491485596,
            "y": -0.6538509130477905,
            "z": -63.49652862548828
        },
        {
            "x": 0.5116181373596191,
            "y": -0.6563093662261963,
            "z": -63.64592361450195
        },
        {
            "x": 0.5659716129302979,
            "y": -0.6584805250167847,
            "z": -63.7956428527832
        },
        {
            "x": 0.6190230250358582,
            "y": -0.6603618264198303,
            "z": -63.94586944580078
        },
        {
            "x": 0.6708008050918579,
            "y": -0.6619547009468079,
            "z": -64.09663391113281
        },
        {
            "x": 0.7212298512458801,
            "y": -0.6632511019706726,
            "z": -64.24777221679688
        },
        {
            "x": 0.7703574299812317,
            "y": -0.6642398834228516,
            "z": -64.39945220947266
        },
        {
            "x": 0.8181189298629761,
            "y": -0.6649129986763,
            "z": -64.55155181884766
        },
        {
            "x": 0.8645309209823608,
            "y": -0.6652724146842957,
            "z": -64.70392608642578
        },
        {
            "x": 0.9096643924713135,
            "y": -0.6653132438659668,
            "z": -64.85681915283203
        },
        {
            "x": 0.9534438848495483,
            "y": -0.6650272607803345,
            "z": -65.01001739501953
        },
        {
            "x": 0.9958717226982117,
            "y": -0.6644184589385986,
            "z": -65.16352081298828
        },
        {
            "x": 1.0370471477508545,
            "y": -0.6635000705718994,
            "z": -65.31755828857422
        },
        {
            "x": 1.0768877267837524,
            "y": -0.6622802019119263,
            "z": -65.47171783447266
        },
        {
            "x": 1.1154274940490723,
            "y": -0.6607578992843628,
            "z": -65.6261978149414
        },
        {
            "x": 1.140395164489746,
            "y": -0.6595741510391235,
            "z": -65.72936248779297
        },
        {
            "x": 1.1768211126327515,
            "y": -0.6575673818588257,
            "z": -65.88430786132812
        },
        {
            "x": 1.212007999420166,
            "y": -0.6552736759185791,
            "z": -66.03960418701172
        },
        {
            "x": 1.2459187507629395,
            "y": -0.6526967883110046,
            "z": -66.1951675415039
        },
        {
            "x": 1.278601050376892,
            "y": -0.6498045921325684,
            "z": -66.3508529663086
        },
        {
            "x": 1.3101099729537964,
            "y": -0.6464952230453491,
            "z": -66.50686645507812
        },
        {
            "x": 1.340392827987671,
            "y": -0.6427661180496216,
            "z": -66.66295623779297
        },
        {
            "x": 1.36947762966156,
            "y": -0.6386160850524902,
            "z": -66.8192367553711
        },
        {
            "x": 1.3974508047103882,
            "y": -0.6340624094009399,
            "z": -66.97590637207031
        },
        {
            "x": 1.4242584705352783,
            "y": -0.6291252374649048,
            "z": -67.13251495361328
        },
        {
            "x": 1.4499483108520508,
            "y": -0.62380051612854,
            "z": -67.28933715820312
        },
        {
            "x": 1.4744960069656372,
            "y": -0.6180909872055054,
            "z": -67.44629669189453
        },
        {
            "x": 1.497965931892395,
            "y": -0.6120206713676453,
            "z": -67.60331726074219
        },
        {
            "x": 1.5204060077667236,
            "y": -0.6055883169174194,
            "z": -67.76068115234375
        },
        {
            "x": 1.5417653322219849,
            "y": -0.5988162755966187,
            "z": -67.91792297363281
        },
        {
            "x": 1.5620555877685547,
            "y": -0.5916957855224609,
            "z": -68.07525634765625
        },
        {
            "x": 1.581355094909668,
            "y": -0.5842435956001282,
            "z": -68.2327880859375
        },
        {
            "x": 1.5996546745300293,
            "y": -0.5764791369438171,
            "z": -68.3902816772461
        },
        {
            "x": 1.6169893741607666,
            "y": -0.5683987140655518,
            "z": -68.54796600341797
        },
        {
            "x": 1.6333266496658325,
            "y": -0.5600063800811768,
            "z": -68.7056884765625
        },
        {
            "x": 1.6487178802490234,
            "y": -0.5513290166854858,
            "z": -68.8633804321289
        },
        {
            "x": 1.66318678855896,
            "y": -0.5423699617385864,
            "z": -69.0211181640625
        },
        {
            "x": 1.6767494678497314,
            "y": -0.5331388711929321,
            "z": -69.17888641357422
        },
        {
            "x": 1.6893922090530396,
            "y": -0.523631751537323,
            "z": -69.33670806884766
        },
        {
            "x": 1.7011770009994507,
            "y": -0.5138587951660156,
            "z": -69.49474334716797
        },
        {
            "x": 1.712088704109192,
            "y": -0.5038531422615051,
            "z": -69.65259552001953
        },
        {
            "x": 1.7221589088439941,
            "y": -0.4936072826385498,
            "z": -69.810546875
        },
        {
            "x": 1.7313718795776367,
            "y": -0.4831254482269287,
            "z": -69.9684829711914
        },
        {
            "x": 1.7397732734680176,
            "y": -0.4724286198616028,
            "z": -70.12638092041016
        },
        {
            "x": 1.74738609790802,
            "y": -0.4615088701248169,
            "z": -70.28448486328125
        },
        {
            "x": 1.754202127456665,
            "y": -0.45040303468704224,
            "z": -70.44239044189453
        },
        {
            "x": 1.7602317333221436,
            "y": -0.4390987753868103,
            "z": -70.60029602050781
        },
        {
            "x": 1.7655060291290283,
            "y": -0.42760345339775085,
            "z": -70.75830078125
        },
        {
            "x": 1.7700327634811401,
            "y": -0.41594386100769043,
            "z": -70.91619110107422
        },
        {
            "x": 1.7738397121429443,
            "y": -0.40411221981048584,
            "z": -71.07417297363281
        },
        {
            "x": 1.776916742324829,
            "y": -0.3921220898628235,
            "z": -71.23213195800781
        },
        {
            "x": 1.7792726755142212,
            "y": -0.37999212741851807,
            "z": -71.38995361328125
        },
        {
            "x": 1.7809438705444336,
            "y": -0.367715984582901,
            "z": -71.5478744506836
        },
        {
            "x": 1.7819414138793945,
            "y": -0.3553216755390167,
            "z": -71.7056655883789
        },
        {
            "x": 1.7822492122650146,
            "y": -0.3428051471710205,
            "z": -71.8634262084961
        },
        {
            "x": 1.7818814516067505,
            "y": -0.33015620708465576,
            "z": -72.02141571044922
        },
        {
            "x": 1.7808526754379272,
            "y": -0.3174220621585846,
            "z": -72.1791763305664
        },
        {
            "x": 1.7791519165039062,
            "y": -0.30459386110305786,
            "z": -72.33695220947266
        },
        {
            "x": 1.7776437997817993,
            "y": -0.2959933578968048,
            "z": -72.4421157836914
        },
        {
            "x": 1.7748055458068848,
            "y": -0.2830274701118469,
            "z": -72.59983825683594
        },
        {
            "x": 1.7712934017181396,
            "y": -0.26998403668403625,
            "z": -72.75765991210938
        },
        {
            "x": 1.7670936584472656,
            "y": -0.2568795680999756,
            "z": -72.91544342041016
        },
        {
            "x": 1.7621989250183105,
            "y": -0.24372908473014832,
            "z": -73.07312774658203
        },
        {
            "x": 1.756629467010498,
            "y": -0.23052725195884705,
            "z": -73.23089599609375
        },
        {
            "x": 1.7503852844238281,
            "y": -0.21730223298072815,
            "z": -73.38851165771484
        },
        {
            "x": 1.7434648275375366,
            "y": -0.20405103266239166,
            "z": -73.5461196899414
        },
        {
            "x": 1.7358388900756836,
            "y": -0.19076783955097198,
            "z": -73.7038803100586
        },
        {
            "x": 1.7275464534759521,
            "y": -0.1774960458278656,
            "z": -73.86138153076172
        },
        {
            "x": 1.7185786962509155,
            "y": -0.16422146558761597,
            "z": -74.01892852783203
        },
        {
            "x": 1.708949089050293,
            "y": -0.1509578824043274,
            "z": -74.17642974853516
        },
        {
            "x": 1.6986284255981445,
            "y": -0.137721449136734,
            "z": -74.33380889892578
        },
        {
            "x": 1.687623381614685,
            "y": -0.12449765205383301,
            "z": -74.49136352539062
        },
        {
            "x": 1.6759765148162842,
            "y": -0.11132930219173431,
            "z": -74.64866638183594
        },
        {
            "x": 1.6636801958084106,
            "y": -0.09820762276649475,
            "z": -74.805908203125
        },
        {
            "x": 1.6507012844085693,
            "y": -0.08513616770505905,
            "z": -74.96319580078125
        },
        {
            "x": 1.6370762586593628,
            "y": -0.07213903963565826,
            "z": -75.12033081054688
        },
        {
            "x": 1.622806429862976,
            "y": -0.059207815676927567,
            "z": -75.27751159667969
        },
        {
            "x": 1.6079127788543701,
            "y": -0.04636049270629883,
            "z": -75.43463134765625
        },
        {
            "x": 1.5923823118209839,
            "y": -0.03361550718545914,
            "z": -75.59158325195312
        },
        {
            "x": 1.5762197971343994,
            "y": -0.02097388543188572,
            "z": -75.74844360351562
        },
        {
            "x": 1.559454321861267,
            "y": -0.008442232385277748,
            "z": -75.90525817871094
        },
        {
            "x": 1.5420928001403809,
            "y": 0.00397072546184063,
            "z": -76.0619888305664
        },
        {
            "x": 1.5241026878356934,
            "y": 0.016270071268081665,
            "z": -76.21888732910156
        },
        {
            "x": 1.5055336952209473,
            "y": 0.02841227315366268,
            "z": -76.37547302246094
        },
        {
            "x": 1.4863948822021484,
            "y": 0.04041349142789841,
            "z": -76.53206634521484
        },
        {
            "x": 1.4666967391967773,
            "y": 0.05226070433855057,
            "z": -76.6885757446289
        },
        {
            "x": 1.4464526176452637,
            "y": 0.06393870711326599,
            "z": -76.8449478149414
        },
        {
            "x": 1.4256184101104736,
            "y": 0.07545316964387894,
            "z": -77.00144958496094
        },
        {
            "x": 1.4042915105819702,
            "y": 0.08677239716053009,
            "z": -77.15766906738281
        },
        {
            "x": 1.3824583292007446,
            "y": 0.09790164232254028,
            "z": -77.31381225585938
        },
        {
            "x": 1.3601129055023193,
            "y": 0.10884004831314087,
            "z": -77.46998596191406
        },
        {
            "x": 1.3372776508331299,
            "y": 0.11955373734235764,
            "z": -77.62596893310547
        },
        {
            "x": 1.3139580488204956,
            "y": 0.13005851209163666,
            "z": -77.78197479248047
        },
        {
            "x": 1.2901886701583862,
            "y": 0.1403384953737259,
            "z": -77.93789672851562
        },
        {
            "x": 1.265997290611267,
            "y": 0.15037864446640015,
            "z": -78.09365844726562
        },
        {
            "x": 1.2413520812988281,
            "y": 0.16017238795757294,
            "z": -78.24944305419922
        },
        {
            "x": 1.216318964958191,
            "y": 0.1697068214416504,
            "z": -78.40503692626953
        },
        {
            "x": 1.1908963918685913,
            "y": 0.17898239195346832,
            "z": -78.5605697631836
        },
        {
            "x": 1.1650733947753906,
            "y": 0.18800005316734314,
            "z": -78.7162094116211
        },
        {
            "x": 1.1389222145080566,
            "y": 0.1967180222272873,
            "z": -78.87158966064453
        },
        {
            "x": 1.1124341487884521,
            "y": 0.20514710247516632,
            "z": -79.02689361572266
        },
        {
            "x": 1.0946073532104492,
            "y": 0.2106086164712906,
            "z": -79.1303939819336
        },
        {
            "x": 1.0676002502441406,
            "y": 0.21853527426719666,
            "z": -79.28557586669922
        },
        {
            "x": 1.040289044380188,
            "y": 0.22615313529968262,
            "z": -79.44078826904297
        },
        {
            "x": 1.0127143859863281,
            "y": 0.2334526777267456,
            "z": -79.59596252441406
        },
        {
            "x": 0.9849119186401367,
            "y": 0.24042046070098877,
            "z": -79.75096893310547
        },
        {
            "x": 0.9568562507629395,
            "y": 0.24704568088054657,
            "z": -79.9060287475586
        },
        {
            "x": 0.9286165833473206,
            "y": 0.25331544876098633,
            "z": -80.06090545654297
        },
        {
            "x": 0.9001911878585815,
            "y": 0.2592322826385498,
            "z": -80.21574401855469
        },
        {
            "x": 0.8715648055076599,
            "y": 0.2647932171821594,
            "z": -80.3707275390625
        },
        {
            "x": 0.8428245186805725,
            "y": 0.26996445655822754,
            "z": -80.52546691894531
        },
        {
            "x": 0.813946008682251,
            "y": 0.274749755859375,
            "z": -80.68022155761719
        },
        {
            "x": 0.784964382648468,
            "y": 0.27914565801620483,
            "z": -80.83492279052734
        },
        {
            "x": 0.7559165954589844,
            "y": 0.283141553401947,
            "z": -80.9895248413086
        },
        {
            "x": 0.72676682472229,
            "y": 0.2867235839366913,
            "z": -81.144287109375
        },
        {
            "x": 0.6976140737533569,
            "y": 0.2898760735988617,
            "z": -81.298828125
        },
        {
            "x": 0.6684364080429077,
            "y": 0.29260343313217163,
            "z": -81.45333862304688
        },
        {
            "x": 0.6392413377761841,
            "y": 0.29489850997924805,
            "z": -81.60792541503906
        },
        {
            "x": 0.6100808382034302,
            "y": 0.2967381179332733,
            "z": -81.76239776611328
        },
        {
            "x": 0.5809459686279297,
            "y": 0.29811519384384155,
            "z": -81.91691589355469
        },
        {
            "x": 0.5518680214881897,
            "y": 0.2990309000015259,
            "z": -82.0714340209961
        },
        {
            "x": 0.5228855013847351,
            "y": 0.2994760572910309,
            "z": -82.22584533691406
        },
        {
            "x": 0.49400585889816284,
            "y": 0.29944145679473877,
            "z": -82.3802261352539
        },
        {
            "x": 0.4652460813522339,
            "y": 0.2991209030151367,
            "z": -82.53459930419922
        },
        {
            "x": 0.43662112951278687,
            "y": 0.29863569140434265,
            "z": -82.68896484375
        },
        {
            "x": 0.408113569021225,
            "y": 0.29798856377601624,
            "z": -82.84352111816406
        },
        {
            "x": 0.3798198699951172,
            "y": 0.29718124866485596,
            "z": -82.99787902832031
        },
        {
            "x": 0.35171061754226685,
            "y": 0.29621511697769165,
            "z": -83.15230560302734
        },
        {
            "x": 0.3238047659397125,
            "y": 0.2950982451438904,
            "z": -83.3067398071289
        },
        {
            "x": 0.2961367964744568,
            "y": 0.29383474588394165,
            "z": -83.46111297607422
        },
        {
            "x": 0.2686794102191925,
            "y": 0.29242295026779175,
            "z": -83.61571502685547
        },
        {
            "x": 0.24151849746704102,
            "y": 0.29086834192276,
            "z": -83.77012634277344
        },
        {
            "x": 0.21463225781917572,
            "y": 0.2891772985458374,
            "z": -83.92455291748047
        },
        {
            "x": 0.18801143765449524,
            "y": 0.2873515486717224,
            "z": -84.0791244506836
        },
        {
            "x": 0.1617182195186615,
            "y": 0.2853950262069702,
            "z": -84.23360443115234
        },
        {
            "x": 0.13573148846626282,
            "y": 0.2833068370819092,
            "z": -84.3882064819336
        },
        {
            "x": 0.110079824924469,
            "y": 0.2810957729816437,
            "z": -84.5428466796875
        },
        {
            "x": 0.0847870260477066,
            "y": 0.27876678109169006,
            "z": -84.69740295410156
        },
        {
            "x": 0.059840962290763855,
            "y": 0.2763179838657379,
            "z": -84.85212707519531
        },
        {
            "x": 0.03529536724090576,
            "y": 0.2737548351287842,
            "z": -85.00677490234375
        },
        {
            "x": 0.011132270097732544,
            "y": 0.27108263969421387,
            "z": -85.16144561767578
        },
        {
            "x": -0.012670934200286865,
            "y": 0.26830142736434937,
            "z": -85.31636047363281
        },
        {
            "x": -0.03603509068489075,
            "y": 0.26541996002197266,
            "z": -85.47112274169922
        },
        {
            "x": -0.05896122381091118,
            "y": 0.26243650913238525,
            "z": -85.62592315673828
        },
        {
            "x": -0.07401517033576965,
            "y": 0.2603950500488281,
            "z": -85.72915649414062
        },
        {
            "x": -0.0962306559085846,
            "y": 0.257255494594574,
            "z": -85.88401794433594
        },
        {
            "x": -0.11800681054592133,
            "y": 0.2540207505226135,
            "z": -86.03904724121094
        },
        {
            "x": -0.13932685554027557,
            "y": 0.25070005655288696,
            "z": -86.19409942626953
        },
        {
            "x": -0.16017428040504456,
            "y": 0.24729865789413452,
            "z": -86.34912109375
        },
        {
            "x": -0.18056648969650269,
            "y": 0.24381524324417114,
            "z": -86.5042724609375
        },
        {
            "x": -0.20045524835586548,
            "y": 0.240255206823349,
            "z": -86.65937805175781
        },
        {
            "x": -0.21985740959644318,
            "y": 0.23662298917770386,
            "z": -86.81452178955078
        },
        {
            "x": -0.23879539966583252,
            "y": 0.23291730880737305,
            "z": -86.96990966796875
        },
        {
            "x": -0.25721314549446106,
            "y": 0.2291502207517624,
            "z": -87.12515258789062
        },
        {
            "x": -0.2751181125640869,
            "y": 0.2253168225288391,
            "z": -87.28050231933594
        },
        {
            "x": -0.29251155257225037,
            "y": 0.22142519056797028,
            "z": -87.4358901977539
        },
        {
            "x": -0.30939042568206787,
            "y": 0.21747973561286926,
            "z": -87.5912857055664
        },
        {
            "x": -0.3257736563682556,
            "y": 0.2134772092103958,
            "z": -87.74690246582031
        },
        {
            "x": -0.34158581495285034,
            "y": 0.20942898094654083,
            "z": -87.90240478515625
        },
        {
            "x": -0.3568781614303589,
            "y": 0.20533598959445953,
            "z": -88.05792236328125
        },
        {
            "x": -0.37165698409080505,
            "y": 0.20119856297969818,
            "z": -88.21360778808594
        },
        {
            "x": -0.3858914077281952,
            "y": 0.1970258355140686,
            "z": -88.36923217773438
        },
        {
            "x": -0.3995822072029114,
            "y": 0.19281437993049622,
            "z": -88.52497863769531
        },
        {
            "x": -0.41273510456085205,
            "y": 0.18857166171073914,
            "z": -88.68077087402344
        },
        {
            "x": -0.42534294724464417,
            "y": 0.1843033879995346,
            "z": -88.83650207519531
        },
        {
            "x": -0.437417209148407,
            "y": 0.18001091480255127,
            "z": -88.99227142333984
        },
        {
            "x": -0.44892221689224243,
            "y": 0.17569583654403687,
            "z": -89.14810180664062
        },
        {
            "x": -0.45988088846206665,
            "y": 0.1713634431362152,
            "z": -89.30396270751953
        },
        {
            "x": -0.4703141450881958,
            "y": 0.16701114177703857,
            "z": -89.46003723144531
        },
        {
            "x": -0.4801846146583557,
            "y": 0.16265353560447693,
            "z": -89.615966796875
        },
        {
            "x": -0.48949769139289856,
            "y": 0.15828680992126465,
            "z": -89.77195739746094
        },
        {
            "x": -0.4982694089412689,
            "y": 0.15391579270362854,
            "z": -89.9280014038086
        },
        {
            "x": -0.5064941644668579,
            "y": 0.14954565465450287,
            "z": -90.0840072631836
        },
        {
            "x": -0.514193058013916,
            "y": 0.14517202973365784,
            "z": -90.2402572631836
        },
        {
            "x": -0.5213084816932678,
            "y": 0.14080971479415894,
            "z": -90.39634704589844
        },
        {
            "x": -0.5278776288032532,
            "y": 0.1364579200744629,
            "z": -90.55243682861328
        },
        {
            "x": -0.53391432762146,
            "y": 0.13211531937122345,
            "z": -90.70866394042969
        },
        {
            "x": -0.5394099354743958,
            "y": 0.12779244780540466,
            "z": -90.86479187011719
        },
        {
            "x": -0.5443634986877441,
            "y": 0.1234864667057991,
            "z": -91.02105712890625
        },
        {
            "x": -0.5487686395645142,
            "y": 0.11920331418514252,
            "z": -91.17735290527344
        },
        {
            "x": -0.5526368021965027,
            "y": 0.11494890600442886,
            "z": -91.33356475830078
        },
        {
            "x": -0.5559701323509216,
            "y": 0.11072119325399399,
            "z": -91.48990631103516
        },
        {
            "x": -0.558760404586792,
            "y": 0.10653156042098999,
            "z": -91.64610290527344
        },
        {
            "x": -0.5610260367393494,
            "y": 0.10237768292427063,
            "z": -91.8023452758789
        },
        {
            "x": -0.5627690553665161,
            "y": 0.0982578694820404,
            "z": -91.95881652832031
        },
        {
            "x": -0.5639901757240295,
            "y": 0.09418544173240662,
            "z": -92.11512756347656
        },
        {
            "x": -0.5646907091140747,
            "y": 0.09015994518995285,
            "z": -92.27146911621094
        },
        {
            "x": -0.5649137496948242,
            "y": 0.08750279247760773,
            "z": -92.37574768066406
        },
        {
            "x": -0.5649310946464539,
            "y": 0.0835551843047142,
            "z": -92.53234100341797
        },
        {
            "x": -0.5646268129348755,
            "y": 0.07965803146362305,
            "z": -92.68917083740234
        },
        {
            "x": -0.5640947818756104,
            "y": 0.07581845670938492,
            "z": -92.8460693359375
        },
        {
            "x": -0.5633665323257446,
            "y": 0.07204142212867737,
            "z": -93.00291442871094
        },
        {
            "x": -0.5624499320983887,
            "y": 0.06832627952098846,
            "z": -93.15986633300781
        },
        {
            "x": -0.5613362193107605,
            "y": 0.06468360126018524,
            "z": -93.31671905517578
        },
        {
            "x": -0.560028612613678,
            "y": 0.06111409515142441,
            "z": -93.47356414794922
        },
        {
            "x": -0.5585300922393799,
            "y": 0.057615071535110474,
            "z": -93.63060760498047
        },
        {
            "x": -0.5568416714668274,
            "y": 0.05419892817735672,
            "z": -93.78743743896484
        },
        {
            "x": -0.5549558401107788,
            "y": 0.05086497962474823,
            "z": -93.94432830810547
        },
        {
            "x": -0.5528656244277954,
            "y": 0.047617893666028976,
            "z": -94.10122680664062
        },
        {
            "x": -0.5505797863006592,
            "y": 0.04446066915988922,
            "z": -94.258056640625
        },
        {
            "x": -0.5480902791023254,
            "y": 0.041391175240278244,
            "z": -94.41507720947266
        },
        {
            "x": -0.5453985333442688,
            "y": 0.03842315077781677,
            "z": -94.57189178466797
        },
        {
            "x": -0.5425024628639221,
            "y": 0.035556092858314514,
            "z": -94.72870635986328
        },
        {
            "x": -0.5393984317779541,
            "y": 0.032788924872875214,
            "z": -94.88563537597656
        },
        {
            "x": -0.5360919237136841,
            "y": 0.03012886270880699,
            "z": -95.04243469238281
        },
        {
            "x": -0.532571017742157,
            "y": 0.027578070759773254,
            "z": -95.19935607910156
        },
        {
            "x": -0.5288329720497131,
            "y": 0.025142565369606018,
            "z": -95.35625457763672
        },
        {
            "x": -0.5248881578445435,
            "y": 0.022824205458164215,
            "z": -95.51304626464844
        },
        {
            "x": -0.5207307934761047,
            "y": 0.020624564960598946,
            "z": -95.6698226928711
        },
        {
            "x": -0.5163544416427612,
            "y": 0.018549110740423203,
            "z": -95.82659149169922
        },
        {
            "x": -0.5117594599723816,
            "y": 0.01660297065973282,
            "z": -95.98336791992188
        },
        {
            "x": -0.5069406032562256,
            "y": 0.014783540740609169,
            "z": -96.14032745361328
        },
        {
            "x": -0.5019092559814453,
            "y": 0.013098567724227905,
            "z": -96.29707336425781
        },
        {
            "x": -0.49665504693984985,
            "y": 0.011550746858119965,
            "z": -96.45387268066406
        },
        {
            "x": -0.49117031693458557,
            "y": 0.010146629065275192,
            "z": -96.61064910888672
        },
        {
            "x": -0.4854637384414673,
            "y": 0.008885170333087444,
            "z": -96.76737976074219
        },
        {
            "x": -0.4795271158218384,
            "y": 0.007767922710627317,
            "z": -96.92428588867188
        },
        {
            "x": -0.4733694791793823,
            "y": 0.006803320720791817,
            "z": -97.08098602294922
        },
        {
            "x": -0.4669749140739441,
            "y": 0.005996194668114185,
            "z": -97.23767852783203
        },
        {
            "x": -0.460348516702652,
            "y": 0.0053444067016243935,
            "z": -97.39448547363281
        },
        {
            "x": -0.4534984827041626,
            "y": 0.004852034151554108,
            "z": -97.5511474609375
        },
        {
            "x": -0.4464111626148224,
            "y": 0.004523804876953363,
            "z": -97.70790100097656
        },
        {
            "x": -0.43908262252807617,
            "y": 0.004367528483271599,
            "z": -97.86463165283203
        },
        {
            "x": -0.43152767419815063,
            "y": 0.00435137003660202,
            "z": -98.02125549316406
        },
        {
            "x": -0.42373329401016235,
            "y": 0.00435744971036911,
            "z": -98.1780014038086
        },
        {
            "x": -0.41570988297462463,
            "y": 0.0043634697794914246,
            "z": -98.3346176147461
        },
        {
            "x": -0.40744176506996155,
            "y": 0.004369515925645828,
            "z": -98.49119567871094
        },
        {
            "x": -0.39892661571502686,
            "y": 0.004375554621219635,
            "z": -98.64797973632812
        },
        {
            "x": -0.39018720388412476,
            "y": 0.00438159704208374,
            "z": -98.80455017089844
        },
        {
            "x": -0.3812101483345032,
            "y": 0.004387624561786652,
            "z": -98.9610824584961
        },
        {
            "x": -0.3750893175601959,
            "y": 0.004391677677631378,
            "z": -99.06544494628906
        },
        {
            "x": -0.3657149374485016,
            "y": 0.004397720098495483,
            "z": -99.22196197509766
        },
        {
            "x": -0.35609617829322815,
            "y": 0.004403766244649887,
            "z": -99.37858581542969
        },
        {
            "x": -0.34623441100120544,
            "y": 0.004409819841384888,
            "z": -99.5351791381836
        },
        {
            "x": -0.3361443877220154,
            "y": 0.004415828734636307,
            "z": -99.69166564941406
        },
        {
            "x": -0.32581478357315063,
            "y": 0.004421878606081009,
            "z": -99.8482437133789
        },
        {
            "x": -0.31525689363479614,
            "y": 0.004427924752235413,
            "z": -100.00471496582031
        },
        {
            "x": -0.30445626378059387,
            "y": 0.004433959722518921,
            "z": -100.1611557006836
        },
        {
            "x": -0.293412446975708,
            "y": 0.004440039396286011,
            "z": -100.31777954101562
        },
        {
            "x": -0.28215593099594116,
            "y": 0.004446070641279221,
            "z": -100.47421264648438
        },
        {
            "x": -0.27067050337791443,
            "y": 0.004452083259820938,
            "z": -100.63067626953125
        },
        {
            "x": -0.2589501142501831,
            "y": 0.004458148032426834,
            "z": -100.78711700439453
        },
        {
            "x": -0.24701566994190216,
            "y": 0.004464197903871536,
            "z": -100.9435043334961
        },
        {
            "x": -0.23484918475151062,
            "y": 0.004470210522413254,
            "z": -101.10006713867188
        },
        {
            "x": -0.2224861979484558,
            "y": 0.004476260393857956,
            "z": -101.25643157958984
        },
        {
            "x": -0.20990228652954102,
            "y": 0.004482302814722061,
            "z": -101.41280364990234
        },
        {
            "x": -0.1971096396446228,
            "y": 0.004488356411457062,
            "z": -101.56925201416016
        },
        {
            "x": -0.18412935733795166,
            "y": 0.0044944025576114655,
            "z": -101.72560119628906
        },
        {
            "x": -0.17094829678535461,
            "y": 0.004500433802604675,
            "z": -101.88204193115234
        },
        {
            "x": -0.15757638216018677,
            "y": 0.004506487399339676,
            "z": -102.03846740722656
        },
        {
            "x": -0.14403651654720306,
            "y": 0.00451250746846199,
            "z": -102.19480895996094
        },
        {
            "x": -0.13033021986484528,
            "y": 0.004518583416938782,
            "z": -102.35115051269531
        },
        {
            "x": -0.11646576225757599,
            "y": 0.004524603486061096,
            "z": -102.50748443603516
        },
        {
            "x": -0.102447509765625,
            "y": 0.004530642181634903,
            "z": -102.6638412475586
        },
        {
            "x": -0.08827286958694458,
            "y": 0.004536721855401993,
            "z": -102.82039642333984
        },
        {
            "x": -0.07398976385593414,
            "y": 0.004542775452136993,
            "z": -102.97676849365234
        },
        {
            "x": -0.059592682868242264,
            "y": 0.004548788070678711,
            "z": -103.1332015991211
        },
        {
            "x": -0.04509451985359192,
            "y": 0.004554830491542816,
            "z": -103.2896728515625
        },
        {
            "x": -0.030522294342517853,
            "y": 0.004560843110084534,
            "z": -103.44609069824219
        },
        {
            "x": -0.015867523849010468,
            "y": 0.0045669302344322205,
            "z": -103.60275268554688
        },
        {
            "x": -0.001186266541481018,
            "y": 0.0045729465782642365,
            "z": -103.75923156738281
        },
        {
            "x": 0.013519980013370514,
            "y": 0.0045911893248558044,
            "z": -103.91575622558594
        },
        {
            "x": 0.028238296508789062,
            "y": 0.004866724833846092,
            "z": -104.07244110107422
        },
        {
            "x": 0.04292096197605133,
            "y": 0.005529578775167465,
            "z": -104.22904968261719
        },
        {
            "x": 0.057566508650779724,
            "y": 0.006572256796061993,
            "z": -104.38581085205078
        },
        {
            "x": 0.07213133573532104,
            "y": 0.008000699803233147,
            "z": -104.5426025390625
        },
        {
            "x": 0.08658229559659958,
            "y": 0.009793815203011036,
            "z": -104.69938659667969
        },
        {
            "x": 0.1009044498205185,
            "y": 0.01194232702255249,
            "z": -104.8563461303711
        },
        {
            "x": 0.11504432559013367,
            "y": 0.01443500630557537,
            "z": -105.01327514648438
        },
        {
            "x": 0.12896639108657837,
            "y": 0.017277618870139122,
            "z": -105.17027282714844
        },
        {
            "x": 0.14265890419483185,
            "y": 0.020457562059164047,
            "z": -105.32759094238281
        },
        {
            "x": 0.156039297580719,
            "y": 0.02395392768085003,
            "z": -105.48477172851562
        },
        {
            "x": 0.16909289360046387,
            "y": 0.02776353433728218,
            "z": -105.64208221435547
        },
        {
            "x": 0.17756831645965576,
            "y": 0.030483361333608627,
            "z": -105.74700164794922
        },
        {
            "x": 0.18994459509849548,
            "y": 0.03480559587478638,
            "z": -105.90450286865234
        },
        {
            "x": 0.20186549425125122,
            "y": 0.039422690868377686,
            "z": -106.06222534179688
        },
        {
            "x": 0.21324238181114197,
            "y": 0.04433199018239975,
            "z": -106.2200698852539
        },
        {
            "x": 0.22403430938720703,
            "y": 0.04951806738972664,
            "z": -106.3779525756836
        },
        {
            "x": 0.2341938614845276,
            "y": 0.05497497320175171,
            "z": -106.53610229492188
        },
        {
            "x": 0.24364814162254333,
            "y": 0.06068672984838486,
            "z": -106.69426727294922
        },
        {
            "x": 0.25232595205307007,
            "y": 0.06665746867656708,
            "z": -106.85260772705078
        },
        {
            "x": 0.26017189025878906,
            "y": 0.07288341224193573,
            "z": -107.01129913330078
        },
        {
            "x": 0.26710939407348633,
            "y": 0.07933606952428818,
            "z": -107.1699447631836
        },
        {
            "x": 0.2730880677700043,
            "y": 0.08601725101470947,
            "z": -107.32878112792969
        },
        {
            "x": 0.2780131995677948,
            "y": 0.09292224049568176,
            "z": -107.48777770996094
        },
        {
            "x": 0.28181523084640503,
            "y": 0.10003909468650818,
            "z": -107.64688873291016
        },
        {
            "x": 0.28444704413414,
            "y": 0.10736562311649323,
            "z": -107.80631256103516
        },
        {
            "x": 0.285858154296875,
            "y": 0.11486497521400452,
            "z": -107.96548461914062
        },
        {
            "x": 0.2863192558288574,
            "y": 0.12249192595481873,
            "z": -108.12352752685547
        },
        {
            "x": 0.28656432032585144,
            "y": 0.1302473545074463,
            "z": -108.28071594238281
        },
        {
            "x": 0.286835253238678,
            "y": 0.13814862072467804,
            "z": -108.43766784667969
        },
        {
            "x": 0.28713861107826233,
            "y": 0.14620386064052582,
            "z": -108.59473419189453
        },
        {
            "x": 0.2874690890312195,
            "y": 0.15440192818641663,
            "z": -108.75180053710938
        },
        {
            "x": 0.2878227233886719,
            "y": 0.16272902488708496,
            "z": -108.90876007080078
        },
        {
            "x": 0.2881954312324524,
            "y": 0.1711796224117279,
            "z": -109.06573486328125
        },
        {
            "x": 0.28858456015586853,
            "y": 0.17974255979061127,
            "z": -109.22270202636719
        },
        {
            "x": 0.2889878451824188,
            "y": 0.18841183185577393,
            "z": -109.37965393066406
        },
        {
            "x": 0.28940433263778687,
            "y": 0.19719332456588745,
            "z": -109.53683471679688
        },
        {
            "x": 0.2898309528827667,
            "y": 0.20604947209358215,
            "z": -109.69379425048828
        },
        {
            "x": 0.2902669310569763,
            "y": 0.21498838067054749,
            "z": -109.8508071899414
        },
        {
            "x": 0.29071104526519775,
            "y": 0.22399815917015076,
            "z": -110.0078125
        },
        {
            "x": 0.291162371635437,
            "y": 0.23306868970394135,
            "z": -110.16476440429688
        },
        {
            "x": 0.2916203737258911,
            "y": 0.2422035038471222,
            "z": -110.3219223022461
        },
        {
            "x": 0.2920833230018616,
            "y": 0.251370906829834,
            "z": -110.47887420654297
        },
        {
            "x": 0.2925509810447693,
            "y": 0.2605735659599304,
            "z": -110.63580322265625
        },
        {
            "x": 0.2930232286453247,
            "y": 0.26981091499328613,
            "z": -110.79286193847656
        },
        {
            "x": 0.29349881410598755,
            "y": 0.2790597677230835,
            "z": -110.94979858398438
        },
        {
            "x": 0.2939777970314026,
            "y": 0.28832483291625977,
            "z": -111.10685729980469
        },
        {
            "x": 0.2944595217704773,
            "y": 0.2975904941558838,
            "z": -111.263916015625
        },
        {
            "x": 0.2949432134628296,
            "y": 0.30684176087379456,
            "z": -111.42086029052734
        },
        {
            "x": 0.2954293489456177,
            "y": 0.3160838782787323,
            "z": -111.57792663574219
        },
        {
            "x": 0.2959167957305908,
            "y": 0.3252940773963928,
            "z": -111.7348861694336
        },
        {
            "x": 0.296405553817749,
            "y": 0.33446991443634033,
            "z": -111.89183807373047
        },
        {
            "x": 0.2968961000442505,
            "y": 0.3436145782470703,
            "z": -112.04900360107422
        },
        {
            "x": 0.29738694429397583,
            "y": 0.3526962995529175,
            "z": -112.20598602294922
        },
        {
            "x": 0.29787853360176086,
            "y": 0.36171743273735046,
            "z": -112.36294555664062
        },
        {
            "x": 0.2982064485549927,
            "y": 0.36769476532936096,
            "z": -112.46761322021484
        },
        {
            "x": 0.29869866371154785,
            "y": 0.37659507989883423,
            "z": -112.62458038330078
        },
        {
            "x": 0.299191415309906,
            "y": 0.3854186534881592,
            "z": -112.78167724609375
        },
        {
            "x": 0.2996841073036194,
            "y": 0.3941511809825897,
            "z": -112.93877410888672
        },
        {
            "x": 0.3001764416694641,
            "y": 0.4027741551399231,
            "z": -113.09576416015625
        },
        {
            "x": 0.3006686568260193,
            "y": 0.41129299998283386,
            "z": -113.25288391113281
        },
        {
            "x": 0.3011602759361267,
            "y": 0.41968834400177,
            "z": -113.40989685058594
        },
        {
            "x": 0.3016514778137207,
            "y": 0.42795759439468384,
            "z": -113.56690979003906
        },
        {
            "x": 0.30214256048202515,
            "y": 0.4360988140106201,
            "z": -113.72413635253906
        },
        {
            "x": 0.3026324212551117,
            "y": 0.444083034992218,
            "z": -113.88116455078125
        },
        {
            "x": 0.3031216263771057,
            "y": 0.451917827129364,
            "z": -114.03826141357422
        },
        {
            "x": 0.3036099672317505,
            "y": 0.4595921039581299,
            "z": -114.19537353515625
        },
        {
            "x": 0.30409711599349976,
            "y": 0.46709033846855164,
            "z": -114.35245513916016
        },
        {
            "x": 0.3045838177204132,
            "y": 0.4744144082069397,
            "z": -114.50971221923828
        },
        {
            "x": 0.30506882071495056,
            "y": 0.4815426468849182,
            "z": -114.66679382324219
        },
        {
            "x": 0.30555275082588196,
            "y": 0.48847562074661255,
            "z": -114.8238754272461
        },
        {
            "x": 0.3060356378555298,
            "y": 0.4952038526535034,
            "z": -114.98107147216797
        },
        {
            "x": 0.30651700496673584,
            "y": 0.5017088055610657,
            "z": -115.13819122314453
        },
        {
            "x": 0.30699723958969116,
            "y": 0.5079959630966187,
            "z": -115.29540252685547
        },
        {
            "x": 0.30747613310813904,
            "y": 0.514051616191864,
            "z": -115.45262908935547
        },
        {
            "x": 0.3079533576965332,
            "y": 0.5198609828948975,
            "z": -115.60974884033203
        },
        {
            "x": 0.30842888355255127,
            "y": 0.5254141688346863,
            "z": -115.76691436767578
        },
        {
            "x": 0.3089030385017395,
            "y": 0.5307104587554932,
            "z": -115.92405700683594
        },
        {
            "x": 0.3093756139278412,
            "y": 0.5357412099838257,
            "z": -116.08123016357422
        },
        {
            "x": 0.3098471164703369,
            "y": 0.540500283241272,
            "z": -116.23860168457031
        },
        {
            "x": 0.3103165030479431,
            "y": 0.5449596643447876,
            "z": -116.39578247070312
        },
        {
            "x": 0.3107842206954956,
            "y": 0.5491290092468262,
            "z": -116.55303192138672
        },
        {
            "x": 0.3112502992153168,
            "y": 0.5529976487159729,
            "z": -116.71027374267578
        },
        {
            "x": 0.31171461939811707,
            "y": 0.5565521717071533,
            "z": -116.86748504638672
        },
        {
            "x": 0.31217750906944275,
            "y": 0.5597805976867676,
            "z": -117.02488708496094
        },
        {
            "x": 0.31263822317123413,
            "y": 0.5626778602600098,
            "z": -117.18211364746094
        },
        {
            "x": 0.3130970895290375,
            "y": 0.5652395486831665,
            "z": -117.33934020996094
        },
        {
            "x": 0.31355440616607666,
            "y": 0.5674555897712708,
            "z": -117.49668884277344
        },
        {
            "x": 0.31400954723358154,
            "y": 0.5693024396896362,
            "z": -117.6539306640625
        },
        {
            "x": 0.31446313858032227,
            "y": 0.5707883834838867,
            "z": -117.81127166748047
        },
        {
            "x": 0.3149147927761078,
            "y": 0.5719034671783447,
            "z": -117.96862030029297
        },
        {
            "x": 0.3153643012046814,
            "y": 0.5726356506347656,
            "z": -118.1258544921875
        },
        {
            "x": 0.3158121705055237,
            "y": 0.5729637742042542,
            "z": -118.2832260131836
        },
        {
            "x": 0.3162577450275421,
            "y": 0.572895884513855,
            "z": -118.44048309326172
        },
        {
            "x": 0.3167012929916382,
            "y": 0.5724343061447144,
            "z": -118.59772491455078
        },
        {
            "x": 0.31714367866516113,
            "y": 0.5715847611427307,
            "z": -118.75518035888672
        },
        {
            "x": 0.31758326292037964,
            "y": 0.570343017578125,
            "z": -118.91242980957031
        },
        {
            "x": 0.31802287697792053,
            "y": 0.5687345266342163,
            "z": -119.06965637207031
        },
        {
            "x": 0.3183135986328125,
            "y": 0.5674693584442139,
            "z": -119.17447662353516
        },
        {
            "x": 0.31874793767929077,
            "y": 0.5652561187744141,
            "z": -119.33172607421875
        },
        {
            "x": 0.3191804885864258,
            "y": 0.5626974105834961,
            "z": -119.48904418945312
        },
        {
            "x": 0.3196108043193817,
            "y": 0.5598031282424927,
            "z": -119.64636993408203
        },
        {
            "x": 0.32003915309906006,
            "y": 0.5565832257270813,
            "z": -119.80358123779297
        },
        {
            "x": 0.32046547532081604,
            "y": 0.5530277490615845,
            "z": -119.9609146118164
        },
        {
            "x": 0.320889413356781,
            "y": 0.549166202545166,
            "z": -120.11809539794922
        },
        {
            "x": 0.3213115334510803,
            "y": 0.5450038313865662,
            "z": -120.27529907226562
        },
        {
            "x": 0.3217318058013916,
            "y": 0.5405447483062744,
            "z": -120.43267822265625
        },
        {
            "x": 0.32214969396591187,
            "y": 0.5357943773269653,
            "z": -120.58984375
        },
        {
            "x": 0.3225654363632202,
            "y": 0.5307682752609253,
            "z": -120.7470703125
        },
        {
            "x": 0.32297903299331665,
            "y": 0.5254764556884766,
            "z": -120.90428161621094
        },
        {
            "x": 0.32339078187942505,
            "y": 0.519930362701416,
            "z": -121.0614242553711
        },
        {
            "x": 0.3238004446029663,
            "y": 0.514116644859314,
            "z": -121.21878051757812
        },
        {
            "x": 0.3242078423500061,
            "y": 0.508071780204773,
            "z": -121.37590789794922
        },
        {
            "x": 0.32461297512054443,
            "y": 0.5017964839935303,
            "z": -121.53301239013672
        },
        {
            "x": 0.3250163197517395,
            "y": 0.49529439210891724,
            "z": -121.69023895263672
        },
        {
            "x": 0.325417160987854,
            "y": 0.4885752201080322,
            "z": -121.84732818603516
        },
        {
            "x": 0.32581615447998047,
            "y": 0.4816465675830841,
            "z": -122.0045166015625
        },
        {
            "x": 0.32621315121650696,
            "y": 0.474521666765213,
            "z": -122.16170501708984
        },
        {
            "x": 0.3266075849533081,
            "y": 0.46721500158309937,
            "z": -122.31875610351562
        },
        {
            "x": 0.32700008153915405,
            "y": 0.4597238302230835,
            "z": -122.4758071899414
        },
        {
            "x": 0.32739028334617615,
            "y": 0.45206135511398315,
            "z": -122.63286590576172
        },
        {
            "x": 0.32777857780456543,
            "y": 0.4442381262779236,
            "z": -122.7899169921875
        },
        {
            "x": 0.3281649947166443,
            "y": 0.4362533688545227,
            "z": -122.94715118408203
        },
        {
            "x": 0.32854902744293213,
            "y": 0.4281299114227295,
            "z": -123.10419464111328
        },
        {
            "x": 0.3289308547973633,
            "y": 0.41986799240112305,
            "z": -123.2612533569336
        },
        {
            "x": 0.3293105959892273,
            "y": 0.41147929430007935,
            "z": -123.41832733154297
        },
        {
            "x": 0.3296881914138794,
            "y": 0.4029771089553833,
            "z": -123.5753402709961
        },
        {
            "x": 0.33006393909454346,
            "y": 0.39435112476348877,
            "z": -123.73255157470703
        },
        {
            "x": 0.3304373323917389,
            "y": 0.3856354355812073,
            "z": -123.88954162597656
        },
        {
            "x": 0.3308084011077881,
            "y": 0.3768281638622284,
            "z": -124.0465316772461
        },
        {
            "x": 0.3311777710914612,
            "y": 0.3679322600364685,
            "z": -124.2036361694336
        },
        {
            "x": 0.3315446376800537,
            "y": 0.35896673798561096,
            "z": -124.3606185913086
        },
        {
            "x": 0.3319096863269806,
            "y": 0.34992891550064087,
            "z": -124.51769256591797
        },
        {
            "x": 0.332272469997406,
            "y": 0.3408343195915222,
            "z": -124.67477416992188
        },
        {
            "x": 0.33263319730758667,
            "y": 0.3316986858844757,
            "z": -124.83174133300781
        },
        {
            "x": 0.33299165964126587,
            "y": 0.3225160837173462,
            "z": -124.98881530761719
        },
        {
            "x": 0.3333481252193451,
            "y": 0.3133080005645752,
            "z": -125.14579010009766
        },
        {
            "x": 0.3337021768093109,
            "y": 0.30407875776290894,
            "z": -125.30274200439453
        },
        {
            "x": 0.3340548872947693,
            "y": 0.29482418298721313,
            "z": -125.45989227294922
        },
        {
            "x": 0.33440470695495605,
            "y": 0.2855759859085083,
            "z": -125.61686706542969
        },
        {
            "x": 0.3347526788711548,
            "y": 0.2763320207595825,
            "z": -125.77381896972656
        },
        {
            "x": 0.3349832594394684,
            "y": 0.2701767683029175,
            "z": -125.87846374511719
        },
        {
            "x": 0.33532780408859253,
            "y": 0.2609589099884033,
            "z": -126.0354232788086
        },
        {
            "x": 0.3356701731681824,
            "y": 0.2517634630203247,
            "z": -126.1924819946289
        },
        {
            "x": 0.3360106348991394,
            "y": 0.24260340631008148,
            "z": -126.34956359863281
        },
        {
            "x": 0.3363487124443054,
            "y": 0.2334936410188675,
            "z": -126.50653076171875
        },
        {
            "x": 0.3366849422454834,
            "y": 0.22443106770515442,
            "z": -126.66361999511719
        },
        {
            "x": 0.33701878786087036,
            "y": 0.21543827652931213,
            "z": -126.82061004638672
        },
        {
            "x": 0.33735066652297974,
            "y": 0.20651713013648987,
            "z": -126.97756958007812
        },
        {
            "x": 0.3376806676387787,
            "y": 0.19766399264335632,
            "z": -127.13475799560547
        },
        {
            "x": 0.3380083739757538,
            "y": 0.18890897929668427,
            "z": -127.29174041748047
        },
        {
            "x": 0.3383341431617737,
            "y": 0.18025153875350952,
            "z": -127.44878387451172
        },
        {
            "x": 0.33865755796432495,
            "y": 0.17169885337352753,
            "z": -127.60584259033203
        },
        {
            "x": 0.3389790654182434,
            "y": 0.16326335072517395,
            "z": -127.7628402709961
        },
        {
            "x": 0.33929863572120667,
            "y": 0.15494003891944885,
            "z": -127.9200439453125
        },
        {
            "x": 0.3396161198616028,
            "y": 0.14676323533058167,
            "z": -128.07705688476562
        },
        {
            "x": 0.3399311304092407,
            "y": 0.13872738182544708,
            "z": -128.23406982421875
        },
        {
            "x": 0.3402445316314697,
            "y": 0.1308349072933197,
            "z": -128.39120483398438
        },
        {
            "x": 0.34055548906326294,
            "y": 0.1231035441160202,
            "z": -128.54824829101562
        },
        {
            "x": 0.3408648371696472,
            "y": 0.11553950607776642,
            "z": -128.70541381835938
        },
        {
            "x": 0.3411718010902405,
            "y": 0.10815301537513733,
            "z": -128.862548828125
        },
        {
            "x": 0.3414768576622009,
            "y": 0.10095366835594177,
            "z": -129.0196075439453
        },
        {
            "x": 0.34177953004837036,
            "y": 0.09394639730453491,
            "z": -129.17666625976562
        },
        {
            "x": 0.34208041429519653,
            "y": 0.08714619278907776,
            "z": -129.33375549316406
        },
        {
            "x": 0.34237906336784363,
            "y": 0.0805579274892807,
            "z": -129.4908447265625
        },
        {
            "x": 0.3426761031150818,
            "y": 0.07418079674243927,
            "z": -129.6481475830078
        },
        {
            "x": 0.3429708480834961,
            "y": 0.06803812086582184,
            "z": -129.80523681640625
        },
        {
            "x": 0.3432633876800537,
            "y": 0.062135595828294754,
            "z": -129.96241760253906
        },
        {
            "x": 0.34355416893959045,
            "y": 0.056482017040252686,
            "z": -130.11961364746094
        },
        {
            "x": 0.3438425660133362,
            "y": 0.05108395591378212,
            "z": -130.2767333984375
        },
        {
            "x": 0.34412962198257446,
            "y": 0.045939814299345016,
            "z": -130.43408203125
        },
        {
            "x": 0.3444139063358307,
            "y": 0.041081104427576065,
            "z": -130.59124755859375
        },
        {
            "x": 0.3446964621543884,
            "y": 0.03650753200054169,
            "z": -130.74839782714844
        },
        {
            "x": 0.3449769616127014,
            "y": 0.032218825072050095,
            "z": -130.90565490722656
        },
        {
            "x": 0.34525540471076965,
            "y": 0.028229497373104095,
            "z": -131.0628204345703
        },
        {
            "x": 0.34553200006484985,
            "y": 0.024551071226596832,
            "z": -131.2201385498047
        },
        {
            "x": 0.34580639004707336,
            "y": 0.02119509130716324,
            "z": -131.3773956298828
        },
        {
            "x": 0.34607890248298645,
            "y": 0.01816391944885254,
            "z": -131.5345916748047
        },
        {
            "x": 0.34634914994239807,
            "y": 0.015462887473404408,
            "z": -131.69187927246094
        },
        {
            "x": 0.3466176986694336,
            "y": 0.01311199925839901,
            "z": -131.8490753173828
        },
        {
            "x": 0.3468838334083557,
            "y": 0.011118898168206215,
            "z": -132.0063018798828
        },
        {
            "x": 0.34714850783348083,
            "y": 0.009482152760028839,
            "z": -132.16371154785156
        },
        {
            "x": 0.3474108576774597,
            "y": 0.008214318193495274,
            "z": -132.32093811035156
        },
        {
            "x": 0.34767210483551025,
            "y": 0.007329839281737804,
            "z": -132.47816467285156
        },
        {
            "x": 0.3478456139564514,
            "y": 0.006961798295378685,
            "z": -132.58297729492188
        },
        {
            "x": 0.34810250997543335,
            "y": 0.006726614665240049,
            "z": -132.74020385742188
        },
        {
            "x": 0.3483577370643616,
            "y": 0.006726525723934174,
            "z": -132.89752197265625
        },
        {
            "x": 0.34861084818840027,
            "y": 0.006733149290084839,
            "z": -133.0548553466797
        },
        {
            "x": 0.3488617539405823,
            "y": 0.006739780306816101,
            "z": -133.2121124267578
        },
        {
            "x": 0.34911105036735535,
            "y": 0.00674641877412796,
            "z": -133.36944580078125
        },
        {
            "x": 0.3493579626083374,
            "y": 0.006753057241439819,
            "z": -133.52667236328125
        },
        {
            "x": 0.34960320591926575,
            "y": 0.006759651005268097,
            "z": -133.6839141845703
        },
        {
            "x": 0.3498464822769165,
            "y": 0.006766311824321747,
            "z": -133.8413543701172
        },
        {
            "x": 0.3500875234603882,
            "y": 0.006772935390472412,
            "z": -133.9985809326172
        },
        {
            "x": 0.3503269553184509,
            "y": 0.006779558956623077,
            "z": -134.15586853027344
        },
        {
            "x": 0.35056400299072266,
            "y": 0.006786152720451355,
            "z": -134.3131561279297
        },
        {
            "x": 0.35079944133758545,
            "y": 0.006792791187763214,
            "z": -134.47039794921875
        },
        {
            "x": 0.3510328233242035,
            "y": 0.006799429655075073,
            "z": -134.62783813476562
        },
        {
            "x": 0.3512642979621887,
            "y": 0.0068060532212257385,
            "z": -134.78506469726562
        },
        {
            "x": 0.3514936566352844,
            "y": 0.00681266188621521,
            "z": -134.9423065185547
        },
        {
            "x": 0.35172104835510254,
            "y": 0.006819292902946472,
            "z": -135.09967041015625
        },
        {
            "x": 0.35194677114486694,
            "y": 0.0068259164690971375,
            "z": -135.25689697265625
        },
        {
            "x": 0.3521702289581299,
            "y": 0.0068325474858284,
            "z": -135.4142303466797
        },
        {
            "x": 0.3523920476436615,
            "y": 0.006839171051979065,
            "z": -135.57156372070312
        },
        {
            "x": 0.352611780166626,
            "y": 0.006845816969871521,
            "z": -135.72879028320312
        },
        {
            "x": 0.3528292775154114,
            "y": 0.006852433085441589,
            "z": -135.88604736328125
        },
        {
            "x": 0.3530453145503998,
            "y": 0.006859049201011658,
            "z": -136.04327392578125
        },
        {
            "x": 0.35325896739959717,
            "y": 0.006865665316581726,
            "z": -136.20050048828125
        },
        {
            "x": 0.3534712791442871,
            "y": 0.006872296333312988,
            "z": -136.35794067382812
        },
        {
            "x": 0.35368138551712036,
            "y": 0.006878949701786041,
            "z": -136.51516723632812
        },
        {
            "x": 0.3538894057273865,
            "y": 0.006885550916194916,
            "z": -136.6724853515625
        },
        {
            "x": 0.3540958762168884,
            "y": 0.006892189383506775,
            "z": -136.82977294921875
        },
        {
            "x": 0.35429996252059937,
            "y": 0.006898798048496246,
            "z": -136.98699951171875
        },
        {
            "x": 0.35450267791748047,
            "y": 0.006905443966388702,
            "z": -137.1444091796875
        },
        {
            "x": 0.35470324754714966,
            "y": 0.006912067532539368,
            "z": -137.30166625976562
        },
        {
            "x": 0.3549014925956726,
            "y": 0.006918683648109436,
            "z": -137.45889282226562
        },
        {
            "x": 0.35509854555130005,
            "y": 0.006925307214260101,
            "z": -137.61624145507812
        },
        {
            "x": 0.35529226064682007,
            "y": 0.0069319382309913635,
            "z": -137.77346801757812
        },
        {
            "x": 0.35548317432403564,
            "y": 0.006938561797142029,
            "z": -137.93081665039062
        },
        {
            "x": 0.35567140579223633,
            "y": 0.006945192813873291,
            "z": -138.08816528320312
        },
        {
            "x": 0.3558424115180969,
            "y": 0.00695183128118515,
            "z": -138.24542236328125
        },
        {
            "x": 0.3560061454772949,
            "y": 0.0069584473967552185,
            "z": -138.40277099609375
        },
        {
            "x": 0.35613223910331726,
            "y": 0.006965085864067078,
            "z": -138.5601806640625
        },
        {
            "x": 0.3561690151691437,
            "y": 0.006971709430217743,
            "z": -138.717529296875
        },
        {
            "x": 0.3561481237411499,
            "y": 0.006978340446949005,
            "z": -138.87521362304688
        },
        {
            "x": 0.35591286420822144,
            "y": 0.006984978914260864,
            "z": -139.03298950195312
        },
        {
            "x": 0.3554527461528778,
            "y": 0.006991587579250336,
            "z": -139.19061279296875
        },
        {
            "x": 0.3549976348876953,
            "y": 0.006996020674705505,
            "z": -139.29595947265625
        },
        {
            "x": 0.3539431691169739,
            "y": 0.007002636790275574,
            "z": -139.45411682128906
        },
        {
            "x": 0.35251814126968384,
            "y": 0.007009260356426239,
            "z": -139.61215209960938
        },
        {
            "x": 0.3506065607070923,
            "y": 0.007015891373157501,
            "z": -139.77069091796875
        },
        {
            "x": 0.3481476902961731,
            "y": 0.00702250748872757,
            "z": -139.9287872314453
        },
        {
            "x": 0.34528273344039917,
            "y": 0.007029145956039429,
            "z": -140.0871124267578
        },
        {
            "x": 0.34180182218551636,
            "y": 0.007035799324512482,
            "z": -140.24559020996094
        },
        {
            "x": 0.3378340005874634,
            "y": 0.00704241544008255,
            "z": -140.40354919433594
        },
        {
            "x": 0.333365261554718,
            "y": 0.007048994302749634,
            "z": -140.5622100830078
        },
        {
            "x": 0.32828810811042786,
            "y": 0.00705564022064209,
            "z": -140.7203826904297
        },
        {
            "x": 0.3228110671043396,
            "y": 0.007062256336212158,
            "z": -140.87850952148438
        },
        {
            "x": 0.3167046010494232,
            "y": 0.007068902254104614,
            "z": -141.03700256347656
        },
        {
            "x": 0.3100910782814026,
            "y": 0.0070560285821557045,
            "z": -141.19496154785156
        },
        {
            "x": 0.30301690101623535,
            "y": 0.00684132007881999,
            "z": -141.35342407226562
        },
        {
            "x": 0.2953234910964966,
            "y": 0.00640078354626894,
            "z": -141.51162719726562
        },
        {
            "x": 0.28720900416374207,
            "y": 0.005734880454838276,
            "z": -141.6695098876953
        },
        {
            "x": 0.2785131633281708,
            "y": 0.004849882796406746,
            "z": -141.8279571533203
        },
        {
            "x": 0.2692910432815552,
            "y": 0.003756531747058034,
            "z": -141.9857940673828
        },
        {
            "x": 0.25964081287384033,
            "y": 0.0024519541766494513,
            "z": -142.14393615722656
        },
        {
            "x": 0.2493414282798767,
            "y": 0.0009319696109741926,
            "z": -142.30213928222656
        },
        {
            "x": 0.23863400518894196,
            "y": -0.0007879836484789848,
            "z": -142.45982360839844
        },
        {
            "x": 0.2273882031440735,
            "y": -0.0027132248505949974,
            "z": -142.61793518066406
        },
        {
            "x": 0.21559429168701172,
            "y": -0.004831343423575163,
            "z": -142.77565002441406
        },
        {
            "x": 0.203384131193161,
            "y": -0.00715211546048522,
            "z": -142.9334259033203
        },
        {
            "x": 0.1905309557914734,
            "y": -0.009672991000115871,
            "z": -143.091552734375
        },
        {
            "x": 0.1772768497467041,
            "y": -0.012372544966638088,
            "z": -143.24903869628906
        },
        {
            "x": 0.16350026428699493,
            "y": -0.015266270376741886,
            "z": -143.406982421875
        },
        {
            "x": 0.14916184544563293,
            "y": -0.018342865630984306,
            "z": -143.56451416015625
        },
        {
            "x": 0.1344284862279892,
            "y": -0.0216018445789814,
            "z": -143.7220458984375
        },
        {
            "x": 0.1190757006406784,
            "y": -0.02504624053835869,
            "z": -143.87989807128906
        },
        {
            "x": 0.1033318042755127,
            "y": -0.028650673106312752,
            "z": -144.037109375
        },
        {
            "x": 0.08706645667552948,
            "y": -0.03244183585047722,
            "z": -144.19471740722656
        },
        {
            "x": 0.07024087011814117,
            "y": -0.03639979287981987,
            "z": -144.35206604003906
        },
        {
            "x": 0.05304998159408569,
            "y": -0.04051879793405533,
            "z": -144.50926208496094
        },
        {
            "x": 0.03525441884994507,
            "y": -0.044809747487306595,
            "z": -144.66676330566406
        },
        {
            "x": 0.017049401998519897,
            "y": -0.049251820892095566,
            "z": -144.82374572753906
        },
        {
            "x": -0.0016501843929290771,
            "y": -0.053861841559410095,
            "z": -144.98098754882812
        },
        {
            "x": -0.020882070064544678,
            "y": -0.058620385825634,
            "z": -145.1380157470703
        },
        {
            "x": -0.040476493537425995,
            "y": -0.06352595239877701,
            "z": -145.294921875
        },
        {
            "x": -0.06066734343767166,
            "y": -0.06858929991722107,
            "z": -145.4519500732422
        },
        {
            "x": -0.0812707170844078,
            "y": -0.07379280030727386,
            "z": -145.60870361328125
        },
        {
            "x": -0.10234581679105759,
            "y": -0.0791446790099144,
            "z": -145.7656707763672
        },
        {
            "x": -0.12390980869531631,
            "y": -0.08462370932102203,
            "z": -145.92218017578125
        },
        {
            "x": -0.13848043978214264,
            "y": -0.08835367858409882,
            "z": -146.0264892578125
        },
        {
            "x": -0.16081051528453827,
            "y": -0.0940701961517334,
            "z": -146.18319702148438
        },
        {
            "x": -0.1835906058549881,
            "y": -0.09990666806697845,
            "z": -146.33958435058594
        },
        {
            "x": -0.20678208768367767,
            "y": -0.10588093101978302,
            "z": -146.49612426757812
        },
        {
            "x": -0.23051410913467407,
            "y": -0.11197877675294876,
            "z": -146.65248107910156
        },
        {
            "x": -0.25459766387939453,
            "y": -0.11819233000278473,
            "z": -146.8086700439453
        },
        {
            "x": -0.27919429540634155,
            "y": -0.12453283369541168,
            "z": -146.9650115966797
        },
        {
            "x": -0.30418622493743896,
            "y": -0.13097327947616577,
            "z": -147.120849609375
        },
        {
            "x": -0.32964491844177246,
            "y": -0.13754960894584656,
            "z": -147.27713012695312
        },
        {
            "x": -0.3555799722671509,
            "y": -0.1442227065563202,
            "z": -147.43304443359375
        },
        {
            "x": -0.38184088468551636,
            "y": -0.15099593997001648,
            "z": -147.58876037597656
        },
        {
            "x": -0.4086460769176483,
            "y": -0.15788790583610535,
            "z": -147.7447509765625
        },
        {
            "x": -0.43580329418182373,
            "y": -0.1648625284433365,
            "z": -147.90020751953125
        },
        {
            "x": -0.46342164278030396,
            "y": -0.17195528745651245,
            "z": -148.0560760498047
        },
        {
            "x": -0.4914647936820984,
            "y": -0.17912545800209045,
            "z": -148.21148681640625
        },
        {
            "x": -0.519832193851471,
            "y": -0.18638548254966736,
            "z": -148.36683654785156
        },
        {
            "x": -0.5487520694732666,
            "y": -0.19375067949295044,
            "z": -148.52236938476562
        },
        {
            "x": -0.5779627561569214,
            "y": -0.20117822289466858,
            "z": -148.67739868164062
        },
        {
            "x": -0.6076453924179077,
            "y": -0.20870839059352875,
            "z": -148.83277893066406
        },
        {
            "x": -0.6377353072166443,
            "y": -0.21630463004112244,
            "z": -148.98780822753906
        },
        {
            "x": -0.6681485176086426,
            "y": -0.22397640347480774,
            "z": -149.1427459716797
        },
        {
            "x": -0.6990541219711304,
            "y": -0.23172736167907715,
            "z": -149.29771423339844
        },
        {
            "x": -0.7302461862564087,
            "y": -0.23953285813331604,
            "z": -149.45230102539062
        },
        {
            "x": -0.7618944644927979,
            "y": -0.24742044508457184,
            "z": -149.607177734375
        },
        {
            "x": -0.793938934803009,
            "y": -0.2553665041923523,
            "z": -149.7617645263672
        },
        {
            "x": -0.826300323009491,
            "y": -0.2633732557296753,
            "z": -149.9163055419922
        },
        {
            "x": -0.8591176271438599,
            "y": -0.2714387774467468,
            "z": -150.07083129882812
        },
        {
            "x": -0.8921968936920166,
            "y": -0.2795465588569641,
            "z": -150.22503662109375
        },
        {
            "x": -0.9257397651672363,
            "y": -0.28772127628326416,
            "z": -150.37945556640625
        },
        {
            "x": -0.9596164226531982,
            "y": -0.29593586921691895,
            "z": -150.53359985351562
        },
        {
            "x": -0.9938232898712158,
            "y": -0.30419865250587463,
            "z": -150.6877899169922
        },
        {
            "x": -1.0284230709075928,
            "y": -0.31249576807022095,
            "z": -150.84170532226562
        },
        {
            "x": -1.0633198022842407,
            "y": -0.3208352029323578,
            "z": -150.99562072753906
        },
        {
            "x": -1.098642110824585,
            "y": -0.3292151689529419,
            "z": -151.14952087402344
        },
        {
            "x": -1.134240746498108,
            "y": -0.3376164734363556,
            "z": -151.30311584472656
        },
        {
            "x": -1.1702289581298828,
            "y": -0.3460629880428314,
            "z": -151.45697021484375
        },
        {
            "x": -1.2065287828445435,
            "y": -0.35451823472976685,
            "z": -151.61038208007812
        },
        {
            "x": -1.2431374788284302,
            "y": -0.36300718784332275,
            "z": -151.76390075683594
        },
        {
            "x": -1.2801237106323242,
            "y": -0.3715132474899292,
            "z": -151.9173126220703
        },
        {
            "x": -1.3173320293426514,
            "y": -0.38002467155456543,
            "z": -152.0704345703125
        },
        {
            "x": -1.3549948930740356,
            "y": -0.3885771632194519,
            "z": -152.2239227294922
        },
        {
            "x": -1.392872929573059,
            "y": -0.3971134424209595,
            "z": -152.3768768310547
        },
        {
            "x": -1.4310626983642578,
            "y": -0.4056682288646698,
            "z": -152.52992248535156
        },
        {
            "x": -1.4567328691482544,
            "y": -0.4113749861717224,
            "z": -152.63194274902344
        },
        {
            "x": -1.49540376663208,
            "y": -0.4199228286743164,
            "z": -152.7846221923828
        },
        {
            "x": -1.5344555377960205,
            "y": -0.4284917116165161,
            "z": -152.9376220703125
        },
        {
            "x": -1.573776364326477,
            "y": -0.43704381585121155,
            "z": -153.0902862548828
        },
        {
            "x": -1.6133415699005127,
            "y": -0.4455903172492981,
            "z": -153.242919921875
        },
        {
            "x": -1.653281331062317,
            "y": -0.4541328549385071,
            "z": -153.3955535888672
        },
        {
            "x": -1.6933890581130981,
            "y": -0.4626495838165283,
            "z": -153.54788208007812
        },
        {
            "x": -1.7338414192199707,
            "y": -0.47116172313690186,
            "z": -153.70033264160156
        },
        {
            "x": -1.7745712995529175,
            "y": -0.47965291142463684,
            "z": -153.85269165039062
        },
        {
            "x": -1.8155322074890137,
            "y": -0.48811987042427063,
            "z": -154.00494384765625
        },
        {
            "x": -1.8567906618118286,
            "y": -0.496559739112854,
            "z": -154.15707397460938
        },
        {
            "x": -1.8982511758804321,
            "y": -0.5049699544906616,
            "z": -154.30911254882812
        },
        {
            "x": -1.9400255680084229,
            "y": -0.5133541822433472,
            "z": -154.461181640625
        },
        {
            "x": -1.9820382595062256,
            "y": -0.5217008590698242,
            "z": -154.6131134033203
        },
        {
            "x": -2.0242795944213867,
            "y": -0.5300100445747375,
            "z": -154.7650146484375
        },
        {
            "x": -2.0667459964752197,
            "y": -0.5382705926895142,
            "z": -154.91665649414062
        },
        {
            "x": -2.1094601154327393,
            "y": -0.5464972257614136,
            "z": -155.06842041015625
        },
        {
            "x": -2.1524300575256348,
            "y": -0.5546704530715942,
            "z": -155.2200164794922
        },
        {
            "x": -2.195582151412964,
            "y": -0.5627926588058472,
            "z": -155.3715362548828
        },
        {
            "x": -2.2390220165252686,
            "y": -0.5708717107772827,
            "z": -155.52316284179688
        },
        {
            "x": -2.282597780227661,
            "y": -0.5788787007331848,
            "z": -155.67440795898438
        },
        {
            "x": -2.3264122009277344,
            "y": -0.5868334770202637,
            "z": -155.82579040527344
        },
        {
            "x": -2.3704535961151123,
            "y": -0.5947226285934448,
            "z": -155.9770050048828
        },
        {
            "x": -2.4146461486816406,
            "y": -0.6025447845458984,
            "z": -156.12815856933594
        },
        {
            "x": -2.459156036376953,
            "y": -0.6103136539459229,
            "z": -156.2794952392578
        },
        {
            "x": -2.503743886947632,
            "y": -0.6179894208908081,
            "z": -156.430419921875
        },
        {
            "x": -2.548585891723633,
            "y": -0.6256023645401001,
            "z": -156.58154296875
        },
        {
            "x": -2.5935909748077393,
            "y": -0.6331307291984558,
            "z": -156.732421875
        },
        {
            "x": -2.638751983642578,
            "y": -0.6405794620513916,
            "z": -156.88330078125
        },
        {
            "x": -2.684185743331909,
            "y": -0.6479501724243164,
            "z": -157.03428649902344
        },
        {
            "x": -2.7296793460845947,
            "y": -0.6552202105522156,
            "z": -157.1849365234375
        },
        {
            "x": -2.7753961086273193,
            "y": -0.662407398223877,
            "z": -157.335693359375
        },
        {
            "x": -2.821253538131714,
            "y": -0.6694989800453186,
            "z": -157.48634338378906
        },
        {
            "x": -2.867269515991211,
            "y": -0.6764921545982361,
            "z": -157.63694763183594
        },
        {
            "x": -2.913475513458252,
            "y": -0.6833865642547607,
            "z": -157.78756713867188
        },
        {
            "x": -2.9597926139831543,
            "y": -0.6901775598526001,
            "z": -157.93807983398438
        },
        {
            "x": -3.006272554397583,
            "y": -0.6968625783920288,
            "z": -158.0885467529297
        },
        {
            "x": -3.0528671741485596,
            "y": -0.7034329175949097,
            "z": -158.23890686035156
        },
        {
            "x": -3.0996105670928955,
            "y": -0.7098933458328247,
            "z": -158.38929748535156
        },
        {
            "x": -3.146472692489624,
            "y": -0.7162339687347412,
            "z": -158.53952026367188
        },
        {
            "x": -3.1935033798217773,
            "y": -0.7224671244621277,
            "z": -158.68992614746094
        },
        {
            "x": -3.2406322956085205,
            "y": -0.7285662889480591,
            "z": -158.8401336669922
        },
        {
            "x": -3.287822723388672,
            "y": -0.7345373034477234,
            "z": -158.99020385742188
        },
        {
            "x": -3.3193657398223877,
            "y": -0.7384525537490845,
            "z": -159.09030151367188
        },
        {
            "x": -3.366779088973999,
            "y": -0.7442087531089783,
            "z": -159.24032592773438
        },
        {
            "x": -3.414306163787842,
            "y": -0.7498354911804199,
            "z": -159.3904571533203
        },
        {
            "x": -3.46195125579834,
            "y": -0.7553264498710632,
            "z": -159.54054260253906
        },
        {
            "x": -3.5096285343170166,
            "y": -0.7606738209724426,
            "z": -159.69049072265625
        },
        {
            "x": -3.557457447052002,
            "y": -0.7658807635307312,
            "z": -159.84051513671875
        },
        {
            "x": -3.605330228805542,
            "y": -0.7709345817565918,
            "z": -159.9903564453125
        },
        {
            "x": -3.6532812118530273,
            "y": -0.7758411169052124,
            "z": -160.14024353027344
        },
        {
            "x": -3.701395034790039,
            "y": -0.7806032299995422,
            "z": -160.29025268554688
        },
        {
            "x": -3.7494895458221436,
            "y": -0.7851991653442383,
            "z": -160.44003295898438
        },
        {
            "x": -3.797698974609375,
            "y": -0.7896380424499512,
            "z": -160.58987426757812
        },
        {
            "x": -3.8459413051605225,
            "y": -0.7939137816429138,
            "z": -160.73963928222656
        },
        {
            "x": -3.8942389488220215,
            "y": -0.7980266809463501,
            "z": -160.88938903808594
        },
        {
            "x": -3.9426510334014893,
            "y": -0.8019717931747437,
            "z": -161.0392303466797
        },
        {
            "x": -3.9910364151000977,
            "y": -0.8057376146316528,
            "z": -161.1889190673828
        },
        {
            "x": -4.039488315582275,
            "y": -0.8093311190605164,
            "z": -161.33856201171875
        },
        {
            "x": -4.087987422943115,
            "y": -0.8127491474151611,
            "z": -161.48829650878906
        },
        {
            "x": -4.136507511138916,
            "y": -0.8159832954406738,
            "z": -161.63792419433594
        },
        {
            "x": -4.185079097747803,
            "y": -0.8190308809280396,
            "z": -161.78758239746094
        },
        {
            "x": -4.2336859703063965,
            "y": -0.8218927383422852,
            "z": -161.93728637695312
        },
        {
            "x": -4.282250881195068,
            "y": -0.8245630860328674,
            "z": -162.08676147460938
        },
        {
            "x": -4.330856800079346,
            "y": -0.8270390033721924,
            "z": -162.23634338378906
        },
        {
            "x": -4.379481315612793,
            "y": -0.8293138742446899,
            "z": -162.38587951660156
        },
        {
            "x": -4.428101062774658,
            "y": -0.8313896656036377,
            "z": -162.5353546142578
        },
        {
            "x": -4.476794719696045,
            "y": -0.8332674503326416,
            "z": -162.68508911132812
        },
        {
            "x": -4.525402545928955,
            "y": -0.8349342346191406,
            "z": -162.8345489501953
        },
        {
            "x": -4.574052333831787,
            "y": -0.8363877534866333,
            "z": -162.98414611816406
        },
        {
            "x": -4.622663974761963,
            "y": -0.837630033493042,
            "z": -163.1336212158203
        },
        {
            "x": -4.6712470054626465,
            "y": -0.8386585116386414,
            "z": -163.2831268310547
        },
        {
            "x": -4.719874858856201,
            "y": -0.8394671678543091,
            "z": -163.43280029296875
        },
        {
            "x": -4.768441677093506,
            "y": -0.840048611164093,
            "z": -163.5823211669922
        },
        {
            "x": -4.816952705383301,
            "y": -0.8404057621955872,
            "z": -163.73178100585938
        },
        {
            "x": -4.865464210510254,
            "y": -0.8405372500419617,
            "z": -163.88136291503906
        },
        {
            "x": -4.913920879364014,
            "y": -0.8404371738433838,
            "z": -164.0308380126953
        },
        {
            "x": -4.962341785430908,
            "y": -0.8401020765304565,
            "z": -164.180419921875
        },
        {
            "x": -5.010733127593994,
            "y": -0.839543342590332,
            "z": -164.33001708984375
        },
        {
            "x": -5.059034824371338,
            "y": -0.8387649059295654,
            "z": -164.47950744628906
        },
        {
            "x": -5.107302665710449,
            "y": -0.8377653360366821,
            "z": -164.6291046142578
        },
        {
            "x": -5.155500888824463,
            "y": -0.8365451097488403,
            "z": -164.77862548828125
        },
        {
            "x": -5.203603267669678,
            "y": -0.8351142406463623,
            "z": -164.92811584472656
        },
        {
            "x": -5.251728534698486,
            "y": -0.8334726095199585,
            "z": -165.07785034179688
        },
        {
            "x": -5.2997002601623535,
            "y": -0.8316277861595154,
            "z": -165.2273712158203
        },
        {
            "x": -5.347593784332275,
            "y": -0.8295729160308838,
            "z": -165.37693786621094
        },
        {
            "x": -5.379493236541748,
            "y": -0.8280940055847168,
            "z": -165.47665405273438
        },
        {
            "x": -5.427229881286621,
            "y": -0.8257133364677429,
            "z": -165.6261749267578
        },
        {
            "x": -5.474931240081787,
            "y": -0.8231287002563477,
            "z": -165.77589416503906
        },
        {
            "x": -5.522530555725098,
            "y": -0.8203551173210144,
            "z": -165.92556762695312
        },
        {
            "x": -5.570002555847168,
            "y": -0.8173964023590088,
            "z": -166.0751953125
        },
        {
            "x": -5.617421627044678,
            "y": -0.8142508268356323,
            "z": -166.2249298095703
        },
        {
            "x": -5.664670467376709,
            "y": -0.8109203577041626,
            "z": -166.37457275390625
        },
        {
            "x": -5.711838245391846,
            "y": -0.8074115514755249,
            "z": -166.5242919921875
        },
        {
            "x": -5.758920192718506,
            "y": -0.8037265539169312,
            "z": -166.6741180419922
        },
        {
            "x": -5.8058366775512695,
            "y": -0.7998719811439514,
            "z": -166.82388305664062
        },
        {
            "x": -5.852655410766602,
            "y": -0.7958424687385559,
            "z": -166.9736785888672
        },
        {
            "x": -5.899313449859619,
            "y": -0.7916486263275146,
            "z": -167.12347412109375
        },
        {
            "x": -5.945858955383301,
            "y": -0.7872938513755798,
            "z": -167.2733154296875
        },
        {
            "x": -5.99229097366333,
            "y": -0.7827781438827515,
            "z": -167.42327880859375
        },
        {
            "x": -6.0385589599609375,
            "y": -0.778101921081543,
            "z": -167.57318115234375
        },
        {
            "x": -6.084658145904541,
            "y": -0.7732776403427124,
            "z": -167.72303771972656
        },
        {
            "x": -6.130638599395752,
            "y": -0.7682993412017822,
            "z": -167.87306213378906
        },
        {
            "x": -6.176473617553711,
            "y": -0.7631784677505493,
            "z": -168.02304077148438
        },
        {
            "x": -6.222112655639648,
            "y": -0.7579091787338257,
            "z": -168.1730499267578
        },
        {
            "x": -6.267650127410889,
            "y": -0.7524948120117188,
            "z": -168.3232421875
        },
        {
            "x": -6.31295919418335,
            "y": -0.7469536066055298,
            "z": -168.47323608398438
        },
        {
            "x": -6.358091831207275,
            "y": -0.741276741027832,
            "z": -168.62332153320312
        },
        {
            "x": -6.4030938148498535,
            "y": -0.735464334487915,
            "z": -168.77346801757812
        },
        {
            "x": -6.447853088378906,
            "y": -0.7295287847518921,
            "z": -168.92356872558594
        },
        {
            "x": -6.492559909820557,
            "y": -0.723455548286438,
            "z": -169.07406616210938
        },
        {
            "x": -6.536979675292969,
            "y": -0.7172763347625732,
            "z": -169.22421264648438
        },
        {
            "x": -6.58122444152832,
            "y": -0.7109689712524414,
            "z": -169.3745880126953
        },
        {
            "x": -6.625298500061035,
            "y": -0.7045495510101318,
            "z": -169.5249481201172
        },
        {
            "x": -6.669124603271484,
            "y": -0.6980210542678833,
            "z": -169.67529296875
        },
        {
            "x": -6.712862968444824,
            "y": -0.6913729906082153,
            "z": -169.82594299316406
        },
        {
            "x": -6.7562761306762695,
            "y": -0.6846325397491455,
            "z": -169.97630310058594
        },
        {
            "x": -6.799519062042236,
            "y": -0.6777812838554382,
            "z": -170.12692260742188
        },
        {
            "x": -6.8425822257995605,
            "y": -0.6708316802978516,
            "z": -170.2775421142578
        },
        {
            "x": -6.885352611541748,
            "y": -0.6637922525405884,
            "z": -170.42808532714844
        },
        {
            "x": -6.927994251251221,
            "y": -0.6566485166549683,
            "z": -170.57888793945312
        },
        {
            "x": -6.9703497886657715,
            "y": -0.6494219303131104,
            "z": -170.72959899902344
        },
        {
            "x": -7.012497901916504,
            "y": -0.6421051025390625,
            "z": -170.88043212890625
        },
        {
            "x": -7.054445743560791,
            "y": -0.6347071528434753,
            "z": -171.0312957763672
        },
        {
            "x": -7.09608268737793,
            "y": -0.6272306442260742,
            "z": -171.18215942382812
        },
        {
            "x": -7.137546062469482,
            "y": -0.6196726560592651,
            "z": -171.33309936523438
        },
        {
            "x": -7.178743362426758,
            "y": -0.6120397448539734,
            "z": -171.484130859375
        },
        {
            "x": -7.219720363616943,
            "y": -0.6043341755867004,
            "z": -171.63528442382812
        },
        {
            "x": -7.260414123535156,
            "y": -0.5965709686279297,
            "z": -171.7862548828125
        },
        {
            "x": -7.287369251251221,
            "y": -0.5913568139076233,
            "z": -171.886962890625
        },
        {
            "x": -7.327685832977295,
            "y": -0.5834769010543823,
            "z": -172.03823852539062
        },
        {
            "x": -7.367700576782227,
            "y": -0.575543999671936,
            "z": -172.18942260742188
        },
        {
            "x": -7.407467842102051,
            "y": -0.5675433874130249,
            "z": -172.3408660888672
        },
        {
            "x": -7.446978569030762,
            "y": -0.55949866771698,
            "z": -172.49220275878906
        },
        {
            "x": -7.486173152923584,
            "y": -0.5514039993286133,
            "z": -172.64361572265625
        },
        {
            "x": -7.52515983581543,
            "y": -0.5432533025741577,
            "z": -172.79519653320312
        },
        {
            "x": -7.563786029815674,
            "y": -0.5350750088691711,
            "z": -172.946533203125
        },
        {
            "x": -7.602224349975586,
            "y": -0.5268310308456421,
            "z": -173.09840393066406
        },
        {
            "x": -7.640360355377197,
            "y": -0.518565833568573,
            "z": -173.25003051757812
        },
        {
            "x": -7.678138732910156,
            "y": -0.5102679133415222,
            "z": -173.4016876220703
        },
        {
            "x": -7.715720176696777,
            "y": -0.5019228458404541,
            "z": -173.55364990234375
        },
        {
            "x": -7.752928733825684,
            "y": -0.4935685098171234,
            "z": -173.70529174804688
        },
        {
            "x": -7.789914608001709,
            "y": -0.48516562581062317,
            "z": -173.85745239257812
        },
        {
            "x": -7.826590538024902,
            "y": -0.4767560660839081,
            "z": -174.0093994140625
        },
        {
            "x": -7.862870693206787,
            "y": -0.4683307111263275,
            "z": -174.16131591796875
        },
        {
            "x": -7.898971080780029,
            "y": -0.45986998081207275,
            "z": -174.3135986328125
        },
        {
            "x": -7.934669494628906,
            "y": -0.4514191150665283,
            "z": -174.465576171875
        },
        {
            "x": -7.970099925994873,
            "y": -0.44293805956840515,
            "z": -174.61795043945312
        },
        {
            "x": -8.005253791809082,
            "y": -0.43445396423339844,
            "z": -174.7703094482422
        },
        {
            "x": -8.0399751663208,
            "y": -0.42597874999046326,
            "z": -174.92250061035156
        },
        {
            "x": -8.074477195739746,
            "y": -0.4174851179122925,
            "z": -175.0750732421875
        },
        {
            "x": -8.108596801757812,
            "y": -0.4090123772621155,
            "z": -175.22735595703125
        },
        {
            "x": -8.142387390136719,
            "y": -0.40053072571754456,
            "z": -175.3799591064453
        },
        {
            "x": -8.175947189331055,
            "y": -0.39204880595207214,
            "z": -175.53277587890625
        },
        {
            "x": -8.2090425491333,
            "y": -0.3835967183113098,
            "z": -175.685302734375
        },
        {
            "x": -8.241923332214355,
            "y": -0.3751380443572998,
            "z": -175.83828735351562
        },
        {
            "x": -8.274394989013672,
            "y": -0.36671701073646545,
            "z": -175.990966796875
        },
        {
            "x": -8.306495666503906,
            "y": -0.3583078980445862,
            "z": -176.1438446044922
        },
        {
            "x": -8.338376998901367,
            "y": -0.34990864992141724,
            "z": -176.29702758789062
        },
        {
            "x": -8.369770050048828,
            "y": -0.34155938029289246,
            "z": -176.4498291015625
        },
        {
            "x": -8.400890350341797,
            "y": -0.3332204818725586,
            "z": -176.60305786132812
        },
        {
            "x": -8.431660652160645,
            "y": -0.32492369413375854,
            "z": -176.75619506835938
        },
        {
            "x": -8.462008476257324,
            "y": -0.31666216254234314,
            "z": -176.90936279296875
        },
        {
            "x": -8.492120742797852,
            "y": -0.30842629075050354,
            "z": -177.0628204345703
        },
        {
            "x": -8.521760940551758,
            "y": -0.30024904012680054,
            "z": -177.216064453125
        },
        {
            "x": -8.551085472106934,
            "y": -0.29210180044174194,
            "z": -177.36961364746094
        },
        {
            "x": -8.580073356628418,
            "y": -0.28400975465774536,
            "z": -177.52308654785156
        },
        {
            "x": -8.608600616455078,
            "y": -0.27597326040267944,
            "z": -177.676513671875
        },
        {
            "x": -8.63686466217041,
            "y": -0.2679772973060608,
            "z": -177.8302764892578
        },
        {
            "x": -8.664704322814941,
            "y": -0.2600472569465637,
            "z": -177.98391723632812
        },
        {
            "x": -8.692160606384277,
            "y": -0.2521696090698242,
            "z": -178.1377716064453
        },
        {
            "x": -8.719293594360352,
            "y": -0.24436144530773163,
            "z": -178.29148864746094
        },
        {
            "x": -8.737093925476074,
            "y": -0.23919923603534698,
            "z": -178.39390563964844
        },
        {
            "x": -8.763550758361816,
            "y": -0.23149344325065613,
            "z": -178.54795837402344
        },
        {
            "x": -8.789674758911133,
            "y": -0.22386318445205688,
            "z": -178.70193481445312
        },
        {
            "x": -8.815322875976562,
            "y": -0.2163088619709015,
            "z": -178.85595703125
        },
        {
            "x": -8.840666770935059,
            "y": -0.20882409811019897,
            "z": -179.01019287109375
        },
        {
            "x": -8.865571975708008,
            "y": -0.2014310657978058,
            "z": -179.16424560546875
        },
        {
            "x": -8.890074729919434,
            "y": -0.19411060214042664,
            "z": -179.3185272216797
        },
        {
            "x": -8.914257049560547,
            "y": -0.18687908351421356,
            "z": -179.47280883789062
        },
        {
            "x": -8.937960624694824,
            "y": -0.17973896861076355,
            "z": -179.6271514892578
        },
        {
            "x": -8.961321830749512,
            "y": -0.17268073558807373,
            "z": -179.78172302246094
        },
        {
            "x": -8.984283447265625,
            "y": -0.16572988033294678,
            "z": -179.93605041503906
        },
        {
            "x": -9.006776809692383,
            "y": -0.15887072682380676,
            "z": -180.09060668945312
        },
        {
            "x": -9.028960227966309,
            "y": -0.15210910141468048,
            "z": -180.24530029296875
        },
        {
            "x": -9.05068302154541,
            "y": -0.14545802772045135,
            "z": -180.39987182617188
        },
        {
            "x": -9.071996688842773,
            "y": -0.1389051079750061,
            "z": -180.55471801757812
        },
        {
            "x": -9.09295654296875,
            "y": -0.13247036933898926,
            "z": -180.70936584472656
        },
        {
            "x": -9.113405227661133,
            "y": -0.1261512041091919,
            "z": -180.8641357421875
        },
        {
            "x": -9.133533477783203,
            "y": -0.11993546783924103,
            "z": -181.0191650390625
        },
        {
            "x": -9.153225898742676,
            "y": -0.11385037004947662,
            "z": -181.17393493652344
        },
        {
            "x": -9.172462463378906,
            "y": -0.10787615180015564,
            "z": -181.32904052734375
        },
        {
            "x": -9.191362380981445,
            "y": -0.10203193128108978,
            "z": -181.48414611816406
        },
        {
            "x": -9.209750175476074,
            "y": -0.09632792323827744,
            "z": -181.63894653320312
        },
        {
            "x": -9.22775936126709,
            "y": -0.0907367691397667,
            "z": -181.79420471191406
        },
        {
            "x": -9.24539852142334,
            "y": -0.08528749644756317,
            "z": -181.94927978515625
        },
        {
            "x": -9.262514114379883,
            "y": -0.07997578382492065,
            "z": -182.1045379638672
        },
        {
            "x": -9.27929401397705,
            "y": -0.07479608803987503,
            "z": -182.25999450683594
        },
        {
            "x": -9.295625686645508,
            "y": -0.06977000087499619,
            "z": -182.41513061523438
        },
        {
            "x": -9.311478614807129,
            "y": -0.06488078832626343,
            "z": -182.57054138183594
        },
        {
            "x": -9.326998710632324,
            "y": -0.060143910348415375,
            "z": -182.72607421875
        },
        {
            "x": -9.34201717376709,
            "y": -0.055563200265169144,
            "z": -182.8814239501953
        },
        {
            "x": -9.35661506652832,
            "y": -0.05112815648317337,
            "z": -183.03707885742188
        },
        {
            "x": -9.370855331420898,
            "y": -0.046855293214321136,
            "z": -183.1925506591797
        },
        {
            "x": -9.384543418884277,
            "y": -0.04274962097406387,
            "z": -183.3480224609375
        },
        {
            "x": -9.397875785827637,
            "y": -0.03879830986261368,
            "z": -183.50384521484375
        },
        {
            "x": -9.410787582397461,
            "y": -0.035020165145397186,
            "z": -183.6593780517578
        },
        {
            "x": -9.423187255859375,
            "y": -0.03140559047460556,
            "z": -183.8151092529297
        },
        {
            "x": -9.435242652893066,
            "y": -0.027966706082224846,
            "z": -183.97097778320312
        },
        {
            "x": -9.446805953979492,
            "y": -0.024710096418857574,
            "z": -184.1265411376953
        },
        {
            "x": -9.457906723022461,
            "y": -0.021623730659484863,
            "z": -184.28244018554688
        },
        {
            "x": -9.468671798706055,
            "y": -0.01871846616268158,
            "z": -184.43829345703125
        },
        {
            "x": -9.478889465332031,
            "y": -0.01600535959005356,
            "z": -184.59405517578125
        },
        {
            "x": -9.488702774047852,
            "y": -0.013473807834088802,
            "z": -184.75015258789062
        },
        {
            "x": -9.498127937316895,
            "y": -0.011135938577353954,
            "z": -184.9059295654297
        },
        {
            "x": -9.504097938537598,
            "y": -0.009685776196420193,
            "z": -185.0096893310547
        },
        {
            "x": -9.51271915435791,
            "y": -0.0076700421050190926,
            "z": -185.16580200195312
        },
        {
            "x": -9.52098274230957,
            "y": -0.005852276459336281,
            "z": -185.32180786132812
        },
        {
            "x": -9.52869987487793,
            "y": -0.004235130734741688,
            "z": -185.47769165039062
        },
        {
            "x": -9.536026000976562,
            "y": -0.0028238436207175255,
            "z": -185.6339874267578
        },
        {
            "x": -9.542938232421875,
            "y": -0.0016224551945924759,
            "z": -185.7899169921875
        },
        {
            "x": -9.549309730529785,
            "y": -0.0006288476288318634,
            "z": -185.94589233398438
        },
        {
            "x": -9.555342674255371,
            "y": 0.00015625893138349056,
            "z": -186.10215759277344
        },
        {
            "x": -9.560900688171387,
            "y": 0.0007190185133367777,
            "z": -186.2581787109375
        },
        {
            "x": -9.565938949584961,
            "y": 0.0010627593146637082,
            "z": -186.414306640625
        },
        {
            "x": -9.570648193359375,
            "y": 0.0011717211455106735,
            "z": -186.57061767578125
        },
        {
            "x": -9.574853897094727,
            "y": 0.0011747926473617554,
            "z": -186.72647094726562
        },
        {
            "x": -9.578572273254395,
            "y": 0.0011777132749557495,
            "z": -186.8828125
        },
        {
            "x": -9.581954002380371,
            "y": 0.0011806413531303406,
            "z": -187.03916931152344
        },
        {
            "x": -9.584799766540527,
            "y": 0.0011835694313049316,
            "z": -187.19505310058594
        },
        {
            "x": -9.587214469909668,
            "y": 0.001186467707157135,
            "z": -187.35145568847656
        },
        {
            "x": -9.589262962341309,
            "y": 0.001189395785331726,
            "z": -187.50762939453125
        },
        {
            "x": -9.590754508972168,
            "y": 0.0011922940611839294,
            "z": -187.66360473632812
        },
        {
            "x": -9.5918607711792,
            "y": 0.001195177435874939,
            "z": -187.8201446533203
        },
        {
            "x": -9.592583656311035,
            "y": 0.001198112964630127,
            "z": -187.9762420654297
        },
        {
            "x": -9.592752456665039,
            "y": 0.001201033592224121,
            "z": -188.13232421875
        },
        {
            "x": -9.592561721801758,
            "y": 0.0012039616703987122,
            "z": -188.2887725830078
        },
        {
            "x": -9.591962814331055,
            "y": 0.0012068599462509155,
            "z": -188.4447479248047
        },
        {
            "x": -9.590842247009277,
            "y": 0.0012097656726837158,
            "z": -188.60092163085938
        },
        {
            "x": -9.589383125305176,
            "y": 0.0012127012014389038,
            "z": -188.75753784179688
        },
        {
            "x": -9.587475776672363,
            "y": 0.001215606927871704,
            "z": -188.91346740722656
        },
        {
            "x": -9.585066795349121,
            "y": 0.0012185126543045044,
            "z": -189.0697784423828
        },
        {
            "x": -9.582340240478516,
            "y": 0.0012214258313179016,
            "z": -189.2261199951172
        },
        {
            "x": -9.579129219055176,
            "y": 0.0012243539094924927,
            "z": -189.38198852539062
        },
        {
            "x": -9.575431823730469,
            "y": 0.0012272968888282776,
            "z": -189.5385284423828
        },
        {
            "x": -9.57141399383545,
            "y": 0.0012301802635192871,
            "z": -189.69467163085938
        },
        {
            "x": -9.566890716552734,
            "y": 0.001233026385307312,
            "z": -189.85055541992188
        },
        {
            "x": -9.561919212341309,
            "y": 0.0012359768152236938,
            "z": -190.0070343017578
        },
        {
            "x": -9.556598663330078,
            "y": 0.0012389197945594788,
            "z": -190.16297912597656
        },
        {
            "x": -9.550736427307129,
            "y": 0.0012418180704116821,
            "z": -190.31903076171875
        },
        {
            "x": -9.544495582580566,
            "y": 0.0012447237968444824,
            "z": -190.47543334960938
        },
        {
            "x": -9.537860870361328,
            "y": 0.0012476295232772827,
            "z": -190.63121032714844
        },
        {
            "x": -9.530670166015625,
            "y": 0.00125054270029068,
            "z": -190.787353515625
        },
        {
            "x": -9.52314567565918,
            "y": 0.0012534931302070618,
            "z": -190.94351196289062
        },
        {
            "x": -9.515170097351074,
            "y": 0.001256398856639862,
            "z": -191.0991973876953
        },
        {
            "x": -9.506668090820312,
            "y": 0.0012592747807502747,
            "z": -191.2554931640625
        },
        {
            "x": -9.497843742370605,
            "y": 0.0012622252106666565,
            "z": -191.41140747070312
        },
        {
            "x": -9.488511085510254,
            "y": 0.001265101134777069,
            "z": -191.56707763671875
        },
        {
            "x": -9.482027053833008,
            "y": 0.00126706063747406,
            "z": -191.671142578125
        },
        {
            "x": -9.472029685974121,
            "y": 0.0012699663639068604,
            "z": -191.8270263671875
        },
        {
            "x": -9.46152114868164,
            "y": 0.0012728944420814514,
            "z": -191.98269653320312
        },
        {
            "x": -9.450559616088867,
            "y": 0.0012758001685142517,
            "z": -192.13882446289062
        },
        {
            "x": -9.439251899719238,
            "y": 0.0012786760926246643,
            "z": -192.29440307617188
        },
        {
            "x": -9.427379608154297,
            "y": 0.0012815892696380615,
            "z": -192.4501190185547
        },
        {
            "x": -9.415138244628906,
            "y": 0.0012845173478126526,
            "z": -192.6060028076172
        },
        {
            "x": -9.402485847473145,
            "y": 0.0012874603271484375,
            "z": -192.76136779785156
        },
        {
            "x": -9.38927936553955,
            "y": 0.001290351152420044,
            "z": -192.91729736328125
        },
        {
            "x": -9.375750541687012,
            "y": 0.001293279230594635,
            "z": -193.0729217529297
        },
        {
            "x": -9.361721992492676,
            "y": 0.0012961924076080322,
            "z": -193.228271484375
        },
        {
            "x": -9.347235679626465,
            "y": 0.0012991353869438171,
            "z": -193.38404846191406
        },
        {
            "x": -9.332411766052246,
            "y": 0.0013019964098930359,
            "z": -193.539306640625
        },
        {
            "x": -9.316998481750488,
            "y": 0.0013048872351646423,
            "z": -193.69488525390625
        },
        {
            "x": -9.301244735717773,
            "y": 0.0013077929615974426,
            "z": -193.8504180908203
        },
        {
            "x": -9.285069465637207,
            "y": 0.0013107433915138245,
            "z": -194.0054473876953
        },
        {
            "x": -9.268360137939453,
            "y": 0.0013136863708496094,
            "z": -194.16102600097656
        },
        {
            "x": -9.25133228302002,
            "y": 0.001316569745540619,
            "z": -194.3162078857422
        },
        {
            "x": -9.233778953552246,
            "y": 0.0013466700911521912,
            "z": -194.4713134765625
        },
        {
            "x": -9.21580696105957,
            "y": 0.001576106296852231,
            "z": -194.6267547607422
        },
        {
            "x": -9.197479248046875,
            "y": 0.0020517061930149794,
            "z": -194.78160095214844
        },
        {
            "x": -9.178594589233398,
            "y": 0.0027808700688183308,
            "z": -194.93670654296875
        },
        {
            "x": -9.159384727478027,
            "y": 0.0037486939691007137,
            "z": -195.0917205810547
        },
        {
            "x": -9.139702796936035,
            "y": 0.004950487986207008,
            "z": -195.2464141845703
        },
        {
            "x": -9.119540214538574,
            "y": 0.006391994655132294,
            "z": -195.40171813964844
        },
        {
            "x": -9.099059104919434,
            "y": 0.008066657930612564,
            "z": -195.55630493164062
        },
        {
            "x": -9.078034400939941,
            "y": 0.00997079350054264,
            "z": -195.7111358642578
        },
        {
            "x": -9.056673049926758,
            "y": 0.01209874264895916,
            "z": -195.865966796875
        },
        {
            "x": -9.034878730773926,
            "y": 0.014442013576626778,
            "z": -196.02040100097656
        },
        {
            "x": -9.012561798095703,
            "y": 0.017022177577018738,
            "z": -196.17535400390625
        },
        {
            "x": -8.989954948425293,
            "y": 0.01980595663189888,
            "z": -196.32974243164062
        },
        {
            "x": -8.966836929321289,
            "y": 0.022802414372563362,
            "z": -196.48416137695312
        },
        {
            "x": -8.943357467651367,
            "y": 0.026010829955339432,
            "z": -196.63880920410156
        },
        {
            "x": -8.919469833374023,
            "y": 0.029421765357255936,
            "z": -196.79286193847656
        },
        {
            "x": -8.895084381103516,
            "y": 0.03304543346166611,
            "z": -196.94740295410156
        },
        {
            "x": -8.870397567749023,
            "y": 0.03685801848769188,
            "z": -197.10154724121094
        },
        {
            "x": -8.84521770477295,
            "y": 0.0408649779856205,
            "z": -197.2556610107422
        },
        {
            "x": -8.819664001464844,
            "y": 0.04507828131318092,
            "z": -197.4099884033203
        },
        {
            "x": -8.793742179870605,
            "y": 0.04946545884013176,
            "z": -197.56373596191406
        },
        {
            "x": -8.767346382141113,
            "y": 0.0540485680103302,
            "z": -197.7178497314453
        },
        {
            "x": -8.740633964538574,
            "y": 0.05880765989422798,
            "z": -197.8717041015625
        },
        {
            "x": -8.713436126708984,
            "y": 0.06375062465667725,
            "z": -198.02549743652344
        },
        {
            "x": -8.68591022491455,
            "y": 0.0688708946108818,
            "z": -198.17929077148438
        },
        {
            "x": -8.667379379272461,
            "y": 0.07236720621585846,
            "z": -198.2815399169922
        },
        {
            "x": -8.63912582397461,
            "y": 0.07777334749698639,
            "z": -198.43519592285156
        },
        {
            "x": -8.610559463500977,
            "y": 0.08334740251302719,
            "z": -198.58888244628906
        },
        {
            "x": -8.581578254699707,
            "y": 0.0890759527683258,
            "z": -198.74224853515625
        },
        {
            "x": -8.552205085754395,
            "y": 0.09497261047363281,
            "z": -198.89584350585938
        },
        {
            "x": -8.522513389587402,
            "y": 0.10101789236068726,
            "z": -199.04904174804688
        },
        {
            "x": -8.49235725402832,
            "y": 0.1072244644165039,
            "z": -199.20236206054688
        },
        {
            "x": -8.461934089660645,
            "y": 0.11357232183218002,
            "z": -199.3555145263672
        },
        {
            "x": -8.431039810180664,
            "y": 0.12007135897874832,
            "z": -199.50868225097656
        },
        {
            "x": -8.399815559387207,
            "y": 0.12671956419944763,
            "z": -199.66188049316406
        },
        {
            "x": -8.36827278137207,
            "y": 0.13349348306655884,
            "z": -199.81466674804688
        },
        {
            "x": -8.336278915405273,
            "y": 0.14041811227798462,
            "z": -199.96775817871094
        },
        {
            "x": -8.30405044555664,
            "y": 0.14746099710464478,
            "z": -200.12046813964844
        },
        {
            "x": -8.271354675292969,
            "y": 0.15464413166046143,
            "z": -200.27333068847656
        },
        {
            "x": -8.238360404968262,
            "y": 0.16195446252822876,
            "z": -200.42611694335938
        },
        {
            "x": -8.205058097839355,
            "y": 0.16937074065208435,
            "z": -200.57852172851562
        },
        {
            "x": -8.171316146850586,
            "y": 0.17692652344703674,
            "z": -200.73129272460938
        },
        {
            "x": -8.137365341186523,
            "y": 0.1845788061618805,
            "z": -200.8835906982422
        },
        {
            "x": -8.102950096130371,
            "y": 0.19235822558403015,
            "z": -201.0360565185547
        },
        {
            "x": -8.068270683288574,
            "y": 0.2002461552619934,
            "z": -201.18853759765625
        },
        {
            "x": -8.033288955688477,
            "y": 0.20822197198867798,
            "z": -201.34060668945312
        },
        {
            "x": -7.997928619384766,
            "y": 0.216318279504776,
            "z": -201.49293518066406
        },
        {
            "x": -7.962332725524902,
            "y": 0.22449451684951782,
            "z": -201.64483642578125
        },
        {
            "x": -7.9263224601745605,
            "y": 0.232779860496521,
            "z": -201.7969512939453
        },
        {
            "x": -7.890049457550049,
            "y": 0.2411593347787857,
            "z": -201.94911193847656
        },
        {
            "x": -7.853466510772705,
            "y": 0.24961289763450623,
            "z": -202.1008758544922
        },
        {
            "x": -7.816560745239258,
            "y": 0.25816619396209717,
            "z": -202.2528533935547
        },
        {
            "x": -7.779402256011963,
            "y": 0.266784131526947,
            "z": -202.40447998046875
        },
        {
            "x": -7.741888999938965,
            "y": 0.27549341320991516,
            "z": -202.55630493164062
        },
        {
            "x": -7.704134941101074,
            "y": 0.2842731475830078,
            "z": -202.70802307128906
        },
        {
            "x": -7.666052341461182,
            "y": 0.29311972856521606,
            "z": -202.85955810546875
        },
        {
            "x": -7.627725601196289,
            "y": 0.3020384907722473,
            "z": -203.0111541748047
        },
        {
            "x": -7.589120864868164,
            "y": 0.3110145330429077,
            "z": -203.16256713867188
        },
        {
            "x": -7.550224781036377,
            "y": 0.32005947828292847,
            "z": -203.31407165527344
        },
        {
            "x": -7.511114597320557,
            "y": 0.3291497528553009,
            "z": -203.46531677246094
        },
        {
            "x": -7.47165060043335,
            "y": 0.3383050262928009,
            "z": -203.61671447753906
        },
        {
            "x": -7.432010173797607,
            "y": 0.3475019335746765,
            "z": -203.76792907714844
        },
        {
            "x": -7.392071723937988,
            "y": 0.35674571990966797,
            "z": -203.91908264160156
        },
        {
            "x": -7.351893901824951,
            "y": 0.3660377562046051,
            "z": -204.07025146484375
        },
        {
            "x": -7.311519622802734,
            "y": 0.37535360455513,
            "z": -204.2211151123047
        },
        {
            "x": -7.270781517028809,
            "y": 0.38473448157310486,
            "z": -204.37240600585938
        },
        {
            "x": -7.229956150054932,
            "y": 0.3941207230091095,
            "z": -204.5232391357422
        },
        {
            "x": -7.188821315765381,
            "y": 0.40354281663894653,
            "z": -204.674072265625
        },
        {
            "x": -7.161280155181885,
            "y": 0.40984368324279785,
            "z": -204.77468872070312
        },
        {
            "x": -7.119845390319824,
            "y": 0.41929763555526733,
            "z": -204.9253387451172
        },
        {
            "x": -7.078079700469971,
            "y": 0.428790420293808,
            "z": -205.07623291015625
        },
        {
            "x": -7.0361762046813965,
            "y": 0.43829137086868286,
            "z": -205.2269744873047
        },
        {
            "x": -6.9940409660339355,
            "y": 0.4478013515472412,
            "z": -205.37759399414062
        },
        {
            "x": -6.951691627502441,
            "y": 0.45733270049095154,
            "z": -205.52835083007812
        },
        {
            "x": -6.9091973304748535,
            "y": 0.4668528139591217,
            "z": -205.67881774902344
        },
        {
            "x": -6.86646032333374,
            "y": 0.4763866662979126,
            "z": -205.82943725585938
        },
        {
            "x": -6.823547840118408,
            "y": 0.48592013120651245,
            "z": -205.97996520996094
        },
        {
            "x": -6.780450344085693,
            "y": 0.49544423818588257,
            "z": -206.13043212890625
        },
        {
            "x": -6.737196922302246,
            "y": 0.5049625635147095,
            "z": -206.28089904785156
        },
        {
            "x": -6.693754196166992,
            "y": 0.51446533203125,
            "z": -206.4312744140625
        },
        {
            "x": -6.65015983581543,
            "y": 0.5239566564559937,
            "z": -206.5816650390625
        },
        {
            "x": -6.606372833251953,
            "y": 0.533433198928833,
            "z": -206.73207092285156
        },
        {
            "x": -6.562441349029541,
            "y": 0.5428844094276428,
            "z": -206.88243103027344
        },
        {
            "x": -6.518416404724121,
            "y": 0.5523015856742859,
            "z": -207.03262329101562
        },
        {
            "x": -6.4741644859313965,
            "y": 0.5617008209228516,
            "z": -207.18292236328125
        },
        {
            "x": -6.429827690124512,
            "y": 0.5710612535476685,
            "z": -207.33311462402344
        },
        {
            "x": -6.385318756103516,
            "y": 0.5803885459899902,
            "z": -207.4833526611328
        },
        {
            "x": -6.3406596183776855,
            "y": 0.5896819829940796,
            "z": -207.6336212158203
        },
        {
            "x": -6.295952796936035,
            "y": 0.59891676902771,
            "z": -207.78366088867188
        },
        {
            "x": -6.251072406768799,
            "y": 0.6081130504608154,
            "z": -207.93377685546875
        },
        {
            "x": -6.20610237121582,
            "y": 0.6172574758529663,
            "z": -208.08384704589844
        },
        {
            "x": -6.161003589630127,
            "y": 0.6263480186462402,
            "z": -208.23388671875
        },
        {
            "x": -6.115757942199707,
            "y": 0.6353946924209595,
            "z": -208.38418579101562
        },
        {
            "x": -6.07047176361084,
            "y": 0.6443684101104736,
            "z": -208.5342254638672
        },
        {
            "x": -6.02507209777832,
            "y": 0.6532838344573975,
            "z": -208.68434143066406
        },
        {
            "x": -5.979597568511963,
            "y": 0.6621257066726685,
            "z": -208.83438110351562
        },
        {
            "x": -5.934035301208496,
            "y": 0.6708980202674866,
            "z": -208.98439025878906
        },
        {
            "x": -5.888356685638428,
            "y": 0.679606020450592,
            "z": -209.1345977783203
        },
        {
            "x": -5.842644214630127,
            "y": 0.6882245540618896,
            "z": -209.28457641601562
        },
        {
            "x": -5.796871185302734,
            "y": 0.6967613101005554,
            "z": -209.43460083007812
        },
        {
            "x": -5.750998020172119,
            "y": 0.7052185535430908,
            "z": -209.58470153808594
        },
        {
            "x": -5.705086708068848,
            "y": 0.7135857343673706,
            "z": -209.7347412109375
        },
        {
            "x": -5.659132957458496,
            "y": 0.7218612432479858,
            "z": -209.88479614257812
        },
        {
            "x": -5.613089084625244,
            "y": 0.7300426959991455,
            "z": -210.03492736816406
        },
        {
            "x": -5.567041873931885,
            "y": 0.7381201982498169,
            "z": -210.1849822998047
        },
        {
            "x": -5.520938396453857,
            "y": 0.7460999488830566,
            "z": -210.3350830078125
        },
        {
            "x": -5.474814414978027,
            "y": 0.753972053527832,
            "z": -210.48516845703125
        },
        {
            "x": -5.428682804107666,
            "y": 0.7617268562316895,
            "z": -210.6351776123047
        },
        {
            "x": -5.3824543952941895,
            "y": 0.7693822383880615,
            "z": -210.7854461669922
        },
        {
            "x": -5.336278438568115,
            "y": 0.7769114971160889,
            "z": -210.9355010986328
        },
        {
            "x": -5.290088176727295,
            "y": 0.7843220233917236,
            "z": -211.08555603027344
        },
        {
            "x": -5.259278297424316,
            "y": 0.7891904711723328,
            "z": -211.18565368652344
        },
        {
            "x": -5.213077068328857,
            "y": 0.7963916063308716,
            "z": -211.3357696533203
        },
        {
            "x": -5.166832447052002,
            "y": 0.8034709692001343,
            "z": -211.4860382080078
        },
        {
            "x": -5.120611190795898,
            "y": 0.8104104995727539,
            "z": -211.6362762451172
        },
        {
            "x": -5.074413299560547,
            "y": 0.8172116279602051,
            "z": -211.78648376464844
        },
        {
            "x": -5.028214931488037,
            "y": 0.8238776922225952,
            "z": -211.9368133544922
        },
        {
            "x": -4.982054710388184,
            "y": 0.8303969502449036,
            "z": -212.08700561523438
        },
        {
            "x": -4.935933589935303,
            "y": 0.8367655277252197,
            "z": -212.23728942871094
        },
        {
            "x": -4.889768123626709,
            "y": 0.842991828918457,
            "z": -212.38778686523438
        },
        {
            "x": -4.843707084655762,
            "y": 0.8490579128265381,
            "z": -212.5381622314453
        },
        {
            "x": -4.797672271728516,
            "y": 0.8549675941467285,
            "z": -212.68850708007812
        },
        {
            "x": -4.751657485961914,
            "y": 0.8607155680656433,
            "z": -212.83900451660156
        },
        {
            "x": -4.705740928649902,
            "y": 0.8662937879562378,
            "z": -212.9894256591797
        },
        {
            "x": -4.659800052642822,
            "y": 0.8717116117477417,
            "z": -213.1400604248047
        },
        {
            "x": -4.613979339599609,
            "y": 0.8769537210464478,
            "z": -213.29058837890625
        },
        {
            "x": -4.568213939666748,
            "y": 0.8820165395736694,
            "z": -213.44110107421875
        },
        {
            "x": -4.522487163543701,
            "y": 0.886902928352356,
            "z": -213.59181213378906
        },
        {
            "x": -4.476885795593262,
            "y": 0.8916032910346985,
            "z": -213.74241638183594
        },
        {
            "x": -4.431305408477783,
            "y": 0.8961237668991089,
            "z": -213.89317321777344
        },
        {
            "x": -4.385819435119629,
            "y": 0.9004512429237366,
            "z": -214.0439910888672
        },
        {
            "x": -4.340449810028076,
            "y": 0.9045790433883667,
            "z": -214.1947021484375
        },
        {
            "x": -4.2951579093933105,
            "y": 0.9085143804550171,
            "z": -214.34555053710938
        },
        {
            "x": -4.249988079071045,
            "y": 0.912248969078064,
            "z": -214.496337890625
        },
        {
            "x": -4.2048749923706055,
            "y": 0.9157784581184387,
            "z": -214.64724731445312
        },
        {
            "x": -4.159842014312744,
            "y": 0.9191019535064697,
            "z": -214.7984161376953
        },
        {
            "x": -4.114977836608887,
            "y": 0.9222102761268616,
            "z": -214.94932556152344
        },
        {
            "x": -4.070184230804443,
            "y": 0.925109326839447,
            "z": -215.1005096435547
        },
        {
            "x": -4.025542736053467,
            "y": 0.9277854561805725,
            "z": -215.25155639648438
        },
        {
            "x": -3.9809916019439697,
            "y": 0.9302366375923157,
            "z": -215.40269470214844
        },
        {
            "x": -3.9365384578704834,
            "y": 0.9324676990509033,
            "z": -215.55410766601562
        },
        {
            "x": -3.8922626972198486,
            "y": 0.934468150138855,
            "z": -215.70530700683594
        },
        {
            "x": -3.848114013671875,
            "y": 0.9362348318099976,
            "z": -215.8566436767578
        },
        {
            "x": -3.8041021823883057,
            "y": 0.9377614259719849,
            "z": -216.00802612304688
        },
        {
            "x": -3.7602121829986572,
            "y": 0.9390503168106079,
            "z": -216.1595001220703
        },
        {
            "x": -3.7164807319641113,
            "y": 0.9400990009307861,
            "z": -216.31101989746094
        },
        {
            "x": -3.672875165939331,
            "y": 0.940898597240448,
            "z": -216.46258544921875
        },
        {
            "x": -3.6294431686401367,
            "y": 0.9414428472518921,
            "z": -216.61424255371094
        },
        {
            "x": -3.5861852169036865,
            "y": 0.9417356252670288,
            "z": -216.76589965820312
        },
        {
            "x": -3.5430543422698975,
            "y": 0.941773533821106,
            "z": -216.9176025390625
        },
        {
            "x": -3.5001490116119385,
            "y": 0.9415521621704102,
            "z": -217.06932067871094
        },
        {
            "x": -3.457329511642456,
            "y": 0.9410695433616638,
            "z": -217.22125244140625
        },
        {
            "x": -3.414710760116577,
            "y": 0.9403378963470459,
            "z": -217.37318420410156
        },
        {
            "x": -3.372326135635376,
            "y": 0.9393622875213623,
            "z": -217.5250244140625
        },
        {
            "x": -3.344132423400879,
            "y": 0.9385719895362854,
            "z": -217.62632751464844
        },
        {
            "x": -3.3019986152648926,
            "y": 0.9371861219406128,
            "z": -217.77841186523438
        },
        {
            "x": -3.2600605487823486,
            "y": 0.9355644583702087,
            "z": -217.93045043945312
        },
        {
            "x": -3.2182488441467285,
            "y": 0.93370521068573,
            "z": -218.082763671875
        },
        {
            "x": -3.176730155944824,
            "y": 0.9316108226776123,
            "z": -218.2349090576172
        },
        {
            "x": -3.1353540420532227,
            "y": 0.9292905926704407,
            "z": -218.3871612548828
        },
        {
            "x": -3.0941545963287354,
            "y": 0.9267457723617554,
            "z": -218.5395965576172
        },
        {
            "x": -3.0532426834106445,
            "y": 0.9239848852157593,
            "z": -218.6918182373047
        },
        {
            "x": -3.0123915672302246,
            "y": 0.9209926128387451,
            "z": -218.84446716308594
        },
        {
            "x": -2.9718527793884277,
            "y": 0.9177931547164917,
            "z": -218.9969940185547
        },
        {
            "x": -2.931513786315918,
            "y": 0.9143869876861572,
            "z": -219.1494903564453
        },
        {
            "x": -2.8913304805755615,
            "y": 0.9107692241668701,
            "z": -219.3022918701172
        },
        {
            "x": -2.851468563079834,
            "y": 0.9069482684135437,
            "z": -219.45484924316406
        },
        {
            "x": -2.8117003440856934,
            "y": 0.9029216766357422,
            "z": -219.60775756835938
        },
        {
            "x": -2.772233247756958,
            "y": 0.8987044095993042,
            "z": -219.76060485839844
        },
        {
            "x": -2.733016014099121,
            "y": 0.8943008184432983,
            "z": -219.91331481933594
        },
        {
            "x": -2.6939444541931152,
            "y": 0.8896920680999756,
            "z": -220.06642150878906
        },
        {
            "x": -2.6552014350891113,
            "y": 0.884907603263855,
            "z": -220.21932983398438
        },
        {
            "x": -2.61661958694458,
            "y": 0.8799402713775635,
            "z": -220.3723602294922
        },
        {
            "x": -2.578247547149658,
            "y": 0.8747881650924683,
            "z": -220.5256805419922
        },
        {
            "x": -2.540224552154541,
            "y": 0.8694679737091064,
            "z": -220.6786651611328
        },
        {
            "x": -2.5023579597473145,
            "y": 0.8639724254608154,
            "z": -220.83187866210938
        },
        {
            "x": -2.464766025543213,
            "y": 0.8583084344863892,
            "z": -220.98519897460938
        },
        {
            "x": -2.4274425506591797,
            "y": 0.8524903059005737,
            "z": -221.13832092285156
        },
        {
            "x": -2.390247344970703,
            "y": 0.8464857339859009,
            "z": -221.29205322265625
        },
        {
            "x": -2.3534398078918457,
            "y": 0.8403408527374268,
            "z": -221.4454345703125
        },
        {
            "x": -2.3168139457702637,
            "y": 0.8340423107147217,
            "z": -221.59890747070312
        },
        {
            "x": -2.2804248332977295,
            "y": 0.8275846838951111,
            "z": -221.75270080566406
        },
        {
            "x": -2.244393825531006,
            "y": 0.820992112159729,
            "z": -221.9061279296875
        },
        {
            "x": -2.20847749710083,
            "y": 0.8142399787902832,
            "z": -222.06004333496094
        },
        {
            "x": -2.1729090213775635,
            "y": 0.8073550462722778,
            "z": -222.21385192871094
        },
        {
            "x": -2.137624502182007,
            "y": 0.8003472089767456,
            "z": -222.3675079345703
        },
        {
            "x": -2.1025097370147705,
            "y": 0.7931832671165466,
            "z": -222.52159118652344
        },
        {
            "x": -2.0677757263183594,
            "y": 0.7859047651290894,
            "z": -222.67547607421875
        },
        {
            "x": -2.0332324504852295,
            "y": 0.7785000801086426,
            "z": -222.82943725585938
        },
        {
            "x": -1.9989302158355713,
            "y": 0.7709610462188721,
            "z": -222.9837188720703
        },
        {
            "x": -1.9650145769119263,
            "y": 0.7633205652236938,
            "z": -223.13768005371094
        },
        {
            "x": -1.9312610626220703,
            "y": 0.7555519342422485,
            "z": -223.2919158935547
        },
        {
            "x": -1.8978341817855835,
            "y": 0.7476733326911926,
            "z": -223.44625854492188
        },
        {
            "x": -1.8647266626358032,
            "y": 0.7397041320800781,
            "z": -223.60031127929688
        },
        {
            "x": -1.8317558765411377,
            "y": 0.731601357460022,
            "z": -223.75494384765625
        },
        {
            "x": -1.7991833686828613,
            "y": 0.7234093546867371,
            "z": -223.90940856933594
        },
        {
            "x": -1.7668949365615845,
            "y": 0.7151354551315308,
            "z": -224.06365966796875
        },
        {
            "x": -1.745464563369751,
            "y": 0.7095558643341064,
            "z": -224.16671752929688
        },
        {
            "x": -1.7136425971984863,
            "y": 0.7011116147041321,
            "z": -224.32135009765625
        },
        {
            "x": -1.682090163230896,
            "y": 0.6925889849662781,
            "z": -224.47586059570312
        },
        {
            "x": -1.6507376432418823,
            "y": 0.6839636564254761,
            "z": -224.63076782226562
        },
        {
            "x": -1.619787335395813,
            "y": 0.6752724051475525,
            "z": -224.7854461669922
        },
        {
            "x": -1.5890710353851318,
            "y": 0.6665033102035522,
            "z": -224.94017028808594
        },
        {
            "x": -1.5586097240447998,
            "y": 0.6576490998268127,
            "z": -225.0951385498047
        },
        {
            "x": -1.5285327434539795,
            "y": 0.6487395167350769,
            "z": -225.2499542236328
        },
        {
            "x": -1.4986400604248047,
            "y": 0.6397531032562256,
            "z": -225.40496826171875
        },
        {
            "x": -1.469066858291626,
            "y": 0.6306955814361572,
            "z": -225.56015014648438
        },
        {
            "x": -1.4398627281188965,
            "y": 0.6215976476669312,
            "z": -225.715087890625
        },
        {
            "x": -1.4108507633209229,
            "y": 0.6124343276023865,
            "z": -225.87020874023438
        },
        {
            "x": -1.382171630859375,
            "y": 0.6032096147537231,
            "z": -226.02552795410156
        },
        {
            "x": -1.3538247346878052,
            "y": 0.5939462780952454,
            "z": -226.18072509765625
        },
        {
            "x": -1.325708270072937,
            "y": 0.5846350193023682,
            "z": -226.3360137939453
        },
        {
            "x": -1.2979357242584229,
            "y": 0.5752755999565125,
            "z": -226.49147033691406
        },
        {
            "x": -1.2704765796661377,
            "y": 0.5658931732177734,
            "z": -226.64669799804688
        },
        {
            "x": -1.2432408332824707,
            "y": 0.5564616918563843,
            "z": -226.8022003173828
        },
        {
            "x": -1.2163625955581665,
            "y": 0.5469931364059448,
            "z": -226.9578399658203
        },
        {
            "x": -1.1897876262664795,
            "y": 0.5375145673751831,
            "z": -227.1132354736328
        },
        {
            "x": -1.163440227508545,
            "y": 0.5279964208602905,
            "z": -227.26893615722656
        },
        {
            "x": -1.1374874114990234,
            "y": 0.5184599161148071,
            "z": -227.4246368408203
        },
        {
            "x": -1.1118264198303223,
            "y": 0.5089251399040222,
            "z": -227.58006286621094
        },
        {
            "x": -1.0863837003707886,
            "y": 0.4993513822555542,
            "z": -227.7359161376953
        },
        {
            "x": -1.061295747756958,
            "y": 0.48976215720176697,
            "z": -227.89193725585938
        },
        {
            "x": -1.0365371704101562,
            "y": 0.48019474744796753,
            "z": -228.04750061035156
        },
        {
            "x": -1.0120015144348145,
            "y": 0.47059518098831177,
            "z": -228.20358276367188
        },
        {
            "x": -0.9878548383712769,
            "y": 0.46100562810897827,
            "z": -228.35958862304688
        },
        {
            "x": -0.9639791250228882,
            "y": 0.45143523812294006,
            "z": -228.51535034179688
        },
        {
            "x": -0.9403313994407654,
            "y": 0.4418359398841858,
            "z": -228.6717071533203
        },
        {
            "x": -0.9171115159988403,
            "y": 0.4322713315486908,
            "z": -228.82774353027344
        },
        {
            "x": -0.894141435623169,
            "y": 0.42272984981536865,
            "z": -228.9836883544922
        },
        {
            "x": -0.87141352891922,
            "y": 0.4131763279438019,
            "z": -229.14015197753906
        },
        {
            "x": -0.8491086959838867,
            "y": 0.40366441011428833,
            "z": -229.29629516601562
        },
        {
            "x": -0.8270400762557983,
            "y": 0.39418014883995056,
            "z": -229.45242309570312
        },
        {
            "x": -0.8052287697792053,
            "y": 0.38469892740249634,
            "z": -229.60899353027344
        },
        {
            "x": -0.7838290929794312,
            "y": 0.3752688765525818,
            "z": -229.7653045654297
        },
        {
            "x": -0.7626670598983765,
            "y": 0.3658767640590668,
            "z": -229.92161560058594
        },
        {
            "x": -0.7417839765548706,
            "y": 0.35650700330734253,
            "z": -230.07818603515625
        },
        {
            "x": -0.7212951183319092,
            "y": 0.34718984365463257,
            "z": -230.2346649169922
        },
        {
            "x": -0.7010421752929688,
            "y": 0.3379192352294922,
            "z": -230.39109802246094
        },
        {
            "x": -0.681062638759613,
            "y": 0.32868337631225586,
            "z": -230.54786682128906
        },
        {
            "x": -0.6614878177642822,
            "y": 0.319510817527771,
            "z": -230.70445251464844
        },
        {
            "x": -0.6485919952392578,
            "y": 0.31343603134155273,
            "z": -230.80868530273438
        },
        {
            "x": -0.6294233798980713,
            "y": 0.30435705184936523,
            "z": -230.96536254882812
        },
        {
            "x": -0.6106065511703491,
            "y": 0.29532498121261597,
            "z": -231.122314453125
        },
        {
            "x": -0.5921294689178467,
            "y": 0.2863786518573761,
            "z": -231.27894592285156
        },
        {
            "x": -0.5738714933395386,
            "y": 0.27749598026275635,
            "z": -231.43568420410156
        },
        {
            "x": -0.5559467077255249,
            "y": 0.2686641216278076,
            "z": -231.5928192138672
        },
        {
            "x": -0.5384031534194946,
            "y": 0.2599385976791382,
            "z": -231.74948120117188
        },
        {
            "x": -0.5210649967193604,
            "y": 0.25128406286239624,
            "z": -231.9062957763672
        },
        {
            "x": -0.5040223598480225,
            "y": 0.2426833212375641,
            "z": -232.06362915039062
        },
        {
            "x": -0.4873790144920349,
            "y": 0.2341979593038559,
            "z": -232.22044372558594
        },
        {
            "x": -0.4709511697292328,
            "y": 0.22580096125602722,
            "z": -232.3773651123047
        },
        {
            "x": -0.45482006669044495,
            "y": 0.21747630834579468,
            "z": -232.53466796875
        },
        {
            "x": -0.4390769600868225,
            "y": 0.20926429331302643,
            "z": -232.69166564941406
        },
        {
            "x": -0.42354661226272583,
            "y": 0.20114755630493164,
            "z": -232.8487548828125
        },
        {
            "x": -0.4083143472671509,
            "y": 0.19312646985054016,
            "z": -233.0060577392578
        },
        {
            "x": -0.3934687376022339,
            "y": 0.1852201670408249,
            "z": -233.16323852539062
        },
        {
            "x": -0.37886786460876465,
            "y": 0.17742818593978882,
            "z": -233.32032775878906
        },
        {
            "x": -0.36451444029808044,
            "y": 0.16973575949668884,
            "z": -233.47767639160156
        },
        {
            "x": -0.3505476117134094,
            "y": 0.16216036677360535,
            "z": -233.63516235351562
        },
        {
            "x": -0.33686649799346924,
            "y": 0.15472054481506348,
            "z": -233.7922821044922
        },
        {
            "x": -0.3234070837497711,
            "y": 0.14739307761192322,
            "z": -233.94964599609375
        },
        {
            "x": -0.310305655002594,
            "y": 0.14018452167510986,
            "z": -234.10720825195312
        },
        {
            "x": -0.29754638671875,
            "y": 0.13312846422195435,
            "z": -234.26438903808594
        },
        {
            "x": -0.2849878966808319,
            "y": 0.1261986792087555,
            "z": -234.4217071533203
        },
        {
            "x": -0.2727351486682892,
            "y": 0.11938390135765076,
            "z": -234.57955932617188
        },
        {
            "x": -0.26085707545280457,
            "y": 0.11272898316383362,
            "z": -234.7369384765625
        },
        {
            "x": -0.24919836223125458,
            "y": 0.1062244325876236,
            "z": -234.89430236816406
        },
        {
            "x": -0.23782040178775787,
            "y": 0.09985140711069107,
            "z": -235.0520477294922
        },
        {
            "x": -0.22681529819965363,
            "y": 0.09363503754138947,
            "z": -235.2096405029297
        },
        {
            "x": -0.21605008840560913,
            "y": 0.08757604658603668,
            "z": -235.36712646484375
        },
        {
            "x": -0.20553478598594666,
            "y": 0.0816720575094223,
            "z": -235.52484130859375
        },
        {
            "x": -0.19538754224777222,
            "y": 0.0759265273809433,
            "z": -235.6826171875
        },
        {
            "x": -0.18553128838539124,
            "y": 0.07035378366708755,
            "z": -235.84017944335938
        },
        {
            "x": -0.17588162422180176,
            "y": 0.06494469940662384,
            "z": -235.99777221679688
        },
        {
            "x": -0.166566401720047,
            "y": 0.05969926342368126,
            "z": -236.15577697753906
        },
        {
            "x": -0.15759587287902832,
            "y": 0.054639335721731186,
            "z": -236.3134765625
        },
        {
            "x": -0.14883580803871155,
            "y": 0.049761369824409485,
            "z": -236.4710235595703
        },
        {
            "x": -0.14034245908260345,
            "y": 0.045048002153635025,
            "z": -236.62905883789062
        },
        {
            "x": -0.13223148882389069,
            "y": 0.04053137078881264,
            "z": -236.78689575195312
        },
        {
            "x": -0.12436878681182861,
            "y": 0.03621208667755127,
            "z": -236.9444122314453
        },
        {
            "x": -0.11671532690525055,
            "y": 0.03206910192966461,
            "z": -237.10243225097656
        },
        {
            "x": -0.10941866040229797,
            "y": 0.028120256960392,
            "z": -237.26046752929688
        },
        {
            "x": -0.10243828594684601,
            "y": 0.024384282529354095,
            "z": -237.41810607910156
        },
        {
            "x": -0.09788855910301208,
            "y": 0.022006355226039886,
            "z": -237.52320861816406
        },
        {
            "x": -0.091281458735466,
            "y": 0.018597230315208435,
            "z": -237.6811981201172
        },
        {
            "x": -0.0850394070148468,
            "y": 0.01539806742221117,
            "z": -237.8393096923828
        },
        {
            "x": -0.07906776666641235,
            "y": 0.012418948113918304,
            "z": -237.99703979492188
        },
        {
            "x": -0.07329760491847992,
            "y": 0.009649788960814476,
            "z": -238.1549072265625
        },
        {
            "x": -0.06784561276435852,
            "y": 0.007089916151016951,
            "z": -238.3131561279297
        },
        {
            "x": -0.06273619830608368,
            "y": 0.004762026946991682,
            "z": -238.47096252441406
        },
        {
            "x": -0.057827919721603394,
            "y": 0.0026621054857969284,
            "z": -238.62869262695312
        },
        {
            "x": -0.053167253732681274,
            "y": 0.0007804099004715681,
            "z": -238.7869873046875
        },
        {
            "x": -0.048865363001823425,
            "y": -0.0008692801930010319,
            "z": -238.94505310058594
        },
        {
            "x": -0.044825151562690735,
            "y": -0.002277666935697198,
            "z": -239.10279846191406
        },
        {
            "x": -0.04098217189311981,
            "y": -0.003447418101131916,
            "z": -239.26077270507812
        },
        {
            "x": -0.03745757043361664,
            "y": -0.0043795048259198666,
            "z": -239.41896057128906
        },
        {
            "x": -0.03425221145153046,
            "y": -0.005068731028586626,
            "z": -239.57705688476562
        },
        {
            "x": -0.0312504917383194,
            "y": -0.005505154840648174,
            "z": -239.73477172851562
        },
        {
            "x": -0.02849571406841278,
            "y": -0.005687779281288385,
            "z": -239.8928680419922
        },
        {
            "x": -0.026073142886161804,
            "y": -0.005700595676898956,
            "z": -240.0510711669922
        },
        {
            "x": -0.023901447653770447,
            "y": -0.0057008638978004456,
            "z": -240.20880126953125
        },
        {
            "x": -0.02191486954689026,
            "y": -0.0057011619210243225,
            "z": -240.36680603027344
        },
        {
            "x": -0.020208925008773804,
            "y": -0.005701407790184021,
            "z": -240.5249481201172
        },
        {
            "x": -0.01876327395439148,
            "y": -0.005701705813407898,
            "z": -240.68270874023438
        },
        {
            "x": -0.017462939023971558,
            "y": -0.005702018737792969,
            "z": -240.84036254882812
        },
        {
            "x": -0.016344845294952393,
            "y": -0.005702279508113861,
            "z": -240.99815368652344
        },
        {
            "x": -0.015412300825119019,
            "y": -0.005702555179595947,
            "z": -241.15574645996094
        },
        {
            "x": -0.014543026685714722,
            "y": -0.005702845752239227,
            "z": -241.31324768066406
        },
        {
            "x": -0.01370161771774292,
            "y": -0.00570312887430191,
            "z": -241.4706268310547
        },
        {
            "x": -0.012919485569000244,
            "y": -0.0057034119963645935,
            "z": -241.6279754638672
        },
        {
            "x": -0.012102991342544556,
            "y": -0.005703695118427277,
            "z": -241.78501892089844
        },
        {
            "x": -0.011185675859451294,
            "y": -0.005703963339328766,
            "z": -241.9420166015625
        },
        {
            "x": -0.010200083255767822,
            "y": -0.0057042911648750305,
            "z": -242.09922790527344
        },
        {
            "x": -0.009098976850509644,
            "y": -0.005704551935195923,
            "z": -242.25601196289062
        },
        {
            "x": -0.007827520370483398,
            "y": -0.005704835057258606,
            "z": -242.41281127929688
        },
        {
            "x": -0.006430387496948242,
            "y": -0.005705103278160095,
            "z": -242.56985473632812
        },
        {
            "x": -0.004905670881271362,
            "y": -0.005705416202545166,
            "z": -242.72657775878906
        },
        {
            "x": -0.0031761527061462402,
            "y": -0.00570572167634964,
            "z": -242.88333129882812
        },
        {
            "x": -0.001267462968826294,
            "y": -0.005705967545509338,
            "z": -243.040283203125
        },
        {
            "x": 0.0007562041282653809,
            "y": -0.005706258118152618,
            "z": -243.19711303710938
        },
        {
            "x": 0.002962261438369751,
            "y": -0.0057065486907958984,
            "z": -243.35386657714844
        },
        {
            "x": 0.005385100841522217,
            "y": -0.005706824362277985,
            "z": -243.5105438232422
        },
        {
            "x": 0.0079537034034729,
            "y": -0.005707152187824249,
            "z": -243.66738891601562
        },
        {
            "x": 0.01066538691520691,
            "y": -0.005707398056983948,
            "z": -243.82424926757812
        },
        {
            "x": 0.013592004776000977,
            "y": -0.005707629024982452,
            "z": -243.98080444335938
        },
        {
            "x": 0.016713857650756836,
            "y": -0.005707979202270508,
            "z": -244.13760375976562
        },
        {
            "x": 0.018864423036575317,
            "y": -0.00570814311504364,
            "z": -244.24215698242188
        },
        {
            "x": 0.02222532033920288,
            "y": -0.005708456039428711,
            "z": -244.3987274169922
        },
        {
            "x": 0.02582085132598877,
            "y": -0.005708739161491394,
            "z": -244.5553741455078
        },
        {
            "x": 0.029602617025375366,
            "y": -0.0057089924812316895,
            "z": -244.71231079101562
        },
        {
            "x": 0.033509790897369385,
            "y": -0.005709290504455566,
            "z": -244.86900329589844
        },
        {
            "x": 0.03762969374656677,
            "y": -0.005709558725357056,
            "z": -245.0255889892578
        },
        {
            "x": 0.04197314381599426,
            "y": -0.005709804594516754,
            "z": -245.1822967529297
        },
        {
            "x": 0.04645833373069763,
            "y": -0.005710169672966003,
            "z": -245.33901977539062
        },
        {
            "x": 0.051124125719070435,
            "y": -0.00571044534444809,
            "z": -245.49571228027344
        },
        {
            "x": 0.05602765083312988,
            "y": -0.005710698664188385,
            "z": -245.65228271484375
        },
        {
            "x": 0.06110844016075134,
            "y": -0.005711033940315247,
            "z": -245.80911254882812
        },
        {
            "x": 0.06633830070495605,
            "y": -0.005711264908313751,
            "z": -245.96575927734375
        },
        {
            "x": 0.07180202007293701,
            "y": -0.005711585283279419,
            "z": -246.1221466064453
        },
        {
            "x": 0.07749032974243164,
            "y": -0.005711868405342102,
            "z": -246.27903747558594
        },
        {
            "x": 0.08330661058425903,
            "y": -0.005712129175662994,
            "z": -246.4356689453125
        },
        {
            "x": 0.08934351801872253,
            "y": -0.005712442100048065,
            "z": -246.592041015625
        },
        {
            "x": 0.09563255310058594,
            "y": -0.005712680518627167,
            "z": -246.7487030029297
        },
        {
            "x": 0.10207110643386841,
            "y": -0.005713008344173431,
            "z": -246.90538024902344
        },
        {
            "x": 0.10869276523590088,
            "y": -0.005713269114494324,
            "z": -247.06187438964844
        },
        {
            "x": 0.11558619141578674,
            "y": -0.00571354478597641,
            "z": -247.2183837890625
        },
        {
            "x": 0.12266257405281067,
            "y": -0.005713842809200287,
            "z": -247.3750457763672
        },
        {
            "x": 0.12989357113838196,
            "y": -0.005714140832424164,
            "z": -247.53146362304688
        },
        {
            "x": 0.13738268613815308,
            "y": -0.005714409053325653,
            "z": -247.68775939941406
        },
        {
            "x": 0.1451030969619751,
            "y": -0.005714647471904755,
            "z": -247.84437561035156
        },
        {
            "x": 0.15298116207122803,
            "y": -0.0057149603962898254,
            "z": -248.00100708007812
        },
        {
            "x": 0.1610906720161438,
            "y": -0.00571528822183609,
            "z": -248.15725708007812
        },
        {
            "x": 0.16945752501487732,
            "y": -0.005715526640415192,
            "z": -248.3137969970703
        },
        {
            "x": 0.17798417806625366,
            "y": -0.005715787410736084,
            "z": -248.4702911376953
        },
        {
            "x": 0.18673202395439148,
            "y": -0.005716077983379364,
            "z": -248.62649536132812
        },
        {
            "x": 0.19576090574264526,
            "y": -0.005716368556022644,
            "z": -248.78306579589844
        },
        {
            "x": 0.20494797825813293,
            "y": -0.005716688930988312,
            "z": -248.93954467773438
        },
        {
            "x": 0.21434828639030457,
            "y": -0.005716972053050995,
            "z": -249.09568786621094
        },
        {
            "x": 0.22404351830482483,
            "y": -0.005717262625694275,
            "z": -249.25204467773438
        },
        {
            "x": 0.23392164707183838,
            "y": -0.00571751594543457,
            "z": -249.40846252441406
        },
        {
            "x": 0.2439931035041809,
            "y": -0.00571780651807785,
            "z": -249.56472778320312
        },
        {
            "x": 0.2543651759624481,
            "y": -0.005718104541301727,
            "z": -249.720947265625
        },
        {
            "x": 0.26494547724723816,
            "y": -0.0057183802127838135,
            "z": -249.87733459472656
        },
        {
            "x": 0.275712788105011,
            "y": -0.00571867823600769,
            "z": -250.03355407714844
        },
        {
            "x": 0.2867642939090729,
            "y": -0.005718939006328583,
            "z": -250.1896209716797
        },
        {
            "x": 0.29805663228034973,
            "y": -0.005719222128391266,
            "z": -250.34593200683594
        },
        {
            "x": 0.30954045057296753,
            "y": -0.005719512701034546,
            "z": -250.502197265625
        },
        {
            "x": 0.3213014602661133,
            "y": -0.0057197511196136475,
            "z": -250.6581573486328
        },
        {
            "x": 0.3333124816417694,
            "y": -0.005720086395740509,
            "z": -250.8143768310547
        },
        {
            "x": 0.3414163291454315,
            "y": -0.005720280110836029,
            "z": -250.91845703125
        },
        {
            "x": 0.35379335284233093,
            "y": -0.005720548331737518,
            "z": -251.07427978515625
        },
        {
            "x": 0.36647605895996094,
            "y": -0.005720809102058411,
            "z": -251.23046875
        },
        {
            "x": 0.3793453574180603,
            "y": -0.005721107125282288,
            "z": -251.3866729736328
        },
        {
            "x": 0.39246565103530884,
            "y": -0.0057214125990867615,
            "z": -251.54241943359375
        },
        {
            "x": 0.40590202808380127,
            "y": -0.005721718072891235,
            "z": -251.69854736328125
        },
        {
            "x": 0.41950753331184387,
            "y": -0.005722023546695709,
            "z": -251.85452270507812
        },
        {
            "x": 0.43338650465011597,
            "y": -0.005722254514694214,
            "z": -252.01019287109375
        },
        {
            "x": 0.44759923219680786,
            "y": -0.0057225301861763,
            "z": -252.16641235351562
        },
        {
            "x": 0.461977481842041,
            "y": -0.005722835659980774,
            "z": -252.32229614257812
        },
        {
            "x": 0.47663143277168274,
            "y": -0.005723148584365845,
            "z": -252.47793579101562
        },
        {
            "x": 0.4916108548641205,
            "y": -0.005723409354686737,
            "z": -252.63388061523438
        },
        {
            "x": 0.5067726373672485,
            "y": -0.005723699927330017,
            "z": -252.7896270751953
        },
        {
            "x": 0.5222418308258057,
            "y": -0.005723945796489716,
            "z": -252.94534301757812
        },
        {
            "x": 0.5380059480667114,
            "y": -0.005724236369132996,
            "z": -253.1011962890625
        },
        {
            "x": 0.5539624094963074,
            "y": -0.005724504590034485,
            "z": -253.25686645507812
        },
        {
            "x": 0.5702409744262695,
            "y": -0.0057248324155807495,
            "z": -253.41236877441406
        },
        {
            "x": 0.5868102312088013,
            "y": -0.005725152790546417,
            "z": -253.56808471679688
        },
        {
            "x": 0.6035810112953186,
            "y": -0.005725391209125519,
            "z": -253.72364807128906
        },
        {
            "x": 0.6206892728805542,
            "y": -0.005725681781768799,
            "z": -253.87908935546875
        },
        {
            "x": 0.638083815574646,
            "y": -0.005725957453250885,
            "z": -254.03472900390625
        },
        {
            "x": 0.6556817889213562,
            "y": -0.0057262033224105835,
            "z": -254.19004821777344
        },
        {
            "x": 0.6736334562301636,
            "y": -0.005726538598537445,
            "z": -254.34532165527344
        },
        {
            "x": 0.691855788230896,
            "y": -0.0057267919182777405,
            "z": -254.50088500976562
        },
        {
            "x": 0.7103344798088074,
            "y": -0.005727052688598633,
            "z": -254.65621948242188
        },
        {
            "x": 0.7291563749313354,
            "y": -0.005727343261241913,
            "z": -254.8114776611328
        },
        {
            "x": 0.7482284307479858,
            "y": -0.005727618932723999,
            "z": -254.96690368652344
        },
        {
            "x": 0.7675685882568359,
            "y": -0.00572793185710907,
            "z": -255.1219482421875
        },
        {
            "x": 0.7872775197029114,
            "y": -0.005728185176849365,
            "z": -255.2771759033203
        },
        {
            "x": 0.8072279691696167,
            "y": -0.00572851300239563,
            "z": -255.4325408935547
        },
        {
            "x": 0.8274645209312439,
            "y": -0.005728758871555328,
            "z": -255.58740234375
        },
        {
            "x": 0.8480532169342041,
            "y": -0.005729071795940399,
            "z": -255.74256896972656
        },
        {
            "x": 0.8688738346099854,
            "y": -0.005729347467422485,
            "z": -255.8975830078125
        },
        {
            "x": 0.89003986120224,
            "y": -0.0057296231389045715,
            "z": -256.05230712890625
        },
        {
            "x": 0.9115279912948608,
            "y": -0.0057299137115478516,
            "z": -256.2075500488281
        },
        {
            "x": 0.9332424402236938,
            "y": -0.005730174481868744,
            "z": -256.36224365234375
        },
        {
            "x": 0.9553611278533936,
            "y": -0.0057305023074150085,
            "z": -256.51702880859375
        },
        {
            "x": 0.9777405261993408,
            "y": -0.005730785429477692,
            "z": -256.6719665527344
        },
        {
            "x": 1.0003907680511475,
            "y": -0.0057310983538627625,
            "z": -256.826416015625
        },
        {
            "x": 1.0234441757202148,
            "y": -0.005731336772441864,
            "z": -256.9811706542969
        },
        {
            "x": 1.0467524528503418,
            "y": -0.005731627345085144,
            "z": -257.13592529296875
        },
        {
            "x": 1.0703920125961304,
            "y": -0.005731895565986633,
            "z": -257.29022216796875
        },
        {
            "x": 1.0943738222122192,
            "y": -0.0057321712374687195,
            "z": -257.44488525390625
        },
        {
            "x": 1.1104844808578491,
            "y": -0.00573238730430603,
            "z": -257.54766845703125
        },
        {
            "x": 1.1349842548370361,
            "y": -0.00573267787694931,
            "z": -257.701904296875
        },
        {
            "x": 1.1598354578018188,
            "y": -0.0057329460978507996,
            "z": -257.85650634765625
        },
        {
            "x": 1.184935450553894,
            "y": -0.0057332515716552734,
            "z": -258.0105895996094
        },
        {
            "x": 1.2104605436325073,
            "y": -0.00573352724313736,
            "z": -258.16485595703125
        },
        {
            "x": 1.2362496852874756,
            "y": -0.0057338327169418335,
            "z": -258.3191833496094
        },
        {
            "x": 1.2623488903045654,
            "y": -0.005734138190746307,
            "z": -258.47296142578125
        },
        {
            "x": 1.288847804069519,
            "y": -0.005734361708164215,
            "z": -258.6271667480469
        },
        {
            "x": 1.3156285285949707,
            "y": -0.005734667181968689,
            "z": -258.7811279296875
        },
        {
            "x": 1.342794418334961,
            "y": -0.005734950304031372,
            "z": -258.9349670410156
        },
        {
            "x": 1.3702565431594849,
            "y": -0.005735225975513458,
            "z": -259.08892822265625
        },
        {
            "x": 1.3980464935302734,
            "y": -0.005735531449317932,
            "z": -259.24249267578125
        },
        {
            "x": 1.4262559413909912,
            "y": -0.005735814571380615,
            "z": -259.3963317871094
        },
        {
            "x": 1.4547362327575684,
            "y": -0.005771893076598644,
            "z": -259.5499572753906
        },
        {
            "x": 1.48360276222229,
            "y": -0.006220526061952114,
            "z": -259.70343017578125
        },
        {
            "x": 1.5127873420715332,
            "y": -0.007249441463500261,
            "z": -259.8570251464844
        },
        {
            "x": 1.5422996282577515,
            "y": -0.008862261660397053,
            "z": -260.0102233886719
        },
        {
            "x": 1.5722334384918213,
            "y": -0.01103215292096138,
            "z": -260.1636657714844
        },
        {
            "x": 1.6024161577224731,
            "y": -0.013741757720708847,
            "z": -260.31683349609375
        },
        {
            "x": 1.6330244541168213,
            "y": -0.016988812014460564,
            "z": -260.469970703125
        },
        {
            "x": 1.6639665365219116,
            "y": -0.020783143118023872,
            "z": -260.6231384277344
        },
        {
            "x": 1.695210576057434,
            "y": -0.025078561156988144,
            "z": -260.77581787109375
        },
        {
            "x": 1.7268950939178467,
            "y": -0.02988760732114315,
            "z": -260.9288024902344
        },
        {
            "x": 1.7588081359863281,
            "y": -0.03517631068825722,
            "z": -261.0813903808594
        },
        {
            "x": 1.79123854637146,
            "y": -0.0409800261259079,
            "z": -261.23419189453125
        },
        {
            "x": 1.8239353895187378,
            "y": -0.04725083336234093,
            "z": -261.3868713378906
        },
        {
            "x": 1.856988549232483,
            "y": -0.05396893247961998,
            "z": -261.5390625
        },
        {
            "x": 1.8904763460159302,
            "y": -0.06115676462650299,
            "z": -261.6916809082031
        },
        {
            "x": 1.9241952896118164,
            "y": -0.06877928972244263,
            "z": -261.84375
        },
        {
            "x": 1.9584355354309082,
            "y": -0.07685469090938568,
            "z": -261.9961242675781
        },
        {
            "x": 1.9929084777832031,
            "y": -0.08533228188753128,
            "z": -262.1481628417969
        },
        {
            "x": 2.027787923812866,
            "y": -0.09421080350875854,
            "z": -262.2999267578125
        },
        {
            "x": 2.063056707382202,
            "y": -0.10352552682161331,
            "z": -262.4520568847656
        },
        {
            "x": 2.098588228225708,
            "y": -0.11319296061992645,
            "z": -262.6034240722656
        },
        {
            "x": 2.134636878967285,
            "y": -0.12327034026384354,
            "z": -262.75531005859375
        },
        {
            "x": 2.1709115505218506,
            "y": -0.1336880624294281,
            "z": -262.90673828125
        },
        {
            "x": 2.207648515701294,
            "y": -0.1444772183895111,
            "z": -263.0580139160156
        },
        {
            "x": 2.244722843170166,
            "y": -0.15562543272972107,
            "z": -263.2094421386719
        },
        {
            "x": 2.282123327255249,
            "y": -0.1670776903629303,
            "z": -263.3603210449219
        },
        {
            "x": 2.3199644088745117,
            "y": -0.17888081073760986,
            "z": -263.5114440917969
        },
        {
            "x": 2.35813307762146,
            "y": -0.19098804891109467,
            "z": -263.66229248046875
        },
        {
            "x": 2.396742105484009,
            "y": -0.2034214437007904,
            "z": -263.81317138671875
        },
        {
            "x": 2.4355716705322266,
            "y": -0.21611368656158447,
            "z": -263.96368408203125
        },
        {
            "x": 2.4617159366607666,
            "y": -0.22472921013832092,
            "z": -264.0638732910156
        },
        {
            "x": 2.501293659210205,
            "y": -0.23792457580566406,
            "z": -264.2145080566406
        },
        {
            "x": 2.5411434173583984,
            "y": -0.2513461112976074,
            "z": -264.3646240234375
        },
        {
            "x": 2.581509828567505,
            "y": -0.2650604248046875,
            "z": -264.5150146484375
        },
        {
            "x": 2.622072696685791,
            "y": -0.2789781987667084,
            "z": -264.6648864746094
        },
        {
            "x": 2.6631784439086914,
            "y": -0.2931682765483856,
            "z": -264.81494140625
        },
        {
            "x": 2.7045164108276367,
            "y": -0.307555615901947,
            "z": -264.9647216796875
        },
        {
            "x": 2.7462732791900635,
            "y": -0.3221452832221985,
            "z": -265.1141662597656
        },
        {
            "x": 2.7884933948516846,
            "y": -0.3369845747947693,
            "z": -265.2641296386719
        },
        {
            "x": 2.830965042114258,
            "y": -0.35196059942245483,
            "z": -265.4132080078125
        },
        {
            "x": 2.873934268951416,
            "y": -0.36717015504837036,
            "z": -265.56280517578125
        },
        {
            "x": 2.917142868041992,
            "y": -0.3825024962425232,
            "z": -265.71185302734375
        },
        {
            "x": 2.960824966430664,
            "y": -0.3980186879634857,
            "z": -265.8609313964844
        },
        {
            "x": 3.0048422813415527,
            "y": -0.4136887192726135,
            "z": -266.0099792480469
        },
        {
            "x": 3.049265146255493,
            "y": -0.4294853210449219,
            "z": -266.1587219238281
        },
        {
            "x": 3.0940022468566895,
            "y": -0.44540953636169434,
            "z": -266.307373046875
        },
        {
            "x": 3.139180898666382,
            "y": -0.46145394444465637,
            "z": -266.4559631347656
        },
        {
            "x": 3.184705972671509,
            "y": -0.47761595249176025,
            "z": -266.6045227050781
        },
        {
            "x": 3.2305681705474854,
            "y": -0.49384838342666626,
            "z": -266.7526550292969
        },
        {
            "x": 3.2768988609313965,
            "y": -0.5102044939994812,
            "z": -266.9010314941406
        },
        {
            "x": 3.3234448432922363,
            "y": -0.5265800952911377,
            "z": -267.048828125
        },
        {
            "x": 3.3705403804779053,
            "y": -0.543077826499939,
            "z": -267.1969909667969
        },
        {
            "x": 3.417811393737793,
            "y": -0.5595689415931702,
            "z": -267.34442138671875
        },
        {
            "x": 3.4656455516815186,
            "y": -0.5761556029319763,
            "z": -267.4922790527344
        },
        {
            "x": 3.513763904571533,
            "y": -0.5927668213844299,
            "z": -267.6399230957031
        },
        {
            "x": 3.562286376953125,
            "y": -0.6093932390213013,
            "z": -267.787353515625
        },
        {
            "x": 3.611137628555298,
            "y": -0.6260356903076172,
            "z": -267.9346923828125
        },
        {
            "x": 3.6603684425354004,
            "y": -0.6426659822463989,
            "z": -268.0817565917969
        },
        {
            "x": 3.709991693496704,
            "y": -0.6593142747879028,
            "z": -268.2290344238281
        },
        {
            "x": 3.7599236965179443,
            "y": -0.6759121417999268,
            "z": -268.3758850097656
        },
        {
            "x": 3.810342788696289,
            "y": -0.6925190687179565,
            "z": -268.5229187011719
        },
        {
            "x": 3.8609578609466553,
            "y": -0.7090297937393188,
            "z": -268.6694030761719
        },
        {
            "x": 3.9121131896972656,
            "y": -0.7255486249923706,
            "z": -268.8162536621094
        },
        {
            "x": 3.963460922241211,
            "y": -0.7419543266296387,
            "z": -268.9625244140625
        },
        {
            "x": 4.0153608322143555,
            "y": -0.7583420872688293,
            "z": -269.1091613769531
        },
        {
            "x": 4.06744384765625,
            "y": -0.7745963335037231,
            "z": -269.25531005859375
        },
        {
            "x": 4.120011329650879,
            "y": -0.790787935256958,
            "z": -269.4015808105469
        },
        {
            "x": 4.172824859619141,
            "y": -0.8068578243255615,
            "z": -269.5475769042969
        },
        {
            "x": 4.22609281539917,
            "y": -0.8228248357772827,
            "z": -269.6934814453125
        },
        {
            "x": 4.279598236083984,
            "y": -0.8386474251747131,
            "z": -269.8392333984375
        },
        {
            "x": 4.3336029052734375,
            "y": -0.8543577194213867,
            "z": -269.98504638671875
        },
        {
            "x": 4.387838363647461,
            "y": -0.8699057698249817,
            "z": -270.1306457519531
        },
        {
            "x": 4.44247579574585,
            "y": -0.8852958679199219,
            "z": -270.2760314941406
        },
        {
            "x": 4.479108810424805,
            "y": -0.8954693675041199,
            "z": -270.373046875
        },
        {
            "x": 4.534245014190674,
            "y": -0.9105583429336548,
            "z": -270.5181884765625
        },
        {
            "x": 4.589910984039307,
            "y": -0.9255092144012451,
            "z": -270.6636657714844
        },
        {
            "x": 4.645726680755615,
            "y": -0.9402141571044922,
            "z": -270.80859375
        },
        {
            "x": 4.702023983001709,
            "y": -0.9547392129898071,
            "z": -270.9537353515625
        },
        {
            "x": 4.758553504943848,
            "y": -0.9690313339233398,
            "z": -271.09857177734375
        },
        {
            "x": 4.815523147583008,
            "y": -0.9831160306930542,
            "z": -271.24346923828125
        },
        {
            "x": 4.872662544250488,
            "y": -0.9969260096549988,
            "z": -271.3880310058594
        },
        {
            "x": 4.930324554443359,
            "y": -1.01051664352417,
            "z": -271.5328063964844
        },
        {
            "x": 4.988151550292969,
            "y": -1.0238237380981445,
            "z": -271.67724609375
        },
        {
            "x": 5.046391010284424,
            "y": -1.0368664264678955,
            "z": -271.8216247558594
        },
        {
            "x": 5.104951858520508,
            "y": -1.0496307611465454,
            "z": -271.9660339355469
        },
        {
            "x": 5.163794994354248,
            "y": -1.0620819330215454,
            "z": -272.11016845703125
        },
        {
            "x": 5.223021030426025,
            "y": -1.0742546319961548,
            "z": -272.2545166015625
        },
        {
            "x": 5.2824625968933105,
            "y": -1.086085319519043,
            "z": -272.3984069824219
        },
        {
            "x": 5.342292308807373,
            "y": -1.0976061820983887,
            "z": -272.54248046875
        },
        {
            "x": 5.402361869812012,
            "y": -1.1087627410888672,
            "z": -272.6861572265625
        },
        {
            "x": 5.462813377380371,
            "y": -1.1195948123931885,
            "z": -272.8300476074219
        },
        {
            "x": 5.523502349853516,
            "y": -1.1300562620162964,
            "z": -272.9737243652344
        },
        {
            "x": 5.58452844619751,
            "y": -1.1401551961898804,
            "z": -273.1174011230469
        },
        {
            "x": 5.645758628845215,
            "y": -1.1498446464538574,
            "z": -273.2607727050781
        },
        {
            "x": 5.707350730895996,
            "y": -1.15915846824646,
            "z": -273.4042663574219
        },
        {
            "x": 5.7691426277160645,
            "y": -1.168058156967163,
            "z": -273.5474853515625
        },
        {
            "x": 5.831289768218994,
            "y": -1.1765536069869995,
            "z": -273.69073486328125
        },
        {
            "x": 5.893748760223389,
            "y": -1.1846097707748413,
            "z": -273.8339538574219
        },
        {
            "x": 5.95648717880249,
            "y": -1.1922365427017212,
            "z": -273.9772033691406
        },
        {
            "x": 6.019366264343262,
            "y": -1.1994028091430664,
            "z": -274.1200256347656
        },
        {
            "x": 6.08267068862915,
            "y": -1.2061256170272827,
            "z": -274.2630920410156
        },
        {
            "x": 6.146082878112793,
            "y": -1.2123475074768066,
            "z": -274.40576171875
        },
        {
            "x": 6.209972858428955,
            "y": -1.2181117534637451,
            "z": -274.5488586425781
        },
        {
            "x": 6.273838520050049,
            "y": -1.223365306854248,
            "z": -274.6913146972656
        },
        {
            "x": 6.33809757232666,
            "y": -1.228126049041748,
            "z": -274.8339538574219
        },
        {
            "x": 6.402563571929932,
            "y": -1.2323522567749023,
            "z": -274.97650146484375
        },
        {
            "x": 6.467288970947266,
            "y": -1.236053466796875,
            "z": -275.118896484375
        },
        {
            "x": 6.532232761383057,
            "y": -1.239223837852478,
            "z": -275.26129150390625
        },
        {
            "x": 6.597460746765137,
            "y": -1.241849422454834,
            "z": -275.4036560058594
        },
        {
            "x": 6.662815093994141,
            "y": -1.2438911199569702,
            "z": -275.5458068847656
        },
        {
            "x": 6.728529930114746,
            "y": -1.2453687191009521,
            "z": -275.6881103515625
        },
        {
            "x": 6.794311046600342,
            "y": -1.2462668418884277,
            "z": -275.8301086425781
        },
        {
            "x": 6.860346794128418,
            "y": -1.246577501296997,
            "z": -275.9720764160156
        },
        {
            "x": 6.926616668701172,
            "y": -1.2462635040283203,
            "z": -276.11407470703125
        },
        {
            "x": 6.993030548095703,
            "y": -1.245361089706421,
            "z": -276.2558898925781
        },
        {
            "x": 7.059612274169922,
            "y": -1.2438814640045166,
            "z": -276.3975524902344
        },
        {
            "x": 7.1041083335876465,
            "y": -1.242574691772461,
            "z": -276.4919128417969
        },
        {
            "x": 7.171074867248535,
            "y": -1.240135669708252,
            "z": -276.63360595703125
        },
        {
            "x": 7.238154888153076,
            "y": -1.2371506690979004,
            "z": -276.77508544921875
        },
        {
            "x": 7.305535316467285,
            "y": -1.2336206436157227,
            "z": -276.9167175292969
        },
        {
            "x": 7.372926712036133,
            "y": -1.2295477390289307,
            "z": -277.0579833984375
        },
        {
            "x": 7.440607070922852,
            "y": -1.2249484062194824,
            "z": -277.19940185546875
        },
        {
            "x": 7.5083208084106445,
            "y": -1.2198514938354492,
            "z": -277.3405456542969
        },
        {
            "x": 7.576236724853516,
            "y": -1.2142566442489624,
            "z": -277.4816589355469
        },
        {
            "x": 7.644347667694092,
            "y": -1.2081513404846191,
            "z": -277.6229248046875
        },
        {
            "x": 7.7125630378723145,
            "y": -1.2015752792358398,
            "z": -277.7639465332031
        },
        {
            "x": 7.780890464782715,
            "y": -1.194537878036499,
            "z": -277.9048767089844
        },
        {
            "x": 7.849395275115967,
            "y": -1.1870450973510742,
            "z": -278.04583740234375
        },
        {
            "x": 7.91793155670166,
            "y": -1.1791038513183594,
            "z": -278.1865234375
        },
        {
            "x": 7.986717700958252,
            "y": -1.1707162857055664,
            "z": -278.3274230957031
        },
        {
            "x": 8.05554485321045,
            "y": -1.1619176864624023,
            "z": -278.46807861328125
        },
        {
            "x": 8.124444007873535,
            "y": -1.1527199745178223,
            "z": -278.60858154296875
        },
        {
            "x": 8.193570137023926,
            "y": -1.1430940628051758,
            "z": -278.7492370605469
        },
        {
            "x": 8.262715339660645,
            "y": -1.1330876350402832,
            "z": -278.8897399902344
        },
        {
            "x": 8.331988334655762,
            "y": -1.1227002143859863,
            "z": -279.0302734375
        },
        {
            "x": 8.40129280090332,
            "y": -1.111958622932434,
            "z": -279.1705322265625
        },
        {
            "x": 8.470762252807617,
            "y": -1.1008458137512207,
            "z": -279.3109130859375
        },
        {
            "x": 8.540233612060547,
            "y": -1.0893945693969727,
            "z": -279.4510803222656
        },
        {
            "x": 8.609862327575684,
            "y": -1.0775980949401855,
            "z": -279.59136962890625
        },
        {
            "x": 8.679430961608887,
            "y": -1.0655035972595215,
            "z": -279.7313537597656
        },
        {
            "x": 8.749275207519531,
            "y": -1.0530622005462646,
            "z": -279.8716125488281
        },
        {
            "x": 8.819036483764648,
            "y": -1.040340781211853,
            "z": -280.0115661621094
        },
        {
            "x": 8.88896656036377,
            "y": -1.027306079864502,
            "z": -280.1517333984375
        },
        {
            "x": 8.958909034729004,
            "y": -1.0140042304992676,
            "z": -280.2917785644531
        },
        {
            "x": 9.028848648071289,
            "y": -1.0004470348358154,
            "z": -280.4315490722656
        },
        {
            "x": 9.099002838134766,
            "y": -0.9865871667861938,
            "z": -280.57171630859375
        },
        {
            "x": 9.1690673828125,
            "y": -0.9725104570388794,
            "z": -280.71160888671875
        },
        {
            "x": 9.239169120788574,
            "y": -0.9582005739212036,
            "z": -280.8514099121094
        },
        {
            "x": 9.309377670288086,
            "y": -0.943656861782074,
            "z": -280.9913024902344
        },
        {
            "x": 9.379566192626953,
            "y": -0.9288938045501709,
            "z": -281.1311340332031
        },
        {
            "x": 9.449825286865234,
            "y": -0.9139264225959778,
            "z": -281.2709045410156
        },
        {
            "x": 9.520076751708984,
            "y": -0.8987699747085571,
            "z": -281.41070556640625
        },
        {
            "x": 9.590367317199707,
            "y": -0.8834362030029297,
            "z": -281.5503845214844
        },
        {
            "x": 9.660727500915527,
            "y": -0.8679155111312866,
            "z": -281.6901550292969
        },
        {
            "x": 9.731024742126465,
            "y": -0.8522485494613647,
            "z": -281.829833984375
        },
        {
            "x": 9.801373481750488,
            "y": -0.836429238319397,
            "z": -281.96942138671875
        },
        {
            "x": 9.87183952331543,
            "y": -0.8204450011253357,
            "z": -282.10931396484375
        },
        {
            "x": 9.942183494567871,
            "y": -0.804355263710022,
            "z": -282.2489929199219
        },
        {
            "x": 10.012569427490234,
            "y": -0.7881407737731934,
            "z": -282.388671875
        },
        {
            "x": 10.059558868408203,
            "y": -0.7772550582885742,
            "z": -282.48193359375
        },
        {
            "x": 10.129810333251953,
            "y": -0.7608850598335266,
            "z": -282.62152099609375
        },
        {
            "x": 10.200201988220215,
            "y": -0.74439537525177,
            "z": -282.7613220214844
        },
        {
            "x": 10.270537376403809,
            "y": -0.7278425097465515,
            "z": -282.9010314941406
        },
        {
            "x": 10.340880393981934,
            "y": -0.7112215757369995,
            "z": -283.0406494140625
        },
        {
            "x": 10.411271095275879,
            "y": -0.6945215463638306,
            "z": -283.1805725097656
        },
        {
            "x": 10.481534004211426,
            "y": -0.6778066158294678,
            "z": -283.3201904296875
        },
        {
            "x": 10.551796913146973,
            "y": -0.6610499620437622,
            "z": -283.4598388671875
        },
        {
            "x": 10.62220573425293,
            "y": -0.6442297697067261,
            "z": -283.599853515625
        },
        {
            "x": 10.69244384765625,
            "y": -0.627425491809845,
            "z": -283.7395935058594
        },
        {
            "x": 10.762675285339355,
            "y": -0.6106138229370117,
            "z": -283.8794250488281
        },
        {
            "x": 10.83288860321045,
            "y": -0.5938038229942322,
            "z": -284.0193176269531
        },
        {
            "x": 10.90306568145752,
            "y": -0.5770086050033569,
            "z": -284.1592102050781
        },
        {
            "x": 10.97325325012207,
            "y": -0.5602343082427979,
            "z": -284.29925537109375
        },
        {
            "x": 11.043342590332031,
            "y": -0.5435075759887695,
            "z": -284.43927001953125
        },
        {
            "x": 11.113409996032715,
            "y": -0.5268316268920898,
            "z": -284.5792236328125
        },
        {
            "x": 11.183398246765137,
            "y": -0.5102218389511108,
            "z": -284.71923828125
        },
        {
            "x": 11.253395080566406,
            "y": -0.4936727285385132,
            "z": -284.85931396484375
        },
        {
            "x": 11.323346138000488,
            "y": -0.47720175981521606,
            "z": -284.9994812011719
        },
        {
            "x": 11.393242835998535,
            "y": -0.4608239531517029,
            "z": -285.13970947265625
        },
        {
            "x": 11.463069915771484,
            "y": -0.4445574879646301,
            "z": -285.2798767089844
        },
        {
            "x": 11.53281307220459,
            "y": -0.428406298160553,
            "z": -285.4201354980469
        },
        {
            "x": 11.602535247802734,
            "y": -0.4123755991458893,
            "z": -285.56036376953125
        },
        {
            "x": 11.67223072052002,
            "y": -0.39646491408348083,
            "z": -285.700927734375
        },
        {
            "x": 11.741852760314941,
            "y": -0.3807012438774109,
            "z": -285.8414611816406
        },
        {
            "x": 11.811323165893555,
            "y": -0.3651164472103119,
            "z": -285.9818420410156
        },
        {
            "x": 11.880782127380371,
            "y": -0.3496895730495453,
            "z": -286.1224060058594
        },
        {
            "x": 11.950222969055176,
            "y": -0.334433376789093,
            "z": -286.2630310058594
        },
        {
            "x": 12.019513130187988,
            "y": -0.3193822503089905,
            "z": -286.4036865234375
        },
        {
            "x": 12.088889122009277,
            "y": -0.30449947714805603,
            "z": -286.54461669921875
        },
        {
            "x": 12.15804672241211,
            "y": -0.2898523211479187,
            "z": -286.68536376953125
        },
        {
            "x": 12.227156639099121,
            "y": -0.27542614936828613,
            "z": -286.8262634277344
        },
        {
            "x": 12.29619312286377,
            "y": -0.26122748851776123,
            "z": -286.9672546386719
        },
        {
            "x": 12.365117073059082,
            "y": -0.24728506803512573,
            "z": -287.10821533203125
        },
        {
            "x": 12.434117317199707,
            "y": -0.23355460166931152,
            "z": -287.2496337890625
        },
        {
            "x": 12.502870559692383,
            "y": -0.2201126366853714,
            "z": -287.3909912109375
        },
        {
            "x": 12.571639060974121,
            "y": -0.2069258987903595,
            "z": -287.5326843261719
        },
        {
            "x": 12.640290260314941,
            "y": -0.19398891925811768,
            "z": -287.6749267578125
        },
        {
            "x": 12.708486557006836,
            "y": -0.1813879758119583,
            "z": -287.81695556640625
        },
        {
            "x": 12.776652336120605,
            "y": -0.169048011302948,
            "z": -287.9596862792969
        },
        {
            "x": 12.844450950622559,
            "y": -0.15702977776527405,
            "z": -288.1028137207031
        },
        {
            "x": 12.911656379699707,
            "y": -0.14539426565170288,
            "z": -288.24542236328125
        },
        {
            "x": 12.97879695892334,
            "y": -0.13406533002853394,
            "z": -288.3887023925781
        },
        {
            "x": 13.02343463897705,
            "y": -0.12669093906879425,
            "z": -288.48455810546875
        },
        {
            "x": 13.089899063110352,
            "y": -0.11594196408987045,
            "z": -288.6286315917969
        },
        {
            "x": 13.155745506286621,
            "y": -0.10560187697410583,
            "z": -288.7723083496094
        },
        {
            "x": 13.221368789672852,
            "y": -0.09564100205898285,
            "z": -288.9162292480469
        },
        {
            "x": 13.286798477172852,
            "y": -0.08605290949344635,
            "z": -289.0609130859375
        },
        {
            "x": 13.351819038391113,
            "y": -0.07684628665447235,
            "z": -289.2063293457031
        },
        {
            "x": 13.416006088256836,
            "y": -0.06809468567371368,
            "z": -289.3514099121094
        },
        {
            "x": 13.47960090637207,
            "y": -0.059799667447805405,
            "z": -289.4961242675781
        },
        {
            "x": 13.543144226074219,
            "y": -0.0519261509180069,
            "z": -289.6417236328125
        },
        {
            "x": 13.606315612792969,
            "y": -0.04447973892092705,
            "z": -289.7880859375
        },
        {
            "x": 13.668795585632324,
            "y": -0.037496041506528854,
            "z": -289.93463134765625
        },
        {
            "x": 13.730424880981445,
            "y": -0.031017564237117767,
            "z": -290.0808410644531
        },
        {
            "x": 13.791589736938477,
            "y": -0.025053948163986206,
            "z": -290.2268981933594
        },
        {
            "x": 13.852689743041992,
            "y": -0.019552789628505707,
            "z": -290.3739929199219
        },
        {
            "x": 13.913225173950195,
            "y": -0.014549532905220985,
            "z": -290.52166748046875
        },
        {
            "x": 13.972983360290527,
            "y": -0.010069013573229313,
            "z": -290.66943359375
        },
        {
            "x": 14.031960487365723,
            "y": -0.0061531346291303635,
            "z": -290.8168029785156
        },
        {
            "x": 14.090489387512207,
            "y": -0.002784052398055792,
            "z": -290.964111328125
        },
        {
            "x": 14.148873329162598,
            "y": 5.540228448808193e-05,
            "z": -291.1124572753906
        },
        {
            "x": 14.206718444824219,
            "y": 0.0023412518203258514,
            "z": -291.261474609375
        },
        {
            "x": 14.263611793518066,
            "y": 0.004026183858513832,
            "z": -291.4102478027344
        },
        {
            "x": 14.319783210754395,
            "y": 0.005119848996400833,
            "z": -291.55841064453125
        },
        {
            "x": 14.375690460205078,
            "y": 0.005626477301120758,
            "z": -291.7070007324219
        },
        {
            "x": 14.43130874633789,
            "y": 0.005676425993442535,
            "z": -291.8565979003906
        },
        {
            "x": 14.486275672912598,
            "y": 0.005680210888385773,
            "z": -292.0067443847656
        },
        {
            "x": 14.540278434753418,
            "y": 0.005684025585651398,
            "z": -292.1563415527344
        },
        {
            "x": 14.59369945526123,
            "y": 0.005687825381755829,
            "z": -292.3055114746094
        },
        {
            "x": 14.646916389465332,
            "y": 0.005691617727279663,
            "z": -292.4554443359375
        },
        {
            "x": 14.699685096740723,
            "y": 0.0056954026222229,
            "z": -292.60626220703125
        },
        {
            "x": 14.75167179107666,
            "y": 0.005699187517166138,
            "z": -292.7572937011719
        },
        {
            "x": 14.802780151367188,
            "y": 0.005702979862689972,
            "z": -292.9076232910156
        },
        {
            "x": 14.853432655334473,
            "y": 0.005706749856472015,
            "z": -293.0578308105469
        },
        {
            "x": 14.903863906860352,
            "y": 0.00571046769618988,
            "z": -293.20904541015625
        },
        {
            "x": 14.953690528869629,
            "y": 0.0057143718004226685,
            "z": -293.3609313964844
        },
        {
            "x": 15.002644538879395,
            "y": 0.005718104541301727,
            "z": -293.5125732421875
        },
        {
            "x": 15.050914764404297,
            "y": 0.005721881985664368,
            "z": -293.6636962890625
        },
        {
            "x": 15.098836898803711,
            "y": 0.005725696682929993,
            "z": -293.8150939941406
        },
        {
            "x": 15.146418571472168,
            "y": 0.005729496479034424,
            "z": -293.9674987792969
        },
        {
            "x": 15.193230628967285,
            "y": 0.005733281373977661,
            "z": -294.1202697753906
        },
        {
            "x": 15.239208221435547,
            "y": 0.005737103521823883,
            "z": -294.2725830078125
        },
        {
            "x": 15.284586906433105,
            "y": 0.005740903317928314,
            "z": -294.42449951171875
        },
        {
            "x": 15.329706192016602,
            "y": 0.0057446956634521484,
            "z": -294.5771484375
        },
        {
            "x": 15.374310493469238,
            "y": 0.005748525261878967,
            "z": -294.73065185546875
        },
        {
            "x": 15.403560638427734,
            "y": 0.005750969052314758,
            "z": -294.8328552246094
        },
        {
            "x": 15.446758270263672,
            "y": 0.005754806101322174,
            "z": -294.9858703613281
        },
        {
            "x": 15.489465713500977,
            "y": 0.005758598446846008,
            "z": -295.1386413574219
        },
        {
            "x": 15.531878471374512,
            "y": 0.00576242059469223,
            "z": -295.29217529296875
        },
        {
            "x": 15.573720932006836,
            "y": 0.005766168236732483,
            "z": -295.4465026855469
        },
        {
            "x": 15.614686012268066,
            "y": 0.005769968032836914,
            "z": -295.6006164550781
        },
        {
            "x": 15.654898643493652,
            "y": 0.0057738423347473145,
            "z": -295.7540283203125
        },
        {
            "x": 15.694782257080078,
            "y": 0.005777575075626373,
            "z": -295.90771484375
        },
        {
            "x": 15.734331130981445,
            "y": 0.00578133761882782,
            "z": -296.0625305175781
        },
        {
            "x": 15.77304458618164,
            "y": 0.005785107612609863,
            "z": -296.217529296875
        },
        {
            "x": 15.810953140258789,
            "y": 0.00578896701335907,
            "z": -296.3720703125
        },
        {
            "x": 15.848294258117676,
            "y": 0.005792751908302307,
            "z": -296.526123046875
        },
        {
            "x": 15.885327339172363,
            "y": 0.005796514451503754,
            "z": -296.6809387207031
        },
        {
            "x": 15.921833038330078,
            "y": 0.005800336599349976,
            "z": -296.836669921875
        },
        {
            "x": 15.957453727722168,
            "y": 0.005804121494293213,
            "z": -296.99212646484375
        },
        {
            "x": 15.99234676361084,
            "y": 0.005807913839817047,
            "z": -297.14691162109375
        },
        {
            "x": 16.02686882019043,
            "y": 0.005811735987663269,
            "z": -297.3018798828125
        },
        {
            "x": 16.060977935791016,
            "y": 0.0058155059814453125,
            "z": -297.4577941894531
        },
        {
            "x": 16.094362258911133,
            "y": 0.005819275975227356,
            "z": -297.6141357421875
        },
        {
            "x": 16.126916885375977,
            "y": 0.00582306832075119,
            "z": -297.7698974609375
        },
        {
            "x": 16.158924102783203,
            "y": 0.005826897919178009,
            "z": -297.9251403808594
        },
        {
            "x": 16.190601348876953,
            "y": 0.0058306679129600525,
            "z": -298.0811767578125
        },
        {
            "x": 16.2216796875,
            "y": 0.005834490060806274,
            "z": -298.2379150390625
        },
        {
            "x": 16.25193214416504,
            "y": 0.005838245153427124,
            "z": -298.3945007324219
        },
        {
            "x": 16.281497955322266,
            "y": 0.005842030048370361,
            "z": -298.550537109375
        },
        {
            "x": 16.310672760009766,
            "y": 0.0058458298444747925,
            "z": -298.70654296875
        },
        {
            "x": 16.33942413330078,
            "y": 0.0058496370911598206,
            "z": -298.8635559082031
        },
        {
            "x": 16.367416381835938,
            "y": 0.0058534592390060425,
            "z": -299.0209045410156
        },
        {
            "x": 16.394588470458984,
            "y": 0.005857206881046295,
            "z": -299.17755126953125
        },
        {
            "x": 16.421289443969727,
            "y": 0.005861066281795502,
            "z": -299.3339538574219
        },
        {
            "x": 16.447607040405273,
            "y": 0.005864828824996948,
            "z": -299.4909362792969
        },
        {
            "x": 16.473316192626953,
            "y": 0.005868628621101379,
            "z": -299.6486511230469
        },
        {
            "x": 16.498210906982422,
            "y": 0.0058724284172058105,
            "z": -299.80621337890625
        },
        {
            "x": 16.522422790527344,
            "y": 0.005876228213310242,
            "z": -299.9628601074219
        },
        {
            "x": 16.54630470275879,
            "y": 0.00588003545999527,
            "z": -300.11993408203125
        },
        {
            "x": 16.56970977783203,
            "y": 0.005883805453777313,
            "z": -300.2779235839844
        },
        {
            "x": 16.592323303222656,
            "y": 0.00588756799697876,
            "z": -300.43597412109375
        },
        {
            "x": 16.61418914794922,
            "y": 0.005891367793083191,
            "z": -300.59344482421875
        },
        {
            "x": 16.63559341430664,
            "y": 0.005895189940929413,
            "z": -300.7504577636719
        },
        {
            "x": 16.65662384033203,
            "y": 0.0058989375829696655,
            "z": -300.9083251953125
        },
        {
            "x": 16.677013397216797,
            "y": 0.005902782082557678,
            "z": -301.0669860839844
        },
        {
            "x": 16.696556091308594,
            "y": 0.005906514823436737,
            "z": -301.2249755859375
        },
        {
            "x": 16.715545654296875,
            "y": 0.005910418927669525,
            "z": -301.3823547363281
        },
        {
            "x": 16.728023529052734,
            "y": 0.005912899971008301,
            "z": -301.4874267578125
        },
        {
            "x": 16.746322631835938,
            "y": 0.005916699767112732,
            "z": -301.6457824707031
        },
        {
            "x": 16.763906478881836,
            "y": 0.005920484662055969,
            "z": -301.80462646484375
        },
        {
            "x": 16.780746459960938,
            "y": 0.005924336612224579,
            "z": -301.9628601074219
        },
        {
            "x": 16.797101974487305,
            "y": 0.005928106606006622,
            "z": -302.120361328125
        },
        {
            "x": 16.813081741333008,
            "y": 0.005931876599788666,
            "z": -302.27874755859375
        },
        {
            "x": 16.828428268432617,
            "y": 0.0059356689453125,
            "z": -302.4377136230469
        },
        {
            "x": 16.843006134033203,
            "y": 0.005939476191997528,
            "z": -302.5963134765625
        },
        {
            "x": 16.857013702392578,
            "y": 0.005943290889263153,
            "z": -302.75439453125
        },
        {
            "x": 16.87063980102539,
            "y": 0.0059470608830451965,
            "z": -302.91253662109375
        },
        {
            "x": 16.883758544921875,
            "y": 0.005950823426246643,
            "z": -303.071533203125
        },
        {
            "x": 16.896135330200195,
            "y": 0.005954623222351074,
            "z": -303.2306823730469
        },
        {
            "x": 16.907833099365234,
            "y": 0.005958430469036102,
            "z": -303.3890686035156
        },
        {
            "x": 16.919126510620117,
            "y": 0.005962252616882324,
            "z": -303.5472717285156
        },
        {
            "x": 16.929994583129883,
            "y": 0.005966015160083771,
            "z": -303.7060852050781
        },
        {
            "x": 16.94019317626953,
            "y": 0.005969822406768799,
            "z": -303.8654479980469
        },
        {
            "x": 16.949674606323242,
            "y": 0.005973614752292633,
            "z": -304.0243835449219
        },
        {
            "x": 16.95863914489746,
            "y": 0.005977354943752289,
            "z": -304.1825256347656
        },
        {
            "x": 16.967256546020508,
            "y": 0.005981191992759705,
            "z": -304.3412780761719
        },
        {
            "x": 16.975296020507812,
            "y": 0.005985036492347717,
            "z": -304.50067138671875
        },
        {
            "x": 16.982603073120117,
            "y": 0.005988791584968567,
            "z": -304.6599426269531
        },
        {
            "x": 16.98931312561035,
            "y": 0.005992591381072998,
            "z": -304.8183288574219
        },
        {
            "x": 16.995670318603516,
            "y": 0.005996368825435638,
            "z": -304.97674560546875
        },
        {
            "x": 17.001556396484375,
            "y": 0.006000138819217682,
            "z": -305.13592529296875
        },
        {
            "x": 17.006750106811523,
            "y": 0.006062990054488182,
            "z": -305.29559326171875
        },
        {
            "x": 17.01126480102539,
            "y": 0.006413079798221588,
            "z": -305.4543762207031
        },
        {
            "x": 17.01538848876953,
            "y": 0.0070642102509737015,
            "z": -305.6127014160156
        },
        {
            "x": 17.019119262695312,
            "y": 0.00801524706184864,
            "z": -305.7716369628906
        },
        {
            "x": 17.022228240966797,
            "y": 0.00926448218524456,
            "z": -305.9311218261719
        },
        {
            "x": 17.024627685546875,
            "y": 0.010815550573170185,
            "z": -306.0905456542969
        },
        {
            "x": 17.02654457092285,
            "y": 0.012644799426198006,
            "z": -306.2489013671875
        },
        {
            "x": 17.028121948242188,
            "y": 0.014757826924324036,
            "z": -306.40753173828125
        },
        {
            "x": 17.029176712036133,
            "y": 0.01716107875108719,
            "z": -306.56695556640625
        },
        {
            "x": 17.029510498046875,
            "y": 0.019850682467222214,
            "z": -306.7263488769531
        },
        {
            "x": 17.029285430908203,
            "y": 0.022802121937274933,
            "z": -306.8851013183594
        },
        {
            "x": 17.02872657775879,
            "y": 0.02601383998990059,
            "z": -307.0434875488281
        },
        {
            "x": 17.027729034423828,
            "y": 0.029500164091587067,
            "z": -307.2025451660156
        },
        {
            "x": 17.02606201171875,
            "y": 0.03326692432165146,
            "z": -307.3620300292969
        },
        {
            "x": 17.023771286010742,
            "y": 0.03727814182639122,
            "z": -307.5209045410156
        },
        {
            "x": 17.021093368530273,
            "y": 0.04152432829141617,
            "z": -307.6791076660156
        },
        {
            "x": 17.0180606842041,
            "y": 0.046032462269067764,
            "z": -307.83795166015625
        },
        {
            "x": 17.014429092407227,
            "y": 0.05080503225326538,
            "z": -307.9971923828125
        },
        {
            "x": 17.01014518737793,
            "y": 0.05581766366958618,
            "z": -308.1562194824219
        },
        {
            "x": 17.00701904296875,
            "y": 0.05927273631095886,
            "z": -308.2618408203125
        },
        {
            "x": 17.00206756591797,
            "y": 0.06464684009552002,
            "z": -308.419921875
        },
        {
            "x": 16.996692657470703,
            "y": 0.07027703523635864,
            "z": -308.5787658691406
        },
        {
            "x": 16.99070167541504,
            "y": 0.07614858448505402,
            "z": -308.73797607421875
        },
        {
            "x": 16.984113693237305,
            "y": 0.08222559839487076,
            "z": -308.8966369628906
        },
        {
            "x": 16.97713279724121,
            "y": 0.08849986642599106,
            "z": -309.05474853515625
        },
        {
            "x": 16.969816207885742,
            "y": 0.09499673545360565,
            "z": -309.2130432128906
        },
        {
            "x": 16.96194839477539,
            "y": 0.10173065960407257,
            "z": -309.3719787597656
        },
        {
            "x": 16.953449249267578,
            "y": 0.10867424309253693,
            "z": -309.5308837890625
        },
        {
            "x": 16.944503784179688,
            "y": 0.11578369140625,
            "z": -309.68896484375
        },
        {
            "x": 16.93524932861328,
            "y": 0.12308800220489502,
            "z": -309.84686279296875
        },
        {
            "x": 16.925535202026367,
            "y": 0.13061434030532837,
            "z": -310.0054016113281
        },
        {
            "x": 16.91520881652832,
            "y": 0.13834159076213837,
            "z": -310.1642150878906
        },
        {
            "x": 16.90434455871582,
            "y": 0.14623843133449554,
            "z": -310.322509765625
        },
        {
            "x": 16.893177032470703,
            "y": 0.1542843133211136,
            "z": -310.4801025390625
        },
        {
            "x": 16.88164710998535,
            "y": 0.16252630949020386,
            "z": -310.63812255859375
        },
        {
            "x": 16.869548797607422,
            "y": 0.1709735244512558,
            "z": -310.7967224121094
        },
        {
            "x": 16.85686492919922,
            "y": 0.17957758903503418,
            "z": -310.9550476074219
        },
        {
            "x": 16.84380531311035,
            "y": 0.1883137822151184,
            "z": -311.11260986328125
        },
        {
            "x": 16.830463409423828,
            "y": 0.19720953702926636,
            "z": -311.27020263671875
        },
        {
            "x": 16.81663703918457,
            "y": 0.20629099011421204,
            "z": -311.42828369140625
        },
        {
            "x": 16.802215576171875,
            "y": 0.21553780138492584,
            "z": -311.5865783691406
        },
        {
            "x": 16.787336349487305,
            "y": 0.22489994764328003,
            "z": -311.744140625
        },
        {
            "x": 16.772193908691406,
            "y": 0.23437699675559998,
            "z": -311.9012451171875
        },
        {
            "x": 16.75664520263672,
            "y": 0.24403877556324005,
            "z": -312.0591125488281
        },
        {
            "x": 16.74054718017578,
            "y": 0.2538490295410156,
            "z": -312.2171325683594
        },
        {
            "x": 16.723918914794922,
            "y": 0.26377540826797485,
            "z": -312.37481689453125
        },
        {
            "x": 16.706993103027344,
            "y": 0.273789644241333,
            "z": -312.5317687988281
        },
        {
            "x": 16.689781188964844,
            "y": 0.28393125534057617,
            "z": -312.6888732910156
        },
        {
            "x": 16.672040939331055,
            "y": 0.2942435145378113,
            "z": -312.84674072265625
        },
        {
            "x": 16.65375328063965,
            "y": 0.30465933680534363,
            "z": -313.0043029785156
        },
        {
            "x": 16.635108947753906,
            "y": 0.3151441812515259,
            "z": -313.1612243652344
        },
        {
            "x": 16.6162052154541,
            "y": 0.3257269561290741,
            "z": -313.3179931640625
        },
        {
            "x": 16.59690284729004,
            "y": 0.3364361524581909,
            "z": -313.4751281738281
        },
        {
            "x": 16.57701873779297,
            "y": 0.34727558493614197,
            "z": -313.6326599121094
        },
        {
            "x": 16.556686401367188,
            "y": 0.3581821918487549,
            "z": -313.78973388671875
        },
        {
            "x": 16.5361270904541,
            "y": 0.3691290020942688,
            "z": -313.9460754394531
        },
        {
            "x": 16.515247344970703,
            "y": 0.3801880478858948,
            "z": -314.10284423828125
        },
        {
            "x": 16.493850708007812,
            "y": 0.39135801792144775,
            "z": -314.2598571777344
        },
        {
            "x": 16.471960067749023,
            "y": 0.4025954604148865,
            "z": -314.4167785644531
        },
        {
            "x": 16.449745178222656,
            "y": 0.4138758182525635,
            "z": -314.5732421875
        },
        {
            "x": 16.42731285095215,
            "y": 0.42520374059677124,
            "z": -314.7294006347656
        },
        {
            "x": 16.404449462890625,
            "y": 0.43663156032562256,
            "z": -314.8860168457031
        },
        {
            "x": 16.38890266418457,
            "y": 0.44429659843444824,
            "z": -314.99053955078125
        },
        {
            "x": 16.3652400970459,
            "y": 0.4558165669441223,
            "z": -315.1470031738281
        },
        {
            "x": 16.341310501098633,
            "y": 0.4673566222190857,
            "z": -315.302978515625
        },
        {
            "x": 16.317113876342773,
            "y": 0.47895002365112305,
            "z": -315.4590148925781
        },
        {
            "x": 16.29247283935547,
            "y": 0.49061721563339233,
            "z": -315.61541748046875
        },
        {
            "x": 16.267330169677734,
            "y": 0.5023356676101685,
            "z": -315.7718811035156
        },
        {
            "x": 16.24188232421875,
            "y": 0.5140399932861328,
            "z": -315.9276428222656
        },
        {
            "x": 16.216217041015625,
            "y": 0.5257596969604492,
            "z": -316.0831604003906
        },
        {
            "x": 16.190156936645508,
            "y": 0.5375494360923767,
            "z": -316.2392578125
        },
        {
            "x": 16.163639068603516,
            "y": 0.5493707656860352,
            "z": -316.3953857421875
        },
        {
            "x": 16.1367130279541,
            "y": 0.5611896514892578,
            "z": -316.55120849609375
        },
        {
            "x": 16.109582901000977,
            "y": 0.5729839205741882,
            "z": -316.70648193359375
        },
        {
            "x": 16.08218765258789,
            "y": 0.5847968459129333,
            "z": -316.8618469238281
        },
        {
            "x": 16.054325103759766,
            "y": 0.5966638326644897,
            "z": -317.017822265625
        },
        {
            "x": 16.026037216186523,
            "y": 0.6085169315338135,
            "z": -317.17352294921875
        },
        {
            "x": 15.997456550598145,
            "y": 0.6203290820121765,
            "z": -317.32867431640625
        },
        {
            "x": 15.968674659729004,
            "y": 0.6321223974227905,
            "z": -317.48370361328125
        },
        {
            "x": 15.939558029174805,
            "y": 0.643927812576294,
            "z": -317.63897705078125
        },
        {
            "x": 15.909953117370605,
            "y": 0.6557468175888062,
            "z": -317.7945861816406
        },
        {
            "x": 15.879980087280273,
            "y": 0.6675193309783936,
            "z": -317.9497985839844
        },
        {
            "x": 15.849842071533203,
            "y": 0.6792243719100952,
            "z": -318.10443115234375
        },
        {
            "x": 15.819452285766602,
            "y": 0.6909135580062866,
            "z": -318.25921630859375
        },
        {
            "x": 15.788649559020996,
            "y": 0.702597975730896,
            "z": -318.4142761230469
        },
        {
            "x": 15.75740909576416,
            "y": 0.7142451405525208,
            "z": -318.56939697265625
        },
        {
            "x": 15.725884437561035,
            "y": 0.7258277535438538,
            "z": -318.7240905761719
        },
        {
            "x": 15.694222450256348,
            "y": 0.7373394966125488,
            "z": -318.87847900390625
        },
        {
            "x": 15.66220760345459,
            "y": 0.7488293051719666,
            "z": -319.0331726074219
        },
        {
            "x": 15.629751205444336,
            "y": 0.7602821588516235,
            "z": -319.18804931640625
        },
        {
            "x": 15.596972465515137,
            "y": 0.7716518640518188,
            "z": -319.3426208496094
        },
        {
            "x": 15.5640287399292,
            "y": 0.7829333543777466,
            "z": -319.4967956542969
        },
        {
            "x": 15.530871391296387,
            "y": 0.7941494584083557,
            "z": -319.6510009765625
        },
        {
            "x": 15.49728775024414,
            "y": 0.8053234815597534,
            "z": -319.8055114746094
        },
        {
            "x": 15.463298797607422,
            "y": 0.8164204359054565,
            "z": -319.9600524902344
        },
        {
            "x": 15.42910385131836,
            "y": 0.8274043798446655,
            "z": -320.1140441894531
        },
        {
            "x": 15.39475154876709,
            "y": 0.8382896184921265,
            "z": -320.2678527832031
        },
        {
            "x": 15.360060691833496,
            "y": 0.8491133451461792,
            "z": -320.4219970703125
        },
        {
            "x": 15.324972152709961,
            "y": 0.859851598739624,
            "z": -320.5762939453125
        },
        {
            "x": 15.289576530456543,
            "y": 0.8704770803451538,
            "z": -320.7302551269531
        },
        {
            "x": 15.25406265258789,
            "y": 0.8809652328491211,
            "z": -320.8836975097656
        },
        {
            "x": 15.218317985534668,
            "y": 0.8913611173629761,
            "z": -321.037353515625
        },
        {
            "x": 15.18214225769043,
            "y": 0.9016751050949097,
            "z": -321.1914367675781
        },
        {
            "x": 15.14565658569336,
            "y": 0.9118611812591553,
            "z": -321.34527587890625
        },
        {
            "x": 15.108946800231934,
            "y": 0.9219075441360474,
            "z": -321.4987487792969
        },
        {
            "x": 15.084433555603027,
            "y": 0.9285170435905457,
            "z": -321.6007385253906
        },
        {
            "x": 15.047422409057617,
            "y": 0.9383479952812195,
            "z": -321.754150390625
        },
        {
            "x": 15.010008811950684,
            "y": 0.9480743408203125,
            "z": -321.9078674316406
        },
        {
            "x": 14.972259521484375,
            "y": 0.9576619267463684,
            "z": -322.0614929199219
        },
        {
            "x": 14.934375762939453,
            "y": 0.9670683145523071,
            "z": -322.21453857421875
        },
        {
            "x": 14.896309852600098,
            "y": 0.9763336181640625,
            "z": -322.3675537109375
        },
        {
            "x": 14.857975959777832,
            "y": 0.9854627251625061,
            "z": -322.520751953125
        },
        {
            "x": 14.81924819946289,
            "y": 0.9944561719894409,
            "z": -322.6742248535156
        },
        {
            "x": 14.780256271362305,
            "y": 1.0032730102539062,
            "z": -322.82733154296875
        },
        {
            "x": 14.741206169128418,
            "y": 1.011898159980774,
            "z": -322.97991943359375
        },
        {
            "x": 14.70190715789795,
            "y": 1.0203748941421509,
            "z": -323.1327819824219
        },
        {
            "x": 14.66225814819336,
            "y": 1.028699517250061,
            "z": -323.28594970703125
        },
        {
            "x": 14.622316360473633,
            "y": 1.036834716796875,
            "z": -323.43890380859375
        },
        {
            "x": 14.582164764404297,
            "y": 1.044782042503357,
            "z": -323.59161376953125
        },
        {
            "x": 14.541940689086914,
            "y": 1.052528738975525,
            "z": -323.7439880371094
        },
        {
            "x": 14.501453399658203,
            "y": 1.060103178024292,
            "z": -323.8966369628906
        },
        {
            "x": 14.460566520690918,
            "y": 1.0674960613250732,
            "z": -324.049560546875
        },
        {
            "x": 14.419501304626465,
            "y": 1.0746711492538452,
            "z": -324.2020263671875
        },
        {
            "x": 14.37829303741455,
            "y": 1.0816376209259033,
            "z": -324.354248046875
        },
        {
            "x": 14.336908340454102,
            "y": 1.0884041786193848,
            "z": -324.506591796875
        },
        {
            "x": 14.295238494873047,
            "y": 1.0949628353118896,
            "z": -324.6590576171875
        },
        {
            "x": 14.253265380859375,
            "y": 1.101306676864624,
            "z": -324.8115234375
        },
        {
            "x": 14.211137771606445,
            "y": 1.1074204444885254,
            "z": -324.9635925292969
        },
        {
            "x": 14.168911933898926,
            "y": 1.1133041381835938,
            "z": -325.11541748046875
        },
        {
            "x": 14.12639331817627,
            "y": 1.1189727783203125,
            "z": -325.2677001953125
        },
        {
            "x": 14.083605766296387,
            "y": 1.124406099319458,
            "z": -325.41998291015625
        },
        {
            "x": 14.040584564208984,
            "y": 1.129600167274475,
            "z": -325.5720520019531
        },
        {
            "x": 13.997469902038574,
            "y": 1.1345446109771729,
            "z": -325.7237548828125
        },
        {
            "x": 13.954209327697754,
            "y": 1.1392391920089722,
            "z": -325.87548828125
        },
        {
            "x": 13.910618782043457,
            "y": 1.143694519996643,
            "z": -326.027587890625
        },
        {
            "x": 13.866806983947754,
            "y": 1.1478928327560425,
            "z": -326.17950439453125
        },
        {
            "x": 13.822858810424805,
            "y": 1.1518256664276123,
            "z": -326.33111572265625
        },
        {
            "x": 13.778785705566406,
            "y": 1.1554906368255615,
            "z": -326.4825744628906
        },
        {
            "x": 13.73455810546875,
            "y": 1.1588847637176514,
            "z": -326.6340637207031
        },
        {
            "x": 13.690001487731934,
            "y": 1.1620161533355713,
            "z": -326.785888671875
        },
        {
            "x": 13.645214080810547,
            "y": 1.164872407913208,
            "z": -326.93756103515625
        },
        {
            "x": 13.600364685058594,
            "y": 1.1674362421035767,
            "z": -327.08880615234375
        },
        {
            "x": 13.555377006530762,
            "y": 1.1697108745574951,
            "z": -327.2400817871094
        },
        {
            "x": 13.510174751281738,
            "y": 1.1717004776000977,
            "z": -327.39141845703125
        },
        {
            "x": 13.464731216430664,
            "y": 1.1733994483947754,
            "z": -327.5428161621094
        },
        {
            "x": 13.41906452178955,
            "y": 1.1747970581054688,
            "z": -327.69415283203125
        },
        {
            "x": 13.373383522033691,
            "y": 1.175882339477539,
            "z": -327.84503173828125
        },
        {
            "x": 13.327561378479004,
            "y": 1.176664113998413,
            "z": -327.9959716796875
        },
        {
            "x": 13.296869277954102,
            "y": 1.1770178079605103,
            "z": -328.0967712402344
        },
        {
            "x": 13.250612258911133,
            "y": 1.1772737503051758,
            "z": -328.2479553222656
        },
        {
            "x": 13.20419979095459,
            "y": 1.17721426486969,
            "z": -328.39892578125
        },
        {
            "x": 13.15775203704834,
            "y": 1.1768407821655273,
            "z": -328.54962158203125
        },
        {
            "x": 13.111150741577148,
            "y": 1.1761528253555298,
            "z": -328.70037841796875
        },
        {
            "x": 13.064273834228516,
            "y": 1.1751470565795898,
            "z": -328.8514099121094
        },
        {
            "x": 13.017241477966309,
            "y": 1.1738417148590088,
            "z": -329.002197265625
        },
        {
            "x": 12.970134735107422,
            "y": 1.1722419261932373,
            "z": -329.15264892578125
        },
        {
            "x": 12.922872543334961,
            "y": 1.1703438758850098,
            "z": -329.30322265625
        },
        {
            "x": 12.875508308410645,
            "y": 1.1681479215621948,
            "z": -329.4537658691406
        },
        {
            "x": 12.827876091003418,
            "y": 1.1656649112701416,
            "z": -329.6044616699219
        },
        {
            "x": 12.780120849609375,
            "y": 1.162905216217041,
            "z": -329.7548828125
        },
        {
            "x": 12.732316970825195,
            "y": 1.1598715782165527,
            "z": -329.905029296875
        },
        {
            "x": 12.684354782104492,
            "y": 1.156552791595459,
            "z": -330.0553894042969
        },
        {
            "x": 12.636262893676758,
            "y": 1.152967929840088,
            "z": -330.2057189941406
        },
        {
            "x": 12.587957382202148,
            "y": 1.1491189002990723,
            "z": -330.3559875488281
        },
        {
            "x": 12.539538383483887,
            "y": 1.1450111865997314,
            "z": -330.5061340332031
        },
        {
            "x": 12.491098403930664,
            "y": 1.1406478881835938,
            "z": -330.6560363769531
        },
        {
            "x": 12.442468643188477,
            "y": 1.1360278129577637,
            "z": -330.8061218261719
        },
        {
            "x": 12.393677711486816,
            "y": 1.131160855293274,
            "z": -330.95623779296875
        },
        {
            "x": 12.344727516174316,
            "y": 1.126051664352417,
            "z": -331.10626220703125
        },
        {
            "x": 12.29578685760498,
            "y": 1.1207112073898315,
            "z": -331.25579833984375
        },
        {
            "x": 12.246718406677246,
            "y": 1.1151328086853027,
            "z": -331.405517578125
        },
        {
            "x": 12.197521209716797,
            "y": 1.1093250513076782,
            "z": -331.55523681640625
        },
        {
            "x": 12.14810562133789,
            "y": 1.1032838821411133,
            "z": -331.7052001953125
        },
        {
            "x": 12.098594665527344,
            "y": 1.0970211029052734,
            "z": -331.8548889160156
        },
        {
            "x": 12.049049377441406,
            "y": 1.0905520915985107,
            "z": -332.00433349609375
        },
        {
            "x": 11.999417304992676,
            "y": 1.0838706493377686,
            "z": -332.1537780761719
        },
        {
            "x": 11.949630737304688,
            "y": 1.076977252960205,
            "z": -332.3033447265625
        },
        {
            "x": 11.899625778198242,
            "y": 1.0698649883270264,
            "z": -332.4529724121094
        },
        {
            "x": 11.849630355834961,
            "y": 1.0625710487365723,
            "z": -332.602294921875
        },
        {
            "x": 11.79959487915039,
            "y": 1.0550894737243652,
            "z": -332.75146484375
        },
        {
            "x": 11.749442100524902,
            "y": 1.047412395477295,
            "z": -332.9007263183594
        },
        {
            "x": 11.699117660522461,
            "y": 1.039534330368042,
            "z": -333.05010986328125
        },
        {
            "x": 11.64868450164795,
            "y": 1.0314791202545166,
            "z": -333.1993408203125
        },
        {
            "x": 11.598184585571289,
            "y": 1.0232542753219604,
            "z": -333.34844970703125
        },
        {
            "x": 11.547683715820312,
            "y": 1.014866590499878,
            "z": -333.4974060058594
        },
        {
            "x": 11.497003555297852,
            "y": 1.0062901973724365,
            "z": -333.64654541015625
        },
        {
            "x": 11.446234703063965,
            "y": 0.9975541234016418,
            "z": -333.7956237792969
        },
        {
            "x": 11.395370483398438,
            "y": 0.9886642694473267,
            "z": -333.9445495605469
        },
        {
            "x": 11.34448528289795,
            "y": 0.979624330997467,
            "z": -334.0933532714844
        },
        {
            "x": 11.293533325195312,
            "y": 0.9704276323318481,
            "z": -334.2421569824219
        },
        {
            "x": 11.24246883392334,
            "y": 0.9610793590545654,
            "z": -334.3910217285156
        },
        {
            "x": 11.208345413208008,
            "y": 0.9547688364982605,
            "z": -334.49029541015625
        },
        {
            "x": 11.157118797302246,
            "y": 0.9451894164085388,
            "z": -334.63897705078125
        },
        {
            "x": 11.105864524841309,
            "y": 0.935479462146759,
            "z": -334.78759765625
        },
        {
            "x": 11.054540634155273,
            "y": 0.9256350994110107,
            "z": -334.93621826171875
        },
        {
            "x": 11.003117561340332,
            "y": 0.9156618118286133,
            "z": -335.08489990234375
        },
        {
            "x": 10.951555252075195,
            "y": 0.905558168888092,
            "z": -335.23358154296875
        },
        {
            "x": 10.899995803833008,
            "y": 0.8953502178192139,
            "z": -335.38201904296875
        },
        {
            "x": 10.848396301269531,
            "y": 0.8850317001342773,
            "z": -335.53045654296875
        },
        {
            "x": 10.796684265136719,
            "y": 0.8745908737182617,
            "z": -335.6790466308594
        },
        {
            "x": 10.744938850402832,
            "y": 0.8640527725219727,
            "z": -335.82745361328125
        },
        {
            "x": 10.693078994750977,
            "y": 0.8534057140350342,
            "z": -335.9759216308594
        },
        {
            "x": 10.641205787658691,
            "y": 0.8426730036735535,
            "z": -336.12420654296875
        },
        {
            "x": 10.589320182800293,
            "y": 0.8318531513214111,
            "z": -336.2724304199219
        },
        {
            "x": 10.537284851074219,
            "y": 0.8209262490272522,
            "z": -336.4208984375
        },
        {
            "x": 10.485251426696777,
            "y": 0.8099265694618225,
            "z": -336.5691223144531
        },
        {
            "x": 10.433149337768555,
            "y": 0.7988495230674744,
            "z": -336.7173156738281
        },
        {
            "x": 10.381033897399902,
            "y": 0.7877028584480286,
            "z": -336.8654479980469
        },
        {
            "x": 10.328847885131836,
            "y": 0.7764806747436523,
            "z": -337.0135803222656
        },
        {
            "x": 10.27657699584961,
            "y": 0.7651824951171875,
            "z": -337.16180419921875
        },
        {
            "x": 10.224233627319336,
            "y": 0.7538243532180786,
            "z": -337.30999755859375
        },
        {
            "x": 10.171904563903809,
            "y": 0.742422878742218,
            "z": -337.4579772949219
        },
        {
            "x": 10.119555473327637,
            "y": 0.7309683561325073,
            "z": -337.6059265136719
        },
        {
            "x": 10.067168235778809,
            "y": 0.7194615006446838,
            "z": -337.75390625
        },
        {
            "x": 10.014702796936035,
            "y": 0.7079038619995117,
            "z": -337.9019470214844
        },
        {
            "x": 9.962141990661621,
            "y": 0.6962966918945312,
            "z": -338.050048828125
        },
        {
            "x": 9.909629821777344,
            "y": 0.6846715211868286,
            "z": -338.1979064941406
        },
        {
            "x": 9.857083320617676,
            "y": 0.673008143901825,
            "z": -338.3458557128906
        },
        {
            "x": 9.804491996765137,
            "y": 0.6613153219223022,
            "z": -338.4937744140625
        },
        {
            "x": 9.751852989196777,
            "y": 0.6496003270149231,
            "z": -338.64166259765625
        },
        {
            "x": 9.699117660522461,
            "y": 0.6378539800643921,
            "z": -338.7896728515625
        },
        {
            "x": 9.646465301513672,
            "y": 0.6261124610900879,
            "z": -338.9374084472656
        },
        {
            "x": 9.593785285949707,
            "y": 0.6143568754196167,
            "z": -339.085205078125
        },
        {
            "x": 9.541022300720215,
            "y": 0.6025850176811218,
            "z": -339.2331237792969
        },
        {
            "x": 9.488247871398926,
            "y": 0.5908171534538269,
            "z": -339.3808898925781
        },
        {
            "x": 9.435463905334473,
            "y": 0.5790535807609558,
            "z": -339.5286865234375
        },
        {
            "x": 9.382651329040527,
            "y": 0.5672929883003235,
            "z": -339.67645263671875
        },
        {
            "x": 9.329850196838379,
            "y": 0.5555483102798462,
            "z": -339.82421875
        },
        {
            "x": 9.276982307434082,
            "y": 0.5438082218170166,
            "z": -339.9720458984375
        },
        {
            "x": 9.224124908447266,
            "y": 0.5320958495140076,
            "z": -340.1197509765625
        },
        {
            "x": 9.1712646484375,
            "y": 0.5204086303710938,
            "z": -340.2674560546875
        },
        {
            "x": 9.118331909179688,
            "y": 0.5087363719940186,
            "z": -340.415283203125
        },
        {
            "x": 9.065443992614746,
            "y": 0.49710553884506226,
            "z": -340.5630187988281
        },
        {
            "x": 9.012553215026855,
            "y": 0.4855149984359741,
            "z": -340.71063232421875
        },
        {
            "x": 8.977277755737305,
            "y": 0.47780919075012207,
            "z": -340.80914306640625
        },
        {
            "x": 8.924391746520996,
            "y": 0.46629220247268677,
            "z": -340.9567565917969
        },
        {
            "x": 8.871448516845703,
            "y": 0.45480984449386597,
            "z": -341.1045227050781
        },
        {
            "x": 8.818482398986816,
            "y": 0.44337815046310425,
            "z": -341.2523498535156
        },
        {
            "x": 8.765583992004395,
            "y": 0.4320186972618103,
            "z": -341.39990234375
        },
        {
            "x": 8.712620735168457,
            "y": 0.42070451378822327,
            "z": -341.5476989746094
        },
        {
            "x": 8.659724235534668,
            "y": 0.40946733951568604,
            "z": -341.6953125
        },
        {
            "x": 8.606823921203613,
            "y": 0.3982999920845032,
            "z": -341.8429260253906
        },
        {
            "x": 8.553836822509766,
            "y": 0.3871878683567047,
            "z": -341.99078369140625
        },
        {
            "x": 8.500913619995117,
            "y": 0.3761671781539917,
            "z": -342.1383972167969
        },
        {
            "x": 8.448030471801758,
            "y": 0.3652351200580597,
            "z": -342.2860107421875
        },
        {
            "x": 8.395124435424805,
            "y": 0.3543807864189148,
            "z": -342.4337463378906
        },
        {
            "x": 8.34226131439209,
            "y": 0.34362542629241943,
            "z": -342.58135986328125
        },
        {
            "x": 8.289323806762695,
            "y": 0.3329469561576843,
            "z": -342.72918701171875
        },
        {
            "x": 8.236501693725586,
            "y": 0.32238325476646423,
            "z": -342.8768310546875
        },
        {
            "x": 8.183670043945312,
            "y": 0.311923623085022,
            "z": -343.0244445800781
        },
        {
            "x": 8.130819320678711,
            "y": 0.3015631437301636,
            "z": -343.1722412109375
        },
        {
            "x": 8.078027725219727,
            "y": 0.2913224995136261,
            "z": -343.31988525390625
        },
        {
            "x": 8.025245666503906,
            "y": 0.28119438886642456,
            "z": -343.46759033203125
        },
        {
            "x": 7.972465515136719,
            "y": 0.2711828351020813,
            "z": -343.6153869628906
        },
        {
            "x": 7.919753551483154,
            "y": 0.2613075375556946,
            "z": -343.7630310058594
        },
        {
            "x": 7.867060661315918,
            "y": 0.25155723094940186,
            "z": -343.91070556640625
        },
        {
            "x": 7.814358711242676,
            "y": 0.2419346272945404,
            "z": -344.05853271484375
        },
        {
            "x": 7.761704444885254,
            "y": 0.2324569821357727,
            "z": -344.20623779296875
        },
        {
            "x": 7.7090349197387695,
            "y": 0.22311203181743622,
            "z": -344.3540954589844
        },
        {
            "x": 7.656469345092773,
            "y": 0.21392390131950378,
            "z": -344.5018310546875
        },
        {
            "x": 7.603878021240234,
            "y": 0.20487448573112488,
            "z": -344.64971923828125
        },
        {
            "x": 7.55134391784668,
            "y": 0.19599010050296783,
            "z": -344.7974853515625
        },
        {
            "x": 7.498873233795166,
            "y": 0.18726733326911926,
            "z": -344.94525146484375
        },
        {
            "x": 7.446393966674805,
            "y": 0.17869767546653748,
            "z": -345.09320068359375
        },
        {
            "x": 7.393974304199219,
            "y": 0.170299232006073,
            "z": -345.2410888671875
        },
        {
            "x": 7.3416032791137695,
            "y": 0.16207648813724518,
            "z": -345.38897705078125
        },
        {
            "x": 7.289238929748535,
            "y": 0.15402919054031372,
            "z": -345.5368957519531
        },
        {
            "x": 7.236988544464111,
            "y": 0.1461687982082367,
            "z": -345.6847229003906
        },
        {
            "x": 7.184747219085693,
            "y": 0.13848468661308289,
            "z": -345.8326721191406
        },
        {
            "x": 7.132503986358643,
            "y": 0.13098490238189697,
            "z": -345.9808044433594
        },
        {
            "x": 7.0803422927856445,
            "y": 0.12369098514318466,
            "z": -346.1287536621094
        },
        {
            "x": 7.028256416320801,
            "y": 0.11659511923789978,
            "z": -346.2767028808594
        },
        {
            "x": 6.976243019104004,
            "y": 0.10970068722963333,
            "z": -346.4246520996094
        },
        {
            "x": 6.9242987632751465,
            "y": 0.10301235318183899,
            "z": -346.5726623535156
        },
        {
            "x": 6.872300148010254,
            "y": 0.09652791917324066,
            "z": -346.720947265625
        },
        {
            "x": 6.820423126220703,
            "y": 0.09026824682950974,
            "z": -346.8689880371094
        },
        {
            "x": 6.768624305725098,
            "y": 0.08422686159610748,
            "z": -347.0170593261719
        },
        {
            "x": 6.734160900115967,
            "y": 0.0803283303976059,
            "z": -347.11566162109375
        },
        {
            "x": 6.682479381561279,
            "y": 0.074664406478405,
            "z": -347.2637939453125
        },
        {
            "x": 6.630796432495117,
            "y": 0.06922423839569092,
            "z": -347.412109375
        },
        {
            "x": 6.579184532165527,
            "y": 0.06401965022087097,
            "z": -347.56036376953125
        },
        {
            "x": 6.5276947021484375,
            "y": 0.05906883254647255,
            "z": -347.7084655761719
        },
        {
            "x": 6.476288318634033,
            "y": 0.05435788631439209,
            "z": -347.856689453125
        },
        {
            "x": 6.424930095672607,
            "y": 0.04989112168550491,
            "z": -348.0050048828125
        },
        {
            "x": 6.373618125915527,
            "y": 0.045674167573451996,
            "z": -348.1533508300781
        },
        {
            "x": 6.322334289550781,
            "y": 0.04172169417142868,
            "z": -348.3017272949219
        },
        {
            "x": 6.271245002746582,
            "y": 0.038035523146390915,
            "z": -348.449951171875
        },
        {
            "x": 6.220217227935791,
            "y": 0.03460928052663803,
            "z": -348.5982971191406
        },
        {
            "x": 6.169209003448486,
            "y": 0.031446970999240875,
            "z": -348.7467956542969
        },
        {
            "x": 6.11829137802124,
            "y": 0.028570981696248055,
            "z": -348.895263671875
        },
        {
            "x": 6.067434310913086,
            "y": 0.02597108855843544,
            "z": -349.04376220703125
        },
        {
            "x": 6.016770362854004,
            "y": 0.023654816672205925,
            "z": -349.1920166015625
        },
        {
            "x": 5.966163635253906,
            "y": 0.021620869636535645,
            "z": -349.3405456542969
        },
        {
            "x": 5.915579795837402,
            "y": 0.019886977970600128,
            "z": -349.4892272949219
        },
        {
            "x": 5.865091323852539,
            "y": 0.018448306247591972,
            "z": -349.6377868652344
        },
        {
            "x": 5.81471061706543,
            "y": 0.01730719953775406,
            "z": -349.7863464355469
        },
        {
            "x": 5.764492034912109,
            "y": 0.016468139365315437,
            "z": -349.93487548828125
        },
        {
            "x": 5.714348793029785,
            "y": 0.015947548672556877,
            "z": -350.0835266113281
        },
        {
            "x": 5.664251327514648,
            "y": 0.015738412737846375,
            "z": -350.2322692871094
        },
        {
            "x": 5.614267826080322,
            "y": 0.015731722116470337,
            "z": -350.3809509277344
        },
        {
            "x": 5.564436435699463,
            "y": 0.01573812961578369,
            "z": -350.529541015625
        },
        {
            "x": 5.514678478240967,
            "y": 0.015744686126708984,
            "z": -350.67840576171875
        },
        {
            "x": 5.464995384216309,
            "y": 0.015751108527183533,
            "z": -350.8272705078125
        },
        {
            "x": 5.415390968322754,
            "y": 0.015757650136947632,
            "z": -350.9761657714844
        },
        {
            "x": 5.365922927856445,
            "y": 0.015764132142066956,
            "z": -351.1250305175781
        },
        {
            "x": 5.31666374206543,
            "y": 0.015770629048347473,
            "z": -351.2737121582031
        },
        {
            "x": 5.267428874969482,
            "y": 0.01577705144882202,
            "z": -351.4228210449219
        },
        {
            "x": 5.218328475952148,
            "y": 0.015783533453941345,
            "z": -351.5718078613281
        },
        {
            "x": 5.169305801391602,
            "y": 0.01579001545906067,
            "z": -351.7208557128906
        },
        {
            "x": 5.120394229888916,
            "y": 0.015796542167663574,
            "z": -351.8699035644531
        },
        {
            "x": 5.071737289428711,
            "y": 0.015803024172782898,
            "z": -352.0186767578125
        },
        {
            "x": 5.023144721984863,
            "y": 0.01580950617790222,
            "z": -352.1678466796875
        },
        {
            "x": 4.974563121795654,
            "y": 0.01581600308418274,
            "z": -352.3172607421875
        },
        {
            "x": 4.9261603355407715,
            "y": 0.015822485089302063,
            "z": -352.46636962890625
        },
        {
            "x": 4.877920627593994,
            "y": 0.01582898199558258,
            "z": -352.615478515625
        },
        {
            "x": 4.82988166809082,
            "y": 0.01583544909954071,
            "z": -352.7645263671875
        },
        {
            "x": 4.781928539276123,
            "y": 0.015841946005821228,
            "z": -352.9137878417969
        },
        {
            "x": 4.733949184417725,
            "y": 0.015848413109779358,
            "z": -353.0634460449219
        },
        {
            "x": 4.686235427856445,
            "y": 0.015854939818382263,
            "z": -353.2126770019531
        },
        {
            "x": 4.638708114624023,
            "y": 0.01586146652698517,
            "z": -353.3618469238281
        },
        {
            "x": 4.6071319580078125,
            "y": 0.015865817666053772,
            "z": -353.4613037109375
        },
        {
            "x": 4.559813022613525,
            "y": 0.01587231457233429,
            "z": -353.6108093261719
        },
        {
            "x": 4.512514114379883,
            "y": 0.015878751873970032,
            "z": -353.7605285644531
        },
        {
            "x": 4.465404510498047,
            "y": 0.01588521897792816,
            "z": -353.9100341796875
        },
        {
            "x": 4.418545722961426,
            "y": 0.015891700983047485,
            "z": -354.0592956542969
        },
        {
            "x": 4.371818542480469,
            "y": 0.015898212790489197,
            "z": -354.2088928222656
        },
        {
            "x": 4.325206279754639,
            "y": 0.015904635190963745,
            "z": -354.3586120605469
        },
        {
            "x": 4.278679370880127,
            "y": 0.015911191701889038,
            "z": -354.50836181640625
        },
        {
            "x": 4.232295989990234,
            "y": 0.01591762900352478,
            "z": -354.65814208984375
        },
        {
            "x": 4.186205863952637,
            "y": 0.01592414081096649,
            "z": -354.80767822265625
        },
        {
            "x": 4.140246868133545,
            "y": 0.015930652618408203,
            "z": -354.9574279785156
        },
        {
            "x": 4.094358921051025,
            "y": 0.015937089920043945,
            "z": -355.107421875
        },
        {
            "x": 4.048613548278809,
            "y": 0.015943586826324463,
            "z": -355.25732421875
        },
        {
            "x": 4.003055095672607,
            "y": 0.015950053930282593,
            "z": -355.4072570800781
        },
        {
            "x": 3.957780361175537,
            "y": 0.015956491231918335,
            "z": -355.55694580078125
        },
        {
            "x": 3.9126434326171875,
            "y": 0.015963047742843628,
            "z": -355.7069091796875
        },
        {
            "x": 3.867508888244629,
            "y": 0.01596952974796295,
            "z": -355.8572692871094
        },
        {
            "x": 3.8226161003112793,
            "y": 0.015976056456565857,
            "z": -356.0072937011719
        },
        {
            "x": 3.777949333190918,
            "y": 0.015982523560523987,
            "z": -356.1572570800781
        },
        {
            "x": 3.73349666595459,
            "y": 0.015988990664482117,
            "z": -356.30731201171875
        },
        {
            "x": 3.6891837120056152,
            "y": 0.015995487570762634,
            "z": -356.45758056640625
        },
        {
            "x": 3.6449332237243652,
            "y": 0.016001954674720764,
            "z": -356.6080627441406
        },
        {
            "x": 3.6009418964385986,
            "y": 0.016008391976356506,
            "z": -356.7582092285156
        },
        {
            "x": 3.557223320007324,
            "y": 0.016014888882637024,
            "z": -356.9082336425781
        },
        {
            "x": 3.5136051177978516,
            "y": 0.016021370887756348,
            "z": -357.0588073730469
        },
        {
            "x": 3.470165729522705,
            "y": 0.016027897596359253,
            "z": -357.20928955078125
        },
        {
            "x": 3.4268126487731934,
            "y": 0.016034364700317383,
            "z": -357.3599853515625
        },
        {
            "x": 3.383742094039917,
            "y": 0.0160408616065979,
            "z": -357.5103454589844
        },
        {
            "x": 3.3409738540649414,
            "y": 0.016047269105911255,
            "z": -357.6606140136719
        },
        {
            "x": 3.298295259475708,
            "y": 0.016053810715675354,
            "z": -357.81146240234375
        },
        {
            "x": 3.2557568550109863,
            "y": 0.016060292720794678,
            "z": -357.9623107910156
        },
        {
            "x": 3.213407516479492,
            "y": 0.016066744923591614,
            "z": -358.1130676269531
        },
        {
            "x": 3.171342611312866,
            "y": 0.01607327163219452,
            "z": -358.26361083984375
        },
        {
            "x": 3.129554271697998,
            "y": 0.016079723834991455,
            "z": -358.4141845703125
        },
        {
            "x": 3.0878469944000244,
            "y": 0.01608625054359436,
            "z": -358.5653076171875
        },
        {
            "x": 3.046250104904175,
            "y": 0.01609271764755249,
            "z": -358.7164611816406
        },
        {
            "x": 3.0049266815185547,
            "y": 0.016099169850349426,
            "z": -358.8673400878906
        },
        {
            "x": 2.9639108180999756,
            "y": 0.016105681657791138,
            "z": -359.0180969238281
        },
        {
            "x": 2.9231433868408203,
            "y": 0.016112178564071655,
            "z": -359.1690368652344
        },
        {
            "x": 2.8824923038482666,
            "y": 0.01611866056919098,
            "z": -359.3203125
        },
        {
            "x": 2.8419106006622314,
            "y": 0.016125112771987915,
            "z": -359.4718322753906
        },
        {
            "x": 2.801708936691284,
            "y": 0.016131624579429626,
            "z": -359.62274169921875
        },
        {
            "x": 2.76180362701416,
            "y": 0.01613810658454895,
            "z": -359.77374267578125
        },
        {
            "x": 2.7353157997131348,
            "y": 0.01614244282245636,
            "z": -359.8745422363281
        },
        {
            "x": 2.695636510848999,
            "y": 0.016148924827575684,
            "z": -360.0260925292969
        },
        {
            "x": 2.656125783920288,
            "y": 0.016155406832695007,
            "z": -360.177734375
        },
        {
            "x": 2.6169023513793945,
            "y": 0.016161859035491943,
            "z": -360.3289794921875
        },
        {
            "x": 2.5780415534973145,
            "y": 0.016168326139450073,
            "z": -360.4801330566406
        },
        {
            "x": 2.5393731594085693,
            "y": 0.01617485284805298,
            "z": -360.6317138671875
        },
        {
            "x": 2.500802993774414,
            "y": 0.016181275248527527,
            "z": -360.78363037109375
        },
        {
            "x": 2.462456464767456,
            "y": 0.016187801957130432,
            "z": -360.935302734375
        },
        {
            "x": 2.4244182109832764,
            "y": 0.016194283962249756,
            "z": -361.0868225097656
        },
        {
            "x": 2.3867406845092773,
            "y": 0.016200736165046692,
            "z": -361.23834228515625
        },
        {
            "x": 2.3491907119750977,
            "y": 0.016207247972488403,
            "z": -361.3903503417969
        },
        {
            "x": 2.3117635250091553,
            "y": 0.01621370017528534,
            "z": -361.54248046875
        },
        {
            "x": 2.2746357917785645,
            "y": 0.01622021198272705,
            "z": -361.69427490234375
        },
        {
            "x": 2.2378463745117188,
            "y": 0.01622670888900757,
            "z": -361.84600830078125
        },
        {
            "x": 2.2013638019561768,
            "y": 0.01623322069644928,
            "z": -361.9978942871094
        },
        {
            "x": 2.165027618408203,
            "y": 0.016239657998085022,
            "z": -362.1501770019531
        },
        {
            "x": 2.1288092136383057,
            "y": 0.016246110200881958,
            "z": -362.30255126953125
        },
        {
            "x": 2.092998504638672,
            "y": 0.016252607107162476,
            "z": -362.4544372558594
        },
        {
            "x": 2.0575191974639893,
            "y": 0.0162590891122818,
            "z": -362.60638427734375
        },
        {
            "x": 2.0222551822662354,
            "y": 0.01626555621623993,
            "z": -362.7586975097656
        },
        {
            "x": 1.98714017868042,
            "y": 0.016272082924842834,
            "z": -362.9113464355469
        },
        {
            "x": 1.952268362045288,
            "y": 0.016278520226478577,
            "z": -363.0637512207031
        },
        {
            "x": 1.917797327041626,
            "y": 0.016285032033920288,
            "z": -363.21575927734375
        },
        {
            "x": 1.8836524486541748,
            "y": 0.016291514039039612,
            "z": -363.3679504394531
        },
        {
            "x": 1.8496339321136475,
            "y": 0.016298025846481323,
            "z": -363.5208740234375
        },
        {
            "x": 1.8158200979232788,
            "y": 0.01630447804927826,
            "z": -363.6736755371094
        },
        {
            "x": 1.7823113203048706,
            "y": 0.016310915350914,
            "z": -363.82623291015625
        },
        {
            "x": 1.7491999864578247,
            "y": 0.01631753146648407,
            "z": -363.978515625
        },
        {
            "x": 1.7163968086242676,
            "y": 0.016323938965797424,
            "z": -364.1311340332031
        },
        {
            "x": 1.683724045753479,
            "y": 0.016330435872077942,
            "z": -364.2843933105469
        },
        {
            "x": 1.651284098625183,
            "y": 0.016336947679519653,
            "z": -364.4374084472656
        },
        {
            "x": 1.6192164421081543,
            "y": 0.016343355178833008,
            "z": -364.5899963378906
        },
        {
            "x": 1.5875319242477417,
            "y": 0.0163499116897583,
            "z": -364.74261474609375
        },
        {
            "x": 1.5561299324035645,
            "y": 0.01635633409023285,
            "z": -364.8955993652344
        },
        {
            "x": 1.5248574018478394,
            "y": 0.01636284589767456,
            "z": -365.049072265625
        },
        {
            "x": 1.493831992149353,
            "y": 0.016369342803955078,
            "z": -365.2023010253906
        },
        {
            "x": 1.4632636308670044,
            "y": 0.016375824809074402,
            "z": -365.3550109863281
        },
        {
            "x": 1.4330483675003052,
            "y": 0.016382277011871338,
            "z": -365.5080261230469
        },
        {
            "x": 1.4030605554580688,
            "y": 0.01638875901699066,
            "z": -365.66143798828125
        },
        {
            "x": 1.3732447624206543,
            "y": 0.016395241022109985,
            "z": -365.81500244140625
        },
        {
            "x": 1.3437376022338867,
            "y": 0.016401708126068115,
            "z": -365.9683837890625
        },
        {
            "x": 1.314718246459961,
            "y": 0.016408205032348633,
            "z": -366.121337890625
        },
        {
            "x": 1.286031723022461,
            "y": 0.016414791345596313,
            "z": -366.2746276855469
        },
        {
            "x": 1.2669858932495117,
            "y": 0.01641911268234253,
            "z": -366.377197265625
        },
        {
            "x": 1.2385886907577515,
            "y": 0.01642554998397827,
            "z": -366.531005859375
        },
        {
            "x": 1.2105528116226196,
            "y": 0.016432031989097595,
            "z": -366.6844482421875
        },
        {
            "x": 1.1829578876495361,
            "y": 0.016438528895378113,
            "z": -366.83770751953125
        },
        {
            "x": 1.155722737312317,
            "y": 0.016444995999336243,
            "z": -366.9912414550781
        },
        {
            "x": 1.128638744354248,
            "y": 0.016451507806777954,
            "z": -367.1454772949219
        },
        {
            "x": 1.101823329925537,
            "y": 0.016457974910736084,
            "z": -367.29937744140625
        },
        {
            "x": 1.0754426717758179,
            "y": 0.016464412212371826,
            "z": -367.4527893066406
        },
        {
            "x": 1.0494563579559326,
            "y": 0.01647096872329712,
            "z": -367.6064758300781
        },
        {
            "x": 1.0237977504730225,
            "y": 0.016477376222610474,
            "z": -367.76043701171875
        },
        {
            "x": 0.9983086585998535,
            "y": 0.01648387312889099,
            "z": -367.9148254394531
        },
        {
            "x": 0.9731405973434448,
            "y": 0.01649037003517151,
            "z": -368.06884765625
        },
        {
            "x": 0.9484502077102661,
            "y": 0.016496866941452026,
            "z": -368.2223815917969
        },
        {
            "x": 0.9241356253623962,
            "y": 0.016503289341926575,
            "z": -368.37640380859375
        },
        {
            "x": 0.9000896215438843,
            "y": 0.016509786248207092,
            "z": -368.5308532714844
        },
        {
            "x": 0.8762513399124146,
            "y": 0.016516268253326416,
            "z": -368.685302734375
        },
        {
            "x": 0.8528004884719849,
            "y": 0.016522765159606934,
            "z": -368.8393859863281
        },
        {
            "x": 0.8298524618148804,
            "y": 0.016529247164726257,
            "z": -368.99310302734375
        },
        {
            "x": 0.8072495460510254,
            "y": 0.016535744071006775,
            "z": -369.1474609375
        },
        {
            "x": 0.7848508358001709,
            "y": 0.016542211174964905,
            "z": -369.30230712890625
        },
        {
            "x": 0.7627422213554382,
            "y": 0.016548722982406616,
            "z": -369.456787109375
        },
        {
            "x": 0.7411092519760132,
            "y": 0.01655520498752594,
            "z": -369.6107482910156
        },
        {
            "x": 0.719946026802063,
            "y": 0.016561642289161682,
            "z": -369.76483154296875
        },
        {
            "x": 0.6990785002708435,
            "y": 0.01656818389892578,
            "z": -369.9195556640625
        },
        {
            "x": 0.6783884763717651,
            "y": 0.016574636101722717,
            "z": -370.0746765136719
        },
        {
            "x": 0.6580877900123596,
            "y": 0.01658114790916443,
            "z": -370.2291564941406
        },
        {
            "x": 0.6383015513420105,
            "y": 0.01658758521080017,
            "z": -370.3832702636719
        },
        {
            "x": 0.6189344525337219,
            "y": 0.01659408211708069,
            "z": -370.5378112792969
        },
        {
            "x": 0.5998214483261108,
            "y": 0.016600534319877625,
            "z": -370.6929016113281
        },
        {
            "x": 0.5809376239776611,
            "y": 0.016607046127319336,
            "z": -370.8481140136719
        },
        {
            "x": 0.5625289678573608,
            "y": 0.016613543033599854,
            "z": -371.0025329589844
        },
        {
            "x": 0.544632077217102,
            "y": 0.01661999523639679,
            "z": -371.15679931640625
        },
        {
            "x": 0.5270938873291016,
            "y": 0.016626447439193726,
            "z": -371.3117370605469
        },
        {
            "x": 0.5097861289978027,
            "y": 0.01663297414779663,
            "z": -371.4671936035156
        },
        {
            "x": 0.4928050935268402,
            "y": 0.01663944125175476,
            "z": -371.6221923828125
        },
        {
            "x": 0.47632232308387756,
            "y": 0.016645953059196472,
            "z": -371.7767333984375
        },
        {
            "x": 0.46033287048339844,
            "y": 0.01665244996547699,
            "z": -371.9313659667969
        },
        {
            "x": 0.4446757137775421,
            "y": 0.01665891706943512,
            "z": -372.0867004394531
        },
        {
            "x": 0.4292558431625366,
            "y": 0.016665399074554443,
            "z": -372.2421875
        },
        {
            "x": 0.4142361581325531,
            "y": 0.01667185127735138,
            "z": -372.3970642089844
        },
        {
            "x": 0.39973828196525574,
            "y": 0.01667836308479309,
            "z": -372.5517883300781
        },
        {
            "x": 0.3857058584690094,
            "y": 0.01668483018875122,
            "z": -372.70672607421875
        },
        {
            "x": 0.371950626373291,
            "y": 0.016691267490386963,
            "z": -372.8624267578125
        },
        {
            "x": 0.36292514204978943,
            "y": 0.016695618629455566,
            "z": -372.966064453125
        },
        {
            "x": 0.34975099563598633,
            "y": 0.01670217514038086,
            "z": -373.12103271484375
        },
        {
            "x": 0.3371279835700989,
            "y": 0.01670864224433899,
            "z": -373.2757263183594
        },
        {
            "x": 0.32495659589767456,
            "y": 0.016715124249458313,
            "z": -373.43096923828125
        },
        {
            "x": 0.3130720257759094,
            "y": 0.01672157645225525,
            "z": -373.5867614746094
        },
        {
            "x": 0.3014753758907318,
            "y": 0.016728103160858154,
            "z": -373.7423400878906
        },
        {
            "x": 0.2903876304626465,
            "y": 0.016734570264816284,
            "z": -373.8971862792969
        },
        {
            "x": 0.27983900904655457,
            "y": 0.016741037368774414,
            "z": -374.05206298828125
        },
        {
            "x": 0.26968374848365784,
            "y": 0.016747474670410156,
            "z": -374.20782470703125
        },
        {
            "x": 0.2597975432872772,
            "y": 0.016753986477851868,
            "z": -374.3636779785156
        },
        {
            "x": 0.2502898573875427,
            "y": 0.016760513186454773,
            "z": -374.5190124511719
        },
        {
            "x": 0.24132007360458374,
            "y": 0.01676696538925171,
            "z": -374.6739196777344
        },
        {
            "x": 0.23287582397460938,
            "y": 0.016773462295532227,
            "z": -374.82904052734375
        },
        {
            "x": 0.22477099299430847,
            "y": 0.016779929399490356,
            "z": -374.985107421875
        },
        {
            "x": 0.21695727109909058,
            "y": 0.016786441206932068,
            "z": -375.1408996582031
        },
        {
            "x": 0.20959210395812988,
            "y": 0.016792908310890198,
            "z": -375.2960205078125
        },
        {
            "x": 0.20278936624526978,
            "y": 0.01679934561252594,
            "z": -375.45098876953125
        },
        {
            "x": 0.19647270441055298,
            "y": 0.016805842518806458,
            "z": -375.6064758300781
        },
        {
            "x": 0.19046035408973694,
            "y": 0.01681235432624817,
            "z": -375.7626647949219
        },
        {
            "x": 0.18477755784988403,
            "y": 0.016818851232528687,
            "z": -375.9183349609375
        },
        {
            "x": 0.17960399389266968,
            "y": 0.016825318336486816,
            "z": -376.0733337402344
        },
        {
            "x": 0.17499110102653503,
            "y": 0.016831785440444946,
            "z": -376.22845458984375
        },
        {
            "x": 0.17080342769622803,
            "y": 0.016838297247886658,
            "z": -376.3843688964844
        },
        {
            "x": 0.1668909192085266,
            "y": 0.016844749450683594,
            "z": -376.54034423828125
        },
        {
            "x": 0.16336491703987122,
            "y": 0.016851216554641724,
            "z": -376.6959228515625
        },
        {
            "x": 0.1603652536869049,
            "y": 0.016857728362083435,
            "z": -376.85107421875
        },
        {
            "x": 0.15785428881645203,
            "y": 0.01686421036720276,
            "z": -377.0068359375
        },
        {
            "x": 0.15563133358955383,
            "y": 0.016870662569999695,
            "z": -377.1631774902344
        },
        {
            "x": 0.15368229150772095,
            "y": 0.0168771892786026,
            "z": -377.319091796875
        },
        {
            "x": 0.15212410688400269,
            "y": 0.01688365638256073,
            "z": -377.47491455078125
        },
        {
            "x": 0.15098771452903748,
            "y": 0.016890138387680054,
            "z": -377.63079833984375
        },
        {
            "x": 0.15010324120521545,
            "y": 0.016896605491638184,
            "z": -377.787353515625
        },
        {
            "x": 0.1493467092514038,
            "y": 0.016903087496757507,
            "z": -377.9440612792969
        },
        {
            "x": 0.14879637956619263,
            "y": 0.01690959930419922,
            "z": -378.1003723144531
        },
        {
            "x": 0.14850100874900818,
            "y": 0.01691603660583496,
            "z": -378.2568054199219
        },
        {
            "x": 0.14837434887886047,
            "y": 0.016922637820243835,
            "z": -378.4137268066406
        },
        {
            "x": 0.14829730987548828,
            "y": 0.01692904531955719,
            "z": -378.5708923339844
        },
        {
            "x": 0.14825120568275452,
            "y": 0.016935482621192932,
            "z": -378.7279968261719
        },
        {
            "x": 0.14829197525978088,
            "y": 0.016942009329795837,
            "z": -378.8848571777344
        },
        {
            "x": 0.1484055519104004,
            "y": 0.016948476433753967,
            "z": -379.0419616699219
        },
        {
            "x": 0.14854884147644043,
            "y": 0.016954973340034485,
            "z": -379.1993408203125
        },
        {
            "x": 0.14868703484535217,
            "y": 0.01696142554283142,
            "z": -379.3565673828125
        },
        {
            "x": 0.14883750677108765,
            "y": 0.016967982053756714,
            "z": -379.51373291015625
        },
        {
            "x": 0.1489463448524475,
            "y": 0.01697230339050293,
            "z": -379.6185302734375
        },
        {
            "x": 0.1491195559501648,
            "y": 0.01697877049446106,
            "z": -379.7757263183594
        },
        {
            "x": 0.14929646253585815,
            "y": 0.01698528230190277,
            "z": -379.9330749511719
        },
        {
            "x": 0.14947083592414856,
            "y": 0.016991794109344482,
            "z": -380.09039306640625
        },
        {
            "x": 0.14964637160301208,
            "y": 0.016998201608657837,
            "z": -380.24761962890625
        },
        {
            "x": 0.14982393383979797,
            "y": 0.01700471341609955,
            "z": -380.40496826171875
        },
        {
            "x": 0.1500023603439331,
            "y": 0.017011210322380066,
            "z": -380.56219482421875
        },
        {
            "x": 0.15018051862716675,
            "y": 0.01701773703098297,
            "z": -380.71942138671875
        },
        {
            "x": 0.15035882592201233,
            "y": 0.017024129629135132,
            "z": -380.8768615722656
        },
        {
            "x": 0.15053698420524597,
            "y": 0.01703062653541565,
            "z": -381.0340881347656
        },
        {
            "x": 0.15071532130241394,
            "y": 0.01703713834285736,
            "z": -381.1913757324219
        },
        {
            "x": 0.15089356899261475,
            "y": 0.01704363524913788,
            "z": -381.3486633300781
        },
        {
            "x": 0.15107184648513794,
            "y": 0.01705007255077362,
            "z": -381.5058898925781
        },
        {
            "x": 0.15125027298927307,
            "y": 0.01705653965473175,
            "z": -381.663330078125
        },
        {
            "x": 0.15142866969108582,
            "y": 0.017063066363334656,
            "z": -381.820556640625
        },
        {
            "x": 0.15160685777664185,
            "y": 0.017069533467292786,
            "z": -381.977783203125
        },
        {
            "x": 0.15178513526916504,
            "y": 0.01707601547241211,
            "z": -382.1351318359375
        },
        {
            "x": 0.151963472366333,
            "y": 0.017082497477531433,
            "z": -382.2923583984375
        },
        {
            "x": 0.15214180946350098,
            "y": 0.01708899438381195,
            "z": -382.44970703125
        },
        {
            "x": 0.15232017636299133,
            "y": 0.017095521092414856,
            "z": -382.6070251464844
        },
        {
            "x": 0.15249842405319214,
            "y": 0.017101913690567017,
            "z": -382.7642517089844
        },
        {
            "x": 0.15267658233642578,
            "y": 0.017108455300331116,
            "z": -382.9214782714844
        },
        {
            "x": 0.15285494923591614,
            "y": 0.017114892601966858,
            "z": -383.0787353515625
        },
        {
            "x": 0.15303313732147217,
            "y": 0.017121359705924988,
            "z": -383.2359619140625
        },
        {
            "x": 0.1532115936279297,
            "y": 0.0171278715133667,
            "z": -383.39337158203125
        },
        {
            "x": 0.15338975191116333,
            "y": 0.01713433861732483,
            "z": -383.55059814453125
        },
        {
            "x": 0.15356814861297607,
            "y": 0.017140865325927734,
            "z": -383.7078857421875
        },
        {
            "x": 0.1537463665008545,
            "y": 0.01714731752872467,
            "z": -383.86517333984375
        },
        {
            "x": 0.15392473340034485,
            "y": 0.017153769731521606,
            "z": -384.02239990234375
        },
        {
            "x": 0.1541031301021576,
            "y": 0.01716029644012451,
            "z": -384.1798400878906
        },
        {
            "x": 0.15428143739700317,
            "y": 0.01716679334640503,
            "z": -384.3370666503906
        },
        {
            "x": 0.15445968508720398,
            "y": 0.017173275351524353,
            "z": -384.49432373046875
        },
        {
            "x": 0.15463793277740479,
            "y": 0.017179742455482483,
            "z": -384.6516418457031
        },
        {
            "x": 0.15481626987457275,
            "y": 0.017186254262924194,
            "z": -384.80889892578125
        },
        {
            "x": 0.15499451756477356,
            "y": 0.017192691564559937,
            "z": -384.9662170410156
        },
        {
            "x": 0.1551729440689087,
            "y": 0.017199218273162842,
            "z": -385.12353515625
        },
        {
            "x": 0.1553511917591095,
            "y": 0.017205655574798584,
            "z": -385.2807922363281
        },
        {
            "x": 0.15552949905395508,
            "y": 0.017212137579917908,
            "z": -385.4381103515625
        },
        {
            "x": 0.15570780634880066,
            "y": 0.017218634486198425,
            "z": -385.5953369140625
        },
        {
            "x": 0.1558859646320343,
            "y": 0.01722516119480133,
            "z": -385.7525634765625
        },
        {
            "x": 0.15606451034545898,
            "y": 0.017231598496437073,
            "z": -385.9100036621094
        },
        {
            "x": 0.15624266862869263,
            "y": 0.017238065600395203,
            "z": -386.0672302246094
        },
        {
            "x": 0.15642106533050537,
            "y": 0.017244607210159302,
            "z": -386.2244873046875
        },
        {
            "x": 0.15653979778289795,
            "y": 0.017248883843421936,
            "z": -386.32928466796875
        },
        {
            "x": 0.15671810507774353,
            "y": 0.017255350947380066,
            "z": -386.4865417480469
        },
        {
            "x": 0.1568964421749115,
            "y": 0.017261862754821777,
            "z": -386.64385986328125
        },
        {
            "x": 0.15707474946975708,
            "y": 0.017268329858779907,
            "z": -386.8011779785156
        },
        {
            "x": 0.15725299715995789,
            "y": 0.01727481186389923,
            "z": -386.95843505859375
        },
        {
            "x": 0.15743130445480347,
            "y": 0.01728130877017975,
            "z": -387.1157531738281
        },
        {
            "x": 0.15760955214500427,
            "y": 0.017287835478782654,
            "z": -387.27301025390625
        },
        {
            "x": 0.15778791904449463,
            "y": 0.017294347286224365,
            "z": -387.43023681640625
        },
        {
            "x": 0.15796628594398499,
            "y": 0.01730075478553772,
            "z": -387.587646484375
        },
        {
            "x": 0.15814459323883057,
            "y": 0.017307281494140625,
            "z": -387.744873046875
        },
        {
            "x": 0.15832293033599854,
            "y": 0.01731373369693756,
            "z": -387.90216064453125
        },
        {
            "x": 0.15850114822387695,
            "y": 0.017320245504379272,
            "z": -388.0594482421875
        },
        {
            "x": 0.15867942571640015,
            "y": 0.017326682806015015,
            "z": -388.2167053222656
        },
        {
            "x": 0.15885785222053528,
            "y": 0.01733320951461792,
            "z": -388.3741149902344
        },
        {
            "x": 0.15903624892234802,
            "y": 0.017339646816253662,
            "z": -388.5313720703125
        },
        {
            "x": 0.15921440720558167,
            "y": 0.01734618842601776,
            "z": -388.6885986328125
        },
        {
            "x": 0.15939271450042725,
            "y": 0.01735261082649231,
            "z": -388.8459167480469
        },
        {
            "x": 0.15957111120224,
            "y": 0.017359137535095215,
            "z": -389.003173828125
        },
        {
            "x": 0.15974941849708557,
            "y": 0.01736566424369812,
            "z": -389.1604919433594
        },
        {
            "x": 0.15992778539657593,
            "y": 0.01737208664417267,
            "z": -389.31781005859375
        },
        {
            "x": 0.16010600328445435,
            "y": 0.017378568649291992,
            "z": -389.47503662109375
        },
        {
            "x": 0.16028431057929993,
            "y": 0.017385020852088928,
            "z": -389.63226318359375
        },
        {
            "x": 0.16046258807182312,
            "y": 0.017391547560691833,
            "z": -389.78948974609375
        },
        {
            "x": 0.16064077615737915,
            "y": 0.017398014664649963,
            "z": -389.94671630859375
        },
        {
            "x": 0.16081920266151428,
            "y": 0.0174044668674469,
            "z": -390.10418701171875
        },
        {
            "x": 0.1609974503517151,
            "y": 0.017411008477211,
            "z": -390.26141357421875
        },
        {
            "x": 0.16117578744888306,
            "y": 0.017417490482330322,
            "z": -390.418701171875
        },
        {
            "x": 0.16135400533676147,
            "y": 0.01742391288280487,
            "z": -390.57598876953125
        },
        {
            "x": 0.16153231263160706,
            "y": 0.017430409789085388,
            "z": -390.73321533203125
        },
        {
            "x": 0.16171082854270935,
            "y": 0.0174369215965271,
            "z": -390.8906555175781
        },
        {
            "x": 0.16188907623291016,
            "y": 0.017443418502807617,
            "z": -391.04791259765625
        },
        {
            "x": 0.16206732392311096,
            "y": 0.01744990050792694,
            "z": -391.2051086425781
        },
        {
            "x": 0.16224566102027893,
            "y": 0.01745632290840149,
            "z": -391.3624572753906
        },
        {
            "x": 0.16242390871047974,
            "y": 0.017462849617004395,
            "z": -391.5196838378906
        },
        {
            "x": 0.16260230541229248,
            "y": 0.017469316720962524,
            "z": -391.6770324707031
        },
        {
            "x": 0.16278061270713806,
            "y": 0.017475858330726624,
            "z": -391.8343811035156
        },
        {
            "x": 0.16295883059501648,
            "y": 0.017482280731201172,
            "z": -391.9915771484375
        },
        {
            "x": 0.16313722729682922,
            "y": 0.017488792538642883,
            "z": -392.14892578125
        },
        {
            "x": 0.16331559419631958,
            "y": 0.017495304346084595,
            "z": -392.30615234375
        },
        {
            "x": 0.16349375247955322,
            "y": 0.01750175654888153,
            "z": -392.46337890625
        },
        {
            "x": 0.16367214918136597,
            "y": 0.017508208751678467,
            "z": -392.6208190917969
        },
        {
            "x": 0.16385045647621155,
            "y": 0.017514735460281372,
            "z": -392.7780456542969
        },
        {
            "x": 0.16402876377105713,
            "y": 0.01752115786075592,
            "z": -392.9352722167969
        },
        {
            "x": 0.16414955258369446,
            "y": 0.0175255686044693,
            "z": -393.04010009765625
        },
        {
            "x": 0.16432783007621765,
            "y": 0.01753208041191101,
            "z": -393.19732666015625
        },
        {
            "x": 0.16450616717338562,
            "y": 0.017538517713546753,
            "z": -393.35467529296875
        },
        {
            "x": 0.1646844744682312,
            "y": 0.01754501461982727,
            "z": -393.5119934082031
        },
        {
            "x": 0.164862722158432,
            "y": 0.01755155622959137,
            "z": -393.6692199707031
        },
        {
            "x": 0.1650412380695343,
            "y": 0.0175580233335495,
            "z": -393.8265686035156
        },
        {
            "x": 0.16521939635276794,
            "y": 0.01756446063518524,
            "z": -393.9837951660156
        },
        {
            "x": 0.16539758443832397,
            "y": 0.017570972442626953,
            "z": -394.1410217285156
        },
        {
            "x": 0.16557610034942627,
            "y": 0.017577439546585083,
            "z": -394.2984619140625
        },
        {
            "x": 0.16575440764427185,
            "y": 0.017583906650543213,
            "z": -394.4556884765625
        },
        {
            "x": 0.16593262553215027,
            "y": 0.017590388655662537,
            "z": -394.61297607421875
        },
        {
            "x": 0.16611096262931824,
            "y": 0.017596915364265442,
            "z": -394.770263671875
        },
        {
            "x": 0.16628915071487427,
            "y": 0.017603367567062378,
            "z": -394.927490234375
        },
        {
            "x": 0.16646766662597656,
            "y": 0.0176098495721817,
            "z": -395.0849304199219
        },
        {
            "x": 0.16664591431617737,
            "y": 0.01761634647846222,
            "z": -395.2421569824219
        },
        {
            "x": 0.16682419180870056,
            "y": 0.01762285828590393,
            "z": -395.3993835449219
        },
        {
            "x": 0.16700252890586853,
            "y": 0.017629340291023254,
            "z": -395.5567321777344
        },
        {
            "x": 0.16718077659606934,
            "y": 0.017635777592658997,
            "z": -395.71392822265625
        },
        {
            "x": 0.16735920310020447,
            "y": 0.017642289400100708,
            "z": -395.8712463378906
        },
        {
            "x": 0.16753756999969482,
            "y": 0.017648756504058838,
            "z": -396.028564453125
        },
        {
            "x": 0.16771572828292847,
            "y": 0.01765526831150055,
            "z": -396.185791015625
        },
        {
            "x": 0.16789403557777405,
            "y": 0.017661720514297485,
            "z": -396.343017578125
        },
        {
            "x": 0.1680721938610077,
            "y": 0.017668217420578003,
            "z": -396.500244140625
        },
        {
            "x": 0.1682504117488861,
            "y": 0.017674729228019714,
            "z": -396.65753173828125
        },
        {
            "x": 0.16842889785766602,
            "y": 0.01768118143081665,
            "z": -396.8149108886719
        },
        {
            "x": 0.16860723495483398,
            "y": 0.017687663435935974,
            "z": -396.97216796875
        },
        {
            "x": 0.16878557205200195,
            "y": 0.01769416034221649,
            "z": -397.12939453125
        },
        {
            "x": 0.16896378993988037,
            "y": 0.01770065724849701,
            "z": -397.28668212890625
        },
        {
            "x": 0.1691420078277588,
            "y": 0.01770719885826111,
            "z": -397.4439697265625
        },
        {
            "x": 0.1693204641342163,
            "y": 0.017713606357574463,
            "z": -397.60137939453125
        },
        {
            "x": 0.1694987714290619,
            "y": 0.017720073461532593,
            "z": -397.75860595703125
        },
        {
            "x": 0.16967704892158508,
            "y": 0.01772657036781311,
            "z": -397.91583251953125
        },
        {
            "x": 0.16985532641410828,
            "y": 0.017733097076416016,
            "z": -398.07318115234375
        },
        {
            "x": 0.17003369331359863,
            "y": 0.01773950457572937,
            "z": -398.23040771484375
        },
        {
            "x": 0.1702120006084442,
            "y": 0.017745986580848694,
            "z": -398.38775634765625
        },
        {
            "x": 0.17039036750793457,
            "y": 0.017752498388290405,
            "z": -398.5450439453125
        },
        {
            "x": 0.170568585395813,
            "y": 0.017759069800376892,
            "z": -398.70233154296875
        },
        {
            "x": 0.17074689269065857,
            "y": 0.017765462398529053,
            "z": -398.8596496582031
        },
        {
            "x": 0.17092517018318176,
            "y": 0.017771944403648376,
            "z": -399.0168762207031
        },
        {
            "x": 0.17110350728034973,
            "y": 0.017778441309928894,
            "z": -399.17413330078125
        },
        {
            "x": 0.1712818145751953,
            "y": 0.01778501272201538,
            "z": -399.33154296875
        },
        {
            "x": 0.17146015167236328,
            "y": 0.017791375517845154,
            "z": -399.4887390136719
        },
        {
            "x": 0.17163845896720886,
            "y": 0.017797887325286865,
            "z": -399.64599609375
        },
        {
            "x": 0.1717572808265686,
            "y": 0.017802223563194275,
            "z": -399.75079345703125
        },
        {
            "x": 0.17193540930747986,
            "y": 0.017808660864830017,
            "z": -399.9080505371094
        },
        {
            "x": 0.172113835811615,
            "y": 0.017815157771110535,
            "z": -400.06536865234375
        },
        {
            "x": 0.17229220271110535,
            "y": 0.017821624875068665,
            "z": -400.22265625
        },
        {
            "x": 0.17247048020362854,
            "y": 0.01782819628715515,
            "z": -400.37994384765625
        },
        {
            "x": 0.17264878749847412,
            "y": 0.017834603786468506,
            "z": -400.5372619628906
        },
        {
            "x": 0.17282700538635254,
            "y": 0.017841070890426636,
            "z": -400.6944885253906
        },
        {
            "x": 0.17300540208816528,
            "y": 0.017847582697868347,
            "z": -400.85174560546875
        },
        {
            "x": 0.17318370938301086,
            "y": 0.017854109406471252,
            "z": -401.0091552734375
        },
        {
            "x": 0.17336201667785645,
            "y": 0.0178605318069458,
            "z": -401.1663818359375
        },
        {
            "x": 0.17354035377502441,
            "y": 0.01786699891090393,
            "z": -401.32366943359375
        },
        {
            "x": 0.17371866106987,
            "y": 0.017873555421829224,
            "z": -401.4809875488281
        },
        {
            "x": 0.1738969385623932,
            "y": 0.017880022525787354,
            "z": -401.63818359375
        },
        {
            "x": 0.17407527565956116,
            "y": 0.01788647472858429,
            "z": -401.7956237792969
        },
        {
            "x": 0.17425358295440674,
            "y": 0.017893001437187195,
            "z": -401.952880859375
        },
        {
            "x": 0.1744319498538971,
            "y": 0.01789945363998413,
            "z": -402.110107421875
        },
        {
            "x": 0.17461013793945312,
            "y": 0.017905905842781067,
            "z": -402.2674255371094
        },
        {
            "x": 0.17478850483894348,
            "y": 0.01791238784790039,
            "z": -402.4246520996094
        },
        {
            "x": 0.17496681213378906,
            "y": 0.017918884754180908,
            "z": -402.5820007324219
        },
        {
            "x": 0.1751452088356018,
            "y": 0.01792539656162262,
            "z": -402.73931884765625
        },
        {
            "x": 0.175323486328125,
            "y": 0.017931878566741943,
            "z": -402.8965759277344
        },
        {
            "x": 0.17550155520439148,
            "y": 0.01793833076953888,
            "z": -403.0538330078125
        },
        {
            "x": 0.1756799817085266,
            "y": 0.017944887280464172,
            "z": -403.2110595703125
        },
        {
            "x": 0.17585816979408264,
            "y": 0.017951279878616333,
            "z": -403.3682861328125
        },
        {
            "x": 0.17603668570518494,
            "y": 0.01795780658721924,
            "z": -403.5257263183594
        },
        {
            "x": 0.17621484398841858,
            "y": 0.017964258790016174,
            "z": -403.6829528808594
        },
        {
            "x": 0.17639315128326416,
            "y": 0.017970740795135498,
            "z": -403.8402404785156
        },
        {
            "x": 0.17657142877578735,
            "y": 0.017977282404899597,
            "z": -403.9975280761719
        },
        {
            "x": 0.17674964666366577,
            "y": 0.017983704805374146,
            "z": -404.1547546386719
        },
        {
            "x": 0.17692813277244568,
            "y": 0.017990201711654663,
            "z": -404.31219482421875
        },
        {
            "x": 0.17710646986961365,
            "y": 0.017996713519096375,
            "z": -404.46942138671875
        },
        {
            "x": 0.17728468775749207,
            "y": 0.018003195524215698,
            "z": -404.6266784667969
        },
        {
            "x": 0.17746296525001526,
            "y": 0.018009647727012634,
            "z": -404.7840270996094
        },
        {
            "x": 0.17764127254486084,
            "y": 0.018016114830970764,
            "z": -404.94122314453125
        },
        {
            "x": 0.17781969904899597,
            "y": 0.018022611737251282,
            "z": -405.0985412597656
        },
        {
            "x": 0.17799797654151917,
            "y": 0.01802915334701538,
            "z": -405.2558898925781
        },
        {
            "x": 0.17817628383636475,
            "y": 0.01803557574748993,
            "z": -405.4131164550781
        },
        {
            "x": 0.17835462093353271,
            "y": 0.018042072653770447,
            "z": -405.5704650878906
        },
        {
            "x": 0.1785328984260559,
            "y": 0.01804855465888977,
            "z": -405.7276916503906
        },
        {
            "x": 0.1787111461162567,
            "y": 0.0180550217628479,
            "z": -405.8849182128906
        },
        {
            "x": 0.17888963222503662,
            "y": 0.018061578273773193,
            "z": -406.0423889160156
        },
        {
            "x": 0.17906785011291504,
            "y": 0.018067970871925354,
            "z": -406.1995849609375
        },
        {
            "x": 0.17924809455871582,
            "y": 0.01807457208633423,
            "z": -406.3568115234375
        },
        {
            "x": 0.17936691641807556,
            "y": 0.018078863620758057,
            "z": -406.4616394042969
        },
        {
            "x": 0.17954516410827637,
            "y": 0.018085360527038574,
            "z": -406.6188659667969
        },
        {
            "x": 0.1797236204147339,
            "y": 0.018091842532157898,
            "z": -406.7762145996094
        },
        {
            "x": 0.17990192770957947,
            "y": 0.018098339438438416,
            "z": -406.93353271484375
        },
        {
            "x": 0.18008026480674744,
            "y": 0.018104836344718933,
            "z": -407.0907287597656
        },
        {
            "x": 0.18025848269462585,
            "y": 0.01811128854751587,
            "z": -407.24810791015625
        },
        {
            "x": 0.1804368495941162,
            "y": 0.01811780035495758,
            "z": -407.40533447265625
        },
        {
            "x": 0.18061494827270508,
            "y": 0.018124237656593323,
            "z": -407.56256103515625
        },
        {
            "x": 0.18079349398612976,
            "y": 0.018130749464035034,
            "z": -407.7200012207031
        },
        {
            "x": 0.18097171187400818,
            "y": 0.018137216567993164,
            "z": -407.8772277832031
        },
        {
            "x": 0.18115007877349854,
            "y": 0.018143728375434875,
            "z": -408.0345153808594
        },
        {
            "x": 0.18132835626602173,
            "y": 0.018150195479393005,
            "z": -408.1918029785156
        },
        {
            "x": 0.18150663375854492,
            "y": 0.018156692385673523,
            "z": -408.3490295410156
        },
        {
            "x": 0.18168506026268005,
            "y": 0.018163219094276428,
            "z": -408.5064697265625
        },
        {
            "x": 0.18186333775520325,
            "y": 0.018169626593589783,
            "z": -408.6636962890625
        },
        {
            "x": 0.18204152584075928,
            "y": 0.018176108598709106,
            "z": -408.8209228515625
        },
        {
            "x": 0.1822199523448944,
            "y": 0.01818263530731201,
            "z": -408.9782409667969
        },
        {
            "x": 0.1823980212211609,
            "y": 0.018189191818237305,
            "z": -409.135498046875
        },
        {
            "x": 0.18257653713226318,
            "y": 0.018195584416389465,
            "z": -409.2928466796875
        },
        {
            "x": 0.18275490403175354,
            "y": 0.01820206642150879,
            "z": -409.4501647949219
        },
        {
            "x": 0.18293309211730957,
            "y": 0.01820853352546692,
            "z": -409.6073913574219
        },
        {
            "x": 0.18311136960983276,
            "y": 0.01821504533290863,
            "z": -409.7646179199219
        },
        {
            "x": 0.18328970670700073,
            "y": 0.018221527338027954,
            "z": -409.921875
        },
        {
            "x": 0.18346792459487915,
            "y": 0.018227994441986084,
            "z": -410.0791015625
        },
        {
            "x": 0.18364626169204712,
            "y": 0.0182344913482666,
            "z": -410.2365417480469
        },
        {
            "x": 0.18382462859153748,
            "y": 0.018240973353385925,
            "z": -410.3937072753906
        },
        {
            "x": 0.18400287628173828,
            "y": 0.018247470259666443,
            "z": -410.551025390625
        },
        {
            "x": 0.18418118357658386,
            "y": 0.01825392246246338,
            "z": -410.70831298828125
        },
        {
            "x": 0.18435943126678467,
            "y": 0.01826043426990509,
            "z": -410.8655090332031
        },
        {
            "x": 0.1845378875732422,
            "y": 0.018266960978507996,
            "z": -411.0229797363281
        },
        {
            "x": 0.1847161054611206,
            "y": 0.018273383378982544,
            "z": -411.1802062988281
        },
        {
            "x": 0.1848944127559662,
            "y": 0.018279850482940674,
            "z": -411.33746337890625
        },
        {
            "x": 0.18507272005081177,
            "y": 0.01828637719154358,
            "z": -411.4947814941406
        },
        {
            "x": 0.18525108695030212,
            "y": 0.01829288899898529,
            "z": -411.6520080566406
        },
        {
            "x": 0.18542936444282532,
            "y": 0.018299296498298645,
            "z": -411.8093566894531
        },
        {
            "x": 0.18560773134231567,
            "y": 0.01830577850341797,
            "z": -411.9666748046875
        },
        {
            "x": 0.1857859194278717,
            "y": 0.018312305212020874,
            "z": -412.1239318847656
        },
        {
            "x": 0.18596428632736206,
            "y": 0.018318787217140198,
            "z": -412.2812194824219
        },
        {
            "x": 0.18614253401756287,
            "y": 0.01832522451877594,
            "z": -412.4384765625
        },
        {
            "x": 0.18632084131240845,
            "y": 0.018331751227378845,
            "z": -412.5957336425781
        },
        {
            "x": 0.18649929761886597,
            "y": 0.01833820343017578,
            "z": -412.7531433105469
        },
        {
            "x": 0.18667739629745483,
            "y": 0.018344789743423462,
            "z": -412.9103698730469
        },
        {
            "x": 0.18685591220855713,
            "y": 0.018351152539253235,
            "z": -413.067626953125
        },
        {
            "x": 0.1869746446609497,
            "y": 0.018355533480644226,
            "z": -413.17242431640625
        },
        {
            "x": 0.18715286254882812,
            "y": 0.018362000584602356,
            "z": -413.3296813964844
        },
        {
            "x": 0.18733125925064087,
            "y": 0.018368452787399292,
            "z": -413.4869689941406
        },
        {
            "x": 0.18750959634780884,
            "y": 0.01837494969367981,
            "z": -413.6443176269531
        },
        {
            "x": 0.18768787384033203,
            "y": 0.01838141679763794,
            "z": -413.8015441894531
        },
        {
            "x": 0.1878661811351776,
            "y": 0.01838800311088562,
            "z": -413.9588623046875
        },
        {
            "x": 0.1880444586277008,
            "y": 0.018394380807876587,
            "z": -414.1161193847656
        },
        {
            "x": 0.18822279572486877,
            "y": 0.018400847911834717,
            "z": -414.2733459472656
        },
        {
            "x": 0.18840119242668152,
            "y": 0.018407359719276428,
            "z": -414.4307556152344
        },
        {
            "x": 0.18857935070991516,
            "y": 0.018413901329040527,
            "z": -414.5879821777344
        },
        {
            "x": 0.18875765800476074,
            "y": 0.018420308828353882,
            "z": -414.7453308105469
        },
        {
            "x": 0.1889360547065735,
            "y": 0.018426820635795593,
            "z": -414.902587890625
        },
        {
            "x": 0.18911433219909668,
            "y": 0.01843331754207611,
            "z": -415.05987548828125
        },
        {
            "x": 0.18929263949394226,
            "y": 0.01843978464603424,
            "z": -415.21728515625
        },
        {
            "x": 0.18947100639343262,
            "y": 0.01844625174999237,
            "z": -415.37451171875
        },
        {
            "x": 0.18964922428131104,
            "y": 0.018452733755111694,
            "z": -415.53173828125
        },
        {
            "x": 0.189827561378479,
            "y": 0.018459215760231018,
            "z": -415.6890869140625
        },
        {
            "x": 0.19000592827796936,
            "y": 0.018465742468833923,
            "z": -415.8463134765625
        },
        {
            "x": 0.19018429517745972,
            "y": 0.018472179770469666,
            "z": -416.0036315917969
        },
        {
            "x": 0.19036254286766052,
            "y": 0.01847866177558899,
            "z": -416.16094970703125
        },
        {
            "x": 0.19054090976715088,
            "y": 0.0184851735830307,
            "z": -416.31817626953125
        },
        {
            "x": 0.19071906805038452,
            "y": 0.01849164068698883,
            "z": -416.47540283203125
        },
        {
            "x": 0.19089725613594055,
            "y": 0.018498092889785767,
            "z": -416.6326599121094
        },
        {
            "x": 0.1910756230354309,
            "y": 0.018504604697227478,
            "z": -416.7898864746094
        },
        {
            "x": 0.19125401973724365,
            "y": 0.01851111650466919,
            "z": -416.94732666015625
        },
        {
            "x": 0.19143226742744446,
            "y": 0.01851755380630493,
            "z": -417.10455322265625
        },
        {
            "x": 0.19161060452461243,
            "y": 0.018524035811424255,
            "z": -417.2618408203125
        },
        {
            "x": 0.19178888201713562,
            "y": 0.018530547618865967,
            "z": -417.41912841796875
        },
        {
            "x": 0.1919671893119812,
            "y": 0.018536999821662903,
            "z": -417.57635498046875
        },
        {
            "x": 0.19214558601379395,
            "y": 0.018543526530265808,
            "z": -417.7337951660156
        },
        {
            "x": 0.19232383370399475,
            "y": 0.01854996383190155,
            "z": -417.8910217285156
        },
        {
            "x": 0.19250205159187317,
            "y": 0.018556445837020874,
            "z": -418.0482482910156
        },
        {
            "x": 0.1926804482936859,
            "y": 0.018562927842140198,
            "z": -418.2055969238281
        },
        {
            "x": 0.1928587257862091,
            "y": 0.01856940984725952,
            "z": -418.36279296875
        },
        {
            "x": 0.19303706288337708,
            "y": 0.018575921654701233,
            "z": -418.5201416015625
        },
        {
            "x": 0.19321545958518982,
            "y": 0.018582388758659363,
            "z": -418.677490234375
        },
        {
            "x": 0.19339361786842346,
            "y": 0.018588900566101074,
            "z": -418.834716796875
        },
        {
            "x": 0.1935720145702362,
            "y": 0.018595397472381592,
            "z": -418.9920654296875
        },
        {
            "x": 0.1937503218650818,
            "y": 0.018601849675178528,
            "z": -419.1492919921875
        },
        {
            "x": 0.19392859935760498,
            "y": 0.018608346581459045,
            "z": -419.3065185546875
        },
        {
            "x": 0.1941070556640625,
            "y": 0.018614813685417175,
            "z": -419.46392822265625
        },
        {
            "x": 0.1942853331565857,
            "y": 0.018621385097503662,
            "z": -419.62115478515625
        },
        {
            "x": 0.1944635510444641,
            "y": 0.01862776279449463,
            "z": -419.7784118652344
        }
    ]
    },
    "level2":{
        "lane1":[
            {
                "x": -0.14102429151535034,
                "y": 0.00840863585472107,
                "z": -419.5832214355469
            },
            {
                "x": -0.1411430835723877,
                "y": 0.008403576910495758,
                "z": -419.4783630371094
            },
            {
                "x": -0.1413213014602661,
                "y": 0.008395969867706299,
                "z": -419.3211669921875
            },
            {
                "x": -0.1414996087551117,
                "y": 0.008388355374336243,
                "z": -419.1638488769531
            },
            {
                "x": -0.14167794585227966,
                "y": 0.00838075578212738,
                "z": -419.0065002441406
            },
            {
                "x": -0.1418561041355133,
                "y": 0.008373156189918518,
                "z": -418.8492736816406
            },
            {
                "x": -0.1420344114303589,
                "y": 0.008365549147129059,
                "z": -418.69189453125
            },
            {
                "x": -0.1422126293182373,
                "y": 0.008357949554920197,
                "z": -418.5346984863281
            },
            {
                "x": -0.1423908770084381,
                "y": 0.008350342512130737,
                "z": -418.3774719238281
            },
            {
                "x": -0.14256921410560608,
                "y": 0.008342735469341278,
                "z": -418.2200012207031
            },
            {
                "x": -0.1427474319934845,
                "y": 0.008335128426551819,
                "z": -418.06280517578125
            },
            {
                "x": -0.14292573928833008,
                "y": 0.008327536284923553,
                "z": -417.905517578125
            },
            {
                "x": -0.14310398697853088,
                "y": 0.008319929242134094,
                "z": -417.74822998046875
            },
            {
                "x": -0.1432822346687317,
                "y": 0.008312322199344635,
                "z": -417.5910339355469
            },
            {
                "x": -0.14346063137054443,
                "y": 0.008304700255393982,
                "z": -417.4335632324219
            },
            {
                "x": -0.14363887906074524,
                "y": 0.00829710066318512,
                "z": -417.2763366699219
            },
            {
                "x": -0.14381703734397888,
                "y": 0.008289508521556854,
                "z": -417.1191101074219
            },
            {
                "x": -0.14399534463882446,
                "y": 0.008281894028186798,
                "z": -416.9617614746094
            },
            {
                "x": -0.14417359232902527,
                "y": 0.008274294435977936,
                "z": -416.8045349121094
            },
            {
                "x": -0.14435186982154846,
                "y": 0.008266694843769073,
                "z": -416.647216796875
            },
            {
                "x": -0.14453017711639404,
                "y": 0.008259095251560211,
                "z": -416.4898681640625
            },
            {
                "x": -0.14470842480659485,
                "y": 0.008251480758190155,
                "z": -416.3326721191406
            },
            {
                "x": -0.1448865830898285,
                "y": 0.00824388861656189,
                "z": -416.1754150390625
            },
            {
                "x": -0.14506477117538452,
                "y": 0.008236289024353027,
                "z": -416.0181884765625
            },
            {
                "x": -0.14524301886558533,
                "y": 0.008228681981563568,
                "z": -415.8609619140625
            },
            {
                "x": -0.14542141556739807,
                "y": 0.008221067488193512,
                "z": -415.7035217285156
            },
            {
                "x": -0.1455996036529541,
                "y": 0.008213460445404053,
                "z": -415.5462951660156
            },
            {
                "x": -0.1457778811454773,
                "y": 0.00820586085319519,
                "z": -415.3890075683594
            },
            {
                "x": -0.1459560990333557,
                "y": 0.008198253810405731,
                "z": -415.2317199707031
            },
            {
                "x": -0.14613434672355652,
                "y": 0.008190654218196869,
                "z": -415.0744934082031
            },
            {
                "x": -0.14631271362304688,
                "y": 0.00818304717540741,
                "z": -414.9170227050781
            },
            {
                "x": -0.14649102091789246,
                "y": 0.00817544013261795,
                "z": -414.7598571777344
            },
            {
                "x": -0.1466691493988037,
                "y": 0.008167825639247894,
                "z": -414.60260009765625
            },
            {
                "x": -0.1468474566936493,
                "y": 0.008160233497619629,
                "z": -414.4452819824219
            },
            {
                "x": -0.1470256745815277,
                "y": 0.008152619004249573,
                "z": -414.28802490234375
            },
            {
                "x": -0.14720401167869568,
                "y": 0.00814501941204071,
                "z": -414.13067626953125
            },
            {
                "x": -0.14738231897354126,
                "y": 0.008137404918670654,
                "z": -413.9733581542969
            },
            {
                "x": -0.1475605070590973,
                "y": 0.008129812777042389,
                "z": -413.8161315917969
            },
            {
                "x": -0.14773881435394287,
                "y": 0.008122198283672333,
                "z": -413.6587829589844
            },
            {
                "x": -0.1479170322418213,
                "y": 0.00811459869146347,
                "z": -413.5015563964844
            },
            {
                "x": -0.1480952799320221,
                "y": 0.008106991648674011,
                "z": -413.3443298339844
            },
            {
                "x": -0.14827361702919006,
                "y": 0.008099399507045746,
                "z": -413.1868591308594
            },
            {
                "x": -0.14845189452171326,
                "y": 0.008091777563095093,
                "z": -413.0296936035156
            },
            {
                "x": -0.1486300826072693,
                "y": 0.00808417797088623,
                "z": -412.8724365234375
            },
            {
                "x": -0.14874622225761414,
                "y": 0.008079230785369873,
                "z": -412.7708435058594
            },
            {
                "x": -0.14892438054084778,
                "y": 0.008071623742580414,
                "z": -412.6136169433594
            },
            {
                "x": -0.14910271763801575,
                "y": 0.008064024150371552,
                "z": -412.456298828125
            },
            {
                "x": -0.14928102493286133,
                "y": 0.008056417107582092,
                "z": -412.2989196777344
            },
            {
                "x": -0.14945924282073975,
                "y": 0.008048810064792633,
                "z": -412.1417236328125
            },
            {
                "x": -0.14963755011558533,
                "y": 0.008041203022003174,
                "z": -411.9843444824219
            },
            {
                "x": -0.14981573820114136,
                "y": 0.008033603429794312,
                "z": -411.8271179199219
            },
            {
                "x": -0.14999398589134216,
                "y": 0.00802600383758545,
                "z": -411.6698913574219
            },
            {
                "x": -0.1501724123954773,
                "y": 0.008018389344215393,
                "z": -411.5124816894531
            },
            {
                "x": -0.1503506302833557,
                "y": 0.00801078975200653,
                "z": -411.3552551269531
            },
            {
                "x": -0.15052884817123413,
                "y": 0.008003175258636475,
                "z": -411.1979675292969
            },
            {
                "x": -0.15070703625679016,
                "y": 0.007995575666427612,
                "z": -411.0406799316406
            },
            {
                "x": -0.15088534355163574,
                "y": 0.00798797607421875,
                "z": -410.8834533691406
            },
            {
                "x": -0.1510637104511261,
                "y": 0.007980361580848694,
                "z": -410.7260437011719
            },
            {
                "x": -0.1512419581413269,
                "y": 0.007972761988639832,
                "z": -410.56878662109375
            },
            {
                "x": -0.15142014622688293,
                "y": 0.007965169847011566,
                "z": -410.4115905761719
            },
            {
                "x": -0.15159845352172852,
                "y": 0.00795755535364151,
                "z": -410.25421142578125
            },
            {
                "x": -0.15177670121192932,
                "y": 0.00794994831085205,
                "z": -410.09698486328125
            },
            {
                "x": -0.15195497870445251,
                "y": 0.007942348718643188,
                "z": -409.9396667480469
            },
            {
                "x": -0.1521332859992981,
                "y": 0.007934749126434326,
                "z": -409.7823181152344
            },
            {
                "x": -0.1523115336894989,
                "y": 0.007927142083644867,
                "z": -409.6250915527344
            },
            {
                "x": -0.15248966217041016,
                "y": 0.007919542491436005,
                "z": -409.4678649902344
            },
            {
                "x": -0.1526678502559662,
                "y": 0.00791195034980774,
                "z": -409.3106384277344
            },
            {
                "x": -0.1528460681438446,
                "y": 0.007904335856437683,
                "z": -409.1534118652344
            },
            {
                "x": -0.15302452445030212,
                "y": 0.007896728813648224,
                "z": -408.9959716796875
            },
            {
                "x": -0.15320274233818054,
                "y": 0.007889129221439362,
                "z": -408.8387451171875
            },
            {
                "x": -0.15338096022605896,
                "y": 0.007881522178649902,
                "z": -408.68145751953125
            },
            {
                "x": -0.15355920791625977,
                "y": 0.00787392258644104,
                "z": -408.524169921875
            },
            {
                "x": -0.15373745560646057,
                "y": 0.00786631554365158,
                "z": -408.366943359375
            },
            {
                "x": -0.15391585230827332,
                "y": 0.007858701050281525,
                "z": -408.20947265625
            },
            {
                "x": -0.15409409999847412,
                "y": 0.007851101458072662,
                "z": -408.05224609375
            },
            {
                "x": -0.15427225828170776,
                "y": 0.0078435018658638,
                "z": -407.89501953125
            },
            {
                "x": -0.15445053577423096,
                "y": 0.00783589482307434,
                "z": -407.7376708984375
            },
            {
                "x": -0.15462875366210938,
                "y": 0.007828295230865479,
                "z": -407.5804443359375
            },
            {
                "x": -0.15480712056159973,
                "y": 0.007820673286914825,
                "z": -407.423095703125
            },
            {
                "x": -0.15498539805412292,
                "y": 0.00781308114528656,
                "z": -407.2657470703125
            },
            {
                "x": -0.15516358613967896,
                "y": 0.007805481553077698,
                "z": -407.1085510253906
            },
            {
                "x": -0.15534192323684692,
                "y": 0.007797867059707642,
                "z": -406.9512023925781
            },
            {
                "x": -0.15552014112472534,
                "y": 0.007790267467498779,
                "z": -406.7939758300781
            },
            {
                "x": -0.15569835901260376,
                "y": 0.007782667875289917,
                "z": -406.6367492675781
            },
            {
                "x": -0.15587672591209412,
                "y": 0.007775053381919861,
                "z": -406.47930908203125
            },
            {
                "x": -0.15605497360229492,
                "y": 0.0077674612402915955,
                "z": -406.32208251953125
            },
            {
                "x": -0.15623319149017334,
                "y": 0.007759846746921539,
                "z": -406.16485595703125
            },
            {
                "x": -0.1563493311405182,
                "y": 0.007754899561405182,
                "z": -406.0632629394531
            },
            {
                "x": -0.1565275490283966,
                "y": 0.00774729996919632,
                "z": -405.90606689453125
            },
            {
                "x": -0.1567057967185974,
                "y": 0.00773969292640686,
                "z": -405.74871826171875
            },
            {
                "x": -0.15688413381576538,
                "y": 0.007732085883617401,
                "z": -405.59136962890625
            },
            {
                "x": -0.1570623815059662,
                "y": 0.007724478840827942,
                "z": -405.43414306640625
            },
            {
                "x": -0.15724068880081177,
                "y": 0.007716871798038483,
                "z": -405.27679443359375
            },
            {
                "x": -0.15741881728172302,
                "y": 0.00770927220582962,
                "z": -405.11956787109375
            },
            {
                "x": -0.15759709477424622,
                "y": 0.007701672613620758,
                "z": -404.96234130859375
            },
            {
                "x": -0.15777546167373657,
                "y": 0.007694061845541,
                "z": -404.8049011230469
            },
            {
                "x": -0.15795370936393738,
                "y": 0.007686462253332138,
                "z": -404.64764404296875
            },
            {
                "x": -0.1581319272518158,
                "y": 0.007678855210542679,
                "z": -404.4903564453125
            },
            {
                "x": -0.158310204744339,
                "y": 0.0076712556183338165,
                "z": -404.3330993652344
            },
            {
                "x": -0.1584884524345398,
                "y": 0.007663648575544357,
                "z": -404.1758728027344
            },
            {
                "x": -0.15866681933403015,
                "y": 0.0076560452580451965,
                "z": -404.0184326171875
            },
            {
                "x": -0.15884506702423096,
                "y": 0.007648434489965439,
                "z": -403.8612060546875
            },
            {
                "x": -0.1590232253074646,
                "y": 0.007640838623046875,
                "z": -403.7039794921875
            },
            {
                "x": -0.15920156240463257,
                "y": 0.007633224129676819,
                "z": -403.546630859375
            },
            {
                "x": -0.159379780292511,
                "y": 0.007625635713338852,
                "z": -403.389404296875
            },
            {
                "x": -0.15955808758735657,
                "y": 0.007618021219968796,
                "z": -403.23211669921875
            },
            {
                "x": -0.15973636507987976,
                "y": 0.0076104141771793365,
                "z": -403.0747375488281
            },
            {
                "x": -0.15991464257240295,
                "y": 0.007602807134389877,
                "z": -402.91754150390625
            },
            {
                "x": -0.1600928008556366,
                "y": 0.0075952112674713135,
                "z": -402.76031494140625
            },
            {
                "x": -0.16027098894119263,
                "y": 0.007587607949972153,
                "z": -402.60308837890625
            },
            {
                "x": -0.16044920682907104,
                "y": 0.00758000835776329,
                "z": -402.4458312988281
            },
            {
                "x": -0.1606276035308838,
                "y": 0.007572401314973831,
                "z": -402.28839111328125
            },
            {
                "x": -0.1608058214187622,
                "y": 0.00756479799747467,
                "z": -402.1311950683594
            },
            {
                "x": -0.160984069108963,
                "y": 0.00755719467997551,
                "z": -401.973876953125
            },
            {
                "x": -0.16116231679916382,
                "y": 0.00754958763718605,
                "z": -401.81658935546875
            },
            {
                "x": -0.16134056448936462,
                "y": 0.00754198431968689,
                "z": -401.6593933105469
            },
            {
                "x": -0.16151893138885498,
                "y": 0.00753437727689743,
                "z": -401.501953125
            },
            {
                "x": -0.16169720888137817,
                "y": 0.007526770234107971,
                "z": -401.3447265625
            },
            {
                "x": -0.16187536716461182,
                "y": 0.007519163191318512,
                "z": -401.1875
            },
            {
                "x": -0.1620536744594574,
                "y": 0.007511559873819351,
                "z": -401.0301208496094
            },
            {
                "x": -0.16223189234733582,
                "y": 0.007503952831029892,
                "z": -400.8729248046875
            },
            {
                "x": -0.1624101996421814,
                "y": 0.00749635323882103,
                "z": -400.715576171875
            },
            {
                "x": -0.1625884771347046,
                "y": 0.007488749921321869,
                "z": -400.5582275390625
            },
            {
                "x": -0.1627667248249054,
                "y": 0.00748114287853241,
                "z": -400.4010009765625
            },
            {
                "x": -0.16294506192207336,
                "y": 0.007473543286323547,
                "z": -400.24371337890625
            },
            {
                "x": -0.163123220205307,
                "y": 0.007465943694114685,
                "z": -400.0864562988281
            },
            {
                "x": -0.1633014678955078,
                "y": 0.007458332926034927,
                "z": -399.9292297363281
            },
            {
                "x": -0.16347983479499817,
                "y": 0.007450725883245468,
                "z": -399.77178955078125
            },
            {
                "x": -0.16365808248519897,
                "y": 0.007443122565746307,
                "z": -399.61456298828125
            },
            {
                "x": -0.163836270570755,
                "y": 0.007435519248247147,
                "z": -399.45733642578125
            },
            {
                "x": -0.16395241022109985,
                "y": 0.007430572062730789,
                "z": -399.3557434082031
            },
            {
                "x": -0.16413059830665588,
                "y": 0.00742296501994133,
                "z": -399.1985168457031
            },
            {
                "x": -0.16430887579917908,
                "y": 0.007415365427732468,
                "z": -399.04119873046875
            },
            {
                "x": -0.16448724269866943,
                "y": 0.00740775465965271,
                "z": -398.88385009765625
            },
            {
                "x": -0.16466546058654785,
                "y": 0.007400147616863251,
                "z": -398.72662353515625
            },
            {
                "x": -0.16484376788139343,
                "y": 0.007392548024654388,
                "z": -398.56927490234375
            },
            {
                "x": -0.16502192616462708,
                "y": 0.007384940981864929,
                "z": -398.41204833984375
            },
            {
                "x": -0.16520023345947266,
                "y": 0.007377348840236664,
                "z": -398.25482177734375
            },
            {
                "x": -0.16537857055664062,
                "y": 0.007369723170995712,
                "z": -398.0973815917969
            },
            {
                "x": -0.16555684804916382,
                "y": 0.00736212357878685,
                "z": -397.9401550292969
            },
            {
                "x": -0.16573506593704224,
                "y": 0.007354523986577988,
                "z": -397.7828674316406
            },
            {
                "x": -0.16591328382492065,
                "y": 0.007346924394369125,
                "z": -397.6255798339844
            },
            {
                "x": -0.16609153151512146,
                "y": 0.007339324802160263,
                "z": -397.46832275390625
            },
            {
                "x": -0.1662699282169342,
                "y": 0.0073317065834999084,
                "z": -397.3109130859375
            },
            {
                "x": -0.16644814610481262,
                "y": 0.007324095815420151,
                "z": -397.1536865234375
            },
            {
                "x": -0.16662636399269104,
                "y": 0.007316499948501587,
                "z": -396.9964599609375
            },
            {
                "x": -0.16680464148521423,
                "y": 0.007308892905712128,
                "z": -396.839111328125
            },
            {
                "x": -0.16698288917541504,
                "y": 0.007301293313503265,
                "z": -396.681884765625
            },
            {
                "x": -0.16716116666793823,
                "y": 0.007293689996004105,
                "z": -396.5245666503906
            },
            {
                "x": -0.1673395037651062,
                "y": 0.007286079227924347,
                "z": -396.3671875
            },
            {
                "x": -0.16751769185066223,
                "y": 0.007278483361005783,
                "z": -396.2099609375
            },
            {
                "x": -0.16769587993621826,
                "y": 0.007270880043506622,
                "z": -396.052734375
            },
            {
                "x": -0.16787409782409668,
                "y": 0.00726328045129776,
                "z": -395.8955078125
            },
            {
                "x": -0.1680523157119751,
                "y": 0.007255673408508301,
                "z": -395.73828125
            },
            {
                "x": -0.16823071241378784,
                "y": 0.007248062640428543,
                "z": -395.5809020996094
            },
            {
                "x": -0.16840896010398865,
                "y": 0.007240459322929382,
                "z": -395.4236755371094
            },
            {
                "x": -0.16858723759651184,
                "y": 0.0072328634560108185,
                "z": -395.26641845703125
            },
            {
                "x": -0.16876551508903503,
                "y": 0.007225252687931061,
                "z": -395.109130859375
            },
            {
                "x": -0.16894370317459106,
                "y": 0.0072176456451416016,
                "z": -394.95184326171875
            },
            {
                "x": -0.16912207007408142,
                "y": 0.007210042327642441,
                "z": -394.79443359375
            },
            {
                "x": -0.16930031776428223,
                "y": 0.00720243901014328,
                "z": -394.63720703125
            },
            {
                "x": -0.16947856545448303,
                "y": 0.007194839417934418,
                "z": -394.47998046875
            },
            {
                "x": -0.16965684294700623,
                "y": 0.007187236100435257,
                "z": -394.3226318359375
            },
            {
                "x": -0.16983503103256226,
                "y": 0.007179640233516693,
                "z": -394.1654052734375
            },
            {
                "x": -0.17001336812973022,
                "y": 0.0071720220148563385,
                "z": -394.008056640625
            },
            {
                "x": -0.1701916754245758,
                "y": 0.007164418697357178,
                "z": -393.8507385253906
            },
            {
                "x": -0.17036989331245422,
                "y": 0.007156815379858017,
                "z": -393.6935119628906
            },
            {
                "x": -0.1705482006072998,
                "y": 0.007149215787649155,
                "z": -393.5361633300781
            },
            {
                "x": -0.17072641849517822,
                "y": 0.007141605019569397,
                "z": -393.37896728515625
            },
            {
                "x": -0.17090460658073425,
                "y": 0.007134005427360535,
                "z": -393.22174072265625
            },
            {
                "x": -0.171083003282547,
                "y": 0.007126394659280777,
                "z": -393.06427001953125
            },
            {
                "x": -0.17126122117042542,
                "y": 0.007118787616491318,
                "z": -392.90704345703125
            },
            {
                "x": -0.17143943905830383,
                "y": 0.0071111880242824554,
                "z": -392.74981689453125
            },
            {
                "x": -0.1715555489063263,
                "y": 0.0071062371134757996,
                "z": -392.6482238769531
            },
            {
                "x": -0.1717337667942047,
                "y": 0.007098633795976639,
                "z": -392.49102783203125
            },
            {
                "x": -0.1719120442867279,
                "y": 0.0070910267531871796,
                "z": -392.33367919921875
            },
            {
                "x": -0.17209038138389587,
                "y": 0.007083415985107422,
                "z": -392.1763610839844
            },
            {
                "x": -0.1722685992717743,
                "y": 0.007075812667608261,
                "z": -392.0191345214844
            },
            {
                "x": -0.17244693636894226,
                "y": 0.007068213075399399,
                "z": -391.8617858886719
            },
            {
                "x": -0.1726250946521759,
                "y": 0.007060609757900238,
                "z": -391.7045593261719
            },
            {
                "x": -0.1728033423423767,
                "y": 0.007053006440401077,
                "z": -391.5473327636719
            },
            {
                "x": -0.17298170924186707,
                "y": 0.0070454031229019165,
                "z": -391.389892578125
            },
            {
                "x": -0.17315992712974548,
                "y": 0.007037799805402756,
                "z": -391.232666015625
            },
            {
                "x": -0.17333820462226868,
                "y": 0.0070301927626132965,
                "z": -391.07537841796875
            },
            {
                "x": -0.17351645231246948,
                "y": 0.007022589445114136,
                "z": -390.9180908203125
            },
            {
                "x": -0.1736946702003479,
                "y": 0.0070149824023246765,
                "z": -390.7608642578125
            },
            {
                "x": -0.17387309670448303,
                "y": 0.007007382810115814,
                "z": -390.6034240722656
            },
            {
                "x": -0.17405128479003906,
                "y": 0.006999775767326355,
                "z": -390.4461669921875
            },
            {
                "x": -0.1742294728755951,
                "y": 0.006992172449827194,
                "z": -390.2889709472656
            },
            {
                "x": -0.17440780997276306,
                "y": 0.0069845616817474365,
                "z": -390.1316223144531
            },
            {
                "x": -0.17458602786064148,
                "y": 0.006976965814828873,
                "z": -389.9743957519531
            },
            {
                "x": -0.17476430535316467,
                "y": 0.006969362497329712,
                "z": -389.81707763671875
            },
            {
                "x": -0.17494264245033264,
                "y": 0.006961748003959656,
                "z": -389.65972900390625
            },
            {
                "x": -0.17512086033821106,
                "y": 0.006954152137041092,
                "z": -389.50250244140625
            },
            {
                "x": -0.1752990186214447,
                "y": 0.006946556270122528,
                "z": -389.34527587890625
            },
            {
                "x": -0.17547723650932312,
                "y": 0.006938952952623367,
                "z": -389.18804931640625
            },
            {
                "x": -0.17565545439720154,
                "y": 0.006931334733963013,
                "z": -389.03082275390625
            },
            {
                "x": -0.17583385109901428,
                "y": 0.0069237276911735535,
                "z": -388.8733825683594
            },
            {
                "x": -0.1760120689868927,
                "y": 0.00691613182425499,
                "z": -388.7161560058594
            },
            {
                "x": -0.1761903464794159,
                "y": 0.00690852478146553,
                "z": -388.5588684082031
            },
            {
                "x": -0.1763685941696167,
                "y": 0.006900925189256668,
                "z": -388.4015808105469
            },
            {
                "x": -0.17654678225517273,
                "y": 0.006893318146467209,
                "z": -388.2443542480469
            },
            {
                "x": -0.17672517895698547,
                "y": 0.006885714828968048,
                "z": -388.0869140625
            },
            {
                "x": -0.17690342664718628,
                "y": 0.006878111511468887,
                "z": -387.9296875
            },
            {
                "x": -0.1770816445350647,
                "y": 0.006870504468679428,
                "z": -387.7724609375
            },
            {
                "x": -0.1772599220275879,
                "y": 0.006862901151180267,
                "z": -387.6151123046875
            },
            {
                "x": -0.1774381399154663,
                "y": 0.0068553052842617035,
                "z": -387.4578857421875
            },
            {
                "x": -0.17761650681495667,
                "y": 0.006847694516181946,
                "z": -387.300537109375
            },
            {
                "x": -0.17779475450515747,
                "y": 0.00684008002281189,
                "z": -387.1431884765625
            },
            {
                "x": -0.17797300219535828,
                "y": 0.006832476705312729,
                "z": -386.9859924316406
            },
            {
                "x": -0.17815130949020386,
                "y": 0.006824877113103867,
                "z": -386.8286437988281
            },
            {
                "x": -0.1783294975757599,
                "y": 0.006817277520895004,
                "z": -386.6714172363281
            },
            {
                "x": -0.1785077154636383,
                "y": 0.0068096742033958435,
                "z": -386.5141906738281
            },
            {
                "x": -0.17868611216545105,
                "y": 0.006802059710025787,
                "z": -386.35675048828125
            },
            {
                "x": -0.17886435985565186,
                "y": 0.006794456392526627,
                "z": -386.19952392578125
            },
            {
                "x": -0.17904254794120789,
                "y": 0.006786853075027466,
                "z": -386.04229736328125
            },
            {
                "x": -0.17915868759155273,
                "y": 0.006781913340091705,
                "z": -385.94073486328125
            },
            {
                "x": -0.17933687567710876,
                "y": 0.006774298846721649,
                "z": -385.78350830078125
            },
            {
                "x": -0.17951515316963196,
                "y": 0.006766699254512787,
                "z": -385.62615966796875
            },
            {
                "x": -0.17969346046447754,
                "y": 0.006759088486433029,
                "z": -385.46881103515625
            },
            {
                "x": -0.17987170815467834,
                "y": 0.006751485168933868,
                "z": -385.31158447265625
            },
            {
                "x": -0.18005001544952393,
                "y": 0.006743881851434708,
                "z": -385.15423583984375
            },
            {
                "x": -0.18022820353507996,
                "y": 0.006736274808645248,
                "z": -384.99700927734375
            },
            {
                "x": -0.18040645122528076,
                "y": 0.006728678941726685,
                "z": -384.83978271484375
            },
            {
                "x": -0.18058481812477112,
                "y": 0.00672106072306633,
                "z": -384.682373046875
            },
            {
                "x": -0.1807630956172943,
                "y": 0.006713457405567169,
                "z": -384.52508544921875
            },
            {
                "x": -0.18094131350517273,
                "y": 0.006705872714519501,
                "z": -384.3677978515625
            },
            {
                "x": -0.18111956119537354,
                "y": 0.006698254495859146,
                "z": -384.21051025390625
            },
            {
                "x": -0.18129777908325195,
                "y": 0.006690651178359985,
                "z": -384.05328369140625
            },
            {
                "x": -0.1814761757850647,
                "y": 0.006683044135570526,
                "z": -383.8958435058594
            },
            {
                "x": -0.1816544234752655,
                "y": 0.006675440818071365,
                "z": -383.7386169433594
            },
            {
                "x": -0.18183264136314392,
                "y": 0.006667826324701309,
                "z": -383.5813903808594
            },
            {
                "x": -0.18201091885566711,
                "y": 0.006660234183073044,
                "z": -383.4240417480469
            },
            {
                "x": -0.18218913674354553,
                "y": 0.006652630865573883,
                "z": -383.2668151855469
            },
            {
                "x": -0.18236741423606873,
                "y": 0.006645031273365021,
                "z": -383.1094970703125
            },
            {
                "x": -0.18254569172859192,
                "y": 0.006637420505285263,
                "z": -382.9521179199219
            },
            {
                "x": -0.18272393941879272,
                "y": 0.006629817187786102,
                "z": -382.7949523925781
            },
            {
                "x": -0.18290212750434875,
                "y": 0.0066222138702869415,
                "z": -382.6376953125
            },
            {
                "x": -0.18308034539222717,
                "y": 0.006614614278078079,
                "z": -382.48046875
            },
            {
                "x": -0.18325859308242798,
                "y": 0.006607018411159515,
                "z": -382.3232727050781
            },
            {
                "x": -0.18343695998191833,
                "y": 0.006599396467208862,
                "z": -382.1658020019531
            },
            {
                "x": -0.18361513316631317,
                "y": 0.006591796875,
                "z": -382.0085754394531
            },
            {
                "x": -0.18379341065883636,
                "y": 0.006584193557500839,
                "z": -381.8512878417969
            },
            {
                "x": -0.18397167325019836,
                "y": 0.0065765902400016785,
                "z": -381.6940002441406
            },
            {
                "x": -0.18414989113807678,
                "y": 0.006568990647792816,
                "z": -381.5367736816406
            },
            {
                "x": -0.18432824313640594,
                "y": 0.0065613798797130585,
                "z": -381.37933349609375
            },
            {
                "x": -0.18450649082660675,
                "y": 0.006553776562213898,
                "z": -381.22210693359375
            },
            {
                "x": -0.18468467891216278,
                "y": 0.006546173244714737,
                "z": -381.0648498535156
            },
            {
                "x": -0.18486297130584717,
                "y": 0.006538569927215576,
                "z": -380.90753173828125
            },
            {
                "x": -0.1850409358739853,
                "y": 0.006530966609716415,
                "z": -380.75030517578125
            },
            {
                "x": -0.18521921336650848,
                "y": 0.006523367017507553,
                "z": -380.59295654296875
            },
            {
                "x": -0.185397669672966,
                "y": 0.006515759974718094,
                "z": -380.4356384277344
            },
            {
                "x": -0.1855754554271698,
                "y": 0.006508156657218933,
                "z": -380.2784118652344
            },
            {
                "x": -0.18575146794319153,
                "y": 0.006500553339719772,
                "z": -380.1210632324219
            },
            {
                "x": -0.18592558801174164,
                "y": 0.006492946296930313,
                "z": -379.9638366699219
            },
            {
                "x": -0.18610192835330963,
                "y": 0.006485350430011749,
                "z": -379.8066101074219
            },
            {
                "x": -0.18627695739269257,
                "y": 0.006477735936641693,
                "z": -379.6492004394531
            },
            {
                "x": -0.18644024431705475,
                "y": 0.006470121443271637,
                "z": -379.4919738769531
            },
            {
                "x": -0.18658564984798431,
                "y": 0.006462542340159416,
                "z": -379.3348083496094
            },
            {
                "x": -0.18667559325695038,
                "y": 0.006457570940256119,
                "z": -379.2331848144531
            },
            {
                "x": -0.18681970238685608,
                "y": 0.006449975073337555,
                "z": -379.0759582519531
            },
            {
                "x": -0.18694324791431427,
                "y": 0.006442353129386902,
                "z": -378.9187316894531
            },
            {
                "x": -0.18700042366981506,
                "y": 0.0064347535371780396,
                "z": -378.76153564453125
            },
            {
                "x": -0.18697230517864227,
                "y": 0.006427150219678879,
                "z": -378.60443115234375
            },
            {
                "x": -0.1868978589773178,
                "y": 0.006419524550437927,
                "z": -378.4471130371094
            },
            {
                "x": -0.18679030239582062,
                "y": 0.0064119137823581696,
                "z": -378.2900085449219
            },
            {
                "x": -0.18653523921966553,
                "y": 0.006404366344213486,
                "z": -378.1331481933594
            },
            {
                "x": -0.18604235351085663,
                "y": 0.006396729499101639,
                "z": -377.9761047363281
            },
            {
                "x": -0.18532174825668335,
                "y": 0.006389137357473373,
                "z": -377.8191833496094
            },
            {
                "x": -0.1844644397497177,
                "y": 0.006381537765264511,
                "z": -377.6621398925781
            },
            {
                "x": -0.183383971452713,
                "y": 0.006373938173055649,
                "z": -377.50543212890625
            },
            {
                "x": -0.18192167580127716,
                "y": 0.0063663050532341,
                "z": -377.3489074707031
            },
            {
                "x": -0.18004541099071503,
                "y": 0.006358705461025238,
                "z": -377.1921081542969
            },
            {
                "x": -0.177857905626297,
                "y": 0.006351135671138763,
                "z": -377.0352478027344
            },
            {
                "x": -0.17540296912193298,
                "y": 0.006343521177768707,
                "z": -376.878662109375
            },
            {
                "x": -0.1725035011768341,
                "y": 0.006335914134979248,
                "z": -376.7221984863281
            },
            {
                "x": -0.16907602548599243,
                "y": 0.006328266113996506,
                "z": -376.56591796875
            },
            {
                "x": -0.1652035117149353,
                "y": 0.006320692598819733,
                "z": -376.40924072265625
            },
            {
                "x": -0.1610490083694458,
                "y": 0.006313089281320572,
                "z": -376.25244140625
            },
            {
                "x": -0.1565190851688385,
                "y": 0.0063055045902729034,
                "z": -376.09613037109375
            },
            {
                "x": -0.15144330263137817,
                "y": 0.00629788264632225,
                "z": -375.9399108886719
            },
            {
                "x": -0.14581412076950073,
                "y": 0.0062902942299842834,
                "z": -375.7835693359375
            },
            {
                "x": -0.1398339867591858,
                "y": 0.006282690912485123,
                "z": -375.6269836425781
            },
            {
                "x": -0.13355883955955505,
                "y": 0.006275072693824768,
                "z": -375.4703063964844
            },
            {
                "x": -0.12683996558189392,
                "y": 0.006267465651035309,
                "z": -375.3140869140625
            },
            {
                "x": -0.1195271909236908,
                "y": 0.006259862333536148,
                "z": -375.1579284667969
            },
            {
                "x": -0.11174485087394714,
                "y": 0.006252255290746689,
                "z": -375.00146484375
            },
            {
                "x": -0.10367724299430847,
                "y": 0.006244666874408722,
                "z": -374.8448486328125
            },
            {
                "x": -0.095272958278656,
                "y": 0.006237044930458069,
                "z": -374.68841552734375
            },
            {
                "x": -0.08635208010673523,
                "y": 0.006229456514120102,
                "z": -374.5324401855469
            },
            {
                "x": -0.07688325643539429,
                "y": 0.006221838295459747,
                "z": -374.3762512207031
            },
            {
                "x": -0.06701898574829102,
                "y": 0.006214268505573273,
                "z": -374.2196960449219
            },
            {
                "x": -0.0569021999835968,
                "y": 0.006206635385751724,
                "z": -374.0633544921875
            },
            {
                "x": -0.04637232422828674,
                "y": 0.006199013441801071,
                "z": -373.90716552734375
            },
            {
                "x": -0.03530511260032654,
                "y": 0.006191428750753403,
                "z": -373.75115966796875
            },
            {
                "x": -0.023749738931655884,
                "y": 0.00618382915854454,
                "z": -373.5950012207031
            },
            {
                "x": -0.011875271797180176,
                "y": 0.006176214665174484,
                "z": -373.43853759765625
            },
            {
                "x": 0.0002822279930114746,
                "y": 0.006168629974126816,
                "z": -373.282470703125
            },
            {
                "x": 0.012889742851257324,
                "y": 0.006161019206047058,
                "z": -373.1266174316406
            },
            {
                "x": 0.026049286127090454,
                "y": 0.0061534084379673,
                "z": -372.9705505371094
            },
            {
                "x": 0.039616942405700684,
                "y": 0.006145808845758438,
                "z": -372.8144226074219
            },
            {
                "x": 0.05345499515533447,
                "y": 0.006138295400887728,
                "z": -372.65826416015625
            },
            {
                "x": 0.06255674362182617,
                "y": 0.006133224815130234,
                "z": -372.5575256347656
            },
            {
                "x": 0.0770101249217987,
                "y": 0.006125636398792267,
                "z": -372.4018249511719
            },
            {
                "x": 0.09201386570930481,
                "y": 0.006118021905422211,
                "z": -372.24603271484375
            },
            {
                "x": 0.10744011402130127,
                "y": 0.006110403686761856,
                "z": -372.08990478515625
            },
            {
                "x": 0.12309414148330688,
                "y": 0.0061028338968753815,
                "z": -371.9339599609375
            },
            {
                "x": 0.1390862762928009,
                "y": 0.006095211952924728,
                "z": -371.7781066894531
            },
            {
                "x": 0.15555298328399658,
                "y": 0.006087608635425568,
                "z": -371.62261962890625
            },
            {
                "x": 0.17251941561698914,
                "y": 0.006080005317926407,
                "z": -371.4670104980469
            },
            {
                "x": 0.1898462474346161,
                "y": 0.0060724057257175446,
                "z": -371.3109130859375
            },
            {
                "x": 0.20737963914871216,
                "y": 0.0060648247599601746,
                "z": -371.15521240234375
            },
            {
                "x": 0.22529327869415283,
                "y": 0.00605720654129982,
                "z": -370.9997253417969
            },
            {
                "x": 0.24372181296348572,
                "y": 0.0060495734214782715,
                "z": -370.8443298339844
            },
            {
                "x": 0.26257526874542236,
                "y": 0.006041999906301498,
                "z": -370.6888122558594
            },
            {
                "x": 0.28172123432159424,
                "y": 0.006034381687641144,
                "z": -370.53289794921875
            },
            {
                "x": 0.30110257863998413,
                "y": 0.006026778370141983,
                "z": -370.3775329589844
            },
            {
                "x": 0.3209170997142792,
                "y": 0.00601915642619133,
                "z": -370.222412109375
            },
            {
                "x": 0.3412325382232666,
                "y": 0.006011590361595154,
                "z": -370.0670166015625
            },
            {
                "x": 0.36189883947372437,
                "y": 0.006003964692354202,
                "z": -369.9115905761719
            },
            {
                "x": 0.38279882073402405,
                "y": 0.00599636510014534,
                "z": -369.756103515625
            },
            {
                "x": 0.40402311086654663,
                "y": 0.005988754332065582,
                "z": -369.6009216308594
            },
            {
                "x": 0.4256826937198639,
                "y": 0.0059811510145664215,
                "z": -369.4459533691406
            },
            {
                "x": 0.4477892816066742,
                "y": 0.005973562598228455,
                "z": -369.2908935546875
            },
            {
                "x": 0.4701955318450928,
                "y": 0.0059659406542778015,
                "z": -369.1356506347656
            },
            {
                "x": 0.4928291440010071,
                "y": 0.005958378314971924,
                "z": -368.9805908203125
            },
            {
                "x": 0.5158518552780151,
                "y": 0.005950748920440674,
                "z": -368.8255920410156
            },
            {
                "x": 0.5392992496490479,
                "y": 0.0059431567788124084,
                "z": -368.67083740234375
            },
            {
                "x": 0.5631566643714905,
                "y": 0.005935538560152054,
                "z": -368.515869140625
            },
            {
                "x": 0.5872551202774048,
                "y": 0.005927935242652893,
                "z": -368.3608093261719
            },
            {
                "x": 0.6115927696228027,
                "y": 0.005920331925153732,
                "z": -368.2060546875
            },
            {
                "x": 0.6363519430160522,
                "y": 0.005912721157073975,
                "z": -368.0513610839844
            },
            {
                "x": 0.6615308523178101,
                "y": 0.005905125290155411,
                "z": -367.896728515625
            },
            {
                "x": 0.687037467956543,
                "y": 0.005897514522075653,
                "z": -367.7419738769531
            },
            {
                "x": 0.7127711772918701,
                "y": 0.005889922380447388,
                "z": -367.5871887207031
            },
            {
                "x": 0.7387744188308716,
                "y": 0.00588231161236763,
                "z": -367.4327697753906
            },
            {
                "x": 0.7652161121368408,
                "y": 0.005874700844287872,
                "z": -367.27838134765625
            },
            {
                "x": 0.7920790910720825,
                "y": 0.005867093801498413,
                "z": -367.1238708496094
            },
            {
                "x": 0.819175124168396,
                "y": 0.00585952028632164,
                "z": -366.96929931640625
            },
            {
                "x": 0.8464921712875366,
                "y": 0.0058518946170806885,
                "z": -366.81488037109375
            },
            {
                "x": 0.8741259574890137,
                "y": 0.005844295024871826,
                "z": -366.6607666015625
            },
            {
                "x": 0.9021958112716675,
                "y": 0.005836714059114456,
                "z": -366.5066833496094
            },
            {
                "x": 0.9306590557098389,
                "y": 0.005829092115163803,
                "z": -366.35223388671875
            },
            {
                "x": 0.9592875242233276,
                "y": 0.005821488797664642,
                "z": -366.1980285644531
            },
            {
                "x": 0.9881330132484436,
                "y": 0.005814177915453911,
                "z": -366.0440673828125
            },
            {
                "x": 1.0069799423217773,
                "y": 0.005808938294649124,
                "z": -365.94464111328125
            },
            {
                "x": 1.0364762544631958,
                "y": 0.005801334977149963,
                "z": -365.790771484375
            },
            {
                "x": 1.0663304328918457,
                "y": 0.005793720483779907,
                "z": -365.6367492675781
            },
            {
                "x": 1.0963963270187378,
                "y": 0.005786120891571045,
                "z": -365.4826354980469
            },
            {
                "x": 1.12666654586792,
                "y": 0.0057784877717494965,
                "z": -365.3288879394531
            },
            {
                "x": 1.1573145389556885,
                "y": 0.005770936608314514,
                "z": -365.1752014160156
            },
            {
                "x": 1.1883364915847778,
                "y": 0.005763288587331772,
                "z": -365.0216064453125
            },
            {
                "x": 1.2196331024169922,
                "y": 0.005755685269832611,
                "z": -364.8678283691406
            },
            {
                "x": 1.2511504888534546,
                "y": 0.005748078227043152,
                "z": -364.7139892578125
            },
            {
                "x": 1.2828829288482666,
                "y": 0.005740489810705185,
                "z": -364.56060791015625
            },
            {
                "x": 1.3150088787078857,
                "y": 0.005732886493206024,
                "z": -364.4072570800781
            },
            {
                "x": 1.347495198249817,
                "y": 0.00572529062628746,
                "z": -364.2537536621094
            },
            {
                "x": 1.380178451538086,
                "y": 0.0057176873087882996,
                "z": -364.10028076171875
            },
            {
                "x": 1.413095235824585,
                "y": 0.005710072815418243,
                "z": -363.94677734375
            },
            {
                "x": 1.446262001991272,
                "y": 0.005702473223209381,
                "z": -363.7936706542969
            },
            {
                "x": 1.4798142910003662,
                "y": 0.005694866180419922,
                "z": -363.640625
            },
            {
                "x": 1.5136905908584595,
                "y": 0.00568726658821106,
                "z": -363.4873046875
            },
            {
                "x": 1.5477174520492554,
                "y": 0.005679640918970108,
                "z": -363.3341064453125
            },
            {
                "x": 1.5819623470306396,
                "y": 0.005672048777341843,
                "z": -363.1810302734375
            },
            {
                "x": 1.616538166999817,
                "y": 0.005664452910423279,
                "z": -363.0281066894531
            },
            {
                "x": 1.6514520645141602,
                "y": 0.005656827241182327,
                "z": -362.87530517578125
            },
            {
                "x": 1.6865997314453125,
                "y": 0.00564921647310257,
                "z": -362.72235107421875
            },
            {
                "x": 1.7219103574752808,
                "y": 0.005641654133796692,
                "z": -362.5694885253906
            },
            {
                "x": 1.7574589252471924,
                "y": 0.005634032189846039,
                "z": -362.4169006347656
            },
            {
                "x": 1.7933928966522217,
                "y": 0.00562642514705658,
                "z": -362.26416015625
            },
            {
                "x": 1.8296078443527222,
                "y": 0.005618825554847717,
                "z": -362.11151123046875
            },
            {
                "x": 1.8660142421722412,
                "y": 0.005611218512058258,
                "z": -361.9588317871094
            },
            {
                "x": 1.902587890625,
                "y": 0.005603611469268799,
                "z": -361.8062744140625
            },
            {
                "x": 1.9394315481185913,
                "y": 0.0055960193276405334,
                "z": -361.6539001464844
            },
            {
                "x": 1.9766498804092407,
                "y": 0.00558839738368988,
                "z": -361.5014343261719
            },
            {
                "x": 2.0140891075134277,
                "y": 0.0055808089673519135,
                "z": -361.3490295410156
            },
            {
                "x": 2.0516932010650635,
                "y": 0.005573201924562454,
                "z": -361.1966247558594
            },
            {
                "x": 2.0895042419433594,
                "y": 0.005565587431192398,
                "z": -361.0443420410156
            },
            {
                "x": 2.127567768096924,
                "y": 0.005557999014854431,
                "z": -360.8923034667969
            },
            {
                "x": 2.165977954864502,
                "y": 0.00555039569735527,
                "z": -360.7401123046875
            },
            {
                "x": 2.204608678817749,
                "y": 0.005542777478694916,
                "z": -360.5878601074219
            },
            {
                "x": 2.2433457374572754,
                "y": 0.00553518533706665,
                "z": -360.4358215332031
            },
            {
                "x": 2.2823233604431152,
                "y": 0.005527552217245102,
                "z": -360.28387451171875
            },
            {
                "x": 2.3215811252593994,
                "y": 0.005519963800907135,
                "z": -360.1321105957031
            },
            {
                "x": 2.361114263534546,
                "y": 0.0055123381316661835,
                "z": -359.9803161621094
            },
            {
                "x": 2.400890350341797,
                "y": 0.0055047497153282166,
                "z": -359.82818603515625
            },
            {
                "x": 2.4407405853271484,
                "y": 0.005497150123119354,
                "z": -359.67645263671875
            },
            {
                "x": 2.4808247089385986,
                "y": 0.0054895468056201935,
                "z": -359.5248718261719
            },
            {
                "x": 2.506882667541504,
                "y": 0.005484573543071747,
                "z": -359.427001953125
            },
            {
                "x": 2.5474352836608887,
                "y": 0.00547698512673378,
                "z": -359.2754211425781
            },
            {
                "x": 2.588164806365967,
                "y": 0.005469385534524918,
                "z": -359.1236572265625
            },
            {
                "x": 2.629041910171509,
                "y": 0.005461756139993668,
                "z": -358.97210693359375
            },
            {
                "x": 2.670128583908081,
                "y": 0.005454178899526596,
                "z": -358.8207702636719
            },
            {
                "x": 2.7115280628204346,
                "y": 0.00544656440615654,
                "z": -358.6694030761719
            },
            {
                "x": 2.7531285285949707,
                "y": 0.005438949912786484,
                "z": -358.51800537109375
            },
            {
                "x": 2.794872283935547,
                "y": 0.005431368947029114,
                "z": -358.3666687011719
            },
            {
                "x": 2.836805820465088,
                "y": 0.005423735827207565,
                "z": -358.2153015136719
            },
            {
                "x": 2.878920316696167,
                "y": 0.005416136234998703,
                "z": -358.06427001953125
            },
            {
                "x": 2.921318292617798,
                "y": 0.005408532917499542,
                "z": -357.9131774902344
            },
            {
                "x": 2.963911533355713,
                "y": 0.0054009296000003815,
                "z": -357.7619934082031
            },
            {
                "x": 3.0066142082214355,
                "y": 0.005393322557210922,
                "z": -357.6109313964844
            },
            {
                "x": 3.0495285987854004,
                "y": 0.005385704338550568,
                "z": -357.4598388671875
            },
            {
                "x": 3.092642307281494,
                "y": 0.005378097295761108,
                "z": -357.30908203125
            },
            {
                "x": 3.1360044479370117,
                "y": 0.005370493978261948,
                "z": -357.1582336425781
            },
            {
                "x": 3.179544687271118,
                "y": 0.005362890660762787,
                "z": -357.0072021484375
            },
            {
                "x": 3.2231788635253906,
                "y": 0.005355283617973328,
                "z": -356.8564758300781
            },
            {
                "x": 3.2670085430145264,
                "y": 0.005347698926925659,
                "z": -356.7057189941406
            },
            {
                "x": 3.3110833168029785,
                "y": 0.005340076982975006,
                "z": -356.5550537109375
            },
            {
                "x": 3.3553647994995117,
                "y": 0.0053324587643146515,
                "z": -356.4044189453125
            },
            {
                "x": 3.399746894836426,
                "y": 0.005324874073266983,
                "z": -356.2537536621094
            },
            {
                "x": 3.4442524909973145,
                "y": 0.005317270755767822,
                "z": -356.1033020019531
            },
            {
                "x": 3.4889538288116455,
                "y": 0.005309678614139557,
                "z": -355.9530029296875
            },
            {
                "x": 3.53397274017334,
                "y": 0.005302060395479202,
                "z": -355.8023681640625
            },
            {
                "x": 3.579094648361206,
                "y": 0.00529446080327034,
                "z": -355.6519775390625
            },
            {
                "x": 3.624319314956665,
                "y": 0.005286850035190582,
                "z": -355.5016174316406
            },
            {
                "x": 3.6696908473968506,
                "y": 0.005279239267110825,
                "z": -355.3512878417969
            },
            {
                "x": 3.715257406234741,
                "y": 0.005271647125482559,
                "z": -355.2012023925781
            },
            {
                "x": 3.761099100112915,
                "y": 0.0052640438079833984,
                "z": -355.0508728027344
            },
            {
                "x": 3.8070149421691895,
                "y": 0.005256433039903641,
                "z": -354.90069580078125
            },
            {
                "x": 3.853029251098633,
                "y": 0.0052488334476947784,
                "z": -354.75054931640625
            },
            {
                "x": 3.899235486984253,
                "y": 0.0052412450313568115,
                "z": -354.6004638671875
            },
            {
                "x": 3.9456090927124023,
                "y": 0.005233637988567352,
                "z": -354.4505615234375
            },
            {
                "x": 3.9922029972076416,
                "y": 0.00522603839635849,
                "z": -354.3004455566406
            },
            {
                "x": 4.038895606994629,
                "y": 0.00521840900182724,
                "z": -354.1503601074219
            },
            {
                "x": 4.085661888122559,
                "y": 0.00521082803606987,
                "z": -354.0005798339844
            },
            {
                "x": 4.132637023925781,
                "y": 0.0052031949162483215,
                "z": -353.8506774902344
            },
            {
                "x": 4.1797614097595215,
                "y": 0.005195606499910355,
                "z": -353.70098876953125
            },
            {
                "x": 4.227059364318848,
                "y": 0.00518798828125,
                "z": -353.5511474609375
            },
            {
                "x": 4.274503231048584,
                "y": 0.005180384963750839,
                "z": -353.4012756347656
            },
            {
                "x": 4.321974277496338,
                "y": 0.005172807723283768,
                "z": -353.25164794921875
            },
            {
                "x": 4.369630336761475,
                "y": 0.005165189504623413,
                "z": -353.1020812988281
            },
            {
                "x": 4.400508880615234,
                "y": 0.005160249769687653,
                "z": -353.00543212890625
            },
            {
                "x": 4.4484429359436035,
                "y": 0.005152646452188492,
                "z": -352.8558349609375
            },
            {
                "x": 4.496481895446777,
                "y": 0.005145043134689331,
                "z": -352.70623779296875
            },
            {
                "x": 4.544628620147705,
                "y": 0.005137432366609573,
                "z": -352.5566711425781
            },
            {
                "x": 4.592890739440918,
                "y": 0.005129821598529816,
                "z": -352.4073181152344
            },
            {
                "x": 4.6413702964782715,
                "y": 0.0051222071051597595,
                "z": -352.2578125
            },
            {
                "x": 4.68993616104126,
                "y": 0.005114607512950897,
                "z": -352.1083679199219
            },
            {
                "x": 4.738560676574707,
                "y": 0.005107011646032333,
                "z": -351.9590148925781
            },
            {
                "x": 4.787359237670898,
                "y": 0.005099385976791382,
                "z": -351.8096618652344
            },
            {
                "x": 4.836273670196533,
                "y": 0.00509180873632431,
                "z": -351.6604919433594
            },
            {
                "x": 4.885342597961426,
                "y": 0.00508417934179306,
                "z": -351.51116943359375
            },
            {
                "x": 4.9344987869262695,
                "y": 0.005076590925455093,
                "z": -351.3619384765625
            },
            {
                "x": 4.983730316162109,
                "y": 0.005068976432085037,
                "z": -351.2127685546875
            },
            {
                "x": 5.033120155334473,
                "y": 0.005061376839876175,
                "z": -351.0635070800781
            },
            {
                "x": 5.082605361938477,
                "y": 0.005053769797086716,
                "z": -350.9145202636719
            },
            {
                "x": 5.132216453552246,
                "y": 0.005046147853136063,
                "z": -350.7655029296875
            },
            {
                "x": 5.18196439743042,
                "y": 0.005038555711507797,
                "z": -350.6163024902344
            },
            {
                "x": 5.231722831726074,
                "y": 0.005030941218137741,
                "z": -350.4673156738281
            },
            {
                "x": 5.281636714935303,
                "y": 0.005023356527090073,
                "z": -350.3183898925781
            },
            {
                "x": 5.331697940826416,
                "y": 0.005015753209590912,
                "z": -350.1693420410156
            },
            {
                "x": 5.381822109222412,
                "y": 0.005136839114129543,
                "z": -350.0205078125
            },
            {
                "x": 5.432007312774658,
                "y": 0.005572183057665825,
                "z": -349.8716735839844
            },
            {
                "x": 5.482264518737793,
                "y": 0.006314335856586695,
                "z": -349.722900390625
            },
            {
                "x": 5.532658576965332,
                "y": 0.007359582465142012,
                "z": -349.57415771484375
            },
            {
                "x": 5.583240509033203,
                "y": 0.008711685426533222,
                "z": -349.42523193359375
            },
            {
                "x": 5.633829116821289,
                "y": 0.010365761816501617,
                "z": -349.2764892578125
            },
            {
                "x": 5.684501647949219,
                "y": 0.012310544028878212,
                "z": -349.1277160644531
            },
            {
                "x": 5.7352471351623535,
                "y": 0.014540806412696838,
                "z": -348.9790954589844
            },
            {
                "x": 5.786078929901123,
                "y": 0.017055880278348923,
                "z": -348.8305358886719
            },
            {
                "x": 5.83710241317749,
                "y": 0.019863056018948555,
                "z": -348.6817321777344
            },
            {
                "x": 5.888111591339111,
                "y": 0.022939275950193405,
                "z": -348.533203125
            },
            {
                "x": 5.939169883728027,
                "y": 0.026283439248800278,
                "z": -348.3846435546875
            },
            {
                "x": 5.990347862243652,
                "y": 0.029897987842559814,
                "z": -348.236083984375
            },
            {
                "x": 6.041606903076172,
                "y": 0.033779919147491455,
                "z": -348.087646484375
            },
            {
                "x": 6.092983245849609,
                "y": 0.037921540439128876,
                "z": -347.9390869140625
            },
            {
                "x": 6.144400596618652,
                "y": 0.04231436550617218,
                "z": -347.7905578613281
            },
            {
                "x": 6.195835113525391,
                "y": 0.04695390909910202,
                "z": -347.6421813964844
            },
            {
                "x": 6.2473883628845215,
                "y": 0.05184786394238472,
                "z": -347.4938049316406
            },
            {
                "x": 6.299006462097168,
                "y": 0.05697932466864586,
                "z": -347.345458984375
            },
            {
                "x": 6.350679874420166,
                "y": 0.06234467029571533,
                "z": -347.1971435546875
            },
            {
                "x": 6.4024658203125,
                "y": 0.06795049458742142,
                "z": -347.0486755371094
            },
            {
                "x": 6.4542155265808105,
                "y": 0.07377967238426208,
                "z": -346.9005126953125
            },
            {
                "x": 6.506068229675293,
                "y": 0.07983280718326569,
                "z": -346.75238037109375
            },
            {
                "x": 6.53960657119751,
                "y": 0.08385495841503143,
                "z": -346.6565856933594
            },
            {
                "x": 6.591568470001221,
                "y": 0.09027282148599625,
                "z": -346.5083923339844
            },
            {
                "x": 6.643577575683594,
                "y": 0.09690302610397339,
                "z": -346.3601379394531
            },
            {
                "x": 6.695657253265381,
                "y": 0.10373933613300323,
                "z": -346.21197509765625
            },
            {
                "x": 6.747756004333496,
                "y": 0.11077236384153366,
                "z": -346.06390380859375
            },
            {
                "x": 6.799966812133789,
                "y": 0.11801601946353912,
                "z": -345.9157409667969
            },
            {
                "x": 6.852189064025879,
                "y": 0.12545102834701538,
                "z": -345.76763916015625
            },
            {
                "x": 6.9044342041015625,
                "y": 0.13307411968708038,
                "z": -345.61962890625
            },
            {
                "x": 6.956779479980469,
                "y": 0.14088940620422363,
                "z": -345.47149658203125
            },
            {
                "x": 7.009124755859375,
                "y": 0.1488824039697647,
                "z": -345.32354736328125
            },
            {
                "x": 7.061542510986328,
                "y": 0.15705713629722595,
                "z": -345.175537109375
            },
            {
                "x": 7.113988399505615,
                "y": 0.16540329158306122,
                "z": -345.02752685546875
            },
            {
                "x": 7.166436672210693,
                "y": 0.17391379177570343,
                "z": -344.87957763671875
            },
            {
                "x": 7.2190022468566895,
                "y": 0.1826036274433136,
                "z": -344.7315368652344
            },
            {
                "x": 7.271524429321289,
                "y": 0.19143998622894287,
                "z": -344.583740234375
            },
            {
                "x": 7.324119567871094,
                "y": 0.2004372626543045,
                "z": -344.435791015625
            },
            {
                "x": 7.376749038696289,
                "y": 0.2095879316329956,
                "z": -344.28790283203125
            },
            {
                "x": 7.429376125335693,
                "y": 0.21888107061386108,
                "z": -344.14007568359375
            },
            {
                "x": 7.482062816619873,
                "y": 0.22832363843917847,
                "z": -343.99224853515625
            },
            {
                "x": 7.534815311431885,
                "y": 0.2379099726676941,
                "z": -343.8443298339844
            },
            {
                "x": 7.587527751922607,
                "y": 0.24761918187141418,
                "z": -343.696533203125
            },
            {
                "x": 7.64024543762207,
                "y": 0.25745779275894165,
                "z": -343.548828125
            },
            {
                "x": 7.693009376525879,
                "y": 0.2674281597137451,
                "z": -343.4010314941406
            },
            {
                "x": 7.7457756996154785,
                "y": 0.2775150537490845,
                "z": -343.2533874511719
            },
            {
                "x": 7.798647403717041,
                "y": 0.28773224353790283,
                "z": -343.1054992675781
            },
            {
                "x": 7.851465702056885,
                "y": 0.2980506420135498,
                "z": -342.9577941894531
            },
            {
                "x": 7.904313087463379,
                "y": 0.3084836006164551,
                "z": -342.8100280761719
            },
            {
                "x": 7.957181930541992,
                "y": 0.319021999835968,
                "z": -342.6623229980469
            },
            {
                "x": 8.010049819946289,
                "y": 0.3296540379524231,
                "z": -342.5146484375
            },
            {
                "x": 8.06300163269043,
                "y": 0.34039729833602905,
                "z": -342.3667907714844
            },
            {
                "x": 8.115889549255371,
                "y": 0.3512192666530609,
                "z": -342.2191467285156
            },
            {
                "x": 8.168763160705566,
                "y": 0.3621237874031067,
                "z": -342.071533203125
            },
            {
                "x": 8.221724510192871,
                "y": 0.37312352657318115,
                "z": -341.92376708984375
            },
            {
                "x": 8.274638175964355,
                "y": 0.3841938376426697,
                "z": -341.7761535644531
            },
            {
                "x": 8.327584266662598,
                "y": 0.3953494429588318,
                "z": -341.6283874511719
            },
            {
                "x": 8.380517959594727,
                "y": 0.4065713584423065,
                "z": -341.48065185546875
            },
            {
                "x": 8.43343448638916,
                "y": 0.4178532361984253,
                "z": -341.3329772949219
            },
            {
                "x": 8.486377716064453,
                "y": 0.4292035698890686,
                "z": -341.18524169921875
            },
            {
                "x": 8.539310455322266,
                "y": 0.44060832262039185,
                "z": -341.0375671386719
            },
            {
                "x": 8.592211723327637,
                "y": 0.4520640969276428,
                "z": -340.8899230957031
            },
            {
                "x": 8.645176887512207,
                "y": 0.4635820984840393,
                "z": -340.7420959472656
            },
            {
                "x": 8.698071479797363,
                "y": 0.4751288890838623,
                "z": -340.594482421875
            },
            {
                "x": 8.750958442687988,
                "y": 0.48671823740005493,
                "z": -340.44683837890625
            },
            {
                "x": 8.78512954711914,
                "y": 0.49422788619995117,
                "z": -340.35137939453125
            },
            {
                "x": 8.837984085083008,
                "y": 0.5058718323707581,
                "z": -340.2037658691406
            },
            {
                "x": 8.890873908996582,
                "y": 0.5175542831420898,
                "z": -340.0559997558594
            },
            {
                "x": 8.943756103515625,
                "y": 0.5292627215385437,
                "z": -339.908203125
            },
            {
                "x": 8.996580123901367,
                "y": 0.5409835577011108,
                "z": -339.760498046875
            },
            {
                "x": 9.04941463470459,
                "y": 0.5527279376983643,
                "z": -339.61273193359375
            },
            {
                "x": 9.102179527282715,
                "y": 0.5644741058349609,
                "z": -339.465087890625
            },
            {
                "x": 9.154935836791992,
                "y": 0.5762275457382202,
                "z": -339.3173828125
            },
            {
                "x": 9.207756042480469,
                "y": 0.5880012512207031,
                "z": -339.1695251464844
            },
            {
                "x": 9.26046085357666,
                "y": 0.5997582674026489,
                "z": -339.0218200683594
            },
            {
                "x": 9.313156127929688,
                "y": 0.6115162372589111,
                "z": -338.8740234375
            },
            {
                "x": 9.365825653076172,
                "y": 0.6232630014419556,
                "z": -338.7262268066406
            },
            {
                "x": 9.418465614318848,
                "y": 0.6349915266036987,
                "z": -338.5784606933594
            },
            {
                "x": 9.471152305603027,
                "y": 0.6467204093933105,
                "z": -338.4305114746094
            },
            {
                "x": 9.523715019226074,
                "y": 0.6584109663963318,
                "z": -338.2826843261719
            },
            {
                "x": 9.576228141784668,
                "y": 0.670071542263031,
                "z": -338.13494873046875
            },
            {
                "x": 9.628763198852539,
                "y": 0.6817118525505066,
                "z": -337.9870300292969
            },
            {
                "x": 9.681235313415527,
                "y": 0.6933091878890991,
                "z": -337.8392028808594
            },
            {
                "x": 9.733709335327148,
                "y": 0.7048768401145935,
                "z": -337.6912536621094
            },
            {
                "x": 9.786111831665039,
                "y": 0.7163975238800049,
                "z": -337.5433044433594
            },
            {
                "x": 9.838446617126465,
                "y": 0.7278639674186707,
                "z": -337.3953857421875
            },
            {
                "x": 9.890751838684082,
                "y": 0.7392767667770386,
                "z": -337.2475280761719
            },
            {
                "x": 9.943028450012207,
                "y": 0.7506363391876221,
                "z": -337.0995788574219
            },
            {
                "x": 9.995248794555664,
                "y": 0.7619361877441406,
                "z": -336.95159912109375
            },
            {
                "x": 10.047467231750488,
                "y": 0.7731835842132568,
                "z": -336.8033752441406
            },
            {
                "x": 10.099546432495117,
                "y": 0.7843443155288696,
                "z": -336.6554260253906
            },
            {
                "x": 10.15162467956543,
                "y": 0.7954378128051758,
                "z": -336.5073547363281
            },
            {
                "x": 10.20365047454834,
                "y": 0.8064556121826172,
                "z": -336.3591613769531
            },
            {
                "x": 10.255583763122559,
                "y": 0.8173842430114746,
                "z": -336.2110900878906
            },
            {
                "x": 10.307524681091309,
                "y": 0.8282431364059448,
                "z": -336.062744140625
            },
            {
                "x": 10.359350204467773,
                "y": 0.8389945030212402,
                "z": -335.9146423339844
            },
            {
                "x": 10.411139488220215,
                "y": 0.8496531248092651,
                "z": -335.7664794921875
            },
            {
                "x": 10.46289348602295,
                "y": 0.8602206707000732,
                "z": -335.61810302734375
            },
            {
                "x": 10.51452922821045,
                "y": 0.8706775307655334,
                "z": -335.4698486328125
            },
            {
                "x": 10.566139221191406,
                "y": 0.8810325860977173,
                "z": -335.32147216796875
            },
            {
                "x": 10.617690086364746,
                "y": 0.891271710395813,
                "z": -335.1731262207031
            },
            {
                "x": 10.669166564941406,
                "y": 0.9013911485671997,
                "z": -335.0247802734375
            },
            {
                "x": 10.720585823059082,
                "y": 0.9113993644714355,
                "z": -334.876220703125
            },
            {
                "x": 10.771862983703613,
                "y": 0.9212743639945984,
                "z": -334.727783203125
            },
            {
                "x": 10.823064804077148,
                "y": 0.931014895439148,
                "z": -334.5793762207031
            },
            {
                "x": 10.874306678771973,
                "y": 0.940635085105896,
                "z": -334.4306945800781
            },
            {
                "x": 10.925411224365234,
                "y": 0.950109601020813,
                "z": -334.2821350097656
            },
            {
                "x": 10.976387023925781,
                "y": 0.9594416618347168,
                "z": -334.1335144042969
            },
            {
                "x": 11.009278297424316,
                "y": 0.9653927087783813,
                "z": -334.0374755859375
            },
            {
                "x": 11.060104370117188,
                "y": 0.9744747877120972,
                "z": -333.88885498046875
            },
            {
                "x": 11.110925674438477,
                "y": 0.9834093451499939,
                "z": -333.74017333984375
            },
            {
                "x": 11.161694526672363,
                "y": 0.992195725440979,
                "z": -333.59130859375
            },
            {
                "x": 11.212292671203613,
                "y": 1.0008058547973633,
                "z": -333.4425354003906
            },
            {
                "x": 11.262807846069336,
                "y": 1.0092540979385376,
                "z": -333.29364013671875
            },
            {
                "x": 11.313233375549316,
                "y": 1.017526388168335,
                "z": -333.14483642578125
            },
            {
                "x": 11.36358642578125,
                "y": 1.0256271362304688,
                "z": -332.99591064453125
            },
            {
                "x": 11.413904190063477,
                "y": 1.0335559844970703,
                "z": -332.84674072265625
            },
            {
                "x": 11.464007377624512,
                "y": 1.04128897190094,
                "z": -332.6977233886719
            },
            {
                "x": 11.514025688171387,
                "y": 1.0488345623016357,
                "z": -332.5486755371094
            },
            {
                "x": 11.56399917602539,
                "y": 1.0561916828155518,
                "z": -332.39959716796875
            },
            {
                "x": 11.613861083984375,
                "y": 1.0633444786071777,
                "z": -332.2504577636719
            },
            {
                "x": 11.66367244720459,
                "y": 1.0703074932098389,
                "z": -332.1010437011719
            },
            {
                "x": 11.71325969696045,
                "y": 1.0770542621612549,
                "z": -331.9518127441406
            },
            {
                "x": 11.76275634765625,
                "y": 1.0835919380187988,
                "z": -331.8025817871094
            },
            {
                "x": 11.812227249145508,
                "y": 1.0899162292480469,
                "z": -331.6531982421875
            },
            {
                "x": 11.861536026000977,
                "y": 1.0960183143615723,
                "z": -331.5037841796875
            },
            {
                "x": 11.910722732543945,
                "y": 1.1019020080566406,
                "z": -331.3542785644531
            },
            {
                "x": 11.959785461425781,
                "y": 1.1075596809387207,
                "z": -331.2047119140625
            },
            {
                "x": 12.008692741394043,
                "y": 1.112973690032959,
                "z": -331.05523681640625
            },
            {
                "x": 12.057564735412598,
                "y": 1.1181540489196777,
                "z": -330.9056701660156
            },
            {
                "x": 12.10627269744873,
                "y": 1.123096227645874,
                "z": -330.7560119628906
            },
            {
                "x": 12.154818534851074,
                "y": 1.1277953386306763,
                "z": -330.6063537597656
            },
            {
                "x": 12.203296661376953,
                "y": 1.1322450637817383,
                "z": -330.45648193359375
            },
            {
                "x": 12.251626014709473,
                "y": 1.1364326477050781,
                "z": -330.30670166015625
            },
            {
                "x": 12.299866676330566,
                "y": 1.1403675079345703,
                "z": -330.1568603515625
            },
            {
                "x": 12.347932815551758,
                "y": 1.1440434455871582,
                "z": -330.0068359375
            },
            {
                "x": 12.39580249786377,
                "y": 1.1474449634552002,
                "z": -329.85693359375
            },
            {
                "x": 12.443624496459961,
                "y": 1.1505751609802246,
                "z": -329.70684814453125
            },
            {
                "x": 12.491292953491211,
                "y": 1.1534291505813599,
                "z": -329.5568542480469
            },
            {
                "x": 12.538829803466797,
                "y": 1.1560072898864746,
                "z": -329.4067077636719
            },
            {
                "x": 12.586202621459961,
                "y": 1.158299446105957,
                "z": -329.2563781738281
            },
            {
                "x": 12.633356094360352,
                "y": 1.160294771194458,
                "z": -329.1062927246094
            },
            {
                "x": 12.680449485778809,
                "y": 1.1620014905929565,
                "z": -328.9559631347656
            },
            {
                "x": 12.72743034362793,
                "y": 1.1634140014648438,
                "z": -328.8055725097656
            },
            {
                "x": 12.774212837219238,
                "y": 1.1645216941833496,
                "z": -328.6551513671875
            },
            {
                "x": 12.82080364227295,
                "y": 1.165317177772522,
                "z": -328.5046081542969
            },
            {
                "x": 12.867196083068848,
                "y": 1.1658048629760742,
                "z": -328.3542175292969
            },
            {
                "x": 12.913501739501953,
                "y": 1.1659810543060303,
                "z": -328.2037658691406
            },
            {
                "x": 12.959744453430176,
                "y": 1.1658360958099365,
                "z": -328.052978515625
            },
            {
                "x": 13.005681991577148,
                "y": 1.165369987487793,
                "z": -327.90228271484375
            },
            {
                "x": 13.051412582397461,
                "y": 1.1645963191986084,
                "z": -327.75164794921875
            },
            {
                "x": 13.080890655517578,
                "y": 1.1639389991760254,
                "z": -327.6542663574219
            },
            {
                "x": 13.126422882080078,
                "y": 1.162657380104065,
                "z": -327.5036315917969
            },
            {
                "x": 13.171828269958496,
                "y": 1.1610779762268066,
                "z": -327.3526611328125
            },
            {
                "x": 13.217016220092773,
                "y": 1.1592051982879639,
                "z": -327.20166015625
            },
            {
                "x": 13.261954307556152,
                "y": 1.1570444107055664,
                "z": -327.0507507324219
            },
            {
                "x": 13.306781768798828,
                "y": 1.1545875072479248,
                "z": -326.8997802734375
            },
            {
                "x": 13.35145378112793,
                "y": 1.1518516540527344,
                "z": -326.748779296875
            },
            {
                "x": 13.39592456817627,
                "y": 1.148838996887207,
                "z": -326.5976257324219
            },
            {
                "x": 13.440191268920898,
                "y": 1.1455512046813965,
                "z": -326.4462585449219
            },
            {
                "x": 13.48419189453125,
                "y": 1.1419918537139893,
                "z": -326.295166015625
            },
            {
                "x": 13.528092384338379,
                "y": 1.1381689310073853,
                "z": -326.14404296875
            },
            {
                "x": 13.57184886932373,
                "y": 1.134084701538086,
                "z": -325.9926452636719
            },
            {
                "x": 13.615342140197754,
                "y": 1.129746675491333,
                "z": -325.8412170410156
            },
            {
                "x": 13.658621788024902,
                "y": 1.1251451969146729,
                "z": -325.689697265625
            },
            {
                "x": 13.701682090759277,
                "y": 1.1203062534332275,
                "z": -325.538330078125
            },
            {
                "x": 13.744613647460938,
                "y": 1.115225076675415,
                "z": -325.38690185546875
            },
            {
                "x": 13.787364959716797,
                "y": 1.1099003553390503,
                "z": -325.2351379394531
            },
            {
                "x": 13.829802513122559,
                "y": 1.1043373346328735,
                "z": -325.0834655761719
            },
            {
                "x": 13.872025489807129,
                "y": 1.0985480546951294,
                "z": -324.9318542480469
            },
            {
                "x": 13.914125442504883,
                "y": 1.092534065246582,
                "z": -324.7801513671875
            },
            {
                "x": 13.95602035522461,
                "y": 1.0863012075424194,
                "z": -324.6283874511719
            },
            {
                "x": 13.99764347076416,
                "y": 1.0798418521881104,
                "z": -324.4764709472656
            },
            {
                "x": 14.038980484008789,
                "y": 1.0731759071350098,
                "z": -324.32464599609375
            },
            {
                "x": 14.080116271972656,
                "y": 1.0663090944290161,
                "z": -324.1728515625
            },
            {
                "x": 14.121177673339844,
                "y": 1.0592262744903564,
                "z": -324.020751953125
            },
            {
                "x": 14.161961555480957,
                "y": 1.0519429445266724,
                "z": -323.8686828613281
            },
            {
                "x": 14.20244026184082,
                "y": 1.0444626808166504,
                "z": -323.7164611816406
            },
            {
                "x": 14.242658615112305,
                "y": 1.0368009805679321,
                "z": -323.5643615722656
            },
            {
                "x": 14.282712936401367,
                "y": 1.0289573669433594,
                "z": -323.41229248046875
            },
            {
                "x": 14.322629928588867,
                "y": 1.0209109783172607,
                "z": -323.25982666015625
            },
            {
                "x": 14.362213134765625,
                "y": 1.0126930475234985,
                "z": -323.10748291015625
            },
            {
                "x": 14.401479721069336,
                "y": 1.004307746887207,
                "z": -322.955078125
            },
            {
                "x": 14.440536499023438,
                "y": 0.9957571029663086,
                "z": -322.80267333984375
            },
            {
                "x": 14.479415893554688,
                "y": 0.9870414733886719,
                "z": -322.6502990722656
            },
            {
                "x": 14.51810073852539,
                "y": 0.9781484603881836,
                "z": -322.49761962890625
            },
            {
                "x": 14.556441307067871,
                "y": 0.9691035747528076,
                "z": -322.3448486328125
            },
            {
                "x": 14.594463348388672,
                "y": 0.9599229097366333,
                "z": -322.19232177734375
            },
            {
                "x": 14.632326126098633,
                "y": 0.9505873322486877,
                "z": -322.0396423339844
            },
            {
                "x": 14.6699857711792,
                "y": 0.9411062598228455,
                "z": -321.88690185546875
            },
            {
                "x": 14.707337379455566,
                "y": 0.9314827919006348,
                "z": -321.7339782714844
            },
            {
                "x": 14.744391441345215,
                "y": 0.9217179417610168,
                "z": -321.5809020996094
            },
            {
                "x": 14.78112506866455,
                "y": 0.9118473529815674,
                "z": -321.4281005859375
            },
            {
                "x": 14.817719459533691,
                "y": 0.901841402053833,
                "z": -321.27520751953125
            },
            {
                "x": 14.841224670410156,
                "y": 0.8953081369400024,
                "z": -321.17626953125
            },
            {
                "x": 14.87732982635498,
                "y": 0.8850986957550049,
                "z": -321.02313232421875
            },
            {
                "x": 14.913093566894531,
                "y": 0.874770998954773,
                "z": -320.869873046875
            },
            {
                "x": 14.9486083984375,
                "y": 0.8643442392349243,
                "z": -320.71673583984375
            },
            {
                "x": 14.983936309814453,
                "y": 0.8538126945495605,
                "z": -320.56353759765625
            },
            {
                "x": 15.019017219543457,
                "y": 0.8431638479232788,
                "z": -320.4100646972656
            },
            {
                "x": 15.05367374420166,
                "y": 0.8324258923530579,
                "z": -320.256591796875
            },
            {
                "x": 15.088007926940918,
                "y": 0.8216058015823364,
                "z": -320.103271484375
            },
            {
                "x": 15.122200965881348,
                "y": 0.8106861114501953,
                "z": -319.9496765136719
            },
            {
                "x": 15.156122207641602,
                "y": 0.7996877431869507,
                "z": -319.796142578125
            },
            {
                "x": 15.189702987670898,
                "y": 0.7885951995849609,
                "z": -319.6423645019531
            },
            {
                "x": 15.222885131835938,
                "y": 0.7774375677108765,
                "z": -319.4886169433594
            },
            {
                "x": 15.255779266357422,
                "y": 0.7662237882614136,
                "z": -319.33502197265625
            },
            {
                "x": 15.288549423217773,
                "y": 0.7549229860305786,
                "z": -319.18109130859375
            },
            {
                "x": 15.320969581604004,
                "y": 0.7435600161552429,
                "z": -319.0271301269531
            },
            {
                "x": 15.352985382080078,
                "y": 0.7321416139602661,
                "z": -318.8731384277344
            },
            {
                "x": 15.384678840637207,
                "y": 0.7206732034683228,
                "z": -318.7191162109375
            },
            {
                "x": 15.416133880615234,
                "y": 0.7091682553291321,
                "z": -318.5652160644531
            },
            {
                "x": 15.447351455688477,
                "y": 0.6975983381271362,
                "z": -318.4109802246094
            },
            {
                "x": 15.478187561035156,
                "y": 0.6859794855117798,
                "z": -318.256591796875
            },
            {
                "x": 15.508597373962402,
                "y": 0.6743423938751221,
                "z": -318.1023864746094
            },
            {
                "x": 15.538724899291992,
                "y": 0.662682831287384,
                "z": -317.9482421875
            },
            {
                "x": 15.568645477294922,
                "y": 0.6509881019592285,
                "z": -317.7939453125
            },
            {
                "x": 15.598224639892578,
                "y": 0.639257550239563,
                "z": -317.6394348144531
            },
            {
                "x": 15.627408981323242,
                "y": 0.6274936199188232,
                "z": -317.4846496582031
            },
            {
                "x": 15.656182289123535,
                "y": 0.6157445311546326,
                "z": -317.3301696777344
            },
            {
                "x": 15.684752464294434,
                "y": 0.6039804220199585,
                "z": -317.1756286621094
            },
            {
                "x": 15.713038444519043,
                "y": 0.592197597026825,
                "z": -317.0209045410156
            },
            {
                "x": 15.740893363952637,
                "y": 0.5804110169410706,
                "z": -316.8660888671875
            },
            {
                "x": 15.768352508544922,
                "y": 0.5686213970184326,
                "z": -316.7110290527344
            },
            {
                "x": 15.795475006103516,
                "y": 0.5568619966506958,
                "z": -316.5563049316406
            },
            {
                "x": 15.822368621826172,
                "y": 0.5451091527938843,
                "z": -316.4015197753906
            },
            {
                "x": 15.84892749786377,
                "y": 0.5333462953567505,
                "z": -316.2462463378906
            },
            {
                "x": 15.87499713897705,
                "y": 0.5216159820556641,
                "z": -316.09112548828125
            },
            {
                "x": 15.90070915222168,
                "y": 0.5099111795425415,
                "z": -315.9359436035156
            },
            {
                "x": 15.926155090332031,
                "y": 0.4982413649559021,
                "z": -315.78082275390625
            },
            {
                "x": 15.951292991638184,
                "y": 0.4865942597389221,
                "z": -315.62554931640625
            },
            {
                "x": 15.975997924804688,
                "y": 0.47496938705444336,
                "z": -315.47003173828125
            },
            {
                "x": 16.000226974487305,
                "y": 0.46340447664260864,
                "z": -315.31463623046875
            },
            {
                "x": 16.024147033691406,
                "y": 0.4518944025039673,
                "z": -315.15936279296875
            },
            {
                "x": 16.047847747802734,
                "y": 0.44040945172309875,
                "z": -315.00372314453125
            },
            {
                "x": 16.071109771728516,
                "y": 0.42897969484329224,
                "z": -314.8480224609375
            },
            {
                "x": 16.0938777923584,
                "y": 0.41761186718940735,
                "z": -314.69232177734375
            },
            {
                "x": 16.108360290527344,
                "y": 0.4103084206581116,
                "z": -314.5917663574219
            },
            {
                "x": 16.13056182861328,
                "y": 0.3990602493286133,
                "z": -314.43621826171875
            },
            {
                "x": 16.152503967285156,
                "y": 0.3878621459007263,
                "z": -314.28033447265625
            },
            {
                "x": 16.173986434936523,
                "y": 0.3767257034778595,
                "z": -314.12420654296875
            },
            {
                "x": 16.194931030273438,
                "y": 0.3656843900680542,
                "z": -313.9682312011719
            },
            {
                "x": 16.215534210205078,
                "y": 0.35472971200942993,
                "z": -313.8122863769531
            },
            {
                "x": 16.235883712768555,
                "y": 0.34386104345321655,
                "z": -313.6564025878906
            },
            {
                "x": 16.255828857421875,
                "y": 0.3330676555633545,
                "z": -313.50018310546875
            },
            {
                "x": 16.27525520324707,
                "y": 0.32235777378082275,
                "z": -313.3436279296875
            },
            {
                "x": 16.294212341308594,
                "y": 0.3117746114730835,
                "z": -313.18756103515625
            },
            {
                "x": 16.312894821166992,
                "y": 0.30129274725914,
                "z": -313.0314025878906
            },
            {
                "x": 16.331253051757812,
                "y": 0.29090338945388794,
                "z": -312.8749084472656
            },
            {
                "x": 16.349084854125977,
                "y": 0.2806245684623718,
                "z": -312.7184143066406
            },
            {
                "x": 16.366413116455078,
                "y": 0.27045735716819763,
                "z": -312.5617370605469
            },
            {
                "x": 16.38337516784668,
                "y": 0.2604333162307739,
                "z": -312.4053955078125
            },
            {
                "x": 16.40005874633789,
                "y": 0.2505241632461548,
                "z": -312.24896240234375
            },
            {
                "x": 16.416290283203125,
                "y": 0.2407260239124298,
                "z": -312.092041015625
            },
            {
                "x": 16.43194007873535,
                "y": 0.23106956481933594,
                "z": -311.935302734375
            },
            {
                "x": 16.44715690612793,
                "y": 0.22155730426311493,
                "z": -311.778564453125
            },
            {
                "x": 16.462108612060547,
                "y": 0.2121812105178833,
                "z": -311.621826171875
            },
            {
                "x": 16.47664451599121,
                "y": 0.20294883847236633,
                "z": -311.4649353027344
            },
            {
                "x": 16.490610122680664,
                "y": 0.19386109709739685,
                "z": -311.307861328125
            },
            {
                "x": 16.504056930541992,
                "y": 0.18493622541427612,
                "z": -311.1510009765625
            },
            {
                "x": 16.51716423034668,
                "y": 0.17617687582969666,
                "z": -310.99420166015625
            },
            {
                "x": 16.52996826171875,
                "y": 0.1675591766834259,
                "z": -310.8370056152344
            },
            {
                "x": 16.542224884033203,
                "y": 0.15910914540290833,
                "z": -310.6797790527344
            },
            {
                "x": 16.55389976501465,
                "y": 0.15083113312721252,
                "z": -310.52252197265625
            },
            {
                "x": 16.565153121948242,
                "y": 0.14273658394813538,
                "z": -310.365478515625
            },
            {
                "x": 16.576093673706055,
                "y": 0.13482627272605896,
                "z": -310.2083740234375
            },
            {
                "x": 16.58660125732422,
                "y": 0.12707450985908508,
                "z": -310.0508117675781
            },
            {
                "x": 16.596487045288086,
                "y": 0.11951762437820435,
                "z": -309.8934020996094
            },
            {
                "x": 16.605852127075195,
                "y": 0.11216109991073608,
                "z": -309.7361145019531
            },
            {
                "x": 16.614892959594727,
                "y": 0.10500103235244751,
                "z": -309.5788269042969
            },
            {
                "x": 16.623546600341797,
                "y": 0.09803653508424759,
                "z": -309.42138671875
            },
            {
                "x": 16.631622314453125,
                "y": 0.09126166999340057,
                "z": -309.26361083984375
            },
            {
                "x": 16.639101028442383,
                "y": 0.08470131456851959,
                "z": -309.1061096191406
            },
            {
                "x": 16.64617156982422,
                "y": 0.07836754620075226,
                "z": -308.9487609863281
            },
            {
                "x": 16.65291404724121,
                "y": 0.0722401961684227,
                "z": -308.7911682128906
            },
            {
                "x": 16.65912628173828,
                "y": 0.06632561981678009,
                "z": -308.6333923339844
            },
            {
                "x": 16.664701461791992,
                "y": 0.06063501909375191,
                "z": -308.4757080078125
            },
            {
                "x": 16.669775009155273,
                "y": 0.05517840385437012,
                "z": -308.31805419921875
            },
            {
                "x": 16.674528121948242,
                "y": 0.049961354583501816,
                "z": -308.1605224609375
            },
            {
                "x": 16.678878784179688,
                "y": 0.04497116804122925,
                "z": -308.0027160644531
            },
            {
                "x": 16.6812686920166,
                "y": 0.0418664775788784,
                "z": -307.90069580078125
            },
            {
                "x": 16.684507369995117,
                "y": 0.037277255207300186,
                "z": -307.742919921875
            },
            {
                "x": 16.68731117248535,
                "y": 0.03293558582663536,
                "z": -307.58526611328125
            },
            {
                "x": 16.689790725708008,
                "y": 0.02883826196193695,
                "z": -307.4275207519531
            },
            {
                "x": 16.69173812866211,
                "y": 0.02499298006296158,
                "z": -307.2696228027344
            },
            {
                "x": 16.692996978759766,
                "y": 0.021410519257187843,
                "z": -307.1116027832031
            },
            {
                "x": 16.69371795654297,
                "y": 0.01809559389948845,
                "z": -306.95391845703125
            },
            {
                "x": 16.694107055664062,
                "y": 0.015044012106955051,
                "z": -306.7962951660156
            },
            {
                "x": 16.694047927856445,
                "y": 0.012253847904503345,
                "z": -306.6382141113281
            },
            {
                "x": 16.693307876586914,
                "y": 0.009747233241796494,
                "z": -306.48016357421875
            },
            {
                "x": 16.691944122314453,
                "y": 0.00751801673322916,
                "z": -306.3222351074219
            },
            {
                "x": 16.690181732177734,
                "y": 0.005570031702518463,
                "z": -306.16455078125
            },
            {
                "x": 16.688045501708984,
                "y": 0.003905376186594367,
                "z": -306.00677490234375
            },
            {
                "x": 16.68527603149414,
                "y": 0.002534704515710473,
                "z": -305.8485412597656
            },
            {
                "x": 16.681827545166016,
                "y": 0.001457349513657391,
                "z": -305.69061279296875
            },
            {
                "x": 16.67787742614746,
                "y": 0.0006751101464033127,
                "z": -305.5330505371094
            },
            {
                "x": 16.673583984375,
                "y": 0.00019164755940437317,
                "z": -305.3753356933594
            },
            {
                "x": 16.668750762939453,
                "y": 1.862191129475832e-05,
                "z": -305.2174377441406
            },
            {
                "x": 16.663209915161133,
                "y": 1.0125339031219482e-05,
                "z": -305.0593566894531
            },
            {
                "x": 16.65706443786621,
                "y": 5.200505256652832e-06,
                "z": -304.9015808105469
            },
            {
                "x": 16.650556564331055,
                "y": 2.7939677238464355e-07,
                "z": -304.7441101074219
            },
            {
                "x": 16.64359474182129,
                "y": -4.630535840988159e-06,
                "z": -304.5863952636719
            },
            {
                "x": 16.63595199584961,
                "y": -9.544193744659424e-06,
                "z": -304.428466796875
            },
            {
                "x": 16.62763214111328,
                "y": -1.4446675777435303e-05,
                "z": -304.27081298828125
            },
            {
                "x": 16.61884880065918,
                "y": -1.9375234842300415e-05,
                "z": -304.1131591796875
            },
            {
                "x": 16.60968780517578,
                "y": -2.428889274597168e-05,
                "z": -303.9556579589844
            },
            {
                "x": 16.59991455078125,
                "y": -2.9202550649642944e-05,
                "z": -303.7978820800781
            },
            {
                "x": 16.589412689208984,
                "y": -3.4108757972717285e-05,
                "z": -303.6401672363281
            },
            {
                "x": 16.578351974487305,
                "y": -3.9014965295791626e-05,
                "z": -303.4827880859375
            },
            {
                "x": 16.56690788269043,
                "y": -4.39472496509552e-05,
                "z": -303.32537841796875
            },
            {
                "x": 16.554962158203125,
                "y": -4.885345697402954e-05,
                "z": -303.1678161621094
            },
            {
                "x": 16.542293548583984,
                "y": -5.378201603889465e-05,
                "z": -303.0102844238281
            },
            {
                "x": 16.52895736694336,
                "y": -5.8691948652267456e-05,
                "z": -302.85284423828125
            },
            {
                "x": 16.515188217163086,
                "y": -6.360933184623718e-05,
                "z": -302.69586181640625
            },
            {
                "x": 16.501001358032227,
                "y": -6.851926445960999e-05,
                "z": -302.53857421875
            },
            {
                "x": 16.486141204833984,
                "y": -7.34180212020874e-05,
                "z": -302.38116455078125
            },
            {
                "x": 16.470556259155273,
                "y": -7.83577561378479e-05,
                "z": -302.223876953125
            },
            {
                "x": 16.45442771911621,
                "y": -8.326396346092224e-05,
                "z": -302.06689453125
            },
            {
                "x": 16.437942504882812,
                "y": -8.817017078399658e-05,
                "z": -301.9100646972656
            },
            {
                "x": 16.420883178710938,
                "y": -9.309500455856323e-05,
                "z": -301.75299072265625
            },
            {
                "x": 16.403039932250977,
                "y": -9.80086624622345e-05,
                "z": -301.59576416015625
            },
            {
                "x": 16.384571075439453,
                "y": -0.00010292604565620422,
                "z": -301.43902587890625
            },
            {
                "x": 16.365718841552734,
                "y": -0.00010783225297927856,
                "z": -301.282470703125
            },
            {
                "x": 16.353309631347656,
                "y": -0.00011105462908744812,
                "z": -301.1812744140625
            },
            {
                "x": 16.333524703979492,
                "y": -0.00011594966053962708,
                "z": -301.0244140625
            },
            {
                "x": 16.312957763671875,
                "y": -0.00012088194489479065,
                "z": -300.8676452636719
            },
            {
                "x": 16.29182243347168,
                "y": -0.00012576580047607422,
                "z": -300.711181640625
            },
            {
                "x": 16.27033233642578,
                "y": -0.0001306980848312378,
                "z": -300.55499267578125
            },
            {
                "x": 16.248273849487305,
                "y": -0.00013561174273490906,
                "z": -300.3984069824219
            },
            {
                "x": 16.225460052490234,
                "y": -0.00014052540063858032,
                "z": -300.24200439453125
            },
            {
                "x": 16.201969146728516,
                "y": -0.00014543533325195312,
                "z": -300.0858459472656
            },
            {
                "x": 16.178020477294922,
                "y": -0.0001503489911556244,
                "z": -299.9298095703125
            },
            {
                "x": 16.15366554260254,
                "y": -0.00015527009963989258,
                "z": -299.77386474609375
            },
            {
                "x": 16.12859344482422,
                "y": -0.00016017630696296692,
                "z": -299.61773681640625
            },
            {
                "x": 16.102754592895508,
                "y": -0.00016508996486663818,
                "z": -299.4617614746094
            },
            {
                "x": 16.07639503479004,
                "y": -0.0001700073480606079,
                "z": -299.3062744140625
            },
            {
                "x": 16.049623489379883,
                "y": -0.0001749284565448761,
                "z": -299.1506652832031
            },
            {
                "x": 16.022287368774414,
                "y": -0.0001798495650291443,
                "z": -298.99505615234375
            },
            {
                "x": 15.994168281555176,
                "y": -0.0001847483217716217,
                "z": -298.8394470214844
            },
            {
                "x": 15.965360641479492,
                "y": -0.0001896694302558899,
                "z": -298.68408203125
            },
            {
                "x": 15.936174392700195,
                "y": -0.00019459053874015808,
                "z": -298.5291442871094
            },
            {
                "x": 15.906500816345215,
                "y": -0.00019953027367591858,
                "z": -298.3740234375
            },
            {
                "x": 15.876097679138184,
                "y": -0.00020442157983779907,
                "z": -298.21875
            },
            {
                "x": 15.84495735168457,
                "y": -0.00020933151245117188,
                "z": -298.06378173828125
            },
            {
                "x": 15.813286781311035,
                "y": -0.00021423399448394775,
                "z": -297.90924072265625
            },
            {
                "x": 15.781235694885254,
                "y": -0.0002191588282585144,
                "z": -297.7548522949219
            },
            {
                "x": 15.748583793640137,
                "y": -0.0002240687608718872,
                "z": -297.60028076171875
            },
            {
                "x": 15.71509838104248,
                "y": -0.00022900104522705078,
                "z": -297.4455261230469
            },
            {
                "x": 15.681001663208008,
                "y": -0.00023390725255012512,
                "z": -297.2913818359375
            },
            {
                "x": 15.646493911743164,
                "y": -0.00023882463574409485,
                "z": -297.13751220703125
            },
            {
                "x": 15.61151123046875,
                "y": -0.00024374574422836304,
                "z": -296.9834899902344
            },
            {
                "x": 15.575810432434082,
                "y": -0.0002486482262611389,
                "z": -296.8294677734375
            },
            {
                "x": 15.539297103881836,
                "y": -0.0002535805106163025,
                "z": -296.675537109375
            },
            {
                "x": 15.502320289611816,
                "y": -0.0002585016191005707,
                "z": -296.522216796875
            },
            {
                "x": 15.464975357055664,
                "y": -0.0002634003758430481,
                "z": -296.3689880371094
            },
            {
                "x": 15.426977157592773,
                "y": -0.0002683103084564209,
                "z": -296.21551513671875
            },
            {
                "x": 15.388222694396973,
                "y": -0.0002732276916503906,
                "z": -296.0622253417969
            },
            {
                "x": 15.348759651184082,
                "y": -0.0002781525254249573,
                "z": -295.9092102050781
            },
            {
                "x": 15.308932304382324,
                "y": -0.00028307363390922546,
                "z": -295.756591796875
            },
            {
                "x": 15.268669128417969,
                "y": -0.00028797611594200134,
                "z": -295.60400390625
            },
            {
                "x": 15.227645874023438,
                "y": -0.0002928823232650757,
                "z": -295.4512023925781
            },
            {
                "x": 15.185859680175781,
                "y": -0.00029780156910419464,
                "z": -295.2987976074219
            },
            {
                "x": 15.143579483032227,
                "y": -0.0003027282655239105,
                "z": -295.1468200683594
            },
            {
                "x": 15.100873947143555,
                "y": -0.00030764006078243256,
                "z": -294.99481201171875
            },
            {
                "x": 15.057640075683594,
                "y": -0.00031255558133125305,
                "z": -294.8428955078125
            },
            {
                "x": 15.013616561889648,
                "y": -0.0003174692392349243,
                "z": -294.6910095214844
            },
            {
                "x": 14.984794616699219,
                "y": -0.00032067298889160156,
                "z": -294.59307861328125
            },
            {
                "x": 14.939826965332031,
                "y": -0.00032558292150497437,
                "z": -294.44195556640625
            },
            {
                "x": 14.894469261169434,
                "y": -0.00033048540353775024,
                "z": -294.290771484375
            },
            {
                "x": 14.848481178283691,
                "y": -0.00033542513847351074,
                "z": -294.1395263671875
            },
            {
                "x": 14.801750183105469,
                "y": -0.0003403276205062866,
                "z": -293.9884948730469
            },
            {
                "x": 14.7543306350708,
                "y": -0.0003452245146036148,
                "z": -293.8377990722656
            },
            {
                "x": 14.70653247833252,
                "y": -0.0003501400351524353,
                "z": -293.6875305175781
            },
            {
                "x": 14.658320426940918,
                "y": -0.0003550741821527481,
                "z": -293.537353515625
            },
            {
                "x": 14.609358787536621,
                "y": -0.0003599841147661209,
                "z": -293.3868713378906
            },
            {
                "x": 14.559699058532715,
                "y": -0.00036490336060523987,
                "z": -293.23681640625
            },
            {
                "x": 14.509472846984863,
                "y": -0.0003697983920574188,
                "z": -293.08721923828125
            },
            {
                "x": 14.45889663696289,
                "y": -0.0003747232258319855,
                "z": -292.93780517578125
            },
            {
                "x": 14.407815933227539,
                "y": -0.0003796406090259552,
                "z": -292.7884521484375
            },
            {
                "x": 14.355912208557129,
                "y": -0.00038454867899417877,
                "z": -292.63885498046875
            },
            {
                "x": 14.303357124328613,
                "y": -0.00038945116102695465,
                "z": -292.48992919921875
            },
            {
                "x": 14.250384330749512,
                "y": -0.00039438530802726746,
                "z": -292.3414306640625
            },
            {
                "x": 14.197000503540039,
                "y": -0.00039928779006004333,
                "z": -292.1929016113281
            },
            {
                "x": 14.143045425415039,
                "y": -0.00040419958531856537,
                "z": -292.0444030761719
            },
            {
                "x": 14.088290214538574,
                "y": -0.0004115456249564886,
                "z": -291.89605712890625
            },
            {
                "x": 14.032891273498535,
                "y": -0.0006437029223889112,
                "z": -291.7480773925781
            },
            {
                "x": 13.977182388305664,
                "y": -0.0014497980009764433,
                "z": -291.6006164550781
            },
            {
                "x": 13.921083450317383,
                "y": -0.0028360001742839813,
                "z": -291.45318603515625
            },
            {
                "x": 13.864275932312012,
                "y": -0.004818419460207224,
                "z": -291.3057556152344
            },
            {
                "x": 13.806726455688477,
                "y": -0.007365087047219276,
                "z": -291.15863037109375
            },
            {
                "x": 13.748600006103516,
                "y": -0.010460475459694862,
                "z": -291.0116882324219
            },
            {
                "x": 13.690240859985352,
                "y": -0.014086450450122356,
                "z": -290.8653259277344
            },
            {
                "x": 13.631353378295898,
                "y": -0.018266182392835617,
                "z": -290.7189636230469
            },
            {
                "x": 13.571752548217773,
                "y": -0.022973643615841866,
                "z": -290.5726013183594
            },
            {
                "x": 13.51150131225586,
                "y": -0.02818443812429905,
                "z": -290.4266662597656
            },
            {
                "x": 13.450716972351074,
                "y": -0.0338897630572319,
                "z": -290.281005859375
            },
            {
                "x": 13.389699935913086,
                "y": -0.04008539393544197,
                "z": -290.1358642578125
            },
            {
                "x": 13.328171730041504,
                "y": -0.04676970839500427,
                "z": -289.9906005859375
            },
            {
                "x": 13.265892028808594,
                "y": -0.05392962321639061,
                "z": -289.8453674316406
            },
            {
                "x": 13.203062057495117,
                "y": -0.06153033301234245,
                "z": -289.7007751464844
            },
            {
                "x": 13.139835357666016,
                "y": -0.06957893073558807,
                "z": -289.5564880371094
            },
            {
                "x": 13.076300621032715,
                "y": -0.07806470990180969,
                "z": -289.4123229980469
            },
            {
                "x": 13.012245178222656,
                "y": -0.08697713911533356,
                "z": -289.268310546875
            },
            {
                "x": 12.947522163391113,
                "y": -0.09630723297595978,
                "z": -289.12445068359375
            },
            {
                "x": 12.882392883300781,
                "y": -0.10602734237909317,
                "z": -288.9810791015625
            },
            {
                "x": 12.817033767700195,
                "y": -0.11612717807292938,
                "z": -288.8381042480469
            },
            {
                "x": 12.751224517822266,
                "y": -0.12662705779075623,
                "z": -288.6949462890625
            },
            {
                "x": 12.68497371673584,
                "y": -0.13748517632484436,
                "z": -288.5521240234375
            },
            {
                "x": 12.618269920349121,
                "y": -0.14869624376296997,
                "z": -288.4096374511719
            },
            {
                "x": 12.575052261352539,
                "y": -0.1561199277639389,
                "z": -288.31781005859375
            },
            {
                "x": 12.507951736450195,
                "y": -0.16788065433502197,
                "z": -288.1757507324219
            },
            {
                "x": 12.440378189086914,
                "y": -0.17998529970645905,
                "z": -288.0336608886719
            },
            {
                "x": 12.372432708740234,
                "y": -0.19240936636924744,
                "z": -287.891845703125
            },
            {
                "x": 12.304348945617676,
                "y": -0.2051207423210144,
                "z": -287.7503662109375
            },
            {
                "x": 12.235884666442871,
                "y": -0.21813595294952393,
                "z": -287.6089172363281
            },
            {
                "x": 12.167338371276855,
                "y": -0.23140284419059753,
                "z": -287.4678649902344
            },
            {
                "x": 12.098654747009277,
                "y": -0.2449568510055542,
                "z": -287.326904296875
            },
            {
                "x": 12.029741287231445,
                "y": -0.258781760931015,
                "z": -287.1858215332031
            },
            {
                "x": 11.960888862609863,
                "y": -0.2728274464607239,
                "z": -287.04510498046875
            },
            {
                "x": 11.891902923583984,
                "y": -0.2871209681034088,
                "z": -286.9043273925781
            },
            {
                "x": 11.822848320007324,
                "y": -0.3016436696052551,
                "z": -286.763671875
            },
            {
                "x": 11.753718376159668,
                "y": -0.3163822293281555,
                "z": -286.6230773925781
            },
            {
                "x": 11.684429168701172,
                "y": -0.3313400149345398,
                "z": -286.482421875
            },
            {
                "x": 11.615167617797852,
                "y": -0.34647321701049805,
                "z": -286.34197998046875
            },
            {
                "x": 11.545820236206055,
                "y": -0.3617924451828003,
                "z": -286.2015686035156
            },
            {
                "x": 11.476387023925781,
                "y": -0.377293199300766,
                "z": -286.0611877441406
            },
            {
                "x": 11.406947135925293,
                "y": -0.3929457664489746,
                "z": -285.9209289550781
            },
            {
                "x": 11.337417602539062,
                "y": -0.40875792503356934,
                "z": -285.7806091308594
            },
            {
                "x": 11.267728805541992,
                "y": -0.42472243309020996,
                "z": -285.6402893066406
            },
            {
                "x": 11.198076248168945,
                "y": -0.4407960772514343,
                "z": -285.50018310546875
            },
            {
                "x": 11.128347396850586,
                "y": -0.4569949805736542,
                "z": -285.36016845703125
            },
            {
                "x": 11.058589935302734,
                "y": -0.4732949435710907,
                "z": -285.2200927734375
            },
            {
                "x": 10.988764762878418,
                "y": -0.48969632387161255,
                "z": -285.0801086425781
            },
            {
                "x": 10.918785095214844,
                "y": -0.5062111616134644,
                "z": -284.9399719238281
            },
            {
                "x": 10.848864555358887,
                "y": -0.522773027420044,
                "z": -284.80010986328125
            },
            {
                "x": 10.778875350952148,
                "y": -0.5394116640090942,
                "z": -284.6601867675781
            },
            {
                "x": 10.708845138549805,
                "y": -0.5561034083366394,
                "z": -284.520263671875
            },
            {
                "x": 10.638775825500488,
                "y": -0.5728377103805542,
                "z": -284.38043212890625
            },
            {
                "x": 10.56860637664795,
                "y": -0.5896239876747131,
                "z": -284.2404479980469
            },
            {
                "x": 10.498475074768066,
                "y": -0.606411874294281,
                "z": -284.1006774902344
            },
            {
                "x": 10.428301811218262,
                "y": -0.6232119202613831,
                "z": -283.96099853515625
            },
            {
                "x": 10.358059883117676,
                "y": -0.6400256156921387,
                "z": -283.82110595703125
            },
            {
                "x": 10.28782844543457,
                "y": -0.6568209528923035,
                "z": -283.681396484375
            },
            {
                "x": 10.217516899108887,
                "y": -0.6736025214195251,
                "z": -283.5416564941406
            },
            {
                "x": 10.147205352783203,
                "y": -0.690353274345398,
                "z": -283.4018859863281
            },
            {
                "x": 10.076948165893555,
                "y": -0.7070513963699341,
                "z": -283.2622985839844
            },
            {
                "x": 10.006563186645508,
                "y": -0.7237151861190796,
                "z": -283.12249755859375
            },
            {
                "x": 9.936250686645508,
                "y": -0.7402976751327515,
                "z": -282.9828186035156
            },
            {
                "x": 9.865942001342773,
                "y": -0.7568097114562988,
                "z": -282.8432312011719
            },
            {
                "x": 9.795520782470703,
                "y": -0.7732610702514648,
                "z": -282.703369140625
            },
            {
                "x": 9.72518539428711,
                "y": -0.7896022796630859,
                "z": -282.5636291503906
            },
            {
                "x": 9.654803276062012,
                "y": -0.8058335781097412,
                "z": -282.4239807128906
            },
            {
                "x": 9.60934066772461,
                "y": -0.8162615299224854,
                "z": -282.333740234375
            },
            {
                "x": 9.538972854614258,
                "y": -0.8322967290878296,
                "z": -282.1940612792969
            },
            {
                "x": 9.468557357788086,
                "y": -0.8482053279876709,
                "z": -282.05426025390625
            },
            {
                "x": 9.398160934448242,
                "y": -0.8639698624610901,
                "z": -281.91448974609375
            },
            {
                "x": 9.32781982421875,
                "y": -0.8795745372772217,
                "z": -281.7747802734375
            },
            {
                "x": 9.257452011108398,
                "y": -0.8950201272964478,
                "z": -281.6348876953125
            },
            {
                "x": 9.187174797058105,
                "y": -0.9102710485458374,
                "z": -281.4952087402344
            },
            {
                "x": 9.116905212402344,
                "y": -0.9253429770469666,
                "z": -281.3553771972656
            },
            {
                "x": 9.04658317565918,
                "y": -0.9402347803115845,
                "z": -281.2153625488281
            },
            {
                "x": 8.976348876953125,
                "y": -0.9549053907394409,
                "z": -281.07550048828125
            },
            {
                "x": 8.906150817871094,
                "y": -0.9693493843078613,
                "z": -280.9355163574219
            },
            {
                "x": 8.835986137390137,
                "y": -0.9835675954818726,
                "z": -280.7955322265625
            },
            {
                "x": 8.765897750854492,
                "y": -0.9975398778915405,
                "z": -280.65557861328125
            },
            {
                "x": 8.695706367492676,
                "y": -1.0112860202789307,
                "z": -280.5152893066406
            },
            {
                "x": 8.625714302062988,
                "y": -1.024735927581787,
                "z": -280.3752746582031
            },
            {
                "x": 8.555773735046387,
                "y": -1.037914514541626,
                "z": -280.23516845703125
            },
            {
                "x": 8.4857816696167,
                "y": -1.0508248805999756,
                "z": -280.0948486328125
            },
            {
                "x": 8.415947914123535,
                "y": -1.0634276866912842,
                "z": -279.9546813964844
            },
            {
                "x": 8.346128463745117,
                "y": -1.0757219791412354,
                "z": -279.8143310546875
            },
            {
                "x": 8.276402473449707,
                "y": -1.087702751159668,
                "z": -279.67388916015625
            },
            {
                "x": 8.206769943237305,
                "y": -1.099348545074463,
                "z": -279.5335388183594
            },
            {
                "x": 8.13722038269043,
                "y": -1.110660195350647,
                "z": -279.39306640625
            },
            {
                "x": 8.067739486694336,
                "y": -1.1216092109680176,
                "z": -279.25262451171875
            },
            {
                "x": 7.998364448547363,
                "y": -1.1321980953216553,
                "z": -279.1120300292969
            },
            {
                "x": 7.928974628448486,
                "y": -1.1424334049224854,
                "z": -278.97119140625
            },
            {
                "x": 7.859769821166992,
                "y": -1.1522738933563232,
                "z": -278.8304443359375
            },
            {
                "x": 7.790616512298584,
                "y": -1.1617166996002197,
                "z": -278.6896057128906
            },
            {
                "x": 7.721610069274902,
                "y": -1.1707468032836914,
                "z": -278.5487365722656
            },
            {
                "x": 7.652707099914551,
                "y": -1.1793633699417114,
                "z": -278.40777587890625
            },
            {
                "x": 7.583858966827393,
                "y": -1.1875643730163574,
                "z": -278.2666015625
            },
            {
                "x": 7.515209674835205,
                "y": -1.1953119039535522,
                "z": -278.1255187988281
            },
            {
                "x": 7.44667387008667,
                "y": -1.2026019096374512,
                "z": -277.9843444824219
            },
            {
                "x": 7.378215312957764,
                "y": -1.2094413042068481,
                "z": -277.84295654296875
            },
            {
                "x": 7.309950351715088,
                "y": -1.215806484222412,
                "z": -277.70166015625
            },
            {
                "x": 7.241754531860352,
                "y": -1.2216894626617432,
                "z": -277.5600891113281
            },
            {
                "x": 7.173727512359619,
                "y": -1.2270655632019043,
                "z": -277.41851806640625
            },
            {
                "x": 7.105900764465332,
                "y": -1.231938123703003,
                "z": -277.2769775390625
            },
            {
                "x": 7.038150310516357,
                "y": -1.2363026142120361,
                "z": -277.1352233886719
            },
            {
                "x": 6.9706268310546875,
                "y": -1.2401328086853027,
                "z": -276.9934387207031
            },
            {
                "x": 6.903236389160156,
                "y": -1.2434117794036865,
                "z": -276.85162353515625
            },
            {
                "x": 6.835975646972656,
                "y": -1.2461495399475098,
                "z": -276.7095031738281
            },
            {
                "x": 6.768932819366455,
                "y": -1.2483291625976562,
                "z": -276.5674743652344
            },
            {
                "x": 6.702123165130615,
                "y": -1.2499332427978516,
                "z": -276.4254455566406
            },
            {
                "x": 6.659037113189697,
                "y": -1.2506470680236816,
                "z": -276.3335266113281
            },
            {
                "x": 6.592530250549316,
                "y": -1.2512843608856201,
                "z": -276.1913146972656
            },
            {
                "x": 6.526157379150391,
                "y": -1.2513247728347778,
                "z": -276.048828125
            },
            {
                "x": 6.459994316101074,
                "y": -1.250742793083191,
                "z": -275.9063415527344
            },
            {
                "x": 6.394069194793701,
                "y": -1.2495760917663574,
                "z": -275.7638244628906
            },
            {
                "x": 6.3282999992370605,
                "y": -1.2478344440460205,
                "z": -275.62115478515625
            },
            {
                "x": 6.262767314910889,
                "y": -1.2455278635025024,
                "z": -275.4783935546875
            },
            {
                "x": 6.1975202560424805,
                "y": -1.2426457405090332,
                "z": -275.335693359375
            },
            {
                "x": 6.1323699951171875,
                "y": -1.2392157316207886,
                "z": -275.192626953125
            },
            {
                "x": 6.067575931549072,
                "y": -1.2352628707885742,
                "z": -275.0497741699219
            },
            {
                "x": 6.002962112426758,
                "y": -1.230785846710205,
                "z": -274.9066467285156
            },
            {
                "x": 5.938605785369873,
                "y": -1.2257776260375977,
                "z": -274.7635192871094
            },
            {
                "x": 5.874557018280029,
                "y": -1.2202731370925903,
                "z": -274.62030029296875
            },
            {
                "x": 5.810613632202148,
                "y": -1.2142754793167114,
                "z": -274.476806640625
            },
            {
                "x": 5.7470173835754395,
                "y": -1.2078083753585815,
                "z": -274.3334045410156
            },
            {
                "x": 5.683664798736572,
                "y": -1.2008572816848755,
                "z": -274.1899719238281
            },
            {
                "x": 5.620593547821045,
                "y": -1.1934475898742676,
                "z": -274.0462951660156
            },
            {
                "x": 5.557755470275879,
                "y": -1.1855974197387695,
                "z": -273.9026184082031
            },
            {
                "x": 5.495217323303223,
                "y": -1.177316665649414,
                "z": -273.75885009765625
            },
            {
                "x": 5.432908535003662,
                "y": -1.1685937643051147,
                "z": -273.6148986816406
            },
            {
                "x": 5.370974063873291,
                "y": -1.1594676971435547,
                "z": -273.4709777832031
            },
            {
                "x": 5.309275150299072,
                "y": -1.1499419212341309,
                "z": -273.3269348144531
            },
            {
                "x": 5.2479071617126465,
                "y": -1.1400325298309326,
                "z": -273.1828918457031
            },
            {
                "x": 5.186795711517334,
                "y": -1.129730224609375,
                "z": -273.0386962890625
            },
            {
                "x": 5.125941276550293,
                "y": -1.1190470457077026,
                "z": -272.8941955566406
            },
            {
                "x": 5.065387725830078,
                "y": -1.1080193519592285,
                "z": -272.749755859375
            },
            {
                "x": 5.005193710327148,
                "y": -1.0966520309448242,
                "z": -272.60528564453125
            },
            {
                "x": 4.945230960845947,
                "y": -1.0849342346191406,
                "z": -272.4606018066406
            },
            {
                "x": 4.885672092437744,
                "y": -1.0729012489318848,
                "z": -272.3159484863281
            },
            {
                "x": 4.826291561126709,
                "y": -1.0605342388153076,
                "z": -272.1709289550781
            },
            {
                "x": 4.767340183258057,
                "y": -1.0478918552398682,
                "z": -272.0260925292969
            },
            {
                "x": 4.708652019500732,
                "y": -1.0349442958831787,
                "z": -271.8810729980469
            },
            {
                "x": 4.650308132171631,
                "y": -1.0217126607894897,
                "z": -271.73590087890625
            },
            {
                "x": 4.592313766479492,
                "y": -1.0082168579101562,
                "z": -271.5906982421875
            },
            {
                "x": 4.534606456756592,
                "y": -0.9944629669189453,
                "z": -271.4453430175781
            },
            {
                "x": 4.477250099182129,
                "y": -0.9804540872573853,
                "z": -271.2998046875
            },
            {
                "x": 4.420229911804199,
                "y": -0.9662156105041504,
                "z": -271.1543273925781
            },
            {
                "x": 4.36352014541626,
                "y": -0.9517394304275513,
                "z": -271.008544921875
            },
            {
                "x": 4.307172775268555,
                "y": -0.937067449092865,
                "z": -270.8629150390625
            },
            {
                "x": 4.251185417175293,
                "y": -0.922184944152832,
                "z": -270.7170104980469
            },
            {
                "x": 4.195429801940918,
                "y": -0.9070860147476196,
                "z": -270.5708923339844
            },
            {
                "x": 4.1401495933532715,
                "y": -0.8918274641036987,
                "z": -270.4248962402344
            },
            {
                "x": 4.085160255432129,
                "y": -0.876397967338562,
                "z": -270.2787170410156
            },
            {
                "x": 4.04984188079834,
                "y": -0.8663444519042969,
                "z": -270.18426513671875
            },
            {
                "x": 3.9954466819763184,
                "y": -0.8506485223770142,
                "z": -270.037841796875
            },
            {
                "x": 3.941403388977051,
                "y": -0.8348157405853271,
                "z": -269.89141845703125
            },
            {
                "x": 3.8876795768737793,
                "y": -0.8188327550888062,
                "z": -269.7446594238281
            },
            {
                "x": 3.8343586921691895,
                "y": -0.8027515411376953,
                "z": -269.5980224609375
            },
            {
                "x": 3.7813634872436523,
                "y": -0.7865346670150757,
                "z": -269.45111083984375
            },
            {
                "x": 3.7287380695343018,
                "y": -0.7702380418777466,
                "z": -269.30419921875
            },
            {
                "x": 3.676516532897949,
                "y": -0.7538485527038574,
                "z": -269.15716552734375
            },
            {
                "x": 3.624518394470215,
                "y": -0.7373577356338501,
                "z": -269.00982666015625
            },
            {
                "x": 3.573030710220337,
                "y": -0.7208210229873657,
                "z": -268.862548828125
            },
            {
                "x": 3.521817207336426,
                "y": -0.704218864440918,
                "z": -268.715087890625
            },
            {
                "x": 3.471036911010742,
                "y": -0.687572717666626,
                "z": -268.5675048828125
            },
            {
                "x": 3.420553207397461,
                "y": -0.6708922386169434,
                "z": -268.41986083984375
            },
            {
                "x": 3.3704817295074463,
                "y": -0.654171347618103,
                "z": -268.2720031738281
            },
            {
                "x": 3.3207638263702393,
                "y": -0.6374459266662598,
                "z": -268.1240539550781
            },
            {
                "x": 3.2714664936065674,
                "y": -0.6207283735275269,
                "z": -267.9761047363281
            },
            {
                "x": 3.222459316253662,
                "y": -0.6039912104606628,
                "z": -267.8278503417969
            },
            {
                "x": 3.173889398574829,
                "y": -0.5872968435287476,
                "z": -267.6796569824219
            },
            {
                "x": 3.1256566047668457,
                "y": -0.5706082582473755,
                "z": -267.5311584472656
            },
            {
                "x": 3.0777533054351807,
                "y": -0.5539630651473999,
                "z": -267.38262939453125
            },
            {
                "x": 3.0303280353546143,
                "y": -0.5373748540878296,
                "z": -267.2340087890625
            },
            {
                "x": 2.9832003116607666,
                "y": -0.520847499370575,
                "z": -267.08526611328125
            },
            {
                "x": 2.936528444290161,
                "y": -0.5043933987617493,
                "z": -266.9364013671875
            },
            {
                "x": 2.89016056060791,
                "y": -0.48801422119140625,
                "z": -266.7874450683594
            },
            {
                "x": 2.8441708087921143,
                "y": -0.4717082977294922,
                "z": -266.6381530761719
            },
            {
                "x": 2.7985446453094482,
                "y": -0.4555128216743469,
                "z": -266.4888610839844
            },
            {
                "x": 2.7533321380615234,
                "y": -0.43943774700164795,
                "z": -266.3395080566406
            },
            {
                "x": 2.708467960357666,
                "y": -0.42347365617752075,
                "z": -266.18988037109375
            },
            {
                "x": 2.6640055179595947,
                "y": -0.4076578617095947,
                "z": -266.040283203125
            },
            {
                "x": 2.6198692321777344,
                "y": -0.39195483922958374,
                "z": -265.8903503417969
            },
            {
                "x": 2.576150894165039,
                "y": -0.376438170671463,
                "z": -265.7404479980469
            },
            {
                "x": 2.532862901687622,
                "y": -0.36108434200286865,
                "z": -265.5904541015625
            },
            {
                "x": 2.489828109741211,
                "y": -0.34588712453842163,
                "z": -265.4402160644531
            },
            {
                "x": 2.447279930114746,
                "y": -0.3308948576450348,
                "z": -265.28997802734375
            },
            {
                "x": 2.405015468597412,
                "y": -0.3160821199417114,
                "z": -265.1394348144531
            },
            {
                "x": 2.3631949424743652,
                "y": -0.3014938235282898,
                "z": -264.98895263671875
            },
            {
                "x": 2.3217525482177734,
                "y": -0.2871173024177551,
                "z": -264.8382263183594
            },
            {
                "x": 2.280639886856079,
                "y": -0.27296674251556396,
                "z": -264.6875
            },
            {
                "x": 2.2399649620056152,
                "y": -0.25906020402908325,
                "z": -264.5364990234375
            },
            {
                "x": 2.199615955352783,
                "y": -0.24541278183460236,
                "z": -264.3855895996094
            },
            {
                "x": 2.159660816192627,
                "y": -0.2320055514574051,
                "z": -264.2342529296875
            },
            {
                "x": 2.12003755569458,
                "y": -0.2188761979341507,
                "z": -264.0830078125
            },
            {
                "x": 2.080885648727417,
                "y": -0.20604296028614044,
                "z": -263.93170166015625
            },
            {
                "x": 2.055762529373169,
                "y": -0.19790291786193848,
                "z": -263.83380126953125
            },
            {
                "x": 2.0171401500701904,
                "y": -0.1855483204126358,
                "z": -263.6822509765625
            },
            {
                "x": 1.978928804397583,
                "y": -0.17349591851234436,
                "z": -263.5304870605469
            },
            {
                "x": 1.9410195350646973,
                "y": -0.16177088022232056,
                "z": -263.3785095214844
            },
            {
                "x": 1.9035792350769043,
                "y": -0.15038853883743286,
                "z": -263.2266845703125
            },
            {
                "x": 1.86643385887146,
                "y": -0.13932786881923676,
                "z": -263.0744323730469
            },
            {
                "x": 1.8296842575073242,
                "y": -0.1286315619945526,
                "z": -262.9223327636719
            },
            {
                "x": 1.7933610677719116,
                "y": -0.11830522119998932,
                "z": -262.77001953125
            },
            {
                "x": 1.757285237312317,
                "y": -0.10833989083766937,
                "z": -262.617431640625
            },
            {
                "x": 1.7217053174972534,
                "y": -0.09877278655767441,
                "z": -262.4649963378906
            },
            {
                "x": 1.686396837234497,
                "y": -0.089585080742836,
                "z": -262.312255859375
            },
            {
                "x": 1.6515071392059326,
                "y": -0.08082325756549835,
                "z": -262.15948486328125
            },
            {
                "x": 1.6169779300689697,
                "y": -0.07247529923915863,
                "z": -262.0065612792969
            },
            {
                "x": 1.5827422142028809,
                "y": -0.06454554200172424,
                "z": -261.853515625
            },
            {
                "x": 1.548964500427246,
                "y": -0.05705772712826729,
                "z": -261.7004699707031
            },
            {
                "x": 1.5154767036437988,
                "y": -0.05002790316939354,
                "z": -261.5472412109375
            },
            {
                "x": 1.4824087619781494,
                "y": -0.0434611439704895,
                "z": -261.39398193359375
            },
            {
                "x": 1.4496723413467407,
                "y": -0.037359099835157394,
                "z": -261.2406005859375
            },
            {
                "x": 1.417284607887268,
                "y": -0.03173510357737541,
                "z": -261.087158203125
            },
            {
                "x": 1.3852957487106323,
                "y": -0.026609141379594803,
                "z": -260.9334716796875
            },
            {
                "x": 1.35361909866333,
                "y": -0.021994132548570633,
                "z": -260.77984619140625
            },
            {
                "x": 1.3223648071289062,
                "y": -0.017888354137539864,
                "z": -260.62615966796875
            },
            {
                "x": 1.2914035320281982,
                "y": -0.0142982704564929,
                "z": -260.4723205566406
            },
            {
                "x": 1.260830283164978,
                "y": -0.0112539641559124,
                "z": -260.31854248046875
            },
            {
                "x": 1.2305951118469238,
                "y": -0.008756216615438461,
                "z": -260.1643371582031
            },
            {
                "x": 1.2006804943084717,
                "y": -0.006812097039073706,
                "z": -260.01031494140625
            },
            {
                "x": 1.1711819171905518,
                "y": -0.005428097676485777,
                "z": -259.8561706542969
            },
            {
                "x": 1.141959547996521,
                "y": -0.004628458991646767,
                "z": -259.7018127441406
            },
            {
                "x": 1.1131250858306885,
                "y": -0.004404851701110601,
                "z": -259.547607421875
            },
            {
                "x": 1.084625005722046,
                "y": -0.004405586048960686,
                "z": -259.3930358886719
            },
            {
                "x": 1.056438684463501,
                "y": -0.004406429827213287,
                "z": -259.23858642578125
            },
            {
                "x": 1.028670072555542,
                "y": -0.004407268017530441,
                "z": -259.0841979980469
            },
            {
                "x": 1.0011911392211914,
                "y": -0.004408104345202446,
                "z": -258.92950439453125
            },
            {
                "x": 0.9740631580352783,
                "y": -0.004408933222293854,
                "z": -258.77496337890625
            },
            {
                "x": 0.9472957849502563,
                "y": -0.004409778863191605,
                "z": -258.62017822265625
            },
            {
                "x": 0.920791506767273,
                "y": -0.004410622641444206,
                "z": -258.4653625488281
            },
            {
                "x": 0.8947233557701111,
                "y": -0.004411458969116211,
                "z": -258.31060791015625
            },
            {
                "x": 0.8689330220222473,
                "y": -0.004412291571497917,
                "z": -258.1556091308594
            },
            {
                "x": 0.8434547185897827,
                "y": -0.0044131409376859665,
                "z": -258.00079345703125
            },
            {
                "x": 0.8183776140213013,
                "y": -0.004413967952132225,
                "z": -257.8458557128906
            },
            {
                "x": 0.7935271263122559,
                "y": -0.004414813593029976,
                "z": -257.69061279296875
            },
            {
                "x": 0.7690736055374146,
                "y": -0.0044156406074762344,
                "z": -257.5356140136719
            },
            {
                "x": 0.7449461817741394,
                "y": -0.004416484385728836,
                "z": -257.3804626464844
            },
            {
                "x": 0.7294906973838806,
                "y": -0.00441703200340271,
                "z": -257.28021240234375
            },
            {
                "x": 0.7058925032615662,
                "y": -0.004417868331074715,
                "z": -257.1250915527344
            },
            {
                "x": 0.682600200176239,
                "y": -0.004418700933456421,
                "z": -256.9696960449219
            },
            {
                "x": 0.6595638990402222,
                "y": -0.0044195447117090225,
                "z": -256.8143615722656
            },
            {
                "x": 0.6369462013244629,
                "y": -0.004420377314090729,
                "z": -256.6590881347656
            },
            {
                "x": 0.6145772933959961,
                "y": -0.00442122109234333,
                "z": -256.5035095214844
            },
            {
                "x": 0.5925083756446838,
                "y": -0.0044220611453056335,
                "z": -256.3481140136719
            },
            {
                "x": 0.570820152759552,
                "y": -0.0044228918850421906,
                "z": -256.192626953125
            },
            {
                "x": 0.5493436455726624,
                "y": -0.004423726350069046,
                "z": -256.0368347167969
            },
            {
                "x": 0.5282282829284668,
                "y": -0.004424571990966797,
                "z": -255.88133239746094
            },
            {
                "x": 0.5074296593666077,
                "y": -0.004425406455993652,
                "z": -255.72561645507812
            },
            {
                "x": 0.4868639409542084,
                "y": -0.004426250234246254,
                "z": -255.56991577148438
            },
            {
                "x": 0.46668070554733276,
                "y": -0.00442708283662796,
                "z": -255.41424560546875
            },
            {
                "x": 0.44674450159072876,
                "y": -0.004427909851074219,
                "z": -255.2582550048828
            },
            {
                "x": 0.42708709836006165,
                "y": -0.004428759217262268,
                "z": -255.10247802734375
            },
            {
                "x": 0.4077922999858856,
                "y": -0.004429589956998825,
                "z": -254.9467010498047
            },
            {
                "x": 0.38873153924942017,
                "y": -0.004430433735251427,
                "z": -254.7906494140625
            },
            {
                "x": 0.36996975541114807,
                "y": -0.00443127378821373,
                "z": -254.6348114013672
            },
            {
                "x": 0.35154107213020325,
                "y": -0.0044321101158857346,
                "z": -254.4788055419922
            },
            {
                "x": 0.3333265781402588,
                "y": -0.004432953894138336,
                "z": -254.32266235351562
            },
            {
                "x": 0.3154405951499939,
                "y": -0.004433786496520042,
                "z": -254.16673278808594
            },
            {
                "x": 0.29787901043891907,
                "y": -0.004434624686837196,
                "z": -254.01071166992188
            },
            {
                "x": 0.2805216610431671,
                "y": -0.004435468465089798,
                "z": -253.85458374023438
            },
            {
                "x": 0.2634860873222351,
                "y": -0.004436297342181206,
                "z": -253.6986083984375
            },
            {
                "x": 0.24673500657081604,
                "y": -0.004437137395143509,
                "z": -253.5422821044922
            },
            {
                "x": 0.23020672798156738,
                "y": -0.004437971860170364,
                "z": -253.38607788085938
            },
            {
                "x": 0.21399837732315063,
                "y": -0.004438817501068115,
                "z": -253.22987365722656
            },
            {
                "x": 0.1980626881122589,
                "y": -0.004439651966094971,
                "z": -253.07354736328125
            },
            {
                "x": 0.18234822154045105,
                "y": -0.00444050133228302,
                "z": -252.9172821044922
            },
            {
                "x": 0.16694483160972595,
                "y": -0.00444132462143898,
                "z": -252.7608642578125
            },
            {
                "x": 0.15181490778923035,
                "y": -0.004442159086465836,
                "z": -252.60452270507812
            },
            {
                "x": 0.13689517974853516,
                "y": -0.00444299541413784,
                "z": -252.4481964111328
            },
            {
                "x": 0.12229830026626587,
                "y": -0.004443839192390442,
                "z": -252.29176330566406
            },
            {
                "x": 0.10795146226882935,
                "y": -0.004444677382707596,
                "z": -252.1352996826172
            },
            {
                "x": 0.09380760788917542,
                "y": -0.004445509985089302,
                "z": -251.97879028320312
            },
            {
                "x": 0.07998651266098022,
                "y": -0.0044463519006967545,
                "z": -251.8223419189453
            },
            {
                "x": 0.06640931963920593,
                "y": -0.004447195678949356,
                "z": -251.6658172607422
            },
            {
                "x": 0.05303514003753662,
                "y": -0.004448032006621361,
                "z": -251.50926208496094
            },
            {
                "x": 0.03998374938964844,
                "y": -0.004448859021067619,
                "z": -251.35279846191406
            },
            {
                "x": 0.027153342962265015,
                "y": -0.004449706524610519,
                "z": -251.1962127685547
            },
            {
                "x": 0.014521926641464233,
                "y": -0.004450546577572823,
                "z": -251.0395050048828
            },
            {
                "x": 0.002215743064880371,
                "y": -0.00445137545466423,
                "z": -250.88296508789062
            },
            {
                "x": -0.009872585535049438,
                "y": -0.004452221095561981,
                "z": -250.726318359375
            },
            {
                "x": -0.0175856351852417,
                "y": -0.004452761262655258,
                "z": -250.62518310546875
            },
            {
                "x": -0.02927464246749878,
                "y": -0.004453603178262711,
                "z": -250.4685821533203
            },
            {
                "x": -0.04070505499839783,
                "y": -0.00445442833006382,
                "z": -250.3118438720703
            },
            {
                "x": -0.051966339349746704,
                "y": -0.004455279558897018,
                "z": -250.15505981445312
            },
            {
                "x": -0.06294915080070496,
                "y": -0.0044561102986335754,
                "z": -249.99844360351562
            },
            {
                "x": -0.07366353273391724,
                "y": -0.00445694662630558,
                "z": -249.84164428710938
            },
            {
                "x": -0.08420558273792267,
                "y": -0.00445779412984848,
                "z": -249.6848602294922
            },
            {
                "x": -0.09449884295463562,
                "y": -0.004458624869585037,
                "z": -249.52822875976562
            },
            {
                "x": -0.1045255959033966,
                "y": -0.004459451884031296,
                "z": -249.3712615966797
            },
            {
                "x": -0.11436691880226135,
                "y": -0.004460299387574196,
                "z": -249.2144775390625
            },
            {
                "x": -0.12398795783519745,
                "y": -0.0044611357152462006,
                "z": -249.0576934814453
            },
            {
                "x": -0.13332827389240265,
                "y": -0.004461977630853653,
                "z": -248.90086364746094
            },
            {
                "x": -0.1424836665391922,
                "y": -0.004462819546461105,
                "z": -248.7440185546875
            },
            {
                "x": -0.1514492928981781,
                "y": -0.004463654011487961,
                "z": -248.58702087402344
            },
            {
                "x": -0.16012629866600037,
                "y": -0.004464495927095413,
                "z": -248.4302215576172
            },
            {
                "x": -0.16861480474472046,
                "y": -0.00446532666683197,
                "z": -248.27333068847656
            },
            {
                "x": -0.176930233836174,
                "y": -0.004466172307729721,
                "z": -248.11636352539062
            },
            {
                "x": -0.1849629282951355,
                "y": -0.0044670067727565765,
                "z": -247.95953369140625
            },
            {
                "x": -0.19279266893863678,
                "y": -0.004467839375138283,
                "z": -247.80252075195312
            },
            {
                "x": -0.20046764612197876,
                "y": -0.004468673840165138,
                "z": -247.6455078125
            },
            {
                "x": -0.20788495242595673,
                "y": -0.0044695306569337845,
                "z": -247.48861694335938
            },
            {
                "x": -0.21506129205226898,
                "y": -0.00447036512196064,
                "z": -247.33172607421875
            },
            {
                "x": -0.22209513187408447,
                "y": -0.004471190273761749,
                "z": -247.17474365234375
            },
            {
                "x": -0.22890807688236237,
                "y": -0.004472039639949799,
                "z": -247.01785278320312
            },
            {
                "x": -0.23547488451004028,
                "y": -0.004472872242331505,
                "z": -246.8607177734375
            },
            {
                "x": -0.24187543988227844,
                "y": -0.004473702982068062,
                "z": -246.7037353515625
            },
            {
                "x": -0.24809372425079346,
                "y": -0.004474552348256111,
                "z": -246.5467529296875
            },
            {
                "x": -0.25405824184417725,
                "y": -0.004475390538573265,
                "z": -246.38973999023438
            },
            {
                "x": -0.25983989238739014,
                "y": -0.004476215690374374,
                "z": -246.23269653320312
            },
            {
                "x": -0.26547136902809143,
                "y": -0.004477059468626976,
                "z": -246.07553100585938
            },
            {
                "x": -0.2708563208580017,
                "y": -0.004477892071008682,
                "z": -245.9185791015625
            },
            {
                "x": -0.2760317623615265,
                "y": -0.004478735849261284,
                "z": -245.7615203857422
            },
            {
                "x": -0.28107595443725586,
                "y": -0.004479574039578438,
                "z": -245.60438537597656
            },
            {
                "x": -0.2859034836292267,
                "y": -0.004480412229895592,
                "z": -245.44735717773438
            },
            {
                "x": -0.29049867391586304,
                "y": -0.004481244832277298,
                "z": -245.29025268554688
            },
            {
                "x": -0.29494813084602356,
                "y": -0.004482081159949303,
                "z": -245.13311767578125
            },
            {
                "x": -0.2992323935031891,
                "y": -0.004482932388782501,
                "z": -244.97608947753906
            },
            {
                "x": -0.3032737970352173,
                "y": -0.004483761265873909,
                "z": -244.81895446777344
            },
            {
                "x": -0.3071332573890686,
                "y": -0.0044845957309007645,
                "z": -244.66188049316406
            },
            {
                "x": -0.310863733291626,
                "y": -0.004485437646508217,
                "z": -244.50477600097656
            },
            {
                "x": -0.3143894672393799,
                "y": -0.0044862814247608185,
                "z": -244.3475799560547
            },
            {
                "x": -0.3176852762699127,
                "y": -0.004487115889787674,
                "z": -244.19052124023438
            },
            {
                "x": -0.3207938075065613,
                "y": -0.004487676080316305,
                "z": -244.0334014892578
            },
            {
                "x": -0.3228214383125305,
                "y": -0.00448849331587553,
                "z": -243.9319305419922
            },
            {
                "x": -0.32567328214645386,
                "y": -0.004489331506192684,
                "z": -243.77490234375
            },
            {
                "x": -0.3283271789550781,
                "y": -0.004490175284445286,
                "z": -243.61773681640625
            },
            {
                "x": -0.3308587670326233,
                "y": -0.004491010680794716,
                "z": -243.46051025390625
            },
            {
                "x": -0.3332217335700989,
                "y": -0.004491857253015041,
                "z": -243.30343627929688
            },
            {
                "x": -0.3353568911552429,
                "y": -0.0044926842674613,
                "z": -243.146240234375
            },
            {
                "x": -0.3373391926288605,
                "y": -0.004493517801165581,
                "z": -242.9890594482422
            },
            {
                "x": -0.3391963839530945,
                "y": -0.00449435506016016,
                "z": -242.8319549560547
            },
            {
                "x": -0.34086087346076965,
                "y": -0.004495200701057911,
                "z": -242.67466735839844
            },
            {
                "x": -0.34233227372169495,
                "y": -0.004496034234762192,
                "z": -242.5175323486328
            },
            {
                "x": -0.3436918258666992,
                "y": -0.004496877081692219,
                "z": -242.36033630371094
            },
            {
                "x": -0.34490638971328735,
                "y": -0.0044977106153965,
                "z": -242.2031707763672
            },
            {
                "x": -0.34596067667007446,
                "y": -0.004498550668358803,
                "z": -242.04603576660156
            },
            {
                "x": -0.3469250798225403,
                "y": -0.004499389789998531,
                "z": -241.88864135742188
            },
            {
                "x": -0.3478071689605713,
                "y": -0.004500223323702812,
                "z": -241.7314910888672
            },
            {
                "x": -0.34859979152679443,
                "y": -0.004501065239310265,
                "z": -241.57424926757812
            },
            {
                "x": -0.3493950664997101,
                "y": -0.004501905292272568,
                "z": -241.41690063476562
            },
            {
                "x": -0.3502557575702667,
                "y": -0.004502740688621998,
                "z": -241.2596435546875
            },
            {
                "x": -0.35113266110420227,
                "y": -0.004503576084971428,
                "z": -241.10227966308594
            },
            {
                "x": -0.3521207273006439,
                "y": -0.004504416137933731,
                "z": -240.94482421875
            },
            {
                "x": -0.35330450534820557,
                "y": -0.004505247808992863,
                "z": -240.7874755859375
            },
            {
                "x": -0.3546471893787384,
                "y": -0.004506091587245464,
                "z": -240.63015747070312
            },
            {
                "x": -0.3561697006225586,
                "y": -0.004506925120949745,
                "z": -240.47274780273438
            },
            {
                "x": -0.3579753041267395,
                "y": -0.004507764242589474,
                "z": -240.31533813476562
            },
            {
                "x": -0.36002635955810547,
                "y": -0.004508603364229202,
                "z": -240.1577911376953
            },
            {
                "x": -0.36226075887680054,
                "y": -0.004509449936449528,
                "z": -240.0004119873047
            },
            {
                "x": -0.3647923469543457,
                "y": -0.004461691714823246,
                "z": -239.84291076660156
            },
            {
                "x": -0.3676419258117676,
                "y": -0.004190290812402964,
                "z": -239.6855010986328
            },
            {
                "x": -0.3706936538219452,
                "y": -0.003672536928206682,
                "z": -239.52816772460938
            },
            {
                "x": -0.3739851415157318,
                "y": -0.0029025268740952015,
                "z": -239.3705596923828
            },
            {
                "x": -0.37762102484703064,
                "y": -0.0018889263737946749,
                "z": -239.21315002441406
            },
            {
                "x": -0.38153135776519775,
                "y": -0.0006393317598849535,
                "z": -239.05581665039062
            },
            {
                "x": -0.38563108444213867,
                "y": 0.0008447524160146713,
                "z": -238.89837646484375
            },
            {
                "x": -0.3900336027145386,
                "y": 0.002565339906141162,
                "z": -238.74098205566406
            },
            {
                "x": -0.39478468894958496,
                "y": 0.0045182774774730206,
                "z": -238.58352661132812
            },
            {
                "x": -0.39974820613861084,
                "y": 0.006693252362310886,
                "z": -238.4261932373047
            },
            {
                "x": -0.4049381613731384,
                "y": 0.009088566526770592,
                "z": -238.2688446044922
            },
            {
                "x": -0.4104885458946228,
                "y": 0.011708765290677547,
                "z": -238.11138916015625
            },
            {
                "x": -0.41632387042045593,
                "y": 0.014543039724230766,
                "z": -237.95416259765625
            },
            {
                "x": -0.42235255241394043,
                "y": 0.0175882987678051,
                "z": -237.79689025878906
            },
            {
                "x": -0.4286930561065674,
                "y": 0.020845452323555946,
                "z": -237.63938903808594
            },
            {
                "x": -0.4353781044483185,
                "y": 0.02430625818669796,
                "z": -237.48216247558594
            },
            {
                "x": -0.44228100776672363,
                "y": 0.02797069400548935,
                "z": -237.32496643066406
            },
            {
                "x": -0.4468574523925781,
                "y": 0.030441172420978546,
                "z": -237.2234344482422
            },
            {
                "x": -0.4542344808578491,
                "y": 0.0344296470284462,
                "z": -237.066162109375
            },
            {
                "x": -0.46194931864738464,
                "y": 0.038616955280303955,
                "z": -236.90890502929688
            },
            {
                "x": -0.46986353397369385,
                "y": 0.04299147427082062,
                "z": -236.75169372558594
            },
            {
                "x": -0.4780524969100952,
                "y": 0.04754924401640892,
                "z": -236.59451293945312
            },
            {
                "x": -0.48661261796951294,
                "y": 0.05229344218969345,
                "z": -236.43728637695312
            },
            {
                "x": -0.4954155385494232,
                "y": 0.0572168342769146,
                "z": -236.2802276611328
            },
            {
                "x": -0.5044459104537964,
                "y": 0.0623156800866127,
                "z": -236.12313842773438
            },
            {
                "x": -0.5138459801673889,
                "y": 0.0675937682390213,
                "z": -235.96585083007812
            },
            {
                "x": -0.5235336422920227,
                "y": 0.07303126156330109,
                "z": -235.80885314941406
            },
            {
                "x": -0.5334349870681763,
                "y": 0.07864269614219666,
                "z": -235.65179443359375
            },
            {
                "x": -0.5436654090881348,
                "y": 0.0844176858663559,
                "z": -235.49468994140625
            },
            {
                "x": -0.5542333722114563,
                "y": 0.09034507721662521,
                "z": -235.33778381347656
            },
            {
                "x": -0.5650268793106079,
                "y": 0.09643366187810898,
                "z": -235.18069458007812
            },
            {
                "x": -0.5761001110076904,
                "y": 0.1026749238371849,
                "z": -235.02374267578125
            },
            {
                "x": -0.5875405073165894,
                "y": 0.10906343907117844,
                "z": -234.86685180664062
            },
            {
                "x": -0.5992348194122314,
                "y": 0.11559783667325974,
                "z": -234.7099151611328
            },
            {
                "x": -0.6111565828323364,
                "y": 0.12226971983909607,
                "z": -234.5531005859375
            },
            {
                "x": -0.6234729290008545,
                "y": 0.12909221649169922,
                "z": -234.3961639404297
            },
            {
                "x": -0.6360741853713989,
                "y": 0.13604429364204407,
                "z": -234.2393341064453
            },
            {
                "x": -0.6488803625106812,
                "y": 0.14312335848808289,
                "z": -234.08262634277344
            },
            {
                "x": -0.6620336771011353,
                "y": 0.1503329873085022,
                "z": -233.9258575439453
            },
            {
                "x": -0.6755340099334717,
                "y": 0.1576685607433319,
                "z": -233.76919555664062
            },
            {
                "x": -0.6892410516738892,
                "y": 0.1651233732700348,
                "z": -233.61260986328125
            },
            {
                "x": -0.7032795548439026,
                "y": 0.17270749807357788,
                "z": -233.45578002929688
            },
            {
                "x": -0.7176657915115356,
                "y": 0.18039637804031372,
                "z": -233.29916381835938
            },
            {
                "x": -0.7322831749916077,
                "y": 0.1881968379020691,
                "z": -233.14266967773438
            },
            {
                "x": -0.7471901178359985,
                "y": 0.19610965251922607,
                "z": -232.986083984375
            },
            {
                "x": -0.7624698877334595,
                "y": 0.2041248381137848,
                "z": -232.82957458496094
            },
            {
                "x": -0.7780082821846008,
                "y": 0.21224361658096313,
                "z": -232.67300415039062
            },
            {
                "x": -0.7937968969345093,
                "y": 0.22045662999153137,
                "z": -232.51658630371094
            },
            {
                "x": -0.8099698424339294,
                "y": 0.2287658452987671,
                "z": -232.3601531982422
            },
            {
                "x": -0.8264197111129761,
                "y": 0.23716521263122559,
                "z": -232.20376586914062
            },
            {
                "x": -0.8430978059768677,
                "y": 0.24564875662326813,
                "z": -232.04747009277344
            },
            {
                "x": -0.8601677417755127,
                "y": 0.25422394275665283,
                "z": -231.89105224609375
            },
            {
                "x": -0.8775349855422974,
                "y": 0.26287633180618286,
                "z": -231.73477172851562
            },
            {
                "x": -0.8951160907745361,
                "y": 0.2716006636619568,
                "z": -231.57861328125
            },
            {
                "x": -0.9130733013153076,
                "y": 0.2804074287414551,
                "z": -231.42230224609375
            },
            {
                "x": -0.9313418865203857,
                "y": 0.28927433490753174,
                "z": -231.2662353515625
            },
            {
                "x": -0.949833869934082,
                "y": 0.29820942878723145,
                "z": -231.1101837158203
            },
            {
                "x": -0.9687034487724304,
                "y": 0.3072226941585541,
                "z": -230.9539031982422
            },
            {
                "x": -0.9878736734390259,
                "y": 0.31627726554870605,
                "z": -230.79800415039062
            },
            {
                "x": -1.0072729587554932,
                "y": 0.32539159059524536,
                "z": -230.6420440673828
            },
            {
                "x": -1.0199854373931885,
                "y": 0.33130943775177,
                "z": -230.5413055419922
            },
            {
                "x": -1.039967656135559,
                "y": 0.34050947427749634,
                "z": -230.3854217529297
            },
            {
                "x": -1.0602033138275146,
                "y": 0.3497585654258728,
                "z": -230.22955322265625
            },
            {
                "x": -1.0807344913482666,
                "y": 0.3590582013130188,
                "z": -230.07359313964844
            },
            {
                "x": -1.1016263961791992,
                "y": 0.3683907389640808,
                "z": -229.9178466796875
            },
            {
                "x": -1.1227827072143555,
                "y": 0.3777615427970886,
                "z": -229.7620849609375
            },
            {
                "x": -1.1441928148269653,
                "y": 0.3871638774871826,
                "z": -229.60638427734375
            },
            {
                "x": -1.1659965515136719,
                "y": 0.39659708738327026,
                "z": -229.4507598876953
            },
            {
                "x": -1.1880781650543213,
                "y": 0.4060631990432739,
                "z": -229.29502868652344
            },
            {
                "x": -1.210402011871338,
                "y": 0.4155450463294983,
                "z": -229.1394500732422
            },
            {
                "x": -1.2331103086471558,
                "y": 0.42504945397377014,
                "z": -228.98391723632812
            },
            {
                "x": -1.256081461906433,
                "y": 0.4345656931400299,
                "z": -228.82847595214844
            },
            {
                "x": -1.2793152332305908,
                "y": 0.44409555196762085,
                "z": -228.6730499267578
            },
            {
                "x": -1.3029580116271973,
                "y": 0.4536468982696533,
                "z": -228.51748657226562
            },
            {
                "x": -1.326811671257019,
                "y": 0.4631868600845337,
                "z": -228.3622589111328
            },
            {
                "x": -1.3509547710418701,
                "y": 0.47273218631744385,
                "z": -228.2069854736328
            },
            {
                "x": -1.3754912614822388,
                "y": 0.4822850823402405,
                "z": -228.0516357421875
            },
            {
                "x": -1.400247573852539,
                "y": 0.4918215274810791,
                "z": -227.8965301513672
            },
            {
                "x": -1.4253082275390625,
                "y": 0.5013606548309326,
                "z": -227.7412872314453
            },
            {
                "x": -1.450748085975647,
                "y": 0.5108855962753296,
                "z": -227.5861358642578
            },
            {
                "x": -1.476400375366211,
                "y": 0.5203855037689209,
                "z": -227.4311981201172
            },
            {
                "x": -1.502357006072998,
                "y": 0.5298731327056885,
                "z": -227.2761993408203
            },
            {
                "x": -1.5286685228347778,
                "y": 0.5393366813659668,
                "z": -227.1212921142578
            },
            {
                "x": -1.555208683013916,
                "y": 0.5487710237503052,
                "z": -226.96646118164062
            },
            {
                "x": -1.5821038484573364,
                "y": 0.5581932067871094,
                "z": -226.81141662597656
            },
            {
                "x": -1.609305739402771,
                "y": 0.5675665736198425,
                "z": -226.6566925048828
            },
            {
                "x": -1.6367369890213013,
                "y": 0.5769081115722656,
                "z": -226.50193786621094
            },
            {
                "x": -1.6645063161849976,
                "y": 0.5862137079238892,
                "z": -226.34719848632812
            },
            {
                "x": -1.6925878524780273,
                "y": 0.5954671502113342,
                "z": -226.19264221191406
            },
            {
                "x": -1.7209324836730957,
                "y": 0.6046881079673767,
                "z": -226.0378875732422
            },
            {
                "x": -1.7495815753936768,
                "y": 0.6138508915901184,
                "z": -225.8833465576172
            },
            {
                "x": -1.778541088104248,
                "y": 0.622955322265625,
                "z": -225.72894287109375
            },
            {
                "x": -1.8077479600906372,
                "y": 0.6320093870162964,
                "z": -225.57444763183594
            },
            {
                "x": -1.8372972011566162,
                "y": 0.6410009860992432,
                "z": -225.4200439453125
            },
            {
                "x": -1.8671265840530396,
                "y": 0.6499295234680176,
                "z": -225.2657012939453
            },
            {
                "x": -1.8972010612487793,
                "y": 0.6587917804718018,
                "z": -225.11135864257812
            },
            {
                "x": -1.9276303052902222,
                "y": 0.6675784587860107,
                "z": -224.9571533203125
            },
            {
                "x": -1.9583112001419067,
                "y": 0.6762920618057251,
                "z": -224.80296325683594
            },
            {
                "x": -1.989242672920227,
                "y": 0.6849271059036255,
                "z": -224.6488494873047
            },
            {
                "x": -2.0205228328704834,
                "y": 0.693480372428894,
                "z": -224.4947967529297
            },
            {
                "x": -2.052065134048462,
                "y": 0.7019534707069397,
                "z": -224.34068298339844
            },
            {
                "x": -2.083868980407715,
                "y": 0.7103331089019775,
                "z": -224.1867218017578
            },
            {
                "x": -2.1159884929656982,
                "y": 0.7186182737350464,
                "z": -224.03289794921875
            },
            {
                "x": -2.136841297149658,
                "y": 0.7239177227020264,
                "z": -223.93356323242188
            },
            {
                "x": -2.169376850128174,
                "y": 0.732043445110321,
                "z": -223.77975463867188
            },
            {
                "x": -2.2022619247436523,
                "y": 0.740073561668396,
                "z": -223.62596130371094
            },
            {
                "x": -2.235351324081421,
                "y": 0.7479981184005737,
                "z": -223.4722137451172
            },
            {
                "x": -2.2687337398529053,
                "y": 0.7558081150054932,
                "z": -223.318603515625
            },
            {
                "x": -2.302433490753174,
                "y": 0.763510525226593,
                "z": -223.16497802734375
            },
            {
                "x": -2.3363211154937744,
                "y": 0.771093487739563,
                "z": -223.011474609375
            },
            {
                "x": -2.3705334663391113,
                "y": 0.7785605192184448,
                "z": -222.85801696777344
            },
            {
                "x": -2.4050426483154297,
                "y": 0.7859069108963013,
                "z": -222.70449829101562
            },
            {
                "x": -2.4397497177124023,
                "y": 0.7931220531463623,
                "z": -222.55111694335938
            },
            {
                "x": -2.4747872352600098,
                "y": 0.8002111911773682,
                "z": -222.39781188964844
            },
            {
                "x": -2.5100295543670654,
                "y": 0.8071660399436951,
                "z": -222.24456787109375
            },
            {
                "x": -2.5455503463745117,
                "y": 0.8139824867248535,
                "z": -222.09133911132812
            },
            {
                "x": -2.581403970718384,
                "y": 0.8206638097763062,
                "z": -221.93807983398438
            },
            {
                "x": -2.617400646209717,
                "y": 0.8271939754486084,
                "z": -221.78504943847656
            },
            {
                "x": -2.65370512008667,
                "y": 0.8335813283920288,
                "z": -221.6320037841797
            },
            {
                "x": -2.69028377532959,
                "y": 0.8398170471191406,
                "z": -221.47900390625
            },
            {
                "x": -2.727053165435791,
                "y": 0.8458939790725708,
                "z": -221.32611083984375
            },
            {
                "x": -2.7641513347625732,
                "y": 0.8518189191818237,
                "z": -221.17318725585938
            },
            {
                "x": -2.8014473915100098,
                "y": 0.8575831651687622,
                "z": -221.02035522460938
            },
            {
                "x": -2.838982582092285,
                "y": 0.8631772994995117,
                "z": -220.8676300048828
            },
            {
                "x": -2.8767857551574707,
                "y": 0.8686001300811768,
                "z": -220.71499633789062
            },
            {
                "x": -2.9147770404815674,
                "y": 0.8738530874252319,
                "z": -220.56239318847656
            },
            {
                "x": -2.95304536819458,
                "y": 0.8789334893226624,
                "z": -220.4098358154297
            },
            {
                "x": -2.9915881156921387,
                "y": 0.8838366270065308,
                "z": -220.25718688964844
            },
            {
                "x": -3.030297040939331,
                "y": 0.8885512351989746,
                "z": -220.10470581054688
            },
            {
                "x": -3.069277048110962,
                "y": 0.8930816054344177,
                "z": -219.95228576660156
            },
            {
                "x": -3.1084532737731934,
                "y": 0.8974246978759766,
                "z": -219.79991149902344
            },
            {
                "x": -3.1478676795959473,
                "y": 0.9015724658966064,
                "z": -219.64759826660156
            },
            {
                "x": -3.1875627040863037,
                "y": 0.905523419380188,
                "z": -219.49522399902344
            },
            {
                "x": -3.2273900508880615,
                "y": 0.9092721939086914,
                "z": -219.34304809570312
            },
            {
                "x": -3.267477512359619,
                "y": 0.9128199815750122,
                "z": -219.19093322753906
            },
            {
                "x": -3.307772159576416,
                "y": 0.9161596298217773,
                "z": -219.03878784179688
            },
            {
                "x": -3.348266124725342,
                "y": 0.9192842245101929,
                "z": -218.88673400878906
            },
            {
                "x": -3.3890154361724854,
                "y": 0.9221973419189453,
                "z": -218.73468017578125
            },
            {
                "x": -3.4299116134643555,
                "y": 0.9248946905136108,
                "z": -218.5826873779297
            },
            {
                "x": -3.471036434173584,
                "y": 0.9273682832717896,
                "z": -218.4308319091797
            },
            {
                "x": -3.512359380722046,
                "y": 0.9296126365661621,
                "z": -218.27894592285156
            },
            {
                "x": -3.553838014602661,
                "y": 0.9316302537918091,
                "z": -218.12718200683594
            },
            {
                "x": -3.595543622970581,
                "y": 0.9334185123443604,
                "z": -217.97549438476562
            },
            {
                "x": -3.637460231781006,
                "y": 0.9349722862243652,
                "z": -217.8236541748047
            },
            {
                "x": -3.679534912109375,
                "y": 0.9362795352935791,
                "z": -217.67208862304688
            },
            {
                "x": -3.72178316116333,
                "y": 0.9373464584350586,
                "z": -217.5205535888672
            },
            {
                "x": -3.7491517066955566,
                "y": 0.9379111528396606,
                "z": -217.4226837158203
            },
            {
                "x": -3.7917001247406006,
                "y": 0.9385677576065063,
                "z": -217.27122497558594
            },
            {
                "x": -3.834439516067505,
                "y": 0.9389750957489014,
                "z": -217.1197509765625
            },
            {
                "x": -3.877321720123291,
                "y": 0.9391299486160278,
                "z": -216.96827697753906
            },
            {
                "x": -3.920380115509033,
                "y": 0.9390288591384888,
                "z": -216.81698608398438
            },
            {
                "x": -3.9635908603668213,
                "y": 0.9386622905731201,
                "z": -216.66563415527344
            },
            {
                "x": -4.0069661140441895,
                "y": 0.938046395778656,
                "z": -216.51438903808594
            },
            {
                "x": -4.050485134124756,
                "y": 0.9371843338012695,
                "z": -216.36325073242188
            },
            {
                "x": -4.094196319580078,
                "y": 0.936077356338501,
                "z": -216.21189880371094
            },
            {
                "x": -4.138026237487793,
                "y": 0.9347214698791504,
                "z": -216.06088256835938
            },
            {
                "x": -4.181984901428223,
                "y": 0.933128833770752,
                "z": -215.90977478027344
            },
            {
                "x": -4.226094722747803,
                "y": 0.9313040375709534,
                "z": -215.7587432861328
            },
            {
                "x": -4.270312309265137,
                "y": 0.9292511343955994,
                "z": -215.60781860351562
            },
            {
                "x": -4.314724445343018,
                "y": 0.926958441734314,
                "z": -215.45669555664062
            },
            {
                "x": -4.359221935272217,
                "y": 0.9244471192359924,
                "z": -215.30589294433594
            },
            {
                "x": -4.403812408447266,
                "y": 0.921717643737793,
                "z": -215.15509033203125
            },
            {
                "x": -4.4485697746276855,
                "y": 0.9187703132629395,
                "z": -215.00418090820312
            },
            {
                "x": -4.4933929443359375,
                "y": 0.9156051874160767,
                "z": -214.8534698486328
            },
            {
                "x": -4.5383620262146,
                "y": 0.9122283458709717,
                "z": -214.70266723632812
            },
            {
                "x": -4.58345365524292,
                "y": 0.9086474180221558,
                "z": -214.5519256591797
            },
            {
                "x": -4.628587245941162,
                "y": 0.9048683047294617,
                "z": -214.40133666992188
            },
            {
                "x": -4.673836708068848,
                "y": 0.9008828997612,
                "z": -214.2507781982422
            },
            {
                "x": -4.719176769256592,
                "y": 0.8967025876045227,
                "z": -214.1002197265625
            },
            {
                "x": -4.764596462249756,
                "y": 0.8923319578170776,
                "z": -213.94972229003906
            },
            {
                "x": -4.810164928436279,
                "y": 0.8877688050270081,
                "z": -213.79905700683594
            },
            {
                "x": -4.855741500854492,
                "y": 0.8830205202102661,
                "z": -213.64862060546875
            },
            {
                "x": -4.901423454284668,
                "y": 0.878088653087616,
                "z": -213.49815368652344
            },
            {
                "x": -4.947169780731201,
                "y": 0.8729809522628784,
                "z": -213.3477325439453
            },
            {
                "x": -4.992964744567871,
                "y": 0.867701530456543,
                "z": -213.1973876953125
            },
            {
                "x": -5.038886070251465,
                "y": 0.8622395992279053,
                "z": -213.046875
            },
            {
                "x": -5.084778785705566,
                "y": 0.8566174507141113,
                "z": -212.8965606689453
            },
            {
                "x": -5.130751609802246,
                "y": 0.8508315086364746,
                "z": -212.74627685546875
            },
            {
                "x": -5.176787853240967,
                "y": 0.844883143901825,
                "z": -212.59591674804688
            },
            {
                "x": -5.2228312492370605,
                "y": 0.8387774229049683,
                "z": -212.4456787109375
            },
            {
                "x": -5.268947124481201,
                "y": 0.8325145244598389,
                "z": -212.29539489746094
            },
            {
                "x": -5.315085411071777,
                "y": 0.8261035680770874,
                "z": -212.14511108398438
            },
            {
                "x": -5.361236572265625,
                "y": 0.8195500373840332,
                "z": -211.99493408203125
            },
            {
                "x": -5.40742301940918,
                "y": 0.8128471374511719,
                "z": -211.84466552734375
            },
            {
                "x": -5.4536027908325195,
                "y": 0.8060086965560913,
                "z": -211.69451904296875
            },
            {
                "x": -5.499802589416504,
                "y": 0.7990339994430542,
                "z": -211.5443878173828
            },
            {
                "x": -5.54606294631958,
                "y": 0.7919206619262695,
                "z": -211.39407348632812
            },
            {
                "x": -5.592263221740723,
                "y": 0.784684419631958,
                "z": -211.24395751953125
            },
            {
                "x": -5.638471603393555,
                "y": 0.7773209810256958,
                "z": -211.09384155273438
            },
            {
                "x": -5.668310165405273,
                "y": 0.7725019454956055,
                "z": -210.9968719482422
            },
            {
                "x": -5.714483737945557,
                "y": 0.7649431228637695,
                "z": -210.8468017578125
            },
            {
                "x": -5.76068639755249,
                "y": 0.7572599649429321,
                "z": -210.69662475585938
            },
            {
                "x": -5.80686092376709,
                "y": 0.7494655847549438,
                "z": -210.5464630126953
            },
            {
                "x": -5.8529839515686035,
                "y": 0.7415682077407837,
                "z": -210.39639282226562
            },
            {
                "x": -5.899106502532959,
                "y": 0.7335585951805115,
                "z": -210.24618530273438
            },
            {
                "x": -5.945168972015381,
                "y": 0.725448489189148,
                "z": -210.09605407714844
            },
            {
                "x": -5.991189002990723,
                "y": 0.7172420024871826,
                "z": -209.94595336914062
            },
            {
                "x": -6.037197113037109,
                "y": 0.7089317440986633,
                "z": -209.79568481445312
            },
            {
                "x": -6.083125591278076,
                "y": 0.7005393505096436,
                "z": -209.64553833007812
            },
            {
                "x": -6.129004955291748,
                "y": 0.6920528411865234,
                "z": -209.49537658691406
            },
            {
                "x": -6.174816608428955,
                "y": 0.6834829449653625,
                "z": -209.34518432617188
            },
            {
                "x": -6.220550060272217,
                "y": 0.6748369336128235,
                "z": -209.19503784179688
            },
            {
                "x": -6.266265869140625,
                "y": 0.6661009788513184,
                "z": -209.044677734375
            },
            {
                "x": -6.311849117279053,
                "y": 0.6573001146316528,
                "z": -208.8944854736328
            },
            {
                "x": -6.357344627380371,
                "y": 0.6484295129776001,
                "z": -208.74432373046875
            },
            {
                "x": -6.4027934074401855,
                "y": 0.6394845843315125,
                "z": -208.59397888183594
            },
            {
                "x": -6.448112487792969,
                "y": 0.6304844617843628,
                "z": -208.44371032714844
            },
            {
                "x": -6.493365287780762,
                "y": 0.6214152574539185,
                "z": -208.29336547851562
            },
            {
                "x": -6.538529396057129,
                "y": 0.6122900247573853,
                "z": -208.14297485351562
            },
            {
                "x": -6.583543300628662,
                "y": 0.6031181812286377,
                "z": -207.99267578125
            },
            {
                "x": -6.628462314605713,
                "y": 0.5938972234725952,
                "z": -207.84234619140625
            },
            {
                "x": -6.673232078552246,
                "y": 0.5846284031867981,
                "z": -207.69195556640625
            },
            {
                "x": -6.717896461486816,
                "y": 0.5753161907196045,
                "z": -207.5415496826172
            },
            {
                "x": -6.762482643127441,
                "y": 0.5659542679786682,
                "z": -207.39096069335938
            },
            {
                "x": -6.806881904602051,
                "y": 0.5565667152404785,
                "z": -207.24041748046875
            },
            {
                "x": -6.8511576652526855,
                "y": 0.547144889831543,
                "z": -207.08987426757812
            },
            {
                "x": -6.895262241363525,
                "y": 0.5376931428909302,
                "z": -206.9392852783203
            },
            {
                "x": -6.939239978790283,
                "y": 0.5282182097434998,
                "z": -206.78866577148438
            },
            {
                "x": -6.983089923858643,
                "y": 0.5187125205993652,
                "z": -206.6378631591797
            },
            {
                "x": -7.026739597320557,
                "y": 0.5091972947120667,
                "z": -206.48716735839844
            },
            {
                "x": -7.070226192474365,
                "y": 0.4996683895587921,
                "z": -206.3364715576172
            },
            {
                "x": -7.113560199737549,
                "y": 0.4901210367679596,
                "z": -206.18556213378906
            },
            {
                "x": -7.156717777252197,
                "y": 0.4805721044540405,
                "z": -206.03475952148438
            },
            {
                "x": -7.199677467346191,
                "y": 0.4710138142108917,
                "z": -205.88380432128906
            },
            {
                "x": -7.242489337921143,
                "y": 0.4614534378051758,
                "z": -205.73281860351562
            },
            {
                "x": -7.285064697265625,
                "y": 0.45190155506134033,
                "z": -205.5818328857422
            },
            {
                "x": -7.327479362487793,
                "y": 0.44234830141067505,
                "z": -205.43069458007812
            },
            {
                "x": -7.369679927825928,
                "y": 0.43281352519989014,
                "z": -205.27963256835938
            },
            {
                "x": -7.411637783050537,
                "y": 0.423289954662323,
                "z": -205.1284942626953
            },
            {
                "x": -7.453477382659912,
                "y": 0.41377174854278564,
                "z": -204.97711181640625
            },
            {
                "x": -7.4950079917907715,
                "y": 0.404285728931427,
                "z": -204.8258819580078
            },
            {
                "x": -7.5363616943359375,
                "y": 0.39481985569000244,
                "z": -204.67454528808594
            },
            {
                "x": -7.5629401206970215,
                "y": 0.38872241973876953,
                "z": -204.57679748535156
            },
            {
                "x": -7.6038689613342285,
                "y": 0.37930530309677124,
                "z": -204.42539978027344
            },
            {
                "x": -7.644650459289551,
                "y": 0.3699130415916443,
                "z": -204.2738037109375
            },
            {
                "x": -7.685140132904053,
                "y": 0.3605608344078064,
                "z": -204.1221923828125
            },
            {
                "x": -7.725384712219238,
                "y": 0.35125136375427246,
                "z": -203.9705810546875
            },
            {
                "x": -7.765411376953125,
                "y": 0.3419806659221649,
                "z": -203.81883239746094
            },
            {
                "x": -7.805149555206299,
                "y": 0.33275890350341797,
                "z": -203.66708374023438
            },
            {
                "x": -7.844656944274902,
                "y": 0.32359081506729126,
                "z": -203.51528930664062
            },
            {
                "x": -7.883890628814697,
                "y": 0.3144657611846924,
                "z": -203.36322021484375
            },
            {
                "x": -7.9228644371032715,
                "y": 0.3054048418998718,
                "z": -203.2112579345703
            },
            {
                "x": -7.9615559577941895,
                "y": 0.29640358686447144,
                "z": -203.05918884277344
            },
            {
                "x": -7.999974250793457,
                "y": 0.2874653935432434,
                "z": -202.90699768066406
            },
            {
                "x": -8.03812313079834,
                "y": 0.2786009907722473,
                "z": -202.7548828125
            },
            {
                "x": -8.075989723205566,
                "y": 0.26979365944862366,
                "z": -202.60243225097656
            },
            {
                "x": -8.113580703735352,
                "y": 0.26107126474380493,
                "z": -202.4501190185547
            },
            {
                "x": -8.150823593139648,
                "y": 0.25243079662323,
                "z": -202.29774475097656
            },
            {
                "x": -8.187813758850098,
                "y": 0.24386310577392578,
                "z": -202.14515686035156
            },
            {
                "x": -8.224485397338867,
                "y": 0.23538842797279358,
                "z": -201.99266052246094
            },
            {
                "x": -8.260838508605957,
                "y": 0.22699309885501862,
                "z": -201.83990478515625
            },
            {
                "x": -8.296943664550781,
                "y": 0.21869251132011414,
                "z": -201.68711853027344
            },
            {
                "x": -8.332639694213867,
                "y": 0.21049439907073975,
                "z": -201.53436279296875
            },
            {
                "x": -8.368064880371094,
                "y": 0.20239201188087463,
                "z": -201.3814697265625
            },
            {
                "x": -8.403148651123047,
                "y": 0.19439345598220825,
                "z": -201.2285919189453
            },
            {
                "x": -8.437891006469727,
                "y": 0.1864997148513794,
                "z": -201.07554626464844
            },
            {
                "x": -8.472391128540039,
                "y": 0.17870816588401794,
                "z": -200.9222869873047
            },
            {
                "x": -8.506446838378906,
                "y": 0.17103858292102814,
                "z": -200.7691192626953
            },
            {
                "x": -8.540252685546875,
                "y": 0.16347947716712952,
                "z": -200.61582946777344
            },
            {
                "x": -8.573660850524902,
                "y": 0.15604326128959656,
                "z": -200.4624481201172
            },
            {
                "x": -8.606720924377441,
                "y": 0.14873290061950684,
                "z": -200.30902099609375
            },
            {
                "x": -8.639495849609375,
                "y": 0.14154042303562164,
                "z": -200.15536499023438
            },
            {
                "x": -8.671822547912598,
                "y": 0.13448500633239746,
                "z": -200.0017852783203
            },
            {
                "x": -8.703871726989746,
                "y": 0.12756343185901642,
                "z": -199.84812927246094
            },
            {
                "x": -8.735508918762207,
                "y": 0.120778389275074,
                "z": -199.69430541992188
            },
            {
                "x": -8.766802787780762,
                "y": 0.1141345277428627,
                "z": -199.54046630859375
            },
            {
                "x": -8.797755241394043,
                "y": 0.10763153433799744,
                "z": -199.38648986816406
            },
            {
                "x": -8.828282356262207,
                "y": 0.10127606987953186,
                "z": -199.23240661621094
            },
            {
                "x": -8.858492851257324,
                "y": 0.0950780063867569,
                "z": -199.07838439941406
            },
            {
                "x": -8.88826847076416,
                "y": 0.08902981877326965,
                "z": -198.9241485595703
            },
            {
                "x": -8.917705535888672,
                "y": 0.08314023911952972,
                "z": -198.7699432373047
            },
            {
                "x": -8.946747779846191,
                "y": 0.07741281390190125,
                "z": -198.6156768798828
            },
            {
                "x": -8.975394248962402,
                "y": 0.0718463733792305,
                "z": -198.4610595703125
            },
            {
                "x": -9.003687858581543,
                "y": 0.06645442545413971,
                "z": -198.30667114257812
            },
            {
                "x": -9.031516075134277,
                "y": 0.06123170256614685,
                "z": -198.1521453857422
            },
            {
                "x": -9.04930591583252,
                "y": 0.05795137584209442,
                "z": -198.0522918701172
            },
            {
                "x": -9.07654857635498,
                "y": 0.05302170291543007,
                "z": -197.89768981933594
            },
            {
                "x": -9.103339195251465,
                "y": 0.04826698079705238,
                "z": -197.74290466308594
            },
            {
                "x": -9.129816055297852,
                "y": 0.04369315505027771,
                "z": -197.58798217773438
            },
            {
                "x": -9.15579605102539,
                "y": 0.039317820221185684,
                "z": -197.43316650390625
            },
            {
                "x": -9.181402206420898,
                "y": 0.03512722998857498,
                "z": -197.27810668945312
            },
            {
                "x": -9.20664119720459,
                "y": 0.031131725758314133,
                "z": -197.12310791015625
            },
            {
                "x": -9.231383323669434,
                "y": 0.027331840246915817,
                "z": -196.96800231933594
            },
            {
                "x": -9.255823135375977,
                "y": 0.023733779788017273,
                "z": -196.81265258789062
            },
            {
                "x": -9.279760360717773,
                "y": 0.020344777032732964,
                "z": -196.65748596191406
            },
            {
                "x": -9.30329418182373,
                "y": 0.01715858280658722,
                "z": -196.5021209716797
            },
            {
                "x": -9.326469421386719,
                "y": 0.014181855134665966,
                "z": -196.34674072265625
            },
            {
                "x": -9.349122047424316,
                "y": 0.011425918899476528,
                "z": -196.19129943847656
            },
            {
                "x": -9.371461868286133,
                "y": 0.008883466944098473,
                "z": -196.0355987548828
            },
            {
                "x": -9.39330768585205,
                "y": 0.006563750095665455,
                "z": -195.88006591796875
            },
            {
                "x": -9.414714813232422,
                "y": 0.004464936908334494,
                "z": -195.72442626953125
            },
            {
                "x": -9.435771942138672,
                "y": 0.00259852665476501,
                "z": -195.5686798095703
            },
            {
                "x": -9.456284523010254,
                "y": 0.0009646271355450153,
                "z": -195.41297912597656
            },
            {
                "x": -9.47646713256836,
                "y": -0.00043929857201874256,
                "z": -195.257080078125
            },
            {
                "x": -9.496197700500488,
                "y": -0.0016079475171864033,
                "z": -195.10116577148438
            },
            {
                "x": -9.51543140411377,
                "y": -0.0025299079716205597,
                "z": -194.9452362060547
            },
            {
                "x": -9.53431510925293,
                "y": -0.0032072027679532766,
                "z": -194.78929138183594
            },
            {
                "x": -9.552680015563965,
                "y": -0.0036401874385774136,
                "z": -194.63327026367188
            },
            {
                "x": -9.570672035217285,
                "y": -0.0038258302956819534,
                "z": -194.47720336914062
            },
            {
                "x": -9.588241577148438,
                "y": -0.003837090451270342,
                "z": -194.32093811035156
            },
            {
                "x": -9.605279922485352,
                "y": -0.0038411226123571396,
                "z": -194.1647491455078
            },
            {
                "x": -9.621988296508789,
                "y": -0.00384515430778265,
                "z": -194.00851440429688
            },
            {
                "x": -9.63818645477295,
                "y": -0.0038491906598210335,
                "z": -193.8522491455078
            },
            {
                "x": -9.653947830200195,
                "y": -0.003853225614875555,
                "z": -193.69589233398438
            },
            {
                "x": -9.66933822631836,
                "y": -0.003857264295220375,
                "z": -193.53936767578125
            },
            {
                "x": -9.684173583984375,
                "y": -0.003861301578581333,
                "z": -193.38299560546875
            },
            {
                "x": -9.698664665222168,
                "y": -0.003865332342684269,
                "z": -193.22654724121094
            },
            {
                "x": -9.712677955627441,
                "y": -0.003869364969432354,
                "z": -193.07000732421875
            },
            {
                "x": -9.726198196411133,
                "y": -0.0038734073750674725,
                "z": -192.91346740722656
            },
            {
                "x": -9.739380836486816,
                "y": -0.0038774367421865463,
                "z": -192.75682067871094
            },
            {
                "x": -9.752031326293945,
                "y": -0.0038814693689346313,
                "z": -192.6001739501953
            },
            {
                "x": -9.764263153076172,
                "y": -0.003885506186634302,
                "z": -192.44351196289062
            },
            {
                "x": -9.776094436645508,
                "y": -0.003889543004333973,
                "z": -192.28680419921875
            },
            {
                "x": -9.787384986877441,
                "y": -0.003893575631082058,
                "z": -192.130126953125
            },
            {
                "x": -9.798334121704102,
                "y": -0.003897612914443016,
                "z": -191.97337341308594
            },
            {
                "x": -9.808807373046875,
                "y": -0.003901645541191101,
                "z": -191.8164825439453
            },
            {
                "x": -9.81877326965332,
                "y": -0.0039056818932294846,
                "z": -191.65969848632812
            },
            {
                "x": -9.828401565551758,
                "y": -0.003909694030880928,
                "z": -191.5028839111328
            },
            {
                "x": -9.834351539611816,
                "y": -0.003912344574928284,
                "z": -191.40159606933594
            },
            {
                "x": -9.843141555786133,
                "y": -0.003916377201676369,
                "z": -191.24472045898438
            },
            {
                "x": -9.851604461669922,
                "y": -0.003920406103134155,
                "z": -191.08775329589844
            },
            {
                "x": -9.859550476074219,
                "y": -0.003924447577446699,
                "z": -190.93077087402344
            },
            {
                "x": -9.867053985595703,
                "y": -0.003928481601178646,
                "z": -190.77383422851562
            },
            {
                "x": -9.874185562133789,
                "y": -0.003932520281523466,
                "z": -190.61679077148438
            },
            {
                "x": -9.880775451660156,
                "y": -0.003936548717319965,
                "z": -190.45985412597656
            },
            {
                "x": -9.886993408203125,
                "y": -0.003940585069358349,
                "z": -190.30284118652344
            },
            {
                "x": -9.892804145812988,
                "y": -0.003944616764783859,
                "z": -190.14569091796875
            },
            {
                "x": -9.898062705993652,
                "y": -0.003948655910789967,
                "z": -189.98867797851562
            },
            {
                "x": -9.902989387512207,
                "y": -0.003952691797167063,
                "z": -189.83155822753906
            },
            {
                "x": -9.907453536987305,
                "y": -0.003956730477511883,
                "z": -189.6744842529297
            },
            {
                "x": -9.911421775817871,
                "y": -0.003960758913308382,
                "z": -189.51742553710938
            },
            {
                "x": -9.915058135986328,
                "y": -0.003964798990637064,
                "z": -189.3601531982422
            },
            {
                "x": -9.91818618774414,
                "y": -0.0039688292890787125,
                "z": -189.203125
            },
            {
                "x": -9.920873641967773,
                "y": -0.003972869366407394,
                "z": -189.0460205078125
            },
            {
                "x": -9.923226356506348,
                "y": -0.003976901993155479,
                "z": -188.8887939453125
            },
            {
                "x": -9.925030708312988,
                "y": -0.003980936482548714,
                "z": -188.73171997070312
            },
            {
                "x": -9.926438331604004,
                "y": -0.003984975628554821,
                "z": -188.57449340820312
            },
            {
                "x": -9.927486419677734,
                "y": -0.003989010583609343,
                "z": -188.41726684570312
            },
            {
                "x": -9.927997589111328,
                "y": -0.0039930446073412895,
                "z": -188.26019287109375
            },
            {
                "x": -9.928122520446777,
                "y": -0.003997078165411949,
                "z": -188.1030731201172
            },
            {
                "x": -9.927850723266602,
                "y": -0.004001107066869736,
                "z": -187.94598388671875
            },
            {
                "x": -9.927041053771973,
                "y": -0.0040051378309726715,
                "z": -187.7888641357422
            },
            {
                "x": -9.925881385803223,
                "y": -0.00400918535888195,
                "z": -187.63153076171875
            },
            {
                "x": -9.924263000488281,
                "y": -0.004013213329017162,
                "z": -187.47445678710938
            },
            {
                "x": -9.922115325927734,
                "y": -0.004017253872007132,
                "z": -187.31732177734375
            },
            {
                "x": -9.919634819030762,
                "y": -0.00402127904817462,
                "z": -187.16015625
            },
            {
                "x": -9.916669845581055,
                "y": -0.004025314934551716,
                "z": -187.00311279296875
            },
            {
                "x": -9.913180351257324,
                "y": -0.00402935640886426,
                "z": -186.84580993652344
            },
            {
                "x": -9.909364700317383,
                "y": -0.004033390898257494,
                "z": -186.68873596191406
            },
            {
                "x": -9.905030250549316,
                "y": -0.00403780909255147,
                "z": -186.53170776367188
            },
            {
                "x": -9.900235176086426,
                "y": -0.004190018866211176,
                "z": -186.37454223632812
            },
            {
                "x": -9.8950777053833,
                "y": -0.004583441652357578,
                "z": -186.217529296875
            },
            {
                "x": -9.88936996459961,
                "y": -0.005194703117012978,
                "z": -186.0604248046875
            },
            {
                "x": -9.883257865905762,
                "y": -0.006020257715135813,
                "z": -185.90335083007812
            },
            {
                "x": -9.876763343811035,
                "y": -0.007056349888443947,
                "z": -185.74636840820312
            },
            {
                "x": -9.869693756103516,
                "y": -0.008310969918966293,
                "z": -185.58935546875
            },
            {
                "x": -9.862269401550293,
                "y": -0.009771091863512993,
                "z": -185.432373046875
            },
            {
                "x": -9.854409217834473,
                "y": -0.011433201842010021,
                "z": -185.2755126953125
            },
            {
                "x": -9.846010208129883,
                "y": -0.01329764723777771,
                "z": -185.11842346191406
            },
            {
                "x": -9.83727741241455,
                "y": -0.01536460779607296,
                "z": -184.9615478515625
            },
            {
                "x": -9.828047752380371,
                "y": -0.01762618124485016,
                "z": -184.8047637939453
            },
            {
                "x": -9.821821212768555,
                "y": -0.01918596401810646,
                "z": -184.7034454345703
            },
            {
                "x": -9.811906814575195,
                "y": -0.021763455122709274,
                "z": -184.5466766357422
            },
            {
                "x": -9.801513671875,
                "y": -0.024531099945306778,
                "z": -184.38986206054688
            },
            {
                "x": -9.790624618530273,
                "y": -0.02748274616897106,
                "z": -184.2330322265625
            },
            {
                "x": -9.779414176940918,
                "y": -0.030612017959356308,
                "z": -184.07635498046875
            },
            {
                "x": -9.767667770385742,
                "y": -0.03392510488629341,
                "z": -183.9196319580078
            },
            {
                "x": -9.755486488342285,
                "y": -0.0374152697622776,
                "z": -183.7629852294922
            },
            {
                "x": -9.742949485778809,
                "y": -0.041074931621551514,
                "z": -183.60643005371094
            },
            {
                "x": -9.729860305786133,
                "y": -0.04490780830383301,
                "z": -183.44970703125
            },
            {
                "x": -9.716413497924805,
                "y": -0.0489065945148468,
                "z": -183.29319763183594
            },
            {
                "x": -9.702531814575195,
                "y": -0.05307149887084961,
                "z": -183.13671875
            },
            {
                "x": -9.688140869140625,
                "y": -0.057396333664655685,
                "z": -182.98025512695312
            },
            {
                "x": -9.67342758178711,
                "y": -0.06187589466571808,
                "z": -182.82388305664062
            },
            {
                "x": -9.658203125,
                "y": -0.06651782989501953,
                "z": -182.66737365722656
            },
            {
                "x": -9.642538070678711,
                "y": -0.07130886614322662,
                "z": -182.51109313964844
            },
            {
                "x": -9.626534461975098,
                "y": -0.07624613493680954,
                "z": -182.35488891601562
            },
            {
                "x": -9.610001564025879,
                "y": -0.0813319981098175,
                "z": -182.1986083984375
            },
            {
                "x": -9.593098640441895,
                "y": -0.08655883371829987,
                "z": -182.04244995117188
            },
            {
                "x": -9.575779914855957,
                "y": -0.09193037450313568,
                "z": -181.8863067626953
            },
            {
                "x": -9.557958602905273,
                "y": -0.09743845462799072,
                "z": -181.73019409179688
            },
            {
                "x": -9.539820671081543,
                "y": -0.10307499766349792,
                "z": -181.57418823242188
            },
            {
                "x": -9.52121353149414,
                "y": -0.10884173214435577,
                "z": -181.41831970214844
            },
            {
                "x": -9.502148628234863,
                "y": -0.11474184691905975,
                "z": -181.26243591308594
            },
            {
                "x": -9.482757568359375,
                "y": -0.12076348066329956,
                "z": -181.1066131591797
            },
            {
                "x": -9.46284008026123,
                "y": -0.12691298127174377,
                "z": -180.95071411132812
            },
            {
                "x": -9.442575454711914,
                "y": -0.13317610323429108,
                "z": -180.7949676513672
            },
            {
                "x": -9.42190933227539,
                "y": -0.13955634832382202,
                "z": -180.63931274414062
            },
            {
                "x": -9.4007568359375,
                "y": -0.1460500806570053,
                "z": -180.48370361328125
            },
            {
                "x": -9.379294395446777,
                "y": -0.1526504009962082,
                "z": -180.32815551757812
            },
            {
                "x": -9.357341766357422,
                "y": -0.1593642681837082,
                "z": -180.1725311279297
            },
            {
                "x": -9.334992408752441,
                "y": -0.16617804765701294,
                "z": -180.01710510253906
            },
            {
                "x": -9.312307357788086,
                "y": -0.1730906367301941,
                "z": -179.8617706298828
            },
            {
                "x": -9.289118766784668,
                "y": -0.18010368943214417,
                "z": -179.70640563964844
            },
            {
                "x": -9.265617370605469,
                "y": -0.1872072070837021,
                "z": -179.55117797851562
            },
            {
                "x": -9.241680145263672,
                "y": -0.19440770149230957,
                "z": -179.3959503173828
            },
            {
                "x": -9.217299461364746,
                "y": -0.20169685781002045,
                "z": -179.24078369140625
            },
            {
                "x": -9.192627906799316,
                "y": -0.2090654969215393,
                "z": -179.08575439453125
            },
            {
                "x": -9.167485237121582,
                "y": -0.21651971340179443,
                "z": -178.9307403564453
            },
            {
                "x": -9.141973495483398,
                "y": -0.2240527868270874,
                "z": -178.77586364746094
            },
            {
                "x": -9.116113662719727,
                "y": -0.2316601574420929,
                "z": -178.6210479736328
            },
            {
                "x": -9.089767456054688,
                "y": -0.2393501102924347,
                "z": -178.4661102294922
            },
            {
                "x": -9.063156127929688,
                "y": -0.24709974229335785,
                "z": -178.3114013671875
            },
            {
                "x": -9.036102294921875,
                "y": -0.254917711019516,
                "z": -178.15682983398438
            },
            {
                "x": -9.018406867980957,
                "y": -0.26000267267227173,
                "z": -178.05697631835938
            },
            {
                "x": -8.990792274475098,
                "y": -0.26792341470718384,
                "z": -177.90249633789062
            },
            {
                "x": -8.96271800994873,
                "y": -0.2759092450141907,
                "z": -177.7479705810547
            },
            {
                "x": -8.93427562713623,
                "y": -0.2839526832103729,
                "z": -177.593505859375
            },
            {
                "x": -8.905537605285645,
                "y": -0.2920406460762024,
                "z": -177.4392547607422
            },
            {
                "x": -8.876335144042969,
                "y": -0.3001849055290222,
                "z": -177.28494262695312
            },
            {
                "x": -8.846847534179688,
                "y": -0.30837324261665344,
                "z": -177.1307830810547
            },
            {
                "x": -8.816972732543945,
                "y": -0.31660330295562744,
                "z": -176.97671508789062
            },
            {
                "x": -8.786678314208984,
                "y": -0.32488560676574707,
                "z": -176.822509765625
            },
            {
                "x": -8.756131172180176,
                "y": -0.33319389820098877,
                "z": -176.6685791015625
            },
            {
                "x": -8.725133895874023,
                "y": -0.3415408432483673,
                "z": -176.51467895507812
            },
            {
                "x": -8.693842887878418,
                "y": -0.3499196171760559,
                "z": -176.36080932617188
            },
            {
                "x": -8.662209510803223,
                "y": -0.35832175612449646,
                "z": -176.20713806152344
            },
            {
                "x": -8.63015079498291,
                "y": -0.36676254868507385,
                "z": -176.05328369140625
            },
            {
                "x": -8.59785270690918,
                "y": -0.37521421909332275,
                "z": -175.89968872070312
            },
            {
                "x": -8.565138816833496,
                "y": -0.38368433713912964,
                "z": -175.74624633789062
            },
            {
                "x": -8.532100677490234,
                "y": -0.39217904210090637,
                "z": -175.5926513671875
            },
            {
                "x": -8.498773574829102,
                "y": -0.40067893266677856,
                "z": -175.4393310546875
            },
            {
                "x": -8.465038299560547,
                "y": -0.4091957211494446,
                "z": -175.2859344482422
            },
            {
                "x": -8.431036949157715,
                "y": -0.4177190065383911,
                "z": -175.1326446533203
            },
            {
                "x": -8.396674156188965,
                "y": -0.42624062299728394,
                "z": -174.9794921875
            },
            {
                "x": -8.362027168273926,
                "y": -0.43476369976997375,
                "z": -174.82643127441406
            },
            {
                "x": -8.327069282531738,
                "y": -0.4432840347290039,
                "z": -174.6734619140625
            },
            {
                "x": -8.291733741760254,
                "y": -0.45179954171180725,
                "z": -174.52056884765625
            },
            {
                "x": -8.256110191345215,
                "y": -0.46031761169433594,
                "z": -174.36752319335938
            },
            {
                "x": -8.220169067382812,
                "y": -0.46881261467933655,
                "z": -174.21475219726562
            },
            {
                "x": -8.183932304382324,
                "y": -0.47729799151420593,
                "z": -174.06199645996094
            },
            {
                "x": -8.14739990234375,
                "y": -0.48576438426971436,
                "z": -173.90933227539062
            },
            {
                "x": -8.110527038574219,
                "y": -0.494208425283432,
                "z": -173.75674438476562
            },
            {
                "x": -8.073376655578613,
                "y": -0.5026393532752991,
                "z": -173.60403442382812
            },
            {
                "x": -8.035935401916504,
                "y": -0.511032223701477,
                "z": -173.45162963867188
            },
            {
                "x": -7.998213291168213,
                "y": -0.5193955898284912,
                "z": -173.29928588867188
            },
            {
                "x": -7.9601922035217285,
                "y": -0.5277318954467773,
                "z": -173.14688110351562
            },
            {
                "x": -7.921860218048096,
                "y": -0.5360281467437744,
                "z": -172.99464416503906
            },
            {
                "x": -7.883296012878418,
                "y": -0.5442895293235779,
                "z": -172.84237670898438
            },
            {
                "x": -7.844399452209473,
                "y": -0.552505612373352,
                "z": -172.69021606445312
            },
            {
                "x": -7.805270195007324,
                "y": -0.5606743097305298,
                "z": -172.5381622314453
            },
            {
                "x": -7.765862464904785,
                "y": -0.5687990784645081,
                "z": -172.38613891601562
            },
            {
                "x": -7.726168632507324,
                "y": -0.5768683552742004,
                "z": -172.2342529296875
            },
            {
                "x": -7.686254978179932,
                "y": -0.5848819017410278,
                "z": -172.08241271972656
            },
            {
                "x": -7.645989894866943,
                "y": -0.5928473472595215,
                "z": -171.9304656982422
            },
            {
                "x": -7.605536937713623,
                "y": -0.6007429957389832,
                "z": -171.77877807617188
            },
            {
                "x": -7.5648417472839355,
                "y": -0.6085752844810486,
                "z": -171.62713623046875
            },
            {
                "x": -7.538392543792725,
                "y": -0.6135967969894409,
                "z": -171.52923583984375
            },
            {
                "x": -7.497287273406982,
                "y": -0.6213161945343018,
                "z": -171.377685546875
            },
            {
                "x": -7.455912113189697,
                "y": -0.6289684772491455,
                "z": -171.22613525390625
            },
            {
                "x": -7.414266586303711,
                "y": -0.6365454196929932,
                "z": -171.0746307373047
            },
            {
                "x": -7.372454643249512,
                "y": -0.6440367698669434,
                "z": -170.9232940673828
            },
            {
                "x": -7.330330848693848,
                "y": -0.6514533758163452,
                "z": -170.7718963623047
            },
            {
                "x": -7.288049697875977,
                "y": -0.6587818264961243,
                "z": -170.62066650390625
            },
            {
                "x": -7.24552583694458,
                "y": -0.6660200357437134,
                "z": -170.4695281982422
            },
            {
                "x": -7.202719211578369,
                "y": -0.6731752157211304,
                "z": -170.3182373046875
            },
            {
                "x": -7.159779071807861,
                "y": -0.6802288293838501,
                "z": -170.1671600341797
            },
            {
                "x": -7.116568088531494,
                "y": -0.687188446521759,
                "z": -170.01611328125
            },
            {
                "x": -7.073180675506592,
                "y": -0.6940473318099976,
                "z": -169.86509704589844
            },
            {
                "x": -7.029577732086182,
                "y": -0.7007978558540344,
                "z": -169.7142333984375
            },
            {
                "x": -6.985711097717285,
                "y": -0.7074517011642456,
                "z": -169.5631866455078
            },
            {
                "x": -6.941740036010742,
                "y": -0.7139872908592224,
                "z": -169.4124298095703
            },
            {
                "x": -6.897526741027832,
                "y": -0.7204104065895081,
                "z": -169.26168823242188
            },
            {
                "x": -6.853128433227539,
                "y": -0.7267194986343384,
                "z": -169.11090087890625
            },
            {
                "x": -6.808548450469971,
                "y": -0.7329053282737732,
                "z": -168.96026611328125
            },
            {
                "x": -6.763765335083008,
                "y": -0.7389749884605408,
                "z": -168.80958557128906
            },
            {
                "x": -6.7188191413879395,
                "y": -0.7449175715446472,
                "z": -168.65896606445312
            },
            {
                "x": -6.67369270324707,
                "y": -0.7507245540618896,
                "z": -168.5084686279297
            },
            {
                "x": -6.628435134887695,
                "y": -0.7564010620117188,
                "z": -168.3580322265625
            },
            {
                "x": -6.582972526550293,
                "y": -0.7619444131851196,
                "z": -168.2076416015625
            },
            {
                "x": -6.537370681762695,
                "y": -0.7673497200012207,
                "z": -168.05726623535156
            },
            {
                "x": -6.49154806137085,
                "y": -0.7726155519485474,
                "z": -167.90676879882812
            },
            {
                "x": -6.445603370666504,
                "y": -0.777732253074646,
                "z": -167.7564697265625
            },
            {
                "x": -6.399534225463867,
                "y": -0.7827032804489136,
                "z": -167.60621643066406
            },
            {
                "x": -6.3532891273498535,
                "y": -0.7875246405601501,
                "z": -167.4559783935547
            },
            {
                "x": -6.306926727294922,
                "y": -0.7921851873397827,
                "z": -167.30581665039062
            },
            {
                "x": -6.260366439819336,
                "y": -0.7966949939727783,
                "z": -167.15553283691406
            },
            {
                "x": -6.213735103607178,
                "y": -0.8010404109954834,
                "z": -167.00543212890625
            },
            {
                "x": -6.166980743408203,
                "y": -0.8052241802215576,
                "z": -166.8553924560547
            },
            {
                "x": -6.12004280090332,
                "y": -0.8092368841171265,
                "z": -166.70526123046875
            },
            {
                "x": -6.0730414390563965,
                "y": -0.8130789995193481,
                "z": -166.55526733398438
            },
            {
                "x": -6.025876045227051,
                "y": -0.8167515993118286,
                "z": -166.4052276611328
            },
            {
                "x": -5.978608131408691,
                "y": -0.8202489614486694,
                "z": -166.2552490234375
            },
            {
                "x": -5.9312520027160645,
                "y": -0.8235580325126648,
                "z": -166.10533142089844
            },
            {
                "x": -5.883757591247559,
                "y": -0.8266878128051758,
                "z": -165.95538330078125
            },
            {
                "x": -5.836209774017334,
                "y": -0.8296313285827637,
                "z": -165.80555725097656
            },
            {
                "x": -5.788550853729248,
                "y": -0.8323881030082703,
                "z": -165.65574645996094
            },
            {
                "x": -5.74075984954834,
                "y": -0.834947943687439,
                "z": -165.5057830810547
            },
            {
                "x": -5.692938327789307,
                "y": -0.8373104333877563,
                "z": -165.3560333251953
            },
            {
                "x": -5.64501428604126,
                "y": -0.8394763469696045,
                "z": -165.20628356933594
            },
            {
                "x": -5.614038944244385,
                "y": -0.8407683968544006,
                "z": -165.1095733642578
            },
            {
                "x": -5.565996170043945,
                "y": -0.8425964117050171,
                "z": -164.9598846435547
            },
            {
                "x": -5.517858028411865,
                "y": -0.844220757484436,
                "z": -164.8101043701172
            },
            {
                "x": -5.469659805297852,
                "y": -0.8456358909606934,
                "z": -164.6603546142578
            },
            {
                "x": -5.421418190002441,
                "y": -0.8468315601348877,
                "z": -164.51071166992188
            },
            {
                "x": -5.373103618621826,
                "y": -0.8478107452392578,
                "z": -164.36097717285156
            },
            {
                "x": -5.324748516082764,
                "y": -0.8485711812973022,
                "z": -164.21136474609375
            },
            {
                "x": -5.276357650756836,
                "y": -0.8491106033325195,
                "z": -164.061767578125
            },
            {
                "x": -5.227858066558838,
                "y": -0.8494197130203247,
                "z": -163.91200256347656
            },
            {
                "x": -5.1793742179870605,
                "y": -0.8494969606399536,
                "z": -163.7624053955078
            },
            {
                "x": -5.130845069885254,
                "y": -0.8493456840515137,
                "z": -163.61279296875
            },
            {
                "x": -5.082287311553955,
                "y": -0.8489688634872437,
                "z": -163.4632110595703
            },
            {
                "x": -5.0337090492248535,
                "y": -0.848361611366272,
                "z": -163.3136444091797
            },
            {
                "x": -4.985056400299072,
                "y": -0.8475301861763,
                "z": -163.16390991210938
            },
            {
                "x": -4.936462879180908,
                "y": -0.8464828729629517,
                "z": -163.01438903808594
            },
            {
                "x": -4.887843132019043,
                "y": -0.8452224135398865,
                "z": -162.86485290527344
            },
            {
                "x": -4.839176177978516,
                "y": -0.8437445163726807,
                "z": -162.7152557373047
            },
            {
                "x": -4.790557384490967,
                "y": -0.8420559167861938,
                "z": -162.5657501220703
            },
            {
                "x": -4.741896629333496,
                "y": -0.8401621580123901,
                "z": -162.4161376953125
            },
            {
                "x": -4.693238258361816,
                "y": -0.8380675315856934,
                "z": -162.2665252685547
            },
            {
                "x": -4.644626140594482,
                "y": -0.835771381855011,
                "z": -162.1169891357422
            },
            {
                "x": -4.59604549407959,
                "y": -0.8332761526107788,
                "z": -161.96751403808594
            },
            {
                "x": -4.5474724769592285,
                "y": -0.8305890560150146,
                "z": -161.81797790527344
            },
            {
                "x": -4.498922348022461,
                "y": -0.8277145028114319,
                "z": -161.66844177246094
            },
            {
                "x": -4.450336456298828,
                "y": -0.8246458172798157,
                "z": -161.51873779296875
            },
            {
                "x": -4.401847839355469,
                "y": -0.8213942050933838,
                "z": -161.36915588378906
            },
            {
                "x": -4.353381633758545,
                "y": -0.8179633021354675,
                "z": -161.21958923339844
            },
            {
                "x": -4.304952621459961,
                "y": -0.8143560886383057,
                "z": -161.0699462890625
            },
            {
                "x": -4.256604194641113,
                "y": -0.8105746507644653,
                "z": -160.92039489746094
            },
            {
                "x": -4.208222389221191,
                "y": -0.8066130876541138,
                "z": -160.7706298828125
            },
            {
                "x": -4.159979343414307,
                "y": -0.8024904727935791,
                "z": -160.62100219726562
            },
            {
                "x": -4.11178731918335,
                "y": -0.7982051372528076,
                "z": -160.4713897705078
            },
            {
                "x": -4.063621520996094,
                "y": -0.7937531471252441,
                "z": -160.32164001464844
            },
            {
                "x": -4.015568733215332,
                "y": -0.7891433238983154,
                "z": -160.1719970703125
            },
            {
                "x": -3.967550277709961,
                "y": -0.7843770384788513,
                "z": -160.02220153808594
            },
            {
                "x": -3.9196341037750244,
                "y": -0.7794607281684875,
                "z": -159.87245178222656
            },
            {
                "x": -3.8718137741088867,
                "y": -0.7743972539901733,
                "z": -159.72274780273438
            },
            {
                "x": -3.8240716457366943,
                "y": -0.7691818475723267,
                "z": -159.57289123535156
            },
            {
                "x": -3.776453971862793,
                "y": -0.7638288736343384,
                "z": -159.42315673828125
            },
            {
                "x": -3.7289133071899414,
                "y": -0.7583374977111816,
                "z": -159.27333068847656
            },
            {
                "x": -3.681434392929077,
                "y": -0.7527024149894714,
                "z": -159.1233367919922
            },
            {
                "x": -3.6341030597686768,
                "y": -0.7469393014907837,
                "z": -158.9735107421875
            },
            {
                "x": -3.586902379989624,
                "y": -0.7410464286804199,
                "z": -158.82363891601562
            },
            {
                "x": -3.55647349357605,
                "y": -0.7371764183044434,
                "z": -158.726806640625
            },
            {
                "x": -3.5094425678253174,
                "y": -0.7310757637023926,
                "z": -158.57688903808594
            },
            {
                "x": -3.4625351428985596,
                "y": -0.7248505353927612,
                "z": -158.42681884765625
            },
            {
                "x": -3.4157230854034424,
                "y": -0.718508243560791,
                "z": -158.2767333984375
            },
            {
                "x": -3.3691048622131348,
                "y": -0.7120562195777893,
                "z": -158.126708984375
            },
            {
                "x": -3.3225862979888916,
                "y": -0.7054840326309204,
                "z": -157.97653198242188
            },
            {
                "x": -3.2762246131896973,
                "y": -0.6988074779510498,
                "z": -157.82643127441406
            },
            {
                "x": -3.230037212371826,
                "y": -0.6920276284217834,
                "z": -157.67626953125
            },
            {
                "x": -3.183910608291626,
                "y": -0.6851373314857483,
                "z": -157.5259246826172
            },
            {
                "x": -3.1380298137664795,
                "y": -0.678152322769165,
                "z": -157.37564086914062
            },
            {
                "x": -3.092273712158203,
                "y": -0.6710693836212158,
                "z": -157.22531127929688
            },
            {
                "x": -3.0466885566711426,
                "y": -0.6638948917388916,
                "z": -157.074951171875
            },
            {
                "x": -3.0012941360473633,
                "y": -0.6566338539123535,
                "z": -156.92457580566406
            },
            {
                "x": -2.9559969902038574,
                "y": -0.6492737531661987,
                "z": -156.77395629882812
            },
            {
                "x": -2.9109702110290527,
                "y": -0.6418401002883911,
                "z": -156.62350463867188
            },
            {
                "x": -2.866093873977661,
                "y": -0.6343265771865845,
                "z": -156.4729766845703
            },
            {
                "x": -2.82139253616333,
                "y": -0.6267304420471191,
                "z": -156.32229614257812
            },
            {
                "x": -2.776916742324829,
                "y": -0.6190646290779114,
                "z": -156.1716766357422
            },
            {
                "x": -2.732598066329956,
                "y": -0.6113216876983643,
                "z": -156.02090454101562
            },
            {
                "x": -2.6885111331939697,
                "y": -0.6035120487213135,
                "z": -155.8700714111328
            },
            {
                "x": -2.6446101665496826,
                "y": -0.5956422686576843,
                "z": -155.7192840576172
            },
            {
                "x": -2.600968360900879,
                "y": -0.5877093076705933,
                "z": -155.5684356689453
            },
            {
                "x": -2.5575032234191895,
                "y": -0.5797168016433716,
                "z": -155.41751098632812
            },
            {
                "x": -2.5142791271209717,
                "y": -0.5716710090637207,
                "z": -155.2665557861328
            },
            {
                "x": -2.4712233543395996,
                "y": -0.5635621547698975,
                "z": -155.11532592773438
            },
            {
                "x": -2.4284253120422363,
                "y": -0.5554132461547852,
                "z": -154.96424865722656
            },
            {
                "x": -2.3858940601348877,
                "y": -0.5472156405448914,
                "z": -154.81304931640625
            },
            {
                "x": -2.343554735183716,
                "y": -0.5389748811721802,
                "z": -154.66177368164062
            },
            {
                "x": -2.3015012741088867,
                "y": -0.5306962728500366,
                "z": -154.51048278808594
            },
            {
                "x": -2.2596213817596436,
                "y": -0.522370457649231,
                "z": -154.35894775390625
            },
            {
                "x": -2.2180514335632324,
                "y": -0.5140199065208435,
                "z": -154.20753479003906
            },
            {
                "x": -2.176755905151367,
                "y": -0.505638837814331,
                "z": -154.0560302734375
            },
            {
                "x": -2.135648488998413,
                "y": -0.49722546339035034,
                "z": -153.90438842773438
            },
            {
                "x": -2.0948846340179443,
                "y": -0.48879262804985046,
                "z": -153.7527618408203
            },
            {
                "x": -2.054325819015503,
                "y": -0.4803319573402405,
                "z": -153.60096740722656
            },
            {
                "x": -2.0140604972839355,
                "y": -0.47185376286506653,
                "z": -153.4490966796875
            },
            {
                "x": -1.974099040031433,
                "y": -0.46336454153060913,
                "z": -153.29725646972656
            },
            {
                "x": -1.9343533515930176,
                "y": -0.4548584818840027,
                "z": -153.145263671875
            },
            {
                "x": -1.8949832916259766,
                "y": -0.44634827971458435,
                "z": -152.99327087402344
            },
            {
                "x": -1.8558404445648193,
                "y": -0.43783169984817505,
                "z": -152.84121704101562
            },
            {
                "x": -1.8169875144958496,
                "y": -0.4293012022972107,
                "z": -152.68887329101562
            },
            {
                "x": -1.7784607410430908,
                "y": -0.42078259587287903,
                "z": -152.53668212890625
            },
            {
                "x": -1.7402348518371582,
                "y": -0.41226595640182495,
                "z": -152.38438415527344
            },
            {
                "x": -1.7157387733459473,
                "y": -0.40676766633987427,
                "z": -152.28598022460938
            },
            {
                "x": -1.6780067682266235,
                "y": -0.39826321601867676,
                "z": -152.1335906982422
            },
            {
                "x": -1.640602707862854,
                "y": -0.3897644877433777,
                "z": -151.98098754882812
            },
            {
                "x": -1.603514552116394,
                "y": -0.38127970695495605,
                "z": -151.8283233642578
            },
            {
                "x": -1.5667340755462646,
                "y": -0.3728181719779968,
                "z": -151.67568969726562
            },
            {
                "x": -1.5303153991699219,
                "y": -0.36437103152275085,
                "z": -151.52285766601562
            },
            {
                "x": -1.494183897972107,
                "y": -0.35595259070396423,
                "z": -151.37005615234375
            },
            {
                "x": -1.4584453105926514,
                "y": -0.34756189584732056,
                "z": -151.21719360351562
            },
            {
                "x": -1.4229717254638672,
                "y": -0.3391898274421692,
                "z": -151.06405639648438
            },
            {
                "x": -1.3878716230392456,
                "y": -0.33085986971855164,
                "z": -150.9110107421875
            },
            {
                "x": -1.3531657457351685,
                "y": -0.3225642442703247,
                "z": -150.7578125
            },
            {
                "x": -1.3187412023544312,
                "y": -0.31430715322494507,
                "z": -150.6045684814453
            },
            {
                "x": -1.284751534461975,
                "y": -0.30609482526779175,
                "z": -150.45126342773438
            },
            {
                "x": -1.2510216236114502,
                "y": -0.2979160249233246,
                "z": -150.29769897460938
            },
            {
                "x": -1.217722773551941,
                "y": -0.28979697823524475,
                "z": -150.14425659179688
            },
            {
                "x": -1.1848078966140747,
                "y": -0.28172987699508667,
                "z": -149.99073791503906
            },
            {
                "x": -1.15218186378479,
                "y": -0.273709774017334,
                "z": -149.83702087402344
            },
            {
                "x": -1.1200262308120728,
                "y": -0.26575231552124023,
                "z": -149.68328857421875
            },
            {
                "x": -1.08816397190094,
                "y": -0.2578510642051697,
                "z": -149.52944946289062
            },
            {
                "x": -1.0567270517349243,
                "y": -0.2500140964984894,
                "z": -149.37548828125
            },
            {
                "x": -1.0256867408752441,
                "y": -0.24224750697612762,
                "z": -149.2215576171875
            },
            {
                "x": -0.9949979782104492,
                "y": -0.23454952239990234,
                "z": -149.06756591796875
            },
            {
                "x": -0.964775562286377,
                "y": -0.2269250899553299,
                "z": -148.91346740722656
            },
            {
                "x": -0.9348783493041992,
                "y": -0.219377338886261,
                "z": -148.75929260253906
            },
            {
                "x": -0.9054027795791626,
                "y": -0.2118980586528778,
                "z": -148.6048126220703
            },
            {
                "x": -0.8763362169265747,
                "y": -0.20450884103775024,
                "z": -148.4504852294922
            },
            {
                "x": -0.8476535081863403,
                "y": -0.19720222055912018,
                "z": -148.2960205078125
            },
            {
                "x": -0.8194518685340881,
                "y": -0.18998542428016663,
                "z": -148.1414794921875
            },
            {
                "x": -0.7915844321250916,
                "y": -0.1828603595495224,
                "z": -147.9868927001953
            },
            {
                "x": -0.7641738057136536,
                "y": -0.175819993019104,
                "z": -147.83201599121094
            },
            {
                "x": -0.7371647357940674,
                "y": -0.16888542473316193,
                "z": -147.67730712890625
            },
            {
                "x": -0.7105994820594788,
                "y": -0.16205361485481262,
                "z": -147.5225067138672
            },
            {
                "x": -0.6844802498817444,
                "y": -0.15531906485557556,
                "z": -147.36749267578125
            },
            {
                "x": -0.6587274074554443,
                "y": -0.1486932635307312,
                "z": -147.21250915527344
            },
            {
                "x": -0.6334899663925171,
                "y": -0.14217370748519897,
                "z": -147.05735778808594
            },
            {
                "x": -0.6086276769638062,
                "y": -0.13576927781105042,
                "z": -146.9021759033203
            },
            {
                "x": -0.5842424035072327,
                "y": -0.1294824481010437,
                "z": -146.7469940185547
            },
            {
                "x": -0.5603040456771851,
                "y": -0.12330901622772217,
                "z": -146.5916290283203
            },
            {
                "x": -0.5367569327354431,
                "y": -0.11725972592830658,
                "z": -146.436279296875
            },
            {
                "x": -0.5137690305709839,
                "y": -0.11133906245231628,
                "z": -146.28085327148438
            },
            {
                "x": -0.49111443758010864,
                "y": -0.10553749650716782,
                "z": -146.12521362304688
            },
            {
                "x": -0.4689874053001404,
                "y": -0.09987270832061768,
                "z": -145.9696807861328
            },
            {
                "x": -0.4473239481449127,
                "y": -0.09433945268392563,
                "z": -145.8140411376953
            },
            {
                "x": -0.43353480100631714,
                "y": -0.09084226191043854,
                "z": -145.71348571777344
            },
            {
                "x": -0.4126442074775696,
                "y": -0.08553767204284668,
                "z": -145.55776977539062
            },
            {
                "x": -0.39216697216033936,
                "y": -0.08036912977695465,
                "z": -145.40185546875
            },
            {
                "x": -0.3721470236778259,
                "y": -0.07534980773925781,
                "z": -145.2459259033203
            },
            {
                "x": -0.3526897430419922,
                "y": -0.0704813003540039,
                "z": -145.08999633789062
            },
            {
                "x": -0.33359038829803467,
                "y": -0.06575800478458405,
                "z": -144.93394470214844
            },
            {
                "x": -0.31505775451660156,
                "y": -0.06119006127119064,
                "z": -144.7778778076172
            },
            {
                "x": -0.2969760298728943,
                "y": -0.0567825622856617,
                "z": -144.62176513671875
            },
            {
                "x": -0.27933308482170105,
                "y": -0.052529655396938324,
                "z": -144.46543884277344
            },
            {
                "x": -0.26226338744163513,
                "y": -0.04844271019101143,
                "z": -144.30918884277344
            },
            {
                "x": -0.24556422233581543,
                "y": -0.04451785236597061,
                "z": -144.15286254882812
            },
            {
                "x": -0.22945630550384521,
                "y": -0.04076607525348663,
                "z": -143.99647521972656
            },
            {
                "x": -0.21380673348903656,
                "y": -0.03718756139278412,
                "z": -143.840087890625
            },
            {
                "x": -0.19859579205513,
                "y": -0.033777203410863876,
                "z": -143.68345642089844
            },
            {
                "x": -0.18397846817970276,
                "y": -0.030547186732292175,
                "z": -143.52696228027344
            },
            {
                "x": -0.1697566658258438,
                "y": -0.027500977739691734,
                "z": -143.3704376220703
            },
            {
                "x": -0.15611056983470917,
                "y": -0.024637576192617416,
                "z": -143.21372985839844
            },
            {
                "x": -0.14294226467609406,
                "y": -0.02196059748530388,
                "z": -143.05711364746094
            },
            {
                "x": -0.13022059202194214,
                "y": -0.019469019025564194,
                "z": -142.9003448486328
            },
            {
                "x": -0.11811184883117676,
                "y": -0.017173806205391884,
                "z": -142.74351501464844
            },
            {
                "x": -0.10640743374824524,
                "y": -0.015076662413775921,
                "z": -142.58676147460938
            },
            {
                "x": -0.09528074413537979,
                "y": -0.01317580696195364,
                "z": -142.42999267578125
            },
            {
                "x": -0.08464447408914566,
                "y": -0.011473378166556358,
                "z": -142.27316284179688
            },
            {
                "x": -0.07446470111608505,
                "y": -0.00997819472104311,
                "z": -142.11627197265625
            },
            {
                "x": -0.06489689648151398,
                "y": -0.008690830320119858,
                "z": -141.95921325683594
            },
            {
                "x": -0.055743224918842316,
                "y": -0.007612319663167,
                "z": -141.80227661132812
            },
            {
                "x": -0.047151774168014526,
                "y": -0.00674399733543396,
                "z": -141.645263671875
            },
            {
                "x": -0.03910233825445175,
                "y": -0.006094161421060562,
                "z": -141.4882354736328
            },
            {
                "x": -0.031489044427871704,
                "y": -0.005665763281285763,
                "z": -141.33120727539062
            },
            {
                "x": -0.02449256181716919,
                "y": -0.00546276057139039,
                "z": -141.17398071289062
            },
            {
                "x": -0.017928972840309143,
                "y": -0.005454812198877335,
                "z": -141.0169219970703
            },
            {
                "x": -0.011912241578102112,
                "y": -0.005462559871375561,
                "z": -140.85984802246094
            },
            {
                "x": -0.006481483578681946,
                "y": -0.005470311734825373,
                "z": -140.70262145996094
            },
            {
                "x": -0.0014580190181732178,
                "y": -0.005478052422404289,
                "z": -140.54550170898438
            },
            {
                "x": 0.0029464811086654663,
                "y": -0.005485804285854101,
                "z": -140.38827514648438
            },
            {
                "x": 0.006874203681945801,
                "y": -0.005493552889674902,
                "z": -140.23104858398438
            },
            {
                "x": 0.010301634669303894,
                "y": -0.005501303821802139,
                "z": -140.07388305664062
            },
            {
                "x": 0.013129279017448425,
                "y": -0.005509046372026205,
                "z": -139.91661071777344
            },
            {
                "x": 0.015558317303657532,
                "y": -0.005516797304153442,
                "z": -139.7594451904297
            },
            {
                "x": 0.01742270588874817,
                "y": -0.005524542182683945,
                "z": -139.6022491455078
            },
            {
                "x": 0.018830403685569763,
                "y": -0.0055322954431176186,
                "z": -139.44485473632812
            },
            {
                "x": 0.019860833883285522,
                "y": -0.005540040787309408,
                "z": -139.28765869140625
            },
            {
                "x": 0.020460963249206543,
                "y": -0.005548084154725075,
                "z": -139.1304473876953
            },
            {
                "x": 0.020745232701301575,
                "y": -0.005552831571549177,
                "z": -139.0288848876953
            },
            {
                "x": 0.020974352955818176,
                "y": -0.005560575518757105,
                "z": -138.87168884277344
            },
            {
                "x": 0.020992740988731384,
                "y": -0.005568324588239193,
                "z": -138.71435546875
            },
            {
                "x": 0.020954564213752747,
                "y": -0.0055760787799954414,
                "z": -138.55702209472656
            },
            {
                "x": 0.02082708477973938,
                "y": -0.005583824124187231,
                "z": -138.39979553222656
            },
            {
                "x": 0.020663470029830933,
                "y": -0.005591572728008032,
                "z": -138.2424774169922
            },
            {
                "x": 0.02049212157726288,
                "y": -0.005599320866167545,
                "z": -138.08523559570312
            },
            {
                "x": 0.020303875207901,
                "y": -0.00560706527903676,
                "z": -137.92800903320312
            },
            {
                "x": 0.020112916827201843,
                "y": -0.005614815279841423,
                "z": -137.7705841064453
            },
            {
                "x": 0.01991911232471466,
                "y": -0.005622564349323511,
                "z": -137.61334228515625
            },
            {
                "x": 0.019722148776054382,
                "y": -0.005630309693515301,
                "z": -137.45606994628906
            },
            {
                "x": 0.019523873925209045,
                "y": -0.0056380582973361015,
                "z": -137.2987823486328
            },
            {
                "x": 0.019323259592056274,
                "y": -0.005645805038511753,
                "z": -137.1415557861328
            },
            {
                "x": 0.019120603799819946,
                "y": -0.005653556901961565,
                "z": -136.98411560058594
            },
            {
                "x": 0.01891648769378662,
                "y": -0.0056613050401210785,
                "z": -136.82688903808594
            },
            {
                "x": 0.018710076808929443,
                "y": -0.005669050384312868,
                "z": -136.66966247558594
            },
            {
                "x": 0.018502026796340942,
                "y": -0.0056767999194562435,
                "z": -136.51231384277344
            },
            {
                "x": 0.018291935324668884,
                "y": -0.005684546194970608,
                "z": -136.35508728027344
            },
            {
                "x": 0.01807977259159088,
                "y": -0.005692294333130121,
                "z": -136.19776916503906
            },
            {
                "x": 0.017866060137748718,
                "y": -0.005700043868273497,
                "z": -136.04042053222656
            },
            {
                "x": 0.017649993300437927,
                "y": -0.005707790609449148,
                "z": -135.88319396972656
            },
            {
                "x": 0.01743246614933014,
                "y": -0.005715532694011927,
                "z": -135.72596740722656
            },
            {
                "x": 0.01721273362636566,
                "y": -0.005723278969526291,
                "z": -135.56874084472656
            },
            {
                "x": 0.016991108655929565,
                "y": -0.0057310243137180805,
                "z": -135.4114990234375
            },
            {
                "x": 0.01676751673221588,
                "y": -0.005738777574151754,
                "z": -135.2540740966797
            },
            {
                "x": 0.016541823744773865,
                "y": -0.005746523849666119,
                "z": -135.0968475341797
            },
            {
                "x": 0.016314491629600525,
                "y": -0.005754272453486919,
                "z": -134.93955993652344
            },
            {
                "x": 0.01608504354953766,
                "y": -0.005762019660323858,
                "z": -134.7822723388672
            },
            {
                "x": 0.015853658318519592,
                "y": -0.00576976640149951,
                "z": -134.6250457763672
            },
            {
                "x": 0.015620246529579163,
                "y": -0.005777518730610609,
                "z": -134.4676055908203
            },
            {
                "x": 0.015384823083877563,
                "y": -0.005785264540463686,
                "z": -134.31036376953125
            },
            {
                "x": 0.015147879719734192,
                "y": -0.00579301081597805,
                "z": -134.15313720703125
            },
            {
                "x": 0.01490841805934906,
                "y": -0.005800758488476276,
                "z": -133.99578857421875
            },
            {
                "x": 0.014667287468910217,
                "y": -0.005808504763990641,
                "z": -133.8385467529297
            },
            {
                "x": 0.014424145221710205,
                "y": -0.005816255696117878,
                "z": -133.68121337890625
            },
            {
                "x": 0.014178812503814697,
                "y": -0.005824003368616104,
                "z": -133.52389526367188
            },
            {
                "x": 0.013931944966316223,
                "y": -0.005831751506775618,
                "z": -133.3666534423828
            },
            {
                "x": 0.013682618737220764,
                "y": -0.005839500110596418,
                "z": -133.20932006835938
            },
            {
                "x": 0.013431742787361145,
                "y": -0.005847249645739794,
                "z": -133.05209350585938
            },
            {
                "x": 0.013178721070289612,
                "y": -0.005854994524270296,
                "z": -132.89486694335938
            },
            {
                "x": 0.012923389673233032,
                "y": -0.005854162387549877,
                "z": -132.7374267578125
            },
            {
                "x": 0.012666493654251099,
                "y": -0.005613452289253473,
                "z": -132.58018493652344
            },
            {
                "x": 0.012407347559928894,
                "y": -0.004983019083738327,
                "z": -132.4229278564453
            },
            {
                "x": 0.012238174676895142,
                "y": -0.0043733250349760056,
                "z": -132.3213653564453
            },
            {
                "x": 0.011975854635238647,
                "y": -0.0031070897821336985,
                "z": -132.16412353515625
            },
            {
                "x": 0.011711373925209045,
                "y": -0.0014729795511811972,
                "z": -132.00677490234375
            },
            {
                "x": 0.01144513487815857,
                "y": 0.0005196761339902878,
                "z": -131.84942626953125
            },
            {
                "x": 0.011176645755767822,
                "y": 0.0028688027523458004,
                "z": -131.69219970703125
            },
            {
                "x": 0.010906383395195007,
                "y": 0.00556874880567193,
                "z": -131.53488159179688
            },
            {
                "x": 0.010633885860443115,
                "y": 0.0085983257740736,
                "z": -131.377685546875
            },
            {
                "x": 0.010359719395637512,
                "y": 0.011951025575399399,
                "z": -131.22047424316406
            },
            {
                "x": 0.010083034634590149,
                "y": 0.015630286186933517,
                "z": -131.06304931640625
            },
            {
                "x": 0.009804636240005493,
                "y": 0.01961805298924446,
                "z": -130.90586853027344
            },
            {
                "x": 0.009524255990982056,
                "y": 0.023903872817754745,
                "z": -130.74862670898438
            },
            {
                "x": 0.009241625666618347,
                "y": 0.02847805991768837,
                "z": -130.59141540527344
            },
            {
                "x": 0.008957400918006897,
                "y": 0.03333541005849838,
                "z": -130.43423461914062
            },
            {
                "x": 0.008670374751091003,
                "y": 0.03847850114107132,
                "z": -130.27687072753906
            },
            {
                "x": 0.008382052183151245,
                "y": 0.04387552663683891,
                "z": -130.11973571777344
            },
            {
                "x": 0.008091345429420471,
                "y": 0.049525801092386246,
                "z": -129.96261596679688
            },
            {
                "x": 0.007798716425895691,
                "y": 0.05542931705713272,
                "z": -129.80535888671875
            },
            {
                "x": 0.007504016160964966,
                "y": 0.06157100200653076,
                "z": -129.6482391357422
            },
            {
                "x": 0.007207229733467102,
                "y": 0.06794339418411255,
                "z": -129.4910125732422
            },
            {
                "x": 0.006908416748046875,
                "y": 0.07453440874814987,
                "z": -129.3338165283203
            },
            {
                "x": 0.00660763680934906,
                "y": 0.08133344352245331,
                "z": -129.1767120361328
            },
            {
                "x": 0.00630497932434082,
                "y": 0.08833973109722137,
                "z": -129.01963806152344
            },
            {
                "x": 0.005999952554702759,
                "y": 0.09553810954093933,
                "z": -128.86256408691406
            },
            {
                "x": 0.005693212151527405,
                "y": 0.10291928052902222,
                "z": -128.70550537109375
            },
            {
                "x": 0.005383729934692383,
                "y": 0.11048650741577148,
                "z": -128.54823303222656
            },
            {
                "x": 0.0050728172063827515,
                "y": 0.11821684241294861,
                "z": -128.3911895751953
            },
            {
                "x": 0.004759505391120911,
                "y": 0.12610599398612976,
                "z": -128.23411560058594
            },
            {
                "x": 0.00444445013999939,
                "y": 0.1341431736946106,
                "z": -128.07704162597656
            },
            {
                "x": 0.004127055406570435,
                "y": 0.1423187255859375,
                "z": -127.9200210571289
            },
            {
                "x": 0.0038075000047683716,
                "y": 0.1506410539150238,
                "z": -127.7628173828125
            },
            {
                "x": 0.003486037254333496,
                "y": 0.15907546877861023,
                "z": -127.60580444335938
            },
            {
                "x": 0.003162682056427002,
                "y": 0.1676245927810669,
                "z": -127.44877624511719
            },
            {
                "x": 0.002836957573890686,
                "y": 0.17628414928913116,
                "z": -127.29167175292969
            },
            {
                "x": 0.002509370446205139,
                "y": 0.18503722548484802,
                "z": -127.13468933105469
            },
            {
                "x": 0.0021795034408569336,
                "y": 0.19388315081596375,
                "z": -126.97763061523438
            },
            {
                "x": 0.0018475353717803955,
                "y": 0.20280921459197998,
                "z": -126.820556640625
            },
            {
                "x": 0.0015137344598770142,
                "y": 0.2118006944656372,
                "z": -126.66356658935547
            },
            {
                "x": 0.0011775493621826172,
                "y": 0.22086209058761597,
                "z": -126.50648498535156
            },
            {
                "x": 0.0008395165205001831,
                "y": 0.2299705445766449,
                "z": -126.3495101928711
            },
            {
                "x": 0.0004992783069610596,
                "y": 0.23912426829338074,
                "z": -126.1925277709961
            },
            {
                "x": 0.0001567751169204712,
                "y": 0.2483236938714981,
                "z": -126.03536987304688
            },
            {
                "x": -0.00018768012523651123,
                "y": 0.2575402557849884,
                "z": -125.87841033935547
            },
            {
                "x": -0.0005340278148651123,
                "y": 0.26677441596984863,
                "z": -125.72146606445312
            },
            {
                "x": -0.0007599592208862305,
                "y": 0.27274543046951294,
                "z": -125.62007904052734
            },
            {
                "x": -0.0011097192764282227,
                "y": 0.28199201822280884,
                "z": -125.4631118774414
            },
            {
                "x": -0.001462101936340332,
                "y": 0.29123973846435547,
                "z": -125.3060531616211
            },
            {
                "x": -0.0018162727355957031,
                "y": 0.30047374963760376,
                "z": -125.14900970458984
            },
            {
                "x": -0.002172619104385376,
                "y": 0.30968034267425537,
                "z": -124.99205017089844
            },
            {
                "x": -0.002530992031097412,
                "y": 0.3188629150390625,
                "z": -124.83497619628906
            },
            {
                "x": -0.0028916150331497192,
                "y": 0.3279976546764374,
                "z": -124.67803192138672
            },
            {
                "x": -0.003254115581512451,
                "y": 0.33708620071411133,
                "z": -124.52105712890625
            },
            {
                "x": -0.0036193132400512695,
                "y": 0.34612977504730225,
                "z": -124.36387634277344
            },
            {
                "x": -0.003985941410064697,
                "y": 0.3550952672958374,
                "z": -124.2069091796875
            },
            {
                "x": -0.004355117678642273,
                "y": 0.36398792266845703,
                "z": -124.04988098144531
            },
            {
                "x": -0.004726245999336243,
                "y": 0.37279900908470154,
                "z": -123.892822265625
            },
            {
                "x": -0.005099475383758545,
                "y": 0.38151466846466064,
                "z": -123.73585510253906
            },
            {
                "x": -0.005475133657455444,
                "y": 0.39014142751693726,
                "z": -123.57866668701172
            },
            {
                "x": -0.005852624773979187,
                "y": 0.39864468574523926,
                "z": -123.42166137695312
            },
            {
                "x": -0.006232157349586487,
                "y": 0.4070301353931427,
                "z": -123.2646713256836
            },
            {
                "x": -0.006614014506340027,
                "y": 0.4152964949607849,
                "z": -123.10755157470703
            },
            {
                "x": -0.0069978684186935425,
                "y": 0.42342203855514526,
                "z": -122.9505386352539
            },
            {
                "x": -0.007383972406387329,
                "y": 0.4314029812812805,
                "z": -122.79341888427734
            },
            {
                "x": -0.007772356271743774,
                "y": 0.43923240900039673,
                "z": -122.63629150390625
            },
            {
                "x": -0.00816240906715393,
                "y": 0.44689643383026123,
                "z": -122.47924041748047
            },
            {
                "x": -0.008554786443710327,
                "y": 0.4543909728527069,
                "z": -122.32221221923828
            },
            {
                "x": -0.0089491605758667,
                "y": 0.4616999924182892,
                "z": -122.1651611328125
            },
            {
                "x": -0.00934581458568573,
                "y": 0.46882209181785583,
                "z": -122.00809478759766
            },
            {
                "x": -0.009744882583618164,
                "y": 0.47575730085372925,
                "z": -121.85083770751953
            },
            {
                "x": -0.010145649313926697,
                "y": 0.48248016834259033,
                "z": -121.69375610351562
            },
            {
                "x": -0.010548770427703857,
                "y": 0.4889827370643616,
                "z": -121.53662109375
            },
            {
                "x": -0.0109538733959198,
                "y": 0.49526315927505493,
                "z": -121.37947082519531
            },
            {
                "x": -0.011361092329025269,
                "y": 0.5013111233711243,
                "z": -121.22236633300781
            },
            {
                "x": -0.011770665645599365,
                "y": 0.5071282386779785,
                "z": -121.06504821777344
            },
            {
                "x": -0.01218213140964508,
                "y": 0.5126791596412659,
                "z": -120.9079360961914
            },
            {
                "x": -0.012595586478710175,
                "y": 0.517972469329834,
                "z": -120.75079345703125
            },
            {
                "x": -0.013011358678340912,
                "y": 0.5230041742324829,
                "z": -120.59353637695312
            },
            {
                "x": -0.013429097831249237,
                "y": 0.5277588367462158,
                "z": -120.43638610839844
            },
            {
                "x": -0.01384899765253067,
                "y": 0.5322218537330627,
                "z": -120.27914428710938
            },
            {
                "x": -0.014271199703216553,
                "y": 0.5363907814025879,
                "z": -120.12187957763672
            },
            {
                "x": -0.014695055782794952,
                "y": 0.5402569770812988,
                "z": -119.96471405029297
            },
            {
                "x": -0.015121228992938995,
                "y": 0.5438170433044434,
                "z": -119.80741882324219
            },
            {
                "x": -0.015549346804618835,
                "y": 0.5470449924468994,
                "z": -119.65023803710938
            },
            {
                "x": -0.015979357063770294,
                "y": 0.5499427318572998,
                "z": -119.49305725097656
            },
            {
                "x": -0.016412004828453064,
                "y": 0.5525083541870117,
                "z": -119.33566284179688
            },
            {
                "x": -0.01684613525867462,
                "y": 0.5547272562980652,
                "z": -119.17845153808594
            },
            {
                "x": -0.017273180186748505,
                "y": 0.5565812587738037,
                "z": -119.0212631225586
            },
            {
                "x": -0.017566144466400146,
                "y": 0.5575829744338989,
                "z": -118.9197006225586
            },
            {
                "x": -0.018005579710006714,
                "y": 0.5588377714157104,
                "z": -118.76248931884766
            },
            {
                "x": -0.01844741404056549,
                "y": 0.5597079992294312,
                "z": -118.60517120361328
            },
            {
                "x": -0.018891066312789917,
                "y": 0.5601839423179626,
                "z": -118.4478759765625
            },
            {
                "x": -0.019336499273777008,
                "y": 0.560266375541687,
                "z": -118.2906494140625
            },
            {
                "x": -0.019784167408943176,
                "y": 0.5599526166915894,
                "z": -118.13333129882812
            },
            {
                "x": -0.0202333927154541,
                "y": 0.5592420697212219,
                "z": -117.97611999511719
            },
            {
                "x": -0.02068464457988739,
                "y": 0.5581415891647339,
                "z": -117.81890106201172
            },
            {
                "x": -0.021138355135917664,
                "y": 0.5566684007644653,
                "z": -117.66149139404297
            },
            {
                "x": -0.021593250334262848,
                "y": 0.5548349022865295,
                "z": -117.5042953491211
            },
            {
                "x": -0.02205023169517517,
                "y": 0.5526397824287415,
                "z": -117.3470458984375
            },
            {
                "x": -0.022509150207042694,
                "y": 0.5500898361206055,
                "z": -117.18978881835938
            },
            {
                "x": -0.02296958863735199,
                "y": 0.5472049713134766,
                "z": -117.0325927734375
            },
            {
                "x": -0.02343236654996872,
                "y": 0.543988823890686,
                "z": -116.87521362304688
            },
            {
                "x": -0.023896493017673492,
                "y": 0.5404520630836487,
                "z": -116.71803283691406
            },
            {
                "x": -0.024362213909626007,
                "y": 0.5365965962409973,
                "z": -116.56086730957031
            },
            {
                "x": -0.024829983711242676,
                "y": 0.5324371457099915,
                "z": -116.40359497070312
            },
            {
                "x": -0.025299154222011566,
                "y": 0.5279881954193115,
                "z": -116.24642944335938
            },
            {
                "x": -0.02577020227909088,
                "y": 0.5232487916946411,
                "z": -116.08919525146484
            },
            {
                "x": -0.026242882013320923,
                "y": 0.5182250738143921,
                "z": -115.93196105957031
            },
            {
                "x": -0.026716865599155426,
                "y": 0.5129386186599731,
                "z": -115.77481842041016
            },
            {
                "x": -0.027192331850528717,
                "y": 0.5073955059051514,
                "z": -115.6176986694336
            },
            {
                "x": -0.02766931802034378,
                "y": 0.5016003847122192,
                "z": -115.46057891845703
            },
            {
                "x": -0.028147749602794647,
                "y": 0.49555712938308716,
                "z": -115.3034896850586
            },
            {
                "x": -0.028628148138523102,
                "y": 0.48927515745162964,
                "z": -115.14620208740234
            },
            {
                "x": -0.029109381139278412,
                "y": 0.48277854919433594,
                "z": -114.98912048339844
            },
            {
                "x": -0.029591985046863556,
                "y": 0.4760644733905792,
                "z": -114.83199310302734
            },
            {
                "x": -0.030075855553150177,
                "y": 0.46913713216781616,
                "z": -114.67485809326172
            },
            {
                "x": -0.030560798943042755,
                "y": 0.46201592683792114,
                "z": -114.5177993774414
            },
            {
                "x": -0.03104739636182785,
                "y": 0.4546980857849121,
                "z": -114.36054229736328
            },
            {
                "x": -0.031534403562545776,
                "y": 0.4472106397151947,
                "z": -114.20350646972656
            },
            {
                "x": -0.03202245384454727,
                "y": 0.43954527378082275,
                "z": -114.04646301269531
            },
            {
                "x": -0.03251173347234726,
                "y": 0.4317130446434021,
                "z": -113.88932800292969
            },
            {
                "x": -0.03300146758556366,
                "y": 0.42373406887054443,
                "z": -113.7322998046875
            },
            {
                "x": -0.033492155373096466,
                "y": 0.4156053960323334,
                "z": -113.57518005371094
            },
            {
                "x": -0.03398355841636658,
                "y": 0.40733593702316284,
                "z": -113.41808319091797
            },
            {
                "x": -0.03447510302066803,
                "y": 0.3989446461200714,
                "z": -113.26107025146484
            },
            {
                "x": -0.03496730327606201,
                "y": 0.3904304802417755,
                "z": -113.10398864746094
            },
            {
                "x": -0.035459570586681366,
                "y": 0.3818119764328003,
                "z": -112.94699096679688
            },
            {
                "x": -0.03595193475484848,
                "y": 0.373088002204895,
                "z": -112.78999328613281
            },
            {
                "x": -0.03644483536481857,
                "y": 0.3642618656158447,
                "z": -112.6328125
            },
            {
                "x": -0.036937013268470764,
                "y": 0.3553639054298401,
                "z": -112.47583770751953
            },
            {
                "x": -0.03741328418254852,
                "y": 0.34639212489128113,
                "z": -112.3188705444336
            },
            {
                "x": -0.03774723410606384,
                "y": 0.3405574560165405,
                "z": -112.21747589111328
            },
            {
                "x": -0.03823810815811157,
                "y": 0.3314780592918396,
                "z": -112.06050872802734
            },
            {
                "x": -0.03872838616371155,
                "y": 0.3223414421081543,
                "z": -111.9034423828125
            },
            {
                "x": -0.0392175018787384,
                "y": 0.3131614923477173,
                "z": -111.74639129638672
            },
            {
                "x": -0.039704978466033936,
                "y": 0.30395209789276123,
                "z": -111.58943939208984
            },
            {
                "x": -0.040191128849983215,
                "y": 0.29471004009246826,
                "z": -111.43236541748047
            },
            {
                "x": -0.040675029158592224,
                "y": 0.28545814752578735,
                "z": -111.2754135131836
            },
            {
                "x": -0.0411565825343132,
                "y": 0.27619725465774536,
                "z": -111.11846160888672
            },
            {
                "x": -0.041635945439338684,
                "y": 0.26692456007003784,
                "z": -110.96129608154297
            },
            {
                "x": -0.04211170971393585,
                "y": 0.2576737105846405,
                "z": -110.80435180664062
            },
            {
                "x": -0.04258403927087784,
                "y": 0.24843567609786987,
                "z": -110.64732360839844
            },
            {
                "x": -0.043052248656749725,
                "y": 0.23922473192214966,
                "z": -110.49031829833984
            },
            {
                "x": -0.0435154065489769,
                "y": 0.23005369305610657,
                "z": -110.33336639404297
            },
            {
                "x": -0.043973758816719055,
                "y": 0.22091339528560638,
                "z": -110.17617797851562
            },
            {
                "x": -0.044425465166568756,
                "y": 0.21183723211288452,
                "z": -110.01920318603516
            },
            {
                "x": -0.044870130717754364,
                "y": 0.20282307267189026,
                "z": -109.86223602294922
            },
            {
                "x": -0.045306675136089325,
                "y": 0.1938742697238922,
                "z": -109.70513916015625
            },
            {
                "x": -0.04573385417461395,
                "y": 0.18500998616218567,
                "z": -109.54815673828125
            },
            {
                "x": -0.04615076631307602,
                "y": 0.17622709274291992,
                "z": -109.39106750488281
            },
            {
                "x": -0.046555452048778534,
                "y": 0.16753984987735748,
                "z": -109.23397064208984
            },
            {
                "x": -0.0469454750418663,
                "y": 0.1589667797088623,
                "z": -109.07695007324219
            },
            {
                "x": -0.047319196164608,
                "y": 0.15050646662712097,
                "z": -108.91993713378906
            },
            {
                "x": -0.04767397791147232,
                "y": 0.14216747879981995,
                "z": -108.76290893554688
            },
            {
                "x": -0.048006512224674225,
                "y": 0.13395832479000092,
                "z": -108.60588073730469
            },
            {
                "x": -0.048311732709407806,
                "y": 0.12588486075401306,
                "z": -108.44864654541016
            },
            {
                "x": -0.04858466237783432,
                "y": 0.11796899139881134,
                "z": -108.29159545898438
            },
            {
                "x": -0.048830293118953705,
                "y": 0.11020731180906296,
                "z": -108.1344985961914
            },
            {
                "x": -0.04924372583627701,
                "y": 0.1026177704334259,
                "z": -107.97755432128906
            },
            {
                "x": -0.050564512610435486,
                "y": 0.09522129595279694,
                "z": -107.82083129882812
            },
            {
                "x": -0.0530879870057106,
                "y": 0.08800044655799866,
                "z": -107.66395568847656
            },
            {
                "x": -0.05676954984664917,
                "y": 0.0809786468744278,
                "z": -107.50727081298828
            },
            {
                "x": -0.061540886759757996,
                "y": 0.0741560161113739,
                "z": -107.35057067871094
            },
            {
                "x": -0.06738197803497314,
                "y": 0.06754587590694427,
                "z": -107.19376373291016
            },
            {
                "x": -0.07418201863765717,
                "y": 0.06115926802158356,
                "z": -107.03709411621094
            },
            {
                "x": -0.0818832740187645,
                "y": 0.05499514937400818,
                "z": -106.88035583496094
            },
            {
                "x": -0.09041517972946167,
                "y": 0.04906412214040756,
                "z": -106.72359466552734
            },
            {
                "x": -0.09973040968179703,
                "y": 0.04339000582695007,
                "z": -106.56696319580078
            },
            {
                "x": -0.10976067185401917,
                "y": 0.037966493517160416,
                "z": -106.4102554321289
            },
            {
                "x": -0.12043002992868423,
                "y": 0.03280642628669739,
                "z": -106.25364685058594
            },
            {
                "x": -0.13167695701122284,
                "y": 0.02791472151875496,
                "z": -106.09705352783203
            },
            {
                "x": -0.1434902846813202,
                "y": 0.023304611444473267,
                "z": -105.94029235839844
            },
            {
                "x": -0.15577003359794617,
                "y": 0.018989581614732742,
                "z": -105.78372192382812
            },
            {
                "x": -0.1684672236442566,
                "y": 0.014969129115343094,
                "z": -105.62718963623047
            },
            {
                "x": -0.17687316238880157,
                "y": 0.012531430460512638,
                "z": -105.52606964111328
            },
            {
                "x": -0.1901756227016449,
                "y": 0.009024195373058319,
                "z": -105.3695068359375
            },
            {
                "x": -0.20378747582435608,
                "y": 0.005832127295434475,
                "z": -105.21287536621094
            },
            {
                "x": -0.21765582263469696,
                "y": 0.0029659983702003956,
                "z": -105.05625915527344
            },
            {
                "x": -0.2317405343055725,
                "y": 0.0004433698486536741,
                "z": -104.89971923828125
            },
            {
                "x": -0.24602138996124268,
                "y": -0.0017284953501075506,
                "z": -104.74308776855469
            },
            {
                "x": -0.2604397237300873,
                "y": -0.0035471608862280846,
                "z": -104.58656311035156
            },
            {
                "x": -0.2749708294868469,
                "y": -0.005005701445043087,
                "z": -104.43002319335938
            },
            {
                "x": -0.2896086871623993,
                "y": -0.006088982801884413,
                "z": -104.27328491210938
            },
            {
                "x": -0.3042815923690796,
                "y": -0.006782027892768383,
                "z": -104.11673736572266
            },
            {
                "x": -0.31899261474609375,
                "y": -0.007088587153702974,
                "z": -103.96012878417969
            },
            {
                "x": -0.33370739221572876,
                "y": -0.00711808493360877,
                "z": -103.80352020263672
            },
            {
                "x": -0.3483983874320984,
                "y": -0.007125249598175287,
                "z": -103.64696502685547
            },
            {
                "x": -0.3630661368370056,
                "y": -0.007132417988032103,
                "z": -103.49018859863281
            },
            {
                "x": -0.3776581883430481,
                "y": -0.007139580324292183,
                "z": -103.3336181640625
            },
            {
                "x": -0.3921736180782318,
                "y": -0.0071467449888587,
                "z": -103.17703247070312
            },
            {
                "x": -0.4066077470779419,
                "y": -0.007153911050409079,
                "z": -103.02032470703125
            },
            {
                "x": -0.4209219813346863,
                "y": -0.007161066867411137,
                "z": -102.86370086669922
            },
            {
                "x": -0.4351221024990082,
                "y": -0.00716823898255825,
                "z": -102.70697021484375
            },
            {
                "x": -0.4491870403289795,
                "y": -0.00717539805918932,
                "z": -102.55023193359375
            },
            {
                "x": -0.46309757232666016,
                "y": -0.007182564586400986,
                "z": -102.39354705810547
            },
            {
                "x": -0.4768468141555786,
                "y": -0.007189722266048193,
                "z": -102.23686218261719
            },
            {
                "x": -0.4904307723045349,
                "y": -0.0071968878619372845,
                "z": -102.08016204833984
            },
            {
                "x": -0.5038409233093262,
                "y": -0.007204044610261917,
                "z": -101.9234390258789
            },
            {
                "x": -0.517085075378418,
                "y": -0.007211217191070318,
                "z": -101.7665023803711
            },
            {
                "x": -0.5301132798194885,
                "y": -0.007218378130346537,
                "z": -101.60973358154297
            },
            {
                "x": -0.5429520010948181,
                "y": -0.0072255441918969154,
                "z": -101.4529037475586
            },
            {
                "x": -0.5555896162986755,
                "y": -0.007232705131173134,
                "z": -101.29605865478516
            },
            {
                "x": -0.5680129528045654,
                "y": -0.007239874452352524,
                "z": -101.13924407958984
            },
            {
                "x": -0.5802316665649414,
                "y": -0.007247040048241615,
                "z": -100.98220825195312
            },
            {
                "x": -0.5922170877456665,
                "y": -0.007254205644130707,
                "z": -100.82535552978516
            },
            {
                "x": -0.6039857864379883,
                "y": -0.007261362858116627,
                "z": -100.66849517822266
            },
            {
                "x": -0.6155371069908142,
                "y": -0.007268528454005718,
                "z": -100.51148223876953
            },
            {
                "x": -0.6268454790115356,
                "y": -0.0072756921872496605,
                "z": -100.35456848144531
            },
            {
                "x": -0.6379332542419434,
                "y": -0.007282855920493603,
                "z": -100.19754791259766
            },
            {
                "x": -0.648792564868927,
                "y": -0.007290027569979429,
                "z": -100.0405044555664
            },
            {
                "x": -0.6594119668006897,
                "y": -0.007297188974916935,
                "z": -99.883544921875
            },
            {
                "x": -0.6697913408279419,
                "y": -0.007304353639483452,
                "z": -99.72647094726562
            },
            {
                "x": -0.6799319982528687,
                "y": -0.007311507128179073,
                "z": -99.5694808959961
            },
            {
                "x": -0.6898369789123535,
                "y": -0.00731867179274559,
                "z": -99.41246795654297
            },
            {
                "x": -0.699517548084259,
                "y": -0.007325847167521715,
                "z": -99.2552490234375
            },
            {
                "x": -0.7089406847953796,
                "y": -0.0073330095037817955,
                "z": -99.09820556640625
            },
            {
                "x": -0.7181267738342285,
                "y": -0.0073401713743805885,
                "z": -98.94115447998047
            },
            {
                "x": -0.723938524723053,
                "y": -0.007344840560108423,
                "z": -98.8397216796875
            },
            {
                "x": -0.7327296137809753,
                "y": -0.007352003827691078,
                "z": -98.68264770507812
            },
            {
                "x": -0.7412893176078796,
                "y": -0.007359165232628584,
                "z": -98.52545166015625
            },
            {
                "x": -0.7496117353439331,
                "y": -0.007366330362856388,
                "z": -98.3682632446289
            },
            {
                "x": -0.7576922178268433,
                "y": -0.007373490370810032,
                "z": -98.21115112304688
            },
            {
                "x": -0.7655352354049683,
                "y": -0.007380656898021698,
                "z": -98.05391693115234
            },
            {
                "x": -0.7731359004974365,
                "y": -0.007372470572590828,
                "z": -97.89677429199219
            },
            {
                "x": -0.7805052995681763,
                "y": -0.007232993375509977,
                "z": -97.73961639404297
            },
            {
                "x": -0.7876518964767456,
                "y": -0.0069264573976397514,
                "z": -97.58223724365234
            },
            {
                "x": -0.7945469617843628,
                "y": -0.0064506689086556435,
                "z": -97.42507934570312
            },
            {
                "x": -0.8012130260467529,
                "y": -0.005813166499137878,
                "z": -97.2678451538086
            },
            {
                "x": -0.8076514005661011,
                "y": -0.005019071511924267,
                "z": -97.11058044433594
            },
            {
                "x": -0.8138588666915894,
                "y": -0.004072163719683886,
                "z": -96.95337677001953
            },
            {
                "x": -0.8198373317718506,
                "y": -0.0029684496112167835,
                "z": -96.79597473144531
            },
            {
                "x": -0.8255823850631714,
                "y": -0.0017178715206682682,
                "z": -96.63874816894531
            },
            {
                "x": -0.8311036825180054,
                "y": -0.00032444647513329983,
                "z": -96.4815444946289
            },
            {
                "x": -0.8364039063453674,
                "y": 0.0012098918668925762,
                "z": -96.32420349121094
            },
            {
                "x": -0.8414740562438965,
                "y": 0.002884208457544446,
                "z": -96.16696166992188
            },
            {
                "x": -0.8463260531425476,
                "y": 0.004694412462413311,
                "z": -96.00962829589844
            },
            {
                "x": -0.8509591817855835,
                "y": 0.006634444929659367,
                "z": -95.85228729248047
            },
            {
                "x": -0.855374276638031,
                "y": 0.008699411526322365,
                "z": -95.69503021240234
            },
            {
                "x": -0.8595685958862305,
                "y": 0.010890981182456017,
                "z": -95.53778076171875
            },
            {
                "x": -0.863544225692749,
                "y": 0.013203933835029602,
                "z": -95.38053131103516
            },
            {
                "x": -0.8673089742660522,
                "y": 0.015633024275302887,
                "z": -95.22327423095703
            },
            {
                "x": -0.8708680868148804,
                "y": 0.018177907913923264,
                "z": -95.0658187866211
            },
            {
                "x": -0.8742063641548157,
                "y": 0.020832307636737823,
                "z": -94.90853881835938
            },
            {
                "x": -0.8773376941680908,
                "y": 0.023595480248332024,
                "z": -94.751220703125
            },
            {
                "x": -0.8802637457847595,
                "y": 0.02646094746887684,
                "z": -94.59391021728516
            },
            {
                "x": -0.8829866647720337,
                "y": 0.029424700886011124,
                "z": -94.4366455078125
            },
            {
                "x": -0.8855070471763611,
                "y": 0.03249066695570946,
                "z": -94.27916717529297
            },
            {
                "x": -0.8878163695335388,
                "y": 0.03564686328172684,
                "z": -94.12191772460938
            },
            {
                "x": -0.88992840051651,
                "y": 0.038892071694135666,
                "z": -93.96465301513672
            },
            {
                "x": -0.8918436765670776,
                "y": 0.04222525656223297,
                "z": -93.8072738647461
            },
            {
                "x": -0.8935592770576477,
                "y": 0.045640308409929276,
                "z": -93.6500015258789
            },
            {
                "x": -0.8950806856155396,
                "y": 0.04913796856999397,
                "z": -93.4926528930664
            },
            {
                "x": -0.8964090347290039,
                "y": 0.052711132913827896,
                "z": -93.33528137207031
            },
            {
                "x": -0.8975465893745422,
                "y": 0.056354016065597534,
                "z": -93.17800903320312
            },
            {
                "x": -0.8984870910644531,
                "y": 0.06006944179534912,
                "z": -93.02066040039062
            },
            {
                "x": -0.8992365598678589,
                "y": 0.0638495534658432,
                "z": -92.86338806152344
            },
            {
                "x": -0.8997907042503357,
                "y": 0.06769156455993652,
                "z": -92.70611572265625
            },
            {
                "x": -0.9001224040985107,
                "y": 0.07159725576639175,
                "z": -92.54863739013672
            },
            {
                "x": -0.9001456499099731,
                "y": 0.07555559277534485,
                "z": -92.39131164550781
            },
            {
                "x": -0.8997740149497986,
                "y": 0.07956847548484802,
                "z": -92.23396301269531
            },
            {
                "x": -0.8993056416511536,
                "y": 0.0821869969367981,
                "z": -92.13229370117188
            },
            {
                "x": -0.898154079914093,
                "y": 0.08627952635288239,
                "z": -91.97490692138672
            },
            {
                "x": -0.896452784538269,
                "y": 0.09042052924633026,
                "z": -91.81741333007812
            },
            {
                "x": -0.8942344188690186,
                "y": 0.09460179507732391,
                "z": -91.65992736816406
            },
            {
                "x": -0.8914905190467834,
                "y": 0.09881757199764252,
                "z": -91.5025405883789
            },
            {
                "x": -0.8882171511650085,
                "y": 0.10307011008262634,
                "z": -91.34505462646484
            },
            {
                "x": -0.8843749761581421,
                "y": 0.10735106468200684,
                "z": -91.18770599365234
            },
            {
                "x": -0.8799970746040344,
                "y": 0.11165918409824371,
                "z": -91.03034973144531
            },
            {
                "x": -0.8750749230384827,
                "y": 0.11599619686603546,
                "z": -90.8728256225586
            },
            {
                "x": -0.8696214556694031,
                "y": 0.12034790217876434,
                "z": -90.71551513671875
            },
            {
                "x": -0.8636072874069214,
                "y": 0.12471852451562881,
                "z": -90.55816650390625
            },
            {
                "x": -0.857042133808136,
                "y": 0.12910255789756775,
                "z": -90.40084838867188
            },
            {
                "x": -0.8499363660812378,
                "y": 0.13349471986293793,
                "z": -90.24360656738281
            },
            {
                "x": -0.8422680497169495,
                "y": 0.1378992646932602,
                "z": -90.08617401123047
            },
            {
                "x": -0.8340408802032471,
                "y": 0.14230167865753174,
                "z": -89.92896270751953
            },
            {
                "x": -0.8252732753753662,
                "y": 0.14670321345329285,
                "z": -89.77180480957031
            },
            {
                "x": -0.8159499168395996,
                "y": 0.15110448002815247,
                "z": -89.61456298828125
            },
            {
                "x": -0.8060932755470276,
                "y": 0.15549544990062714,
                "z": -89.45746612548828
            },
            {
                "x": -0.7956500053405762,
                "y": 0.1598777174949646,
                "z": -89.30030822753906
            },
            {
                "x": -0.7846577763557434,
                "y": 0.16424621641635895,
                "z": -89.14317321777344
            },
            {
                "x": -0.7731291651725769,
                "y": 0.16859446465969086,
                "z": -88.98619079589844
            },
            {
                "x": -0.761052131652832,
                "y": 0.1729218065738678,
                "z": -88.82923889160156
            },
            {
                "x": -0.7484127879142761,
                "y": 0.17722418904304504,
                "z": -88.67233276367188
            },
            {
                "x": -0.7352343797683716,
                "y": 0.1814984381198883,
                "z": -88.51546478271484
            },
            {
                "x": -0.7214950919151306,
                "y": 0.18574663996696472,
                "z": -88.35844421386719
            },
            {
                "x": -0.707239031791687,
                "y": 0.1899552047252655,
                "z": -88.20166778564453
            },
            {
                "x": -0.69242262840271,
                "y": 0.19412526488304138,
                "z": -88.04490661621094
            },
            {
                "x": -0.6770708560943604,
                "y": 0.19825321435928345,
                "z": -87.88818359375
            },
            {
                "x": -0.6611988544464111,
                "y": 0.2023349553346634,
                "z": -87.7315673828125
            },
            {
                "x": -0.6447842121124268,
                "y": 0.20637327432632446,
                "z": -87.57482147216797
            },
            {
                "x": -0.6278462409973145,
                "y": 0.21035227179527283,
                "z": -87.41831970214844
            },
            {
                "x": -0.6103900074958801,
                "y": 0.21427574753761292,
                "z": -87.26187896728516
            },
            {
                "x": -0.5924123525619507,
                "y": 0.2181430459022522,
                "z": -87.10537719726562
            },
            {
                "x": -0.5739448666572571,
                "y": 0.22194522619247437,
                "z": -86.94905090332031
            },
            {
                "x": -0.5549497008323669,
                "y": 0.22568140923976898,
                "z": -86.79268646240234
            },
            {
                "x": -0.5354611277580261,
                "y": 0.22934749722480774,
                "z": -86.63638305664062
            },
            {
                "x": -0.5154969096183777,
                "y": 0.23293860256671906,
                "z": -86.48023986816406
            },
            {
                "x": -0.4950408935546875,
                "y": 0.2364557832479477,
                "z": -86.32406616210938
            },
            {
                "x": -0.4741186797618866,
                "y": 0.23988839983940125,
                "z": -86.16805267333984
            },
            {
                "x": -0.45273104310035706,
                "y": 0.24323666095733643,
                "z": -86.01210021972656
            },
            {
                "x": -0.4308587312698364,
                "y": 0.24650228023529053,
                "z": -85.85602569580078
            },
            {
                "x": -0.40857037901878357,
                "y": 0.2496740221977234,
                "z": -85.7002182006836
            },
            {
                "x": -0.38584017753601074,
                "y": 0.2527492642402649,
                "z": -85.5444564819336
            },
            {
                "x": -0.3709275424480438,
                "y": 0.2546829879283905,
                "z": -85.44387817382812
            },
            {
                "x": -0.3475029468536377,
                "y": 0.2575966715812683,
                "z": -85.28824615478516
            },
            {
                "x": -0.3236485719680786,
                "y": 0.2604075074195862,
                "z": -85.13256072998047
            },
            {
                "x": -0.2993897497653961,
                "y": 0.2631087899208069,
                "z": -84.9769515991211
            },
            {
                "x": -0.27476418018341064,
                "y": 0.26569896936416626,
                "z": -84.82150268554688
            },
            {
                "x": -0.2497560977935791,
                "y": 0.2681780457496643,
                "z": -84.66600036621094
            },
            {
                "x": -0.22439907491207123,
                "y": 0.2705366015434265,
                "z": -84.51068115234375
            },
            {
                "x": -0.19868695735931396,
                "y": 0.2727717161178589,
                "z": -84.35542297363281
            },
            {
                "x": -0.17260989546775818,
                "y": 0.2748860716819763,
                "z": -84.20002746582031
            },
            {
                "x": -0.14625640213489532,
                "y": 0.2768709659576416,
                "z": -84.04488372802734
            },
            {
                "x": -0.11958974599838257,
                "y": 0.27872416377067566,
                "z": -83.88975524902344
            },
            {
                "x": -0.09262341260910034,
                "y": 0.28043943643569946,
                "z": -83.73465728759766
            },
            {
                "x": -0.06540055572986603,
                "y": 0.28201672434806824,
                "z": -83.57970428466797
            },
            {
                "x": -0.03789028897881508,
                "y": 0.28345543146133423,
                "z": -83.4245834350586
            },
            {
                "x": -0.010174155235290527,
                "y": 0.2847464084625244,
                "z": -83.26969909667969
            },
            {
                "x": 0.017774097621440887,
                "y": 0.2858847379684448,
                "z": -83.11488342285156
            },
            {
                "x": 0.045942433178424835,
                "y": 0.2868729829788208,
                "z": -82.95999145507812
            },
            {
                "x": 0.07427852600812912,
                "y": 0.28770628571510315,
                "z": -82.80525207519531
            },
            {
                "x": 0.1027989313006401,
                "y": 0.28838050365448,
                "z": -82.65045928955078
            },
            {
                "x": 0.13147886097431183,
                "y": 0.28888750076293945,
                "z": -82.49569702148438
            },
            {
                "x": 0.16027063131332397,
                "y": 0.2892295718193054,
                "z": -82.34107208251953
            },
            {
                "x": 0.18917030096054077,
                "y": 0.2893238067626953,
                "z": -82.18648529052734
            },
            {
                "x": 0.21816670894622803,
                "y": 0.2889590263366699,
                "z": -82.03193664550781
            },
            {
                "x": 0.24723753333091736,
                "y": 0.2881040573120117,
                "z": -81.87740325927734
            },
            {
                "x": 0.2763981819152832,
                "y": 0.28678521513938904,
                "z": -81.72270202636719
            },
            {
                "x": 0.30555838346481323,
                "y": 0.28501468896865845,
                "z": -81.56822204589844
            },
            {
                "x": 0.33473992347717285,
                "y": 0.28279614448547363,
                "z": -81.41370391845703
            },
            {
                "x": 0.36391815543174744,
                "y": 0.28012487292289734,
                "z": -81.25920867919922
            },
            {
                "x": 0.393055260181427,
                "y": 0.2770293354988098,
                "z": -81.10477447509766
            },
            {
                "x": 0.42218711972236633,
                "y": 0.27351295948028564,
                "z": -80.95013427734375
            },
            {
                "x": 0.45121365785598755,
                "y": 0.26959192752838135,
                "z": -80.79573822021484
            },
            {
                "x": 0.4801527261734009,
                "y": 0.265255331993103,
                "z": -80.64131927490234
            },
            {
                "x": 0.5090060830116272,
                "y": 0.2605268359184265,
                "z": -80.48678588867188
            },
            {
                "x": 0.5377071499824524,
                "y": 0.25542211532592773,
                "z": -80.3323745727539
            },
            {
                "x": 0.5662769079208374,
                "y": 0.24994255602359772,
                "z": -80.1778564453125
            },
            {
                "x": 0.5946695804595947,
                "y": 0.24408398568630219,
                "z": -80.02332305908203
            },
            {
                "x": 0.6228556632995605,
                "y": 0.2378765046596527,
                "z": -79.86888885498047
            },
            {
                "x": 0.6508527994155884,
                "y": 0.23132182657718658,
                "z": -79.7143325805664
            },
            {
                "x": 0.6786002516746521,
                "y": 0.22443699836730957,
                "z": -79.55986785888672
            },
            {
                "x": 0.7060906291007996,
                "y": 0.21721073985099792,
                "z": -79.4053726196289
            },
            {
                "x": 0.7333492636680603,
                "y": 0.20965823531150818,
                "z": -79.25066375732422
            },
            {
                "x": 0.7602850198745728,
                "y": 0.20180778205394745,
                "z": -79.09612274169922
            },
            {
                "x": 0.786913275718689,
                "y": 0.1936587691307068,
                "z": -78.94158172607422
            },
            {
                "x": 0.8039359450340271,
                "y": 0.18822872638702393,
                "z": -78.84172058105469
            },
            {
                "x": 0.8300150036811829,
                "y": 0.17959684133529663,
                "z": -78.6871109008789
            },
            {
                "x": 0.8557594418525696,
                "y": 0.17068344354629517,
                "z": -78.53236389160156
            },
            {
                "x": 0.8811234831809998,
                "y": 0.16149559617042542,
                "z": -78.37757110595703
            },
            {
                "x": 0.9060792922973633,
                "y": 0.15205080807209015,
                "z": -78.22283935546875
            },
            {
                "x": 0.9306459426879883,
                "y": 0.14235037565231323,
                "z": -78.0679702758789
            },
            {
                "x": 0.9547751545906067,
                "y": 0.1324167549610138,
                "z": -77.91315460205078
            },
            {
                "x": 0.9784572720527649,
                "y": 0.12224544584751129,
                "z": -77.75830078125
            },
            {
                "x": 1.0017114877700806,
                "y": 0.11183340102434158,
                "z": -77.60320281982422
            },
            {
                "x": 1.024465560913086,
                "y": 0.10122145712375641,
                "z": -77.44825744628906
            },
            {
                "x": 1.046749234199524,
                "y": 0.09039999544620514,
                "z": -77.293212890625
            },
            {
                "x": 1.068528652191162,
                "y": 0.07937712222337723,
                "z": -77.13810729980469
            },
            {
                "x": 1.089776873588562,
                "y": 0.06816600263118744,
                "z": -76.98301696777344
            },
            {
                "x": 1.1105358600616455,
                "y": 0.05676107481122017,
                "z": -76.8276596069336
            },
            {
                "x": 1.1307352781295776,
                "y": 0.045200273394584656,
                "z": -76.67247009277344
            },
            {
                "x": 1.1503804922103882,
                "y": 0.03347655385732651,
                "z": -76.51721954345703
            },
            {
                "x": 1.1694585084915161,
                "y": 0.021585974842309952,
                "z": -76.36181640625
            },
            {
                "x": 1.187963843345642,
                "y": 0.009558914229273796,
                "z": -76.20645904541016
            },
            {
                "x": 1.205905795097351,
                "y": -0.0026103868149220943,
                "z": -76.05094909667969
            },
            {
                "x": 1.2232555150985718,
                "y": -0.01490787323564291,
                "z": -75.8953857421875
            },
            {
                "x": 1.2399694919586182,
                "y": -0.02732047624886036,
                "z": -75.7398681640625
            },
            {
                "x": 1.256083607673645,
                "y": -0.039840877056121826,
                "z": -75.58433532714844
            },
            {
                "x": 1.2715904712677002,
                "y": -0.05246240273118019,
                "z": -75.42872619628906
            },
            {
                "x": 1.2864753007888794,
                "y": -0.0651761144399643,
                "z": -75.27305603027344
            },
            {
                "x": 1.3007233142852783,
                "y": -0.07799223065376282,
                "z": -75.11715698242188
            },
            {
                "x": 1.3143211603164673,
                "y": -0.09086664766073227,
                "z": -74.96139526367188
            },
            {
                "x": 1.32728910446167,
                "y": -0.10381048917770386,
                "z": -74.80553436279297
            },
            {
                "x": 1.3396114110946655,
                "y": -0.1168108806014061,
                "z": -74.64964294433594
            },
            {
                "x": 1.3512554168701172,
                "y": -0.12985624372959137,
                "z": -74.4937515258789
            },
            {
                "x": 1.362257480621338,
                "y": -0.14295776188373566,
                "z": -74.3376235961914
            },
            {
                "x": 1.3725919723510742,
                "y": -0.1560724526643753,
                "z": -74.18165588378906
            },
            {
                "x": 1.3822616338729858,
                "y": -0.16920901834964752,
                "z": -74.025634765625
            },
            {
                "x": 1.3912602663040161,
                "y": -0.18236783146858215,
                "z": -73.8694839477539
            },
            {
                "x": 1.3995814323425293,
                "y": -0.19552084803581238,
                "z": -73.7134017944336
            },
            {
                "x": 1.4072378873825073,
                "y": -0.2086767852306366,
                "z": -73.55718994140625
            },
            {
                "x": 1.4142262935638428,
                "y": -0.22181956470012665,
                "z": -73.40093994140625
            },
            {
                "x": 1.4205348491668701,
                "y": -0.23493021726608276,
                "z": -73.24476623535156
            },
            {
                "x": 1.4261571168899536,
                "y": -0.24801768362522125,
                "z": -73.08845520019531
            },
            {
                "x": 1.4311041831970215,
                "y": -0.26105600595474243,
                "z": -72.93221282958984
            },
            {
                "x": 1.435387372970581,
                "y": -0.27404510974884033,
                "z": -72.77595520019531
            },
            {
                "x": 1.438997507095337,
                "y": -0.2869913578033447,
                "z": -72.61947631835938
            },
            {
                "x": 1.4419021606445312,
                "y": -0.2998518943786621,
                "z": -72.46318054199219
            },
            {
                "x": 1.4441466331481934,
                "y": -0.31263574957847595,
                "z": -72.3068618774414
            },
            {
                "x": 1.4452531337738037,
                "y": -0.32085031270980835,
                "z": -72.20589447021484
            },
            {
                "x": 1.4463932514190674,
                "y": -0.3334883451461792,
                "z": -72.0495376586914
            },
            {
                "x": 1.4468648433685303,
                "y": -0.34603437781333923,
                "z": -71.89307403564453
            },
            {
                "x": 1.4466818571090698,
                "y": -0.3584705889225006,
                "z": -71.73662567138672
            },
            {
                "x": 1.4458396434783936,
                "y": -0.3707825541496277,
                "z": -71.58023834228516
            },
            {
                "x": 1.444297432899475,
                "y": -0.38297104835510254,
                "z": -71.42375946044922
            },
            {
                "x": 1.4420775175094604,
                "y": -0.39501309394836426,
                "z": -71.26741027832031
            },
            {
                "x": 1.4391673803329468,
                "y": -0.40691128373146057,
                "z": -71.11105346679688
            },
            {
                "x": 1.435545802116394,
                "y": -0.4186709523200989,
                "z": -70.95450592041016
            },
            {
                "x": 1.4312005043029785,
                "y": -0.4302482008934021,
                "z": -70.79817962646484
            },
            {
                "x": 1.4261115789413452,
                "y": -0.44165509939193726,
                "z": -70.64181518554688
            },
            {
                "x": 1.4202762842178345,
                "y": -0.45288291573524475,
                "z": -70.48545837402344
            },
            {
                "x": 1.413691520690918,
                "y": -0.4639163613319397,
                "z": -70.3292007446289
            },
            {
                "x": 1.4063149690628052,
                "y": -0.47476136684417725,
                "z": -70.17276763916016
            },
            {
                "x": 1.398138403892517,
                "y": -0.4853808879852295,
                "z": -70.01655578613281
            },
            {
                "x": 1.3891665935516357,
                "y": -0.4957835376262665,
                "z": -69.86038970947266
            },
            {
                "x": 1.379380226135254,
                "y": -0.5059694051742554,
                "z": -69.70417022705078
            },
            {
                "x": 1.3687622547149658,
                "y": -0.5159112215042114,
                "z": -69.54808044433594
            },
            {
                "x": 1.3572665452957153,
                "y": -0.5256077647209167,
                "z": -69.39198303222656
            },
            {
                "x": 1.3449113368988037,
                "y": -0.5350532531738281,
                "z": -69.23592376708984
            },
            {
                "x": 1.3316940069198608,
                "y": -0.5442324876785278,
                "z": -69.08003234863281
            },
            {
                "x": 1.317583680152893,
                "y": -0.553139865398407,
                "z": -68.92420959472656
            },
            {
                "x": 1.3025404214859009,
                "y": -0.5617585182189941,
                "z": -68.76847076416016
            },
            {
                "x": 1.286576747894287,
                "y": -0.570090115070343,
                "z": -68.61283111572266
            },
            {
                "x": 1.2696553468704224,
                "y": -0.5781363248825073,
                "z": -68.45706939697266
            },
            {
                "x": 1.251795768737793,
                "y": -0.5858651399612427,
                "z": -68.3016357421875
            },
            {
                "x": 1.232925295829773,
                "y": -0.5932704210281372,
                "z": -68.14623260498047
            },
            {
                "x": 1.213071346282959,
                "y": -0.6003532409667969,
                "z": -67.99097442626953
            },
            {
                "x": 1.1922216415405273,
                "y": -0.6071025133132935,
                "z": -67.83589935302734
            },
            {
                "x": 1.1703197956085205,
                "y": -0.6135194301605225,
                "z": -67.68074035644531
            },
            {
                "x": 1.147361397743225,
                "y": -0.6195634603500366,
                "z": -67.52595520019531
            },
            {
                "x": 1.1233559846878052,
                "y": -0.6252504587173462,
                "z": -67.37130737304688
            },
            {
                "x": 1.098264455795288,
                "y": -0.6305756568908691,
                "z": -67.21674346923828
            },
            {
                "x": 1.072106957435608,
                "y": -0.6355222463607788,
                "z": -67.06245422363281
            },
            {
                "x": 1.0447664260864258,
                "y": -0.640070378780365,
                "z": -66.90827178955078
            },
            {
                "x": 1.0163060426712036,
                "y": -0.6442263722419739,
                "z": -66.7542953491211
            },
            {
                "x": 0.9867324829101562,
                "y": -0.6479799747467041,
                "z": -66.60063171386719
            },
            {
                "x": 0.9559885263442993,
                "y": -0.6513281464576721,
                "z": -66.44709014892578
            },
            {
                "x": 0.924035906791687,
                "y": -0.6542404890060425,
                "z": -66.29391479492188
            },
            {
                "x": 0.8909055590629578,
                "y": -0.6568195819854736,
                "z": -66.1409912109375
            },
            {
                "x": 0.8565329313278198,
                "y": -0.6591323614120483,
                "z": -65.9881591796875
            },
            {
                "x": 0.8209875226020813,
                "y": -0.6611671447753906,
                "z": -65.83578491210938
            },
            {
                "x": 0.7842308282852173,
                "y": -0.6629077196121216,
                "z": -65.68373107910156
            },
            {
                "x": 0.7597406506538391,
                "y": -0.6638808250427246,
                "z": -65.585693359375
            },
            {
                "x": 0.7208957076072693,
                "y": -0.6651504039764404,
                "z": -65.43415832519531
            },
            {
                "x": 0.6807205677032471,
                "y": -0.6661144495010376,
                "z": -65.28286743164062
            },
            {
                "x": 0.6392674446105957,
                "y": -0.666771411895752,
                "z": -65.1319580078125
            },
            {
                "x": 0.59656822681427,
                "y": -0.6671205163002014,
                "z": -64.98149108886719
            },
            {
                "x": 0.5525606870651245,
                "y": -0.6671565771102905,
                "z": -64.831298828125
            },
            {
                "x": 0.5072517395019531,
                "y": -0.6668688058853149,
                "z": -64.68161010742188
            },
            {
                "x": 0.460631787776947,
                "y": -0.6662672758102417,
                "z": -64.53231811523438
            },
            {
                "x": 0.4126686751842499,
                "y": -0.665361762046814,
                "z": -64.38328552246094
            },
            {
                "x": 0.3634834289550781,
                "y": -0.6641604900360107,
                "z": -64.2348403930664
            },
            {
                "x": 0.3129265010356903,
                "y": -0.662658154964447,
                "z": -64.08678436279297
            },
            {
                "x": 0.26108551025390625,
                "y": -0.6608655452728271,
                "z": -63.93922805786133
            },
            {
                "x": 0.20798827707767487,
                "y": -0.6587938070297241,
                "z": -63.79214859008789
            },
            {
                "x": 0.1535462737083435,
                "y": -0.6564453840255737,
                "z": -63.645347595214844
            },
            {
                "x": 0.09790711104869843,
                "y": -0.6538242697715759,
                "z": -63.49921417236328
            },
            {
                "x": 0.0409945473074913,
                "y": -0.6509356498718262,
                "z": -63.35354995727539
            },
            {
                "x": -0.017151284962892532,
                "y": -0.6477888822555542,
                "z": -63.208274841308594
            },
            {
                "x": -0.07645710557699203,
                "y": -0.6443933844566345,
                "z": -63.06354522705078
            },
            {
                "x": -0.13697026669979095,
                "y": -0.6407448649406433,
                "z": -62.919212341308594
            },
            {
                "x": -0.19864138960838318,
                "y": -0.63685142993927,
                "z": -62.77535629272461
            },
            {
                "x": -0.26134270429611206,
                "y": -0.6327272653579712,
                "z": -62.632022857666016
            },
            {
                "x": -0.3250950574874878,
                "y": -0.6283753514289856,
                "z": -62.48912811279297
            },
            {
                "x": -0.3898479640483856,
                "y": -0.6237961649894714,
                "z": -62.346656799316406
            },
            {
                "x": -0.4555578827857971,
                "y": -0.6189950704574585,
                "z": -62.20458221435547
            },
            {
                "x": -0.5222260355949402,
                "y": -0.613976240158081,
                "z": -62.06269836425781
            },
            {
                "x": -0.5896076560020447,
                "y": -0.6087578535079956,
                "z": -61.92131805419922
            },
            {
                "x": -0.6577626466751099,
                "y": -0.6033332347869873,
                "z": -61.78019714355469
            },
            {
                "x": -0.7265784740447998,
                "y": -0.5977072715759277,
                "z": -61.63933563232422
            },
            {
                "x": -0.7959237098693848,
                "y": -0.5918932557106018,
                "z": -61.49872970581055
            },
            {
                "x": -0.8658220767974854,
                "y": -0.5858864784240723,
                "z": -61.35809326171875
            },
            {
                "x": -0.9359972476959229,
                "y": -0.5797035694122314,
                "z": -61.21773147583008
            },
            {
                "x": -1.0064119100570679,
                "y": -0.5733401775360107,
                "z": -61.07741165161133
            },
            {
                "x": -1.0769984722137451,
                "y": -0.5668012499809265,
                "z": -60.93694305419922
            },
            {
                "x": -1.1475170850753784,
                "y": -0.5601009130477905,
                "z": -60.796451568603516
            },
            {
                "x": -1.2179211378097534,
                "y": -0.5532337427139282,
                "z": -60.65568923950195
            },
            {
                "x": -1.2880094051361084,
                "y": -0.5462034940719604,
                "z": -60.514617919921875
            },
            {
                "x": -1.3575646877288818,
                "y": -0.5390268564224243,
                "z": -60.373291015625
            },
            {
                "x": -1.4265249967575073,
                "y": -0.5316983461380005,
                "z": -60.23139572143555
            },
            {
                "x": -1.4945927858352661,
                "y": -0.5242324471473694,
                "z": -60.089054107666016
            },
            {
                "x": -1.5615979433059692,
                "y": -0.5166244506835938,
                "z": -59.946044921875
            },
            {
                "x": -1.6274441480636597,
                "y": -0.5088761448860168,
                "z": -59.802120208740234
            },
            {
                "x": -1.691756248474121,
                "y": -0.5010128617286682,
                "z": -59.657569885253906
            },
            {
                "x": -1.7543931007385254,
                "y": -0.4930309057235718,
                "z": -59.51213073730469
            },
            {
                "x": -1.7937933206558228,
                "y": -0.4878106117248535,
                "z": -59.41763687133789
            },
            {
                "x": -1.8531237840652466,
                "y": -0.4796455502510071,
                "z": -59.27055358886719
            },
            {
                "x": -1.9102318286895752,
                "y": -0.471388041973114,
                "z": -59.12257766723633
            },
            {
                "x": -1.9653359651565552,
                "y": -0.46306484937667847,
                "z": -58.974327087402344
            },
            {
                "x": -2.0190227031707764,
                "y": -0.4546745717525482,
                "z": -58.82582092285156
            },
            {
                "x": -2.071493148803711,
                "y": -0.44620633125305176,
                "z": -58.67681121826172
            },
            {
                "x": -2.1227192878723145,
                "y": -0.4376770853996277,
                "z": -58.527496337890625
            },
            {
                "x": -2.1727218627929688,
                "y": -0.4290856122970581,
                "z": -58.3778190612793
            },
            {
                "x": -2.221630573272705,
                "y": -0.42042768001556396,
                "z": -58.22759246826172
            },
            {
                "x": -2.2693724632263184,
                "y": -0.41173189878463745,
                "z": -58.07723617553711
            },
            {
                "x": -2.3160552978515625,
                "y": -0.4029884934425354,
                "z": -57.92647933959961
            },
            {
                "x": -2.361640691757202,
                "y": -0.3942074775695801,
                "z": -57.77544021606445
            },
            {
                "x": -2.4061672687530518,
                "y": -0.38539671897888184,
                "z": -57.6241569519043
            },
            {
                "x": -2.44974946975708,
                "y": -0.3765483498573303,
                "z": -57.47240447998047
            },
            {
                "x": -2.492300033569336,
                "y": -0.36768996715545654,
                "z": -57.320579528808594
            },
            {
                "x": -2.533863067626953,
                "y": -0.3588162660598755,
                "z": -57.16850662231445
            },
            {
                "x": -2.574491262435913,
                "y": -0.3499266505241394,
                "z": -57.016082763671875
            },
            {
                "x": -2.614168167114258,
                "y": -0.34103912115097046,
                "z": -56.863529205322266
            },
            {
                "x": -2.6529674530029297,
                "y": -0.33214741945266724,
                "z": -56.710662841796875
            },
            {
                "x": -2.6908583641052246,
                "y": -0.3232625722885132,
                "z": -56.55758285522461
            },
            {
                "x": -2.7278337478637695,
                "y": -0.31439003348350525,
                "z": -56.40438461303711
            },
            {
                "x": -2.7639431953430176,
                "y": -0.3054196834564209,
                "z": -56.25099563598633
            },
            {
                "x": -2.7992067337036133,
                "y": -0.2963029742240906,
                "z": -56.09742736816406
            },
            {
                "x": -2.833627939224243,
                "y": -0.2870485782623291,
                "z": -55.94368362426758
            },
            {
                "x": -2.8672432899475098,
                "y": -0.2776506543159485,
                "z": -55.78956604003906
            },
            {
                "x": -2.8999993801116943,
                "y": -0.2681465744972229,
                "z": -55.63549041748047
            },
            {
                "x": -2.931973934173584,
                "y": -0.25852808356285095,
                "z": -55.48121643066406
            },
            {
                "x": -2.963146448135376,
                "y": -0.24880565702915192,
                "z": -55.3267822265625
            },
            {
                "x": -2.9934935569763184,
                "y": -0.2389887571334839,
                "z": -55.17226028442383
            },
            {
                "x": -3.0231151580810547,
                "y": -0.229072704911232,
                "z": -55.017398834228516
            },
            {
                "x": -3.0519301891326904,
                "y": -0.21909108757972717,
                "z": -54.86260223388672
            },
            {
                "x": -3.0799851417541504,
                "y": -0.2090396285057068,
                "z": -54.70767593383789
            },
            {
                "x": -3.1072869300842285,
                "y": -0.19891539216041565,
                "z": -54.5525016784668
            },
            {
                "x": -3.1338205337524414,
                "y": -0.1887454390525818,
                "z": -54.39731979370117
            },
            {
                "x": -3.1596434116363525,
                "y": -0.17852377891540527,
                "z": -54.2419319152832
            },
            {
                "x": -3.1847336292266846,
                "y": -0.16826388239860535,
                "z": -54.08641815185547
            },
            {
                "x": -3.209052085876465,
                "y": -0.15798135101795197,
                "z": -53.930904388427734
            },
            {
                "x": -3.232672691345215,
                "y": -0.14766976237297058,
                "z": -53.77516174316406
            },
            {
                "x": -3.2555575370788574,
                "y": -0.13735350966453552,
                "z": -53.619441986083984
            },
            {
                "x": -3.277744770050049,
                "y": -0.12703220546245575,
                "z": -53.46360778808594
            },
            {
                "x": -3.2992196083068848,
                "y": -0.11670169234275818,
                "z": -53.3074836730957
            },
            {
                "x": -3.319969892501831,
                "y": -0.106393963098526,
                "z": -53.151458740234375
            },
            {
                "x": -3.3400189876556396,
                "y": -0.09560181200504303,
                "z": -52.99535369873047
            },
            {
                "x": -3.352602481842041,
                "y": -0.08797983825206757,
                "z": -52.89451599121094
            },
            {
                "x": -3.3714771270751953,
                "y": -0.07514861971139908,
                "z": -52.7384033203125
            },
            {
                "x": -3.389667510986328,
                "y": -0.06119352951645851,
                "z": -52.58223342895508
            },
            {
                "x": -3.407163143157959,
                "y": -0.046213191002607346,
                "z": -52.42606735229492
            },
            {
                "x": -3.4239461421966553,
                "y": -0.030296357348561287,
                "z": -52.27003479003906
            },
            {
                "x": -3.440035343170166,
                "y": -0.013510803692042828,
                "z": -52.1139030456543
            },
            {
                "x": -3.455434799194336,
                "y": 0.004000568762421608,
                "z": -51.95790481567383
            },
            {
                "x": -3.470153331756592,
                "y": 0.022160900756716728,
                "z": -51.801902770996094
            },
            {
                "x": -3.4842159748077393,
                "y": 0.0409020371735096,
                "z": -51.64573669433594
            },
            {
                "x": -3.4975533485412598,
                "y": 0.06010151281952858,
                "z": -51.48974609375
            },
            {
                "x": -3.51023530960083,
                "y": 0.07967546582221985,
                "z": -51.33369445800781
            },
            {
                "x": -3.5222434997558594,
                "y": 0.09952772408723831,
                "z": -51.177635192871094
            },
            {
                "x": -3.5335891246795654,
                "y": 0.11956168711185455,
                "z": -51.021602630615234
            },
            {
                "x": -3.5442516803741455,
                "y": 0.13971951603889465,
                "z": -50.86534118652344
            },
            {
                "x": -3.554241180419922,
                "y": 0.15985560417175293,
                "z": -50.709232330322266
            },
            {
                "x": -3.5635628700256348,
                "y": 0.1799027919769287,
                "z": -50.55308151245117
            },
            {
                "x": -3.572232961654663,
                "y": 0.19978860020637512,
                "z": -50.396759033203125
            },
            {
                "x": -3.580223560333252,
                "y": 0.2193852663040161,
                "z": -50.240474700927734
            },
            {
                "x": -3.587538480758667,
                "y": 0.23862439393997192,
                "z": -50.08400344848633
            },
            {
                "x": -3.594195604324341,
                "y": 0.2574072480201721,
                "z": -49.927459716796875
            },
            {
                "x": -3.6001803874969482,
                "y": 0.27563369274139404,
                "z": -49.77091598510742
            },
            {
                "x": -3.6055047512054443,
                "y": 0.2932215631008148,
                "z": -49.61427688598633
            },
            {
                "x": -3.610130786895752,
                "y": 0.3100459575653076,
                "z": -49.457542419433594
            },
            {
                "x": -3.6140921115875244,
                "y": 0.3260450065135956,
                "z": -49.30069351196289
            },
            {
                "x": -3.6173903942108154,
                "y": 0.34114259481430054,
                "z": -49.14354705810547
            },
            {
                "x": -3.6200060844421387,
                "y": 0.3552092909812927,
                "z": -48.986480712890625
            },
            {
                "x": -3.6219286918640137,
                "y": 0.3681250810623169,
                "z": -48.82925033569336
            },
            {
                "x": -3.6231586933135986,
                "y": 0.3798263669013977,
                "z": -48.671913146972656
            },
            {
                "x": -3.6236515045166016,
                "y": 0.39023011922836304,
                "z": -48.5144157409668
            },
            {
                "x": -3.623157024383545,
                "y": 0.39926281571388245,
                "z": -48.35640335083008
            },
            {
                "x": -3.621306896209717,
                "y": 0.40674400329589844,
                "z": -48.19834899902344
            },
            {
                "x": -3.6180312633514404,
                "y": 0.4126749038696289,
                "z": -48.04021453857422
            },
            {
                "x": -3.613262414932251,
                "y": 0.4177812337875366,
                "z": -47.88189697265625
            },
            {
                "x": -3.606982469558716,
                "y": 0.4218200445175171,
                "z": -47.72370529174805
            },
            {
                "x": -3.5990514755249023,
                "y": 0.4245472550392151,
                "z": -47.565399169921875
            },
            {
                "x": -3.589462995529175,
                "y": 0.42606672644615173,
                "z": -47.407142639160156
            },
            {
                "x": -3.5782055854797363,
                "y": 0.42648065090179443,
                "z": -47.249046325683594
            },
            {
                "x": -3.565199375152588,
                "y": 0.42587125301361084,
                "z": -47.09092712402344
            },
            {
                "x": -3.550377130508423,
                "y": 0.4242943227291107,
                "z": -46.93306350708008
            },
            {
                "x": -3.5337226390838623,
                "y": 0.4218493700027466,
                "z": -46.77534866333008
            },
            {
                "x": -3.5151965618133545,
                "y": 0.41863083839416504,
                "z": -46.61762237548828
            },
            {
                "x": -3.494823694229126,
                "y": 0.41472935676574707,
                "z": -46.460330963134766
            },
            {
                "x": -3.4722037315368652,
                "y": 0.41020241379737854,
                "z": -46.303340911865234
            },
            {
                "x": -3.4570579528808594,
                "y": 0.4070000946521759,
                "z": -46.20201110839844
            },
            {
                "x": -3.4316160678863525,
                "y": 0.4016691744327545,
                "z": -46.04548263549805
            },
            {
                "x": -3.404242515563965,
                "y": 0.3959472179412842,
                "z": -45.88918685913086
            },
            {
                "x": -3.374955415725708,
                "y": 0.3899195194244385,
                "z": -45.73326873779297
            },
            {
                "x": -3.343867063522339,
                "y": 0.3836837410926819,
                "z": -45.57783126831055
            },
            {
                "x": -3.3109891414642334,
                "y": 0.37731218338012695,
                "z": -45.42270278930664
            },
            {
                "x": -3.2764155864715576,
                "y": 0.3708949089050293,
                "z": -45.26810073852539
            },
            {
                "x": -3.240178108215332,
                "y": 0.364513099193573,
                "z": -45.11396026611328
            },
            {
                "x": -3.2023870944976807,
                "y": 0.3582395315170288,
                "z": -44.96005630493164
            },
            {
                "x": -3.163259983062744,
                "y": 0.3521697521209717,
                "z": -44.80677795410156
            },
            {
                "x": -3.1228506565093994,
                "y": 0.3463757634162903,
                "z": -44.65386962890625
            },
            {
                "x": -3.0812885761260986,
                "y": 0.3409532308578491,
                "z": -44.50137710571289
            },
            {
                "x": -3.0387866497039795,
                "y": 0.33597081899642944,
                "z": -44.34930419921875
            },
            {
                "x": -2.9954421520233154,
                "y": 0.3315002918243408,
                "z": -44.1973991394043
            },
            {
                "x": -2.9515223503112793,
                "y": 0.3276359438896179,
                "z": -44.045982360839844
            },
            {
                "x": -2.9071438312530518,
                "y": 0.3244771361351013,
                "z": -43.894832611083984
            },
            {
                "x": -2.8624587059020996,
                "y": 0.32207608222961426,
                "z": -43.743778228759766
            },
            {
                "x": -2.8177032470703125,
                "y": 0.3205151855945587,
                "z": -43.59300231933594
            },
            {
                "x": -2.772982597351074,
                "y": 0.3198772072792053,
                "z": -43.44223403930664
            },
            {
                "x": -2.728496551513672,
                "y": 0.3202857971191406,
                "z": -43.29153060913086
            },
            {
                "x": -2.6844229698181152,
                "y": 0.3217787742614746,
                "z": -43.14094924926758
            },
            {
                "x": -2.6408748626708984,
                "y": 0.3244359493255615,
                "z": -42.99034118652344
            },
            {
                "x": -2.5979788303375244,
                "y": 0.32799845933914185,
                "z": -42.83970260620117
            },
            {
                "x": -2.5558876991271973,
                "y": 0.33154332637786865,
                "z": -42.688934326171875
            },
            {
                "x": -2.514613151550293,
                "y": 0.3349902629852295,
                "z": -42.53782272338867
            },
            {
                "x": -2.474353075027466,
                "y": 0.33832716941833496,
                "z": -42.386714935302734
            },
            {
                "x": -2.435110092163086,
                "y": 0.3415571451187134,
                "z": -42.235347747802734
            },
            {
                "x": -2.3970375061035156,
                "y": 0.34467047452926636,
                "z": -42.083740234375
            },
            {
                "x": -2.360140800476074,
                "y": 0.3476683497428894,
                "z": -41.93193817138672
            },
            {
                "x": -2.3244078159332275,
                "y": 0.35055243968963623,
                "z": -41.779685974121094
            },
            {
                "x": -2.2899680137634277,
                "y": 0.3533118963241577,
                "z": -41.62737274169922
            },
            {
                "x": -2.256863594055176,
                "y": 0.3559420704841614,
                "z": -41.47477340698242
            },
            {
                "x": -2.2250254154205322,
                "y": 0.3584466576576233,
                "z": -41.32179641723633
            },
            {
                "x": -2.1945033073425293,
                "y": 0.3608187437057495,
                "z": -41.168670654296875
            },
            {
                "x": -2.1652731895446777,
                "y": 0.36305826902389526,
                "z": -41.01520919799805
            },
            {
                "x": -2.1374096870422363,
                "y": 0.3651544451713562,
                "z": -40.86147689819336
            },
            {
                "x": -2.1108546257019043,
                "y": 0.36710795760154724,
                "z": -40.70760726928711
            },
            {
                "x": -2.085573673248291,
                "y": 0.368918240070343,
                "z": -40.553401947021484
            },
            {
                "x": -2.061574697494507,
                "y": 0.3705803155899048,
                "z": -40.39906692504883
            },
            {
                "x": -2.0388824939727783,
                "y": 0.37208446860313416,
                "z": -40.24455261230469
            },
            {
                "x": -2.017402410507202,
                "y": 0.3734353482723236,
                "z": -40.0896110534668
            },
            {
                "x": -1.9971568584442139,
                "y": 0.3746262490749359,
                "z": -39.93470764160156
            },
            {
                "x": -1.9780675172805786,
                "y": 0.375655859708786,
                "z": -39.77961730957031
            },
            {
                "x": -1.9664478302001953,
                "y": 0.3762277662754059,
                "z": -39.67935562133789
            },
            {
                "x": -1.9493186473846436,
                "y": 0.37697917222976685,
                "z": -39.52399444580078
            },
            {
                "x": -1.933305025100708,
                "y": 0.3775608539581299,
                "z": -39.368408203125
            },
            {
                "x": -1.9183766841888428,
                "y": 0.3779633939266205,
                "z": -39.212646484375
            },
            {
                "x": -1.9044331312179565,
                "y": 0.3781852126121521,
                "z": -39.05683135986328
            },
            {
                "x": -1.891585350036621,
                "y": 0.378226637840271,
                "z": -38.90102005004883
            },
            {
                "x": -1.8799306154251099,
                "y": 0.3780868947505951,
                "z": -38.74522399902344
            },
            {
                "x": -1.8695945739746094,
                "y": 0.37776416540145874,
                "z": -38.58946228027344
            },
            {
                "x": -1.8607170581817627,
                "y": 0.37726229429244995,
                "z": -38.43355178833008
            },
            {
                "x": -1.8534214496612549,
                "y": 0.37659043073654175,
                "z": -38.27785110473633
            },
            {
                "x": -1.847808599472046,
                "y": 0.3757508397102356,
                "z": -38.12211990356445
            },
            {
                "x": -1.8440303802490234,
                "y": 0.3747429847717285,
                "z": -37.9664192199707
            },
            {
                "x": -1.8421581983566284,
                "y": 0.37357139587402344,
                "z": -37.810794830322266
            },
            {
                "x": -1.8421947956085205,
                "y": 0.37224119901657104,
                "z": -37.65500259399414
            },
            {
                "x": -1.844173550605774,
                "y": 0.3707590401172638,
                "z": -37.49943542480469
            },
            {
                "x": -1.8481446504592896,
                "y": 0.3691229224205017,
                "z": -37.34389877319336
            },
            {
                "x": -1.8541045188903809,
                "y": 0.36733540892601013,
                "z": -37.18832015991211
            },
            {
                "x": -1.8619630336761475,
                "y": 0.36540573835372925,
                "z": -37.032894134521484
            },
            {
                "x": -1.8716914653778076,
                "y": 0.3633340895175934,
                "z": -36.877437591552734
            },
            {
                "x": -1.8832697868347168,
                "y": 0.3611227869987488,
                "z": -36.72207260131836
            },
            {
                "x": -1.8966325521469116,
                "y": 0.3587755858898163,
                "z": -36.56688690185547
            },
            {
                "x": -1.9116690158843994,
                "y": 0.35629820823669434,
                "z": -36.41179656982422
            },
            {
                "x": -1.9283084869384766,
                "y": 0.3536939024925232,
                "z": -36.256813049316406
            },
            {
                "x": -1.9465032815933228,
                "y": 0.35096311569213867,
                "z": -36.1019401550293
            },
            {
                "x": -1.966216802597046,
                "y": 0.3481050133705139,
                "z": -35.94699478149414
            },
            {
                "x": -1.98728346824646,
                "y": 0.34513282775878906,
                "z": -35.7923698425293
            },
            {
                "x": -2.0096559524536133,
                "y": 0.34204602241516113,
                "z": -35.637813568115234
            },
            {
                "x": -2.0332834720611572,
                "y": 0.33884578943252563,
                "z": -35.48337936401367
            },
            {
                "x": -2.058103561401367,
                "y": 0.3355359733104706,
                "z": -35.329139709472656
            },
            {
                "x": -2.0840494632720947,
                "y": 0.3321174383163452,
                "z": -35.17483139038086
            },
            {
                "x": -2.1109960079193115,
                "y": 0.32860201597213745,
                "z": -35.020843505859375
            },
            {
                "x": -2.1389338970184326,
                "y": 0.32498711347579956,
                "z": -34.86699676513672
            },
            {
                "x": -2.1678388118743896,
                "y": 0.3212713897228241,
                "z": -34.71315383911133
            },
            {
                "x": -2.197592258453369,
                "y": 0.3174668550491333,
                "z": -34.55955505371094
            },
            {
                "x": -2.2281806468963623,
                "y": 0.3135714530944824,
                "z": -34.405982971191406
            },
            {
                "x": -2.2595484256744385,
                "y": 0.30958980321884155,
                "z": -34.252525329589844
            },
            {
                "x": -2.2916531562805176,
                "y": 0.30552542209625244,
                "z": -34.09929656982422
            },
            {
                "x": -2.324470281600952,
                "y": 0.30137938261032104,
                "z": -33.946075439453125
            },
            {
                "x": -2.3579118251800537,
                "y": 0.29716044664382935,
                "z": -33.793060302734375
            },
            {
                "x": -2.3919732570648193,
                "y": 0.2928682267665863,
                "z": -33.640159606933594
            },
            {
                "x": -2.4266793727874756,
                "y": 0.2884984612464905,
                "z": -33.4871826171875
            },
            {
                "x": -2.4618942737579346,
                "y": 0.28406810760498047,
                "z": -33.33448791503906
            },
            {
                "x": -2.497629404067993,
                "y": 0.27957460284233093,
                "z": -33.18189239501953
            },
            {
                "x": -2.5209813117980957,
                "y": 0.2766380310058594,
                "z": -33.08333206176758
            },
            {
                "x": -2.5574090480804443,
                "y": 0.2720341682434082,
                "z": -32.93049240112305
            },
            {
                "x": -2.5937435626983643,
                "y": 0.26736074686050415,
                "z": -32.77717208862305
            },
            {
                "x": -2.629699945449829,
                "y": 0.2626304030418396,
                "z": -32.623680114746094
            },
            {
                "x": -2.6651551723480225,
                "y": 0.25784832239151,
                "z": -32.470123291015625
            },
            {
                "x": -2.7001214027404785,
                "y": 0.2530131936073303,
                "z": -32.316280364990234
            },
            {
                "x": -2.7344799041748047,
                "y": 0.2481347620487213,
                "z": -32.162353515625
            },
            {
                "x": -2.768187999725342,
                "y": 0.24321305751800537,
                "z": -32.00822067260742
            },
            {
                "x": -2.8011815547943115,
                "y": 0.23824280500411987,
                "z": -31.853654861450195
            },
            {
                "x": -2.8333208560943604,
                "y": 0.23324191570281982,
                "z": -31.699045181274414
            },
            {
                "x": -2.8645923137664795,
                "y": 0.22820524871349335,
                "z": -31.544126510620117
            },
            {
                "x": -2.8949027061462402,
                "y": 0.2231380045413971,
                "z": -31.388944625854492
            },
            {
                "x": -2.924121618270874,
                "y": 0.21804478764533997,
                "z": -31.233551025390625
            },
            {
                "x": -2.952244997024536,
                "y": 0.21292167901992798,
                "z": -31.07768440246582
            },
            {
                "x": -2.9791409969329834,
                "y": 0.20778518915176392,
                "z": -30.921737670898438
            },
            {
                "x": -3.004777431488037,
                "y": 0.20263254642486572,
                "z": -30.765522003173828
            },
            {
                "x": -3.0290584564208984,
                "y": 0.19746357202529907,
                "z": -30.60892677307129
            },
            {
                "x": -3.051919460296631,
                "y": 0.19228996336460114,
                "z": -30.452186584472656
            },
            {
                "x": -3.0733604431152344,
                "y": 0.18710868060588837,
                "z": -30.295103073120117
            },
            {
                "x": -3.093327522277832,
                "y": 0.18192696571350098,
                "z": -30.137798309326172
            },
            {
                "x": -3.1117308139801025,
                "y": 0.1767522096633911,
                "z": -29.980377197265625
            },
            {
                "x": -3.128587007522583,
                "y": 0.17158524692058563,
                "z": -29.822769165039062
            },
            {
                "x": -3.143911600112915,
                "y": 0.1664300560951233,
                "z": -29.665006637573242
            },
            {
                "x": -3.157705307006836,
                "y": 0.1612730175256729,
                "z": -29.507108688354492
            },
            {
                "x": -3.169947385787964,
                "y": 0.15525077283382416,
                "z": -29.348953247070312
            },
            {
                "x": -3.180640935897827,
                "y": 0.1478869915008545,
                "z": -29.190967559814453
            },
            {
                "x": -3.1898672580718994,
                "y": 0.13928449153900146,
                "z": -29.032920837402344
            },
            {
                "x": -3.197655439376831,
                "y": 0.1295371651649475,
                "z": -28.874893188476562
            },
            {
                "x": -3.204014778137207,
                "y": 0.11871804296970367,
                "z": -28.71697235107422
            },
            {
                "x": -3.2090036869049072,
                "y": 0.10690610110759735,
                "z": -28.558900833129883
            },
            {
                "x": -3.212692975997925,
                "y": 0.09424878656864166,
                "z": -28.40110969543457
            },
            {
                "x": -3.2151424884796143,
                "y": 0.08082358539104462,
                "z": -28.243404388427734
            },
            {
                "x": -3.21638822555542,
                "y": 0.06670208275318146,
                "z": -28.085674285888672
            },
            {
                "x": -3.2164664268493652,
                "y": 0.051992420107126236,
                "z": -27.92815589904785
            },
            {
                "x": -3.2154746055603027,
                "y": 0.03678654134273529,
                "z": -27.7706298828125
            },
            {
                "x": -3.2134644985198975,
                "y": 0.02118552476167679,
                "z": -27.613204956054688
            },
            {
                "x": -3.2104806900024414,
                "y": 0.005595773458480835,
                "z": -27.45590591430664
            },
            {
                "x": -3.2065420150756836,
                "y": -0.008606135845184326,
                "z": -27.29840660095215
            },
            {
                "x": -3.201735734939575,
                "y": -0.02133450284600258,
                "z": -27.140962600708008
            },
            {
                "x": -3.1961123943328857,
                "y": -0.03267083317041397,
                "z": -26.983478546142578
            },
            {
                "x": -3.1896963119506836,
                "y": -0.042700834572315216,
                "z": -26.825742721557617
            },
            {
                "x": -3.1823794841766357,
                "y": -0.05142301321029663,
                "z": -26.668046951293945
            },
            {
                "x": -3.1741297245025635,
                "y": -0.0589764378964901,
                "z": -26.51033592224121
            },
            {
                "x": -3.1683149337768555,
                "y": -0.06328947097063065,
                "z": -26.408403396606445
            },
            {
                "x": -3.1583664417266846,
                "y": -0.0690665990114212,
                "z": -26.250560760498047
            },
            {
                "x": -3.1472442150115967,
                "y": -0.07386572659015656,
                "z": -26.09259796142578
            },
            {
                "x": -3.134927988052368,
                "y": -0.07777030766010284,
                "z": -25.934663772583008
            },
            {
                "x": -3.1213765144348145,
                "y": -0.08085279166698456,
                "z": -25.776870727539062
            },
            {
                "x": -3.1064956188201904,
                "y": -0.08316954970359802,
                "z": -25.619016647338867
            },
            {
                "x": -3.090273380279541,
                "y": -0.08480720221996307,
                "z": -25.461368560791016
            },
            {
                "x": -3.072667121887207,
                "y": -0.08585351705551147,
                "z": -25.30382537841797
            },
            {
                "x": -3.0535993576049805,
                "y": -0.08638264238834381,
                "z": -25.146198272705078
            },
            {
                "x": -3.0330402851104736,
                "y": -0.08645520359277725,
                "z": -24.9888916015625
            },
            {
                "x": -3.010923147201538,
                "y": -0.08615540713071823,
                "z": -24.831724166870117
            },
            {
                "x": -2.987215518951416,
                "y": -0.08556438982486725,
                "z": -24.674734115600586
            },
            {
                "x": -2.9619052410125732,
                "y": -0.0847560241818428,
                "z": -24.517988204956055
            },
            {
                "x": -2.9348459243774414,
                "y": -0.08401693403720856,
                "z": -24.36134910583496
            },
            {
                "x": -2.906073808670044,
                "y": -0.08457913994789124,
                "z": -24.205158233642578
            },
            {
                "x": -2.8755507469177246,
                "y": -0.08622536063194275,
                "z": -24.049264907836914
            },
            {
                "x": -2.8432021141052246,
                "y": -0.08694186061620712,
                "z": -23.893495559692383
            },
            {
                "x": -2.8090121746063232,
                "y": -0.08616753667593002,
                "z": -23.738237380981445
            },
            {
                "x": -2.772928476333618,
                "y": -0.08400087058544159,
                "z": -23.583267211914062
            },
            {
                "x": -2.7349815368652344,
                "y": -0.08068126440048218,
                "z": -23.428768157958984
            },
            {
                "x": -2.6952974796295166,
                "y": -0.07746990770101547,
                "z": -23.275096893310547
            },
            {
                "x": -2.6547577381134033,
                "y": -0.07485608756542206,
                "z": -23.122581481933594
            },
            {
                "x": -2.6136584281921387,
                "y": -0.07273560762405396,
                "z": -22.97028160095215
            },
            {
                "x": -2.5719854831695557,
                "y": -0.07101288437843323,
                "z": -22.818115234375
            },
            {
                "x": -2.5296719074249268,
                "y": -0.06960581243038177,
                "z": -22.6658992767334
            },
            {
                "x": -2.486800193786621,
                "y": -0.06844237446784973,
                "z": -22.51403045654297
            },
            {
                "x": -2.4433202743530273,
                "y": -0.067434161901474,
                "z": -22.36229705810547
            },
            {
                "x": -2.3992881774902344,
                "y": -0.06649629771709442,
                "z": -22.210750579833984
            },
            {
                "x": -2.3547699451446533,
                "y": -0.06555011123418808,
                "z": -22.05945587158203
            },
            {
                "x": -2.3097331523895264,
                "y": -0.06450828909873962,
                "z": -21.908164978027344
            },
            {
                "x": -2.264380693435669,
                "y": -0.06329334527254105,
                "z": -21.75725746154785
            },
            {
                "x": -2.218744993209839,
                "y": -0.06182807683944702,
                "z": -21.606521606445312
            },
            {
                "x": -2.172886848449707,
                "y": -0.06002940982580185,
                "z": -21.45583152770996
            },
            {
                "x": -2.126983404159546,
                "y": -0.05785372480750084,
                "z": -21.305400848388672
            },
            {
                "x": -2.081089973449707,
                "y": -0.05535421520471573,
                "z": -21.154985427856445
            },
            {
                "x": -2.035352945327759,
                "y": -0.052461616694927216,
                "z": -21.004655838012695
            },
            {
                "x": -1.989937424659729,
                "y": -0.0490880087018013,
                "z": -20.854467391967773
            },
            {
                "x": -1.9449005126953125,
                "y": -0.0451645590364933,
                "z": -20.704193115234375
            },
            {
                "x": -1.900418996810913,
                "y": -0.04063757136464119,
                "z": -20.554000854492188
            },
            {
                "x": -1.856576919555664,
                "y": -0.03542662784457207,
                "z": -20.403757095336914
            },
            {
                "x": -1.8134630918502808,
                "y": -0.029432376846671104,
                "z": -20.253236770629883
            },
            {
                "x": -1.7712444067001343,
                "y": -0.022800130769610405,
                "z": -20.102815628051758
            },
            {
                "x": -1.7299461364746094,
                "y": -0.01677495241165161,
                "z": -19.95223617553711
            },
            {
                "x": -1.7038275003433228,
                "y": -0.01351231150329113,
                "z": -19.854841232299805
            },
            {
                "x": -1.664219856262207,
                "y": -0.009413233026862144,
                "z": -19.70387077331543
            },
            {
                "x": -1.6256763935089111,
                "y": -0.006583514157682657,
                "z": -19.55255126953125
            },
            {
                "x": -1.5883145332336426,
                "y": -0.005191398318856955,
                "z": -19.400949478149414
            },
            {
                "x": -1.5521198511123657,
                "y": -0.004999993368983269,
                "z": -19.24916648864746
            },
            {
                "x": -1.5170751810073853,
                "y": -0.005000004544854164,
                "z": -19.09699821472168
            },
            {
                "x": -1.4832695722579956,
                "y": -0.005000008270144463,
                "z": -18.94464683532715
            },
            {
                "x": -1.45065176486969,
                "y": -0.005000000819563866,
                "z": -18.79203987121582
            },
            {
                "x": -1.41916024684906,
                "y": -0.0049999915063381195,
                "z": -18.638973236083984
            },
            {
                "x": -1.3888243436813354,
                "y": -0.004999998956918716,
                "z": -18.48582649230957
            },
            {
                "x": -1.3596460819244385,
                "y": -0.004999998956918716,
                "z": -18.332386016845703
            },
            {
                "x": -1.3315068483352661,
                "y": -0.004999998956918716,
                "z": -18.178682327270508
            },
            {
                "x": -1.3044012784957886,
                "y": -0.005000004544854164,
                "z": -18.024822235107422
            },
            {
                "x": -1.2782182693481445,
                "y": -0.005000002682209015,
                "z": -17.870534896850586
            },
            {
                "x": -1.2530148029327393,
                "y": -0.0049999915063381195,
                "z": -17.716218948364258
            },
            {
                "x": -1.2286396026611328,
                "y": -0.004999997094273567,
                "z": -17.56172752380371
            },
            {
                "x": -1.205019235610962,
                "y": -0.004999997094273567,
                "z": -17.406925201416016
            },
            {
                "x": -1.182155728340149,
                "y": -0.005000000819563866,
                "z": -17.252050399780273
            },
            {
                "x": -1.1599222421646118,
                "y": -0.005000000819563866,
                "z": -17.0969295501709
            },
            {
                "x": -1.138253927230835,
                "y": -0.005000000819563866,
                "z": -16.94164276123047
            },
            {
                "x": -1.1170985698699951,
                "y": -0.004999995231628418,
                "z": -16.78631019592285
            },
            {
                "x": -1.0963866710662842,
                "y": -0.005000002682209015,
                "z": -16.630842208862305
            },
            {
                "x": -1.0760279893875122,
                "y": -0.004999997094273567,
                "z": -16.475263595581055
            },
            {
                "x": -1.0559427738189697,
                "y": -0.005000006407499313,
                "z": -16.3195743560791
            },
            {
                "x": -1.036035418510437,
                "y": -0.005000002682209015,
                "z": -16.163591384887695
            },
            {
                "x": -1.0162776708602905,
                "y": -0.005000000819563866,
                "z": -16.00769805908203
            },
            {
                "x": -0.9965466856956482,
                "y": -0.004999997094273567,
                "z": -15.851643562316895
            },
            {
                "x": -0.9768269062042236,
                "y": -0.004999995231628418,
                "z": -15.695733070373535
            },
            {
                "x": -0.9576669931411743,
                "y": -0.005000000819563866,
                "z": -15.540486335754395
            },
            {
                "x": -0.9393828511238098,
                "y": -0.005000002682209015,
                "z": -15.384937286376953
            },
            {
                "x": -0.921832799911499,
                "y": -0.004999997094273567,
                "z": -15.229338645935059
            },
            {
                "x": -0.9048413634300232,
                "y": -0.004999998956918716,
                "z": -15.073545455932617
            },
            {
                "x": -0.8882675170898438,
                "y": -0.004999998956918716,
                "z": -14.91745662689209
            },
            {
                "x": -0.8720141053199768,
                "y": -0.005000000819563866,
                "z": -14.761322021484375
            },
            {
                "x": -0.8559293746948242,
                "y": -0.004999998956918716,
                "z": -14.60494613647461
            },
            {
                "x": -0.8399267792701721,
                "y": -0.004999997094273567,
                "z": -14.448498725891113
            },
            {
                "x": -0.8239868879318237,
                "y": -0.004999995231628418,
                "z": -14.292122840881348
            },
            {
                "x": -0.8080680966377258,
                "y": -0.005000006407499313,
                "z": -14.135615348815918
            },
            {
                "x": -0.7921732068061829,
                "y": -0.005000004544854164,
                "z": -13.979196548461914
            },
            {
                "x": -0.7762769460678101,
                "y": -0.005000004544854164,
                "z": -13.822761535644531
            },
            {
                "x": -0.7603458166122437,
                "y": -0.005000004544854164,
                "z": -13.666121482849121
            },
            {
                "x": -0.7444090843200684,
                "y": -0.004999997094273567,
                "z": -13.50967025756836
            },
            {
                "x": -0.7284349203109741,
                "y": -0.004999997094273567,
                "z": -13.35321044921875
            },
            {
                "x": -0.7180942296981812,
                "y": -0.004999987781047821,
                "z": -13.252143859863281
            },
            {
                "x": -0.7020412087440491,
                "y": -0.005000004544854164,
                "z": -13.095681190490723
            },
            {
                "x": -0.6859206557273865,
                "y": -0.005000008270144463,
                "z": -12.939118385314941
            },
            {
                "x": -0.6697413325309753,
                "y": -0.00499998964369297,
                "z": -12.782561302185059
            },
            {
                "x": -0.6535139679908752,
                "y": -0.005000006407499313,
                "z": -12.626111030578613
            },
            {
                "x": -0.6372132897377014,
                "y": -0.004999997094273567,
                "z": -12.46955394744873
            },
            {
                "x": -0.6208627223968506,
                "y": -0.00499998964369297,
                "z": -12.313115119934082
            },
            {
                "x": -0.6044512987136841,
                "y": -0.004999998956918716,
                "z": -12.1566801071167
            },
            {
                "x": -0.5879591703414917,
                "y": -0.004999997094273567,
                "z": -12.000054359436035
            },
            {
                "x": -0.5714298486709595,
                "y": -0.004999997094273567,
                "z": -11.843629837036133
            },
            {
                "x": -0.5546620488166809,
                "y": -0.004999998956918716,
                "z": -11.686752319335938
            },
            {
                "x": -0.5371332764625549,
                "y": -0.004999998956918716,
                "z": -11.529622077941895
            },
            {
                "x": -0.5188426971435547,
                "y": -0.004999987781047821,
                "z": -11.372700691223145
            },
            {
                "x": -0.49981454014778137,
                "y": -0.005000000819563866,
                "z": -11.215736389160156
            },
            {
                "x": -0.48019352555274963,
                "y": -0.005000008270144463,
                "z": -11.059118270874023
            },
            {
                "x": -0.46002358198165894,
                "y": -0.005000002682209015,
                "z": -10.90263843536377
            },
            {
                "x": -0.439344197511673,
                "y": -0.005000002682209015,
                "z": -10.746187210083008
            },
            {
                "x": -0.41826048493385315,
                "y": -0.005000002682209015,
                "z": -10.589972496032715
            },
            {
                "x": -0.3968200981616974,
                "y": -0.005000002682209015,
                "z": -10.433771133422852
            },
            {
                "x": -0.37510204315185547,
                "y": -0.004999997094273567,
                "z": -10.277678489685059
            },
            {
                "x": -0.3532432019710541,
                "y": -0.005000000819563866,
                "z": -10.122010231018066
            },
            {
                "x": -0.33191442489624023,
                "y": -0.005000002682209015,
                "z": -9.96696662902832
            },
            {
                "x": -0.311339795589447,
                "y": -0.004999995231628418,
                "z": -9.811882972717285
            },
            {
                "x": -0.2915255129337311,
                "y": -0.005000000819563866,
                "z": -9.656702995300293
            },
            {
                "x": -0.27247002720832825,
                "y": -0.005000002682209015,
                "z": -9.501235008239746
            },
            {
                "x": -0.2541928291320801,
                "y": -0.004999995231628418,
                "z": -9.34587287902832
            },
            {
                "x": -0.2366631180047989,
                "y": -0.005000000819563866,
                "z": -9.19036865234375
            },
            {
                "x": -0.21991124749183655,
                "y": -0.005000006407499313,
                "z": -9.034775733947754
            },
            {
                "x": -0.20392709970474243,
                "y": -0.005000006407499313,
                "z": -8.879152297973633
            },
            {
                "x": -0.18866455554962158,
                "y": -0.004999998956918716,
                "z": -8.723248481750488
            },
            {
                "x": -0.17415562272071838,
                "y": -0.004999995231628418,
                "z": -8.567462921142578
            },
            {
                "x": -0.1604061722755432,
                "y": -0.005000004544854164,
                "z": -8.41159725189209
            },
            {
                "x": -0.14735445380210876,
                "y": -0.005000000819563866,
                "z": -8.255538940429688
            },
            {
                "x": -0.13500365614891052,
                "y": -0.005000010132789612,
                "z": -8.099520683288574
            },
            {
                "x": -0.12333126366138458,
                "y": -0.004999995231628418,
                "z": -7.943329811096191
            },
            {
                "x": -0.11232681572437286,
                "y": -0.004999998956918716,
                "z": -7.78706169128418
            },
            {
                "x": -0.10194573551416397,
                "y": -0.004999985918402672,
                "z": -7.6308064460754395
            },
            {
                "x": -0.09209506958723068,
                "y": -0.005000004544854164,
                "z": -7.4742817878723145
            },
            {
                "x": -0.08264850825071335,
                "y": -0.004999998956918716,
                "z": -7.317662239074707
            },
            {
                "x": -0.07341650873422623,
                "y": -0.004999997094273567,
                "z": -7.160849571228027
            },
            {
                "x": -0.06421368569135666,
                "y": -0.004999998956918716,
                "z": -7.003648281097412
            },
            {
                "x": -0.05488678067922592,
                "y": -0.00499998964369297,
                "z": -6.846465587615967
            },
            {
                "x": -0.04521668329834938,
                "y": -0.005000000819563866,
                "z": -6.689096450805664
            },
            {
                "x": -0.03872678801417351,
                "y": -0.004999997094273567,
                "z": -6.587455749511719
            },
            {
                "x": -0.0286879725754261,
                "y": -0.005000002682209015,
                "z": -6.43111515045166
            },
            {
                "x": -0.020092623308300972,
                "y": -0.004999995231628418,
                "z": -6.275939464569092
            },
            {
                "x": -0.01339268870651722,
                "y": -0.005000006407499313,
                "z": -6.120791912078857
            },
            {
                "x": -0.008538261987268925,
                "y": -0.005000008270144463,
                "z": -5.965585708618164
            },
            {
                "x": -0.0054417261853814125,
                "y": -0.005000002682209015,
                "z": -5.809952735900879
            },
            {
                "x": -0.0033389467280358076,
                "y": -0.004999997094273567,
                "z": -5.65315055847168
            },
            {
                "x": -0.0014116228558123112,
                "y": -0.005000000819563866,
                "z": -5.496084690093994
            },
            {
                "x": 0.00038963137194514275,
                "y": -0.004999998956918716,
                "z": -5.3387980461120605
            },
            {
                "x": 0.002065638080239296,
                "y": -0.005000000819563866,
                "z": -5.181704044342041
            },
            {
                "x": 0.003563559614121914,
                "y": -0.005000008270144463,
                "z": -5.024932861328125
            },
            {
                "x": 0.003962636925280094,
                "y": -0.004999998956918716,
                "z": -4.86924409866333
            },
            {
                "x": 0.0028778472915291786,
                "y": -0.005000006407499313,
                "z": -4.713520526885986
            },
            {
                "x": 0.000495630782097578,
                "y": -0.005000002682209015,
                "z": -4.557395935058594
            },
            {
                "x": -0.0030180006287992,
                "y": -0.004999995231628418,
                "z": -4.401264190673828
            },
            {
                "x": -0.007409750483930111,
                "y": -0.004999997094273567,
                "z": -4.244935035705566
            },
            {
                "x": -0.012486202642321587,
                "y": -0.005000000819563866,
                "z": -4.088301658630371
            },
            {
                "x": -0.018045540899038315,
                "y": -0.005000002682209015,
                "z": -3.93157958984375
            },
            {
                "x": -0.023899449035525322,
                "y": -0.004999987781047821,
                "z": -3.7745306491851807
            },
            {
                "x": -0.02981371432542801,
                "y": -0.005000004544854164,
                "z": -3.6172614097595215
            },
            {
                "x": -0.03566933795809746,
                "y": -0.004999997094273567,
                "z": -3.4602835178375244
            },
            {
                "x": -0.041850171983242035,
                "y": -0.004999997094273567,
                "z": -3.303584575653076
            },
            {
                "x": -0.04836120828986168,
                "y": -0.005000002682209015,
                "z": -3.146745204925537
            },
            {
                "x": -0.055040109902620316,
                "y": -0.005000006407499313,
                "z": -2.9897446632385254
            },
            {
                "x": -0.06173444539308548,
                "y": -0.005000011995434761,
                "z": -2.8323745727539062
            },
            {
                "x": -0.06827718764543533,
                "y": -0.004999995231628418,
                "z": -2.6750214099884033
            },
            {
                "x": -0.07449209690093994,
                "y": -0.005000000819563866,
                "z": -2.51741886138916
            },
            {
                "x": -0.08024051040410995,
                "y": -0.005000002682209015,
                "z": -2.359724283218384
            },
            {
                "x": -0.08558237552642822,
                "y": -0.004999997094273567,
                "z": -2.2022597789764404
            },
            {
                "x": -0.0907285287976265,
                "y": -0.005000002682209015,
                "z": -2.044811487197876
            },
            {
                "x": -0.09587597846984863,
                "y": -0.004999993368983269,
                "z": -1.8877928256988525
            },
            {
                "x": -0.10122774541378021,
                "y": -0.005000002682209015,
                "z": -1.730983853340149
            },
            {
                "x": -0.10696401447057724,
                "y": -0.005000002682209015,
                "z": -1.5742590427398682
            },
            {
                "x": -0.11323854327201843,
                "y": -0.005000004544854164,
                "z": -1.417839765548706
            },
            {
                "x": -0.12023057043552399,
                "y": -0.005000002682209015,
                "z": -1.2614948749542236
            },
            {
                "x": -0.12801557779312134,
                "y": -0.005000010132789612,
                "z": -1.1052777767181396
            },
            {
                "x": -0.13655060529708862,
                "y": -0.004999995231628418,
                "z": -0.9487265944480896
            },
            {
                "x": -0.14517399668693542,
                "y": -0.004999997094273567,
                "z": -0.7914608120918274
            },
            {
                "x": -0.1535387486219406,
                "y": -0.005000002682209015,
                "z": -0.6340210437774658
            },
            {
                "x": -0.1613522619009018,
                "y": -0.005000002682209015,
                "z": -0.47608959674835205
            },
            {
                "x": -0.16807018220424652,
                "y": -0.005000002682209015,
                "z": -0.31706738471984863
            },
            {
                "x": -0.17262333631515503,
                "y": -0.005000002682209015,
                "z": -0.15660689771175385
            },
            {
                "x": -0.17301979660987854,
                "y": -0.004999995231628418,
                "z": 0.005485857371240854
            }
        ],
        "lane2":[
            {
                "x": -0.05724415183067322,
                "y": 0.011982515454292297,
                "z": -419.5831604003906
            },
            {
                "x": -0.057362884283065796,
                "y": 0.011977463960647583,
                "z": -419.4783020019531
            },
            {
                "x": -0.05754116177558899,
                "y": 0.011969856917858124,
                "z": -419.32110595703125
            },
            {
                "x": -0.05771946907043457,
                "y": 0.011962242424488068,
                "z": -419.1637878417969
            },
            {
                "x": -0.05789780616760254,
                "y": 0.011954650282859802,
                "z": -419.0064392089844
            },
            {
                "x": -0.05807596445083618,
                "y": 0.011947043240070343,
                "z": -418.8492126464844
            },
            {
                "x": -0.058254241943359375,
                "y": 0.011939436197280884,
                "z": -418.69183349609375
            },
            {
                "x": -0.05843248963356018,
                "y": 0.011931836605072021,
                "z": -418.53460693359375
            },
            {
                "x": -0.0586107075214386,
                "y": 0.011924229562282562,
                "z": -418.37738037109375
            },
            {
                "x": -0.05878904461860657,
                "y": 0.011916622519493103,
                "z": -418.21990966796875
            },
            {
                "x": -0.058967262506484985,
                "y": 0.01190902292728424,
                "z": -418.0627136230469
            },
            {
                "x": -0.059145569801330566,
                "y": 0.011901408433914185,
                "z": -417.9054260253906
            },
            {
                "x": -0.059323787689208984,
                "y": 0.011893808841705322,
                "z": -417.7481384277344
            },
            {
                "x": -0.05950203537940979,
                "y": 0.011886201798915863,
                "z": -417.5909423828125
            },
            {
                "x": -0.059680432081222534,
                "y": 0.011878587305545807,
                "z": -417.4334716796875
            },
            {
                "x": -0.05985867977142334,
                "y": 0.011870980262756348,
                "z": -417.2762451171875
            },
            {
                "x": -0.06003686785697937,
                "y": 0.011863388121128082,
                "z": -417.1190185546875
            },
            {
                "x": -0.06021517515182495,
                "y": 0.011855781078338623,
                "z": -416.961669921875
            },
            {
                "x": -0.06039342284202576,
                "y": 0.011848174035549164,
                "z": -416.804443359375
            },
            {
                "x": -0.06057173013687134,
                "y": 0.011840566992759705,
                "z": -416.6471252441406
            },
            {
                "x": -0.06075003743171692,
                "y": 0.011832959949970245,
                "z": -416.4897766113281
            },
            {
                "x": -0.06092825531959534,
                "y": 0.011825360357761383,
                "z": -416.33258056640625
            },
            {
                "x": -0.06110638380050659,
                "y": 0.01181776076555252,
                "z": -416.17529296875
            },
            {
                "x": -0.06128460168838501,
                "y": 0.011810161173343658,
                "z": -416.0180969238281
            },
            {
                "x": -0.0614628791809082,
                "y": 0.011802561581134796,
                "z": -415.8608703613281
            },
            {
                "x": -0.06164121627807617,
                "y": 0.011794954538345337,
                "z": -415.7033996582031
            },
            {
                "x": -0.06181946396827698,
                "y": 0.011787347495555878,
                "z": -415.54620361328125
            },
            {
                "x": -0.061997681856155396,
                "y": 0.011779740452766418,
                "z": -415.388916015625
            },
            {
                "x": -0.0621759295463562,
                "y": 0.011772140860557556,
                "z": -415.23162841796875
            },
            {
                "x": -0.06235414743423462,
                "y": 0.011764533817768097,
                "z": -415.07440185546875
            },
            {
                "x": -0.06253251433372498,
                "y": 0.011756926774978638,
                "z": -414.91693115234375
            },
            {
                "x": -0.06271082162857056,
                "y": 0.011749327182769775,
                "z": -414.759765625
            },
            {
                "x": -0.0628889799118042,
                "y": 0.011741727590560913,
                "z": -414.6025085449219
            },
            {
                "x": -0.06306731700897217,
                "y": 0.01173412799835205,
                "z": -414.4451904296875
            },
            {
                "x": -0.0632455050945282,
                "y": 0.011726506054401398,
                "z": -414.2879333496094
            },
            {
                "x": -0.06342387199401855,
                "y": 0.011718899011611938,
                "z": -414.1305847167969
            },
            {
                "x": -0.06360217928886414,
                "y": 0.011711299419403076,
                "z": -413.9732666015625
            },
            {
                "x": -0.06378033757209778,
                "y": 0.011703699827194214,
                "z": -413.8160400390625
            },
            {
                "x": -0.06395867466926575,
                "y": 0.011696092784404755,
                "z": -413.65869140625
            },
            {
                "x": -0.06413689255714417,
                "y": 0.011688485741615295,
                "z": -413.50146484375
            },
            {
                "x": -0.06431511044502258,
                "y": 0.011680878698825836,
                "z": -413.34423828125
            },
            {
                "x": -0.06449347734451294,
                "y": 0.011673279106616974,
                "z": -413.186767578125
            },
            {
                "x": -0.06467172503471375,
                "y": 0.011665664613246918,
                "z": -413.0295715332031
            },
            {
                "x": -0.06484994292259216,
                "y": 0.011658057570457458,
                "z": -412.8723449707031
            },
            {
                "x": -0.06496602296829224,
                "y": 0.011653117835521698,
                "z": -412.770751953125
            },
            {
                "x": -0.06514424085617065,
                "y": 0.011645510792732239,
                "z": -412.613525390625
            },
            {
                "x": -0.06532257795333862,
                "y": 0.01163790374994278,
                "z": -412.4562072753906
            },
            {
                "x": -0.06550085544586182,
                "y": 0.011630304157733917,
                "z": -412.298828125
            },
            {
                "x": -0.06567907333374023,
                "y": 0.011622704565525055,
                "z": -412.1416320800781
            },
            {
                "x": -0.06585738062858582,
                "y": 0.011615097522735596,
                "z": -411.9842529296875
            },
            {
                "x": -0.06603559851646423,
                "y": 0.011607490479946136,
                "z": -411.8270263671875
            },
            {
                "x": -0.06621378660202026,
                "y": 0.011599890887737274,
                "z": -411.6697998046875
            },
            {
                "x": -0.0663922131061554,
                "y": 0.011592276394367218,
                "z": -411.51239013671875
            },
            {
                "x": -0.0665704607963562,
                "y": 0.011584676802158356,
                "z": -411.35516357421875
            },
            {
                "x": -0.06674867868423462,
                "y": 0.0115770623087883,
                "z": -411.1978759765625
            },
            {
                "x": -0.06692689657211304,
                "y": 0.01156945526599884,
                "z": -411.04058837890625
            },
            {
                "x": -0.06710520386695862,
                "y": 0.011561855673789978,
                "z": -410.88336181640625
            },
            {
                "x": -0.06728357076644897,
                "y": 0.011554248631000519,
                "z": -410.7259521484375
            },
            {
                "x": -0.06746178865432739,
                "y": 0.011546649038791656,
                "z": -410.5686950683594
            },
            {
                "x": -0.06763997673988342,
                "y": 0.011539049446582794,
                "z": -410.4114990234375
            },
            {
                "x": -0.067818284034729,
                "y": 0.011531442403793335,
                "z": -410.2541198730469
            },
            {
                "x": -0.06799653172492981,
                "y": 0.011523835361003876,
                "z": -410.0968933105469
            },
            {
                "x": -0.068174809217453,
                "y": 0.011516228318214417,
                "z": -409.9395751953125
            },
            {
                "x": -0.06835314631462097,
                "y": 0.011508636176586151,
                "z": -409.7822265625
            },
            {
                "x": -0.068531334400177,
                "y": 0.011501021683216095,
                "z": -409.625
            },
            {
                "x": -0.06870949268341064,
                "y": 0.01149342954158783,
                "z": -409.4677734375
            },
            {
                "x": -0.06888771057128906,
                "y": 0.011485829949378967,
                "z": -409.310546875
            },
            {
                "x": -0.06906592845916748,
                "y": 0.011478222906589508,
                "z": -409.1533203125
            },
            {
                "x": -0.06924432516098022,
                "y": 0.011470608413219452,
                "z": -408.9958801269531
            },
            {
                "x": -0.06942257285118103,
                "y": 0.011463023722171783,
                "z": -408.8386535644531
            },
            {
                "x": -0.06960079073905945,
                "y": 0.01145540177822113,
                "z": -408.6813659667969
            },
            {
                "x": -0.06977900862693787,
                "y": 0.011447802186012268,
                "z": -408.5240783691406
            },
            {
                "x": -0.06995728611946106,
                "y": 0.011440187692642212,
                "z": -408.3668518066406
            },
            {
                "x": -0.07013565301895142,
                "y": 0.01143258810043335,
                "z": -408.20941162109375
            },
            {
                "x": -0.07031390070915222,
                "y": 0.011424995958805084,
                "z": -408.05218505859375
            },
            {
                "x": -0.07049208879470825,
                "y": 0.011417388916015625,
                "z": -407.89495849609375
            },
            {
                "x": -0.07067039608955383,
                "y": 0.011409781873226166,
                "z": -407.73760986328125
            },
            {
                "x": -0.07084864377975464,
                "y": 0.011402174830436707,
                "z": -407.58038330078125
            },
            {
                "x": -0.07102695107460022,
                "y": 0.011394567787647247,
                "z": -407.42303466796875
            },
            {
                "x": -0.07120522856712341,
                "y": 0.011386960744857788,
                "z": -407.26568603515625
            },
            {
                "x": -0.07138344645500183,
                "y": 0.011379368603229523,
                "z": -407.1084899902344
            },
            {
                "x": -0.0715617835521698,
                "y": 0.01137174665927887,
                "z": -406.9511413574219
            },
            {
                "x": -0.07173994183540344,
                "y": 0.011364154517650604,
                "z": -406.79388427734375
            },
            {
                "x": -0.07191818952560425,
                "y": 0.011356547474861145,
                "z": -406.63665771484375
            },
            {
                "x": -0.0720965564250946,
                "y": 0.011348947882652283,
                "z": -406.4792175292969
            },
            {
                "x": -0.07227477431297302,
                "y": 0.01134134829044342,
                "z": -406.3219909667969
            },
            {
                "x": -0.07245302200317383,
                "y": 0.011333733797073364,
                "z": -406.1647644042969
            },
            {
                "x": -0.07256916165351868,
                "y": 0.011328786611557007,
                "z": -406.06317138671875
            },
            {
                "x": -0.0727473795413971,
                "y": 0.011321179568767548,
                "z": -405.9059753417969
            },
            {
                "x": -0.0729256272315979,
                "y": 0.011313572525978088,
                "z": -405.7486267089844
            },
            {
                "x": -0.07310393452644348,
                "y": 0.011305972933769226,
                "z": -405.5912780761719
            },
            {
                "x": -0.07328221201896667,
                "y": 0.011298365890979767,
                "z": -405.4340515136719
            },
            {
                "x": -0.07346045970916748,
                "y": 0.011290758848190308,
                "z": -405.2767028808594
            },
            {
                "x": -0.07363861799240112,
                "y": 0.011283159255981445,
                "z": -405.1194763183594
            },
            {
                "x": -0.07381689548492432,
                "y": 0.011275552213191986,
                "z": -404.9622497558594
            },
            {
                "x": -0.07399526238441467,
                "y": 0.01126793771982193,
                "z": -404.8048095703125
            },
            {
                "x": -0.07417351007461548,
                "y": 0.011260338127613068,
                "z": -404.6475524902344
            },
            {
                "x": -0.07435175776481628,
                "y": 0.011252723634243011,
                "z": -404.49029541015625
            },
            {
                "x": -0.07453000545501709,
                "y": 0.01124514639377594,
                "z": -404.3330078125
            },
            {
                "x": -0.0747082531452179,
                "y": 0.011237531900405884,
                "z": -404.17578125
            },
            {
                "x": -0.07488662004470825,
                "y": 0.011229924857616425,
                "z": -404.0183410644531
            },
            {
                "x": -0.07506486773490906,
                "y": 0.011222317814826965,
                "z": -403.8611145019531
            },
            {
                "x": -0.07524308562278748,
                "y": 0.011214718222618103,
                "z": -403.7038879394531
            },
            {
                "x": -0.07542136311531067,
                "y": 0.011207103729248047,
                "z": -403.5465393066406
            },
            {
                "x": -0.0755995512008667,
                "y": 0.011199504137039185,
                "z": -403.3893127441406
            },
            {
                "x": -0.07577788829803467,
                "y": 0.011191904544830322,
                "z": -403.2320251464844
            },
            {
                "x": -0.07595619559288025,
                "y": 0.011184312403202057,
                "z": -403.07464599609375
            },
            {
                "x": -0.07613441348075867,
                "y": 0.011176705360412598,
                "z": -402.91741943359375
            },
            {
                "x": -0.07631257176399231,
                "y": 0.011169090867042542,
                "z": -402.76019287109375
            },
            {
                "x": -0.07649075984954834,
                "y": 0.01116149127483368,
                "z": -402.60296630859375
            },
            {
                "x": -0.07666894793510437,
                "y": 0.011153891682624817,
                "z": -402.4457092285156
            },
            {
                "x": -0.07684740424156189,
                "y": 0.01114627718925476,
                "z": -402.2882995605469
            },
            {
                "x": -0.0770256519317627,
                "y": 0.011138685047626495,
                "z": -402.1310729980469
            },
            {
                "x": -0.0772038996219635,
                "y": 0.01113107055425644,
                "z": -401.9737854003906
            },
            {
                "x": -0.0773821473121643,
                "y": 0.011123470962047577,
                "z": -401.8164978027344
            },
            {
                "x": -0.07756036520004272,
                "y": 0.011115871369838715,
                "z": -401.6592712402344
            },
            {
                "x": -0.07773873209953308,
                "y": 0.011108271777629852,
                "z": -401.5018310546875
            },
            {
                "x": -0.07791700959205627,
                "y": 0.011100657284259796,
                "z": -401.3446350097656
            },
            {
                "x": -0.07809513807296753,
                "y": 0.011093050241470337,
                "z": -401.1873779296875
            },
            {
                "x": -0.0782734751701355,
                "y": 0.011085450649261475,
                "z": -401.0299987792969
            },
            {
                "x": -0.07845166325569153,
                "y": 0.011077843606472015,
                "z": -400.872802734375
            },
            {
                "x": -0.07862997055053711,
                "y": 0.011070244014263153,
                "z": -400.7154541015625
            },
            {
                "x": -0.07880830764770508,
                "y": 0.011062636971473694,
                "z": -400.5581359863281
            },
            {
                "x": -0.0789865255355835,
                "y": 0.011055029928684235,
                "z": -400.4009094238281
            },
            {
                "x": -0.07916486263275146,
                "y": 0.01104743778705597,
                "z": -400.2435607910156
            },
            {
                "x": -0.07934302091598511,
                "y": 0.011039823293685913,
                "z": -400.0863342285156
            },
            {
                "x": -0.07952126860618591,
                "y": 0.01103222370147705,
                "z": -399.9291076660156
            },
            {
                "x": -0.07969966530799866,
                "y": 0.011024609208106995,
                "z": -399.7716979980469
            },
            {
                "x": -0.07987791299819946,
                "y": 0.011017009615898132,
                "z": -399.61444091796875
            },
            {
                "x": -0.0800561010837555,
                "y": 0.011009402573108673,
                "z": -399.4572448730469
            },
            {
                "x": -0.08017221093177795,
                "y": 0.011004462838172913,
                "z": -399.3556213378906
            },
            {
                "x": -0.08035045862197876,
                "y": 0.010996848344802856,
                "z": -399.19842529296875
            },
            {
                "x": -0.08052870631217957,
                "y": 0.010989248752593994,
                "z": -399.0411071777344
            },
            {
                "x": -0.08070704340934753,
                "y": 0.010981641709804535,
                "z": -398.8837585449219
            },
            {
                "x": -0.08088529109954834,
                "y": 0.010974034667015076,
                "z": -398.7265319824219
            },
            {
                "x": -0.08106359839439392,
                "y": 0.010966435074806213,
                "z": -398.5691833496094
            },
            {
                "x": -0.08124172687530518,
                "y": 0.010958828032016754,
                "z": -398.4119567871094
            },
            {
                "x": -0.08142003417015076,
                "y": 0.010951228439807892,
                "z": -398.2547302246094
            },
            {
                "x": -0.08159837126731873,
                "y": 0.010943606495857239,
                "z": -398.0972595214844
            },
            {
                "x": -0.08177664875984192,
                "y": 0.010936006903648376,
                "z": -397.9400329589844
            },
            {
                "x": -0.08195486664772034,
                "y": 0.010928414762020111,
                "z": -397.7827453613281
            },
            {
                "x": -0.08213308453559875,
                "y": 0.010920815169811249,
                "z": -397.6254577636719
            },
            {
                "x": -0.08231136202812195,
                "y": 0.010913200676441193,
                "z": -397.46826171875
            },
            {
                "x": -0.08248975872993469,
                "y": 0.010905586183071136,
                "z": -397.3108215332031
            },
            {
                "x": -0.0826680064201355,
                "y": 0.010897979140281677,
                "z": -397.1535949707031
            },
            {
                "x": -0.08284619450569153,
                "y": 0.010890386998653412,
                "z": -396.9963684082031
            },
            {
                "x": -0.08302450180053711,
                "y": 0.010882779955863953,
                "z": -396.8390197753906
            },
            {
                "x": -0.08320271968841553,
                "y": 0.010875172913074493,
                "z": -396.6817932128906
            },
            {
                "x": -0.08338099718093872,
                "y": 0.010867573320865631,
                "z": -396.52447509765625
            },
            {
                "x": -0.08355933427810669,
                "y": 0.010859966278076172,
                "z": -396.36712646484375
            },
            {
                "x": -0.08373755216598511,
                "y": 0.01085236668586731,
                "z": -396.2099304199219
            },
            {
                "x": -0.08391571044921875,
                "y": 0.01084475964307785,
                "z": -396.05267333984375
            },
            {
                "x": -0.08409392833709717,
                "y": 0.010837167501449585,
                "z": -395.89544677734375
            },
            {
                "x": -0.08427214622497559,
                "y": 0.010829560458660126,
                "z": -395.73822021484375
            },
            {
                "x": -0.08445057272911072,
                "y": 0.01082194596529007,
                "z": -395.5808410644531
            },
            {
                "x": -0.08462882041931152,
                "y": 0.010814346373081207,
                "z": -395.4236145019531
            },
            {
                "x": -0.08480706810951233,
                "y": 0.010806754231452942,
                "z": -395.266357421875
            },
            {
                "x": -0.08498534560203552,
                "y": 0.010799139738082886,
                "z": -395.1090393066406
            },
            {
                "x": -0.08516353368759155,
                "y": 0.010791540145874023,
                "z": -394.9517517089844
            },
            {
                "x": -0.08534190058708191,
                "y": 0.010783925652503967,
                "z": -394.7943420410156
            },
            {
                "x": -0.08552014827728271,
                "y": 0.010776318609714508,
                "z": -394.6371154785156
            },
            {
                "x": -0.08569839596748352,
                "y": 0.010768719017505646,
                "z": -394.4798889160156
            },
            {
                "x": -0.08587664365768433,
                "y": 0.010761119425296783,
                "z": -394.3225402832031
            },
            {
                "x": -0.08605489134788513,
                "y": 0.010753527283668518,
                "z": -394.1653137207031
            },
            {
                "x": -0.0862332284450531,
                "y": 0.010745897889137268,
                "z": -394.0079650878906
            },
            {
                "x": -0.08641153573989868,
                "y": 0.010738298296928406,
                "z": -393.85064697265625
            },
            {
                "x": -0.08658969402313232,
                "y": 0.010730698704719543,
                "z": -393.69342041015625
            },
            {
                "x": -0.08676803112030029,
                "y": 0.010723099112510681,
                "z": -393.53607177734375
            },
            {
                "x": -0.08694624900817871,
                "y": 0.010715484619140625,
                "z": -393.3788757324219
            },
            {
                "x": -0.08712446689605713,
                "y": 0.010707877576351166,
                "z": -393.2216491699219
            },
            {
                "x": -0.08730283379554749,
                "y": 0.010700277984142303,
                "z": -393.0641784667969
            },
            {
                "x": -0.08748108148574829,
                "y": 0.010692678391933441,
                "z": -392.9069519042969
            },
            {
                "x": -0.08765929937362671,
                "y": 0.010685078799724579,
                "z": -392.7497253417969
            },
            {
                "x": -0.08777537941932678,
                "y": 0.010680131614208221,
                "z": -392.64813232421875
            },
            {
                "x": -0.0879535973072052,
                "y": 0.010672517120838165,
                "z": -392.4909362792969
            },
            {
                "x": -0.08813190460205078,
                "y": 0.010664917528629303,
                "z": -392.3335876464844
            },
            {
                "x": -0.08831021189689636,
                "y": 0.010657303035259247,
                "z": -392.1763000488281
            },
            {
                "x": -0.08848842978477478,
                "y": 0.010649703443050385,
                "z": -392.01904296875
            },
            {
                "x": -0.08866673707962036,
                "y": 0.010642096400260925,
                "z": -391.8616943359375
            },
            {
                "x": -0.08884492516517639,
                "y": 0.010634496808052063,
                "z": -391.7044677734375
            },
            {
                "x": -0.0890231728553772,
                "y": 0.0106268972158432,
                "z": -391.5472412109375
            },
            {
                "x": -0.08920153975486755,
                "y": 0.010619282722473145,
                "z": -391.3898010253906
            },
            {
                "x": -0.08937975764274597,
                "y": 0.010611675679683685,
                "z": -391.2325744628906
            },
            {
                "x": -0.08955800533294678,
                "y": 0.010604076087474823,
                "z": -391.0752868652344
            },
            {
                "x": -0.08973628282546997,
                "y": 0.01059647649526596,
                "z": -390.9179992675781
            },
            {
                "x": -0.08991450071334839,
                "y": 0.010588876903057098,
                "z": -390.7607727050781
            },
            {
                "x": -0.09009292721748352,
                "y": 0.010581262409687042,
                "z": -390.60333251953125
            },
            {
                "x": -0.09027114510536194,
                "y": 0.010573655366897583,
                "z": -390.4460754394531
            },
            {
                "x": -0.09044933319091797,
                "y": 0.010566048324108124,
                "z": -390.28887939453125
            },
            {
                "x": -0.09062767028808594,
                "y": 0.010558448731899261,
                "z": -390.13153076171875
            },
            {
                "x": -0.09080585837364197,
                "y": 0.0105508491396904,
                "z": -389.97430419921875
            },
            {
                "x": -0.09098410606384277,
                "y": 0.010543256998062134,
                "z": -389.8169860839844
            },
            {
                "x": -0.09116244316101074,
                "y": 0.010535620152950287,
                "z": -389.6596374511719
            },
            {
                "x": -0.09134072065353394,
                "y": 0.010528035461902618,
                "z": -389.5024108886719
            },
            {
                "x": -0.09151884913444519,
                "y": 0.010520435869693756,
                "z": -389.3451843261719
            },
            {
                "x": -0.09169706702232361,
                "y": 0.01051284372806549,
                "z": -389.1879577636719
            },
            {
                "x": -0.09187531471252441,
                "y": 0.010505221784114838,
                "z": -389.0307312011719
            },
            {
                "x": -0.09205368161201477,
                "y": 0.010497629642486572,
                "z": -388.873291015625
            },
            {
                "x": -0.09223189949989319,
                "y": 0.010490015149116516,
                "z": -388.716064453125
            },
            {
                "x": -0.09241017699241638,
                "y": 0.010482415556907654,
                "z": -388.55877685546875
            },
            {
                "x": -0.09258845448493958,
                "y": 0.010474815964698792,
                "z": -388.4014892578125
            },
            {
                "x": -0.09276661276817322,
                "y": 0.010467208921909332,
                "z": -388.2442626953125
            },
            {
                "x": -0.09294503927230835,
                "y": 0.010459601879119873,
                "z": -388.0868225097656
            },
            {
                "x": -0.09312328696250916,
                "y": 0.010451987385749817,
                "z": -387.9295959472656
            },
            {
                "x": -0.09330150485038757,
                "y": 0.010444387793540955,
                "z": -387.7723693847656
            },
            {
                "x": -0.09347978234291077,
                "y": 0.010436788201332092,
                "z": -387.6150207519531
            },
            {
                "x": -0.0936579704284668,
                "y": 0.010429181158542633,
                "z": -387.4577941894531
            },
            {
                "x": -0.09383630752563477,
                "y": 0.010421574115753174,
                "z": -387.3004455566406
            },
            {
                "x": -0.09401455521583557,
                "y": 0.010413967072963715,
                "z": -387.1430969238281
            },
            {
                "x": -0.09419283270835876,
                "y": 0.010406367480754852,
                "z": -386.98590087890625
            },
            {
                "x": -0.09437114000320435,
                "y": 0.010398760437965393,
                "z": -386.82855224609375
            },
            {
                "x": -0.09454932808876038,
                "y": 0.01039116084575653,
                "z": -386.67132568359375
            },
            {
                "x": -0.0947275459766388,
                "y": 0.010383553802967072,
                "z": -386.51409912109375
            },
            {
                "x": -0.09490591287612915,
                "y": 0.010375939309597015,
                "z": -386.3566589355469
            },
            {
                "x": -0.09508416056632996,
                "y": 0.010368339717388153,
                "z": -386.1994323730469
            },
            {
                "x": -0.09526237845420837,
                "y": 0.010360732674598694,
                "z": -386.0422058105469
            },
            {
                "x": -0.09537851810455322,
                "y": 0.010355792939662933,
                "z": -385.94061279296875
            },
            {
                "x": -0.09555673599243164,
                "y": 0.010348185896873474,
                "z": -385.7834167480469
            },
            {
                "x": -0.09573501348495483,
                "y": 0.010340586304664612,
                "z": -385.6260681152344
            },
            {
                "x": -0.09591332077980042,
                "y": 0.010332971811294556,
                "z": -385.4687194824219
            },
            {
                "x": -0.09609156847000122,
                "y": 0.010325364768505096,
                "z": -385.3114929199219
            },
            {
                "x": -0.09626981616020203,
                "y": 0.010317765176296234,
                "z": -385.1541442871094
            },
            {
                "x": -0.09644797444343567,
                "y": 0.010310158133506775,
                "z": -384.9969177246094
            },
            {
                "x": -0.09662628173828125,
                "y": 0.010302551090717316,
                "z": -384.8396911621094
            },
            {
                "x": -0.09680461883544922,
                "y": 0.010294951498508453,
                "z": -384.6822509765625
            },
            {
                "x": -0.09698286652565002,
                "y": 0.010287344455718994,
                "z": -384.5250244140625
            },
            {
                "x": -0.09716108441352844,
                "y": 0.010279752314090729,
                "z": -384.36773681640625
            },
            {
                "x": -0.09733939170837402,
                "y": 0.010272130370140076,
                "z": -384.21044921875
            },
            {
                "x": -0.09751760959625244,
                "y": 0.010264530777931213,
                "z": -384.0532531738281
            },
            {
                "x": -0.09769600629806519,
                "y": 0.010256938636302948,
                "z": -383.8957824707031
            },
            {
                "x": -0.0978742241859436,
                "y": 0.010249324142932892,
                "z": -383.7385559082031
            },
            {
                "x": -0.09805241227149963,
                "y": 0.010241717100143433,
                "z": -383.5813293457031
            },
            {
                "x": -0.09823068976402283,
                "y": 0.01023411750793457,
                "z": -383.4239807128906
            },
            {
                "x": -0.09840893745422363,
                "y": 0.010226525366306305,
                "z": -383.2667541503906
            },
            {
                "x": -0.09858724474906921,
                "y": 0.010218918323516846,
                "z": -383.1094055175781
            },
            {
                "x": -0.09876552224159241,
                "y": 0.010211296379566193,
                "z": -382.9520263671875
            },
            {
                "x": -0.0989437997341156,
                "y": 0.010203704237937927,
                "z": -382.79486083984375
            },
            {
                "x": -0.09912192821502686,
                "y": 0.010196089744567871,
                "z": -382.6376037597656
            },
            {
                "x": -0.09930014610290527,
                "y": 0.010188497602939606,
                "z": -382.4803771972656
            },
            {
                "x": -0.09947842359542847,
                "y": 0.01018090546131134,
                "z": -382.32318115234375
            },
            {
                "x": -0.09965673089027405,
                "y": 0.010173290967941284,
                "z": -382.16571044921875
            },
            {
                "x": -0.09983494877815247,
                "y": 0.010165683925151825,
                "z": -382.00848388671875
            },
            {
                "x": -0.10001325607299805,
                "y": 0.010158084332942963,
                "z": -381.8511962890625
            },
            {
                "x": -0.10019147396087646,
                "y": 0.010150477290153503,
                "z": -381.69390869140625
            },
            {
                "x": -0.1003696620464325,
                "y": 0.010142870247364044,
                "z": -381.53668212890625
            },
            {
                "x": -0.10054805874824524,
                "y": 0.010135263204574585,
                "z": -381.3792419433594
            },
            {
                "x": -0.10072630643844604,
                "y": 0.010127663612365723,
                "z": -381.2220153808594
            },
            {
                "x": -0.10090449452400208,
                "y": 0.010120049118995667,
                "z": -381.06475830078125
            },
            {
                "x": -0.10108280181884766,
                "y": 0.010112442076206207,
                "z": -380.9074401855469
            },
            {
                "x": -0.10126078128814697,
                "y": 0.010104849934577942,
                "z": -380.7502136230469
            },
            {
                "x": -0.10143905878067017,
                "y": 0.01009725034236908,
                "z": -380.5928649902344
            },
            {
                "x": -0.10161751508712769,
                "y": 0.010089650750160217,
                "z": -380.435546875
            },
            {
                "x": -0.1017952561378479,
                "y": 0.010082036256790161,
                "z": -380.2783203125
            },
            {
                "x": -0.10197126865386963,
                "y": 0.010074429214000702,
                "z": -380.1209716796875
            },
            {
                "x": -0.10214540362358093,
                "y": 0.01006682962179184,
                "z": -379.9637451171875
            },
            {
                "x": -0.10232177376747131,
                "y": 0.010059237480163574,
                "z": -379.8065185546875
            },
            {
                "x": -0.10249677300453186,
                "y": 0.010051615536212921,
                "z": -379.64910888671875
            },
            {
                "x": -0.10266005992889404,
                "y": 0.010043993592262268,
                "z": -379.4919128417969
            },
            {
                "x": -0.10280507802963257,
                "y": 0.010036440566182137,
                "z": -379.334716796875
            },
            {
                "x": -0.10289540886878967,
                "y": 0.010031446814537048,
                "z": -379.23309326171875
            },
            {
                "x": -0.10303947329521179,
                "y": 0.01002386212348938,
                "z": -379.07586669921875
            },
            {
                "x": -0.10316300392150879,
                "y": 0.01001623272895813,
                "z": -378.9186706542969
            },
            {
                "x": -0.10322016477584839,
                "y": 0.010008648037910461,
                "z": -378.7615051269531
            },
            {
                "x": -0.10319209098815918,
                "y": 0.010001055896282196,
                "z": -378.6044616699219
            },
            {
                "x": -0.10311761498451233,
                "y": 0.009993426501750946,
                "z": -378.4471435546875
            },
            {
                "x": -0.10301011800765991,
                "y": 0.009985782206058502,
                "z": -378.29010009765625
            },
            {
                "x": -0.10275524854660034,
                "y": 0.009978249669075012,
                "z": -378.13336181640625
            },
            {
                "x": -0.10226282477378845,
                "y": 0.009970605373382568,
                "z": -377.9764404296875
            },
            {
                "x": -0.1015426516532898,
                "y": 0.009962990880012512,
                "z": -377.81964111328125
            },
            {
                "x": -0.10068574547767639,
                "y": 0.009955383837223053,
                "z": -377.66265869140625
            },
            {
                "x": -0.099606454372406,
                "y": 0.009947814047336578,
                "z": -377.506103515625
            },
            {
                "x": -0.09814628958702087,
                "y": 0.009940199553966522,
                "z": -377.3498229980469
            },
            {
                "x": -0.09627234935760498,
                "y": 0.009932592511177063,
                "z": -377.19317626953125
            },
            {
                "x": -0.09408676624298096,
                "y": 0.009924985468387604,
                "z": -377.0364990234375
            },
            {
                "x": -0.09163486957550049,
                "y": 0.009917378425598145,
                "z": -376.88006591796875
            },
            {
                "x": -0.08874061703681946,
                "y": 0.009909801185131073,
                "z": -376.72393798828125
            },
            {
                "x": -0.08531910181045532,
                "y": 0.009902141988277435,
                "z": -376.5679016113281
            },
            {
                "x": -0.08145084977149963,
                "y": 0.009894557297229767,
                "z": -376.411376953125
            },
            {
                "x": -0.07730075716972351,
                "y": 0.009886972606182098,
                "z": -376.2547607421875
            },
            {
                "x": -0.07277849316596985,
                "y": 0.009879395365715027,
                "z": -376.09869384765625
            },
            {
                "x": -0.06771284341812134,
                "y": 0.009871773421764374,
                "z": -375.9427795410156
            },
            {
                "x": -0.06209191679954529,
                "y": 0.009864166378974915,
                "z": -375.7867126464844
            },
            {
                "x": -0.056117624044418335,
                "y": 0.009856551885604858,
                "z": -375.6302490234375
            },
            {
                "x": -0.04985055327415466,
                "y": 0.009848937392234802,
                "z": -375.4737548828125
            },
            {
                "x": -0.04314449429512024,
                "y": 0.009841345250606537,
                "z": -375.31787109375
            },
            {
                "x": -0.03584510087966919,
                "y": 0.00983370840549469,
                "z": -375.1619873046875
            },
            {
                "x": -0.028072327375411987,
                "y": 0.009826131165027618,
                "z": -375.0057067871094
            },
            {
                "x": -0.02001243829727173,
                "y": 0.00981852412223816,
                "z": -374.8492736816406
            },
            {
                "x": -0.011620908975601196,
                "y": 0.009810924530029297,
                "z": -374.6930236816406
            },
            {
                "x": -0.0027171969413757324,
                "y": 0.009803332388401031,
                "z": -374.537353515625
            },
            {
                "x": 0.006736248731613159,
                "y": 0.009795717895030975,
                "z": -374.3814392089844
            },
            {
                "x": 0.01659071445465088,
                "y": 0.009788118302822113,
                "z": -374.22509765625
            },
            {
                "x": 0.026696473360061646,
                "y": 0.00978049635887146,
                "z": -374.0688781738281
            },
            {
                "x": 0.037208348512649536,
                "y": 0.009772889316082,
                "z": -373.9129333496094
            },
            {
                "x": 0.04825484752655029,
                "y": 0.009765282273292542,
                "z": -373.75726318359375
            },
            {
                "x": 0.05979481339454651,
                "y": 0.00975770503282547,
                "z": -373.601318359375
            },
            {
                "x": 0.07165902853012085,
                "y": 0.00975007563829422,
                "z": -373.4449462890625
            },
            {
                "x": 0.08380052447319031,
                "y": 0.009742513298988342,
                "z": -373.2890319824219
            },
            {
                "x": 0.0963849127292633,
                "y": 0.009734883904457092,
                "z": -373.1335144042969
            },
            {
                "x": 0.10952255129814148,
                "y": 0.00972728431224823,
                "z": -372.97772216796875
            },
            {
                "x": 0.12307560443878174,
                "y": 0.009719692170619965,
                "z": -372.82177734375
            },
            {
                "x": 0.13689890503883362,
                "y": 0.009712062776088715,
                "z": -372.6657409667969
            },
            {
                "x": 0.1459897756576538,
                "y": 0.00970710813999176,
                "z": -372.56512451171875
            },
            {
                "x": 0.16041719913482666,
                "y": 0.009699515998363495,
                "z": -372.40972900390625
            },
            {
                "x": 0.17539656162261963,
                "y": 0.009691908955574036,
                "z": -372.2541809082031
            },
            {
                "x": 0.1908075213432312,
                "y": 0.009684264659881592,
                "z": -372.0982360839844
            },
            {
                "x": 0.20644670724868774,
                "y": 0.009676702320575714,
                "z": -371.9424133300781
            },
            {
                "x": 0.22241482138633728,
                "y": 0.009669072926044464,
                "z": -371.78680419921875
            },
            {
                "x": 0.23885250091552734,
                "y": 0.009661480784416199,
                "z": -371.6316223144531
            },
            {
                "x": 0.2557956576347351,
                "y": 0.00965389609336853,
                "z": -371.4761657714844
            },
            {
                "x": 0.27310794591903687,
                "y": 0.009646274149417877,
                "z": -371.3202209472656
            },
            {
                "x": 0.2906220853328705,
                "y": 0.009638704359531403,
                "z": -371.1646728515625
            },
            {
                "x": 0.30850648880004883,
                "y": 0.009631074965000153,
                "z": -371.0094909667969
            },
            {
                "x": 0.32690468430519104,
                "y": 0.00962347537279129,
                "z": -370.85430908203125
            },
            {
                "x": 0.34573739767074585,
                "y": 0.009615853428840637,
                "z": -370.698974609375
            },
            {
                "x": 0.3648677468299866,
                "y": 0.009608261287212372,
                "z": -370.5431823730469
            },
            {
                "x": 0.3842243254184723,
                "y": 0.00960066169500351,
                "z": -370.38800048828125
            },
            {
                "x": 0.404005229473114,
                "y": 0.009593039751052856,
                "z": -370.2331237792969
            },
            {
                "x": 0.4242915213108063,
                "y": 0.009585462510585785,
                "z": -370.0779724121094
            },
            {
                "x": 0.4449397027492523,
                "y": 0.009577848017215729,
                "z": -369.9226989746094
            },
            {
                "x": 0.4658203721046448,
                "y": 0.00957024097442627,
                "z": -369.7673645019531
            },
            {
                "x": 0.48701390624046326,
                "y": 0.009562656283378601,
                "z": -369.61236572265625
            },
            {
                "x": 0.5086382627487183,
                "y": 0.009554989635944366,
                "z": -369.45770263671875
            },
            {
                "x": 0.5307183265686035,
                "y": 0.009547434747219086,
                "z": -369.3028259277344
            },
            {
                "x": 0.5531080961227417,
                "y": 0.009539812803268433,
                "z": -369.14764404296875
            },
            {
                "x": 0.5757167339324951,
                "y": 0.009532257914543152,
                "z": -368.9927673339844
            },
            {
                "x": 0.5987035632133484,
                "y": 0.009524606168270111,
                "z": -368.8380432128906
            },
            {
                "x": 0.6221163868904114,
                "y": 0.00951702892780304,
                "z": -368.6835021972656
            },
            {
                "x": 0.6459513902664185,
                "y": 0.009509414434432983,
                "z": -368.5286865234375
            },
            {
                "x": 0.670030951499939,
                "y": 0.009501799941062927,
                "z": -368.37371826171875
            },
            {
                "x": 0.6943387389183044,
                "y": 0.009494215250015259,
                "z": -368.2191467285156
            },
            {
                "x": 0.7190589308738708,
                "y": 0.009486615657806396,
                "z": -368.0647277832031
            },
            {
                "x": 0.7442064881324768,
                "y": 0.009478993713855743,
                "z": -367.9103088378906
            },
            {
                "x": 0.76969313621521,
                "y": 0.009471401572227478,
                "z": -367.755615234375
            },
            {
                "x": 0.7954030632972717,
                "y": 0.009463809430599213,
                "z": -367.60101318359375
            },
            {
                "x": 0.82137131690979,
                "y": 0.009456172585487366,
                "z": -367.44677734375
            },
            {
                "x": 0.8477741479873657,
                "y": 0.009448602795600891,
                "z": -367.2926330566406
            },
            {
                "x": 0.8746090531349182,
                "y": 0.009440980851650238,
                "z": -367.1382751464844
            },
            {
                "x": 0.9016866087913513,
                "y": 0.009433381259441376,
                "z": -366.9838562011719
            },
            {
                "x": 0.9289749264717102,
                "y": 0.009425759315490723,
                "z": -366.82952880859375
            },
            {
                "x": 0.9565685987472534,
                "y": 0.009418167173862457,
                "z": -366.6756896972656
            },
            {
                "x": 0.9846017360687256,
                "y": 0.009410582482814789,
                "z": -366.52178955078125
            },
            {
                "x": 1.0130411386489868,
                "y": 0.009403012692928314,
                "z": -366.36749267578125
            },
            {
                "x": 1.0416492223739624,
                "y": 0.00939536839723587,
                "z": -366.2133483886719
            },
            {
                "x": 1.0704591274261475,
                "y": 0.009387895464897156,
                "z": -366.0596008300781
            },
            {
                "x": 1.0892804861068726,
                "y": 0.009382806718349457,
                "z": -365.9603271484375
            },
            {
                "x": 1.1187387704849243,
                "y": 0.009375229477882385,
                "z": -365.8066711425781
            },
            {
                "x": 1.1485695838928223,
                "y": 0.009367600083351135,
                "z": -365.6527099609375
            },
            {
                "x": 1.1786136627197266,
                "y": 0.009360000491142273,
                "z": -365.4987487792969
            },
            {
                "x": 1.208848476409912,
                "y": 0.009352363646030426,
                "z": -365.3451843261719
            },
            {
                "x": 1.2394545078277588,
                "y": 0.009344778954982758,
                "z": -365.1916809082031
            },
            {
                "x": 1.270443320274353,
                "y": 0.009337179362773895,
                "z": -365.03826904296875
            },
            {
                "x": 1.3017199039459229,
                "y": 0.009329564869403839,
                "z": -364.88458251953125
            },
            {
                "x": 1.3332107067108154,
                "y": 0.009321972727775574,
                "z": -364.7308654785156
            },
            {
                "x": 1.364903450012207,
                "y": 0.009314373135566711,
                "z": -364.57769775390625
            },
            {
                "x": 1.3969883918762207,
                "y": 0.009306758642196655,
                "z": -364.4245300292969
            },
            {
                "x": 1.4294469356536865,
                "y": 0.009299151599407196,
                "z": -364.27117919921875
            },
            {
                "x": 1.4621102809906006,
                "y": 0.00929155945777893,
                "z": -364.1177978515625
            },
            {
                "x": 1.494994878768921,
                "y": 0.009283944964408875,
                "z": -363.9644470214844
            },
            {
                "x": 1.5281192064285278,
                "y": 0.009276352822780609,
                "z": -363.8115539550781
            },
            {
                "x": 1.5616339445114136,
                "y": 0.009268730878829956,
                "z": -363.6585998535156
            },
            {
                "x": 1.5954866409301758,
                "y": 0.009261146187782288,
                "z": -363.5054016113281
            },
            {
                "x": 1.6294913291931152,
                "y": 0.009253539144992828,
                "z": -363.3523254394531
            },
            {
                "x": 1.6637004613876343,
                "y": 0.009245909750461578,
                "z": -363.1994323730469
            },
            {
                "x": 1.6982322931289673,
                "y": 0.009238310158252716,
                "z": -363.04669189453125
            },
            {
                "x": 1.7331135272979736,
                "y": 0.009230703115463257,
                "z": -362.89404296875
            },
            {
                "x": 1.7682411670684814,
                "y": 0.009223125874996185,
                "z": -362.7411804199219
            },
            {
                "x": 1.8035247325897217,
                "y": 0.009215526282787323,
                "z": -362.5884094238281
            },
            {
                "x": 1.8390332460403442,
                "y": 0.009207941591739655,
                "z": -362.4360046386719
            },
            {
                "x": 1.8749250173568726,
                "y": 0.009200289845466614,
                "z": -362.2834777832031
            },
            {
                "x": 1.9111136198043823,
                "y": 0.009192712604999542,
                "z": -362.13092041015625
            },
            {
                "x": 1.9474997520446777,
                "y": 0.009185127913951874,
                "z": -361.978271484375
            },
            {
                "x": 1.9840394258499146,
                "y": 0.009177476167678833,
                "z": -361.82586669921875
            },
            {
                "x": 2.020841360092163,
                "y": 0.009169898927211761,
                "z": -361.6737060546875
            },
            {
                "x": 2.05802321434021,
                "y": 0.009162262082099915,
                "z": -361.5213928222656
            },
            {
                "x": 2.0954387187957764,
                "y": 0.009154662489891052,
                "z": -361.36907958984375
            },
            {
                "x": 2.1330208778381348,
                "y": 0.00914708524942398,
                "z": -361.2167663574219
            },
            {
                "x": 2.1707966327667236,
                "y": 0.009139448404312134,
                "z": -361.0646057128906
            },
            {
                "x": 2.2088167667388916,
                "y": 0.009131856262683868,
                "z": -360.9127502441406
            },
            {
                "x": 2.2471954822540283,
                "y": 0.009124279022216797,
                "z": -360.7607116699219
            },
            {
                "x": 2.28580641746521,
                "y": 0.009116671979427338,
                "z": -360.6085205078125
            },
            {
                "x": 2.3245160579681396,
                "y": 0.009109050035476685,
                "z": -360.4565734863281
            },
            {
                "x": 2.363452911376953,
                "y": 0.00910145789384842,
                "z": -360.3047790527344
            },
            {
                "x": 2.4026713371276855,
                "y": 0.009093843400478363,
                "z": -360.1531677246094
            },
            {
                "x": 2.442178726196289,
                "y": 0.009086214005947113,
                "z": -360.00146484375
            },
            {
                "x": 2.481933355331421,
                "y": 0.009078621864318848,
                "z": -359.8493957519531
            },
            {
                "x": 2.5217549800872803,
                "y": 0.00907103717327118,
                "z": -359.6977844238281
            },
            {
                "x": 2.561798095703125,
                "y": 0.009063415229320526,
                "z": -359.5463562011719
            },
            {
                "x": 2.587831735610962,
                "y": 0.009058475494384766,
                "z": -359.4485778808594
            },
            {
                "x": 2.6283578872680664,
                "y": 0.009050868451595306,
                "z": -359.2970886230469
            },
            {
                "x": 2.6690685749053955,
                "y": 0.009043261408805847,
                "z": -359.14544677734375
            },
            {
                "x": 2.709913730621338,
                "y": 0.009035624563694,
                "z": -358.9939880371094
            },
            {
                "x": 2.750960350036621,
                "y": 0.009028062224388123,
                "z": -358.8428039550781
            },
            {
                "x": 2.7923240661621094,
                "y": 0.009020425379276276,
                "z": -358.6915588378906
            },
            {
                "x": 2.8339016437530518,
                "y": 0.009012818336486816,
                "z": -358.5402526855469
            },
            {
                "x": 2.8756263256073,
                "y": 0.009005218744277954,
                "z": -358.38897705078125
            },
            {
                "x": 2.9175262451171875,
                "y": 0.008997641503810883,
                "z": -358.23773193359375
            },
            {
                "x": 2.959601402282715,
                "y": 0.008990012109279633,
                "z": -358.08685302734375
            },
            {
                "x": 3.001967668533325,
                "y": 0.008982419967651367,
                "z": -357.9358825683594
            },
            {
                "x": 3.0445423126220703,
                "y": 0.008974805474281311,
                "z": -357.78472900390625
            },
            {
                "x": 3.087221622467041,
                "y": 0.008967176079750061,
                "z": -357.6337585449219
            },
            {
                "x": 3.130099058151245,
                "y": 0.008959606289863586,
                "z": -357.4828186035156
            },
            {
                "x": 3.173175573348999,
                "y": 0.008951984345912933,
                "z": -357.3321838378906
            },
            {
                "x": 3.2165122032165527,
                "y": 0.008944369852542877,
                "z": -357.1814270019531
            },
            {
                "x": 3.2600345611572266,
                "y": 0.008936777710914612,
                "z": -357.03045654296875
            },
            {
                "x": 3.3036420345306396,
                "y": 0.008929163217544556,
                "z": -356.8797912597656
            },
            {
                "x": 3.347435235977173,
                "y": 0.008921578526496887,
                "z": -356.7291564941406
            },
            {
                "x": 3.391474485397339,
                "y": 0.00891394168138504,
                "z": -356.5786437988281
            },
            {
                "x": 3.4357359409332275,
                "y": 0.008906334638595581,
                "z": -356.4281005859375
            },
            {
                "x": 3.4800987243652344,
                "y": 0.00889875739812851,
                "z": -356.2774658203125
            },
            {
                "x": 3.5245745182037354,
                "y": 0.008891172707080841,
                "z": -356.12713623046875
            },
            {
                "x": 3.56923770904541,
                "y": 0.008883535861968994,
                "z": -355.9769592285156
            },
            {
                "x": 3.614229440689087,
                "y": 0.008875943720340729,
                "z": -355.826416015625
            },
            {
                "x": 3.6593339443206787,
                "y": 0.008868314325809479,
                "z": -355.67608642578125
            },
            {
                "x": 3.7045364379882812,
                "y": 0.00886072963476181,
                "z": -355.5257873535156
            },
            {
                "x": 3.7498779296875,
                "y": 0.00885310024023056,
                "z": -355.3755798339844
            },
            {
                "x": 3.795408248901367,
                "y": 0.008845515549182892,
                "z": -355.2255859375
            },
            {
                "x": 3.8412258625030518,
                "y": 0.00883791595697403,
                "z": -355.0753479003906
            },
            {
                "x": 3.88712477684021,
                "y": 0.008830294013023376,
                "z": -354.9252014160156
            },
            {
                "x": 3.9331164360046387,
                "y": 0.008822686970233917,
                "z": -354.7751159667969
            },
            {
                "x": 3.9792890548706055,
                "y": 0.00881512463092804,
                "z": -354.6252136230469
            },
            {
                "x": 4.025631904602051,
                "y": 0.00880751758813858,
                "z": -354.4753723144531
            },
            {
                "x": 4.072206020355225,
                "y": 0.008799910545349121,
                "z": -354.3253479003906
            },
            {
                "x": 4.118882656097412,
                "y": 0.008792266249656677,
                "z": -354.17529296875
            },
            {
                "x": 4.165621757507324,
                "y": 0.008784696459770203,
                "z": -354.02557373046875
            },
            {
                "x": 4.2125654220581055,
                "y": 0.008777059614658356,
                "z": -353.87579345703125
            },
            {
                "x": 4.2596611976623535,
                "y": 0.008769460022449493,
                "z": -353.7261657714844
            },
            {
                "x": 4.306943893432617,
                "y": 0.008761867880821228,
                "z": -353.576416015625
            },
            {
                "x": 4.354371070861816,
                "y": 0.008754253387451172,
                "z": -353.4265441894531
            },
            {
                "x": 4.401813507080078,
                "y": 0.008746668696403503,
                "z": -353.2770690917969
            },
            {
                "x": 4.4494404792785645,
                "y": 0.008739069104194641,
                "z": -353.1275634765625
            },
            {
                "x": 4.480302333831787,
                "y": 0.008734121918678284,
                "z": -353.0309753417969
            },
            {
                "x": 4.5282206535339355,
                "y": 0.008726522326469421,
                "z": -352.8814392089844
            },
            {
                "x": 4.576242923736572,
                "y": 0.008718937635421753,
                "z": -352.7318420410156
            },
            {
                "x": 4.624362945556641,
                "y": 0.008711270987987518,
                "z": -352.5823974609375
            },
            {
                "x": 4.672595024108887,
                "y": 0.00870370864868164,
                "z": -352.4331359863281
            },
            {
                "x": 4.7210540771484375,
                "y": 0.00869607925415039,
                "z": -352.28369140625
            },
            {
                "x": 4.769608020782471,
                "y": 0.008688464760780334,
                "z": -352.13427734375
            },
            {
                "x": 4.818212509155273,
                "y": 0.008680872619152069,
                "z": -351.98504638671875
            },
            {
                "x": 4.866982460021973,
                "y": 0.008673250675201416,
                "z": -351.835693359375
            },
            {
                "x": 4.915871620178223,
                "y": 0.008665673434734344,
                "z": -351.6866455078125
            },
            {
                "x": 4.964923858642578,
                "y": 0.008658058941364288,
                "z": -351.5373840332031
            },
            {
                "x": 5.014066696166992,
                "y": 0.008650466799736023,
                "z": -351.3881530761719
            },
            {
                "x": 5.063279151916504,
                "y": 0.008642837405204773,
                "z": -351.2390441894531
            },
            {
                "x": 5.112641334533691,
                "y": 0.008635230362415314,
                "z": -351.0898742675781
            },
            {
                "x": 5.162105083465576,
                "y": 0.008627653121948242,
                "z": -350.9409484863281
            },
            {
                "x": 5.211697101593018,
                "y": 0.008620038628578186,
                "z": -350.7920227050781
            },
            {
                "x": 5.2614359855651855,
                "y": 0.00861242413520813,
                "z": -350.642822265625
            },
            {
                "x": 5.311173915863037,
                "y": 0.008604809641838074,
                "z": -350.4939270019531
            },
            {
                "x": 5.361063480377197,
                "y": 0.008597202599048615,
                "z": -350.34503173828125
            },
            {
                "x": 5.411106586456299,
                "y": 0.008589640259742737,
                "z": -350.1960754394531
            },
            {
                "x": 5.461214542388916,
                "y": 0.008710863068699837,
                "z": -350.0472412109375
            },
            {
                "x": 5.511384010314941,
                "y": 0.009146242402493954,
                "z": -349.8984680175781
            },
            {
                "x": 5.561616897583008,
                "y": 0.009888174943625927,
                "z": -349.749755859375
            },
            {
                "x": 5.611988067626953,
                "y": 0.010933110490441322,
                "z": -349.6011047363281
            },
            {
                "x": 5.662552356719971,
                "y": 0.012284955009818077,
                "z": -349.4522399902344
            },
            {
                "x": 5.713127136230469,
                "y": 0.013938738964498043,
                "z": -349.3034973144531
            },
            {
                "x": 5.763782501220703,
                "y": 0.015883024781942368,
                "z": -349.1548156738281
            },
            {
                "x": 5.814507961273193,
                "y": 0.01811254397034645,
                "z": -349.0062255859375
            },
            {
                "x": 5.8653154373168945,
                "y": 0.020626673474907875,
                "z": -348.8577575683594
            },
            {
                "x": 5.91632604598999,
                "y": 0.0234332587569952,
                "z": -348.7090148925781
            },
            {
                "x": 5.96732234954834,
                "y": 0.02650885283946991,
                "z": -348.56048583984375
            },
            {
                "x": 6.018364429473877,
                "y": 0.029852040112018585,
                "z": -348.4119567871094
            },
            {
                "x": 6.069519519805908,
                "y": 0.033465199172496796,
                "z": -348.26348876953125
            },
            {
                "x": 6.120760917663574,
                "y": 0.037345923483371735,
                "z": -348.1150817871094
            },
            {
                "x": 6.172124862670898,
                "y": 0.041486699134111404,
                "z": -347.966552734375
            },
            {
                "x": 6.223530292510986,
                "y": 0.045878659933805466,
                "z": -347.8180847167969
            },
            {
                "x": 6.274949073791504,
                "y": 0.050517015159130096,
                "z": -347.6697692871094
            },
            {
                "x": 6.326481342315674,
                "y": 0.05540909618139267,
                "z": -347.52142333984375
            },
            {
                "x": 6.378087997436523,
                "y": 0.06053944304585457,
                "z": -347.3731384277344
            },
            {
                "x": 6.429749488830566,
                "y": 0.06590372323989868,
                "z": -347.224853515625
            },
            {
                "x": 6.481523513793945,
                "y": 0.07150845229625702,
                "z": -347.0764465332031
            },
            {
                "x": 6.533256530761719,
                "y": 0.07733583450317383,
                "z": -346.9283142089844
            },
            {
                "x": 6.585093975067139,
                "y": 0.08338729292154312,
                "z": -346.7801513671875
            },
            {
                "x": 6.618622779846191,
                "y": 0.08740829676389694,
                "z": -346.6844482421875
            },
            {
                "x": 6.670579433441162,
                "y": 0.09382572770118713,
                "z": -346.5362548828125
            },
            {
                "x": 6.7225751876831055,
                "y": 0.1004544049501419,
                "z": -346.3880615234375
            },
            {
                "x": 6.774641513824463,
                "y": 0.10728896409273148,
                "z": -346.2398986816406
            },
            {
                "x": 6.826725959777832,
                "y": 0.11432020366191864,
                "z": -346.09185791015625
            },
            {
                "x": 6.878924369812012,
                "y": 0.12156230211257935,
                "z": -345.9437561035156
            },
            {
                "x": 6.931139945983887,
                "y": 0.1289965659379959,
                "z": -345.7956848144531
            },
            {
                "x": 6.983375072479248,
                "y": 0.13661828637123108,
                "z": -345.6476745605469
            },
            {
                "x": 7.035708904266357,
                "y": 0.14443178474903107,
                "z": -345.49957275390625
            },
            {
                "x": 7.088040828704834,
                "y": 0.1524229645729065,
                "z": -345.3516540527344
            },
            {
                "x": 7.140451431274414,
                "y": 0.16059665381908417,
                "z": -345.2036437988281
            },
            {
                "x": 7.192890644073486,
                "y": 0.16894182562828064,
                "z": -345.0556945800781
            },
            {
                "x": 7.245329856872559,
                "y": 0.17745113372802734,
                "z": -344.9078063964844
            },
            {
                "x": 7.297886371612549,
                "y": 0.1861395388841629,
                "z": -344.7597351074219
            },
            {
                "x": 7.350395202636719,
                "y": 0.1949736475944519,
                "z": -344.61199951171875
            },
            {
                "x": 7.402988433837891,
                "y": 0.20397073030471802,
                "z": -344.4640808105469
            },
            {
                "x": 7.4556097984313965,
                "y": 0.2131199836730957,
                "z": -344.3161926269531
            },
            {
                "x": 7.5082292556762695,
                "y": 0.22241196036338806,
                "z": -344.1684265136719
            },
            {
                "x": 7.560905456542969,
                "y": 0.2318527102470398,
                "z": -344.0205993652344
            },
            {
                "x": 7.613653659820557,
                "y": 0.24143844842910767,
                "z": -343.8726501464844
            },
            {
                "x": 7.666362285614014,
                "y": 0.2511470913887024,
                "z": -343.7249450683594
            },
            {
                "x": 7.7190728187561035,
                "y": 0.2609841823577881,
                "z": -343.57720947265625
            },
            {
                "x": 7.771834373474121,
                "y": 0.2709541916847229,
                "z": -343.429443359375
            },
            {
                "x": 7.824590682983398,
                "y": 0.28103938698768616,
                "z": -343.28179931640625
            },
            {
                "x": 7.877459526062012,
                "y": 0.2912558913230896,
                "z": -343.1339111328125
            },
            {
                "x": 7.930273532867432,
                "y": 0.3015737533569336,
                "z": -342.9862060546875
            },
            {
                "x": 7.983116626739502,
                "y": 0.31200575828552246,
                "z": -342.8385009765625
            },
            {
                "x": 8.035983085632324,
                "y": 0.322543740272522,
                "z": -342.6907958984375
            },
            {
                "x": 8.088844299316406,
                "y": 0.3331746459007263,
                "z": -342.5430908203125
            },
            {
                "x": 8.14179515838623,
                "y": 0.34391748905181885,
                "z": -342.395263671875
            },
            {
                "x": 8.194683074951172,
                "y": 0.35473954677581787,
                "z": -342.24761962890625
            },
            {
                "x": 8.24754810333252,
                "y": 0.36564257740974426,
                "z": -342.10003662109375
            },
            {
                "x": 8.300508499145508,
                "y": 0.37664228677749634,
                "z": -341.9522705078125
            },
            {
                "x": 8.353424072265625,
                "y": 0.3877127766609192,
                "z": -341.80462646484375
            },
            {
                "x": 8.406371116638184,
                "y": 0.39886847138404846,
                "z": -341.6568603515625
            },
            {
                "x": 8.45930290222168,
                "y": 0.41008999943733215,
                "z": -341.5091552734375
            },
            {
                "x": 8.512218475341797,
                "y": 0.4213718771934509,
                "z": -341.36151123046875
            },
            {
                "x": 8.56515884399414,
                "y": 0.43272164463996887,
                "z": -341.2137756347656
            },
            {
                "x": 8.618093490600586,
                "y": 0.4441271126270294,
                "z": -341.06610107421875
            },
            {
                "x": 8.670997619628906,
                "y": 0.4555830955505371,
                "z": -340.91845703125
            },
            {
                "x": 8.723960876464844,
                "y": 0.4671008586883545,
                "z": -340.7705993652344
            },
            {
                "x": 8.77685832977295,
                "y": 0.47864818572998047,
                "z": -340.62298583984375
            },
            {
                "x": 8.829745292663574,
                "y": 0.4902377426624298,
                "z": -340.4753112792969
            },
            {
                "x": 8.863921165466309,
                "y": 0.4977482557296753,
                "z": -340.3798828125
            },
            {
                "x": 8.91677474975586,
                "y": 0.5093920230865479,
                "z": -340.23223876953125
            },
            {
                "x": 8.969667434692383,
                "y": 0.5210752487182617,
                "z": -340.08447265625
            },
            {
                "x": 9.022550582885742,
                "y": 0.5327840447425842,
                "z": -339.9366760253906
            },
            {
                "x": 9.075379371643066,
                "y": 0.5445060729980469,
                "z": -339.7889709472656
            },
            {
                "x": 9.128217697143555,
                "y": 0.5562512874603271,
                "z": -339.6412048339844
            },
            {
                "x": 9.180986404418945,
                "y": 0.5679980516433716,
                "z": -339.4934997558594
            },
            {
                "x": 9.233745574951172,
                "y": 0.5797520875930786,
                "z": -339.3458557128906
            },
            {
                "x": 9.286569595336914,
                "y": 0.591526985168457,
                "z": -339.19793701171875
            },
            {
                "x": 9.339282989501953,
                "y": 0.603285551071167,
                "z": -339.0502014160156
            },
            {
                "x": 9.391984939575195,
                "y": 0.6150451898574829,
                "z": -338.9023742675781
            },
            {
                "x": 9.444656372070312,
                "y": 0.6267925500869751,
                "z": -338.75457763671875
            },
            {
                "x": 9.497299194335938,
                "y": 0.6385215520858765,
                "z": -338.6068420410156
            },
            {
                "x": 9.549995422363281,
                "y": 0.6502523422241211,
                "z": -338.4588623046875
            },
            {
                "x": 9.602567672729492,
                "y": 0.661945104598999,
                "z": -338.31103515625
            },
            {
                "x": 9.655088424682617,
                "y": 0.6736072301864624,
                "z": -338.16326904296875
            },
            {
                "x": 9.707626342773438,
                "y": 0.6852482557296753,
                "z": -338.01531982421875
            },
            {
                "x": 9.76010513305664,
                "y": 0.6968469619750977,
                "z": -337.8674621582031
            },
            {
                "x": 9.812592506408691,
                "y": 0.7084174752235413,
                "z": -337.719482421875
            },
            {
                "x": 9.865002632141113,
                "y": 0.7199399471282959,
                "z": -337.5715026855469
            },
            {
                "x": 9.917344093322754,
                "y": 0.7314077615737915,
                "z": -337.423583984375
            },
            {
                "x": 9.96965217590332,
                "y": 0.7428215742111206,
                "z": -337.27569580078125
            },
            {
                "x": 10.021942138671875,
                "y": 0.7541836500167847,
                "z": -337.1277160644531
            },
            {
                "x": 10.074176788330078,
                "y": 0.7654867768287659,
                "z": -336.97967529296875
            },
            {
                "x": 10.1264066696167,
                "y": 0.7767363786697388,
                "z": -336.8314514160156
            },
            {
                "x": 10.178494453430176,
                "y": 0.7878987789154053,
                "z": -336.6834716796875
            },
            {
                "x": 10.230581283569336,
                "y": 0.7989941835403442,
                "z": -336.53533935546875
            },
            {
                "x": 10.282620429992676,
                "y": 0.810015082359314,
                "z": -336.38714599609375
            },
            {
                "x": 10.334566116333008,
                "y": 0.820946216583252,
                "z": -336.2390441894531
            },
            {
                "x": 10.386519432067871,
                "y": 0.8318074345588684,
                "z": -336.09063720703125
            },
            {
                "x": 10.43835163116455,
                "y": 0.8425602912902832,
                "z": -335.9425354003906
            },
            {
                "x": 10.490155220031738,
                "y": 0.8532216548919678,
                "z": -335.7943420410156
            },
            {
                "x": 10.541924476623535,
                "y": 0.8637925386428833,
                "z": -335.64593505859375
            },
            {
                "x": 10.593573570251465,
                "y": 0.874252200126648,
                "z": -335.49761962890625
            },
            {
                "x": 10.645195007324219,
                "y": 0.8846091032028198,
                "z": -335.3492126464844
            },
            {
                "x": 10.696757316589355,
                "y": 0.8948503136634827,
                "z": -335.2008361816406
            },
            {
                "x": 10.748250007629395,
                "y": 0.9049729108810425,
                "z": -335.05242919921875
            },
            {
                "x": 10.799688339233398,
                "y": 0.9149850010871887,
                "z": -334.9038391113281
            },
            {
                "x": 10.850983619689941,
                "y": 0.9248629808425903,
                "z": -334.7553405761719
            },
            {
                "x": 10.902192115783691,
                "y": 0.9346053600311279,
                "z": -334.60693359375
            },
            {
                "x": 10.953447341918945,
                "y": 0.9442278146743774,
                "z": -334.4581604003906
            },
            {
                "x": 11.0045747756958,
                "y": 0.9537063837051392,
                "z": -334.3095397949219
            },
            {
                "x": 11.055571556091309,
                "y": 0.9630419611930847,
                "z": -334.160888671875
            },
            {
                "x": 11.088472366333008,
                "y": 0.9689949750900269,
                "z": -334.0647888183594
            },
            {
                "x": 11.139307975769043,
                "y": 0.9780788421630859,
                "z": -333.9161682128906
            },
            {
                "x": 11.190142631530762,
                "y": 0.9870153665542603,
                "z": -333.7674560546875
            },
            {
                "x": 11.240935325622559,
                "y": 0.9958057999610901,
                "z": -333.6185607910156
            },
            {
                "x": 11.291558265686035,
                "y": 1.0044198036193848,
                "z": -333.46966552734375
            },
            {
                "x": 11.342086791992188,
                "y": 1.0128703117370605,
                "z": -333.3207092285156
            },
            {
                "x": 11.392525672912598,
                "y": 1.0211446285247803,
                "z": -333.171875
            },
            {
                "x": 11.442899703979492,
                "y": 1.029248833656311,
                "z": -333.02288818359375
            },
            {
                "x": 11.493244171142578,
                "y": 1.0371813774108887,
                "z": -332.8736267089844
            },
            {
                "x": 11.543366432189941,
                "y": 1.0449177026748657,
                "z": -332.72454833984375
            },
            {
                "x": 11.593398094177246,
                "y": 1.0524652004241943,
                "z": -332.57550048828125
            },
            {
                "x": 11.643389701843262,
                "y": 1.059824824333191,
                "z": -332.4263610839844
            },
            {
                "x": 11.69327163696289,
                "y": 1.0669801235198975,
                "z": -332.27716064453125
            },
            {
                "x": 11.743112564086914,
                "y": 1.0739474296569824,
                "z": -332.1276550292969
            },
            {
                "x": 11.792720794677734,
                "y": 1.0806968212127686,
                "z": -331.9783630371094
            },
            {
                "x": 11.842230796813965,
                "y": 1.0872362852096558,
                "z": -331.8290710449219
            },
            {
                "x": 11.8917236328125,
                "y": 1.0935630798339844,
                "z": -331.6795959472656
            },
            {
                "x": 11.941061973571777,
                "y": 1.0996685028076172,
                "z": -331.5301208496094
            },
            {
                "x": 11.990273475646973,
                "y": 1.1055552959442139,
                "z": -331.38055419921875
            },
            {
                "x": 12.039356231689453,
                "y": 1.1112152338027954,
                "z": -331.2309265136719
            },
            {
                "x": 12.088275909423828,
                "y": 1.1166305541992188,
                "z": -331.0814208984375
            },
            {
                "x": 12.137176513671875,
                "y": 1.1218135356903076,
                "z": -330.9317626953125
            },
            {
                "x": 12.1859130859375,
                "y": 1.1267585754394531,
                "z": -330.7820129394531
            },
            {
                "x": 12.234484672546387,
                "y": 1.1314599514007568,
                "z": -330.6322937011719
            },
            {
                "x": 12.28298282623291,
                "y": 1.1359113454818726,
                "z": -330.48236083984375
            },
            {
                "x": 12.331331253051758,
                "y": 1.1401007175445557,
                "z": -330.33251953125
            },
            {
                "x": 12.37960147857666,
                "y": 1.1440376043319702,
                "z": -330.1825256347656
            },
            {
                "x": 12.42770004272461,
                "y": 1.1477160453796387,
                "z": -330.0324401855469
            },
            {
                "x": 12.475594520568848,
                "y": 1.1511189937591553,
                "z": -329.8824768066406
            },
            {
                "x": 12.523432731628418,
                "y": 1.154250144958496,
                "z": -329.7322998046875
            },
            {
                "x": 12.571125030517578,
                "y": 1.1571054458618164,
                "z": -329.58221435546875
            },
            {
                "x": 12.618697166442871,
                "y": 1.1596852540969849,
                "z": -329.4319763183594
            },
            {
                "x": 12.66610336303711,
                "y": 1.1619789600372314,
                "z": -329.28155517578125
            },
            {
                "x": 12.713276863098145,
                "y": 1.1639748811721802,
                "z": -329.13140869140625
            },
            {
                "x": 12.76038932800293,
                "y": 1.1656821966171265,
                "z": -328.9809875488281
            },
            {
                "x": 12.807400703430176,
                "y": 1.1670955419540405,
                "z": -328.8305358886719
            },
            {
                "x": 12.854220390319824,
                "y": 1.1682037115097046,
                "z": -328.6800231933594
            },
            {
                "x": 12.900839805603027,
                "y": 1.1689995527267456,
                "z": -328.52935791015625
            },
            {
                "x": 12.947254180908203,
                "y": 1.169487476348877,
                "z": -328.3788757324219
            },
            {
                "x": 12.993581771850586,
                "y": 1.169663429260254,
                "z": -328.2283935546875
            },
            {
                "x": 13.039861679077148,
                "y": 1.169518232345581,
                "z": -328.07745361328125
            },
            {
                "x": 13.085835456848145,
                "y": 1.1690514087677002,
                "z": -327.9266662597656
            },
            {
                "x": 13.131591796875,
                "y": 1.1682772636413574,
                "z": -327.7759094238281
            },
            {
                "x": 13.161083221435547,
                "y": 1.1676194667816162,
                "z": -327.67852783203125
            },
            {
                "x": 13.206637382507324,
                "y": 1.1663371324539185,
                "z": -327.52783203125
            },
            {
                "x": 13.252083778381348,
                "y": 1.1647560596466064,
                "z": -327.3767395019531
            },
            {
                "x": 13.2973051071167,
                "y": 1.162881851196289,
                "z": -327.2255859375
            },
            {
                "x": 13.342269897460938,
                "y": 1.160719394683838,
                "z": -327.0745849609375
            },
            {
                "x": 13.38711929321289,
                "y": 1.1582612991333008,
                "z": -326.92352294921875
            },
            {
                "x": 13.431821823120117,
                "y": 1.1555233001708984,
                "z": -326.7724609375
            },
            {
                "x": 13.476332664489746,
                "y": 1.1525077819824219,
                "z": -326.6211242675781
            },
            {
                "x": 13.520634651184082,
                "y": 1.149217128753662,
                "z": -326.4696350097656
            },
            {
                "x": 13.564658164978027,
                "y": 1.145655870437622,
                "z": -326.3185119628906
            },
            {
                "x": 13.60858154296875,
                "y": 1.1418308019638062,
                "z": -326.1672668457031
            },
            {
                "x": 13.652375221252441,
                "y": 1.1377429962158203,
                "z": -326.0157470703125
            },
            {
                "x": 13.695911407470703,
                "y": 1.1334006786346436,
                "z": -325.8641662597656
            },
            {
                "x": 13.739219665527344,
                "y": 1.128795862197876,
                "z": -325.7125549316406
            },
            {
                "x": 13.78230094909668,
                "y": 1.1239545345306396,
                "z": -325.5610656738281
            },
            {
                "x": 13.825261116027832,
                "y": 1.118869662284851,
                "z": -325.4095764160156
            },
            {
                "x": 13.868057250976562,
                "y": 1.113539695739746,
                "z": -325.2576904296875
            },
            {
                "x": 13.91053295135498,
                "y": 1.10797119140625,
                "z": -325.10589599609375
            },
            {
                "x": 13.952778816223145,
                "y": 1.1021788120269775,
                "z": -324.95416259765625
            },
            {
                "x": 13.994902610778809,
                "y": 1.096161127090454,
                "z": -324.8023376464844
            },
            {
                "x": 14.036835670471191,
                "y": 1.0899226665496826,
                "z": -324.6504821777344
            },
            {
                "x": 14.07850170135498,
                "y": 1.08345627784729,
                "z": -324.4984130859375
            },
            {
                "x": 14.119871139526367,
                "y": 1.0767850875854492,
                "z": -324.346435546875
            },
            {
                "x": 14.161028861999512,
                "y": 1.069914698600769,
                "z": -324.1945495605469
            },
            {
                "x": 14.202119827270508,
                "y": 1.0628266334533691,
                "z": -324.0423889160156
            },
            {
                "x": 14.24294662475586,
                "y": 1.0555354356765747,
                "z": -323.89013671875
            },
            {
                "x": 14.283466339111328,
                "y": 1.0480475425720215,
                "z": -323.73779296875
            },
            {
                "x": 14.323708534240723,
                "y": 1.040380835533142,
                "z": -323.5855407714844
            },
            {
                "x": 14.363788604736328,
                "y": 1.0325324535369873,
                "z": -323.43341064453125
            },
            {
                "x": 14.403741836547852,
                "y": 1.0244784355163574,
                "z": -323.28082275390625
            },
            {
                "x": 14.443370819091797,
                "y": 1.0162510871887207,
                "z": -323.1282958984375
            },
            {
                "x": 14.482672691345215,
                "y": 1.007858157157898,
                "z": -322.9757385253906
            },
            {
                "x": 14.52175235748291,
                "y": 0.9993025064468384,
                "z": -322.8232421875
            },
            {
                "x": 14.560661315917969,
                "y": 0.9905803799629211,
                "z": -322.6707763671875
            },
            {
                "x": 14.599388122558594,
                "y": 0.9816772937774658,
                "z": -322.5179138183594
            },
            {
                "x": 14.63776969909668,
                "y": 0.9726223945617676,
                "z": -322.3650207519531
            },
            {
                "x": 14.675819396972656,
                "y": 0.9634350538253784,
                "z": -322.21234130859375
            },
            {
                "x": 14.713706016540527,
                "y": 0.9540935754776001,
                "z": -322.0595703125
            },
            {
                "x": 14.751402854919434,
                "y": 0.9446030855178833,
                "z": -321.9066467285156
            },
            {
                "x": 14.788798332214355,
                "y": 0.9349678754806519,
                "z": -321.7535705566406
            },
            {
                "x": 14.825891494750977,
                "y": 0.9251929521560669,
                "z": -321.6003112792969
            },
            {
                "x": 14.862646102905273,
                "y": 0.9153167605400085,
                "z": -321.4474792480469
            },
            {
                "x": 14.899269104003906,
                "y": 0.9053022861480713,
                "z": -321.29443359375
            },
            {
                "x": 14.922802925109863,
                "y": 0.8987617492675781,
                "z": -321.1954040527344
            },
            {
                "x": 14.958950996398926,
                "y": 0.8885394930839539,
                "z": -321.0420837402344
            },
            {
                "x": 14.994752883911133,
                "y": 0.8782012462615967,
                "z": -320.88861083984375
            },
            {
                "x": 15.030289649963379,
                "y": 0.8677683472633362,
                "z": -320.73541259765625
            },
            {
                "x": 15.06564712524414,
                "y": 0.857227623462677,
                "z": -320.58209228515625
            },
            {
                "x": 15.100772857666016,
                "y": 0.8465650081634521,
                "z": -320.4283752441406
            },
            {
                "x": 15.13547134399414,
                "y": 0.8358141779899597,
                "z": -320.2747802734375
            },
            {
                "x": 15.169833183288574,
                "y": 0.8249855637550354,
                "z": -320.12127685546875
            },
            {
                "x": 15.204051971435547,
                "y": 0.8140579462051392,
                "z": -319.96759033203125
            },
            {
                "x": 15.238008499145508,
                "y": 0.8030474185943604,
                "z": -319.8139343261719
            },
            {
                "x": 15.271635055541992,
                "y": 0.7919394969940186,
                "z": -319.659912109375
            },
            {
                "x": 15.304854393005371,
                "y": 0.780769944190979,
                "z": -319.5059509277344
            },
            {
                "x": 15.337770462036133,
                "y": 0.7695482969284058,
                "z": -319.352294921875
            },
            {
                "x": 15.37056827545166,
                "y": 0.7582377195358276,
                "z": -319.1982421875
            },
            {
                "x": 15.403032302856445,
                "y": 0.7468593120574951,
                "z": -319.0440673828125
            },
            {
                "x": 15.435091018676758,
                "y": 0.7354263663291931,
                "z": -318.8898620605469
            },
            {
                "x": 15.466813087463379,
                "y": 0.7239477038383484,
                "z": -318.7356872558594
            },
            {
                "x": 15.498290061950684,
                "y": 0.7124344110488892,
                "z": -318.5816955566406
            },
            {
                "x": 15.529544830322266,
                "y": 0.7008503079414368,
                "z": -318.42730712890625
            },
            {
                "x": 15.560425758361816,
                "y": 0.6892147064208984,
                "z": -318.2726745605469
            },
            {
                "x": 15.590869903564453,
                "y": 0.6775644421577454,
                "z": -318.1182861328125
            },
            {
                "x": 15.62101936340332,
                "y": 0.6658966541290283,
                "z": -317.9640197753906
            },
            {
                "x": 15.650969505310059,
                "y": 0.6541900634765625,
                "z": -317.8095703125
            },
            {
                "x": 15.680588722229004,
                "y": 0.6424427628517151,
                "z": -317.65484619140625
            },
            {
                "x": 15.709816932678223,
                "y": 0.630662202835083,
                "z": -317.49981689453125
            },
            {
                "x": 15.738614082336426,
                "y": 0.6189029216766357,
                "z": -317.3452453613281
            },
            {
                "x": 15.76720905303955,
                "y": 0.6071290969848633,
                "z": -317.19061279296875
            },
            {
                "x": 15.795530319213867,
                "y": 0.5953309535980225,
                "z": -317.03564453125
            },
            {
                "x": 15.823429107666016,
                "y": 0.5835260152816772,
                "z": -316.88055419921875
            },
            {
                "x": 15.850920677185059,
                "y": 0.5717226266860962,
                "z": -316.725341796875
            },
            {
                "x": 15.878066062927246,
                "y": 0.5599538087844849,
                "z": -316.57049560546875
            },
            {
                "x": 15.904984474182129,
                "y": 0.5481890439987183,
                "z": -316.41552734375
            },
            {
                "x": 15.931587219238281,
                "y": 0.5364078283309937,
                "z": -316.2600402832031
            },
            {
                "x": 15.957695960998535,
                "y": 0.524660587310791,
                "z": -316.1047058105469
            },
            {
                "x": 15.983430862426758,
                "y": 0.5129443407058716,
                "z": -315.9493713378906
            },
            {
                "x": 16.00889778137207,
                "y": 0.501264750957489,
                "z": -315.7940979003906
            },
            {
                "x": 16.034072875976562,
                "y": 0.4896010160446167,
                "z": -315.63861083984375
            },
            {
                "x": 16.058818817138672,
                "y": 0.47795724868774414,
                "z": -315.4828186035156
            },
            {
                "x": 16.08307456970215,
                "y": 0.4663781523704529,
                "z": -315.3272399902344
            },
            {
                "x": 16.107017517089844,
                "y": 0.4548587203025818,
                "z": -315.1718444824219
            },
            {
                "x": 16.130741119384766,
                "y": 0.44336026906967163,
                "z": -315.0160217285156
            },
            {
                "x": 16.1540470123291,
                "y": 0.43191149830818176,
                "z": -314.8600769042969
            },
            {
                "x": 16.176849365234375,
                "y": 0.4205264747142792,
                "z": -314.7041015625
            },
            {
                "x": 16.19134521484375,
                "y": 0.4132155179977417,
                "z": -314.60345458984375
            },
            {
                "x": 16.213565826416016,
                "y": 0.40195780992507935,
                "z": -314.4477844238281
            },
            {
                "x": 16.235536575317383,
                "y": 0.39074477553367615,
                "z": -314.29168701171875
            },
            {
                "x": 16.25705337524414,
                "y": 0.3795889616012573,
                "z": -314.1353454589844
            },
            {
                "x": 16.278032302856445,
                "y": 0.36853164434432983,
                "z": -313.9790954589844
            },
            {
                "x": 16.298656463623047,
                "y": 0.35756731033325195,
                "z": -313.8230285644531
            },
            {
                "x": 16.31902503967285,
                "y": 0.3466866612434387,
                "z": -313.6669616699219
            },
            {
                "x": 16.339004516601562,
                "y": 0.33587485551834106,
                "z": -313.51043701171875
            },
            {
                "x": 16.35846519470215,
                "y": 0.3251468539237976,
                "z": -313.3536376953125
            },
            {
                "x": 16.377443313598633,
                "y": 0.3145517408847809,
                "z": -313.1973876953125
            },
            {
                "x": 16.396142959594727,
                "y": 0.3040603697299957,
                "z": -313.04107666015625
            },
            {
                "x": 16.41452980041504,
                "y": 0.2936553359031677,
                "z": -312.8843994140625
            },
            {
                "x": 16.432392120361328,
                "y": 0.2833574116230011,
                "z": -312.72760009765625
            },
            {
                "x": 16.449748992919922,
                "y": 0.2731757164001465,
                "z": -312.5706787109375
            },
            {
                "x": 16.466724395751953,
                "y": 0.26314279437065125,
                "z": -312.4142150878906
            },
            {
                "x": 16.483427047729492,
                "y": 0.2532210946083069,
                "z": -312.257568359375
            },
            {
                "x": 16.49968910217285,
                "y": 0.2434048056602478,
                "z": -312.1003723144531
            },
            {
                "x": 16.515365600585938,
                "y": 0.23373161256313324,
                "z": -311.94329833984375
            },
            {
                "x": 16.530601501464844,
                "y": 0.22420936822891235,
                "z": -311.7864685058594
            },
            {
                "x": 16.545568466186523,
                "y": 0.2148234099149704,
                "z": -311.6295471191406
            },
            {
                "x": 16.56012725830078,
                "y": 0.2055751532316208,
                "z": -311.47235107421875
            },
            {
                "x": 16.574121475219727,
                "y": 0.19647002220153809,
                "z": -311.31500244140625
            },
            {
                "x": 16.587587356567383,
                "y": 0.1875326931476593,
                "z": -311.1579284667969
            },
            {
                "x": 16.600709915161133,
                "y": 0.1787654310464859,
                "z": -311.0010070800781
            },
            {
                "x": 16.6135311126709,
                "y": 0.17013514041900635,
                "z": -310.84356689453125
            },
            {
                "x": 16.625810623168945,
                "y": 0.16166821122169495,
                "z": -310.68597412109375
            },
            {
                "x": 16.63750648498535,
                "y": 0.15337607264518738,
                "z": -310.5284729003906
            },
            {
                "x": 16.648771286010742,
                "y": 0.14527294039726257,
                "z": -310.3712463378906
            },
            {
                "x": 16.659725189208984,
                "y": 0.13735345005989075,
                "z": -310.2139587402344
            },
            {
                "x": 16.670251846313477,
                "y": 0.1295870542526245,
                "z": -310.0561218261719
            },
            {
                "x": 16.680158615112305,
                "y": 0.12201537191867828,
                "z": -309.8983459472656
            },
            {
                "x": 16.689533233642578,
                "y": 0.1146489605307579,
                "z": -309.7409362792969
            },
            {
                "x": 16.698585510253906,
                "y": 0.10748180001974106,
                "z": -309.5834655761719
            },
            {
                "x": 16.707252502441406,
                "y": 0.10050569474697113,
                "z": -309.4257507324219
            },
            {
                "x": 16.715347290039062,
                "y": 0.09371664375066757,
                "z": -309.2676696777344
            },
            {
                "x": 16.72283935546875,
                "y": 0.08714538812637329,
                "z": -309.10986328125
            },
            {
                "x": 16.729915618896484,
                "y": 0.08080532401800156,
                "z": -308.95233154296875
            },
            {
                "x": 16.73666763305664,
                "y": 0.07466936856508255,
                "z": -308.7945556640625
            },
            {
                "x": 16.742891311645508,
                "y": 0.06874261051416397,
                "z": -308.6364440917969
            },
            {
                "x": 16.74847984313965,
                "y": 0.0630408525466919,
                "z": -308.47845458984375
            },
            {
                "x": 16.753557205200195,
                "y": 0.05757773295044899,
                "z": -308.3205871582031
            },
            {
                "x": 16.75831413269043,
                "y": 0.052354730665683746,
                "z": -308.1628723144531
            },
            {
                "x": 16.762619018554688,
                "y": 0.04735342413187027,
                "z": -308.0047607421875
            },
            {
                "x": 16.765071868896484,
                "y": 0.044243644922971725,
                "z": -307.9024963378906
            },
            {
                "x": 16.768314361572266,
                "y": 0.03964604437351227,
                "z": -307.74444580078125
            },
            {
                "x": 16.771121978759766,
                "y": 0.03529959172010422,
                "z": -307.58660888671875
            },
            {
                "x": 16.773605346679688,
                "y": 0.031196843832731247,
                "z": -307.4286804199219
            },
            {
                "x": 16.775558471679688,
                "y": 0.027343660593032837,
                "z": -307.27044677734375
            },
            {
                "x": 16.776817321777344,
                "y": 0.023753700777888298,
                "z": -307.112060546875
            },
            {
                "x": 16.777542114257812,
                "y": 0.020434269681572914,
                "z": -306.9541931152344
            },
            {
                "x": 16.777929306030273,
                "y": 0.017379362136125565,
                "z": -306.79638671875
            },
            {
                "x": 16.77787208557129,
                "y": 0.014584152027964592,
                "z": -306.637939453125
            },
            {
                "x": 16.777130126953125,
                "y": 0.012071916833519936,
                "z": -306.47955322265625
            },
            {
                "x": 16.775766372680664,
                "y": 0.009838941507041454,
                "z": -306.3214111328125
            },
            {
                "x": 16.77400016784668,
                "y": 0.007888964377343655,
                "z": -306.1635437011719
            },
            {
                "x": 16.77185821533203,
                "y": 0.006221901625394821,
                "z": -306.0054626464844
            },
            {
                "x": 16.76908302307129,
                "y": 0.004848233424127102,
                "z": -305.84686279296875
            },
            {
                "x": 16.765626907348633,
                "y": 0.0037687732838094234,
                "z": -305.68865966796875
            },
            {
                "x": 16.761672973632812,
                "y": 0.002985667437314987,
                "z": -305.5308532714844
            },
            {
                "x": 16.757375717163086,
                "y": 0.0025018472224473953,
                "z": -305.3728942871094
            },
            {
                "x": 16.752531051635742,
                "y": 0.0023286084178835154,
                "z": -305.2146911621094
            },
            {
                "x": 16.746976852416992,
                "y": 0.0023200921714305878,
                "z": -305.0562744140625
            },
            {
                "x": 16.740821838378906,
                "y": 0.0023151636123657227,
                "z": -304.898193359375
            },
            {
                "x": 16.734304428100586,
                "y": 0.0023102276027202606,
                "z": -304.74053955078125
            },
            {
                "x": 16.727327346801758,
                "y": 0.0023053325712680817,
                "z": -304.58251953125
            },
            {
                "x": 16.71967124938965,
                "y": 0.0023004114627838135,
                "z": -304.4242248535156
            },
            {
                "x": 16.711336135864258,
                "y": 0.002295512706041336,
                "z": -304.2662353515625
            },
            {
                "x": 16.702539443969727,
                "y": 0.0022905953228473663,
                "z": -304.1084289550781
            },
            {
                "x": 16.693363189697266,
                "y": 0.002285681664943695,
                "z": -303.95068359375
            },
            {
                "x": 16.683565139770508,
                "y": 0.0022807754576206207,
                "z": -303.7925109863281
            },
            {
                "x": 16.67304039001465,
                "y": 0.002275843173265457,
                "z": -303.63446044921875
            },
            {
                "x": 16.661964416503906,
                "y": 0.002270948141813278,
                "z": -303.4768371582031
            },
            {
                "x": 16.650501251220703,
                "y": 0.0022660084068775177,
                "z": -303.3191833496094
            },
            {
                "x": 16.638532638549805,
                "y": 0.0022610872983932495,
                "z": -303.16131591796875
            },
            {
                "x": 16.625831604003906,
                "y": 0.002256188541650772,
                "z": -303.0033874511719
            },
            {
                "x": 16.612468719482422,
                "y": 0.0022512823343276978,
                "z": -302.84564208984375
            },
            {
                "x": 16.59868621826172,
                "y": 0.0022463612258434296,
                "z": -302.6884460449219
            },
            {
                "x": 16.584470748901367,
                "y": 0.0022414512932300568,
                "z": -302.5309143066406
            },
            {
                "x": 16.569576263427734,
                "y": 0.0022365450859069824,
                "z": -302.3730773925781
            },
            {
                "x": 16.553956985473633,
                "y": 0.0022316016256809235,
                "z": -302.2154235839844
            },
            {
                "x": 16.53780174255371,
                "y": 0.0022266916930675507,
                "z": -302.05828857421875
            },
            {
                "x": 16.521297454833984,
                "y": 0.0022217892110347748,
                "z": -301.9012145996094
            },
            {
                "x": 16.504194259643555,
                "y": 0.002216864377260208,
                "z": -301.7437438964844
            },
            {
                "x": 16.48630714416504,
                "y": 0.0022119469940662384,
                "z": -301.58612060546875
            },
            {
                "x": 16.467803955078125,
                "y": 0.0022070370614528656,
                "z": -301.4290771484375
            },
            {
                "x": 16.448928833007812,
                "y": 0.002202145755290985,
                "z": -301.2723388671875
            },
            {
                "x": 16.436500549316406,
                "y": 0.0021989047527313232,
                "z": -301.17095947265625
            },
            {
                "x": 16.41666603088379,
                "y": 0.0021940134465694427,
                "z": -301.01373291015625
            },
            {
                "x": 16.39604949951172,
                "y": 0.002189062535762787,
                "z": -300.8565673828125
            },
            {
                "x": 16.3748779296875,
                "y": 0.0021841861307621002,
                "z": -300.6998596191406
            },
            {
                "x": 16.353361129760742,
                "y": 0.002179279923439026,
                "z": -300.5434265136719
            },
            {
                "x": 16.331253051757812,
                "y": 0.002174343913793564,
                "z": -300.3865661621094
            },
            {
                "x": 16.308380126953125,
                "y": 0.002169433981180191,
                "z": -300.2297058105469
            },
            {
                "x": 16.284841537475586,
                "y": 0.0021645240485668182,
                "z": -300.0732421875
            },
            {
                "x": 16.260860443115234,
                "y": 0.002159617841243744,
                "z": -299.9170227050781
            },
            {
                "x": 16.23646354675293,
                "y": 0.002154707908630371,
                "z": -299.7607727050781
            },
            {
                "x": 16.211322784423828,
                "y": 0.0021497607231140137,
                "z": -299.604248046875
            },
            {
                "x": 16.185426712036133,
                "y": 0.0021448805928230286,
                "z": -299.4479064941406
            },
            {
                "x": 16.159021377563477,
                "y": 0.0021399594843387604,
                "z": -299.2921447753906
            },
            {
                "x": 16.132213592529297,
                "y": 0.002135027199983597,
                "z": -299.1363220214844
            },
            {
                "x": 16.104814529418945,
                "y": 0.0021301060914993286,
                "z": -298.9803771972656
            },
            {
                "x": 16.076618194580078,
                "y": 0.002125222235918045,
                "z": -298.8243408203125
            },
            {
                "x": 16.047752380371094,
                "y": 0.0021203123033046722,
                "z": -298.6686706542969
            },
            {
                "x": 16.018531799316406,
                "y": 0.0021153725683689117,
                "z": -298.5135498046875
            },
            {
                "x": 15.988801956176758,
                "y": 0.0021104328334331512,
                "z": -298.35809326171875
            },
            {
                "x": 15.958319664001465,
                "y": 0.0021055378019809723,
                "z": -298.2024230957031
            },
            {
                "x": 15.927103042602539,
                "y": 0.0021006204187870026,
                "z": -298.0470886230469
            },
            {
                "x": 15.895383834838867,
                "y": 0.002095736563205719,
                "z": -297.892333984375
            },
            {
                "x": 15.863285064697266,
                "y": 0.0020908042788505554,
                "z": -297.7376708984375
            },
            {
                "x": 15.830558776855469,
                "y": 0.0020859017968177795,
                "z": -297.5827331542969
            },
            {
                "x": 15.796981811523438,
                "y": 0.0020809732377529144,
                "z": -297.4275817871094
            },
            {
                "x": 15.762819290161133,
                "y": 0.0020760558545589447,
                "z": -297.2731628417969
            },
            {
                "x": 15.728266716003418,
                "y": 0.0020711496472358704,
                "z": -297.1190490722656
            },
            {
                "x": 15.693215370178223,
                "y": 0.0020662136375904083,
                "z": -296.9647216796875
            },
            {
                "x": 15.657419204711914,
                "y": 0.002061307430267334,
                "z": -296.8103332519531
            },
            {
                "x": 15.620818138122559,
                "y": 0.002056397497653961,
                "z": -296.656005859375
            },
            {
                "x": 15.583786010742188,
                "y": 0.002051468938589096,
                "z": -296.5024719238281
            },
            {
                "x": 15.546384811401367,
                "y": 0.0020465701818466187,
                "z": -296.3489990234375
            },
            {
                "x": 15.50829792022705,
                "y": 0.0020416490733623505,
                "z": -296.1951599121094
            },
            {
                "x": 15.469437599182129,
                "y": 0.0020367391407489777,
                "z": -296.04144287109375
            },
            {
                "x": 15.42989444732666,
                "y": 0.002031814306974411,
                "z": -295.8881530761719
            },
            {
                "x": 15.3900146484375,
                "y": 0.0020268894731998444,
                "z": -295.7353515625
            },
            {
                "x": 15.349678039550781,
                "y": 0.0020219869911670685,
                "z": -295.5824279785156
            },
            {
                "x": 15.308544158935547,
                "y": 0.002017073333263397,
                "z": -295.4292297363281
            },
            {
                "x": 15.266655921936035,
                "y": 0.0020121634006500244,
                "z": -295.2764587402344
            },
            {
                "x": 15.224308013916016,
                "y": 0.0020072460174560547,
                "z": -295.12420654296875
            },
            {
                "x": 15.181541442871094,
                "y": 0.002002321183681488,
                "z": -294.9720153808594
            },
            {
                "x": 15.138212203979492,
                "y": 0.0019974075257778168,
                "z": -294.8197326660156
            },
            {
                "x": 15.094066619873047,
                "y": 0.001992497593164444,
                "z": -294.66748046875
            },
            {
                "x": 15.065180778503418,
                "y": 0.0019893087446689606,
                "z": -294.5693054199219
            },
            {
                "x": 15.020145416259766,
                "y": 0.0019843876361846924,
                "z": -294.4179382324219
            },
            {
                "x": 14.974719047546387,
                "y": 0.001979466527700424,
                "z": -294.2665710449219
            },
            {
                "x": 14.92862319946289,
                "y": 0.0019745491445064545,
                "z": -294.1149597167969
            },
            {
                "x": 14.88176441192627,
                "y": 0.00196964293718338,
                "z": -293.9635009765625
            },
            {
                "x": 14.834245681762695,
                "y": 0.0019647404551506042,
                "z": -293.8124694824219
            },
            {
                "x": 14.786383628845215,
                "y": 0.001959826797246933,
                "z": -293.66204833984375
            },
            {
                "x": 14.738090515136719,
                "y": 0.001954905688762665,
                "z": -293.5115966796875
            },
            {
                "x": 14.68900203704834,
                "y": 0.0019499845802783966,
                "z": -293.3607177734375
            },
            {
                "x": 14.639217376708984,
                "y": 0.0019450671970844269,
                "z": -293.2102966308594
            },
            {
                "x": 14.588903427124023,
                "y": 0.0019401833415031433,
                "z": -293.0604553222656
            },
            {
                "x": 14.538259506225586,
                "y": 0.0019352510571479797,
                "z": -292.9108581542969
            },
            {
                "x": 14.487071990966797,
                "y": 0.001930326223373413,
                "z": -292.7611389160156
            },
            {
                "x": 14.435029983520508,
                "y": 0.0019254423677921295,
                "z": -292.6111755371094
            },
            {
                "x": 14.38235092163086,
                "y": 0.0019205175340175629,
                "z": -292.4618835449219
            },
            {
                "x": 14.329304695129395,
                "y": 0.0019155927002429962,
                "z": -292.3131408691406
            },
            {
                "x": 14.275842666625977,
                "y": 0.0019106902182102203,
                "z": -292.1644287109375
            },
            {
                "x": 14.221758842468262,
                "y": 0.0019057616591453552,
                "z": -292.01556396484375
            },
            {
                "x": 14.166860580444336,
                "y": 0.0018983955960720778,
                "z": -291.8668518066406
            },
            {
                "x": 14.111343383789062,
                "y": 0.0016654875362291932,
                "z": -291.7185363769531
            },
            {
                "x": 14.055558204650879,
                "y": 0.0008580079302191734,
                "z": -291.5708923339844
            },
            {
                "x": 13.999363899230957,
                "y": -0.0005309297703206539,
                "z": -291.4232177734375
            },
            {
                "x": 13.94240951538086,
                "y": -0.0025188527069985867,
                "z": -291.2754211425781
            },
            {
                "x": 13.884710311889648,
                "y": -0.0050723678432404995,
                "z": -291.1278381347656
            },
            {
                "x": 13.826481819152832,
                "y": -0.008173573762178421,
                "z": -290.980712890625
            },
            {
                "x": 13.768047332763672,
                "y": -0.011804511770606041,
                "z": -290.83416748046875
            },
            {
                "x": 13.709041595458984,
                "y": -0.015993019565939903,
                "z": -290.68743896484375
            },
            {
                "x": 13.649284362792969,
                "y": -0.020713070407509804,
                "z": -290.54071044921875
            },
            {
                "x": 13.588882446289062,
                "y": -0.025937069207429886,
                "z": -290.3944091796875
            },
            {
                "x": 13.52800178527832,
                "y": -0.03165165334939957,
                "z": -290.2485656738281
            },
            {
                "x": 13.46690845489502,
                "y": -0.03785549849271774,
                "z": -290.1031799316406
            },
            {
                "x": 13.405251502990723,
                "y": -0.044553957879543304,
                "z": -289.9576721191406
            },
            {
                "x": 13.342809677124023,
                "y": -0.051732778549194336,
                "z": -289.81207275390625
            },
            {
                "x": 13.279842376708984,
                "y": -0.059350162744522095,
                "z": -289.6671447753906
            },
            {
                "x": 13.216537475585938,
                "y": -0.0674092024564743,
                "z": -289.5226745605469
            },
            {
                "x": 13.152912139892578,
                "y": -0.07590728998184204,
                "z": -289.3783264160156
            },
            {
                "x": 13.08871841430664,
                "y": -0.08483929932117462,
                "z": -289.2339782714844
            },
            {
                "x": 13.023850440979004,
                "y": -0.09419044852256775,
                "z": -289.08978271484375
            },
            {
                "x": 12.958612442016602,
                "y": -0.10392706841230392,
                "z": -288.9461669921875
            },
            {
                "x": 12.8931884765625,
                "y": -0.11403709650039673,
                "z": -288.8031005859375
            },
            {
                "x": 12.827280044555664,
                "y": -0.1245531290769577,
                "z": -288.6596984863281
            },
            {
                "x": 12.760893821716309,
                "y": -0.13543342053890228,
                "z": -288.5165710449219
            },
            {
                "x": 12.69407844543457,
                "y": -0.146663099527359,
                "z": -288.37384033203125
            },
            {
                "x": 12.650825500488281,
                "y": -0.15409331023693085,
                "z": -288.28192138671875
            },
            {
                "x": 12.58364486694336,
                "y": -0.16586822271347046,
                "z": -288.13970947265625
            },
            {
                "x": 12.515965461730957,
                "y": -0.1779923439025879,
                "z": -287.9974060058594
            },
            {
                "x": 12.447935104370117,
                "y": -0.19043180346488953,
                "z": -287.8554382324219
            },
            {
                "x": 12.37978458404541,
                "y": -0.20315614342689514,
                "z": -287.7137451171875
            },
            {
                "x": 12.311236381530762,
                "y": -0.21618741750717163,
                "z": -287.5721740722656
            },
            {
                "x": 12.242654800415039,
                "y": -0.22946107387542725,
                "z": -287.4310302734375
            },
            {
                "x": 12.173928260803223,
                "y": -0.24302399158477783,
                "z": -287.2899475097656
            },
            {
                "x": 12.104975700378418,
                "y": -0.2568563222885132,
                "z": -287.14886474609375
            },
            {
                "x": 12.036110877990723,
                "y": -0.27090510725975037,
                "z": -287.00811767578125
            },
            {
                "x": 11.967092514038086,
                "y": -0.2852054536342621,
                "z": -286.86724853515625
            },
            {
                "x": 11.898015975952148,
                "y": -0.2997329533100128,
                "z": -286.7265319824219
            },
            {
                "x": 11.82885456085205,
                "y": -0.3144780993461609,
                "z": -286.5859375
            },
            {
                "x": 11.759550094604492,
                "y": -0.3294394910335541,
                "z": -286.4451904296875
            },
            {
                "x": 11.690264701843262,
                "y": -0.3445780277252197,
                "z": -286.3047180175781
            },
            {
                "x": 11.620892524719238,
                "y": -0.3599027991294861,
                "z": -286.16424560546875
            },
            {
                "x": 11.551444053649902,
                "y": -0.3754069209098816,
                "z": -286.02386474609375
            },
            {
                "x": 11.481988906860352,
                "y": -0.3910633325576782,
                "z": -285.883544921875
            },
            {
                "x": 11.412440299987793,
                "y": -0.4068797826766968,
                "z": -285.7431640625
            },
            {
                "x": 11.342718124389648,
                "y": -0.4228520095348358,
                "z": -285.6028137207031
            },
            {
                "x": 11.273053169250488,
                "y": -0.43892836570739746,
                "z": -285.46270751953125
            },
            {
                "x": 11.203303337097168,
                "y": -0.45513254404067993,
                "z": -285.3226013183594
            },
            {
                "x": 11.133535385131836,
                "y": -0.4714348316192627,
                "z": -285.18255615234375
            },
            {
                "x": 11.06369400024414,
                "y": -0.48784032464027405,
                "z": -285.04248046875
            },
            {
                "x": 10.993695259094238,
                "y": -0.5043595433235168,
                "z": -284.9023742675781
            },
            {
                "x": 10.9237642288208,
                "y": -0.520923912525177,
                "z": -284.762451171875
            },
            {
                "x": 10.853758811950684,
                "y": -0.5375664234161377,
                "z": -284.62249755859375
            },
            {
                "x": 10.783723831176758,
                "y": -0.5542593598365784,
                "z": -284.4825744628906
            },
            {
                "x": 10.713635444641113,
                "y": -0.5709983110427856,
                "z": -284.3426513671875
            },
            {
                "x": 10.643460273742676,
                "y": -0.5877858400344849,
                "z": -284.20269775390625
            },
            {
                "x": 10.573315620422363,
                "y": -0.6045771837234497,
                "z": -284.0628967285156
            },
            {
                "x": 10.503129959106445,
                "y": -0.6213800311088562,
                "z": -283.92315673828125
            },
            {
                "x": 10.432883262634277,
                "y": -0.6381947994232178,
                "z": -283.7833251953125
            },
            {
                "x": 10.362639427185059,
                "y": -0.6549932956695557,
                "z": -283.6435241699219
            },
            {
                "x": 10.292325019836426,
                "y": -0.6717755794525146,
                "z": -283.5038146972656
            },
            {
                "x": 10.222004890441895,
                "y": -0.6885281205177307,
                "z": -283.36407470703125
            },
            {
                "x": 10.151751518249512,
                "y": -0.7052253484725952,
                "z": -283.2243957519531
            },
            {
                "x": 10.081354141235352,
                "y": -0.7218919992446899,
                "z": -283.0846252441406
            },
            {
                "x": 10.011045455932617,
                "y": -0.7384738326072693,
                "z": -282.9449462890625
            },
            {
                "x": 9.940739631652832,
                "y": -0.7549850940704346,
                "z": -282.8053283691406
            },
            {
                "x": 9.87032413482666,
                "y": -0.7714350819587708,
                "z": -282.6655578613281
            },
            {
                "x": 9.799971580505371,
                "y": -0.7877798080444336,
                "z": -282.5257568359375
            },
            {
                "x": 9.729588508605957,
                "y": -0.8040111064910889,
                "z": -282.3861083984375
            },
            {
                "x": 9.684131622314453,
                "y": -0.814437985420227,
                "z": -282.29583740234375
            },
            {
                "x": 9.613762855529785,
                "y": -0.8304733037948608,
                "z": -282.1561584472656
            },
            {
                "x": 9.543346405029297,
                "y": -0.8463819026947021,
                "z": -282.0163879394531
            },
            {
                "x": 9.472962379455566,
                "y": -0.8621437549591064,
                "z": -281.87664794921875
            },
            {
                "x": 9.402623176574707,
                "y": -0.8777478337287903,
                "z": -281.7369079589844
            },
            {
                "x": 9.332263946533203,
                "y": -0.8931916952133179,
                "z": -281.5970764160156
            },
            {
                "x": 9.262004852294922,
                "y": -0.9084385633468628,
                "z": -281.4573974609375
            },
            {
                "x": 9.19173526763916,
                "y": -0.9235100150108337,
                "z": -281.31756591796875
            },
            {
                "x": 9.121432304382324,
                "y": -0.9383979439735413,
                "z": -281.1776428222656
            },
            {
                "x": 9.051198959350586,
                "y": -0.9530681371688843,
                "z": -281.0376892089844
            },
            {
                "x": 8.981019973754883,
                "y": -0.9675081968307495,
                "z": -280.8978271484375
            },
            {
                "x": 8.910867691040039,
                "y": -0.9817235469818115,
                "z": -280.7578125
            },
            {
                "x": 8.840798377990723,
                "y": -0.9956921339035034,
                "z": -280.617919921875
            },
            {
                "x": 8.770613670349121,
                "y": -1.009436845779419,
                "z": -280.4776611328125
            },
            {
                "x": 8.700644493103027,
                "y": -1.022882103919983,
                "z": -280.337646484375
            },
            {
                "x": 8.630725860595703,
                "y": -1.036056399345398,
                "z": -280.1976013183594
            },
            {
                "x": 8.560742378234863,
                "y": -1.0489649772644043,
                "z": -280.05731201171875
            },
            {
                "x": 8.490931510925293,
                "y": -1.061563491821289,
                "z": -279.9171447753906
            },
            {
                "x": 8.42113971710205,
                "y": -1.073852777481079,
                "z": -279.77691650390625
            },
            {
                "x": 8.351435661315918,
                "y": -1.085829496383667,
                "z": -279.6365051269531
            },
            {
                "x": 8.28182601928711,
                "y": -1.0974712371826172,
                "z": -279.4961853027344
            },
            {
                "x": 8.212298393249512,
                "y": -1.1087791919708252,
                "z": -279.35577392578125
            },
            {
                "x": 8.14284896850586,
                "y": -1.1197230815887451,
                "z": -279.21539306640625
            },
            {
                "x": 8.073501586914062,
                "y": -1.1303071975708008,
                "z": -279.0748291015625
            },
            {
                "x": 8.004138946533203,
                "y": -1.1405385732650757,
                "z": -278.9340515136719
            },
            {
                "x": 7.934963226318359,
                "y": -1.1503746509552002,
                "z": -278.7934265136719
            },
            {
                "x": 7.865834712982178,
                "y": -1.1598137617111206,
                "z": -278.652587890625
            },
            {
                "x": 7.796868324279785,
                "y": -1.1688382625579834,
                "z": -278.5118103027344
            },
            {
                "x": 7.727993488311768,
                "y": -1.1774511337280273,
                "z": -278.3708801269531
            },
            {
                "x": 7.659189224243164,
                "y": -1.1856467723846436,
                "z": -278.2298278808594
            },
            {
                "x": 7.590569972991943,
                "y": -1.1933908462524414,
                "z": -278.08880615234375
            },
            {
                "x": 7.522073745727539,
                "y": -1.2006762027740479,
                "z": -277.9476623535156
            },
            {
                "x": 7.453648567199707,
                "y": -1.2075121402740479,
                "z": -277.8063659667969
            },
            {
                "x": 7.385432243347168,
                "y": -1.2138724327087402,
                "z": -277.6651916503906
            },
            {
                "x": 7.317266464233398,
                "y": -1.219752550125122,
                "z": -277.5237121582031
            },
            {
                "x": 7.249285697937012,
                "y": -1.225124716758728,
                "z": -277.3822326660156
            },
            {
                "x": 7.181499481201172,
                "y": -1.2299940586090088,
                "z": -277.2407531738281
            },
            {
                "x": 7.113794803619385,
                "y": -1.2343553304672241,
                "z": -277.09906005859375
            },
            {
                "x": 7.04631233215332,
                "y": -1.238182783126831,
                "z": -276.9573974609375
            },
            {
                "x": 6.978969097137451,
                "y": -1.2414591312408447,
                "z": -276.8156433105469
            },
            {
                "x": 6.911757946014404,
                "y": -1.244194746017456,
                "z": -276.6736755371094
            },
            {
                "x": 6.844759941101074,
                "y": -1.2463724613189697,
                "z": -276.53173828125
            },
            {
                "x": 6.7780046463012695,
                "y": -1.2479748725891113,
                "z": -276.3897705078125
            },
            {
                "x": 6.734948635101318,
                "y": -1.248687982559204,
                "z": -276.2979736328125
            },
            {
                "x": 6.668499946594238,
                "y": -1.2493243217468262,
                "z": -276.1558837890625
            },
            {
                "x": 6.602168560028076,
                "y": -1.2493643760681152,
                "z": -276.01348876953125
            },
            {
                "x": 6.536065101623535,
                "y": -1.2487826347351074,
                "z": -275.8711242675781
            },
            {
                "x": 6.470186710357666,
                "y": -1.2476162910461426,
                "z": -275.72869873046875
            },
            {
                "x": 6.40447998046875,
                "y": -1.2458761930465698,
                "z": -275.5861511230469
            },
            {
                "x": 6.338989734649658,
                "y": -1.2435705661773682,
                "z": -275.4435119628906
            },
            {
                "x": 6.2738118171691895,
                "y": -1.2406913042068481,
                "z": -275.3009338378906
            },
            {
                "x": 6.208707809448242,
                "y": -1.2372633218765259,
                "z": -275.1579895019531
            },
            {
                "x": 6.143984794616699,
                "y": -1.2333145141601562,
                "z": -275.0152587890625
            },
            {
                "x": 6.079418182373047,
                "y": -1.2288403511047363,
                "z": -274.87225341796875
            },
            {
                "x": 6.015130043029785,
                "y": -1.22383713722229,
                "z": -274.7292785644531
            },
            {
                "x": 5.951138496398926,
                "y": -1.2183374166488647,
                "z": -274.5861511230469
            },
            {
                "x": 5.887253284454346,
                "y": -1.2123451232910156,
                "z": -274.4428405761719
            },
            {
                "x": 5.823713779449463,
                "y": -1.2058833837509155,
                "z": -274.299560546875
            },
            {
                "x": 5.760426044464111,
                "y": -1.1989390850067139,
                "z": -274.15625
            },
            {
                "x": 5.697420597076416,
                "y": -1.1915369033813477,
                "z": -274.0127258300781
            },
            {
                "x": 5.634637832641602,
                "y": -1.1836934089660645,
                "z": -273.8691711425781
            },
            {
                "x": 5.572171211242676,
                "y": -1.1754217147827148,
                "z": -273.7255859375
            },
            {
                "x": 5.509922027587891,
                "y": -1.1667070388793945,
                "z": -273.5817565917969
            },
            {
                "x": 5.448056221008301,
                "y": -1.1575908660888672,
                "z": -273.43798828125
            },
            {
                "x": 5.386416435241699,
                "y": -1.1480741500854492,
                "z": -273.29412841796875
            },
            {
                "x": 5.325120449066162,
                "y": -1.1381760835647583,
                "z": -273.15020751953125
            },
            {
                "x": 5.264066219329834,
                "y": -1.1278831958770752,
                "z": -273.0061340332031
            },
            {
                "x": 5.20328426361084,
                "y": -1.1172125339508057,
                "z": -272.8618469238281
            },
            {
                "x": 5.142787933349609,
                "y": -1.1061949729919434,
                "z": -272.7175598144531
            },
            {
                "x": 5.082670211791992,
                "y": -1.0948419570922852,
                "z": -272.5732421875
            },
            {
                "x": 5.022764682769775,
                "y": -1.0831350088119507,
                "z": -272.4287109375
            },
            {
                "x": 4.963286399841309,
                "y": -1.0711181163787842,
                "z": -272.28424072265625
            },
            {
                "x": 4.903962135314941,
                "y": -1.058762788772583,
                "z": -272.1393737792969
            },
            {
                "x": 4.84508752822876,
                "y": -1.046136736869812,
                "z": -271.9947509765625
            },
            {
                "x": 4.786453723907471,
                "y": -1.033200979232788,
                "z": -271.8498229980469
            },
            {
                "x": 4.728193283081055,
                "y": -1.0199882984161377,
                "z": -271.7048645019531
            },
            {
                "x": 4.670255661010742,
                "y": -1.0065054893493652,
                "z": -271.5597839355469
            },
            {
                "x": 4.612630367279053,
                "y": -0.992770791053772,
                "z": -271.4146423339844
            },
            {
                "x": 4.555330753326416,
                "y": -0.978775680065155,
                "z": -271.2692565917969
            },
            {
                "x": 4.498385906219482,
                "y": -0.9645559191703796,
                "z": -271.1239929199219
            },
            {
                "x": 4.441738128662109,
                "y": -0.9500953555107117,
                "z": -270.9783630371094
            },
            {
                "x": 4.385467052459717,
                "y": -0.9354435205459595,
                "z": -270.8329162597656
            },
            {
                "x": 4.329541206359863,
                "y": -0.920576810836792,
                "z": -270.68719482421875
            },
            {
                "x": 4.273857593536377,
                "y": -0.9054971933364868,
                "z": -270.541259765625
            },
            {
                "x": 4.218648910522461,
                "y": -0.8902583718299866,
                "z": -270.3954162597656
            },
            {
                "x": 4.163716793060303,
                "y": -0.8748451471328735,
                "z": -270.24945068359375
            },
            {
                "x": 4.128458499908447,
                "y": -0.8648085594177246,
                "z": -270.1551208496094
            },
            {
                "x": 4.074119567871094,
                "y": -0.849128782749176,
                "z": -270.0088806152344
            },
            {
                "x": 4.0201592445373535,
                "y": -0.8333202600479126,
                "z": -269.8626403808594
            },
            {
                "x": 3.966491460800171,
                "y": -0.8173537850379944,
                "z": -269.716064453125
            },
            {
                "x": 3.9132497310638428,
                "y": -0.8012963533401489,
                "z": -269.56964111328125
            },
            {
                "x": 3.860313653945923,
                "y": -0.7850975394248962,
                "z": -269.4228515625
            },
            {
                "x": 3.8077609539031982,
                "y": -0.7688233852386475,
                "z": -269.2762145996094
            },
            {
                "x": 3.7556052207946777,
                "y": -0.7524544596672058,
                "z": -269.12933349609375
            },
            {
                "x": 3.70367431640625,
                "y": -0.7359849214553833,
                "z": -268.982177734375
            },
            {
                "x": 3.6522557735443115,
                "y": -0.7194703221321106,
                "z": -268.8350830078125
            },
            {
                "x": 3.6011064052581787,
                "y": -0.7028888463973999,
                "z": -268.6878356933594
            },
            {
                "x": 3.5503957271575928,
                "y": -0.6862657070159912,
                "z": -268.5404357910156
            },
            {
                "x": 3.4999732971191406,
                "y": -0.6696056127548218,
                "z": -268.39300537109375
            },
            {
                "x": 3.449978828430176,
                "y": -0.6529102325439453,
                "z": -268.245361328125
            },
            {
                "x": 3.400315046310425,
                "y": -0.6362030506134033,
                "z": -268.09759521484375
            },
            {
                "x": 3.3510942459106445,
                "y": -0.6195113658905029,
                "z": -267.9498596191406
            },
            {
                "x": 3.3021397590637207,
                "y": -0.6027923822402954,
                "z": -267.8017578125
            },
            {
                "x": 3.253645896911621,
                "y": -0.586124062538147,
                "z": -267.65380859375
            },
            {
                "x": 3.205467700958252,
                "y": -0.5694544315338135,
                "z": -267.50543212890625
            },
            {
                "x": 3.1576337814331055,
                "y": -0.5528334975242615,
                "z": -267.3571472167969
            },
            {
                "x": 3.1102702617645264,
                "y": -0.5362668037414551,
                "z": -267.2087097167969
            },
            {
                "x": 3.0632057189941406,
                "y": -0.5197616219520569,
                "z": -267.0601806640625
            },
            {
                "x": 3.016599655151367,
                "y": -0.5033307075500488,
                "z": -266.9115295410156
            },
            {
                "x": 2.970289707183838,
                "y": -0.4869720935821533,
                "z": -266.76275634765625
            },
            {
                "x": 2.9243693351745605,
                "y": -0.47069084644317627,
                "z": -266.61370849609375
            },
            {
                "x": 2.8787927627563477,
                "y": -0.4545131027698517,
                "z": -266.46453857421875
            },
            {
                "x": 2.8336527347564697,
                "y": -0.43846386671066284,
                "z": -266.3154296875
            },
            {
                "x": 2.7888383865356445,
                "y": -0.42251765727996826,
                "z": -266.1659851074219
            },
            {
                "x": 2.74444580078125,
                "y": -0.40672677755355835,
                "z": -266.0166015625
            },
            {
                "x": 2.700361490249634,
                "y": -0.39104223251342773,
                "z": -265.8668212890625
            },
            {
                "x": 2.656705617904663,
                "y": -0.3755478262901306,
                "z": -265.7171630859375
            },
            {
                "x": 2.613478183746338,
                "y": -0.36021554470062256,
                "z": -265.5673828125
            },
            {
                "x": 2.5704941749572754,
                "y": -0.3450363874435425,
                "z": -265.41729736328125
            },
            {
                "x": 2.5280110836029053,
                "y": -0.3300670385360718,
                "z": -265.2673034667969
            },
            {
                "x": 2.485793113708496,
                "y": -0.3152710199356079,
                "z": -265.116943359375
            },
            {
                "x": 2.444040536880493,
                "y": -0.3007066249847412,
                "z": -264.9667053222656
            },
            {
                "x": 2.4026436805725098,
                "y": -0.2863459587097168,
                "z": -264.816162109375
            },
            {
                "x": 2.3615946769714355,
                "y": -0.27221745252609253,
                "z": -264.6656188964844
            },
            {
                "x": 2.320966958999634,
                "y": -0.25832709670066833,
                "z": -264.5148620605469
            },
            {
                "x": 2.280674457550049,
                "y": -0.2446988970041275,
                "z": -264.3641357421875
            },
            {
                "x": 2.2407758235931396,
                "y": -0.23131084442138672,
                "z": -264.2130126953125
            },
            {
                "x": 2.2011969089508057,
                "y": -0.2181963324546814,
                "z": -264.0619201660156
            },
            {
                "x": 2.162109136581421,
                "y": -0.2053842544555664,
                "z": -263.910888671875
            },
            {
                "x": 2.137011766433716,
                "y": -0.19725272059440613,
                "z": -263.8130798339844
            },
            {
                "x": 2.0984389781951904,
                "y": -0.18491417169570923,
                "z": -263.6616516113281
            },
            {
                "x": 2.0602810382843018,
                "y": -0.17287881672382355,
                "z": -263.5101623535156
            },
            {
                "x": 2.0224170684814453,
                "y": -0.16116786003112793,
                "z": -263.3583679199219
            },
            {
                "x": 1.985034704208374,
                "y": -0.14980345964431763,
                "z": -263.2067565917969
            },
            {
                "x": 1.9479278326034546,
                "y": -0.13875439763069153,
                "z": -263.0547180175781
            },
            {
                "x": 1.9112353324890137,
                "y": -0.12807486951351166,
                "z": -262.90283203125
            },
            {
                "x": 1.8749535083770752,
                "y": -0.11776066571474075,
                "z": -262.7507019042969
            },
            {
                "x": 1.8389265537261963,
                "y": -0.10780902951955795,
                "z": -262.5982971191406
            },
            {
                "x": 1.8033976554870605,
                "y": -0.09825582802295685,
                "z": -262.446044921875
            },
            {
                "x": 1.7681238651275635,
                "y": -0.08907735347747803,
                "z": -262.2934875488281
            },
            {
                "x": 1.733289122581482,
                "y": -0.08032970875501633,
                "z": -262.1409606933594
            },
            {
                "x": 1.698796272277832,
                "y": -0.0719907283782959,
                "z": -261.98822021484375
            },
            {
                "x": 1.664609432220459,
                "y": -0.06407254934310913,
                "z": -261.83538818359375
            },
            {
                "x": 1.630873203277588,
                "y": -0.056594159454107285,
                "z": -261.6824951171875
            },
            {
                "x": 1.5974230766296387,
                "y": -0.04957255348563194,
                "z": -261.5294494628906
            },
            {
                "x": 1.5644066333770752,
                "y": -0.043016254901885986,
                "z": -261.3764343261719
            },
            {
                "x": 1.531701922416687,
                "y": -0.03692038729786873,
                "z": -261.22320556640625
            },
            {
                "x": 1.4993629455566406,
                "y": -0.03130510076880455,
                "z": -261.0699768066406
            },
            {
                "x": 1.4674099683761597,
                "y": -0.02618531882762909,
                "z": -260.91650390625
            },
            {
                "x": 1.4357712268829346,
                "y": -0.02157605066895485,
                "z": -260.76300048828125
            },
            {
                "x": 1.4045606851577759,
                "y": -0.01747630536556244,
                "z": -260.6095275878906
            },
            {
                "x": 1.3736302852630615,
                "y": -0.013890085741877556,
                "z": -260.4558410644531
            },
            {
                "x": 1.343102216720581,
                "y": -0.01085066981613636,
                "z": -260.30230712890625
            },
            {
                "x": 1.3128987550735474,
                "y": -0.008355881087481976,
                "z": -260.14825439453125
            },
            {
                "x": 1.2830204963684082,
                "y": -0.006414378527551889,
                "z": -259.9944152832031
            },
            {
                "x": 1.2535624504089355,
                "y": -0.005032596178352833,
                "z": -259.8404846191406
            },
            {
                "x": 1.2243661880493164,
                "y": -0.004234116058796644,
                "z": -259.686279296875
            },
            {
                "x": 1.1955740451812744,
                "y": -0.004011086188256741,
                "z": -259.5323181152344
            },
            {
                "x": 1.1671042442321777,
                "y": -0.004011821001768112,
                "z": -259.3779296875
            },
            {
                "x": 1.1389505863189697,
                "y": -0.004012677818536758,
                "z": -259.2236633300781
            },
            {
                "x": 1.1112207174301147,
                "y": -0.004013508558273315,
                "z": -259.0694580078125
            },
            {
                "x": 1.0837674140930176,
                "y": -0.004014354199171066,
                "z": -258.9148864746094
            },
            {
                "x": 1.0566760301589966,
                "y": -0.00401519238948822,
                "z": -258.76055908203125
            },
            {
                "x": 1.0299385786056519,
                "y": -0.004016023129224777,
                "z": -258.6059875488281
            },
            {
                "x": 1.0034618377685547,
                "y": -0.004016861319541931,
                "z": -258.4513244628906
            },
            {
                "x": 0.97742760181427,
                "y": -0.004017706960439682,
                "z": -258.2967834472656
            },
            {
                "x": 0.9516624808311462,
                "y": -0.004018545150756836,
                "z": -258.1419372558594
            },
            {
                "x": 0.9262164831161499,
                "y": -0.00401938334107399,
                "z": -257.9872741699219
            },
            {
                "x": 0.901166558265686,
                "y": -0.004020217806100845,
                "z": -257.83251953125
            },
            {
                "x": 0.8763420581817627,
                "y": -0.004021052271127701,
                "z": -257.6774597167969
            },
            {
                "x": 0.8519219160079956,
                "y": -0.004021886736154556,
                "z": -257.5226745605469
            },
            {
                "x": 0.8278136253356934,
                "y": -0.00402272492647171,
                "z": -257.36767578125
            },
            {
                "x": 0.8123766183853149,
                "y": -0.004023253917694092,
                "z": -257.26751708984375
            },
            {
                "x": 0.7888104915618896,
                "y": -0.004024103283882141,
                "z": -257.112548828125
            },
            {
                "x": 0.7655365467071533,
                "y": -0.00402495265007019,
                "z": -256.9573059082031
            },
            {
                "x": 0.7425283193588257,
                "y": -0.004025798290967941,
                "z": -256.8021545410156
            },
            {
                "x": 0.7199393510818481,
                "y": -0.004026617854833603,
                "z": -256.6470947265625
            },
            {
                "x": 0.697585940361023,
                "y": -0.004027467221021652,
                "z": -256.4916076660156
            },
            {
                "x": 0.6755470633506775,
                "y": -0.004028286784887314,
                "z": -256.3363952636719
            },
            {
                "x": 0.6538820266723633,
                "y": -0.004029139876365662,
                "z": -256.18109130859375
            },
            {
                "x": 0.632421612739563,
                "y": -0.00402996689081192,
                "z": -256.02545166015625
            },
            {
                "x": 0.6113356351852417,
                "y": -0.004030812531709671,
                "z": -255.87014770507812
            },
            {
                "x": 0.5905554890632629,
                "y": -0.004031643271446228,
                "z": -255.71458435058594
            },
            {
                "x": 0.5700099468231201,
                "y": -0.004032488912343979,
                "z": -255.55902099609375
            },
            {
                "x": 0.5498518347740173,
                "y": -0.004033330827951431,
                "z": -255.403564453125
            },
            {
                "x": 0.5299311280250549,
                "y": -0.004034146666526794,
                "z": -255.2476806640625
            },
            {
                "x": 0.5102954506874084,
                "y": -0.004034996032714844,
                "z": -255.0920867919922
            },
            {
                "x": 0.49102282524108887,
                "y": -0.004035834223031998,
                "z": -254.9364776611328
            },
            {
                "x": 0.47197583317756653,
                "y": -0.004036668688058853,
                "z": -254.78054809570312
            },
            {
                "x": 0.45323634147644043,
                "y": -0.0040375106036663055,
                "z": -254.6248779296875
            },
            {
                "x": 0.4348243772983551,
                "y": -0.004038356244564056,
                "z": -254.46902465820312
            },
            {
                "x": 0.41662517189979553,
                "y": -0.004039198160171509,
                "z": -254.31301879882812
            },
            {
                "x": 0.39876124262809753,
                "y": -0.004040028899908066,
                "z": -254.1572723388672
            },
            {
                "x": 0.3812151253223419,
                "y": -0.004040855914354324,
                "z": -254.0013885498047
            },
            {
                "x": 0.3638705015182495,
                "y": -0.004041701555252075,
                "z": -253.84539794921875
            },
            {
                "x": 0.34685540199279785,
                "y": -0.004042539745569229,
                "z": -253.6895751953125
            },
            {
                "x": 0.33011916279792786,
                "y": -0.0040433816611766815,
                "z": -253.53338623046875
            },
            {
                "x": 0.3136051595211029,
                "y": -0.004044204950332642,
                "z": -253.37734985351562
            },
            {
                "x": 0.29741567373275757,
                "y": -0.004045058041810989,
                "z": -253.2213134765625
            },
            {
                "x": 0.2814915180206299,
                "y": -0.004045899957418442,
                "z": -253.0651092529297
            },
            {
                "x": 0.26579126715660095,
                "y": -0.004046741873025894,
                "z": -252.90896606445312
            },
            {
                "x": 0.25040510296821594,
                "y": -0.004047565162181854,
                "z": -252.75271606445312
            },
            {
                "x": 0.23528555035591125,
                "y": -0.004048392176628113,
                "z": -252.59649658203125
            },
            {
                "x": 0.22037965059280396,
                "y": -0.004049237817525864,
                "z": -252.44033813476562
            },
            {
                "x": 0.20579862594604492,
                "y": -0.004050079733133316,
                "z": -252.28407287597656
            },
            {
                "x": 0.19145992398262024,
                "y": -0.0040509141981601715,
                "z": -252.12770080566406
            },
            {
                "x": 0.17733058333396912,
                "y": -0.0040517523884773254,
                "z": -251.97134399414062
            },
            {
                "x": 0.16352331638336182,
                "y": -0.004052590578794479,
                "z": -251.81503295898438
            },
            {
                "x": 0.14995399117469788,
                "y": -0.004053428769111633,
                "z": -251.6586151123047
            },
            {
                "x": 0.13659226894378662,
                "y": -0.004054278135299683,
                "z": -251.502197265625
            },
            {
                "x": 0.12355485558509827,
                "y": -0.004055093973875046,
                "z": -251.34588623046875
            },
            {
                "x": 0.11073160171508789,
                "y": -0.0040559321641922,
                "z": -251.18939208984375
            },
            {
                "x": 0.09811186790466309,
                "y": -0.004056788980960846,
                "z": -251.0328369140625
            },
            {
                "x": 0.08581957221031189,
                "y": -0.004057619720697403,
                "z": -250.87649536132812
            },
            {
                "x": 0.07373753190040588,
                "y": -0.004058472812175751,
                "z": -250.7199249267578
            },
            {
                "x": 0.06603002548217773,
                "y": -0.004059001803398132,
                "z": -250.61883544921875
            },
            {
                "x": 0.05435490608215332,
                "y": -0.004059843719005585,
                "z": -250.4624481201172
            },
            {
                "x": 0.04293268918991089,
                "y": -0.004060667008161545,
                "z": -250.30581665039062
            },
            {
                "x": 0.03167840838432312,
                "y": -0.004061516374349594,
                "z": -250.14910888671875
            },
            {
                "x": 0.020706355571746826,
                "y": -0.00406235083937645,
                "z": -249.99266052246094
            },
            {
                "x": 0.009999901056289673,
                "y": -0.004063181579113007,
                "z": -249.83595275878906
            },
            {
                "x": -0.0005350112915039062,
                "y": -0.004064034670591354,
                "z": -249.67930603027344
            },
            {
                "x": -0.01081913709640503,
                "y": -0.004064865410327911,
                "z": -249.52279663085938
            },
            {
                "x": -0.02083808183670044,
                "y": -0.004065684974193573,
                "z": -249.36595153808594
            },
            {
                "x": -0.03067338466644287,
                "y": -0.004066541790962219,
                "z": -249.2092742919922
            },
            {
                "x": -0.040285319089889526,
                "y": -0.004067365080118179,
                "z": -249.05262756347656
            },
            {
                "x": -0.049618303775787354,
                "y": -0.00406821072101593,
                "z": -248.8959197998047
            },
            {
                "x": -0.05876836180686951,
                "y": -0.004069067537784576,
                "z": -248.73916625976562
            },
            {
                "x": -0.0677262395620346,
                "y": -0.004069898277521133,
                "z": -248.5823211669922
            },
            {
                "x": -0.07639573514461517,
                "y": -0.004070740193128586,
                "z": -248.4256591796875
            },
            {
                "x": -0.08487938344478607,
                "y": -0.004071567207574844,
                "z": -248.26885986328125
            },
            {
                "x": -0.09318867325782776,
                "y": -0.004072424024343491,
                "z": -248.1119842529297
            },
            {
                "x": -0.10121408104896545,
                "y": -0.004073247313499451,
                "z": -247.95529174804688
            },
            {
                "x": -0.10903988778591156,
                "y": -0.004074074327945709,
                "z": -247.79837036132812
            },
            {
                "x": -0.11670978367328644,
                "y": -0.004074938595294952,
                "z": -247.64146423339844
            },
            {
                "x": -0.12411908805370331,
                "y": -0.004075769335031509,
                "z": -247.48475646972656
            },
            {
                "x": -0.13129208981990814,
                "y": -0.004076603800058365,
                "z": -247.3279266357422
            },
            {
                "x": -0.13832125067710876,
                "y": -0.0040774233639240265,
                "z": -247.17105102539062
            },
            {
                "x": -0.14512884616851807,
                "y": -0.004078272730112076,
                "z": -247.01426696777344
            },
            {
                "x": -0.15169090032577515,
                "y": -0.004079118371009827,
                "z": -246.8572540283203
            },
            {
                "x": -0.15808779001235962,
                "y": -0.004079945385456085,
                "z": -246.70037841796875
            },
            {
                "x": -0.16430138051509857,
                "y": -0.004080798476934433,
                "z": -246.54351806640625
            },
            {
                "x": -0.17026138305664062,
                "y": -0.0040816254913806915,
                "z": -246.38661193847656
            },
            {
                "x": -0.17603975534439087,
                "y": -0.004082448780536652,
                "z": -246.2296600341797
            },
            {
                "x": -0.18166768550872803,
                "y": -0.004083305597305298,
                "z": -246.07260131835938
            },
            {
                "x": -0.1870480626821518,
                "y": -0.004084121435880661,
                "z": -245.915771484375
            },
            {
                "x": -0.19222092628479004,
                "y": -0.004084985703229904,
                "z": -245.75877380371094
            },
            {
                "x": -0.19726219773292542,
                "y": -0.004085816442966461,
                "z": -245.60174560546875
            },
            {
                "x": -0.2020852267742157,
                "y": -0.00408664345741272,
                "z": -245.4448699951172
            },
            {
                "x": -0.20667755603790283,
                "y": -0.004087492823600769,
                "z": -245.287841796875
            },
            {
                "x": -0.2111254632472992,
                "y": -0.004088301211595535,
                "z": -245.13076782226562
            },
            {
                "x": -0.2154064178466797,
                "y": -0.004089180380105972,
                "z": -244.973876953125
            },
            {
                "x": -0.21944469213485718,
                "y": -0.0040899887681007385,
                "z": -244.8168487548828
            },
            {
                "x": -0.22330251336097717,
                "y": -0.0040908269584178925,
                "z": -244.65982055664062
            },
            {
                "x": -0.22703084349632263,
                "y": -0.00409168004989624,
                "z": -244.5028533935547
            },
            {
                "x": -0.2305535078048706,
                "y": -0.004092525690793991,
                "z": -244.34576416015625
            },
            {
                "x": -0.23384761810302734,
                "y": -0.0040933601558208466,
                "z": -244.18878173828125
            },
            {
                "x": -0.23689799010753632,
                "y": -0.004093636758625507,
                "z": -244.03175354003906
            },
            {
                "x": -0.23898090422153473,
                "y": -0.0040947310626506805,
                "z": -243.93035888671875
            },
            {
                "x": -0.2418307363986969,
                "y": -0.004095572978258133,
                "z": -243.77345275878906
            },
            {
                "x": -0.24448318779468536,
                "y": -0.004096418619155884,
                "z": -243.6163330078125
            },
            {
                "x": -0.24701367318630219,
                "y": -0.004097245633602142,
                "z": -243.45919799804688
            },
            {
                "x": -0.24937483668327332,
                "y": -0.004098102450370789,
                "z": -243.30221557617188
            },
            {
                "x": -0.2515084743499756,
                "y": -0.004098925739526749,
                "z": -243.1451416015625
            },
            {
                "x": -0.253490149974823,
                "y": -0.004099756479263306,
                "z": -242.98806762695312
            },
            {
                "x": -0.25534623861312866,
                "y": -0.004100590944290161,
                "z": -242.83102416992188
            },
            {
                "x": -0.2570094168186188,
                "y": -0.004101444035768509,
                "z": -242.67385864257812
            },
            {
                "x": -0.2584802210330963,
                "y": -0.004102274775505066,
                "z": -242.5167694091797
            },
            {
                "x": -0.25983914732933044,
                "y": -0.004103124141693115,
                "z": -242.35964965820312
            },
            {
                "x": -0.26105305552482605,
                "y": -0.004103947430849075,
                "z": -242.20257568359375
            },
            {
                "x": -0.26210692524909973,
                "y": -0.004104793071746826,
                "z": -242.0454864501953
            },
            {
                "x": -0.26307106018066406,
                "y": -0.004105627536773682,
                "z": -241.8881378173828
            },
            {
                "x": -0.2639528810977936,
                "y": -0.004106465727090836,
                "z": -241.7310333251953
            },
            {
                "x": -0.26474529504776,
                "y": -0.0041073039174079895,
                "z": -241.57386779785156
            },
            {
                "x": -0.26554074883461,
                "y": -0.00410814955830574,
                "z": -241.4164581298828
            },
            {
                "x": -0.26640158891677856,
                "y": -0.004108980298042297,
                "z": -241.25917053222656
            },
            {
                "x": -0.2672785818576813,
                "y": -0.004109807312488556,
                "z": -241.101806640625
            },
            {
                "x": -0.2682671546936035,
                "y": -0.004110656678676605,
                "z": -240.94427490234375
            },
            {
                "x": -0.2694518566131592,
                "y": -0.004111491143703461,
                "z": -240.78680419921875
            },
            {
                "x": -0.2707951068878174,
                "y": -0.004112329334020615,
                "z": -240.62940979003906
            },
            {
                "x": -0.2723188102245331,
                "y": -0.004113160073757172,
                "z": -240.47186279296875
            },
            {
                "x": -0.27412620186805725,
                "y": -0.0041140057146549225,
                "z": -240.31430053710938
            },
            {
                "x": -0.2761787176132202,
                "y": -0.004114843904972076,
                "z": -240.15664672851562
            },
            {
                "x": -0.27841469645500183,
                "y": -0.00411568209528923,
                "z": -239.99917602539062
            },
            {
                "x": -0.2809489965438843,
                "y": -0.004067794419825077,
                "z": -239.84149169921875
            },
            {
                "x": -0.28380152583122253,
                "y": -0.0037959921173751354,
                "z": -239.68389892578125
            },
            {
                "x": -0.2868548035621643,
                "y": -0.0032777967862784863,
                "z": -239.52650451660156
            },
            {
                "x": -0.2901495397090912,
                "y": -0.0025068470276892185,
                "z": -239.36874389648438
            },
            {
                "x": -0.2937900424003601,
                "y": -0.001491837203502655,
                "z": -239.21112060546875
            },
            {
                "x": -0.2977030277252197,
                "y": -0.0002412612084299326,
                "z": -239.05368041992188
            },
            {
                "x": -0.3018054664134979,
                "y": 0.0012439440470188856,
                "z": -238.89614868164062
            },
            {
                "x": -0.30621373653411865,
                "y": 0.002966931089758873,
                "z": -238.73854064941406
            },
            {
                "x": -0.31096962094306946,
                "y": 0.004921973682940006,
                "z": -238.5809326171875
            },
            {
                "x": -0.31593599915504456,
                "y": 0.007098349742591381,
                "z": -238.4235076904297
            },
            {
                "x": -0.32113078236579895,
                "y": 0.009495996870100498,
                "z": -238.26600646972656
            },
            {
                "x": -0.3266880214214325,
                "y": 0.012119589373469353,
                "z": -238.10833740234375
            },
            {
                "x": -0.33252784609794617,
                "y": 0.014956195838749409,
                "z": -237.9510040283203
            },
            {
                "x": -0.33856070041656494,
                "y": 0.018003670498728752,
                "z": -237.7936248779297
            },
            {
                "x": -0.3449094593524933,
                "y": 0.02126520872116089,
                "z": -237.63592529296875
            },
            {
                "x": -0.35160142183303833,
                "y": 0.02472972869873047,
                "z": -237.478515625
            },
            {
                "x": -0.35850855708122253,
                "y": 0.0283964890986681,
                "z": -237.3212432861328
            },
            {
                "x": -0.3630894422531128,
                "y": 0.030869463458657265,
                "z": -237.21958923339844
            },
            {
                "x": -0.37047603726387024,
                "y": 0.03486325591802597,
                "z": -237.0621337890625
            },
            {
                "x": -0.3781975507736206,
                "y": 0.03905429691076279,
                "z": -236.90475463867188
            },
            {
                "x": -0.38611626625061035,
                "y": 0.04343143478035927,
                "z": -236.74745178222656
            },
            {
                "x": -0.39431601762771606,
                "y": 0.047995325177907944,
                "z": -236.5900421142578
            },
            {
                "x": -0.40288570523262024,
                "y": 0.05274491012096405,
                "z": -236.43264770507812
            },
            {
                "x": -0.4116935133934021,
                "y": 0.057671163231134415,
                "z": -236.27549743652344
            },
            {
                "x": -0.4207340180873871,
                "y": 0.06277582049369812,
                "z": -236.1182403564453
            },
            {
                "x": -0.43014514446258545,
                "y": 0.06806020438671112,
                "z": -235.96075439453125
            },
            {
                "x": -0.43984073400497437,
                "y": 0.07350228726863861,
                "z": -235.80364990234375
            },
            {
                "x": -0.44975051283836365,
                "y": 0.07911856472492218,
                "z": -235.64645385742188
            },
            {
                "x": -0.45999228954315186,
                "y": 0.08490006625652313,
                "z": -235.48916625976562
            },
            {
                "x": -0.47057175636291504,
                "y": 0.09083402156829834,
                "z": -235.3320770263672
            },
            {
                "x": -0.48137301206588745,
                "y": 0.09692709892988205,
                "z": -235.17486572265625
            },
            {
                "x": -0.4924589991569519,
                "y": 0.10317560285329819,
                "z": -235.01776123046875
            },
            {
                "x": -0.5039126873016357,
                "y": 0.10957165062427521,
                "z": -234.86065673828125
            },
            {
                "x": -0.5156151652336121,
                "y": 0.11611068248748779,
                "z": -234.70362854003906
            },
            {
                "x": -0.5275490880012512,
                "y": 0.12278944253921509,
                "z": -234.5466766357422
            },
            {
                "x": -0.539880633354187,
                "y": 0.1296204924583435,
                "z": -234.38954162597656
            },
            {
                "x": -0.5524914264678955,
                "y": 0.13657793402671814,
                "z": -234.2325897216797
            },
            {
                "x": -0.5653101205825806,
                "y": 0.1436639279127121,
                "z": -234.07574462890625
            },
            {
                "x": -0.5784792304039001,
                "y": 0.1508822739124298,
                "z": -233.9187774658203
            },
            {
                "x": -0.5919928550720215,
                "y": 0.1582251787185669,
                "z": -233.761962890625
            },
            {
                "x": -0.6057087182998657,
                "y": 0.16568484902381897,
                "z": -233.6052703857422
            },
            {
                "x": -0.619766354560852,
                "y": 0.17327940464019775,
                "z": -233.44822692871094
            },
            {
                "x": -0.6341667175292969,
                "y": 0.18097585439682007,
                "z": -233.2914581298828
            },
            {
                "x": -0.648795485496521,
                "y": 0.1887824833393097,
                "z": -233.13482666015625
            },
            {
                "x": -0.6637204885482788,
                "y": 0.1967049539089203,
                "z": -232.97805786132812
            },
            {
                "x": -0.6790168285369873,
                "y": 0.204728901386261,
                "z": -232.8213653564453
            },
            {
                "x": -0.6945669054985046,
                "y": 0.21285387873649597,
                "z": -232.6646728515625
            },
            {
                "x": -0.7103745937347412,
                "y": 0.2210768312215805,
                "z": -232.50807189941406
            },
            {
                "x": -0.7265663146972656,
                "y": 0.2293957769870758,
                "z": -232.35147094726562
            },
            {
                "x": -0.7430284023284912,
                "y": 0.23780138790607452,
                "z": -232.19496154785156
            },
            {
                "x": -0.7597248554229736,
                "y": 0.24629437923431396,
                "z": -232.03848266601562
            },
            {
                "x": -0.7768166065216064,
                "y": 0.25488048791885376,
                "z": -231.88189697265625
            },
            {
                "x": -0.7941949367523193,
                "y": 0.2635384500026703,
                "z": -231.7255096435547
            },
            {
                "x": -0.8117948174476624,
                "y": 0.2722721993923187,
                "z": -231.5691680908203
            },
            {
                "x": -0.8297765851020813,
                "y": 0.2810910642147064,
                "z": -231.41265869140625
            },
            {
                "x": -0.848057746887207,
                "y": 0.2899639904499054,
                "z": -231.2564697265625
            },
            {
                "x": -0.8665684461593628,
                "y": 0.2989082336425781,
                "z": -231.1002655029297
            },
            {
                "x": -0.8854618072509766,
                "y": 0.30793285369873047,
                "z": -230.9438018798828
            },
            {
                "x": -0.9046499729156494,
                "y": 0.3169959783554077,
                "z": -230.7877197265625
            },
            {
                "x": -0.9240642786026001,
                "y": 0.3261173367500305,
                "z": -230.6316680908203
            },
            {
                "x": -0.9367964267730713,
                "y": 0.33204448223114014,
                "z": -230.53079223632812
            },
            {
                "x": -0.9568002223968506,
                "y": 0.34125447273254395,
                "z": -230.37472534179688
            },
            {
                "x": -0.9770505428314209,
                "y": 0.35051029920578003,
                "z": -230.21873474121094
            },
            {
                "x": -0.9976070523262024,
                "y": 0.3598213791847229,
                "z": -230.06259155273438
            },
            {
                "x": -1.0185240507125854,
                "y": 0.3691651225090027,
                "z": -229.90667724609375
            },
            {
                "x": -1.039693832397461,
                "y": 0.37854206562042236,
                "z": -229.75079345703125
            },
            {
                "x": -1.0611305236816406,
                "y": 0.3879559338092804,
                "z": -229.59490966796875
            },
            {
                "x": -1.0829609632492065,
                "y": 0.39740070700645447,
                "z": -229.43907165527344
            },
            {
                "x": -1.105059266090393,
                "y": 0.40687403082847595,
                "z": -229.28323364257812
            },
            {
                "x": -1.1274069547653198,
                "y": 0.4163660705089569,
                "z": -229.1275177001953
            },
            {
                "x": -1.150144338607788,
                "y": 0.4258826971054077,
                "z": -228.97174072265625
            },
            {
                "x": -1.1731317043304443,
                "y": 0.43540558218955994,
                "z": -228.81619262695312
            },
            {
                "x": -1.1963919401168823,
                "y": 0.4449462294578552,
                "z": -228.6605987548828
            },
            {
                "x": -1.2200641632080078,
                "y": 0.45450955629348755,
                "z": -228.50486755371094
            },
            {
                "x": -1.2439318895339966,
                "y": 0.4640551209449768,
                "z": -228.34951782226562
            },
            {
                "x": -1.2681078910827637,
                "y": 0.473613440990448,
                "z": -228.1940460205078
            },
            {
                "x": -1.292671799659729,
                "y": 0.4831770062446594,
                "z": -228.0385284423828
            },
            {
                "x": -1.3174439668655396,
                "y": 0.49271950125694275,
                "z": -227.88331604003906
            },
            {
                "x": -1.3425359725952148,
                "y": 0.5022706985473633,
                "z": -227.7278594970703
            },
            {
                "x": -1.368006706237793,
                "y": 0.5118070840835571,
                "z": -227.57252502441406
            },
            {
                "x": -1.3936772346496582,
                "y": 0.5213136672973633,
                "z": -227.41749572753906
            },
            {
                "x": -1.41966712474823,
                "y": 0.5308135747909546,
                "z": -227.2622833251953
            },
            {
                "x": -1.4460047483444214,
                "y": 0.5402865409851074,
                "z": -227.10723876953125
            },
            {
                "x": -1.472565770149231,
                "y": 0.5497281551361084,
                "z": -226.9522705078125
            },
            {
                "x": -1.4994940757751465,
                "y": 0.5591620206832886,
                "z": -226.7970428466797
            },
            {
                "x": -1.5267236232757568,
                "y": 0.568544864654541,
                "z": -226.64218139648438
            },
            {
                "x": -1.5541784763336182,
                "y": 0.5778943300247192,
                "z": -226.48728942871094
            },
            {
                "x": -1.5819796323776245,
                "y": 0.5872106552124023,
                "z": -226.3323516845703
            },
            {
                "x": -1.6100904941558838,
                "y": 0.5964736938476562,
                "z": -226.17762756347656
            },
            {
                "x": -1.6384601593017578,
                "y": 0.605702817440033,
                "z": -226.0227508544922
            },
            {
                "x": -1.667144536972046,
                "y": 0.6148768663406372,
                "z": -225.86802673339844
            },
            {
                "x": -1.6961294412612915,
                "y": 0.6239892244338989,
                "z": -225.71347045898438
            },
            {
                "x": -1.7253644466400146,
                "y": 0.6330519318580627,
                "z": -225.55882263183594
            },
            {
                "x": -1.7549501657485962,
                "y": 0.6420546174049377,
                "z": -225.40423583984375
            },
            {
                "x": -1.7847970724105835,
                "y": 0.6509883403778076,
                "z": -225.24981689453125
            },
            {
                "x": -1.8149073123931885,
                "y": 0.659861147403717,
                "z": -225.09527587890625
            },
            {
                "x": -1.8453726768493652,
                "y": 0.6686581373214722,
                "z": -224.94088745117188
            },
            {
                "x": -1.876075029373169,
                "y": 0.6773778200149536,
                "z": -224.78659057617188
            },
            {
                "x": -1.907041311264038,
                "y": 0.6860225200653076,
                "z": -224.63230895996094
            },
            {
                "x": -1.9383559226989746,
                "y": 0.6945850849151611,
                "z": -224.4781036376953
            },
            {
                "x": -1.969921588897705,
                "y": 0.7030644416809082,
                "z": -224.3238525390625
            },
            {
                "x": -2.0017590522766113,
                "y": 0.7114529013633728,
                "z": -224.16973876953125
            },
            {
                "x": -2.0339102745056152,
                "y": 0.7197462320327759,
                "z": -224.0157470703125
            },
            {
                "x": -2.0547802448272705,
                "y": 0.7250499725341797,
                "z": -223.91632080078125
            },
            {
                "x": -2.0873522758483887,
                "y": 0.733184814453125,
                "z": -223.76235961914062
            },
            {
                "x": -2.1202704906463623,
                "y": 0.7412228584289551,
                "z": -223.6083984375
            },
            {
                "x": -2.1533851623535156,
                "y": 0.7491533756256104,
                "z": -223.4545440673828
            },
            {
                "x": -2.1868021488189697,
                "y": 0.7569713592529297,
                "z": -223.30076599121094
            },
            {
                "x": -2.220531463623047,
                "y": 0.7646805047988892,
                "z": -223.14700317382812
            },
            {
                "x": -2.2544524669647217,
                "y": 0.772270917892456,
                "z": -222.9933624267578
            },
            {
                "x": -2.288699150085449,
                "y": 0.77974534034729,
                "z": -222.83973693847656
            },
            {
                "x": -2.3232357501983643,
                "y": 0.7870975136756897,
                "z": -222.6861114501953
            },
            {
                "x": -2.3579797744750977,
                "y": 0.7943203449249268,
                "z": -222.53256225585938
            },
            {
                "x": -2.3930470943450928,
                "y": 0.8014154434204102,
                "z": -222.37913513183594
            },
            {
                "x": -2.428319215774536,
                "y": 0.808376133441925,
                "z": -222.22573852539062
            },
            {
                "x": -2.4638772010803223,
                "y": 0.8151994347572327,
                "z": -222.0723876953125
            },
            {
                "x": -2.499757766723633,
                "y": 0.8218858242034912,
                "z": -221.9189910888672
            },
            {
                "x": -2.5357887744903564,
                "y": 0.8284220695495605,
                "z": -221.7658233642578
            },
            {
                "x": -2.572131872177124,
                "y": 0.8348162174224854,
                "z": -221.6126251220703
            },
            {
                "x": -2.608731746673584,
                "y": 0.8410552740097046,
                "z": -221.4595184326172
            },
            {
                "x": -2.6455414295196533,
                "y": 0.8471387624740601,
                "z": -221.30645751953125
            },
            {
                "x": -2.6826746463775635,
                "y": 0.8530693054199219,
                "z": -221.1533660888672
            },
            {
                "x": -2.719994306564331,
                "y": 0.8588370084762573,
                "z": -221.00045776367188
            },
            {
                "x": -2.757568359375,
                "y": 0.8644368648529053,
                "z": -220.8475799560547
            },
            {
                "x": -2.7953989505767822,
                "y": 0.8698635101318359,
                "z": -220.69482421875
            },
            {
                "x": -2.833421230316162,
                "y": 0.8751206398010254,
                "z": -220.54209899902344
            },
            {
                "x": -2.871729612350464,
                "y": 0.8802063465118408,
                "z": -220.38938903808594
            },
            {
                "x": -2.9102981090545654,
                "y": 0.8851125240325928,
                "z": -220.23663330078125
            },
            {
                "x": -2.9490349292755127,
                "y": 0.8898304104804993,
                "z": -220.08404541015625
            },
            {
                "x": -2.9880523681640625,
                "y": 0.8943650722503662,
                "z": -219.9314727783203
            },
            {
                "x": -3.0272557735443115,
                "y": 0.898711085319519,
                "z": -219.77899169921875
            },
            {
                "x": -3.0667028427124023,
                "y": 0.9028621912002563,
                "z": -219.62657165527344
            },
            {
                "x": -3.1064276695251465,
                "y": 0.9068160057067871,
                "z": -219.4740753173828
            },
            {
                "x": -3.1462883949279785,
                "y": 0.9105678200721741,
                "z": -219.32177734375
            },
            {
                "x": -3.186408758163452,
                "y": 0.9141183495521545,
                "z": -219.16952514648438
            },
            {
                "x": -3.226726531982422,
                "y": 0.9174597859382629,
                "z": -219.01730346679688
            },
            {
                "x": -3.2672533988952637,
                "y": 0.9205867052078247,
                "z": -218.8651123046875
            },
            {
                "x": -3.308035135269165,
                "y": 0.9235021471977234,
                "z": -218.7129364013672
            },
            {
                "x": -3.34895920753479,
                "y": 0.9262011051177979,
                "z": -218.56085205078125
            },
            {
                "x": -3.390117645263672,
                "y": 0.9286765456199646,
                "z": -218.4088592529297
            },
            {
                "x": -3.4314608573913574,
                "y": 0.9309219121932983,
                "z": -218.2569122314453
            },
            {
                "x": -3.472975015640259,
                "y": 0.9329411387443542,
                "z": -218.1050262451172
            },
            {
                "x": -3.5147078037261963,
                "y": 0.9347304105758667,
                "z": -217.9532470703125
            },
            {
                "x": -3.5566444396972656,
                "y": 0.9362847208976746,
                "z": -217.8013153076172
            },
            {
                "x": -3.5987582206726074,
                "y": 0.9375931024551392,
                "z": -217.6496124267578
            },
            {
                "x": -3.64102840423584,
                "y": 0.9386603832244873,
                "z": -217.4980010986328
            },
            {
                "x": -3.6684091091156006,
                "y": 0.9392252564430237,
                "z": -217.4000701904297
            },
            {
                "x": -3.7109954357147217,
                "y": 0.9398823380470276,
                "z": -217.2484893798828
            },
            {
                "x": -3.7537550926208496,
                "y": 0.9402896761894226,
                "z": -217.09693908691406
            },
            {
                "x": -3.796664237976074,
                "y": 0.9404444694519043,
                "z": -216.9453887939453
            },
            {
                "x": -3.8397481441497803,
                "y": 0.9403431415557861,
                "z": -216.79400634765625
            },
            {
                "x": -3.8829827308654785,
                "y": 0.9399762153625488,
                "z": -216.64256286621094
            },
            {
                "x": -3.926386594772339,
                "y": 0.939359724521637,
                "z": -216.4912109375
            },
            {
                "x": -3.969923257827759,
                "y": 0.9384971857070923,
                "z": -216.3400115966797
            },
            {
                "x": -4.013660430908203,
                "y": 0.9373893737792969,
                "z": -216.18858337402344
            },
            {
                "x": -4.057518005371094,
                "y": 0.9360325336456299,
                "z": -216.03744506835938
            },
            {
                "x": -4.1014933586120605,
                "y": 0.9344390630722046,
                "z": -215.88629150390625
            },
            {
                "x": -4.145628929138184,
                "y": 0.9326130747795105,
                "z": -215.73516845703125
            },
            {
                "x": -4.1898651123046875,
                "y": 0.9305592179298401,
                "z": -215.58419799804688
            },
            {
                "x": -4.234300136566162,
                "y": 0.9282651543617249,
                "z": -215.43299865722656
            },
            {
                "x": -4.278814792633057,
                "y": 0.9257526993751526,
                "z": -215.28211975097656
            },
            {
                "x": -4.323426723480225,
                "y": 0.9230217933654785,
                "z": -215.1312255859375
            },
            {
                "x": -4.368204116821289,
                "y": 0.9200730323791504,
                "z": -214.9802703857422
            },
            {
                "x": -4.41304349899292,
                "y": 0.9169065952301025,
                "z": -214.8295135498047
            },
            {
                "x": -4.458028793334961,
                "y": 0.9135284423828125,
                "z": -214.67864990234375
            },
            {
                "x": -4.5031352043151855,
                "y": 0.9099462032318115,
                "z": -214.52786254882812
            },
            {
                "x": -4.548289775848389,
                "y": 0.9061652421951294,
                "z": -214.37721252441406
            },
            {
                "x": -4.593557834625244,
                "y": 0.9021780490875244,
                "z": -214.22657775878906
            },
            {
                "x": -4.638912200927734,
                "y": 0.8979963064193726,
                "z": -214.07598876953125
            },
            {
                "x": -4.684345722198486,
                "y": 0.8936242461204529,
                "z": -213.92543029785156
            },
            {
                "x": -4.729925155639648,
                "y": 0.8890599012374878,
                "z": -213.7747344970703
            },
            {
                "x": -4.77551794052124,
                "y": 0.8843098282814026,
                "z": -213.62423706054688
            },
            {
                "x": -4.821208953857422,
                "y": 0.8793768882751465,
                "z": -213.47373962402344
            },
            {
                "x": -4.866966247558594,
                "y": 0.8742677569389343,
                "z": -213.3232879638672
            },
            {
                "x": -4.912779331207275,
                "y": 0.8689862489700317,
                "z": -213.17288208007812
            },
            {
                "x": -4.9587016105651855,
                "y": 0.8635240793228149,
                "z": -213.02235412597656
            },
            {
                "x": -5.004610538482666,
                "y": 0.8578996658325195,
                "z": -212.8719940185547
            },
            {
                "x": -5.050591468811035,
                "y": 0.8521127700805664,
                "z": -212.72169494628906
            },
            {
                "x": -5.096627712249756,
                "y": 0.8461642265319824,
                "z": -212.57131958007812
            },
            {
                "x": -5.142687797546387,
                "y": 0.8400562405586243,
                "z": -212.42103576660156
            },
            {
                "x": -5.188808441162109,
                "y": 0.833792507648468,
                "z": -212.27072143554688
            },
            {
                "x": -5.234952449798584,
                "y": 0.8273807764053345,
                "z": -212.12042236328125
            },
            {
                "x": -5.28110408782959,
                "y": 0.8208271265029907,
                "z": -211.97024536132812
            },
            {
                "x": -5.327300071716309,
                "y": 0.8141226768493652,
                "z": -211.81996154785156
            },
            {
                "x": -5.373480796813965,
                "y": 0.8072840571403503,
                "z": -211.66981506347656
            },
            {
                "x": -5.419677734375,
                "y": 0.8003096580505371,
                "z": -211.51966857910156
            },
            {
                "x": -5.465944290161133,
                "y": 0.7931952476501465,
                "z": -211.3693389892578
            },
            {
                "x": -5.512145519256592,
                "y": 0.7859587073326111,
                "z": -211.21923828125
            },
            {
                "x": -5.558352470397949,
                "y": 0.7785954475402832,
                "z": -211.06912231445312
            },
            {
                "x": -5.588191509246826,
                "y": 0.7737764120101929,
                "z": -210.97215270996094
            },
            {
                "x": -5.634363174438477,
                "y": 0.7662177681922913,
                "z": -210.82208251953125
            },
            {
                "x": -5.680565357208252,
                "y": 0.7585347890853882,
                "z": -210.67190551757812
            },
            {
                "x": -5.726734638214111,
                "y": 0.7507410049438477,
                "z": -210.52175903320312
            },
            {
                "x": -5.772853851318359,
                "y": 0.7428442239761353,
                "z": -210.37168884277344
            },
            {
                "x": -5.818971157073975,
                "y": 0.7348354458808899,
                "z": -210.22152709960938
            },
            {
                "x": -5.865028381347656,
                "y": 0.726726233959198,
                "z": -210.0714111328125
            },
            {
                "x": -5.911041736602783,
                "y": 0.7185208797454834,
                "z": -209.9213409423828
            },
            {
                "x": -5.957041263580322,
                "y": 0.7102121114730835,
                "z": -209.7710723876953
            },
            {
                "x": -6.002964019775391,
                "y": 0.7018206119537354,
                "z": -209.62095642089844
            },
            {
                "x": -6.048832416534424,
                "y": 0.6933361887931824,
                "z": -209.47080993652344
            },
            {
                "x": -6.0946364402771,
                "y": 0.6847677230834961,
                "z": -209.32064819335938
            },
            {
                "x": -6.140356063842773,
                "y": 0.6761241555213928,
                "z": -209.17056274414062
            },
            {
                "x": -6.186061859130859,
                "y": 0.6673901081085205,
                "z": -209.02024841308594
            },
            {
                "x": -6.231633186340332,
                "y": 0.6585915088653564,
                "z": -208.87008666992188
            },
            {
                "x": -6.277113437652588,
                "y": 0.6497238278388977,
                "z": -208.71995544433594
            },
            {
                "x": -6.3225507736206055,
                "y": 0.6407811641693115,
                "z": -208.56964111328125
            },
            {
                "x": -6.36785364151001,
                "y": 0.6317843198776245,
                "z": -208.41946411132812
            },
            {
                "x": -6.4130940437316895,
                "y": 0.6227174997329712,
                "z": -208.26913452148438
            },
            {
                "x": -6.4582390785217285,
                "y": 0.6135959625244141,
                "z": -208.11880493164062
            },
            {
                "x": -6.503237247467041,
                "y": 0.6044272184371948,
                "z": -207.96856689453125
            },
            {
                "x": -6.54813814163208,
                "y": 0.5952101349830627,
                "z": -207.81829833984375
            },
            {
                "x": -6.5928850173950195,
                "y": 0.5859458446502686,
                "z": -207.66799926757812
            },
            {
                "x": -6.637533664703369,
                "y": 0.5766369104385376,
                "z": -207.5176239013672
            },
            {
                "x": -6.682096004486084,
                "y": 0.5672799944877625,
                "z": -207.3671112060547
            },
            {
                "x": -6.726477146148682,
                "y": 0.5578962564468384,
                "z": -207.21664428710938
            },
            {
                "x": -6.770729064941406,
                "y": 0.5484796762466431,
                "z": -207.06619262695312
            },
            {
                "x": -6.814810752868652,
                "y": 0.5390327572822571,
                "z": -206.91566467285156
            },
            {
                "x": -6.858767986297607,
                "y": 0.52956223487854,
                "z": -206.76510620117188
            },
            {
                "x": -6.902588367462158,
                "y": 0.5200629234313965,
                "z": -206.6144256591797
            },
            {
                "x": -6.946219444274902,
                "y": 0.5105516910552979,
                "z": -206.46377563476562
            },
            {
                "x": -6.989675521850586,
                "y": 0.5010295510292053,
                "z": -206.31321716308594
            },
            {
                "x": -7.032986164093018,
                "y": 0.4914871156215668,
                "z": -206.16238403320312
            },
            {
                "x": -7.076117038726807,
                "y": 0.48194438219070435,
                "z": -206.01165771484375
            },
            {
                "x": -7.119046211242676,
                "y": 0.4723927974700928,
                "z": -205.86080932617188
            },
            {
                "x": -7.161832809448242,
                "y": 0.46283790469169617,
                "z": -205.70989990234375
            },
            {
                "x": -7.204373836517334,
                "y": 0.4532935619354248,
                "z": -205.55906677246094
            },
            {
                "x": -7.246766090393066,
                "y": 0.44374561309814453,
                "z": -205.40798950195312
            },
            {
                "x": -7.288931369781494,
                "y": 0.43421870470046997,
                "z": -205.25704956054688
            },
            {
                "x": -7.330860614776611,
                "y": 0.4247016906738281,
                "z": -205.1060028076172
            },
            {
                "x": -7.372669219970703,
                "y": 0.41519051790237427,
                "z": -204.95477294921875
            },
            {
                "x": -7.414164066314697,
                "y": 0.40571272373199463,
                "z": -204.8036651611328
            },
            {
                "x": -7.455491542816162,
                "y": 0.39625275135040283,
                "z": -204.6524200439453
            },
            {
                "x": -7.482044219970703,
                "y": 0.3901613652706146,
                "z": -204.5547637939453
            },
            {
                "x": -7.522939682006836,
                "y": 0.3807521164417267,
                "z": -204.40347290039062
            },
            {
                "x": -7.563692569732666,
                "y": 0.3713662922382355,
                "z": -204.25201416015625
            },
            {
                "x": -7.604140281677246,
                "y": 0.3620237708091736,
                "z": -204.1005401611328
            },
            {
                "x": -7.644356727600098,
                "y": 0.35272079706192017,
                "z": -203.94903564453125
            },
            {
                "x": -7.684341907501221,
                "y": 0.3434597849845886,
                "z": -203.79745483398438
            },
            {
                "x": -7.7240495681762695,
                "y": 0.33424508571624756,
                "z": -203.6457977294922
            },
            {
                "x": -7.763519763946533,
                "y": 0.3250857889652252,
                "z": -203.49415588378906
            },
            {
                "x": -7.802711486816406,
                "y": 0.31597042083740234,
                "z": -203.34225463867188
            },
            {
                "x": -7.841655254364014,
                "y": 0.30691656470298767,
                "z": -203.19041442871094
            },
            {
                "x": -7.8803019523620605,
                "y": 0.297925740480423,
                "z": -203.03851318359375
            },
            {
                "x": -7.918691158294678,
                "y": 0.2889942526817322,
                "z": -202.88644409179688
            },
            {
                "x": -7.9567975997924805,
                "y": 0.28013989329338074,
                "z": -202.73448181152344
            },
            {
                "x": -7.994625568389893,
                "y": 0.2713416814804077,
                "z": -202.58218383789062
            },
            {
                "x": -8.032183647155762,
                "y": 0.2626269459724426,
                "z": -202.4300079345703
            },
            {
                "x": -8.069378852844238,
                "y": 0.2539973556995392,
                "z": -202.27783203125
            },
            {
                "x": -8.106337547302246,
                "y": 0.24543702602386475,
                "z": -202.12538146972656
            },
            {
                "x": -8.142962455749512,
                "y": 0.23697304725646973,
                "z": -201.9730682373047
            },
            {
                "x": -8.179281234741211,
                "y": 0.22858600318431854,
                "z": -201.82046508789062
            },
            {
                "x": -8.215347290039062,
                "y": 0.2202943116426468,
                "z": -201.66786193847656
            },
            {
                "x": -8.250996589660645,
                "y": 0.21210667490959167,
                "z": -201.5153045654297
            },
            {
                "x": -8.286392211914062,
                "y": 0.20401182770729065,
                "z": -201.362548828125
            },
            {
                "x": -8.321425437927246,
                "y": 0.19602443277835846,
                "z": -201.20986938476562
            },
            {
                "x": -8.356135368347168,
                "y": 0.18813812732696533,
                "z": -201.05697631835938
            },
            {
                "x": -8.39059066772461,
                "y": 0.18035653233528137,
                "z": -200.90390014648438
            },
            {
                "x": -8.424606323242188,
                "y": 0.1726963073015213,
                "z": -200.75094604492188
            },
            {
                "x": -8.45837688446045,
                "y": 0.1651451289653778,
                "z": -200.5977783203125
            },
            {
                "x": -8.491737365722656,
                "y": 0.15771996974945068,
                "z": -200.4446258544922
            },
            {
                "x": -8.524764060974121,
                "y": 0.15041662752628326,
                "z": -200.29135131835938
            },
            {
                "x": -8.557493209838867,
                "y": 0.1432344764471054,
                "z": -200.13790893554688
            },
            {
                "x": -8.589781761169434,
                "y": 0.13618749380111694,
                "z": -199.98451232910156
            },
            {
                "x": -8.621792793273926,
                "y": 0.12927398085594177,
                "z": -199.83103942871094
            },
            {
                "x": -8.653382301330566,
                "y": 0.12249913066625595,
                "z": -199.67742919921875
            },
            {
                "x": -8.684645652770996,
                "y": 0.11586204916238785,
                "z": -199.52374267578125
            },
            {
                "x": -8.715551376342773,
                "y": 0.10936912894248962,
                "z": -199.37002563476562
            },
            {
                "x": -8.746042251586914,
                "y": 0.10302120447158813,
                "z": -199.2161407470703
            },
            {
                "x": -8.776212692260742,
                "y": 0.09683124721050262,
                "z": -199.06228637695312
            },
            {
                "x": -8.80594539642334,
                "y": 0.09079214930534363,
                "z": -198.90829467773438
            },
            {
                "x": -8.835350036621094,
                "y": 0.08490894734859467,
                "z": -198.7542266845703
            },
            {
                "x": -8.864343643188477,
                "y": 0.07919102907180786,
                "z": -198.60023498535156
            },
            {
                "x": -8.892958641052246,
                "y": 0.07363103330135345,
                "z": -198.44581604003906
            },
            {
                "x": -8.921212196350098,
                "y": 0.0682467669248581,
                "z": -198.29161071777344
            },
            {
                "x": -8.948999404907227,
                "y": 0.06303209066390991,
                "z": -198.1373291015625
            },
            {
                "x": -8.966769218444824,
                "y": 0.05975522845983505,
                "z": -198.03758239746094
            },
            {
                "x": -8.993969917297363,
                "y": 0.05483317747712135,
                "z": -197.88320922851562
            },
            {
                "x": -9.020721435546875,
                "y": 0.05008528381586075,
                "z": -197.72865295410156
            },
            {
                "x": -9.04716968536377,
                "y": 0.04551694914698601,
                "z": -197.57391357421875
            },
            {
                "x": -9.073104858398438,
                "y": 0.04114944115281105,
                "z": -197.41937255859375
            },
            {
                "x": -9.098681449890137,
                "y": 0.036963604390621185,
                "z": -197.2644805908203
            },
            {
                "x": -9.123880386352539,
                "y": 0.03297456353902817,
                "z": -197.10971069335938
            },
            {
                "x": -9.14858627319336,
                "y": 0.02918032929301262,
                "z": -196.95484924316406
            },
            {
                "x": -9.172995567321777,
                "y": 0.025586869567632675,
                "z": -196.79969787597656
            },
            {
                "x": -9.196889877319336,
                "y": 0.022203966975212097,
                "z": -196.64479064941406
            },
            {
                "x": -9.22039794921875,
                "y": 0.019021550193428993,
                "z": -196.48960876464844
            },
            {
                "x": -9.243535041809082,
                "y": 0.01604972407221794,
                "z": -196.33447265625
            },
            {
                "x": -9.266153335571289,
                "y": 0.01329816598445177,
                "z": -196.17929077148438
            },
            {
                "x": -9.288466453552246,
                "y": 0.010759017430245876,
                "z": -196.02377319335938
            },
            {
                "x": -9.310271263122559,
                "y": 0.008443580940365791,
                "z": -195.86849975585938
            },
            {
                "x": -9.331655502319336,
                "y": 0.006347356829792261,
                "z": -195.71307373046875
            },
            {
                "x": -9.352677345275879,
                "y": 0.004484144970774651,
                "z": -195.5575714111328
            },
            {
                "x": -9.373157501220703,
                "y": 0.0028530117124319077,
                "z": -195.40213012695312
            },
            {
                "x": -9.393315315246582,
                "y": 0.0014509069733321667,
                "z": -195.24639892578125
            },
            {
                "x": -9.413009643554688,
                "y": 0.0002845226554200053,
                "z": -195.0907745361328
            },
            {
                "x": -9.432218551635742,
                "y": -0.0006360660772770643,
                "z": -194.9350128173828
            },
            {
                "x": -9.45107364654541,
                "y": -0.0013122034724801779,
                "z": -194.77932739257812
            },
            {
                "x": -9.469407081604004,
                "y": -0.0017442945390939713,
                "z": -194.62359619140625
            },
            {
                "x": -9.487378120422363,
                "y": -0.0019295932725071907,
                "z": -194.46768188476562
            },
            {
                "x": -9.504914283752441,
                "y": -0.0019407663494348526,
                "z": -194.31173706054688
            },
            {
                "x": -9.521930694580078,
                "y": -0.0019447971135377884,
                "z": -194.15573120117188
            },
            {
                "x": -9.538614273071289,
                "y": -0.001948835328221321,
                "z": -193.9997100830078
            },
            {
                "x": -9.554783821105957,
                "y": -0.0019528623670339584,
                "z": -193.84375
            },
            {
                "x": -9.570528984069824,
                "y": -0.0019568949937820435,
                "z": -193.6875762939453
            },
            {
                "x": -9.585890769958496,
                "y": -0.00196094810962677,
                "z": -193.5313262939453
            },
            {
                "x": -9.600703239440918,
                "y": -0.0019649844616651535,
                "z": -193.37518310546875
            },
            {
                "x": -9.615178108215332,
                "y": -0.00196901336312294,
                "z": -193.2189178466797
            },
            {
                "x": -9.629165649414062,
                "y": -0.001973044127225876,
                "z": -193.06268310546875
            },
            {
                "x": -9.642667770385742,
                "y": -0.001977084204554558,
                "z": -192.9063262939453
            },
            {
                "x": -9.655831336975098,
                "y": -0.001981111243367195,
                "z": -192.74990844726562
            },
            {
                "x": -9.668457984924316,
                "y": -0.0019851531833410263,
                "z": -192.5935516357422
            },
            {
                "x": -9.680676460266113,
                "y": -0.0019891876727342606,
                "z": -192.43707275390625
            },
            {
                "x": -9.692485809326172,
                "y": -0.0019932184368371964,
                "z": -192.28065490722656
            },
            {
                "x": -9.703760147094727,
                "y": -0.0019972454756498337,
                "z": -192.12420654296875
            },
            {
                "x": -9.714695930480957,
                "y": -0.0020012930035591125,
                "z": -191.96762084960938
            },
            {
                "x": -9.725149154663086,
                "y": -0.0020053181797266006,
                "z": -191.81103515625
            },
            {
                "x": -9.735100746154785,
                "y": -0.002009360119700432,
                "z": -191.65444946289062
            },
            {
                "x": -9.744715690612793,
                "y": -0.0020133713260293007,
                "z": -191.49786376953125
            },
            {
                "x": -9.750655174255371,
                "y": -0.002016030251979828,
                "z": -191.3967742919922
            },
            {
                "x": -9.759432792663574,
                "y": -0.0020200498402118683,
                "z": -191.2401123046875
            },
            {
                "x": -9.767885208129883,
                "y": -0.002024088054895401,
                "z": -191.08335876464844
            },
            {
                "x": -9.775815963745117,
                "y": -0.002028118818998337,
                "z": -190.9266815185547
            },
            {
                "x": -9.783310890197754,
                "y": -0.002032151445746422,
                "z": -190.76991271972656
            },
            {
                "x": -9.790431022644043,
                "y": -0.002036202698945999,
                "z": -190.61312866210938
            },
            {
                "x": -9.797009468078613,
                "y": -0.002040218561887741,
                "z": -190.45645141601562
            },
            {
                "x": -9.80321979522705,
                "y": -0.002044256776571274,
                "z": -190.2996368408203
            },
            {
                "x": -9.809020042419434,
                "y": -0.002048281952738762,
                "z": -190.1427459716797
            },
            {
                "x": -9.81427001953125,
                "y": -0.0020523257553577423,
                "z": -189.98594665527344
            },
            {
                "x": -9.819192886352539,
                "y": -0.002056363970041275,
                "z": -189.82904052734375
            },
            {
                "x": -9.823647499084473,
                "y": -0.0020604152232408524,
                "z": -189.67227172851562
            },
            {
                "x": -9.827610969543457,
                "y": -0.0020644310861825943,
                "z": -189.51539611816406
            },
            {
                "x": -9.831243515014648,
                "y": -0.0020684748888015747,
                "z": -189.3583221435547
            },
            {
                "x": -9.834365844726562,
                "y": -0.002072500064969063,
                "z": -189.20156860351562
            },
            {
                "x": -9.837050437927246,
                "y": -0.0020765457302331924,
                "z": -189.04466247558594
            },
            {
                "x": -9.839399337768555,
                "y": -0.0020805764943361282,
                "z": -188.88766479492188
            },
            {
                "x": -9.84119987487793,
                "y": -0.0020846091210842133,
                "z": -188.73086547851562
            },
            {
                "x": -9.842605590820312,
                "y": -0.0020886454731225967,
                "z": -188.5738067626953
            },
            {
                "x": -9.843652725219727,
                "y": -0.0020926855504512787,
                "z": -188.4168701171875
            },
            {
                "x": -9.844162940979004,
                "y": -0.002096710726618767,
                "z": -188.26004028320312
            },
            {
                "x": -9.84428596496582,
                "y": -0.002100761979818344,
                "z": -188.10308837890625
            },
            {
                "x": -9.844015121459961,
                "y": -0.0021047815680503845,
                "z": -187.94625854492188
            },
            {
                "x": -9.843206405639648,
                "y": -0.002108803018927574,
                "z": -187.78939819335938
            },
            {
                "x": -9.842048645019531,
                "y": -0.002112865447998047,
                "z": -187.63226318359375
            },
            {
                "x": -9.840434074401855,
                "y": -0.0021168850362300873,
                "z": -187.4754638671875
            },
            {
                "x": -9.838289260864258,
                "y": -0.0021209195256233215,
                "z": -187.31854248046875
            },
            {
                "x": -9.835811614990234,
                "y": -0.0021249577403068542,
                "z": -187.16156005859375
            },
            {
                "x": -9.832853317260742,
                "y": -0.00212898850440979,
                "z": -187.00485229492188
            },
            {
                "x": -9.829367637634277,
                "y": -0.0021330267190933228,
                "z": -186.84776306152344
            },
            {
                "x": -9.825555801391602,
                "y": -0.002137070521712303,
                "z": -186.6908721923828
            },
            {
                "x": -9.821231842041016,
                "y": -0.002141473116353154,
                "z": -186.53416442871094
            },
            {
                "x": -9.816441535949707,
                "y": -0.0022936593741178513,
                "z": -186.37716674804688
            },
            {
                "x": -9.811291694641113,
                "y": -0.0026866584084928036,
                "z": -186.2203826904297
            },
            {
                "x": -9.805593490600586,
                "y": -0.003296980634331703,
                "z": -186.0635986328125
            },
            {
                "x": -9.79948902130127,
                "y": -0.004121726844459772,
                "z": -185.9066925048828
            },
            {
                "x": -9.79300594329834,
                "y": -0.005156147293746471,
                "z": -185.74998474121094
            },
            {
                "x": -9.785947799682617,
                "y": -0.006408939603716135,
                "z": -185.59320068359375
            },
            {
                "x": -9.778532028198242,
                "y": -0.007867514155805111,
                "z": -185.43641662597656
            },
            {
                "x": -9.770686149597168,
                "y": -0.009526682086288929,
                "z": -185.2798309326172
            },
            {
                "x": -9.762297630310059,
                "y": -0.011388633400201797,
                "z": -185.1229705810547
            },
            {
                "x": -9.75357723236084,
                "y": -0.013453141786158085,
                "z": -184.96629333496094
            },
            {
                "x": -9.744363784790039,
                "y": -0.015710610896348953,
                "z": -184.80979919433594
            },
            {
                "x": -9.73814582824707,
                "y": -0.017268355935811996,
                "z": -184.70864868164062
            },
            {
                "x": -9.728242874145508,
                "y": -0.019842948764562607,
                "z": -184.55203247070312
            },
            {
                "x": -9.717870712280273,
                "y": -0.022605542093515396,
                "z": -184.3955078125
            },
            {
                "x": -9.70699405670166,
                "y": -0.025553535670042038,
                "z": -184.2388916015625
            },
            {
                "x": -9.695799827575684,
                "y": -0.02867850661277771,
                "z": -184.08242797851562
            },
            {
                "x": -9.684073448181152,
                "y": -0.031985774636268616,
                "z": -183.92599487304688
            },
            {
                "x": -9.671906471252441,
                "y": -0.035472091287374496,
                "z": -183.76950073242188
            },
            {
                "x": -9.659391403198242,
                "y": -0.039125923067331314,
                "z": -183.61322021484375
            },
            {
                "x": -9.646324157714844,
                "y": -0.04295261949300766,
                "z": -183.45675659179688
            },
            {
                "x": -9.632891654968262,
                "y": -0.046947162598371506,
                "z": -183.3004150390625
            },
            {
                "x": -9.619035720825195,
                "y": -0.05110466480255127,
                "z": -183.1442108154297
            },
            {
                "x": -9.604663848876953,
                "y": -0.05542365834116936,
                "z": -182.9879608154297
            },
            {
                "x": -9.589969635009766,
                "y": -0.059897635132074356,
                "z": -182.831787109375
            },
            {
                "x": -9.5747709274292,
                "y": -0.06453128159046173,
                "z": -182.6755828857422
            },
            {
                "x": -9.559124946594238,
                "y": -0.0693168193101883,
                "z": -182.5194854736328
            },
            {
                "x": -9.543145179748535,
                "y": -0.07424670457839966,
                "z": -182.36349487304688
            },
            {
                "x": -9.526638984680176,
                "y": -0.07932423055171967,
                "z": -182.2074737548828
            },
            {
                "x": -9.50975513458252,
                "y": -0.0845455676317215,
                "z": -182.05148315429688
            },
            {
                "x": -9.492467880249023,
                "y": -0.0899079293012619,
                "z": -181.89561462402344
            },
            {
                "x": -9.47467041015625,
                "y": -0.09540840983390808,
                "z": -181.73971557617188
            },
            {
                "x": -9.456554412841797,
                "y": -0.10103806853294373,
                "z": -181.5839080810547
            },
            {
                "x": -9.437980651855469,
                "y": -0.10679470002651215,
                "z": -181.42832946777344
            },
            {
                "x": -9.418936729431152,
                "y": -0.11268815398216248,
                "z": -181.27259826660156
            },
            {
                "x": -9.399574279785156,
                "y": -0.1187010407447815,
                "z": -181.1170196533203
            },
            {
                "x": -9.37968921661377,
                "y": -0.124840646982193,
                "z": -180.9613494873047
            },
            {
                "x": -9.35944652557373,
                "y": -0.13109731674194336,
                "z": -180.8057861328125
            },
            {
                "x": -9.338814735412598,
                "y": -0.13746678829193115,
                "z": -180.650390625
            },
            {
                "x": -9.317689895629883,
                "y": -0.14395204186439514,
                "z": -180.4949951171875
            },
            {
                "x": -9.296255111694336,
                "y": -0.1505441516637802,
                "z": -180.33963012695312
            },
            {
                "x": -9.274337768554688,
                "y": -0.1572466641664505,
                "z": -180.1842803955078
            },
            {
                "x": -9.252013206481934,
                "y": -0.1640532910823822,
                "z": -180.02902221679688
            },
            {
                "x": -9.229362487792969,
                "y": -0.17095543444156647,
                "z": -179.87391662597656
            },
            {
                "x": -9.206208229064941,
                "y": -0.17795820534229279,
                "z": -179.7187957763672
            },
            {
                "x": -9.182732582092285,
                "y": -0.1850542426109314,
                "z": -179.563720703125
            },
            {
                "x": -9.158835411071777,
                "y": -0.19224269688129425,
                "z": -179.40875244140625
            },
            {
                "x": -9.134483337402344,
                "y": -0.19952332973480225,
                "z": -179.25376892089844
            },
            {
                "x": -9.109843254089355,
                "y": -0.20688249170780182,
                "z": -179.09893798828125
            },
            {
                "x": -9.08474063873291,
                "y": -0.21432486176490784,
                "z": -178.94418334960938
            },
            {
                "x": -9.059255599975586,
                "y": -0.22185032069683075,
                "z": -178.78944396972656
            },
            {
                "x": -9.03343391418457,
                "y": -0.22944611310958862,
                "z": -178.63485717773438
            },
            {
                "x": -9.007122039794922,
                "y": -0.2371261715888977,
                "z": -178.48013305664062
            },
            {
                "x": -8.980541229248047,
                "y": -0.24486713111400604,
                "z": -178.3256072998047
            },
            {
                "x": -8.953531265258789,
                "y": -0.2526725232601166,
                "z": -178.17129516601562
            },
            {
                "x": -8.935853958129883,
                "y": -0.25775212049484253,
                "z": -178.07154846191406
            },
            {
                "x": -8.908272743225098,
                "y": -0.2656635642051697,
                "z": -177.91722106933594
            },
            {
                "x": -8.880242347717285,
                "y": -0.2736370265483856,
                "z": -177.76295471191406
            },
            {
                "x": -8.851827621459961,
                "y": -0.28167253732681274,
                "z": -177.60865783691406
            },
            {
                "x": -8.823131561279297,
                "y": -0.2897489070892334,
                "z": -177.45460510253906
            },
            {
                "x": -8.793966293334961,
                "y": -0.29788267612457275,
                "z": -177.30052185058594
            },
            {
                "x": -8.764508247375488,
                "y": -0.30606260895729065,
                "z": -177.146484375
            },
            {
                "x": -8.734678268432617,
                "y": -0.31428009271621704,
                "z": -176.99266052246094
            },
            {
                "x": -8.704415321350098,
                "y": -0.3225541114807129,
                "z": -176.838623046875
            },
            {
                "x": -8.673909187316895,
                "y": -0.3308514654636383,
                "z": -176.68490600585938
            },
            {
                "x": -8.642951965332031,
                "y": -0.3391874134540558,
                "z": -176.53118896484375
            },
            {
                "x": -8.611690521240234,
                "y": -0.34755808115005493,
                "z": -176.37747192382812
            },
            {
                "x": -8.58010482788086,
                "y": -0.3559478521347046,
                "z": -176.22401428222656
            },
            {
                "x": -8.548077583312988,
                "y": -0.3643803596496582,
                "z": -176.07032775878906
            },
            {
                "x": -8.51581859588623,
                "y": -0.3728216588497162,
                "z": -175.91693115234375
            },
            {
                "x": -8.483150482177734,
                "y": -0.38128042221069336,
                "z": -175.763671875
            },
            {
                "x": -8.450140953063965,
                "y": -0.38976746797561646,
                "z": -175.61024475097656
            },
            {
                "x": -8.41685962677002,
                "y": -0.3982556164264679,
                "z": -175.4571075439453
            },
            {
                "x": -8.383158683776855,
                "y": -0.4067637026309967,
                "z": -175.3038787841797
            },
            {
                "x": -8.349196434020996,
                "y": -0.4152776300907135,
                "z": -175.1507568359375
            },
            {
                "x": -8.3148775100708,
                "y": -0.42378824949264526,
                "z": -174.99781799316406
            },
            {
                "x": -8.280261039733887,
                "y": -0.4323038160800934,
                "z": -174.84487915039062
            },
            {
                "x": -8.245349884033203,
                "y": -0.44081270694732666,
                "z": -174.69210815429688
            },
            {
                "x": -8.210049629211426,
                "y": -0.4493197500705719,
                "z": -174.53933715820312
            },
            {
                "x": -8.17446231842041,
                "y": -0.45782899856567383,
                "z": -174.38648986816406
            },
            {
                "x": -8.138567924499512,
                "y": -0.4663131833076477,
                "z": -174.2339324951172
            },
            {
                "x": -8.1023588180542,
                "y": -0.47479185461997986,
                "z": -174.0812530517578
            },
            {
                "x": -8.065873146057129,
                "y": -0.4832474887371063,
                "z": -173.9287872314453
            },
            {
                "x": -8.029037475585938,
                "y": -0.4916831851005554,
                "z": -173.7763671875
            },
            {
                "x": -7.991922378540039,
                "y": -0.5001060366630554,
                "z": -173.62379455566406
            },
            {
                "x": -7.954526901245117,
                "y": -0.508488655090332,
                "z": -173.47158813476562
            },
            {
                "x": -7.916833400726318,
                "y": -0.516845703125,
                "z": -173.31935119628906
            },
            {
                "x": -7.878857135772705,
                "y": -0.5251718759536743,
                "z": -173.1671142578125
            },
            {
                "x": -7.8405609130859375,
                "y": -0.5334603786468506,
                "z": -173.01502990722656
            },
            {
                "x": -7.802031517028809,
                "y": -0.5417144298553467,
                "z": -172.86289978027344
            },
            {
                "x": -7.763180255889893,
                "y": -0.5499209761619568,
                "z": -172.7109375
            },
            {
                "x": -7.72407865524292,
                "y": -0.5580837726593018,
                "z": -172.55899047851562
            },
            {
                "x": -7.68471622467041,
                "y": -0.5661991834640503,
                "z": -172.40711975097656
            },
            {
                "x": -7.645056247711182,
                "y": -0.5742615461349487,
                "z": -172.25538635253906
            },
            {
                "x": -7.605177879333496,
                "y": -0.5822679996490479,
                "z": -172.1036376953125
            },
            {
                "x": -7.5649566650390625,
                "y": -0.5902249813079834,
                "z": -171.95187377929688
            },
            {
                "x": -7.52453088760376,
                "y": -0.5981149673461914,
                "z": -171.80027770996094
            },
            {
                "x": -7.483879089355469,
                "y": -0.6059388518333435,
                "z": -171.6488037109375
            },
            {
                "x": -7.457452774047852,
                "y": -0.6109561920166016,
                "z": -171.55099487304688
            },
            {
                "x": -7.416376113891602,
                "y": -0.6186700463294983,
                "z": -171.39956665039062
            },
            {
                "x": -7.3750433921813965,
                "y": -0.6263144016265869,
                "z": -171.24815368652344
            },
            {
                "x": -7.333427906036377,
                "y": -0.6338858604431152,
                "z": -171.09677124023438
            },
            {
                "x": -7.291654109954834,
                "y": -0.641370415687561,
                "z": -170.94557189941406
            },
            {
                "x": -7.249565601348877,
                "y": -0.6487807631492615,
                "z": -170.79428100585938
            },
            {
                "x": -7.207312107086182,
                "y": -0.6561042070388794,
                "z": -170.6431884765625
            },
            {
                "x": -7.164829254150391,
                "y": -0.6633355617523193,
                "z": -170.49215698242188
            },
            {
                "x": -7.122049331665039,
                "y": -0.6704860925674438,
                "z": -170.34097290039062
            },
            {
                "x": -7.0791473388671875,
                "y": -0.6775335073471069,
                "z": -170.1900177001953
            },
            {
                "x": -7.035967826843262,
                "y": -0.6844879388809204,
                "z": -170.03909301757812
            },
            {
                "x": -6.992609024047852,
                "y": -0.6913421750068665,
                "z": -169.88818359375
            },
            {
                "x": -6.949044227600098,
                "y": -0.6980867385864258,
                "z": -169.73744201660156
            },
            {
                "x": -6.9052042961120605,
                "y": -0.7047366499900818,
                "z": -169.58648681640625
            },
            {
                "x": -6.861267566680908,
                "y": -0.7112671136856079,
                "z": -169.4358367919922
            },
            {
                "x": -6.817082405090332,
                "y": -0.7176859378814697,
                "z": -169.2852020263672
            },
            {
                "x": -6.772712707519531,
                "y": -0.723990797996521,
                "z": -169.134521484375
            },
            {
                "x": -6.7281670570373535,
                "y": -0.730171799659729,
                "z": -168.98399353027344
            },
            {
                "x": -6.683406352996826,
                "y": -0.7362384796142578,
                "z": -168.83340454101562
            },
            {
                "x": -6.638494968414307,
                "y": -0.7421764135360718,
                "z": -168.68289184570312
            },
            {
                "x": -6.5933918952941895,
                "y": -0.7479801177978516,
                "z": -168.53248596191406
            },
            {
                "x": -6.548162937164307,
                "y": -0.7536530494689941,
                "z": -168.38214111328125
            },
            {
                "x": -6.502729892730713,
                "y": -0.7591925859451294,
                "z": -168.23184204101562
            },
            {
                "x": -6.457149028778076,
                "y": -0.7645953893661499,
                "z": -168.08152770996094
            },
            {
                "x": -6.41135835647583,
                "y": -0.7698574662208557,
                "z": -167.93113708496094
            },
            {
                "x": -6.365436553955078,
                "y": -0.774971604347229,
                "z": -167.78091430664062
            },
            {
                "x": -6.319392681121826,
                "y": -0.7799397706985474,
                "z": -167.63075256347656
            },
            {
                "x": -6.2731733322143555,
                "y": -0.7847582697868347,
                "z": -167.48057556152344
            },
            {
                "x": -6.226830005645752,
                "y": -0.7894169092178345,
                "z": -167.33047485351562
            },
            {
                "x": -6.180296897888184,
                "y": -0.7939239740371704,
                "z": -167.1802978515625
            },
            {
                "x": -6.133685111999512,
                "y": -0.7982674837112427,
                "z": -167.03025817871094
            },
            {
                "x": -6.0869550704956055,
                "y": -0.8024489879608154,
                "z": -166.88027954101562
            },
            {
                "x": -6.040037155151367,
                "y": -0.8064597845077515,
                "z": -166.730224609375
            },
            {
                "x": -5.99305534362793,
                "y": -0.810300350189209,
                "z": -166.58030700683594
            },
            {
                "x": -5.945913314819336,
                "y": -0.8139709234237671,
                "z": -166.43031311035156
            },
            {
                "x": -5.898660182952881,
                "y": -0.8174670338630676,
                "z": -166.2803955078125
            },
            {
                "x": -5.8513264656066895,
                "y": -0.8207744359970093,
                "z": -166.13055419921875
            },
            {
                "x": -5.8038482666015625,
                "y": -0.8239030838012695,
                "z": -165.98065185546875
            },
            {
                "x": -5.756317615509033,
                "y": -0.8268454670906067,
                "z": -165.8308868408203
            },
            {
                "x": -5.708676338195801,
                "y": -0.8296010494232178,
                "z": -165.68112182617188
            },
            {
                "x": -5.6608991622924805,
                "y": -0.8321600556373596,
                "z": -165.5312042236328
            },
            {
                "x": -5.613096714019775,
                "y": -0.834521472454071,
                "z": -165.3815155029297
            },
            {
                "x": -5.565183639526367,
                "y": -0.8366867303848267,
                "z": -165.23179626464844
            },
            {
                "x": -5.534217834472656,
                "y": -0.8379783034324646,
                "z": -165.13511657714844
            },
            {
                "x": -5.4861907958984375,
                "y": -0.8398056030273438,
                "z": -164.98548889160156
            },
            {
                "x": -5.43806266784668,
                "y": -0.8414294123649597,
                "z": -164.8357391357422
            },
            {
                "x": -5.389878749847412,
                "y": -0.8428440690040588,
                "z": -164.68603515625
            },
            {
                "x": -5.341646194458008,
                "y": -0.8440393209457397,
                "z": -164.53640747070312
            },
            {
                "x": -5.293343544006348,
                "y": -0.845018208026886,
                "z": -164.38673400878906
            },
            {
                "x": -5.244998455047607,
                "y": -0.8457783460617065,
                "z": -164.2371368408203
            },
            {
                "x": -5.196615695953369,
                "y": -0.8463175296783447,
                "z": -164.08755493164062
            },
            {
                "x": -5.14812707901001,
                "y": -0.8466264009475708,
                "z": -163.93783569335938
            },
            {
                "x": -5.099648475646973,
                "y": -0.8467034697532654,
                "z": -163.78823852539062
            },
            {
                "x": -5.051128387451172,
                "y": -0.8465521335601807,
                "z": -163.638671875
            },
            {
                "x": -5.00257682800293,
                "y": -0.8461753129959106,
                "z": -163.4890899658203
            },
            {
                "x": -4.9540019035339355,
                "y": -0.8455678224563599,
                "z": -163.33953857421875
            },
            {
                "x": -4.90535306930542,
                "y": -0.8447363376617432,
                "z": -163.1898193359375
            },
            {
                "x": -4.8567633628845215,
                "y": -0.84368896484375,
                "z": -163.04031372070312
            },
            {
                "x": -4.8081488609313965,
                "y": -0.8424285650253296,
                "z": -162.8907928466797
            },
            {
                "x": -4.759482383728027,
                "y": -0.8409504890441895,
                "z": -162.74119567871094
            },
            {
                "x": -4.7108659744262695,
                "y": -0.8392618894577026,
                "z": -162.5916748046875
            },
            {
                "x": -4.662205219268799,
                "y": -0.8373680114746094,
                "z": -162.44207763671875
            },
            {
                "x": -4.6135478019714355,
                "y": -0.835273265838623,
                "z": -162.29248046875
            },
            {
                "x": -4.5649333000183105,
                "y": -0.8329768180847168,
                "z": -162.1429443359375
            },
            {
                "x": -4.5163493156433105,
                "y": -0.8304813504219055,
                "z": -161.99343872070312
            },
            {
                "x": -4.467776298522949,
                "y": -0.8277941346168518,
                "z": -161.84390258789062
            },
            {
                "x": -4.419220924377441,
                "y": -0.8249191045761108,
                "z": -161.69436645507812
            },
            {
                "x": -4.370631694793701,
                "y": -0.8218501806259155,
                "z": -161.54464721679688
            },
            {
                "x": -4.322137355804443,
                "y": -0.8185979723930359,
                "z": -161.3950653076172
            },
            {
                "x": -4.273666858673096,
                "y": -0.815166711807251,
                "z": -161.24546813964844
            },
            {
                "x": -4.225229740142822,
                "y": -0.8115588426589966,
                "z": -161.09580993652344
            },
            {
                "x": -4.176875114440918,
                "y": -0.807776689529419,
                "z": -160.94622802734375
            },
            {
                "x": -4.128484725952148,
                "y": -0.8038144111633301,
                "z": -160.7964324951172
            },
            {
                "x": -4.080231666564941,
                "y": -0.7996907234191895,
                "z": -160.6467742919922
            },
            {
                "x": -4.032032489776611,
                "y": -0.7954046726226807,
                "z": -160.4971466064453
            },
            {
                "x": -3.983853578567505,
                "y": -0.7909513711929321,
                "z": -160.34735107421875
            },
            {
                "x": -3.935791492462158,
                "y": -0.786340594291687,
                "z": -160.19766235351562
            },
            {
                "x": -3.88775897026062,
                "y": -0.7815727591514587,
                "z": -160.0478515625
            },
            {
                "x": -3.839829444885254,
                "y": -0.7766550183296204,
                "z": -159.8980255126953
            },
            {
                "x": -3.791996717453003,
                "y": -0.7715901136398315,
                "z": -159.74830627441406
            },
            {
                "x": -3.7442374229431152,
                "y": -0.7663727402687073,
                "z": -159.598388671875
            },
            {
                "x": -3.6966071128845215,
                "y": -0.7610182762145996,
                "z": -159.4486083984375
            },
            {
                "x": -3.6490490436553955,
                "y": -0.755524754524231,
                "z": -159.2987518310547
            },
            {
                "x": -3.601555347442627,
                "y": -0.7498878240585327,
                "z": -159.14871215820312
            },
            {
                "x": -3.5542056560516357,
                "y": -0.7441223859786987,
                "z": -158.99880981445312
            },
            {
                "x": -3.5069854259490967,
                "y": -0.7382270097732544,
                "z": -158.848876953125
            },
            {
                "x": -3.476547956466675,
                "y": -0.7343558073043823,
                "z": -158.75201416015625
            },
            {
                "x": -3.429495334625244,
                "y": -0.7282524108886719,
                "z": -158.60203552246094
            },
            {
                "x": -3.382567882537842,
                "y": -0.7220243215560913,
                "z": -158.45191955566406
            },
            {
                "x": -3.335736036300659,
                "y": -0.7156793475151062,
                "z": -158.3017578125
            },
            {
                "x": -3.2890915870666504,
                "y": -0.7092236280441284,
                "z": -158.15164184570312
            },
            {
                "x": -3.2425570487976074,
                "y": -0.7026490569114685,
                "z": -158.0014190673828
            },
            {
                "x": -3.1961681842803955,
                "y": -0.695968508720398,
                "z": -157.85121154785156
            },
            {
                "x": -3.1499595642089844,
                "y": -0.6891855001449585,
                "z": -157.70098876953125
            },
            {
                "x": -3.1038079261779785,
                "y": -0.6822913885116577,
                "z": -157.55056762695312
            },
            {
                "x": -3.05789852142334,
                "y": -0.6753019094467163,
                "z": -157.4001922607422
            },
            {
                "x": -3.012122631072998,
                "y": -0.6682159304618835,
                "z": -157.2498016357422
            },
            {
                "x": -2.966505289077759,
                "y": -0.6610363125801086,
                "z": -157.0993194580078
            },
            {
                "x": -2.9210894107818604,
                "y": -0.6537717580795288,
                "z": -156.94886779785156
            },
            {
                "x": -2.8757617473602295,
                "y": -0.6464065909385681,
                "z": -156.79815673828125
            },
            {
                "x": -2.830706834793091,
                "y": -0.6389683485031128,
                "z": -156.64761352539062
            },
            {
                "x": -2.7858033180236816,
                "y": -0.6314501762390137,
                "z": -156.49700927734375
            },
            {
                "x": -2.7410671710968018,
                "y": -0.6238480806350708,
                "z": -156.34619140625
            },
            {
                "x": -2.696568489074707,
                "y": -0.6161782145500183,
                "z": -156.19552612304688
            },
            {
                "x": -2.6522133350372314,
                "y": -0.6084288358688354,
                "z": -156.0446014404297
            },
            {
                "x": -2.608098268508911,
                "y": -0.6006141901016235,
                "z": -155.8936767578125
            },
            {
                "x": -2.564164638519287,
                "y": -0.5927385091781616,
                "z": -155.74278259277344
            },
            {
                "x": -2.5204875469207764,
                "y": -0.5847991704940796,
                "z": -155.591796875
            },
            {
                "x": -2.4769959449768066,
                "y": -0.5768017768859863,
                "z": -155.44078063964844
            },
            {
                "x": -2.4337310791015625,
                "y": -0.5687482357025146,
                "z": -155.28968811035156
            },
            {
                "x": -2.3906490802764893,
                "y": -0.5606343746185303,
                "z": -155.13836669921875
            },
            {
                "x": -2.3478119373321533,
                "y": -0.5524780750274658,
                "z": -154.98715209960938
            },
            {
                "x": -2.305246353149414,
                "y": -0.544273853302002,
                "z": -154.83583068847656
            },
            {
                "x": -2.262874126434326,
                "y": -0.5360265374183655,
                "z": -154.6844482421875
            },
            {
                "x": -2.220778465270996,
                "y": -0.5277397632598877,
                "z": -154.5330047607422
            },
            {
                "x": -2.1788711547851562,
                "y": -0.5194082856178284,
                "z": -154.38137817382812
            },
            {
                "x": -2.137256622314453,
                "y": -0.5110488533973694,
                "z": -154.2297821044922
            },
            {
                "x": -2.095928430557251,
                "y": -0.5026611089706421,
                "z": -154.07815551757812
            },
            {
                "x": -2.0547828674316406,
                "y": -0.4942398965358734,
                "z": -153.9263916015625
            },
            {
                "x": -2.01397705078125,
                "y": -0.48579835891723633,
                "z": -153.77459716796875
            },
            {
                "x": -1.973386287689209,
                "y": -0.4773310422897339,
                "z": -153.62269592285156
            },
            {
                "x": -1.9330753087997437,
                "y": -0.46884316205978394,
                "z": -153.4706573486328
            },
            {
                "x": -1.8930819034576416,
                "y": -0.46034711599349976,
                "z": -153.3186798095703
            },
            {
                "x": -1.85329270362854,
                "y": -0.45183178782463074,
                "z": -153.16651916503906
            },
            {
                "x": -1.8138833045959473,
                "y": -0.44331300258636475,
                "z": -153.01438903808594
            },
            {
                "x": -1.774704098701477,
                "y": -0.4347885847091675,
                "z": -152.8621826171875
            },
            {
                "x": -1.7358037233352661,
                "y": -0.42624765634536743,
                "z": -152.70965576171875
            },
            {
                "x": -1.6972459554672241,
                "y": -0.4177221357822418,
                "z": -152.55734252929688
            },
            {
                "x": -1.658970832824707,
                "y": -0.4091944694519043,
                "z": -152.4048614501953
            },
            {
                "x": -1.634448528289795,
                "y": -0.4036903381347656,
                "z": -152.30633544921875
            },
            {
                "x": -1.5966823101043701,
                "y": -0.39517825841903687,
                "z": -152.15380859375
            },
            {
                "x": -1.5592284202575684,
                "y": -0.3866681456565857,
                "z": -152.00100708007812
            },
            {
                "x": -1.5221071243286133,
                "y": -0.3781757652759552,
                "z": -151.8481903076172
            },
            {
                "x": -1.4852790832519531,
                "y": -0.3697033226490021,
                "z": -151.6953582763672
            },
            {
                "x": -1.4488203525543213,
                "y": -0.36124688386917114,
                "z": -151.54237365722656
            },
            {
                "x": -1.4126503467559814,
                "y": -0.3528195023536682,
                "z": -151.389404296875
            },
            {
                "x": -1.3768624067306519,
                "y": -0.3444172143936157,
                "z": -151.236328125
            },
            {
                "x": -1.3413554430007935,
                "y": -0.3360372483730316,
                "z": -151.0830535888672
            },
            {
                "x": -1.306203842163086,
                "y": -0.3276951313018799,
                "z": -150.9297637939453
            },
            {
                "x": -1.2714614868164062,
                "y": -0.3193907141685486,
                "z": -150.77642822265625
            },
            {
                "x": -1.236993432044983,
                "y": -0.3111233115196228,
                "z": -150.6229705810547
            },
            {
                "x": -1.2029573917388916,
                "y": -0.3028997778892517,
                "z": -150.46946716308594
            },
            {
                "x": -1.1691932678222656,
                "y": -0.2947126626968384,
                "z": -150.3157501220703
            },
            {
                "x": -1.1358425617218018,
                "y": -0.28658097982406616,
                "z": -150.16204833984375
            },
            {
                "x": -1.1028937101364136,
                "y": -0.2785055637359619,
                "z": -150.0083770751953
            },
            {
                "x": -1.0702210664749146,
                "y": -0.27047407627105713,
                "z": -149.8544464111328
            },
            {
                "x": -1.038021206855774,
                "y": -0.2625056803226471,
                "z": -149.7005157470703
            },
            {
                "x": -1.0061242580413818,
                "y": -0.2545958459377289,
                "z": -149.5465087890625
            },
            {
                "x": -0.9746366739273071,
                "y": -0.24674628674983978,
                "z": -149.39230346679688
            },
            {
                "x": -0.9435622692108154,
                "y": -0.23897123336791992,
                "z": -149.23818969726562
            },
            {
                "x": -0.9128254652023315,
                "y": -0.23126119375228882,
                "z": -149.08395385742188
            },
            {
                "x": -0.8825632929801941,
                "y": -0.2236267626285553,
                "z": -148.9296417236328
            },
            {
                "x": -0.8526275157928467,
                "y": -0.2160693109035492,
                "z": -148.7752685546875
            },
            {
                "x": -0.823103666305542,
                "y": -0.20857782661914825,
                "z": -148.6205596923828
            },
            {
                "x": -0.7940051555633545,
                "y": -0.20118051767349243,
                "z": -148.46604919433594
            },
            {
                "x": -0.7652732133865356,
                "y": -0.19386139512062073,
                "z": -148.31134033203125
            },
            {
                "x": -0.7370350360870361,
                "y": -0.18663528561592102,
                "z": -148.1565704345703
            },
            {
                "x": -0.7091280221939087,
                "y": -0.17950016260147095,
                "z": -148.00177001953125
            },
            {
                "x": -0.6816727519035339,
                "y": -0.17244838178157806,
                "z": -147.84664916992188
            },
            {
                "x": -0.6546324491500854,
                "y": -0.16550585627555847,
                "z": -147.69174194335938
            },
            {
                "x": -0.6280190348625183,
                "y": -0.15866169333457947,
                "z": -147.53668212890625
            },
            {
                "x": -0.6018669605255127,
                "y": -0.15191875398159027,
                "z": -147.3814697265625
            },
            {
                "x": -0.5760729312896729,
                "y": -0.14528238773345947,
                "z": -147.22625732421875
            },
            {
                "x": -0.5507937669754028,
                "y": -0.13875210285186768,
                "z": -147.0708465576172
            },
            {
                "x": -0.5259009599685669,
                "y": -0.13233987987041473,
                "z": -146.9154510498047
            },
            {
                "x": -0.5014703869819641,
                "y": -0.126041442155838,
                "z": -146.7599639892578
            },
            {
                "x": -0.477501779794693,
                "y": -0.11986027657985687,
                "z": -146.6044158935547
            },
            {
                "x": -0.4539145529270172,
                "y": -0.11380071938037872,
                "z": -146.44883728027344
            },
            {
                "x": -0.4308893382549286,
                "y": -0.10787052661180496,
                "z": -146.2931365966797
            },
            {
                "x": -0.40820419788360596,
                "y": -0.1020611971616745,
                "z": -146.13726806640625
            },
            {
                "x": -0.3860347270965576,
                "y": -0.09638560563325882,
                "z": -145.98146057128906
            },
            {
                "x": -0.3643442988395691,
                "y": -0.09084554761648178,
                "z": -145.82562255859375
            },
            {
                "x": -0.35053205490112305,
                "y": -0.0873425304889679,
                "z": -145.7248992919922
            },
            {
                "x": -0.3296017348766327,
                "y": -0.08202792704105377,
                "z": -145.56887817382812
            },
            {
                "x": -0.3090991675853729,
                "y": -0.07685307413339615,
                "z": -145.4127960205078
            },
            {
                "x": -0.2890402674674988,
                "y": -0.0718240737915039,
                "z": -145.2565460205078
            },
            {
                "x": -0.26955336332321167,
                "y": -0.06694822013378143,
                "z": -145.10037231445312
            },
            {
                "x": -0.25042423605918884,
                "y": -0.06221766397356987,
                "z": -144.944091796875
            },
            {
                "x": -0.2318553775548935,
                "y": -0.05764085054397583,
                "z": -144.78770446777344
            },
            {
                "x": -0.2137509435415268,
                "y": -0.053227927535772324,
                "z": -144.63140869140625
            },
            {
                "x": -0.19607281684875488,
                "y": -0.048966627568006516,
                "z": -144.47476196289062
            },
            {
                "x": -0.17897705733776093,
                "y": -0.04487351328134537,
                "z": -144.3182830810547
            },
            {
                "x": -0.1622510850429535,
                "y": -0.04094245284795761,
                "z": -144.16168212890625
            },
            {
                "x": -0.1461111158132553,
                "y": -0.03718329966068268,
                "z": -144.00498962402344
            },
            {
                "x": -0.1304408758878708,
                "y": -0.033600155264139175,
                "z": -143.84840393066406
            },
            {
                "x": -0.11519941687583923,
                "y": -0.03018305078148842,
                "z": -143.6914520263672
            },
            {
                "x": -0.10055869072675705,
                "y": -0.026947952806949615,
                "z": -143.5347137451172
            },
            {
                "x": -0.08631446212530136,
                "y": -0.023897062987089157,
                "z": -143.37794494628906
            },
            {
                "x": -0.07264045625925064,
                "y": -0.02102789841592312,
                "z": -143.22091674804688
            },
            {
                "x": -0.05945419520139694,
                "y": -0.018347369506955147,
                "z": -143.0640869140625
            },
            {
                "x": -0.04670652002096176,
                "y": -0.015850797295570374,
                "z": -142.90699768066406
            },
            {
                "x": -0.034577593207359314,
                "y": -0.013551880605518818,
                "z": -142.74989318847656
            },
            {
                "x": -0.022854983806610107,
                "y": -0.011451584286987782,
                "z": -142.59292602539062
            },
            {
                "x": -0.011704757809638977,
                "y": -0.009546808898448944,
                "z": -142.43580627441406
            },
            {
                "x": -0.0010540038347244263,
                "y": -0.0078421700745821,
                "z": -142.27874755859375
            },
            {
                "x": 0.009146198630332947,
                "y": -0.006344125140458345,
                "z": -142.12156677246094
            },
            {
                "x": 0.01873120665550232,
                "y": -0.005054542329162359,
                "z": -141.9641876220703
            },
            {
                "x": 0.027898743748664856,
                "y": -0.003974518738687038,
                "z": -141.80703735351562
            },
            {
                "x": 0.036508992314338684,
                "y": -0.0031044117640703917,
                "z": -141.6497039794922
            },
            {
                "x": 0.04456968605518341,
                "y": -0.0024538233410567045,
                "z": -141.49241638183594
            },
            {
                "x": 0.0521976500749588,
                "y": -0.0020247173961251974,
                "z": -141.33511352539062
            },
            {
                "x": 0.05920775234699249,
                "y": -0.0018214329611510038,
                "z": -141.17755126953125
            },
            {
                "x": 0.06578059494495392,
                "y": -0.0018135132268071175,
                "z": -141.02029418945312
            },
            {
                "x": 0.07181036472320557,
                "y": -0.0018212581053376198,
                "z": -140.86285400390625
            },
            {
                "x": 0.0772494226694107,
                "y": -0.001829004380851984,
                "z": -140.70541381835938
            },
            {
                "x": 0.08228157460689545,
                "y": -0.0018367515876889229,
                "z": -140.54803466796875
            },
            {
                "x": 0.08669520914554596,
                "y": -0.001844500657171011,
                "z": -140.39047241210938
            },
            {
                "x": 0.09062807261943817,
                "y": -0.0018522501923143864,
                "z": -140.2330322265625
            },
            {
                "x": 0.09406262636184692,
                "y": -0.0018599983304738998,
                "z": -140.07553100585938
            },
            {
                "x": 0.09689505398273468,
                "y": -0.0018677455373108387,
                "z": -139.9180145263672
            },
            {
                "x": 0.09932780265808105,
                "y": -0.0018754899501800537,
                "z": -139.76060485839844
            },
            {
                "x": 0.10119572281837463,
                "y": -0.0018832432106137276,
                "z": -139.6031036376953
            },
            {
                "x": 0.10260513424873352,
                "y": -0.0018909918144345284,
                "z": -139.4455108642578
            },
            {
                "x": 0.10363712906837463,
                "y": -0.0018987399525940418,
                "z": -139.28807067871094
            },
            {
                "x": 0.10423046350479126,
                "y": -0.0019071034621447325,
                "z": -139.1306915283203
            },
            {
                "x": 0.10452234745025635,
                "y": -0.00191153259947896,
                "z": -139.02906799316406
            },
            {
                "x": 0.10475169122219086,
                "y": -0.00191927095875144,
                "z": -138.8717498779297
            },
            {
                "x": 0.10477009415626526,
                "y": -0.0019270237535238266,
                "z": -138.71434020996094
            },
            {
                "x": 0.10473191738128662,
                "y": -0.0019347714260220528,
                "z": -138.55697631835938
            },
            {
                "x": 0.10460439324378967,
                "y": -0.001942517701536417,
                "z": -138.3997039794922
            },
            {
                "x": 0.10444074869155884,
                "y": -0.0019502644427120686,
                "z": -138.2423858642578
            },
            {
                "x": 0.10426943004131317,
                "y": -0.001958012580871582,
                "z": -138.0851287841797
            },
            {
                "x": 0.1040811538696289,
                "y": -0.001965759787708521,
                "z": -137.9279022216797
            },
            {
                "x": 0.10389024019241333,
                "y": -0.001973513513803482,
                "z": -137.7704620361328
            },
            {
                "x": 0.10369637608528137,
                "y": -0.0019812569953501225,
                "z": -137.6132354736328
            },
            {
                "x": 0.10349944233894348,
                "y": -0.001989006996154785,
                "z": -137.45594787597656
            },
            {
                "x": 0.10330113768577576,
                "y": -0.0019967537373304367,
                "z": -137.2986602783203
            },
            {
                "x": 0.10310055315494537,
                "y": -0.002004501409828663,
                "z": -137.1414337158203
            },
            {
                "x": 0.10289788246154785,
                "y": -0.0020122523419559,
                "z": -136.98399353027344
            },
            {
                "x": 0.10269378125667572,
                "y": -0.002019999548792839,
                "z": -136.82676696777344
            },
            {
                "x": 0.10248735547065735,
                "y": -0.002027742099016905,
                "z": -136.66954040527344
            },
            {
                "x": 0.10227927565574646,
                "y": -0.0020354934968054295,
                "z": -136.51219177246094
            },
            {
                "x": 0.1020691841840744,
                "y": -0.002043238840997219,
                "z": -136.35496520996094
            },
            {
                "x": 0.10185708105564117,
                "y": -0.002050990704447031,
                "z": -136.19761657714844
            },
            {
                "x": 0.10164330899715424,
                "y": -0.0020587402395904064,
                "z": -136.04029846191406
            },
            {
                "x": 0.10142722725868225,
                "y": -0.0020664860494434834,
                "z": -135.88307189941406
            },
            {
                "x": 0.10120971500873566,
                "y": -0.002074228134006262,
                "z": -135.72584533691406
            },
            {
                "x": 0.10099002718925476,
                "y": -0.0020819762721657753,
                "z": -135.56858825683594
            },
            {
                "x": 0.10076834261417389,
                "y": -0.0020897206850349903,
                "z": -135.41136169433594
            },
            {
                "x": 0.1005447506904602,
                "y": -0.0020974758081138134,
                "z": -135.2539520263672
            },
            {
                "x": 0.100319042801857,
                "y": -0.002105219289660454,
                "z": -135.0967254638672
            },
            {
                "x": 0.10009175539016724,
                "y": -0.0021129678934812546,
                "z": -134.93942260742188
            },
            {
                "x": 0.09986229240894318,
                "y": -0.0021207151003181934,
                "z": -134.78213500976562
            },
            {
                "x": 0.09963089227676392,
                "y": -0.002128459047526121,
                "z": -134.62490844726562
            },
            {
                "x": 0.09939748048782349,
                "y": -0.0021362141706049442,
                "z": -134.4674530029297
            },
            {
                "x": 0.09916205704212189,
                "y": -0.0021439609117805958,
                "z": -134.3102569580078
            },
            {
                "x": 0.09892509877681732,
                "y": -0.002151704393327236,
                "z": -134.15301513671875
            },
            {
                "x": 0.09868563711643219,
                "y": -0.002159454859793186,
                "z": -133.99566650390625
            },
            {
                "x": 0.09844447672367096,
                "y": -0.0021672029979526997,
                "z": -133.8384246826172
            },
            {
                "x": 0.09820137917995453,
                "y": -0.0021749529987573624,
                "z": -133.68109130859375
            },
            {
                "x": 0.09795603156089783,
                "y": -0.0021827006712555885,
                "z": -133.52377319335938
            },
            {
                "x": 0.09770917892456055,
                "y": -0.002190448809415102,
                "z": -133.3665313720703
            },
            {
                "x": 0.0974598377943039,
                "y": -0.0021981955505907536,
                "z": -133.2091827392578
            },
            {
                "x": 0.09720896184444427,
                "y": -0.002205940429121256,
                "z": -133.0519561767578
            },
            {
                "x": 0.09695595502853394,
                "y": -0.0022136890329420567,
                "z": -132.89471435546875
            },
            {
                "x": 0.09670057892799377,
                "y": -0.0022127896081656218,
                "z": -132.7373046875
            },
            {
                "x": 0.09644374251365662,
                "y": -0.001971891848370433,
                "z": -132.58004760742188
            },
            {
                "x": 0.09618456661701202,
                "y": -0.0013412972912192345,
                "z": -132.42282104492188
            },
            {
                "x": 0.09601537883281708,
                "y": -0.0007314376998692751,
                "z": -132.32125854492188
            },
            {
                "x": 0.09575308859348297,
                "y": 0.0005350131541490555,
                "z": -132.1640167236328
            },
            {
                "x": 0.09548859298229218,
                "y": 0.002169249812141061,
                "z": -132.00668334960938
            },
            {
                "x": 0.0952223390340805,
                "y": 0.004161913879215717,
                "z": -131.84934997558594
            },
            {
                "x": 0.09495384991168976,
                "y": 0.006511335726827383,
                "z": -131.69212341308594
            },
            {
                "x": 0.09468363225460052,
                "y": 0.009211208671331406,
                "z": -131.5347900390625
            },
            {
                "x": 0.09441116452217102,
                "y": 0.012240834534168243,
                "z": -131.37759399414062
            },
            {
                "x": 0.09413698315620422,
                "y": 0.01559373177587986,
                "z": -131.22039794921875
            },
            {
                "x": 0.09386026859283447,
                "y": 0.019272927194833755,
                "z": -131.06300354003906
            },
            {
                "x": 0.09358187019824982,
                "y": 0.0232606902718544,
                "z": -130.90582275390625
            },
            {
                "x": 0.09330148994922638,
                "y": 0.027546508237719536,
                "z": -130.74859619140625
            },
            {
                "x": 0.09301888942718506,
                "y": 0.03212090954184532,
                "z": -130.59136962890625
            },
            {
                "x": 0.09273464977741241,
                "y": 0.036978334188461304,
                "z": -130.4342041015625
            },
            {
                "x": 0.09244763851165771,
                "y": 0.04212113842368126,
                "z": -130.27684020996094
            },
            {
                "x": 0.09215931594371796,
                "y": 0.047518402338027954,
                "z": -130.11968994140625
            },
            {
                "x": 0.09186860918998718,
                "y": 0.053168654441833496,
                "z": -129.96258544921875
            },
            {
                "x": 0.09157600998878479,
                "y": 0.059071898460388184,
                "z": -129.80532836914062
            },
            {
                "x": 0.09128129482269287,
                "y": 0.06521384418010712,
                "z": -129.64822387695312
            },
            {
                "x": 0.09098450839519501,
                "y": 0.07158588618040085,
                "z": -129.49102783203125
            },
            {
                "x": 0.09068571031093597,
                "y": 0.07817685604095459,
                "z": -129.3338165283203
            },
            {
                "x": 0.09038490056991577,
                "y": 0.08497621864080429,
                "z": -129.17672729492188
            },
            {
                "x": 0.09008225798606873,
                "y": 0.09198246151208878,
                "z": -129.0196533203125
            },
            {
                "x": 0.08977724611759186,
                "y": 0.0991804301738739,
                "z": -128.86257934570312
            },
            {
                "x": 0.0894705057144165,
                "y": 0.10656191408634186,
                "z": -128.7055206298828
            },
            {
                "x": 0.08916103839874268,
                "y": 0.11412914842367172,
                "z": -128.54823303222656
            },
            {
                "x": 0.08885011076927185,
                "y": 0.12185907363891602,
                "z": -128.39120483398438
            },
            {
                "x": 0.08853678405284882,
                "y": 0.12974819540977478,
                "z": -128.234130859375
            },
            {
                "x": 0.08822175860404968,
                "y": 0.13778570294380188,
                "z": -128.07704162597656
            },
            {
                "x": 0.08790436387062073,
                "y": 0.14596088230609894,
                "z": -127.92005157470703
            },
            {
                "x": 0.08758480846881866,
                "y": 0.1542835533618927,
                "z": -127.7628402709961
            },
            {
                "x": 0.0872633308172226,
                "y": 0.16271796822547913,
                "z": -127.60582733154297
            },
            {
                "x": 0.0869399756193161,
                "y": 0.17126663029193878,
                "z": -127.44880676269531
            },
            {
                "x": 0.08661425113677979,
                "y": 0.17992620170116425,
                "z": -127.29170227050781
            },
            {
                "x": 0.08628664910793304,
                "y": 0.1886792778968811,
                "z": -127.13472747802734
            },
            {
                "x": 0.08595676720142365,
                "y": 0.19752563536167145,
                "z": -126.97765350341797
            },
            {
                "x": 0.0856248140335083,
                "y": 0.20645169913768768,
                "z": -126.8205795288086
            },
            {
                "x": 0.08529098331928253,
                "y": 0.21544277667999268,
                "z": -126.66360473632812
            },
            {
                "x": 0.08495482802391052,
                "y": 0.22450417280197144,
                "z": -126.50651550292969
            },
            {
                "x": 0.0846167802810669,
                "y": 0.23361310362815857,
                "z": -126.34953308105469
            },
            {
                "x": 0.08427655696868896,
                "y": 0.24276620149612427,
                "z": -126.19257354736328
            },
            {
                "x": 0.08393403887748718,
                "y": 0.2519656717777252,
                "z": -126.03541564941406
            },
            {
                "x": 0.0835895985364914,
                "y": 0.2611827254295349,
                "z": -125.8784408569336
            },
            {
                "x": 0.0832432359457016,
                "y": 0.27041691541671753,
                "z": -125.72149658203125
            },
            {
                "x": 0.08301728963851929,
                "y": 0.2763879895210266,
                "z": -125.62010955810547
            },
            {
                "x": 0.08266755938529968,
                "y": 0.2856346368789673,
                "z": -125.463134765625
            },
            {
                "x": 0.08231516182422638,
                "y": 0.29488247632980347,
                "z": -125.30607604980469
            },
            {
                "x": 0.08196099102497101,
                "y": 0.30411651730537415,
                "z": -125.14903259277344
            },
            {
                "x": 0.08160465955734253,
                "y": 0.3133232295513153,
                "z": -124.9920654296875
            },
            {
                "x": 0.0812462866306305,
                "y": 0.3225058913230896,
                "z": -124.83499145507812
            },
            {
                "x": 0.0808856338262558,
                "y": 0.33164072036743164,
                "z": -124.67804718017578
            },
            {
                "x": 0.08052314817905426,
                "y": 0.34072935581207275,
                "z": -124.52107238769531
            },
            {
                "x": 0.08015792071819305,
                "y": 0.3497730493545532,
                "z": -124.36389923095703
            },
            {
                "x": 0.07979126274585724,
                "y": 0.35873883962631226,
                "z": -124.20692443847656
            },
            {
                "x": 0.07942211627960205,
                "y": 0.3676314055919647,
                "z": -124.04988861083984
            },
            {
                "x": 0.07905100286006927,
                "y": 0.37644219398498535,
                "z": -123.89283752441406
            },
            {
                "x": 0.07867775857448578,
                "y": 0.3851584196090698,
                "z": -123.7358627319336
            },
            {
                "x": 0.07830210030078888,
                "y": 0.39378488063812256,
                "z": -123.57866668701172
            },
            {
                "x": 0.07792457938194275,
                "y": 0.4022887349128723,
                "z": -123.42164611816406
            },
            {
                "x": 0.07754503190517426,
                "y": 0.4106742739677429,
                "z": -123.26465606689453
            },
            {
                "x": 0.07716317474842072,
                "y": 0.41894081234931946,
                "z": -123.10753631591797
            },
            {
                "x": 0.0767793357372284,
                "y": 0.4270666539669037,
                "z": -122.95050811767578
            },
            {
                "x": 0.07639321684837341,
                "y": 0.43504756689071655,
                "z": -122.79339599609375
            },
            {
                "x": 0.07600481808185577,
                "y": 0.4428771734237671,
                "z": -122.63626098632812
            },
            {
                "x": 0.07561475038528442,
                "y": 0.45054131746292114,
                "z": -122.47921752929688
            },
            {
                "x": 0.07522240281105042,
                "y": 0.458035945892334,
                "z": -122.32217407226562
            },
            {
                "x": 0.07482801377773285,
                "y": 0.46534478664398193,
                "z": -122.16513061523438
            },
            {
                "x": 0.07443134486675262,
                "y": 0.4724673926830292,
                "z": -122.00804901123047
            },
            {
                "x": 0.07403227686882019,
                "y": 0.4794027507305145,
                "z": -121.85078430175781
            },
            {
                "x": 0.07363148033618927,
                "y": 0.4861258864402771,
                "z": -121.69368743896484
            },
            {
                "x": 0.07322834432125092,
                "y": 0.49262839555740356,
                "z": -121.53655242919922
            },
            {
                "x": 0.07282324135303497,
                "y": 0.4989089369773865,
                "z": -121.37939453125
            },
            {
                "x": 0.0724160224199295,
                "y": 0.5049571394920349,
                "z": -121.2222671508789
            },
            {
                "x": 0.07200643420219421,
                "y": 0.5107744336128235,
                "z": -121.06494903564453
            },
            {
                "x": 0.07159492373466492,
                "y": 0.5163252353668213,
                "z": -120.90784454345703
            },
            {
                "x": 0.07118147611618042,
                "y": 0.5216187238693237,
                "z": -120.75069427490234
            },
            {
                "x": 0.0707656741142273,
                "y": 0.5266504287719727,
                "z": -120.59343719482422
            },
            {
                "x": 0.07034794986248016,
                "y": 0.5314052104949951,
                "z": -120.436279296875
            },
            {
                "x": 0.06992802023887634,
                "y": 0.5358682870864868,
                "z": -120.2790298461914
            },
            {
                "x": 0.06950581073760986,
                "y": 0.5400371551513672,
                "z": -120.12174987792969
            },
            {
                "x": 0.06908193230628967,
                "y": 0.5439034700393677,
                "z": -119.9645767211914
            },
            {
                "x": 0.06865572929382324,
                "y": 0.5474634766578674,
                "z": -119.80728149414062
            },
            {
                "x": 0.0682276040315628,
                "y": 0.5506913661956787,
                "z": -119.65007781982422
            },
            {
                "x": 0.06779755651950836,
                "y": 0.5535891056060791,
                "z": -119.49288940429688
            },
            {
                "x": 0.067364901304245,
                "y": 0.556154727935791,
                "z": -119.33548736572266
            },
            {
                "x": 0.06693077087402344,
                "y": 0.5583734512329102,
                "z": -119.17826843261719
            },
            {
                "x": 0.06650358438491821,
                "y": 0.5602273344993591,
                "z": -119.02106475830078
            },
            {
                "x": 0.06621073186397552,
                "y": 0.5612289905548096,
                "z": -118.91950225830078
            },
            {
                "x": 0.06577128171920776,
                "y": 0.5624836683273315,
                "z": -118.76228332519531
            },
            {
                "x": 0.0653294026851654,
                "y": 0.5633536577224731,
                "z": -118.60496520996094
            },
            {
                "x": 0.06488576531410217,
                "y": 0.5638294219970703,
                "z": -118.44764709472656
            },
            {
                "x": 0.06444031000137329,
                "y": 0.5639115571975708,
                "z": -118.29042053222656
            },
            {
                "x": 0.06399261951446533,
                "y": 0.5635976791381836,
                "z": -118.1330795288086
            },
            {
                "x": 0.0635433942079544,
                "y": 0.5628867149353027,
                "z": -117.9758529663086
            },
            {
                "x": 0.06309211254119873,
                "y": 0.5617859959602356,
                "z": -117.8186264038086
            },
            {
                "x": 0.06263838708400726,
                "y": 0.5603125095367432,
                "z": -117.66120147705078
            },
            {
                "x": 0.062183454632759094,
                "y": 0.5584787130355835,
                "z": -117.5040054321289
            },
            {
                "x": 0.06172645092010498,
                "y": 0.5562831163406372,
                "z": -117.34674072265625
            },
            {
                "x": 0.06126755475997925,
                "y": 0.5537328720092773,
                "z": -117.1894760131836
            },
            {
                "x": 0.06080707907676697,
                "y": 0.5508476495742798,
                "z": -117.03227996826172
            },
            {
                "x": 0.06034429371356964,
                "y": 0.5476311445236206,
                "z": -116.87488555908203
            },
            {
                "x": 0.05988018214702606,
                "y": 0.5440939664840698,
                "z": -116.71770477294922
            },
            {
                "x": 0.059414416551589966,
                "y": 0.5402381420135498,
                "z": -116.5605239868164
            },
            {
                "x": 0.058946624398231506,
                "y": 0.5360782146453857,
                "z": -116.40322875976562
            },
            {
                "x": 0.05847744643688202,
                "y": 0.5316292643547058,
                "z": -116.24607849121094
            },
            {
                "x": 0.058006346225738525,
                "y": 0.5268889665603638,
                "z": -116.08882141113281
            },
            {
                "x": 0.05753369629383087,
                "y": 0.5218653082847595,
                "z": -115.93159484863281
            },
            {
                "x": 0.05705969035625458,
                "y": 0.5165781378746033,
                "z": -115.7744369506836
            },
            {
                "x": 0.0565841943025589,
                "y": 0.5110347270965576,
                "z": -115.61732482910156
            },
            {
                "x": 0.05610719323158264,
                "y": 0.5052390098571777,
                "z": -115.46019744873047
            },
            {
                "x": 0.055628761649131775,
                "y": 0.49919557571411133,
                "z": -115.30309295654297
            },
            {
                "x": 0.05514836311340332,
                "y": 0.49291306734085083,
                "z": -115.14579772949219
            },
            {
                "x": 0.05466710031032562,
                "y": 0.4864162504673004,
                "z": -114.98870849609375
            },
            {
                "x": 0.054184526205062866,
                "y": 0.4797017574310303,
                "z": -114.8315658569336
            },
            {
                "x": 0.053700610995292664,
                "y": 0.47277408838272095,
                "z": -114.67444610595703
            },
            {
                "x": 0.053215667605400085,
                "y": 0.46565255522727966,
                "z": -114.51737213134766
            },
            {
                "x": 0.052729055285453796,
                "y": 0.45833471417427063,
                "z": -114.36011505126953
            },
            {
                "x": 0.05224204063415527,
                "y": 0.4508465528488159,
                "z": -114.20306396484375
            },
            {
                "x": 0.05175398290157318,
                "y": 0.4431808590888977,
                "z": -114.04602813720703
            },
            {
                "x": 0.05126470327377319,
                "y": 0.43534839153289795,
                "z": -113.8888931274414
            },
            {
                "x": 0.050774917006492615,
                "y": 0.4273691177368164,
                "z": -113.73184967041016
            },
            {
                "x": 0.05028426647186279,
                "y": 0.4192405343055725,
                "z": -113.5747299194336
            },
            {
                "x": 0.0497928261756897,
                "y": 0.41097021102905273,
                "z": -113.4176254272461
            },
            {
                "x": 0.049301281571388245,
                "y": 0.4025788903236389,
                "z": -113.26061248779297
            },
            {
                "x": 0.04880906641483307,
                "y": 0.3940643072128296,
                "z": -113.103515625
            },
            {
                "x": 0.04831680655479431,
                "y": 0.38544583320617676,
                "z": -112.94651794433594
            },
            {
                "x": 0.04782441258430481,
                "y": 0.3767220675945282,
                "z": -112.78953552246094
            },
            {
                "x": 0.04733152687549591,
                "y": 0.3678957223892212,
                "z": -112.6323471069336
            },
            {
                "x": 0.046839356422424316,
                "y": 0.358997642993927,
                "z": -112.47537231445312
            },
            {
                "x": 0.046363189816474915,
                "y": 0.35002535581588745,
                "z": -112.31840515136719
            },
            {
                "x": 0.04602910578250885,
                "y": 0.3441905975341797,
                "z": -112.21701049804688
            },
            {
                "x": 0.04553823173046112,
                "y": 0.3351111114025116,
                "z": -112.06004333496094
            },
            {
                "x": 0.04504796862602234,
                "y": 0.32597440481185913,
                "z": -111.90296936035156
            },
            {
                "x": 0.04455883800983429,
                "y": 0.3167944550514221,
                "z": -111.74591827392578
            },
            {
                "x": 0.04407137632369995,
                "y": 0.3075850009918213,
                "z": -111.5889663696289
            },
            {
                "x": 0.04358522593975067,
                "y": 0.2983429431915283,
                "z": -111.43189239501953
            },
            {
                "x": 0.04310135543346405,
                "y": 0.28909116983413696,
                "z": -111.27494049072266
            },
            {
                "x": 0.04261980950832367,
                "y": 0.27983027696609497,
                "z": -111.11798858642578
            },
            {
                "x": 0.042140424251556396,
                "y": 0.2705574929714203,
                "z": -110.96082305908203
            },
            {
                "x": 0.04166467487812042,
                "y": 0.2613067626953125,
                "z": -110.80387878417969
            },
            {
                "x": 0.04119236767292023,
                "y": 0.2520695924758911,
                "z": -110.64686584472656
            },
            {
                "x": 0.040724143385887146,
                "y": 0.2428583800792694,
                "z": -110.48986053466797
            },
            {
                "x": 0.04026100039482117,
                "y": 0.23368757963180542,
                "z": -110.3329086303711
            },
            {
                "x": 0.03980265557765961,
                "y": 0.22454799711704254,
                "z": -110.17573547363281
            },
            {
                "x": 0.039350949227809906,
                "y": 0.21547171473503113,
                "z": -110.01874542236328
            },
            {
                "x": 0.03890629857778549,
                "y": 0.20645791292190552,
                "z": -109.8617935180664
            },
            {
                "x": 0.038469791412353516,
                "y": 0.19750992953777313,
                "z": -109.70470428466797
            },
            {
                "x": 0.03804262727499008,
                "y": 0.18864569067955017,
                "z": -109.54772186279297
            },
            {
                "x": 0.03762572258710861,
                "y": 0.17986330389976501,
                "z": -109.3906478881836
            },
            {
                "x": 0.03722107410430908,
                "y": 0.17117643356323242,
                "z": -109.23355102539062
            },
            {
                "x": 0.03683104366064072,
                "y": 0.1626042127609253,
                "z": -109.0765609741211
            },
            {
                "x": 0.036457359790802,
                "y": 0.15414442121982574,
                "z": -108.9195556640625
            },
            {
                "x": 0.03610261529684067,
                "y": 0.1458064615726471,
                "z": -108.76254272460938
            },
            {
                "x": 0.03577011823654175,
                "y": 0.1375986635684967,
                "z": -108.60552978515625
            },
            {
                "x": 0.03546493500471115,
                "y": 0.12952622771263123,
                "z": -108.44831085205078
            },
            {
                "x": 0.035192035138607025,
                "y": 0.12161116302013397,
                "z": -108.2912826538086
            },
            {
                "x": 0.03494641184806824,
                "y": 0.11384936422109604,
                "z": -108.13417053222656
            },
            {
                "x": 0.03453223407268524,
                "y": 0.1062474474310875,
                "z": -107.97696685791016
            },
            {
                "x": 0.03320600837469101,
                "y": 0.09882247447967529,
                "z": -107.81964111328125
            },
            {
                "x": 0.030672401189804077,
                "y": 0.0915723592042923,
                "z": -107.6621322631836
            },
            {
                "x": 0.026976697146892548,
                "y": 0.08452369272708893,
                "z": -107.50483703613281
            },
            {
                "x": 0.02218831330537796,
                "y": 0.07767678052186966,
                "z": -107.34757995605469
            },
            {
                "x": 0.016327396035194397,
                "y": 0.07104458659887314,
                "z": -107.19025421142578
            },
            {
                "x": 0.00950593501329422,
                "y": 0.0646379142999649,
                "z": -107.03306579589844
            },
            {
                "x": 0.001781947910785675,
                "y": 0.0584557019174099,
                "z": -106.87586975097656
            },
            {
                "x": -0.006772711873054504,
                "y": 0.052508994936943054,
                "z": -106.71868896484375
            },
            {
                "x": -0.016111060976982117,
                "y": 0.04682108759880066,
                "z": -106.56167602539062
            },
            {
                "x": -0.02616417407989502,
                "y": 0.041385333985090256,
                "z": -106.40460205078125
            },
            {
                "x": -0.036855511367321014,
                "y": 0.03621475026011467,
                "z": -106.24767303466797
            },
            {
                "x": -0.04812353104352951,
                "y": 0.03131404519081116,
                "z": -106.0907974243164
            },
            {
                "x": -0.05995681509375572,
                "y": 0.02669643610715866,
                "z": -105.93377685546875
            },
            {
                "x": -0.07225468754768372,
                "y": 0.022375188767910004,
                "z": -105.77696990966797
            },
            {
                "x": -0.08496874570846558,
                "y": 0.018349558115005493,
                "z": -105.62022399902344
            },
            {
                "x": -0.09338472783565521,
                "y": 0.01590912416577339,
                "z": -105.51897430419922
            },
            {
                "x": -0.1067010834813118,
                "y": 0.012398405000567436,
                "z": -105.36226654052734
            },
            {
                "x": -0.12032555043697357,
                "y": 0.009203552268445492,
                "z": -105.20549774169922
            },
            {
                "x": -0.1342044323682785,
                "y": 0.006335430778563023,
                "z": -105.04875946044922
            },
            {
                "x": -0.14829817414283752,
                "y": 0.003811474656686187,
                "z": -104.8921127319336
            },
            {
                "x": -0.16258634626865387,
                "y": 0.0016386748757213354,
                "z": -104.73539733886719
            },
            {
                "x": -0.17701034247875214,
                "y": -0.00018050591461360455,
                "z": -104.57881164550781
            },
            {
                "x": -0.19154566526412964,
                "y": -0.0016392762772738934,
                "z": -104.42222595214844
            },
            {
                "x": -0.20618608593940735,
                "y": -0.002722436096519232,
                "z": -104.26545715332031
            },
            {
                "x": -0.22086043655872345,
                "y": -0.003415336599573493,
                "z": -104.10890197753906
            },
            {
                "x": -0.23557153344154358,
                "y": -0.003721693530678749,
                "z": -103.95228576660156
            },
            {
                "x": -0.2502857744693756,
                "y": -0.0037511191330850124,
                "z": -103.7956771850586
            },
            {
                "x": -0.2649751603603363,
                "y": -0.0037582782097160816,
                "z": -103.63915252685547
            },
            {
                "x": -0.2796405255794525,
                "y": -0.0037654503248631954,
                "z": -103.4823989868164
            },
            {
                "x": -0.29422909021377563,
                "y": -0.0037726126611232758,
                "z": -103.32587432861328
            },
            {
                "x": -0.308740496635437,
                "y": -0.003779773600399494,
                "z": -103.16932678222656
            },
            {
                "x": -0.32316938042640686,
                "y": -0.0037869377993047237,
                "z": -103.01266479492188
            },
            {
                "x": -0.3374781608581543,
                "y": -0.0037941010668873787,
                "z": -102.8561019897461
            },
            {
                "x": -0.3516719341278076,
                "y": -0.003801269456744194,
                "z": -102.69944763183594
            },
            {
                "x": -0.3657301664352417,
                "y": -0.003808434121310711,
                "z": -102.54277038574219
            },
            {
                "x": -0.379633367061615,
                "y": -0.0038155969232320786,
                "z": -102.38618469238281
            },
            {
                "x": -0.3933749794960022,
                "y": -0.003822754602879286,
                "z": -102.22958374023438
            },
            {
                "x": -0.40695106983184814,
                "y": -0.003829916473478079,
                "z": -102.07296752929688
            },
            {
                "x": -0.4203530251979828,
                "y": -0.0038370825350284576,
                "z": -101.91634368896484
            },
            {
                "x": -0.4335886538028717,
                "y": -0.003844247665256262,
                "z": -101.75950622558594
            },
            {
                "x": -0.4466082751750946,
                "y": -0.0038514123298227787,
                "z": -101.60285186767578
            },
            {
                "x": -0.45943817496299744,
                "y": -0.0038585783913731575,
                "z": -101.44612121582031
            },
            {
                "x": -0.47206705808639526,
                "y": -0.0038657430559396744,
                "z": -101.28938293457031
            },
            {
                "x": -0.4844813346862793,
                "y": -0.0038728993386030197,
                "z": -101.1326904296875
            },
            {
                "x": -0.4966910481452942,
                "y": -0.0038800686597824097,
                "z": -100.97576904296875
            },
            {
                "x": -0.5086674690246582,
                "y": -0.0038872305303812027,
                "z": -100.81903076171875
            },
            {
                "x": -0.5204273462295532,
                "y": -0.0038944007828831673,
                "z": -100.66228485107422
            },
            {
                "x": -0.5319697260856628,
                "y": -0.0039015626534819603,
                "z": -100.5053939819336
            },
            {
                "x": -0.5432692766189575,
                "y": -0.003908722661435604,
                "z": -100.34860229492188
            },
            {
                "x": -0.5543482899665833,
                "y": -0.003915890119969845,
                "z": -100.19170379638672
            },
            {
                "x": -0.5651990175247192,
                "y": -0.003923052456229925,
                "z": -100.0347900390625
            },
            {
                "x": -0.5758098363876343,
                "y": -0.003930217586457729,
                "z": -99.87794494628906
            },
            {
                "x": -0.5861809253692627,
                "y": -0.0039373841136693954,
                "z": -99.72100830078125
            },
            {
                "x": -0.5963134169578552,
                "y": -0.003944545052945614,
                "z": -99.56413269042969
            },
            {
                "x": -0.6062104105949402,
                "y": -0.003951709717512131,
                "z": -99.40725708007812
            },
            {
                "x": -0.6158830523490906,
                "y": -0.003958879504352808,
                "z": -99.25016021728516
            },
            {
                "x": -0.6252986192703247,
                "y": -0.003966039977967739,
                "z": -99.09325408935547
            },
            {
                "x": -0.6344771981239319,
                "y": -0.003973198123276234,
                "z": -98.93633270263672
            },
            {
                "x": -0.6402844190597534,
                "y": -0.003977865446358919,
                "z": -98.83496856689453
            },
            {
                "x": -0.6490683555603027,
                "y": -0.003985028713941574,
                "z": -98.67802429199219
            },
            {
                "x": -0.6576210856437683,
                "y": -0.003992191981524229,
                "z": -98.5209732055664
            },
            {
                "x": -0.6659367084503174,
                "y": -0.0039993589743971825,
                "z": -98.36389923095703
            },
            {
                "x": -0.6740107536315918,
                "y": -0.004006517119705677,
                "z": -98.2069091796875
            },
            {
                "x": -0.6818474531173706,
                "y": -0.004013689234852791,
                "z": -98.04979705810547
            },
            {
                "x": -0.689441978931427,
                "y": -0.004005481954663992,
                "z": -97.89279174804688
            },
            {
                "x": -0.6968052983283997,
                "y": -0.003866024548187852,
                "z": -97.73576354980469
            },
            {
                "x": -0.703946053981781,
                "y": -0.0035596515517681837,
                "z": -97.5785140991211
            },
            {
                "x": -0.7108355760574341,
                "y": -0.0030841275583952665,
                "z": -97.4214859008789
            },
            {
                "x": -0.7174962162971497,
                "y": -0.0024470658972859383,
                "z": -97.26436614990234
            },
            {
                "x": -0.7239294052124023,
                "y": -0.0016535213217139244,
                "z": -97.10723114013672
            },
            {
                "x": -0.7301318645477295,
                "y": -0.0007072924636304379,
                "z": -96.95015716552734
            },
            {
                "x": -0.7361056804656982,
                "y": 0.0003956621512770653,
                "z": -96.79288482666016
            },
            {
                "x": -0.7418460845947266,
                "y": 0.001645323121920228,
                "z": -96.63578033447266
            },
            {
                "x": -0.7473630905151367,
                "y": 0.003037738148123026,
                "z": -96.47869110107422
            },
            {
                "x": -0.752659261226654,
                "y": 0.004570947494357824,
                "z": -96.32146453857422
            },
            {
                "x": -0.7577254176139832,
                "y": 0.006244071759283543,
                "z": -96.16436004638672
            },
            {
                "x": -0.7625738382339478,
                "y": 0.008052948862314224,
                "z": -96.00714874267578
            },
            {
                "x": -0.7672033309936523,
                "y": 0.009991561993956566,
                "z": -95.84991455078125
            },
            {
                "x": -0.7716151475906372,
                "y": 0.012055017054080963,
                "z": -95.69277954101562
            },
            {
                "x": -0.7758062481880188,
                "y": 0.01424504816532135,
                "z": -95.53565216064453
            },
            {
                "x": -0.7797789573669434,
                "y": 0.016556356102228165,
                "z": -95.37852478027344
            },
            {
                "x": -0.7835409641265869,
                "y": 0.018983714282512665,
                "z": -95.22137451171875
            },
            {
                "x": -0.7870975136756897,
                "y": 0.021526820957660675,
                "z": -95.06403350830078
            },
            {
                "x": -0.7904332876205444,
                "y": 0.024179374799132347,
                "z": -94.90687561035156
            },
            {
                "x": -0.7935623526573181,
                "y": 0.026940591633319855,
                "z": -94.74966430664062
            },
            {
                "x": -0.7964864373207092,
                "y": 0.029804065823554993,
                "z": -94.59246826171875
            },
            {
                "x": -0.799207329750061,
                "y": 0.032765742391347885,
                "z": -94.43531036376953
            },
            {
                "x": -0.8017259836196899,
                "y": 0.035829637199640274,
                "z": -94.2779541015625
            },
            {
                "x": -0.8040337562561035,
                "y": 0.038983725011348724,
                "z": -94.12080383300781
            },
            {
                "x": -0.8061442375183105,
                "y": 0.04222675412893295,
                "z": -93.9636459350586
            },
            {
                "x": -0.8080582618713379,
                "y": 0.04555772989988327,
                "z": -93.8063735961914
            },
            {
                "x": -0.8097726702690125,
                "y": 0.04897047206759453,
                "z": -93.64922332763672
            },
            {
                "x": -0.8112931251525879,
                "y": 0.05246581509709358,
                "z": -93.4919662475586
            },
            {
                "x": -0.8126206994056702,
                "y": 0.05603666231036186,
                "z": -93.33470916748047
            },
            {
                "x": -0.8137574195861816,
                "y": 0.059677232056856155,
                "z": -93.17754364013672
            },
            {
                "x": -0.8146972060203552,
                "y": 0.06339029222726822,
                "z": -93.0202865600586
            },
            {
                "x": -0.8154462575912476,
                "y": 0.06716784834861755,
                "z": -92.86311340332031
            },
            {
                "x": -0.8159999251365662,
                "y": 0.07100708037614822,
                "z": -92.70596313476562
            },
            {
                "x": -0.8163315057754517,
                "y": 0.07490941882133484,
                "z": -92.54862213134766
            },
            {
                "x": -0.8163545727729797,
                "y": 0.07886333018541336,
                "z": -92.3914794921875
            },
            {
                "x": -0.8159836530685425,
                "y": 0.08287020027637482,
                "z": -92.2343521118164
            },
            {
                "x": -0.8155159950256348,
                "y": 0.08548427373170853,
                "z": -92.13285827636719
            },
            {
                "x": -0.814366340637207,
                "y": 0.08956994116306305,
                "z": -91.97573852539062
            },
            {
                "x": -0.8126682639122009,
                "y": 0.09370346367359161,
                "z": -91.81853485107422
            },
            {
                "x": -0.8104538321495056,
                "y": 0.09787705540657043,
                "z": -91.66133880615234
            },
            {
                "x": -0.8077150583267212,
                "y": 0.10208506882190704,
                "z": -91.50423431396484
            },
            {
                "x": -0.8044475317001343,
                "y": 0.10632989555597305,
                "z": -91.3470458984375
            },
            {
                "x": -0.800612211227417,
                "y": 0.1106031984090805,
                "z": -91.18997192382812
            },
            {
                "x": -0.7962425351142883,
                "y": 0.11490336060523987,
                "z": -91.03290557861328
            },
            {
                "x": -0.7913293838500977,
                "y": 0.11923232674598694,
                "z": -90.87568664550781
            },
            {
                "x": -0.7858862280845642,
                "y": 0.12357574701309204,
                "z": -90.71865844726562
            },
            {
                "x": -0.7798831462860107,
                "y": 0.12793835997581482,
                "z": -90.56160736083984
            },
            {
                "x": -0.7733301520347595,
                "y": 0.1323142945766449,
                "z": -90.40457153320312
            },
            {
                "x": -0.7662375569343567,
                "y": 0.13669833540916443,
                "z": -90.24761199951172
            },
            {
                "x": -0.7585833072662354,
                "y": 0.14109474420547485,
                "z": -90.09048461914062
            },
            {
                "x": -0.7503718137741089,
                "y": 0.14548873901367188,
                "z": -89.93357849121094
            },
            {
                "x": -0.7416207790374756,
                "y": 0.149881973862648,
                "z": -89.77672576904297
            },
            {
                "x": -0.732314944267273,
                "y": 0.15427497029304504,
                "z": -89.61976623535156
            },
            {
                "x": -0.7224768996238708,
                "y": 0.15865767002105713,
                "z": -89.46295166015625
            },
            {
                "x": -0.7120526432991028,
                "y": 0.16303187608718872,
                "z": -89.30609130859375
            },
            {
                "x": -0.7010810375213623,
                "y": 0.16739219427108765,
                "z": -89.14925384521484
            },
            {
                "x": -0.6895737648010254,
                "y": 0.1717323660850525,
                "z": -88.9925537109375
            },
            {
                "x": -0.6775192618370056,
                "y": 0.17605164647102356,
                "z": -88.83590698242188
            },
            {
                "x": -0.6649035215377808,
                "y": 0.18034590780735016,
                "z": -88.67927551269531
            },
            {
                "x": -0.6517495512962341,
                "y": 0.1846121996641159,
                "z": -88.522705078125
            },
            {
                "x": -0.6380357146263123,
                "y": 0.18885251879692078,
                "z": -88.36598205566406
            },
            {
                "x": -0.6238061189651489,
                "y": 0.1930532604455948,
                "z": -88.20948791503906
            },
            {
                "x": -0.6090161800384521,
                "y": 0.19721579551696777,
                "z": -88.05300903320312
            },
            {
                "x": -0.5936919450759888,
                "y": 0.20133629441261292,
                "z": -87.89657592773438
            },
            {
                "x": -0.5778486728668213,
                "y": 0.2054106444120407,
                "z": -87.74024200439453
            },
            {
                "x": -0.5614631772041321,
                "y": 0.20944175124168396,
                "z": -87.58375549316406
            },
            {
                "x": -0.5445549488067627,
                "y": 0.21341368556022644,
                "z": -87.42754364013672
            },
            {
                "x": -0.5271295309066772,
                "y": 0.2173301875591278,
                "z": -87.27136993408203
            },
            {
                "x": -0.5091831088066101,
                "y": 0.22119073569774628,
                "z": -87.11515045166016
            },
            {
                "x": -0.4907469153404236,
                "y": 0.22498640418052673,
                "z": -86.9590835571289
            },
            {
                "x": -0.4717843532562256,
                "y": 0.22871610522270203,
                "z": -86.80298614501953
            },
            {
                "x": -0.4523283541202545,
                "y": 0.23237600922584534,
                "z": -86.64694213867188
            },
            {
                "x": -0.43239709734916687,
                "y": 0.2359611541032791,
                "z": -86.4910659790039
            },
            {
                "x": -0.4119744896888733,
                "y": 0.23947253823280334,
                "z": -86.33514404296875
            },
            {
                "x": -0.3910852074623108,
                "y": 0.24289965629577637,
                "z": -86.17937469482422
            },
            {
                "x": -0.36973127722740173,
                "y": 0.24624258279800415,
                "z": -86.023681640625
            },
            {
                "x": -0.34789249300956726,
                "y": 0.24950316548347473,
                "z": -85.86784362792969
            },
            {
                "x": -0.32563796639442444,
                "y": 0.252670019865036,
                "z": -85.7122573852539
            },
            {
                "x": -0.3029407858848572,
                "y": 0.2557407021522522,
                "z": -85.55673217773438
            },
            {
                "x": -0.28804969787597656,
                "y": 0.25767162442207336,
                "z": -85.45630645751953
            },
            {
                "x": -0.26465797424316406,
                "y": 0.2605811655521393,
                "z": -85.3008804321289
            },
            {
                "x": -0.24083641171455383,
                "y": 0.2633879780769348,
                "z": -85.14541625976562
            },
            {
                "x": -0.2166096270084381,
                "y": 0.266085684299469,
                "z": -84.9900131225586
            },
            {
                "x": -0.1920161247253418,
                "y": 0.2686724066734314,
                "z": -84.83475494384766
            },
            {
                "x": -0.1670389473438263,
                "y": 0.27114832401275635,
                "z": -84.67945098876953
            },
            {
                "x": -0.14171238243579865,
                "y": 0.27350395917892456,
                "z": -84.52432250976562
            },
            {
                "x": -0.11603007465600967,
                "y": 0.27573639154434204,
                "z": -84.3692398071289
            },
            {
                "x": -0.08998225629329681,
                "y": 0.2778483033180237,
                "z": -84.21401977539062
            },
            {
                "x": -0.06365640461444855,
                "y": 0.27983105182647705,
                "z": -84.05904388427734
            },
            {
                "x": -0.03701605647802353,
                "y": 0.2816823124885559,
                "z": -83.90406799316406
            },
            {
                "x": -0.01007562130689621,
                "y": 0.28339582681655884,
                "z": -83.7491226196289
            },
            {
                "x": 0.01712307333946228,
                "y": 0.2849716246128082,
                "z": -83.59429931640625
            },
            {
                "x": 0.04460985213518143,
                "y": 0.28640908002853394,
                "z": -83.43931579589844
            },
            {
                "x": 0.07230450212955475,
                "y": 0.2876989245414734,
                "z": -83.2845458984375
            },
            {
                "x": 0.10023245960474014,
                "y": 0.2888363003730774,
                "z": -83.12983703613281
            },
            {
                "x": 0.1283821165561676,
                "y": 0.2898238003253937,
                "z": -82.97505187988281
            },
            {
                "x": 0.15670087933540344,
                "y": 0.29065650701522827,
                "z": -82.82040405273438
            },
            {
                "x": 0.18520626425743103,
                "y": 0.2913302481174469,
                "z": -82.66569519042969
            },
            {
                "x": 0.21387237310409546,
                "y": 0.2918369174003601,
                "z": -82.5110092163086
            },
            {
                "x": 0.24265232682228088,
                "y": 0.292178750038147,
                "z": -82.35645294189453
            },
            {
                "x": 0.2715427875518799,
                "y": 0.29227280616760254,
                "z": -82.20191192626953
            },
            {
                "x": 0.3005322515964508,
                "y": 0.2919076383113861,
                "z": -82.04740142822266
            },
            {
                "x": 0.32959815859794617,
                "y": 0.29105260968208313,
                "z": -81.89289855957031
            },
            {
                "x": 0.35875535011291504,
                "y": 0.2897336483001709,
                "z": -81.73822021484375
            },
            {
                "x": 0.38791489601135254,
                "y": 0.2879629135131836,
                "z": -81.58372497558594
            },
            {
                "x": 0.4170970022678375,
                "y": 0.28574398159980774,
                "z": -81.42920684814453
            },
            {
                "x": 0.44627827405929565,
                "y": 0.28307220339775085,
                "z": -81.27469635009766
            },
            {
                "x": 0.4754204750061035,
                "y": 0.2799758315086365,
                "z": -81.12023162841797
            },
            {
                "x": 0.5045586228370667,
                "y": 0.2764585018157959,
                "z": -80.965576171875
            },
            {
                "x": 0.533594012260437,
                "y": 0.2725359797477722,
                "z": -80.81111907958984
            },
            {
                "x": 0.5625435709953308,
                "y": 0.26819756627082825,
                "z": -80.65664672851562
            },
            {
                "x": 0.5914101004600525,
                "y": 0.2634667158126831,
                "z": -80.5020523071289
            },
            {
                "x": 0.6201263666152954,
                "y": 0.2583591043949127,
                "z": -80.3475570678711
            },
            {
                "x": 0.6487126350402832,
                "y": 0.25287604331970215,
                "z": -80.19293975830078
            },
            {
                "x": 0.6771241426467896,
                "y": 0.2470134198665619,
                "z": -80.0383071899414
            },
            {
                "x": 0.7053298950195312,
                "y": 0.24080140888690948,
                "z": -79.88375091552734
            },
            {
                "x": 0.7333492636680603,
                "y": 0.23424135148525238,
                "z": -79.72909545898438
            },
            {
                "x": 0.7611206769943237,
                "y": 0.2273504137992859,
                "z": -79.57449340820312
            },
            {
                "x": 0.7886363863945007,
                "y": 0.2201172113418579,
                "z": -79.41986083984375
            },
            {
                "x": 0.8159217238426208,
                "y": 0.21255716681480408,
                "z": -79.26499938964844
            },
            {
                "x": 0.8428858518600464,
                "y": 0.20469824969768524,
                "z": -79.11030578613281
            },
            {
                "x": 0.8695436716079712,
                "y": 0.19654005765914917,
                "z": -78.95558166503906
            },
            {
                "x": 0.88658607006073,
                "y": 0.19110354781150818,
                "z": -78.8555908203125
            },
            {
                "x": 0.9126973152160645,
                "y": 0.18246087431907654,
                "z": -78.70079040527344
            },
            {
                "x": 0.9384740591049194,
                "y": 0.17353612184524536,
                "z": -78.54585266113281
            },
            {
                "x": 0.9638722538948059,
                "y": 0.1643357276916504,
                "z": -78.39086151123047
            },
            {
                "x": 0.9888628721237183,
                "y": 0.15487760305404663,
                "z": -78.23590850830078
            },
            {
                "x": 1.013465404510498,
                "y": 0.14516299962997437,
                "z": -78.08080291748047
            },
            {
                "x": 1.037630319595337,
                "y": 0.1352144479751587,
                "z": -77.92576599121094
            },
            {
                "x": 1.0613497495651245,
                "y": 0.12502701580524445,
                "z": -77.77066040039062
            },
            {
                "x": 1.0846413373947144,
                "y": 0.11459808796644211,
                "z": -77.61531829833984
            },
            {
                "x": 1.1074329614639282,
                "y": 0.10396844148635864,
                "z": -77.46012115478516
            },
            {
                "x": 1.129754662513733,
                "y": 0.093128502368927,
                "z": -77.30481719970703
            },
            {
                "x": 1.1515719890594482,
                "y": 0.0820862427353859,
                "z": -77.1494369506836
            },
            {
                "x": 1.1728585958480835,
                "y": 0.07085482776165009,
                "z": -76.99406433105469
            },
            {
                "x": 1.1936558485031128,
                "y": 0.05942884460091591,
                "z": -76.83842468261719
            },
            {
                "x": 1.2138935327529907,
                "y": 0.047846220433712006,
                "z": -76.68293762207031
            },
            {
                "x": 1.2335759401321411,
                "y": 0.03609991818666458,
                "z": -76.52739715576172
            },
            {
                "x": 1.252691388130188,
                "y": 0.02418595924973488,
                "z": -76.37168884277344
            },
            {
                "x": 1.2712335586547852,
                "y": 0.01213498692959547,
                "z": -76.21601867675781
            },
            {
                "x": 1.2892117500305176,
                "y": -5.902792327105999e-05,
                "z": -76.06019592285156
            },
            {
                "x": 1.3065968751907349,
                "y": -0.012381775304675102,
                "z": -75.9043197631836
            },
            {
                "x": 1.32334566116333,
                "y": -0.024820275604724884,
                "z": -75.74848175048828
            },
            {
                "x": 1.3394938707351685,
                "y": -0.03736715018749237,
                "z": -75.59262084960938
            },
            {
                "x": 1.3550338745117188,
                "y": -0.050015710294246674,
                "z": -75.4366683959961
            },
            {
                "x": 1.3699508905410767,
                "y": -0.06275675445795059,
                "z": -75.2806625366211
            },
            {
                "x": 1.3842296600341797,
                "y": -0.0756007581949234,
                "z": -75.12442779541016
            },
            {
                "x": 1.3978575468063354,
                "y": -0.0885036289691925,
                "z": -74.96831512451172
            },
            {
                "x": 1.4108542203903198,
                "y": -0.10147610306739807,
                "z": -74.81211853027344
            },
            {
                "x": 1.4232038259506226,
                "y": -0.11450541019439697,
                "z": -74.65586853027344
            },
            {
                "x": 1.434874176979065,
                "y": -0.12758013606071472,
                "z": -74.4996337890625
            },
            {
                "x": 1.4459012746810913,
                "y": -0.14071136713027954,
                "z": -74.34315490722656
            },
            {
                "x": 1.45625901222229,
                "y": -0.15385577082633972,
                "z": -74.18682098388672
            },
            {
                "x": 1.4659504890441895,
                "y": -0.167022243142128,
                "z": -74.03045654296875
            },
            {
                "x": 1.4749698638916016,
                "y": -0.18021127581596375,
                "z": -73.87394714355469
            },
            {
                "x": 1.4833099842071533,
                "y": -0.19339454174041748,
                "z": -73.7175064086914
            },
            {
                "x": 1.490984320640564,
                "y": -0.20658060908317566,
                "z": -73.56092834472656
            },
            {
                "x": 1.4979888200759888,
                "y": -0.21975380182266235,
                "z": -73.4043197631836
            },
            {
                "x": 1.5043119192123413,
                "y": -0.23289477825164795,
                "z": -73.24778747558594
            },
            {
                "x": 1.5099469423294067,
                "y": -0.2460121214389801,
                "z": -73.09111785888672
            },
            {
                "x": 1.514905571937561,
                "y": -0.2590804100036621,
                "z": -72.93452453613281
            },
            {
                "x": 1.5191985368728638,
                "y": -0.2720993757247925,
                "z": -72.77789306640625
            },
            {
                "x": 1.522816777229309,
                "y": -0.2850748896598816,
                "z": -72.6210708618164
            },
            {
                "x": 1.5257282257080078,
                "y": -0.297964870929718,
                "z": -72.46440887451172
            },
            {
                "x": 1.5279779434204102,
                "y": -0.3107779920101166,
                "z": -72.30773162841797
            },
            {
                "x": 1.529086947441101,
                "y": -0.319011926651001,
                "z": -72.20652770996094
            },
            {
                "x": 1.5302294492721558,
                "y": -0.3316783607006073,
                "z": -72.0498275756836
            },
            {
                "x": 1.5307021141052246,
                "y": -0.34425240755081177,
                "z": -71.89301300048828
            },
            {
                "x": 1.5305187702178955,
                "y": -0.3567165732383728,
                "z": -71.7362060546875
            },
            {
                "x": 1.5296746492385864,
                "y": -0.36905601620674133,
                "z": -71.57947540283203
            },
            {
                "x": 1.528128981590271,
                "y": -0.3812725841999054,
                "z": -71.4226303100586
            },
            {
                "x": 1.5259038209915161,
                "y": -0.3933430016040802,
                "z": -71.26590728759766
            },
            {
                "x": 1.5229867696762085,
                "y": -0.4052695035934448,
                "z": -71.10917663574219
            },
            {
                "x": 1.5193562507629395,
                "y": -0.4170578122138977,
                "z": -70.95225524902344
            },
            {
                "x": 1.5150001049041748,
                "y": -0.42866382002830505,
                "z": -70.7955322265625
            },
            {
                "x": 1.5098984241485596,
                "y": -0.44009929895401,
                "z": -70.63877868652344
            },
            {
                "x": 1.5040483474731445,
                "y": -0.45135581493377686,
                "z": -70.48202514648438
            },
            {
                "x": 1.4974461793899536,
                "y": -0.4624180793762207,
                "z": -70.32535552978516
            },
            {
                "x": 1.4900497198104858,
                "y": -0.47329190373420715,
                "z": -70.16849517822266
            },
            {
                "x": 1.4818511009216309,
                "y": -0.48393988609313965,
                "z": -70.0118637084961
            },
            {
                "x": 1.4728546142578125,
                "y": -0.49437111616134644,
                "z": -69.85527801513672
            },
            {
                "x": 1.4630407094955444,
                "y": -0.5045856237411499,
                "z": -69.69860076904297
            },
            {
                "x": 1.4523921012878418,
                "y": -0.5145556926727295,
                "z": -69.54208374023438
            },
            {
                "x": 1.440863013267517,
                "y": -0.524280309677124,
                "z": -69.38551330566406
            },
            {
                "x": 1.4284709692001343,
                "y": -0.5337538123130798,
                "z": -69.22898864746094
            },
            {
                "x": 1.4152138233184814,
                "y": -0.5429606437683105,
                "z": -69.0726318359375
            },
            {
                "x": 1.4010597467422485,
                "y": -0.551895260810852,
                "z": -68.91632080078125
            },
            {
                "x": 1.3859691619873047,
                "y": -0.5605408549308777,
                "z": -68.7601089477539
            },
            {
                "x": 1.3699547052383423,
                "y": -0.5688989162445068,
                "z": -68.60395050048828
            },
            {
                "x": 1.3529778718948364,
                "y": -0.576971173286438,
                "z": -68.44770050048828
            },
            {
                "x": 1.3350588083267212,
                "y": -0.5847254991531372,
                "z": -68.29174041748047
            },
            {
                "x": 1.316124677658081,
                "y": -0.5921555757522583,
                "z": -68.13581848144531
            },
            {
                "x": 1.296202540397644,
                "y": -0.5992625951766968,
                "z": -67.98001098632812
            },
            {
                "x": 1.2752796411514282,
                "y": -0.6060352921485901,
                "z": -67.82439422607422
            },
            {
                "x": 1.2532994747161865,
                "y": -0.6124748587608337,
                "z": -67.66869354248047
            },
            {
                "x": 1.2302576303482056,
                "y": -0.6185407042503357,
                "z": -67.51333618164062
            },
            {
                "x": 1.2061635255813599,
                "y": -0.6242483854293823,
                "z": -67.3581314086914
            },
            {
                "x": 1.1809773445129395,
                "y": -0.6295934915542603,
                "z": -67.20297241210938
            },
            {
                "x": 1.1547197103500366,
                "y": -0.6345586776733398,
                "z": -67.048095703125
            },
            {
                "x": 1.1272729635238647,
                "y": -0.6391242742538452,
                "z": -66.89331817626953
            },
            {
                "x": 1.0986998081207275,
                "y": -0.6432965993881226,
                "z": -66.73873138427734
            },
            {
                "x": 1.0690076351165771,
                "y": -0.6470650434494019,
                "z": -66.58445739746094
            },
            {
                "x": 1.038138747215271,
                "y": -0.65042644739151,
                "z": -66.43028259277344
            },
            {
                "x": 1.0060536861419678,
                "y": -0.6533505916595459,
                "z": -66.27647399902344
            },
            {
                "x": 0.9727835059165955,
                "y": -0.6559404134750366,
                "z": -66.12290954589844
            },
            {
                "x": 0.9382641315460205,
                "y": -0.6582629084587097,
                "z": -65.96941375732422
            },
            {
                "x": 0.9025660753250122,
                "y": -0.6603063344955444,
                "z": -65.81639099121094
            },
            {
                "x": 0.865591287612915,
                "y": -0.6620549559593201,
                "z": -65.66366577148438
            },
            {
                "x": 0.8410473465919495,
                "y": -0.6630316972732544,
                "z": -65.565185546875
            },
            {
                "x": 0.8020297884941101,
                "y": -0.6643067002296448,
                "z": -65.41297912597656
            },
            {
                "x": 0.7616746425628662,
                "y": -0.6652748584747314,
                "z": -65.26101684570312
            },
            {
                "x": 0.7200307846069336,
                "y": -0.665934681892395,
                "z": -65.10940551757812
            },
            {
                "x": 0.6771340370178223,
                "y": -0.6662852168083191,
                "z": -64.958251953125
            },
            {
                "x": 0.6329226493835449,
                "y": -0.6663212776184082,
                "z": -64.80736541748047
            },
            {
                "x": 0.5874049067497253,
                "y": -0.6660319566726685,
                "z": -64.65697479248047
            },
            {
                "x": 0.540566623210907,
                "y": -0.6654273271560669,
                "z": -64.50699615478516
            },
            {
                "x": 0.49237629771232605,
                "y": -0.6645174026489258,
                "z": -64.35724639892578
            },
            {
                "x": 0.44295942783355713,
                "y": -0.663310170173645,
                "z": -64.2081069946289
            },
            {
                "x": 0.39216679334640503,
                "y": -0.661800742149353,
                "z": -64.05936431884766
            },
            {
                "x": 0.3400803804397583,
                "y": -0.6599994897842407,
                "z": -63.911102294921875
            },
            {
                "x": 0.2867368161678314,
                "y": -0.6579179763793945,
                "z": -63.76334762573242
            },
            {
                "x": 0.23204244673252106,
                "y": -0.6555584669113159,
                "z": -63.61585998535156
            },
            {
                "x": 0.17614692449569702,
                "y": -0.6529251337051392,
                "z": -63.469051361083984
            },
            {
                "x": 0.11897888779640198,
                "y": -0.650023341178894,
                "z": -63.322731018066406
            },
            {
                "x": 0.06057067960500717,
                "y": -0.646862268447876,
                "z": -63.17680358886719
            },
            {
                "x": 0.0010112300515174866,
                "y": -0.6434520483016968,
                "z": -63.03145980834961
            },
            {
                "x": -0.059762682765722275,
                "y": -0.6397876143455505,
                "z": -62.886505126953125
            },
            {
                "x": -0.12168514728546143,
                "y": -0.6358782052993774,
                "z": -62.74205780029297
            },
            {
                "x": -0.18463414907455444,
                "y": -0.6317375898361206,
                "z": -62.59815979003906
            },
            {
                "x": -0.24863171577453613,
                "y": -0.6273688077926636,
                "z": -62.45471954345703
            },
            {
                "x": -0.31361547112464905,
                "y": -0.6227731704711914,
                "z": -62.311737060546875
            },
            {
                "x": -0.3795474171638489,
                "y": -0.6179556846618652,
                "z": -62.169185638427734
            },
            {
                "x": -0.44642359018325806,
                "y": -0.6129210591316223,
                "z": -62.02685546875
            },
            {
                "x": -0.5139978528022766,
                "y": -0.6076875925064087,
                "z": -61.88507080078125
            },
            {
                "x": -0.5823270082473755,
                "y": -0.602249026298523,
                "z": -61.74359130859375
            },
            {
                "x": -0.6512922048568726,
                "y": -0.5966106653213501,
                "z": -61.602420806884766
            },
            {
                "x": -0.7207660675048828,
                "y": -0.590785801410675,
                "z": -61.461551666259766
            },
            {
                "x": -0.7907658219337463,
                "y": -0.5847702026367188,
                "z": -61.320716857910156
            },
            {
                "x": -0.8610093593597412,
                "y": -0.5785810947418213,
                "z": -61.18021774291992
            },
            {
                "x": -0.9314640164375305,
                "y": -0.5722140669822693,
                "z": -61.03982162475586
            },
            {
                "x": -1.0020543336868286,
                "y": -0.5656746625900269,
                "z": -60.89934158325195
            },
            {
                "x": -1.0725345611572266,
                "y": -0.5589779615402222,
                "z": -60.75892639160156
            },
            {
                "x": -1.1428656578063965,
                "y": -0.5521177053451538,
                "z": -60.618309020996094
            },
            {
                "x": -1.2128318548202515,
                "y": -0.545099675655365,
                "z": -60.47748565673828
            },
            {
                "x": -1.2822240591049194,
                "y": -0.5379397869110107,
                "z": -60.336483001708984
            },
            {
                "x": -1.3509751558303833,
                "y": -0.5306335091590881,
                "z": -60.19502258300781
            },
            {
                "x": -1.4187933206558228,
                "y": -0.5231949090957642,
                "z": -60.053199768066406
            },
            {
                "x": -1.4854981899261475,
                "y": -0.5156209468841553,
                "z": -59.910831451416016
            },
            {
                "x": -1.5509997606277466,
                "y": -0.5079131722450256,
                "z": -59.767669677734375
            },
            {
                "x": -1.6149253845214844,
                "y": -0.5000971555709839,
                "z": -59.623985290527344
            },
            {
                "x": -1.6771420240402222,
                "y": -0.492168664932251,
                "z": -59.47951889038086
            },
            {
                "x": -1.7162492275238037,
                "y": -0.4869871735572815,
                "z": -59.3857307434082
            },
            {
                "x": -1.7751047611236572,
                "y": -0.47888749837875366,
                "z": -59.23982620239258
            },
            {
                "x": -1.8317815065383911,
                "y": -0.4706922769546509,
                "z": -59.09296417236328
            },
            {
                "x": -1.886591911315918,
                "y": -0.4624132513999939,
                "z": -58.94550323486328
            },
            {
                "x": -1.9400349855422974,
                "y": -0.45406103134155273,
                "z": -58.797672271728516
            },
            {
                "x": -1.9922736883163452,
                "y": -0.44563019275665283,
                "z": -58.649314880371094
            },
            {
                "x": -2.043282985687256,
                "y": -0.43713700771331787,
                "z": -58.500640869140625
            },
            {
                "x": -2.0930795669555664,
                "y": -0.4285808801651001,
                "z": -58.35157775878906
            },
            {
                "x": -2.1417930126190186,
                "y": -0.4199574589729309,
                "z": -58.20195007324219
            },
            {
                "x": -2.189349412918091,
                "y": -0.41129550337791443,
                "z": -58.05217361450195
            },
            {
                "x": -2.235856056213379,
                "y": -0.4025850296020508,
                "z": -57.9019889831543
            },
            {
                "x": -2.2812743186950684,
                "y": -0.3938360810279846,
                "z": -57.751502990722656
            },
            {
                "x": -2.3256418704986572,
                "y": -0.3850567936897278,
                "z": -57.60075759887695
            },
            {
                "x": -2.3690717220306396,
                "y": -0.3762393593788147,
                "z": -57.44954299926758
            },
            {
                "x": -2.4114761352539062,
                "y": -0.36741143465042114,
                "z": -57.29823303222656
            },
            {
                "x": -2.452902317047119,
                "y": -0.35856688022613525,
                "z": -57.14665985107422
            },
            {
                "x": -2.493396282196045,
                "y": -0.3497065603733063,
                "z": -56.99473571777344
            },
            {
                "x": -2.532947063446045,
                "y": -0.34084731340408325,
                "z": -56.84267044067383
            },
            {
                "x": -2.571624994277954,
                "y": -0.3319835066795349,
                "z": -56.690284729003906
            },
            {
                "x": -2.609398603439331,
                "y": -0.3231261968612671,
                "z": -56.53767776489258
            },
            {
                "x": -2.6462621688842773,
                "y": -0.3142804205417633,
                "z": -56.384944915771484
            },
            {
                "x": -2.6822640895843506,
                "y": -0.3053366243839264,
                "z": -56.23200607299805
            },
            {
                "x": -2.7174251079559326,
                "y": -0.2962464392185211,
                "z": -56.078887939453125
            },
            {
                "x": -2.751746416091919,
                "y": -0.2870188057422638,
                "z": -55.92559051513672
            },
            {
                "x": -2.785266637802124,
                "y": -0.2776474356651306,
                "z": -55.77191162109375
            },
            {
                "x": -2.81793212890625,
                "y": -0.2681695222854614,
                "z": -55.61826705932617
            },
            {
                "x": -2.849818468093872,
                "y": -0.25857752561569214,
                "z": -55.464412689208984
            },
            {
                "x": -2.8809049129486084,
                "y": -0.24888165295124054,
                "z": -55.310401916503906
            },
            {
                "x": -2.9111719131469727,
                "y": -0.23909081518650055,
                "z": -55.15629577636719
            },
            {
                "x": -2.9407143592834473,
                "y": -0.22920110821723938,
                "z": -55.0018424987793
            },
            {
                "x": -2.9694526195526123,
                "y": -0.21924608945846558,
                "z": -54.847450256347656
            },
            {
                "x": -2.9974365234375,
                "y": -0.20922011137008667,
                "z": -54.69293212890625
            },
            {
                "x": -3.024667501449585,
                "y": -0.19912204146385193,
                "z": -54.53815460205078
            },
            {
                "x": -3.051133871078491,
                "y": -0.18897777795791626,
                "z": -54.383365631103516
            },
            {
                "x": -3.076892137527466,
                "y": -0.1787818819284439,
                "z": -54.22836685180664
            },
            {
                "x": -3.1019182205200195,
                "y": -0.1685481071472168,
                "z": -54.073246002197266
            },
            {
                "x": -3.126178026199341,
                "y": -0.15829044580459595,
                "z": -53.91810989379883
            },
            {
                "x": -3.1497392654418945,
                "y": -0.14800459146499634,
                "z": -53.76275634765625
            },
            {
                "x": -3.1725692749023438,
                "y": -0.13771310448646545,
                "z": -53.6074104309082
            },
            {
                "x": -3.1947021484375,
                "y": -0.12741698324680328,
                "z": -53.451961517333984
            },
            {
                "x": -3.216125249862671,
                "y": -0.11711148917675018,
                "z": -53.29621124267578
            },
            {
                "x": -3.236825704574585,
                "y": -0.10682842135429382,
                "z": -53.14055633544922
            },
            {
                "x": -3.2568273544311523,
                "y": -0.09606117755174637,
                "z": -52.98481750488281
            },
            {
                "x": -3.2693817615509033,
                "y": -0.08845623582601547,
                "z": -52.88421630859375
            },
            {
                "x": -3.2882113456726074,
                "y": -0.07565468549728394,
                "z": -52.728477478027344
            },
            {
                "x": -3.3063604831695557,
                "y": -0.061730969697237015,
                "z": -52.57265853881836
            },
            {
                "x": -3.323814868927002,
                "y": -0.04678516834974289,
                "z": -52.41686248779297
            },
            {
                "x": -3.3405601978302,
                "y": -0.030903685837984085,
                "z": -52.26118469238281
            },
            {
                "x": -3.356611967086792,
                "y": -0.014156493358314037,
                "z": -52.10541534423828
            },
            {
                "x": -3.3719770908355713,
                "y": 0.0033158077858388424,
                "z": -51.94976806640625
            },
            {
                "x": -3.3866615295410156,
                "y": 0.021434703841805458,
                "z": -51.79412841796875
            },
            {
                "x": -3.4006927013397217,
                "y": 0.040134232491254807,
                "z": -51.638309478759766
            },
            {
                "x": -3.413999557495117,
                "y": 0.0592900849878788,
                "z": -51.4826774597168
            },
            {
                "x": -3.4266531467437744,
                "y": 0.07882045954465866,
                "z": -51.32697677612305
            },
            {
                "x": -3.4386346340179443,
                "y": 0.09862785786390305,
                "z": -51.1712646484375
            },
            {
                "x": -3.4499545097351074,
                "y": 0.1186164915561676,
                "z": -51.015586853027344
            },
            {
                "x": -3.4605932235717773,
                "y": 0.13872918486595154,
                "z": -50.859676361083984
            },
            {
                "x": -3.4705593585968018,
                "y": 0.15881937742233276,
                "z": -50.70392608642578
            },
            {
                "x": -3.479860544204712,
                "y": 0.17882157862186432,
                "z": -50.548126220703125
            },
            {
                "x": -3.488510847091675,
                "y": 0.19866159558296204,
                "z": -50.392154693603516
            },
            {
                "x": -3.496483087539673,
                "y": 0.21821409463882446,
                "z": -50.23622512817383
            },
            {
                "x": -3.5037810802459717,
                "y": 0.2374086081981659,
                "z": -50.080116271972656
            },
            {
                "x": -3.510422945022583,
                "y": 0.25614842772483826,
                "z": -49.92393112182617
            },
            {
                "x": -3.5163934230804443,
                "y": 0.2743327021598816,
                "z": -49.76774597167969
            },
            {
                "x": -3.5217058658599854,
                "y": 0.2918790280818939,
                "z": -49.611473083496094
            },
            {
                "x": -3.5263214111328125,
                "y": 0.3086644113063812,
                "z": -49.45509719848633
            },
            {
                "x": -3.530273675918579,
                "y": 0.3246251344680786,
                "z": -49.29861831665039
            },
            {
                "x": -3.5335638523101807,
                "y": 0.3396871089935303,
                "z": -49.1418342590332
            },
            {
                "x": -3.5361735820770264,
                "y": 0.35371989011764526,
                "z": -48.98514175415039
            },
            {
                "x": -3.5380916595458984,
                "y": 0.3666039705276489,
                "z": -48.828285217285156
            },
            {
                "x": -3.539318323135376,
                "y": 0.37827610969543457,
                "z": -48.67133331298828
            },
            {
                "x": -3.5398101806640625,
                "y": 0.3886483907699585,
                "z": -48.514305114746094
            },
            {
                "x": -3.539318084716797,
                "y": 0.39764440059661865,
                "z": -48.35691833496094
            },
            {
                "x": -3.5374763011932373,
                "y": 0.40508827567100525,
                "z": -48.19963073730469
            },
            {
                "x": -3.534217119216919,
                "y": 0.410988986492157,
                "z": -48.04227828979492
            },
            {
                "x": -3.529472589492798,
                "y": 0.41606876254081726,
                "z": -47.8847770690918
            },
            {
                "x": -3.523226499557495,
                "y": 0.420085608959198,
                "z": -47.72742462158203
            },
            {
                "x": -3.5153391361236572,
                "y": 0.4227965474128723,
                "z": -47.570003509521484
            },
            {
                "x": -3.505805253982544,
                "y": 0.42430683970451355,
                "z": -47.412635803222656
            },
            {
                "x": -3.4946138858795166,
                "y": 0.4247177839279175,
                "z": -47.25546646118164
            },
            {
                "x": -3.4816863536834717,
                "y": 0.42411160469055176,
                "z": -47.098297119140625
            },
            {
                "x": -3.466954231262207,
                "y": 0.4225435256958008,
                "z": -46.9413948059082
            },
            {
                "x": -3.4504034519195557,
                "y": 0.42011335492134094,
                "z": -46.78466796875
            },
            {
                "x": -3.4319956302642822,
                "y": 0.4169149100780487,
                "z": -46.6279411315918
            },
            {
                "x": -3.4117538928985596,
                "y": 0.4130382239818573,
                "z": -46.47166061401367
            },
            {
                "x": -3.3895812034606934,
                "y": 0.40854620933532715,
                "z": -46.31564712524414
            },
            {
                "x": -3.374232292175293,
                "y": 0.4053584933280945,
                "z": -46.21501922607422
            },
            {
                "x": -3.3489556312561035,
                "y": 0.4000619053840637,
                "z": -46.05950164794922
            },
            {
                "x": -3.3217577934265137,
                "y": 0.3943764865398407,
                "z": -45.904212951660156
            },
            {
                "x": -3.292656660079956,
                "y": 0.38838690519332886,
                "z": -45.7492790222168
            },
            {
                "x": -3.2617604732513428,
                "y": 0.38218963146209717,
                "z": -45.59480667114258
            },
            {
                "x": -3.2290804386138916,
                "y": 0.3758563697338104,
                "z": -45.44061279296875
            },
            {
                "x": -3.1947062015533447,
                "y": 0.3694761395454407,
                "z": -45.28689956665039
            },
            {
                "x": -3.1586666107177734,
                "y": 0.36312922835350037,
                "z": -45.13360595703125
            },
            {
                "x": -3.121068000793457,
                "y": 0.35688769817352295,
                "z": -44.9804801940918
            },
            {
                "x": -3.0821242332458496,
                "y": 0.35084640979766846,
                "z": -44.827919006347656
            },
            {
                "x": -3.041884660720825,
                "y": 0.3450770974159241,
                "z": -44.6756591796875
            },
            {
                "x": -3.000476360321045,
                "y": 0.3396749198436737,
                "z": -44.52373123168945
            },
            {
                "x": -2.9581096172332764,
                "y": 0.3347086012363434,
                "z": -44.37214279174805
            },
            {
                "x": -2.9148762226104736,
                "y": 0.3302498757839203,
                "z": -44.22062683105469
            },
            {
                "x": -2.871044158935547,
                "y": 0.3263937830924988,
                "z": -44.06951141357422
            },
            {
                "x": -2.8267252445220947,
                "y": 0.32323968410491943,
                "z": -43.9185676574707
            },
            {
                "x": -2.7820746898651123,
                "y": 0.3208409547805786,
                "z": -43.76762771606445
            },
            {
                "x": -2.737325668334961,
                "y": 0.31928080320358276,
                "z": -43.61687469482422
            },
            {
                "x": -2.6925852298736572,
                "y": 0.31864339113235474,
                "z": -43.46603775024414
            },
            {
                "x": -2.6480541229248047,
                "y": 0.3190529942512512,
                "z": -43.315185546875
            },
            {
                "x": -2.6039113998413086,
                "y": 0.320548951625824,
                "z": -43.164363861083984
            },
            {
                "x": -2.5602738857269287,
                "y": 0.32321229577064514,
                "z": -43.01344680786133
            },
            {
                "x": -2.5172736644744873,
                "y": 0.3267836570739746,
                "z": -42.8624382019043
            },
            {
                "x": -2.4750611782073975,
                "y": 0.330338716506958,
                "z": -42.711238861083984
            },
            {
                "x": -2.43365478515625,
                "y": 0.33379656076431274,
                "z": -42.55964660644531
            },
            {
                "x": -2.3932526111602783,
                "y": 0.33714520931243896,
                "z": -42.40800857543945
            },
            {
                "x": -2.3538615703582764,
                "y": 0.34038734436035156,
                "z": -42.25606918334961
            },
            {
                "x": -2.3156344890594482,
                "y": 0.3435131311416626,
                "z": -42.10384750366211
            },
            {
                "x": -2.2785823345184326,
                "y": 0.34652358293533325,
                "z": -41.95140075683594
            },
            {
                "x": -2.2426939010620117,
                "y": 0.34942013025283813,
                "z": -41.798484802246094
            },
            {
                "x": -2.208099126815796,
                "y": 0.3521919250488281,
                "z": -41.64548873901367
            },
            {
                "x": -2.174844741821289,
                "y": 0.3548339307308197,
                "z": -41.49219512939453
            },
            {
                "x": -2.1428604125976562,
                "y": 0.3573499321937561,
                "z": -41.33852005004883
            },
            {
                "x": -2.1121978759765625,
                "y": 0.35973280668258667,
                "z": -41.184696197509766
            },
            {
                "x": -2.082832098007202,
                "y": 0.36198264360427856,
                "z": -41.030517578125
            },
            {
                "x": -2.0548408031463623,
                "y": 0.36408835649490356,
                "z": -40.87608337402344
            },
            {
                "x": -2.028165578842163,
                "y": 0.3660506010055542,
                "z": -40.72151184082031
            },
            {
                "x": -2.0027694702148438,
                "y": 0.3678690195083618,
                "z": -40.56660461425781
            },
            {
                "x": -1.9786655902862549,
                "y": 0.3695383071899414,
                "z": -40.411598205566406
            },
            {
                "x": -1.9558731317520142,
                "y": 0.3710489869117737,
                "z": -40.25638961791992
            },
            {
                "x": -1.9343022108078003,
                "y": 0.372405469417572,
                "z": -40.10079574584961
            },
            {
                "x": -1.9139702320098877,
                "y": 0.37360134720802307,
                "z": -39.94524002075195
            },
            {
                "x": -1.8948042392730713,
                "y": 0.3746350407600403,
                "z": -39.78951644897461
            },
            {
                "x": -1.88313627243042,
                "y": 0.3752092123031616,
                "z": -39.6888427734375
            },
            {
                "x": -1.865939974784851,
                "y": 0.3759634494781494,
                "z": -39.532875061035156
            },
            {
                "x": -1.8498643636703491,
                "y": 0.3765472173690796,
                "z": -39.37668991088867
            },
            {
                "x": -1.8348829746246338,
                "y": 0.37695106863975525,
                "z": -39.220375061035156
            },
            {
                "x": -1.8208935260772705,
                "y": 0.3771735429763794,
                "z": -39.06404113769531
            },
            {
                "x": -1.8079923391342163,
                "y": 0.37721502780914307,
                "z": -38.90758514404297
            },
            {
                "x": -1.7962889671325684,
                "y": 0.37707453966140747,
                "z": -38.75114059448242
            },
            {
                "x": -1.7859045267105103,
                "y": 0.376750111579895,
                "z": -38.59464645385742
            },
            {
                "x": -1.7769802808761597,
                "y": 0.37624555826187134,
                "z": -38.43790817260742
            },
            {
                "x": -1.7696434259414673,
                "y": 0.37556973099708557,
                "z": -38.281333923339844
            },
            {
                "x": -1.7639966011047363,
                "y": 0.3747249245643616,
                "z": -38.124656677246094
            },
            {
                "x": -1.7601947784423828,
                "y": 0.3737105429172516,
                "z": -37.967960357666016
            },
            {
                "x": -1.7583098411560059,
                "y": 0.37253111600875854,
                "z": -37.811309814453125
            },
            {
                "x": -1.7583465576171875,
                "y": 0.3711918294429779,
                "z": -37.65446472167969
            },
            {
                "x": -1.7603389024734497,
                "y": 0.3696994483470917,
                "z": -37.49783706665039
            },
            {
                "x": -1.7643375396728516,
                "y": 0.36805206537246704,
                "z": -37.34123992919922
            },
            {
                "x": -1.7703369855880737,
                "y": 0.36625242233276367,
                "z": -37.18461608886719
            },
            {
                "x": -1.7782471179962158,
                "y": 0.3643099367618561,
                "z": -37.028167724609375
            },
            {
                "x": -1.7880380153656006,
                "y": 0.36222490668296814,
                "z": -36.87171173095703
            },
            {
                "x": -1.799688696861267,
                "y": 0.3599996566772461,
                "z": -36.71537399291992
            },
            {
                "x": -1.813131332397461,
                "y": 0.3576383590698242,
                "z": -36.55926513671875
            },
            {
                "x": -1.8282533884048462,
                "y": 0.35514676570892334,
                "z": -36.40328598022461
            },
            {
                "x": -1.8449839353561401,
                "y": 0.35252809524536133,
                "z": -36.24745178222656
            },
            {
                "x": -1.8632735013961792,
                "y": 0.3497830033302307,
                "z": -36.091773986816406
            },
            {
                "x": -1.8830841779708862,
                "y": 0.3469107449054718,
                "z": -35.936065673828125
            },
            {
                "x": -1.904248833656311,
                "y": 0.3439246416091919,
                "z": -35.78071975708008
            },
            {
                "x": -1.9267206192016602,
                "y": 0.34082406759262085,
                "z": -35.625484466552734
            },
            {
                "x": -1.9504467248916626,
                "y": 0.3376103937625885,
                "z": -35.47040557861328
            },
            {
                "x": -1.9753642082214355,
                "y": 0.33428755402565,
                "z": -35.3155517578125
            },
            {
                "x": -2.001406669616699,
                "y": 0.33085620403289795,
                "z": -35.160675048828125
            },
            {
                "x": -2.028446912765503,
                "y": 0.3273283839225769,
                "z": -35.00614929199219
            },
            {
                "x": -2.0564773082733154,
                "y": 0.32370150089263916,
                "z": -34.85179138183594
            },
            {
                "x": -2.0854721069335938,
                "y": 0.3199741244316101,
                "z": -34.69746780395508
            },
            {
                "x": -2.1153130531311035,
                "y": 0.31615838408470154,
                "z": -34.54342269897461
            },
            {
                "x": -2.1459860801696777,
                "y": 0.3122521936893463,
                "z": -34.38942337036133
            },
            {
                "x": -2.177435874938965,
                "y": 0.3082599937915802,
                "z": -34.235565185546875
            },
            {
                "x": -2.209620714187622,
                "y": 0.3041854500770569,
                "z": -34.08195495605469
            },
            {
                "x": -2.242514133453369,
                "y": 0.3000297546386719,
                "z": -33.928375244140625
            },
            {
                "x": -2.276029348373413,
                "y": 0.29580143094062805,
                "z": -33.7750244140625
            },
            {
                "x": -2.310161590576172,
                "y": 0.2915002405643463,
                "z": -33.621803283691406
            },
            {
                "x": -2.3449370861053467,
                "y": 0.2871217727661133,
                "z": -33.46852111816406
            },
            {
                "x": -2.3802177906036377,
                "y": 0.2826830744743347,
                "z": -33.31554412841797
            },
            {
                "x": -2.4160149097442627,
                "y": 0.27818164229393005,
                "z": -33.16268539428711
            },
            {
                "x": -2.4394004344940186,
                "y": 0.27524083852767944,
                "z": -33.06398391723633
            },
            {
                "x": -2.4758331775665283,
                "y": 0.27063632011413574,
                "z": -32.91111373901367
            },
            {
                "x": -2.512125015258789,
                "y": 0.2659684419631958,
                "z": -32.75798034667969
            },
            {
                "x": -2.5480260848999023,
                "y": 0.2612453103065491,
                "z": -32.6047248840332
            },
            {
                "x": -2.5834195613861084,
                "y": 0.2564714550971985,
                "z": -32.45143508911133
            },
            {
                "x": -2.6183178424835205,
                "y": 0.2516457438468933,
                "z": -32.297889709472656
            },
            {
                "x": -2.6526005268096924,
                "y": 0.24677810072898865,
                "z": -32.14430236816406
            },
            {
                "x": -2.6862266063690186,
                "y": 0.24186837673187256,
                "z": -31.990549087524414
            },
            {
                "x": -2.719130277633667,
                "y": 0.2369116246700287,
                "z": -31.83639907836914
            },
            {
                "x": -2.751173973083496,
                "y": 0.2319255918264389,
                "z": -31.6822509765625
            },
            {
                "x": -2.782344102859497,
                "y": 0.22690516710281372,
                "z": -31.52783203125
            },
            {
                "x": -2.8125483989715576,
                "y": 0.22185571491718292,
                "z": -31.373193740844727
            },
            {
                "x": -2.8416566848754883,
                "y": 0.21678172051906586,
                "z": -31.218387603759766
            },
            {
                "x": -2.8696677684783936,
                "y": 0.2116791307926178,
                "z": -31.06314468383789
            },
            {
                "x": -2.896449565887451,
                "y": 0.20656442642211914,
                "z": -30.907861709594727
            },
            {
                "x": -2.921971559524536,
                "y": 0.2014348804950714,
                "z": -30.752347946166992
            },
            {
                "x": -2.9461395740509033,
                "y": 0.19628994166851044,
                "z": -30.596477508544922
            },
            {
                "x": -2.9688897132873535,
                "y": 0.19114139676094055,
                "z": -30.44049835205078
            },
            {
                "x": -2.9902241230010986,
                "y": 0.18598587810993195,
                "z": -30.284194946289062
            },
            {
                "x": -3.0100903511047363,
                "y": 0.1808304637670517,
                "z": -30.127685546875
            },
            {
                "x": -3.0283989906311035,
                "y": 0.17568230628967285,
                "z": -29.9710750579834
            },
            {
                "x": -3.0451674461364746,
                "y": 0.17054221034049988,
                "z": -29.814287185668945
            },
            {
                "x": -3.060412645339966,
                "y": 0.1654137521982193,
                "z": -29.6573429107666
            },
            {
                "x": -3.0741350650787354,
                "y": 0.1602836549282074,
                "z": -29.500261306762695
            },
            {
                "x": -3.0863137245178223,
                "y": 0.15429143607616425,
                "z": -29.34292221069336
            },
            {
                "x": -3.0969533920288086,
                "y": 0.1469642072916031,
                "z": -29.18573570251465
            },
            {
                "x": -3.1061341762542725,
                "y": 0.13840356469154358,
                "z": -29.028472900390625
            },
            {
                "x": -3.113884925842285,
                "y": 0.1287025362253189,
                "z": -28.871204376220703
            },
            {
                "x": -3.1202139854431152,
                "y": 0.11793279647827148,
                "z": -28.714012145996094
            },
            {
                "x": -3.125180244445801,
                "y": 0.10617321729660034,
                "z": -28.55665397644043
            },
            {
                "x": -3.1288540363311768,
                "y": 0.0935700386762619,
                "z": -28.39954376220703
            },
            {
                "x": -3.131293535232544,
                "y": 0.08019965887069702,
                "z": -28.242483139038086
            },
            {
                "x": -3.1325340270996094,
                "y": 0.06613311171531677,
                "z": -28.08537483215332
            },
            {
                "x": -3.1326119899749756,
                "y": 0.05147811397910118,
                "z": -27.928443908691406
            },
            {
                "x": -3.1316237449645996,
                "y": 0.03632619231939316,
                "z": -27.771480560302734
            },
            {
                "x": -3.129620313644409,
                "y": 0.020777400583028793,
                "z": -27.614587783813477
            },
            {
                "x": -3.126645803451538,
                "y": 0.0052376389503479,
                "z": -27.457786560058594
            },
            {
                "x": -3.1227192878723145,
                "y": -0.008920750580728054,
                "z": -27.30076026916504
            },
            {
                "x": -3.117926597595215,
                "y": -0.021612290292978287,
                "z": -27.143762588500977
            },
            {
                "x": -3.112318754196167,
                "y": -0.03291725739836693,
                "z": -26.98670196533203
            },
            {
                "x": -3.105919599533081,
                "y": -0.04291980713605881,
                "z": -26.829389572143555
            },
            {
                "x": -3.098625659942627,
                "y": -0.05161361023783684,
                "z": -26.67218589782715
            },
            {
                "x": -3.0904018878936768,
                "y": -0.05914274603128433,
                "z": -26.514968872070312
            },
            {
                "x": -3.0846071243286133,
                "y": -0.06344065070152283,
                "z": -26.41339111328125
            },
            {
                "x": -3.074695587158203,
                "y": -0.06919540464878082,
                "z": -26.256135940551758
            },
            {
                "x": -3.063617467880249,
                "y": -0.07397501170635223,
                "z": -26.09879493713379
            },
            {
                "x": -3.051352024078369,
                "y": -0.07786311209201813,
                "z": -25.94150733947754
            },
            {
                "x": -3.037858247756958,
                "y": -0.08093204349279404,
                "z": -25.784385681152344
            },
            {
                "x": -3.023043394088745,
                "y": -0.08323787152767181,
                "z": -25.627239227294922
            },
            {
                "x": -3.0068955421447754,
                "y": -0.08486767113208771,
                "z": -25.47031593322754
            },
            {
                "x": -2.989372730255127,
                "y": -0.08590872585773468,
                "z": -25.31351661682129
            },
            {
                "x": -2.970398187637329,
                "y": -0.08643501996994019,
                "z": -25.156661987304688
            },
            {
                "x": -2.9499449729919434,
                "y": -0.08650687336921692,
                "z": -25.000164031982422
            },
            {
                "x": -2.9279427528381348,
                "y": -0.08620843291282654,
                "z": -24.843814849853516
            },
            {
                "x": -2.9043638706207275,
                "y": -0.0856204628944397,
                "z": -24.68767738342285
            },
            {
                "x": -2.8791964054107666,
                "y": -0.08481656014919281,
                "z": -24.531814575195312
            },
            {
                "x": -2.852290391921997,
                "y": -0.08408184349536896,
                "z": -24.37606430053711
            },
            {
                "x": -2.823690414428711,
                "y": -0.08464162051677704,
                "z": -24.220806121826172
            },
            {
                "x": -2.7933497428894043,
                "y": -0.08627855032682419,
                "z": -24.06584358215332
            },
            {
                "x": -2.761202573776245,
                "y": -0.08698992431163788,
                "z": -23.911043167114258
            },
            {
                "x": -2.727224588394165,
                "y": -0.08621922135353088,
                "z": -23.75674819946289
            },
            {
                "x": -2.691371440887451,
                "y": -0.08406557142734528,
                "z": -23.602767944335938
            },
            {
                "x": -2.65366792678833,
                "y": -0.08076660335063934,
                "z": -23.449260711669922
            },
            {
                "x": -2.614203691482544,
                "y": -0.07757346332073212,
                "z": -23.296445846557617
            },
            {
                "x": -2.5737547874450684,
                "y": -0.07496602833271027,
                "z": -23.14427375793457
            },
            {
                "x": -2.5327377319335938,
                "y": -0.07285003364086151,
                "z": -22.992273330688477
            },
            {
                "x": -2.491149425506592,
                "y": -0.07113099098205566,
                "z": -22.840417861938477
            },
            {
                "x": -2.4489238262176514,
                "y": -0.06972699612379074,
                "z": -22.68851661682129
            },
            {
                "x": -2.406142234802246,
                "y": -0.06856617331504822,
                "z": -22.536968231201172
            },
            {
                "x": -2.3627512454986572,
                "y": -0.06756007671356201,
                "z": -22.38554573059082
            },
            {
                "x": -2.3188040256500244,
                "y": -0.06662406027317047,
                "z": -22.234291076660156
            },
            {
                "x": -2.2743630409240723,
                "y": -0.06567948311567307,
                "z": -22.08325958251953
            },
            {
                "x": -2.2293941974639893,
                "y": -0.0646391287446022,
                "z": -21.93219757080078
            },
            {
                "x": -2.184098482131958,
                "y": -0.06342560052871704,
                "z": -21.781476974487305
            },
            {
                "x": -2.1385061740875244,
                "y": -0.061961546540260315,
                "z": -21.630882263183594
            },
            {
                "x": -2.0926742553710938,
                "y": -0.06016360595822334,
                "z": -21.480283737182617
            },
            {
                "x": -2.0467793941497803,
                "y": -0.05798816308379173,
                "z": -21.329879760742188
            },
            {
                "x": -2.00087571144104,
                "y": -0.055487871170043945,
                "z": -21.179431915283203
            },
            {
                "x": -1.9551092386245728,
                "y": -0.0525931641459465,
                "z": -21.029003143310547
            },
            {
                "x": -1.9096431732177734,
                "y": -0.04921538755297661,
                "z": -20.87864875793457
            },
            {
                "x": -1.8645368814468384,
                "y": -0.04528557136654854,
                "z": -20.728139877319336
            },
            {
                "x": -1.8199677467346191,
                "y": -0.040749285370111465,
                "z": -20.577655792236328
            },
            {
                "x": -1.7760218381881714,
                "y": -0.0355253666639328,
                "z": -20.42705535888672
            },
            {
                "x": -1.7327895164489746,
                "y": -0.029514195397496223,
                "z": -20.276119232177734
            },
            {
                "x": -1.6904404163360596,
                "y": -0.02286151796579361,
                "z": -20.125232696533203
            },
            {
                "x": -1.6490027904510498,
                "y": -0.01681668311357498,
                "z": -19.97414779663086
            },
            {
                "x": -1.622789740562439,
                "y": -0.013542800210416317,
                "z": -19.876399993896484
            },
            {
                "x": -1.5830321311950684,
                "y": -0.009428892284631729,
                "z": -19.7248592376709
            },
            {
                "x": -1.5443358421325684,
                "y": -0.006589123513549566,
                "z": -19.57293701171875
            },
            {
                "x": -1.5068217515945435,
                "y": -0.005192012991756201,
                "z": -19.42072105407715
            },
            {
                "x": -1.470475673675537,
                "y": -0.004999998025596142,
                "z": -19.268301010131836
            },
            {
                "x": -1.4352823495864868,
                "y": -0.005000000353902578,
                "z": -19.115488052368164
            },
            {
                "x": -1.4013354778289795,
                "y": -0.005000004079192877,
                "z": -18.96249771118164
            },
            {
                "x": -1.3685815334320068,
                "y": -0.005000000353902578,
                "z": -18.80925750732422
            },
            {
                "x": -1.3369601964950562,
                "y": -0.004999998491257429,
                "z": -18.65555763244629
            },
            {
                "x": -1.3065052032470703,
                "y": -0.004999998491257429,
                "z": -18.501808166503906
            },
            {
                "x": -1.2772129774093628,
                "y": -0.005000002682209015,
                "z": -18.34777069091797
            },
            {
                "x": -1.2489711046218872,
                "y": -0.004999998491257429,
                "z": -18.193506240844727
            },
            {
                "x": -1.2217696905136108,
                "y": -0.005000004079192877,
                "z": -18.03910255432129
            },
            {
                "x": -1.195500373840332,
                "y": -0.005000001285225153,
                "z": -17.884305953979492
            },
            {
                "x": -1.1702193021774292,
                "y": -0.005000002216547728,
                "z": -17.729515075683594
            },
            {
                "x": -1.14577317237854,
                "y": -0.005000000819563866,
                "z": -17.574575424194336
            },
            {
                "x": -1.122091293334961,
                "y": -0.004999998956918716,
                "z": -17.419368743896484
            },
            {
                "x": -1.0991731882095337,
                "y": -0.004999999888241291,
                "z": -17.26412582397461
            },
            {
                "x": -1.076891303062439,
                "y": -0.004999996162950993,
                "z": -17.108665466308594
            },
            {
                "x": -1.055181860923767,
                "y": -0.005000000819563866,
                "z": -16.953086853027344
            },
            {
                "x": -1.0339921712875366,
                "y": -0.004999998025596142,
                "z": -16.797500610351562
            },
            {
                "x": -1.0132520198822021,
                "y": -0.004999998956918716,
                "z": -16.641820907592773
            },
            {
                "x": -0.9928702116012573,
                "y": -0.004999999888241291,
                "z": -16.486066818237305
            },
            {
                "x": -0.9727676510810852,
                "y": -0.005000001285225153,
                "z": -16.330242156982422
            },
            {
                "x": -0.9528477191925049,
                "y": -0.00500000175088644,
                "z": -16.174158096313477
            },
            {
                "x": -0.9330838322639465,
                "y": -0.004999999422580004,
                "z": -16.018218994140625
            },
            {
                "x": -0.913353681564331,
                "y": -0.00500000175088644,
                "z": -15.86217212677002
            },
            {
                "x": -0.8936249613761902,
                "y": -0.004999995231628418,
                "z": -15.706189155578613
            },
            {
                "x": -0.8744115829467773,
                "y": -0.004999999888241291,
                "z": -15.550509452819824
            },
            {
                "x": -0.8560760617256165,
                "y": -0.00500000175088644,
                "z": -15.394522666931152
            },
            {
                "x": -0.838486909866333,
                "y": -0.00499999662861228,
                "z": -15.238577842712402
            },
            {
                "x": -0.8214653730392456,
                "y": -0.005000002682209015,
                "z": -15.08250904083252
            },
            {
                "x": -0.8048695921897888,
                "y": -0.004999998491257429,
                "z": -14.926214218139648
            },
            {
                "x": -0.788602352142334,
                "y": -0.005000000353902578,
                "z": -14.76994514465332
            },
            {
                "x": -0.772510290145874,
                "y": -0.005000002216547728,
                "z": -14.61349868774414
            },
            {
                "x": -0.7565039992332458,
                "y": -0.005000005476176739,
                "z": -14.457015991210938
            },
            {
                "x": -0.7405616641044617,
                "y": -0.004999998025596142,
                "z": -14.300614356994629
            },
            {
                "x": -0.7246415615081787,
                "y": -0.005000003147870302,
                "z": -14.144094467163086
            },
            {
                "x": -0.7087463736534119,
                "y": -0.005000004544854164,
                "z": -13.987674713134766
            },
            {
                "x": -0.6928504109382629,
                "y": -0.005000001285225153,
                "z": -13.831242561340332
            },
            {
                "x": -0.6769203543663025,
                "y": -0.005000004544854164,
                "z": -13.674612998962402
            },
            {
                "x": -0.6609852910041809,
                "y": -0.004999997094273567,
                "z": -13.518177032470703
            },
            {
                "x": -0.6450132727622986,
                "y": -0.005000000819563866,
                "z": -13.361740112304688
            },
            {
                "x": -0.6346743106842041,
                "y": -0.004999998491257429,
                "z": -13.260688781738281
            },
            {
                "x": -0.6186242699623108,
                "y": -0.0050000036135315895,
                "z": -13.104255676269531
            },
            {
                "x": -0.6025068163871765,
                "y": -0.004999999888241291,
                "z": -12.947723388671875
            },
            {
                "x": -0.5863308310508728,
                "y": -0.005000000353902578,
                "z": -12.791197776794434
            },
            {
                "x": -0.5701066851615906,
                "y": -0.00500000175088644,
                "z": -12.634778022766113
            },
            {
                "x": -0.553809404373169,
                "y": -0.005000004079192877,
                "z": -12.478253364562988
            },
            {
                "x": -0.5374622344970703,
                "y": -0.005000000353902578,
                "z": -12.321847915649414
            },
            {
                "x": -0.5210541486740112,
                "y": -0.00500000175088644,
                "z": -12.165446281433105
            },
            {
                "x": -0.5045654773712158,
                "y": -0.005000000819563866,
                "z": -12.008851051330566
            },
            {
                "x": -0.48803985118865967,
                "y": -0.005000000353902578,
                "z": -11.852460861206055
            },
            {
                "x": -0.47129905223846436,
                "y": -0.005000002682209015,
                "z": -11.69583511352539
            },
            {
                "x": -0.4538179337978363,
                "y": -0.00500000175088644,
                "z": -11.539132118225098
            },
            {
                "x": -0.43557313084602356,
                "y": -0.004999998956918716,
                "z": -11.382604598999023
            },
            {
                "x": -0.4165880084037781,
                "y": -0.005000004079192877,
                "z": -11.225996017456055
            },
            {
                "x": -0.39700692892074585,
                "y": -0.005000004544854164,
                "z": -11.069696426391602
            },
            {
                "x": -0.3768734931945801,
                "y": -0.005000002682209015,
                "z": -10.913496971130371
            },
            {
                "x": -0.3562262952327728,
                "y": -0.004999999422580004,
                "z": -10.757292747497559
            },
            {
                "x": -0.3351707458496094,
                "y": -0.004999998025596142,
                "z": -10.601284980773926
            },
            {
                "x": -0.3137539327144623,
                "y": -0.004999998491257429,
                "z": -10.445258140563965
            },
            {
                "x": -0.29205504059791565,
                "y": -0.005000000819563866,
                "z": -10.289300918579102
            },
            {
                "x": -0.2701936662197113,
                "y": -0.005000003147870302,
                "z": -10.133614540100098
            },
            {
                "x": -0.2488132119178772,
                "y": -0.00500000175088644,
                "z": -9.978195190429688
            },
            {
                "x": -0.22818458080291748,
                "y": -0.00500000175088644,
                "z": -9.822705268859863
            },
            {
                "x": -0.2083183377981186,
                "y": -0.004999999888241291,
                "z": -9.66711711883545
            },
            {
                "x": -0.18921241164207458,
                "y": -0.004999998025596142,
                "z": -9.511238098144531
            },
            {
                "x": -0.17088694870471954,
                "y": -0.0049999975599348545,
                "z": -9.35546588897705
            },
            {
                "x": -0.15331096947193146,
                "y": -0.005000002682209015,
                "z": -9.199552536010742
            },
            {
                "x": -0.1365152895450592,
                "y": -0.005000005476176739,
                "z": -9.043551445007324
            },
            {
                "x": -0.1204894632101059,
                "y": -0.005000002682209015,
                "z": -8.887523651123047
            },
            {
                "x": -0.1051875576376915,
                "y": -0.004999995231628418,
                "z": -8.731217384338379
            },
            {
                "x": -0.09064190834760666,
                "y": -0.004999997094273567,
                "z": -8.575035095214844
            },
            {
                "x": -0.0768580213189125,
                "y": -0.005000004544854164,
                "z": -8.418780326843262
            },
            {
                "x": -0.06377426534891129,
                "y": -0.004999999888241291,
                "z": -8.262338638305664
            },
            {
                "x": -0.051394060254096985,
                "y": -0.005000006407499313,
                "z": -8.105951309204102
            },
            {
                "x": -0.03969487547874451,
                "y": -0.004999997094273567,
                "z": -7.949399471282959
            },
            {
                "x": -0.028666067868471146,
                "y": -0.004999998025596142,
                "z": -7.792786121368408
            },
            {
                "x": -0.018263470381498337,
                "y": -0.004999997094273567,
                "z": -7.6362080574035645
            },
            {
                "x": -0.008396565914154053,
                "y": -0.005000004544854164,
                "z": -7.47942590713501
            },
            {
                "x": 0.0010600276291370392,
                "y": -0.00500000175088644,
                "z": -7.3226399421691895
            },
            {
                "x": 0.010296468622982502,
                "y": -0.004999998956918716,
                "z": -7.165752410888672
            },
            {
                "x": 0.019498156383633614,
                "y": -0.005000002682209015,
                "z": -7.008570671081543
            },
            {
                "x": 0.0288181621581316,
                "y": -0.004999996162950993,
                "z": -6.851504802703857
            },
            {
                "x": 0.0384746715426445,
                "y": -0.004999994300305843,
                "z": -6.6943559646606445
            },
            {
                "x": 0.044955380260944366,
                "y": -0.005000000819563866,
                "z": -6.592858791351318
            },
            {
                "x": 0.0550120547413826,
                "y": -0.004999998956918716,
                "z": -6.4362311363220215
            },
            {
                "x": 0.06366118788719177,
                "y": -0.00500000175088644,
                "z": -6.280084609985352
            },
            {
                "x": 0.07040588557720184,
                "y": -0.005000005476176739,
                "z": -6.12390661239624
            },
            {
                "x": 0.07529127597808838,
                "y": -0.0050000036135315895,
                "z": -5.967713832855225
            },
            {
                "x": 0.07840478420257568,
                "y": -0.004999998025596142,
                "z": -5.811233043670654
            },
            {
                "x": 0.08051062375307083,
                "y": -0.004999999888241291,
                "z": -5.654222011566162
            },
            {
                "x": 0.08243891596794128,
                "y": -0.004999999888241291,
                "z": -5.497078895568848
            },
            {
                "x": 0.08424092829227448,
                "y": -0.00500000175088644,
                "z": -5.339724063873291
            },
            {
                "x": 0.08591760694980621,
                "y": -0.00500000175088644,
                "z": -5.182565689086914
            },
            {
                "x": 0.08741777390241623,
                "y": -0.005000000819563866,
                "z": -5.025538444519043
            },
            {
                "x": 0.08781884610652924,
                "y": -0.004999998956918716,
                "z": -4.869045257568359
            },
            {
                "x": 0.08672896772623062,
                "y": -0.005000000819563866,
                "z": -4.712568283081055
            },
            {
                "x": 0.08433668315410614,
                "y": -0.005000000819563866,
                "z": -4.555798053741455
            },
            {
                "x": 0.08081134408712387,
                "y": -0.005000000819563866,
                "z": -4.399135112762451
            },
            {
                "x": 0.07640792429447174,
                "y": -0.005000004544854164,
                "z": -4.2423858642578125
            },
            {
                "x": 0.07132141292095184,
                "y": -0.0050000036135315895,
                "z": -4.085440635681152
            },
            {
                "x": 0.06575481593608856,
                "y": -0.004999998956918716,
                "z": -3.9285147190093994
            },
            {
                "x": 0.05989772453904152,
                "y": -0.00500000175088644,
                "z": -3.771378755569458
            },
            {
                "x": 0.0539843887090683,
                "y": -0.004999999888241291,
                "z": -3.614133834838867
            },
            {
                "x": 0.048126086592674255,
                "y": -0.004999992437660694,
                "z": -3.457085132598877
            },
            {
                "x": 0.041937205940485,
                "y": -0.005000004544854164,
                "z": -3.3001809120178223
            },
            {
                "x": 0.03542083874344826,
                "y": -0.005000002682209015,
                "z": -3.143214464187622
            },
            {
                "x": 0.028740089386701584,
                "y": -0.00500000175088644,
                "z": -2.986170530319214
            },
            {
                "x": 0.022047443315386772,
                "y": -0.005000007338821888,
                "z": -2.8288397789001465
            },
            {
                "x": 0.015509983524680138,
                "y": -0.004999998956918716,
                "z": -2.671614408493042
            },
            {
                "x": 0.009303689934313297,
                "y": -0.0050000036135315895,
                "z": -2.5142290592193604
            },
            {
                "x": 0.003564487909898162,
                "y": -0.00500000175088644,
                "z": -2.356788158416748
            },
            {
                "x": -0.0017719021998345852,
                "y": -0.004999999888241291,
                "z": -2.1994831562042236
            },
            {
                "x": -0.006916445679962635,
                "y": -0.004999998956918716,
                "z": -2.0420846939086914
            },
            {
                "x": -0.012065956369042397,
                "y": -0.004999999888241291,
                "z": -1.8850035667419434
            },
            {
                "x": -0.017423277720808983,
                "y": -0.005000005476176739,
                "z": -1.7280324697494507
            },
            {
                "x": -0.02316884696483612,
                "y": -0.005000002682209015,
                "z": -1.5710529088974
            },
            {
                "x": -0.029457056894898415,
                "y": -0.004999999888241291,
                "z": -1.4142974615097046
            },
            {
                "x": -0.03646720200777054,
                "y": -0.005000000819563866,
                "z": -1.2575461864471436
            },
            {
                "x": -0.04427456483244896,
                "y": -0.005000004544854164,
                "z": -1.1008793115615845
            },
            {
                "x": -0.05282142013311386,
                "y": -0.005000002682209015,
                "z": -0.9441090226173401
            },
            {
                "x": -0.06144044175744057,
                "y": -0.0050000036135315895,
                "z": -0.7869221568107605
            },
            {
                "x": -0.06979410350322723,
                "y": -0.004999998956918716,
                "z": -0.6296924352645874
            },
            {
                "x": -0.07758630067110062,
                "y": -0.00500000175088644,
                "z": -0.4721963703632355
            },
            {
                "x": -0.08426941186189651,
                "y": -0.004999998956918716,
                "z": -0.31401774287223816
            },
            {
                "x": -0.08877890557050705,
                "y": -0.00500000175088644,
                "z": -0.15516065061092377
            },
            {
                "x": -0.08916845172643661,
                "y": -0.00500000175088644,
                "z": 0.0045634107664227486
            }
        ],
        "lane3":[
            {
                "x": 0.02653604745864868,
                "y": 0.015556402504444122,
                "z": -419.5830078125
            },
            {
                "x": 0.02641722559928894,
                "y": 0.015551343560218811,
                "z": -419.47821044921875
            },
            {
                "x": 0.026239007711410522,
                "y": 0.015543721616268158,
                "z": -419.32098388671875
            },
            {
                "x": 0.026060670614242554,
                "y": 0.015536122024059296,
                "z": -419.1636657714844
            },
            {
                "x": 0.025882363319396973,
                "y": 0.015528522431850433,
                "z": -419.0063171386719
            },
            {
                "x": 0.025704145431518555,
                "y": 0.015520915389060974,
                "z": -418.84912109375
            },
            {
                "x": 0.02552586793899536,
                "y": 0.015513300895690918,
                "z": -418.6917724609375
            },
            {
                "x": 0.025347620248794556,
                "y": 0.015505701303482056,
                "z": -418.5345458984375
            },
            {
                "x": 0.025169432163238525,
                "y": 0.01549810916185379,
                "z": -418.3773193359375
            },
            {
                "x": 0.02499106526374817,
                "y": 0.015490494668483734,
                "z": -418.2198486328125
            },
            {
                "x": 0.02481287717819214,
                "y": 0.015482895076274872,
                "z": -418.0626220703125
            },
            {
                "x": 0.024634599685668945,
                "y": 0.015475280582904816,
                "z": -417.90533447265625
            },
            {
                "x": 0.02445635199546814,
                "y": 0.015467695891857147,
                "z": -417.748046875
            },
            {
                "x": 0.024278104305267334,
                "y": 0.015460081398487091,
                "z": -417.5908508300781
            },
            {
                "x": 0.024099737405776978,
                "y": 0.015452466905117035,
                "z": -417.4333801269531
            },
            {
                "x": 0.023921430110931396,
                "y": 0.015444859862327576,
                "z": -417.2761535644531
            },
            {
                "x": 0.02374330163002014,
                "y": 0.015437252819538116,
                "z": -417.1189270019531
            },
            {
                "x": 0.023564964532852173,
                "y": 0.015429660677909851,
                "z": -416.9615783691406
            },
            {
                "x": 0.023386746644973755,
                "y": 0.015422068536281586,
                "z": -416.8043212890625
            },
            {
                "x": 0.023208439350128174,
                "y": 0.015414431691169739,
                "z": -416.6470031738281
            },
            {
                "x": 0.023030102252960205,
                "y": 0.015406839549541473,
                "z": -416.4896545410156
            },
            {
                "x": 0.022851943969726562,
                "y": 0.015399247407913208,
                "z": -416.3324279785156
            },
            {
                "x": 0.022673755884170532,
                "y": 0.015391640365123749,
                "z": -416.1752014160156
            },
            {
                "x": 0.022495567798614502,
                "y": 0.015384040772914886,
                "z": -416.0179748535156
            },
            {
                "x": 0.02231729030609131,
                "y": 0.015376448631286621,
                "z": -415.8607482910156
            },
            {
                "x": 0.022138893604278564,
                "y": 0.015368849039077759,
                "z": -415.7033386230469
            },
            {
                "x": 0.021960705518722534,
                "y": 0.015361227095127106,
                "z": -415.54608154296875
            },
            {
                "x": 0.02178245782852173,
                "y": 0.015353620052337646,
                "z": -415.3888244628906
            },
            {
                "x": 0.021604180335998535,
                "y": 0.015346027910709381,
                "z": -415.2315368652344
            },
            {
                "x": 0.021425962448120117,
                "y": 0.015338405966758728,
                "z": -415.0743103027344
            },
            {
                "x": 0.02124762535095215,
                "y": 0.015330813825130463,
                "z": -414.9168395996094
            },
            {
                "x": 0.021069347858428955,
                "y": 0.015323221683502197,
                "z": -414.7596130371094
            },
            {
                "x": 0.020891159772872925,
                "y": 0.015315614640712738,
                "z": -414.6023864746094
            },
            {
                "x": 0.02071288228034973,
                "y": 0.015307992696762085,
                "z": -414.4450378417969
            },
            {
                "x": 0.020534664392471313,
                "y": 0.01530040055513382,
                "z": -414.2878112792969
            },
            {
                "x": 0.020356327295303345,
                "y": 0.015292778611183167,
                "z": -414.1304626464844
            },
            {
                "x": 0.020177990198135376,
                "y": 0.015285186469554901,
                "z": -413.9731750488281
            },
            {
                "x": 0.019999802112579346,
                "y": 0.015277579426765442,
                "z": -413.8159484863281
            },
            {
                "x": 0.019821494817733765,
                "y": 0.01526997983455658,
                "z": -413.6585998535156
            },
            {
                "x": 0.01964324712753296,
                "y": 0.015262357890605927,
                "z": -413.5013732910156
            },
            {
                "x": 0.01946505904197693,
                "y": 0.015254758298397064,
                "z": -413.3441162109375
            },
            {
                "x": 0.019286692142486572,
                "y": 0.015247151255607605,
                "z": -413.1866760253906
            },
            {
                "x": 0.019108474254608154,
                "y": 0.015239551663398743,
                "z": -413.0294494628906
            },
            {
                "x": 0.018930256366729736,
                "y": 0.015231944620609283,
                "z": -412.8722229003906
            },
            {
                "x": 0.018814116716384888,
                "y": 0.015226997435092926,
                "z": -412.7706604003906
            },
            {
                "x": 0.018635869026184082,
                "y": 0.015219390392303467,
                "z": -412.6134338378906
            },
            {
                "x": 0.018457621335983276,
                "y": 0.015211790800094604,
                "z": -412.4560852050781
            },
            {
                "x": 0.018279284238815308,
                "y": 0.015204198658466339,
                "z": -412.2987365722656
            },
            {
                "x": 0.01810106635093689,
                "y": 0.01519659161567688,
                "z": -412.1415100097656
            },
            {
                "x": 0.01792275905609131,
                "y": 0.01518898457288742,
                "z": -411.9841613769531
            },
            {
                "x": 0.01774454116821289,
                "y": 0.015181384980678558,
                "z": -411.8269348144531
            },
            {
                "x": 0.017566412687301636,
                "y": 0.015173770487308502,
                "z": -411.6697082519531
            },
            {
                "x": 0.01738792657852173,
                "y": 0.015166163444519043,
                "z": -411.5122985839844
            },
            {
                "x": 0.017209678888320923,
                "y": 0.01515856385231018,
                "z": -411.3550720214844
            },
            {
                "x": 0.017031461000442505,
                "y": 0.015150949358940125,
                "z": -411.1977844238281
            },
            {
                "x": 0.016853243112564087,
                "y": 0.015143342316150665,
                "z": -411.0404968261719
            },
            {
                "x": 0.01667499542236328,
                "y": 0.015135742723941803,
                "z": -410.8832092285156
            },
            {
                "x": 0.016496628522872925,
                "y": 0.015128135681152344,
                "z": -410.7257995605469
            },
            {
                "x": 0.01631838083267212,
                "y": 0.015120528638362885,
                "z": -410.5685729980469
            },
            {
                "x": 0.0161401629447937,
                "y": 0.015112921595573425,
                "z": -410.4113464355469
            },
            {
                "x": 0.015961885452270508,
                "y": 0.01510532945394516,
                "z": -410.2539978027344
            },
            {
                "x": 0.015783578157424927,
                "y": 0.0150977224111557,
                "z": -410.0967712402344
            },
            {
                "x": 0.015605330467224121,
                "y": 0.015090122818946838,
                "z": -409.9394836425781
            },
            {
                "x": 0.01542702317237854,
                "y": 0.01508251577615738,
                "z": -409.7821350097656
            },
            {
                "x": 0.015248805284500122,
                "y": 0.01507490873336792,
                "z": -409.6249084472656
            },
            {
                "x": 0.01507064700126648,
                "y": 0.015067309141159058,
                "z": -409.4676818847656
            },
            {
                "x": 0.014892399311065674,
                "y": 0.015059716999530792,
                "z": -409.3104553222656
            },
            {
                "x": 0.014714151620864868,
                "y": 0.015052102506160736,
                "z": -409.1532287597656
            },
            {
                "x": 0.014535844326019287,
                "y": 0.015044502913951874,
                "z": -408.9957580566406
            },
            {
                "x": 0.014357537031173706,
                "y": 0.015036895871162415,
                "z": -408.8385314941406
            },
            {
                "x": 0.014179319143295288,
                "y": 0.015029281377792358,
                "z": -408.6812438964844
            },
            {
                "x": 0.01400110125541687,
                "y": 0.0150216743350029,
                "z": -408.5239562988281
            },
            {
                "x": 0.013822883367538452,
                "y": 0.01501406729221344,
                "z": -408.3667297363281
            },
            {
                "x": 0.013644486665725708,
                "y": 0.015006467700004578,
                "z": -408.2093200683594
            },
            {
                "x": 0.01346626877784729,
                "y": 0.014998875558376312,
                "z": -408.0520935058594
            },
            {
                "x": 0.01328808069229126,
                "y": 0.014991261065006256,
                "z": -407.8948669433594
            },
            {
                "x": 0.013109773397445679,
                "y": 0.014983654022216797,
                "z": -407.7375183105469
            },
            {
                "x": 0.012931525707244873,
                "y": 0.014976054430007935,
                "z": -407.5802917480469
            },
            {
                "x": 0.012753218412399292,
                "y": 0.014968447387218475,
                "z": -407.4229431152344
            },
            {
                "x": 0.012574970722198486,
                "y": 0.014960847795009613,
                "z": -407.2655944824219
            },
            {
                "x": 0.012396752834320068,
                "y": 0.014953233301639557,
                "z": -407.1083679199219
            },
            {
                "x": 0.012218475341796875,
                "y": 0.014945641160011292,
                "z": -406.9510192871094
            },
            {
                "x": 0.012040257453918457,
                "y": 0.01493804156780243,
                "z": -406.7937927246094
            },
            {
                "x": 0.011862009763717651,
                "y": 0.014930441975593567,
                "z": -406.6365661621094
            },
            {
                "x": 0.01168358325958252,
                "y": 0.01492282748222351,
                "z": -406.4791564941406
            },
            {
                "x": 0.011505335569381714,
                "y": 0.014915235340595245,
                "z": -406.3219299316406
            },
            {
                "x": 0.011327177286148071,
                "y": 0.01490762084722519,
                "z": -406.1647033691406
            },
            {
                "x": 0.011211037635803223,
                "y": 0.014902666211128235,
                "z": -406.0630798339844
            },
            {
                "x": 0.011032849550247192,
                "y": 0.014895066618919373,
                "z": -405.9058532714844
            },
            {
                "x": 0.010854512453079224,
                "y": 0.01488746702671051,
                "z": -405.7485656738281
            },
            {
                "x": 0.01067623496055603,
                "y": 0.014879859983921051,
                "z": -405.5912170410156
            },
            {
                "x": 0.010497957468032837,
                "y": 0.014872245490550995,
                "z": -405.4339599609375
            },
            {
                "x": 0.010319679975509644,
                "y": 0.014864645898342133,
                "z": -405.276611328125
            },
            {
                "x": 0.010141462087631226,
                "y": 0.014857038855552673,
                "z": -405.119384765625
            },
            {
                "x": 0.009963244199752808,
                "y": 0.014849431812763214,
                "z": -404.962158203125
            },
            {
                "x": 0.009784907102584839,
                "y": 0.014841824769973755,
                "z": -404.8046875
            },
            {
                "x": 0.009606629610061646,
                "y": 0.014834225177764893,
                "z": -404.6474609375
            },
            {
                "x": 0.009428411722183228,
                "y": 0.014826610684394836,
                "z": -404.49017333984375
            },
            {
                "x": 0.009250164031982422,
                "y": 0.014819011092185974,
                "z": -404.3328857421875
            },
            {
                "x": 0.009071916341781616,
                "y": 0.014811418950557709,
                "z": -404.1756591796875
            },
            {
                "x": 0.008893519639968872,
                "y": 0.014803804457187653,
                "z": -404.0182189941406
            },
            {
                "x": 0.008715271949768066,
                "y": 0.01479620486497879,
                "z": -403.86102294921875
            },
            {
                "x": 0.008537083864212036,
                "y": 0.014788597822189331,
                "z": -403.7037658691406
            },
            {
                "x": 0.008358776569366455,
                "y": 0.014780998229980469,
                "z": -403.54644775390625
            },
            {
                "x": 0.008180588483810425,
                "y": 0.014773383736610413,
                "z": -403.38922119140625
            },
            {
                "x": 0.008002281188964844,
                "y": 0.01476578414440155,
                "z": -403.23187255859375
            },
            {
                "x": 0.007823944091796875,
                "y": 0.014758177101612091,
                "z": -403.07452392578125
            },
            {
                "x": 0.007645756006240845,
                "y": 0.014750584959983826,
                "z": -402.91729736328125
            },
            {
                "x": 0.007467597723007202,
                "y": 0.01474297046661377,
                "z": -402.76007080078125
            },
            {
                "x": 0.0072893500328063965,
                "y": 0.014735370874404907,
                "z": -402.60284423828125
            },
            {
                "x": 0.007111102342605591,
                "y": 0.014727771282196045,
                "z": -402.44561767578125
            },
            {
                "x": 0.006932735443115234,
                "y": 0.014720156788825989,
                "z": -402.2882080078125
            },
            {
                "x": 0.006754457950592041,
                "y": 0.014712557196617126,
                "z": -402.1309814453125
            },
            {
                "x": 0.006576329469680786,
                "y": 0.014704950153827667,
                "z": -401.9736328125
            },
            {
                "x": 0.006397992372512817,
                "y": 0.014697343111038208,
                "z": -401.81640625
            },
            {
                "x": 0.006219714879989624,
                "y": 0.014689765870571136,
                "z": -401.6591796875
            },
            {
                "x": 0.006041437387466431,
                "y": 0.01468215137720108,
                "z": -401.501708984375
            },
            {
                "x": 0.005863219499588013,
                "y": 0.014674529433250427,
                "z": -401.344482421875
            },
            {
                "x": 0.005684971809387207,
                "y": 0.014666937291622162,
                "z": -401.187255859375
            },
            {
                "x": 0.005506634712219238,
                "y": 0.014659345149993896,
                "z": -401.0299072265625
            },
            {
                "x": 0.005328506231307983,
                "y": 0.01465173065662384,
                "z": -400.8726806640625
            },
            {
                "x": 0.005150169134140015,
                "y": 0.014644131064414978,
                "z": -400.71533203125
            },
            {
                "x": 0.004971832036972046,
                "y": 0.014636524021625519,
                "z": -400.55804443359375
            },
            {
                "x": 0.004793614149093628,
                "y": 0.014628909528255463,
                "z": -400.40081787109375
            },
            {
                "x": 0.004615277051925659,
                "y": 0.0146213099360466,
                "z": -400.2434387207031
            },
            {
                "x": 0.004437088966369629,
                "y": 0.014613710343837738,
                "z": -400.0862121582031
            },
            {
                "x": 0.004258871078491211,
                "y": 0.014606103301048279,
                "z": -399.92901611328125
            },
            {
                "x": 0.004080533981323242,
                "y": 0.01459849625825882,
                "z": -399.77154541015625
            },
            {
                "x": 0.003902256488800049,
                "y": 0.01459088921546936,
                "z": -399.61431884765625
            },
            {
                "x": 0.0037240684032440186,
                "y": 0.014583289623260498,
                "z": -399.45709228515625
            },
            {
                "x": 0.00360792875289917,
                "y": 0.014578327536582947,
                "z": -399.35552978515625
            },
            {
                "x": 0.0034297704696655273,
                "y": 0.014570735394954681,
                "z": -399.19830322265625
            },
            {
                "x": 0.0032514631748199463,
                "y": 0.014563128352165222,
                "z": -399.04095458984375
            },
            {
                "x": 0.0030731558799743652,
                "y": 0.01455552875995636,
                "z": -398.88360595703125
            },
            {
                "x": 0.0028949081897735596,
                "y": 0.014547914266586304,
                "z": -398.72637939453125
            },
            {
                "x": 0.002716630697250366,
                "y": 0.014540322124958038,
                "z": -398.56903076171875
            },
            {
                "x": 0.0025384128093719482,
                "y": 0.014532722532749176,
                "z": -398.41180419921875
            },
            {
                "x": 0.0023601949214935303,
                "y": 0.014525100588798523,
                "z": -398.25457763671875
            },
            {
                "x": 0.002181798219680786,
                "y": 0.01451750099658966,
                "z": -398.09716796875
            },
            {
                "x": 0.0020035207271575928,
                "y": 0.014509901404380798,
                "z": -397.93994140625
            },
            {
                "x": 0.0018252730369567871,
                "y": 0.014502301812171936,
                "z": -397.78265380859375
            },
            {
                "x": 0.0016470253467559814,
                "y": 0.014494702219963074,
                "z": -397.6253662109375
            },
            {
                "x": 0.0014687776565551758,
                "y": 0.014487087726593018,
                "z": -397.4681396484375
            },
            {
                "x": 0.0012904107570648193,
                "y": 0.014479473233222961,
                "z": -397.3106994628906
            },
            {
                "x": 0.0011121630668640137,
                "y": 0.014471873641014099,
                "z": -397.1534729003906
            },
            {
                "x": 0.0009339749813079834,
                "y": 0.014464281499385834,
                "z": -396.9962463378906
            },
            {
                "x": 0.0007556676864624023,
                "y": 0.014456667006015778,
                "z": -396.8388977050781
            },
            {
                "x": 0.0005774796009063721,
                "y": 0.014449059963226318,
                "z": -396.6816711425781
            },
            {
                "x": 0.0003991425037384033,
                "y": 0.014441452920436859,
                "z": -396.52435302734375
            },
            {
                "x": 0.00022086501121520996,
                "y": 0.014433853328227997,
                "z": -396.36700439453125
            },
            {
                "x": 4.264712333679199e-05,
                "y": 0.014426246285438538,
                "z": -396.2098083496094
            },
            {
                "x": -0.00013551115989685059,
                "y": 0.014418654143810272,
                "z": -396.05255126953125
            },
            {
                "x": -0.00031372904777526855,
                "y": 0.01441105455160141,
                "z": -395.89532470703125
            },
            {
                "x": -0.0004919767379760742,
                "y": 0.014403454959392548,
                "z": -395.73809814453125
            },
            {
                "x": -0.0006703436374664307,
                "y": 0.014395825564861298,
                "z": -395.5807189941406
            },
            {
                "x": -0.0008486509323120117,
                "y": 0.01438824087381363,
                "z": -395.4234924316406
            },
            {
                "x": -0.0010268688201904297,
                "y": 0.014380626380443573,
                "z": -395.2662048339844
            },
            {
                "x": -0.0012051761150360107,
                "y": 0.014373034238815308,
                "z": -395.1089172363281
            },
            {
                "x": -0.0013833343982696533,
                "y": 0.014365419745445251,
                "z": -394.9516906738281
            },
            {
                "x": -0.0015617609024047852,
                "y": 0.014357812702655792,
                "z": -394.7942810058594
            },
            {
                "x": -0.0017400085926055908,
                "y": 0.014350205659866333,
                "z": -394.6370544433594
            },
            {
                "x": -0.0019182264804840088,
                "y": 0.01434260606765747,
                "z": -394.4798278808594
            },
            {
                "x": -0.002096503973007202,
                "y": 0.014334991574287415,
                "z": -394.3224792480469
            },
            {
                "x": -0.002274751663208008,
                "y": 0.014327391982078552,
                "z": -394.1652526855469
            },
            {
                "x": -0.0024530887603759766,
                "y": 0.014319784939289093,
                "z": -394.0079040527344
            },
            {
                "x": -0.0026313364505767822,
                "y": 0.014312170445919037,
                "z": -393.8505554199219
            },
            {
                "x": -0.0028095245361328125,
                "y": 0.014304585754871368,
                "z": -393.6933288574219
            },
            {
                "x": -0.0029878616333007812,
                "y": 0.01429697871208191,
                "z": -393.53594970703125
            },
            {
                "x": -0.003166019916534424,
                "y": 0.014289379119873047,
                "z": -393.37872314453125
            },
            {
                "x": -0.003344297409057617,
                "y": 0.01428176462650299,
                "z": -393.22149658203125
            },
            {
                "x": -0.003522634506225586,
                "y": 0.014274172484874725,
                "z": -393.06402587890625
            },
            {
                "x": -0.003700941801071167,
                "y": 0.01426655799150467,
                "z": -392.9068603515625
            },
            {
                "x": -0.0038791298866271973,
                "y": 0.014258958399295807,
                "z": -392.7496032714844
            },
            {
                "x": -0.0039952099323272705,
                "y": 0.014254018664360046,
                "z": -392.64801025390625
            },
            {
                "x": -0.004173487424850464,
                "y": 0.014246389269828796,
                "z": -392.4908447265625
            },
            {
                "x": -0.0043517351150512695,
                "y": 0.014238804578781128,
                "z": -392.33349609375
            },
            {
                "x": -0.004530072212219238,
                "y": 0.014231190085411072,
                "z": -392.17620849609375
            },
            {
                "x": -0.0047082602977752686,
                "y": 0.01422359049320221,
                "z": -392.0189208984375
            },
            {
                "x": -0.004886537790298462,
                "y": 0.014215968549251556,
                "z": -391.861572265625
            },
            {
                "x": -0.005064725875854492,
                "y": 0.014208391308784485,
                "z": -391.704345703125
            },
            {
                "x": -0.0052430033683776855,
                "y": 0.014200776815414429,
                "z": -391.547119140625
            },
            {
                "x": -0.00542140007019043,
                "y": 0.014193162322044373,
                "z": -391.38970947265625
            },
            {
                "x": -0.005599647760391235,
                "y": 0.014185555279254913,
                "z": -391.23248291015625
            },
            {
                "x": -0.005777865648269653,
                "y": 0.014177963137626648,
                "z": -391.0751953125
            },
            {
                "x": -0.005956143140792847,
                "y": 0.014170363545417786,
                "z": -390.9178771972656
            },
            {
                "x": -0.006134390830993652,
                "y": 0.014162756502628326,
                "z": -390.76068115234375
            },
            {
                "x": -0.006312757730484009,
                "y": 0.014155134558677673,
                "z": -390.60321044921875
            },
            {
                "x": -0.006490975618362427,
                "y": 0.014147534966468811,
                "z": -390.44598388671875
            },
            {
                "x": -0.006669163703918457,
                "y": 0.014139942824840546,
                "z": -390.28875732421875
            },
            {
                "x": -0.006847500801086426,
                "y": 0.014132343232631683,
                "z": -390.13140869140625
            },
            {
                "x": -0.007025688886642456,
                "y": 0.014124728739261627,
                "z": -389.97418212890625
            },
            {
                "x": -0.007203966379165649,
                "y": 0.014117144048213959,
                "z": -389.81689453125
            },
            {
                "x": -0.007382303476333618,
                "y": 0.014109514653682709,
                "z": -389.6595153808594
            },
            {
                "x": -0.0075605809688568115,
                "y": 0.01410190761089325,
                "z": -389.5023193359375
            },
            {
                "x": -0.007738709449768066,
                "y": 0.014094322919845581,
                "z": -389.3450927734375
            },
            {
                "x": -0.007916927337646484,
                "y": 0.014086723327636719,
                "z": -389.1878662109375
            },
            {
                "x": -0.00809517502784729,
                "y": 0.01407911628484726,
                "z": -389.0306396484375
            },
            {
                "x": -0.008273482322692871,
                "y": 0.0140715092420578,
                "z": -388.8731689453125
            },
            {
                "x": -0.008451730012893677,
                "y": 0.014063894748687744,
                "z": -388.7159423828125
            },
            {
                "x": -0.008629977703094482,
                "y": 0.014056295156478882,
                "z": -388.55865478515625
            },
            {
                "x": -0.008808284997940063,
                "y": 0.01404869556427002,
                "z": -388.4013671875
            },
            {
                "x": -0.008986413478851318,
                "y": 0.014041103422641754,
                "z": -388.244140625
            },
            {
                "x": -0.00916483998298645,
                "y": 0.014033474028110504,
                "z": -388.0867004394531
            },
            {
                "x": -0.009343087673187256,
                "y": 0.014025859534740448,
                "z": -387.9294738769531
            },
            {
                "x": -0.009521305561065674,
                "y": 0.014018267393112183,
                "z": -387.7722473144531
            },
            {
                "x": -0.009699612855911255,
                "y": 0.014010675251483917,
                "z": -387.61492919921875
            },
            {
                "x": -0.009877830743789673,
                "y": 0.014003068208694458,
                "z": -387.45770263671875
            },
            {
                "x": -0.010056078433990479,
                "y": 0.013995453715324402,
                "z": -387.30035400390625
            },
            {
                "x": -0.01023438572883606,
                "y": 0.013987846672534943,
                "z": -387.14300537109375
            },
            {
                "x": -0.010412633419036865,
                "y": 0.013980261981487274,
                "z": -386.98577880859375
            },
            {
                "x": -0.010590910911560059,
                "y": 0.013972647488117218,
                "z": -386.82843017578125
            },
            {
                "x": -0.010769128799438477,
                "y": 0.013965047895908356,
                "z": -386.67120361328125
            },
            {
                "x": -0.010947376489639282,
                "y": 0.013957425951957703,
                "z": -386.51397705078125
            },
            {
                "x": -0.011125773191452026,
                "y": 0.013949833810329437,
                "z": -386.3565673828125
            },
            {
                "x": -0.011303991079330444,
                "y": 0.013942226767539978,
                "z": -386.1993408203125
            },
            {
                "x": -0.01148223876953125,
                "y": 0.013934619724750519,
                "z": -386.0421142578125
            },
            {
                "x": -0.011598318815231323,
                "y": 0.013929665088653564,
                "z": -385.9405212402344
            },
            {
                "x": -0.011776477098464966,
                "y": 0.013922065496444702,
                "z": -385.78326416015625
            },
            {
                "x": -0.011954843997955322,
                "y": 0.013914473354816437,
                "z": -385.6259765625
            },
            {
                "x": -0.012133151292800903,
                "y": 0.013906866312026978,
                "z": -385.4686279296875
            },
            {
                "x": -0.012311428785324097,
                "y": 0.013899251818656921,
                "z": -385.3114013671875
            },
            {
                "x": -0.012489646673202515,
                "y": 0.013891644775867462,
                "z": -385.154052734375
            },
            {
                "x": -0.012667834758758545,
                "y": 0.0138840451836586,
                "z": -384.996826171875
            },
            {
                "x": -0.012846112251281738,
                "y": 0.013876445591449738,
                "z": -384.839599609375
            },
            {
                "x": -0.013024479150772095,
                "y": 0.013868838548660278,
                "z": -384.6821594238281
            },
            {
                "x": -0.013202697038650513,
                "y": 0.013861231505870819,
                "z": -384.52490234375
            },
            {
                "x": -0.01338091492652893,
                "y": 0.013853617012500763,
                "z": -384.36761474609375
            },
            {
                "x": -0.0135592520236969,
                "y": 0.013846024870872498,
                "z": -384.2103576660156
            },
            {
                "x": -0.01373744010925293,
                "y": 0.013838410377502441,
                "z": -384.0531005859375
            },
            {
                "x": -0.013915866613388062,
                "y": 0.013830818235874176,
                "z": -383.89569091796875
            },
            {
                "x": -0.01409408450126648,
                "y": 0.013823211193084717,
                "z": -383.73846435546875
            },
            {
                "x": -0.01427227258682251,
                "y": 0.013815619051456451,
                "z": -383.58123779296875
            },
            {
                "x": -0.014450550079345703,
                "y": 0.013807997107505798,
                "z": -383.42388916015625
            },
            {
                "x": -0.014628797769546509,
                "y": 0.013800397515296936,
                "z": -383.26666259765625
            },
            {
                "x": -0.014807075262069702,
                "y": 0.013792797923088074,
                "z": -383.10931396484375
            },
            {
                "x": -0.014985412359237671,
                "y": 0.013785183429718018,
                "z": -382.95196533203125
            },
            {
                "x": -0.015163630247116089,
                "y": 0.013777598738670349,
                "z": -382.79473876953125
            },
            {
                "x": -0.015341758728027344,
                "y": 0.013769969344139099,
                "z": -382.63751220703125
            },
            {
                "x": -0.015519976615905762,
                "y": 0.013762369751930237,
                "z": -382.48028564453125
            },
            {
                "x": -0.015698224306106567,
                "y": 0.013754785060882568,
                "z": -382.32305908203125
            },
            {
                "x": -0.015876561403274536,
                "y": 0.013747192919254303,
                "z": -382.1656494140625
            },
            {
                "x": -0.016054779291152954,
                "y": 0.01373957097530365,
                "z": -382.0084228515625
            },
            {
                "x": -0.016233086585998535,
                "y": 0.013731978833675385,
                "z": -381.85113525390625
            },
            {
                "x": -0.016411274671554565,
                "y": 0.013724356889724731,
                "z": -381.6938171386719
            },
            {
                "x": -0.016589492559432983,
                "y": 0.013716749846935272,
                "z": -381.5365905761719
            },
            {
                "x": -0.016767889261245728,
                "y": 0.013709142804145813,
                "z": -381.3791198730469
            },
            {
                "x": -0.016946107149124146,
                "y": 0.01370154321193695,
                "z": -381.2218933105469
            },
            {
                "x": -0.01712435483932495,
                "y": 0.013693936169147491,
                "z": -381.0646667480469
            },
            {
                "x": -0.017302632331848145,
                "y": 0.01368633657693863,
                "z": -380.9073181152344
            },
            {
                "x": -0.01748061180114746,
                "y": 0.013678744435310364,
                "z": -380.7500915527344
            },
            {
                "x": -0.017658859491348267,
                "y": 0.013671129941940308,
                "z": -380.5927429199219
            },
            {
                "x": -0.017837345600128174,
                "y": 0.013663522899150848,
                "z": -380.4354248046875
            },
            {
                "x": -0.018015056848526,
                "y": 0.013655923306941986,
                "z": -380.2782287597656
            },
            {
                "x": -0.01819106936454773,
                "y": 0.01364830881357193,
                "z": -380.1208801269531
            },
            {
                "x": -0.01836526393890381,
                "y": 0.013640709221363068,
                "z": -379.9636535644531
            },
            {
                "x": -0.01854163408279419,
                "y": 0.013633109629154205,
                "z": -379.8064270019531
            },
            {
                "x": -0.01871660351753235,
                "y": 0.013625502586364746,
                "z": -379.6490173339844
            },
            {
                "x": -0.01887989044189453,
                "y": 0.01361788809299469,
                "z": -379.4917907714844
            },
            {
                "x": -0.01902526617050171,
                "y": 0.013610310852527618,
                "z": -379.3346252441406
            },
            {
                "x": -0.019115179777145386,
                "y": 0.013605326414108276,
                "z": -379.2330322265625
            },
            {
                "x": -0.019259274005889893,
                "y": 0.013597741723060608,
                "z": -379.0758056640625
            },
            {
                "x": -0.01938280463218689,
                "y": 0.013590112328529358,
                "z": -378.9186096191406
            },
            {
                "x": -0.0194399356842041,
                "y": 0.013582542538642883,
                "z": -378.761474609375
            },
            {
                "x": -0.019411802291870117,
                "y": 0.013574913144111633,
                "z": -378.6044616699219
            },
            {
                "x": -0.019337445497512817,
                "y": 0.013567328453063965,
                "z": -378.4471740722656
            },
            {
                "x": -0.0192299485206604,
                "y": 0.013559654355049133,
                "z": -378.2901916503906
            },
            {
                "x": -0.018975257873535156,
                "y": 0.01355212926864624,
                "z": -378.1335144042969
            },
            {
                "x": -0.01848316192626953,
                "y": 0.013544470071792603,
                "z": -377.9767761230469
            },
            {
                "x": -0.01776343584060669,
                "y": 0.013536892831325531,
                "z": -377.8200378417969
            },
            {
                "x": -0.016906946897506714,
                "y": 0.013529233634471893,
                "z": -377.66314697265625
            },
            {
                "x": -0.015828818082809448,
                "y": 0.013521693646907806,
                "z": -377.5067443847656
            },
            {
                "x": -0.01437079906463623,
                "y": 0.013514071702957153,
                "z": -377.3506774902344
            },
            {
                "x": -0.01249915361404419,
                "y": 0.013506479561328888,
                "z": -377.19427490234375
            },
            {
                "x": -0.010315358638763428,
                "y": 0.013498850166797638,
                "z": -377.0377502441406
            },
            {
                "x": -0.007866531610488892,
                "y": 0.013491243124008179,
                "z": -376.88153076171875
            },
            {
                "x": -0.00497746467590332,
                "y": 0.013483673334121704,
                "z": -376.72564697265625
            },
            {
                "x": -0.0015617609024047852,
                "y": 0.01347600668668747,
                "z": -376.5698547363281
            },
            {
                "x": 0.002302199602127075,
                "y": 0.013468436896800995,
                "z": -376.4134826660156
            },
            {
                "x": 0.00644800066947937,
                "y": 0.013460852205753326,
                "z": -376.25701904296875
            },
            {
                "x": 0.010962486267089844,
                "y": 0.013453245162963867,
                "z": -376.10125732421875
            },
            {
                "x": 0.01601812243461609,
                "y": 0.013445667922496796,
                "z": -375.9456787109375
            },
            {
                "x": 0.021630823612213135,
                "y": 0.013438031077384949,
                "z": -375.7898254394531
            },
            {
                "x": 0.027599364519119263,
                "y": 0.013430409133434296,
                "z": -375.63348388671875
            },
            {
                "x": 0.033858299255371094,
                "y": 0.013422824442386627,
                "z": -375.4772033691406
            },
            {
                "x": 0.04055166244506836,
                "y": 0.013415217399597168,
                "z": -375.3216247558594
            },
            {
                "x": 0.04783770442008972,
                "y": 0.013407573103904724,
                "z": -375.1660461425781
            },
            {
                "x": 0.05560097098350525,
                "y": 0.01340000331401825,
                "z": -375.00994873046875
            },
            {
                "x": 0.0636531412601471,
                "y": 0.013392381370067596,
                "z": -374.8536376953125
            },
            {
                "x": 0.0720318853855133,
                "y": 0.013384826481342316,
                "z": -374.6976623535156
            },
            {
                "x": 0.08091846108436584,
                "y": 0.013377197086811066,
                "z": -374.5422668457031
            },
            {
                "x": 0.09035658836364746,
                "y": 0.013369575142860413,
                "z": -374.3866271972656
            },
            {
                "x": 0.10020145773887634,
                "y": 0.01336195319890976,
                "z": -374.23040771484375
            },
            {
                "x": 0.11029618978500366,
                "y": 0.013354361057281494,
                "z": -374.0743408203125
            },
            {
                "x": 0.12079000473022461,
                "y": 0.013346783816814423,
                "z": -373.9187316894531
            },
            {
                "x": 0.13181588053703308,
                "y": 0.013339154422283173,
                "z": -373.7633361816406
            },
            {
                "x": 0.1433405876159668,
                "y": 0.013331584632396698,
                "z": -373.6075744628906
            },
            {
                "x": 0.15519452095031738,
                "y": 0.013323940336704254,
                "z": -373.451416015625
            },
            {
                "x": 0.16732001304626465,
                "y": 0.013316355645656586,
                "z": -373.295654296875
            },
            {
                "x": 0.17988136410713196,
                "y": 0.013308726251125336,
                "z": -373.140380859375
            },
            {
                "x": 0.19299709796905518,
                "y": 0.013301141560077667,
                "z": -372.9848937988281
            },
            {
                "x": 0.2065356969833374,
                "y": 0.013293556869029999,
                "z": -372.8290710449219
            },
            {
                "x": 0.22034615278244019,
                "y": 0.013285905122756958,
                "z": -372.6732177734375
            },
            {
                "x": 0.22942408919334412,
                "y": 0.013280980288982391,
                "z": -372.57275390625
            },
            {
                "x": 0.24382570385932922,
                "y": 0.01327340304851532,
                "z": -372.4176330566406
            },
            {
                "x": 0.2587807774543762,
                "y": 0.013265788555145264,
                "z": -372.2622985839844
            },
            {
                "x": 0.27417638897895813,
                "y": 0.013258136808872223,
                "z": -372.10650634765625
            },
            {
                "x": 0.289800763130188,
                "y": 0.013250581920146942,
                "z": -371.95086669921875
            },
            {
                "x": 0.30574479699134827,
                "y": 0.013242945075035095,
                "z": -371.7955017089844
            },
            {
                "x": 0.3221537172794342,
                "y": 0.013235360383987427,
                "z": -371.64056396484375
            },
            {
                "x": 0.3390733599662781,
                "y": 0.013227768242359161,
                "z": -371.4853515625
            },
            {
                "x": 0.35637134313583374,
                "y": 0.013220138847827911,
                "z": -371.3294982910156
            },
            {
                "x": 0.3738662898540497,
                "y": 0.013212569057941437,
                "z": -371.1741638183594
            },
            {
                "x": 0.3917214572429657,
                "y": 0.013204939663410187,
                "z": -371.01922607421875
            },
            {
                "x": 0.41008931398391724,
                "y": 0.013197354972362518,
                "z": -370.8642883300781
            },
            {
                "x": 0.42890140414237976,
                "y": 0.013189733028411865,
                "z": -370.7091064453125
            },
            {
                "x": 0.44801604747772217,
                "y": 0.013182125985622406,
                "z": -370.553466796875
            },
            {
                "x": 0.4673479199409485,
                "y": 0.013174541294574738,
                "z": -370.3984680175781
            },
            {
                "x": 0.4870953857898712,
                "y": 0.013166919350624084,
                "z": -370.2438049316406
            },
            {
                "x": 0.507352352142334,
                "y": 0.013159334659576416,
                "z": -370.08892822265625
            },
            {
                "x": 0.5279826521873474,
                "y": 0.01315172016620636,
                "z": -369.9337463378906
            },
            {
                "x": 0.5488440990447998,
                "y": 0.013144128024578094,
                "z": -369.7785949707031
            },
            {
                "x": 0.5700067281723022,
                "y": 0.013136513531208038,
                "z": -369.62384033203125
            },
            {
                "x": 0.5915959477424622,
                "y": 0.013128861784934998,
                "z": -369.46942138671875
            },
            {
                "x": 0.6136494874954224,
                "y": 0.01312129944562912,
                "z": -369.314697265625
            },
            {
                "x": 0.6360228061676025,
                "y": 0.013113684952259064,
                "z": -369.1596374511719
            },
            {
                "x": 0.6586064100265503,
                "y": 0.013106100261211395,
                "z": -369.0049743652344
            },
            {
                "x": 0.6815576553344727,
                "y": 0.013098500669002533,
                "z": -368.8504638671875
            },
            {
                "x": 0.7049359083175659,
                "y": 0.013090893626213074,
                "z": -368.6961669921875
            },
            {
                "x": 0.7287485003471375,
                "y": 0.013083286583423615,
                "z": -368.5414733886719
            },
            {
                "x": 0.7528091669082642,
                "y": 0.013075672090053558,
                "z": -368.38665771484375
            },
            {
                "x": 0.7770867943763733,
                "y": 0.013068079948425293,
                "z": -368.2322692871094
            },
            {
                "x": 0.8017681837081909,
                "y": 0.013060487806797028,
                "z": -368.0780944824219
            },
            {
                "x": 0.8268843293190002,
                "y": 0.013052873313426971,
                "z": -367.923828125
            },
            {
                "x": 0.8523513674736023,
                "y": 0.013045251369476318,
                "z": -367.7693176269531
            },
            {
                "x": 0.8780375719070435,
                "y": 0.013037703931331635,
                "z": -367.61480712890625
            },
            {
                "x": 0.9039705991744995,
                "y": 0.013030052185058594,
                "z": -367.4607849121094
            },
            {
                "x": 0.9303348064422607,
                "y": 0.01302248239517212,
                "z": -367.306884765625
            },
            {
                "x": 0.9571415185928345,
                "y": 0.01301487535238266,
                "z": -367.1526794433594
            },
            {
                "x": 0.9842005968093872,
                "y": 0.013007253408432007,
                "z": -366.99835205078125
            },
            {
                "x": 1.011460304260254,
                "y": 0.012999631464481354,
                "z": -366.8442077636719
            },
            {
                "x": 1.0390139818191528,
                "y": 0.012992046773433685,
                "z": -366.6905517578125
            },
            {
                "x": 1.0670104026794434,
                "y": 0.01298443228006363,
                "z": -366.5368957519531
            },
            {
                "x": 1.095426082611084,
                "y": 0.012976862490177155,
                "z": -366.38275146484375
            },
            {
                "x": 1.1240137815475464,
                "y": 0.012969233095645905,
                "z": -366.2286682128906
            },
            {
                "x": 1.152789831161499,
                "y": 0.012961655855178833,
                "z": -366.0750732421875
            },
            {
                "x": 1.171583652496338,
                "y": 0.012956671416759491,
                "z": -365.9759826660156
            },
            {
                "x": 1.2010040283203125,
                "y": 0.01294911652803421,
                "z": -365.82257080078125
            },
            {
                "x": 1.230811595916748,
                "y": 0.012941502034664154,
                "z": -365.668701171875
            },
            {
                "x": 1.2608338594436646,
                "y": 0.012933872640132904,
                "z": -365.51483154296875
            },
            {
                "x": 1.2910336256027222,
                "y": 0.012926265597343445,
                "z": -365.3614196777344
            },
            {
                "x": 1.3215975761413574,
                "y": 0.012918643653392792,
                "z": -365.20819091796875
            },
            {
                "x": 1.3525530099868774,
                "y": 0.01291106641292572,
                "z": -365.0549011230469
            },
            {
                "x": 1.3838095664978027,
                "y": 0.012903474271297455,
                "z": -364.9013366699219
            },
            {
                "x": 1.4152740240097046,
                "y": 0.012895852327346802,
                "z": -364.74774169921875
            },
            {
                "x": 1.4469274282455444,
                "y": 0.01288825273513794,
                "z": -364.5947570800781
            },
            {
                "x": 1.4789711236953735,
                "y": 0.012880615890026093,
                "z": -364.4417724609375
            },
            {
                "x": 1.511401653289795,
                "y": 0.012873008847236633,
                "z": -364.28857421875
            },
            {
                "x": 1.5440449714660645,
                "y": 0.012865446507930756,
                "z": -364.13525390625
            },
            {
                "x": 1.5768975019454956,
                "y": 0.012857817113399506,
                "z": -363.9820861816406
            },
            {
                "x": 1.609979510307312,
                "y": 0.012850217521190643,
                "z": -363.8293762207031
            },
            {
                "x": 1.643457055091858,
                "y": 0.012842603027820587,
                "z": -363.6766052246094
            },
            {
                "x": 1.6772862672805786,
                "y": 0.012835018336772919,
                "z": -363.5235290527344
            },
            {
                "x": 1.7112683057785034,
                "y": 0.01282741129398346,
                "z": -363.37054443359375
            },
            {
                "x": 1.7454420328140259,
                "y": 0.012819766998291016,
                "z": -363.2177734375
            },
            {
                "x": 1.779929757118225,
                "y": 0.012812167406082153,
                "z": -363.06524658203125
            },
            {
                "x": 1.8147789239883423,
                "y": 0.012804575264453888,
                "z": -362.9127502441406
            },
            {
                "x": 1.8498857021331787,
                "y": 0.01279699057340622,
                "z": -362.75994873046875
            },
            {
                "x": 1.8851425647735596,
                "y": 0.012789398431777954,
                "z": -362.6073303222656
            },
            {
                "x": 1.9206109046936035,
                "y": 0.012781806290149689,
                "z": -362.4551086425781
            },
            {
                "x": 1.9564602375030518,
                "y": 0.012774169445037842,
                "z": -362.302734375
            },
            {
                "x": 1.9926224946975708,
                "y": 0.012766577303409576,
                "z": -362.1502990722656
            },
            {
                "x": 2.0289885997772217,
                "y": 0.01275903731584549,
                "z": -361.9977111816406
            },
            {
                "x": 2.065495014190674,
                "y": 0.01275133341550827,
                "z": -361.845458984375
            },
            {
                "x": 2.102254867553711,
                "y": 0.012743756175041199,
                "z": -361.6934814453125
            },
            {
                "x": 2.1394004821777344,
                "y": 0.01273614913225174,
                "z": -361.5412902832031
            },
            {
                "x": 2.1767919063568115,
                "y": 0.01272851973772049,
                "z": -361.38909912109375
            },
            {
                "x": 2.2143523693084717,
                "y": 0.012720935046672821,
                "z": -361.23687744140625
            },
            {
                "x": 2.2520923614501953,
                "y": 0.012713320553302765,
                "z": -361.0848388671875
            },
            {
                "x": 2.290069580078125,
                "y": 0.012705713510513306,
                "z": -360.93316650390625
            },
            {
                "x": 2.328416347503662,
                "y": 0.012698143720626831,
                "z": -360.78125
            },
            {
                "x": 2.367007255554199,
                "y": 0.012690551578998566,
                "z": -360.6291198730469
            },
            {
                "x": 2.4056904315948486,
                "y": 0.012682929635047913,
                "z": -360.4773254394531
            },
            {
                "x": 2.444586753845215,
                "y": 0.012675337493419647,
                "z": -360.32568359375
            },
            {
                "x": 2.4837653636932373,
                "y": 0.012667708098888397,
                "z": -360.17425537109375
            },
            {
                "x": 2.5232467651367188,
                "y": 0.012660086154937744,
                "z": -360.0226135253906
            },
            {
                "x": 2.562980890274048,
                "y": 0.012652494013309479,
                "z": -359.8706359863281
            },
            {
                "x": 2.6027731895446777,
                "y": 0.01264490932226181,
                "z": -359.7191467285156
            },
            {
                "x": 2.642775297164917,
                "y": 0.012637287378311157,
                "z": -359.5678405761719
            },
            {
                "x": 2.6687848567962646,
                "y": 0.012632369995117188,
                "z": -359.47015380859375
            },
            {
                "x": 2.709284543991089,
                "y": 0.012624762952327728,
                "z": -359.31878662109375
            },
            {
                "x": 2.74997615814209,
                "y": 0.012617126107215881,
                "z": -359.1671447753906
            },
            {
                "x": 2.790789842605591,
                "y": 0.012609519064426422,
                "z": -359.0158386230469
            },
            {
                "x": 2.831796169281006,
                "y": 0.01260194182395935,
                "z": -358.86480712890625
            },
            {
                "x": 2.87312388420105,
                "y": 0.01259429007768631,
                "z": -358.7137145996094
            },
            {
                "x": 2.9146792888641357,
                "y": 0.012586697936058044,
                "z": -358.5624694824219
            },
            {
                "x": 2.9563846588134766,
                "y": 0.012579113245010376,
                "z": -358.4112854003906
            },
            {
                "x": 2.99825119972229,
                "y": 0.012571536004543304,
                "z": -358.2601623535156
            },
            {
                "x": 3.0402863025665283,
                "y": 0.012563899159431458,
                "z": -358.10943603515625
            },
            {
                "x": 3.0826213359832764,
                "y": 0.012556299567222595,
                "z": -357.9585266113281
            },
            {
                "x": 3.1251773834228516,
                "y": 0.012548685073852539,
                "z": -357.8074645996094
            },
            {
                "x": 3.1678333282470703,
                "y": 0.012541063129901886,
                "z": -357.6565856933594
            },
            {
                "x": 3.2106738090515137,
                "y": 0.01253347098827362,
                "z": -357.5057678222656
            },
            {
                "x": 3.2537126541137695,
                "y": 0.012525849044322968,
                "z": -357.3552551269531
            },
            {
                "x": 3.297024726867676,
                "y": 0.012518249452114105,
                "z": -357.20458984375
            },
            {
                "x": 3.340528964996338,
                "y": 0.012510664761066437,
                "z": -357.0536804199219
            },
            {
                "x": 3.3841097354888916,
                "y": 0.012503042817115784,
                "z": -356.9031066894531
            },
            {
                "x": 3.427865982055664,
                "y": 0.012495443224906921,
                "z": -356.75262451171875
            },
            {
                "x": 3.4718689918518066,
                "y": 0.012487806379795074,
                "z": -356.6022033691406
            },
            {
                "x": 3.5161118507385254,
                "y": 0.012480229139328003,
                "z": -356.45172119140625
            },
            {
                "x": 3.560455560684204,
                "y": 0.01247262954711914,
                "z": -356.3011779785156
            },
            {
                "x": 3.604900598526001,
                "y": 0.012465029954910278,
                "z": -356.15093994140625
            },
            {
                "x": 3.6495256423950195,
                "y": 0.012457385659217834,
                "z": -356.0008850097656
            },
            {
                "x": 3.694491147994995,
                "y": 0.012449793517589569,
                "z": -355.8504638671875
            },
            {
                "x": 3.7395780086517334,
                "y": 0.012442179024219513,
                "z": -355.7001953125
            },
            {
                "x": 3.7847580909729004,
                "y": 0.012434586882591248,
                "z": -355.5499572753906
            },
            {
                "x": 3.8300695419311523,
                "y": 0.012426964938640594,
                "z": -355.39984130859375
            },
            {
                "x": 3.875563621520996,
                "y": 0.012419357895851135,
                "z": -355.2499694824219
            },
            {
                "x": 3.921356439590454,
                "y": 0.012411758303642273,
                "z": -355.09979248046875
            },
            {
                "x": 3.9672396183013916,
                "y": 0.012404166162014008,
                "z": -354.9496765136719
            },
            {
                "x": 4.013208389282227,
                "y": 0.012396588921546936,
                "z": -354.7997131347656
            },
            {
                "x": 4.059347629547119,
                "y": 0.012388981878757477,
                "z": -354.64990234375
            },
            {
                "x": 4.105659484863281,
                "y": 0.012381389737129211,
                "z": -354.50018310546875
            },
            {
                "x": 4.152214527130127,
                "y": 0.012373782694339752,
                "z": -354.3501892089844
            },
            {
                "x": 4.198874473571777,
                "y": 0.012366153299808502,
                "z": -354.2001953125
            },
            {
                "x": 4.245586395263672,
                "y": 0.01235857605934143,
                "z": -354.0505676269531
            },
            {
                "x": 4.292498588562012,
                "y": 0.012350916862487793,
                "z": -353.9009094238281
            },
            {
                "x": 4.339564800262451,
                "y": 0.01234331727027893,
                "z": -353.7513427734375
            },
            {
                "x": 4.386831760406494,
                "y": 0.012335754930973053,
                "z": -353.60162353515625
            },
            {
                "x": 4.434243202209473,
                "y": 0.012328147888183594,
                "z": -353.45184326171875
            },
            {
                "x": 4.481656551361084,
                "y": 0.012320533394813538,
                "z": -353.30242919921875
            },
            {
                "x": 4.529255390167236,
                "y": 0.012312941253185272,
                "z": -353.1530456542969
            },
            {
                "x": 4.560100555419922,
                "y": 0.012308001518249512,
                "z": -353.0565185546875
            },
            {
                "x": 4.608003616333008,
                "y": 0.012300387024879456,
                "z": -352.90704345703125
            },
            {
                "x": 4.656007766723633,
                "y": 0.01229279488325119,
                "z": -352.7574768066406
            },
            {
                "x": 4.7041015625,
                "y": 0.01228514313697815,
                "z": -352.60809326171875
            },
            {
                "x": 4.752305507659912,
                "y": 0.012277580797672272,
                "z": -352.45892333984375
            },
            {
                "x": 4.800742149353027,
                "y": 0.012269958853721619,
                "z": -352.3095397949219
            },
            {
                "x": 4.8492841720581055,
                "y": 0.012262314558029175,
                "z": -352.1601867675781
            },
            {
                "x": 4.897868633270264,
                "y": 0.012254737317562103,
                "z": -352.010986328125
            },
            {
                "x": 4.946610450744629,
                "y": 0.012247145175933838,
                "z": -351.8617858886719
            },
            {
                "x": 4.995474338531494,
                "y": 0.012239523231983185,
                "z": -351.7127380371094
            },
            {
                "x": 5.0445098876953125,
                "y": 0.012231916189193726,
                "z": -351.5635681152344
            },
            {
                "x": 5.093637466430664,
                "y": 0.012224346399307251,
                "z": -351.41436767578125
            },
            {
                "x": 5.142833709716797,
                "y": 0.012216687202453613,
                "z": -351.26531982421875
            },
            {
                "x": 5.192168235778809,
                "y": 0.012209102511405945,
                "z": -351.1162414550781
            },
            {
                "x": 5.241610050201416,
                "y": 0.012201502919197083,
                "z": -350.9674072265625
            },
            {
                "x": 5.291182994842529,
                "y": 0.012193910777568817,
                "z": -350.8184814453125
            },
            {
                "x": 5.340911865234375,
                "y": 0.01218627393245697,
                "z": -350.6693115234375
            },
            {
                "x": 5.390629291534424,
                "y": 0.012178696691989899,
                "z": -350.5204772949219
            },
            {
                "x": 5.440495491027832,
                "y": 0.012171052396297455,
                "z": -350.3716735839844
            },
            {
                "x": 5.490519046783447,
                "y": 0.012163519859313965,
                "z": -350.2227478027344
            },
            {
                "x": 5.540612697601318,
                "y": 0.012284919619560242,
                "z": -350.0740051269531
            },
            {
                "x": 5.590765476226807,
                "y": 0.01272030919790268,
                "z": -349.9252624511719
            },
            {
                "x": 5.640974998474121,
                "y": 0.013462085276842117,
                "z": -349.776611328125
            },
            {
                "x": 5.691322326660156,
                "y": 0.014506736770272255,
                "z": -349.6280212402344
            },
            {
                "x": 5.74186897277832,
                "y": 0.015858391299843788,
                "z": -349.4792175292969
            },
            {
                "x": 5.792429447174072,
                "y": 0.017511893063783646,
                "z": -349.3305358886719
            },
            {
                "x": 5.843068599700928,
                "y": 0.019455742090940475,
                "z": -349.181884765625
            },
            {
                "x": 5.893774032592773,
                "y": 0.021684523671865463,
                "z": -349.0333557128906
            },
            {
                "x": 5.944558143615723,
                "y": 0.02419772930443287,
                "z": -348.8849792480469
            },
            {
                "x": 5.995554447174072,
                "y": 0.027003739029169083,
                "z": -348.7362365722656
            },
            {
                "x": 6.046538352966309,
                "y": 0.030078692361712456,
                "z": -348.58770751953125
            },
            {
                "x": 6.09756326675415,
                "y": 0.03342096507549286,
                "z": -348.43927001953125
            },
            {
                "x": 6.148695945739746,
                "y": 0.037032756954431534,
                "z": -348.2908630371094
            },
            {
                "x": 6.199920177459717,
                "y": 0.04091229662299156,
                "z": -348.14251708984375
            },
            {
                "x": 6.2512712478637695,
                "y": 0.04505230113863945,
                "z": -347.9940185546875
            },
            {
                "x": 6.302666187286377,
                "y": 0.04944339767098427,
                "z": -347.8455810546875
            },
            {
                "x": 6.354069232940674,
                "y": 0.05408059060573578,
                "z": -347.69732666015625
            },
            {
                "x": 6.405580997467041,
                "y": 0.05897083878517151,
                "z": -347.5490417480469
            },
            {
                "x": 6.457174301147461,
                "y": 0.06410005688667297,
                "z": -347.4007873535156
            },
            {
                "x": 6.508825302124023,
                "y": 0.06946331262588501,
                "z": -347.2525634765625
            },
            {
                "x": 6.560586929321289,
                "y": 0.0750669538974762,
                "z": -347.1041564941406
            },
            {
                "x": 6.612302780151367,
                "y": 0.08089257776737213,
                "z": -346.9560546875
            },
            {
                "x": 6.664124965667725,
                "y": 0.08694238215684891,
                "z": -346.8079528808594
            },
            {
                "x": 6.697643280029297,
                "y": 0.09096220880746841,
                "z": -346.7123107910156
            },
            {
                "x": 6.749595642089844,
                "y": 0.09737922996282578,
                "z": -346.5641174316406
            },
            {
                "x": 6.801578521728516,
                "y": 0.10400643944740295,
                "z": -346.41595458984375
            },
            {
                "x": 6.853630065917969,
                "y": 0.11083927750587463,
                "z": -346.267822265625
            },
            {
                "x": 6.905701160430908,
                "y": 0.11786873638629913,
                "z": -346.11981201171875
            },
            {
                "x": 6.957886219024658,
                "y": 0.12510932981967926,
                "z": -345.9717712402344
            },
            {
                "x": 7.010096073150635,
                "y": 0.13254278898239136,
                "z": -345.82373046875
            },
            {
                "x": 7.062321662902832,
                "y": 0.14016324281692505,
                "z": -345.67572021484375
            },
            {
                "x": 7.11464262008667,
                "y": 0.14797493815422058,
                "z": -345.52764892578125
            },
            {
                "x": 7.166961669921875,
                "y": 0.15596431493759155,
                "z": -345.3797912597656
            },
            {
                "x": 7.219365119934082,
                "y": 0.16413699090480804,
                "z": -345.2318115234375
            },
            {
                "x": 7.2717976570129395,
                "y": 0.17248117923736572,
                "z": -345.0838623046875
            },
            {
                "x": 7.324229717254639,
                "y": 0.18098929524421692,
                "z": -344.93597412109375
            },
            {
                "x": 7.376776218414307,
                "y": 0.18967631459236145,
                "z": -344.7879638671875
            },
            {
                "x": 7.4292707443237305,
                "y": 0.19850817322731018,
                "z": -344.6402587890625
            },
            {
                "x": 7.481863021850586,
                "y": 0.20750506222248077,
                "z": -344.4923095703125
            },
            {
                "x": 7.534475326538086,
                "y": 0.21665292978286743,
                "z": -344.3444519042969
            },
            {
                "x": 7.587087154388428,
                "y": 0.22594377398490906,
                "z": -344.19671630859375
            },
            {
                "x": 7.639753341674805,
                "y": 0.23538273572921753,
                "z": -344.0489501953125
            },
            {
                "x": 7.692497253417969,
                "y": 0.24496786296367645,
                "z": -343.9009704589844
            },
            {
                "x": 7.745203018188477,
                "y": 0.2546759843826294,
                "z": -343.7532653808594
            },
            {
                "x": 7.7979044914245605,
                "y": 0.2645115256309509,
                "z": -343.6055908203125
            },
            {
                "x": 7.850663661956787,
                "y": 0.2744811773300171,
                "z": -343.4578552246094
            },
            {
                "x": 7.903411865234375,
                "y": 0.284564733505249,
                "z": -343.3102111816406
            },
            {
                "x": 7.95627498626709,
                "y": 0.29478052258491516,
                "z": -343.1623229980469
            },
            {
                "x": 8.009087562561035,
                "y": 0.30509787797927856,
                "z": -343.0146484375
            },
            {
                "x": 8.061924934387207,
                "y": 0.315528929233551,
                "z": -342.8669738769531
            },
            {
                "x": 8.114789962768555,
                "y": 0.3260665535926819,
                "z": -342.7192077636719
            },
            {
                "x": 8.167644500732422,
                "y": 0.3366962671279907,
                "z": -342.5715637207031
            },
            {
                "x": 8.220592498779297,
                "y": 0.3474387526512146,
                "z": -342.4237365722656
            },
            {
                "x": 8.273481369018555,
                "y": 0.3582608699798584,
                "z": -342.2760925292969
            },
            {
                "x": 8.326339721679688,
                "y": 0.369162380695343,
                "z": -342.1285095214844
            },
            {
                "x": 8.37929916381836,
                "y": 0.3801621198654175,
                "z": -341.98077392578125
            },
            {
                "x": 8.43221378326416,
                "y": 0.39123278856277466,
                "z": -341.8330993652344
            },
            {
                "x": 8.485161781311035,
                "y": 0.4023885726928711,
                "z": -341.6853332519531
            },
            {
                "x": 8.538091659545898,
                "y": 0.41360974311828613,
                "z": -341.5376281738281
            },
            {
                "x": 8.5910062789917,
                "y": 0.42489153146743774,
                "z": -341.3899841308594
            },
            {
                "x": 8.643943786621094,
                "y": 0.4362407922744751,
                "z": -341.2422790527344
            },
            {
                "x": 8.696882247924805,
                "y": 0.44764700531959534,
                "z": -341.0945739746094
            },
            {
                "x": 8.749788284301758,
                "y": 0.4591032862663269,
                "z": -340.9469299316406
            },
            {
                "x": 8.802749633789062,
                "y": 0.47062066197395325,
                "z": -340.7991027832031
            },
            {
                "x": 8.8556489944458,
                "y": 0.4821685552597046,
                "z": -340.6514587402344
            },
            {
                "x": 8.908536911010742,
                "y": 0.4937583804130554,
                "z": -340.5038146972656
            },
            {
                "x": 8.942715644836426,
                "y": 0.5012696981430054,
                "z": -340.4083251953125
            },
            {
                "x": 8.995569229125977,
                "y": 0.5129133462905884,
                "z": -340.2607116699219
            },
            {
                "x": 9.048465728759766,
                "y": 0.5245973467826843,
                "z": -340.1129455566406
            },
            {
                "x": 9.101349830627441,
                "y": 0.5363065004348755,
                "z": -339.96514892578125
            },
            {
                "x": 9.154184341430664,
                "y": 0.5480297803878784,
                "z": -339.81744384765625
            },
            {
                "x": 9.207026481628418,
                "y": 0.559775710105896,
                "z": -339.66961669921875
            },
            {
                "x": 9.259798049926758,
                "y": 0.5715229511260986,
                "z": -339.5219421386719
            },
            {
                "x": 9.312559127807617,
                "y": 0.583277702331543,
                "z": -339.374267578125
            },
            {
                "x": 9.365389823913574,
                "y": 0.5950538516044617,
                "z": -339.226318359375
            },
            {
                "x": 9.418107986450195,
                "y": 0.6068139672279358,
                "z": -339.0785827636719
            },
            {
                "x": 9.470819473266602,
                "y": 0.618575394153595,
                "z": -338.93072509765625
            },
            {
                "x": 9.523491859436035,
                "y": 0.630323052406311,
                "z": -338.7829284667969
            },
            {
                "x": 9.57613754272461,
                "y": 0.6420527696609497,
                "z": -338.6352233886719
            },
            {
                "x": 9.628843307495117,
                "y": 0.6537854075431824,
                "z": -338.4871826171875
            },
            {
                "x": 9.681425094604492,
                "y": 0.665480375289917,
                "z": -338.3393249511719
            },
            {
                "x": 9.733952522277832,
                "y": 0.6771441102027893,
                "z": -338.1915588378906
            },
            {
                "x": 9.786493301391602,
                "y": 0.6887857913970947,
                "z": -338.0435791015625
            },
            {
                "x": 9.83897876739502,
                "y": 0.7003858685493469,
                "z": -337.8957214355469
            },
            {
                "x": 9.8914794921875,
                "y": 0.711959183216095,
                "z": -337.7477111816406
            },
            {
                "x": 9.943897247314453,
                "y": 0.7234834432601929,
                "z": -337.5997009277344
            },
            {
                "x": 9.996246337890625,
                "y": 0.7349525690078735,
                "z": -337.4517517089844
            },
            {
                "x": 10.04856014251709,
                "y": 0.7463674545288086,
                "z": -337.3038330078125
            },
            {
                "x": 10.100860595703125,
                "y": 0.7577320337295532,
                "z": -337.1558532714844
            },
            {
                "x": 10.153111457824707,
                "y": 0.7690384984016418,
                "z": -337.0077819824219
            },
            {
                "x": 10.205349922180176,
                "y": 0.7802902460098267,
                "z": -336.8594970703125
            },
            {
                "x": 10.2574462890625,
                "y": 0.7914543747901917,
                "z": -336.7114562988281
            },
            {
                "x": 10.30954360961914,
                "y": 0.8025515079498291,
                "z": -336.5633544921875
            },
            {
                "x": 10.361597061157227,
                "y": 0.8135755062103271,
                "z": -336.41510009765625
            },
            {
                "x": 10.413555145263672,
                "y": 0.8245092630386353,
                "z": -336.2669372558594
            },
            {
                "x": 10.465519905090332,
                "y": 0.8353726863861084,
                "z": -336.1185302734375
            },
            {
                "x": 10.517358779907227,
                "y": 0.8461271524429321,
                "z": -335.97039794921875
            },
            {
                "x": 10.569174766540527,
                "y": 0.8567911386489868,
                "z": -335.8221435546875
            },
            {
                "x": 10.62096118927002,
                "y": 0.8673653602600098,
                "z": -335.6737060546875
            },
            {
                "x": 10.672625541687012,
                "y": 0.8778278231620789,
                "z": -335.5253601074219
            },
            {
                "x": 10.724255561828613,
                "y": 0.8881866931915283,
                "z": -335.376953125
            },
            {
                "x": 10.775829315185547,
                "y": 0.8984298706054688,
                "z": -335.228515625
            },
            {
                "x": 10.827338218688965,
                "y": 0.9085557460784912,
                "z": -335.080078125
            },
            {
                "x": 10.87879467010498,
                "y": 0.9185715913772583,
                "z": -334.931396484375
            },
            {
                "x": 10.930107116699219,
                "y": 0.9284526109695435,
                "z": -334.7828369140625
            },
            {
                "x": 10.981327056884766,
                "y": 0.9381967782974243,
                "z": -334.6343994140625
            },
            {
                "x": 11.032594680786133,
                "y": 0.9478214383125305,
                "z": -334.4856262207031
            },
            {
                "x": 11.083745002746582,
                "y": 0.9573041200637817,
                "z": -334.3369445800781
            },
            {
                "x": 11.134759902954102,
                "y": 0.966643214225769,
                "z": -334.1882629394531
            },
            {
                "x": 11.167673110961914,
                "y": 0.9725981950759888,
                "z": -334.09210205078125
            },
            {
                "x": 11.218518257141113,
                "y": 0.9816837310791016,
                "z": -333.9434814453125
            },
            {
                "x": 11.269365310668945,
                "y": 0.990622341632843,
                "z": -333.79473876953125
            },
            {
                "x": 11.320181846618652,
                "y": 0.9994168281555176,
                "z": -333.6457214355469
            },
            {
                "x": 11.370826721191406,
                "y": 1.0080344676971436,
                "z": -333.49676513671875
            },
            {
                "x": 11.421371459960938,
                "y": 1.0164874792099,
                "z": -333.3478088378906
            },
            {
                "x": 11.471821784973145,
                "y": 1.024763584136963,
                "z": -333.19891357421875
            },
            {
                "x": 11.522218704223633,
                "y": 1.0328712463378906,
                "z": -333.04986572265625
            },
            {
                "x": 11.572587966918945,
                "y": 1.0408077239990234,
                "z": -332.9005126953125
            },
            {
                "x": 11.62273120880127,
                "y": 1.0485470294952393,
                "z": -332.75140380859375
            },
            {
                "x": 11.672774314880371,
                "y": 1.0560963153839111,
                "z": -332.6023254394531
            },
            {
                "x": 11.722784996032715,
                "y": 1.0634584426879883,
                "z": -332.4530944824219
            },
            {
                "x": 11.772687911987305,
                "y": 1.0706167221069336,
                "z": -332.3038635253906
            },
            {
                "x": 11.822558403015137,
                "y": 1.0775879621505737,
                "z": -332.1542663574219
            },
            {
                "x": 11.872186660766602,
                "y": 1.0843400955200195,
                "z": -332.0048828125
            },
            {
                "x": 11.921711921691895,
                "y": 1.090881109237671,
                "z": -331.8555908203125
            },
            {
                "x": 11.971223831176758,
                "y": 1.09721040725708,
                "z": -331.7060546875
            },
            {
                "x": 12.020590782165527,
                "y": 1.1033194065093994,
                "z": -331.55645751953125
            },
            {
                "x": 12.069828987121582,
                "y": 1.1092092990875244,
                "z": -331.40679931640625
            },
            {
                "x": 12.11893367767334,
                "y": 1.1148713827133179,
                "z": -331.257080078125
            },
            {
                "x": 12.167864799499512,
                "y": 1.1202877759933472,
                "z": -331.1075744628906
            },
            {
                "x": 12.216793060302734,
                "y": 1.1254734992980957,
                "z": -330.9578552246094
            },
            {
                "x": 12.265559196472168,
                "y": 1.1304214000701904,
                "z": -330.8080139160156
            },
            {
                "x": 12.314156532287598,
                "y": 1.1351251602172852,
                "z": -330.6581726074219
            },
            {
                "x": 12.362672805786133,
                "y": 1.139578104019165,
                "z": -330.5082092285156
            },
            {
                "x": 12.411042213439941,
                "y": 1.1437690258026123,
                "z": -330.3582763671875
            },
            {
                "x": 12.45934009552002,
                "y": 1.1477081775665283,
                "z": -330.208251953125
            },
            {
                "x": 12.50747299194336,
                "y": 1.1513888835906982,
                "z": -330.05804443359375
            },
            {
                "x": 12.555390357971191,
                "y": 1.154793381690979,
                "z": -329.90802001953125
            },
            {
                "x": 12.603245735168457,
                "y": 1.1579256057739258,
                "z": -329.75775146484375
            },
            {
                "x": 12.650961875915527,
                "y": 1.160781979560852,
                "z": -329.60760498046875
            },
            {
                "x": 12.698569297790527,
                "y": 1.1633634567260742,
                "z": -329.457275390625
            },
            {
                "x": 12.746007919311523,
                "y": 1.165658712387085,
                "z": -329.3067626953125
            },
            {
                "x": 12.793201446533203,
                "y": 1.1676552295684814,
                "z": -329.156494140625
            },
            {
                "x": 12.84033489227295,
                "y": 1.169363021850586,
                "z": -329.00604248046875
            },
            {
                "x": 12.887374877929688,
                "y": 1.1707770824432373,
                "z": -328.85546875
            },
            {
                "x": 12.934232711791992,
                "y": 1.1718859672546387,
                "z": -328.704833984375
            },
            {
                "x": 12.98088264465332,
                "y": 1.1726820468902588,
                "z": -328.5541076660156
            },
            {
                "x": 13.027318000793457,
                "y": 1.1731699705123901,
                "z": -328.4035339355469
            },
            {
                "x": 13.073664665222168,
                "y": 1.1733458042144775,
                "z": -328.2529602050781
            },
            {
                "x": 13.119983673095703,
                "y": 1.1732001304626465,
                "z": -328.1019287109375
            },
            {
                "x": 13.165993690490723,
                "y": 1.1727328300476074,
                "z": -327.95098876953125
            },
            {
                "x": 13.211773872375488,
                "y": 1.1719579696655273,
                "z": -327.8001708984375
            },
            {
                "x": 13.241278648376465,
                "y": 1.171299934387207,
                "z": -327.7027587890625
            },
            {
                "x": 13.286855697631836,
                "y": 1.1700167655944824,
                "z": -327.5519714355469
            },
            {
                "x": 13.332341194152832,
                "y": 1.1684341430664062,
                "z": -327.4007568359375
            },
            {
                "x": 13.377598762512207,
                "y": 1.1665581464767456,
                "z": -327.24951171875
            },
            {
                "x": 13.422592163085938,
                "y": 1.1643943786621094,
                "z": -327.098388671875
            },
            {
                "x": 13.467459678649902,
                "y": 1.1619348526000977,
                "z": -326.9472961425781
            },
            {
                "x": 13.512194633483887,
                "y": 1.159194827079773,
                "z": -326.79608154296875
            },
            {
                "x": 13.556746482849121,
                "y": 1.156176209449768,
                "z": -326.6446228027344
            },
            {
                "x": 13.601085662841797,
                "y": 1.152882695198059,
                "z": -326.4930114746094
            },
            {
                "x": 13.64512825012207,
                "y": 1.1493196487426758,
                "z": -326.341796875
            },
            {
                "x": 13.689075469970703,
                "y": 1.1454923152923584,
                "z": -326.19049072265625
            },
            {
                "x": 13.73290729522705,
                "y": 1.1414008140563965,
                "z": -326.0387878417969
            },
            {
                "x": 13.776484489440918,
                "y": 1.137054204940796,
                "z": -325.8871154785156
            },
            {
                "x": 13.819820404052734,
                "y": 1.1324462890625,
                "z": -325.7353820800781
            },
            {
                "x": 13.862922668457031,
                "y": 1.1276023387908936,
                "z": -325.5838317871094
            },
            {
                "x": 13.905914306640625,
                "y": 1.122513771057129,
                "z": -325.4322509765625
            },
            {
                "x": 13.948752403259277,
                "y": 1.1171784400939941,
                "z": -325.28021240234375
            },
            {
                "x": 13.991268157958984,
                "y": 1.1116044521331787,
                "z": -325.1282653808594
            },
            {
                "x": 14.03353500366211,
                "y": 1.105808973312378,
                "z": -324.9764404296875
            },
            {
                "x": 14.075684547424316,
                "y": 1.0997874736785889,
                "z": -324.8245849609375
            },
            {
                "x": 14.117655754089355,
                "y": 1.093543291091919,
                "z": -324.67254638671875
            },
            {
                "x": 14.159363746643066,
                "y": 1.0870702266693115,
                "z": -324.5202941894531
            },
            {
                "x": 14.200765609741211,
                "y": 1.080393671989441,
                "z": -324.3682556152344
            },
            {
                "x": 14.241944313049316,
                "y": 1.0735197067260742,
                "z": -324.2162780761719
            },
            {
                "x": 14.283065795898438,
                "y": 1.066426157951355,
                "z": -324.06396484375
            },
            {
                "x": 14.323935508728027,
                "y": 1.0591272115707397,
                "z": -323.9115295410156
            },
            {
                "x": 14.364497184753418,
                "y": 1.0516316890716553,
                "z": -323.7590637207031
            },
            {
                "x": 14.404764175415039,
                "y": 1.0439599752426147,
                "z": -323.60675048828125
            },
            {
                "x": 14.444868087768555,
                "y": 1.0361065864562988,
                "z": -323.4544982910156
            },
            {
                "x": 14.484858512878418,
                "y": 1.0280450582504272,
                "z": -323.3017883300781
            },
            {
                "x": 14.524531364440918,
                "y": 1.019808292388916,
                "z": -323.1490783691406
            },
            {
                "x": 14.563871383666992,
                "y": 1.0114076137542725,
                "z": -322.99639892578125
            },
            {
                "x": 14.602971076965332,
                "y": 1.0028471946716309,
                "z": -322.8438415527344
            },
            {
                "x": 14.641908645629883,
                "y": 0.994118332862854,
                "z": -322.69122314453125
            },
            {
                "x": 14.680679321289062,
                "y": 0.9852052927017212,
                "z": -322.5382080078125
            },
            {
                "x": 14.71910285949707,
                "y": 0.9761402010917664,
                "z": -322.3851318359375
            },
            {
                "x": 14.757179260253906,
                "y": 0.9669463634490967,
                "z": -322.2323303222656
            },
            {
                "x": 14.79509162902832,
                "y": 0.9575989246368408,
                "z": -322.0794372558594
            },
            {
                "x": 14.83282470703125,
                "y": 0.9480989575386047,
                "z": -321.9263916015625
            },
            {
                "x": 14.87026596069336,
                "y": 0.9384521245956421,
                "z": -321.7731628417969
            },
            {
                "x": 14.907395362854004,
                "y": 0.9286670684814453,
                "z": -321.6197204589844
            },
            {
                "x": 14.944169998168945,
                "y": 0.9187851548194885,
                "z": -321.466796875
            },
            {
                "x": 14.98082160949707,
                "y": 0.9087623357772827,
                "z": -321.3136291503906
            },
            {
                "x": 15.004384994506836,
                "y": 0.9022142887115479,
                "z": -321.2144775390625
            },
            {
                "x": 15.040578842163086,
                "y": 0.8919793367385864,
                "z": -321.06097412109375
            },
            {
                "x": 15.076416969299316,
                "y": 0.8816304206848145,
                "z": -320.9073791503906
            },
            {
                "x": 15.11197280883789,
                "y": 0.8711913824081421,
                "z": -320.7540283203125
            },
            {
                "x": 15.14736270904541,
                "y": 0.8606414198875427,
                "z": -320.6005859375
            },
            {
                "x": 15.182533264160156,
                "y": 0.8499650359153748,
                "z": -320.4466857910156
            },
            {
                "x": 15.21727180480957,
                "y": 0.8392013311386108,
                "z": -320.29290771484375
            },
            {
                "x": 15.25166130065918,
                "y": 0.8283641934394836,
                "z": -320.1393127441406
            },
            {
                "x": 15.285904884338379,
                "y": 0.817428708076477,
                "z": -319.9855041503906
            },
            {
                "x": 15.319897651672363,
                "y": 0.8064060211181641,
                "z": -319.8316650390625
            },
            {
                "x": 15.353569984436035,
                "y": 0.7952827215194702,
                "z": -319.6773986816406
            },
            {
                "x": 15.386823654174805,
                "y": 0.7841011881828308,
                "z": -319.5233459472656
            },
            {
                "x": 15.41976547241211,
                "y": 0.7728717923164368,
                "z": -319.36956787109375
            },
            {
                "x": 15.452591896057129,
                "y": 0.7615513205528259,
                "z": -319.2153625488281
            },
            {
                "x": 15.485098838806152,
                "y": 0.7501575946807861,
                "z": -319.06097412109375
            },
            {
                "x": 15.51719856262207,
                "y": 0.7387099266052246,
                "z": -318.9065856933594
            },
            {
                "x": 15.548948287963867,
                "y": 0.7272210717201233,
                "z": -318.7522888183594
            },
            {
                "x": 15.58044719696045,
                "y": 0.7156994342803955,
                "z": -318.59814453125
            },
            {
                "x": 15.611741065979004,
                "y": 0.7041012048721313,
                "z": -318.4435729980469
            },
            {
                "x": 15.642664909362793,
                "y": 0.6924487352371216,
                "z": -318.2887268066406
            },
            {
                "x": 15.67314338684082,
                "y": 0.6807854175567627,
                "z": -318.1341857910156
            },
            {
                "x": 15.703313827514648,
                "y": 0.6691094040870667,
                "z": -317.97979736328125
            },
            {
                "x": 15.733297348022461,
                "y": 0.6573908925056458,
                "z": -317.8251647949219
            },
            {
                "x": 15.762961387634277,
                "y": 0.6456267833709717,
                "z": -317.67022705078125
            },
            {
                "x": 15.792227745056152,
                "y": 0.6338297128677368,
                "z": -317.5150146484375
            },
            {
                "x": 15.821049690246582,
                "y": 0.6220600605010986,
                "z": -317.3603210449219
            },
            {
                "x": 15.849668502807617,
                "y": 0.6102766990661621,
                "z": -317.20550537109375
            },
            {
                "x": 15.87802505493164,
                "y": 0.5984631180763245,
                "z": -317.0503234863281
            },
            {
                "x": 15.90596866607666,
                "y": 0.5866397619247437,
                "z": -316.89501953125
            },
            {
                "x": 15.933492660522461,
                "y": 0.5748226642608643,
                "z": -316.7396545410156
            },
            {
                "x": 15.960657119750977,
                "y": 0.5630444884300232,
                "z": -316.58465576171875
            },
            {
                "x": 15.987605094909668,
                "y": 0.5512678623199463,
                "z": -316.4295349121094
            },
            {
                "x": 16.01424789428711,
                "y": 0.5394681692123413,
                "z": -316.2738037109375
            },
            {
                "x": 16.040395736694336,
                "y": 0.5277038812637329,
                "z": -316.1182556152344
            },
            {
                "x": 16.066152572631836,
                "y": 0.5159763693809509,
                "z": -315.9627685546875
            },
            {
                "x": 16.091644287109375,
                "y": 0.5042870044708252,
                "z": -315.8073425292969
            },
            {
                "x": 16.116853713989258,
                "y": 0.49260663986206055,
                "z": -315.6516418457031
            },
            {
                "x": 16.141639709472656,
                "y": 0.48094385862350464,
                "z": -315.49554443359375
            },
            {
                "x": 16.16592788696289,
                "y": 0.4693506360054016,
                "z": -315.3398132324219
            },
            {
                "x": 16.18988800048828,
                "y": 0.45782193541526794,
                "z": -315.184326171875
            },
            {
                "x": 16.213640213012695,
                "y": 0.44630998373031616,
                "z": -315.0282897949219
            },
            {
                "x": 16.23698616027832,
                "y": 0.43484216928482056,
                "z": -314.8721008300781
            },
            {
                "x": 16.25982093811035,
                "y": 0.42344003915786743,
                "z": -314.7159118652344
            },
            {
                "x": 16.27433204650879,
                "y": 0.41612154245376587,
                "z": -314.6151428222656
            },
            {
                "x": 16.296573638916016,
                "y": 0.4048542380332947,
                "z": -314.4593200683594
            },
            {
                "x": 16.318572998046875,
                "y": 0.39362633228302,
                "z": -314.3030700683594
            },
            {
                "x": 16.34012794494629,
                "y": 0.3824511170387268,
                "z": -314.1463928222656
            },
            {
                "x": 16.361135482788086,
                "y": 0.3713777959346771,
                "z": -313.98992919921875
            },
            {
                "x": 16.381778717041016,
                "y": 0.3604038655757904,
                "z": -313.833740234375
            },
            {
                "x": 16.402170181274414,
                "y": 0.3495112657546997,
                "z": -313.677490234375
            },
            {
                "x": 16.422183990478516,
                "y": 0.3386809825897217,
                "z": -313.5207214355469
            },
            {
                "x": 16.44167709350586,
                "y": 0.3279348611831665,
                "z": -313.3636474609375
            },
            {
                "x": 16.460678100585938,
                "y": 0.3173278570175171,
                "z": -313.2071533203125
            },
            {
                "x": 16.479393005371094,
                "y": 0.30682694911956787,
                "z": -313.0507507324219
            },
            {
                "x": 16.4978084564209,
                "y": 0.29640626907348633,
                "z": -312.89385986328125
            },
            {
                "x": 16.515703201293945,
                "y": 0.2860892415046692,
                "z": -312.73675537109375
            },
            {
                "x": 16.533084869384766,
                "y": 0.27589309215545654,
                "z": -312.5796203613281
            },
            {
                "x": 16.550077438354492,
                "y": 0.26585128903388977,
                "z": -312.4230041503906
            },
            {
                "x": 16.566801071166992,
                "y": 0.2559170126914978,
                "z": -312.26617431640625
            },
            {
                "x": 16.583087921142578,
                "y": 0.2460825890302658,
                "z": -312.1086730957031
            },
            {
                "x": 16.59879493713379,
                "y": 0.23639275133609772,
                "z": -311.9513244628906
            },
            {
                "x": 16.614046096801758,
                "y": 0.22686049342155457,
                "z": -311.7943115234375
            },
            {
                "x": 16.6290283203125,
                "y": 0.21746471524238586,
                "z": -311.63720703125
            },
            {
                "x": 16.643613815307617,
                "y": 0.20820054411888123,
                "z": -311.47979736328125
            },
            {
                "x": 16.657634735107422,
                "y": 0.1990780383348465,
                "z": -311.3221130371094
            },
            {
                "x": 16.671119689941406,
                "y": 0.19012826681137085,
                "z": -311.164794921875
            },
            {
                "x": 16.68425178527832,
                "y": 0.18135307729244232,
                "z": -311.00775146484375
            },
            {
                "x": 16.697093963623047,
                "y": 0.17271023988723755,
                "z": -310.8500671386719
            },
            {
                "x": 16.70939826965332,
                "y": 0.16422641277313232,
                "z": -310.6921691894531
            },
            {
                "x": 16.721115112304688,
                "y": 0.15592017769813538,
                "z": -310.534423828125
            },
            {
                "x": 16.73238754272461,
                "y": 0.14780855178833008,
                "z": -310.37701416015625
            },
            {
                "x": 16.743358612060547,
                "y": 0.13987989723682404,
                "z": -310.2195739746094
            },
            {
                "x": 16.753902435302734,
                "y": 0.13209882378578186,
                "z": -310.0614318847656
            },
            {
                "x": 16.76382827758789,
                "y": 0.12451238185167313,
                "z": -309.9033203125
            },
            {
                "x": 16.77322006225586,
                "y": 0.11713609099388123,
                "z": -309.7456970214844
            },
            {
                "x": 16.782278060913086,
                "y": 0.1099618449807167,
                "z": -309.58807373046875
            },
            {
                "x": 16.79096031188965,
                "y": 0.10297416150569916,
                "z": -309.4300842285156
            },
            {
                "x": 16.799074172973633,
                "y": 0.09617093950510025,
                "z": -309.2716979980469
            },
            {
                "x": 16.80657958984375,
                "y": 0.08958879858255386,
                "z": -309.1136169433594
            },
            {
                "x": 16.81365966796875,
                "y": 0.0832425132393837,
                "z": -308.9559020996094
            },
            {
                "x": 16.820423126220703,
                "y": 0.07709796726703644,
                "z": -308.7978820800781
            },
            {
                "x": 16.82666015625,
                "y": 0.0711590051651001,
                "z": -308.6394958496094
            },
            {
                "x": 16.832256317138672,
                "y": 0.0654461607336998,
                "z": -308.48114013671875
            },
            {
                "x": 16.837343215942383,
                "y": 0.05997654050588608,
                "z": -308.32305908203125
            },
            {
                "x": 16.842105865478516,
                "y": 0.054747574031353,
                "z": -308.1651611328125
            },
            {
                "x": 16.846418380737305,
                "y": 0.049736835062503815,
                "z": -308.00677490234375
            },
            {
                "x": 16.848875045776367,
                "y": 0.04662035405635834,
                "z": -307.9043273925781
            },
            {
                "x": 16.85212516784668,
                "y": 0.04201440140604973,
                "z": -307.7459716796875
            },
            {
                "x": 16.854936599731445,
                "y": 0.037663187831640244,
                "z": -307.58795166015625
            },
            {
                "x": 16.857419967651367,
                "y": 0.0335550531744957,
                "z": -307.4297790527344
            },
            {
                "x": 16.859378814697266,
                "y": 0.02969399094581604,
                "z": -307.2712097167969
            },
            {
                "x": 16.860641479492188,
                "y": 0.026096569374203682,
                "z": -307.1125183105469
            },
            {
                "x": 16.861366271972656,
                "y": 0.022772613912820816,
                "z": -306.9544372558594
            },
            {
                "x": 16.861753463745117,
                "y": 0.019714422523975372,
                "z": -306.7964172363281
            },
            {
                "x": 16.8616943359375,
                "y": 0.016914186999201775,
                "z": -306.6377258300781
            },
            {
                "x": 16.860952377319336,
                "y": 0.014396345242857933,
                "z": -306.47894287109375
            },
            {
                "x": 16.859582901000977,
                "y": 0.012159671634435654,
                "z": -306.3205261230469
            },
            {
                "x": 16.857816696166992,
                "y": 0.010207715444266796,
                "z": -306.1624755859375
            },
            {
                "x": 16.855674743652344,
                "y": 0.008538264781236649,
                "z": -306.0041809082031
            },
            {
                "x": 16.85289192199707,
                "y": 0.0071616386994719505,
                "z": -305.8451843261719
            },
            {
                "x": 16.84942626953125,
                "y": 0.006080118473619223,
                "z": -305.6866455078125
            },
            {
                "x": 16.845468521118164,
                "y": 0.005296171642839909,
                "z": -305.52862548828125
            },
            {
                "x": 16.841163635253906,
                "y": 0.0048120031133294106,
                "z": -305.3704833984375
            },
            {
                "x": 16.836313247680664,
                "y": 0.00463857501745224,
                "z": -305.2119140625
            },
            {
                "x": 16.83074378967285,
                "y": 0.004630044102668762,
                "z": -305.05316162109375
            },
            {
                "x": 16.8245792388916,
                "y": 0.0046251267194747925,
                "z": -304.8948059082031
            },
            {
                "x": 16.818052291870117,
                "y": 0.004620179533958435,
                "z": -304.7369689941406
            },
            {
                "x": 16.811063766479492,
                "y": 0.004615329205989838,
                "z": -304.5786437988281
            },
            {
                "x": 16.803388595581055,
                "y": 0.0046103596687316895,
                "z": -304.4200134277344
            },
            {
                "x": 16.795034408569336,
                "y": 0.004605472087860107,
                "z": -304.26165771484375
            },
            {
                "x": 16.786224365234375,
                "y": 0.0046005770564079285,
                "z": -304.1036376953125
            },
            {
                "x": 16.777036666870117,
                "y": 0.004595629870891571,
                "z": -303.9456787109375
            },
            {
                "x": 16.767215728759766,
                "y": 0.00459076464176178,
                "z": -303.787109375
            },
            {
                "x": 16.75666618347168,
                "y": 0.004585839807987213,
                "z": -303.6286926269531
            },
            {
                "x": 16.74557113647461,
                "y": 0.004580885171890259,
                "z": -303.4708251953125
            },
            {
                "x": 16.73409652709961,
                "y": 0.004575982689857483,
                "z": -303.31298828125
            },
            {
                "x": 16.722103118896484,
                "y": 0.004571050405502319,
                "z": -303.1548156738281
            },
            {
                "x": 16.709369659423828,
                "y": 0.004566170275211334,
                "z": -302.9964599609375
            },
            {
                "x": 16.695980072021484,
                "y": 0.004561245441436768,
                "z": -302.8384094238281
            },
            {
                "x": 16.68218231201172,
                "y": 0.004556320607662201,
                "z": -302.6809997558594
            },
            {
                "x": 16.66794204711914,
                "y": 0.004551410675048828,
                "z": -302.523193359375
            },
            {
                "x": 16.65300750732422,
                "y": 0.004546500742435455,
                "z": -302.36492919921875
            },
            {
                "x": 16.637351989746094,
                "y": 0.004541561007499695,
                "z": -302.20697021484375
            },
            {
                "x": 16.62117576599121,
                "y": 0.00453668087720871,
                "z": -302.0495910644531
            },
            {
                "x": 16.604650497436523,
                "y": 0.004531741142272949,
                "z": -301.892333984375
            },
            {
                "x": 16.587507247924805,
                "y": 0.00452684611082077,
                "z": -301.7344665527344
            },
            {
                "x": 16.5695743560791,
                "y": 0.004521898925304413,
                "z": -301.576416015625
            },
            {
                "x": 16.551036834716797,
                "y": 0.00451698899269104,
                "z": -301.41912841796875
            },
            {
                "x": 16.53213882446289,
                "y": 0.004512093961238861,
                "z": -301.2622375488281
            },
            {
                "x": 16.519685745239258,
                "y": 0.004508867859840393,
                "z": -301.1606140136719
            },
            {
                "x": 16.49980354309082,
                "y": 0.004503965377807617,
                "z": -301.0030212402344
            },
            {
                "x": 16.479137420654297,
                "y": 0.0044990405440330505,
                "z": -300.8454284667969
            },
            {
                "x": 16.457929611206055,
                "y": 0.004494145512580872,
                "z": -300.6885070800781
            },
            {
                "x": 16.43638801574707,
                "y": 0.004489250481128693,
                "z": -300.5318603515625
            },
            {
                "x": 16.414230346679688,
                "y": 0.004484295845031738,
                "z": -300.3746643066406
            },
            {
                "x": 16.391294479370117,
                "y": 0.004479393362998962,
                "z": -300.2174072265625
            },
            {
                "x": 16.367706298828125,
                "y": 0.004474475979804993,
                "z": -300.0606384277344
            },
            {
                "x": 16.343698501586914,
                "y": 0.004469573497772217,
                "z": -299.9042053222656
            },
            {
                "x": 16.319257736206055,
                "y": 0.0044647082686424255,
                "z": -299.7476501464844
            },
            {
                "x": 16.294052124023438,
                "y": 0.004459753632545471,
                "z": -299.5907287597656
            },
            {
                "x": 16.268091201782227,
                "y": 0.004454821348190308,
                "z": -299.43402099609375
            },
            {
                "x": 16.24164581298828,
                "y": 0.004449918866157532,
                "z": -299.27801513671875
            },
            {
                "x": 16.214799880981445,
                "y": 0.004445008933544159,
                "z": -299.1219787597656
            },
            {
                "x": 16.187339782714844,
                "y": 0.004440084099769592,
                "z": -298.9656677246094
            },
            {
                "x": 16.159067153930664,
                "y": 0.0044351667165756226,
                "z": -298.8092041015625
            },
            {
                "x": 16.130144119262695,
                "y": 0.004430271685123444,
                "z": -298.6531982421875
            },
            {
                "x": 16.100889205932617,
                "y": 0.004425309598445892,
                "z": -298.4979248046875
            },
            {
                "x": 16.07109832763672,
                "y": 0.004420414566993713,
                "z": -298.3421630859375
            },
            {
                "x": 16.040536880493164,
                "y": 0.004415497183799744,
                "z": -298.18609619140625
            },
            {
                "x": 16.009244918823242,
                "y": 0.004410572350025177,
                "z": -298.0303955078125
            },
            {
                "x": 15.977476119995117,
                "y": 0.00440572202205658,
                "z": -297.8753967285156
            },
            {
                "x": 15.945331573486328,
                "y": 0.004400752484798431,
                "z": -297.72052001953125
            },
            {
                "x": 15.912529945373535,
                "y": 0.004395827651023865,
                "z": -297.565185546875
            },
            {
                "x": 15.878862380981445,
                "y": 0.004390940070152283,
                "z": -297.4096374511719
            },
            {
                "x": 15.844633102416992,
                "y": 0.004386022686958313,
                "z": -297.2548828125
            },
            {
                "x": 15.810032844543457,
                "y": 0.004381135106086731,
                "z": -297.1005859375
            },
            {
                "x": 15.774916648864746,
                "y": 0.0043761953711509705,
                "z": -296.94598388671875
            },
            {
                "x": 15.739023208618164,
                "y": 0.004371263086795807,
                "z": -296.7911376953125
            },
            {
                "x": 15.702336311340332,
                "y": 0.004366382956504822,
                "z": -296.636474609375
            },
            {
                "x": 15.665246963500977,
                "y": 0.004361428320407867,
                "z": -296.4826965332031
            },
            {
                "x": 15.627790451049805,
                "y": 0.004356548190116882,
                "z": -296.3290100097656
            },
            {
                "x": 15.589615821838379,
                "y": 0.004351615905761719,
                "z": -296.1748046875
            },
            {
                "x": 15.55064868927002,
                "y": 0.004346705973148346,
                "z": -296.02069091796875
            },
            {
                "x": 15.511026382446289,
                "y": 0.00434180349111557,
                "z": -295.8670959472656
            },
            {
                "x": 15.471094131469727,
                "y": 0.004336856305599213,
                "z": -295.71405029296875
            },
            {
                "x": 15.430684089660645,
                "y": 0.004331961274147034,
                "z": -295.5608825683594
            },
            {
                "x": 15.38943862915039,
                "y": 0.004327014088630676,
                "z": -295.4072570800781
            },
            {
                "x": 15.347448348999023,
                "y": 0.0043221116065979,
                "z": -295.2541198730469
            },
            {
                "x": 15.305031776428223,
                "y": 0.0043172091245651245,
                "z": -295.10162353515625
            },
            {
                "x": 15.262205123901367,
                "y": 0.004312284290790558,
                "z": -294.94921875
            },
            {
                "x": 15.218779563903809,
                "y": 0.004307366907596588,
                "z": -294.796630859375
            },
            {
                "x": 15.17451286315918,
                "y": 0.004302464425563812,
                "z": -294.6439208984375
            },
            {
                "x": 15.145559310913086,
                "y": 0.004299290478229523,
                "z": -294.5455017089844
            },
            {
                "x": 15.100459098815918,
                "y": 0.004294358193874359,
                "z": -294.3939514160156
            },
            {
                "x": 15.054964065551758,
                "y": 0.004289440810680389,
                "z": -294.2423095703125
            },
            {
                "x": 15.008758544921875,
                "y": 0.00428452342748642,
                "z": -294.0903625488281
            },
            {
                "x": 14.961773872375488,
                "y": 0.004279613494873047,
                "z": -293.93853759765625
            },
            {
                "x": 14.914155006408691,
                "y": 0.004274711012840271,
                "z": -293.78717041015625
            },
            {
                "x": 14.866229057312012,
                "y": 0.004269793629646301,
                "z": -293.6365051269531
            },
            {
                "x": 14.817854881286621,
                "y": 0.0042648836970329285,
                "z": -293.4858093261719
            },
            {
                "x": 14.768640518188477,
                "y": 0.004259966313838959,
                "z": -293.3345642089844
            },
            {
                "x": 14.718730926513672,
                "y": 0.004255041480064392,
                "z": -293.18377685546875
            },
            {
                "x": 14.668330192565918,
                "y": 0.004250146448612213,
                "z": -293.03363037109375
            },
            {
                "x": 14.6176176071167,
                "y": 0.004245229065418243,
                "z": -292.88385009765625
            },
            {
                "x": 14.566327095031738,
                "y": 0.00424029678106308,
                "z": -292.73382568359375
            },
            {
                "x": 14.514142990112305,
                "y": 0.004235416650772095,
                "z": -292.5834655761719
            },
            {
                "x": 14.46134090423584,
                "y": 0.004230514168739319,
                "z": -292.433837890625
            },
            {
                "x": 14.408219337463379,
                "y": 0.004225574433803558,
                "z": -292.2848815917969
            },
            {
                "x": 14.354679107666016,
                "y": 0.004220649600028992,
                "z": -292.13592529296875
            },
            {
                "x": 14.30046558380127,
                "y": 0.004215747117996216,
                "z": -291.98675537109375
            },
            {
                "x": 14.245424270629883,
                "y": 0.004208327271044254,
                "z": -291.837646484375
            },
            {
                "x": 14.189790725708008,
                "y": 0.003974620718508959,
                "z": -291.68902587890625
            },
            {
                "x": 14.133929252624512,
                "y": 0.0031657074578106403,
                "z": -291.5411376953125
            },
            {
                "x": 14.077638626098633,
                "y": 0.0017740119947120547,
                "z": -291.3931884765625
            },
            {
                "x": 14.020538330078125,
                "y": -0.0002195353154093027,
                "z": -291.24505615234375
            },
            {
                "x": 13.962691307067871,
                "y": -0.0027799326926469803,
                "z": -291.0970764160156
            },
            {
                "x": 13.9043550491333,
                "y": -0.005886987317353487,
                "z": -290.94970703125
            },
            {
                "x": 13.845845222473145,
                "y": -0.009522926062345505,
                "z": -290.8029479980469
            },
            {
                "x": 13.786722183227539,
                "y": -0.01372027862817049,
                "z": -290.6559753417969
            },
            {
                "x": 13.72680950164795,
                "y": -0.018452998250722885,
                "z": -290.5088195800781
            },
            {
                "x": 13.666258811950684,
                "y": -0.02369021251797676,
                "z": -290.3621826171875
            },
            {
                "x": 13.6052827835083,
                "y": -0.029414141550660133,
                "z": -290.21612548828125
            },
            {
                "x": 13.544109344482422,
                "y": -0.03562626242637634,
                "z": -290.07049560546875
            },
            {
                "x": 13.482325553894043,
                "y": -0.04233890026807785,
                "z": -289.9246520996094
            },
            {
                "x": 13.419721603393555,
                "y": -0.04953668266534805,
                "z": -289.77874755859375
            },
            {
                "x": 13.356618881225586,
                "y": -0.057170767337083817,
                "z": -289.63348388671875
            },
            {
                "x": 13.293233871459961,
                "y": -0.06524030864238739,
                "z": -289.48883056640625
            },
            {
                "x": 13.22951889038086,
                "y": -0.07375076413154602,
                "z": -289.34429931640625
            },
            {
                "x": 13.165184020996094,
                "y": -0.08270236849784851,
                "z": -289.19964599609375
            },
            {
                "x": 13.10017204284668,
                "y": -0.09207459539175034,
                "z": -289.0550842285156
            },
            {
                "x": 13.034825325012207,
                "y": -0.10182779282331467,
                "z": -288.9112854003906
            },
            {
                "x": 12.969337463378906,
                "y": -0.11194800585508347,
                "z": -288.76800537109375
            },
            {
                "x": 12.903327941894531,
                "y": -0.12248028069734573,
                "z": -288.62445068359375
            },
            {
                "x": 12.836809158325195,
                "y": -0.13338273763656616,
                "z": -288.4809875488281
            },
            {
                "x": 12.769885063171387,
                "y": -0.1446308195590973,
                "z": -288.3381042480469
            },
            {
                "x": 12.726593971252441,
                "y": -0.15206784009933472,
                "z": -288.2460632324219
            },
            {
                "x": 12.659332275390625,
                "y": -0.16385695338249207,
                "z": -288.1036682128906
            },
            {
                "x": 12.591546058654785,
                "y": -0.17600062489509583,
                "z": -287.96112060546875
            },
            {
                "x": 12.523432731628418,
                "y": -0.1884554922580719,
                "z": -287.8189697265625
            },
            {
                "x": 12.455212593078613,
                "y": -0.20119279623031616,
                "z": -287.67718505859375
            },
            {
                "x": 12.386580467224121,
                "y": -0.2142401486635208,
                "z": -287.535400390625
            },
            {
                "x": 12.317964553833008,
                "y": -0.22752061486244202,
                "z": -287.39422607421875
            },
            {
                "x": 12.249194145202637,
                "y": -0.2410924732685089,
                "z": -287.2530517578125
            },
            {
                "x": 12.180205345153809,
                "y": -0.2549322545528412,
                "z": -287.1118469238281
            },
            {
                "x": 12.111324310302734,
                "y": -0.2689841389656067,
                "z": -286.9710693359375
            },
            {
                "x": 12.042274475097656,
                "y": -0.2832913100719452,
                "z": -286.83013916015625
            },
            {
                "x": 11.973175048828125,
                "y": -0.2978236675262451,
                "z": -286.68939208984375
            },
            {
                "x": 11.903984069824219,
                "y": -0.31257542967796326,
                "z": -286.5487365722656
            },
            {
                "x": 11.834664344787598,
                "y": -0.32754042744636536,
                "z": -286.407958984375
            },
            {
                "x": 11.765356063842773,
                "y": -0.34268438816070557,
                "z": -286.2674255371094
            },
            {
                "x": 11.695959091186523,
                "y": -0.35801464319229126,
                "z": -286.126953125
            },
            {
                "x": 11.626495361328125,
                "y": -0.37352216243743896,
                "z": -285.9864501953125
            },
            {
                "x": 11.557023048400879,
                "y": -0.389182448387146,
                "z": -285.8461608886719
            },
            {
                "x": 11.487457275390625,
                "y": -0.4050031900405884,
                "z": -285.70574951171875
            },
            {
                "x": 11.417701721191406,
                "y": -0.42098307609558105,
                "z": -285.5653076171875
            },
            {
                "x": 11.34802532196045,
                "y": -0.43706220388412476,
                "z": -285.4251708984375
            },
            {
                "x": 11.278251647949219,
                "y": -0.453271746635437,
                "z": -285.2850036621094
            },
            {
                "x": 11.208473205566406,
                "y": -0.46957632899284363,
                "z": -285.1449890136719
            },
            {
                "x": 11.138615608215332,
                "y": -0.4859859347343445,
                "z": -285.0048828125
            },
            {
                "x": 11.068597793579102,
                "y": -0.502509593963623,
                "z": -284.86468505859375
            },
            {
                "x": 10.9986572265625,
                "y": -0.5190764665603638,
                "z": -284.7247619628906
            },
            {
                "x": 10.928635597229004,
                "y": -0.5357227921485901,
                "z": -284.584716796875
            },
            {
                "x": 10.858595848083496,
                "y": -0.5524169206619263,
                "z": -284.4448547363281
            },
            {
                "x": 10.788487434387207,
                "y": -0.5691606998443604,
                "z": -284.3049011230469
            },
            {
                "x": 10.718307495117188,
                "y": -0.5859493017196655,
                "z": -284.1649169921875
            },
            {
                "x": 10.648147583007812,
                "y": -0.6027441024780273,
                "z": -284.025146484375
            },
            {
                "x": 10.577951431274414,
                "y": -0.6195497512817383,
                "z": -283.8852844238281
            },
            {
                "x": 10.507699012756348,
                "y": -0.6363657712936401,
                "z": -283.7455139160156
            },
            {
                "x": 10.437443733215332,
                "y": -0.6531671285629272,
                "z": -283.605712890625
            },
            {
                "x": 10.36712646484375,
                "y": -0.6699501276016235,
                "z": -283.4659118652344
            },
            {
                "x": 10.296797752380371,
                "y": -0.6867046356201172,
                "z": -283.3262023925781
            },
            {
                "x": 10.226547241210938,
                "y": -0.7034008502960205,
                "z": -283.1865234375
            },
            {
                "x": 10.15613842010498,
                "y": -0.7200703620910645,
                "z": -283.0467224121094
            },
            {
                "x": 10.085832595825195,
                "y": -0.7366516590118408,
                "z": -282.9071044921875
            },
            {
                "x": 10.015528678894043,
                "y": -0.753162145614624,
                "z": -282.7674560546875
            },
            {
                "x": 9.945119857788086,
                "y": -0.7696106433868408,
                "z": -282.627685546875
            },
            {
                "x": 9.87475299835205,
                "y": -0.7859589457511902,
                "z": -282.4878234863281
            },
            {
                "x": 9.804369926452637,
                "y": -0.8021903038024902,
                "z": -282.34820556640625
            },
            {
                "x": 9.758916854858398,
                "y": -0.8126159310340881,
                "z": -282.2579650878906
            },
            {
                "x": 9.688546180725098,
                "y": -0.8286515474319458,
                "z": -282.1182556152344
            },
            {
                "x": 9.61812973022461,
                "y": -0.844559907913208,
                "z": -281.9784851074219
            },
            {
                "x": 9.54775619506836,
                "y": -0.860319197177887,
                "z": -281.8387756347656
            },
            {
                "x": 9.477420806884766,
                "y": -0.875922679901123,
                "z": -281.69903564453125
            },
            {
                "x": 9.40706729888916,
                "y": -0.8913648128509521,
                "z": -281.5592346191406
            },
            {
                "x": 9.336827278137207,
                "y": -0.9066075086593628,
                "z": -281.4195861816406
            },
            {
                "x": 9.266560554504395,
                "y": -0.9216785430908203,
                "z": -281.2797546386719
            },
            {
                "x": 9.196274757385254,
                "y": -0.9365624189376831,
                "z": -281.1398620605469
            },
            {
                "x": 9.126043319702148,
                "y": -0.9512322545051575,
                "z": -280.9999084472656
            },
            {
                "x": 9.055882453918457,
                "y": -0.9656684398651123,
                "z": -280.8600769042969
            },
            {
                "x": 8.985743522644043,
                "y": -0.9798809885978699,
                "z": -280.7201232910156
            },
            {
                "x": 8.915691375732422,
                "y": -0.9938458204269409,
                "z": -280.5802001953125
            },
            {
                "x": 8.845513343811035,
                "y": -1.0075888633728027,
                "z": -280.4400329589844
            },
            {
                "x": 8.775568962097168,
                "y": -1.0210297107696533,
                "z": -280.300048828125
            },
            {
                "x": 8.705670356750488,
                "y": -1.0341997146606445,
                "z": -280.1600036621094
            },
            {
                "x": 8.635695457458496,
                "y": -1.0471065044403076,
                "z": -280.019775390625
            },
            {
                "x": 8.565908432006836,
                "y": -1.0597007274627686,
                "z": -279.879638671875
            },
            {
                "x": 8.49614429473877,
                "y": -1.0719847679138184,
                "z": -279.739501953125
            },
            {
                "x": 8.426462173461914,
                "y": -1.0839574337005615,
                "z": -279.5990905761719
            },
            {
                "x": 8.356876373291016,
                "y": -1.0955950021743774,
                "z": -279.45880126953125
            },
            {
                "x": 8.287369728088379,
                "y": -1.1068992614746094,
                "z": -279.3184814453125
            },
            {
                "x": 8.217952728271484,
                "y": -1.117837905883789,
                "z": -279.1781311035156
            },
            {
                "x": 8.14863395690918,
                "y": -1.1284174919128418,
                "z": -279.03765869140625
            },
            {
                "x": 8.079296112060547,
                "y": -1.1386446952819824,
                "z": -278.89691162109375
            },
            {
                "x": 8.010150909423828,
                "y": -1.1484763622283936,
                "z": -278.75634765625
            },
            {
                "x": 7.941047191619873,
                "y": -1.1579115390777588,
                "z": -278.6155700683594
            },
            {
                "x": 7.8721208572387695,
                "y": -1.1669307947158813,
                "z": -278.4748229980469
            },
            {
                "x": 7.8032755851745605,
                "y": -1.1755397319793701,
                "z": -278.333984375
            },
            {
                "x": 7.7345123291015625,
                "y": -1.1837300062179565,
                "z": -278.1930236816406
            },
            {
                "x": 7.665921688079834,
                "y": -1.1914703845977783,
                "z": -278.0520324707031
            },
            {
                "x": 7.597467422485352,
                "y": -1.1987512111663818,
                "z": -277.9110107421875
            },
            {
                "x": 7.529075622558594,
                "y": -1.2055834531784058,
                "z": -277.7698059082031
            },
            {
                "x": 7.460907459259033,
                "y": -1.2119389772415161,
                "z": -277.6286926269531
            },
            {
                "x": 7.392771244049072,
                "y": -1.2178159952163696,
                "z": -277.4872741699219
            },
            {
                "x": 7.324837684631348,
                "y": -1.22318434715271,
                "z": -277.34588623046875
            },
            {
                "x": 7.257091999053955,
                "y": -1.2280504703521729,
                "z": -277.2044982910156
            },
            {
                "x": 7.189434051513672,
                "y": -1.2324085235595703,
                "z": -277.06292724609375
            },
            {
                "x": 7.121991157531738,
                "y": -1.2362329959869385,
                "z": -276.92132568359375
            },
            {
                "x": 7.054696083068848,
                "y": -1.239506721496582,
                "z": -276.77972412109375
            },
            {
                "x": 6.9875335693359375,
                "y": -1.2422399520874023,
                "z": -276.6377868652344
            },
            {
                "x": 6.920581340789795,
                "y": -1.2444159984588623,
                "z": -276.4959716796875
            },
            {
                "x": 6.853879928588867,
                "y": -1.246016502380371,
                "z": -276.3541259765625
            },
            {
                "x": 6.810854434967041,
                "y": -1.2467288970947266,
                "z": -276.2623596191406
            },
            {
                "x": 6.744463920593262,
                "y": -1.2473645210266113,
                "z": -276.12042236328125
            },
            {
                "x": 6.6781744956970215,
                "y": -1.247403860092163,
                "z": -275.9781188964844
            },
            {
                "x": 6.6121296882629395,
                "y": -1.2468223571777344,
                "z": -275.8359069824219
            },
            {
                "x": 6.546297550201416,
                "y": -1.2456563711166382,
                "z": -275.69354248046875
            },
            {
                "x": 6.480654239654541,
                "y": -1.24391770362854,
                "z": -275.5511779785156
            },
            {
                "x": 6.4152069091796875,
                "y": -1.2416130304336548,
                "z": -275.4085693359375
            },
            {
                "x": 6.350097179412842,
                "y": -1.2387363910675049,
                "z": -275.2662048339844
            },
            {
                "x": 6.285038948059082,
                "y": -1.2353105545043945,
                "z": -275.1233215332031
            },
            {
                "x": 6.2203874588012695,
                "y": -1.2313659191131592,
                "z": -274.9807434082031
            },
            {
                "x": 6.155867576599121,
                "y": -1.2268946170806885,
                "z": -274.83782958984375
            },
            {
                "x": 6.091648578643799,
                "y": -1.2218962907791138,
                "z": -274.69500732421875
            },
            {
                "x": 6.027713775634766,
                "y": -1.2164011001586914,
                "z": -274.55206298828125
            },
            {
                "x": 5.9638872146606445,
                "y": -1.210414171218872,
                "z": -274.4088439941406
            },
            {
                "x": 5.900403022766113,
                "y": -1.2039577960968018,
                "z": -274.2657165527344
            },
            {
                "x": 5.837181091308594,
                "y": -1.197020173072815,
                "z": -274.12255859375
            },
            {
                "x": 5.774242401123047,
                "y": -1.1896255016326904,
                "z": -273.97918701171875
            },
            {
                "x": 5.711514472961426,
                "y": -1.181788682937622,
                "z": -273.8357238769531
            },
            {
                "x": 5.649117946624756,
                "y": -1.1735260486602783,
                "z": -273.69232177734375
            },
            {
                "x": 5.586929798126221,
                "y": -1.1648194789886475,
                "z": -273.5486145019531
            },
            {
                "x": 5.525132179260254,
                "y": -1.1557130813598633,
                "z": -273.4049987792969
            },
            {
                "x": 5.463552474975586,
                "y": -1.1462054252624512,
                "z": -273.2613220214844
            },
            {
                "x": 5.402327537536621,
                "y": -1.1363184452056885,
                "z": -273.1175537109375
            },
            {
                "x": 5.341331481933594,
                "y": -1.1260350942611694,
                "z": -272.9736022949219
            },
            {
                "x": 5.28062105178833,
                "y": -1.1153769493103027,
                "z": -272.8294677734375
            },
            {
                "x": 5.220181465148926,
                "y": -1.1043695211410522,
                "z": -272.685302734375
            },
            {
                "x": 5.1601409912109375,
                "y": -1.0930306911468506,
                "z": -272.5412292480469
            },
            {
                "x": 5.100292205810547,
                "y": -1.0813347101211548,
                "z": -272.39678955078125
            },
            {
                "x": 5.040894508361816,
                "y": -1.069333791732788,
                "z": -272.2525329589844
            },
            {
                "x": 4.981626987457275,
                "y": -1.056990146636963,
                "z": -272.1078186035156
            },
            {
                "x": 4.922829627990723,
                "y": -1.0443804264068604,
                "z": -271.96331787109375
            },
            {
                "x": 4.8642497062683105,
                "y": -1.0314562320709229,
                "z": -271.81854248046875
            },
            {
                "x": 4.8060736656188965,
                "y": -1.018262505531311,
                "z": -271.673828125
            },
            {
                "x": 4.748192310333252,
                "y": -1.0047926902770996,
                "z": -271.52886962890625
            },
            {
                "x": 4.690648078918457,
                "y": -0.9910773038864136,
                "z": -271.38397216796875
            },
            {
                "x": 4.633406162261963,
                "y": -0.9770959615707397,
                "z": -271.23870849609375
            },
            {
                "x": 4.576536178588867,
                "y": -0.9628947973251343,
                "z": -271.0936279296875
            },
            {
                "x": 4.519950866699219,
                "y": -0.9484499096870422,
                "z": -270.9481506347656
            },
            {
                "x": 4.463756561279297,
                "y": -0.9338181018829346,
                "z": -270.8029479980469
            },
            {
                "x": 4.407891273498535,
                "y": -0.9189671874046326,
                "z": -270.6573486328125
            },
            {
                "x": 4.352278709411621,
                "y": -0.9039069414138794,
                "z": -270.5116271972656
            },
            {
                "x": 4.29714298248291,
                "y": -0.888687789440155,
                "z": -270.3659362792969
            },
            {
                "x": 4.242272853851318,
                "y": -0.8732924461364746,
                "z": -270.2201232910156
            },
            {
                "x": 4.207070827484131,
                "y": -0.8632711172103882,
                "z": -270.1259765625
            },
            {
                "x": 4.152787685394287,
                "y": -0.8476075530052185,
                "z": -269.9798583984375
            },
            {
                "x": 4.098910331726074,
                "y": -0.8318232297897339,
                "z": -269.8338623046875
            },
            {
                "x": 4.045297622680664,
                "y": -0.8158732652664185,
                "z": -269.68743896484375
            },
            {
                "x": 3.992135763168335,
                "y": -0.7998395562171936,
                "z": -269.541259765625
            },
            {
                "x": 3.9392590522766113,
                "y": -0.7836588621139526,
                "z": -269.39459228515625
            },
            {
                "x": 3.8867790699005127,
                "y": -0.7674071788787842,
                "z": -269.2481689453125
            },
            {
                "x": 3.834688663482666,
                "y": -0.75105881690979,
                "z": -269.1014709472656
            },
            {
                "x": 3.782824993133545,
                "y": -0.7346104979515076,
                "z": -268.9544982910156
            },
            {
                "x": 3.731475830078125,
                "y": -0.7181179523468018,
                "z": -268.8076171875
            },
            {
                "x": 3.6803901195526123,
                "y": -0.7015572786331177,
                "z": -268.66058349609375
            },
            {
                "x": 3.6297500133514404,
                "y": -0.6849571466445923,
                "z": -268.513427734375
            },
            {
                "x": 3.5793886184692383,
                "y": -0.6683173179626465,
                "z": -268.3660888671875
            },
            {
                "x": 3.529470920562744,
                "y": -0.6516475677490234,
                "z": -268.2186584472656
            },
            {
                "x": 3.4798617362976074,
                "y": -0.6349585056304932,
                "z": -268.0710754394531
            },
            {
                "x": 3.4307167530059814,
                "y": -0.6182927489280701,
                "z": -267.9236145019531
            },
            {
                "x": 3.3818161487579346,
                "y": -0.6015920042991638,
                "z": -267.7756042480469
            },
            {
                "x": 3.33339786529541,
                "y": -0.5849498510360718,
                "z": -267.6279296875
            },
            {
                "x": 3.2852747440338135,
                "y": -0.5682990550994873,
                "z": -267.4797058105469
            },
            {
                "x": 3.2375099658966064,
                "y": -0.5517023801803589,
                "z": -267.3316345214844
            },
            {
                "x": 3.1902074813842773,
                "y": -0.5351572036743164,
                "z": -267.1833801269531
            },
            {
                "x": 3.143206834793091,
                "y": -0.5186741352081299,
                "z": -267.03509521484375
            },
            {
                "x": 3.096666097640991,
                "y": -0.5022664666175842,
                "z": -266.8865966796875
            },
            {
                "x": 3.050414562225342,
                "y": -0.48592838644981384,
                "z": -266.7380676269531
            },
            {
                "x": 3.004563808441162,
                "y": -0.4696718454360962,
                "z": -266.5892028808594
            },
            {
                "x": 2.9590370655059814,
                "y": -0.4535118639469147,
                "z": -266.4402160644531
            },
            {
                "x": 2.9139692783355713,
                "y": -0.43748849630355835,
                "z": -266.29132080078125
            },
            {
                "x": 2.8692047595977783,
                "y": -0.4215601086616516,
                "z": -266.1420593261719
            },
            {
                "x": 2.8248820304870605,
                "y": -0.4057942032814026,
                "z": -265.992919921875
            },
            {
                "x": 2.7808494567871094,
                "y": -0.39012810587882996,
                "z": -265.84332275390625
            },
            {
                "x": 2.7372560501098633,
                "y": -0.3746560215950012,
                "z": -265.6938781738281
            },
            {
                "x": 2.69408917427063,
                "y": -0.3593452572822571,
                "z": -265.5442810058594
            },
            {
                "x": 2.651156187057495,
                "y": -0.3441842198371887,
                "z": -265.3944091796875
            },
            {
                "x": 2.6087377071380615,
                "y": -0.32923781871795654,
                "z": -265.24462890625
            },
            {
                "x": 2.5665671825408936,
                "y": -0.31445854902267456,
                "z": -265.0944519042969
            },
            {
                "x": 2.5248827934265137,
                "y": -0.2999180555343628,
                "z": -264.9444274902344
            },
            {
                "x": 2.4835307598114014,
                "y": -0.28557321429252625,
                "z": -264.7940368652344
            },
            {
                "x": 2.4425458908081055,
                "y": -0.27146682143211365,
                "z": -264.64373779296875
            },
            {
                "x": 2.4019649028778076,
                "y": -0.25759270787239075,
                "z": -264.4931640625
            },
            {
                "x": 2.3617289066314697,
                "y": -0.24398374557495117,
                "z": -264.3426513671875
            },
            {
                "x": 2.321887493133545,
                "y": -0.23061488568782806,
                "z": -264.1917419433594
            },
            {
                "x": 2.2823526859283447,
                "y": -0.21751520037651062,
                "z": -264.04083251953125
            },
            {
                "x": 2.24332857131958,
                "y": -0.20472431182861328,
                "z": -263.8900451660156
            },
            {
                "x": 2.218257188796997,
                "y": -0.19660131633281708,
                "z": -263.79229736328125
            },
            {
                "x": 2.179734230041504,
                "y": -0.18427887558937073,
                "z": -263.64111328125
            },
            {
                "x": 2.141629219055176,
                "y": -0.172260582447052,
                "z": -263.48980712890625
            },
            {
                "x": 2.1038105487823486,
                "y": -0.16056379675865173,
                "z": -263.33819580078125
            },
            {
                "x": 2.0664868354797363,
                "y": -0.14921730756759644,
                "z": -263.18682861328125
            },
            {
                "x": 2.0294182300567627,
                "y": -0.13817985355854034,
                "z": -263.0349426269531
            },
            {
                "x": 1.992782711982727,
                "y": -0.1275171935558319,
                "z": -262.8832702636719
            },
            {
                "x": 1.9565428495407104,
                "y": -0.11721517145633698,
                "z": -262.7313232421875
            },
            {
                "x": 1.9205645322799683,
                "y": -0.10727722197771072,
                "z": -262.5791015625
            },
            {
                "x": 1.8850867748260498,
                "y": -0.09773798286914825,
                "z": -262.4271240234375
            },
            {
                "x": 1.8498475551605225,
                "y": -0.08856876194477081,
                "z": -262.27471923828125
            },
            {
                "x": 1.815068244934082,
                "y": -0.07983534783124924,
                "z": -262.1224365234375
            },
            {
                "x": 1.780611515045166,
                "y": -0.07150539010763168,
                "z": -261.9698181152344
            },
            {
                "x": 1.7464734315872192,
                "y": -0.06359879672527313,
                "z": -261.81719970703125
            },
            {
                "x": 1.7127788066864014,
                "y": -0.05612988770008087,
                "z": -261.6645202636719
            },
            {
                "x": 1.6793662309646606,
                "y": -0.049116555601358414,
                "z": -261.5116271972656
            },
            {
                "x": 1.646401047706604,
                "y": -0.04257075861096382,
                "z": -261.35882568359375
            },
            {
                "x": 1.6137281656265259,
                "y": -0.0364810936152935,
                "z": -261.20574951171875
            },
            {
                "x": 1.5814381837844849,
                "y": -0.030874567106366158,
                "z": -261.05279541015625
            },
            {
                "x": 1.5495213270187378,
                "y": -0.025761008262634277,
                "z": -260.89947509765625
            },
            {
                "x": 1.5179203748703003,
                "y": -0.02115756832063198,
                "z": -260.7461853027344
            },
            {
                "x": 1.4867534637451172,
                "y": -0.01706387847661972,
                "z": -260.5929260253906
            },
            {
                "x": 1.455854058265686,
                "y": -0.013481559231877327,
                "z": -260.4393615722656
            },
            {
                "x": 1.4253714084625244,
                "y": -0.01044713519513607,
                "z": -260.28607177734375
            },
            {
                "x": 1.3951996564865112,
                "y": -0.007955336943268776,
                "z": -260.1321716308594
            },
            {
                "x": 1.365357518196106,
                "y": -0.006016495171934366,
                "z": -259.978515625
            },
            {
                "x": 1.3359403610229492,
                "y": -0.0046369959600269794,
                "z": -259.8247985839844
            },
            {
                "x": 1.3067702054977417,
                "y": -0.0038397307507693768,
                "z": -259.6707763671875
            },
            {
                "x": 1.2780203819274902,
                "y": -0.0036173230037093163,
                "z": -259.5169677734375
            },
            {
                "x": 1.24958074092865,
                "y": -0.0036180466413497925,
                "z": -259.3627624511719
            },
            {
                "x": 1.2214598655700684,
                "y": -0.0036189109086990356,
                "z": -259.208740234375
            },
            {
                "x": 1.1937687397003174,
                "y": -0.0036197304725646973,
                "z": -259.0547180175781
            },
            {
                "x": 1.166340947151184,
                "y": -0.0036206021904945374,
                "z": -258.9002990722656
            },
            {
                "x": 1.1392862796783447,
                "y": -0.003621421754360199,
                "z": -258.7461853027344
            },
            {
                "x": 1.1125786304473877,
                "y": -0.003622252494096756,
                "z": -258.59173583984375
            },
            {
                "x": 1.0861321687698364,
                "y": -0.0036230944097042084,
                "z": -258.437255859375
            },
            {
                "x": 1.0601346492767334,
                "y": -0.00362396240234375,
                "z": -258.2829284667969
            },
            {
                "x": 1.034392237663269,
                "y": -0.003624808043241501,
                "z": -258.12823486328125
            },
            {
                "x": 1.0089786052703857,
                "y": -0.0036255978047847748,
                "z": -257.9737854003906
            },
            {
                "x": 0.9839579463005066,
                "y": -0.0036264732480049133,
                "z": -257.8191833496094
            },
            {
                "x": 0.95915687084198,
                "y": -0.003627277910709381,
                "z": -257.6642761230469
            },
            {
                "x": 0.9347701072692871,
                "y": -0.0036281533539295197,
                "z": -257.5097351074219
            },
            {
                "x": 0.9106833934783936,
                "y": -0.0036289654672145844,
                "z": -257.3548278808594
            },
            {
                "x": 0.8952624797821045,
                "y": -0.00362950935959816,
                "z": -257.2547912597656
            },
            {
                "x": 0.8717285394668579,
                "y": -0.003630340099334717,
                "z": -257.1000671386719
            },
            {
                "x": 0.8484751582145691,
                "y": -0.0036311857402324677,
                "z": -256.9449462890625
            },
            {
                "x": 0.8254929780960083,
                "y": -0.0036320313811302185,
                "z": -256.78997802734375
            },
            {
                "x": 0.8029327392578125,
                "y": -0.0036328546702861786,
                "z": -256.6351013183594
            },
            {
                "x": 0.7805967330932617,
                "y": -0.0036337152123451233,
                "z": -256.479736328125
            },
            {
                "x": 0.7585856914520264,
                "y": -0.0036345385015010834,
                "z": -256.3247375488281
            },
            {
                "x": 0.736943781375885,
                "y": -0.0036353878676891327,
                "z": -256.1695861816406
            },
            {
                "x": 0.7155014276504517,
                "y": -0.0036362148821353912,
                "z": -256.0140686035156
            },
            {
                "x": 0.6944431066513062,
                "y": -0.003637053072452545,
                "z": -255.8589630126953
            },
            {
                "x": 0.673681378364563,
                "y": -0.0036378800868988037,
                "z": -255.70355224609375
            },
            {
                "x": 0.6531558632850647,
                "y": -0.0036387071013450623,
                "z": -255.54812622070312
            },
            {
                "x": 0.6330230236053467,
                "y": -0.003639582544565201,
                "z": -255.39288330078125
            },
            {
                "x": 0.6131178140640259,
                "y": -0.003640413284301758,
                "z": -255.23709106445312
            },
            {
                "x": 0.5935037136077881,
                "y": -0.0036412328481674194,
                "z": -255.0817108154297
            },
            {
                "x": 0.5742533802986145,
                "y": -0.003642074763774872,
                "z": -254.92625427246094
            },
            {
                "x": 0.5552201271057129,
                "y": -0.003642898052930832,
                "z": -254.77044677734375
            },
            {
                "x": 0.5365029573440552,
                "y": -0.003643762320280075,
                "z": -254.61495971679688
            },
            {
                "x": 0.5181095600128174,
                "y": -0.0036446116864681244,
                "z": -254.45924377441406
            },
            {
                "x": 0.49992379546165466,
                "y": -0.003645431250333786,
                "z": -254.3033905029297
            },
            {
                "x": 0.48208197951316833,
                "y": -0.0036462657153606415,
                "z": -254.14781188964844
            },
            {
                "x": 0.46455129981040955,
                "y": -0.0036470964550971985,
                "z": -253.9920654296875
            },
            {
                "x": 0.44722089171409607,
                "y": -0.003647930920124054,
                "z": -253.8362274169922
            },
            {
                "x": 0.43022632598876953,
                "y": -0.0036487802863121033,
                "z": -253.68057250976562
            },
            {
                "x": 0.4135031998157501,
                "y": -0.003649625927209854,
                "z": -253.5244903564453
            },
            {
                "x": 0.39700350165367126,
                "y": -0.003650456666946411,
                "z": -253.36859130859375
            },
            {
                "x": 0.3808329403400421,
                "y": -0.003651294857263565,
                "z": -253.2127685546875
            },
            {
                "x": 0.3649202287197113,
                "y": -0.0036521628499031067,
                "z": -253.05665588378906
            },
            {
                "x": 0.34923431277275085,
                "y": -0.003652971237897873,
                "z": -252.90065002441406
            },
            {
                "x": 0.33386531472206116,
                "y": -0.0036538168787956238,
                "z": -252.74459838867188
            },
            {
                "x": 0.31875622272491455,
                "y": -0.0036546364426612854,
                "z": -252.58847045898438
            },
            {
                "x": 0.3038642108440399,
                "y": -0.0036554746329784393,
                "z": -252.4324493408203
            },
            {
                "x": 0.28929898142814636,
                "y": -0.003656327724456787,
                "z": -252.27635192871094
            },
            {
                "x": 0.27496981620788574,
                "y": -0.003657151013612747,
                "z": -252.12008666992188
            },
            {
                "x": 0.2608535587787628,
                "y": -0.0036580003798007965,
                "z": -251.96389770507812
            },
            {
                "x": 0.24706146121025085,
                "y": -0.003658827394247055,
                "z": -251.80775451660156
            },
            {
                "x": 0.23350057005882263,
                "y": -0.003659665584564209,
                "z": -251.6514434814453
            },
            {
                "x": 0.22015070915222168,
                "y": -0.0036605186760425568,
                "z": -251.4951629638672
            },
            {
                "x": 0.20712712407112122,
                "y": -0.003661319613456726,
                "z": -251.33901977539062
            },
            {
                "x": 0.1943117082118988,
                "y": -0.003662165254354477,
                "z": -251.1826171875
            },
            {
                "x": 0.18170297145843506,
                "y": -0.0036630406975746155,
                "z": -251.0261993408203
            },
            {
                "x": 0.16942283511161804,
                "y": -0.003663860261440277,
                "z": -250.8699951171875
            },
            {
                "x": 0.15734878182411194,
                "y": -0.0036647096276283264,
                "z": -250.71351623535156
            },
            {
                "x": 0.14964675903320312,
                "y": -0.003665246069431305,
                "z": -250.6125030517578
            },
            {
                "x": 0.13798382878303528,
                "y": -0.0036660805344581604,
                "z": -250.456298828125
            },
            {
                "x": 0.12656986713409424,
                "y": -0.0036668963730335236,
                "z": -250.2997589111328
            },
            {
                "x": 0.11532369256019592,
                "y": -0.0036677569150924683,
                "z": -250.14317321777344
            },
            {
                "x": 0.10436135530471802,
                "y": -0.003668602555990219,
                "z": -249.9868621826172
            },
            {
                "x": 0.0936627984046936,
                "y": -0.0036694183945655823,
                "z": -249.8302764892578
            },
            {
                "x": 0.08313551545143127,
                "y": -0.003670278936624527,
                "z": -249.67373657226562
            },
            {
                "x": 0.07286062836647034,
                "y": -0.003671102225780487,
                "z": -249.51736450195312
            },
            {
                "x": 0.06285035610198975,
                "y": -0.0036719441413879395,
                "z": -249.3606719970703
            },
            {
                "x": 0.053020745515823364,
                "y": -0.003672786056995392,
                "z": -249.20407104492188
            },
            {
                "x": 0.04341691732406616,
                "y": -0.003673601895570755,
                "z": -249.0475616455078
            },
            {
                "x": 0.03409293293952942,
                "y": -0.003674440085887909,
                "z": -248.89100646972656
            },
            {
                "x": 0.02494734525680542,
                "y": -0.003675296902656555,
                "z": -248.7343292236328
            },
            {
                "x": 0.01599639654159546,
                "y": -0.0036761388182640076,
                "z": -248.5775909423828
            },
            {
                "x": 0.007335633039474487,
                "y": -0.0036769770085811615,
                "z": -248.4210968017578
            },
            {
                "x": -0.00114402174949646,
                "y": -0.0036778077483177185,
                "z": -248.2643585205078
            },
            {
                "x": -0.009447455406188965,
                "y": -0.0036786720156669617,
                "z": -248.1076202392578
            },
            {
                "x": -0.017464548349380493,
                "y": -0.003679487854242325,
                "z": -247.9510955810547
            },
            {
                "x": -0.02528640627861023,
                "y": -0.0036803334951400757,
                "z": -247.7942352294922
            },
            {
                "x": -0.03295113146305084,
                "y": -0.003681182861328125,
                "z": -247.63742065429688
            },
            {
                "x": -0.04035361111164093,
                "y": -0.0036819912493228912,
                "z": -247.4808807373047
            },
            {
                "x": -0.047522157430648804,
                "y": -0.003682844340801239,
                "z": -247.32412719726562
            },
            {
                "x": -0.05454741418361664,
                "y": -0.003683667629957199,
                "z": -247.1673583984375
            },
            {
                "x": -0.06134869158267975,
                "y": -0.0036845095455646515,
                "z": -247.01071166992188
            },
            {
                "x": -0.06790627539157867,
                "y": -0.0036853626370429993,
                "z": -246.8538055419922
            },
            {
                "x": -0.07430015504360199,
                "y": -0.0036861859261989594,
                "z": -246.69699096679688
            },
            {
                "x": -0.08050934970378876,
                "y": -0.0036870501935482025,
                "z": -246.54025268554688
            },
            {
                "x": -0.08646366000175476,
                "y": -0.003687862306833267,
                "z": -246.38348388671875
            },
            {
                "x": -0.0922396183013916,
                "y": -0.0036886855959892273,
                "z": -246.2266082763672
            },
            {
                "x": -0.09786424040794373,
                "y": -0.0036895424127578735,
                "z": -246.0696258544922
            },
            {
                "x": -0.10323932766914368,
                "y": -0.003690361976623535,
                "z": -245.91297912597656
            },
            {
                "x": -0.10840959846973419,
                "y": -0.0036912187933921814,
                "z": -245.75607299804688
            },
            {
                "x": -0.1134486198425293,
                "y": -0.0036920644342899323,
                "z": -245.5990753173828
            },
            {
                "x": -0.11826717853546143,
                "y": -0.0036928802728652954,
                "z": -245.44236755371094
            },
            {
                "x": -0.12285648286342621,
                "y": -0.003693748265504837,
                "z": -245.28546142578125
            },
            {
                "x": -0.12730242311954498,
                "y": -0.0036945492029190063,
                "z": -245.12841796875
            },
            {
                "x": -0.13158071041107178,
                "y": -0.0036954209208488464,
                "z": -244.97164916992188
            },
            {
                "x": -0.13561540842056274,
                "y": -0.0036962293088436127,
                "z": -244.81475830078125
            },
            {
                "x": -0.1394714117050171,
                "y": -0.0036970600485801697,
                "z": -244.6577911376953
            },
            {
                "x": -0.14319805800914764,
                "y": -0.0036979317665100098,
                "z": -244.5009002685547
            },
            {
                "x": -0.14671754837036133,
                "y": -0.0036987699568271637,
                "z": -244.34396362304688
            },
            {
                "x": -0.15000952780246735,
                "y": -0.003699604421854019,
                "z": -244.1870574951172
            },
            {
                "x": -0.153115913271904,
                "y": -0.0037001606542617083,
                "z": -244.03009033203125
            },
            {
                "x": -0.15514039993286133,
                "y": -0.0037009716033935547,
                "z": -243.9287872314453
            },
            {
                "x": -0.1579878330230713,
                "y": -0.003701820969581604,
                "z": -243.77198791503906
            },
            {
                "x": -0.16063900291919708,
                "y": -0.003702659159898758,
                "z": -243.61497497558594
            },
            {
                "x": -0.1631685495376587,
                "y": -0.0037034712731838226,
                "z": -243.45787048339844
            },
            {
                "x": -0.16552773118019104,
                "y": -0.003704346716403961,
                "z": -243.301025390625
            },
            {
                "x": -0.16766001284122467,
                "y": -0.003705166280269623,
                "z": -243.14404296875
            },
            {
                "x": -0.1696409285068512,
                "y": -0.003705989569425583,
                "z": -242.98703002929688
            },
            {
                "x": -0.1714959442615509,
                "y": -0.0037068314850330353,
                "z": -242.83010864257812
            },
            {
                "x": -0.1731579601764679,
                "y": -0.00370769202709198,
                "z": -242.67303466796875
            },
            {
                "x": -0.17462807893753052,
                "y": -0.0037085115909576416,
                "z": -242.51602172851562
            },
            {
                "x": -0.1759864091873169,
                "y": -0.003709368407726288,
                "z": -242.3589630126953
            },
            {
                "x": -0.1771998107433319,
                "y": -0.003710191696882248,
                "z": -242.2019500732422
            },
            {
                "x": -0.17825311422348022,
                "y": -0.0037110261619091034,
                "z": -242.04493713378906
            },
            {
                "x": -0.17921698093414307,
                "y": -0.003711860626935959,
                "z": -241.8876495361328
            },
            {
                "x": -0.1800985038280487,
                "y": -0.0037127062678337097,
                "z": -241.73057556152344
            },
            {
                "x": -0.1808907687664032,
                "y": -0.003713540732860565,
                "z": -241.5734405517578
            },
            {
                "x": -0.1816863715648651,
                "y": -0.0037143826484680176,
                "z": -241.41603088378906
            },
            {
                "x": -0.18254736065864563,
                "y": -0.0037152208387851715,
                "z": -241.2587127685547
            },
            {
                "x": -0.18342450261116028,
                "y": -0.00371604785323143,
                "z": -241.10133361816406
            },
            {
                "x": -0.1844135820865631,
                "y": -0.003716900944709778,
                "z": -240.94369506835938
            },
            {
                "x": -0.18559902906417847,
                "y": -0.0037177391350269318,
                "z": -240.78614807128906
            },
            {
                "x": -0.18694299459457397,
                "y": -0.0037185698747634888,
                "z": -240.628662109375
            },
            {
                "x": -0.18846789002418518,
                "y": -0.0037193968892097473,
                "z": -240.4709930419922
            },
            {
                "x": -0.19027721881866455,
                "y": -0.003720231354236603,
                "z": -240.31326293945312
            },
            {
                "x": -0.19233089685440063,
                "y": -0.003721080720424652,
                "z": -240.155517578125
            },
            {
                "x": -0.1945684850215912,
                "y": -0.003721911460161209,
                "z": -239.9979248046875
            },
            {
                "x": -0.1971057504415512,
                "y": -0.0036738691851496696,
                "z": -239.84007263183594
            },
            {
                "x": -0.19996079802513123,
                "y": -0.0034017059952020645,
                "z": -239.6823272705078
            },
            {
                "x": -0.2030160129070282,
                "y": -0.0028830431401729584,
                "z": -239.5248260498047
            },
            {
                "x": -0.20631413161754608,
                "y": -0.002111135981976986,
                "z": -239.3668975830078
            },
            {
                "x": -0.2099587768316269,
                "y": -0.0010948467534035444,
                "z": -239.20912170410156
            },
            {
                "x": -0.21387454867362976,
                "y": 0.000156724127009511,
                "z": -239.05157470703125
            },
            {
                "x": -0.2179800271987915,
                "y": 0.0016431983094662428,
                "z": -238.89389038085938
            },
            {
                "x": -0.22239340841770172,
                "y": 0.003368319710716605,
                "z": -238.73611450195312
            },
            {
                "x": -0.22715404629707336,
                "y": 0.00532545568421483,
                "z": -238.57835388183594
            },
            {
                "x": -0.23212406039237976,
                "y": 0.0075035798363387585,
                "z": -238.42080688476562
            },
            {
                "x": -0.23732362687587738,
                "y": 0.00990355759859085,
                "z": -238.26315307617188
            },
            {
                "x": -0.2428872436285019,
                "y": 0.01253027655184269,
                "z": -238.10531616210938
            },
            {
                "x": -0.24873213469982147,
                "y": 0.015369504690170288,
                "z": -237.94784545898438
            },
            {
                "x": -0.25476914644241333,
                "y": 0.01841922476887703,
                "z": -237.7903594970703
            },
            {
                "x": -0.26112526655197144,
                "y": 0.021684633567929268,
                "z": -237.6324920654297
            },
            {
                "x": -0.26782411336898804,
                "y": 0.025152843445539474,
                "z": -237.47491455078125
            },
            {
                "x": -0.27473634481430054,
                "y": 0.028822485357522964,
                "z": -237.31752014160156
            },
            {
                "x": -0.2793208062648773,
                "y": 0.031297385692596436,
                "z": -237.2157745361328
            },
            {
                "x": -0.28671690821647644,
                "y": 0.035296469926834106,
                "z": -237.05812072753906
            },
            {
                "x": -0.2944450378417969,
                "y": 0.03949122875928879,
                "z": -236.90060424804688
            },
            {
                "x": -0.3023694157600403,
                "y": 0.043871618807315826,
                "z": -236.74317932128906
            },
            {
                "x": -0.31057846546173096,
                "y": 0.04844074696302414,
                "z": -236.5856170654297
            },
            {
                "x": -0.3191579282283783,
                "y": 0.05319591239094734,
                "z": -236.42800903320312
            },
            {
                "x": -0.327971488237381,
                "y": 0.05812549963593483,
                "z": -236.27078247070312
            },
            {
                "x": -0.3370208740234375,
                "y": 0.06323520839214325,
                "z": -236.1133575439453
            },
            {
                "x": -0.3464438319206238,
                "y": 0.06852640211582184,
                "z": -235.95567321777344
            },
            {
                "x": -0.356147825717926,
                "y": 0.07397330552339554,
                "z": -235.79843139648438
            },
            {
                "x": -0.36606457829475403,
                "y": 0.07959362864494324,
                "z": -235.64112854003906
            },
            {
                "x": -0.37631964683532715,
                "y": 0.08538274466991425,
                "z": -235.483642578125
            },
            {
                "x": -0.3869091868400574,
                "y": 0.0913223922252655,
                "z": -235.32640075683594
            },
            {
                "x": -0.3977176547050476,
                "y": 0.09741964191198349,
                "z": -235.16909790039062
            },
            {
                "x": -0.4088172912597656,
                "y": 0.1036759614944458,
                "z": -235.01177978515625
            },
            {
                "x": -0.4202837347984314,
                "y": 0.11007925868034363,
                "z": -234.85450744628906
            },
            {
                "x": -0.43199384212493896,
                "y": 0.11662256717681885,
                "z": -234.6973876953125
            },
            {
                "x": -0.44394218921661377,
                "y": 0.12330953776836395,
                "z": -234.54022216796875
            },
            {
                "x": -0.4562871754169464,
                "y": 0.13014808297157288,
                "z": -234.3829345703125
            },
            {
                "x": -0.4689076542854309,
                "y": 0.1371108889579773,
                "z": -234.2258758544922
            },
            {
                "x": -0.4817386269569397,
                "y": 0.1442038118839264,
                "z": -234.06886291503906
            },
            {
                "x": -0.49492478370666504,
                "y": 0.15143156051635742,
                "z": -233.9116973876953
            },
            {
                "x": -0.508450448513031,
                "y": 0.15878108143806458,
                "z": -233.7547607421875
            },
            {
                "x": -0.5221770405769348,
                "y": 0.1662467122077942,
                "z": -233.59791564941406
            },
            {
                "x": -0.536252498626709,
                "y": 0.17385096848011017,
                "z": -233.440673828125
            },
            {
                "x": -0.5506669282913208,
                "y": 0.18155498802661896,
                "z": -233.2837677001953
            },
            {
                "x": -0.5653063058853149,
                "y": 0.1893673539161682,
                "z": -233.12701416015625
            },
            {
                "x": -0.5802502632141113,
                "y": 0.19729989767074585,
                "z": -232.9700469970703
            },
            {
                "x": -0.5955629944801331,
                "y": 0.20533256232738495,
                "z": -232.81317138671875
            },
            {
                "x": -0.6111240983009338,
                "y": 0.21346336603164673,
                "z": -232.6563720703125
            },
            {
                "x": -0.626950740814209,
                "y": 0.22169622778892517,
                "z": -232.4995880126953
            },
            {
                "x": -0.6431612968444824,
                "y": 0.23002493381500244,
                "z": -232.3428192138672
            },
            {
                "x": -0.6596355438232422,
                "y": 0.238436758518219,
                "z": -232.1862030029297
            },
            {
                "x": -0.6763503551483154,
                "y": 0.24693918228149414,
                "z": -232.02952575683594
            },
            {
                "x": -0.693465530872345,
                "y": 0.25553712248802185,
                "z": -231.87274169921875
            },
            {
                "x": -0.7108557224273682,
                "y": 0.26420098543167114,
                "z": -231.7162628173828
            },
            {
                "x": -0.7284727096557617,
                "y": 0.27294331789016724,
                "z": -231.5597381591797
            },
            {
                "x": -0.7464781999588013,
                "y": 0.2817738652229309,
                "z": -231.40301513671875
            },
            {
                "x": -0.7647744417190552,
                "y": 0.29065412282943726,
                "z": -231.24673461914062
            },
            {
                "x": -0.7833012342453003,
                "y": 0.2996061444282532,
                "z": -231.09036254882812
            },
            {
                "x": -0.8022192716598511,
                "y": 0.3086426258087158,
                "z": -230.9337158203125
            },
            {
                "x": -0.821427047252655,
                "y": 0.3177151083946228,
                "z": -230.77743530273438
            },
            {
                "x": -0.8408554196357727,
                "y": 0.32684361934661865,
                "z": -230.62127685546875
            },
            {
                "x": -0.8536045551300049,
                "y": 0.3327781558036804,
                "z": -230.520263671875
            },
            {
                "x": -0.873633861541748,
                "y": 0.34199997782707214,
                "z": -230.364013671875
            },
            {
                "x": -0.8938969969749451,
                "y": 0.35126161575317383,
                "z": -230.2079315185547
            },
            {
                "x": -0.9144776463508606,
                "y": 0.36058366298675537,
                "z": -230.05160522460938
            },
            {
                "x": -0.9354195594787598,
                "y": 0.3699386715888977,
                "z": -229.89547729492188
            },
            {
                "x": -0.9566051959991455,
                "y": 0.3793225884437561,
                "z": -229.739501953125
            },
            {
                "x": -0.9780662655830383,
                "y": 0.3887471556663513,
                "z": -229.58343505859375
            },
            {
                "x": -0.9999232292175293,
                "y": 0.39820346236228943,
                "z": -229.42739868164062
            },
            {
                "x": -1.022038221359253,
                "y": 0.40768393874168396,
                "z": -229.27145385742188
            },
            {
                "x": -1.0444118976593018,
                "y": 0.41718706488609314,
                "z": -229.11557006835938
            },
            {
                "x": -1.067176342010498,
                "y": 0.42671501636505127,
                "z": -228.9595947265625
            },
            {
                "x": -1.0901808738708496,
                "y": 0.4362449645996094,
                "z": -228.80392456054688
            },
            {
                "x": -1.1134684085845947,
                "y": 0.4457969069480896,
                "z": -228.64816284179688
            },
            {
                "x": -1.1371681690216064,
                "y": 0.45537132024765015,
                "z": -228.4922332763672
            },
            {
                "x": -1.16105318069458,
                "y": 0.4649238884449005,
                "z": -228.33676147460938
            },
            {
                "x": -1.1852611303329468,
                "y": 0.4744947552680969,
                "z": -228.18109130859375
            },
            {
                "x": -1.2098500728607178,
                "y": 0.48406803607940674,
                "z": -228.02540588378906
            },
            {
                "x": -1.234641432762146,
                "y": 0.493617981672287,
                "z": -227.87010192871094
            },
            {
                "x": -1.2597627639770508,
                "y": 0.5031802654266357,
                "z": -227.7144775390625
            },
            {
                "x": -1.2852613925933838,
                "y": 0.5127272605895996,
                "z": -227.5589599609375
            },
            {
                "x": -1.3109527826309204,
                "y": 0.522241473197937,
                "z": -227.40377807617188
            },
            {
                "x": -1.336974859237671,
                "y": 0.5317531228065491,
                "z": -227.24838256835938
            },
            {
                "x": -1.3633424043655396,
                "y": 0.5412367582321167,
                "z": -227.0931396484375
            },
            {
                "x": -1.3899203538894653,
                "y": 0.5506844520568848,
                "z": -226.9381103515625
            },
            {
                "x": -1.416884422302246,
                "y": 0.560130774974823,
                "z": -226.78265380859375
            },
            {
                "x": -1.4441425800323486,
                "y": 0.5695235729217529,
                "z": -226.62762451171875
            },
            {
                "x": -1.4716157913208008,
                "y": 0.5788792371749878,
                "z": -226.47265625
            },
            {
                "x": -1.4994542598724365,
                "y": 0.588208019733429,
                "z": -226.3175048828125
            },
            {
                "x": -1.5275931358337402,
                "y": 0.597480297088623,
                "z": -226.1626434326172
            },
            {
                "x": -1.5559839010238647,
                "y": 0.6067162156105042,
                "z": -226.0076446533203
            },
            {
                "x": -1.584706425666809,
                "y": 0.6159024238586426,
                "z": -225.8527069091797
            },
            {
                "x": -1.6137150526046753,
                "y": 0.6250222325325012,
                "z": -225.69802856445312
            },
            {
                "x": -1.6429767608642578,
                "y": 0.634093165397644,
                "z": -225.54322814941406
            },
            {
                "x": -1.672600269317627,
                "y": 0.6431073546409607,
                "z": -225.38844299316406
            },
            {
                "x": -1.7024691104888916,
                "y": 0.6520476341247559,
                "z": -225.23390197753906
            },
            {
                "x": -1.732611060142517,
                "y": 0.6609296202659607,
                "z": -225.0792236328125
            },
            {
                "x": -1.763112187385559,
                "y": 0.6697369813919067,
                "z": -224.92462158203125
            },
            {
                "x": -1.7938404083251953,
                "y": 0.6784640550613403,
                "z": -224.77020263671875
            },
            {
                "x": -1.8248366117477417,
                "y": 0.6871170401573181,
                "z": -224.6157684326172
            },
            {
                "x": -1.8561842441558838,
                "y": 0.6956886053085327,
                "z": -224.46141052246094
            },
            {
                "x": -1.88777494430542,
                "y": 0.7041746377944946,
                "z": -224.3070526123047
            },
            {
                "x": -1.9196510314941406,
                "y": 0.7125731706619263,
                "z": -224.15274047851562
            },
            {
                "x": -1.951830506324768,
                "y": 0.7208738327026367,
                "z": -223.9986114501953
            },
            {
                "x": -1.9727163314819336,
                "y": 0.7261814475059509,
                "z": -223.8991241455078
            },
            {
                "x": -2.0053248405456543,
                "y": 0.7343254089355469,
                "z": -223.7449951171875
            },
            {
                "x": -2.0382754802703857,
                "y": 0.7423713207244873,
                "z": -223.5908660888672
            },
            {
                "x": -2.071415901184082,
                "y": 0.7503079175949097,
                "z": -223.43690490722656
            },
            {
                "x": -2.104871988296509,
                "y": 0.7581350207328796,
                "z": -223.28292846679688
            },
            {
                "x": -2.13862943649292,
                "y": 0.7658504247665405,
                "z": -223.12905883789062
            },
            {
                "x": -2.1725804805755615,
                "y": 0.7734476923942566,
                "z": -222.9752655029297
            },
            {
                "x": -2.206866979598999,
                "y": 0.7809306383132935,
                "z": -222.82147216796875
            },
            {
                "x": -2.241427183151245,
                "y": 0.7882877588272095,
                "z": -222.667724609375
            },
            {
                "x": -2.276204824447632,
                "y": 0.7955174446105957,
                "z": -222.5140380859375
            },
            {
                "x": -2.3113086223602295,
                "y": 0.8026199340820312,
                "z": -222.36044311523438
            },
            {
                "x": -2.3466060161590576,
                "y": 0.8095855116844177,
                "z": -222.20693969726562
            },
            {
                "x": -2.3822021484375,
                "y": 0.8164160251617432,
                "z": -222.0534210205078
            },
            {
                "x": -2.4181132316589355,
                "y": 0.8231081962585449,
                "z": -221.89988708496094
            },
            {
                "x": -2.4541730880737305,
                "y": 0.8296495079994202,
                "z": -221.74659729003906
            },
            {
                "x": -2.4905552864074707,
                "y": 0.8360503911972046,
                "z": -221.59324645996094
            },
            {
                "x": -2.527181386947632,
                "y": 0.8422937393188477,
                "z": -221.44003295898438
            },
            {
                "x": -2.564026117324829,
                "y": 0.8483830094337463,
                "z": -221.28683471679688
            },
            {
                "x": -2.601198434829712,
                "y": 0.85431969165802,
                "z": -221.13357543945312
            },
            {
                "x": -2.638542652130127,
                "y": 0.8600912094116211,
                "z": -220.98056030273438
            },
            {
                "x": -2.6761529445648193,
                "y": 0.8656961917877197,
                "z": -220.82752990722656
            },
            {
                "x": -2.714012384414673,
                "y": 0.8711268901824951,
                "z": -220.6746826171875
            },
            {
                "x": -2.7520618438720703,
                "y": 0.8763877153396606,
                "z": -220.52183532714844
            },
            {
                "x": -2.790410041809082,
                "y": 0.8814786672592163,
                "z": -220.36895751953125
            },
            {
                "x": -2.829007863998413,
                "y": 0.8863884806632996,
                "z": -220.21607971191406
            },
            {
                "x": -2.867774486541748,
                "y": 0.8911098837852478,
                "z": -220.06336975097656
            },
            {
                "x": -2.906829595565796,
                "y": 0.895648717880249,
                "z": -219.91065979003906
            },
            {
                "x": -2.946054220199585,
                "y": 0.8999969959259033,
                "z": -219.7581024169922
            },
            {
                "x": -2.985539674758911,
                "y": 0.9041520357131958,
                "z": -219.60552978515625
            },
            {
                "x": -3.0252914428710938,
                "y": 0.9081084728240967,
                "z": -219.45294189453125
            },
            {
                "x": -3.065183162689209,
                "y": 0.9118630886077881,
                "z": -219.30052185058594
            },
            {
                "x": -3.105341672897339,
                "y": 0.9154168963432312,
                "z": -219.1481170654297
            },
            {
                "x": -3.145683526992798,
                "y": 0.9187600612640381,
                "z": -218.9958038330078
            },
            {
                "x": -3.1862423419952393,
                "y": 0.9218894243240356,
                "z": -218.84349060058594
            },
            {
                "x": -3.227048635482788,
                "y": 0.9248064756393433,
                "z": -218.69125366210938
            },
            {
                "x": -3.268003463745117,
                "y": 0.9275073409080505,
                "z": -218.53903198242188
            },
            {
                "x": -3.309196710586548,
                "y": 0.9299847483634949,
                "z": -218.38690185546875
            },
            {
                "x": -3.3505585193634033,
                "y": 0.9322309494018555,
                "z": -218.23489379882812
            },
            {
                "x": -3.3921077251434326,
                "y": 0.9342518448829651,
                "z": -218.08285522460938
            },
            {
                "x": -3.4338698387145996,
                "y": 0.9360421895980835,
                "z": -217.93099975585938
            },
            {
                "x": -3.4758307933807373,
                "y": 0.9375972747802734,
                "z": -217.7789764404297
            },
            {
                "x": -3.5179758071899414,
                "y": 0.9389064311981201,
                "z": -217.62716674804688
            },
            {
                "x": -3.560271978378296,
                "y": 0.9399741888046265,
                "z": -217.47544860839844
            },
            {
                "x": -3.5876686573028564,
                "y": 0.9405393600463867,
                "z": -217.37747192382812
            },
            {
                "x": -3.6302847862243652,
                "y": 0.9411967396736145,
                "z": -217.22576904296875
            },
            {
                "x": -3.673067092895508,
                "y": 0.9416042566299438,
                "z": -217.0741424560547
            },
            {
                "x": -3.7160086631774902,
                "y": 0.9417589902877808,
                "z": -216.92247009277344
            },
            {
                "x": -3.7591121196746826,
                "y": 0.9416574239730835,
                "z": -216.77102661132812
            },
            {
                "x": -3.802370071411133,
                "y": 0.9412901401519775,
                "z": -216.61949157714844
            },
            {
                "x": -3.845808982849121,
                "y": 0.9406730532646179,
                "z": -216.46803283691406
            },
            {
                "x": -3.889357566833496,
                "y": 0.9398100972175598,
                "z": -216.31680297851562
            },
            {
                "x": -3.9331228733062744,
                "y": 0.9387015104293823,
                "z": -216.16526794433594
            },
            {
                "x": -3.9770045280456543,
                "y": 0.9373437762260437,
                "z": -216.0140380859375
            },
            {
                "x": -4.020997524261475,
                "y": 0.9357495307922363,
                "z": -215.8628387451172
            },
            {
                "x": -4.065160751342773,
                "y": 0.9339222311973572,
                "z": -215.7115936279297
            },
            {
                "x": -4.109413146972656,
                "y": 0.9318674802780151,
                "z": -215.56057739257812
            },
            {
                "x": -4.153873443603516,
                "y": 0.9295719861984253,
                "z": -215.4093017578125
            },
            {
                "x": -4.198408126831055,
                "y": 0.9270582795143127,
                "z": -215.2583465576172
            },
            {
                "x": -4.243034839630127,
                "y": 0.9243264198303223,
                "z": -215.107421875
            },
            {
                "x": -4.287834644317627,
                "y": 0.9213759899139404,
                "z": -214.95635986328125
            },
            {
                "x": -4.332690238952637,
                "y": 0.9182082414627075,
                "z": -214.80557250976562
            },
            {
                "x": -4.377697467803955,
                "y": 0.9148284196853638,
                "z": -214.65463256835938
            },
            {
                "x": -4.422820091247559,
                "y": 0.911244809627533,
                "z": -214.5037841796875
            },
            {
                "x": -4.467987537384033,
                "y": 0.9074625968933105,
                "z": -214.3530731201172
            },
            {
                "x": -4.5132737159729,
                "y": 0.9034736156463623,
                "z": -214.20237731933594
            },
            {
                "x": -4.558640956878662,
                "y": 0.8992906808853149,
                "z": -214.0517578125
            },
            {
                "x": -4.604097366333008,
                "y": 0.894916296005249,
                "z": -213.90113830566406
            },
            {
                "x": -4.649686336517334,
                "y": 0.8903509378433228,
                "z": -213.7504119873047
            },
            {
                "x": -4.695287704467773,
                "y": 0.8855998516082764,
                "z": -213.59988403320312
            },
            {
                "x": -4.740996360778809,
                "y": 0.8806648254394531,
                "z": -213.44931030273438
            },
            {
                "x": -4.786763668060303,
                "y": 0.8755545616149902,
                "z": -213.29884338378906
            },
            {
                "x": -4.832586765289307,
                "y": 0.8702716827392578,
                "z": -213.14840698242188
            },
            {
                "x": -4.878518581390381,
                "y": 0.8648083209991455,
                "z": -212.99783325195312
            },
            {
                "x": -4.924443244934082,
                "y": 0.8591820001602173,
                "z": -212.8474578857422
            },
            {
                "x": -4.970427513122559,
                "y": 0.8533945083618164,
                "z": -212.69712829589844
            },
            {
                "x": -5.016469955444336,
                "y": 0.8474450707435608,
                "z": -212.54673767089844
            },
            {
                "x": -5.062540531158447,
                "y": 0.841335654258728,
                "z": -212.39639282226562
            },
            {
                "x": -5.108665943145752,
                "y": 0.8350711464881897,
                "z": -212.24607849121094
            },
            {
                "x": -5.154820919036865,
                "y": 0.8286576867103577,
                "z": -212.09573364257812
            },
            {
                "x": -5.200971603393555,
                "y": 0.8221042156219482,
                "z": -211.945556640625
            },
            {
                "x": -5.2471699714660645,
                "y": 0.8153992891311646,
                "z": -211.79527282714844
            },
            {
                "x": -5.293361186981201,
                "y": 0.8085590600967407,
                "z": -211.6450958251953
            },
            {
                "x": -5.339555740356445,
                "y": 0.8015850186347961,
                "z": -211.49496459960938
            },
            {
                "x": -5.385823726654053,
                "y": 0.7944703102111816,
                "z": -211.34461975097656
            },
            {
                "x": -5.4320268630981445,
                "y": 0.7872334122657776,
                "z": -211.19451904296875
            },
            {
                "x": -5.478222370147705,
                "y": 0.7798704504966736,
                "z": -211.04440307617188
            },
            {
                "x": -5.50806999206543,
                "y": 0.7750512361526489,
                "z": -210.94744873046875
            },
            {
                "x": -5.554240703582764,
                "y": 0.7674927711486816,
                "z": -210.79739379882812
            },
            {
                "x": -5.600440979003906,
                "y": 0.7598099112510681,
                "z": -210.64718627929688
            },
            {
                "x": -5.646606922149658,
                "y": 0.7520169019699097,
                "z": -210.49705505371094
            },
            {
                "x": -5.692722320556641,
                "y": 0.744120717048645,
                "z": -210.3470001220703
            },
            {
                "x": -5.738834381103516,
                "y": 0.7361125946044922,
                "z": -210.19686889648438
            },
            {
                "x": -5.784885406494141,
                "y": 0.7280043363571167,
                "z": -210.04676818847656
            },
            {
                "x": -5.830892086029053,
                "y": 0.7198001146316528,
                "z": -209.89671325683594
            },
            {
                "x": -5.8768839836120605,
                "y": 0.7114928960800171,
                "z": -209.74647521972656
            },
            {
                "x": -5.922801494598389,
                "y": 0.7031023502349854,
                "z": -209.59637451171875
            },
            {
                "x": -5.968657493591309,
                "y": 0.69461989402771,
                "z": -209.44627380371094
            },
            {
                "x": -6.0144548416137695,
                "y": 0.6860528588294983,
                "z": -209.29612731933594
            },
            {
                "x": -6.060160160064697,
                "y": 0.6774117946624756,
                "z": -209.14608764648438
            },
            {
                "x": -6.105855941772461,
                "y": 0.6686795949935913,
                "z": -208.9958038330078
            },
            {
                "x": -6.15141487121582,
                "y": 0.6598833799362183,
                "z": -208.84568786621094
            },
            {
                "x": -6.19688081741333,
                "y": 0.651018500328064,
                "z": -208.69561767578125
            },
            {
                "x": -6.242305755615234,
                "y": 0.642078161239624,
                "z": -208.54531860351562
            },
            {
                "x": -6.287591457366943,
                "y": 0.6330846548080444,
                "z": -208.3952178955078
            },
            {
                "x": -6.33281946182251,
                "y": 0.6240202188491821,
                "z": -208.24493408203125
            },
            {
                "x": -6.3779473304748535,
                "y": 0.6149023771286011,
                "z": -208.09466552734375
            },
            {
                "x": -6.422929763793945,
                "y": 0.6057367920875549,
                "z": -207.9444580078125
            },
            {
                "x": -6.467811107635498,
                "y": 0.5965235233306885,
                "z": -207.7942657470703
            },
            {
                "x": -6.51253604888916,
                "y": 0.5872637033462524,
                "z": -207.64402770996094
            },
            {
                "x": -6.557168483734131,
                "y": 0.5779581069946289,
                "z": -207.4937286376953
            },
            {
                "x": -6.601706504821777,
                "y": 0.5686062574386597,
                "z": -207.34327697753906
            },
            {
                "x": -6.64607048034668,
                "y": 0.5592262148857117,
                "z": -207.19288635253906
            },
            {
                "x": -6.690297603607178,
                "y": 0.5498149394989014,
                "z": -207.04249572753906
            },
            {
                "x": -6.73435640335083,
                "y": 0.5403728485107422,
                "z": -206.89205932617188
            },
            {
                "x": -6.778293132781982,
                "y": 0.5309067368507385,
                "z": -206.7415771484375
            },
            {
                "x": -6.822084426879883,
                "y": 0.5214138031005859,
                "z": -206.5909881591797
            },
            {
                "x": -6.865697383880615,
                "y": 0.5119065046310425,
                "z": -206.44041442871094
            },
            {
                "x": -6.909122467041016,
                "y": 0.5023912191390991,
                "z": -206.28993225097656
            },
            {
                "x": -6.952409744262695,
                "y": 0.49285370111465454,
                "z": -206.13919067382812
            },
            {
                "x": -6.995512962341309,
                "y": 0.4833170771598816,
                "z": -205.98855590820312
            },
            {
                "x": -7.038412094116211,
                "y": 0.47377219796180725,
                "z": -205.8378143310547
            },
            {
                "x": -7.081174373626709,
                "y": 0.46422284841537476,
                "z": -205.68701171875
            },
            {
                "x": -7.123682022094727,
                "y": 0.45468607544898987,
                "z": -205.5363006591797
            },
            {
                "x": -7.166050434112549,
                "y": 0.4451434016227722,
                "z": -205.3852996826172
            },
            {
                "x": -7.208180904388428,
                "y": 0.435624361038208,
                "z": -205.2344970703125
            },
            {
                "x": -7.2500810623168945,
                "y": 0.42611387372016907,
                "z": -205.0835418701172
            },
            {
                "x": -7.291858673095703,
                "y": 0.4166097044944763,
                "z": -204.93240356445312
            },
            {
                "x": -7.33331823348999,
                "y": 0.40714022517204285,
                "z": -204.7814483642578
            },
            {
                "x": -7.374619483947754,
                "y": 0.3976861834526062,
                "z": -204.63027954101562
            },
            {
                "x": -7.401146411895752,
                "y": 0.3916007876396179,
                "z": -204.53273010253906
            },
            {
                "x": -7.442007541656494,
                "y": 0.38219934701919556,
                "z": -204.38157653808594
            },
            {
                "x": -7.48273229598999,
                "y": 0.37282001972198486,
                "z": -204.23019409179688
            },
            {
                "x": -7.523138999938965,
                "y": 0.363487184047699,
                "z": -204.0789031982422
            },
            {
                "x": -7.563327312469482,
                "y": 0.3541907072067261,
                "z": -203.927490234375
            },
            {
                "x": -7.603270530700684,
                "y": 0.34493935108184814,
                "z": -203.7760772705078
            },
            {
                "x": -7.642948150634766,
                "y": 0.33573174476623535,
                "z": -203.62454223632812
            },
            {
                "x": -7.682379245758057,
                "y": 0.326581209897995,
                "z": -203.4730224609375
            },
            {
                "x": -7.721530914306641,
                "y": 0.31747549772262573,
                "z": -203.32130432128906
            },
            {
                "x": -7.760444164276123,
                "y": 0.30842870473861694,
                "z": -203.16957092285156
            },
            {
                "x": -7.799046039581299,
                "y": 0.2994483709335327,
                "z": -203.01785278320312
            },
            {
                "x": -7.837406158447266,
                "y": 0.29052358865737915,
                "z": -202.86590576171875
            },
            {
                "x": -7.87546968460083,
                "y": 0.2816792130470276,
                "z": -202.71412658691406
            },
            {
                "x": -7.913259029388428,
                "y": 0.2728901505470276,
                "z": -202.56198120117188
            },
            {
                "x": -7.950784206390381,
                "y": 0.26418304443359375,
                "z": -202.40992736816406
            },
            {
                "x": -7.987933158874512,
                "y": 0.2555643618106842,
                "z": -202.2579345703125
            },
            {
                "x": -8.024860382080078,
                "y": 0.24701139330863953,
                "z": -202.10560607910156
            },
            {
                "x": -8.06143856048584,
                "y": 0.2385581135749817,
                "z": -201.9534912109375
            },
            {
                "x": -8.097722053527832,
                "y": 0.2301793098449707,
                "z": -201.80104064941406
            },
            {
                "x": -8.133749008178711,
                "y": 0.22189652919769287,
                "z": -201.64857482910156
            },
            {
                "x": -8.169354438781738,
                "y": 0.21371936798095703,
                "z": -201.4962158203125
            },
            {
                "x": -8.204715728759766,
                "y": 0.2056320309638977,
                "z": -201.3436279296875
            },
            {
                "x": -8.239701271057129,
                "y": 0.1976557821035385,
                "z": -201.19114685058594
            },
            {
                "x": -8.274377822875977,
                "y": 0.1897769272327423,
                "z": -201.0384063720703
            },
            {
                "x": -8.30879020690918,
                "y": 0.18200531601905823,
                "z": -200.88552856445312
            },
            {
                "x": -8.342763900756836,
                "y": 0.1743544191122055,
                "z": -200.7327423095703
            },
            {
                "x": -8.37649917602539,
                "y": 0.16681116819381714,
                "z": -200.5797576904297
            },
            {
                "x": -8.409810066223145,
                "y": 0.15939703583717346,
                "z": -200.4268341064453
            },
            {
                "x": -8.442806243896484,
                "y": 0.15210071206092834,
                "z": -200.27371215820312
            },
            {
                "x": -8.475486755371094,
                "y": 0.14492888748645782,
                "z": -200.12045288085938
            },
            {
                "x": -8.507739067077637,
                "y": 0.13789033889770508,
                "z": -199.96725463867188
            },
            {
                "x": -8.539712905883789,
                "y": 0.1309848427772522,
                "z": -199.81394958496094
            },
            {
                "x": -8.571255683898926,
                "y": 0.12422019988298416,
                "z": -199.6605987548828
            },
            {
                "x": -8.602487564086914,
                "y": 0.11758989095687866,
                "z": -199.50704956054688
            },
            {
                "x": -8.633344650268555,
                "y": 0.11110708117485046,
                "z": -199.3535614013672
            },
            {
                "x": -8.663800239562988,
                "y": 0.10476665198802948,
                "z": -199.19985961914062
            },
            {
                "x": -8.693931579589844,
                "y": 0.09858479350805283,
                "z": -199.0461883544922
            },
            {
                "x": -8.72361946105957,
                "y": 0.09255478531122208,
                "z": -198.89244079589844
            },
            {
                "x": -8.752994537353516,
                "y": 0.0866779237985611,
                "z": -198.73854064941406
            },
            {
                "x": -8.781940460205078,
                "y": 0.08096951246261597,
                "z": -198.5847930908203
            },
            {
                "x": -8.810521125793457,
                "y": 0.0754159539937973,
                "z": -198.43055725097656
            },
            {
                "x": -8.838735580444336,
                "y": 0.07003938406705856,
                "z": -198.27658081054688
            },
            {
                "x": -8.866479873657227,
                "y": 0.06483273208141327,
                "z": -198.12252807617188
            },
            {
                "x": -8.884232521057129,
                "y": 0.061559319496154785,
                "z": -198.0228729248047
            },
            {
                "x": -8.91139030456543,
                "y": 0.056644901633262634,
                "z": -197.86874389648438
            },
            {
                "x": -8.938104629516602,
                "y": 0.05190381407737732,
                "z": -197.7144012451172
            },
            {
                "x": -8.964522361755371,
                "y": 0.04734096676111221,
                "z": -197.55984497070312
            },
            {
                "x": -8.990410804748535,
                "y": 0.042981263250112534,
                "z": -197.40557861328125
            },
            {
                "x": -9.015959739685059,
                "y": 0.0388001911342144,
                "z": -197.2508544921875
            },
            {
                "x": -9.041117668151855,
                "y": 0.03481758385896683,
                "z": -197.09632873535156
            },
            {
                "x": -9.065788269042969,
                "y": 0.03102898597717285,
                "z": -196.94171142578125
            },
            {
                "x": -9.090167045593262,
                "y": 0.02744012139737606,
                "z": -196.78675842285156
            },
            {
                "x": -9.114020347595215,
                "y": 0.02406332828104496,
                "z": -196.63211059570312
            },
            {
                "x": -9.137500762939453,
                "y": 0.02088468335568905,
                "z": -196.4770965576172
            },
            {
                "x": -9.160600662231445,
                "y": 0.017917754128575325,
                "z": -196.3222198486328
            },
            {
                "x": -9.183182716369629,
                "y": 0.015170535072684288,
                "z": -196.16726684570312
            },
            {
                "x": -9.20546817779541,
                "y": 0.012634681537747383,
                "z": -196.01193237304688
            },
            {
                "x": -9.227234840393066,
                "y": 0.010323511436581612,
                "z": -195.85696411132812
            },
            {
                "x": -9.248592376708984,
                "y": 0.008229889906942844,
                "z": -195.7017059326172
            },
            {
                "x": -9.269580841064453,
                "y": 0.006369853392243385,
                "z": -195.5464630126953
            },
            {
                "x": -9.290027618408203,
                "y": 0.0047414880245924,
                "z": -195.39126586914062
            },
            {
                "x": -9.310161590576172,
                "y": 0.0033411704935133457,
                "z": -195.2357177734375
            },
            {
                "x": -9.329819679260254,
                "y": 0.002177055925130844,
                "z": -195.0803985595703
            },
            {
                "x": -9.349004745483398,
                "y": 0.0012578123714774847,
                "z": -194.92483520507812
            },
            {
                "x": -9.36783218383789,
                "y": 0.0005828214343637228,
                "z": -194.76937866210938
            },
            {
                "x": -9.386134147644043,
                "y": 0.00015161943156272173,
                "z": -194.6139373779297
            },
            {
                "x": -9.404083251953125,
                "y": -3.335694782435894e-05,
                "z": -194.4581756591797
            },
            {
                "x": -9.421588897705078,
                "y": -4.44464385509491e-05,
                "z": -194.30250549316406
            },
            {
                "x": -9.438580513000488,
                "y": -4.845857620239258e-05,
                "z": -194.14674377441406
            },
            {
                "x": -9.455241203308105,
                "y": -5.25154173374176e-05,
                "z": -193.9909210205078
            },
            {
                "x": -9.471380233764648,
                "y": -5.654245615005493e-05,
                "z": -193.83523559570312
            },
            {
                "x": -9.487107276916504,
                "y": -6.056204438209534e-05,
                "z": -193.6792449951172
            },
            {
                "x": -9.502443313598633,
                "y": -6.460770964622498e-05,
                "z": -193.5232696533203
            },
            {
                "x": -9.517232894897461,
                "y": -6.865710020065308e-05,
                "z": -193.3673858642578
            },
            {
                "x": -9.531689643859863,
                "y": -7.26841390132904e-05,
                "z": -193.2113037109375
            },
            {
                "x": -9.54565143585205,
                "y": -7.67335295677185e-05,
                "z": -193.0553741455078
            },
            {
                "x": -9.559136390686035,
                "y": -8.076056838035583e-05,
                "z": -192.89923095703125
            },
            {
                "x": -9.572279930114746,
                "y": -8.479505777359009e-05,
                "z": -192.74302673339844
            },
            {
                "x": -9.584883689880371,
                "y": -8.884072303771973e-05,
                "z": -192.5869598388672
            },
            {
                "x": -9.597089767456055,
                "y": -9.284541010856628e-05,
                "z": -192.43064880371094
            },
            {
                "x": -9.608879089355469,
                "y": -9.689107537269592e-05,
                "z": -192.2744903564453
            },
            {
                "x": -9.620136260986328,
                "y": -0.00010092183947563171,
                "z": -192.11827087402344
            },
            {
                "x": -9.631057739257812,
                "y": -0.00010497495532035828,
                "z": -191.9619140625
            },
            {
                "x": -9.641490936279297,
                "y": -0.00010899826884269714,
                "z": -191.80560302734375
            },
            {
                "x": -9.651430130004883,
                "y": -0.00011304020881652832,
                "z": -191.6492156982422
            },
            {
                "x": -9.661032676696777,
                "y": -0.00011707469820976257,
                "z": -191.49285888671875
            },
            {
                "x": -9.66695785522461,
                "y": -0.00011970847845077515,
                "z": -191.39198303222656
            },
            {
                "x": -9.675724983215332,
                "y": -0.00012373179197311401,
                "z": -191.2355194091797
            },
            {
                "x": -9.684165000915527,
                "y": -0.00012777745723724365,
                "z": -191.0789794921875
            },
            {
                "x": -9.692081451416016,
                "y": -0.00013178959488868713,
                "z": -190.92259216308594
            },
            {
                "x": -9.699566841125488,
                "y": -0.0001358315348625183,
                "z": -190.7659912109375
            },
            {
                "x": -9.706676483154297,
                "y": -0.0001398809254169464,
                "z": -190.60946655273438
            },
            {
                "x": -9.71324348449707,
                "y": -0.00014389678835868835,
                "z": -190.45306396484375
            },
            {
                "x": -9.719446182250977,
                "y": -0.00014792010188102722,
                "z": -190.29640197753906
            },
            {
                "x": -9.725236892700195,
                "y": -0.0001519434154033661,
                "z": -190.13978576660156
            },
            {
                "x": -9.73047924041748,
                "y": -0.0001559928059577942,
                "z": -189.9832305908203
            },
            {
                "x": -9.735396385192871,
                "y": -0.00016004592180252075,
                "z": -189.82650756835938
            },
            {
                "x": -9.73984146118164,
                "y": -0.00016410276293754578,
                "z": -189.6700439453125
            },
            {
                "x": -9.743799209594727,
                "y": -0.00016809627413749695,
                "z": -189.51336669921875
            },
            {
                "x": -9.747427940368652,
                "y": -0.00017215311527252197,
                "z": -189.3565216064453
            },
            {
                "x": -9.750544548034668,
                "y": -0.00017618387937545776,
                "z": -189.2000274658203
            },
            {
                "x": -9.75322437286377,
                "y": -0.0001802109181880951,
                "z": -189.04330444335938
            },
            {
                "x": -9.755571365356445,
                "y": -0.00018423795700073242,
                "z": -188.8865509033203
            },
            {
                "x": -9.757369995117188,
                "y": -0.00018828734755516052,
                "z": -188.7300262451172
            },
            {
                "x": -9.758774757385254,
                "y": -0.00019231438636779785,
                "z": -188.57313537597656
            },
            {
                "x": -9.759818077087402,
                "y": -0.00019634142518043518,
                "z": -188.4164581298828
            },
            {
                "x": -9.760327339172363,
                "y": -0.00020039081573486328,
                "z": -188.25990295410156
            },
            {
                "x": -9.760451316833496,
                "y": -0.00020444393157958984,
                "z": -188.10311889648438
            },
            {
                "x": -9.760181427001953,
                "y": -0.00020845606923103333,
                "z": -187.94656372070312
            },
            {
                "x": -9.759374618530273,
                "y": -0.00021247565746307373,
                "z": -187.78994750976562
            },
            {
                "x": -9.758217811584473,
                "y": -0.00021653622388839722,
                "z": -187.63296508789062
            },
            {
                "x": -9.756604194641113,
                "y": -0.00022056326270103455,
                "z": -187.47647094726562
            },
            {
                "x": -9.754463195800781,
                "y": -0.00022460147738456726,
                "z": -187.3197784423828
            },
            {
                "x": -9.751988410949707,
                "y": -0.0002286285161972046,
                "z": -187.1630401611328
            },
            {
                "x": -9.74903678894043,
                "y": -0.00023265928030014038,
                "z": -187.00660705566406
            },
            {
                "x": -9.74555492401123,
                "y": -0.00023669376969337463,
                "z": -186.8496856689453
            },
            {
                "x": -9.74174976348877,
                "y": -0.00024073943495750427,
                "z": -186.6930389404297
            },
            {
                "x": -9.737433433532715,
                "y": -0.00024512410163879395,
                "z": -186.53665161132812
            },
            {
                "x": -9.732648849487305,
                "y": -0.00039729662239551544,
                "z": -186.37982177734375
            },
            {
                "x": -9.727506637573242,
                "y": -0.0007898455951362848,
                "z": -186.2232666015625
            },
            {
                "x": -9.721818923950195,
                "y": -0.0013992078602313995,
                "z": -186.06675720214844
            },
            {
                "x": -9.715720176696777,
                "y": -0.0022231659386307,
                "z": -185.91001892089844
            },
            {
                "x": -9.709248542785645,
                "y": -0.003255882766097784,
                "z": -185.75360107421875
            },
            {
                "x": -9.702200889587402,
                "y": -0.004506853874772787,
                "z": -185.5970458984375
            },
            {
                "x": -9.694795608520508,
                "y": -0.005963859613984823,
                "z": -185.44046020507812
            },
            {
                "x": -9.686963081359863,
                "y": -0.00762005802243948,
                "z": -185.28414916992188
            },
            {
                "x": -9.67858600616455,
                "y": -0.009479539468884468,
                "z": -185.12753295898438
            },
            {
                "x": -9.669876098632812,
                "y": -0.011541563086211681,
                "z": -184.97105407714844
            },
            {
                "x": -9.660682678222656,
                "y": -0.013794917613267899,
                "z": -184.81483459472656
            },
            {
                "x": -9.654472351074219,
                "y": -0.01535063050687313,
                "z": -184.71383666992188
            },
            {
                "x": -9.64458179473877,
                "y": -0.017922289669513702,
                "z": -184.557373046875
            },
            {
                "x": -9.63422679901123,
                "y": -0.02067984640598297,
                "z": -184.4011688232422
            },
            {
                "x": -9.623366355895996,
                "y": -0.023624174296855927,
                "z": -184.2447509765625
            },
            {
                "x": -9.612187385559082,
                "y": -0.026744848117232323,
                "z": -184.08851623535156
            },
            {
                "x": -9.600481986999512,
                "y": -0.03004627488553524,
                "z": -183.932373046875
            },
            {
                "x": -9.588329315185547,
                "y": -0.03352872654795647,
                "z": -183.7760772705078
            },
            {
                "x": -9.575833320617676,
                "y": -0.037176720798015594,
                "z": -183.62001037597656
            },
            {
                "x": -9.562788009643555,
                "y": -0.04099724441766739,
                "z": -183.4638214111328
            },
            {
                "x": -9.549369812011719,
                "y": -0.044987522065639496,
                "z": -183.30763244628906
            },
            {
                "x": -9.535539627075195,
                "y": -0.049137622117996216,
                "z": -183.15170288085938
            },
            {
                "x": -9.521185874938965,
                "y": -0.05345076695084572,
                "z": -182.99569702148438
            },
            {
                "x": -9.506510734558105,
                "y": -0.05791914463043213,
                "z": -182.83970642089844
            },
            {
                "x": -9.491340637207031,
                "y": -0.06254447996616364,
                "z": -182.6837921142578
            },
            {
                "x": -9.475711822509766,
                "y": -0.06732451915740967,
                "z": -182.52784729003906
            },
            {
                "x": -9.459757804870605,
                "y": -0.07224703580141068,
                "z": -182.37210083007812
            },
            {
                "x": -9.443279266357422,
                "y": -0.07731619477272034,
                "z": -182.2163543701172
            },
            {
                "x": -9.426412582397461,
                "y": -0.08253204822540283,
                "z": -182.060546875
            },
            {
                "x": -9.409154891967773,
                "y": -0.08788524568080902,
                "z": -181.90493774414062
            },
            {
                "x": -9.391382217407227,
                "y": -0.09337809681892395,
                "z": -181.74925231933594
            },
            {
                "x": -9.373290061950684,
                "y": -0.09900084137916565,
                "z": -181.5936279296875
            },
            {
                "x": -9.354747772216797,
                "y": -0.10474737733602524,
                "z": -181.43832397460938
            },
            {
                "x": -9.335726737976074,
                "y": -0.11063417047262192,
                "z": -181.2827911376953
            },
            {
                "x": -9.316391944885254,
                "y": -0.11663828045129776,
                "z": -181.12745666503906
            },
            {
                "x": -9.296539306640625,
                "y": -0.12276799976825714,
                "z": -180.9720001220703
            },
            {
                "x": -9.27631664276123,
                "y": -0.12901823222637177,
                "z": -180.81661987304688
            },
            {
                "x": -9.255720138549805,
                "y": -0.13537690043449402,
                "z": -180.66148376464844
            },
            {
                "x": -9.234623908996582,
                "y": -0.1418537050485611,
                "z": -180.5063018798828
            },
            {
                "x": -9.213215827941895,
                "y": -0.14843755960464478,
                "z": -180.3511199951172
            },
            {
                "x": -9.191337585449219,
                "y": -0.15512871742248535,
                "z": -180.19601440429688
            },
            {
                "x": -9.169035911560059,
                "y": -0.1619282066822052,
                "z": -180.0409393310547
            },
            {
                "x": -9.146418571472168,
                "y": -0.1688198745250702,
                "z": -179.8860626220703
            },
            {
                "x": -9.123299598693848,
                "y": -0.17581234872341156,
                "z": -179.7311553955078
            },
            {
                "x": -9.099847793579102,
                "y": -0.18290090560913086,
                "z": -179.57627868652344
            },
            {
                "x": -9.075990676879883,
                "y": -0.19007734954357147,
                "z": -179.42156982421875
            },
            {
                "x": -9.051668167114258,
                "y": -0.197349414229393,
                "z": -179.2667694091797
            },
            {
                "x": -9.027060508728027,
                "y": -0.2046990990638733,
                "z": -179.1121368408203
            },
            {
                "x": -9.001996994018555,
                "y": -0.2121296525001526,
                "z": -178.95762634277344
            },
            {
                "x": -8.976537704467773,
                "y": -0.21964748203754425,
                "z": -178.80303955078125
            },
            {
                "x": -8.950757026672363,
                "y": -0.2272316813468933,
                "z": -178.64869689941406
            },
            {
                "x": -8.924479484558105,
                "y": -0.23490184545516968,
                "z": -178.49415588378906
            },
            {
                "x": -8.897928237915039,
                "y": -0.242634117603302,
                "z": -178.33982849121094
            },
            {
                "x": -8.87096118927002,
                "y": -0.25042691826820374,
                "z": -178.1857452392578
            },
            {
                "x": -8.853303909301758,
                "y": -0.2555011510848999,
                "z": -178.08612060546875
            },
            {
                "x": -8.825754165649414,
                "y": -0.26340335607528687,
                "z": -177.9319610595703
            },
            {
                "x": -8.79776668548584,
                "y": -0.2713644206523895,
                "z": -177.77793884277344
            },
            {
                "x": -8.769381523132324,
                "y": -0.2793920636177063,
                "z": -177.62379455566406
            },
            {
                "x": -8.74072551727295,
                "y": -0.28745681047439575,
                "z": -177.469970703125
            },
            {
                "x": -8.71159839630127,
                "y": -0.29558002948760986,
                "z": -177.31607055664062
            },
            {
                "x": -8.682172775268555,
                "y": -0.3037515878677368,
                "z": -177.1621856689453
            },
            {
                "x": -8.652386665344238,
                "y": -0.3119564652442932,
                "z": -177.0086212158203
            },
            {
                "x": -8.622154235839844,
                "y": -0.3202221989631653,
                "z": -176.854736328125
            },
            {
                "x": -8.59168815612793,
                "y": -0.328508585691452,
                "z": -176.70120239257812
            },
            {
                "x": -8.560772895812988,
                "y": -0.33683356642723083,
                "z": -176.5476837158203
            },
            {
                "x": -8.529541015625,
                "y": -0.3451961278915405,
                "z": -176.39414978027344
            },
            {
                "x": -8.498002052307129,
                "y": -0.3535735607147217,
                "z": -176.2409210205078
            },
            {
                "x": -8.4660062789917,
                "y": -0.36199772357940674,
                "z": -176.0873565673828
            },
            {
                "x": -8.43378734588623,
                "y": -0.3704286813735962,
                "z": -175.93417358398438
            },
            {
                "x": -8.401162147521973,
                "y": -0.37887606024742126,
                "z": -175.78111267089844
            },
            {
                "x": -8.368183135986328,
                "y": -0.3873554766178131,
                "z": -175.62782287597656
            },
            {
                "x": -8.33494758605957,
                "y": -0.3958318829536438,
                "z": -175.4748992919922
            },
            {
                "x": -8.301281929016113,
                "y": -0.404331237077713,
                "z": -175.32183837890625
            },
            {
                "x": -8.267356872558594,
                "y": -0.41283583641052246,
                "z": -175.16885375976562
            },
            {
                "x": -8.233081817626953,
                "y": -0.4213353991508484,
                "z": -175.01612854003906
            },
            {
                "x": -8.19849681854248,
                "y": -0.4298434853553772,
                "z": -174.8633270263672
            },
            {
                "x": -8.1636323928833,
                "y": -0.4383409917354584,
                "z": -174.71075439453125
            },
            {
                "x": -8.12836742401123,
                "y": -0.4468395411968231,
                "z": -174.55813598632812
            },
            {
                "x": -8.092815399169922,
                "y": -0.4553399980068207,
                "z": -174.40545654296875
            },
            {
                "x": -8.056968688964844,
                "y": -0.4638133645057678,
                "z": -174.25308227539062
            },
            {
                "x": -8.020787239074707,
                "y": -0.47228527069091797,
                "z": -174.1005401611328
            },
            {
                "x": -7.984349250793457,
                "y": -0.48073017597198486,
                "z": -173.94825744628906
            },
            {
                "x": -7.947548866271973,
                "y": -0.4891575276851654,
                "z": -173.79598999023438
            },
            {
                "x": -7.9104695320129395,
                "y": -0.49757230281829834,
                "z": -173.64356994628906
            },
            {
                "x": -7.873119354248047,
                "y": -0.5059447288513184,
                "z": -173.49154663085938
            },
            {
                "x": -7.83545446395874,
                "y": -0.5142953395843506,
                "z": -173.33941650390625
            },
            {
                "x": -7.797524452209473,
                "y": -0.5226114988327026,
                "z": -173.1873779296875
            },
            {
                "x": -7.7592644691467285,
                "y": -0.5308921337127686,
                "z": -173.03543090820312
            },
            {
                "x": -7.720768451690674,
                "y": -0.539138913154602,
                "z": -172.88345336914062
            },
            {
                "x": -7.681962013244629,
                "y": -0.5473359227180481,
                "z": -172.73162841796875
            },
            {
                "x": -7.642889976501465,
                "y": -0.5554927587509155,
                "z": -172.57981872558594
            },
            {
                "x": -7.603571891784668,
                "y": -0.5635989904403687,
                "z": -172.42811584472656
            },
            {
                "x": -7.563945770263672,
                "y": -0.5716544389724731,
                "z": -172.2764892578125
            },
            {
                "x": -7.524103164672852,
                "y": -0.5796537399291992,
                "z": -172.12490844726562
            },
            {
                "x": -7.483924388885498,
                "y": -0.5876021385192871,
                "z": -171.97329711914062
            },
            {
                "x": -7.443527698516846,
                "y": -0.5954864621162415,
                "z": -171.82180786132812
            },
            {
                "x": -7.402918815612793,
                "y": -0.6033020615577698,
                "z": -171.6704864501953
            },
            {
                "x": -7.376514434814453,
                "y": -0.608315110206604,
                "z": -171.57276916503906
            },
            {
                "x": -7.335465908050537,
                "y": -0.6160235404968262,
                "z": -171.4214324951172
            },
            {
                "x": -7.294177532196045,
                "y": -0.6236599683761597,
                "z": -171.2701873779297
            },
            {
                "x": -7.252590656280518,
                "y": -0.6312260627746582,
                "z": -171.11891174316406
            },
            {
                "x": -7.210855007171631,
                "y": -0.6387038230895996,
                "z": -170.96783447265625
            },
            {
                "x": -7.168801307678223,
                "y": -0.6461077928543091,
                "z": -170.81671142578125
            },
            {
                "x": -7.126577377319336,
                "y": -0.6534262895584106,
                "z": -170.66567993164062
            },
            {
                "x": -7.084135055541992,
                "y": -0.6606507301330566,
                "z": -170.5148162841797
            },
            {
                "x": -7.041383266448975,
                "y": -0.6677966117858887,
                "z": -170.36370849609375
            },
            {
                "x": -6.998517036437988,
                "y": -0.6748379468917847,
                "z": -170.21290588378906
            },
            {
                "x": -6.95536994934082,
                "y": -0.6817871332168579,
                "z": -170.06207275390625
            },
            {
                "x": -6.912039756774902,
                "y": -0.6886367201805115,
                "z": -169.91127014160156
            },
            {
                "x": -6.868513107299805,
                "y": -0.6953752636909485,
                "z": -169.76068115234375
            },
            {
                "x": -6.824698448181152,
                "y": -0.7020212411880493,
                "z": -169.60980224609375
            },
            {
                "x": -6.780796051025391,
                "y": -0.7085466384887695,
                "z": -169.4592742919922
            },
            {
                "x": -6.736640453338623,
                "y": -0.7149611115455627,
                "z": -169.30874633789062
            },
            {
                "x": -6.692299842834473,
                "y": -0.7212616801261902,
                "z": -169.15814208984375
            },
            {
                "x": -6.647788047790527,
                "y": -0.7274380326271057,
                "z": -169.0077362060547
            },
            {
                "x": -6.603049278259277,
                "y": -0.7335015535354614,
                "z": -168.85720825195312
            },
            {
                "x": -6.55817174911499,
                "y": -0.7394348382949829,
                "z": -168.70681762695312
            },
            {
                "x": -6.513093948364258,
                "y": -0.7452353835105896,
                "z": -168.55650329589844
            },
            {
                "x": -6.467892646789551,
                "y": -0.7509047389030457,
                "z": -168.40625
            },
            {
                "x": -6.422490119934082,
                "y": -0.7564406394958496,
                "z": -168.25604248046875
            },
            {
                "x": -6.376929759979248,
                "y": -0.7618408203125,
                "z": -168.10581970214844
            },
            {
                "x": -6.331172466278076,
                "y": -0.7670990228652954,
                "z": -167.95550537109375
            },
            {
                "x": -6.285271644592285,
                "y": -0.7722107172012329,
                "z": -167.80538940429688
            },
            {
                "x": -6.239253044128418,
                "y": -0.7771761417388916,
                "z": -167.6552734375
            },
            {
                "x": -6.193060398101807,
                "y": -0.781991720199585,
                "z": -167.5052032470703
            },
            {
                "x": -6.146735668182373,
                "y": -0.7866483330726624,
                "z": -167.35516357421875
            },
            {
                "x": -6.1002302169799805,
                "y": -0.7911527156829834,
                "z": -167.20506286621094
            },
            {
                "x": -6.0536370277404785,
                "y": -0.7954943776130676,
                "z": -167.05508422851562
            },
            {
                "x": -6.006931304931641,
                "y": -0.7996735572814941,
                "z": -166.90518188476562
            },
            {
                "x": -5.960033416748047,
                "y": -0.8036825656890869,
                "z": -166.7552032470703
            },
            {
                "x": -5.9130706787109375,
                "y": -0.8075213432312012,
                "z": -166.60533142089844
            },
            {
                "x": -5.865952968597412,
                "y": -0.8111900687217712,
                "z": -166.45542907714844
            },
            {
                "x": -5.818715572357178,
                "y": -0.8146849870681763,
                "z": -166.3055419921875
            },
            {
                "x": -5.7714033126831055,
                "y": -0.8179907202720642,
                "z": -166.15579223632812
            },
            {
                "x": -5.723941326141357,
                "y": -0.821118175983429,
                "z": -166.0059356689453
            },
            {
                "x": -5.676427841186523,
                "y": -0.8240593671798706,
                "z": -165.85621643066406
            },
            {
                "x": -5.628805160522461,
                "y": -0.826813817024231,
                "z": -165.70651245117188
            },
            {
                "x": -5.581040859222412,
                "y": -0.8293720483779907,
                "z": -165.556640625
            },
            {
                "x": -5.5332560539245605,
                "y": -0.8317323923110962,
                "z": -165.40701293945312
            },
            {
                "x": -5.485352039337158,
                "y": -0.8338969945907593,
                "z": -165.25733947753906
            },
            {
                "x": -5.454399585723877,
                "y": -0.8351881504058838,
                "z": -165.1606903076172
            },
            {
                "x": -5.406387805938721,
                "y": -0.8370147347450256,
                "z": -165.01109313964844
            },
            {
                "x": -5.358269214630127,
                "y": -0.8386380672454834,
                "z": -164.8613739013672
            },
            {
                "x": -5.310100555419922,
                "y": -0.8400521874427795,
                "z": -164.71170043945312
            },
            {
                "x": -5.261876583099365,
                "y": -0.8412470817565918,
                "z": -164.5621337890625
            },
            {
                "x": -5.21358585357666,
                "y": -0.8422255516052246,
                "z": -164.41246032714844
            },
            {
                "x": -5.165251731872559,
                "y": -0.8429855108261108,
                "z": -164.26290893554688
            },
            {
                "x": -5.116876602172852,
                "y": -0.8435244560241699,
                "z": -164.11334228515625
            },
            {
                "x": -5.068398475646973,
                "y": -0.8438329696655273,
                "z": -163.96365356445312
            },
            {
                "x": -5.019925117492676,
                "y": -0.8439100384712219,
                "z": -163.81411743164062
            },
            {
                "x": -4.971413612365723,
                "y": -0.8437585830688477,
                "z": -163.66455078125
            },
            {
                "x": -4.922869682312012,
                "y": -0.8433817028999329,
                "z": -163.51499938964844
            },
            {
                "x": -4.87429666519165,
                "y": -0.8427740335464478,
                "z": -163.36544799804688
            },
            {
                "x": -4.825652599334717,
                "y": -0.841942548751831,
                "z": -163.21575927734375
            },
            {
                "x": -4.777066707611084,
                "y": -0.8408951759338379,
                "z": -163.06622314453125
            },
            {
                "x": -4.728457927703857,
                "y": -0.8396347761154175,
                "z": -162.91676330566406
            },
            {
                "x": -4.67979097366333,
                "y": -0.8381564617156982,
                "z": -162.7671356201172
            },
            {
                "x": -4.6311774253845215,
                "y": -0.8364679217338562,
                "z": -162.6176300048828
            },
            {
                "x": -4.582517147064209,
                "y": -0.8345739841461182,
                "z": -162.46804809570312
            },
            {
                "x": -4.533859729766846,
                "y": -0.8324791193008423,
                "z": -162.31842041015625
            },
            {
                "x": -4.4852423667907715,
                "y": -0.8301823735237122,
                "z": -162.1688995361328
            },
            {
                "x": -4.436654567718506,
                "y": -0.8276866674423218,
                "z": -162.01937866210938
            },
            {
                "x": -4.388082981109619,
                "y": -0.8249993324279785,
                "z": -161.86984252929688
            },
            {
                "x": -4.339521884918213,
                "y": -0.8221240043640137,
                "z": -161.72030639648438
            },
            {
                "x": -4.290931224822998,
                "y": -0.8190546035766602,
                "z": -161.570556640625
            },
            {
                "x": -4.242429256439209,
                "y": -0.8158019781112671,
                "z": -161.4209442138672
            },
            {
                "x": -4.193955421447754,
                "y": -0.8123703002929688,
                "z": -161.27134704589844
            },
            {
                "x": -4.145509243011475,
                "y": -0.808761715888977,
                "z": -161.12167358398438
            },
            {
                "x": -4.097147464752197,
                "y": -0.8049788475036621,
                "z": -160.97207641601562
            },
            {
                "x": -4.0487494468688965,
                "y": -0.8010158538818359,
                "z": -160.82223510742188
            },
            {
                "x": -4.000486373901367,
                "y": -0.7968911528587341,
                "z": -160.6725616455078
            },
            {
                "x": -3.9522805213928223,
                "y": -0.7926045656204224,
                "z": -160.52291870117188
            },
            {
                "x": -3.904087543487549,
                "y": -0.7881498336791992,
                "z": -160.37307739257812
            },
            {
                "x": -3.8560163974761963,
                "y": -0.7835380434989929,
                "z": -160.22335815429688
            },
            {
                "x": -3.8079700469970703,
                "y": -0.77876877784729,
                "z": -160.07350158691406
            },
            {
                "x": -3.7600274085998535,
                "y": -0.773849606513977,
                "z": -159.9236602783203
            },
            {
                "x": -3.712181806564331,
                "y": -0.7687830924987793,
                "z": -159.77383422851562
            },
            {
                "x": -3.6644060611724854,
                "y": -0.763563871383667,
                "z": -159.6239013671875
            },
            {
                "x": -3.61676287651062,
                "y": -0.7582079768180847,
                "z": -159.47409057617188
            },
            {
                "x": -3.5691871643066406,
                "y": -0.7527123689651489,
                "z": -159.3241729736328
            },
            {
                "x": -3.5216784477233887,
                "y": -0.7470735311508179,
                "z": -159.17408752441406
            },
            {
                "x": -3.4743103981018066,
                "y": -0.7413058280944824,
                "z": -159.0241241455078
            },
            {
                "x": -3.4270687103271484,
                "y": -0.7354077100753784,
                "z": -158.87411499023438
            },
            {
                "x": -3.3966243267059326,
                "y": -0.7315355539321899,
                "z": -158.77725219726562
            },
            {
                "x": -3.349550485610962,
                "y": -0.7254292964935303,
                "z": -158.62718200683594
            },
            {
                "x": -3.302602767944336,
                "y": -0.71919846534729,
                "z": -158.4770050048828
            },
            {
                "x": -3.255751609802246,
                "y": -0.71285080909729,
                "z": -158.3267822265625
            },
            {
                "x": -3.209080457687378,
                "y": -0.7063913345336914,
                "z": -158.17660522460938
            },
            {
                "x": -3.1625301837921143,
                "y": -0.6998144388198853,
                "z": -158.02630615234375
            },
            {
                "x": -3.1161134243011475,
                "y": -0.69312983751297,
                "z": -157.8760223388672
            },
            {
                "x": -3.0698840618133545,
                "y": -0.686343789100647,
                "z": -157.72573852539062
            },
            {
                "x": -3.023707389831543,
                "y": -0.6794458031654358,
                "z": -157.5751953125
            },
            {
                "x": -2.977769374847412,
                "y": -0.6724518537521362,
                "z": -157.4247589111328
            },
            {
                "x": -2.931973934173584,
                "y": -0.6653627753257751,
                "z": -157.2742919921875
            },
            {
                "x": -2.886324405670166,
                "y": -0.6581780314445496,
                "z": -157.12371826171875
            },
            {
                "x": -2.8408870697021484,
                "y": -0.6509100794792175,
                "z": -156.9731903076172
            },
            {
                "x": -2.7955284118652344,
                "y": -0.6435397267341614,
                "z": -156.8223876953125
            },
            {
                "x": -2.750445604324341,
                "y": -0.6360968351364136,
                "z": -156.67173767089844
            },
            {
                "x": -2.705514907836914,
                "y": -0.6285741329193115,
                "z": -156.52102661132812
            },
            {
                "x": -2.6607439517974854,
                "y": -0.6209660172462463,
                "z": -156.37010192871094
            },
            {
                "x": -2.616222620010376,
                "y": -0.6132922172546387,
                "z": -156.2193603515625
            },
            {
                "x": -2.5718302726745605,
                "y": -0.6055363416671753,
                "z": -156.0683135986328
            },
            {
                "x": -2.5276875495910645,
                "y": -0.5977168083190918,
                "z": -155.91729736328125
            },
            {
                "x": -2.4837214946746826,
                "y": -0.5898351669311523,
                "z": -155.7662811279297
            },
            {
                "x": -2.440009117126465,
                "y": -0.5818893909454346,
                "z": -155.61517333984375
            },
            {
                "x": -2.396491289138794,
                "y": -0.5738871097564697,
                "z": -155.46408081054688
            },
            {
                "x": -2.3531854152679443,
                "y": -0.5658259391784668,
                "z": -155.3128204345703
            },
            {
                "x": -2.3100764751434326,
                "y": -0.5577070713043213,
                "z": -155.1614227294922
            },
            {
                "x": -2.2672007083892822,
                "y": -0.5495433211326599,
                "z": -155.01007080078125
            },
            {
                "x": -2.2246005535125732,
                "y": -0.5413323640823364,
                "z": -154.85862731933594
            },
            {
                "x": -2.1821951866149902,
                "y": -0.5330786108970642,
                "z": -154.70712280273438
            },
            {
                "x": -2.1400580406188965,
                "y": -0.5247836112976074,
                "z": -154.55552673339844
            },
            {
                "x": -2.0981223583221436,
                "y": -0.516446590423584,
                "z": -154.40377807617188
            },
            {
                "x": -2.0564637184143066,
                "y": -0.5080782175064087,
                "z": -154.25204467773438
            },
            {
                "x": -2.0151028633117676,
                "y": -0.49968379735946655,
                "z": -154.10031127929688
            },
            {
                "x": -1.973919153213501,
                "y": -0.4912547171115875,
                "z": -153.94837951660156
            },
            {
                "x": -1.9330716133117676,
                "y": -0.48280447721481323,
                "z": -153.79644775390625
            },
            {
                "x": -1.892449140548706,
                "y": -0.4743305444717407,
                "z": -153.6444091796875
            },
            {
                "x": -1.8520922660827637,
                "y": -0.46583300828933716,
                "z": -153.49221801757812
            },
            {
                "x": -1.8120663166046143,
                "y": -0.45733004808425903,
                "z": -153.34010314941406
            },
            {
                "x": -1.7722340822219849,
                "y": -0.4488055109977722,
                "z": -153.18777465820312
            },
            {
                "x": -1.7327849864959717,
                "y": -0.44027817249298096,
                "z": -153.03549194335938
            },
            {
                "x": -1.6935698986053467,
                "y": -0.43174588680267334,
                "z": -152.88314819335938
            },
            {
                "x": -1.6546218395233154,
                "y": -0.4231944680213928,
                "z": -152.73045349121094
            },
            {
                "x": -1.6160328388214111,
                "y": -0.41466206312179565,
                "z": -152.5780029296875
            },
            {
                "x": -1.5777082443237305,
                "y": -0.40612339973449707,
                "z": -152.4253387451172
            },
            {
                "x": -1.5531599521636963,
                "y": -0.4006134271621704,
                "z": -152.32669067382812
            },
            {
                "x": -1.5153599977493286,
                "y": -0.3920936584472656,
                "z": -152.17404174804688
            },
            {
                "x": -1.4778556823730469,
                "y": -0.38357216119766235,
                "z": -152.02102661132812
            },
            {
                "x": -1.4407014846801758,
                "y": -0.3750722408294678,
                "z": -151.8680877685547
            },
            {
                "x": -1.4038258790969849,
                "y": -0.36658889055252075,
                "z": -151.71505737304688
            },
            {
                "x": -1.3673269748687744,
                "y": -0.35812318325042725,
                "z": -151.5618896484375
            },
            {
                "x": -1.3311188220977783,
                "y": -0.34968677163124084,
                "z": -151.4087677001953
            },
            {
                "x": -1.2952814102172852,
                "y": -0.3412729501724243,
                "z": -151.25547790527344
            },
            {
                "x": -1.2597408294677734,
                "y": -0.33288508653640747,
                "z": -151.10205078125
            },
            {
                "x": -1.2245378494262695,
                "y": -0.32453078031539917,
                "z": -150.94854736328125
            },
            {
                "x": -1.189758539199829,
                "y": -0.3162176012992859,
                "z": -150.79502868652344
            },
            {
                "x": -1.155247449874878,
                "y": -0.3079398274421692,
                "z": -150.6414031982422
            },
            {
                "x": -1.1211647987365723,
                "y": -0.2997050881385803,
                "z": -150.48768615722656
            },
            {
                "x": -1.0873665809631348,
                "y": -0.2915096879005432,
                "z": -150.33380126953125
            },
            {
                "x": -1.0539640188217163,
                "y": -0.283365398645401,
                "z": -150.17987060546875
            },
            {
                "x": -1.020980954170227,
                "y": -0.2752816379070282,
                "z": -150.0260467529297
            },
            {
                "x": -0.9882619380950928,
                "y": -0.2672387361526489,
                "z": -149.8718719482422
            },
            {
                "x": -0.9560176730155945,
                "y": -0.2592594027519226,
                "z": -149.7177734375
            },
            {
                "x": -0.9240860939025879,
                "y": -0.25134098529815674,
                "z": -149.56356811523438
            },
            {
                "x": -0.8925478458404541,
                "y": -0.24347883462905884,
                "z": -149.40911865234375
            },
            {
                "x": -0.8614394664764404,
                "y": -0.23569533228874207,
                "z": -149.25485229492188
            },
            {
                "x": -0.8306543231010437,
                "y": -0.22797322273254395,
                "z": -149.10035705566406
            },
            {
                "x": -0.8003524541854858,
                "y": -0.22032880783081055,
                "z": -148.9458465576172
            },
            {
                "x": -0.7703781127929688,
                "y": -0.21276165544986725,
                "z": -148.79127502441406
            },
            {
                "x": -0.7408058643341064,
                "y": -0.20525792241096497,
                "z": -148.63629150390625
            },
            {
                "x": -0.7116753458976746,
                "y": -0.19785252213478088,
                "z": -148.48162841796875
            },
            {
                "x": -0.6828942894935608,
                "y": -0.19052091240882874,
                "z": -148.32664489746094
            },
            {
                "x": -0.6546195149421692,
                "y": -0.18328553438186646,
                "z": -148.1716766357422
            },
            {
                "x": -0.6266728043556213,
                "y": -0.17614027857780457,
                "z": -148.01666259765625
            },
            {
                "x": -0.5991731286048889,
                "y": -0.16907711327075958,
                "z": -147.86129760742188
            },
            {
                "x": -0.5721015930175781,
                "y": -0.16212663054466248,
                "z": -147.70620727539062
            },
            {
                "x": -0.5454397797584534,
                "y": -0.15527009963989258,
                "z": -147.55084228515625
            },
            {
                "x": -0.5192549228668213,
                "y": -0.14851874113082886,
                "z": -147.3954620361328
            },
            {
                "x": -0.4934196472167969,
                "y": -0.14187180995941162,
                "z": -147.239990234375
            },
            {
                "x": -0.4680987000465393,
                "y": -0.13533082604408264,
                "z": -147.0843505859375
            },
            {
                "x": -0.44317543506622314,
                "y": -0.12891077995300293,
                "z": -146.92874145507812
            },
            {
                "x": -0.4186994433403015,
                "y": -0.12260071933269501,
                "z": -146.77297973632812
            },
            {
                "x": -0.39470064640045166,
                "y": -0.11641181260347366,
                "z": -146.61721801757812
            },
            {
                "x": -0.37107324600219727,
                "y": -0.11034199595451355,
                "z": -146.4613800048828
            },
            {
                "x": -0.34801071882247925,
                "y": -0.10440225899219513,
                "z": -146.30543518066406
            },
            {
                "x": -0.32529503107070923,
                "y": -0.09858517348766327,
                "z": -146.1493377685547
            },
            {
                "x": -0.30308306217193604,
                "y": -0.09289877116680145,
                "z": -145.99322509765625
            },
            {
                "x": -0.28136569261550903,
                "y": -0.08735191822052002,
                "z": -145.8372039794922
            },
            {
                "x": -0.26753026247024536,
                "y": -0.08384305983781815,
                "z": -145.73631286621094
            },
            {
                "x": -0.2465602159500122,
                "y": -0.07851842790842056,
                "z": -145.57998657226562
            },
            {
                "x": -0.2260323017835617,
                "y": -0.07333725690841675,
                "z": -145.42372131347656
            },
            {
                "x": -0.20593439042568207,
                "y": -0.06829854846000671,
                "z": -145.2671661376953
            },
            {
                "x": -0.18641795217990875,
                "y": -0.06341537833213806,
                "z": -145.11077880859375
            },
            {
                "x": -0.16725894808769226,
                "y": -0.05867753177881241,
                "z": -144.95420837402344
            },
            {
                "x": -0.14865386486053467,
                "y": -0.054091859608888626,
                "z": -144.7975616455078
            },
            {
                "x": -0.13052669167518616,
                "y": -0.04967348277568817,
                "z": -144.64105224609375
            },
            {
                "x": -0.11281338334083557,
                "y": -0.045403774827718735,
                "z": -144.4840850830078
            },
            {
                "x": -0.09569151699542999,
                "y": -0.041304491460323334,
                "z": -144.32737731933594
            },
            {
                "x": -0.07893873006105423,
                "y": -0.03736722096800804,
                "z": -144.1705322265625
            },
            {
                "x": -0.0627666786313057,
                "y": -0.03360070660710335,
                "z": -144.01353454589844
            },
            {
                "x": -0.04707573354244232,
                "y": -0.030012905597686768,
                "z": -143.8567352294922
            },
            {
                "x": -0.03180375695228577,
                "y": -0.026589054614305496,
                "z": -143.699462890625
            },
            {
                "x": -0.01713961362838745,
                "y": -0.023348866030573845,
                "z": -143.54246520996094
            },
            {
                "x": -0.0028729140758514404,
                "y": -0.020293280482292175,
                "z": -143.3854522705078
            },
            {
                "x": 0.010829031467437744,
                "y": -0.01741833984851837,
                "z": -143.2281036376953
            },
            {
                "x": 0.024033263325691223,
                "y": -0.014734255149960518,
                "z": -143.071044921875
            },
            {
                "x": 0.03680695593357086,
                "y": -0.012232691049575806,
                "z": -142.9136505126953
            },
            {
                "x": 0.04895612597465515,
                "y": -0.009930059313774109,
                "z": -142.7563018798828
            },
            {
                "x": 0.06069697439670563,
                "y": -0.007826591841876507,
                "z": -142.5990753173828
            },
            {
                "x": 0.07187069952487946,
                "y": -0.005917899776250124,
                "z": -142.44163513183594
            },
            {
                "x": 0.08253592252731323,
                "y": -0.00421104533597827,
                "z": -142.28436279296875
            },
            {
                "x": 0.09275658428668976,
                "y": -0.0027101333253085613,
                "z": -142.12686157226562
            },
            {
                "x": 0.10235881805419922,
                "y": -0.0014183041639626026,
                "z": -141.96920776367188
            },
            {
                "x": 0.1115403026342392,
                "y": -0.00033676251769065857,
                "z": -141.81179809570312
            },
            {
                "x": 0.12016938626766205,
                "y": 0.0005351428408175707,
                "z": -141.6541290283203
            },
            {
                "x": 0.12824131548404694,
                "y": 0.0011864916887134314,
                "z": -141.4966278076172
            },
            {
                "x": 0.13588395714759827,
                "y": 0.0016163154505193233,
                "z": -141.33901977539062
            },
            {
                "x": 0.14290769398212433,
                "y": 0.0018198906909674406,
                "z": -141.18116760253906
            },
            {
                "x": 0.14948983490467072,
                "y": 0.0018277894705533981,
                "z": -141.02366638183594
            },
            {
                "x": 0.15553268790245056,
                "y": 0.0018200501799583435,
                "z": -140.8658905029297
            },
            {
                "x": 0.1609800159931183,
                "y": 0.0018122941255569458,
                "z": -140.70822143554688
            },
            {
                "x": 0.16602101922035217,
                "y": 0.001804552972316742,
                "z": -140.550537109375
            },
            {
                "x": 0.17044375836849213,
                "y": 0.0017967969179153442,
                "z": -140.39266967773438
            },
            {
                "x": 0.17438176274299622,
                "y": 0.0017890557646751404,
                "z": -140.23501586914062
            },
            {
                "x": 0.1778235137462616,
                "y": 0.001781310886144638,
                "z": -140.0771942138672
            },
            {
                "x": 0.18066070973873138,
                "y": 0.0017735585570335388,
                "z": -139.91941833496094
            },
            {
                "x": 0.18309718370437622,
                "y": 0.0017658025026321411,
                "z": -139.7617645263672
            },
            {
                "x": 0.18496866524219513,
                "y": 0.001758059486746788,
                "z": -139.6039581298828
            },
            {
                "x": 0.1863798052072525,
                "y": 0.001750309020280838,
                "z": -139.44618225097656
            },
            {
                "x": 0.18741336464881897,
                "y": 0.0017425566911697388,
                "z": -139.28851318359375
            },
            {
                "x": 0.1880142241716385,
                "y": 0.0017345009837299585,
                "z": -139.13096618652344
            },
            {
                "x": 0.18829943239688873,
                "y": 0.0017297696322202682,
                "z": -139.02926635742188
            },
            {
                "x": 0.18852899968624115,
                "y": 0.0017220359295606613,
                "z": -138.87181091308594
            },
            {
                "x": 0.18854738771915436,
                "y": 0.0017142854630947113,
                "z": -138.71435546875
            },
            {
                "x": 0.18850919604301453,
                "y": 0.0017065387219190598,
                "z": -138.55694580078125
            },
            {
                "x": 0.18838170170783997,
                "y": 0.001698790118098259,
                "z": -138.399658203125
            },
            {
                "x": 0.18821808695793152,
                "y": 0.001691039651632309,
                "z": -138.2423095703125
            },
            {
                "x": 0.18804670870304108,
                "y": 0.0016832947731018066,
                "z": -138.08505249023438
            },
            {
                "x": 0.18785841763019562,
                "y": 0.0016755461692810059,
                "z": -137.9278106689453
            },
            {
                "x": 0.18766744434833527,
                "y": 0.0016677938401699066,
                "z": -137.7703857421875
            },
            {
                "x": 0.18747365474700928,
                "y": 0.0016600415110588074,
                "z": -137.61314392089844
            },
            {
                "x": 0.187276691198349,
                "y": 0.0016522984951734543,
                "z": -137.45584106445312
            },
            {
                "x": 0.18707844614982605,
                "y": 0.0016445554792881012,
                "z": -137.2985382080078
            },
            {
                "x": 0.18687783181667328,
                "y": 0.0016368068754673004,
                "z": -137.1413116455078
            },
            {
                "x": 0.18667513132095337,
                "y": 0.0016290508210659027,
                "z": -136.98387145996094
            },
            {
                "x": 0.18647103011608124,
                "y": 0.0016213059425354004,
                "z": -136.82664489746094
            },
            {
                "x": 0.18626463413238525,
                "y": 0.001613561064004898,
                "z": -136.66941833496094
            },
            {
                "x": 0.18605658411979675,
                "y": 0.001605810597538948,
                "z": -136.51206970214844
            },
            {
                "x": 0.1858464926481247,
                "y": 0.0015980638563632965,
                "z": -136.35484313964844
            },
            {
                "x": 0.18563435971736908,
                "y": 0.001590317115187645,
                "z": -136.19749450683594
            },
            {
                "x": 0.18542058765888214,
                "y": 0.0015825703740119934,
                "z": -136.04017639160156
            },
            {
                "x": 0.18520450592041016,
                "y": 0.0015748236328363419,
                "z": -135.88294982910156
            },
            {
                "x": 0.18498699367046356,
                "y": 0.0015670787543058395,
                "z": -135.72572326660156
            },
            {
                "x": 0.18476730585098267,
                "y": 0.0015593264251947403,
                "z": -135.56846618652344
            },
            {
                "x": 0.18454565107822418,
                "y": 0.0015515834093093872,
                "z": -135.41123962402344
            },
            {
                "x": 0.1843220442533493,
                "y": 0.001543831080198288,
                "z": -135.25381469726562
            },
            {
                "x": 0.1840963363647461,
                "y": 0.0015360862016677856,
                "z": -135.09658813476562
            },
            {
                "x": 0.18386906385421753,
                "y": 0.0015283375978469849,
                "z": -134.93930053710938
            },
            {
                "x": 0.18363957107067108,
                "y": 0.0015205927193164825,
                "z": -134.78201293945312
            },
            {
                "x": 0.18340817093849182,
                "y": 0.0015128478407859802,
                "z": -134.62478637695312
            },
            {
                "x": 0.18317477405071259,
                "y": 0.001505088061094284,
                "z": -134.4673309326172
            },
            {
                "x": 0.182939350605011,
                "y": 0.0014973506331443787,
                "z": -134.31011962890625
            },
            {
                "x": 0.18270237743854523,
                "y": 0.0014895983040332794,
                "z": -134.1528778076172
            },
            {
                "x": 0.1824629157781601,
                "y": 0.0014818478375673294,
                "z": -133.9955291748047
            },
            {
                "x": 0.18222177028656006,
                "y": 0.001474102959036827,
                "z": -133.8383026123047
            },
            {
                "x": 0.18197861313819885,
                "y": 0.0014663506299257278,
                "z": -133.6809539794922
            },
            {
                "x": 0.18173328042030334,
                "y": 0.0014586057513952255,
                "z": -133.5236358642578
            },
            {
                "x": 0.18148642778396606,
                "y": 0.0014508571475744247,
                "z": -133.36639404296875
            },
            {
                "x": 0.1812370866537094,
                "y": 0.0014431104063987732,
                "z": -133.2090606689453
            },
            {
                "x": 0.1809861958026886,
                "y": 0.0014353636652231216,
                "z": -133.0518341064453
            },
            {
                "x": 0.18073317408561707,
                "y": 0.0014276187866926193,
                "z": -132.89459228515625
            },
            {
                "x": 0.1804778277873993,
                "y": 0.0014285824727267027,
                "z": -132.73716735839844
            },
            {
                "x": 0.18022094666957855,
                "y": 0.0016696654492989182,
                "z": -132.57994079589844
            },
            {
                "x": 0.17996180057525635,
                "y": 0.002300432650372386,
                "z": -132.42271423339844
            },
            {
                "x": 0.17979265749454498,
                "y": 0.0029104596469551325,
                "z": -132.32115173339844
            },
            {
                "x": 0.1795303225517273,
                "y": 0.004177119582891464,
                "z": -132.16390991210938
            },
            {
                "x": 0.1792658418416977,
                "y": 0.005811470560729504,
                "z": -132.00657653808594
            },
            {
                "x": 0.17899958789348602,
                "y": 0.007804157678037882,
                "z": -131.84925842285156
            },
            {
                "x": 0.17873111367225647,
                "y": 0.01015386264771223,
                "z": -131.69203186035156
            },
            {
                "x": 0.17846086621284485,
                "y": 0.012853667140007019,
                "z": -131.53472900390625
            },
            {
                "x": 0.17818839848041534,
                "y": 0.015883348882198334,
                "z": -131.37753295898438
            },
            {
                "x": 0.17791423201560974,
                "y": 0.019236436113715172,
                "z": -131.2203369140625
            },
            {
                "x": 0.17763753235340118,
                "y": 0.022915560752153397,
                "z": -131.0629425048828
            },
            {
                "x": 0.17735913395881653,
                "y": 0.02690333127975464,
                "z": -130.90579223632812
            },
            {
                "x": 0.1770787388086319,
                "y": 0.031189147382974625,
                "z": -130.74856567382812
            },
            {
                "x": 0.17679612338542938,
                "y": 0.035763755440711975,
                "z": -130.59132385253906
            },
            {
                "x": 0.1765119433403015,
                "y": 0.04062126204371452,
                "z": -130.4341583251953
            },
            {
                "x": 0.17622488737106323,
                "y": 0.045763786882162094,
                "z": -130.2768096923828
            },
            {
                "x": 0.17593657970428467,
                "y": 0.0511612705886364,
                "z": -130.1196746826172
            },
            {
                "x": 0.1756458729505539,
                "y": 0.056811507791280746,
                "z": -129.96255493164062
            },
            {
                "x": 0.1753532588481903,
                "y": 0.06271447986364365,
                "z": -129.80532836914062
            },
            {
                "x": 0.17505860328674316,
                "y": 0.06885668635368347,
                "z": -129.648193359375
            },
            {
                "x": 0.1747617870569229,
                "y": 0.07522836327552795,
                "z": -129.4910125732422
            },
            {
                "x": 0.17446297407150269,
                "y": 0.0818193107843399,
                "z": -129.33383178710938
            },
            {
                "x": 0.17416216433048248,
                "y": 0.08861899375915527,
                "z": -129.1767120361328
            },
            {
                "x": 0.17385952174663544,
                "y": 0.09562519192695618,
                "z": -129.0196533203125
            },
            {
                "x": 0.17355450987815857,
                "y": 0.10282275080680847,
                "z": -128.8625946044922
            },
            {
                "x": 0.17324776947498322,
                "y": 0.11020456254482269,
                "z": -128.7055206298828
            },
            {
                "x": 0.1729383021593094,
                "y": 0.11777180433273315,
                "z": -128.54827880859375
            },
            {
                "x": 0.17262738943099976,
                "y": 0.12550130486488342,
                "z": -128.3912353515625
            },
            {
                "x": 0.1723140925168991,
                "y": 0.1333903670310974,
                "z": -128.23416137695312
            },
            {
                "x": 0.1719990372657776,
                "y": 0.14142823219299316,
                "z": -128.0770721435547
            },
            {
                "x": 0.17168165743350983,
                "y": 0.149603009223938,
                "z": -127.92007446289062
            },
            {
                "x": 0.17136207222938538,
                "y": 0.1579260677099228,
                "z": -127.76285552978516
            },
            {
                "x": 0.17104056477546692,
                "y": 0.16636046767234802,
                "z": -127.60584259033203
            },
            {
                "x": 0.1707172393798828,
                "y": 0.17490866780281067,
                "z": -127.44883728027344
            },
            {
                "x": 0.17039155960083008,
                "y": 0.18356826901435852,
                "z": -127.29173278808594
            },
            {
                "x": 0.17006392776966095,
                "y": 0.19232133030891418,
                "z": -127.134765625
            },
            {
                "x": 0.16973404586315155,
                "y": 0.20116811990737915,
                "z": -126.9776840209961
            },
            {
                "x": 0.16940206289291382,
                "y": 0.21009418368339539,
                "z": -126.82061004638672
            },
            {
                "x": 0.16906827688217163,
                "y": 0.21908482909202576,
                "z": -126.66364288330078
            },
            {
                "x": 0.16873213648796082,
                "y": 0.2281462550163269,
                "z": -126.50654602050781
            },
            {
                "x": 0.1683940440416336,
                "y": 0.23725566267967224,
                "z": -126.34955596923828
            },
            {
                "x": 0.16805383563041687,
                "y": 0.24640876054763794,
                "z": -126.19259643554688
            },
            {
                "x": 0.1677113026380539,
                "y": 0.25560832023620605,
                "z": -126.03543853759766
            },
            {
                "x": 0.1673668771982193,
                "y": 0.26482540369033813,
                "z": -125.87846374511719
            },
            {
                "x": 0.16702048480510712,
                "y": 0.2740596532821655,
                "z": -125.72151947021484
            },
            {
                "x": 0.1667945384979248,
                "y": 0.2800305485725403,
                "z": -125.62013244628906
            },
            {
                "x": 0.1664448231458664,
                "y": 0.2892772853374481,
                "z": -125.46316528320312
            },
            {
                "x": 0.16609244048595428,
                "y": 0.2985251545906067,
                "z": -125.30610656738281
            },
            {
                "x": 0.16573823988437653,
                "y": 0.3077593147754669,
                "z": -125.14905548095703
            },
            {
                "x": 0.16538189351558685,
                "y": 0.31696629524230957,
                "z": -124.99209594726562
            },
            {
                "x": 0.16502352058887482,
                "y": 0.3261490762233734,
                "z": -124.83501434326172
            },
            {
                "x": 0.16466288268566132,
                "y": 0.3352839946746826,
                "z": -124.67807006835938
            },
            {
                "x": 0.16430038213729858,
                "y": 0.3443725109100342,
                "z": -124.5210952758789
            },
            {
                "x": 0.16393513977527618,
                "y": 0.3534163236618042,
                "z": -124.36389923095703
            },
            {
                "x": 0.16356851160526276,
                "y": 0.36238178610801697,
                "z": -124.20693969726562
            },
            {
                "x": 0.1631993055343628,
                "y": 0.3712751269340515,
                "z": -124.04989624023438
            },
            {
                "x": 0.1628282368183136,
                "y": 0.380085825920105,
                "z": -123.8928451538086
            },
            {
                "x": 0.1624549925327301,
                "y": 0.388802170753479,
                "z": -123.7358627319336
            },
            {
                "x": 0.162079319357872,
                "y": 0.3974289894104004,
                "z": -123.57865905761719
            },
            {
                "x": 0.16170182824134827,
                "y": 0.4059327244758606,
                "z": -123.42164611816406
            },
            {
                "x": 0.1613222360610962,
                "y": 0.41431868076324463,
                "z": -123.2646484375
            },
            {
                "x": 0.16094036400318146,
                "y": 0.42258530855178833,
                "z": -123.1075210571289
            },
            {
                "x": 0.16055651009082794,
                "y": 0.4307110905647278,
                "z": -122.95049285888672
            },
            {
                "x": 0.16017040610313416,
                "y": 0.4386921525001526,
                "z": -122.79337310791016
            },
            {
                "x": 0.15978197753429413,
                "y": 0.4465218782424927,
                "z": -122.63623046875
            },
            {
                "x": 0.15939189493656158,
                "y": 0.45418623089790344,
                "z": -122.47917938232422
            },
            {
                "x": 0.15899956226348877,
                "y": 0.4616805911064148,
                "z": -122.32213592529297
            },
            {
                "x": 0.15860514342784882,
                "y": 0.46898990869522095,
                "z": -122.16507720947266
            },
            {
                "x": 0.1582084745168686,
                "y": 0.47611287236213684,
                "z": -122.00798797607422
            },
            {
                "x": 0.15780937671661377,
                "y": 0.48304831981658936,
                "z": -121.85071563720703
            },
            {
                "x": 0.15740856528282166,
                "y": 0.4897714853286743,
                "z": -121.69363403320312
            },
            {
                "x": 0.15700550377368927,
                "y": 0.49627405405044556,
                "z": -121.53648376464844
            },
            {
                "x": 0.15660032629966736,
                "y": 0.502554714679718,
                "z": -121.37932586669922
            },
            {
                "x": 0.15619313716888428,
                "y": 0.5086030960083008,
                "z": -121.22219848632812
            },
            {
                "x": 0.1557835340499878,
                "y": 0.5144201517105103,
                "z": -121.06488037109375
            },
            {
                "x": 0.1553720235824585,
                "y": 0.5199713706970215,
                "z": -120.90774536132812
            },
            {
                "x": 0.15495853126049042,
                "y": 0.5252648591995239,
                "z": -120.7505874633789
            },
            {
                "x": 0.1545427143573761,
                "y": 0.5302967429161072,
                "z": -120.59333038330078
            },
            {
                "x": 0.15412497520446777,
                "y": 0.5350515246391296,
                "z": -120.43616485595703
            },
            {
                "x": 0.15370506048202515,
                "y": 0.5395143628120422,
                "z": -120.2789077758789
            },
            {
                "x": 0.15328282117843628,
                "y": 0.543683648109436,
                "z": -120.1216049194336
            },
            {
                "x": 0.1528589427471161,
                "y": 0.5475499033927917,
                "z": -119.96442413330078
            },
            {
                "x": 0.15243272483348846,
                "y": 0.5511099100112915,
                "z": -119.80713653564453
            },
            {
                "x": 0.15200455486774445,
                "y": 0.554337739944458,
                "z": -119.6499252319336
            },
            {
                "x": 0.1515744924545288,
                "y": 0.5572354793548584,
                "z": -119.49272155761719
            },
            {
                "x": 0.15114186704158783,
                "y": 0.5598011016845703,
                "z": -119.33531951904297
            },
            {
                "x": 0.15070772171020508,
                "y": 0.5620196461677551,
                "z": -119.17809295654297
            },
            {
                "x": 0.15028972923755646,
                "y": 0.563873827457428,
                "z": -119.0208740234375
            },
            {
                "x": 0.1499876230955124,
                "y": 0.5648750066757202,
                "z": -118.91929626464844
            },
            {
                "x": 0.14954817295074463,
                "y": 0.5661296248435974,
                "z": -118.76206970214844
            },
            {
                "x": 0.14910627901554108,
                "y": 0.5669993162155151,
                "z": -118.604736328125
            },
            {
                "x": 0.14866262674331665,
                "y": 0.567474901676178,
                "z": -118.4474105834961
            },
            {
                "x": 0.1482171267271042,
                "y": 0.5675568580627441,
                "z": -118.29017639160156
            },
            {
                "x": 0.14776942133903503,
                "y": 0.5672427415847778,
                "z": -118.13284301757812
            },
            {
                "x": 0.14732018113136292,
                "y": 0.5665314197540283,
                "z": -117.97560119628906
            },
            {
                "x": 0.14686886966228485,
                "y": 0.5654304027557373,
                "z": -117.818359375
            },
            {
                "x": 0.1464151293039322,
                "y": 0.563956618309021,
                "z": -117.66092681884766
            },
            {
                "x": 0.14596019685268402,
                "y": 0.5621224641799927,
                "z": -117.50371551513672
            },
            {
                "x": 0.1455031782388687,
                "y": 0.5599266290664673,
                "z": -117.34644317626953
            },
            {
                "x": 0.1450442522764206,
                "y": 0.5573759078979492,
                "z": -117.18917083740234
            },
            {
                "x": 0.1445837765932083,
                "y": 0.5544903874397278,
                "z": -117.0319595336914
            },
            {
                "x": 0.1441209465265274,
                "y": 0.5512737035751343,
                "z": -116.87456512451172
            },
            {
                "x": 0.14365680515766144,
                "y": 0.5477360486984253,
                "z": -116.71736907958984
            },
            {
                "x": 0.14319102466106415,
                "y": 0.5438797473907471,
                "z": -116.56018829345703
            },
            {
                "x": 0.14272326231002808,
                "y": 0.5397196412086487,
                "z": -116.40290069580078
            },
            {
                "x": 0.1422540545463562,
                "y": 0.535270094871521,
                "z": -116.24571990966797
            },
            {
                "x": 0.14178292453289032,
                "y": 0.5305293798446655,
                "z": -116.08846282958984
            },
            {
                "x": 0.14131025969982147,
                "y": 0.5255051851272583,
                "z": -115.93122100830078
            },
            {
                "x": 0.1408362239599228,
                "y": 0.520217776298523,
                "z": -115.77405548095703
            },
            {
                "x": 0.14036071300506592,
                "y": 0.5146738290786743,
                "z": -115.61692810058594
            },
            {
                "x": 0.13988371193408966,
                "y": 0.5088778138160706,
                "z": -115.45980834960938
            },
            {
                "x": 0.1394052505493164,
                "y": 0.5028339624404907,
                "z": -115.30268859863281
            },
            {
                "x": 0.13892486691474915,
                "y": 0.49655115604400635,
                "z": -115.14539337158203
            },
            {
                "x": 0.13844360411167145,
                "y": 0.4900539517402649,
                "z": -114.98829650878906
            },
            {
                "x": 0.13796097040176392,
                "y": 0.4833388924598694,
                "z": -114.83114624023438
            },
            {
                "x": 0.1374770849943161,
                "y": 0.47641101479530334,
                "z": -114.67402648925781
            },
            {
                "x": 0.13699212670326233,
                "y": 0.4692891836166382,
                "z": -114.51695251464844
            },
            {
                "x": 0.13650549948215485,
                "y": 0.4619709849357605,
                "z": -114.35968017578125
            },
            {
                "x": 0.13601845502853394,
                "y": 0.45448246598243713,
                "z": -114.20262908935547
            },
            {
                "x": 0.13553039729595184,
                "y": 0.44681647419929504,
                "z": -114.04558563232422
            },
            {
                "x": 0.13504108786582947,
                "y": 0.4389835000038147,
                "z": -113.888427734375
            },
            {
                "x": 0.13455134630203247,
                "y": 0.4310041666030884,
                "z": -113.73139953613281
            },
            {
                "x": 0.13406065106391907,
                "y": 0.4228752851486206,
                "z": -113.57427215576172
            },
            {
                "x": 0.13356925547122955,
                "y": 0.4146050810813904,
                "z": -113.41716766357422
            },
            {
                "x": 0.13307766616344452,
                "y": 0.40621358156204224,
                "z": -113.26016998291016
            },
            {
                "x": 0.13258542120456696,
                "y": 0.39769840240478516,
                "z": -113.10305786132812
            },
            {
                "x": 0.13209319114685059,
                "y": 0.38908010721206665,
                "z": -112.9460678100586
            },
            {
                "x": 0.13160081207752228,
                "y": 0.38035571575164795,
                "z": -112.78907012939453
            },
            {
                "x": 0.1311078816652298,
                "y": 0.3715291917324066,
                "z": -112.63188171386719
            },
            {
                "x": 0.1306157261133194,
                "y": 0.3626307547092438,
                "z": -112.47489929199219
            },
            {
                "x": 0.13015508651733398,
                "y": 0.3536592125892639,
                "z": -112.31793212890625
            },
            {
                "x": 0.12980547547340393,
                "y": 0.34782373905181885,
                "z": -112.21654510498047
            },
            {
                "x": 0.1293146014213562,
                "y": 0.3387441635131836,
                "z": -112.0595703125
            },
            {
                "x": 0.12882433831691742,
                "y": 0.32960742712020874,
                "z": -111.90249633789062
            },
            {
                "x": 0.12833517789840698,
                "y": 0.32042741775512695,
                "z": -111.74544525146484
            },
            {
                "x": 0.12784774601459503,
                "y": 0.311217725276947,
                "z": -111.58848571777344
            },
            {
                "x": 0.12736156582832336,
                "y": 0.30197569727897644,
                "z": -111.43141174316406
            },
            {
                "x": 0.12687771022319794,
                "y": 0.2927241623401642,
                "z": -111.27447509765625
            },
            {
                "x": 0.12639616429805756,
                "y": 0.28346312046051025,
                "z": -111.11752319335938
            },
            {
                "x": 0.12591677904129028,
                "y": 0.27419066429138184,
                "z": -110.9603500366211
            },
            {
                "x": 0.12544101476669312,
                "y": 0.264940083026886,
                "z": -110.80341339111328
            },
            {
                "x": 0.12496869266033173,
                "y": 0.25570279359817505,
                "z": -110.64640045166016
            },
            {
                "x": 0.124500572681427,
                "y": 0.24649249017238617,
                "z": -110.48941040039062
            },
            {
                "x": 0.12403738498687744,
                "y": 0.23732148110866547,
                "z": -110.33245086669922
            },
            {
                "x": 0.12357909977436066,
                "y": 0.22818216681480408,
                "z": -110.17527770996094
            },
            {
                "x": 0.12312737852334976,
                "y": 0.21910595893859863,
                "z": -110.01829528808594
            },
            {
                "x": 0.12268275022506714,
                "y": 0.21009276807308197,
                "z": -109.8613510131836
            },
            {
                "x": 0.12224624305963516,
                "y": 0.2011449635028839,
                "z": -109.70426940917969
            },
            {
                "x": 0.12181909382343292,
                "y": 0.19228139519691467,
                "z": -109.54730224609375
            },
            {
                "x": 0.12140220403671265,
                "y": 0.1834995150566101,
                "z": -109.39022827148438
            },
            {
                "x": 0.12099757045507431,
                "y": 0.17481324076652527,
                "z": -109.2331314086914
            },
            {
                "x": 0.12060759961605072,
                "y": 0.16624167561531067,
                "z": -109.0761489868164
            },
            {
                "x": 0.1202339455485344,
                "y": 0.15778300166130066,
                "z": -108.9191665649414
            },
            {
                "x": 0.11987918615341187,
                "y": 0.14944542944431305,
                "z": -108.76216888427734
            },
            {
                "x": 0.11954673379659653,
                "y": 0.14123840630054474,
                "z": -108.60517120361328
            },
            {
                "x": 0.11924157291650772,
                "y": 0.13316702842712402,
                "z": -108.44796752929688
            },
            {
                "x": 0.11896870285272598,
                "y": 0.1252533197402954,
                "z": -108.29096221923828
            },
            {
                "x": 0.11872310191392899,
                "y": 0.11749140918254852,
                "z": -108.13385772705078
            },
            {
                "x": 0.1183081567287445,
                "y": 0.10987693071365356,
                "z": -107.97638702392578
            },
            {
                "x": 0.11697658151388168,
                "y": 0.1024237871170044,
                "z": -107.8184585571289
            },
            {
                "x": 0.11443286389112473,
                "y": 0.09514440596103668,
                "z": -107.6603012084961
            },
            {
                "x": 0.11072304844856262,
                "y": 0.0880688726902008,
                "z": -107.50241088867188
            },
            {
                "x": 0.10591746121644974,
                "y": 0.08119753003120422,
                "z": -107.34458923339844
            },
            {
                "x": 0.10003674030303955,
                "y": 0.07454326748847961,
                "z": -107.18672943115234
            },
            {
                "x": 0.0931939035654068,
                "y": 0.06811653077602386,
                "z": -107.02906036376953
            },
            {
                "x": 0.08544734865427017,
                "y": 0.06191639229655266,
                "z": -106.87139892578125
            },
            {
                "x": 0.07686971873044968,
                "y": 0.05595385283231735,
                "z": -106.71379089355469
            },
            {
                "x": 0.0675080269575119,
                "y": 0.050252024084329605,
                "z": -106.55638885498047
            },
            {
                "x": 0.05743228644132614,
                "y": 0.044804155826568604,
                "z": -106.39895629882812
            },
            {
                "x": 0.046718716621398926,
                "y": 0.0396229550242424,
                "z": -106.24171447753906
            },
            {
                "x": 0.03543013334274292,
                "y": 0.03471348434686661,
                "z": -106.08454132080078
            },
            {
                "x": 0.02357664704322815,
                "y": 0.030088260769844055,
                "z": -105.92724609375
            },
            {
                "x": 0.011260636150836945,
                "y": 0.02576078660786152,
                "z": -105.77022552490234
            },
            {
                "x": -0.0014702752232551575,
                "y": 0.021729985252022743,
                "z": -105.6132583618164
            },
            {
                "x": -0.009896345436573029,
                "y": 0.019286826252937317,
                "z": -105.51189422607422
            },
            {
                "x": -0.02322656661272049,
                "y": 0.015772607177495956,
                "z": -105.35501861572266
            },
            {
                "x": -0.03686363995075226,
                "y": 0.012574970722198486,
                "z": -105.1980972290039
            },
            {
                "x": -0.050753019750118256,
                "y": 0.009704861789941788,
                "z": -105.0412368774414
            },
            {
                "x": -0.06485581398010254,
                "y": 0.007179571781307459,
                "z": -104.8844985961914
            },
            {
                "x": -0.07915130257606506,
                "y": 0.005005856044590473,
                "z": -104.72771453857422
            },
            {
                "x": -0.09358096122741699,
                "y": 0.0031861402094364166,
                "z": -104.57106018066406
            },
            {
                "x": -0.10812049359083176,
                "y": 0.0017271600663661957,
                "z": -104.41443634033203
            },
            {
                "x": -0.12276351451873779,
                "y": 0.0006441092118620872,
                "z": -104.25762939453125
            },
            {
                "x": -0.13743926584720612,
                "y": -4.865112714469433e-05,
                "z": -104.10105895996094
            },
            {
                "x": -0.1521504521369934,
                "y": -0.0003547957167029381,
                "z": -103.94444274902344
            },
            {
                "x": -0.16686409711837769,
                "y": -0.00038415007293224335,
                "z": -103.78784942626953
            },
            {
                "x": -0.18155185878276825,
                "y": -0.00039130449295043945,
                "z": -103.6313247680664
            },
            {
                "x": -0.19621491432189941,
                "y": -0.00039848312735557556,
                "z": -103.474609375
            },
            {
                "x": -0.21079999208450317,
                "y": -0.0004056394100189209,
                "z": -103.31812286376953
            },
            {
                "x": -0.22530734539031982,
                "y": -0.0004128068685531616,
                "z": -103.16161346435547
            },
            {
                "x": -0.23973099887371063,
                "y": -0.00041996873915195465,
                "z": -103.00501251220703
            },
            {
                "x": -0.2540343701839447,
                "y": -0.0004271306097507477,
                "z": -102.84851837158203
            },
            {
                "x": -0.26822173595428467,
                "y": -0.00043430738151073456,
                "z": -102.6919174194336
            },
            {
                "x": -0.2822732925415039,
                "y": -0.00044146180152893066,
                "z": -102.53531646728516
            },
            {
                "x": -0.2961691915988922,
                "y": -0.00044862739741802216,
                "z": -102.3788070678711
            },
            {
                "x": -0.309903085231781,
                "y": -0.0004557855427265167,
                "z": -102.22230529785156
            },
            {
                "x": -0.323471337556839,
                "y": -0.00046296045184135437,
                "z": -102.06578063964844
            },
            {
                "x": -0.336865097284317,
                "y": -0.000470111146569252,
                "z": -101.90924835205078
            },
            {
                "x": -0.35009217262268066,
                "y": -0.0004772748798131943,
                "z": -101.75251007080078
            },
            {
                "x": -0.3631032705307007,
                "y": -0.00048444606363773346,
                "z": -101.59596252441406
            },
            {
                "x": -0.37592437863349915,
                "y": -0.0004916135221719742,
                "z": -101.4393310546875
            },
            {
                "x": -0.3885444402694702,
                "y": -0.0004987698048353195,
                "z": -101.28271484375
            },
            {
                "x": -0.4009496867656708,
                "y": -0.0005059316754341125,
                "z": -101.12612915039062
            },
            {
                "x": -0.4131503701210022,
                "y": -0.0005131009966135025,
                "z": -100.96932220458984
            },
            {
                "x": -0.4251178801059723,
                "y": -0.0005202610045671463,
                "z": -100.81270599365234
            },
            {
                "x": -0.4368687868118286,
                "y": -0.0005274303257465363,
                "z": -100.65607452392578
            },
            {
                "x": -0.44840216636657715,
                "y": -0.0005345884710550308,
                "z": -100.49930572509766
            },
            {
                "x": -0.45969289541244507,
                "y": -0.0005417559295892715,
                "z": -100.3426513671875
            },
            {
                "x": -0.47076332569122314,
                "y": -0.0005489196628332138,
                "z": -100.18586730957031
            },
            {
                "x": -0.4816054701805115,
                "y": -0.0005560871213674545,
                "z": -100.02906799316406
            },
            {
                "x": -0.49220776557922363,
                "y": -0.0005632508546113968,
                "z": -99.87236785888672
            },
            {
                "x": -0.5025705099105835,
                "y": -0.000570414587855339,
                "z": -99.71553802490234
            },
            {
                "x": -0.5126948356628418,
                "y": -0.0005775820463895798,
                "z": -99.55880737304688
            },
            {
                "x": -0.5225839018821716,
                "y": -0.0005847383290529251,
                "z": -99.40203857421875
            },
            {
                "x": -0.5322487354278564,
                "y": -0.000591915100812912,
                "z": -99.24507904052734
            },
            {
                "x": -0.5416565537452698,
                "y": -0.0005990695208311081,
                "z": -99.08829498291016
            },
            {
                "x": -0.55082768201828,
                "y": -0.0006062276661396027,
                "z": -98.93150329589844
            },
            {
                "x": -0.5566302537918091,
                "y": -0.0006108935922384262,
                "z": -98.83023071289062
            },
            {
                "x": -0.5654069781303406,
                "y": -0.0006180666387081146,
                "z": -98.67340850830078
            },
            {
                "x": -0.5739529132843018,
                "y": -0.0006252191960811615,
                "z": -98.51647186279297
            },
            {
                "x": -0.5822617411613464,
                "y": -0.0006323885172605515,
                "z": -98.35952758789062
            },
            {
                "x": -0.5903292894363403,
                "y": -0.0006395522505044937,
                "z": -98.20267486572266
            },
            {
                "x": -0.598159670829773,
                "y": -0.0006467215716838837,
                "z": -98.04568481445312
            },
            {
                "x": -0.6057480573654175,
                "y": -0.0006384872831404209,
                "z": -97.88880157470703
            },
            {
                "x": -0.6131052374839783,
                "y": -0.0004990589804947376,
                "z": -97.73190307617188
            },
            {
                "x": -0.620240330696106,
                "y": -0.0001928509445860982,
                "z": -97.57478332519531
            },
            {
                "x": -0.6271241903305054,
                "y": 0.00028241355903446674,
                "z": -97.4178695678711
            },
            {
                "x": -0.6337794065475464,
                "y": 0.0009190336568281054,
                "z": -97.26087951660156
            },
            {
                "x": -0.6402073502540588,
                "y": 0.0017120287520810962,
                "z": -97.1038818359375
            },
            {
                "x": -0.6464049816131592,
                "y": 0.0026575776282697916,
                "z": -96.94692993164062
            },
            {
                "x": -0.6523739695549011,
                "y": 0.003759758546948433,
                "z": -96.78977966308594
            },
            {
                "x": -0.6581099629402161,
                "y": 0.005008508451282978,
                "z": -96.6328125
            },
            {
                "x": -0.6636225581169128,
                "y": 0.006399902515113354,
                "z": -96.47584533691406
            },
            {
                "x": -0.6689146161079407,
                "y": 0.007931992411613464,
                "z": -96.3187484741211
            },
            {
                "x": -0.6739768385887146,
                "y": 0.009603933431208134,
                "z": -96.16175842285156
            },
            {
                "x": -0.6788215041160583,
                "y": 0.011411478742957115,
                "z": -96.0046615600586
            },
            {
                "x": -0.6834475994110107,
                "y": 0.013348679058253765,
                "z": -95.8475570678711
            },
            {
                "x": -0.6878560185432434,
                "y": 0.015410617925226688,
                "z": -95.69053649902344
            },
            {
                "x": -0.6920439004898071,
                "y": 0.017599113285541534,
                "z": -95.53353118896484
            },
            {
                "x": -0.6960137486457825,
                "y": 0.019908776506781578,
                "z": -95.37651824951172
            },
            {
                "x": -0.6997728943824768,
                "y": 0.022334400564432144,
                "z": -95.21947479248047
            },
            {
                "x": -0.703326940536499,
                "y": 0.024875730276107788,
                "z": -95.0622329711914
            },
            {
                "x": -0.7066603302955627,
                "y": 0.027526434510946274,
                "z": -94.90521240234375
            },
            {
                "x": -0.7097870707511902,
                "y": 0.030285704880952835,
                "z": -94.74810791015625
            },
            {
                "x": -0.7127091288566589,
                "y": 0.033147186040878296,
                "z": -94.59102630615234
            },
            {
                "x": -0.7154281139373779,
                "y": 0.03610677272081375,
                "z": -94.4339828491211
            },
            {
                "x": -0.7179449200630188,
                "y": 0.03916860744357109,
                "z": -94.2767333984375
            },
            {
                "x": -0.7202510833740234,
                "y": 0.04232058674097061,
                "z": -94.11969757080078
            },
            {
                "x": -0.7223602533340454,
                "y": 0.04556143283843994,
                "z": -93.96263122558594
            },
            {
                "x": -0.7242728471755981,
                "y": 0.04889019578695297,
                "z": -93.80546569824219
            },
            {
                "x": -0.7259860634803772,
                "y": 0.052300628274679184,
                "z": -93.64842987060547
            },
            {
                "x": -0.7275055050849915,
                "y": 0.055793654173612595,
                "z": -93.49128723144531
            },
            {
                "x": -0.7288321852684021,
                "y": 0.05936218053102493,
                "z": -93.3341293334961
            },
            {
                "x": -0.729968249797821,
                "y": 0.06300044059753418,
                "z": -93.17707061767578
            },
            {
                "x": -0.7309073805809021,
                "y": 0.06671114265918732,
                "z": -93.01990509033203
            },
            {
                "x": -0.7316558361053467,
                "y": 0.0704861581325531,
                "z": -92.86286163330078
            },
            {
                "x": -0.7322091460227966,
                "y": 0.07432258874177933,
                "z": -92.70581817626953
            },
            {
                "x": -0.732540488243103,
                "y": 0.07822159677743912,
                "z": -92.5486068725586
            },
            {
                "x": -0.7325635552406311,
                "y": 0.08217106759548187,
                "z": -92.39163970947266
            },
            {
                "x": -0.732193112373352,
                "y": 0.08617191016674042,
                "z": -92.23474884033203
            },
            {
                "x": -0.7317264080047607,
                "y": 0.08878153562545776,
                "z": -92.13343048095703
            },
            {
                "x": -0.7305785417556763,
                "y": 0.09286034107208252,
                "z": -91.97657775878906
            },
            {
                "x": -0.7288836240768433,
                "y": 0.09698639810085297,
                "z": -91.81964874267578
            },
            {
                "x": -0.7266731858253479,
                "y": 0.10115231573581696,
                "z": -91.6627426147461
            },
            {
                "x": -0.7239395380020142,
                "y": 0.10535255074501038,
                "z": -91.50593566894531
            },
            {
                "x": -0.72067791223526,
                "y": 0.10958967357873917,
                "z": -91.34902954101562
            },
            {
                "x": -0.7168495655059814,
                "y": 0.11385533213615417,
                "z": -91.1922378540039
            },
            {
                "x": -0.7124879956245422,
                "y": 0.11814752966165543,
                "z": -91.03546905517578
            },
            {
                "x": -0.7075839638710022,
                "y": 0.12246845662593842,
                "z": -90.87852478027344
            },
            {
                "x": -0.7021510601043701,
                "y": 0.12680357694625854,
                "z": -90.72181701660156
            },
            {
                "x": -0.6961590051651001,
                "y": 0.13115817308425903,
                "z": -90.56504821777344
            },
            {
                "x": -0.6896181702613831,
                "y": 0.13552603125572205,
                "z": -90.4083023071289
            },
            {
                "x": -0.6825388073921204,
                "y": 0.13990195095539093,
                "z": -90.25163269042969
            },
            {
                "x": -0.674898624420166,
                "y": 0.14429022371768951,
                "z": -90.09479522705078
            },
            {
                "x": -0.6667028665542603,
                "y": 0.148675799369812,
                "z": -89.93818664550781
            },
            {
                "x": -0.657968282699585,
                "y": 0.15306073427200317,
                "z": -89.78162384033203
            },
            {
                "x": -0.6486799716949463,
                "y": 0.15744543075561523,
                "z": -89.62496948242188
            },
            {
                "x": -0.6388605833053589,
                "y": 0.16181989014148712,
                "z": -89.46844482421875
            },
            {
                "x": -0.6284552812576294,
                "y": 0.16618603467941284,
                "z": -89.31188201904297
            },
            {
                "x": -0.617504358291626,
                "y": 0.17053815722465515,
                "z": -89.15534210205078
            },
            {
                "x": -0.6060183644294739,
                "y": 0.17487028241157532,
                "z": -88.9989242553711
            },
            {
                "x": -0.5939863324165344,
                "y": 0.17918145656585693,
                "z": -88.84256744384766
            },
            {
                "x": -0.5813942551612854,
                "y": 0.18346759676933289,
                "z": -88.68624114990234
            },
            {
                "x": -0.5682647228240967,
                "y": 0.1877259612083435,
                "z": -88.52995300292969
            },
            {
                "x": -0.5545762777328491,
                "y": 0.19195836782455444,
                "z": -88.37351989746094
            },
            {
                "x": -0.5403732061386108,
                "y": 0.19615131616592407,
                "z": -88.21732330322266
            },
            {
                "x": -0.5256097912788391,
                "y": 0.20030632615089417,
                "z": -88.06111145019531
            },
            {
                "x": -0.5103131532669067,
                "y": 0.20441934466362,
                "z": -87.90496826171875
            },
            {
                "x": -0.49449849128723145,
                "y": 0.20848631858825684,
                "z": -87.7489013671875
            },
            {
                "x": -0.4781421422958374,
                "y": 0.21251022815704346,
                "z": -87.59270477294922
            },
            {
                "x": -0.4612637162208557,
                "y": 0.21647508442401886,
                "z": -87.436767578125
            },
            {
                "x": -0.44386905431747437,
                "y": 0.2203845977783203,
                "z": -87.28086853027344
            },
            {
                "x": -0.4259538948535919,
                "y": 0.22423842549324036,
                "z": -87.12491607666016
            },
            {
                "x": -0.407549113035202,
                "y": 0.2280275523662567,
                "z": -86.96912384033203
            },
            {
                "x": -0.388619065284729,
                "y": 0.23175078630447388,
                "z": -86.81330108642578
            },
            {
                "x": -0.3691956698894501,
                "y": 0.23540452122688293,
                "z": -86.65752410888672
            },
            {
                "x": -0.34929728507995605,
                "y": 0.23898369073867798,
                "z": -86.50189208984375
            },
            {
                "x": -0.32890814542770386,
                "y": 0.2424892783164978,
                "z": -86.34622955322266
            },
            {
                "x": -0.3080517053604126,
                "y": 0.2459109127521515,
                "z": -86.19070434570312
            },
            {
                "x": -0.2867315411567688,
                "y": 0.24924850463867188,
                "z": -86.03524780273438
            },
            {
                "x": -0.26492634415626526,
                "y": 0.25250402092933655,
                "z": -85.87965393066406
            },
            {
                "x": -0.24270561337471008,
                "y": 0.25566601753234863,
                "z": -85.72429656982422
            },
            {
                "x": -0.2200414538383484,
                "y": 0.2587321400642395,
                "z": -85.56901550292969
            },
            {
                "x": -0.2051718831062317,
                "y": 0.26066023111343384,
                "z": -85.4687271118164
            },
            {
                "x": -0.181813046336174,
                "y": 0.26356565952301025,
                "z": -85.31350708007812
            },
            {
                "x": -0.15802425146102905,
                "y": 0.2663685083389282,
                "z": -85.15826416015625
            },
            {
                "x": -0.13382956385612488,
                "y": 0.26906251907348633,
                "z": -85.00306701660156
            },
            {
                "x": -0.10926813632249832,
                "y": 0.27164581418037415,
                "z": -84.84801483154297
            },
            {
                "x": -0.08432184904813766,
                "y": 0.2741186320781708,
                "z": -84.69290924072266
            },
            {
                "x": -0.05902571976184845,
                "y": 0.2764713168144226,
                "z": -84.5379638671875
            },
            {
                "x": -0.033373232930898666,
                "y": 0.2787010669708252,
                "z": -84.383056640625
            },
            {
                "x": -0.007354646921157837,
                "y": 0.28081053495407104,
                "z": -84.22801208496094
            },
            {
                "x": 0.018943555653095245,
                "y": 0.2827911078929901,
                "z": -84.07319641113281
            },
            {
                "x": 0.04555758833885193,
                "y": 0.28464043140411377,
                "z": -83.91837310791016
            },
            {
                "x": 0.07247214019298553,
                "y": 0.2863522171974182,
                "z": -83.76358032226562
            },
            {
                "x": 0.0996466651558876,
                "y": 0.2879265546798706,
                "z": -83.60888671875
            },
            {
                "x": 0.12710997462272644,
                "y": 0.28936269879341125,
                "z": -83.45404052734375
            },
            {
                "x": 0.15478312969207764,
                "y": 0.2906514108181,
                "z": -83.29939270019531
            },
            {
                "x": 0.1826907992362976,
                "y": 0.29178789258003235,
                "z": -83.1447982788086
            },
            {
                "x": 0.21082176268100739,
                "y": 0.29277461767196655,
                "z": -82.9901123046875
            },
            {
                "x": 0.23912325501441956,
                "y": 0.2936067581176758,
                "z": -82.8355712890625
            },
            {
                "x": 0.2676135301589966,
                "y": 0.2942799925804138,
                "z": -82.68093872070312
            },
            {
                "x": 0.2962658703327179,
                "y": 0.29478633403778076,
                "z": -82.52632904052734
            },
            {
                "x": 0.3250340223312378,
                "y": 0.2951279282569885,
                "z": -82.371826171875
            },
            {
                "x": 0.353915274143219,
                "y": 0.295221745967865,
                "z": -82.21734619140625
            },
            {
                "x": 0.3828977942466736,
                "y": 0.29485630989074707,
                "z": -82.0628662109375
            },
            {
                "x": 0.4119586944580078,
                "y": 0.29400116205215454,
                "z": -81.90838623046875
            },
            {
                "x": 0.44111257791519165,
                "y": 0.29268211126327515,
                "z": -81.75372314453125
            },
            {
                "x": 0.47027140855789185,
                "y": 0.29091113805770874,
                "z": -81.59925079345703
            },
            {
                "x": 0.4994540810585022,
                "y": 0.28869181871414185,
                "z": -81.44471740722656
            },
            {
                "x": 0.5286383032798767,
                "y": 0.286019504070282,
                "z": -81.29019165039062
            },
            {
                "x": 0.5577857494354248,
                "y": 0.2829223871231079,
                "z": -81.13570404052734
            },
            {
                "x": 0.5869301557540894,
                "y": 0.27940404415130615,
                "z": -80.98101043701172
            },
            {
                "x": 0.6159743070602417,
                "y": 0.2754800021648407,
                "z": -80.82650756835938
            },
            {
                "x": 0.6449345350265503,
                "y": 0.27113980054855347,
                "z": -80.6719741821289
            },
            {
                "x": 0.6738141775131226,
                "y": 0.2664065957069397,
                "z": -80.5173110961914
            },
            {
                "x": 0.7025455236434937,
                "y": 0.2612960636615753,
                "z": -80.36273956298828
            },
            {
                "x": 0.731148362159729,
                "y": 0.2558095455169678,
                "z": -80.2080307006836
            },
            {
                "x": 0.7595786452293396,
                "y": 0.2499428391456604,
                "z": -80.05329895019531
            },
            {
                "x": 0.7878041863441467,
                "y": 0.24372631311416626,
                "z": -79.89864349365234
            },
            {
                "x": 0.8158457279205322,
                "y": 0.23716086149215698,
                "z": -79.74385070800781
            },
            {
                "x": 0.8436411619186401,
                "y": 0.23026376962661743,
                "z": -79.589111328125
            },
            {
                "x": 0.8711821436882019,
                "y": 0.2230236828327179,
                "z": -79.434326171875
            },
            {
                "x": 0.8984941840171814,
                "y": 0.2154560685157776,
                "z": -79.2793197631836
            },
            {
                "x": 0.92548668384552,
                "y": 0.20758870244026184,
                "z": -79.12446594238281
            },
            {
                "x": 0.9521741271018982,
                "y": 0.19942131638526917,
                "z": -78.96957397460938
            },
            {
                "x": 0.9692361354827881,
                "y": 0.19397836923599243,
                "z": -78.86947631835938
            },
            {
                "x": 0.9953797459602356,
                "y": 0.18532489240169525,
                "z": -78.7144775390625
            },
            {
                "x": 1.0211888551712036,
                "y": 0.17638878524303436,
                "z": -78.55934143066406
            },
            {
                "x": 1.0466210842132568,
                "y": 0.16717581450939178,
                "z": -78.40414428710938
            },
            {
                "x": 1.0716466903686523,
                "y": 0.1577043980360031,
                "z": -78.24897766113281
            },
            {
                "x": 1.0962845087051392,
                "y": 0.1479756236076355,
                "z": -78.0936508178711
            },
            {
                "x": 1.1204854249954224,
                "y": 0.13801215589046478,
                "z": -77.9383773803711
            },
            {
                "x": 1.1442420482635498,
                "y": 0.1278085708618164,
                "z": -77.78303527832031
            },
            {
                "x": 1.1675711870193481,
                "y": 0.11736275255680084,
                "z": -77.62744140625
            },
            {
                "x": 1.1904007196426392,
                "y": 0.10671539604663849,
                "z": -77.47199249267578
            },
            {
                "x": 1.2127602100372314,
                "y": 0.09585697948932648,
                "z": -77.31641387939453
            },
            {
                "x": 1.2346152067184448,
                "y": 0.08479534089565277,
                "z": -77.16077423095703
            },
            {
                "x": 1.255940318107605,
                "y": 0.07354362308979034,
                "z": -77.00511169433594
            },
            {
                "x": 1.276775598526001,
                "y": 0.06209658831357956,
                "z": -76.84919738769531
            },
            {
                "x": 1.2970513105392456,
                "y": 0.050492141395807266,
                "z": -76.69341278076172
            },
            {
                "x": 1.316771388053894,
                "y": 0.03872324898838997,
                "z": -76.53758239746094
            },
            {
                "x": 1.3359242677688599,
                "y": 0.026785913854837418,
                "z": -76.3815689086914
            },
            {
                "x": 1.3545031547546387,
                "y": 0.014711026102304459,
                "z": -76.22557830810547
            },
            {
                "x": 1.3725178241729736,
                "y": 0.002492299070581794,
                "z": -76.06944274902344
            },
            {
                "x": 1.3899383544921875,
                "y": -0.009855713695287704,
                "z": -75.91324615478516
            },
            {
                "x": 1.406722068786621,
                "y": -0.022320110350847244,
                "z": -75.75708770751953
            },
            {
                "x": 1.4229042530059814,
                "y": -0.034893449395895004,
                "z": -75.60089111328125
            },
            {
                "x": 1.4384775161743164,
                "y": -0.047569043934345245,
                "z": -75.44461822509766
            },
            {
                "x": 1.453426480293274,
                "y": -0.06033742055296898,
                "z": -75.28827667236328
            },
            {
                "x": 1.467736005783081,
                "y": -0.07320933789014816,
                "z": -75.1316909790039
            },
            {
                "x": 1.4813939332962036,
                "y": -0.08614064753055573,
                "z": -74.9752426147461
            },
            {
                "x": 1.4944193363189697,
                "y": -0.09914175420999527,
                "z": -74.8187026977539
            },
            {
                "x": 1.5067964792251587,
                "y": -0.11219996958971024,
                "z": -74.66211700439453
            },
            {
                "x": 1.5184928178787231,
                "y": -0.12530407309532166,
                "z": -74.50552368164062
            },
            {
                "x": 1.5295448303222656,
                "y": -0.1384650021791458,
                "z": -74.34867858886719
            },
            {
                "x": 1.5399259328842163,
                "y": -0.15163910388946533,
                "z": -74.19200134277344
            },
            {
                "x": 1.5496395826339722,
                "y": -0.16483549773693085,
                "z": -74.03528594970703
            },
            {
                "x": 1.5586795806884766,
                "y": -0.17805474996566772,
                "z": -73.87840270996094
            },
            {
                "x": 1.567038893699646,
                "y": -0.19126826524734497,
                "z": -73.72160339355469
            },
            {
                "x": 1.5747308731079102,
                "y": -0.20448443293571472,
                "z": -73.56468963623047
            },
            {
                "x": 1.5817515850067139,
                "y": -0.21768805384635925,
                "z": -73.40771484375
            },
            {
                "x": 1.588089108467102,
                "y": -0.23085933923721313,
                "z": -73.25081634521484
            },
            {
                "x": 1.593737006187439,
                "y": -0.24400660395622253,
                "z": -73.0937728881836
            },
            {
                "x": 1.5987069606781006,
                "y": -0.25710487365722656,
                "z": -72.93682861328125
            },
            {
                "x": 1.6030100584030151,
                "y": -0.270153671503067,
                "z": -72.77985382080078
            },
            {
                "x": 1.6066361665725708,
                "y": -0.28315848112106323,
                "z": -72.6226577758789
            },
            {
                "x": 1.6095542907714844,
                "y": -0.2960779070854187,
                "z": -72.46564483642578
            },
            {
                "x": 1.6118093729019165,
                "y": -0.3089202642440796,
                "z": -72.30862426757812
            },
            {
                "x": 1.6129209995269775,
                "y": -0.3171735405921936,
                "z": -72.20716857910156
            },
            {
                "x": 1.6140657663345337,
                "y": -0.3298683762550354,
                "z": -72.05010223388672
            },
            {
                "x": 1.6145397424697876,
                "y": -0.34247052669525146,
                "z": -71.8929443359375
            },
            {
                "x": 1.6143558025360107,
                "y": -0.3549625873565674,
                "z": -71.73577880859375
            },
            {
                "x": 1.613510012626648,
                "y": -0.367329478263855,
                "z": -71.57870483398438
            },
            {
                "x": 1.611960530281067,
                "y": -0.37957412004470825,
                "z": -71.4215087890625
            },
            {
                "x": 1.6097302436828613,
                "y": -0.3916729688644409,
                "z": -71.26441192626953
            },
            {
                "x": 1.6068062782287598,
                "y": -0.40362775325775146,
                "z": -71.10730743408203
            },
            {
                "x": 1.6031670570373535,
                "y": -0.4154447317123413,
                "z": -70.94999694824219
            },
            {
                "x": 1.598799705505371,
                "y": -0.4270794987678528,
                "z": -70.79289245605469
            },
            {
                "x": 1.5936853885650635,
                "y": -0.43854355812072754,
                "z": -70.63574981689453
            },
            {
                "x": 1.5878201723098755,
                "y": -0.44982871413230896,
                "z": -70.47857666015625
            },
            {
                "x": 1.5812008380889893,
                "y": -0.4609198570251465,
                "z": -70.32149505615234
            },
            {
                "x": 1.573784589767456,
                "y": -0.47182250022888184,
                "z": -70.16423034667969
            },
            {
                "x": 1.5655639171600342,
                "y": -0.4824988842010498,
                "z": -70.0071792602539
            },
            {
                "x": 1.5565426349639893,
                "y": -0.492958664894104,
                "z": -69.85015106201172
            },
            {
                "x": 1.5467010736465454,
                "y": -0.5032019019126892,
                "z": -69.69304656982422
            },
            {
                "x": 1.5360218286514282,
                "y": -0.5132002830505371,
                "z": -69.53607177734375
            },
            {
                "x": 1.5244592428207397,
                "y": -0.5229529142379761,
                "z": -69.37904357910156
            },
            {
                "x": 1.5120309591293335,
                "y": -0.5324541330337524,
                "z": -69.2220687866211
            },
            {
                "x": 1.498733639717102,
                "y": -0.5416887998580933,
                "z": -69.06523132324219
            },
            {
                "x": 1.4845354557037354,
                "y": -0.5506507754325867,
                "z": -68.90843200683594
            },
            {
                "x": 1.4693981409072876,
                "y": -0.5593230724334717,
                "z": -68.75173950195312
            },
            {
                "x": 1.4533324241638184,
                "y": -0.5677077770233154,
                "z": -68.5950927734375
            },
            {
                "x": 1.43630051612854,
                "y": -0.5758060812950134,
                "z": -68.43831634521484
            },
            {
                "x": 1.418322205543518,
                "y": -0.5835856199264526,
                "z": -68.28184509277344
            },
            {
                "x": 1.399324655532837,
                "y": -0.5910406112670898,
                "z": -68.12541198730469
            },
            {
                "x": 1.379333734512329,
                "y": -0.5981719493865967,
                "z": -67.96907806396484
            },
            {
                "x": 1.3583381175994873,
                "y": -0.6049679517745972,
                "z": -67.81290435791016
            },
            {
                "x": 1.3362795114517212,
                "y": -0.6114301681518555,
                "z": -67.65664672851562
            },
            {
                "x": 1.3131537437438965,
                "y": -0.6175179481506348,
                "z": -67.50072479248047
            },
            {
                "x": 1.2889717817306519,
                "y": -0.6232463121414185,
                "z": -67.3449478149414
            },
            {
                "x": 1.2636909484863281,
                "y": -0.6286112070083618,
                "z": -67.18920135498047
            },
            {
                "x": 1.2373324632644653,
                "y": -0.6335951089859009,
                "z": -67.03374481201172
            },
            {
                "x": 1.209780216217041,
                "y": -0.6381780505180359,
                "z": -66.87836456298828
            },
            {
                "x": 1.1810941696166992,
                "y": -0.6423666477203369,
                "z": -66.7231674194336
            },
            {
                "x": 1.151282548904419,
                "y": -0.6461499929428101,
                "z": -66.56826782226562
            },
            {
                "x": 1.1202887296676636,
                "y": -0.6495248079299927,
                "z": -66.41346740722656
            },
            {
                "x": 1.088071346282959,
                "y": -0.6524606943130493,
                "z": -66.259033203125
            },
            {
                "x": 1.0546623468399048,
                "y": -0.6550611853599548,
                "z": -66.10482788085938
            },
            {
                "x": 1.019995927810669,
                "y": -0.6573933959007263,
                "z": -65.95067596435547
            },
            {
                "x": 0.984144389629364,
                "y": -0.6594454646110535,
                "z": -65.79698944091797
            },
            {
                "x": 0.9470609426498413,
                "y": -0.661201000213623,
                "z": -65.64358520507812
            },
            {
                "x": 0.9223538041114807,
                "y": -0.662182629108429,
                "z": -65.54468536376953
            },
            {
                "x": 0.8831636905670166,
                "y": -0.6634629964828491,
                "z": -65.39179992675781
            },
            {
                "x": 0.8426295518875122,
                "y": -0.6644352674484253,
                "z": -65.23916625976562
            },
            {
                "x": 0.8007939457893372,
                "y": -0.6650980114936829,
                "z": -65.08685302734375
            },
            {
                "x": 0.7576996088027954,
                "y": -0.6654499769210815,
                "z": -64.93500518798828
            },
            {
                "x": 0.7132853865623474,
                "y": -0.6654858589172363,
                "z": -64.7834243774414
            },
            {
                "x": 0.6675578951835632,
                "y": -0.6651949882507324,
                "z": -64.63233947753906
            },
            {
                "x": 0.6205011606216431,
                "y": -0.6645874977111816,
                "z": -64.4816665649414
            },
            {
                "x": 0.572084903717041,
                "y": -0.6636730432510376,
                "z": -64.33120727539062
            },
            {
                "x": 0.5224351286888123,
                "y": -0.6624599695205688,
                "z": -64.1813735961914
            },
            {
                "x": 0.47140806913375854,
                "y": -0.660943329334259,
                "z": -64.03194427490234
            },
            {
                "x": 0.4190762937068939,
                "y": -0.6591334342956543,
                "z": -63.88298034667969
            },
            {
                "x": 0.3654850721359253,
                "y": -0.6570420861244202,
                "z": -63.73453903198242
            },
            {
                "x": 0.3105383515357971,
                "y": -0.6546715497970581,
                "z": -63.58637619018555
            },
            {
                "x": 0.2543877959251404,
                "y": -0.6520259380340576,
                "z": -63.43889617919922
            },
            {
                "x": 0.1969628930091858,
                "y": -0.6491110324859619,
                "z": -63.29191589355469
            },
            {
                "x": 0.1382923126220703,
                "y": -0.6459355354309082,
                "z": -63.145328521728516
            },
            {
                "x": 0.07848070561885834,
                "y": -0.6425107717514038,
                "z": -62.99937438964844
            },
            {
                "x": 0.01744607836008072,
                "y": -0.6388304233551025,
                "z": -62.853797912597656
            },
            {
                "x": -0.044728413224220276,
                "y": -0.6349049806594849,
                "z": -62.70875930786133
            },
            {
                "x": -0.10792820155620575,
                "y": -0.6307477355003357,
                "z": -62.56429672241211
            },
            {
                "x": -0.17216631770133972,
                "y": -0.6263624429702759,
                "z": -62.42030715942383
            },
            {
                "x": -0.23738163709640503,
                "y": -0.6217502355575562,
                "z": -62.27681350708008
            },
            {
                "x": -0.30353644490242004,
                "y": -0.616916298866272,
                "z": -62.1337890625
            },
            {
                "x": -0.37062057852745056,
                "y": -0.6118659377098083,
                "z": -61.99101257324219
            },
            {
                "x": -0.4383856952190399,
                "y": -0.6066175699234009,
                "z": -61.84882736206055
            },
            {
                "x": -0.5068889856338501,
                "y": -0.6011649966239929,
                "z": -61.70698928833008
            },
            {
                "x": -0.5760043859481812,
                "y": -0.5955142378807068,
                "z": -61.56550979614258
            },
            {
                "x": -0.6456068754196167,
                "y": -0.5896785259246826,
                "z": -61.42438507080078
            },
            {
                "x": -0.7157087922096252,
                "y": -0.58365398645401,
                "z": -61.28334045410156
            },
            {
                "x": -0.7860215306282043,
                "y": -0.5774587392807007,
                "z": -61.142704010009766
            },
            {
                "x": -0.8565142750740051,
                "y": -0.5710881352424622,
                "z": -61.002227783203125
            },
            {
                "x": -0.927107572555542,
                "y": -0.5645483732223511,
                "z": -60.86174392700195
            },
            {
                "x": -0.997549295425415,
                "y": -0.5578552484512329,
                "z": -60.721405029296875
            },
            {
                "x": -1.0678082704544067,
                "y": -0.5510019063949585,
                "z": -60.5809326171875
            },
            {
                "x": -1.1376532316207886,
                "y": -0.5439959764480591,
                "z": -60.44035339355469
            },
            {
                "x": -1.206882357597351,
                "y": -0.5368528366088867,
                "z": -60.29967498779297
            },
            {
                "x": -1.2754275798797607,
                "y": -0.5295684337615967,
                "z": -60.15864181518555
            },
            {
                "x": -1.3429927825927734,
                "y": -0.5221574902534485,
                "z": -60.01735305786133
            },
            {
                "x": -1.4093966484069824,
                "y": -0.5146176218986511,
                "z": -59.87562561035156
            },
            {
                "x": -1.4745543003082275,
                "y": -0.506950318813324,
                "z": -59.73321533203125
            },
            {
                "x": -1.5380964279174805,
                "y": -0.49918121099472046,
                "z": -59.59039306640625
            },
            {
                "x": -1.5998899936676025,
                "y": -0.4913066029548645,
                "z": -59.4469108581543
            },
            {
                "x": -1.638702392578125,
                "y": -0.4861640930175781,
                "z": -59.35383224487305
            },
            {
                "x": -1.6970829963684082,
                "y": -0.4781298041343689,
                "z": -59.209102630615234
            },
            {
                "x": -1.753330111503601,
                "y": -0.46999669075012207,
                "z": -59.0633544921875
            },
            {
                "x": -1.8078467845916748,
                "y": -0.46176183223724365,
                "z": -58.91667938232422
            },
            {
                "x": -1.8610448837280273,
                "y": -0.4534478187561035,
                "z": -58.769527435302734
            },
            {
                "x": -1.913055658340454,
                "y": -0.4450538158416748,
                "z": -58.621822357177734
            },
            {
                "x": -1.9638453722000122,
                "y": -0.43659713864326477,
                "z": -58.473785400390625
            },
            {
                "x": -2.0134356021881104,
                "y": -0.4280763566493988,
                "z": -58.325340270996094
            },
            {
                "x": -2.0619544982910156,
                "y": -0.4194873571395874,
                "z": -58.17630386352539
            },
            {
                "x": -2.1093273162841797,
                "y": -0.41085880994796753,
                "z": -58.02710723876953
            },
            {
                "x": -2.1556546688079834,
                "y": -0.40218186378479004,
                "z": -57.87750244140625
            },
            {
                "x": -2.200906753540039,
                "y": -0.39346492290496826,
                "z": -57.727569580078125
            },
            {
                "x": -2.2451162338256836,
                "y": -0.3847169280052185,
                "z": -57.577362060546875
            },
            {
                "x": -2.288393259048462,
                "y": -0.3759304881095886,
                "z": -57.42667770385742
            },
            {
                "x": -2.3306524753570557,
                "y": -0.3671328127384186,
                "z": -57.27588653564453
            },
            {
                "x": -2.371940851211548,
                "y": -0.3583177924156189,
                "z": -57.12481689453125
            },
            {
                "x": -2.4123010635375977,
                "y": -0.34948664903640747,
                "z": -56.97339630126953
            },
            {
                "x": -2.4517242908477783,
                "y": -0.3406558930873871,
                "z": -56.821815490722656
            },
            {
                "x": -2.490281581878662,
                "y": -0.3318198323249817,
                "z": -56.66990661621094
            },
            {
                "x": -2.5279393196105957,
                "y": -0.3229895830154419,
                "z": -56.51777267456055
            },
            {
                "x": -2.564689874649048,
                "y": -0.3141709268093109,
                "z": -56.36550521850586
            },
            {
                "x": -2.600584030151367,
                "y": -0.3052539825439453,
                "z": -56.21302795410156
            },
            {
                "x": -2.635643243789673,
                "y": -0.2961900234222412,
                "z": -56.06035232543945
            },
            {
                "x": -2.669865608215332,
                "y": -0.2869887053966522,
                "z": -55.907493591308594
            },
            {
                "x": -2.703289270401001,
                "y": -0.2776443362236023,
                "z": -55.75425720214844
            },
            {
                "x": -2.73586368560791,
                "y": -0.2681928873062134,
                "z": -55.60103988647461
            },
            {
                "x": -2.767662763595581,
                "y": -0.2586272358894348,
                "z": -55.44761276245117
            },
            {
                "x": -2.798663377761841,
                "y": -0.2489578127861023,
                "z": -55.29402160644531
            },
            {
                "x": -2.8288493156433105,
                "y": -0.2391931414604187,
                "z": -55.14033126831055
            },
            {
                "x": -2.85831356048584,
                "y": -0.2293296754360199,
                "z": -54.98628616333008
            },
            {
                "x": -2.8869760036468506,
                "y": -0.21940076351165771,
                "z": -54.832305908203125
            },
            {
                "x": -2.9148871898651123,
                "y": -0.20940075814723969,
                "z": -54.678184509277344
            },
            {
                "x": -2.942047119140625,
                "y": -0.1993289738893509,
                "z": -54.523807525634766
            },
            {
                "x": -2.968446731567383,
                "y": -0.1892104297876358,
                "z": -54.369415283203125
            },
            {
                "x": -2.994140148162842,
                "y": -0.17904013395309448,
                "z": -54.214805603027344
            },
            {
                "x": -3.0191028118133545,
                "y": -0.16883225739002228,
                "z": -54.06007766723633
            },
            {
                "x": -3.0433030128479004,
                "y": -0.15859979391098022,
                "z": -53.90532302856445
            },
            {
                "x": -3.066805601119995,
                "y": -0.14833955466747284,
                "z": -53.7503547668457
            },
            {
                "x": -3.0895802974700928,
                "y": -0.1380731165409088,
                "z": -53.59538650512695
            },
            {
                "x": -3.111659288406372,
                "y": -0.12780216336250305,
                "z": -53.44032287597656
            },
            {
                "x": -3.133031129837036,
                "y": -0.11752106249332428,
                "z": -53.28493881225586
            },
            {
                "x": -3.1536810398101807,
                "y": -0.10726305097341537,
                "z": -53.129661560058594
            },
            {
                "x": -3.173635721206665,
                "y": -0.09652070701122284,
                "z": -52.97429275512695
            },
            {
                "x": -3.1861608028411865,
                "y": -0.0889328271150589,
                "z": -52.87392044067383
            },
            {
                "x": -3.2049455642700195,
                "y": -0.07616094499826431,
                "z": -52.71855545043945
            },
            {
                "x": -3.223053216934204,
                "y": -0.06226862594485283,
                "z": -52.56309509277344
            },
            {
                "x": -3.240466356277466,
                "y": -0.04735737666487694,
                "z": -52.40766143798828
            },
            {
                "x": -3.257173776626587,
                "y": -0.03151126205921173,
                "z": -52.25233459472656
            },
            {
                "x": -3.273188829421997,
                "y": -0.014802430756390095,
                "z": -52.096927642822266
            },
            {
                "x": -3.2885184288024902,
                "y": 0.0026307799853384495,
                "z": -51.94163131713867
            },
            {
                "x": -3.3031694889068604,
                "y": 0.020708242431282997,
                "z": -51.786354064941406
            },
            {
                "x": -3.317168951034546,
                "y": 0.03936614841222763,
                "z": -51.630882263183594
            },
            {
                "x": -3.3304452896118164,
                "y": 0.058478374034166336,
                "z": -51.47560501098633
            },
            {
                "x": -3.3430707454681396,
                "y": 0.0779651552438736,
                "z": -51.320255279541016
            },
            {
                "x": -3.355024814605713,
                "y": 0.0977277010679245,
                "z": -51.164894104003906
            },
            {
                "x": -3.366319179534912,
                "y": 0.11767099797725677,
                "z": -51.009578704833984
            },
            {
                "x": -3.3769338130950928,
                "y": 0.13773855566978455,
                "z": -50.8540153503418
            },
            {
                "x": -3.3868775367736816,
                "y": 0.15778286755084991,
                "z": -50.6986198425293
            },
            {
                "x": -3.396157741546631,
                "y": 0.17774006724357605,
                "z": -50.54317092895508
            },
            {
                "x": -3.4047882556915283,
                "y": 0.19753429293632507,
                "z": -50.38755798339844
            },
            {
                "x": -3.4127423763275146,
                "y": 0.21704265475273132,
                "z": -50.23197937011719
            },
            {
                "x": -3.4200236797332764,
                "y": 0.23619255423545837,
                "z": -50.07623291015625
            },
            {
                "x": -3.4266505241394043,
                "y": 0.2548893094062805,
                "z": -49.92040252685547
            },
            {
                "x": -3.432607412338257,
                "y": 0.27303144335746765,
                "z": -49.76457977294922
            },
            {
                "x": -3.4379069805145264,
                "y": 0.29053622484207153,
                "z": -49.60866928100586
            },
            {
                "x": -3.442512035369873,
                "y": 0.30728262662887573,
                "z": -49.45265579223633
            },
            {
                "x": -3.446455240249634,
                "y": 0.32320505380630493,
                "z": -49.296546936035156
            },
            {
                "x": -3.449737787246704,
                "y": 0.3382313847541809,
                "z": -49.1401252746582
            },
            {
                "x": -3.452341079711914,
                "y": 0.3522302508354187,
                "z": -48.983802795410156
            },
            {
                "x": -3.4542548656463623,
                "y": 0.36508262157440186,
                "z": -48.82732391357422
            },
            {
                "x": -3.4554786682128906,
                "y": 0.37672561407089233,
                "z": -48.67074966430664
            },
            {
                "x": -3.4559690952301025,
                "y": 0.38706648349761963,
                "z": -48.514190673828125
            },
            {
                "x": -3.455479145050049,
                "y": 0.3960258364677429,
                "z": -48.35744094848633
            },
            {
                "x": -3.453646183013916,
                "y": 0.4034324288368225,
                "z": -48.20090866088867
            },
            {
                "x": -3.4504034519195557,
                "y": 0.4093029499053955,
                "z": -48.044342041015625
            },
            {
                "x": -3.445683479309082,
                "y": 0.41435617208480835,
                "z": -47.887657165527344
            },
            {
                "x": -3.4394710063934326,
                "y": 0.41835105419158936,
                "z": -47.731143951416016
            },
            {
                "x": -3.4316272735595703,
                "y": 0.42104580998420715,
                "z": -47.57460403442383
            },
            {
                "x": -3.422147512435913,
                "y": 0.4225468933582306,
                "z": -47.418128967285156
            },
            {
                "x": -3.411022186279297,
                "y": 0.4229549467563629,
                "z": -47.26188278198242
            },
            {
                "x": -3.3981733322143555,
                "y": 0.42235201597213745,
                "z": -47.10566711425781
            },
            {
                "x": -3.383531093597412,
                "y": 0.42079275846481323,
                "z": -46.94972610473633
            },
            {
                "x": -3.367084264755249,
                "y": 0.4183773994445801,
                "z": -46.79397964477539
            },
            {
                "x": -3.3487942218780518,
                "y": 0.4151991009712219,
                "z": -46.63826370239258
            },
            {
                "x": -3.328683853149414,
                "y": 0.4113472104072571,
                "z": -46.482994079589844
            },
            {
                "x": -3.3066554069519043,
                "y": 0.4068840742111206,
                "z": -46.32799530029297
            },
            {
                "x": -3.291407346725464,
                "y": 0.4037169814109802,
                "z": -46.228031158447266
            },
            {
                "x": -3.2662956714630127,
                "y": 0.39845478534698486,
                "z": -46.073524475097656
            },
            {
                "x": -3.2392733097076416,
                "y": 0.39280587434768677,
                "z": -45.91923904418945
            },
            {
                "x": -3.210358142852783,
                "y": 0.3868544101715088,
                "z": -45.76530075073242
            },
            {
                "x": -3.179655075073242,
                "y": 0.3806956708431244,
                "z": -45.61178970336914
            },
            {
                "x": -3.147172689437866,
                "y": 0.37440067529678345,
                "z": -45.45852279663086
            },
            {
                "x": -3.1129980087280273,
                "y": 0.3680574893951416,
                "z": -45.30570602416992
            },
            {
                "x": -3.0771560668945312,
                "y": 0.3617454767227173,
                "z": -45.15325164794922
            },
            {
                "x": -3.03974986076355,
                "y": 0.35553598403930664,
                "z": -45.000911712646484
            },
            {
                "x": -3.0009889602661133,
                "y": 0.3495231866836548,
                "z": -44.84907150268555
            },
            {
                "x": -2.960919141769409,
                "y": 0.343778520822525,
                "z": -44.69744873046875
            },
            {
                "x": -2.9196648597717285,
                "y": 0.33839666843414307,
                "z": -44.546085357666016
            },
            {
                "x": -2.8774330615997314,
                "y": 0.3334464728832245,
                "z": -44.394981384277344
            },
            {
                "x": -2.8343112468719482,
                "y": 0.3289995491504669,
                "z": -44.243858337402344
            },
            {
                "x": -2.7905662059783936,
                "y": 0.3251516819000244,
                "z": -44.09304428100586
            },
            {
                "x": -2.7463080883026123,
                "y": 0.3220023214817047,
                "z": -43.94230270385742
            },
            {
                "x": -2.7016913890838623,
                "y": 0.31960588693618774,
                "z": -43.791481018066406
            },
            {
                "x": -2.6569485664367676,
                "y": 0.3180464506149292,
                "z": -43.640743255615234
            },
            {
                "x": -2.6121883392333984,
                "y": 0.31740957498550415,
                "z": -43.48984146118164
            },
            {
                "x": -2.567612409591675,
                "y": 0.3178201913833618,
                "z": -43.338836669921875
            },
            {
                "x": -2.523400068283081,
                "y": 0.31931912899017334,
                "z": -43.18777847290039
            },
            {
                "x": -2.479673147201538,
                "y": 0.32198864221572876,
                "z": -43.036556243896484
            },
            {
                "x": -2.4365689754486084,
                "y": 0.3255688548088074,
                "z": -42.88518142700195
            },
            {
                "x": -2.394235610961914,
                "y": 0.3291340470314026,
                "z": -42.73354721069336
            },
            {
                "x": -2.3526968955993652,
                "y": 0.332602858543396,
                "z": -42.58146667480469
            },
            {
                "x": -2.312152624130249,
                "y": 0.33596324920654297,
                "z": -42.429298400878906
            },
            {
                "x": -2.2726128101348877,
                "y": 0.33921748399734497,
                "z": -42.27678298950195
            },
            {
                "x": -2.234231948852539,
                "y": 0.34235578775405884,
                "z": -42.12395095825195
            },
            {
                "x": -2.1970245838165283,
                "y": 0.3453787565231323,
                "z": -41.97086715698242
            },
            {
                "x": -2.160979986190796,
                "y": 0.34828782081604004,
                "z": -41.81728744506836
            },
            {
                "x": -2.126230478286743,
                "y": 0.35107192397117615,
                "z": -41.663604736328125
            },
            {
                "x": -2.0928263664245605,
                "y": 0.353725790977478,
                "z": -41.50962448120117
            },
            {
                "x": -2.0606958866119385,
                "y": 0.35625317692756653,
                "z": -41.35523986816406
            },
            {
                "x": -2.029893159866333,
                "y": 0.3586468994617462,
                "z": -41.20071029663086
            },
            {
                "x": -2.000391721725464,
                "y": 0.36090701818466187,
                "z": -41.04582977294922
            },
            {
                "x": -1.972272276878357,
                "y": 0.36302220821380615,
                "z": -40.89067840576172
            },
            {
                "x": -1.9454766511917114,
                "y": 0.36499327421188354,
                "z": -40.73541259765625
            },
            {
                "x": -1.919965386390686,
                "y": 0.3668197989463806,
                "z": -40.579811096191406
            },
            {
                "x": -1.895756483078003,
                "y": 0.36849626898765564,
                "z": -40.42412185668945
            },
            {
                "x": -1.8728636503219604,
                "y": 0.3700134754180908,
                "z": -40.26823806762695
            },
            {
                "x": -1.8512016534805298,
                "y": 0.3713756203651428,
                "z": -40.11198043823242
            },
            {
                "x": -1.8307836055755615,
                "y": 0.37257641553878784,
                "z": -39.95576477050781
            },
            {
                "x": -1.8115407228469849,
                "y": 0.37361419200897217,
                "z": -39.799415588378906
            },
            {
                "x": -1.7998247146606445,
                "y": 0.37419062852859497,
                "z": -39.698333740234375
            },
            {
                "x": -1.7825610637664795,
                "y": 0.3749476969242096,
                "z": -39.5417594909668
            },
            {
                "x": -1.7664240598678589,
                "y": 0.3755336403846741,
                "z": -39.38497543334961
            },
            {
                "x": -1.751389741897583,
                "y": 0.37593874335289,
                "z": -39.22809982299805
            },
            {
                "x": -1.7373541593551636,
                "y": 0.3761618733406067,
                "z": -39.071250915527344
            },
            {
                "x": -1.7243996858596802,
                "y": 0.37620338797569275,
                "z": -38.91415023803711
            },
            {
                "x": -1.7126474380493164,
                "y": 0.37606221437454224,
                "z": -38.75705337524414
            },
            {
                "x": -1.7022147178649902,
                "y": 0.3757361173629761,
                "z": -38.599822998046875
            },
            {
                "x": -1.6932438611984253,
                "y": 0.3752288222312927,
                "z": -38.4422721862793
            },
            {
                "x": -1.6858655214309692,
                "y": 0.3745490610599518,
                "z": -38.284812927246094
            },
            {
                "x": -1.6801846027374268,
                "y": 0.3736990690231323,
                "z": -38.12718963623047
            },
            {
                "x": -1.676358938217163,
                "y": 0.3726780414581299,
                "z": -37.96949768066406
            },
            {
                "x": -1.6744616031646729,
                "y": 0.3714907765388489,
                "z": -37.81182098388672
            },
            {
                "x": -1.6744983196258545,
                "y": 0.37014245986938477,
                "z": -37.653926849365234
            },
            {
                "x": -1.676504135131836,
                "y": 0.36863982677459717,
                "z": -37.49623489379883
            },
            {
                "x": -1.680530071258545,
                "y": 0.3669812083244324,
                "z": -37.33858871459961
            },
            {
                "x": -1.6865696907043457,
                "y": 0.3651694655418396,
                "z": -37.180908203125
            },
            {
                "x": -1.6945315599441528,
                "y": 0.3632141351699829,
                "z": -37.0234375
            },
            {
                "x": -1.7043845653533936,
                "y": 0.3611156940460205,
                "z": -36.86598205566406
            },
            {
                "x": -1.7161080837249756,
                "y": 0.3588765859603882,
                "z": -36.70867919921875
            },
            {
                "x": -1.7296298742294312,
                "y": 0.35650116205215454,
                "z": -36.551639556884766
            },
            {
                "x": -1.744837999343872,
                "y": 0.35399532318115234,
                "z": -36.394771575927734
            },
            {
                "x": -1.7616595029830933,
                "y": 0.35136228799819946,
                "z": -36.23809051513672
            },
            {
                "x": -1.7800438404083252,
                "y": 0.34860289096832275,
                "z": -36.08161544799805
            },
            {
                "x": -1.7999515533447266,
                "y": 0.3457164764404297,
                "z": -35.92513656616211
            },
            {
                "x": -1.8212143182754517,
                "y": 0.34271639585494995,
                "z": -35.769065856933594
            },
            {
                "x": -1.8437849283218384,
                "y": 0.33960211277008057,
                "z": -35.61315155029297
            },
            {
                "x": -1.867610216140747,
                "y": 0.33637499809265137,
                "z": -35.457427978515625
            },
            {
                "x": -1.8926247358322144,
                "y": 0.3330391049385071,
                "z": -35.301971435546875
            },
            {
                "x": -1.9187637567520142,
                "y": 0.3295949697494507,
                "z": -35.146514892578125
            },
            {
                "x": -1.9458982944488525,
                "y": 0.32605481147766113,
                "z": -34.991451263427734
            },
            {
                "x": -1.9740208387374878,
                "y": 0.32241585850715637,
                "z": -34.83658981323242
            },
            {
                "x": -2.003105401992798,
                "y": 0.3186768889427185,
                "z": -34.68178939819336
            },
            {
                "x": -2.033033847808838,
                "y": 0.3148499131202698,
                "z": -34.527286529541016
            },
            {
                "x": -2.0637917518615723,
                "y": 0.31093287467956543,
                "z": -34.37286376953125
            },
            {
                "x": -2.0953238010406494,
                "y": 0.30693021416664124,
                "z": -34.21860122680664
            },
            {
                "x": -2.1275877952575684,
                "y": 0.30284547805786133,
                "z": -34.064613342285156
            },
            {
                "x": -2.160557746887207,
                "y": 0.29868006706237793,
                "z": -33.910675048828125
            },
            {
                "x": -2.1941468715667725,
                "y": 0.29444238543510437,
                "z": -33.75699234008789
            },
            {
                "x": -2.2283496856689453,
                "y": 0.2901322543621063,
                "z": -33.60345458984375
            },
            {
                "x": -2.2631947994232178,
                "y": 0.2857450246810913,
                "z": -33.449859619140625
            },
            {
                "x": -2.298541307449341,
                "y": 0.2812980115413666,
                "z": -33.296600341796875
            },
            {
                "x": -2.3344011306762695,
                "y": 0.2767886817455292,
                "z": -33.143470764160156
            },
            {
                "x": -2.3578197956085205,
                "y": 0.2738436758518219,
                "z": -33.04463195800781
            },
            {
                "x": -2.3942580223083496,
                "y": 0.2692384123802185,
                "z": -32.89174270629883
            },
            {
                "x": -2.4305059909820557,
                "y": 0.26457610726356506,
                "z": -32.73878479003906
            },
            {
                "x": -2.4663515090942383,
                "y": 0.25986021757125854,
                "z": -32.58576583862305
            },
            {
                "x": -2.5016841888427734,
                "y": 0.25509458780288696,
                "z": -32.432743072509766
            },
            {
                "x": -2.5365140438079834,
                "y": 0.2502783536911011,
                "z": -32.27949905395508
            },
            {
                "x": -2.570720672607422,
                "y": 0.24542146921157837,
                "z": -32.126251220703125
            },
            {
                "x": -2.604264736175537,
                "y": 0.24052372574806213,
                "z": -31.97287368774414
            },
            {
                "x": -2.6370785236358643,
                "y": 0.2355804741382599,
                "z": -31.81914520263672
            },
            {
                "x": -2.669027090072632,
                "y": 0.23060929775238037,
                "z": -31.665456771850586
            },
            {
                "x": -2.7000958919525146,
                "y": 0.22560515999794006,
                "z": -31.51154136657715
            },
            {
                "x": -2.730194091796875,
                "y": 0.22057345509529114,
                "z": -31.357446670532227
            },
            {
                "x": -2.7591919898986816,
                "y": 0.21551862359046936,
                "z": -31.20322608947754
            },
            {
                "x": -2.78709077835083,
                "y": 0.21043658256530762,
                "z": -31.04860496520996
            },
            {
                "x": -2.81375789642334,
                "y": 0.20534375309944153,
                "z": -30.89398765563965
            },
            {
                "x": -2.839165449142456,
                "y": 0.20023715496063232,
                "z": -30.739168167114258
            },
            {
                "x": -2.86322021484375,
                "y": 0.1951163411140442,
                "z": -30.584030151367188
            },
            {
                "x": -2.885859966278076,
                "y": 0.18999281525611877,
                "z": -30.428808212280273
            },
            {
                "x": -2.907087802886963,
                "y": 0.1848631054162979,
                "z": -30.273286819458008
            },
            {
                "x": -2.9268529415130615,
                "y": 0.17973393201828003,
                "z": -30.117572784423828
            },
            {
                "x": -2.945066213607788,
                "y": 0.17461244761943817,
                "z": -29.961772918701172
            },
            {
                "x": -2.961747407913208,
                "y": 0.16949915885925293,
                "z": -29.805801391601562
            },
            {
                "x": -2.9769134521484375,
                "y": 0.16439753770828247,
                "z": -29.649677276611328
            },
            {
                "x": -2.9905648231506348,
                "y": 0.15929430723190308,
                "z": -29.49341583251953
            },
            {
                "x": -3.0026798248291016,
                "y": 0.1533321738243103,
                "z": -29.336891174316406
            },
            {
                "x": -3.013265371322632,
                "y": 0.14604151248931885,
                "z": -29.180505752563477
            },
            {
                "x": -3.022400140762329,
                "y": 0.1375226378440857,
                "z": -29.024023056030273
            },
            {
                "x": -3.030113697052002,
                "y": 0.12786805629730225,
                "z": -28.867515563964844
            },
            {
                "x": -3.0364134311676025,
                "y": 0.11714761704206467,
                "z": -28.711057662963867
            },
            {
                "x": -3.0413575172424316,
                "y": 0.10544054955244064,
                "z": -28.55440902709961
            },
            {
                "x": -3.045015335083008,
                "y": 0.09289129078388214,
                "z": -28.39797592163086
            },
            {
                "x": -3.047445058822632,
                "y": 0.07957595586776733,
                "z": -28.241567611694336
            },
            {
                "x": -3.048680067062378,
                "y": 0.0655641108751297,
                "z": -28.0850772857666
            },
            {
                "x": -3.048757791519165,
                "y": 0.0509638674557209,
                "z": -27.928735733032227
            },
            {
                "x": -3.0477733612060547,
                "y": 0.03586571663618088,
                "z": -27.772329330444336
            },
            {
                "x": -3.045776844024658,
                "y": 0.020369352772831917,
                "z": -27.615968704223633
            },
            {
                "x": -3.042811393737793,
                "y": 0.004879373125731945,
                "z": -27.459665298461914
            },
            {
                "x": -3.0388965606689453,
                "y": -0.009235316887497902,
                "z": -27.303115844726562
            },
            {
                "x": -3.0341176986694336,
                "y": -0.021889902651309967,
                "z": -27.146562576293945
            },
            {
                "x": -3.02852463722229,
                "y": -0.0331636518239975,
                "z": -26.989927291870117
            },
            {
                "x": -3.0221431255340576,
                "y": -0.043138857930898666,
                "z": -26.833032608032227
            },
            {
                "x": -3.01487135887146,
                "y": -0.051804158836603165,
                "z": -26.67632484436035
            },
            {
                "x": -3.006673574447632,
                "y": -0.05930902436375618,
                "z": -26.519601821899414
            },
            {
                "x": -3.00089955329895,
                "y": -0.06359177827835083,
                "z": -26.418378829956055
            },
            {
                "x": -2.9910244941711426,
                "y": -0.06932418048381805,
                "z": -26.261709213256836
            },
            {
                "x": -2.9799907207489014,
                "y": -0.07408426702022552,
                "z": -26.104995727539062
            },
            {
                "x": -2.96777606010437,
                "y": -0.07795588672161102,
                "z": -25.948354721069336
            },
            {
                "x": -2.9543397426605225,
                "y": -0.08101129531860352,
                "z": -25.79190444946289
            },
            {
                "x": -2.9395911693573,
                "y": -0.08330617845058441,
                "z": -25.635465621948242
            },
            {
                "x": -2.9235174655914307,
                "y": -0.08492812514305115,
                "z": -25.479259490966797
            },
            {
                "x": -2.9060776233673096,
                "y": -0.08596394956111908,
                "z": -25.32320785522461
            },
            {
                "x": -2.887197256088257,
                "y": -0.08648738265037537,
                "z": -25.167125701904297
            },
            {
                "x": -2.866849422454834,
                "y": -0.08655853569507599,
                "z": -25.01144027709961
            },
            {
                "x": -2.8449628353118896,
                "y": -0.08626145124435425,
                "z": -24.855911254882812
            },
            {
                "x": -2.8215126991271973,
                "y": -0.08567654341459274,
                "z": -24.700618743896484
            },
            {
                "x": -2.7964882850646973,
                "y": -0.0848771184682846,
                "z": -24.545644760131836
            },
            {
                "x": -2.769735097885132,
                "y": -0.08414675295352936,
                "z": -24.390779495239258
            },
            {
                "x": -2.7413077354431152,
                "y": -0.08470410108566284,
                "z": -24.23645782470703
            },
            {
                "x": -2.711148977279663,
                "y": -0.08633171021938324,
                "z": -24.08242416381836
            },
            {
                "x": -2.679203748703003,
                "y": -0.08703798055648804,
                "z": -23.9285888671875
            },
            {
                "x": -2.645437479019165,
                "y": -0.08627091348171234,
                "z": -23.77526092529297
            },
            {
                "x": -2.609814405441284,
                "y": -0.08413030207157135,
                "z": -23.622268676757812
            },
            {
                "x": -2.572354555130005,
                "y": -0.0808519497513771,
                "z": -23.469755172729492
            },
            {
                "x": -2.5331099033355713,
                "y": -0.07767704129219055,
                "z": -23.317792892456055
            },
            {
                "x": -2.4927518367767334,
                "y": -0.07507596909999847,
                "z": -23.16596221923828
            },
            {
                "x": -2.451817274093628,
                "y": -0.07296446710824966,
                "z": -23.01426887512207
            },
            {
                "x": -2.410313367843628,
                "y": -0.0712491124868393,
                "z": -22.862720489501953
            },
            {
                "x": -2.3681766986846924,
                "y": -0.0698481947183609,
                "z": -22.711137771606445
            },
            {
                "x": -2.3254849910736084,
                "y": -0.0686899870634079,
                "z": -22.559907913208008
            },
            {
                "x": -2.282181978225708,
                "y": -0.06768599152565002,
                "z": -22.408794403076172
            },
            {
                "x": -2.238319158554077,
                "y": -0.06675179302692413,
                "z": -22.257831573486328
            },
            {
                "x": -2.193955659866333,
                "y": -0.06580884754657745,
                "z": -22.10706329345703
            },
            {
                "x": -2.149055242538452,
                "y": -0.06476997584104538,
                "z": -21.956228256225586
            },
            {
                "x": -2.103816270828247,
                "y": -0.06355784833431244,
                "z": -21.80569839477539
            },
            {
                "x": -2.0582666397094727,
                "y": -0.06209500506520271,
                "z": -21.655244827270508
            },
            {
                "x": -2.0124619007110596,
                "y": -0.06029780954122543,
                "z": -21.504732131958008
            },
            {
                "x": -1.9665753841400146,
                "y": -0.058122601360082626,
                "z": -21.354360580444336
            },
            {
                "x": -1.9206616878509521,
                "y": -0.05562152713537216,
                "z": -21.203880310058594
            },
            {
                "x": -1.8748650550842285,
                "y": -0.0527246817946434,
                "z": -21.053348541259766
            },
            {
                "x": -1.8293486833572388,
                "y": -0.049342747777700424,
                "z": -20.902828216552734
            },
            {
                "x": -1.784172773361206,
                "y": -0.04540654271841049,
                "z": -20.752086639404297
            },
            {
                "x": -1.739516258239746,
                "y": -0.040860969573259354,
                "z": -20.601306915283203
            },
            {
                "x": -1.6954668760299683,
                "y": -0.03562409058213234,
                "z": -20.45035171508789
            },
            {
                "x": -1.6521155834197998,
                "y": -0.02959599159657955,
                "z": -20.29900360107422
            },
            {
                "x": -1.6096364259719849,
                "y": -0.022922884672880173,
                "z": -20.14764976501465
            },
            {
                "x": -1.5680590867996216,
                "y": -0.016858356073498726,
                "z": -19.99605941772461
            },
            {
                "x": -1.5417522192001343,
                "y": -0.013573270291090012,
                "z": -19.897958755493164
            },
            {
                "x": -1.5018442869186401,
                "y": -0.009444543160498142,
                "z": -19.7458438873291
            },
            {
                "x": -1.462995171546936,
                "y": -0.006594723090529442,
                "z": -19.59332275390625
            },
            {
                "x": -1.4253284931182861,
                "y": -0.005192618817090988,
                "z": -19.440486907958984
            },
            {
                "x": -1.388831377029419,
                "y": -0.005000000819563866,
                "z": -19.28743553161621
            },
            {
                "x": -1.3534892797470093,
                "y": -0.005000005010515451,
                "z": -19.13397789001465
            },
            {
                "x": -1.3194010257720947,
                "y": -0.005000003147870302,
                "z": -18.980348587036133
            },
            {
                "x": -1.2865110635757446,
                "y": -0.005000001285225153,
                "z": -18.82647132873535
            },
            {
                "x": -1.2547600269317627,
                "y": -0.005000000353902578,
                "z": -18.672142028808594
            },
            {
                "x": -1.2241854667663574,
                "y": -0.005000001285225153,
                "z": -18.51778793334961
            },
            {
                "x": -1.1947797536849976,
                "y": -0.00500000175088644,
                "z": -18.363155364990234
            },
            {
                "x": -1.1664352416992188,
                "y": -0.005000002216547728,
                "z": -18.208328247070312
            },
            {
                "x": -1.1391377449035645,
                "y": -0.005000002216547728,
                "z": -18.053380966186523
            },
            {
                "x": -1.11278235912323,
                "y": -0.004999999422580004,
                "z": -17.898073196411133
            },
            {
                "x": -1.0874239206314087,
                "y": -0.005000005941838026,
                "z": -17.74281120300293
            },
            {
                "x": -1.0629067420959473,
                "y": -0.0050000036135315895,
                "z": -17.58742332458496
            },
            {
                "x": -1.0391628742218018,
                "y": -0.005000000819563866,
                "z": -17.43181037902832
            },
            {
                "x": -1.0161906480789185,
                "y": -0.0050000036135315895,
                "z": -17.276201248168945
            },
            {
                "x": -0.9938601851463318,
                "y": -0.00500000175088644,
                "z": -17.120399475097656
            },
            {
                "x": -0.9721097350120544,
                "y": -0.005000004544854164,
                "z": -16.964529037475586
            },
            {
                "x": -0.9508858323097229,
                "y": -0.005000004544854164,
                "z": -16.808692932128906
            },
            {
                "x": -0.9301173686981201,
                "y": -0.00500000175088644,
                "z": -16.652799606323242
            },
            {
                "x": -0.9097123146057129,
                "y": -0.004999999888241291,
                "z": -16.496868133544922
            },
            {
                "x": -0.8895923495292664,
                "y": -0.005000000353902578,
                "z": -16.34090805053711
            },
            {
                "x": -0.8696599006652832,
                "y": -0.005000000819563866,
                "z": -16.18472671508789
            },
            {
                "x": -0.849889874458313,
                "y": -0.005000001285225153,
                "z": -16.028738021850586
            },
            {
                "x": -0.8301604986190796,
                "y": -0.00500000175088644,
                "z": -15.872696876525879
            },
            {
                "x": -0.8104226589202881,
                "y": -0.005000002682209015,
                "z": -15.716643333435059
            },
            {
                "x": -0.7911559343338013,
                "y": -0.00500000175088644,
                "z": -15.560530662536621
            },
            {
                "x": -0.7727692723274231,
                "y": -0.00500000175088644,
                "z": -15.404106140136719
            },
            {
                "x": -0.7551409602165222,
                "y": -0.005000001285225153,
                "z": -15.24781608581543
            },
            {
                "x": -0.7380892634391785,
                "y": -0.005000002682209015,
                "z": -15.091471672058105
            },
            {
                "x": -0.7214716672897339,
                "y": -0.005000001285225153,
                "z": -14.934971809387207
            },
            {
                "x": -0.7051903009414673,
                "y": -0.005000003147870302,
                "z": -14.77856731414795
            },
            {
                "x": -0.689091145992279,
                "y": -0.005000000353902578,
                "z": -14.622051239013672
            },
            {
                "x": -0.6730811595916748,
                "y": -0.005000004544854164,
                "z": -14.465533256530762
            },
            {
                "x": -0.6571364402770996,
                "y": -0.005000002682209015,
                "z": -14.309107780456543
            },
            {
                "x": -0.6412150263786316,
                "y": -0.005000002216547728,
                "z": -14.152573585510254
            },
            {
                "x": -0.6253194212913513,
                "y": -0.004999999888241291,
                "z": -13.996150016784668
            },
            {
                "x": -0.609423816204071,
                "y": -0.005000000353902578,
                "z": -13.839723587036133
            },
            {
                "x": -0.5934948921203613,
                "y": -0.00500000175088644,
                "z": -13.683103561401367
            },
            {
                "x": -0.5775614976882935,
                "y": -0.0050000036135315895,
                "z": -13.526683807373047
            },
            {
                "x": -0.5615922808647156,
                "y": -0.005000000819563866,
                "z": -13.370268821716309
            },
            {
                "x": -0.5512543320655823,
                "y": -0.005000001285225153,
                "z": -13.269232749938965
            },
            {
                "x": -0.5352072715759277,
                "y": -0.005000000819563866,
                "z": -13.112828254699707
            },
            {
                "x": -0.5190929770469666,
                "y": -0.005000000819563866,
                "z": -12.956327438354492
            },
            {
                "x": -0.5029203295707703,
                "y": -0.005000002216547728,
                "z": -12.799833297729492
            },
            {
                "x": -0.4866994619369507,
                "y": -0.0050000036135315895,
                "z": -12.64344596862793
            },
            {
                "x": -0.47040560841560364,
                "y": -0.005000000353902578,
                "z": -12.486953735351562
            },
            {
                "x": -0.45406171679496765,
                "y": -0.005000002216547728,
                "z": -12.330580711364746
            },
            {
                "x": -0.43765708804130554,
                "y": -0.00500000175088644,
                "z": -12.174211502075195
            },
            {
                "x": -0.42117175459861755,
                "y": -0.005000000819563866,
                "z": -12.017648696899414
            },
            {
                "x": -0.4046497642993927,
                "y": -0.005000001285225153,
                "z": -11.86129379272461
            },
            {
                "x": -0.38793617486953735,
                "y": -0.005000000819563866,
                "z": -11.704919815063477
            },
            {
                "x": -0.3705027401447296,
                "y": -0.0050000036135315895,
                "z": -11.548643112182617
            },
            {
                "x": -0.35230356454849243,
                "y": -0.005000002682209015,
                "z": -11.392508506774902
            },
            {
                "x": -0.33336159586906433,
                "y": -0.004999999422580004,
                "z": -11.236255645751953
            },
            {
                "x": -0.31382039189338684,
                "y": -0.005000000819563866,
                "z": -11.08027458190918
            },
            {
                "x": -0.2937234044075012,
                "y": -0.00500000175088644,
                "z": -10.924358367919922
            },
            {
                "x": -0.27310845255851746,
                "y": -0.005000004079192877,
                "z": -10.76839828491211
            },
            {
                "x": -0.2520809471607208,
                "y": -0.00500000175088644,
                "z": -10.612597465515137
            },
            {
                "x": -0.23068785667419434,
                "y": -0.005000001285225153,
                "z": -10.456743240356445
            },
            {
                "x": -0.20900800824165344,
                "y": -0.00500000175088644,
                "z": -10.300924301147461
            },
            {
                "x": -0.18714407086372375,
                "y": -0.005000000353902578,
                "z": -10.145217895507812
            },
            {
                "x": -0.16571186482906342,
                "y": -0.00500000175088644,
                "z": -9.989423751831055
            },
            {
                "x": -0.1450292319059372,
                "y": -0.00500000175088644,
                "z": -9.833526611328125
            },
            {
                "x": -0.12511105835437775,
                "y": -0.005000000819563866,
                "z": -9.677531242370605
            },
            {
                "x": -0.10595474392175674,
                "y": -0.005000000819563866,
                "z": -9.521240234375
            },
            {
                "x": -0.08758098632097244,
                "y": -0.005000000353902578,
                "z": -9.365058898925781
            },
            {
                "x": -0.06995879113674164,
                "y": -0.005000000819563866,
                "z": -9.208735466003418
            },
            {
                "x": -0.053119298070669174,
                "y": -0.00500000175088644,
                "z": -9.052326202392578
            },
            {
                "x": -0.03705178201198578,
                "y": -0.00500000175088644,
                "z": -8.895892143249512
            },
            {
                "x": -0.021710529923439026,
                "y": -0.00500000175088644,
                "z": -8.739185333251953
            },
            {
                "x": -0.007128150202333927,
                "y": -0.005000000819563866,
                "z": -8.582606315612793
            },
            {
                "x": 0.00669017992913723,
                "y": -0.00500000175088644,
                "z": -8.425962448120117
            },
            {
                "x": 0.019805900752544403,
                "y": -0.004999999888241291,
                "z": -8.269140243530273
            },
            {
                "x": 0.03221561014652252,
                "y": -0.0050000036135315895,
                "z": -8.11237907409668
            },
            {
                "x": 0.04394149035215378,
                "y": -0.00500000175088644,
                "z": -7.955469608306885
            },
            {
                "x": 0.05499473586678505,
                "y": -0.005000000819563866,
                "z": -7.798510551452637
            },
            {
                "x": 0.06541881710290909,
                "y": -0.005000002682209015,
                "z": -7.6416096687316895
            },
            {
                "x": 0.07530196756124496,
                "y": -0.00500000175088644,
                "z": -7.484569549560547
            },
            {
                "x": 0.08476856350898743,
                "y": -0.005000002682209015,
                "z": -7.327617645263672
            },
            {
                "x": 0.09400947391986847,
                "y": -0.005000000819563866,
                "z": -7.170654773712158
            },
            {
                "x": 0.10321001708507538,
                "y": -0.0050000036135315895,
                "z": -7.013493061065674
            },
            {
                "x": 0.11252307891845703,
                "y": -0.005000002682209015,
                "z": -6.85654354095459
            },
            {
                "x": 0.12216600775718689,
                "y": -0.004999999888241291,
                "z": -6.699615955352783
            },
            {
                "x": 0.12863750755786896,
                "y": -0.005000000819563866,
                "z": -6.598261833190918
            },
            {
                "x": 0.13871213793754578,
                "y": -0.005000002682209015,
                "z": -6.441346168518066
            },
            {
                "x": 0.14741505682468414,
                "y": -0.0050000036135315895,
                "z": -6.284228801727295
            },
            {
                "x": 0.15420451760292053,
                "y": -0.005000002682209015,
                "z": -6.12701940536499
            },
            {
                "x": 0.1591208428144455,
                "y": -0.00500000175088644,
                "z": -5.969841480255127
            },
            {
                "x": 0.1622513085603714,
                "y": -0.005000000819563866,
                "z": -5.812514305114746
            },
            {
                "x": 0.1643601953983307,
                "y": -0.005000000819563866,
                "z": -5.655292510986328
            },
            {
                "x": 0.16628946363925934,
                "y": -0.005000000819563866,
                "z": -5.498072147369385
            },
            {
                "x": 0.1680922508239746,
                "y": -0.005000000819563866,
                "z": -5.34065055847168
            },
            {
                "x": 0.16976958513259888,
                "y": -0.005000002682209015,
                "z": -5.183427810668945
            },
            {
                "x": 0.17127197980880737,
                "y": -0.00500000175088644,
                "z": -5.026142597198486
            },
            {
                "x": 0.17167502641677856,
                "y": -0.005000002682209015,
                "z": -4.868846893310547
            },
            {
                "x": 0.17058007419109344,
                "y": -0.00500000175088644,
                "z": -4.711615562438965
            },
            {
                "x": 0.16817770898342133,
                "y": -0.005000000819563866,
                "z": -4.55419921875
            },
            {
                "x": 0.1646406650543213,
                "y": -0.005000000819563866,
                "z": -4.397006511688232
            },
            {
                "x": 0.16022557020187378,
                "y": -0.00500000175088644,
                "z": -4.239836692810059
            },
            {
                "x": 0.15512903034687042,
                "y": -0.005000002682209015,
                "z": -4.082578182220459
            },
            {
                "x": 0.14955516159534454,
                "y": -0.00500000175088644,
                "z": -3.9254488945007324
            },
            {
                "x": 0.1436949074268341,
                "y": -0.00500000175088644,
                "z": -3.7682271003723145
            },
            {
                "x": 0.137782484292984,
                "y": -0.00500000175088644,
                "z": -3.61100697517395
            },
            {
                "x": 0.13192148506641388,
                "y": -0.004999996162950993,
                "z": -3.4538862705230713
            },
            {
                "x": 0.12572455406188965,
                "y": -0.00500000175088644,
                "z": -3.2967770099639893
            },
            {
                "x": 0.11920288950204849,
                "y": -0.005000002682209015,
                "z": -3.1396830081939697
            },
            {
                "x": 0.11252028495073318,
                "y": -0.005000000819563866,
                "z": -2.982595443725586
            },
            {
                "x": 0.10582932829856873,
                "y": -0.00500000175088644,
                "z": -2.825305223464966
            },
            {
                "x": 0.09929715096950531,
                "y": -0.005000002682209015,
                "z": -2.668208122253418
            },
            {
                "x": 0.09309947490692139,
                "y": -0.00500000175088644,
                "z": -2.5110397338867188
            },
            {
                "x": 0.08736950159072876,
                "y": -0.004999999888241291,
                "z": -2.3538522720336914
            },
            {
                "x": 0.08203857392072678,
                "y": -0.004999999888241291,
                "z": -2.196707248687744
            },
            {
                "x": 0.07689563184976578,
                "y": -0.005000002682209015,
                "z": -2.039358377456665
            },
            {
                "x": 0.07174404710531235,
                "y": -0.00500000175088644,
                "z": -1.8822141885757446
            },
            {
                "x": 0.06638117879629135,
                "y": -0.004999999888241291,
                "z": -1.7250806093215942
            },
            {
                "x": 0.06062629446387291,
                "y": -0.00500000175088644,
                "z": -1.567846417427063
            },
            {
                "x": 0.054324399679899216,
                "y": -0.00500000175088644,
                "z": -1.410754680633545
            },
            {
                "x": 0.047296129167079926,
                "y": -0.005000000819563866,
                "z": -1.2535969018936157
            },
            {
                "x": 0.03946641832590103,
                "y": -0.004999999888241291,
                "z": -1.0964800119400024
            },
            {
                "x": 0.030907751992344856,
                "y": -0.005000002682209015,
                "z": -0.9394914507865906
            },
            {
                "x": 0.022293109446763992,
                "y": -0.0050000036135315895,
                "z": -0.7823836803436279
            },
            {
                "x": 0.013950579799711704,
                "y": -0.004999998956918716,
                "z": -0.6253643035888672
            },
            {
                "x": 0.006179682910442352,
                "y": -0.005000000819563866,
                "z": -0.4683038294315338
            },
            {
                "x": -0.0004686174215748906,
                "y": -0.004999998956918716,
                "z": -0.3109692633152008
            },
            {
                "x": -0.004934437107294798,
                "y": -0.00500000175088644,
                "z": -0.153717502951622
            },
            {
                "x": -0.005317103583365679,
                "y": -0.005000000819563866,
                "z": 0.0036407262086868286
            }
        ],
        "lane4":[
            {
                "x": 0.11031627655029297,
                "y": 0.019130274653434753,
                "z": -419.5829162597656
            },
            {
                "x": 0.11019748449325562,
                "y": 0.019125208258628845,
                "z": -419.4781188964844
            },
            {
                "x": 0.11001917719841003,
                "y": 0.019117578864097595,
                "z": -419.3208923339844
            },
            {
                "x": 0.10984086990356445,
                "y": 0.019109994173049927,
                "z": -419.1635437011719
            },
            {
                "x": 0.10966259241104126,
                "y": 0.01910237967967987,
                "z": -419.0061950683594
            },
            {
                "x": 0.10948446393013,
                "y": 0.019094794988632202,
                "z": -418.8489685058594
            },
            {
                "x": 0.10930612683296204,
                "y": 0.019087165594100952,
                "z": -418.6916198730469
            },
            {
                "x": 0.10912790894508362,
                "y": 0.01907956600189209,
                "z": -418.5343933105469
            },
            {
                "x": 0.10894960165023804,
                "y": 0.01907198131084442,
                "z": -418.3771667480469
            },
            {
                "x": 0.10877123475074768,
                "y": 0.01906435191631317,
                "z": -418.2197570800781
            },
            {
                "x": 0.10859304666519165,
                "y": 0.019056767225265503,
                "z": -418.0625305175781
            },
            {
                "x": 0.10841476917266846,
                "y": 0.019049152731895447,
                "z": -417.9052429199219
            },
            {
                "x": 0.10823655128479004,
                "y": 0.01904156804084778,
                "z": -417.7479553222656
            },
            {
                "x": 0.10805824398994446,
                "y": 0.019033953547477722,
                "z": -417.5907287597656
            },
            {
                "x": 0.1078798770904541,
                "y": 0.019026339054107666,
                "z": -417.4332580566406
            },
            {
                "x": 0.1077016294002533,
                "y": 0.01901872456073761,
                "z": -417.2760314941406
            },
            {
                "x": 0.10752353072166443,
                "y": 0.019011124968528748,
                "z": -417.1188049316406
            },
            {
                "x": 0.10734519362449646,
                "y": 0.019003525376319885,
                "z": -416.9614562988281
            },
            {
                "x": 0.10716694593429565,
                "y": 0.018995940685272217,
                "z": -416.8042297363281
            },
            {
                "x": 0.10698860883712769,
                "y": 0.018988296389579773,
                "z": -416.6469421386719
            },
            {
                "x": 0.10681027173995972,
                "y": 0.0189807265996933,
                "z": -416.4895935058594
            },
            {
                "x": 0.10663208365440369,
                "y": 0.018973127007484436,
                "z": -416.33233642578125
            },
            {
                "x": 0.10645389556884766,
                "y": 0.018965527415275574,
                "z": -416.17510986328125
            },
            {
                "x": 0.10627570748329163,
                "y": 0.018957912921905518,
                "z": -416.01788330078125
            },
            {
                "x": 0.1060975193977356,
                "y": 0.018950313329696655,
                "z": -415.86065673828125
            },
            {
                "x": 0.10591909289360046,
                "y": 0.018942713737487793,
                "z": -415.7032470703125
            },
            {
                "x": 0.10574087500572205,
                "y": 0.018935099244117737,
                "z": -415.5459899902344
            },
            {
                "x": 0.10556259751319885,
                "y": 0.018927499651908875,
                "z": -415.3887023925781
            },
            {
                "x": 0.10538437962532043,
                "y": 0.018919900059700012,
                "z": -415.2314147949219
            },
            {
                "x": 0.10520607233047485,
                "y": 0.018912270665168762,
                "z": -415.0741882324219
            },
            {
                "x": 0.10502773523330688,
                "y": 0.018904685974121094,
                "z": -414.916748046875
            },
            {
                "x": 0.10484948754310608,
                "y": 0.018897101283073425,
                "z": -414.759521484375
            },
            {
                "x": 0.10467132925987244,
                "y": 0.01888948678970337,
                "z": -414.602294921875
            },
            {
                "x": 0.10449305176734924,
                "y": 0.018881872296333313,
                "z": -414.4449462890625
            },
            {
                "x": 0.10431480407714844,
                "y": 0.01887427270412445,
                "z": -414.2877197265625
            },
            {
                "x": 0.10413649678230286,
                "y": 0.0188666433095932,
                "z": -414.13037109375
            },
            {
                "x": 0.10395818948745728,
                "y": 0.01885904371738434,
                "z": -413.9730529785156
            },
            {
                "x": 0.10378003120422363,
                "y": 0.018851444125175476,
                "z": -413.8157958984375
            },
            {
                "x": 0.10360166430473328,
                "y": 0.018843859434127808,
                "z": -413.6584777832031
            },
            {
                "x": 0.10342344641685486,
                "y": 0.018836230039596558,
                "z": -413.5012512207031
            },
            {
                "x": 0.10324525833129883,
                "y": 0.0188286155462265,
                "z": -413.3440246582031
            },
            {
                "x": 0.10306686162948608,
                "y": 0.018821030855178833,
                "z": -413.18658447265625
            },
            {
                "x": 0.10288867354393005,
                "y": 0.018813416361808777,
                "z": -413.02935791015625
            },
            {
                "x": 0.10271039605140686,
                "y": 0.018805816769599915,
                "z": -412.87213134765625
            },
            {
                "x": 0.10259425640106201,
                "y": 0.01880086213350296,
                "z": -412.7705383300781
            },
            {
                "x": 0.10241609811782837,
                "y": 0.018793277442455292,
                "z": -412.6133117675781
            },
            {
                "x": 0.10223779082298279,
                "y": 0.018785685300827026,
                "z": -412.45599365234375
            },
            {
                "x": 0.10205939412117004,
                "y": 0.018778078258037567,
                "z": -412.29864501953125
            },
            {
                "x": 0.10188120603561401,
                "y": 0.018770448863506317,
                "z": -412.14141845703125
            },
            {
                "x": 0.10170292854309082,
                "y": 0.018762841820716858,
                "z": -411.98406982421875
            },
            {
                "x": 0.10152477025985718,
                "y": 0.018755249679088593,
                "z": -411.82684326171875
            },
            {
                "x": 0.10134652256965637,
                "y": 0.018747642636299133,
                "z": -411.66961669921875
            },
            {
                "x": 0.10116806626319885,
                "y": 0.018740035593509674,
                "z": -411.5121765136719
            },
            {
                "x": 0.10098987817764282,
                "y": 0.018732436001300812,
                "z": -411.3549499511719
            },
            {
                "x": 0.1008116602897644,
                "y": 0.018724828958511353,
                "z": -411.1976623535156
            },
            {
                "x": 0.10063344240188599,
                "y": 0.01871722936630249,
                "z": -411.0403747558594
            },
            {
                "x": 0.10045516490936279,
                "y": 0.018709614872932434,
                "z": -410.88311767578125
            },
            {
                "x": 0.10027673840522766,
                "y": 0.018702030181884766,
                "z": -410.7257080078125
            },
            {
                "x": 0.10009855031967163,
                "y": 0.018694408237934113,
                "z": -410.5684814453125
            },
            {
                "x": 0.09992033243179321,
                "y": 0.018686801195144653,
                "z": -410.4112548828125
            },
            {
                "x": 0.09974199533462524,
                "y": 0.018679209053516388,
                "z": -410.25390625
            },
            {
                "x": 0.09956374764442444,
                "y": 0.018671587109565735,
                "z": -410.0966491699219
            },
            {
                "x": 0.09938549995422363,
                "y": 0.01866399496793747,
                "z": -409.9393615722656
            },
            {
                "x": 0.09920719265937805,
                "y": 0.018656380474567413,
                "z": -409.78204345703125
            },
            {
                "x": 0.09902903437614441,
                "y": 0.018648788332939148,
                "z": -409.62481689453125
            },
            {
                "x": 0.09885081648826599,
                "y": 0.01864118129014969,
                "z": -409.4675598144531
            },
            {
                "x": 0.09867265820503235,
                "y": 0.018633589148521423,
                "z": -409.3103332519531
            },
            {
                "x": 0.09849429130554199,
                "y": 0.018625959753990173,
                "z": -409.1531066894531
            },
            {
                "x": 0.0983160138130188,
                "y": 0.018618375062942505,
                "z": -408.99566650390625
            },
            {
                "x": 0.098137766122818,
                "y": 0.01861076056957245,
                "z": -408.83843994140625
            },
            {
                "x": 0.0979594886302948,
                "y": 0.018603168427944183,
                "z": -408.68115234375
            },
            {
                "x": 0.09778127074241638,
                "y": 0.01859554648399353,
                "z": -408.52386474609375
            },
            {
                "x": 0.0976029634475708,
                "y": 0.018587954342365265,
                "z": -408.36663818359375
            },
            {
                "x": 0.09742459654808044,
                "y": 0.018580332398414612,
                "z": -408.209228515625
            },
            {
                "x": 0.09724640846252441,
                "y": 0.01857273280620575,
                "z": -408.0519714355469
            },
            {
                "x": 0.097068190574646,
                "y": 0.018565140664577484,
                "z": -407.894775390625
            },
            {
                "x": 0.09688994288444519,
                "y": 0.01855751872062683,
                "z": -407.7373962402344
            },
            {
                "x": 0.096711665391922,
                "y": 0.018549926578998566,
                "z": -407.5801696777344
            },
            {
                "x": 0.09653341770172119,
                "y": 0.018542319536209106,
                "z": -407.42279052734375
            },
            {
                "x": 0.09635508060455322,
                "y": 0.01853472739458084,
                "z": -407.2655029296875
            },
            {
                "x": 0.09617689251899719,
                "y": 0.018527112901210785,
                "z": -407.1082763671875
            },
            {
                "x": 0.095998615026474,
                "y": 0.018519528210163116,
                "z": -406.950927734375
            },
            {
                "x": 0.0958203375339508,
                "y": 0.018511906266212463,
                "z": -406.793701171875
            },
            {
                "x": 0.09564214944839478,
                "y": 0.018504329025745392,
                "z": -406.636474609375
            },
            {
                "x": 0.09546375274658203,
                "y": 0.018496684730052948,
                "z": -406.4790344238281
            },
            {
                "x": 0.09528547525405884,
                "y": 0.018489107489585876,
                "z": -406.32177734375
            },
            {
                "x": 0.09510728716850281,
                "y": 0.018481500446796417,
                "z": -406.1645812988281
            },
            {
                "x": 0.09499114751815796,
                "y": 0.018476545810699463,
                "z": -406.06298828125
            },
            {
                "x": 0.09481298923492432,
                "y": 0.018468931317329407,
                "z": -405.90576171875
            },
            {
                "x": 0.09463468194007874,
                "y": 0.01846133917570114,
                "z": -405.7484436035156
            },
            {
                "x": 0.09445640444755554,
                "y": 0.018453732132911682,
                "z": -405.5910949707031
            },
            {
                "x": 0.09427809715270996,
                "y": 0.018446117639541626,
                "z": -405.4338684082031
            },
            {
                "x": 0.09409987926483154,
                "y": 0.01843852549791336,
                "z": -405.2764892578125
            },
            {
                "x": 0.09392160177230835,
                "y": 0.018430903553962708,
                "z": -405.1192932128906
            },
            {
                "x": 0.09374335408210754,
                "y": 0.018423303961753845,
                "z": -404.9620666503906
            },
            {
                "x": 0.09356501698493958,
                "y": 0.018415704369544983,
                "z": -404.80462646484375
            },
            {
                "x": 0.09338676929473877,
                "y": 0.01840810477733612,
                "z": -404.64739990234375
            },
            {
                "x": 0.09320855140686035,
                "y": 0.01840049773454666,
                "z": -404.4901123046875
            },
            {
                "x": 0.09303033351898193,
                "y": 0.018392883241176605,
                "z": -404.33282470703125
            },
            {
                "x": 0.09285202622413635,
                "y": 0.018385298550128937,
                "z": -404.1755676269531
            },
            {
                "x": 0.092673659324646,
                "y": 0.018377676606178284,
                "z": -404.0180969238281
            },
            {
                "x": 0.0924953818321228,
                "y": 0.01837007701396942,
                "z": -403.86090087890625
            },
            {
                "x": 0.09231728315353394,
                "y": 0.018362469971179962,
                "z": -403.70367431640625
            },
            {
                "x": 0.09213894605636597,
                "y": 0.018354877829551697,
                "z": -403.54632568359375
            },
            {
                "x": 0.09196072816848755,
                "y": 0.018347255885601044,
                "z": -403.38909912109375
            },
            {
                "x": 0.09178239107131958,
                "y": 0.018339648842811584,
                "z": -403.2317810058594
            },
            {
                "x": 0.09160414338111877,
                "y": 0.01833203434944153,
                "z": -403.0744323730469
            },
            {
                "x": 0.0914258360862732,
                "y": 0.018324442207813263,
                "z": -402.9172058105469
            },
            {
                "x": 0.09124773740768433,
                "y": 0.0183168426156044,
                "z": -402.7599792480469
            },
            {
                "x": 0.09106948971748352,
                "y": 0.01830924302339554,
                "z": -402.6027526855469
            },
            {
                "x": 0.09089130163192749,
                "y": 0.018301643431186676,
                "z": -402.4455261230469
            },
            {
                "x": 0.09071290493011475,
                "y": 0.018294043838977814,
                "z": -402.2880859375
            },
            {
                "x": 0.09053462743759155,
                "y": 0.018286436796188354,
                "z": -402.130859375
            },
            {
                "x": 0.09035640954971313,
                "y": 0.0182788223028183,
                "z": -401.9735412597656
            },
            {
                "x": 0.09017813205718994,
                "y": 0.01827121526002884,
                "z": -401.8163146972656
            },
            {
                "x": 0.0899999737739563,
                "y": 0.01826363056898117,
                "z": -401.6590270996094
            },
            {
                "x": 0.08982151746749878,
                "y": 0.018256016075611115,
                "z": -401.5016174316406
            },
            {
                "x": 0.08964341878890991,
                "y": 0.01824840158224106,
                "z": -401.3443908691406
            },
            {
                "x": 0.08946511149406433,
                "y": 0.018240801990032196,
                "z": -401.1871643066406
            },
            {
                "x": 0.08928671479225159,
                "y": 0.01823320984840393,
                "z": -401.0298156738281
            },
            {
                "x": 0.08910861611366272,
                "y": 0.01822561025619507,
                "z": -400.8725891113281
            },
            {
                "x": 0.08893027901649475,
                "y": 0.018217995762825012,
                "z": -400.7152404785156
            },
            {
                "x": 0.08875197172164917,
                "y": 0.01821039617061615,
                "z": -400.55792236328125
            },
            {
                "x": 0.08857369422912598,
                "y": 0.018202774226665497,
                "z": -400.4007263183594
            },
            {
                "x": 0.08839544653892517,
                "y": 0.018195167183876038,
                "z": -400.2433166503906
            },
            {
                "x": 0.08821725845336914,
                "y": 0.018187575042247772,
                "z": -400.0860900878906
            },
            {
                "x": 0.08803904056549072,
                "y": 0.018179967999458313,
                "z": -399.92889404296875
            },
            {
                "x": 0.08786064386367798,
                "y": 0.018172383308410645,
                "z": -399.7714538574219
            },
            {
                "x": 0.08768239617347717,
                "y": 0.01816476136445999,
                "z": -399.6142272949219
            },
            {
                "x": 0.08750417828559875,
                "y": 0.018157169222831726,
                "z": -399.4570007324219
            },
            {
                "x": 0.08738809823989868,
                "y": 0.018152199685573578,
                "z": -399.35540771484375
            },
            {
                "x": 0.08720991015434265,
                "y": 0.018144600093364716,
                "z": -399.1982116699219
            },
            {
                "x": 0.08703157305717468,
                "y": 0.01813700795173645,
                "z": -399.0408630371094
            },
            {
                "x": 0.08685329556465149,
                "y": 0.01812940090894699,
                "z": -398.8835144042969
            },
            {
                "x": 0.08667498826980591,
                "y": 0.018121786415576935,
                "z": -398.7262878417969
            },
            {
                "x": 0.08649671077728271,
                "y": 0.01811419427394867,
                "z": -398.5689392089844
            },
            {
                "x": 0.08631855249404907,
                "y": 0.018106594681739807,
                "z": -398.4117126464844
            },
            {
                "x": 0.08614024519920349,
                "y": 0.01809898018836975,
                "z": -398.2544860839844
            },
            {
                "x": 0.08596190810203552,
                "y": 0.018091373145580292,
                "z": -398.0970458984375
            },
            {
                "x": 0.08578366041183472,
                "y": 0.01808377355337143,
                "z": -397.9398193359375
            },
            {
                "x": 0.0856054425239563,
                "y": 0.01807616651058197,
                "z": -397.78253173828125
            },
            {
                "x": 0.0854271650314331,
                "y": 0.018068552017211914,
                "z": -397.625244140625
            },
            {
                "x": 0.08524894714355469,
                "y": 0.018060967326164246,
                "z": -397.468017578125
            },
            {
                "x": 0.08507052063941956,
                "y": 0.018053337931632996,
                "z": -397.3105773925781
            },
            {
                "x": 0.08489230275154114,
                "y": 0.018045760691165924,
                "z": -397.1533508300781
            },
            {
                "x": 0.08471411466598511,
                "y": 0.018038161098957062,
                "z": -396.9961242675781
            },
            {
                "x": 0.08453583717346191,
                "y": 0.01803053915500641,
                "z": -396.8387756347656
            },
            {
                "x": 0.0843576192855835,
                "y": 0.018022924661636353,
                "z": -396.6815490722656
            },
            {
                "x": 0.08417931199073792,
                "y": 0.018015332520008087,
                "z": -396.52423095703125
            },
            {
                "x": 0.08400097489356995,
                "y": 0.018007732927799225,
                "z": -396.36688232421875
            },
            {
                "x": 0.0838228166103363,
                "y": 0.018000110983848572,
                "z": -396.2096862792969
            },
            {
                "x": 0.08364462852478027,
                "y": 0.017992518842220306,
                "z": -396.05242919921875
            },
            {
                "x": 0.08346644043922424,
                "y": 0.017984919250011444,
                "z": -395.89520263671875
            },
            {
                "x": 0.08328816294670105,
                "y": 0.017977319657802582,
                "z": -395.73797607421875
            },
            {
                "x": 0.08310982584953308,
                "y": 0.017969705164432526,
                "z": -395.5805969238281
            },
            {
                "x": 0.08293157815933228,
                "y": 0.01796211302280426,
                "z": -395.4233703613281
            },
            {
                "x": 0.0827532410621643,
                "y": 0.017954498529434204,
                "z": -395.2660827636719
            },
            {
                "x": 0.08257502317428589,
                "y": 0.017946898937225342,
                "z": -395.1087951660156
            },
            {
                "x": 0.08239680528640747,
                "y": 0.01793927699327469,
                "z": -394.9515686035156
            },
            {
                "x": 0.08221843838691711,
                "y": 0.017931699752807617,
                "z": -394.79412841796875
            },
            {
                "x": 0.0820402204990387,
                "y": 0.01792408525943756,
                "z": -394.63690185546875
            },
            {
                "x": 0.08186197280883789,
                "y": 0.0179164856672287,
                "z": -394.47967529296875
            },
            {
                "x": 0.08168360590934753,
                "y": 0.017908848822116852,
                "z": -394.3223571777344
            },
            {
                "x": 0.08150547742843628,
                "y": 0.017901264131069183,
                "z": -394.16510009765625
            },
            {
                "x": 0.08132714033126831,
                "y": 0.017893671989440918,
                "z": -394.00775146484375
            },
            {
                "x": 0.08114880323410034,
                "y": 0.017886042594909668,
                "z": -393.8504638671875
            },
            {
                "x": 0.08097055554389954,
                "y": 0.017878457903862,
                "z": -393.6932373046875
            },
            {
                "x": 0.08079233765602112,
                "y": 0.017870835959911346,
                "z": -393.535888671875
            },
            {
                "x": 0.0806141197681427,
                "y": 0.017863258719444275,
                "z": -393.378662109375
            },
            {
                "x": 0.0804358720779419,
                "y": 0.017855636775493622,
                "z": -393.221435546875
            },
            {
                "x": 0.08025750517845154,
                "y": 0.01784803718328476,
                "z": -393.06396484375
            },
            {
                "x": 0.08007931709289551,
                "y": 0.017840422689914703,
                "z": -392.90673828125
            },
            {
                "x": 0.07990103960037231,
                "y": 0.017832837998867035,
                "z": -392.74951171875
            },
            {
                "x": 0.07978489995002747,
                "y": 0.017827868461608887,
                "z": -392.6479187011719
            },
            {
                "x": 0.07960671186447144,
                "y": 0.017820268869400024,
                "z": -392.49072265625
            },
            {
                "x": 0.07942834496498108,
                "y": 0.017812661826610565,
                "z": -392.33343505859375
            },
            {
                "x": 0.07925015687942505,
                "y": 0.017805054783821106,
                "z": -392.1760559082031
            },
            {
                "x": 0.07907190918922424,
                "y": 0.017797470092773438,
                "z": -392.0188293457031
            },
            {
                "x": 0.07889357209205627,
                "y": 0.017789840698242188,
                "z": -391.8614807128906
            },
            {
                "x": 0.07871535420417786,
                "y": 0.017782263457775116,
                "z": -391.7042541503906
            },
            {
                "x": 0.07853716611862183,
                "y": 0.01777464896440506,
                "z": -391.5470275878906
            },
            {
                "x": 0.07835876941680908,
                "y": 0.017767027020454407,
                "z": -391.38958740234375
            },
            {
                "x": 0.07818049192428589,
                "y": 0.017759427428245544,
                "z": -391.2323303222656
            },
            {
                "x": 0.07800224423408508,
                "y": 0.017751850187778473,
                "z": -391.0750732421875
            },
            {
                "x": 0.07782405614852905,
                "y": 0.017744235694408417,
                "z": -390.9177551269531
            },
            {
                "x": 0.07764583826065063,
                "y": 0.017736636102199554,
                "z": -390.76055908203125
            },
            {
                "x": 0.07746738195419312,
                "y": 0.017728999257087708,
                "z": -390.6031188964844
            },
            {
                "x": 0.07728913426399231,
                "y": 0.01772141456604004,
                "z": -390.4458923339844
            },
            {
                "x": 0.07711103558540344,
                "y": 0.01771382987499237,
                "z": -390.2886657714844
            },
            {
                "x": 0.07693269848823547,
                "y": 0.01770622283220291,
                "z": -390.1313171386719
            },
            {
                "x": 0.07675445079803467,
                "y": 0.017698608338832855,
                "z": -389.9740905761719
            },
            {
                "x": 0.07657614350318909,
                "y": 0.01769101619720459,
                "z": -389.8167724609375
            },
            {
                "x": 0.0763978660106659,
                "y": 0.017683416604995728,
                "z": -389.6593933105469
            },
            {
                "x": 0.07621964812278748,
                "y": 0.017675772309303284,
                "z": -389.502197265625
            },
            {
                "x": 0.07604146003723145,
                "y": 0.01766820251941681,
                "z": -389.344970703125
            },
            {
                "x": 0.07586333155632019,
                "y": 0.01766059547662735,
                "z": -389.1877136230469
            },
            {
                "x": 0.07568499445915222,
                "y": 0.017652980983257294,
                "z": -389.030517578125
            },
            {
                "x": 0.07550659775733948,
                "y": 0.01764538139104843,
                "z": -388.8730773925781
            },
            {
                "x": 0.07532840967178345,
                "y": 0.017637766897678375,
                "z": -388.7158508300781
            },
            {
                "x": 0.07515019178390503,
                "y": 0.017630167305469513,
                "z": -388.5585632324219
            },
            {
                "x": 0.07497185468673706,
                "y": 0.01762256771326065,
                "z": -388.4012756347656
            },
            {
                "x": 0.07479366660118103,
                "y": 0.017614975571632385,
                "z": -388.2440490722656
            },
            {
                "x": 0.07461529970169067,
                "y": 0.017607353627681732,
                "z": -388.0865783691406
            },
            {
                "x": 0.07443708181381226,
                "y": 0.017599739134311676,
                "z": -387.92938232421875
            },
            {
                "x": 0.07425883412361145,
                "y": 0.017592139542102814,
                "z": -387.7721252441406
            },
            {
                "x": 0.07408052682876587,
                "y": 0.01758454740047455,
                "z": -387.61480712890625
            },
            {
                "x": 0.07390233874320984,
                "y": 0.017576932907104492,
                "z": -387.45758056640625
            },
            {
                "x": 0.07372397184371948,
                "y": 0.017569325864315033,
                "z": -387.3002624511719
            },
            {
                "x": 0.07354572415351868,
                "y": 0.017561711370944977,
                "z": -387.1429138183594
            },
            {
                "x": 0.07336747646331787,
                "y": 0.017554141581058502,
                "z": -386.9856872558594
            },
            {
                "x": 0.07318919897079468,
                "y": 0.017546534538269043,
                "z": -386.8283386230469
            },
            {
                "x": 0.07301098108291626,
                "y": 0.017538920044898987,
                "z": -386.6711120605469
            },
            {
                "x": 0.07283273339271545,
                "y": 0.017531290650367737,
                "z": -386.5138854980469
            },
            {
                "x": 0.07265439629554749,
                "y": 0.01752370595932007,
                "z": -386.3564453125
            },
            {
                "x": 0.07247605919837952,
                "y": 0.017516113817691803,
                "z": -386.1992492675781
            },
            {
                "x": 0.07229793071746826,
                "y": 0.01750849187374115,
                "z": -386.0419921875
            },
            {
                "x": 0.07218179106712341,
                "y": 0.017503537237644196,
                "z": -385.9403991699219
            },
            {
                "x": 0.07200363278388977,
                "y": 0.017495937645435333,
                "z": -385.7831726074219
            },
            {
                "x": 0.07182532548904419,
                "y": 0.017488345503807068,
                "z": -385.6258544921875
            },
            {
                "x": 0.07164698839187622,
                "y": 0.01748073101043701,
                "z": -385.468505859375
            },
            {
                "x": 0.07146874070167542,
                "y": 0.017473123967647552,
                "z": -385.311279296875
            },
            {
                "x": 0.07129043340682983,
                "y": 0.017465509474277496,
                "z": -385.1539611816406
            },
            {
                "x": 0.07111230492591858,
                "y": 0.01745791733264923,
                "z": -384.9967041015625
            },
            {
                "x": 0.07093396782875061,
                "y": 0.017450325191020966,
                "z": -384.8395080566406
            },
            {
                "x": 0.07075566053390503,
                "y": 0.01744271069765091,
                "z": -384.6820373535156
            },
            {
                "x": 0.07057741284370422,
                "y": 0.017435096204280853,
                "z": -384.5248107910156
            },
            {
                "x": 0.07039913535118103,
                "y": 0.017427481710910797,
                "z": -384.3675231933594
            },
            {
                "x": 0.07022091746330261,
                "y": 0.017419911921024323,
                "z": -384.2102355957031
            },
            {
                "x": 0.07004272937774658,
                "y": 0.017412282526493073,
                "z": -384.0530090332031
            },
            {
                "x": 0.06986427307128906,
                "y": 0.017404697835445404,
                "z": -383.89556884765625
            },
            {
                "x": 0.06968602538108826,
                "y": 0.017397083342075348,
                "z": -383.73834228515625
            },
            {
                "x": 0.06950783729553223,
                "y": 0.017389491200447083,
                "z": -383.5811462402344
            },
            {
                "x": 0.06932958960533142,
                "y": 0.017381861805915833,
                "z": -383.42376708984375
            },
            {
                "x": 0.06915134191513062,
                "y": 0.017374269664287567,
                "z": -383.26654052734375
            },
            {
                "x": 0.06897303462028503,
                "y": 0.017366677522659302,
                "z": -383.1092224121094
            },
            {
                "x": 0.06879469752311707,
                "y": 0.017359063029289246,
                "z": -382.9518737792969
            },
            {
                "x": 0.06861647963523865,
                "y": 0.01735147088766098,
                "z": -382.7946472167969
            },
            {
                "x": 0.06843835115432739,
                "y": 0.01734384149312973,
                "z": -382.6374206542969
            },
            {
                "x": 0.06826013326644897,
                "y": 0.01733623445034027,
                "z": -382.4801940917969
            },
            {
                "x": 0.06808188557624817,
                "y": 0.0173286572098732,
                "z": -382.3229675292969
            },
            {
                "x": 0.06790345907211304,
                "y": 0.01732105016708374,
                "z": -382.1655578613281
            },
            {
                "x": 0.0677253007888794,
                "y": 0.017313435673713684,
                "z": -382.00830078125
            },
            {
                "x": 0.0675470232963562,
                "y": 0.01730584353208542,
                "z": -381.85101318359375
            },
            {
                "x": 0.06736886501312256,
                "y": 0.017298229038715363,
                "z": -381.6937255859375
            },
            {
                "x": 0.06719061732292175,
                "y": 0.0172906294465065,
                "z": -381.5364990234375
            },
            {
                "x": 0.0670122504234314,
                "y": 0.017283007502555847,
                "z": -381.3790588378906
            },
            {
                "x": 0.06683400273323059,
                "y": 0.017275400459766388,
                "z": -381.2218322753906
            },
            {
                "x": 0.06665575504302979,
                "y": 0.017267808318138123,
                "z": -381.0646057128906
            },
            {
                "x": 0.06647753715515137,
                "y": 0.017260216176509857,
                "z": -380.9072570800781
            },
            {
                "x": 0.06629952788352966,
                "y": 0.017252616584300995,
                "z": -380.7500305175781
            },
            {
                "x": 0.06612128019332886,
                "y": 0.017244987189769745,
                "z": -380.5926818847656
            },
            {
                "x": 0.06594279408454895,
                "y": 0.017237380146980286,
                "z": -380.4353332519531
            },
            {
                "x": 0.06576508283615112,
                "y": 0.017229802906513214,
                "z": -380.278076171875
            },
            {
                "x": 0.0655890703201294,
                "y": 0.017222195863723755,
                "z": -380.1207580566406
            },
            {
                "x": 0.0654149055480957,
                "y": 0.0172145813703537,
                "z": -379.9635314941406
            },
            {
                "x": 0.0652385950088501,
                "y": 0.017206989228725433,
                "z": -379.8063049316406
            },
            {
                "x": 0.06506356596946716,
                "y": 0.01719936728477478,
                "z": -379.6488952636719
            },
            {
                "x": 0.06490027904510498,
                "y": 0.017191775143146515,
                "z": -379.49169921875
            },
            {
                "x": 0.06475457549095154,
                "y": 0.017184175550937653,
                "z": -379.33453369140625
            },
            {
                "x": 0.06466495990753174,
                "y": 0.017179198563098907,
                "z": -379.2329406738281
            },
            {
                "x": 0.06452086567878723,
                "y": 0.017171606421470642,
                "z": -379.0757141113281
            },
            {
                "x": 0.06439739465713501,
                "y": 0.017163999378681183,
                "z": -378.9185485839844
            },
            {
                "x": 0.06434032320976257,
                "y": 0.017156407237052917,
                "z": -378.761474609375
            },
            {
                "x": 0.06436842679977417,
                "y": 0.017148777842521667,
                "z": -378.6044921875
            },
            {
                "x": 0.06444281339645386,
                "y": 0.017141170799732208,
                "z": -378.44720458984375
            },
            {
                "x": 0.06455031037330627,
                "y": 0.017133548855781555,
                "z": -378.2902526855469
            },
            {
                "x": 0.0648047924041748,
                "y": 0.017126016318798065,
                "z": -378.1336669921875
            },
            {
                "x": 0.06529644131660461,
                "y": 0.017118334770202637,
                "z": -377.97711181640625
            },
            {
                "x": 0.0660158097743988,
                "y": 0.017110787332057953,
                "z": -377.8204345703125
            },
            {
                "x": 0.06687191128730774,
                "y": 0.017103128135204315,
                "z": -377.66363525390625
            },
            {
                "x": 0.06794878840446472,
                "y": 0.017095573246479034,
                "z": -377.50738525390625
            },
            {
                "x": 0.06940466165542603,
                "y": 0.017087943851947784,
                "z": -377.3515625
            },
            {
                "x": 0.07127410173416138,
                "y": 0.017080344259738922,
                "z": -377.1954040527344
            },
            {
                "x": 0.07345598936080933,
                "y": 0.01707274466753006,
                "z": -377.0389709472656
            },
            {
                "x": 0.07590183615684509,
                "y": 0.017065122723579407,
                "z": -376.8829040527344
            },
            {
                "x": 0.07878559827804565,
                "y": 0.017057515680789948,
                "z": -376.7273254394531
            },
            {
                "x": 0.08219555020332336,
                "y": 0.017049871385097504,
                "z": -376.5718078613281
            },
            {
                "x": 0.08605524897575378,
                "y": 0.01704232394695282,
                "z": -376.4156188964844
            },
            {
                "x": 0.09019666910171509,
                "y": 0.01703471690416336,
                "z": -376.25933837890625
            },
            {
                "x": 0.0947035551071167,
                "y": 0.0170271098613739,
                "z": -376.1037902832031
            },
            {
                "x": 0.0997491180896759,
                "y": 0.017019517719745636,
                "z": -375.94854736328125
            },
            {
                "x": 0.10535350441932678,
                "y": 0.017011910676956177,
                "z": -375.79296875
            },
            {
                "x": 0.1113162636756897,
                "y": 0.017004288733005524,
                "z": -375.63671875
            },
            {
                "x": 0.11756715178489685,
                "y": 0.016996704041957855,
                "z": -375.48065185546875
            },
            {
                "x": 0.12424778938293457,
                "y": 0.0169890895485878,
                "z": -375.32537841796875
            },
            {
                "x": 0.13152045011520386,
                "y": 0.016981489956378937,
                "z": -375.17010498046875
            },
            {
                "x": 0.13927435874938965,
                "y": 0.016973882913589478,
                "z": -375.0141296386719
            },
            {
                "x": 0.14731869101524353,
                "y": 0.016966260969638824,
                "z": -374.8580322265625
            },
            {
                "x": 0.1556846797466278,
                "y": 0.01695869117975235,
                "z": -374.70233154296875
            },
            {
                "x": 0.1645541489124298,
                "y": 0.016951046884059906,
                "z": -374.5471496582031
            },
            {
                "x": 0.17397698760032654,
                "y": 0.016943417489528656,
                "z": -374.39178466796875
            },
            {
                "x": 0.18381208181381226,
                "y": 0.01693582534790039,
                "z": -374.2357177734375
            },
            {
                "x": 0.1938958466053009,
                "y": 0.01692822575569153,
                "z": -374.0798645019531
            },
            {
                "x": 0.20437157154083252,
                "y": 0.016920670866966248,
                "z": -373.92449951171875
            },
            {
                "x": 0.21537688374519348,
                "y": 0.016913048923015594,
                "z": -373.76934814453125
            },
            {
                "x": 0.22688624262809753,
                "y": 0.016905449330806732,
                "z": -373.6138000488281
            },
            {
                "x": 0.2387300431728363,
                "y": 0.01689779758453369,
                "z": -373.4577941894531
            },
            {
                "x": 0.2508394718170166,
                "y": 0.01689022034406662,
                "z": -373.3022766113281
            },
            {
                "x": 0.26337769627571106,
                "y": 0.01688254624605179,
                "z": -373.1473388671875
            },
            {
                "x": 0.2764716148376465,
                "y": 0.0168750062584877,
                "z": -372.99200439453125
            },
            {
                "x": 0.28999561071395874,
                "y": 0.01686742901802063,
                "z": -372.83642578125
            },
            {
                "x": 0.3037949204444885,
                "y": 0.01685984805226326,
                "z": -372.6806640625
            },
            {
                "x": 0.31285837292671204,
                "y": 0.01685483753681183,
                "z": -372.5803527832031
            },
            {
                "x": 0.3272342085838318,
                "y": 0.01684725284576416,
                "z": -372.42547607421875
            },
            {
                "x": 0.3421649932861328,
                "y": 0.016839660704135895,
                "z": -372.27044677734375
            },
            {
                "x": 0.3575451970100403,
                "y": 0.016832008957862854,
                "z": -372.11480712890625
            },
            {
                "x": 0.37315475940704346,
                "y": 0.016824454069137573,
                "z": -371.95928955078125
            },
            {
                "x": 0.3890749514102936,
                "y": 0.016816839575767517,
                "z": -371.8041687011719
            },
            {
                "x": 0.40545469522476196,
                "y": 0.01680922508239746,
                "z": -371.6495056152344
            },
            {
                "x": 0.4223511517047882,
                "y": 0.0168016254901886,
                "z": -371.4945068359375
            },
            {
                "x": 0.4396347105503082,
                "y": 0.016794003546237946,
                "z": -371.33880615234375
            },
            {
                "x": 0.4571104049682617,
                "y": 0.016786441206932068,
                "z": -371.1836242675781
            },
            {
                "x": 0.4749363958835602,
                "y": 0.016778811812400818,
                "z": -371.0289306640625
            },
            {
                "x": 0.4932739734649658,
                "y": 0.01677120476961136,
                "z": -370.874267578125
            },
            {
                "x": 0.5120652914047241,
                "y": 0.01676362007856369,
                "z": -370.7192687988281
            },
            {
                "x": 0.5311643481254578,
                "y": 0.01675601303577423,
                "z": -370.5637512207031
            },
            {
                "x": 0.550471305847168,
                "y": 0.016748398542404175,
                "z": -370.408935546875
            },
            {
                "x": 0.5701853632926941,
                "y": 0.016740798950195312,
                "z": -370.2545471191406
            },
            {
                "x": 0.5904132127761841,
                "y": 0.016733214259147644,
                "z": -370.09991455078125
            },
            {
                "x": 0.6110254526138306,
                "y": 0.016725599765777588,
                "z": -369.94482421875
            },
            {
                "x": 0.6318676471710205,
                "y": 0.016718000173568726,
                "z": -369.7898254394531
            },
            {
                "x": 0.6529994010925293,
                "y": 0.016710400581359863,
                "z": -369.63531494140625
            },
            {
                "x": 0.6745538711547852,
                "y": 0.01670277863740921,
                "z": -369.4811096191406
            },
            {
                "x": 0.6965806484222412,
                "y": 0.016695186495780945,
                "z": -369.3265686035156
            },
            {
                "x": 0.7189375162124634,
                "y": 0.016687534749507904,
                "z": -369.17169189453125
            },
            {
                "x": 0.7414960861206055,
                "y": 0.01667994260787964,
                "z": -369.01715087890625
            },
            {
                "x": 0.7644115686416626,
                "y": 0.01667238026857376,
                "z": -368.8628845214844
            },
            {
                "x": 0.7877553105354309,
                "y": 0.016664758324623108,
                "z": -368.70880126953125
            },
            {
                "x": 0.8115453124046326,
                "y": 0.01665715128183365,
                "z": -368.55426025390625
            },
            {
                "x": 0.8355871438980103,
                "y": 0.016649551689624786,
                "z": -368.3995666503906
            },
            {
                "x": 0.8598349690437317,
                "y": 0.016641922295093536,
                "z": -368.2453918457031
            },
            {
                "x": 0.8844773769378662,
                "y": 0.016634345054626465,
                "z": -368.0914306640625
            },
            {
                "x": 0.9095622301101685,
                "y": 0.016626738011837006,
                "z": -367.9374084472656
            },
            {
                "x": 0.9350095987319946,
                "y": 0.016619093716144562,
                "z": -367.78302001953125
            },
            {
                "x": 0.9606719017028809,
                "y": 0.016611561179161072,
                "z": -367.62860107421875
            },
            {
                "x": 0.986569881439209,
                "y": 0.01660390943288803,
                "z": -367.47479248046875
            },
            {
                "x": 1.0128953456878662,
                "y": 0.01659635454416275,
                "z": -367.3211364746094
            },
            {
                "x": 1.039674162864685,
                "y": 0.016588769853115082,
                "z": -367.1671142578125
            },
            {
                "x": 1.0667146444320679,
                "y": 0.01658114790916443,
                "z": -367.01287841796875
            },
            {
                "x": 1.0939455032348633,
                "y": 0.016573511064052582,
                "z": -366.8589172363281
            },
            {
                "x": 1.1214593648910522,
                "y": 0.0165659561753273,
                "z": -366.7054748535156
            },
            {
                "x": 1.1494189500808716,
                "y": 0.016558349132537842,
                "z": -366.552001953125
            },
            {
                "x": 1.177810788154602,
                "y": 0.016550712287425995,
                "z": -366.3979797363281
            },
            {
                "x": 1.2063782215118408,
                "y": 0.01654314249753952,
                "z": -366.2440185546875
            },
            {
                "x": 1.235120177268982,
                "y": 0.01653549075126648,
                "z": -366.0906066894531
            },
            {
                "x": 1.2538866996765137,
                "y": 0.016530558466911316,
                "z": -365.99163818359375
            },
            {
                "x": 1.2832694053649902,
                "y": 0.01652298867702484,
                "z": -365.8384094238281
            },
            {
                "x": 1.3130536079406738,
                "y": 0.01651538908481598,
                "z": -365.6846923828125
            },
            {
                "x": 1.3430540561676025,
                "y": 0.016507737338542938,
                "z": -365.5309143066406
            },
            {
                "x": 1.3732186555862427,
                "y": 0.016500160098075867,
                "z": -365.377685546875
            },
            {
                "x": 1.403740644454956,
                "y": 0.016492515802383423,
                "z": -365.22467041015625
            },
            {
                "x": 1.4346628189086914,
                "y": 0.01648496836423874,
                "z": -365.0715637207031
            },
            {
                "x": 1.4658994674682617,
                "y": 0.016477376222610474,
                "z": -364.9180908203125
            },
            {
                "x": 1.4973372220993042,
                "y": 0.016469717025756836,
                "z": -364.7646179199219
            },
            {
                "x": 1.5289509296417236,
                "y": 0.01646214723587036,
                "z": -364.61181640625
            },
            {
                "x": 1.5609537363052368,
                "y": 0.01645451784133911,
                "z": -364.4590148925781
            },
            {
                "x": 1.5933562517166138,
                "y": 0.01644688844680786,
                "z": -364.30596923828125
            },
            {
                "x": 1.6259799003601074,
                "y": 0.016439303755760193,
                "z": -364.15277099609375
            },
            {
                "x": 1.6587998867034912,
                "y": 0.016431696712970734,
                "z": -363.9997253417969
            },
            {
                "x": 1.6918399333953857,
                "y": 0.016424089670181274,
                "z": -363.84722900390625
            },
            {
                "x": 1.7252801656723022,
                "y": 0.016416460275650024,
                "z": -363.6946105957031
            },
            {
                "x": 1.759085774421692,
                "y": 0.016408883035182953,
                "z": -363.5416564941406
            },
            {
                "x": 1.7930452823638916,
                "y": 0.016401298344135284,
                "z": -363.3887634277344
            },
            {
                "x": 1.8271836042404175,
                "y": 0.01639367640018463,
                "z": -363.2361755371094
            },
            {
                "x": 1.8616273403167725,
                "y": 0.01638604700565338,
                "z": -363.0838317871094
            },
            {
                "x": 1.8964440822601318,
                "y": 0.016378477215766907,
                "z": -362.93145751953125
            },
            {
                "x": 1.931530237197876,
                "y": 0.016370832920074463,
                "z": -362.77874755859375
            },
            {
                "x": 1.9667601585388184,
                "y": 0.016363278031349182,
                "z": -362.626220703125
            },
            {
                "x": 2.002188205718994,
                "y": 0.016355648636817932,
                "z": -362.47418212890625
            },
            {
                "x": 2.0379958152770996,
                "y": 0.01634804904460907,
                "z": -362.3219909667969
            },
            {
                "x": 2.0741312503814697,
                "y": 0.016340471804142,
                "z": -362.1696472167969
            },
            {
                "x": 2.1104776859283447,
                "y": 0.016332879662513733,
                "z": -362.0172119140625
            },
            {
                "x": 2.1469504833221436,
                "y": 0.016325220465660095,
                "z": -361.86505126953125
            },
            {
                "x": 2.183668375015259,
                "y": 0.016317643225193024,
                "z": -361.7132568359375
            },
            {
                "x": 2.2207772731781006,
                "y": 0.016310013830661774,
                "z": -361.56121826171875
            },
            {
                "x": 2.2581450939178467,
                "y": 0.01630242168903351,
                "z": -361.40911865234375
            },
            {
                "x": 2.2956833839416504,
                "y": 0.016294807195663452,
                "z": -361.2569885253906
            },
            {
                "x": 2.333388090133667,
                "y": 0.016287200152873993,
                "z": -361.1051025390625
            },
            {
                "x": 2.371321678161621,
                "y": 0.01627965271472931,
                "z": -360.9535827636719
            },
            {
                "x": 2.409637451171875,
                "y": 0.016272038221359253,
                "z": -360.8017883300781
            },
            {
                "x": 2.4482085704803467,
                "y": 0.016264431178569794,
                "z": -360.6497497558594
            },
            {
                "x": 2.4868650436401367,
                "y": 0.016256816685199738,
                "z": -360.498046875
            },
            {
                "x": 2.5257205963134766,
                "y": 0.016249187290668488,
                "z": -360.3465881347656
            },
            {
                "x": 2.564859390258789,
                "y": 0.016241587698459625,
                "z": -360.1952819824219
            },
            {
                "x": 2.6043150424957275,
                "y": 0.01623397320508957,
                "z": -360.0437316894531
            },
            {
                "x": 2.6440281867980957,
                "y": 0.016226381063461304,
                "z": -359.891845703125
            },
            {
                "x": 2.6837916374206543,
                "y": 0.01621878147125244,
                "z": -359.7405090332031
            },
            {
                "x": 2.72375226020813,
                "y": 0.016211166977882385,
                "z": -359.58935546875
            },
            {
                "x": 2.749737501144409,
                "y": 0.016206219792366028,
                "z": -359.4917297363281
            },
            {
                "x": 2.790210723876953,
                "y": 0.016198650002479553,
                "z": -359.3404846191406
            },
            {
                "x": 2.8308839797973633,
                "y": 0.016190990805625916,
                "z": -359.18890380859375
            },
            {
                "x": 2.8716659545898438,
                "y": 0.016183391213417053,
                "z": -359.0377197265625
            },
            {
                "x": 2.9126317501068115,
                "y": 0.01617582142353058,
                "z": -358.8868103027344
            },
            {
                "x": 2.9539237022399902,
                "y": 0.01616816222667694,
                "z": -358.7358703613281
            },
            {
                "x": 2.9954564571380615,
                "y": 0.016160599887371063,
                "z": -358.584716796875
            },
            {
                "x": 3.037142753601074,
                "y": 0.0161530002951622,
                "z": -358.43359375
            },
            {
                "x": 3.0789754390716553,
                "y": 0.01614542305469513,
                "z": -358.2825927734375
            },
            {
                "x": 3.1209707260131836,
                "y": 0.016137756407260895,
                "z": -358.1319580078125
            },
            {
                "x": 3.1632745265960693,
                "y": 0.016130149364471436,
                "z": -357.9812316894531
            },
            {
                "x": 3.205812454223633,
                "y": 0.016122527420520782,
                "z": -357.8302001953125
            },
            {
                "x": 3.2484450340270996,
                "y": 0.016114965081214905,
                "z": -357.679443359375
            },
            {
                "x": 3.2912485599517822,
                "y": 0.01610729843378067,
                "z": -357.5287170410156
            },
            {
                "x": 3.33424973487854,
                "y": 0.016099728643894196,
                "z": -357.3783264160156
            },
            {
                "x": 3.3775367736816406,
                "y": 0.016092129051685333,
                "z": -357.2277526855469
            },
            {
                "x": 3.421022653579712,
                "y": 0.016084499657154083,
                "z": -357.076904296875
            },
            {
                "x": 3.4645769596099854,
                "y": 0.016076907515525818,
                "z": -356.92645263671875
            },
            {
                "x": 3.5082967281341553,
                "y": 0.016069263219833374,
                "z": -356.7760925292969
            },
            {
                "x": 3.5522642135620117,
                "y": 0.01606166362762451,
                "z": -356.62579345703125
            },
            {
                "x": 3.5964877605438232,
                "y": 0.016054101288318634,
                "z": -356.4753723144531
            },
            {
                "x": 3.640812397003174,
                "y": 0.016046516597270966,
                "z": -356.32489013671875
            },
            {
                "x": 3.6852264404296875,
                "y": 0.016038909554481506,
                "z": -356.1747741699219
            },
            {
                "x": 3.7298130989074707,
                "y": 0.016031265258789062,
                "z": -356.02484130859375
            },
            {
                "x": 3.7747530937194824,
                "y": 0.016023658215999603,
                "z": -355.8744812011719
            },
            {
                "x": 3.81982159614563,
                "y": 0.016016051173210144,
                "z": -355.7242736816406
            },
            {
                "x": 3.8649795055389404,
                "y": 0.01600842922925949,
                "z": -355.5741271972656
            },
            {
                "x": 3.9102609157562256,
                "y": 0.016000844538211823,
                "z": -355.42413330078125
            },
            {
                "x": 3.955718994140625,
                "y": 0.015993215143680573,
                "z": -355.27435302734375
            },
            {
                "x": 4.001487731933594,
                "y": 0.015985585749149323,
                "z": -355.124267578125
            },
            {
                "x": 4.047354698181152,
                "y": 0.015978015959262848,
                "z": -354.97418212890625
            },
            {
                "x": 4.093299865722656,
                "y": 0.01597045361995697,
                "z": -354.8243103027344
            },
            {
                "x": 4.139405727386475,
                "y": 0.015962831676006317,
                "z": -354.6745910644531
            },
            {
                "x": 4.185686111450195,
                "y": 0.01595526933670044,
                "z": -354.5249938964844
            },
            {
                "x": 4.232222557067871,
                "y": 0.01594763994216919,
                "z": -354.3750305175781
            },
            {
                "x": 4.278865814208984,
                "y": 0.01594003289937973,
                "z": -354.22509765625
            },
            {
                "x": 4.3255510330200195,
                "y": 0.015932470560073853,
                "z": -354.0755615234375
            },
            {
                "x": 4.37243127822876,
                "y": 0.015924766659736633,
                "z": -353.9259948730469
            },
            {
                "x": 4.419468879699707,
                "y": 0.015917204320430756,
                "z": -353.7765808105469
            },
            {
                "x": 4.466721057891846,
                "y": 0.015909641981124878,
                "z": -353.6268615722656
            },
            {
                "x": 4.514116287231445,
                "y": 0.01590200513601303,
                "z": -353.4771423339844
            },
            {
                "x": 4.5615010261535645,
                "y": 0.015894435346126556,
                "z": -353.3277587890625
            },
            {
                "x": 4.609070301055908,
                "y": 0.01588679850101471,
                "z": -353.1784973144531
            },
            {
                "x": 4.639898300170898,
                "y": 0.015881896018981934,
                "z": -353.08203125
            },
            {
                "x": 4.687786102294922,
                "y": 0.015874244272708893,
                "z": -352.9325866699219
            },
            {
                "x": 4.735772132873535,
                "y": 0.01586659997701645,
                "z": -352.7831115722656
            },
            {
                "x": 4.783840179443359,
                "y": 0.015859030187129974,
                "z": -352.6338195800781
            },
            {
                "x": 4.832015037536621,
                "y": 0.015851430594921112,
                "z": -352.4847412109375
            },
            {
                "x": 4.880429744720459,
                "y": 0.015843860805034637,
                "z": -352.33544921875
            },
            {
                "x": 4.92896032333374,
                "y": 0.015836194157600403,
                "z": -352.18609619140625
            },
            {
                "x": 4.977525234222412,
                "y": 0.015828602015972137,
                "z": -352.03692626953125
            },
            {
                "x": 5.026239395141602,
                "y": 0.01582101732492447,
                "z": -351.8878173828125
            },
            {
                "x": 5.075076103210449,
                "y": 0.015813350677490234,
                "z": -351.7388916015625
            },
            {
                "x": 5.124095439910889,
                "y": 0.015805765986442566,
                "z": -351.5897216796875
            },
            {
                "x": 5.173210144042969,
                "y": 0.015798203647136688,
                "z": -351.4405822753906
            },
            {
                "x": 5.22238826751709,
                "y": 0.01579056680202484,
                "z": -351.2915954589844
            },
            {
                "x": 5.271695137023926,
                "y": 0.015782974660396576,
                "z": -351.1426086425781
            },
            {
                "x": 5.321115016937256,
                "y": 0.015775345265865326,
                "z": -350.9938049316406
            },
            {
                "x": 5.370668411254883,
                "y": 0.015767760574817657,
                "z": -350.84490966796875
            },
            {
                "x": 5.420387268066406,
                "y": 0.0157601460814476,
                "z": -350.6958312988281
            },
            {
                "x": 5.470083713531494,
                "y": 0.015752576291561127,
                "z": -350.54705810546875
            },
            {
                "x": 5.519927501678467,
                "y": 0.01574493944644928,
                "z": -350.3983154296875
            },
            {
                "x": 5.5699310302734375,
                "y": 0.01573735475540161,
                "z": -350.24945068359375
            },
            {
                "x": 5.6200103759765625,
                "y": 0.015859004110097885,
                "z": -350.10076904296875
            },
            {
                "x": 5.670146465301514,
                "y": 0.01629439741373062,
                "z": -349.9520263671875
            },
            {
                "x": 5.720332622528076,
                "y": 0.017036011442542076,
                "z": -349.803466796875
            },
            {
                "x": 5.770656585693359,
                "y": 0.01808035559952259,
                "z": -349.6549377441406
            },
            {
                "x": 5.8211846351623535,
                "y": 0.01943182945251465,
                "z": -349.5061950683594
            },
            {
                "x": 5.871732234954834,
                "y": 0.02108507603406906,
                "z": -349.3575744628906
            },
            {
                "x": 5.9223551750183105,
                "y": 0.023028438910841942,
                "z": -349.20892333984375
            },
            {
                "x": 5.9730401039123535,
                "y": 0.025256507098674774,
                "z": -349.06048583984375
            },
            {
                "x": 6.023800373077393,
                "y": 0.027768755331635475,
                "z": -348.9122009277344
            },
            {
                "x": 6.074782848358154,
                "y": 0.030574165284633636,
                "z": -348.76348876953125
            },
            {
                "x": 6.1257548332214355,
                "y": 0.033648569136857986,
                "z": -348.614990234375
            },
            {
                "x": 6.176762580871582,
                "y": 0.036989904940128326,
                "z": -348.4666442871094
            },
            {
                "x": 6.227872371673584,
                "y": 0.04060030356049538,
                "z": -348.3182678222656
            },
            {
                "x": 6.279078483581543,
                "y": 0.04447871446609497,
                "z": -348.16998291015625
            },
            {
                "x": 6.330418109893799,
                "y": 0.0486178994178772,
                "z": -348.0215148925781
            },
            {
                "x": 6.381802082061768,
                "y": 0.05300812050700188,
                "z": -347.8730773925781
            },
            {
                "x": 6.433189392089844,
                "y": 0.057644132524728775,
                "z": -347.7248840332031
            },
            {
                "x": 6.484679698944092,
                "y": 0.06253255158662796,
                "z": -347.57666015625
            },
            {
                "x": 6.53626012802124,
                "y": 0.06766068935394287,
                "z": -347.428466796875
            },
            {
                "x": 6.587899208068848,
                "y": 0.07302290946245193,
                "z": -347.2803039550781
            },
            {
                "x": 6.639649391174316,
                "y": 0.07862541079521179,
                "z": -347.1318359375
            },
            {
                "x": 6.691349029541016,
                "y": 0.08444936573505402,
                "z": -346.98382568359375
            },
            {
                "x": 6.743155479431152,
                "y": 0.0904974490404129,
                "z": -346.83575439453125
            },
            {
                "x": 6.7766642570495605,
                "y": 0.09451613575220108,
                "z": -346.7401428222656
            },
            {
                "x": 6.828611850738525,
                "y": 0.1009327620267868,
                "z": -346.5919494628906
            },
            {
                "x": 6.880581855773926,
                "y": 0.10755842924118042,
                "z": -346.4438171386719
            },
            {
                "x": 6.932619094848633,
                "y": 0.1143895611166954,
                "z": -346.2957458496094
            },
            {
                "x": 6.984675407409668,
                "y": 0.12141725420951843,
                "z": -346.1477966308594
            },
            {
                "x": 7.036849498748779,
                "y": 0.12865635752677917,
                "z": -345.999755859375
            },
            {
                "x": 7.089053153991699,
                "y": 0.13608905673027039,
                "z": -345.85174560546875
            },
            {
                "x": 7.141268253326416,
                "y": 0.14370818436145782,
                "z": -345.7037658691406
            },
            {
                "x": 7.193576812744141,
                "y": 0.1515180915594101,
                "z": -345.55572509765625
            },
            {
                "x": 7.245882987976074,
                "y": 0.1595056653022766,
                "z": -345.4079284667969
            },
            {
                "x": 7.298279285430908,
                "y": 0.16767732799053192,
                "z": -345.25994873046875
            },
            {
                "x": 7.350704669952393,
                "y": 0.176020547747612,
                "z": -345.11199951171875
            },
            {
                "x": 7.4031291007995605,
                "y": 0.18452748656272888,
                "z": -344.9642028808594
            },
            {
                "x": 7.4556660652160645,
                "y": 0.1932131052017212,
                "z": -344.8161926269531
            },
            {
                "x": 7.508147716522217,
                "y": 0.20204266905784607,
                "z": -344.6684875488281
            },
            {
                "x": 7.5607380867004395,
                "y": 0.21103939414024353,
                "z": -344.5205993652344
            },
            {
                "x": 7.613340377807617,
                "y": 0.22018584609031677,
                "z": -344.3727111816406
            },
            {
                "x": 7.665945529937744,
                "y": 0.22947552800178528,
                "z": -344.2250061035156
            },
            {
                "x": 7.718600749969482,
                "y": 0.23891273140907288,
                "z": -344.07720947265625
            },
            {
                "x": 7.771341800689697,
                "y": 0.24849727749824524,
                "z": -343.9293212890625
            },
            {
                "x": 7.824043273925781,
                "y": 0.258204847574234,
                "z": -343.7816162109375
            },
            {
                "x": 7.876736640930176,
                "y": 0.26803886890411377,
                "z": -343.63397216796875
            },
            {
                "x": 7.9294939041137695,
                "y": 0.2780081629753113,
                "z": -343.4862060546875
            },
            {
                "x": 7.982232570648193,
                "y": 0.2880901098251343,
                "z": -343.338623046875
            },
            {
                "x": 8.0350923538208,
                "y": 0.2983051538467407,
                "z": -343.19073486328125
            },
            {
                "x": 8.087900161743164,
                "y": 0.30862197279930115,
                "z": -343.0430908203125
            },
            {
                "x": 8.140732765197754,
                "y": 0.3190520703792572,
                "z": -342.8953857421875
            },
            {
                "x": 8.193595886230469,
                "y": 0.3295893669128418,
                "z": -342.7476501464844
            },
            {
                "x": 8.246445655822754,
                "y": 0.3402179479598999,
                "z": -342.6000061035156
            },
            {
                "x": 8.29939079284668,
                "y": 0.3509600758552551,
                "z": -342.4521789550781
            },
            {
                "x": 8.352278709411621,
                "y": 0.3617822229862213,
                "z": -342.3045349121094
            },
            {
                "x": 8.405130386352539,
                "y": 0.37268227338790894,
                "z": -342.1570129394531
            },
            {
                "x": 8.458090782165527,
                "y": 0.38368192315101624,
                "z": -342.00927734375
            },
            {
                "x": 8.511004447937012,
                "y": 0.39475277066230774,
                "z": -341.8616027832031
            },
            {
                "x": 8.563952445983887,
                "y": 0.4059086740016937,
                "z": -341.7138366699219
            },
            {
                "x": 8.616881370544434,
                "y": 0.4171294569969177,
                "z": -341.5661315917969
            },
            {
                "x": 8.669795036315918,
                "y": 0.42841118574142456,
                "z": -341.4184875488281
            },
            {
                "x": 8.72273063659668,
                "y": 0.4397599399089813,
                "z": -341.27081298828125
            },
            {
                "x": 8.77567195892334,
                "y": 0.45116692781448364,
                "z": -341.12310791015625
            },
            {
                "x": 8.828577995300293,
                "y": 0.4626234769821167,
                "z": -340.97540283203125
            },
            {
                "x": 8.881537437438965,
                "y": 0.474140465259552,
                "z": -340.82757568359375
            },
            {
                "x": 8.934440612792969,
                "y": 0.4856889247894287,
                "z": -340.679931640625
            },
            {
                "x": 8.98732852935791,
                "y": 0.49727898836135864,
                "z": -340.5322570800781
            },
            {
                "x": 9.021512031555176,
                "y": 0.504791259765625,
                "z": -340.43682861328125
            },
            {
                "x": 9.074363708496094,
                "y": 0.5164346694946289,
                "z": -340.2891845703125
            },
            {
                "x": 9.127264022827148,
                "y": 0.5281194448471069,
                "z": -340.1413879394531
            },
            {
                "x": 9.180150985717773,
                "y": 0.5398290157318115,
                "z": -339.9936218261719
            },
            {
                "x": 9.232989311218262,
                "y": 0.5515535473823547,
                "z": -339.84588623046875
            },
            {
                "x": 9.285834312438965,
                "y": 0.5633001327514648,
                "z": -339.6980285644531
            },
            {
                "x": 9.33860969543457,
                "y": 0.5750479698181152,
                "z": -339.5503845214844
            },
            {
                "x": 9.391373634338379,
                "y": 0.5868033766746521,
                "z": -339.40264892578125
            },
            {
                "x": 9.444209098815918,
                "y": 0.5985807180404663,
                "z": -339.2547302246094
            },
            {
                "x": 9.496935844421387,
                "y": 0.6103423237800598,
                "z": -339.1069641113281
            },
            {
                "x": 9.549653053283691,
                "y": 0.6221055388450623,
                "z": -338.9591064453125
            },
            {
                "x": 9.602328300476074,
                "y": 0.6338536739349365,
                "z": -338.8113098144531
            },
            {
                "x": 9.654977798461914,
                "y": 0.645583987236023,
                "z": -338.66357421875
            },
            {
                "x": 9.707691192626953,
                "y": 0.6573184728622437,
                "z": -338.5155334472656
            },
            {
                "x": 9.760283470153809,
                "y": 0.669015645980835,
                "z": -338.3676452636719
            },
            {
                "x": 9.812819480895996,
                "y": 0.6806809306144714,
                "z": -338.2198181152344
            },
            {
                "x": 9.865362167358398,
                "y": 0.6923233270645142,
                "z": -338.07183837890625
            },
            {
                "x": 9.917853355407715,
                "y": 0.703924834728241,
                "z": -337.92401123046875
            },
            {
                "x": 9.970367431640625,
                "y": 0.7155009508132935,
                "z": -337.7759094238281
            },
            {
                "x": 10.022793769836426,
                "y": 0.7270269393920898,
                "z": -337.6278991699219
            },
            {
                "x": 10.07514762878418,
                "y": 0.7384974956512451,
                "z": -337.47991943359375
            },
            {
                "x": 10.127467155456543,
                "y": 0.7499133348464966,
                "z": -337.33203125
            },
            {
                "x": 10.179778099060059,
                "y": 0.7612804174423218,
                "z": -337.1839599609375
            },
            {
                "x": 10.232046127319336,
                "y": 0.772590160369873,
                "z": -337.03582763671875
            },
            {
                "x": 10.284295082092285,
                "y": 0.7838442325592041,
                "z": -336.8875732421875
            },
            {
                "x": 10.33639907836914,
                "y": 0.7950099110603333,
                "z": -336.7394714355469
            },
            {
                "x": 10.388504028320312,
                "y": 0.8061088919639587,
                "z": -336.5913391113281
            },
            {
                "x": 10.440572738647461,
                "y": 0.8171359300613403,
                "z": -336.44305419921875
            },
            {
                "x": 10.49254322052002,
                "y": 0.828072190284729,
                "z": -336.2948913574219
            },
            {
                "x": 10.544517517089844,
                "y": 0.8389379978179932,
                "z": -336.1464538574219
            },
            {
                "x": 10.596364974975586,
                "y": 0.849694013595581,
                "z": -335.9983215332031
            },
            {
                "x": 10.648195266723633,
                "y": 0.8603607416152954,
                "z": -335.8500061035156
            },
            {
                "x": 10.69999885559082,
                "y": 0.8709381818771362,
                "z": -335.7015075683594
            },
            {
                "x": 10.751676559448242,
                "y": 0.8814034461975098,
                "z": -335.5531311035156
            },
            {
                "x": 10.803316116333008,
                "y": 0.8917641639709473,
                "z": -335.4046630859375
            },
            {
                "x": 10.854901313781738,
                "y": 0.9020094871520996,
                "z": -335.2562255859375
            },
            {
                "x": 10.906426429748535,
                "y": 0.9121385812759399,
                "z": -335.1076965332031
            },
            {
                "x": 10.957902908325195,
                "y": 0.9221581816673279,
                "z": -334.9590148925781
            },
            {
                "x": 11.009230613708496,
                "y": 0.9320422410964966,
                "z": -334.8104248046875
            },
            {
                "x": 11.060461044311523,
                "y": 0.9417881965637207,
                "z": -334.6618957519531
            },
            {
                "x": 11.111741065979004,
                "y": 0.9514150619506836,
                "z": -334.51312255859375
            },
            {
                "x": 11.162914276123047,
                "y": 0.9609018564224243,
                "z": -334.3643798828125
            },
            {
                "x": 11.213949203491211,
                "y": 0.9702445268630981,
                "z": -334.2156066894531
            },
            {
                "x": 11.246872901916504,
                "y": 0.9762014150619507,
                "z": -334.1194152832031
            },
            {
                "x": 11.297728538513184,
                "y": 0.9852886199951172,
                "z": -333.9707946777344
            },
            {
                "x": 11.348587989807129,
                "y": 0.994229257106781,
                "z": -333.8219909667969
            },
            {
                "x": 11.399428367614746,
                "y": 1.0030276775360107,
                "z": -333.6728820800781
            },
            {
                "x": 11.450094223022461,
                "y": 1.0116491317749023,
                "z": -333.5238952636719
            },
            {
                "x": 11.500656127929688,
                "y": 1.0201046466827393,
                "z": -333.3748779296875
            },
            {
                "x": 11.551117897033691,
                "y": 1.0283827781677246,
                "z": -333.2259216308594
            },
            {
                "x": 11.601536750793457,
                "y": 1.0364937782287598,
                "z": -333.07684326171875
            },
            {
                "x": 11.651931762695312,
                "y": 1.0444341897964478,
                "z": -332.92742919921875
            },
            {
                "x": 11.702095985412598,
                "y": 1.0521764755249023,
                "z": -332.7782287597656
            },
            {
                "x": 11.752152442932129,
                "y": 1.059727668762207,
                "z": -332.62908935546875
            },
            {
                "x": 11.802179336547852,
                "y": 1.0670921802520752,
                "z": -332.4798583984375
            },
            {
                "x": 11.852103233337402,
                "y": 1.0742533206939697,
                "z": -332.33056640625
            },
            {
                "x": 11.902005195617676,
                "y": 1.081228494644165,
                "z": -332.1808166503906
            },
            {
                "x": 11.951653480529785,
                "y": 1.0879831314086914,
                "z": -332.0314025878906
            },
            {
                "x": 12.001189231872559,
                "y": 1.0945260524749756,
                "z": -331.882080078125
            },
            {
                "x": 12.050724029541016,
                "y": 1.1008577346801758,
                "z": -331.73248291015625
            },
            {
                "x": 12.100119590759277,
                "y": 1.1069703102111816,
                "z": -331.58282470703125
            },
            {
                "x": 12.149385452270508,
                "y": 1.1128630638122559,
                "z": -331.4330749511719
            },
            {
                "x": 12.198509216308594,
                "y": 1.1185275316238403,
                "z": -331.28326416015625
            },
            {
                "x": 12.247453689575195,
                "y": 1.1239449977874756,
                "z": -331.13372802734375
            },
            {
                "x": 12.296409606933594,
                "y": 1.1291335821151733,
                "z": -330.98388671875
            },
            {
                "x": 12.345206260681152,
                "y": 1.1340844631195068,
                "z": -330.833984375
            },
            {
                "x": 12.393826484680176,
                "y": 1.138790249824524,
                "z": -330.68408203125
            },
            {
                "x": 12.442364692687988,
                "y": 1.143244981765747,
                "z": -330.53399658203125
            },
            {
                "x": 12.490753173828125,
                "y": 1.1474374532699585,
                "z": -330.3840637207031
            },
            {
                "x": 12.539078712463379,
                "y": 1.1513786315917969,
                "z": -330.2339172363281
            },
            {
                "x": 12.58724594116211,
                "y": 1.1550618410110474,
                "z": -330.0836486816406
            },
            {
                "x": 12.635187149047852,
                "y": 1.1584677696228027,
                "z": -329.9335021972656
            },
            {
                "x": 12.683059692382812,
                "y": 1.1616008281707764,
                "z": -329.783203125
            },
            {
                "x": 12.730798721313477,
                "y": 1.1644585132598877,
                "z": -329.63299560546875
            },
            {
                "x": 12.778441429138184,
                "y": 1.1670417785644531,
                "z": -329.4825439453125
            },
            {
                "x": 12.825913429260254,
                "y": 1.169338345527649,
                "z": -329.33197021484375
            },
            {
                "x": 12.873125076293945,
                "y": 1.1713354587554932,
                "z": -329.18157958984375
            },
            {
                "x": 12.920278549194336,
                "y": 1.173043966293335,
                "z": -329.0310974121094
            },
            {
                "x": 12.967350006103516,
                "y": 1.1744585037231445,
                "z": -328.88043212890625
            },
            {
                "x": 13.01424503326416,
                "y": 1.1755681037902832,
                "z": -328.7297058105469
            },
            {
                "x": 13.060922622680664,
                "y": 1.1763646602630615,
                "z": -328.5788269042969
            },
            {
                "x": 13.107381820678711,
                "y": 1.1768524646759033,
                "z": -328.42822265625
            },
            {
                "x": 13.153748512268066,
                "y": 1.1770282983779907,
                "z": -328.277587890625
            },
            {
                "x": 13.200105667114258,
                "y": 1.176882266998291,
                "z": -328.12640380859375
            },
            {
                "x": 13.2461519241333,
                "y": 1.1764142513275146,
                "z": -327.975341796875
            },
            {
                "x": 13.291955947875977,
                "y": 1.1756389141082764,
                "z": -327.8244323730469
            },
            {
                "x": 13.321474075317383,
                "y": 1.1749804019927979,
                "z": -327.72698974609375
            },
            {
                "x": 13.367074966430664,
                "y": 1.1736962795257568,
                "z": -327.57611083984375
            },
            {
                "x": 13.412599563598633,
                "y": 1.172112226486206,
                "z": -327.42474365234375
            },
            {
                "x": 13.457892417907715,
                "y": 1.1702344417572021,
                "z": -327.27337646484375
            },
            {
                "x": 13.502911567687988,
                "y": 1.1680691242218018,
                "z": -327.1222229003906
            },
            {
                "x": 13.547801971435547,
                "y": 1.165608286857605,
                "z": -326.97100830078125
            },
            {
                "x": 13.592568397521973,
                "y": 1.162866234779358,
                "z": -326.8197021484375
            },
            {
                "x": 13.637160301208496,
                "y": 1.1598446369171143,
                "z": -326.66815185546875
            },
            {
                "x": 13.681534767150879,
                "y": 1.156548261642456,
                "z": -326.5163879394531
            },
            {
                "x": 13.725600242614746,
                "y": 1.1529834270477295,
                "z": -326.3650817871094
            },
            {
                "x": 13.769569396972656,
                "y": 1.1491539478302002,
                "z": -326.2137145996094
            },
            {
                "x": 13.81343936920166,
                "y": 1.1450586318969727,
                "z": -326.0618896484375
            },
            {
                "x": 13.857056617736816,
                "y": 1.1407077312469482,
                "z": -325.9100646972656
            },
            {
                "x": 13.900421142578125,
                "y": 1.136096715927124,
                "z": -325.75823974609375
            },
            {
                "x": 13.943547248840332,
                "y": 1.1312501430511475,
                "z": -325.6065979003906
            },
            {
                "x": 13.986567497253418,
                "y": 1.1261577606201172,
                "z": -325.4549255371094
            },
            {
                "x": 14.029446601867676,
                "y": 1.1208171844482422,
                "z": -325.302734375
            },
            {
                "x": 14.072003364562988,
                "y": 1.1152377128601074,
                "z": -325.150634765625
            },
            {
                "x": 14.11429214477539,
                "y": 1.1094391345977783,
                "z": -324.9987487792969
            },
            {
                "x": 14.156466484069824,
                "y": 1.1034140586853027,
                "z": -324.8467712402344
            },
            {
                "x": 14.19847583770752,
                "y": 1.0971639156341553,
                "z": -324.6946105957031
            },
            {
                "x": 14.240225791931152,
                "y": 1.090684175491333,
                "z": -324.542236328125
            },
            {
                "x": 14.281660079956055,
                "y": 1.0840022563934326,
                "z": -324.3900451660156
            },
            {
                "x": 14.322859764099121,
                "y": 1.0771245956420898,
                "z": -324.2380065917969
            },
            {
                "x": 14.364012718200684,
                "y": 1.0700256824493408,
                "z": -324.0855407714844
            },
            {
                "x": 14.404923439025879,
                "y": 1.0627189874649048,
                "z": -323.9329833984375
            },
            {
                "x": 14.445527076721191,
                "y": 1.05521559715271,
                "z": -323.78033447265625
            },
            {
                "x": 14.485819816589355,
                "y": 1.0475391149520874,
                "z": -323.6279602050781
            },
            {
                "x": 14.525947570800781,
                "y": 1.0396808385849,
                "z": -323.4755859375
            },
            {
                "x": 14.565975189208984,
                "y": 1.031611680984497,
                "z": -323.32275390625
            },
            {
                "x": 14.605693817138672,
                "y": 1.0233654975891113,
                "z": -323.1698303222656
            },
            {
                "x": 14.64506721496582,
                "y": 1.0149571895599365,
                "z": -323.01702880859375
            },
            {
                "x": 14.68419075012207,
                "y": 1.0063917636871338,
                "z": -322.8644104003906
            },
            {
                "x": 14.723155975341797,
                "y": 0.9976562261581421,
                "z": -322.711669921875
            },
            {
                "x": 14.761970520019531,
                "y": 0.9887332320213318,
                "z": -322.5584716796875
            },
            {
                "x": 14.800437927246094,
                "y": 0.9796580076217651,
                "z": -322.4052429199219
            },
            {
                "x": 14.838540077209473,
                "y": 0.9704576730728149,
                "z": -322.2523193359375
            },
            {
                "x": 14.876474380493164,
                "y": 0.9611042737960815,
                "z": -322.099365234375
            },
            {
                "x": 14.91424560546875,
                "y": 0.9515947699546814,
                "z": -321.9461364746094
            },
            {
                "x": 14.951732635498047,
                "y": 0.9419361352920532,
                "z": -321.7926940917969
            },
            {
                "x": 14.988899230957031,
                "y": 0.9321410655975342,
                "z": -321.6391296386719
            },
            {
                "x": 15.025694847106934,
                "y": 0.9222534894943237,
                "z": -321.4861145019531
            },
            {
                "x": 15.062376976013184,
                "y": 0.9122223854064941,
                "z": -321.3328552246094
            },
            {
                "x": 15.085968017578125,
                "y": 0.9056668281555176,
                "z": -321.2335510253906
            },
            {
                "x": 15.12220573425293,
                "y": 0.8954192399978638,
                "z": -321.0798645019531
            },
            {
                "x": 15.158080101013184,
                "y": 0.8850597143173218,
                "z": -320.9261169433594
            },
            {
                "x": 15.193656921386719,
                "y": 0.8746144771575928,
                "z": -320.772705078125
            },
            {
                "x": 15.22907829284668,
                "y": 0.8640551567077637,
                "z": -320.6191101074219
            },
            {
                "x": 15.264293670654297,
                "y": 0.8533651232719421,
                "z": -320.46502685546875
            },
            {
                "x": 15.299072265625,
                "y": 0.8425885438919067,
                "z": -320.3110656738281
            },
            {
                "x": 15.333488464355469,
                "y": 0.8317428231239319,
                "z": -320.1573181152344
            },
            {
                "x": 15.367754936218262,
                "y": 0.8207994699478149,
                "z": -320.00341796875
            },
            {
                "x": 15.401787757873535,
                "y": 0.809764564037323,
                "z": -319.849365234375
            },
            {
                "x": 15.435506820678711,
                "y": 0.7986259460449219,
                "z": -319.6949462890625
            },
            {
                "x": 15.468796730041504,
                "y": 0.7874324321746826,
                "z": -319.54071044921875
            },
            {
                "x": 15.50175952911377,
                "y": 0.776195228099823,
                "z": -319.3868103027344
            },
            {
                "x": 15.534615516662598,
                "y": 0.7648649215698242,
                "z": -319.23248291015625
            },
            {
                "x": 15.567166328430176,
                "y": 0.7534558773040771,
                "z": -319.0779113769531
            },
            {
                "x": 15.5993070602417,
                "y": 0.7419935464859009,
                "z": -318.92327880859375
            },
            {
                "x": 15.631082534790039,
                "y": 0.7304944396018982,
                "z": -318.76885986328125
            },
            {
                "x": 15.662606239318848,
                "y": 0.7189645171165466,
                "z": -318.6146240234375
            },
            {
                "x": 15.693938255310059,
                "y": 0.7073520421981812,
                "z": -318.45989990234375
            },
            {
                "x": 15.724906921386719,
                "y": 0.6956827640533447,
                "z": -318.3047790527344
            },
            {
                "x": 15.755420684814453,
                "y": 0.6840062737464905,
                "z": -318.1500244140625
            },
            {
                "x": 15.78561019897461,
                "y": 0.6723220944404602,
                "z": -317.9955749511719
            },
            {
                "x": 15.815624237060547,
                "y": 0.660591721534729,
                "z": -317.8408203125
            },
            {
                "x": 15.845329284667969,
                "y": 0.6488107442855835,
                "z": -317.68560791015625
            },
            {
                "x": 15.87463665008545,
                "y": 0.6369971036911011,
                "z": -317.53021240234375
            },
            {
                "x": 15.903486251831055,
                "y": 0.6252172589302063,
                "z": -317.3753662109375
            },
            {
                "x": 15.932126998901367,
                "y": 0.6134241819381714,
                "z": -317.2204284667969
            },
            {
                "x": 15.96052074432373,
                "y": 0.6015952825546265,
                "z": -317.0650634765625
            },
            {
                "x": 15.988506317138672,
                "y": 0.5897535681724548,
                "z": -316.9094543457031
            },
            {
                "x": 16.016061782836914,
                "y": 0.5779227018356323,
                "z": -316.7539367675781
            },
            {
                "x": 16.043249130249023,
                "y": 0.5661351680755615,
                "z": -316.59881591796875
            },
            {
                "x": 16.070222854614258,
                "y": 0.5543466806411743,
                "z": -316.44354248046875
            },
            {
                "x": 16.096908569335938,
                "y": 0.5425284504890442,
                "z": -316.2875671386719
            },
            {
                "x": 16.12309455871582,
                "y": 0.5307472944259644,
                "z": -316.13177490234375
            },
            {
                "x": 16.14887809753418,
                "y": 0.5190083384513855,
                "z": -315.9761657714844
            },
            {
                "x": 16.174388885498047,
                "y": 0.5073092579841614,
                "z": -315.8206481933594
            },
            {
                "x": 16.199636459350586,
                "y": 0.4956122040748596,
                "z": -315.6647033691406
            },
            {
                "x": 16.224462509155273,
                "y": 0.4839305281639099,
                "z": -315.5083312988281
            },
            {
                "x": 16.248779296875,
                "y": 0.47232311964035034,
                "z": -315.3524169921875
            },
            {
                "x": 16.27276039123535,
                "y": 0.4607850909233093,
                "z": -315.1967468261719
            },
            {
                "x": 16.29654312133789,
                "y": 0.4492596685886383,
                "z": -315.04058837890625
            },
            {
                "x": 16.319923400878906,
                "y": 0.43777281045913696,
                "z": -314.8841247558594
            },
            {
                "x": 16.342792510986328,
                "y": 0.4263536036014557,
                "z": -314.7276916503906
            },
            {
                "x": 16.357318878173828,
                "y": 0.41902753710746765,
                "z": -314.6268310546875
            },
            {
                "x": 16.379579544067383,
                "y": 0.40775066614151,
                "z": -314.4708557128906
            },
            {
                "x": 16.401607513427734,
                "y": 0.3965078592300415,
                "z": -314.31439208984375
            },
            {
                "x": 16.423200607299805,
                "y": 0.3853133022785187,
                "z": -314.1574401855469
            },
            {
                "x": 16.44424057006836,
                "y": 0.3742239475250244,
                "z": -314.00079345703125
            },
            {
                "x": 16.46489906311035,
                "y": 0.3632403612136841,
                "z": -313.84442138671875
            },
            {
                "x": 16.485313415527344,
                "y": 0.3523358702659607,
                "z": -313.6880187988281
            },
            {
                "x": 16.505359649658203,
                "y": 0.3414870798587799,
                "z": -313.5309753417969
            },
            {
                "x": 16.524890899658203,
                "y": 0.3307228684425354,
                "z": -313.3736877441406
            },
            {
                "x": 16.543909072875977,
                "y": 0.3201039731502533,
                "z": -313.2170104980469
            },
            {
                "x": 16.562641143798828,
                "y": 0.30959343910217285,
                "z": -313.0604248046875
            },
            {
                "x": 16.581085205078125,
                "y": 0.29915720224380493,
                "z": -312.9032897949219
            },
            {
                "x": 16.599016189575195,
                "y": 0.2888210713863373,
                "z": -312.7458801269531
            },
            {
                "x": 16.616418838500977,
                "y": 0.2786104679107666,
                "z": -312.58856201171875
            },
            {
                "x": 16.633426666259766,
                "y": 0.2685597836971283,
                "z": -312.43182373046875
            },
            {
                "x": 16.650175094604492,
                "y": 0.2586129307746887,
                "z": -312.27471923828125
            },
            {
                "x": 16.66649055480957,
                "y": 0.24876034259796143,
                "z": -312.1169738769531
            },
            {
                "x": 16.68222427368164,
                "y": 0.239053875207901,
                "z": -311.9593505859375
            },
            {
                "x": 16.697490692138672,
                "y": 0.2295115888118744,
                "z": -311.8021545410156
            },
            {
                "x": 16.71249008178711,
                "y": 0.22010600566864014,
                "z": -311.6449279785156
            },
            {
                "x": 16.727100372314453,
                "y": 0.21082594990730286,
                "z": -311.4872131347656
            },
            {
                "x": 16.74114990234375,
                "y": 0.2016860544681549,
                "z": -311.3292541503906
            },
            {
                "x": 16.754648208618164,
                "y": 0.1927238553762436,
                "z": -311.1717224121094
            },
            {
                "x": 16.767797470092773,
                "y": 0.18394073843955994,
                "z": -311.0144958496094
            },
            {
                "x": 16.780656814575195,
                "y": 0.17528532445430756,
                "z": -310.8565979003906
            },
            {
                "x": 16.792985916137695,
                "y": 0.1667846143245697,
                "z": -310.6983642578125
            },
            {
                "x": 16.804719924926758,
                "y": 0.15846426784992218,
                "z": -310.54034423828125
            },
            {
                "x": 16.816007614135742,
                "y": 0.1503441333770752,
                "z": -310.3827819824219
            },
            {
                "x": 16.826990127563477,
                "y": 0.14240626990795135,
                "z": -310.22515869140625
            },
            {
                "x": 16.837554931640625,
                "y": 0.1346105933189392,
                "z": -310.06671142578125
            },
            {
                "x": 16.847501754760742,
                "y": 0.1270093321800232,
                "z": -309.9082946777344
            },
            {
                "x": 16.856904983520508,
                "y": 0.11962321400642395,
                "z": -309.7504577636719
            },
            {
                "x": 16.8659725189209,
                "y": 0.11244190484285355,
                "z": -309.5926208496094
            },
            {
                "x": 16.874670028686523,
                "y": 0.10544263571500778,
                "z": -309.4344177246094
            },
            {
                "x": 16.882797241210938,
                "y": 0.09862524271011353,
                "z": -309.27569580078125
            },
            {
                "x": 16.890316009521484,
                "y": 0.09203220158815384,
                "z": -309.1173400878906
            },
            {
                "x": 16.897403717041016,
                "y": 0.08567970991134644,
                "z": -308.95947265625
            },
            {
                "x": 16.904178619384766,
                "y": 0.07952655106782913,
                "z": -308.80120849609375
            },
            {
                "x": 16.91042709350586,
                "y": 0.07357542216777802,
                "z": -308.64251708984375
            },
            {
                "x": 16.916034698486328,
                "y": 0.0678514838218689,
                "z": -308.4838562011719
            },
            {
                "x": 16.921127319335938,
                "y": 0.06237533316016197,
                "z": -308.3255920410156
            },
            {
                "x": 16.92589569091797,
                "y": 0.057140376418828964,
                "z": -308.1675109863281
            },
            {
                "x": 16.930212020874023,
                "y": 0.0521201491355896,
                "z": -308.0088195800781
            },
            {
                "x": 16.93267822265625,
                "y": 0.04899703338742256,
                "z": -307.9061279296875
            },
            {
                "x": 16.93593406677246,
                "y": 0.04438275098800659,
                "z": -307.74749755859375
            },
            {
                "x": 16.93874740600586,
                "y": 0.040026795119047165,
                "z": -307.58929443359375
            },
            {
                "x": 16.94123649597168,
                "y": 0.035913269966840744,
                "z": -307.430908203125
            },
            {
                "x": 16.94319725036621,
                "y": 0.03204427659511566,
                "z": -307.27197265625
            },
            {
                "x": 16.94446563720703,
                "y": 0.028439413756132126,
                "z": -307.1129455566406
            },
            {
                "x": 16.9451904296875,
                "y": 0.025110958144068718,
                "z": -306.9546203613281
            },
            {
                "x": 16.94557762145996,
                "y": 0.022049494087696075,
                "z": -306.79644775390625
            },
            {
                "x": 16.945520401000977,
                "y": 0.019244229421019554,
                "z": -306.637451171875
            },
            {
                "x": 16.944772720336914,
                "y": 0.016720764338970184,
                "z": -306.47833251953125
            },
            {
                "x": 16.943405151367188,
                "y": 0.014480394311249256,
                "z": -306.319580078125
            },
            {
                "x": 16.941635131835938,
                "y": 0.012526441365480423,
                "z": -306.16143798828125
            },
            {
                "x": 16.939489364624023,
                "y": 0.010854641906917095,
                "z": -306.00286865234375
            },
            {
                "x": 16.93670082092285,
                "y": 0.009475026279687881,
                "z": -305.8435363769531
            },
            {
                "x": 16.9332275390625,
                "y": 0.00839146412909031,
                "z": -305.6846008300781
            },
            {
                "x": 16.929264068603516,
                "y": 0.007606638595461845,
                "z": -305.5263977050781
            },
            {
                "x": 16.924955368041992,
                "y": 0.007122162729501724,
                "z": -305.3680725097656
            },
            {
                "x": 16.920089721679688,
                "y": 0.00694853812456131,
                "z": -305.2091369628906
            },
            {
                "x": 16.914508819580078,
                "y": 0.006940007209777832,
                "z": -305.0500183105469
            },
            {
                "x": 16.908334732055664,
                "y": 0.0069350749254226685,
                "z": -304.89141845703125
            },
            {
                "x": 16.90180015563965,
                "y": 0.0069301798939704895,
                "z": -304.7333984375
            },
            {
                "x": 16.894798278808594,
                "y": 0.0069252923130989075,
                "z": -304.57476806640625
            },
            {
                "x": 16.887104034423828,
                "y": 0.006920307874679565,
                "z": -304.415771484375
            },
            {
                "x": 16.878734588623047,
                "y": 0.006915442645549774,
                "z": -304.257080078125
            },
            {
                "x": 16.86991310119629,
                "y": 0.0069105178117752075,
                "z": -304.098876953125
            },
            {
                "x": 16.8607120513916,
                "y": 0.006905600428581238,
                "z": -303.9406433105469
            },
            {
                "x": 16.850866317749023,
                "y": 0.006900712847709656,
                "z": -303.78173828125
            },
            {
                "x": 16.840293884277344,
                "y": 0.006895802915096283,
                "z": -303.6229248046875
            },
            {
                "x": 16.829181671142578,
                "y": 0.006890848278999329,
                "z": -303.4648132324219
            },
            {
                "x": 16.817691802978516,
                "y": 0.006885945796966553,
                "z": -303.3067932128906
            },
            {
                "x": 16.80567169189453,
                "y": 0.006881020963191986,
                "z": -303.1482849121094
            },
            {
                "x": 16.79290771484375,
                "y": 0.006876125931739807,
                "z": -302.989501953125
            },
            {
                "x": 16.77949333190918,
                "y": 0.0068711936473846436,
                "z": -302.83123779296875
            },
            {
                "x": 16.765674591064453,
                "y": 0.00686626136302948,
                "z": -302.673583984375
            },
            {
                "x": 16.75141143798828,
                "y": 0.006861366331577301,
                "z": -302.5155334472656
            },
            {
                "x": 16.736440658569336,
                "y": 0.006856448948383331,
                "z": -302.3568115234375
            },
            {
                "x": 16.72075080871582,
                "y": 0.006851531565189362,
                "z": -302.1985168457031
            },
            {
                "x": 16.704551696777344,
                "y": 0.006846629083156586,
                "z": -302.0408935546875
            },
            {
                "x": 16.687999725341797,
                "y": 0.006841711699962616,
                "z": -301.8833923339844
            },
            {
                "x": 16.670818328857422,
                "y": 0.006836816668510437,
                "z": -301.7252197265625
            },
            {
                "x": 16.652841567993164,
                "y": 0.006831839680671692,
                "z": -301.5667419433594
            },
            {
                "x": 16.63426971435547,
                "y": 0.006826944649219513,
                "z": -301.4092102050781
            },
            {
                "x": 16.615346908569336,
                "y": 0.00682203471660614,
                "z": -301.2520751953125
            },
            {
                "x": 16.60287094116211,
                "y": 0.006818845868110657,
                "z": -301.1502990722656
            },
            {
                "x": 16.58293914794922,
                "y": 0.006813928484916687,
                "z": -300.9923095703125
            },
            {
                "x": 16.56222152709961,
                "y": 0.006809018552303314,
                "z": -300.8343505859375
            },
            {
                "x": 16.540985107421875,
                "y": 0.006804145872592926,
                "z": -300.67718505859375
            },
            {
                "x": 16.519411087036133,
                "y": 0.006799198687076569,
                "z": -300.52032470703125
            },
            {
                "x": 16.49720573425293,
                "y": 0.006794273853302002,
                "z": -300.3627624511719
            },
            {
                "x": 16.474212646484375,
                "y": 0.006789363920688629,
                "z": -300.205078125
            },
            {
                "x": 16.450572967529297,
                "y": 0.0067844390869140625,
                "z": -300.0479736328125
            },
            {
                "x": 16.426536560058594,
                "y": 0.006779581308364868,
                "z": -299.8913879394531
            },
            {
                "x": 16.402050018310547,
                "y": 0.0067746639251708984,
                "z": -299.73455810546875
            },
            {
                "x": 16.376781463623047,
                "y": 0.0067697614431381226,
                "z": -299.5772399902344
            },
            {
                "x": 16.35075569152832,
                "y": 0.0067647844552993774,
                "z": -299.4201354980469
            },
            {
                "x": 16.32427215576172,
                "y": 0.0067598819732666016,
                "z": -299.2638854980469
            },
            {
                "x": 16.297388076782227,
                "y": 0.006754957139492035,
                "z": -299.1076354980469
            },
            {
                "x": 16.26986312866211,
                "y": 0.006750062108039856,
                "z": -298.9509582519531
            },
            {
                "x": 16.241514205932617,
                "y": 0.006745137274265289,
                "z": -298.7940673828125
            },
            {
                "x": 16.21253776550293,
                "y": 0.00674021989107132,
                "z": -298.6377868652344
            },
            {
                "x": 16.183244705200195,
                "y": 0.006735265254974365,
                "z": -298.4822998046875
            },
            {
                "x": 16.153396606445312,
                "y": 0.00673038512468338,
                "z": -298.3262634277344
            },
            {
                "x": 16.122756958007812,
                "y": 0.0067254602909088135,
                "z": -298.1697692871094
            },
            {
                "x": 16.091384887695312,
                "y": 0.006720550358295441,
                "z": -298.013671875
            },
            {
                "x": 16.0595703125,
                "y": 0.006715685129165649,
                "z": -297.85845947265625
            },
            {
                "x": 16.02737808227539,
                "y": 0.006710730493068695,
                "z": -297.7033386230469
            },
            {
                "x": 15.994501113891602,
                "y": 0.006705775856971741,
                "z": -297.54766845703125
            },
            {
                "x": 15.960741996765137,
                "y": 0.0067009106278419495,
                "z": -297.39166259765625
            },
            {
                "x": 15.926448822021484,
                "y": 0.006695978343486786,
                "z": -297.23663330078125
            },
            {
                "x": 15.891803741455078,
                "y": 0.006691105663776398,
                "z": -297.0821228027344
            },
            {
                "x": 15.856616973876953,
                "y": 0.006686165928840637,
                "z": -296.92724609375
            },
            {
                "x": 15.820629119873047,
                "y": 0.006681255996227264,
                "z": -296.7720031738281
            },
            {
                "x": 15.783852577209473,
                "y": 0.006676323711872101,
                "z": -296.616943359375
            },
            {
                "x": 15.746707916259766,
                "y": 0.006671376526355743,
                "z": -296.46295166015625
            },
            {
                "x": 15.709195137023926,
                "y": 0.006666526198387146,
                "z": -296.3090515136719
            },
            {
                "x": 15.670931816101074,
                "y": 0.006661601364612579,
                "z": -296.15447998046875
            },
            {
                "x": 15.63185977935791,
                "y": 0.006656676530838013,
                "z": -295.99993896484375
            },
            {
                "x": 15.592158317565918,
                "y": 0.006651744246482849,
                "z": -295.84600830078125
            },
            {
                "x": 15.552172660827637,
                "y": 0.0066468119621276855,
                "z": -295.6927795410156
            },
            {
                "x": 15.511689186096191,
                "y": 0.0066419243812561035,
                "z": -295.5393371582031
            },
            {
                "x": 15.47033405303955,
                "y": 0.006636962294578552,
                "z": -295.38531494140625
            },
            {
                "x": 15.428240776062012,
                "y": 0.00663207471370697,
                "z": -295.2317810058594
            },
            {
                "x": 15.385756492614746,
                "y": 0.0066271573305130005,
                "z": -295.07904052734375
            },
            {
                "x": 15.34286880493164,
                "y": 0.006622247397899628,
                "z": -294.9263916015625
            },
            {
                "x": 15.299344062805176,
                "y": 0.006617307662963867,
                "z": -294.7734680175781
            },
            {
                "x": 15.254959106445312,
                "y": 0.006612420082092285,
                "z": -294.620361328125
            },
            {
                "x": 15.22593879699707,
                "y": 0.006609246134757996,
                "z": -294.521728515625
            },
            {
                "x": 15.18077278137207,
                "y": 0.006604291498661041,
                "z": -294.3699645996094
            },
            {
                "x": 15.135208129882812,
                "y": 0.006599411368370056,
                "z": -294.21807861328125
            },
            {
                "x": 15.088895797729492,
                "y": 0.006594493985176086,
                "z": -294.0657653808594
            },
            {
                "x": 15.041786193847656,
                "y": 0.00658956915140152,
                "z": -293.91357421875
            },
            {
                "x": 14.994063377380371,
                "y": 0.006584689021110535,
                "z": -293.7618408203125
            },
            {
                "x": 14.946073532104492,
                "y": 0.006579756736755371,
                "z": -293.61102294921875
            },
            {
                "x": 14.89762020111084,
                "y": 0.006574846804141998,
                "z": -293.46002197265625
            },
            {
                "x": 14.84827995300293,
                "y": 0.0065699294209480286,
                "z": -293.3083801269531
            },
            {
                "x": 14.798243522644043,
                "y": 0.006565012037754059,
                "z": -293.1572265625
            },
            {
                "x": 14.747756004333496,
                "y": 0.006560109555721283,
                "z": -293.0068054199219
            },
            {
                "x": 14.696975708007812,
                "y": 0.006555177271366119,
                "z": -292.8568420410156
            },
            {
                "x": 14.645580291748047,
                "y": 0.006550267338752747,
                "z": -292.7065734863281
            },
            {
                "x": 14.593255043029785,
                "y": 0.006545372307300568,
                "z": -292.5557556152344
            },
            {
                "x": 14.54033088684082,
                "y": 0.006540514528751373,
                "z": -292.40576171875
            },
            {
                "x": 14.487133026123047,
                "y": 0.006535559892654419,
                "z": -292.2566223144531
            },
            {
                "x": 14.433514595031738,
                "y": 0.0065306201577186584,
                "z": -292.1074523925781
            },
            {
                "x": 14.379175186157227,
                "y": 0.006525717675685883,
                "z": -291.9579162597656
            },
            {
                "x": 14.323990821838379,
                "y": 0.006518266163766384,
                "z": -291.8083801269531
            },
            {
                "x": 14.268238067626953,
                "y": 0.006283779628574848,
                "z": -291.65948486328125
            },
            {
                "x": 14.212299346923828,
                "y": 0.0054733846336603165,
                "z": -291.5113830566406
            },
            {
                "x": 14.155914306640625,
                "y": 0.004078946076333523,
                "z": -291.36322021484375
            },
            {
                "x": 14.09866714477539,
                "y": 0.0020797336474061012,
                "z": -291.2146301269531
            },
            {
                "x": 14.040670394897461,
                "y": -0.0004875126760452986,
                "z": -291.06634521484375
            },
            {
                "x": 13.982230186462402,
                "y": -0.0036004194989800453,
                "z": -290.918701171875
            },
            {
                "x": 13.92364501953125,
                "y": -0.007241349201649427,
                "z": -290.771728515625
            },
            {
                "x": 13.86440372467041,
                "y": -0.011447560042142868,
                "z": -290.62445068359375
            },
            {
                "x": 13.80433464050293,
                "y": -0.01619294285774231,
                "z": -290.4769287109375
            },
            {
                "x": 13.743634223937988,
                "y": -0.02144336700439453,
                "z": -290.3299255371094
            },
            {
                "x": 13.682560920715332,
                "y": -0.0271766297519207,
                "z": -290.1836242675781
            },
            {
                "x": 13.62131118774414,
                "y": -0.03339703381061554,
                "z": -290.037841796875
            },
            {
                "x": 13.559398651123047,
                "y": -0.040123868733644485,
                "z": -289.8916931152344
            },
            {
                "x": 13.496631622314453,
                "y": -0.04734058305621147,
                "z": -289.74542236328125
            },
            {
                "x": 13.433394432067871,
                "y": -0.054991405457258224,
                "z": -289.599853515625
            },
            {
                "x": 13.369930267333984,
                "y": -0.06307142972946167,
                "z": -289.4549865722656
            },
            {
                "x": 13.306124687194824,
                "y": -0.07159426808357239,
                "z": -289.31024169921875
            },
            {
                "x": 13.241650581359863,
                "y": -0.08056548237800598,
                "z": -289.16522216796875
            },
            {
                "x": 13.176494598388672,
                "y": -0.08995877206325531,
                "z": -289.0204162597656
            },
            {
                "x": 13.111039161682129,
                "y": -0.0997285544872284,
                "z": -288.8763427734375
            },
            {
                "x": 13.045485496520996,
                "y": -0.1098589301109314,
                "z": -288.7329406738281
            },
            {
                "x": 12.979375839233398,
                "y": -0.12040744721889496,
                "z": -288.5891418457031
            },
            {
                "x": 12.912723541259766,
                "y": -0.131332129240036,
                "z": -288.4454345703125
            },
            {
                "x": 12.845686912536621,
                "y": -0.14259862899780273,
                "z": -288.30230712890625
            },
            {
                "x": 12.802361488342285,
                "y": -0.15004238486289978,
                "z": -288.210205078125
            },
            {
                "x": 12.735020637512207,
                "y": -0.16184571385383606,
                "z": -288.067626953125
            },
            {
                "x": 12.667125701904297,
                "y": -0.17400895059108734,
                "z": -287.9248352050781
            },
            {
                "x": 12.598929405212402,
                "y": -0.18647915124893188,
                "z": -287.7825622558594
            },
            {
                "x": 12.530640602111816,
                "y": -0.19922949373722076,
                "z": -287.640625
            },
            {
                "x": 12.46192455291748,
                "y": -0.21229290962219238,
                "z": -287.4986267089844
            },
            {
                "x": 12.393275260925293,
                "y": -0.2255801260471344,
                "z": -287.357421875
            },
            {
                "x": 12.32446002960205,
                "y": -0.23916101455688477,
                "z": -287.2160949707031
            },
            {
                "x": 12.2554349899292,
                "y": -0.25300824642181396,
                "z": -287.0748596191406
            },
            {
                "x": 12.186539649963379,
                "y": -0.2670631408691406,
                "z": -286.9340515136719
            },
            {
                "x": 12.11745834350586,
                "y": -0.2813771963119507,
                "z": -286.7930603027344
            },
            {
                "x": 12.048335075378418,
                "y": -0.2959144413471222,
                "z": -286.65228271484375
            },
            {
                "x": 11.979114532470703,
                "y": -0.310672789812088,
                "z": -286.5115051269531
            },
            {
                "x": 11.909778594970703,
                "y": -0.32564133405685425,
                "z": -286.3707580566406
            },
            {
                "x": 11.840444564819336,
                "y": -0.34079068899154663,
                "z": -286.2301025390625
            },
            {
                "x": 11.771025657653809,
                "y": -0.35612648725509644,
                "z": -286.0896301269531
            },
            {
                "x": 11.701546669006348,
                "y": -0.3716374337673187,
                "z": -285.9491271972656
            },
            {
                "x": 11.632057189941406,
                "y": -0.38730156421661377,
                "z": -285.8087463378906
            },
            {
                "x": 11.562471389770508,
                "y": -0.40312659740448,
                "z": -285.6683349609375
            },
            {
                "x": 11.492684364318848,
                "y": -0.4191141724586487,
                "z": -285.5278015136719
            },
            {
                "x": 11.422996520996094,
                "y": -0.43519604206085205,
                "z": -285.3876647949219
            },
            {
                "x": 11.35319995880127,
                "y": -0.4514109492301941,
                "z": -285.2474365234375
            },
            {
                "x": 11.28341293334961,
                "y": -0.4677177965641022,
                "z": -285.1073913574219
            },
            {
                "x": 11.213537216186523,
                "y": -0.48413151502609253,
                "z": -284.9673156738281
            },
            {
                "x": 11.143502235412598,
                "y": -0.500659704208374,
                "z": -284.82696533203125
            },
            {
                "x": 11.0735502243042,
                "y": -0.5172289609909058,
                "z": -284.6871032714844
            },
            {
                "x": 11.003512382507324,
                "y": -0.5338791608810425,
                "z": -284.5470275878906
            },
            {
                "x": 10.933467864990234,
                "y": -0.5505744218826294,
                "z": -284.4071044921875
            },
            {
                "x": 10.863340377807617,
                "y": -0.5673230290412903,
                "z": -284.2671813964844
            },
            {
                "x": 10.7931547164917,
                "y": -0.584112823009491,
                "z": -284.1271667480469
            },
            {
                "x": 10.722979545593262,
                "y": -0.600911021232605,
                "z": -283.9873352050781
            },
            {
                "x": 10.652771949768066,
                "y": -0.6177194714546204,
                "z": -283.8475036621094
            },
            {
                "x": 10.582515716552734,
                "y": -0.634536623954773,
                "z": -283.7076416015625
            },
            {
                "x": 10.512248039245605,
                "y": -0.6513410806655884,
                "z": -283.56787109375
            },
            {
                "x": 10.441927909851074,
                "y": -0.6681246757507324,
                "z": -283.4280700683594
            },
            {
                "x": 10.371590614318848,
                "y": -0.6848812103271484,
                "z": -283.288330078125
            },
            {
                "x": 10.301342964172363,
                "y": -0.7015764713287354,
                "z": -283.1486511230469
            },
            {
                "x": 10.230923652648926,
                "y": -0.718248724937439,
                "z": -283.0087890625
            },
            {
                "x": 10.160618782043457,
                "y": -0.7348294258117676,
                "z": -282.8692321777344
            },
            {
                "x": 10.090317726135254,
                "y": -0.7513392567634583,
                "z": -282.7295837402344
            },
            {
                "x": 10.019916534423828,
                "y": -0.7677862048149109,
                "z": -282.58978271484375
            },
            {
                "x": 9.949531555175781,
                "y": -0.7841380834579468,
                "z": -282.449951171875
            },
            {
                "x": 9.879143714904785,
                "y": -0.8003696799278259,
                "z": -282.3102722167969
            },
            {
                "x": 9.833701133728027,
                "y": -0.810793936252594,
                "z": -282.2200622558594
            },
            {
                "x": 9.76332950592041,
                "y": -0.826829731464386,
                "z": -282.0803527832031
            },
            {
                "x": 9.692913055419922,
                "y": -0.8427379727363586,
                "z": -281.94061279296875
            },
            {
                "x": 9.622550964355469,
                "y": -0.8584945797920227,
                "z": -281.8009033203125
            },
            {
                "x": 9.552217483520508,
                "y": -0.8740975856781006,
                "z": -281.6611633300781
            },
            {
                "x": 9.481871604919434,
                "y": -0.8895379304885864,
                "z": -281.5213623046875
            },
            {
                "x": 9.411650657653809,
                "y": -0.9047764539718628,
                "z": -281.38177490234375
            },
            {
                "x": 9.341384887695312,
                "y": -0.9198471307754517,
                "z": -281.2419738769531
            },
            {
                "x": 9.271117210388184,
                "y": -0.9347269535064697,
                "z": -281.1020812988281
            },
            {
                "x": 9.200886726379395,
                "y": -0.9493963718414307,
                "z": -280.962158203125
            },
            {
                "x": 9.130743980407715,
                "y": -0.9638286232948303,
                "z": -280.8222961425781
            },
            {
                "x": 9.060619354248047,
                "y": -0.9780384302139282,
                "z": -280.68243408203125
            },
            {
                "x": 8.990584373474121,
                "y": -0.9919995069503784,
                "z": -280.54254150390625
            },
            {
                "x": 8.920414924621582,
                "y": -1.0057408809661865,
                "z": -280.4023132324219
            },
            {
                "x": 8.850491523742676,
                "y": -1.0191771984100342,
                "z": -280.2624206542969
            },
            {
                "x": 8.780616760253906,
                "y": -1.0323429107666016,
                "z": -280.1224365234375
            },
            {
                "x": 8.710650444030762,
                "y": -1.0452477931976318,
                "z": -279.9822082519531
            },
            {
                "x": 8.640885353088379,
                "y": -1.0578378438949585,
                "z": -279.8421325683594
            },
            {
                "x": 8.571149826049805,
                "y": -1.0701165199279785,
                "z": -279.7020263671875
            },
            {
                "x": 8.50148868560791,
                "y": -1.082085371017456,
                "z": -279.56170654296875
            },
            {
                "x": 8.431926727294922,
                "y": -1.0937187671661377,
                "z": -279.42144775390625
            },
            {
                "x": 8.36244010925293,
                "y": -1.1050195693969727,
                "z": -279.2811584472656
            },
            {
                "x": 8.293055534362793,
                "y": -1.115952730178833,
                "z": -279.140869140625
            },
            {
                "x": 8.223764419555664,
                "y": -1.1265277862548828,
                "z": -279.0004577636719
            },
            {
                "x": 8.154454231262207,
                "y": -1.1367509365081787,
                "z": -278.8597412109375
            },
            {
                "x": 8.085338592529297,
                "y": -1.146578073501587,
                "z": -278.71923828125
            },
            {
                "x": 8.016260147094727,
                "y": -1.1560094356536865,
                "z": -278.57855224609375
            },
            {
                "x": 7.947373390197754,
                "y": -1.1650232076644897,
                "z": -278.4378662109375
            },
            {
                "x": 7.8785576820373535,
                "y": -1.173628330230713,
                "z": -278.2970886230469
            },
            {
                "x": 7.809837341308594,
                "y": -1.1818132400512695,
                "z": -278.15618896484375
            },
            {
                "x": 7.741273403167725,
                "y": -1.1895501613616943,
                "z": -278.01531982421875
            },
            {
                "x": 7.672860622406006,
                "y": -1.1968262195587158,
                "z": -277.8743591308594
            },
            {
                "x": 7.604502201080322,
                "y": -1.2036547660827637,
                "z": -277.73321533203125
            },
            {
                "x": 7.536383628845215,
                "y": -1.210005521774292,
                "z": -277.5921630859375
            },
            {
                "x": 7.4682769775390625,
                "y": -1.2158795595169067,
                "z": -277.4508361816406
            },
            {
                "x": 7.400388717651367,
                "y": -1.2212438583374023,
                "z": -277.3095397949219
            },
            {
                "x": 7.332683563232422,
                "y": -1.2261067628860474,
                "z": -277.168212890625
            },
            {
                "x": 7.265072345733643,
                "y": -1.2304613590240479,
                "z": -277.02679443359375
            },
            {
                "x": 7.1976704597473145,
                "y": -1.2342833280563354,
                "z": -276.88525390625
            },
            {
                "x": 7.130423069000244,
                "y": -1.2375544309616089,
                "z": -276.7437438964844
            },
            {
                "x": 7.063310146331787,
                "y": -1.2402852773666382,
                "z": -276.6019287109375
            },
            {
                "x": 6.996402263641357,
                "y": -1.2424595355987549,
                "z": -276.460205078125
            },
            {
                "x": 6.929755210876465,
                "y": -1.2440581321716309,
                "z": -276.3184509277344
            },
            {
                "x": 6.8867597579956055,
                "y": -1.2447700500488281,
                "z": -276.226806640625
            },
            {
                "x": 6.820427894592285,
                "y": -1.2454047203063965,
                "z": -276.0849304199219
            },
            {
                "x": 6.754180908203125,
                "y": -1.245443344116211,
                "z": -275.9427795410156
            },
            {
                "x": 6.68819522857666,
                "y": -1.2448619604110718,
                "z": -275.8006286621094
            },
            {
                "x": 6.622407913208008,
                "y": -1.2436964511871338,
                "z": -275.65838623046875
            },
            {
                "x": 6.556828022003174,
                "y": -1.2419590950012207,
                "z": -275.5161437988281
            },
            {
                "x": 6.491423606872559,
                "y": -1.2396554946899414,
                "z": -275.3736572265625
            },
            {
                "x": 6.426382541656494,
                "y": -1.2367815971374512,
                "z": -275.2314758300781
            },
            {
                "x": 6.361370086669922,
                "y": -1.2333579063415527,
                "z": -275.088623046875
            },
            {
                "x": 6.29679012298584,
                "y": -1.2294172048568726,
                "z": -274.94622802734375
            },
            {
                "x": 6.232316970825195,
                "y": -1.2249486446380615,
                "z": -274.8034362792969
            },
            {
                "x": 6.168166160583496,
                "y": -1.2199554443359375,
                "z": -274.6607360839844
            },
            {
                "x": 6.104289531707764,
                "y": -1.214464783668518,
                "z": -274.5179443359375
            },
            {
                "x": 6.040521144866943,
                "y": -1.2084829807281494,
                "z": -274.3748474121094
            },
            {
                "x": 5.977092742919922,
                "y": -1.2020320892333984,
                "z": -274.2318420410156
            },
            {
                "x": 5.913936138153076,
                "y": -1.195101261138916,
                "z": -274.0888366699219
            },
            {
                "x": 5.851064205169678,
                "y": -1.1877140998840332,
                "z": -273.94561767578125
            },
            {
                "x": 5.788390636444092,
                "y": -1.1798838376998901,
                "z": -273.8022766113281
            },
            {
                "x": 5.726065635681152,
                "y": -1.1716301441192627,
                "z": -273.65899658203125
            },
            {
                "x": 5.663938522338867,
                "y": -1.1629319190979004,
                "z": -273.5155029296875
            },
            {
                "x": 5.602208614349365,
                "y": -1.1538352966308594,
                "z": -273.3720397949219
            },
            {
                "x": 5.5406880378723145,
                "y": -1.1443367004394531,
                "z": -273.2284851074219
            },
            {
                "x": 5.479534149169922,
                "y": -1.1344610452651978,
                "z": -273.0848693847656
            },
            {
                "x": 5.418596267700195,
                "y": -1.1241869926452637,
                "z": -272.9410705566406
            },
            {
                "x": 5.357958793640137,
                "y": -1.1135413646697998,
                "z": -272.7970886230469
            },
            {
                "x": 5.2975754737854,
                "y": -1.1025440692901611,
                "z": -272.653076171875
            },
            {
                "x": 5.237611293792725,
                "y": -1.091219425201416,
                "z": -272.5091552734375
            },
            {
                "x": 5.177819728851318,
                "y": -1.0795342922210693,
                "z": -272.3648681640625
            },
            {
                "x": 5.118503570556641,
                "y": -1.067549705505371,
                "z": -272.2208251953125
            },
            {
                "x": 5.059292316436768,
                "y": -1.0552175045013428,
                "z": -272.07623291015625
            },
            {
                "x": 5.0005717277526855,
                "y": -1.0426239967346191,
                "z": -271.9319763183594
            },
            {
                "x": 4.94204568862915,
                "y": -1.0297117233276367,
                "z": -271.78729248046875
            },
            {
                "x": 4.883954048156738,
                "y": -1.0165367126464844,
                "z": -271.6427917480469
            },
            {
                "x": 4.826128959655762,
                "y": -1.003079891204834,
                "z": -271.49798583984375
            },
            {
                "x": 4.768666744232178,
                "y": -0.9893838763237,
                "z": -271.353271484375
            },
            {
                "x": 4.711482048034668,
                "y": -0.9754161834716797,
                "z": -271.2081604003906
            },
            {
                "x": 4.654687404632568,
                "y": -0.9612337350845337,
                "z": -271.063232421875
            },
            {
                "x": 4.598163604736328,
                "y": -0.9468045234680176,
                "z": -270.91796875
            },
            {
                "x": 4.542047023773193,
                "y": -0.9321926832199097,
                "z": -270.7729187011719
            },
            {
                "x": 4.486240863800049,
                "y": -0.9173575639724731,
                "z": -270.62750244140625
            },
            {
                "x": 4.430700302124023,
                "y": -0.902316689491272,
                "z": -270.4819641113281
            },
            {
                "x": 4.375636100769043,
                "y": -0.8871172666549683,
                "z": -270.33648681640625
            },
            {
                "x": 4.320830821990967,
                "y": -0.8717397451400757,
                "z": -270.19085693359375
            },
            {
                "x": 4.285682201385498,
                "y": -0.8617337942123413,
                "z": -270.0968322753906
            },
            {
                "x": 4.2314558029174805,
                "y": -0.8460863828659058,
                "z": -269.95086669921875
            },
            {
                "x": 4.177661895751953,
                "y": -0.8303262591362,
                "z": -269.8050842285156
            },
            {
                "x": 4.1241044998168945,
                "y": -0.8143927454948425,
                "z": -269.6588134765625
            },
            {
                "x": 4.071021556854248,
                "y": -0.7983827590942383,
                "z": -269.5128479003906
            },
            {
                "x": 4.018204689025879,
                "y": -0.7822202444076538,
                "z": -269.3663635253906
            },
            {
                "x": 3.965797185897827,
                "y": -0.7659909725189209,
                "z": -269.2201232910156
            },
            {
                "x": 3.9137730598449707,
                "y": -0.7496632933616638,
                "z": -269.0736083984375
            },
            {
                "x": 3.861976146697998,
                "y": -0.7332361936569214,
                "z": -268.9268493652344
            },
            {
                "x": 3.8106954097747803,
                "y": -0.7167656421661377,
                "z": -268.7801818847656
            },
            {
                "x": 3.759674549102783,
                "y": -0.700225830078125,
                "z": -268.6332702636719
            },
            {
                "x": 3.70910382270813,
                "y": -0.6836485862731934,
                "z": -268.4863586425781
            },
            {
                "x": 3.658804416656494,
                "y": -0.6670290231704712,
                "z": -268.3392028808594
            },
            {
                "x": 3.6089630126953125,
                "y": -0.650384783744812,
                "z": -268.1919860839844
            },
            {
                "x": 3.559408187866211,
                "y": -0.6337140798568726,
                "z": -268.0445556640625
            },
            {
                "x": 3.5103397369384766,
                "y": -0.6170741319656372,
                "z": -267.8973388671875
            },
            {
                "x": 3.4614920616149902,
                "y": -0.6003916263580322,
                "z": -267.7494812011719
            },
            {
                "x": 3.4131500720977783,
                "y": -0.583775520324707,
                "z": -267.60205078125
            },
            {
                "x": 3.365081310272217,
                "y": -0.5671436190605164,
                "z": -267.4539794921875
            },
            {
                "x": 3.3173863887786865,
                "y": -0.5505712032318115,
                "z": -267.3061218261719
            },
            {
                "x": 3.2701451778411865,
                "y": -0.5340476036071777,
                "z": -267.1580810546875
            },
            {
                "x": 3.223207473754883,
                "y": -0.5175867676734924,
                "z": -267.0099792480469
            },
            {
                "x": 3.1767327785491943,
                "y": -0.5012022256851196,
                "z": -266.8617248535156
            },
            {
                "x": 3.1305391788482666,
                "y": -0.48488473892211914,
                "z": -266.71331787109375
            },
            {
                "x": 3.0847580432891846,
                "y": -0.4686529040336609,
                "z": -266.56475830078125
            },
            {
                "x": 3.039281129837036,
                "y": -0.45251065492630005,
                "z": -266.4159240722656
            },
            {
                "x": 2.994286060333252,
                "y": -0.4365132451057434,
                "z": -266.2672424316406
            },
            {
                "x": 2.949571371078491,
                "y": -0.42060261964797974,
                "z": -266.1181335449219
            },
            {
                "x": 2.9053187370300293,
                "y": -0.4048616290092468,
                "z": -265.96923828125
            },
            {
                "x": 2.861337184906006,
                "y": -0.3892139792442322,
                "z": -265.81982421875
            },
            {
                "x": 2.8178062438964844,
                "y": -0.373764306306839,
                "z": -265.67059326171875
            },
            {
                "x": 2.7746999263763428,
                "y": -0.3584750294685364,
                "z": -265.52117919921875
            },
            {
                "x": 2.731818199157715,
                "y": -0.34333211183547974,
                "z": -265.3714904785156
            },
            {
                "x": 2.6894640922546387,
                "y": -0.3284085988998413,
                "z": -265.2219543457031
            },
            {
                "x": 2.647341012954712,
                "y": -0.3136460781097412,
                "z": -265.0719299316406
            },
            {
                "x": 2.6057252883911133,
                "y": -0.2991294264793396,
                "z": -264.9221496582031
            },
            {
                "x": 2.564418315887451,
                "y": -0.2848004996776581,
                "z": -264.7719421386719
            },
            {
                "x": 2.5234971046447754,
                "y": -0.27071622014045715,
                "z": -264.6218566894531
            },
            {
                "x": 2.4829630851745605,
                "y": -0.25685834884643555,
                "z": -264.4714660644531
            },
            {
                "x": 2.4427835941314697,
                "y": -0.24326860904693604,
                "z": -264.3211669921875
            },
            {
                "x": 2.402998924255371,
                "y": -0.22991891205310822,
                "z": -264.17047119140625
            },
            {
                "x": 2.3635082244873047,
                "y": -0.21683411300182343,
                "z": -264.01971435546875
            },
            {
                "x": 2.3245482444763184,
                "y": -0.20406439900398254,
                "z": -263.86920166015625
            },
            {
                "x": 2.2995028495788574,
                "y": -0.19594991207122803,
                "z": -263.77154541015625
            },
            {
                "x": 2.2610297203063965,
                "y": -0.18364356458187103,
                "z": -263.6205749511719
            },
            {
                "x": 2.222977876663208,
                "y": -0.17164233326911926,
                "z": -263.469482421875
            },
            {
                "x": 2.18520450592041,
                "y": -0.15995973348617554,
                "z": -263.31805419921875
            },
            {
                "x": 2.1479389667510986,
                "y": -0.14863115549087524,
                "z": -263.1669006347656
            },
            {
                "x": 2.110908269882202,
                "y": -0.13760533928871155,
                "z": -263.0151672363281
            },
            {
                "x": 2.0743300914764404,
                "y": -0.12695951759815216,
                "z": -262.8637390136719
            },
            {
                "x": 2.0381321907043457,
                "y": -0.11666969209909439,
                "z": -262.71197509765625
            },
            {
                "x": 2.0022027492523193,
                "y": -0.10674542188644409,
                "z": -262.55999755859375
            },
            {
                "x": 1.9667754173278809,
                "y": -0.09722014516592026,
                "z": -262.408203125
            },
            {
                "x": 1.9315712451934814,
                "y": -0.08806018531322479,
                "z": -262.2558898925781
            },
            {
                "x": 1.8968470096588135,
                "y": -0.07934103906154633,
                "z": -262.1038818359375
            },
            {
                "x": 1.8624267578125,
                "y": -0.07102009654045105,
                "z": -261.9514465332031
            },
            {
                "x": 1.8283379077911377,
                "y": -0.06312507390975952,
                "z": -261.7990417480469
            },
            {
                "x": 1.7946841716766357,
                "y": -0.05566558614373207,
                "z": -261.64654541015625
            },
            {
                "x": 1.7613093852996826,
                "y": -0.048660580068826675,
                "z": -261.4938659667969
            },
            {
                "x": 1.7283954620361328,
                "y": -0.04212527349591255,
                "z": -261.3412780761719
            },
            {
                "x": 1.6957546472549438,
                "y": -0.036041807383298874,
                "z": -261.18829345703125
            },
            {
                "x": 1.663513422012329,
                "y": -0.030444035306572914,
                "z": -261.0356140136719
            },
            {
                "x": 1.6316324472427368,
                "y": -0.025336716324090958,
                "z": -260.8824462890625
            },
            {
                "x": 1.6000697612762451,
                "y": -0.02073909342288971,
                "z": -260.7293395996094
            },
            {
                "x": 1.568946123123169,
                "y": -0.0166514553129673,
                "z": -260.5763244628906
            },
            {
                "x": 1.538077712059021,
                "y": -0.013073036447167397,
                "z": -260.42291259765625
            },
            {
                "x": 1.5076404809951782,
                "y": -0.010043634101748466,
                "z": -260.2698059082031
            },
            {
                "x": 1.4775004386901855,
                "y": -0.007554776966571808,
                "z": -260.1161193847656
            },
            {
                "x": 1.4476946592330933,
                "y": -0.005618616007268429,
                "z": -259.9626159667969
            },
            {
                "x": 1.418318271636963,
                "y": -0.0042414069175720215,
                "z": -259.80914306640625
            },
            {
                "x": 1.3891743421554565,
                "y": -0.0034453347325325012,
                "z": -259.6552429199219
            },
            {
                "x": 1.3604668378829956,
                "y": -0.003223537001758814,
                "z": -259.501708984375
            },
            {
                "x": 1.332057237625122,
                "y": -0.0032242760062217712,
                "z": -259.3476257324219
            },
            {
                "x": 1.3039692640304565,
                "y": -0.003225162625312805,
                "z": -259.1937561035156
            },
            {
                "x": 1.2763166427612305,
                "y": -0.003225982189178467,
                "z": -259.0399475097656
            },
            {
                "x": 1.2489145994186401,
                "y": -0.003226831555366516,
                "z": -258.88568115234375
            },
            {
                "x": 1.2218966484069824,
                "y": -0.003227636218070984,
                "z": -258.7317810058594
            },
            {
                "x": 1.195218801498413,
                "y": -0.003228500485420227,
                "z": -258.5775146484375
            },
            {
                "x": 1.1688027381896973,
                "y": -0.0032293274998664856,
                "z": -258.4231872558594
            },
            {
                "x": 1.1428415775299072,
                "y": -0.0032301917672157288,
                "z": -258.26910400390625
            },
            {
                "x": 1.1171218156814575,
                "y": -0.003231033682823181,
                "z": -258.1145324707031
            },
            {
                "x": 1.091740608215332,
                "y": -0.003231838345527649,
                "z": -257.9602966308594
            },
            {
                "x": 1.0667492151260376,
                "y": -0.003232695162296295,
                "z": -257.8058776855469
            },
            {
                "x": 1.0419718027114868,
                "y": -0.0032335296273231506,
                "z": -257.651123046875
            },
            {
                "x": 1.0176184177398682,
                "y": -0.0032344013452529907,
                "z": -257.49676513671875
            },
            {
                "x": 0.9935532808303833,
                "y": -0.0032352134585380554,
                "z": -257.342041015625
            },
            {
                "x": 0.9781485795974731,
                "y": -0.003235757350921631,
                "z": -257.2420959472656
            },
            {
                "x": 0.9546465873718262,
                "y": -0.0032365843653678894,
                "z": -257.08758544921875
            },
            {
                "x": 0.9314137697219849,
                "y": -0.0032374337315559387,
                "z": -256.9325866699219
            },
            {
                "x": 0.9084575176239014,
                "y": -0.0032382458448410034,
                "z": -256.7778015136719
            },
            {
                "x": 0.8859261274337769,
                "y": -0.0032391026616096497,
                "z": -256.62310791015625
            },
            {
                "x": 0.86360764503479,
                "y": -0.003239944577217102,
                "z": -256.4678649902344
            },
            {
                "x": 0.8416244983673096,
                "y": -0.0032407790422439575,
                "z": -256.31304931640625
            },
            {
                "x": 0.8200057744979858,
                "y": -0.003241591155529022,
                "z": -256.1580505371094
            },
            {
                "x": 0.7985816597938538,
                "y": -0.0032424703240394592,
                "z": -256.002685546875
            },
            {
                "x": 0.7775506973266602,
                "y": -0.003243282437324524,
                "z": -255.84779357910156
            },
            {
                "x": 0.7568071484565735,
                "y": -0.00324413925409317,
                "z": -255.6925048828125
            },
            {
                "x": 0.7363017797470093,
                "y": -0.003244943916797638,
                "z": -255.5372314453125
            },
            {
                "x": 0.716194212436676,
                "y": -0.003245808184146881,
                "z": -255.38218688964844
            },
            {
                "x": 0.696304440498352,
                "y": -0.003246679902076721,
                "z": -255.2265167236328
            },
            {
                "x": 0.6767120361328125,
                "y": -0.003247469663619995,
                "z": -255.07130432128906
            },
            {
                "x": 0.6574839353561401,
                "y": -0.0032483190298080444,
                "z": -254.91603088378906
            },
            {
                "x": 0.6384645700454712,
                "y": -0.003249160945415497,
                "z": -254.7603302001953
            },
            {
                "x": 0.6197693943977356,
                "y": -0.003250017762184143,
                "z": -254.6050567626953
            },
            {
                "x": 0.6013945937156677,
                "y": -0.0032508447766304016,
                "z": -254.44947814941406
            },
            {
                "x": 0.5832224488258362,
                "y": -0.003251686692237854,
                "z": -254.2937469482422
            },
            {
                "x": 0.565402626991272,
                "y": -0.0032525137066841125,
                "z": -254.1383514404297
            },
            {
                "x": 0.5478874444961548,
                "y": -0.003253348171710968,
                "z": -253.9827423095703
            },
            {
                "x": 0.530571460723877,
                "y": -0.003254152834415436,
                "z": -253.82701110839844
            },
            {
                "x": 0.513597309589386,
                "y": -0.003255017101764679,
                "z": -253.6715850830078
            },
            {
                "x": 0.49688735604286194,
                "y": -0.003255873918533325,
                "z": -253.51560974121094
            },
            {
                "x": 0.48040199279785156,
                "y": -0.0032567083835601807,
                "z": -253.35984802246094
            },
            {
                "x": 0.4642500877380371,
                "y": -0.0032575279474258423,
                "z": -253.20420837402344
            },
            {
                "x": 0.44834890961647034,
                "y": -0.003258422017097473,
                "z": -253.04820251464844
            },
            {
                "x": 0.43267735838890076,
                "y": -0.0032591894268989563,
                "z": -252.89236450195312
            },
            {
                "x": 0.4173256456851959,
                "y": -0.0032600611448287964,
                "z": -252.73646545410156
            },
            {
                "x": 0.4022270441055298,
                "y": -0.003260888159275055,
                "z": -252.5804443359375
            },
            {
                "x": 0.3873487412929535,
                "y": -0.0032617226243019104,
                "z": -252.424560546875
            },
            {
                "x": 0.3727993667125702,
                "y": -0.0032625794410705566,
                "z": -252.2686309814453
            },
            {
                "x": 0.3584795892238617,
                "y": -0.003263406455516815,
                "z": -252.1124725341797
            },
            {
                "x": 0.34437665343284607,
                "y": -0.003264226019382477,
                "z": -251.95643615722656
            },
            {
                "x": 0.33059895038604736,
                "y": -0.003265075385570526,
                "z": -251.80044555664062
            },
            {
                "x": 0.3170472979545593,
                "y": -0.0032659098505973816,
                "z": -251.6442413330078
            },
            {
                "x": 0.3037092685699463,
                "y": -0.00326673686504364,
                "z": -251.48809814453125
            },
            {
                "x": 0.29069891571998596,
                "y": -0.0032675638794898987,
                "z": -251.33212280273438
            },
            {
                "x": 0.2778918445110321,
                "y": -0.003268405795097351,
                "z": -251.1758270263672
            },
            {
                "x": 0.2652946710586548,
                "y": -0.003269277513027191,
                "z": -251.01953125
            },
            {
                "x": 0.25302496552467346,
                "y": -0.003270097076892853,
                "z": -250.86346435546875
            },
            {
                "x": 0.24095579981803894,
                "y": -0.0032709490042179823,
                "z": -250.7071075439453
            },
            {
                "x": 0.23326414823532104,
                "y": -0.0032714679837226868,
                "z": -250.60618591308594
            },
            {
                "x": 0.22161170840263367,
                "y": -0.003272309899330139,
                "z": -250.4501190185547
            },
            {
                "x": 0.2102070450782776,
                "y": -0.003273122012615204,
                "z": -250.293701171875
            },
            {
                "x": 0.19896894693374634,
                "y": -0.003274008631706238,
                "z": -250.13723754882812
            },
            {
                "x": 0.18801742792129517,
                "y": -0.003274857997894287,
                "z": -249.9810791015625
            },
            {
                "x": 0.1773267388343811,
                "y": -0.0032756850123405457,
                "z": -249.8246307373047
            },
            {
                "x": 0.16680654883384705,
                "y": -0.003276526927947998,
                "z": -249.6681671142578
            },
            {
                "x": 0.15654128789901733,
                "y": -0.0032773390412330627,
                "z": -249.511962890625
            },
            {
                "x": 0.1465388834476471,
                "y": -0.003278188407421112,
                "z": -249.35537719726562
            },
            {
                "x": 0.13671481609344482,
                "y": -0.0032790303230285645,
                "z": -249.19886779785156
            },
            {
                "x": 0.12712010741233826,
                "y": -0.0032798349857330322,
                "z": -249.04249572753906
            },
            {
                "x": 0.11780378222465515,
                "y": -0.0032807067036628723,
                "z": -248.88607788085938
            },
            {
                "x": 0.10866308212280273,
                "y": -0.003281503915786743,
                "z": -248.7294921875
            },
            {
                "x": 0.09971988201141357,
                "y": -0.00328238308429718,
                "z": -248.5728759765625
            },
            {
                "x": 0.09106659889221191,
                "y": -0.0032832100987434387,
                "z": -248.41650390625
            },
            {
                "x": 0.08259057998657227,
                "y": -0.003284044563770294,
                "z": -248.25985717773438
            },
            {
                "x": 0.07429450750350952,
                "y": -0.0032849162817001343,
                "z": -248.10325622558594
            },
            {
                "x": 0.06628468632698059,
                "y": -0.003285728394985199,
                "z": -247.94686889648438
            },
            {
                "x": 0.058467596769332886,
                "y": -0.003286600112915039,
                "z": -247.7901153564453
            },
            {
                "x": 0.0508078932762146,
                "y": -0.003287382423877716,
                "z": -247.63340759277344
            },
            {
                "x": 0.04341122508049011,
                "y": -0.003288254141807556,
                "z": -247.4769744873047
            },
            {
                "x": 0.03624773025512695,
                "y": -0.0032891109585762024,
                "z": -247.32034301757812
            },
            {
                "x": 0.02922576665878296,
                "y": -0.003289923071861267,
                "z": -247.16363525390625
            },
            {
                "x": 0.02243146300315857,
                "y": -0.0032907575368881226,
                "z": -247.00717163085938
            },
            {
                "x": 0.015878289937973022,
                "y": -0.003291606903076172,
                "z": -246.85035705566406
            },
            {
                "x": 0.009486883878707886,
                "y": -0.0032924115657806396,
                "z": -246.69361877441406
            },
            {
                "x": 0.0032833218574523926,
                "y": -0.0032932907342910767,
                "z": -246.5369873046875
            },
            {
                "x": -0.002666264772415161,
                "y": -0.0032940953969955444,
                "z": -246.38037109375
            },
            {
                "x": -0.008440077304840088,
                "y": -0.0032949447631835938,
                "z": -246.2235565185547
            },
            {
                "x": -0.014060258865356445,
                "y": -0.0032957643270492554,
                "z": -246.0666961669922
            },
            {
                "x": -0.019430816173553467,
                "y": -0.0032966136932373047,
                "z": -245.91015625
            },
            {
                "x": -0.024598270654678345,
                "y": -0.0032974407076835632,
                "z": -245.75335693359375
            },
            {
                "x": -0.02963458001613617,
                "y": -0.0032982975244522095,
                "z": -245.59646606445312
            },
            {
                "x": -0.03444918990135193,
                "y": -0.003299124538898468,
                "z": -245.4398651123047
            },
            {
                "x": -0.03903520107269287,
                "y": -0.003299988806247711,
                "z": -245.28306579589844
            },
            {
                "x": -0.04347917437553406,
                "y": -0.003300793468952179,
                "z": -245.1260986328125
            },
            {
                "x": -0.04775458574295044,
                "y": -0.003301665186882019,
                "z": -244.96942138671875
            },
            {
                "x": -0.05178616940975189,
                "y": -0.0033024773001670837,
                "z": -244.81268310546875
            },
            {
                "x": -0.05564016103744507,
                "y": -0.0033032968640327454,
                "z": -244.65579223632812
            },
            {
                "x": -0.05936489999294281,
                "y": -0.0033041611313819885,
                "z": -244.4989471435547
            },
            {
                "x": -0.06288179755210876,
                "y": -0.003305010497570038,
                "z": -244.34213256835938
            },
            {
                "x": -0.06617142260074615,
                "y": -0.0033058226108551025,
                "z": -244.18536376953125
            },
            {
                "x": -0.06933335959911346,
                "y": -0.0033066794276237488,
                "z": -244.0284423828125
            },
            {
                "x": -0.07130016386508942,
                "y": -0.0033071786165237427,
                "z": -243.9272003173828
            },
            {
                "x": -0.0741448849439621,
                "y": -0.0033080503344535828,
                "z": -243.77052307128906
            },
            {
                "x": -0.07679478824138641,
                "y": -0.003308899700641632,
                "z": -243.61358642578125
            },
            {
                "x": -0.07932327687740326,
                "y": -0.0033097043633461,
                "z": -243.4565887451172
            },
            {
                "x": -0.08168081939220428,
                "y": -0.003310561180114746,
                "z": -243.29983520507812
            },
            {
                "x": -0.08381156623363495,
                "y": -0.0033113956451416016,
                "z": -243.1429443359375
            },
            {
                "x": -0.08579166233539581,
                "y": -0.00331222265958786,
                "z": -242.98597717285156
            },
            {
                "x": -0.08764564990997314,
                "y": -0.0033130794763565063,
                "z": -242.82916259765625
            },
            {
                "x": -0.08930656313896179,
                "y": -0.0033139362931251526,
                "z": -242.67221069335938
            },
            {
                "x": -0.09077589213848114,
                "y": -0.0033147484064102173,
                "z": -242.51528930664062
            },
            {
                "x": -0.0921337902545929,
                "y": -0.0033155828714370728,
                "z": -242.35829162597656
            },
            {
                "x": -0.09334644675254822,
                "y": -0.003316439688205719,
                "z": -242.2013397216797
            },
            {
                "x": -0.09439924359321594,
                "y": -0.0033172741532325745,
                "z": -242.04441833496094
            },
            {
                "x": -0.09536293148994446,
                "y": -0.00331810861825943,
                "z": -241.8871612548828
            },
            {
                "x": -0.09624415636062622,
                "y": -0.0033189505338668823,
                "z": -241.73013305664062
            },
            {
                "x": -0.09703627228736877,
                "y": -0.003319784998893738,
                "z": -241.5730438232422
            },
            {
                "x": -0.09783200919628143,
                "y": -0.0033206120133399963,
                "z": -241.4155731201172
            },
            {
                "x": -0.09869316220283508,
                "y": -0.0033214613795280457,
                "z": -241.2582550048828
            },
            {
                "x": -0.09957045316696167,
                "y": -0.003322310745716095,
                "z": -241.10081481933594
            },
            {
                "x": -0.10056012868881226,
                "y": -0.0033231377601623535,
                "z": -240.94309997558594
            },
            {
                "x": -0.10174620151519775,
                "y": -0.003323979675769806,
                "z": -240.7854461669922
            },
            {
                "x": -0.10309089720249176,
                "y": -0.0033248141407966614,
                "z": -240.6279296875
            },
            {
                "x": -0.1046169251203537,
                "y": -0.003325648605823517,
                "z": -240.4701385498047
            },
            {
                "x": -0.1064281016588211,
                "y": -0.0033264681696891785,
                "z": -240.312255859375
            },
            {
                "x": -0.10848301649093628,
                "y": -0.0033273249864578247,
                "z": -240.15435791015625
            },
            {
                "x": -0.11072230339050293,
                "y": -0.0033281445503234863,
                "z": -239.9966583251953
            },
            {
                "x": -0.11326274275779724,
                "y": -0.00327992532402277,
                "z": -239.838623046875
            },
            {
                "x": -0.1161201149225235,
                "y": -0.0030074086971580982,
                "z": -239.68075561523438
            },
            {
                "x": -0.11917702853679657,
                "y": -0.002488377969712019,
                "z": -239.5231475830078
            },
            {
                "x": -0.12247903645038605,
                "y": -0.001715335063636303,
                "z": -239.3650360107422
            },
            {
                "x": -0.1261274814605713,
                "y": -0.0006978560704737902,
                "z": -239.2070770263672
            },
            {
                "x": -0.13004601001739502,
                "y": 0.0005547318141907454,
                "z": -239.0494384765625
            },
            {
                "x": -0.1341550350189209,
                "y": 0.002042618812993169,
                "z": -238.8916473388672
            },
            {
                "x": -0.1385733038187027,
                "y": 0.003769828472286463,
                "z": -238.73367309570312
            },
            {
                "x": -0.14333826303482056,
                "y": 0.005728855263441801,
                "z": -238.57577514648438
            },
            {
                "x": -0.14831167459487915,
                "y": 0.007908597588539124,
                "z": -238.41812133789062
            },
            {
                "x": -0.1535165160894394,
                "y": 0.010311143472790718,
                "z": -238.2603302001953
            },
            {
                "x": -0.15908637642860413,
                "y": 0.012940949760377407,
                "z": -238.102294921875
            },
            {
                "x": -0.1649358868598938,
                "y": 0.01578254997730255,
                "z": -237.9447021484375
            },
            {
                "x": -0.17097818851470947,
                "y": 0.01883506402373314,
                "z": -237.7870635986328
            },
            {
                "x": -0.17734138667583466,
                "y": 0.022104186937212944,
                "z": -237.62901306152344
            },
            {
                "x": -0.18404650688171387,
                "y": 0.025575775653123856,
                "z": -237.4713134765625
            },
            {
                "x": -0.1909635066986084,
                "y": 0.029248112812638283,
                "z": -237.31381225585938
            },
            {
                "x": -0.19555243849754333,
                "y": 0.03172552213072777,
                "z": -237.2119598388672
            },
            {
                "x": -0.20295746624469757,
                "y": 0.03572946414351463,
                "z": -237.0541229248047
            },
            {
                "x": -0.21069256961345673,
                "y": 0.039928171783685684,
                "z": -236.89645385742188
            },
            {
                "x": -0.2186233252286911,
                "y": 0.044312216341495514,
                "z": -236.7388916015625
            },
            {
                "x": -0.22684085369110107,
                "y": 0.04888620600104332,
                "z": -236.58116149902344
            },
            {
                "x": -0.23543010652065277,
                "y": 0.053646910935640335,
                "z": -236.4233856201172
            },
            {
                "x": -0.2442503571510315,
                "y": 0.05858033150434494,
                "z": -236.2660369873047
            },
            {
                "x": -0.2533077001571655,
                "y": 0.06369457393884659,
                "z": -236.10848999023438
            },
            {
                "x": -0.2627426087856293,
                "y": 0.06899258494377136,
                "z": -235.95059204101562
            },
            {
                "x": -0.27245402336120605,
                "y": 0.07444380223751068,
                "z": -235.79322814941406
            },
            {
                "x": -0.2823786735534668,
                "y": 0.0800686627626419,
                "z": -235.6358184814453
            },
            {
                "x": -0.2926470637321472,
                "y": 0.08586542308330536,
                "z": -235.47811889648438
            },
            {
                "x": -0.3032465875148773,
                "y": 0.09181077778339386,
                "z": -235.3207244873047
            },
            {
                "x": -0.3140622675418854,
                "y": 0.09791217744350433,
                "z": -235.16329956054688
            },
            {
                "x": -0.3251757025718689,
                "y": 0.10417632758617401,
                "z": -235.00579833984375
            },
            {
                "x": -0.33665430545806885,
                "y": 0.11058656871318817,
                "z": -234.84837341308594
            },
            {
                "x": -0.3483724892139435,
                "y": 0.11713448166847229,
                "z": -234.69114685058594
            },
            {
                "x": -0.36033421754837036,
                "y": 0.12382897734642029,
                "z": -234.53379821777344
            },
            {
                "x": -0.37269431352615356,
                "y": 0.1306760162115097,
                "z": -234.3762969970703
            },
            {
                "x": -0.3853244483470917,
                "y": 0.1376442313194275,
                "z": -234.21913146972656
            },
            {
                "x": -0.39816713333129883,
                "y": 0.14474369585514069,
                "z": -234.06195068359375
            },
            {
                "x": -0.4113696813583374,
                "y": 0.15198051929473877,
                "z": -233.9045867919922
            },
            {
                "x": -0.4249073266983032,
                "y": 0.1593366265296936,
                "z": -233.74752807617188
            },
            {
                "x": -0.43864670395851135,
                "y": 0.1668092906475067,
                "z": -233.59056091308594
            },
            {
                "x": -0.4527387022972107,
                "y": 0.1744225174188614,
                "z": -233.43313598632812
            },
            {
                "x": -0.46716707944869995,
                "y": 0.18213409185409546,
                "z": -233.2760772705078
            },
            {
                "x": -0.48181799054145813,
                "y": 0.18995264172554016,
                "z": -233.11920166015625
            },
            {
                "x": -0.4967799186706543,
                "y": 0.1978948563337326,
                "z": -232.96202087402344
            },
            {
                "x": -0.5121092796325684,
                "y": 0.2059362381696701,
                "z": -232.80499267578125
            },
            {
                "x": -0.5276820659637451,
                "y": 0.21407325565814972,
                "z": -232.6480712890625
            },
            {
                "x": -0.5435268878936768,
                "y": 0.22231560945510864,
                "z": -232.49110412597656
            },
            {
                "x": -0.5597569942474365,
                "y": 0.23065444827079773,
                "z": -232.33413696289062
            },
            {
                "x": -0.5762434601783752,
                "y": 0.2390725314617157,
                "z": -232.1774139404297
            },
            {
                "x": -0.5929758548736572,
                "y": 0.24758398532867432,
                "z": -232.0205535888672
            },
            {
                "x": -0.6101127862930298,
                "y": 0.2561929225921631,
                "z": -231.86358642578125
            },
            {
                "x": -0.6275180578231812,
                "y": 0.26486432552337646,
                "z": -231.7069549560547
            },
            {
                "x": -0.6451506614685059,
                "y": 0.27361440658569336,
                "z": -231.55032348632812
            },
            {
                "x": -0.6631790399551392,
                "y": 0.2824562191963196,
                "z": -231.39337158203125
            },
            {
                "x": -0.6814928650856018,
                "y": 0.29134514927864075,
                "z": -231.23695373535156
            },
            {
                "x": -0.7000348567962646,
                "y": 0.3003045618534088,
                "z": -231.08045959472656
            },
            {
                "x": -0.7189767360687256,
                "y": 0.30935239791870117,
                "z": -230.923583984375
            },
            {
                "x": -0.7382023334503174,
                "y": 0.31843334436416626,
                "z": -230.7672119140625
            },
            {
                "x": -0.7576476335525513,
                "y": 0.327569842338562,
                "z": -230.6108856201172
            },
            {
                "x": -0.7704126834869385,
                "y": 0.3335118293762207,
                "z": -230.50973510742188
            },
            {
                "x": -0.7904655933380127,
                "y": 0.3427445590496063,
                "z": -230.3533172607422
            },
            {
                "x": -0.8107433915138245,
                "y": 0.3520129323005676,
                "z": -230.1970977783203
            },
            {
                "x": -0.83134925365448,
                "y": 0.36134636402130127,
                "z": -230.04061889648438
            },
            {
                "x": -0.8523141145706177,
                "y": 0.37071171402931213,
                "z": -229.88427734375
            },
            {
                "x": -0.8735185265541077,
                "y": 0.3801039755344391,
                "z": -229.72817993164062
            },
            {
                "x": -0.8950029611587524,
                "y": 0.38953885436058044,
                "z": -229.5719451904297
            },
            {
                "x": -0.9168844819068909,
                "y": 0.3990057706832886,
                "z": -229.41574096679688
            },
            {
                "x": -0.9390172958374023,
                "y": 0.40849387645721436,
                "z": -229.25967407226562
            },
            {
                "x": -0.9614192247390747,
                "y": 0.4180090129375458,
                "z": -229.10357666015625
            },
            {
                "x": -0.9842073917388916,
                "y": 0.427546888589859,
                "z": -228.9474639892578
            },
            {
                "x": -1.0072300434112549,
                "y": 0.4370843768119812,
                "z": -228.7916717529297
            },
            {
                "x": -1.0305474996566772,
                "y": 0.4466485381126404,
                "z": -228.63572692871094
            },
            {
                "x": -1.0542720556259155,
                "y": 0.45623305439949036,
                "z": -228.47959899902344
            },
            {
                "x": -1.0781745910644531,
                "y": 0.46579262614250183,
                "z": -228.3240203857422
            },
            {
                "x": -1.1024121046066284,
                "y": 0.47537514567375183,
                "z": -228.16815185546875
            },
            {
                "x": -1.1270270347595215,
                "y": 0.4849586486816406,
                "z": -228.0123291015625
            },
            {
                "x": -1.1518388986587524,
                "y": 0.4945164918899536,
                "z": -227.8568878173828
            },
            {
                "x": -1.1769895553588867,
                "y": 0.504089891910553,
                "z": -227.70106506347656
            },
            {
                "x": -1.2025163173675537,
                "y": 0.5136473178863525,
                "z": -227.54537963867188
            },
            {
                "x": -1.2282280921936035,
                "y": 0.5231692790985107,
                "z": -227.39007568359375
            },
            {
                "x": -1.2542812824249268,
                "y": 0.5326921939849854,
                "z": -227.2344970703125
            },
            {
                "x": -1.2806775569915771,
                "y": 0.5421861410140991,
                "z": -227.07908630371094
            },
            {
                "x": -1.3072760105133057,
                "y": 0.5516412258148193,
                "z": -226.92393493652344
            },
            {
                "x": -1.3342734575271606,
                "y": 0.5610990524291992,
                "z": -226.768310546875
            },
            {
                "x": -1.3615591526031494,
                "y": 0.5705013871192932,
                "z": -226.6131134033203
            },
            {
                "x": -1.3890528678894043,
                "y": 0.5798641443252563,
                "z": -226.4580078125
            },
            {
                "x": -1.416929006576538,
                "y": 0.5892055034637451,
                "z": -226.30264282226562
            },
            {
                "x": -1.4450929164886475,
                "y": 0.5984859466552734,
                "z": -226.1476593017578
            },
            {
                "x": -1.4735090732574463,
                "y": 0.6077301502227783,
                "z": -225.99252319335938
            },
            {
                "x": -1.5022680759429932,
                "y": 0.6169279217720032,
                "z": -225.83738708496094
            },
            {
                "x": -1.5312992334365845,
                "y": 0.6260548233985901,
                "z": -225.68260192871094
            },
            {
                "x": -1.5605891942977905,
                "y": 0.6351344585418701,
                "z": -225.5276336669922
            },
            {
                "x": -1.5902504920959473,
                "y": 0.6441601514816284,
                "z": -225.37266540527344
            },
            {
                "x": -1.6201437711715698,
                "y": 0.653107762336731,
                "z": -225.21798706054688
            },
            {
                "x": -1.6503159999847412,
                "y": 0.6619985699653625,
                "z": -225.06314086914062
            },
            {
                "x": -1.680851697921753,
                "y": 0.6708158850669861,
                "z": -224.90838623046875
            },
            {
                "x": -1.711602807044983,
                "y": 0.6795493960380554,
                "z": -224.75384521484375
            },
            {
                "x": -1.7426339387893677,
                "y": 0.688211977481842,
                "z": -224.5992431640625
            },
            {
                "x": -1.7740142345428467,
                "y": 0.696792483329773,
                "z": -224.44471740722656
            },
            {
                "x": -1.8056268692016602,
                "y": 0.7052844762802124,
                "z": -224.2902374267578
            },
            {
                "x": -1.8375459909439087,
                "y": 0.7136942148208618,
                "z": -224.1357421875
            },
            {
                "x": -1.8697508573532104,
                "y": 0.7220013737678528,
                "z": -223.98147583007812
            },
            {
                "x": -1.890650749206543,
                "y": 0.7273125648498535,
                "z": -223.88192749023438
            },
            {
                "x": -1.9232994318008423,
                "y": 0.7354663610458374,
                "z": -223.72760009765625
            },
            {
                "x": -1.9562790393829346,
                "y": 0.7435194849967957,
                "z": -223.57333374023438
            },
            {
                "x": -1.9894447326660156,
                "y": 0.7514621019363403,
                "z": -223.4192657470703
            },
            {
                "x": -2.0229451656341553,
                "y": 0.7592994570732117,
                "z": -223.26507568359375
            },
            {
                "x": -2.0567257404327393,
                "y": 0.7670201063156128,
                "z": -223.111083984375
            },
            {
                "x": -2.0907070636749268,
                "y": 0.7746239900588989,
                "z": -222.95716857910156
            },
            {
                "x": -2.125037908554077,
                "y": 0.782116711139679,
                "z": -222.8031768798828
            },
            {
                "x": -2.159618854522705,
                "y": 0.7894780039787292,
                "z": -222.6493377685547
            },
            {
                "x": -2.194429874420166,
                "y": 0.7967146635055542,
                "z": -222.49551391601562
            },
            {
                "x": -2.229574203491211,
                "y": 0.8038251399993896,
                "z": -222.34173583984375
            },
            {
                "x": -2.264892578125,
                "y": 0.8107948303222656,
                "z": -222.18814086914062
            },
            {
                "x": -2.300527572631836,
                "y": 0.8176326751708984,
                "z": -222.03445434570312
            },
            {
                "x": -2.3364694118499756,
                "y": 0.8243304491043091,
                "z": -221.88079833984375
            },
            {
                "x": -2.3725576400756836,
                "y": 0.8308769464492798,
                "z": -221.72738647460938
            },
            {
                "x": -2.408980369567871,
                "y": 0.8372849225997925,
                "z": -221.5738525390625
            },
            {
                "x": -2.445634365081787,
                "y": 0.843532919883728,
                "z": -221.42054748535156
            },
            {
                "x": -2.4825103282928467,
                "y": 0.8496272563934326,
                "z": -221.26718139648438
            },
            {
                "x": -2.5197181701660156,
                "y": 0.8555694818496704,
                "z": -221.11378479003906
            },
            {
                "x": -2.5570878982543945,
                "y": 0.8613448143005371,
                "z": -220.960693359375
            },
            {
                "x": -2.5947375297546387,
                "y": 0.866955578327179,
                "z": -220.80747985839844
            },
            {
                "x": -2.632628917694092,
                "y": 0.872390866279602,
                "z": -220.65451049804688
            },
            {
                "x": -2.670703887939453,
                "y": 0.8776550889015198,
                "z": -220.50155639648438
            },
            {
                "x": -2.7090883255004883,
                "y": 0.8827507495880127,
                "z": -220.3485107421875
            },
            {
                "x": -2.747713804244995,
                "y": 0.8876639604568481,
                "z": -220.19557189941406
            },
            {
                "x": -2.786518096923828,
                "y": 0.8923897743225098,
                "z": -220.04269409179688
            },
            {
                "x": -2.8256027698516846,
                "y": 0.896932065486908,
                "z": -219.88987731933594
            },
            {
                "x": -2.8648526668548584,
                "y": 0.9012830257415771,
                "z": -219.7372283935547
            },
            {
                "x": -2.9043807983398438,
                "y": 0.9054423570632935,
                "z": -219.58447265625
            },
            {
                "x": -2.944154977798462,
                "y": 0.9094008803367615,
                "z": -219.43179321289062
            },
            {
                "x": -2.9840757846832275,
                "y": 0.913158118724823,
                "z": -219.2792510986328
            },
            {
                "x": -3.02427077293396,
                "y": 0.9167150259017944,
                "z": -219.12672424316406
            },
            {
                "x": -3.064636707305908,
                "y": 0.9200600385665894,
                "z": -218.9743194580078
            },
            {
                "x": -3.105231523513794,
                "y": 0.9231920838356018,
                "z": -218.8218536376953
            },
            {
                "x": -3.1460623741149902,
                "y": 0.9261108636856079,
                "z": -218.66952514648438
            },
            {
                "x": -3.187047243118286,
                "y": 0.9288135766983032,
                "z": -218.5172119140625
            },
            {
                "x": -3.2282755374908447,
                "y": 0.9312928915023804,
                "z": -218.3649444580078
            },
            {
                "x": -3.269658327102661,
                "y": 0.9335401654243469,
                "z": -218.21286010742188
            },
            {
                "x": -3.3112387657165527,
                "y": 0.9355624318122864,
                "z": -218.0607147216797
            },
            {
                "x": -3.353032112121582,
                "y": 0.9373539686203003,
                "z": -217.90872192382812
            },
            {
                "x": -3.3950212001800537,
                "y": 0.9389098882675171,
                "z": -217.7566375732422
            },
            {
                "x": -3.4371933937072754,
                "y": 0.9402198791503906,
                "z": -217.60470581054688
            },
            {
                "x": -3.4795138835906982,
                "y": 0.9412881135940552,
                "z": -217.4529266357422
            },
            {
                "x": -3.506932020187378,
                "y": 0.9418535232543945,
                "z": -217.35484313964844
            },
            {
                "x": -3.5495760440826416,
                "y": 0.9425112009048462,
                "z": -217.2030487060547
            },
            {
                "x": -3.5923783779144287,
                "y": 0.9429188370704651,
                "z": -217.0513458251953
            },
            {
                "x": -3.6353490352630615,
                "y": 0.9430734515190125,
                "z": -216.89956665039062
            },
            {
                "x": -3.678478240966797,
                "y": 0.9429717063903809,
                "z": -216.748046875
            },
            {
                "x": -3.721755266189575,
                "y": 0.9426040649414062,
                "z": -216.59645080566406
            },
            {
                "x": -3.7652275562286377,
                "y": 0.9419864416122437,
                "z": -216.44485473632812
            },
            {
                "x": -3.8087940216064453,
                "y": 0.9411230087280273,
                "z": -216.29354858398438
            },
            {
                "x": -3.8525848388671875,
                "y": 0.9400135278701782,
                "z": -216.14193725585938
            },
            {
                "x": -3.896489143371582,
                "y": 0.9386550188064575,
                "z": -215.99063110351562
            },
            {
                "x": -3.940504312515259,
                "y": 0.9370598793029785,
                "z": -215.83935546875
            },
            {
                "x": -3.9846930503845215,
                "y": 0.9352314472198486,
                "z": -215.68804931640625
            },
            {
                "x": -4.028959274291992,
                "y": 0.9331758618354797,
                "z": -215.5369873046875
            },
            {
                "x": -4.073446750640869,
                "y": 0.930878758430481,
                "z": -215.38558959960938
            },
            {
                "x": -4.118005275726318,
                "y": 0.9283636212348938,
                "z": -215.2345428466797
            },
            {
                "x": -4.162642478942871,
                "y": 0.9256309866905212,
                "z": -215.08360290527344
            },
            {
                "x": -4.207468032836914,
                "y": 0.9226788282394409,
                "z": -214.93246459960938
            },
            {
                "x": -4.2523369789123535,
                "y": 0.9195099472999573,
                "z": -214.78163146972656
            },
            {
                "x": -4.297369956970215,
                "y": 0.9161279201507568,
                "z": -214.630615234375
            },
            {
                "x": -4.342504978179932,
                "y": 0.9125432968139648,
                "z": -214.47970581054688
            },
            {
                "x": -4.387685775756836,
                "y": 0.9087598919868469,
                "z": -214.32896423339844
            },
            {
                "x": -4.432992458343506,
                "y": 0.9047690033912659,
                "z": -214.17819213867188
            },
            {
                "x": -4.478370189666748,
                "y": 0.9005849957466125,
                "z": -214.02752685546875
            },
            {
                "x": -4.523843765258789,
                "y": 0.8962087631225586,
                "z": -213.87684631347656
            },
            {
                "x": -4.569451332092285,
                "y": 0.8916415572166443,
                "z": -213.72605895996094
            },
            {
                "x": -4.615057945251465,
                "y": 0.8868898153305054,
                "z": -213.57553100585938
            },
            {
                "x": -4.660783767700195,
                "y": 0.8819527626037598,
                "z": -213.42491149902344
            },
            {
                "x": -4.706564903259277,
                "y": 0.8768408894538879,
                "z": -213.27438354492188
            },
            {
                "x": -4.752394676208496,
                "y": 0.8715571165084839,
                "z": -213.1239013671875
            },
            {
                "x": -4.798336029052734,
                "y": 0.8660925626754761,
                "z": -212.97332763671875
            },
            {
                "x": -4.844271183013916,
                "y": 0.8604647517204285,
                "z": -212.82289123535156
            },
            {
                "x": -4.890265464782715,
                "y": 0.8546760082244873,
                "z": -212.6725311279297
            },
            {
                "x": -4.936313152313232,
                "y": 0.8487258553504944,
                "z": -212.52215576171875
            },
            {
                "x": -4.9823899269104,
                "y": 0.8426153659820557,
                "z": -212.37176513671875
            },
            {
                "x": -5.028520584106445,
                "y": 0.8363500833511353,
                "z": -212.221435546875
            },
            {
                "x": -5.074685096740723,
                "y": 0.8299351930618286,
                "z": -212.07107543945312
            },
            {
                "x": -5.1208367347717285,
                "y": 0.8233815431594849,
                "z": -211.9208984375
            },
            {
                "x": -5.16703987121582,
                "y": 0.8166758418083191,
                "z": -211.7705841064453
            },
            {
                "x": -5.2132368087768555,
                "y": 0.8098347187042236,
                "z": -211.6204071044922
            },
            {
                "x": -5.259433269500732,
                "y": 0.8028603196144104,
                "z": -211.4702606201172
            },
            {
                "x": -5.305702209472656,
                "y": 0.7957453727722168,
                "z": -211.31991577148438
            },
            {
                "x": -5.351907253265381,
                "y": 0.7885081171989441,
                "z": -211.1697998046875
            },
            {
                "x": -5.398101806640625,
                "y": 0.7811452150344849,
                "z": -211.01968383789062
            },
            {
                "x": -5.427948951721191,
                "y": 0.7763261795043945,
                "z": -210.92274475097656
            },
            {
                "x": -5.474117755889893,
                "y": 0.7687678337097168,
                "z": -210.77267456054688
            },
            {
                "x": -5.5203166007995605,
                "y": 0.7610850930213928,
                "z": -210.62249755859375
            },
            {
                "x": -5.566478252410889,
                "y": 0.7532926797866821,
                "z": -210.4723663330078
            },
            {
                "x": -5.6125898361206055,
                "y": 0.7453970909118652,
                "z": -210.32232666015625
            },
            {
                "x": -5.658697128295898,
                "y": 0.737389862537384,
                "z": -210.17218017578125
            },
            {
                "x": -5.704742431640625,
                "y": 0.7292824387550354,
                "z": -210.02210998535156
            },
            {
                "x": -5.750742435455322,
                "y": 0.721079409122467,
                "z": -209.87208557128906
            },
            {
                "x": -5.796725273132324,
                "y": 0.7127737998962402,
                "z": -209.72189331054688
            },
            {
                "x": -5.842637538909912,
                "y": 0.7043840885162354,
                "z": -209.57180786132812
            },
            {
                "x": -5.888483047485352,
                "y": 0.6959036588668823,
                "z": -209.42173767089844
            },
            {
                "x": -5.934272289276123,
                "y": 0.6873378753662109,
                "z": -209.27159118652344
            },
            {
                "x": -5.979964256286621,
                "y": 0.6786993741989136,
                "z": -209.1216278076172
            },
            {
                "x": -6.025649547576904,
                "y": 0.6699690818786621,
                "z": -208.9713592529297
            },
            {
                "x": -6.071196556091309,
                "y": 0.6611753106117249,
                "z": -208.8212890625
            },
            {
                "x": -6.116648197174072,
                "y": 0.652313232421875,
                "z": -208.6712646484375
            },
            {
                "x": -6.162060737609863,
                "y": 0.6433752775192261,
                "z": -208.52101135253906
            },
            {
                "x": -6.207330226898193,
                "y": 0.6343849897384644,
                "z": -208.3709716796875
            },
            {
                "x": -6.252546310424805,
                "y": 0.6253229379653931,
                "z": -208.22073364257812
            },
            {
                "x": -6.29765510559082,
                "y": 0.6162087917327881,
                "z": -208.0705108642578
            },
            {
                "x": -6.342621803283691,
                "y": 0.6070463061332703,
                "z": -207.9203643798828
            },
            {
                "x": -6.387485504150391,
                "y": 0.5978368520736694,
                "z": -207.77023315429688
            },
            {
                "x": -6.432187080383301,
                "y": 0.5885815620422363,
                "z": -207.62005615234375
            },
            {
                "x": -6.476803779602051,
                "y": 0.5792793035507202,
                "z": -207.46983337402344
            },
            {
                "x": -6.5213189125061035,
                "y": 0.5699324607849121,
                "z": -207.3194580078125
            },
            {
                "x": -6.565663814544678,
                "y": 0.560556173324585,
                "z": -207.1691131591797
            },
            {
                "x": -6.609866142272949,
                "y": 0.5511502623558044,
                "z": -207.01881408691406
            },
            {
                "x": -6.653903007507324,
                "y": 0.5417129993438721,
                "z": -206.86846923828125
            },
            {
                "x": -6.697817802429199,
                "y": 0.5322512984275818,
                "z": -206.71804809570312
            },
            {
                "x": -6.741580963134766,
                "y": 0.5227646827697754,
                "z": -206.5675506591797
            },
            {
                "x": -6.78517484664917,
                "y": 0.5132613182067871,
                "z": -206.41705322265625
            },
            {
                "x": -6.828568935394287,
                "y": 0.5037528276443481,
                "z": -206.2666778564453
            },
            {
                "x": -6.871833801269531,
                "y": 0.4942202866077423,
                "z": -206.11599731445312
            },
            {
                "x": -6.914909362792969,
                "y": 0.48468977212905884,
                "z": -205.96548461914062
            },
            {
                "x": -6.957777976989746,
                "y": 0.4751516282558441,
                "z": -205.81484985351562
            },
            {
                "x": -7.000515937805176,
                "y": 0.46560779213905334,
                "z": -205.6641082763672
            },
            {
                "x": -7.042990207672119,
                "y": 0.45607858896255493,
                "z": -205.5135040283203
            },
            {
                "x": -7.085334777832031,
                "y": 0.4465411901473999,
                "z": -205.36260986328125
            },
            {
                "x": -7.1274309158325195,
                "y": 0.43702995777130127,
                "z": -205.2119140625
            },
            {
                "x": -7.169301986694336,
                "y": 0.42752605676651,
                "z": -205.0610809326172
            },
            {
                "x": -7.211049556732178,
                "y": 0.41802892088890076,
                "z": -204.91006469726562
            },
            {
                "x": -7.252471923828125,
                "y": 0.4085676968097687,
                "z": -204.7592315673828
            },
            {
                "x": -7.293769359588623,
                "y": 0.39911919832229614,
                "z": -204.608154296875
            },
            {
                "x": -7.320247173309326,
                "y": 0.3930402398109436,
                "z": -204.5106964111328
            },
            {
                "x": -7.361075401306152,
                "y": 0.3836466073989868,
                "z": -204.3596649169922
            },
            {
                "x": -7.401772499084473,
                "y": 0.37427374720573425,
                "z": -204.20840454101562
            },
            {
                "x": -7.442136764526367,
                "y": 0.36495059728622437,
                "z": -204.05726623535156
            },
            {
                "x": -7.482297420501709,
                "y": 0.355660617351532,
                "z": -203.9059600830078
            },
            {
                "x": -7.5221991539001465,
                "y": 0.3464188873767853,
                "z": -203.7546844482422
            },
            {
                "x": -7.561846733093262,
                "y": 0.33721834421157837,
                "z": -203.603271484375
            },
            {
                "x": -7.601240158081055,
                "y": 0.32807666063308716,
                "z": -203.45191955566406
            },
            {
                "x": -7.640350341796875,
                "y": 0.3189806044101715,
                "z": -203.3003387451172
            },
            {
                "x": -7.679232597351074,
                "y": 0.3099408745765686,
                "z": -203.1487274169922
            },
            {
                "x": -7.717790126800537,
                "y": 0.30097100138664246,
                "z": -202.99717712402344
            },
            {
                "x": -7.7561211585998535,
                "y": 0.29205286502838135,
                "z": -202.84535217285156
            },
            {
                "x": -7.794143199920654,
                "y": 0.2832185626029968,
                "z": -202.69374084472656
            },
            {
                "x": -7.831892490386963,
                "y": 0.27443864941596985,
                "z": -202.541748046875
            },
            {
                "x": -7.869384765625,
                "y": 0.26573917269706726,
                "z": -202.3898162841797
            },
            {
                "x": -7.906486511230469,
                "y": 0.2571313679218292,
                "z": -202.238037109375
            },
            {
                "x": -7.94338321685791,
                "y": 0.2485857605934143,
                "z": -202.08583068847656
            },
            {
                "x": -7.979915142059326,
                "y": 0.24014320969581604,
                "z": -201.9339141845703
            },
            {
                "x": -8.016161918640137,
                "y": 0.23177263140678406,
                "z": -201.7816162109375
            },
            {
                "x": -8.05215072631836,
                "y": 0.22349876165390015,
                "z": -201.6293182373047
            },
            {
                "x": -8.087711334228516,
                "y": 0.21533207595348358,
                "z": -201.47714233398438
            },
            {
                "x": -8.123040199279785,
                "y": 0.20725226402282715,
                "z": -201.32467651367188
            },
            {
                "x": -8.157977104187012,
                "y": 0.19928719103336334,
                "z": -201.1724395751953
            },
            {
                "x": -8.192621231079102,
                "y": 0.19141574203968048,
                "z": -201.0198211669922
            },
            {
                "x": -8.226990699768066,
                "y": 0.18365412950515747,
                "z": -200.86715698242188
            },
            {
                "x": -8.2609224319458,
                "y": 0.1760125458240509,
                "z": -200.71453857421875
            },
            {
                "x": -8.294622421264648,
                "y": 0.16847717761993408,
                "z": -200.56170654296875
            },
            {
                "x": -8.327881813049316,
                "y": 0.16107413172721863,
                "z": -200.40904235839844
            },
            {
                "x": -8.360847473144531,
                "y": 0.15378481149673462,
                "z": -200.2560272216797
            },
            {
                "x": -8.393481254577637,
                "y": 0.14662331342697144,
                "z": -200.10302734375
            },
            {
                "x": -8.42569637298584,
                "y": 0.13959316909313202,
                "z": -199.94998168945312
            },
            {
                "x": -8.457633018493652,
                "y": 0.132695734500885,
                "z": -199.796875
            },
            {
                "x": -8.489128112792969,
                "y": 0.12594127655029297,
                "z": -199.64373779296875
            },
            {
                "x": -8.520329475402832,
                "y": 0.11931775510311127,
                "z": -199.49034118652344
            },
            {
                "x": -8.551137924194336,
                "y": 0.11284501850605011,
                "z": -199.33709716796875
            },
            {
                "x": -8.581558227539062,
                "y": 0.10651212930679321,
                "z": -199.18359375
            },
            {
                "x": -8.611651420593262,
                "y": 0.10033834725618362,
                "z": -199.0301055908203
            },
            {
                "x": -8.6412935256958,
                "y": 0.09431740641593933,
                "z": -198.87660217285156
            },
            {
                "x": -8.670638084411621,
                "y": 0.08844691514968872,
                "z": -198.72286987304688
            },
            {
                "x": -8.699535369873047,
                "y": 0.08274801075458527,
                "z": -198.56936645507812
            },
            {
                "x": -8.728084564208984,
                "y": 0.07720087468624115,
                "z": -198.41529846191406
            },
            {
                "x": -8.756258964538574,
                "y": 0.07183200120925903,
                "z": -198.26153564453125
            },
            {
                "x": -8.783960342407227,
                "y": 0.06663336604833603,
                "z": -198.10772705078125
            },
            {
                "x": -8.801695823669434,
                "y": 0.06336340308189392,
                "z": -198.00816345214844
            },
            {
                "x": -8.828812599182129,
                "y": 0.05845661833882332,
                "z": -197.85426330566406
            },
            {
                "x": -8.855487823486328,
                "y": 0.05372236296534538,
                "z": -197.70013427734375
            },
            {
                "x": -8.881874084472656,
                "y": 0.049164991825819016,
                "z": -197.5457763671875
            },
            {
                "x": -8.907716751098633,
                "y": 0.04481308534741402,
                "z": -197.3917694091797
            },
            {
                "x": -8.933237075805664,
                "y": 0.04063677415251732,
                "z": -197.23721313476562
            },
            {
                "x": -8.958355903625488,
                "y": 0.036660611629486084,
                "z": -197.0829620361328
            },
            {
                "x": -8.982990264892578,
                "y": 0.03287766873836517,
                "z": -196.92855834960938
            },
            {
                "x": -9.007339477539062,
                "y": 0.029293404892086983,
                "z": -196.77378845214844
            },
            {
                "x": -9.031150817871094,
                "y": 0.025922687724232674,
                "z": -196.6194305419922
            },
            {
                "x": -9.05460262298584,
                "y": 0.022747812792658806,
                "z": -196.46458435058594
            },
            {
                "x": -9.077665328979492,
                "y": 0.01978578045964241,
                "z": -196.30996704101562
            },
            {
                "x": -9.100213050842285,
                "y": 0.01704290509223938,
                "z": -196.15525817871094
            },
            {
                "x": -9.122469902038574,
                "y": 0.01451033540070057,
                "z": -196.00009155273438
            },
            {
                "x": -9.144196510314941,
                "y": 0.012203465215861797,
                "z": -195.84544372558594
            },
            {
                "x": -9.16553020477295,
                "y": 0.010112438350915909,
                "z": -195.69033813476562
            },
            {
                "x": -9.186483383178711,
                "y": 0.008255567401647568,
                "z": -195.5353546142578
            },
            {
                "x": -9.206899642944336,
                "y": 0.006629975512623787,
                "z": -195.38040161132812
            },
            {
                "x": -9.227008819580078,
                "y": 0.00523141585290432,
                "z": -195.22503662109375
            },
            {
                "x": -9.246630668640137,
                "y": 0.004069585353136063,
                "z": -195.0699920654297
            },
            {
                "x": -9.265790939331055,
                "y": 0.003151692682877183,
                "z": -194.91465759277344
            },
            {
                "x": -9.284589767456055,
                "y": 0.002477861475199461,
                "z": -194.75942993164062
            },
            {
                "x": -9.30285930633545,
                "y": 0.0020474963821470737,
                "z": -194.60423278808594
            },
            {
                "x": -9.320789337158203,
                "y": 0.0018628776306286454,
                "z": -194.4486846923828
            },
            {
                "x": -9.338261604309082,
                "y": 0.001851879060268402,
                "z": -194.29327392578125
            },
            {
                "x": -9.355230331420898,
                "y": 0.0018478557467460632,
                "z": -194.13775634765625
            },
            {
                "x": -9.371869087219238,
                "y": 0.0018438175320625305,
                "z": -193.98214721679688
            },
            {
                "x": -9.387977600097656,
                "y": 0.0018397793173789978,
                "z": -193.8267364501953
            },
            {
                "x": -9.403687477111816,
                "y": 0.001835756003856659,
                "z": -193.6708984375
            },
            {
                "x": -9.418996810913086,
                "y": 0.0018317252397537231,
                "z": -193.5152130126953
            },
            {
                "x": -9.43376350402832,
                "y": 0.0018276944756507874,
                "z": -193.35955810546875
            },
            {
                "x": -9.448201179504395,
                "y": 0.0018236339092254639,
                "z": -193.2036895751953
            },
            {
                "x": -9.462137222290039,
                "y": 0.0018195956945419312,
                "z": -193.04803466796875
            },
            {
                "x": -9.475605010986328,
                "y": 0.0018155574798583984,
                "z": -192.89208984375
            },
            {
                "x": -9.488728523254395,
                "y": 0.0018115192651748657,
                "z": -192.73614501953125
            },
            {
                "x": -9.501310348510742,
                "y": 0.0018074661493301392,
                "z": -192.58033752441406
            },
            {
                "x": -9.513503074645996,
                "y": 0.001803480088710785,
                "z": -192.42420959472656
            },
            {
                "x": -9.525270462036133,
                "y": 0.0017994493246078491,
                "z": -192.26832580566406
            },
            {
                "x": -9.53650951385498,
                "y": 0.0017954036593437195,
                "z": -192.1123504638672
            },
            {
                "x": -9.547417640686035,
                "y": 0.001791350543498993,
                "z": -191.95619201660156
            },
            {
                "x": -9.557831764221191,
                "y": 0.001787327229976654,
                "z": -191.80020141601562
            },
            {
                "x": -9.567758560180664,
                "y": 0.0017832964658737183,
                "z": -191.64398193359375
            },
            {
                "x": -9.577346801757812,
                "y": 0.0017792433500289917,
                "z": -191.48785400390625
            },
            {
                "x": -9.583261489868164,
                "y": 0.0017766132950782776,
                "z": -191.38717651367188
            },
            {
                "x": -9.59201717376709,
                "y": 0.0017725899815559387,
                "z": -191.2309112548828
            },
            {
                "x": -9.600444793701172,
                "y": 0.001768551766872406,
                "z": -191.0745849609375
            },
            {
                "x": -9.608346939086914,
                "y": 0.0017645284533500671,
                "z": -190.91848754882812
            },
            {
                "x": -9.615823745727539,
                "y": 0.0017604902386665344,
                "z": -190.76206970214844
            },
            {
                "x": -9.62292194366455,
                "y": 0.0017564594745635986,
                "z": -190.6058349609375
            },
            {
                "x": -9.629477500915527,
                "y": 0.001752421259880066,
                "z": -190.4496612548828
            },
            {
                "x": -9.635674476623535,
                "y": 0.001748405396938324,
                "z": -190.29318237304688
            },
            {
                "x": -9.641454696655273,
                "y": 0.0017443522810935974,
                "z": -190.13685607910156
            },
            {
                "x": -9.646689414978027,
                "y": 0.0017403513193130493,
                "z": -189.9805145263672
            },
            {
                "x": -9.651599884033203,
                "y": 0.001736275851726532,
                "z": -189.82398986816406
            },
            {
                "x": -9.656037330627441,
                "y": 0.0017322152853012085,
                "z": -189.66781616210938
            },
            {
                "x": -9.659991264343262,
                "y": 0.0017282366752624512,
                "z": -189.5113525390625
            },
            {
                "x": -9.663613319396973,
                "y": 0.0017241686582565308,
                "z": -189.3546905517578
            },
            {
                "x": -9.666723251342773,
                "y": 0.0017201229929924011,
                "z": -189.19850158691406
            },
            {
                "x": -9.669400215148926,
                "y": 0.001716114580631256,
                "z": -189.04197692871094
            },
            {
                "x": -9.671744346618652,
                "y": 0.0017120838165283203,
                "z": -188.8854522705078
            },
            {
                "x": -9.673539161682129,
                "y": 0.0017080381512641907,
                "z": -188.7292022705078
            },
            {
                "x": -9.674942016601562,
                "y": 0.0017040073871612549,
                "z": -188.57247924804688
            },
            {
                "x": -9.675985336303711,
                "y": 0.001699984073638916,
                "z": -188.41604614257812
            },
            {
                "x": -9.676491737365723,
                "y": 0.0016959086060523987,
                "z": -188.25973510742188
            },
            {
                "x": -9.676616668701172,
                "y": 0.0016918927431106567,
                "z": -188.10311889648438
            },
            {
                "x": -9.676346778869629,
                "y": 0.0016878694295883179,
                "z": -187.94683837890625
            },
            {
                "x": -9.675540924072266,
                "y": 0.001683846116065979,
                "z": -187.79046630859375
            },
            {
                "x": -9.674386024475098,
                "y": 0.0016798004508018494,
                "z": -187.63369750976562
            },
            {
                "x": -9.672775268554688,
                "y": 0.0016757696866989136,
                "z": -187.4774932861328
            },
            {
                "x": -9.670638084411621,
                "y": 0.00167170912027359,
                "z": -187.32102966308594
            },
            {
                "x": -9.668166160583496,
                "y": 0.0016676932573318481,
                "z": -187.1644744873047
            },
            {
                "x": -9.665221214294434,
                "y": 0.0016636550426483154,
                "z": -187.0083465576172
            },
            {
                "x": -9.6617431640625,
                "y": 0.0016596317291259766,
                "z": -186.8516387939453
            },
            {
                "x": -9.657943725585938,
                "y": 0.0016556084156036377,
                "z": -186.69522094726562
            },
            {
                "x": -9.653635025024414,
                "y": 0.0016512118745595217,
                "z": -186.53909301757812
            },
            {
                "x": -9.648855209350586,
                "y": 0.0014990568161010742,
                "z": -186.3824462890625
            },
            {
                "x": -9.643721580505371,
                "y": 0.0011069803731516004,
                "z": -186.22618103027344
            },
            {
                "x": -9.638044357299805,
                "y": 0.0004985668929293752,
                "z": -186.06993103027344
            },
            {
                "x": -9.631952285766602,
                "y": -0.0003246015403419733,
                "z": -185.91336059570312
            },
            {
                "x": -9.625492095947266,
                "y": -0.0013556182384490967,
                "z": -185.7572021484375
            },
            {
                "x": -9.61845588684082,
                "y": -0.002604774199426174,
                "z": -185.6009063720703
            },
            {
                "x": -9.611058235168457,
                "y": -0.004060195293277502,
                "z": -185.4445037841797
            },
            {
                "x": -9.603240013122559,
                "y": -0.0057134670205414295,
                "z": -185.2884979248047
            },
            {
                "x": -9.594876289367676,
                "y": -0.00757044181227684,
                "z": -185.132080078125
            },
            {
                "x": -9.58617877960205,
                "y": -0.009629973210394382,
                "z": -184.97581481933594
            },
            {
                "x": -9.57699966430664,
                "y": -0.01187921967357397,
                "z": -184.8199005126953
            },
            {
                "x": -9.57079792022705,
                "y": -0.013432906940579414,
                "z": -184.71900939941406
            },
            {
                "x": -9.560918807983398,
                "y": -0.0160016268491745,
                "z": -184.56275939941406
            },
            {
                "x": -9.55058479309082,
                "y": -0.0187541376799345,
                "z": -184.4068145751953
            },
            {
                "x": -9.539737701416016,
                "y": -0.021694818511605263,
                "z": -184.25057983398438
            },
            {
                "x": -9.528573989868164,
                "y": -0.02481117658317089,
                "z": -184.09457397460938
            },
            {
                "x": -9.516890525817871,
                "y": -0.02810676209628582,
                "z": -183.93875122070312
            },
            {
                "x": -9.50475025177002,
                "y": -0.031585339456796646,
                "z": -183.78260803222656
            },
            {
                "x": -9.49227523803711,
                "y": -0.03522750735282898,
                "z": -183.62680053710938
            },
            {
                "x": -9.479251861572266,
                "y": -0.039041873067617416,
                "z": -183.47088623046875
            },
            {
                "x": -9.465848922729492,
                "y": -0.043027885258197784,
                "z": -183.31488037109375
            },
            {
                "x": -9.452042579650879,
                "y": -0.04717054218053818,
                "z": -183.1592254638672
            },
            {
                "x": -9.43770980834961,
                "y": -0.05147787183523178,
                "z": -183.00341796875
            },
            {
                "x": -9.423052787780762,
                "y": -0.055940642952919006,
                "z": -182.84764099121094
            },
            {
                "x": -9.40791130065918,
                "y": -0.06055764481425285,
                "z": -182.69198608398438
            },
            {
                "x": -9.39229965209961,
                "y": -0.06533221900463104,
                "z": -182.53623962402344
            },
            {
                "x": -9.376368522644043,
                "y": -0.0702473521232605,
                "z": -182.38070678710938
            },
            {
                "x": -9.359918594360352,
                "y": -0.07530815899372101,
                "z": -182.22523498535156
            },
            {
                "x": -9.343070030212402,
                "y": -0.08051852136850357,
                "z": -182.06961059570312
            },
            {
                "x": -9.325841903686523,
                "y": -0.08586254715919495,
                "z": -181.91424560546875
            },
            {
                "x": -9.308093070983887,
                "y": -0.09134779870510101,
                "z": -181.75877380371094
            },
            {
                "x": -9.290024757385254,
                "y": -0.09696358442306519,
                "z": -181.60337829589844
            },
            {
                "x": -9.271515846252441,
                "y": -0.10270003229379654,
                "z": -181.44833374023438
            },
            {
                "x": -9.252514839172363,
                "y": -0.10858016461133957,
                "z": -181.29295349121094
            },
            {
                "x": -9.233209609985352,
                "y": -0.11457552015781403,
                "z": -181.13784790039062
            },
            {
                "x": -9.21338939666748,
                "y": -0.1206953302025795,
                "z": -180.982666015625
            },
            {
                "x": -9.193188667297363,
                "y": -0.12693911790847778,
                "z": -180.8274383544922
            },
            {
                "x": -9.172627449035645,
                "y": -0.1332869827747345,
                "z": -180.6725616455078
            },
            {
                "x": -9.151557922363281,
                "y": -0.13975535333156586,
                "z": -180.517578125
            },
            {
                "x": -9.13017749786377,
                "y": -0.14633095264434814,
                "z": -180.36260986328125
            },
            {
                "x": -9.108335494995117,
                "y": -0.1530107706785202,
                "z": -180.20777893066406
            },
            {
                "x": -9.086058616638184,
                "y": -0.1598030924797058,
                "z": -180.05287170410156
            },
            {
                "x": -9.063474655151367,
                "y": -0.16668426990509033,
                "z": -179.89822387695312
            },
            {
                "x": -9.040390968322754,
                "y": -0.17366649210453033,
                "z": -179.74354553222656
            },
            {
                "x": -9.016963005065918,
                "y": -0.1807475984096527,
                "z": -179.5888214111328
            },
            {
                "x": -8.993146896362305,
                "y": -0.1879119724035263,
                "z": -179.43438720703125
            },
            {
                "x": -8.968852996826172,
                "y": -0.19517546892166138,
                "z": -179.27975463867188
            },
            {
                "x": -8.944276809692383,
                "y": -0.20251569151878357,
                "z": -179.12533569335938
            },
            {
                "x": -8.9192533493042,
                "y": -0.20993441343307495,
                "z": -178.9710693359375
            },
            {
                "x": -8.893820762634277,
                "y": -0.21744462847709656,
                "z": -178.81661987304688
            },
            {
                "x": -8.86807918548584,
                "y": -0.2250172197818756,
                "z": -178.66253662109375
            },
            {
                "x": -8.841835975646973,
                "y": -0.23267750442028046,
                "z": -178.50819396972656
            },
            {
                "x": -8.815315246582031,
                "y": -0.24040108919143677,
                "z": -178.3540496826172
            },
            {
                "x": -8.788392066955566,
                "y": -0.2481813132762909,
                "z": -178.20021057128906
            },
            {
                "x": -8.770752906799316,
                "y": -0.2532501816749573,
                "z": -178.10069274902344
            },
            {
                "x": -8.74323558807373,
                "y": -0.26114311814308167,
                "z": -177.94671630859375
            },
            {
                "x": -8.715290069580078,
                "y": -0.2690918445587158,
                "z": -177.79293823242188
            },
            {
                "x": -8.686934471130371,
                "y": -0.2771115303039551,
                "z": -177.63893127441406
            },
            {
                "x": -8.658319473266602,
                "y": -0.28516465425491333,
                "z": -177.48533630371094
            },
            {
                "x": -8.629230499267578,
                "y": -0.293277382850647,
                "z": -177.3316192626953
            },
            {
                "x": -8.599835395812988,
                "y": -0.3014405369758606,
                "z": -177.17791748046875
            },
            {
                "x": -8.570096015930176,
                "y": -0.3096328675746918,
                "z": -177.0245819091797
            },
            {
                "x": -8.53989315032959,
                "y": -0.3178902566432953,
                "z": -176.870849609375
            },
            {
                "x": -8.509469032287598,
                "y": -0.32616567611694336,
                "z": -176.71751403808594
            },
            {
                "x": -8.478593826293945,
                "y": -0.33447974920272827,
                "z": -176.564208984375
            },
            {
                "x": -8.447392463684082,
                "y": -0.3428341746330261,
                "z": -176.41082763671875
            },
            {
                "x": -8.415899276733398,
                "y": -0.35119926929473877,
                "z": -176.25779724121094
            },
            {
                "x": -8.38393497467041,
                "y": -0.35961511731147766,
                "z": -176.10440063476562
            },
            {
                "x": -8.35175609588623,
                "y": -0.3680356740951538,
                "z": -175.95140075683594
            },
            {
                "x": -8.319174766540527,
                "y": -0.37647169828414917,
                "z": -175.79855346679688
            },
            {
                "x": -8.286226272583008,
                "y": -0.38494348526000977,
                "z": -175.64541625976562
            },
            {
                "x": -8.253035545349121,
                "y": -0.3934081494808197,
                "z": -175.49269104003906
            },
            {
                "x": -8.219405174255371,
                "y": -0.40189874172210693,
                "z": -175.3397979736328
            },
            {
                "x": -8.185516357421875,
                "y": -0.41039401292800903,
                "z": -175.18698120117188
            },
            {
                "x": -8.151288032531738,
                "y": -0.4188825488090515,
                "z": -175.0344696044922
            },
            {
                "x": -8.116732597351074,
                "y": -0.4273831248283386,
                "z": -174.88177490234375
            },
            {
                "x": -8.081914901733398,
                "y": -0.4358692467212677,
                "z": -174.7294158935547
            },
            {
                "x": -8.046684265136719,
                "y": -0.44435933232307434,
                "z": -174.5769500732422
            },
            {
                "x": -8.011170387268066,
                "y": -0.45285099744796753,
                "z": -174.42440795898438
            },
            {
                "x": -7.975368499755859,
                "y": -0.46131351590156555,
                "z": -174.27223205566406
            },
            {
                "x": -7.939216613769531,
                "y": -0.46977871656417847,
                "z": -174.1198272705078
            },
            {
                "x": -7.902824401855469,
                "y": -0.4782128930091858,
                "z": -173.96774291992188
            },
            {
                "x": -7.866060256958008,
                "y": -0.4866318702697754,
                "z": -173.81561279296875
            },
            {
                "x": -7.829017162322998,
                "y": -0.4950385093688965,
                "z": -173.66336059570312
            },
            {
                "x": -7.791712760925293,
                "y": -0.5034006834030151,
                "z": -173.51150512695312
            },
            {
                "x": -7.75407600402832,
                "y": -0.5117449760437012,
                "z": -173.3594970703125
            },
            {
                "x": -7.716191291809082,
                "y": -0.520051121711731,
                "z": -173.2076416015625
            },
            {
                "x": -7.677968502044678,
                "y": -0.5283238887786865,
                "z": -173.0558319091797
            },
            {
                "x": -7.6395063400268555,
                "y": -0.5365633964538574,
                "z": -172.9039764404297
            },
            {
                "x": -7.600744724273682,
                "y": -0.5447508692741394,
                "z": -172.75234985351562
            },
            {
                "x": -7.561701774597168,
                "y": -0.5529017448425293,
                "z": -172.6006317138672
            },
            {
                "x": -7.522427558898926,
                "y": -0.5609986782073975,
                "z": -172.44911193847656
            },
            {
                "x": -7.482834815979004,
                "y": -0.569047212600708,
                "z": -172.29762268066406
            },
            {
                "x": -7.443027496337891,
                "y": -0.5770394802093506,
                "z": -172.14617919921875
            },
            {
                "x": -7.402892112731934,
                "y": -0.5849792957305908,
                "z": -171.99472045898438
            },
            {
                "x": -7.362524509429932,
                "y": -0.5928580164909363,
                "z": -171.84332275390625
            },
            {
                "x": -7.321959495544434,
                "y": -0.6006652116775513,
                "z": -171.6921844482422
            },
            {
                "x": -7.2955756187438965,
                "y": -0.6056740283966064,
                "z": -171.5945281982422
            },
            {
                "x": -7.254556655883789,
                "y": -0.6133770942687988,
                "z": -171.4433135986328
            },
            {
                "x": -7.213311195373535,
                "y": -0.6210054159164429,
                "z": -171.29222106933594
            },
            {
                "x": -7.171753883361816,
                "y": -0.6285661458969116,
                "z": -171.14105224609375
            },
            {
                "x": -7.130055904388428,
                "y": -0.6360371112823486,
                "z": -170.9901123046875
            },
            {
                "x": -7.088037490844727,
                "y": -0.6434348821640015,
                "z": -170.839111328125
            },
            {
                "x": -7.04584264755249,
                "y": -0.6507483720779419,
                "z": -170.68820190429688
            },
            {
                "x": -7.003439903259277,
                "y": -0.6579657793045044,
                "z": -170.53746032714844
            },
            {
                "x": -6.960716247558594,
                "y": -0.6651071310043335,
                "z": -170.386474609375
            },
            {
                "x": -6.917886734008789,
                "y": -0.6721422672271729,
                "z": -170.2357635498047
            },
            {
                "x": -6.874772071838379,
                "y": -0.6790862679481506,
                "z": -170.0850830078125
            },
            {
                "x": -6.831470966339111,
                "y": -0.6859312057495117,
                "z": -169.9343719482422
            },
            {
                "x": -6.78798246383667,
                "y": -0.6926637887954712,
                "z": -169.78390502929688
            },
            {
                "x": -6.744193077087402,
                "y": -0.6993058919906616,
                "z": -169.63311767578125
            },
            {
                "x": -6.700325012207031,
                "y": -0.7058261632919312,
                "z": -169.48269653320312
            },
            {
                "x": -6.656198024749756,
                "y": -0.7122362852096558,
                "z": -169.332275390625
            },
            {
                "x": -6.611886501312256,
                "y": -0.7185326814651489,
                "z": -169.1817626953125
            },
            {
                "x": -6.567409515380859,
                "y": -0.7247042059898376,
                "z": -169.03147888183594
            },
            {
                "x": -6.522692680358887,
                "y": -0.7307647466659546,
                "z": -168.8810272216797
            },
            {
                "x": -6.477849006652832,
                "y": -0.7366933822631836,
                "z": -168.7307586669922
            },
            {
                "x": -6.432795524597168,
                "y": -0.7424906492233276,
                "z": -168.5805206298828
            },
            {
                "x": -6.387622356414795,
                "y": -0.7481564283370972,
                "z": -168.43035888671875
            },
            {
                "x": -6.342251300811768,
                "y": -0.7536885738372803,
                "z": -168.28024291992188
            },
            {
                "x": -6.296710968017578,
                "y": -0.7590861916542053,
                "z": -168.1300811767578
            },
            {
                "x": -6.250986099243164,
                "y": -0.7643406391143799,
                "z": -167.97988891601562
            },
            {
                "x": -6.20510721206665,
                "y": -0.7694498896598816,
                "z": -167.829833984375
            },
            {
                "x": -6.159113883972168,
                "y": -0.7744123935699463,
                "z": -167.67979431152344
            },
            {
                "x": -6.112947940826416,
                "y": -0.7792251110076904,
                "z": -167.5298309326172
            },
            {
                "x": -6.066641807556152,
                "y": -0.783879816532135,
                "z": -167.37985229492188
            },
            {
                "x": -6.020163536071777,
                "y": -0.7883814573287964,
                "z": -167.2298126220703
            },
            {
                "x": -5.973588943481445,
                "y": -0.7927212715148926,
                "z": -167.0799102783203
            },
            {
                "x": -5.926908016204834,
                "y": -0.7968981266021729,
                "z": -166.93008422851562
            },
            {
                "x": -5.880030155181885,
                "y": -0.8009053468704224,
                "z": -166.78018188476562
            },
            {
                "x": -5.833086967468262,
                "y": -0.8047424554824829,
                "z": -166.63037109375
            },
            {
                "x": -5.78599214553833,
                "y": -0.8084092736244202,
                "z": -166.4805450439453
            },
            {
                "x": -5.738770961761475,
                "y": -0.8119028806686401,
                "z": -166.33070373535156
            },
            {
                "x": -5.6914801597595215,
                "y": -0.8152069449424744,
                "z": -166.18099975585938
            },
            {
                "x": -5.6440348625183105,
                "y": -0.8183332681655884,
                "z": -166.0312042236328
            },
            {
                "x": -5.59653902053833,
                "y": -0.8212733268737793,
                "z": -165.88156127929688
            },
            {
                "x": -5.548933506011963,
                "y": -0.8240267038345337,
                "z": -165.73190307617188
            },
            {
                "x": -5.501182556152344,
                "y": -0.8265838623046875,
                "z": -165.5820770263672
            },
            {
                "x": -5.45341682434082,
                "y": -0.8289433717727661,
                "z": -165.4324951171875
            },
            {
                "x": -5.405521392822266,
                "y": -0.8311071991920471,
                "z": -165.28285217285156
            },
            {
                "x": -5.374581336975098,
                "y": -0.8323979377746582,
                "z": -165.1862335205078
            },
            {
                "x": -5.326584815979004,
                "y": -0.834223747253418,
                "z": -165.0366973876953
            },
            {
                "x": -5.278476238250732,
                "y": -0.8358467817306519,
                "z": -164.88699340820312
            },
            {
                "x": -5.230322360992432,
                "y": -0.837260365486145,
                "z": -164.73739624023438
            },
            {
                "x": -5.182107448577881,
                "y": -0.8384547829627991,
                "z": -164.58782958984375
            },
            {
                "x": -5.133828163146973,
                "y": -0.839432954788208,
                "z": -164.43821716308594
            },
            {
                "x": -5.085504531860352,
                "y": -0.8401925563812256,
                "z": -164.28868103027344
            },
            {
                "x": -5.037137031555176,
                "y": -0.8407313823699951,
                "z": -164.13916015625
            },
            {
                "x": -4.9886698722839355,
                "y": -0.8410396575927734,
                "z": -163.98948669433594
            },
            {
                "x": -4.940201282501221,
                "y": -0.8411165475845337,
                "z": -163.83995056152344
            },
            {
                "x": -4.891698837280273,
                "y": -0.8409650325775146,
                "z": -163.6904296875
            },
            {
                "x": -4.843161582946777,
                "y": -0.8405880928039551,
                "z": -163.54090881347656
            },
            {
                "x": -4.794590950012207,
                "y": -0.8399803042411804,
                "z": -163.391357421875
            },
            {
                "x": -4.745951175689697,
                "y": -0.839148759841919,
                "z": -163.24166870117188
            },
            {
                "x": -4.697368621826172,
                "y": -0.8381013870239258,
                "z": -163.09214782714844
            },
            {
                "x": -4.64876651763916,
                "y": -0.8368409872055054,
                "z": -162.9427032470703
            },
            {
                "x": -4.600099086761475,
                "y": -0.8353624939918518,
                "z": -162.7930908203125
            },
            {
                "x": -4.551488399505615,
                "y": -0.8336739540100098,
                "z": -162.64358520507812
            },
            {
                "x": -4.502829074859619,
                "y": -0.831779956817627,
                "z": -162.49400329589844
            },
            {
                "x": -4.454171180725098,
                "y": -0.8296849727630615,
                "z": -162.34439086914062
            },
            {
                "x": -4.405551433563232,
                "y": -0.8273879289627075,
                "z": -162.1948699951172
            },
            {
                "x": -4.356960773468018,
                "y": -0.8248919248580933,
                "z": -162.04531860351562
            },
            {
                "x": -4.308389186859131,
                "y": -0.8222045302391052,
                "z": -161.89578247070312
            },
            {
                "x": -4.259823322296143,
                "y": -0.819328784942627,
                "z": -161.74623107910156
            },
            {
                "x": -4.21122932434082,
                "y": -0.8162591457366943,
                "z": -161.59646606445312
            },
            {
                "x": -4.162721633911133,
                "y": -0.8130059242248535,
                "z": -161.4468536376953
            },
            {
                "x": -4.114243507385254,
                "y": -0.8095740079879761,
                "z": -161.29722595214844
            },
            {
                "x": -4.065789222717285,
                "y": -0.8059645891189575,
                "z": -161.14752197265625
            },
            {
                "x": -4.017420291900635,
                "y": -0.8021811246871948,
                "z": -160.99790954589844
            },
            {
                "x": -3.9690146446228027,
                "y": -0.7982172966003418,
                "z": -160.84803771972656
            },
            {
                "x": -3.920740842819214,
                "y": -0.7940917015075684,
                "z": -160.69834899902344
            },
            {
                "x": -3.8725287914276123,
                "y": -0.7898043990135193,
                "z": -160.54869079589844
            },
            {
                "x": -3.8243215084075928,
                "y": -0.7853481769561768,
                "z": -160.39877319335938
            },
            {
                "x": -3.7762417793273926,
                "y": -0.7807355523109436,
                "z": -160.24905395507812
            },
            {
                "x": -3.7281811237335205,
                "y": -0.7759647369384766,
                "z": -160.09913635253906
            },
            {
                "x": -3.680224657058716,
                "y": -0.771044135093689,
                "z": -159.9492645263672
            },
            {
                "x": -3.632366895675659,
                "y": -0.7659761905670166,
                "z": -159.79940795898438
            },
            {
                "x": -3.5845742225646973,
                "y": -0.7607551217079163,
                "z": -159.64942932128906
            },
            {
                "x": -3.5369184017181396,
                "y": -0.7553976774215698,
                "z": -159.4995574951172
            },
            {
                "x": -3.489325523376465,
                "y": -0.7498999834060669,
                "z": -159.34959411621094
            },
            {
                "x": -3.4418017864227295,
                "y": -0.744259238243103,
                "z": -159.199462890625
            },
            {
                "x": -3.3944151401519775,
                "y": -0.7384892702102661,
                "z": -159.0494384765625
            },
            {
                "x": -3.3471529483795166,
                "y": -0.732588529586792,
                "z": -158.89938354492188
            },
            {
                "x": -3.3167006969451904,
                "y": -0.7287152409553528,
                "z": -158.80247497558594
            },
            {
                "x": -3.2696053981781006,
                "y": -0.7226060628890991,
                "z": -158.65232849121094
            },
            {
                "x": -3.22263765335083,
                "y": -0.7163726687431335,
                "z": -158.50209045410156
            },
            {
                "x": -3.175766706466675,
                "y": -0.7100222110748291,
                "z": -158.351806640625
            },
            {
                "x": -3.1290695667266846,
                "y": -0.7035590410232544,
                "z": -158.2015380859375
            },
            {
                "x": -3.082503318786621,
                "y": -0.696979820728302,
                "z": -158.0511932373047
            },
            {
                "x": -3.0360589027404785,
                "y": -0.690291166305542,
                "z": -157.9008331298828
            },
            {
                "x": -2.9898087978363037,
                "y": -0.6835019588470459,
                "z": -157.75045776367188
            },
            {
                "x": -2.9436068534851074,
                "y": -0.6766002178192139,
                "z": -157.599853515625
            },
            {
                "x": -2.8976404666900635,
                "y": -0.6696017980575562,
                "z": -157.44932556152344
            },
            {
                "x": -2.851824998855591,
                "y": -0.6625096797943115,
                "z": -157.29879760742188
            },
            {
                "x": -2.8061437606811523,
                "y": -0.6553197503089905,
                "z": -157.14810180664062
            },
            {
                "x": -2.7606847286224365,
                "y": -0.6480484008789062,
                "z": -156.9975128173828
            },
            {
                "x": -2.71529483795166,
                "y": -0.6406729221343994,
                "z": -156.84658813476562
            },
            {
                "x": -2.670184373855591,
                "y": -0.6332253813743591,
                "z": -156.69586181640625
            },
            {
                "x": -2.6252264976501465,
                "y": -0.6256980895996094,
                "z": -156.54505920410156
            },
            {
                "x": -2.5804202556610107,
                "y": -0.6180839538574219,
                "z": -156.39401245117188
            },
            {
                "x": -2.535876512527466,
                "y": -0.6104061603546143,
                "z": -156.24319458007812
            },
            {
                "x": -2.491447925567627,
                "y": -0.6026438474655151,
                "z": -156.09202575683594
            },
            {
                "x": -2.4472761154174805,
                "y": -0.5948193073272705,
                "z": -155.94091796875
            },
            {
                "x": -2.4032785892486572,
                "y": -0.5869319438934326,
                "z": -155.78977966308594
            },
            {
                "x": -2.359530448913574,
                "y": -0.5789795517921448,
                "z": -155.6385498046875
            },
            {
                "x": -2.315985918045044,
                "y": -0.5709724426269531,
                "z": -155.48736572265625
            },
            {
                "x": -2.272639513015747,
                "y": -0.562903642654419,
                "z": -155.33596801757812
            },
            {
                "x": -2.229504108428955,
                "y": -0.5547797083854675,
                "z": -155.18447875976562
            },
            {
                "x": -2.186589241027832,
                "y": -0.5466085076332092,
                "z": -155.03297424316406
            },
            {
                "x": -2.1439547538757324,
                "y": -0.5383908748626709,
                "z": -154.8814239501953
            },
            {
                "x": -2.1015162467956543,
                "y": -0.5301306843757629,
                "z": -154.72979736328125
            },
            {
                "x": -2.0593373775482178,
                "y": -0.5218274593353271,
                "z": -154.5780487060547
            },
            {
                "x": -2.017374038696289,
                "y": -0.5134848356246948,
                "z": -154.42620849609375
            },
            {
                "x": -1.9756709337234497,
                "y": -0.5051075220108032,
                "z": -154.27430725097656
            },
            {
                "x": -1.934277057647705,
                "y": -0.49670642614364624,
                "z": -154.12245178222656
            },
            {
                "x": -1.8930554389953613,
                "y": -0.48826953768730164,
                "z": -153.9703826904297
            },
            {
                "x": -1.8521661758422852,
                "y": -0.4798106253147125,
                "z": -153.81829833984375
            },
            {
                "x": -1.8115116357803345,
                "y": -0.47133004665374756,
                "z": -153.6661376953125
            },
            {
                "x": -1.771108865737915,
                "y": -0.4628227949142456,
                "z": -153.51376342773438
            },
            {
                "x": -1.7310506105422974,
                "y": -0.4543129801750183,
                "z": -153.36154174804688
            },
            {
                "x": -1.6911754608154297,
                "y": -0.4457792043685913,
                "z": -153.20904541015625
            },
            {
                "x": -1.6516867876052856,
                "y": -0.43724334239959717,
                "z": -153.0565948486328
            },
            {
                "x": -1.6124353408813477,
                "y": -0.4287031590938568,
                "z": -152.90411376953125
            },
            {
                "x": -1.5734399557113647,
                "y": -0.420141339302063,
                "z": -152.75123596191406
            },
            {
                "x": -1.5348198413848877,
                "y": -0.4116019606590271,
                "z": -152.59866333007812
            },
            {
                "x": -1.4964460134506226,
                "y": -0.40305233001708984,
                "z": -152.44580078125
            },
            {
                "x": -1.4718716144561768,
                "y": -0.3975365161895752,
                "z": -152.3470458984375
            },
            {
                "x": -1.434037446975708,
                "y": -0.3890090882778168,
                "z": -152.1942596435547
            },
            {
                "x": -1.3964829444885254,
                "y": -0.380476176738739,
                "z": -152.04104614257812
            },
            {
                "x": -1.3592957258224487,
                "y": -0.37196874618530273,
                "z": -151.88795471191406
            },
            {
                "x": -1.322372555732727,
                "y": -0.36347442865371704,
                "z": -151.7347412109375
            },
            {
                "x": -1.2858335971832275,
                "y": -0.3549993932247162,
                "z": -151.58140563964844
            },
            {
                "x": -1.249586820602417,
                "y": -0.34655407071113586,
                "z": -151.42811584472656
            },
            {
                "x": -1.2137001752853394,
                "y": -0.33812862634658813,
                "z": -151.2746124267578
            },
            {
                "x": -1.1781262159347534,
                "y": -0.3297329246997833,
                "z": -151.1210479736328
            },
            {
                "x": -1.142871618270874,
                "y": -0.32136639952659607,
                "z": -150.96731567382812
            },
            {
                "x": -1.108055830001831,
                "y": -0.3130444288253784,
                "z": -150.8136444091797
            },
            {
                "x": -1.0735013484954834,
                "y": -0.3047562837600708,
                "z": -150.65982055664062
            },
            {
                "x": -1.039372205734253,
                "y": -0.29651033878326416,
                "z": -150.50587463378906
            },
            {
                "x": -1.005539894104004,
                "y": -0.28830671310424805,
                "z": -150.35186767578125
            },
            {
                "x": -0.9720853567123413,
                "y": -0.28014975786209106,
                "z": -150.19769287109375
            },
            {
                "x": -0.9390683174133301,
                "y": -0.2720577120780945,
                "z": -150.04371643066406
            },
            {
                "x": -0.9063026905059814,
                "y": -0.2640033960342407,
                "z": -149.88931274414062
            },
            {
                "x": -0.874014139175415,
                "y": -0.25601309537887573,
                "z": -149.7349853515625
            },
            {
                "x": -0.8420478105545044,
                "y": -0.2480861246585846,
                "z": -149.58062744140625
            },
            {
                "x": -0.8104589581489563,
                "y": -0.2402113527059555,
                "z": -149.42591857910156
            },
            {
                "x": -0.7793166637420654,
                "y": -0.23241940140724182,
                "z": -149.27149963378906
            },
            {
                "x": -0.7484831213951111,
                "y": -0.22468522191047668,
                "z": -149.1167449951172
            },
            {
                "x": -0.7181415557861328,
                "y": -0.2170308381319046,
                "z": -148.96202087402344
            },
            {
                "x": -0.6881285905838013,
                "y": -0.20945397019386292,
                "z": -148.80726623535156
            },
            {
                "x": -0.6585080623626709,
                "y": -0.20193800330162048,
                "z": -148.6520538330078
            },
            {
                "x": -0.6293455958366394,
                "y": -0.19452452659606934,
                "z": -148.49722290039062
            },
            {
                "x": -0.6005152463912964,
                "y": -0.18718042969703674,
                "z": -148.34194946289062
            },
            {
                "x": -0.5722039937973022,
                "y": -0.1799357384443283,
                "z": -148.18678283691406
            },
            {
                "x": -0.544217586517334,
                "y": -0.172780379652977,
                "z": -148.03155517578125
            },
            {
                "x": -0.5166733264923096,
                "y": -0.1657058298587799,
                "z": -147.8759307861328
            },
            {
                "x": -0.48957058787345886,
                "y": -0.15874738991260529,
                "z": -147.7206573486328
            },
            {
                "x": -0.46286049485206604,
                "y": -0.1518784612417221,
                "z": -147.56500244140625
            },
            {
                "x": -0.4366428852081299,
                "y": -0.14511874318122864,
                "z": -147.40943908691406
            },
            {
                "x": -0.41076627373695374,
                "y": -0.13846123218536377,
                "z": -147.25372314453125
            },
            {
                "x": -0.3854036331176758,
                "y": -0.1319095343351364,
                "z": -147.0978240966797
            },
            {
                "x": -0.3604498505592346,
                "y": -0.12548168003559113,
                "z": -146.94204711914062
            },
            {
                "x": -0.3359285295009613,
                "y": -0.11915998160839081,
                "z": -146.78598022460938
            },
            {
                "x": -0.31189948320388794,
                "y": -0.11296334862709045,
                "z": -146.63002014160156
            },
            {
                "x": -0.28823187947273254,
                "y": -0.10688325762748718,
                "z": -146.47389221191406
            },
            {
                "x": -0.26513203978538513,
                "y": -0.1009339839220047,
                "z": -146.31773376464844
            },
            {
                "x": -0.24238574504852295,
                "y": -0.09510914981365204,
                "z": -146.1614227294922
            },
            {
                "x": -0.22013133764266968,
                "y": -0.08941192924976349,
                "z": -146.00498962402344
            },
            {
                "x": -0.19838619232177734,
                "y": -0.08385825157165527,
                "z": -145.84881591796875
            },
            {
                "x": -0.18452845513820648,
                "y": -0.08034355938434601,
                "z": -145.74774169921875
            },
            {
                "x": -0.16351868212223053,
                "y": -0.07500889897346497,
                "z": -145.5911102294922
            },
            {
                "x": -0.1429653912782669,
                "y": -0.06982142478227615,
                "z": -145.43466186523438
            },
            {
                "x": -0.12282852083444595,
                "y": -0.06477300822734833,
                "z": -145.2777862548828
            },
            {
                "x": -0.10328246653079987,
                "y": -0.059882521629333496,
                "z": -145.1211700439453
            },
            {
                "x": -0.08409367501735687,
                "y": -0.055137377232313156,
                "z": -144.96435546875
            },
            {
                "x": -0.06545228511095047,
                "y": -0.05054284259676933,
                "z": -144.80738830566406
            },
            {
                "x": -0.04730241745710373,
                "y": -0.04611903056502342,
                "z": -144.6507110595703
            },
            {
                "x": -0.029553905129432678,
                "y": -0.041840918362140656,
                "z": -144.493408203125
            },
            {
                "x": -0.012405946850776672,
                "y": -0.0377354770898819,
                "z": -144.3364715576172
            },
            {
                "x": 0.004373669624328613,
                "y": -0.03379197046160698,
                "z": -144.17938232421875
            },
            {
                "x": 0.02057778835296631,
                "y": -0.030018102377653122,
                "z": -144.02206420898438
            },
            {
                "x": 0.036289408802986145,
                "y": -0.026425670832395554,
                "z": -143.86505126953125
            },
            {
                "x": 0.05159197747707367,
                "y": -0.022995028644800186,
                "z": -143.7074737548828
            },
            {
                "x": 0.06627942621707916,
                "y": -0.019749784842133522,
                "z": -143.5502471923828
            },
            {
                "x": 0.0805685967206955,
                "y": -0.01668950729072094,
                "z": -143.39295959472656
            },
            {
                "x": 0.09429852664470673,
                "y": -0.013808771967887878,
                "z": -143.2353057861328
            },
            {
                "x": 0.1075206995010376,
                "y": -0.01112113706767559,
                "z": -143.07803344726562
            },
            {
                "x": 0.12032048404216766,
                "y": -0.00861458107829094,
                "z": -142.92030334472656
            },
            {
                "x": 0.1324898600578308,
                "y": -0.006308235228061676,
                "z": -142.7626953125
            },
            {
                "x": 0.14424899220466614,
                "y": -0.004201591480523348,
                "z": -142.60520935058594
            },
            {
                "x": 0.15544620156288147,
                "y": -0.002288979943841696,
                "z": -142.44744873046875
            },
            {
                "x": 0.16612589359283447,
                "y": -0.00057991873472929,
                "z": -142.28997802734375
            },
            {
                "x": 0.17636705935001373,
                "y": 0.0009238505735993385,
                "z": -142.1321563720703
            },
            {
                "x": 0.1859864592552185,
                "y": 0.002217920497059822,
                "z": -141.97421264648438
            },
            {
                "x": 0.19518186151981354,
                "y": 0.0033009916078299284,
                "z": -141.81655883789062
            },
            {
                "x": 0.2038297802209854,
                "y": 0.004174693487584591,
                "z": -141.65855407714844
            },
            {
                "x": 0.21191295981407166,
                "y": 0.004826802760362625,
                "z": -141.50083923339844
            },
            {
                "x": 0.2195703685283661,
                "y": 0.0052573541179299355,
                "z": -141.34291076660156
            },
            {
                "x": 0.22660768032073975,
                "y": 0.005461216904222965,
                "z": -141.1847686767578
            },
            {
                "x": 0.2331991195678711,
                "y": 0.005469098687171936,
                "z": -141.0270538330078
            },
            {
                "x": 0.23925499618053436,
                "y": 0.005461357533931732,
                "z": -140.86892700195312
            },
            {
                "x": 0.24471063911914825,
                "y": 0.005453590303659439,
                "z": -140.71099853515625
            },
            {
                "x": 0.2497604340314865,
                "y": 0.005445856600999832,
                "z": -140.5530548095703
            },
            {
                "x": 0.2541922926902771,
                "y": 0.0054380930960178375,
                "z": -140.39486694335938
            },
            {
                "x": 0.25813543796539307,
                "y": 0.005430359393358231,
                "z": -140.2370147705078
            },
            {
                "x": 0.26158440113067627,
                "y": 0.005422607064247131,
                "z": -140.07884216308594
            },
            {
                "x": 0.2644263505935669,
                "y": 0.005414862185716629,
                "z": -139.92079162597656
            },
            {
                "x": 0.26686668395996094,
                "y": 0.005407102406024933,
                "z": -139.76290893554688
            },
            {
                "x": 0.2687416970729828,
                "y": 0.005399342626333237,
                "z": -139.60479736328125
            },
            {
                "x": 0.2701544761657715,
                "y": 0.005391612648963928,
                "z": -139.4468536376953
            },
            {
                "x": 0.2711896300315857,
                "y": 0.005383852869272232,
                "z": -139.2889404296875
            },
            {
                "x": 0.27179861068725586,
                "y": 0.005376122891902924,
                "z": -139.1312255859375
            },
            {
                "x": 0.27207648754119873,
                "y": 0.005371071398258209,
                "z": -139.02947998046875
            },
            {
                "x": 0.27230632305145264,
                "y": 0.005363352596759796,
                "z": -138.87185668945312
            },
            {
                "x": 0.27232474088668823,
                "y": 0.0053555965423583984,
                "z": -138.71434020996094
            },
            {
                "x": 0.2722865343093872,
                "y": 0.005347840487957001,
                "z": -138.55691528320312
            },
            {
                "x": 0.27215901017189026,
                "y": 0.005340099334716797,
                "z": -138.39956665039062
            },
            {
                "x": 0.2719953656196594,
                "y": 0.005332339555025101,
                "z": -138.24221801757812
            },
            {
                "x": 0.2718240022659302,
                "y": 0.005324594676494598,
                "z": -138.0849609375
            },
            {
                "x": 0.2716357111930847,
                "y": 0.005316846072673798,
                "z": -137.92771911621094
            },
            {
                "x": 0.27144473791122437,
                "y": 0.005309104919433594,
                "z": -137.77029418945312
            },
            {
                "x": 0.27125096321105957,
                "y": 0.005301341414451599,
                "z": -137.613037109375
            },
            {
                "x": 0.2710539400577545,
                "y": 0.005293592810630798,
                "z": -137.45574951171875
            },
            {
                "x": 0.27085569500923157,
                "y": 0.005285855382680893,
                "z": -137.2984619140625
            },
            {
                "x": 0.27065509557724,
                "y": 0.005278114229440689,
                "z": -137.1412353515625
            },
            {
                "x": 0.27045243978500366,
                "y": 0.0052703507244586945,
                "z": -136.98377990722656
            },
            {
                "x": 0.27024829387664795,
                "y": 0.005262613296508789,
                "z": -136.82656860351562
            },
            {
                "x": 0.27004191279411316,
                "y": 0.005254864692687988,
                "z": -136.66934204101562
            },
            {
                "x": 0.26983386278152466,
                "y": 0.0052471160888671875,
                "z": -136.51197814941406
            },
            {
                "x": 0.2696237564086914,
                "y": 0.005239367485046387,
                "z": -136.354736328125
            },
            {
                "x": 0.269411563873291,
                "y": 0.005231622606515884,
                "z": -136.19741821289062
            },
            {
                "x": 0.26919782161712646,
                "y": 0.005223877727985382,
                "z": -136.04005432128906
            },
            {
                "x": 0.26898178458213806,
                "y": 0.005216129124164581,
                "z": -135.88282775878906
            },
            {
                "x": 0.2687642574310303,
                "y": 0.0052083805203437805,
                "z": -135.72560119628906
            },
            {
                "x": 0.2685445547103882,
                "y": 0.005200635641813278,
                "z": -135.568359375
            },
            {
                "x": 0.2683228850364685,
                "y": 0.005192883312702179,
                "z": -135.4111328125
            },
            {
                "x": 0.26809924840927124,
                "y": 0.005185142159461975,
                "z": -135.2537078857422
            },
            {
                "x": 0.2678735852241516,
                "y": 0.005177386105060577,
                "z": -135.09646606445312
            },
            {
                "x": 0.26764628291130066,
                "y": 0.005169637501239777,
                "z": -134.93917846679688
            },
            {
                "x": 0.2674168050289154,
                "y": 0.005161892622709274,
                "z": -134.78189086914062
            },
            {
                "x": 0.26718538999557495,
                "y": 0.005154158920049667,
                "z": -134.62466430664062
            },
            {
                "x": 0.2669520080089569,
                "y": 0.005146395415067673,
                "z": -134.46722412109375
            },
            {
                "x": 0.2667165994644165,
                "y": 0.005138657987117767,
                "z": -134.3099822998047
            },
            {
                "x": 0.26647961139678955,
                "y": 0.0051309093832969666,
                "z": -134.1527557373047
            },
            {
                "x": 0.26624011993408203,
                "y": 0.005123153328895569,
                "z": -133.9954071044922
            },
            {
                "x": 0.2659989595413208,
                "y": 0.0051154159009456635,
                "z": -133.83816528320312
            },
            {
                "x": 0.265755832195282,
                "y": 0.005107656121253967,
                "z": -133.68081665039062
            },
            {
                "x": 0.2655104696750641,
                "y": 0.005099911242723465,
                "z": -133.5235137939453
            },
            {
                "x": 0.2652636170387268,
                "y": 0.005092162638902664,
                "z": -133.3662567138672
            },
            {
                "x": 0.26501429080963135,
                "y": 0.005084414035081863,
                "z": -133.20892333984375
            },
            {
                "x": 0.26476341485977173,
                "y": 0.005076657980680466,
                "z": -133.0516815185547
            },
            {
                "x": 0.2645103931427002,
                "y": 0.005068928003311157,
                "z": -132.8944549560547
            },
            {
                "x": 0.2642551064491272,
                "y": 0.0050699482671916485,
                "z": -132.7370147705078
            },
            {
                "x": 0.2639981806278229,
                "y": 0.005311235319823027,
                "z": -132.5797882080078
            },
            {
                "x": 0.26374346017837524,
                "y": 0.005942394491285086,
                "z": -132.42259216308594
            },
            {
                "x": 0.2635698914527893,
                "y": 0.006552420556545258,
                "z": -132.32102966308594
            },
            {
                "x": 0.2633075714111328,
                "y": 0.007819141261279583,
                "z": -132.16380310058594
            },
            {
                "x": 0.263043075799942,
                "y": 0.009453611448407173,
                "z": -132.00648498535156
            },
            {
                "x": 0.26277682185173035,
                "y": 0.011446494609117508,
                "z": -131.8491668701172
            },
            {
                "x": 0.2625083327293396,
                "y": 0.013796258717775345,
                "z": -131.69195556640625
            },
            {
                "x": 0.262238085269928,
                "y": 0.016496267169713974,
                "z": -131.53466796875
            },
            {
                "x": 0.26196569204330444,
                "y": 0.01952601782977581,
                "z": -131.37745666503906
            },
            {
                "x": 0.26169145107269287,
                "y": 0.022878967225551605,
                "z": -131.2202911376953
            },
            {
                "x": 0.2614147961139679,
                "y": 0.026558391749858856,
                "z": -131.0628662109375
            },
            {
                "x": 0.26113641262054443,
                "y": 0.030546167865395546,
                "z": -130.9057159423828
            },
            {
                "x": 0.2608559727668762,
                "y": 0.034832000732421875,
                "z": -130.74850463867188
            },
            {
                "x": 0.2605733871459961,
                "y": 0.03940637409687042,
                "z": -130.59127807617188
            },
            {
                "x": 0.26028913259506226,
                "y": 0.04426394775509834,
                "z": -130.4341278076172
            },
            {
                "x": 0.26000213623046875,
                "y": 0.04940670356154442,
                "z": -130.2767791748047
            },
            {
                "x": 0.2597138285636902,
                "y": 0.05480388179421425,
                "z": -130.11965942382812
            },
            {
                "x": 0.2594231367111206,
                "y": 0.06045408546924591,
                "z": -129.9625244140625
            },
            {
                "x": 0.2591305375099182,
                "y": 0.06635735183954239,
                "z": -129.8052978515625
            },
            {
                "x": 0.2588358521461487,
                "y": 0.07249923050403595,
                "z": -129.648193359375
            },
            {
                "x": 0.258539080619812,
                "y": 0.07887116074562073,
                "z": -129.49099731445312
            },
            {
                "x": 0.2582402229309082,
                "y": 0.0854620561003685,
                "z": -129.3338165283203
            },
            {
                "x": 0.2579394578933716,
                "y": 0.0922614187002182,
                "z": -129.17672729492188
            },
            {
                "x": 0.25763678550720215,
                "y": 0.09926757216453552,
                "z": -129.0196533203125
            },
            {
                "x": 0.2573317885398865,
                "y": 0.10646544396877289,
                "z": -128.8625946044922
            },
            {
                "x": 0.2570250630378723,
                "y": 0.11384683102369308,
                "z": -128.70553588867188
            },
            {
                "x": 0.2567155659198761,
                "y": 0.12141408026218414,
                "z": -128.54827880859375
            },
            {
                "x": 0.25640469789505005,
                "y": 0.12914389371871948,
                "z": -128.3912353515625
            },
            {
                "x": 0.2560913860797882,
                "y": 0.13703295588493347,
                "z": -128.23416137695312
            },
            {
                "x": 0.2557763457298279,
                "y": 0.1450703740119934,
                "z": -128.07708740234375
            },
            {
                "x": 0.2554589509963989,
                "y": 0.15324556827545166,
                "z": -127.92009735107422
            },
            {
                "x": 0.2551393210887909,
                "y": 0.16156816482543945,
                "z": -127.76288604736328
            },
            {
                "x": 0.2548178434371948,
                "y": 0.1700025349855423,
                "z": -127.60587310791016
            },
            {
                "x": 0.2544945180416107,
                "y": 0.17855113744735718,
                "z": -127.44886016845703
            },
            {
                "x": 0.2541688084602356,
                "y": 0.18721076846122742,
                "z": -127.291748046875
            },
            {
                "x": 0.25384122133255005,
                "y": 0.1959637999534607,
                "z": -127.13478088378906
            },
            {
                "x": 0.25351133942604065,
                "y": 0.20481017231941223,
                "z": -126.97771453857422
            },
            {
                "x": 0.2531793713569641,
                "y": 0.21373622119426727,
                "z": -126.82064056396484
            },
            {
                "x": 0.25284552574157715,
                "y": 0.22272732853889465,
                "z": -126.66366577148438
            },
            {
                "x": 0.2525094151496887,
                "y": 0.2317887842655182,
                "z": -126.50658416748047
            },
            {
                "x": 0.2521713376045227,
                "y": 0.24089780449867249,
                "z": -126.34960174560547
            },
            {
                "x": 0.2518311142921448,
                "y": 0.2500511407852173,
                "z": -126.192626953125
            },
            {
                "x": 0.251488596200943,
                "y": 0.2592507600784302,
                "z": -126.03547668457031
            },
            {
                "x": 0.251144140958786,
                "y": 0.26846742630004883,
                "z": -125.87850189208984
            },
            {
                "x": 0.25079959630966187,
                "y": 0.277702271938324,
                "z": -125.7215576171875
            },
            {
                "x": 0.2505718469619751,
                "y": 0.28367307782173157,
                "z": -125.62016296386719
            },
            {
                "x": 0.2502221167087555,
                "y": 0.29291990399360657,
                "z": -125.46319580078125
            },
            {
                "x": 0.249869704246521,
                "y": 0.302168071269989,
                "z": -125.30613708496094
            },
            {
                "x": 0.24951551854610443,
                "y": 0.3114020824432373,
                "z": -125.1490707397461
            },
            {
                "x": 0.24915917217731476,
                "y": 0.3206091523170471,
                "z": -124.99211883544922
            },
            {
                "x": 0.24880078434944153,
                "y": 0.3297915756702423,
                "z": -124.83504486083984
            },
            {
                "x": 0.24844016134738922,
                "y": 0.3389270305633545,
                "z": -124.67808532714844
            },
            {
                "x": 0.2480776607990265,
                "y": 0.348015695810318,
                "z": -124.5211181640625
            },
            {
                "x": 0.2477124184370041,
                "y": 0.3570598363876343,
                "z": -124.3639144897461
            },
            {
                "x": 0.24734577536582947,
                "y": 0.3660251796245575,
                "z": -124.20694732666016
            },
            {
                "x": 0.2469765841960907,
                "y": 0.3749181926250458,
                "z": -124.04991912841797
            },
            {
                "x": 0.24660547077655792,
                "y": 0.3837296962738037,
                "z": -123.89285278320312
            },
            {
                "x": 0.24623216688632965,
                "y": 0.39244598150253296,
                "z": -123.7358627319336
            },
            {
                "x": 0.24585653841495514,
                "y": 0.4010728597640991,
                "z": -123.57865142822266
            },
            {
                "x": 0.24547909200191498,
                "y": 0.4095763564109802,
                "z": -123.42164611816406
            },
            {
                "x": 0.2450994849205017,
                "y": 0.41796284914016724,
                "z": -123.26463317871094
            },
            {
                "x": 0.24471761286258698,
                "y": 0.42622923851013184,
                "z": -123.10750579833984
            },
            {
                "x": 0.24433372914791107,
                "y": 0.4343554973602295,
                "z": -122.95046997070312
            },
            {
                "x": 0.2439476102590561,
                "y": 0.4423367381095886,
                "z": -122.79334259033203
            },
            {
                "x": 0.24355919659137726,
                "y": 0.45016682147979736,
                "z": -122.63619995117188
            },
            {
                "x": 0.24316908419132233,
                "y": 0.45783132314682007,
                "z": -122.4791488647461
            },
            {
                "x": 0.2427767664194107,
                "y": 0.4653257429599762,
                "z": -122.32209777832031
            },
            {
                "x": 0.24238233268260956,
                "y": 0.47263506054878235,
                "z": -122.1650390625
            },
            {
                "x": 0.24198567867279053,
                "y": 0.47975781559944153,
                "z": -122.00794982910156
            },
            {
                "x": 0.24158653616905212,
                "y": 0.48669344186782837,
                "z": -121.85066986083984
            },
            {
                "x": 0.2411857396364212,
                "y": 0.4934167265892029,
                "z": -121.6935806274414
            },
            {
                "x": 0.24078263342380524,
                "y": 0.49991968274116516,
                "z": -121.53640747070312
            },
            {
                "x": 0.24037747085094452,
                "y": 0.5062001943588257,
                "z": -121.37925720214844
            },
            {
                "x": 0.23997022211551666,
                "y": 0.5122489929199219,
                "z": -121.22212219238281
            },
            {
                "x": 0.23956061899662018,
                "y": 0.5180662274360657,
                "z": -121.0647964477539
            },
            {
                "x": 0.2391490936279297,
                "y": 0.5236175060272217,
                "z": -120.90765380859375
            },
            {
                "x": 0.2387356162071228,
                "y": 0.5289111137390137,
                "z": -120.75048828125
            },
            {
                "x": 0.2383197546005249,
                "y": 0.5339430570602417,
                "z": -120.59321594238281
            },
            {
                "x": 0.23790200054645538,
                "y": 0.5386978983879089,
                "z": -120.43604278564453
            },
            {
                "x": 0.23748205602169037,
                "y": 0.5431607365608215,
                "z": -120.27877807617188
            },
            {
                "x": 0.2370598167181015,
                "y": 0.5473300218582153,
                "z": -120.1214828491211
            },
            {
                "x": 0.2366359382867813,
                "y": 0.5511963367462158,
                "z": -119.96428680419922
            },
            {
                "x": 0.23620973527431488,
                "y": 0.5547564029693604,
                "z": -119.80697631835938
            },
            {
                "x": 0.23578152060508728,
                "y": 0.5579841136932373,
                "z": -119.64977264404297
            },
            {
                "x": 0.23535145819187164,
                "y": 0.5608818531036377,
                "z": -119.49254608154297
            },
            {
                "x": 0.23491880297660828,
                "y": 0.5634474158287048,
                "z": -119.33513641357422
            },
            {
                "x": 0.23448462784290314,
                "y": 0.5656659603118896,
                "z": -119.17790222167969
            },
            {
                "x": 0.23405762016773224,
                "y": 0.5675195455551147,
                "z": -119.02068328857422
            },
            {
                "x": 0.23376452922821045,
                "y": 0.5685210227966309,
                "z": -118.91912078857422
            },
            {
                "x": 0.2333250492811203,
                "y": 0.5697754621505737,
                "z": -118.7618637084961
            },
            {
                "x": 0.23288314044475555,
                "y": 0.5706449747085571,
                "z": -118.60452270507812
            },
            {
                "x": 0.23243947327136993,
                "y": 0.5711203813552856,
                "z": -118.44718170166016
            },
            {
                "x": 0.23199395835399628,
                "y": 0.5712020993232727,
                "z": -118.28992462158203
            },
            {
                "x": 0.23154620826244354,
                "y": 0.5708877444267273,
                "z": -118.13258361816406
            },
            {
                "x": 0.23109695315361023,
                "y": 0.5701761245727539,
                "z": -117.97533416748047
            },
            {
                "x": 0.23064562678337097,
                "y": 0.5690747499465942,
                "z": -117.8180923461914
            },
            {
                "x": 0.23019185662269592,
                "y": 0.5676008462905884,
                "z": -117.66065979003906
            },
            {
                "x": 0.22973692417144775,
                "y": 0.5657662749290466,
                "z": -117.50342559814453
            },
            {
                "x": 0.22927989065647125,
                "y": 0.5635700225830078,
                "z": -117.34614562988281
            },
            {
                "x": 0.22882096469402313,
                "y": 0.5610190033912659,
                "z": -117.18885803222656
            },
            {
                "x": 0.22836041450500488,
                "y": 0.5581331253051758,
                "z": -117.03164672851562
            },
            {
                "x": 0.22789759933948517,
                "y": 0.5549160242080688,
                "z": -116.87423706054688
            },
            {
                "x": 0.2274334877729416,
                "y": 0.5513778924942017,
                "z": -116.71702575683594
            },
            {
                "x": 0.22696763277053833,
                "y": 0.5475212931632996,
                "z": -116.5598373413086
            },
            {
                "x": 0.22649985551834106,
                "y": 0.5433608293533325,
                "z": -116.40254974365234
            },
            {
                "x": 0.2260306477546692,
                "y": 0.5389108061790466,
                "z": -116.245361328125
            },
            {
                "x": 0.22555950284004211,
                "y": 0.5341697931289673,
                "z": -116.08809661865234
            },
            {
                "x": 0.22508682310581207,
                "y": 0.5291451811790466,
                "z": -115.93083953857422
            },
            {
                "x": 0.2246127426624298,
                "y": 0.5238576531410217,
                "z": -115.77368927001953
            },
            {
                "x": 0.22413723170757294,
                "y": 0.5183130502700806,
                "z": -115.61654663085938
            },
            {
                "x": 0.22366026043891907,
                "y": 0.5125169157981873,
                "z": -115.45941925048828
            },
            {
                "x": 0.22318175435066223,
                "y": 0.5064722299575806,
                "z": -115.30229187011719
            },
            {
                "x": 0.22270134091377258,
                "y": 0.5001891851425171,
                "z": -115.14498901367188
            },
            {
                "x": 0.2222200632095337,
                "y": 0.49369150400161743,
                "z": -114.98787689208984
            },
            {
                "x": 0.22173739969730377,
                "y": 0.48697614669799805,
                "z": -114.83072662353516
            },
            {
                "x": 0.22125351428985596,
                "y": 0.4800477623939514,
                "z": -114.67359924316406
            },
            {
                "x": 0.22076857089996338,
                "y": 0.4729257822036743,
                "z": -114.51651763916016
            },
            {
                "x": 0.2202819436788559,
                "y": 0.46560704708099365,
                "z": -114.35924530029297
            },
            {
                "x": 0.2197948694229126,
                "y": 0.45811837911605835,
                "z": -114.20219421386719
            },
            {
                "x": 0.21930678188800812,
                "y": 0.4504520893096924,
                "z": -114.04515075683594
            },
            {
                "x": 0.21881753206253052,
                "y": 0.44261878728866577,
                "z": -113.88798522949219
            },
            {
                "x": 0.21832774579524994,
                "y": 0.43463921546936035,
                "z": -113.73095703125
            },
            {
                "x": 0.21783702075481415,
                "y": 0.4265097975730896,
                "z": -113.57382202148438
            },
            {
                "x": 0.21734561026096344,
                "y": 0.4182395935058594,
                "z": -113.41670989990234
            },
            {
                "x": 0.2168540209531784,
                "y": 0.409847617149353,
                "z": -113.25970458984375
            },
            {
                "x": 0.21636177599430084,
                "y": 0.40133243799209595,
                "z": -113.10259246826172
            },
            {
                "x": 0.21586953103542328,
                "y": 0.392713725566864,
                "z": -112.94559478759766
            },
            {
                "x": 0.21537715196609497,
                "y": 0.383989155292511,
                "z": -112.7885971069336
            },
            {
                "x": 0.21488428115844727,
                "y": 0.3751624524593353,
                "z": -112.63141632080078
            },
            {
                "x": 0.21439209580421448,
                "y": 0.36626410484313965,
                "z": -112.47443389892578
            },
            {
                "x": 0.21391575038433075,
                "y": 0.3572917580604553,
                "z": -112.31746673583984
            },
            {
                "x": 0.213581845164299,
                "y": 0.3514566719532013,
                "z": -112.21607208251953
            },
            {
                "x": 0.2130909264087677,
                "y": 0.3423771858215332,
                "z": -112.05908966064453
            },
            {
                "x": 0.2126006931066513,
                "y": 0.33324018120765686,
                "z": -111.90200805664062
            },
            {
                "x": 0.21211156249046326,
                "y": 0.324060320854187,
                "z": -111.74496459960938
            },
            {
                "x": 0.2116241306066513,
                "y": 0.31485068798065186,
                "z": -111.58800506591797
            },
            {
                "x": 0.21113795042037964,
                "y": 0.3056091070175171,
                "z": -111.43095397949219
            },
            {
                "x": 0.2106541097164154,
                "y": 0.296357125043869,
                "z": -111.27400207519531
            },
            {
                "x": 0.21017253398895264,
                "y": 0.28709620237350464,
                "z": -111.11705017089844
            },
            {
                "x": 0.20969317853450775,
                "y": 0.277823805809021,
                "z": -110.95988464355469
            },
            {
                "x": 0.20921744406223297,
                "y": 0.2685733437538147,
                "z": -110.80294799804688
            },
            {
                "x": 0.20874512195587158,
                "y": 0.25933629274368286,
                "z": -110.64593505859375
            },
            {
                "x": 0.20827695727348328,
                "y": 0.2501259446144104,
                "z": -110.48894500732422
            },
            {
                "x": 0.2078137993812561,
                "y": 0.24095536768436432,
                "z": -110.33199310302734
            },
            {
                "x": 0.2073555290699005,
                "y": 0.2318161129951477,
                "z": -110.17481994628906
            },
            {
                "x": 0.2069038301706314,
                "y": 0.22274088859558105,
                "z": -110.01785278320312
            },
            {
                "x": 0.20645920932292938,
                "y": 0.21372760832309723,
                "z": -109.86090087890625
            },
            {
                "x": 0.2060227394104004,
                "y": 0.20478025078773499,
                "z": -109.7038345336914
            },
            {
                "x": 0.20559558272361755,
                "y": 0.1959175318479538,
                "z": -109.546875
            },
            {
                "x": 0.20517870783805847,
                "y": 0.1871355026960373,
                "z": -109.3897933959961
            },
            {
                "x": 0.20477411150932312,
                "y": 0.17845004796981812,
                "z": -109.23271942138672
            },
            {
                "x": 0.20438414812088013,
                "y": 0.16987892985343933,
                "z": -109.07574462890625
            },
            {
                "x": 0.2040105164051056,
                "y": 0.16142119467258453,
                "z": -108.91877746582031
            },
            {
                "x": 0.20365577936172485,
                "y": 0.15308421850204468,
                "z": -108.76178741455078
            },
            {
                "x": 0.2033233642578125,
                "y": 0.1448783427476883,
                "z": -108.60481262207031
            },
            {
                "x": 0.2030182182788849,
                "y": 0.13680800795555115,
                "z": -108.44762420654297
            },
            {
                "x": 0.20274542272090912,
                "y": 0.1288958638906479,
                "z": -108.29064178466797
            },
            {
                "x": 0.20249980688095093,
                "y": 0.1211334615945816,
                "z": -108.13353729248047
            },
            {
                "x": 0.20208409428596497,
                "y": 0.11350694298744202,
                "z": -107.9758071899414
            },
            {
                "x": 0.20074725151062012,
                "y": 0.10602542757987976,
                "z": -107.81727600097656
            },
            {
                "x": 0.19819329679012299,
                "y": 0.09871643036603928,
                "z": -107.65847778320312
            },
            {
                "x": 0.1944693773984909,
                "y": 0.0916140079498291,
                "z": -107.49996948242188
            },
            {
                "x": 0.18964649736881256,
                "y": 0.08471809327602386,
                "z": -107.34159088134766
            },
            {
                "x": 0.1837460994720459,
                "y": 0.0780419409275055,
                "z": -107.1832046508789
            },
            {
                "x": 0.1768817901611328,
                "y": 0.07159513235092163,
                "z": -107.0250473022461
            },
            {
                "x": 0.16911277174949646,
                "y": 0.06537704169750214,
                "z": -106.8669204711914
            },
            {
                "x": 0.16051214933395386,
                "y": 0.059398699551820755,
                "z": -106.70890045166016
            },
            {
                "x": 0.15112733840942383,
                "y": 0.053683072328567505,
                "z": -106.55110168457031
            },
            {
                "x": 0.1410287618637085,
                "y": 0.048222970217466354,
                "z": -106.39331817626953
            },
            {
                "x": 0.13029316067695618,
                "y": 0.04303126409649849,
                "z": -106.23573303222656
            },
            {
                "x": 0.11898376047611237,
                "y": 0.038112904876470566,
                "z": -106.07829284667969
            },
            {
                "x": 0.10711008310317993,
                "y": 0.03348006680607796,
                "z": -105.92072296142578
            },
            {
                "x": 0.09477594494819641,
                "y": 0.029146376997232437,
                "z": -105.76346588134766
            },
            {
                "x": 0.08202816545963287,
                "y": 0.025110404938459396,
                "z": -105.60629272460938
            },
            {
                "x": 0.07359204441308975,
                "y": 0.022664513438940048,
                "z": -105.50481414794922
            },
            {
                "x": 0.06024794280529022,
                "y": 0.019146807491779327,
                "z": -105.3477783203125
            },
            {
                "x": 0.04659824073314667,
                "y": 0.015946391969919205,
                "z": -105.19070434570312
            },
            {
                "x": 0.0326983705163002,
                "y": 0.013074295595288277,
                "z": -105.03372955322266
            },
            {
                "x": 0.018586523830890656,
                "y": 0.010547670535743237,
                "z": -104.87689208984375
            },
            {
                "x": 0.004283703863620758,
                "y": 0.008373018354177475,
                "z": -104.72001647949219
            },
            {
                "x": -0.010151609778404236,
                "y": 0.006552787497639656,
                "z": -104.56330108642578
            },
            {
                "x": -0.02469532936811447,
                "y": 0.005093601997941732,
                "z": -104.40663146972656
            },
            {
                "x": -0.039340898394584656,
                "y": 0.00401064520701766,
                "z": -104.24980926513672
            },
            {
                "x": -0.05401810258626938,
                "y": 0.0033180308528244495,
                "z": -104.09322357177734
            },
            {
                "x": -0.06872940063476562,
                "y": 0.003012107452377677,
                "z": -103.93659973144531
            },
            {
                "x": -0.08344244956970215,
                "y": 0.0029828250408172607,
                "z": -103.78001403808594
            },
            {
                "x": -0.09812857210636139,
                "y": 0.0029756613075733185,
                "z": -103.62350463867188
            },
            {
                "x": -0.1127893328666687,
                "y": 0.0029684901237487793,
                "z": -103.46682739257812
            },
            {
                "x": -0.1273709088563919,
                "y": 0.002961326390504837,
                "z": -103.31035614013672
            },
            {
                "x": -0.14187419414520264,
                "y": 0.0029541663825511932,
                "z": -103.15389251708984
            },
            {
                "x": -0.1562926322221756,
                "y": 0.0029470063745975494,
                "z": -102.99735260009766
            },
            {
                "x": -0.1705905795097351,
                "y": 0.0029398389160633087,
                "z": -102.8409194946289
            },
            {
                "x": -0.1847715675830841,
                "y": 0.002932664006948471,
                "z": -102.68439483642578
            },
            {
                "x": -0.19881638884544373,
                "y": 0.002925500273704529,
                "z": -102.52787017822266
            },
            {
                "x": -0.21270504593849182,
                "y": 0.002918347716331482,
                "z": -102.3714370727539
            },
            {
                "x": -0.22643119096755981,
                "y": 0.0029111839830875397,
                "z": -102.21502685546875
            },
            {
                "x": -0.23999157547950745,
                "y": 0.0029040053486824036,
                "z": -102.05859375
            },
            {
                "x": -0.25337713956832886,
                "y": 0.0028968602418899536,
                "z": -101.90216064453125
            },
            {
                "x": -0.26659566164016724,
                "y": 0.0028896890580654144,
                "z": -101.74552154541016
            },
            {
                "x": -0.27959829568862915,
                "y": 0.0028825178742408752,
                "z": -101.58907318115234
            },
            {
                "x": -0.29241055250167847,
                "y": 0.002875354140996933,
                "z": -101.43255615234375
            },
            {
                "x": -0.3050217628479004,
                "y": 0.002868194133043289,
                "z": -101.27603912353516
            },
            {
                "x": -0.31741803884506226,
                "y": 0.002861037850379944,
                "z": -101.11956787109375
            },
            {
                "x": -0.32960978150367737,
                "y": 0.002853870391845703,
                "z": -100.96288299560547
            },
            {
                "x": -0.3415682315826416,
                "y": 0.0028467029333114624,
                "z": -100.80638122558594
            },
            {
                "x": -0.3533101975917816,
                "y": 0.00283953920006752,
                "z": -100.64986419677734
            },
            {
                "x": -0.36483466625213623,
                "y": 0.002832382917404175,
                "z": -100.49322509765625
            },
            {
                "x": -0.3761166036128998,
                "y": 0.002825208008289337,
                "z": -100.33668518066406
            },
            {
                "x": -0.38717833161354065,
                "y": 0.0028180554509162903,
                "z": -100.18002319335938
            },
            {
                "x": -0.3980119228363037,
                "y": 0.0028108730912208557,
                "z": -100.02335357666016
            },
            {
                "x": -0.4086056351661682,
                "y": 0.0028037168085575104,
                "z": -99.86677551269531
            },
            {
                "x": -0.4189600944519043,
                "y": 0.002796553075313568,
                "z": -99.71007537841797
            },
            {
                "x": -0.42907625436782837,
                "y": 0.002789381891489029,
                "z": -99.553466796875
            },
            {
                "x": -0.4389573335647583,
                "y": 0.0027822330594062805,
                "z": -99.39682006835938
            },
            {
                "x": -0.44861435890197754,
                "y": 0.0027750469744205475,
                "z": -99.239990234375
            },
            {
                "x": -0.45801445841789246,
                "y": 0.002767898142337799,
                "z": -99.08334350585938
            },
            {
                "x": -0.46717819571495056,
                "y": 0.002760734409093857,
                "z": -98.92667388916016
            },
            {
                "x": -0.47297611832618713,
                "y": 0.0027560852468013763,
                "z": -98.82547760009766
            },
            {
                "x": -0.4817456007003784,
                "y": 0.0027488917112350464,
                "z": -98.66878509521484
            },
            {
                "x": -0.49028465151786804,
                "y": 0.0027417391538619995,
                "z": -98.51197814941406
            },
            {
                "x": -0.4985867142677307,
                "y": 0.0027345791459083557,
                "z": -98.35516357421875
            },
            {
                "x": -0.5066478848457336,
                "y": 0.0027274154126644135,
                "z": -98.19843292236328
            },
            {
                "x": -0.5144718885421753,
                "y": 0.0027202479541301727,
                "z": -98.04157257080078
            },
            {
                "x": -0.5220540165901184,
                "y": 0.0027285090181976557,
                "z": -97.88481903076172
            },
            {
                "x": -0.5294052958488464,
                "y": 0.0028679100796580315,
                "z": -97.72805786132812
            },
            {
                "x": -0.5365346670150757,
                "y": 0.0031739287078380585,
                "z": -97.5710678100586
            },
            {
                "x": -0.5434127449989319,
                "y": 0.00364895723760128,
                "z": -97.41427612304688
            },
            {
                "x": -0.5500625371932983,
                "y": 0.004285147413611412,
                "z": -97.2574234008789
            },
            {
                "x": -0.5564854145050049,
                "y": 0.0050775883719325066,
                "z": -97.10054016113281
            },
            {
                "x": -0.5626782178878784,
                "y": 0.0060224393382668495,
                "z": -96.94371795654297
            },
            {
                "x": -0.5686423182487488,
                "y": 0.007123860530555248,
                "z": -96.78668212890625
            },
            {
                "x": -0.5743737816810608,
                "y": 0.008371694013476372,
                "z": -96.62983703613281
            },
            {
                "x": -0.5798820853233337,
                "y": 0.009762074798345566,
                "z": -96.47299194335938
            },
            {
                "x": -0.5851700305938721,
                "y": 0.011293033137917519,
                "z": -96.3160171508789
            },
            {
                "x": -0.590228259563446,
                "y": 0.012963786721229553,
                "z": -96.15914916992188
            },
            {
                "x": -0.595069169998169,
                "y": 0.014770008623600006,
                "z": -96.00218200683594
            },
            {
                "x": -0.5996916890144348,
                "y": 0.016705796122550964,
                "z": -95.84518432617188
            },
            {
                "x": -0.6040968894958496,
                "y": 0.01876622438430786,
                "z": -95.68829345703125
            },
            {
                "x": -0.6082815527915955,
                "y": 0.02095317840576172,
                "z": -95.53140258789062
            },
            {
                "x": -0.6122484803199768,
                "y": 0.023261189460754395,
                "z": -95.37449645996094
            },
            {
                "x": -0.6160048842430115,
                "y": 0.025685090571641922,
                "z": -95.21757507324219
            },
            {
                "x": -0.6195564866065979,
                "y": 0.028224635869264603,
                "z": -95.06045532226562
            },
            {
                "x": -0.622887372970581,
                "y": 0.030873503535985947,
                "z": -94.90353393554688
            },
            {
                "x": -0.626011848449707,
                "y": 0.033630818128585815,
                "z": -94.7465591430664
            },
            {
                "x": -0.6289317607879639,
                "y": 0.036490295082330704,
                "z": -94.58958435058594
            },
            {
                "x": -0.6316487789154053,
                "y": 0.03944779559969902,
                "z": -94.43265533447266
            },
            {
                "x": -0.6341637372970581,
                "y": 0.04250757396221161,
                "z": -94.2755126953125
            },
            {
                "x": -0.6364684104919434,
                "y": 0.045657455921173096,
                "z": -94.11858367919922
            },
            {
                "x": -0.6385761499404907,
                "y": 0.04889611527323723,
                "z": -93.96163177490234
            },
            {
                "x": -0.6404874324798584,
                "y": 0.052222661674022675,
                "z": -93.80457305908203
            },
            {
                "x": -0.6421994566917419,
                "y": 0.05563078075647354,
                "z": -93.64762878417969
            },
            {
                "x": -0.643717885017395,
                "y": 0.059121500700712204,
                "z": -93.4906005859375
            },
            {
                "x": -0.645043671131134,
                "y": 0.0626876950263977,
                "z": -93.33354187011719
            },
            {
                "x": -0.6461790204048157,
                "y": 0.06632363796234131,
                "z": -93.17658996582031
            },
            {
                "x": -0.647117555141449,
                "y": 0.07003197818994522,
                "z": -93.01952362060547
            },
            {
                "x": -0.6478655338287354,
                "y": 0.07380446046590805,
                "z": -92.86258697509766
            },
            {
                "x": -0.6484184265136719,
                "y": 0.07763809710741043,
                "z": -92.70565795898438
            },
            {
                "x": -0.6487494707107544,
                "y": 0.0815337598323822,
                "z": -92.54857635498047
            },
            {
                "x": -0.6487724781036377,
                "y": 0.08547879010438919,
                "z": -92.39179229736328
            },
            {
                "x": -0.6484112739562988,
                "y": 0.08947327733039856,
                "z": -92.23514556884766
            },
            {
                "x": -0.6479368209838867,
                "y": 0.0920787900686264,
                "z": -92.13400268554688
            },
            {
                "x": -0.6467908620834351,
                "y": 0.0961507260799408,
                "z": -91.97740936279297
            },
            {
                "x": -0.6450989246368408,
                "y": 0.10026931762695312,
                "z": -91.82077026367188
            },
            {
                "x": -0.6428926587104797,
                "y": 0.10442756861448288,
                "z": -91.66415405273438
            },
            {
                "x": -0.6401641368865967,
                "y": 0.10862001776695251,
                "z": -91.50763702392578
            },
            {
                "x": -0.6369082927703857,
                "y": 0.11284942924976349,
                "z": -91.35102081298828
            },
            {
                "x": -0.6330868601799011,
                "y": 0.11710746586322784,
                "z": -91.19450378417969
            },
            {
                "x": -0.6287333965301514,
                "y": 0.12139169871807098,
                "z": -91.03804016113281
            },
            {
                "x": -0.6238386034965515,
                "y": 0.1257045567035675,
                "z": -90.88138580322266
            },
            {
                "x": -0.618415892124176,
                "y": 0.13003140687942505,
                "z": -90.72496795654297
            },
            {
                "x": -0.6124350428581238,
                "y": 0.13437798619270325,
                "z": -90.5684814453125
            },
            {
                "x": -0.6059062480926514,
                "y": 0.1387377381324768,
                "z": -90.41202545166016
            },
            {
                "x": -0.598840057849884,
                "y": 0.14310556650161743,
                "z": -90.25565338134766
            },
            {
                "x": -0.5912138223648071,
                "y": 0.14748568832874298,
                "z": -90.0990982055664
            },
            {
                "x": -0.5830338001251221,
                "y": 0.15186284482479095,
                "z": -89.94279479980469
            },
            {
                "x": -0.5743157863616943,
                "y": 0.15623949468135834,
                "z": -89.78652954101562
            },
            {
                "x": -0.5650451183319092,
                "y": 0.16061589121818542,
                "z": -89.63016510009766
            },
            {
                "x": -0.5552442669868469,
                "y": 0.16498209536075592,
                "z": -89.47394561767578
            },
            {
                "x": -0.5448579788208008,
                "y": 0.16934016346931458,
                "z": -89.31765747070312
            },
            {
                "x": -0.5339276790618896,
                "y": 0.17368410527706146,
                "z": -89.16141510009766
            },
            {
                "x": -0.5224630236625671,
                "y": 0.17800816893577576,
                "z": -89.00528717041016
            },
            {
                "x": -0.510453462600708,
                "y": 0.1823112815618515,
                "z": -88.8492202758789
            },
            {
                "x": -0.4978850781917572,
                "y": 0.1865893006324768,
                "z": -88.69319915771484
            },
            {
                "x": -0.48477989435195923,
                "y": 0.1908397376537323,
                "z": -88.53719329833984
            },
            {
                "x": -0.4711170196533203,
                "y": 0.1950642168521881,
                "z": -88.38106536865234
            },
            {
                "x": -0.45694032311439514,
                "y": 0.19924935698509216,
                "z": -88.22515106201172
            },
            {
                "x": -0.4422032833099365,
                "y": 0.20339685678482056,
                "z": -88.06922149658203
            },
            {
                "x": -0.42693448066711426,
                "y": 0.20750239491462708,
                "z": -87.9133529663086
            },
            {
                "x": -0.411148339509964,
                "y": 0.21156200766563416,
                "z": -87.75758361816406
            },
            {
                "x": -0.3948211669921875,
                "y": 0.21557870507240295,
                "z": -87.60165405273438
            },
            {
                "x": -0.3779725134372711,
                "y": 0.21953648328781128,
                "z": -87.44599151611328
            },
            {
                "x": -0.36060869693756104,
                "y": 0.22343900799751282,
                "z": -87.29036712646484
            },
            {
                "x": -0.34272465109825134,
                "y": 0.22728610038757324,
                "z": -87.13469696044922
            },
            {
                "x": -0.32435131072998047,
                "y": 0.23106873035430908,
                "z": -86.97915649414062
            },
            {
                "x": -0.3054537773132324,
                "y": 0.23478546738624573,
                "z": -86.82360076904297
            },
            {
                "x": -0.286063015460968,
                "y": 0.23843300342559814,
                "z": -86.6680908203125
            },
            {
                "x": -0.2661975622177124,
                "y": 0.24200619757175446,
                "z": -86.5127182006836
            },
            {
                "x": -0.24584180116653442,
                "y": 0.24550603330135345,
                "z": -86.35730743408203
            },
            {
                "x": -0.22501830756664276,
                "y": 0.2489221692085266,
                "z": -86.2020263671875
            },
            {
                "x": -0.20373187959194183,
                "y": 0.2522544264793396,
                "z": -86.04682159423828
            },
            {
                "x": -0.18196022510528564,
                "y": 0.255504846572876,
                "z": -85.89146423339844
            },
            {
                "x": -0.15977326035499573,
                "y": 0.25866201519966125,
                "z": -85.73635864257812
            },
            {
                "x": -0.137142151594162,
                "y": 0.2617235481739044,
                "z": -85.5812759399414
            },
            {
                "x": -0.1222941055893898,
                "y": 0.2636488676071167,
                "z": -85.48114776611328
            },
            {
                "x": -0.09896811842918396,
                "y": 0.26655012369155884,
                "z": -85.32615661621094
            },
            {
                "x": -0.07521219551563263,
                "y": 0.26934897899627686,
                "z": -85.17111206054688
            },
            {
                "x": -0.05104948580265045,
                "y": 0.27203935384750366,
                "z": -85.01612854003906
            },
            {
                "x": -0.026520177721977234,
                "y": 0.2746192216873169,
                "z": -84.86127471923828
            },
            {
                "x": -0.0016047731041908264,
                "y": 0.2770889401435852,
                "z": -84.70635986328125
            },
            {
                "x": 0.023660898208618164,
                "y": 0.27943867444992065,
                "z": -84.55160522460938
            },
            {
                "x": 0.04928357154130936,
                "y": 0.28166574239730835,
                "z": -84.39688873291016
            },
            {
                "x": 0.07527294009923935,
                "y": 0.2837727665901184,
                "z": -84.24199676513672
            },
            {
                "x": 0.10154349356889725,
                "y": 0.2857511639595032,
                "z": -84.08734893798828
            },
            {
                "x": 0.1281312108039856,
                "y": 0.28759855031967163,
                "z": -83.93267822265625
            },
            {
                "x": 0.1550198793411255,
                "y": 0.2893086075782776,
                "z": -83.77803802490234
            },
            {
                "x": 0.18217021226882935,
                "y": 0.2908814549446106,
                "z": -83.62348937988281
            },
            {
                "x": 0.20961007475852966,
                "y": 0.2923163175582886,
                "z": -83.46876525878906
            },
            {
                "x": 0.23726175725460052,
                "y": 0.29360389709472656,
                "z": -83.31423950195312
            },
            {
                "x": 0.2651490569114685,
                "y": 0.2947394847869873,
                "z": -83.15975952148438
            },
            {
                "x": 0.29326143860816956,
                "y": 0.2957254648208618,
                "z": -83.00518035888672
            },
            {
                "x": 0.32154566049575806,
                "y": 0.2965570092201233,
                "z": -82.85072326660156
            },
            {
                "x": 0.3500208258628845,
                "y": 0.29722973704338074,
                "z": -82.69617462158203
            },
            {
                "x": 0.37865936756134033,
                "y": 0.2977357506752014,
                "z": -82.5416488647461
            },
            {
                "x": 0.4074156880378723,
                "y": 0.2980771064758301,
                "z": -82.38719940185547
            },
            {
                "x": 0.4362877905368805,
                "y": 0.29817068576812744,
                "z": -82.23277282714844
            },
            {
                "x": 0.46526333689689636,
                "y": 0.29780495166778564,
                "z": -82.07833099365234
            },
            {
                "x": 0.4943193793296814,
                "y": 0.29694968461990356,
                "z": -81.92387390136719
            },
            {
                "x": 0.5234698057174683,
                "y": 0.2956305742263794,
                "z": -81.76923370361328
            },
            {
                "x": 0.5526278614997864,
                "y": 0.29385942220687866,
                "z": -81.61476135253906
            },
            {
                "x": 0.5818111300468445,
                "y": 0.29163962602615356,
                "z": -81.4602279663086
            },
            {
                "x": 0.6109984517097473,
                "y": 0.2889667749404907,
                "z": -81.3056869506836
            },
            {
                "x": 0.6401509046554565,
                "y": 0.28586891293525696,
                "z": -81.15116882324219
            },
            {
                "x": 0.6693017482757568,
                "y": 0.2823495864868164,
                "z": -80.99644470214844
            },
            {
                "x": 0.6983546018600464,
                "y": 0.2784240245819092,
                "z": -80.84188842773438
            },
            {
                "x": 0.7273254990577698,
                "y": 0.2740820348262787,
                "z": -80.68730926513672
            },
            {
                "x": 0.7562183737754822,
                "y": 0.2693464159965515,
                "z": -80.5325698852539
            },
            {
                "x": 0.7849647402763367,
                "y": 0.2642330527305603,
                "z": -80.3779067993164
            },
            {
                "x": 0.81358402967453,
                "y": 0.258743017911911,
                "z": -80.22312927246094
            },
            {
                "x": 0.842033326625824,
                "y": 0.2528722286224365,
                "z": -80.06829833984375
            },
            {
                "x": 0.8702784776687622,
                "y": 0.24665120244026184,
                "z": -79.91352081298828
            },
            {
                "x": 0.8983421325683594,
                "y": 0.24008038640022278,
                "z": -79.75859069824219
            },
            {
                "x": 0.9261615872383118,
                "y": 0.23317715525627136,
                "z": -79.60372924804688
            },
            {
                "x": 0.9537279009819031,
                "y": 0.2259301394224167,
                "z": -79.44880676269531
            },
            {
                "x": 0.9810667634010315,
                "y": 0.2183550000190735,
                "z": -79.29364776611328
            },
            {
                "x": 1.0080877542495728,
                "y": 0.21047915518283844,
                "z": -79.13862609863281
            },
            {
                "x": 1.0348045825958252,
                "y": 0.20230257511138916,
                "z": -78.98356628417969
            },
            {
                "x": 1.0518864393234253,
                "y": 0.19685319066047668,
                "z": -78.88335418701172
            },
            {
                "x": 1.0780621767044067,
                "y": 0.18818889558315277,
                "z": -78.7281723022461
            },
            {
                "x": 1.1039036512374878,
                "y": 0.17924141883850098,
                "z": -78.57283020019531
            },
            {
                "x": 1.129369854927063,
                "y": 0.17001588642597198,
                "z": -78.41741943359375
            },
            {
                "x": 1.1544302701950073,
                "y": 0.1605311781167984,
                "z": -78.26203918457031
            },
            {
                "x": 1.1791038513183594,
                "y": 0.15078824758529663,
                "z": -78.10649871826172
            },
            {
                "x": 1.203340768814087,
                "y": 0.1408098191022873,
                "z": -77.95099639892578
            },
            {
                "x": 1.227134346961975,
                "y": 0.13059011101722717,
                "z": -77.79540252685547
            },
            {
                "x": 1.2505011558532715,
                "y": 0.12012739479541779,
                "z": -77.63955688476562
            },
            {
                "x": 1.27336847782135,
                "y": 0.10946233570575714,
                "z": -77.48384857177734
            },
            {
                "x": 1.2957655191421509,
                "y": 0.09858544170856476,
                "z": -77.32801818847656
            },
            {
                "x": 1.317658543586731,
                "y": 0.08750440180301666,
                "z": -77.1720962524414
            },
            {
                "x": 1.339022159576416,
                "y": 0.07623238861560822,
                "z": -77.01616668701172
            },
            {
                "x": 1.3598957061767578,
                "y": 0.06476430594921112,
                "z": -76.85997009277344
            },
            {
                "x": 1.3802094459533691,
                "y": 0.05313802510499954,
                "z": -76.70388793945312
            },
            {
                "x": 1.3999669551849365,
                "y": 0.04134655371308327,
                "z": -76.5477523803711
            },
            {
                "x": 1.4191572666168213,
                "y": 0.029385831207036972,
                "z": -76.39142608642578
            },
            {
                "x": 1.4377729892730713,
                "y": 0.017287038266658783,
                "z": -76.23513793945312
            },
            {
                "x": 1.4558240175247192,
                "y": 0.005043587181717157,
                "z": -76.07868957519531
            },
            {
                "x": 1.4732797145843506,
                "y": -0.007329678162932396,
                "z": -75.92217254638672
            },
            {
                "x": 1.490098476409912,
                "y": -0.01981998234987259,
                "z": -75.76567840576172
            },
            {
                "x": 1.5063146352767944,
                "y": -0.032419782131910324,
                "z": -75.60916900634766
            },
            {
                "x": 1.5219210386276245,
                "y": -0.0451224148273468,
                "z": -75.45255279541016
            },
            {
                "x": 1.536901831626892,
                "y": -0.05791812762618065,
                "z": -75.29588317871094
            },
            {
                "x": 1.551242470741272,
                "y": -0.07081794738769531,
                "z": -75.13896179199219
            },
            {
                "x": 1.5649305582046509,
                "y": -0.08377772569656372,
                "z": -74.98217010498047
            },
            {
                "x": 1.5779845714569092,
                "y": -0.09680743515491486,
                "z": -74.82527923583984
            },
            {
                "x": 1.5903890132904053,
                "y": -0.10989457368850708,
                "z": -74.66834259033203
            },
            {
                "x": 1.6021114587783813,
                "y": -0.12302805483341217,
                "z": -74.51140594482422
            },
            {
                "x": 1.6131885051727295,
                "y": -0.13621866703033447,
                "z": -74.35420989990234
            },
            {
                "x": 1.6235932111740112,
                "y": -0.14942246675491333,
                "z": -74.19718170166016
            },
            {
                "x": 1.6333287954330444,
                "y": -0.1626487821340561,
                "z": -74.04010772705078
            },
            {
                "x": 1.6423892974853516,
                "y": -0.1758982539176941,
                "z": -73.88288116455078
            },
            {
                "x": 1.6507679224014282,
                "y": -0.18914203345775604,
                "z": -73.7257080078125
            },
            {
                "x": 1.6584771871566772,
                "y": -0.20238833129405975,
                "z": -73.56842803955078
            },
            {
                "x": 1.6655142307281494,
                "y": -0.21562236547470093,
                "z": -73.41108703613281
            },
            {
                "x": 1.6718661785125732,
                "y": -0.2288239598274231,
                "z": -73.25383758544922
            },
            {
                "x": 1.6775269508361816,
                "y": -0.24200111627578735,
                "z": -73.09645080566406
            },
            {
                "x": 1.6825084686279297,
                "y": -0.255129337310791,
                "z": -72.93914031982422
            },
            {
                "x": 1.6868213415145874,
                "y": -0.26820802688598633,
                "z": -72.78179168701172
            },
            {
                "x": 1.690455436706543,
                "y": -0.28124210238456726,
                "z": -72.62425231933594
            },
            {
                "x": 1.693380355834961,
                "y": -0.2941909730434418,
                "z": -72.46687316894531
            },
            {
                "x": 1.6956405639648438,
                "y": -0.307062566280365,
                "z": -72.30949401855469
            },
            {
                "x": 1.6967549324035645,
                "y": -0.31533515453338623,
                "z": -72.20780181884766
            },
            {
                "x": 1.697901964187622,
                "y": -0.3280584216117859,
                "z": -72.0503921508789
            },
            {
                "x": 1.6983771324157715,
                "y": -0.3406885862350464,
                "z": -71.89288330078125
            },
            {
                "x": 1.6981929540634155,
                "y": -0.35320863127708435,
                "z": -71.73536682128906
            },
            {
                "x": 1.6973450183868408,
                "y": -0.365602970123291,
                "z": -71.57794189453125
            },
            {
                "x": 1.6957920789718628,
                "y": -0.3778757154941559,
                "z": -71.42037963867188
            },
            {
                "x": 1.6935566663742065,
                "y": -0.390002965927124,
                "z": -71.26290893554688
            },
            {
                "x": 1.690625548362732,
                "y": -0.4019860625267029,
                "z": -71.10543060302734
            },
            {
                "x": 1.6869776248931885,
                "y": -0.4138317108154297,
                "z": -70.94774627685547
            },
            {
                "x": 1.682599425315857,
                "y": -0.4254951775074005,
                "z": -70.79025268554688
            },
            {
                "x": 1.6774721145629883,
                "y": -0.43698781728744507,
                "z": -70.63269805908203
            },
            {
                "x": 1.671592116355896,
                "y": -0.44830164313316345,
                "z": -70.47513580322266
            },
            {
                "x": 1.664955496788025,
                "y": -0.45942169427871704,
                "z": -70.3176498413086
            },
            {
                "x": 1.6575191020965576,
                "y": -0.4703531265258789,
                "z": -70.15995788574219
            },
            {
                "x": 1.649276614189148,
                "y": -0.4810580015182495,
                "z": -70.00248718261719
            },
            {
                "x": 1.6402307748794556,
                "y": -0.4915463328361511,
                "z": -69.84504699707031
            },
            {
                "x": 1.630361557006836,
                "y": -0.5018182396888733,
                "z": -69.68748474121094
            },
            {
                "x": 1.619651436805725,
                "y": -0.5118448138237,
                "z": -69.53005981445312
            },
            {
                "x": 1.6080557107925415,
                "y": -0.5216255784034729,
                "z": -69.37259674072266
            },
            {
                "x": 1.595590591430664,
                "y": -0.5311547517776489,
                "z": -69.21514129638672
            },
            {
                "x": 1.5822535753250122,
                "y": -0.5404168367385864,
                "z": -69.05783081054688
            },
            {
                "x": 1.5680116415023804,
                "y": -0.549406111240387,
                "z": -68.90056610107422
            },
            {
                "x": 1.5528267621994019,
                "y": -0.55810546875,
                "z": -68.74337005615234
            },
            {
                "x": 1.5367106199264526,
                "y": -0.5665163993835449,
                "z": -68.58622741699219
            },
            {
                "x": 1.5196232795715332,
                "y": -0.5746408700942993,
                "z": -68.428955078125
            },
            {
                "x": 1.5015850067138672,
                "y": -0.5824459791183472,
                "z": -68.27196502685547
            },
            {
                "x": 1.482523798942566,
                "y": -0.5899257659912109,
                "z": -68.114990234375
            },
            {
                "x": 1.4624651670455933,
                "y": -0.5970811247825623,
                "z": -67.95812225341797
            },
            {
                "x": 1.4413959980010986,
                "y": -0.6039007902145386,
                "z": -67.80140686035156
            },
            {
                "x": 1.4192588329315186,
                "y": -0.6103855967521667,
                "z": -67.64459228515625
            },
            {
                "x": 1.3960503339767456,
                "y": -0.6164951324462891,
                "z": -67.48812103271484
            },
            {
                "x": 1.3717793226242065,
                "y": -0.6222443580627441,
                "z": -67.3317642211914
            },
            {
                "x": 1.34640371799469,
                "y": -0.6276291608810425,
                "z": -67.17544555664062
            },
            {
                "x": 1.3199455738067627,
                "y": -0.6326314210891724,
                "z": -67.01939392089844
            },
            {
                "x": 1.2922866344451904,
                "y": -0.6372319459915161,
                "z": -66.86341094970703
            },
            {
                "x": 1.263487696647644,
                "y": -0.6414368748664856,
                "z": -66.70759582519531
            },
            {
                "x": 1.2335582971572876,
                "y": -0.6452349424362183,
                "z": -66.55208587646484
            },
            {
                "x": 1.202439308166504,
                "y": -0.6486231088638306,
                "z": -66.39666748046875
            },
            {
                "x": 1.170089602470398,
                "y": -0.6515707969665527,
                "z": -66.2416000366211
            },
            {
                "x": 1.1365400552749634,
                "y": -0.6541820764541626,
                "z": -66.08673858642578
            },
            {
                "x": 1.1017268896102905,
                "y": -0.6565240025520325,
                "z": -65.93193817138672
            },
            {
                "x": 1.0657232999801636,
                "y": -0.6585845947265625,
                "z": -65.77760314941406
            },
            {
                "x": 1.0284756422042847,
                "y": -0.660347580909729,
                "z": -65.62351989746094
            },
            {
                "x": 1.0036611557006836,
                "y": -0.661333441734314,
                "z": -65.52418518066406
            },
            {
                "x": 0.9642982482910156,
                "y": -0.6626193523406982,
                "z": -65.3706283569336
            },
            {
                "x": 0.9235832095146179,
                "y": -0.6635957360267639,
                "z": -65.21731567382812
            },
            {
                "x": 0.8815579414367676,
                "y": -0.6642613410949707,
                "z": -65.0643081665039
            },
            {
                "x": 0.8382659554481506,
                "y": -0.6646146774291992,
                "z": -64.91175842285156
            },
            {
                "x": 0.7936466932296753,
                "y": -0.664650559425354,
                "z": -64.75948333740234
            },
            {
                "x": 0.7477116584777832,
                "y": -0.6643580794334412,
                "z": -64.60771179199219
            },
            {
                "x": 0.7004366517066956,
                "y": -0.6637475490570068,
                "z": -64.45633697509766
            },
            {
                "x": 0.651792049407959,
                "y": -0.6628286838531494,
                "z": -64.30517578125
            },
            {
                "x": 0.6019117832183838,
                "y": -0.6616097688674927,
                "z": -64.15463256835938
            },
            {
                "x": 0.5506478548049927,
                "y": -0.6600858569145203,
                "z": -64.00452423095703
            },
            {
                "x": 0.498070627450943,
                "y": -0.6582673192024231,
                "z": -63.8548583984375
            },
            {
                "x": 0.44423437118530273,
                "y": -0.6561661958694458,
                "z": -63.70573425292969
            },
            {
                "x": 0.38903525471687317,
                "y": -0.6537846326828003,
                "z": -63.55689239501953
            },
            {
                "x": 0.33262699842453003,
                "y": -0.6511267423629761,
                "z": -63.40873336791992
            },
            {
                "x": 0.27494803071022034,
                "y": -0.6481987833976746,
                "z": -63.261104583740234
            },
            {
                "x": 0.2160150557756424,
                "y": -0.6450089812278748,
                "z": -63.113861083984375
            },
            {
                "x": 0.1559484302997589,
                "y": -0.6415693759918213,
                "z": -62.967281341552734
            },
            {
                "x": 0.09465304017066956,
                "y": -0.6378731727600098,
                "z": -62.821083068847656
            },
            {
                "x": 0.03222799301147461,
                "y": -0.6339317560195923,
                "z": -62.67546081542969
            },
            {
                "x": -0.031222540885210037,
                "y": -0.6297578811645508,
                "z": -62.530426025390625
            },
            {
                "x": -0.09570121765136719,
                "y": -0.6253559589385986,
                "z": -62.38589859008789
            },
            {
                "x": -0.16114728152751923,
                "y": -0.6207273006439209,
                "z": -62.24189758300781
            },
            {
                "x": -0.2275257110595703,
                "y": -0.6158769726753235,
                "z": -62.09838104248047
            },
            {
                "x": -0.29481783509254456,
                "y": -0.6108107566833496,
                "z": -61.955162048339844
            },
            {
                "x": -0.3627738058567047,
                "y": -0.6055475473403931,
                "z": -61.812583923339844
            },
            {
                "x": -0.4314519762992859,
                "y": -0.6000808477401733,
                "z": -61.670379638671875
            },
            {
                "x": -0.5007177591323853,
                "y": -0.5944177508354187,
                "z": -61.52859878540039
            },
            {
                "x": -0.5704469680786133,
                "y": -0.5885712504386902,
                "z": -61.38721466064453
            },
            {
                "x": -0.6406518816947937,
                "y": -0.5825377702713013,
                "z": -61.2459602355957
            },
            {
                "x": -0.7110363245010376,
                "y": -0.5763360261917114,
                "z": -61.10517883300781
            },
            {
                "x": -0.7815654873847961,
                "y": -0.5699621438980103,
                "z": -60.96463394165039
            },
            {
                "x": -0.8521616458892822,
                "y": -0.5634220838546753,
                "z": -60.82414627075195
            },
            {
                "x": -0.9225648641586304,
                "y": -0.5567324161529541,
                "z": -60.68387985229492
            },
            {
                "x": -0.9927501082420349,
                "y": -0.5498862266540527,
                "z": -60.543556213378906
            },
            {
                "x": -1.062474250793457,
                "y": -0.542892336845398,
                "z": -60.40321731567383
            },
            {
                "x": -1.1315429210662842,
                "y": -0.5357656478881836,
                "z": -60.262874603271484
            },
            {
                "x": -1.1998798847198486,
                "y": -0.52850341796875,
                "z": -60.12226104736328
            },
            {
                "x": -1.267191767692566,
                "y": -0.5211200714111328,
                "z": -59.981502532958984
            },
            {
                "x": -1.3332936763763428,
                "y": -0.5136144757270813,
                "z": -59.840423583984375
            },
            {
                "x": -1.3981086015701294,
                "y": -0.5059875249862671,
                "z": -59.698753356933594
            },
            {
                "x": -1.4612668752670288,
                "y": -0.4982652962207794,
                "z": -59.556800842285156
            },
            {
                "x": -1.522636890411377,
                "y": -0.4904446303844452,
                "z": -59.414306640625
            },
            {
                "x": -1.5611556768417358,
                "y": -0.48534098267555237,
                "z": -59.321929931640625
            },
            {
                "x": -1.6190612316131592,
                "y": -0.47737208008766174,
                "z": -59.17837905883789
            },
            {
                "x": -1.6748778820037842,
                "y": -0.46930110454559326,
                "z": -59.033748626708984
            },
            {
                "x": -1.729101538658142,
                "y": -0.4611104726791382,
                "z": -58.88786315917969
            },
            {
                "x": -1.7820552587509155,
                "y": -0.4528345763683319,
                "z": -58.74138641357422
            },
            {
                "x": -1.8338371515274048,
                "y": -0.44447746872901917,
                "z": -58.59432601928711
            },
            {
                "x": -1.8844069242477417,
                "y": -0.4360574185848236,
                "z": -58.446929931640625
            },
            {
                "x": -1.933790922164917,
                "y": -0.42757198214530945,
                "z": -58.299102783203125
            },
            {
                "x": -1.982115626335144,
                "y": -0.41901731491088867,
                "z": -58.150665283203125
            },
            {
                "x": -2.0293049812316895,
                "y": -0.4104222059249878,
                "z": -58.002044677734375
            },
            {
                "x": -2.0754542350769043,
                "y": -0.4017786383628845,
                "z": -57.8530158996582
            },
            {
                "x": -2.120539665222168,
                "y": -0.3930937647819519,
                "z": -57.70363235473633
            },
            {
                "x": -2.1645889282226562,
                "y": -0.3843774199485779,
                "z": -57.55397033691406
            },
            {
                "x": -2.207714557647705,
                "y": -0.3756217062473297,
                "z": -57.40380859375
            },
            {
                "x": -2.2498300075531006,
                "y": -0.3668540418148041,
                "z": -57.2535400390625
            },
            {
                "x": -2.290977954864502,
                "y": -0.3580687940120697,
                "z": -57.10297775268555
            },
            {
                "x": -2.3312056064605713,
                "y": -0.34926676750183105,
                "z": -56.95205307006836
            },
            {
                "x": -2.370502471923828,
                "y": -0.34046441316604614,
                "z": -56.80096435546875
            },
            {
                "x": -2.4089372158050537,
                "y": -0.331656277179718,
                "z": -56.6495361328125
            },
            {
                "x": -2.4464786052703857,
                "y": -0.32285332679748535,
                "z": -56.497867584228516
            },
            {
                "x": -2.4831175804138184,
                "y": -0.3140614628791809,
                "z": -56.346065521240234
            },
            {
                "x": -2.5189034938812256,
                "y": -0.30517125129699707,
                "z": -56.19404602050781
            },
            {
                "x": -2.553861141204834,
                "y": -0.2961336374282837,
                "z": -56.04181671142578
            },
            {
                "x": -2.587984561920166,
                "y": -0.28695884346961975,
                "z": -55.889400482177734
            },
            {
                "x": -2.6213133335113525,
                "y": -0.2776409387588501,
                "z": -55.73659896850586
            },
            {
                "x": -2.6537952423095703,
                "y": -0.2682161331176758,
                "z": -55.58381271362305
            },
            {
                "x": -2.685506582260132,
                "y": -0.25867682695388794,
                "z": -55.430809020996094
            },
            {
                "x": -2.7164225578308105,
                "y": -0.24903400242328644,
                "z": -55.27764892578125
            },
            {
                "x": -2.7465262413024902,
                "y": -0.2392956167459488,
                "z": -55.124366760253906
            },
            {
                "x": -2.7759125232696533,
                "y": -0.2294582724571228,
                "z": -54.970733642578125
            },
            {
                "x": -2.804499626159668,
                "y": -0.21955546736717224,
                "z": -54.81715774536133
            },
            {
                "x": -2.8323378562927246,
                "y": -0.2095814347267151,
                "z": -54.66343307495117
            },
            {
                "x": -2.859426975250244,
                "y": -0.1995358169078827,
                "z": -54.509464263916016
            },
            {
                "x": -2.885758638381958,
                "y": -0.1894432157278061,
                "z": -54.355464935302734
            },
            {
                "x": -2.9113881587982178,
                "y": -0.17929843068122864,
                "z": -54.20124435424805
            },
            {
                "x": -2.9362876415252686,
                "y": -0.16911616921424866,
                "z": -54.046905517578125
            },
            {
                "x": -2.96042799949646,
                "y": -0.15890906751155853,
                "z": -53.89253616333008
            },
            {
                "x": -2.9838716983795166,
                "y": -0.14867454767227173,
                "z": -53.73795700073242
            },
            {
                "x": -3.006591320037842,
                "y": -0.13843300938606262,
                "z": -53.5833625793457
            },
            {
                "x": -3.028616428375244,
                "y": -0.12818725407123566,
                "z": -53.428672790527344
            },
            {
                "x": -3.049936056137085,
                "y": -0.11793104559183121,
                "z": -53.2736701965332
            },
            {
                "x": -3.0705368518829346,
                "y": -0.10769770294427872,
                "z": -53.11876678466797
            },
            {
                "x": -3.0904436111450195,
                "y": -0.09698028862476349,
                "z": -52.963768005371094
            },
            {
                "x": -3.1029398441314697,
                "y": -0.08940944075584412,
                "z": -52.86362838745117
            },
            {
                "x": -3.121680498123169,
                "y": -0.07666724920272827,
                "z": -52.7086296081543
            },
            {
                "x": -3.1397461891174316,
                "y": -0.06280632317066193,
                "z": -52.553531646728516
            },
            {
                "x": -3.157118320465088,
                "y": -0.04792962223291397,
                "z": -52.39846420288086
            },
            {
                "x": -3.1737875938415527,
                "y": -0.03211888298392296,
                "z": -52.243492126464844
            },
            {
                "x": -3.189764976501465,
                "y": -0.015448426827788353,
                "z": -52.08844757080078
            },
            {
                "x": -3.2050604820251465,
                "y": 0.00194571353495121,
                "z": -51.93349838256836
            },
            {
                "x": -3.219677209854126,
                "y": 0.019981728866696358,
                "z": -51.7785758972168
            },
            {
                "x": -3.233644962310791,
                "y": 0.03859800845384598,
                "z": -51.62345504760742
            },
            {
                "x": -3.2468912601470947,
                "y": 0.057666629552841187,
                "z": -51.46853256225586
            },
            {
                "x": -3.259488344192505,
                "y": 0.07710978388786316,
                "z": -51.31353759765625
            },
            {
                "x": -3.2714149951934814,
                "y": 0.09682749211788177,
                "z": -51.15853500366211
            },
            {
                "x": -3.282683849334717,
                "y": 0.11672545969486237,
                "z": -51.003562927246094
            },
            {
                "x": -3.293274402618408,
                "y": 0.13674785196781158,
                "z": -50.84835433959961
            },
            {
                "x": -3.3031957149505615,
                "y": 0.1567462831735611,
                "z": -50.69331359863281
            },
            {
                "x": -3.3124547004699707,
                "y": 0.176658496260643,
                "z": -50.53821563720703
            },
            {
                "x": -3.3210654258728027,
                "y": 0.19640693068504333,
                "z": -50.38296127319336
            },
            {
                "x": -3.3290019035339355,
                "y": 0.21587114036083221,
                "z": -50.22773742675781
            },
            {
                "x": -3.336266279220581,
                "y": 0.23497645556926727,
                "z": -50.07234573364258
            },
            {
                "x": -3.3428776264190674,
                "y": 0.2536301612854004,
                "z": -49.9168701171875
            },
            {
                "x": -3.3488211631774902,
                "y": 0.27173012495040894,
                "z": -49.761409759521484
            },
            {
                "x": -3.3541085720062256,
                "y": 0.289193332195282,
                "z": -49.605865478515625
            },
            {
                "x": -3.3587026596069336,
                "y": 0.3059007525444031,
                "z": -49.45021438598633
            },
            {
                "x": -3.3626363277435303,
                "y": 0.3217849135398865,
                "z": -49.29447555541992
            },
            {
                "x": -3.3659117221832275,
                "y": 0.33677566051483154,
                "z": -49.13842010498047
            },
            {
                "x": -3.36850905418396,
                "y": 0.35074061155319214,
                "z": -48.98247146606445
            },
            {
                "x": -3.370417594909668,
                "y": 0.3635612726211548,
                "z": -48.82636260986328
            },
            {
                "x": -3.371638298034668,
                "y": 0.3751751184463501,
                "z": -48.67017364501953
            },
            {
                "x": -3.3721280097961426,
                "y": 0.38548457622528076,
                "z": -48.51408004760742
            },
            {
                "x": -3.3716399669647217,
                "y": 0.3944072127342224,
                "z": -48.35796356201172
            },
            {
                "x": -3.3698158264160156,
                "y": 0.4017765522003174,
                "z": -48.20219421386719
            },
            {
                "x": -3.366589307785034,
                "y": 0.40761691331863403,
                "z": -48.04640579223633
            },
            {
                "x": -3.361894130706787,
                "y": 0.41264358162879944,
                "z": -47.890541076660156
            },
            {
                "x": -3.355715274810791,
                "y": 0.4166164994239807,
                "z": -47.73487091064453
            },
            {
                "x": -3.3479156494140625,
                "y": 0.419295072555542,
                "z": -47.57920837402344
            },
            {
                "x": -3.338489532470703,
                "y": 0.42078694701194763,
                "z": -47.42362594604492
            },
            {
                "x": -3.327430486679077,
                "y": 0.4211920499801636,
                "z": -47.26830291748047
            },
            {
                "x": -3.31466007232666,
                "y": 0.42059236764907837,
                "z": -47.113037109375
            },
            {
                "x": -3.3001081943511963,
                "y": 0.41904205083847046,
                "z": -46.95806121826172
            },
            {
                "x": -3.2837648391723633,
                "y": 0.4166414737701416,
                "z": -46.80329895019531
            },
            {
                "x": -3.2655932903289795,
                "y": 0.41348326206207275,
                "z": -46.64858627319336
            },
            {
                "x": -3.245614528656006,
                "y": 0.40965622663497925,
                "z": -46.494327545166016
            },
            {
                "x": -3.2237279415130615,
                "y": 0.4052218794822693,
                "z": -46.34034729003906
            },
            {
                "x": -3.2085824012756348,
                "y": 0.40207552909851074,
                "z": -46.24103927612305
            },
            {
                "x": -3.18363618850708,
                "y": 0.3968476951122284,
                "z": -46.08755111694336
            },
            {
                "x": -3.1567893028259277,
                "y": 0.3912353515625,
                "z": -45.934268951416016
            },
            {
                "x": -3.1280601024627686,
                "y": 0.3853219747543335,
                "z": -45.781314849853516
            },
            {
                "x": -3.0975496768951416,
                "y": 0.3792017698287964,
                "z": -45.62876892089844
            },
            {
                "x": -3.065265655517578,
                "y": 0.37294507026672363,
                "z": -45.4764404296875
            },
            {
                "x": -3.03128981590271,
                "y": 0.3666388690471649,
                "z": -45.32451629638672
            },
            {
                "x": -2.99564528465271,
                "y": 0.3603616952896118,
                "z": -45.17289733886719
            },
            {
                "x": -2.9584317207336426,
                "y": 0.35418426990509033,
                "z": -45.02134323120117
            },
            {
                "x": -2.919854164123535,
                "y": 0.3482000231742859,
                "z": -44.87022018432617
            },
            {
                "x": -2.8799540996551514,
                "y": 0.34247997403144836,
                "z": -44.719242095947266
            },
            {
                "x": -2.838853359222412,
                "y": 0.3371184468269348,
                "z": -44.56843948364258
            },
            {
                "x": -2.7967565059661865,
                "y": 0.332184374332428,
                "z": -44.41781997680664
            },
            {
                "x": -2.75374698638916,
                "y": 0.32774925231933594,
                "z": -44.267086029052734
            },
            {
                "x": -2.7100887298583984,
                "y": 0.32390958070755005,
                "z": -44.116573333740234
            },
            {
                "x": -2.6658904552459717,
                "y": 0.3207649290561676,
                "z": -43.96603775024414
            },
            {
                "x": -2.621307849884033,
                "y": 0.3183707892894745,
                "z": -43.81533432006836
            },
            {
                "x": -2.576571226119995,
                "y": 0.31681209802627563,
                "z": -43.66460418701172
            },
            {
                "x": -2.5317914485931396,
                "y": 0.31617575883865356,
                "z": -43.513648986816406
            },
            {
                "x": -2.487170457839966,
                "y": 0.3165873885154724,
                "z": -43.36248779296875
            },
            {
                "x": -2.4428887367248535,
                "y": 0.3180893659591675,
                "z": -43.21120071411133
            },
            {
                "x": -2.3990726470947266,
                "y": 0.32076501846313477,
                "z": -43.059669494628906
            },
            {
                "x": -2.3558645248413086,
                "y": 0.32435405254364014,
                "z": -42.907920837402344
            },
            {
                "x": -2.3134093284606934,
                "y": 0.32792943716049194,
                "z": -42.755855560302734
            },
            {
                "x": -2.2717387676239014,
                "y": 0.331409215927124,
                "z": -42.60329055786133
            },
            {
                "x": -2.2310521602630615,
                "y": 0.334781289100647,
                "z": -42.450584411621094
            },
            {
                "x": -2.19136381149292,
                "y": 0.33804765343666077,
                "z": -42.29750442504883
            },
            {
                "x": -2.152829170227051,
                "y": 0.34119847416877747,
                "z": -42.144046783447266
            },
            {
                "x": -2.1154661178588867,
                "y": 0.34423398971557617,
                "z": -41.99032974243164
            },
            {
                "x": -2.079266309738159,
                "y": 0.34715551137924194,
                "z": -41.83609390258789
            },
            {
                "x": -2.0443620681762695,
                "y": 0.34995192289352417,
                "z": -41.68172073364258
            },
            {
                "x": -2.010807514190674,
                "y": 0.35261762142181396,
                "z": -41.527042388916016
            },
            {
                "x": -1.9785313606262207,
                "y": 0.35515642166137695,
                "z": -41.37196731567383
            },
            {
                "x": -1.9475880861282349,
                "y": 0.35756099224090576,
                "z": -41.21673583984375
            },
            {
                "x": -1.9179508686065674,
                "y": 0.35983142256736755,
                "z": -41.06113052368164
            },
            {
                "x": -1.889703631401062,
                "y": 0.3619561195373535,
                "z": -40.90528106689453
            },
            {
                "x": -1.8627877235412598,
                "y": 0.3639359474182129,
                "z": -40.74931716918945
            },
            {
                "x": -1.8371613025665283,
                "y": 0.3657706379890442,
                "z": -40.59300994873047
            },
            {
                "x": -1.8128472566604614,
                "y": 0.3674542307853699,
                "z": -40.4366455078125
            },
            {
                "x": -1.7898540496826172,
                "y": 0.36897802352905273,
                "z": -40.28007507324219
            },
            {
                "x": -1.7681012153625488,
                "y": 0.37034571170806885,
                "z": -40.123172760009766
            },
            {
                "x": -1.747597098350525,
                "y": 0.371551513671875,
                "z": -39.9662971496582
            },
            {
                "x": -1.728276252746582,
                "y": 0.37259334325790405,
                "z": -39.8093147277832
            },
            {
                "x": -1.7165130376815796,
                "y": 0.3731720447540283,
                "z": -39.707820892333984
            },
            {
                "x": -1.6991826295852661,
                "y": 0.37393197417259216,
                "z": -39.55064010620117
            },
            {
                "x": -1.6829837560653687,
                "y": 0.3745200037956238,
                "z": -39.39325714111328
            },
            {
                "x": -1.6678961515426636,
                "y": 0.37492644786834717,
                "z": -39.2358283996582
            },
            {
                "x": -1.653814435005188,
                "y": 0.3751501441001892,
                "z": -39.078460693359375
            },
            {
                "x": -1.6408065557479858,
                "y": 0.37519174814224243,
                "z": -38.92071533203125
            },
            {
                "x": -1.6290059089660645,
                "y": 0.375049889087677,
                "z": -38.762969970703125
            },
            {
                "x": -1.6185245513916016,
                "y": 0.37472206354141235,
                "z": -38.605003356933594
            },
            {
                "x": -1.6095072031021118,
                "y": 0.3742120563983917,
                "z": -38.44663619995117
            },
            {
                "x": -1.602087378501892,
                "y": 0.373528391122818,
                "z": -38.28828811645508
            },
            {
                "x": -1.5963724851608276,
                "y": 0.3726731538772583,
                "z": -38.12972640991211
            },
            {
                "x": -1.5925228595733643,
                "y": 0.3716455101966858,
                "z": -37.971038818359375
            },
            {
                "x": -1.5906131267547607,
                "y": 0.3704504668712616,
                "z": -37.81233596801758
            },
            {
                "x": -1.590649962425232,
                "y": 0.36909306049346924,
                "z": -37.65338897705078
            },
            {
                "x": -1.5926694869995117,
                "y": 0.36758020520210266,
                "z": -37.494632720947266
            },
            {
                "x": -1.5967228412628174,
                "y": 0.3659103512763977,
                "z": -37.33592987060547
            },
            {
                "x": -1.6028021574020386,
                "y": 0.36408644914627075,
                "z": -37.17720031738281
            },
            {
                "x": -1.6108158826828003,
                "y": 0.36211830377578735,
                "z": -37.01870346069336
            },
            {
                "x": -1.6207313537597656,
                "y": 0.3600064814090729,
                "z": -36.860252380371094
            },
            {
                "x": -1.6325271129608154,
                "y": 0.3577534556388855,
                "z": -36.70198440551758
            },
            {
                "x": -1.6461286544799805,
                "y": 0.3553639054298401,
                "z": -36.54401397705078
            },
            {
                "x": -1.661422610282898,
                "y": 0.3528438210487366,
                "z": -36.386260986328125
            },
            {
                "x": -1.6783350706100464,
                "y": 0.3501964807510376,
                "z": -36.22873306274414
            },
            {
                "x": -1.6968146562576294,
                "y": 0.3474227786064148,
                "z": -36.071449279785156
            },
            {
                "x": -1.716819167137146,
                "y": 0.3445221781730652,
                "z": -35.914207458496094
            },
            {
                "x": -1.738180160522461,
                "y": 0.3415082097053528,
                "z": -35.757415771484375
            },
            {
                "x": -1.7608497142791748,
                "y": 0.3383801281452179,
                "z": -35.600807189941406
            },
            {
                "x": -1.7847734689712524,
                "y": 0.33513957262039185,
                "z": -35.4444465637207
            },
            {
                "x": -1.8098852634429932,
                "y": 0.33179062604904175,
                "z": -35.28839111328125
            },
            {
                "x": -1.836120843887329,
                "y": 0.3283337354660034,
                "z": -35.13235855102539
            },
            {
                "x": -1.8633497953414917,
                "y": 0.3247811794281006,
                "z": -34.97675704956055
            },
            {
                "x": -1.891564965248108,
                "y": 0.3211302161216736,
                "z": -34.821380615234375
            },
            {
                "x": -1.9207390546798706,
                "y": 0.3173796236515045,
                "z": -34.66610336303711
            },
            {
                "x": -1.9507548809051514,
                "y": 0.31354138255119324,
                "z": -34.51115036010742
            },
            {
                "x": -1.9815974235534668,
                "y": 0.30961355566978455,
                "z": -34.35630416870117
            },
            {
                "x": -2.013211488723755,
                "y": 0.3056004047393799,
                "z": -34.20164489746094
            },
            {
                "x": -2.045555353164673,
                "y": 0.30150550603866577,
                "z": -34.04726791381836
            },
            {
                "x": -2.078601598739624,
                "y": 0.297330379486084,
                "z": -33.89297103881836
            },
            {
                "x": -2.112264633178711,
                "y": 0.2930833697319031,
                "z": -33.738948822021484
            },
            {
                "x": -2.146538496017456,
                "y": 0.28876423835754395,
                "z": -33.58509826660156
            },
            {
                "x": -2.1814522743225098,
                "y": 0.28436827659606934,
                "z": -33.43119812011719
            },
            {
                "x": -2.2168643474578857,
                "y": 0.27991291880607605,
                "z": -33.277652740478516
            },
            {
                "x": -2.252786636352539,
                "y": 0.2753956913948059,
                "z": -33.1242561340332
            },
            {
                "x": -2.2762386798858643,
                "y": 0.27244648337364197,
                "z": -33.02527618408203
            },
            {
                "x": -2.3126823902130127,
                "y": 0.26784056425094604,
                "z": -32.87236404418945
            },
            {
                "x": -2.3488872051239014,
                "y": 0.2631838023662567,
                "z": -32.71959686279297
            },
            {
                "x": -2.3846778869628906,
                "y": 0.2584751844406128,
                "z": -32.566810607910156
            },
            {
                "x": -2.4199490547180176,
                "y": 0.25371772050857544,
                "z": -32.4140510559082
            },
            {
                "x": -2.4547102451324463,
                "y": 0.24891094863414764,
                "z": -32.261112213134766
            },
            {
                "x": -2.4888408184051514,
                "y": 0.2440648376941681,
                "z": -32.10820388793945
            },
            {
                "x": -2.5223026275634766,
                "y": 0.2391791045665741,
                "z": -31.955202102661133
            },
            {
                "x": -2.5550265312194824,
                "y": 0.2342493236064911,
                "z": -31.801895141601562
            },
            {
                "x": -2.5868794918060303,
                "y": 0.22929300367832184,
                "z": -31.648662567138672
            },
            {
                "x": -2.6178476810455322,
                "y": 0.2243051826953888,
                "z": -31.49525260925293
            },
            {
                "x": -2.6478397846221924,
                "y": 0.21929126977920532,
                "z": -31.341703414916992
            },
            {
                "x": -2.676727771759033,
                "y": 0.21425552666187286,
                "z": -31.18806266784668
            },
            {
                "x": -2.7045133113861084,
                "y": 0.20919407904148102,
                "z": -31.034069061279297
            },
            {
                "x": -2.7310664653778076,
                "y": 0.2041231393814087,
                "z": -30.880115509033203
            },
            {
                "x": -2.756359577178955,
                "y": 0.1990395188331604,
                "z": -30.72599220275879
            },
            {
                "x": -2.7803001403808594,
                "y": 0.1939428299665451,
                "z": -30.571584701538086
            },
            {
                "x": -2.8028299808502197,
                "y": 0.18884426355361938,
                "z": -30.4171199798584
            },
            {
                "x": -2.823951482772827,
                "y": 0.1837403029203415,
                "z": -30.262378692626953
            },
            {
                "x": -2.843615770339966,
                "y": 0.17863745987415314,
                "z": -30.107465744018555
            },
            {
                "x": -2.8617334365844727,
                "y": 0.17354267835617065,
                "z": -29.95247459411621
            },
            {
                "x": -2.8783273696899414,
                "y": 0.16845616698265076,
                "z": -29.797321319580078
            },
            {
                "x": -2.893413782119751,
                "y": 0.16338138282299042,
                "z": -29.642017364501953
            },
            {
                "x": -2.906994342803955,
                "y": 0.1583050638437271,
                "z": -29.486572265625
            },
            {
                "x": -2.9190454483032227,
                "y": 0.15237301588058472,
                "z": -29.330860137939453
            },
            {
                "x": -2.929576873779297,
                "y": 0.1451188027858734,
                "z": -29.175277709960938
            },
            {
                "x": -2.938666343688965,
                "y": 0.13664180040359497,
                "z": -29.019573211669922
            },
            {
                "x": -2.946342706680298,
                "y": 0.1270335614681244,
                "z": -28.863828659057617
            },
            {
                "x": -2.9526121616363525,
                "y": 0.11636264622211456,
                "z": -28.708105087280273
            },
            {
                "x": -2.9575343132019043,
                "y": 0.10470794886350632,
                "z": -28.55216407775879
            },
            {
                "x": -2.9611761569976807,
                "y": 0.09221251308917999,
                "z": -28.396408081054688
            },
            {
                "x": -2.9635958671569824,
                "y": 0.07895232737064362,
                "z": -28.240652084350586
            },
            {
                "x": -2.9648258686065674,
                "y": 0.06499525904655457,
                "z": -28.08477783203125
            },
            {
                "x": -2.9649033546447754,
                "y": 0.05044950917363167,
                "z": -27.929025650024414
            },
            {
                "x": -2.9639220237731934,
                "y": 0.03540539741516113,
                "z": -27.77318000793457
            },
            {
                "x": -2.961932897567749,
                "y": 0.019961174577474594,
                "z": -27.617347717285156
            },
            {
                "x": -2.9589765071868896,
                "y": 0.0045212553814053535,
                "z": -27.461544036865234
            },
            {
                "x": -2.955073595046997,
                "y": -0.00955000426620245,
                "z": -27.30546760559082
            },
            {
                "x": -2.9503085613250732,
                "y": -0.022167479619383812,
                "z": -27.14936065673828
            },
            {
                "x": -2.944730281829834,
                "y": -0.03341013565659523,
                "z": -26.99315071105957
            },
            {
                "x": -2.938366413116455,
                "y": -0.04335787519812584,
                "z": -26.83667755126953
            },
            {
                "x": -2.931117534637451,
                "y": -0.05199477821588516,
                "z": -26.680463790893555
            },
            {
                "x": -2.9229447841644287,
                "y": -0.05947526916861534,
                "z": -26.52423667907715
            },
            {
                "x": -2.917191743850708,
                "y": -0.06374289095401764,
                "z": -26.423364639282227
            },
            {
                "x": -2.907353401184082,
                "y": -0.0694529265165329,
                "z": -26.267282485961914
            },
            {
                "x": -2.8963637351989746,
                "y": -0.07419350743293762,
                "z": -26.111196517944336
            },
            {
                "x": -2.884199380874634,
                "y": -0.07804864645004272,
                "z": -25.955204010009766
            },
            {
                "x": -2.870821237564087,
                "y": -0.0810905247926712,
                "z": -25.799427032470703
            },
            {
                "x": -2.8561387062072754,
                "y": -0.08337448537349701,
                "z": -25.64369010925293
            },
            {
                "x": -2.840139389038086,
                "y": -0.0849885642528534,
                "z": -25.48820686340332
            },
            {
                "x": -2.8227832317352295,
                "y": -0.08601917326450348,
                "z": -25.33289909362793
            },
            {
                "x": -2.8039960861206055,
                "y": -0.08653976023197174,
                "z": -25.177589416503906
            },
            {
                "x": -2.7837541103363037,
                "y": -0.08661018311977386,
                "z": -25.022714614868164
            },
            {
                "x": -2.7619831562042236,
                "y": -0.08631449937820435,
                "z": -24.868003845214844
            },
            {
                "x": -2.738661527633667,
                "y": -0.08573263883590698,
                "z": -24.713565826416016
            },
            {
                "x": -2.713780641555786,
                "y": -0.08493766188621521,
                "z": -24.55947494506836
            },
            {
                "x": -2.6871800422668457,
                "y": -0.08421166241168976,
                "z": -24.40549659729004
            },
            {
                "x": -2.6589250564575195,
                "y": -0.08476656675338745,
                "z": -24.252111434936523
            },
            {
                "x": -2.628948211669922,
                "y": -0.08638487756252289,
                "z": -24.0990047454834
            },
            {
                "x": -2.5972046852111816,
                "y": -0.0870860368013382,
                "z": -23.946142196655273
            },
            {
                "x": -2.563649892807007,
                "y": -0.08632262051105499,
                "z": -23.79377555847168
            },
            {
                "x": -2.528257131576538,
                "y": -0.08419504761695862,
                "z": -23.641773223876953
            },
            {
                "x": -2.4910411834716797,
                "y": -0.08093731850385666,
                "z": -23.490249633789062
            },
            {
                "x": -2.452016592025757,
                "y": -0.07778061926364899,
                "z": -23.339136123657227
            },
            {
                "x": -2.4117491245269775,
                "y": -0.07518590986728668,
                "z": -23.187652587890625
            },
            {
                "x": -2.3708972930908203,
                "y": -0.07307890057563782,
                "z": -23.036264419555664
            },
            {
                "x": -2.3294780254364014,
                "y": -0.07136722654104233,
                "z": -22.885025024414062
            },
            {
                "x": -2.287428855895996,
                "y": -0.06996938586235046,
                "z": -22.7337589263916
            },
            {
                "x": -2.2448275089263916,
                "y": -0.06881379336118698,
                "z": -22.582847595214844
            },
            {
                "x": -2.201612949371338,
                "y": -0.06781191378831863,
                "z": -22.432044982910156
            },
            {
                "x": -2.157834053039551,
                "y": -0.06687953323125839,
                "z": -22.281368255615234
            },
            {
                "x": -2.113548755645752,
                "y": -0.06593822687864304,
                "z": -22.13086700439453
            },
            {
                "x": -2.068716287612915,
                "y": -0.06490082293748856,
                "z": -21.980262756347656
            },
            {
                "x": -2.0235342979431152,
                "y": -0.06369008123874664,
                "z": -21.829917907714844
            },
            {
                "x": -1.9780274629592896,
                "y": -0.06222847104072571,
                "z": -21.679609298706055
            },
            {
                "x": -1.9322497844696045,
                "y": -0.06043202057480812,
                "z": -21.529186248779297
            },
            {
                "x": -1.8863716125488281,
                "y": -0.05825703591108322,
                "z": -21.37883949279785
            },
            {
                "x": -1.8404474258422852,
                "y": -0.055755194276571274,
                "z": -21.22832489013672
            },
            {
                "x": -1.7946207523345947,
                "y": -0.052856191992759705,
                "z": -21.077695846557617
            },
            {
                "x": -1.7490544319152832,
                "y": -0.04947010800242424,
                "z": -20.92700958251953
            },
            {
                "x": -1.7038087844848633,
                "y": -0.04552750289440155,
                "z": -20.776039123535156
            },
            {
                "x": -1.659064531326294,
                "y": -0.04097263142466545,
                "z": -20.624961853027344
            },
            {
                "x": -1.614911437034607,
                "y": -0.03572278469800949,
                "z": -20.473649978637695
            },
            {
                "x": -1.5714412927627563,
                "y": -0.02967776171863079,
                "z": -20.321884155273438
            },
            {
                "x": -1.5288320779800415,
                "y": -0.022984229028224945,
                "z": -20.170068740844727
            },
            {
                "x": -1.4871151447296143,
                "y": -0.01690000854432583,
                "z": -20.017967224121094
            },
            {
                "x": -1.4607142210006714,
                "y": -0.013603712432086468,
                "z": -19.919517517089844
            },
            {
                "x": -1.4206560850143433,
                "y": -0.00946016889065504,
                "z": -19.76683235168457
            },
            {
                "x": -1.381654143333435,
                "y": -0.006600307300686836,
                "z": -19.61370849609375
            },
            {
                "x": -1.3438349962234497,
                "y": -0.005193223711103201,
                "z": -19.460254669189453
            },
            {
                "x": -1.3071869611740112,
                "y": -0.005000014789402485,
                "z": -19.306568145751953
            },
            {
                "x": -1.2716957330703735,
                "y": -0.00500000175088644,
                "z": -19.152463912963867
            },
            {
                "x": -1.2374664545059204,
                "y": -0.0050000036135315895,
                "z": -18.998199462890625
            },
            {
                "x": -1.2044403553009033,
                "y": -0.005000012926757336,
                "z": -18.843685150146484
            },
            {
                "x": -1.1725597381591797,
                "y": -0.005000004544854164,
                "z": -18.6887264251709
            },
            {
                "x": -1.141865849494934,
                "y": -0.00500000175088644,
                "z": -18.533769607543945
            },
            {
                "x": -1.1123462915420532,
                "y": -0.00500000175088644,
                "z": -18.378538131713867
            },
            {
                "x": -1.0838992595672607,
                "y": -0.005000002682209015,
                "z": -18.22315216064453
            },
            {
                "x": -1.0565056800842285,
                "y": -0.004999998956918716,
                "z": -18.067659378051758
            },
            {
                "x": -1.0300641059875488,
                "y": -0.004999997094273567,
                "z": -17.911840438842773
            },
            {
                "x": -1.0046281814575195,
                "y": -0.005000006407499313,
                "z": -17.756107330322266
            },
            {
                "x": -0.9800400137901306,
                "y": -0.004999999888241291,
                "z": -17.60026741027832
            },
            {
                "x": -0.9562345147132874,
                "y": -0.005000002682209015,
                "z": -17.444250106811523
            },
            {
                "x": -0.9332079887390137,
                "y": -0.005000004544854164,
                "z": -17.28827476501465
            },
            {
                "x": -0.9108289480209351,
                "y": -0.005000006407499313,
                "z": -17.13213539123535
            },
            {
                "x": -0.8890374302864075,
                "y": -0.005000008270144463,
                "z": -16.975969314575195
            },
            {
                "x": -0.8677793741226196,
                "y": -0.00500000175088644,
                "z": -16.81987953186035
            },
            {
                "x": -0.8469827175140381,
                "y": -0.00500000175088644,
                "z": -16.663776397705078
            },
            {
                "x": -0.8265542984008789,
                "y": -0.005000004544854164,
                "z": -16.507665634155273
            },
            {
                "x": -0.8064169883728027,
                "y": -0.005000005476176739,
                "z": -16.351572036743164
            },
            {
                "x": -0.7864720821380615,
                "y": -0.005000005476176739,
                "z": -16.195295333862305
            },
            {
                "x": -0.7666958570480347,
                "y": -0.005000002682209015,
                "z": -16.03925895690918
            },
            {
                "x": -0.7469673156738281,
                "y": -0.005000000819563866,
                "z": -15.883222579956055
            },
            {
                "x": -0.7272202968597412,
                "y": -0.005000002682209015,
                "z": -15.727097511291504
            },
            {
                "x": -0.70790034532547,
                "y": -0.005000002682209015,
                "z": -15.570549964904785
            },
            {
                "x": -0.6894625425338745,
                "y": -0.005000002682209015,
                "z": -15.413690567016602
            },
            {
                "x": -0.6717948913574219,
                "y": -0.004999998025596142,
                "z": -15.257054328918457
            },
            {
                "x": -0.6547131538391113,
                "y": -0.005000002682209015,
                "z": -15.100433349609375
            },
            {
                "x": -0.6380736827850342,
                "y": -0.00500000175088644,
                "z": -14.943729400634766
            },
            {
                "x": -0.6217783093452454,
                "y": -0.005000011064112186,
                "z": -14.787188529968262
            },
            {
                "x": -0.6056720614433289,
                "y": -0.004999997094273567,
                "z": -14.63060474395752
            },
            {
                "x": -0.5896583199501038,
                "y": -0.0050000036135315895,
                "z": -14.47404956817627
            },
            {
                "x": -0.5737111568450928,
                "y": -0.004999999888241291,
                "z": -14.317601203918457
            },
            {
                "x": -0.5577884316444397,
                "y": -0.005000009201467037,
                "z": -14.161055564880371
            },
            {
                "x": -0.5418924689292908,
                "y": -0.0050000036135315895,
                "z": -14.004626274108887
            },
            {
                "x": -0.5259974002838135,
                "y": -0.004999999888241291,
                "z": -13.848204612731934
            },
            {
                "x": -0.5100693702697754,
                "y": -0.00500000175088644,
                "z": -13.691594123840332
            },
            {
                "x": -0.49413761496543884,
                "y": -0.0050000036135315895,
                "z": -13.535189628601074
            },
            {
                "x": -0.4781706631183624,
                "y": -0.005000000819563866,
                "z": -13.378796577453613
            },
            {
                "x": -0.4678344130516052,
                "y": -0.005000005476176739,
                "z": -13.277777671813965
            },
            {
                "x": -0.4517902135848999,
                "y": -0.00500000175088644,
                "z": -13.1214017868042
            },
            {
                "x": -0.4356790781021118,
                "y": -0.00500000175088644,
                "z": -12.96493148803711
            },
            {
                "x": -0.4195098578929901,
                "y": -0.005000002682209015,
                "z": -12.808469772338867
            },
            {
                "x": -0.403292179107666,
                "y": -0.005000004544854164,
                "z": -12.65211296081543
            },
            {
                "x": -0.38700172305107117,
                "y": -0.004999997094273567,
                "z": -12.495654106140137
            },
            {
                "x": -0.37066125869750977,
                "y": -0.005000006407499313,
                "z": -12.339313507080078
            },
            {
                "x": -0.35426008701324463,
                "y": -0.004999998956918716,
                "z": -12.182976722717285
            },
            {
                "x": -0.3377780616283417,
                "y": -0.005000000819563866,
                "z": -12.026445388793945
            },
            {
                "x": -0.32125967741012573,
                "y": -0.00500000175088644,
                "z": -11.870124816894531
            },
            {
                "x": -0.3045732378959656,
                "y": -0.004999997094273567,
                "z": -11.714004516601562
            },
            {
                "x": -0.28718751668930054,
                "y": -0.005000008270144463,
                "z": -11.558154106140137
            },
            {
                "x": -0.2690340280532837,
                "y": -0.005000006407499313,
                "z": -11.402413368225098
            },
            {
                "x": -0.2501351833343506,
                "y": -0.004999999888241291,
                "z": -11.246515274047852
            },
            {
                "x": -0.2306339144706726,
                "y": -0.005000004544854164,
                "z": -11.090853691101074
            },
            {
                "x": -0.21057341992855072,
                "y": -0.005000005476176739,
                "z": -10.935219764709473
            },
            {
                "x": -0.18999062478542328,
                "y": -0.004999999888241291,
                "z": -10.779504776000977
            },
            {
                "x": -0.16899116337299347,
                "y": -0.005000002682209015,
                "z": -10.62391185760498
            },
            {
                "x": -0.14762185513973236,
                "y": -0.005000005476176739,
                "z": -10.468228340148926
            },
            {
                "x": -0.12596097588539124,
                "y": -0.00500000175088644,
                "z": -10.312545776367188
            },
            {
                "x": -0.10409445315599442,
                "y": -0.004999998025596142,
                "z": -10.156822204589844
            },
            {
                "x": -0.08261042088270187,
                "y": -0.004999998956918716,
                "z": -10.000650405883789
            },
            {
                "x": -0.0618739128112793,
                "y": -0.005000002682209015,
                "z": -9.844347953796387
            },
            {
                "x": -0.04190371185541153,
                "y": -0.005000005476176739,
                "z": -9.687943458557129
            },
            {
                "x": -0.02269701659679413,
                "y": -0.00500000175088644,
                "z": -9.531241416931152
            },
            {
                "x": -0.00427498621866107,
                "y": -0.005000009201467037,
                "z": -9.374651908874512
            },
            {
                "x": 0.013393455184996128,
                "y": -0.005000002682209015,
                "z": -9.217916488647461
            },
            {
                "x": 0.030276687815785408,
                "y": -0.005000002682209015,
                "z": -9.061100959777832
            },
            {
                "x": 0.04638591781258583,
                "y": -0.00500000175088644,
                "z": -8.904260635375977
            },
            {
                "x": 0.06176657974720001,
                "y": -0.00500000175088644,
                "z": -8.747153282165527
            },
            {
                "x": 0.07638570666313171,
                "y": -0.004999998956918716,
                "z": -8.590177536010742
            },
            {
                "x": 0.09023846685886383,
                "y": -0.00500000175088644,
                "z": -8.433144569396973
            },
            {
                "x": 0.10338611900806427,
                "y": -0.005000000819563866,
                "z": -8.275940895080566
            },
            {
                "x": 0.11582530289888382,
                "y": -0.005000007338821888,
                "z": -8.11880874633789
            },
            {
                "x": 0.12757791578769684,
                "y": -0.004999999888241291,
                "z": -7.961539268493652
            },
            {
                "x": 0.13865555822849274,
                "y": -0.0050000036135315895,
                "z": -7.804234981536865
            },
            {
                "x": 0.1491011083126068,
                "y": -0.004999998956918716,
                "z": -7.6470112800598145
            },
            {
                "x": 0.15900054574012756,
                "y": -0.0050000036135315895,
                "z": -7.489713668823242
            },
            {
                "x": 0.1684771329164505,
                "y": -0.0050000036135315895,
                "z": -7.332594871520996
            },
            {
                "x": 0.1777224838733673,
                "y": -0.005000004544854164,
                "z": -7.175556659698486
            },
            {
                "x": 0.1869218796491623,
                "y": -0.005000005476176739,
                "z": -7.0184149742126465
            },
            {
                "x": 0.1962279975414276,
                "y": -0.0050000036135315895,
                "z": -6.8615827560424805
            },
            {
                "x": 0.20585733652114868,
                "y": -0.005000002682209015,
                "z": -6.704875946044922
            },
            {
                "x": 0.21231961250305176,
                "y": -0.004999998956918716,
                "z": -6.603665828704834
            },
            {
                "x": 0.22241227328777313,
                "y": -0.005000000819563866,
                "z": -6.446460247039795
            },
            {
                "x": 0.2311689853668213,
                "y": -0.005000004544854164,
                "z": -6.288370609283447
            },
            {
                "x": 0.238003209233284,
                "y": -0.0050000036135315895,
                "z": -6.130131244659424
            },
            {
                "x": 0.242950439453125,
                "y": -0.005000004544854164,
                "z": -5.971968173980713
            },
            {
                "x": 0.24609783291816711,
                "y": -0.00500000175088644,
                "z": -5.813794136047363
            },
            {
                "x": 0.24820978939533234,
                "y": -0.0050000036135315895,
                "z": -5.656363487243652
            },
            {
                "x": 0.2501400113105774,
                "y": -0.004999999888241291,
                "z": -5.499066352844238
            },
            {
                "x": 0.25194355845451355,
                "y": -0.0050000036135315895,
                "z": -5.341577529907227
            },
            {
                "x": 0.25362154841423035,
                "y": -0.0050000036135315895,
                "z": -5.184289455413818
            },
            {
                "x": 0.2551261782646179,
                "y": -0.004999999888241291,
                "z": -5.02674674987793
            },
            {
                "x": 0.2555311918258667,
                "y": -0.005000000819563866,
                "z": -4.86864709854126
            },
            {
                "x": 0.25443118810653687,
                "y": -0.0050000036135315895,
                "z": -4.7106614112854
            },
            {
                "x": 0.2520187497138977,
                "y": -0.004999998956918716,
                "z": -4.5525994300842285
            },
            {
                "x": 0.2484699785709381,
                "y": -0.005000006407499313,
                "z": -4.394876480102539
            },
            {
                "x": 0.24404321610927582,
                "y": -0.005000007338821888,
                "z": -4.23728609085083
            },
            {
                "x": 0.238936647772789,
                "y": -0.0050000036135315895,
                "z": -4.07971715927124
            },
            {
                "x": 0.23335552215576172,
                "y": -0.004999999888241291,
                "z": -3.9223830699920654
            },
            {
                "x": 0.227492094039917,
                "y": -0.005000006407499313,
                "z": -3.765075445175171
            },
            {
                "x": 0.22158056497573853,
                "y": -0.005000000819563866,
                "z": -3.607879638671875
            },
            {
                "x": 0.2157168686389923,
                "y": -0.005000000819563866,
                "z": -3.450686454772949
            },
            {
                "x": 0.2095118910074234,
                "y": -0.004999999888241291,
                "z": -3.293372631072998
            },
            {
                "x": 0.20298492908477783,
                "y": -0.005000004544854164,
                "z": -3.1361522674560547
            },
            {
                "x": 0.1963004767894745,
                "y": -0.00500000175088644,
                "z": -2.979020595550537
            },
            {
                "x": 0.18961122632026672,
                "y": -0.005000002682209015,
                "z": -2.821770668029785
            },
            {
                "x": 0.18308430910110474,
                "y": -0.005000000819563866,
                "z": -2.664802312850952
            },
            {
                "x": 0.17689526081085205,
                "y": -0.005000004544854164,
                "z": -2.5078506469726562
            },
            {
                "x": 0.1711745262145996,
                "y": -0.005000000819563866,
                "z": -2.350916624069214
            },
            {
                "x": 0.16584905982017517,
                "y": -0.005000002682209015,
                "z": -2.193931818008423
            },
            {
                "x": 0.1607077419757843,
                "y": -0.005000002682209015,
                "z": -2.0366320610046387
            },
            {
                "x": 0.15555407106876373,
                "y": -0.004999998956918716,
                "z": -1.8794244527816772
            },
            {
                "x": 0.15018561482429504,
                "y": -0.005000004544854164,
                "z": -1.7221287488937378
            },
            {
                "x": 0.14442144334316254,
                "y": -0.004999999888241291,
                "z": -1.5646393299102783
            },
            {
                "x": 0.1381058543920517,
                "y": -0.005000000819563866,
                "z": -1.4072115421295166
            },
            {
                "x": 0.1310594379901886,
                "y": -0.005000004544854164,
                "z": -1.2496471405029297
            },
            {
                "x": 0.12320734560489655,
                "y": -0.004999999888241291,
                "z": -1.0920803546905518
            },
            {
                "x": 0.11463693529367447,
                "y": -0.005000002682209015,
                "z": -0.9348738193511963
            },
            {
                "x": 0.10602666437625885,
                "y": -0.005000006407499313,
                "z": -0.7778455018997192
            },
            {
                "x": 0.09769526869058609,
                "y": -0.005000000819563866,
                "z": -0.6210366487503052
            },
            {
                "x": 0.0899457111954689,
                "y": -0.00500000175088644,
                "z": -0.46441227197647095
            },
            {
                "x": 0.08333224058151245,
                "y": -0.005000004544854164,
                "z": -0.30792221426963806
            },
            {
                "x": 0.07891008257865906,
                "y": -0.005000000819563866,
                "z": -0.15227720141410828
            },
            {
                "x": 0.07853423058986664,
                "y": -0.005000005476176739,
                "z": 0.002718041418120265
            }
        ],
        "lane5":[
            {
                "x": 0.19409635663032532,
                "y": 0.02270415425300598,
                "z": -419.58282470703125
            },
            {
                "x": 0.19397765398025513,
                "y": 0.02269907295703888,
                "z": -419.4779968261719
            },
            {
                "x": 0.19379925727844238,
                "y": 0.022691458463668823,
                "z": -419.32080078125
            },
            {
                "x": 0.19362106919288635,
                "y": 0.022683873772621155,
                "z": -419.1634521484375
            },
            {
                "x": 0.19344273209571838,
                "y": 0.0226762592792511,
                "z": -419.006103515625
            },
            {
                "x": 0.19326454401016235,
                "y": 0.022668659687042236,
                "z": -418.848876953125
            },
            {
                "x": 0.19308626651763916,
                "y": 0.02266104519367218,
                "z": -418.6915283203125
            },
            {
                "x": 0.19290804862976074,
                "y": 0.022653445601463318,
                "z": -418.5343017578125
            },
            {
                "x": 0.19272980093955994,
                "y": 0.022645846009254456,
                "z": -418.3770751953125
            },
            {
                "x": 0.19255143404006958,
                "y": 0.0226382315158844,
                "z": -418.21966552734375
            },
            {
                "x": 0.19237318634986877,
                "y": 0.022630631923675537,
                "z": -418.06243896484375
            },
            {
                "x": 0.19219493865966797,
                "y": 0.022623032331466675,
                "z": -417.9051208496094
            },
            {
                "x": 0.19201666116714478,
                "y": 0.022615432739257812,
                "z": -417.7478332519531
            },
            {
                "x": 0.19183850288391113,
                "y": 0.02260783314704895,
                "z": -417.590576171875
            },
            {
                "x": 0.191660076379776,
                "y": 0.022600218653678894,
                "z": -417.43316650390625
            },
            {
                "x": 0.1914818286895752,
                "y": 0.022592604160308838,
                "z": -417.27593994140625
            },
            {
                "x": 0.19130361080169678,
                "y": 0.022585004568099976,
                "z": -417.11871337890625
            },
            {
                "x": 0.19112539291381836,
                "y": 0.022577404975891113,
                "z": -416.96136474609375
            },
            {
                "x": 0.190947026014328,
                "y": 0.022569790482521057,
                "z": -416.80413818359375
            },
            {
                "x": 0.19076883792877197,
                "y": 0.022562175989151,
                "z": -416.6468200683594
            },
            {
                "x": 0.19059044122695923,
                "y": 0.02255457639694214,
                "z": -416.4894714355469
            },
            {
                "x": 0.19041231274604797,
                "y": 0.02254699170589447,
                "z": -416.33221435546875
            },
            {
                "x": 0.19023415446281433,
                "y": 0.022539392113685608,
                "z": -416.17498779296875
            },
            {
                "x": 0.1900559365749359,
                "y": 0.022531777620315552,
                "z": -416.0177917480469
            },
            {
                "x": 0.1898776888847351,
                "y": 0.022524163126945496,
                "z": -415.8605651855469
            },
            {
                "x": 0.1896992325782776,
                "y": 0.022516563534736633,
                "z": -415.703125
            },
            {
                "x": 0.18952104449272156,
                "y": 0.022508978843688965,
                "z": -415.5458984375
            },
            {
                "x": 0.18934279680252075,
                "y": 0.022501379251480103,
                "z": -415.3886413574219
            },
            {
                "x": 0.18916460871696472,
                "y": 0.022493764758110046,
                "z": -415.2313232421875
            },
            {
                "x": 0.18898630142211914,
                "y": 0.022486165165901184,
                "z": -415.0740966796875
            },
            {
                "x": 0.188807874917984,
                "y": 0.022478550672531128,
                "z": -414.91668701171875
            },
            {
                "x": 0.18862968683242798,
                "y": 0.022470951080322266,
                "z": -414.75946044921875
            },
            {
                "x": 0.18845146894454956,
                "y": 0.022463366389274597,
                "z": -414.6022033691406
            },
            {
                "x": 0.18827316164970398,
                "y": 0.02245575189590454,
                "z": -414.44482421875
            },
            {
                "x": 0.18809500336647034,
                "y": 0.02244815230369568,
                "z": -414.28759765625
            },
            {
                "x": 0.1879165768623352,
                "y": 0.02244052290916443,
                "z": -414.1302795410156
            },
            {
                "x": 0.18773841857910156,
                "y": 0.022432923316955566,
                "z": -413.9729309082031
            },
            {
                "x": 0.18756017088890076,
                "y": 0.022425323724746704,
                "z": -413.8157043457031
            },
            {
                "x": 0.1873818337917328,
                "y": 0.022417739033699036,
                "z": -413.6583557128906
            },
            {
                "x": 0.18720367550849915,
                "y": 0.02241012454032898,
                "z": -413.5011291503906
            },
            {
                "x": 0.18702548742294312,
                "y": 0.02240249514579773,
                "z": -413.3439025878906
            },
            {
                "x": 0.1868470311164856,
                "y": 0.02239491045475006,
                "z": -413.18646240234375
            },
            {
                "x": 0.18666881322860718,
                "y": 0.022387295961380005,
                "z": -413.0292663574219
            },
            {
                "x": 0.18649059534072876,
                "y": 0.022379696369171143,
                "z": -412.8720397949219
            },
            {
                "x": 0.1863744556903839,
                "y": 0.02237473428249359,
                "z": -412.77044677734375
            },
            {
                "x": 0.18619629740715027,
                "y": 0.022367149591445923,
                "z": -412.61322021484375
            },
            {
                "x": 0.1860179901123047,
                "y": 0.02235954999923706,
                "z": -412.4559020996094
            },
            {
                "x": 0.18583959341049194,
                "y": 0.02235192060470581,
                "z": -412.2985534667969
            },
            {
                "x": 0.1856614053249359,
                "y": 0.022344321012496948,
                "z": -412.1413269042969
            },
            {
                "x": 0.18548306822776794,
                "y": 0.022336706519126892,
                "z": -411.9839782714844
            },
            {
                "x": 0.18530496954917908,
                "y": 0.022329121828079224,
                "z": -411.8267517089844
            },
            {
                "x": 0.1851266622543335,
                "y": 0.022321507334709167,
                "z": -411.6695251464844
            },
            {
                "x": 0.18494826555252075,
                "y": 0.022313907742500305,
                "z": -411.5120849609375
            },
            {
                "x": 0.18477007746696472,
                "y": 0.022306308150291443,
                "z": -411.3548583984375
            },
            {
                "x": 0.1845918595790863,
                "y": 0.02229870855808258,
                "z": -411.19757080078125
            },
            {
                "x": 0.18441352248191833,
                "y": 0.022291108965873718,
                "z": -411.040283203125
            },
            {
                "x": 0.18423530459403992,
                "y": 0.022283479571342468,
                "z": -410.8830871582031
            },
            {
                "x": 0.18405693769454956,
                "y": 0.022275909781455994,
                "z": -410.7256164550781
            },
            {
                "x": 0.18387874960899353,
                "y": 0.022268295288085938,
                "z": -410.5683898925781
            },
            {
                "x": 0.18370047211647034,
                "y": 0.02226068079471588,
                "z": -410.4111633300781
            },
            {
                "x": 0.18352219462394714,
                "y": 0.02225308120250702,
                "z": -410.2538146972656
            },
            {
                "x": 0.1833440065383911,
                "y": 0.022245466709136963,
                "z": -410.0965881347656
            },
            {
                "x": 0.18316569924354553,
                "y": 0.0222378671169281,
                "z": -409.93927001953125
            },
            {
                "x": 0.18298736214637756,
                "y": 0.022230252623558044,
                "z": -409.7818908691406
            },
            {
                "x": 0.18280914425849915,
                "y": 0.022222653031349182,
                "z": -409.62469482421875
            },
            {
                "x": 0.1826310157775879,
                "y": 0.02221505343914032,
                "z": -409.4674377441406
            },
            {
                "x": 0.18245285749435425,
                "y": 0.022207453846931458,
                "z": -409.31024169921875
            },
            {
                "x": 0.1822744905948639,
                "y": 0.0221998393535614,
                "z": -409.15301513671875
            },
            {
                "x": 0.1820962131023407,
                "y": 0.022192224860191345,
                "z": -408.9955749511719
            },
            {
                "x": 0.18191790580749512,
                "y": 0.022184640169143677,
                "z": -408.8383483886719
            },
            {
                "x": 0.18173962831497192,
                "y": 0.022177040576934814,
                "z": -408.6810607910156
            },
            {
                "x": 0.1815614104270935,
                "y": 0.02216942608356476,
                "z": -408.5237731933594
            },
            {
                "x": 0.1813831627368927,
                "y": 0.022161826491355896,
                "z": -408.3665466308594
            },
            {
                "x": 0.18120482563972473,
                "y": 0.02215421199798584,
                "z": -408.2091064453125
            },
            {
                "x": 0.1810266077518463,
                "y": 0.022146612405776978,
                "z": -408.0518798828125
            },
            {
                "x": 0.1808483898639679,
                "y": 0.02213902771472931,
                "z": -407.8946838378906
            },
            {
                "x": 0.18067008256912231,
                "y": 0.02213139832019806,
                "z": -407.7373046875
            },
            {
                "x": 0.18049189448356628,
                "y": 0.02212381362915039,
                "z": -407.5800476074219
            },
            {
                "x": 0.1803135871887207,
                "y": 0.02211621403694153,
                "z": -407.4227294921875
            },
            {
                "x": 0.18013527989387512,
                "y": 0.022108599543571472,
                "z": -407.2654113769531
            },
            {
                "x": 0.17995703220367432,
                "y": 0.02210099995136261,
                "z": -407.1081848144531
            },
            {
                "x": 0.17977875471115112,
                "y": 0.022093400359153748,
                "z": -406.9508361816406
            },
            {
                "x": 0.1796005368232727,
                "y": 0.02208578586578369,
                "z": -406.7936096191406
            },
            {
                "x": 0.17942234873771667,
                "y": 0.022078201174736023,
                "z": -406.6363830566406
            },
            {
                "x": 0.17924383282661438,
                "y": 0.02207055687904358,
                "z": -406.47894287109375
            },
            {
                "x": 0.17906564474105835,
                "y": 0.022062957286834717,
                "z": -406.32171630859375
            },
            {
                "x": 0.1788875162601471,
                "y": 0.02205537259578705,
                "z": -406.1644592285156
            },
            {
                "x": 0.17877134680747986,
                "y": 0.02205042541027069,
                "z": -406.0628967285156
            },
            {
                "x": 0.17859318852424622,
                "y": 0.022042810916900635,
                "z": -405.9056701660156
            },
            {
                "x": 0.17841485142707825,
                "y": 0.02203519642353058,
                "z": -405.7483215332031
            },
            {
                "x": 0.17823660373687744,
                "y": 0.02202761173248291,
                "z": -405.59100341796875
            },
            {
                "x": 0.17805829644203186,
                "y": 0.022020012140274048,
                "z": -405.43377685546875
            },
            {
                "x": 0.17787998914718628,
                "y": 0.02201239764690399,
                "z": -405.2764587402344
            },
            {
                "x": 0.17770174145698547,
                "y": 0.022004783153533936,
                "z": -405.11920166015625
            },
            {
                "x": 0.17752352356910706,
                "y": 0.021997183561325073,
                "z": -404.9620056152344
            },
            {
                "x": 0.1773451566696167,
                "y": 0.02198958396911621,
                "z": -404.8045349121094
            },
            {
                "x": 0.17716696858406067,
                "y": 0.02198198437690735,
                "z": -404.6473083496094
            },
            {
                "x": 0.17698875069618225,
                "y": 0.021974369883537292,
                "z": -404.4900207519531
            },
            {
                "x": 0.17681041359901428,
                "y": 0.021966755390167236,
                "z": -404.3327331542969
            },
            {
                "x": 0.17663222551345825,
                "y": 0.021959170699119568,
                "z": -404.1755065917969
            },
            {
                "x": 0.1764538586139679,
                "y": 0.021951541304588318,
                "z": -404.0180358886719
            },
            {
                "x": 0.17627552151679993,
                "y": 0.02194395661354065,
                "z": -403.86083984375
            },
            {
                "x": 0.17609736323356628,
                "y": 0.021936342120170593,
                "z": -403.70361328125
            },
            {
                "x": 0.1759190857410431,
                "y": 0.02192874252796173,
                "z": -403.5462646484375
            },
            {
                "x": 0.17574089765548706,
                "y": 0.021921128034591675,
                "z": -403.3890075683594
            },
            {
                "x": 0.17556259036064148,
                "y": 0.021913528442382812,
                "z": -403.2317199707031
            },
            {
                "x": 0.1753842830657959,
                "y": 0.02190592885017395,
                "z": -403.0743713378906
            },
            {
                "x": 0.1752060353755951,
                "y": 0.021898329257965088,
                "z": -402.9171447753906
            },
            {
                "x": 0.17502787709236145,
                "y": 0.021890729665756226,
                "z": -402.7598876953125
            },
            {
                "x": 0.17484968900680542,
                "y": 0.02188311517238617,
                "z": -402.6026611328125
            },
            {
                "x": 0.1746715009212494,
                "y": 0.021875515580177307,
                "z": -402.4454345703125
            },
            {
                "x": 0.17449301481246948,
                "y": 0.021867915987968445,
                "z": -402.28802490234375
            },
            {
                "x": 0.17431482672691345,
                "y": 0.021860316395759583,
                "z": -402.1307678222656
            },
            {
                "x": 0.17413657903671265,
                "y": 0.021852701902389526,
                "z": -401.9734802246094
            },
            {
                "x": 0.17395836114883423,
                "y": 0.021845102310180664,
                "z": -401.8161926269531
            },
            {
                "x": 0.17378020286560059,
                "y": 0.021837502717971802,
                "z": -401.6589660644531
            },
            {
                "x": 0.1736016571521759,
                "y": 0.021829888224601746,
                "z": -401.50152587890625
            },
            {
                "x": 0.17342355847358704,
                "y": 0.021822288632392883,
                "z": -401.34429931640625
            },
            {
                "x": 0.17324531078338623,
                "y": 0.021814659237861633,
                "z": -401.18707275390625
            },
            {
                "x": 0.1730669140815735,
                "y": 0.02180705964565277,
                "z": -401.02972412109375
            },
            {
                "x": 0.17288875579833984,
                "y": 0.021799489855766296,
                "z": -400.87249755859375
            },
            {
                "x": 0.17271044850349426,
                "y": 0.021791860461235046,
                "z": -400.7151794433594
            },
            {
                "x": 0.17253217101097107,
                "y": 0.021784260869026184,
                "z": -400.5578308105469
            },
            {
                "x": 0.1723538637161255,
                "y": 0.021776646375656128,
                "z": -400.4006042480469
            },
            {
                "x": 0.17217561602592468,
                "y": 0.021769046783447266,
                "z": -400.24322509765625
            },
            {
                "x": 0.17199742794036865,
                "y": 0.021761447191238403,
                "z": -400.0860290527344
            },
            {
                "x": 0.17181918025016785,
                "y": 0.021753832697868347,
                "z": -399.9288024902344
            },
            {
                "x": 0.17164084315299988,
                "y": 0.021746262907981873,
                "z": -399.7713623046875
            },
            {
                "x": 0.1714625358581543,
                "y": 0.021738633513450623,
                "z": -399.6141357421875
            },
            {
                "x": 0.17128437757492065,
                "y": 0.02173103392124176,
                "z": -399.4569091796875
            },
            {
                "x": 0.1711682379245758,
                "y": 0.02172607183456421,
                "z": -399.3553161621094
            },
            {
                "x": 0.17099010944366455,
                "y": 0.021718457341194153,
                "z": -399.19805908203125
            },
            {
                "x": 0.17081177234649658,
                "y": 0.021710872650146484,
                "z": -399.040771484375
            },
            {
                "x": 0.1706334948539734,
                "y": 0.021703258156776428,
                "z": -398.8834228515625
            },
            {
                "x": 0.17045512795448303,
                "y": 0.021695658564567566,
                "z": -398.7261962890625
            },
            {
                "x": 0.17027691006660461,
                "y": 0.021688058972358704,
                "z": -398.56884765625
            },
            {
                "x": 0.1700986921787262,
                "y": 0.02168045938014984,
                "z": -398.41162109375
            },
            {
                "x": 0.1699204444885254,
                "y": 0.021672844886779785,
                "z": -398.25439453125
            },
            {
                "x": 0.16974204778671265,
                "y": 0.02166523039340973,
                "z": -398.0969543457031
            },
            {
                "x": 0.16956385970115662,
                "y": 0.02165764570236206,
                "z": -397.9397277832031
            },
            {
                "x": 0.16938558220863342,
                "y": 0.021650046110153198,
                "z": -397.7824401855469
            },
            {
                "x": 0.16920733451843262,
                "y": 0.021642416715621948,
                "z": -397.6251220703125
            },
            {
                "x": 0.16902905702590942,
                "y": 0.02163483202457428,
                "z": -397.4679260253906
            },
            {
                "x": 0.16885071992874146,
                "y": 0.021627217531204224,
                "z": -397.31048583984375
            },
            {
                "x": 0.16867244243621826,
                "y": 0.02161961793899536,
                "z": -397.15325927734375
            },
            {
                "x": 0.16849425435066223,
                "y": 0.0216120183467865,
                "z": -396.99603271484375
            },
            {
                "x": 0.16831597685813904,
                "y": 0.021604418754577637,
                "z": -396.83868408203125
            },
            {
                "x": 0.1681378185749054,
                "y": 0.021596789360046387,
                "z": -396.68145751953125
            },
            {
                "x": 0.1679595410823822,
                "y": 0.021589204668998718,
                "z": -396.52410888671875
            },
            {
                "x": 0.16778111457824707,
                "y": 0.021581605076789856,
                "z": -396.3667907714844
            },
            {
                "x": 0.16760292649269104,
                "y": 0.021573975682258606,
                "z": -396.2095642089844
            },
            {
                "x": 0.1674247682094574,
                "y": 0.021566376090049744,
                "z": -396.0523376464844
            },
            {
                "x": 0.16724655032157898,
                "y": 0.021558791399002075,
                "z": -395.8951416015625
            },
            {
                "x": 0.16706830263137817,
                "y": 0.021551191806793213,
                "z": -395.7378845214844
            },
            {
                "x": 0.1668899655342102,
                "y": 0.02154359221458435,
                "z": -395.58050537109375
            },
            {
                "x": 0.16671165823936462,
                "y": 0.021535977721214294,
                "z": -395.42327880859375
            },
            {
                "x": 0.1665334403514862,
                "y": 0.02152836322784424,
                "z": -395.2659912109375
            },
            {
                "x": 0.1663552224636078,
                "y": 0.021520763635635376,
                "z": -395.10870361328125
            },
            {
                "x": 0.1661769449710846,
                "y": 0.02151314914226532,
                "z": -394.95147705078125
            },
            {
                "x": 0.16599857807159424,
                "y": 0.021505579352378845,
                "z": -394.7940368652344
            },
            {
                "x": 0.16582036018371582,
                "y": 0.02149796485900879,
                "z": -394.6368103027344
            },
            {
                "x": 0.1656421720981598,
                "y": 0.021490365266799927,
                "z": -394.4795837402344
            },
            {
                "x": 0.16546377539634705,
                "y": 0.021482735872268677,
                "z": -394.3222351074219
            },
            {
                "x": 0.1652856171131134,
                "y": 0.02147515118122101,
                "z": -394.1650085449219
            },
            {
                "x": 0.16510728001594543,
                "y": 0.021467551589012146,
                "z": -394.0076599121094
            },
            {
                "x": 0.16492900252342224,
                "y": 0.021459922194480896,
                "z": -393.8503723144531
            },
            {
                "x": 0.16475072503089905,
                "y": 0.021452337503433228,
                "z": -393.693115234375
            },
            {
                "x": 0.16457250714302063,
                "y": 0.021444708108901978,
                "z": -393.5357666015625
            },
            {
                "x": 0.1643942892551422,
                "y": 0.021437138319015503,
                "z": -393.3785400390625
            },
            {
                "x": 0.16421598196029663,
                "y": 0.021429508924484253,
                "z": -393.2213134765625
            },
            {
                "x": 0.16403764486312866,
                "y": 0.02142190933227539,
                "z": -393.0638732910156
            },
            {
                "x": 0.16385939717292786,
                "y": 0.02141430974006653,
                "z": -392.9066467285156
            },
            {
                "x": 0.1636812388896942,
                "y": 0.021406710147857666,
                "z": -392.7494201660156
            },
            {
                "x": 0.16356512904167175,
                "y": 0.021401748061180115,
                "z": -392.6477966308594
            },
            {
                "x": 0.16338691115379333,
                "y": 0.021394163370132446,
                "z": -392.4906311035156
            },
            {
                "x": 0.16320860385894775,
                "y": 0.021386533975601196,
                "z": -392.33331298828125
            },
            {
                "x": 0.16303026676177979,
                "y": 0.02137891948223114,
                "z": -392.17596435546875
            },
            {
                "x": 0.16285204887390137,
                "y": 0.021371349692344666,
                "z": -392.0187683105469
            },
            {
                "x": 0.1626737117767334,
                "y": 0.021363720297813416,
                "z": -391.8614196777344
            },
            {
                "x": 0.16249555349349976,
                "y": 0.021356135606765747,
                "z": -391.7041931152344
            },
            {
                "x": 0.16231724619865417,
                "y": 0.02134852111339569,
                "z": -391.5469665527344
            },
            {
                "x": 0.1621389389038086,
                "y": 0.02134089171886444,
                "z": -391.3894958496094
            },
            {
                "x": 0.1619606614112854,
                "y": 0.021333307027816772,
                "z": -391.2322998046875
            },
            {
                "x": 0.16178244352340698,
                "y": 0.021325722336769104,
                "z": -391.07501220703125
            },
            {
                "x": 0.16160425543785095,
                "y": 0.021318107843399048,
                "z": -390.91766357421875
            },
            {
                "x": 0.16142594814300537,
                "y": 0.021310508251190186,
                "z": -390.76043701171875
            },
            {
                "x": 0.16124752163887024,
                "y": 0.021302878856658936,
                "z": -390.60302734375
            },
            {
                "x": 0.1610693335533142,
                "y": 0.021295294165611267,
                "z": -390.44580078125
            },
            {
                "x": 0.16089117527008057,
                "y": 0.0212877094745636,
                "z": -390.28857421875
            },
            {
                "x": 0.1607128381729126,
                "y": 0.02128008008003235,
                "z": -390.1312255859375
            },
            {
                "x": 0.1605345904827118,
                "y": 0.02127249538898468,
                "z": -389.9739990234375
            },
            {
                "x": 0.1603563129901886,
                "y": 0.021264880895614624,
                "z": -389.816650390625
            },
            {
                "x": 0.1601780354976654,
                "y": 0.02125728130340576,
                "z": -389.6593017578125
            },
            {
                "x": 0.1599997580051422,
                "y": 0.021249666810035706,
                "z": -389.5020751953125
            },
            {
                "x": 0.15982168912887573,
                "y": 0.021242082118988037,
                "z": -389.3448486328125
            },
            {
                "x": 0.15964341163635254,
                "y": 0.021234452724456787,
                "z": -389.1876220703125
            },
            {
                "x": 0.1594652235507965,
                "y": 0.02122683823108673,
                "z": -389.0303955078125
            },
            {
                "x": 0.15928679704666138,
                "y": 0.021219253540039062,
                "z": -388.87298583984375
            },
            {
                "x": 0.15910854935646057,
                "y": 0.021211639046669006,
                "z": -388.71575927734375
            },
            {
                "x": 0.15893027186393738,
                "y": 0.021204039454460144,
                "z": -388.5584716796875
            },
            {
                "x": 0.15875199437141418,
                "y": 0.021196439862251282,
                "z": -388.40118408203125
            },
            {
                "x": 0.15857386589050293,
                "y": 0.02118884027004242,
                "z": -388.24395751953125
            },
            {
                "x": 0.1583954393863678,
                "y": 0.021181240677833557,
                "z": -388.0865478515625
            },
            {
                "x": 0.15821725130081177,
                "y": 0.021173611283302307,
                "z": -387.9293212890625
            },
            {
                "x": 0.15803900361061096,
                "y": 0.021166011691093445,
                "z": -387.7720642089844
            },
            {
                "x": 0.157860666513443,
                "y": 0.021158427000045776,
                "z": -387.6147155761719
            },
            {
                "x": 0.15768244862556458,
                "y": 0.021150797605514526,
                "z": -387.45751953125
            },
            {
                "x": 0.15750417113304138,
                "y": 0.02114318311214447,
                "z": -387.3001403808594
            },
            {
                "x": 0.1573258340358734,
                "y": 0.021135598421096802,
                "z": -387.142822265625
            },
            {
                "x": 0.157147616147995,
                "y": 0.02112799882888794,
                "z": -386.985595703125
            },
            {
                "x": 0.15696927905082703,
                "y": 0.02112041413784027,
                "z": -386.8282470703125
            },
            {
                "x": 0.15679112076759338,
                "y": 0.021112799644470215,
                "z": -386.6710205078125
            },
            {
                "x": 0.15661293268203735,
                "y": 0.021105170249938965,
                "z": -386.5137939453125
            },
            {
                "x": 0.1564345359802246,
                "y": 0.021097570657730103,
                "z": -386.3563537597656
            },
            {
                "x": 0.15625622868537903,
                "y": 0.021089985966682434,
                "z": -386.1991271972656
            },
            {
                "x": 0.15607807040214539,
                "y": 0.021082356572151184,
                "z": -386.0419006347656
            },
            {
                "x": 0.15596193075180054,
                "y": 0.02107742428779602,
                "z": -385.9403076171875
            },
            {
                "x": 0.1557837724685669,
                "y": 0.021069809794425964,
                "z": -385.7830810546875
            },
            {
                "x": 0.1556054651737213,
                "y": 0.021062225103378296,
                "z": -385.6257629394531
            },
            {
                "x": 0.15542712807655334,
                "y": 0.021054595708847046,
                "z": -385.46844482421875
            },
            {
                "x": 0.15524888038635254,
                "y": 0.021046996116638184,
                "z": -385.3111877441406
            },
            {
                "x": 0.15507057309150696,
                "y": 0.02103939652442932,
                "z": -385.15380859375
            },
            {
                "x": 0.1548924446105957,
                "y": 0.021031782031059265,
                "z": -384.9966125488281
            },
            {
                "x": 0.15471410751342773,
                "y": 0.021024182438850403,
                "z": -384.83941650390625
            },
            {
                "x": 0.15453574061393738,
                "y": 0.02101658284664154,
                "z": -384.68194580078125
            },
            {
                "x": 0.15435761213302612,
                "y": 0.021008968353271484,
                "z": -384.52471923828125
            },
            {
                "x": 0.1541793942451477,
                "y": 0.021001368761062622,
                "z": -384.367431640625
            },
            {
                "x": 0.1540011167526245,
                "y": 0.020993784070014954,
                "z": -384.21014404296875
            },
            {
                "x": 0.15382298827171326,
                "y": 0.020986154675483704,
                "z": -384.05291748046875
            },
            {
                "x": 0.15364447236061096,
                "y": 0.020978569984436035,
                "z": -383.8954772949219
            },
            {
                "x": 0.15346628427505493,
                "y": 0.02097095549106598,
                "z": -383.7382507324219
            },
            {
                "x": 0.1532881259918213,
                "y": 0.020963355898857117,
                "z": -383.5810241699219
            },
            {
                "x": 0.15310972929000854,
                "y": 0.020955726504325867,
                "z": -383.4236755371094
            },
            {
                "x": 0.15293154120445251,
                "y": 0.020948156714439392,
                "z": -383.2664489746094
            },
            {
                "x": 0.15275323390960693,
                "y": 0.020940542221069336,
                "z": -383.109130859375
            },
            {
                "x": 0.15257495641708374,
                "y": 0.02093292772769928,
                "z": -382.9517822265625
            },
            {
                "x": 0.15239667892456055,
                "y": 0.020925328135490417,
                "z": -382.7945556640625
            },
            {
                "x": 0.15221849083900452,
                "y": 0.020917728543281555,
                "z": -382.6373291015625
            },
            {
                "x": 0.15204033255577087,
                "y": 0.0209101140499115,
                "z": -382.4801025390625
            },
            {
                "x": 0.15186208486557007,
                "y": 0.02090252935886383,
                "z": -382.3228759765625
            },
            {
                "x": 0.15168365836143494,
                "y": 0.02089489996433258,
                "z": -382.16546630859375
            },
            {
                "x": 0.1515055000782013,
                "y": 0.020887300372123718,
                "z": -382.0082092285156
            },
            {
                "x": 0.1513272225856781,
                "y": 0.020879700779914856,
                "z": -381.8509216308594
            },
            {
                "x": 0.15114900469779968,
                "y": 0.020872101187705994,
                "z": -381.6936340332031
            },
            {
                "x": 0.15097081661224365,
                "y": 0.020864516496658325,
                "z": -381.5364074707031
            },
            {
                "x": 0.1507924199104309,
                "y": 0.020856887102127075,
                "z": -381.37896728515625
            },
            {
                "x": 0.1506141722202301,
                "y": 0.02084927260875702,
                "z": -381.22174072265625
            },
            {
                "x": 0.15043595433235168,
                "y": 0.02084168791770935,
                "z": -381.06451416015625
            },
            {
                "x": 0.1502576768398285,
                "y": 0.02083408832550049,
                "z": -380.90716552734375
            },
            {
                "x": 0.15007975697517395,
                "y": 0.020826488733291626,
                "z": -380.74993896484375
            },
            {
                "x": 0.14990147948265076,
                "y": 0.020818859338760376,
                "z": -380.59259033203125
            },
            {
                "x": 0.14972299337387085,
                "y": 0.020811259746551514,
                "z": -380.435302734375
            },
            {
                "x": 0.14954522252082825,
                "y": 0.020803675055503845,
                "z": -380.2780456542969
            },
            {
                "x": 0.1493692696094513,
                "y": 0.02079606056213379,
                "z": -380.1206970214844
            },
            {
                "x": 0.1491951048374176,
                "y": 0.020788460969924927,
                "z": -379.9634704589844
            },
            {
                "x": 0.1490187644958496,
                "y": 0.020780861377716064,
                "z": -379.8062438964844
            },
            {
                "x": 0.14884373545646667,
                "y": 0.020773231983184814,
                "z": -379.6488342285156
            },
            {
                "x": 0.1486804485321045,
                "y": 0.02076566219329834,
                "z": -379.4916687011719
            },
            {
                "x": 0.14852353930473328,
                "y": 0.020757567137479782,
                "z": -379.3345031738281
            },
            {
                "x": 0.14844512939453125,
                "y": 0.02075307071208954,
                "z": -379.23291015625
            },
            {
                "x": 0.14830106496810913,
                "y": 0.02074548602104187,
                "z": -379.07568359375
            },
            {
                "x": 0.14817765355110168,
                "y": 0.020737886428833008,
                "z": -378.9184875488281
            },
            {
                "x": 0.14812055230140686,
                "y": 0.02073027193546295,
                "z": -378.7614440917969
            },
            {
                "x": 0.14814862608909607,
                "y": 0.02072267234325409,
                "z": -378.6045227050781
            },
            {
                "x": 0.14822307229042053,
                "y": 0.02071501314640045,
                "z": -378.4472351074219
            },
            {
                "x": 0.1483304500579834,
                "y": 0.020707398653030396,
                "z": -378.29034423828125
            },
            {
                "x": 0.14858478307724,
                "y": 0.02069990336894989,
                "z": -378.1338806152344
            },
            {
                "x": 0.1490759551525116,
                "y": 0.02069222927093506,
                "z": -377.9774169921875
            },
            {
                "x": 0.14979496598243713,
                "y": 0.020684629678726196,
                "z": -377.8209228515625
            },
            {
                "x": 0.15065062046051025,
                "y": 0.020677000284194946,
                "z": -377.6641845703125
            },
            {
                "x": 0.15172630548477173,
                "y": 0.020669445395469666,
                "z": -377.50811767578125
            },
            {
                "x": 0.15318000316619873,
                "y": 0.020661816000938416,
                "z": -377.3525390625
            },
            {
                "x": 0.15504711866378784,
                "y": 0.020654216408729553,
                "z": -377.19647216796875
            },
            {
                "x": 0.15722715854644775,
                "y": 0.020646601915359497,
                "z": -377.04022216796875
            },
            {
                "x": 0.1596699357032776,
                "y": 0.020639002323150635,
                "z": -376.88433837890625
            },
            {
                "x": 0.16254854202270508,
                "y": 0.020631417632102966,
                "z": -376.72900390625
            },
            {
                "x": 0.16595256328582764,
                "y": 0.02062375843524933,
                "z": -376.5737609863281
            },
            {
                "x": 0.16980785131454468,
                "y": 0.02061617374420166,
                "z": -376.41778564453125
            },
            {
                "x": 0.17394492030143738,
                "y": 0.020608603954315186,
                "z": -376.26165771484375
            },
            {
                "x": 0.17844408750534058,
                "y": 0.02060098946094513,
                "z": -376.10638427734375
            },
            {
                "x": 0.18347954750061035,
                "y": 0.020593374967575073,
                "z": -375.9514465332031
            },
            {
                "x": 0.18907564878463745,
                "y": 0.020585760474205017,
                "z": -375.7960510253906
            },
            {
                "x": 0.19503253698349,
                "y": 0.02057814598083496,
                "z": -375.6400146484375
            },
            {
                "x": 0.2012752890586853,
                "y": 0.020570561289787292,
                "z": -375.484130859375
            },
            {
                "x": 0.20794323086738586,
                "y": 0.020562976598739624,
                "z": -375.32916259765625
            },
            {
                "x": 0.21520254015922546,
                "y": 0.020555362105369568,
                "z": -375.17413330078125
            },
            {
                "x": 0.22294673323631287,
                "y": 0.020547762513160706,
                "z": -375.0184020996094
            },
            {
                "x": 0.2309834063053131,
                "y": 0.020540133118629456,
                "z": -374.8624267578125
            },
            {
                "x": 0.23933658003807068,
                "y": 0.020532533526420593,
                "z": -374.7069396972656
            },
            {
                "x": 0.24818885326385498,
                "y": 0.020524919033050537,
                "z": -374.5520935058594
            },
            {
                "x": 0.25759634375572205,
                "y": 0.020517289638519287,
                "z": -374.39697265625
            },
            {
                "x": 0.267421692609787,
                "y": 0.02050970494747162,
                "z": -374.2410888671875
            },
            {
                "x": 0.27749449014663696,
                "y": 0.020502105355262756,
                "z": -374.08538818359375
            },
            {
                "x": 0.28795212507247925,
                "y": 0.020494535565376282,
                "z": -373.9302673339844
            },
            {
                "x": 0.29893678426742554,
                "y": 0.020486950874328613,
                "z": -373.7754211425781
            },
            {
                "x": 0.31043073534965515,
                "y": 0.020479336380958557,
                "z": -373.6200866699219
            },
            {
                "x": 0.32226434350013733,
                "y": 0.02047167718410492,
                "z": -373.4642028808594
            },
            {
                "x": 0.3343576490879059,
                "y": 0.020464152097702026,
                "z": -373.30889892578125
            },
            {
                "x": 0.34687286615371704,
                "y": 0.020456433296203613,
                "z": -373.15423583984375
            },
            {
                "x": 0.35994479060173035,
                "y": 0.02044890820980072,
                "z": -372.9991760253906
            },
            {
                "x": 0.3734542727470398,
                "y": 0.02044127881526947,
                "z": -372.8437805175781
            },
            {
                "x": 0.38724082708358765,
                "y": 0.020433757454156876,
                "z": -372.6881103515625
            },
            {
                "x": 0.39629119634628296,
                "y": 0.02042868733406067,
                "z": -372.5879821777344
            },
            {
                "x": 0.41064125299453735,
                "y": 0.020421132445335388,
                "z": -372.433349609375
            },
            {
                "x": 0.42554762959480286,
                "y": 0.02041354775428772,
                "z": -372.27862548828125
            },
            {
                "x": 0.44091251492500305,
                "y": 0.02040591835975647,
                "z": -372.12310791015625
            },
            {
                "x": 0.4565070569515228,
                "y": 0.020398318767547607,
                "z": -371.9677429199219
            },
            {
                "x": 0.4724033772945404,
                "y": 0.02039073407649994,
                "z": -371.8128662109375
            },
            {
                "x": 0.4887540638446808,
                "y": 0.0203830748796463,
                "z": -371.658447265625
            },
            {
                "x": 0.5056270360946655,
                "y": 0.020375490188598633,
                "z": -371.50372314453125
            },
            {
                "x": 0.5228963494300842,
                "y": 0.02036789059638977,
                "z": -371.3481140136719
            },
            {
                "x": 0.5403527617454529,
                "y": 0.020360305905342102,
                "z": -371.19305419921875
            },
            {
                "x": 0.5581495761871338,
                "y": 0.020352676510810852,
                "z": -371.03863525390625
            },
            {
                "x": 0.5764567255973816,
                "y": 0.02034512162208557,
                "z": -370.8842468261719
            },
            {
                "x": 0.5952272415161133,
                "y": 0.020337477326393127,
                "z": -370.7294006347656
            },
            {
                "x": 0.6143106818199158,
                "y": 0.020329907536506653,
                "z": -370.57403564453125
            },
            {
                "x": 0.6335927844047546,
                "y": 0.02032226324081421,
                "z": -370.4194030761719
            },
            {
                "x": 0.6532734036445618,
                "y": 0.020314663648605347,
                "z": -370.2652893066406
            },
            {
                "x": 0.6734722256660461,
                "y": 0.020307093858718872,
                "z": -370.1108703613281
            },
            {
                "x": 0.6940664052963257,
                "y": 0.020299479365348816,
                "z": -369.9559631347656
            },
            {
                "x": 0.7148892879486084,
                "y": 0.020291849970817566,
                "z": -369.80108642578125
            },
            {
                "x": 0.7359902858734131,
                "y": 0.020284265279769897,
                "z": -369.64678955078125
            },
            {
                "x": 0.7575093507766724,
                "y": 0.02027665078639984,
                "z": -369.49285888671875
            },
            {
                "x": 0.779509425163269,
                "y": 0.020269066095352173,
                "z": -369.3385314941406
            },
            {
                "x": 0.8018498420715332,
                "y": 0.02026139199733734,
                "z": -369.1837463378906
            },
            {
                "x": 0.8243833780288696,
                "y": 0.020253852009773254,
                "z": -369.02935791015625
            },
            {
                "x": 0.8472630977630615,
                "y": 0.020246222615242004,
                "z": -368.8753356933594
            },
            {
                "x": 0.8705723881721497,
                "y": 0.02023865282535553,
                "z": -368.72149658203125
            },
            {
                "x": 0.8943400382995605,
                "y": 0.020231038331985474,
                "z": -368.5670471191406
            },
            {
                "x": 0.9183628559112549,
                "y": 0.020223423838615417,
                "z": -368.4124755859375
            },
            {
                "x": 0.9425808191299438,
                "y": 0.02021580934524536,
                "z": -368.2585144042969
            },
            {
                "x": 0.9671840667724609,
                "y": 0.020208224654197693,
                "z": -368.10479736328125
            },
            {
                "x": 0.9922376275062561,
                "y": 0.02020062506198883,
                "z": -367.950927734375
            },
            {
                "x": 1.017665147781372,
                "y": 0.020192980766296387,
                "z": -367.7966613769531
            },
            {
                "x": 1.0433039665222168,
                "y": 0.020185425877571106,
                "z": -367.64239501953125
            },
            {
                "x": 1.069166660308838,
                "y": 0.02017781138420105,
                "z": -367.4888610839844
            },
            {
                "x": 1.0954532623291016,
                "y": 0.020170241594314575,
                "z": -367.33538818359375
            },
            {
                "x": 1.1222039461135864,
                "y": 0.02016262710094452,
                "z": -367.1814880371094
            },
            {
                "x": 1.1492257118225098,
                "y": 0.02015504240989685,
                "z": -367.02740478515625
            },
            {
                "x": 1.1764280796051025,
                "y": 0.02014736831188202,
                "z": -366.8735656738281
            },
            {
                "x": 1.2039018869400024,
                "y": 0.020139873027801514,
                "z": -366.72039794921875
            },
            {
                "x": 1.2318247556686401,
                "y": 0.020132213830947876,
                "z": -366.567138671875
            },
            {
                "x": 1.2601927518844604,
                "y": 0.020124614238739014,
                "z": -366.4132080078125
            },
            {
                "x": 1.2887400388717651,
                "y": 0.020117059350013733,
                "z": -366.2593688964844
            },
            {
                "x": 1.3174458742141724,
                "y": 0.020109303295612335,
                "z": -366.10614013671875
            },
            {
                "x": 1.3361868858337402,
                "y": 0.020104438066482544,
                "z": -366.00732421875
            },
            {
                "x": 1.3655314445495605,
                "y": 0.020096883177757263,
                "z": -365.85430908203125
            },
            {
                "x": 1.3952926397323608,
                "y": 0.020089253783226013,
                "z": -365.7006530761719
            },
            {
                "x": 1.4252715110778809,
                "y": 0.020081624388694763,
                "z": -365.5469970703125
            },
            {
                "x": 1.4554005861282349,
                "y": 0.020074039697647095,
                "z": -365.39404296875
            },
            {
                "x": 1.4858806133270264,
                "y": 0.020066380500793457,
                "z": -365.2411804199219
            },
            {
                "x": 1.5167694091796875,
                "y": 0.020058810710906982,
                "z": -365.0882263183594
            },
            {
                "x": 1.5479860305786133,
                "y": 0.02005121111869812,
                "z": -364.9348449707031
            },
            {
                "x": 1.5793973207473755,
                "y": 0.020043596625328064,
                "z": -364.781494140625
            },
            {
                "x": 1.6109716892242432,
                "y": 0.02003602683544159,
                "z": -364.62890625
            },
            {
                "x": 1.6429328918457031,
                "y": 0.02002839744091034,
                "z": -364.4762878417969
            },
            {
                "x": 1.6753079891204834,
                "y": 0.02002076804637909,
                "z": -364.3233642578125
            },
            {
                "x": 1.707911729812622,
                "y": 0.020013198256492615,
                "z": -364.1702575683594
            },
            {
                "x": 1.7406996488571167,
                "y": 0.020005568861961365,
                "z": -364.0173645019531
            },
            {
                "x": 1.773696780204773,
                "y": 0.019997969269752502,
                "z": -363.86505126953125
            },
            {
                "x": 1.8070998191833496,
                "y": 0.01999032497406006,
                "z": -363.712646484375
            },
            {
                "x": 1.8408818244934082,
                "y": 0.019982755184173584,
                "z": -363.55975341796875
            },
            {
                "x": 1.8748188018798828,
                "y": 0.019975200295448303,
                "z": -363.406982421875
            },
            {
                "x": 1.9089213609695435,
                "y": 0.01996760070323944,
                "z": -363.25457763671875
            },
            {
                "x": 1.9433215856552124,
                "y": 0.019959941506385803,
                "z": -363.1024475097656
            },
            {
                "x": 1.9781056642532349,
                "y": 0.01995234191417694,
                "z": -362.9501647949219
            },
            {
                "x": 2.013171434402466,
                "y": 0.01994471251964569,
                "z": -362.79754638671875
            },
            {
                "x": 2.0483741760253906,
                "y": 0.01993715763092041,
                "z": -362.6451416015625
            },
            {
                "x": 2.0837624073028564,
                "y": 0.019929543137550354,
                "z": -362.4932556152344
            },
            {
                "x": 2.11952805519104,
                "y": 0.019921913743019104,
                "z": -362.3412780761719
            },
            {
                "x": 2.15563702583313,
                "y": 0.01991438865661621,
                "z": -362.1890563964844
            },
            {
                "x": 2.191962957382202,
                "y": 0.019906744360923767,
                "z": -362.0366516113281
            },
            {
                "x": 2.2284023761749268,
                "y": 0.019899100065231323,
                "z": -361.8846740722656
            },
            {
                "x": 2.265078544616699,
                "y": 0.019891515374183655,
                "z": -361.7330322265625
            },
            {
                "x": 2.3021507263183594,
                "y": 0.019883856177330017,
                "z": -361.5811462402344
            },
            {
                "x": 2.339493989944458,
                "y": 0.019876331090927124,
                "z": -361.42913818359375
            },
            {
                "x": 2.3770108222961426,
                "y": 0.019868671894073486,
                "z": -361.277099609375
            },
            {
                "x": 2.414680242538452,
                "y": 0.019861087203025818,
                "z": -361.1253967285156
            },
            {
                "x": 2.4525704383850098,
                "y": 0.019853517413139343,
                "z": -360.9739990234375
            },
            {
                "x": 2.4908552169799805,
                "y": 0.019845932722091675,
                "z": -360.8223876953125
            },
            {
                "x": 2.5294058322906494,
                "y": 0.019838303327560425,
                "z": -360.6703796386719
            },
            {
                "x": 2.568035840988159,
                "y": 0.019830703735351562,
                "z": -360.5187683105469
            },
            {
                "x": 2.6068503856658936,
                "y": 0.0198231041431427,
                "z": -360.36749267578125
            },
            {
                "x": 2.645949363708496,
                "y": 0.01981547474861145,
                "z": -360.21630859375
            },
            {
                "x": 2.6853795051574707,
                "y": 0.0198078453540802,
                "z": -360.0649108886719
            },
            {
                "x": 2.7250711917877197,
                "y": 0.019800260663032532,
                "z": -359.9130859375
            },
            {
                "x": 2.764806032180786,
                "y": 0.019792675971984863,
                "z": -359.7618408203125
            },
            {
                "x": 2.804724931716919,
                "y": 0.019785046577453613,
                "z": -359.6108703613281
            },
            {
                "x": 2.830686569213867,
                "y": 0.019780099391937256,
                "z": -359.5133361816406
            },
            {
                "x": 2.8711330890655518,
                "y": 0.019772499799728394,
                "z": -359.3621826171875
            },
            {
                "x": 2.9117884635925293,
                "y": 0.019764885306358337,
                "z": -359.210693359375
            },
            {
                "x": 2.952537775039673,
                "y": 0.019757315516471863,
                "z": -359.0596008300781
            },
            {
                "x": 2.9934637546539307,
                "y": 0.019749686121940613,
                "z": -358.90887451171875
            },
            {
                "x": 3.034719228744507,
                "y": 0.019742026925086975,
                "z": -358.7580261230469
            },
            {
                "x": 3.0762293338775635,
                "y": 0.019734472036361694,
                "z": -358.6069641113281
            },
            {
                "x": 3.117896318435669,
                "y": 0.019726857542991638,
                "z": -358.4559020996094
            },
            {
                "x": 3.1596951484680176,
                "y": 0.01971927285194397,
                "z": -358.3050231933594
            },
            {
                "x": 3.2016515731811523,
                "y": 0.019711628556251526,
                "z": -358.154541015625
            },
            {
                "x": 3.243924140930176,
                "y": 0.019704028964042664,
                "z": -358.00390625
            },
            {
                "x": 3.2864432334899902,
                "y": 0.019696369767189026,
                "z": -357.8529357910156
            },
            {
                "x": 3.329052686691284,
                "y": 0.019688814878463745,
                "z": -357.7022399902344
            },
            {
                "x": 3.371819019317627,
                "y": 0.019681185483932495,
                "z": -357.55169677734375
            },
            {
                "x": 3.4147825241088867,
                "y": 0.019673600792884827,
                "z": -357.40142822265625
            },
            {
                "x": 3.4580438137054443,
                "y": 0.019666001200675964,
                "z": -357.25091552734375
            },
            {
                "x": 3.501512050628662,
                "y": 0.019658386707305908,
                "z": -357.1001892089844
            },
            {
                "x": 3.5450398921966553,
                "y": 0.019650787115097046,
                "z": -356.9497985839844
            },
            {
                "x": 3.5887229442596436,
                "y": 0.019643113017082214,
                "z": -356.799560546875
            },
            {
                "x": 3.6326544284820557,
                "y": 0.019635528326034546,
                "z": -356.6493835449219
            },
            {
                "x": 3.676859140396118,
                "y": 0.019627973437309265,
                "z": -356.4990234375
            },
            {
                "x": 3.7211639881134033,
                "y": 0.019620388746261597,
                "z": -356.3486022949219
            },
            {
                "x": 3.7655484676361084,
                "y": 0.019612789154052734,
                "z": -356.1986083984375
            },
            {
                "x": 3.8100967407226562,
                "y": 0.019605129957199097,
                "z": -356.0487976074219
            },
            {
                "x": 3.8550100326538086,
                "y": 0.019597560167312622,
                "z": -355.89849853515625
            },
            {
                "x": 3.9000601768493652,
                "y": 0.019589915871620178,
                "z": -355.74835205078125
            },
            {
                "x": 3.9451968669891357,
                "y": 0.01958233118057251,
                "z": -355.5982666015625
            },
            {
                "x": 3.990447521209717,
                "y": 0.019574716687202454,
                "z": -355.4483947753906
            },
            {
                "x": 4.035869598388672,
                "y": 0.01956707239151001,
                "z": -355.2987365722656
            },
            {
                "x": 4.0816144943237305,
                "y": 0.01955944299697876,
                "z": -355.14874267578125
            },
            {
                "x": 4.127464771270752,
                "y": 0.019551873207092285,
                "z": -354.99871826171875
            },
            {
                "x": 4.173387050628662,
                "y": 0.019544288516044617,
                "z": -354.8489074707031
            },
            {
                "x": 4.219459533691406,
                "y": 0.019536703824996948,
                "z": -354.69927978515625
            },
            {
                "x": 4.265708923339844,
                "y": 0.019529148936271667,
                "z": -354.5497741699219
            },
            {
                "x": 4.312225818634033,
                "y": 0.01952153444290161,
                "z": -354.39990234375
            },
            {
                "x": 4.358852386474609,
                "y": 0.019513919949531555,
                "z": -354.2500305175781
            },
            {
                "x": 4.405509948730469,
                "y": 0.01950635015964508,
                "z": -354.1006164550781
            },
            {
                "x": 4.452359676361084,
                "y": 0.019498661160469055,
                "z": -353.9510803222656
            },
            {
                "x": 4.499368190765381,
                "y": 0.01949109137058258,
                "z": -353.8017578125
            },
            {
                "x": 4.546605587005615,
                "y": 0.019483506679534912,
                "z": -353.6521301269531
            },
            {
                "x": 4.5939836502075195,
                "y": 0.019475862383842468,
                "z": -353.50244140625
            },
            {
                "x": 4.6413397789001465,
                "y": 0.0194682776927948,
                "z": -353.3531799316406
            },
            {
                "x": 4.68887186050415,
                "y": 0.019460290670394897,
                "z": -353.2039794921875
            },
            {
                "x": 4.719692230224609,
                "y": 0.019455760717391968,
                "z": -353.1075744628906
            },
            {
                "x": 4.767563343048096,
                "y": 0.019448116421699524,
                "z": -352.9581604003906
            },
            {
                "x": 4.815532207489014,
                "y": 0.019440457224845886,
                "z": -352.8087463378906
            },
            {
                "x": 4.863574028015137,
                "y": 0.019432872533798218,
                "z": -352.6595458984375
            },
            {
                "x": 4.911719799041748,
                "y": 0.01942528784275055,
                "z": -352.5105285644531
            },
            {
                "x": 4.960113525390625,
                "y": 0.01941770315170288,
                "z": -352.3612976074219
            },
            {
                "x": 5.008631706237793,
                "y": 0.019410088658332825,
                "z": -352.2120056152344
            },
            {
                "x": 5.05717658996582,
                "y": 0.019402459263801575,
                "z": -352.06292724609375
            },
            {
                "x": 5.105862140655518,
                "y": 0.019394859671592712,
                "z": -351.9139099121094
            },
            {
                "x": 5.154674053192139,
                "y": 0.019387245178222656,
                "z": -351.7649841308594
            },
            {
                "x": 5.203676700592041,
                "y": 0.01937967538833618,
                "z": -351.61590576171875
            },
            {
                "x": 5.252778053283691,
                "y": 0.019372060894966125,
                "z": -351.4668273925781
            },
            {
                "x": 5.301938056945801,
                "y": 0.01936446875333786,
                "z": -351.31787109375
            },
            {
                "x": 5.351217746734619,
                "y": 0.019356831908226013,
                "z": -351.16900634765625
            },
            {
                "x": 5.400615215301514,
                "y": 0.01934920996427536,
                "z": -351.0202331542969
            },
            {
                "x": 5.450149059295654,
                "y": 0.019341647624969482,
                "z": -350.8714294433594
            },
            {
                "x": 5.499858379364014,
                "y": 0.01933404803276062,
                "z": -350.72235107421875
            },
            {
                "x": 5.549533843994141,
                "y": 0.01932641863822937,
                "z": -350.5736389160156
            },
            {
                "x": 5.599354267120361,
                "y": 0.019318804144859314,
                "z": -350.42498779296875
            },
            {
                "x": 5.649339199066162,
                "y": 0.01931121200323105,
                "z": -350.27618408203125
            },
            {
                "x": 5.699403762817383,
                "y": 0.019433043897151947,
                "z": -350.1275329589844
            },
            {
                "x": 5.749523162841797,
                "y": 0.019868480041623116,
                "z": -349.9788513183594
            },
            {
                "x": 5.799684524536133,
                "y": 0.02060985006392002,
                "z": -349.830322265625
            },
            {
                "x": 5.8499860763549805,
                "y": 0.021653905510902405,
                "z": -349.681884765625
            },
            {
                "x": 5.900496006011963,
                "y": 0.023005083203315735,
                "z": -349.533203125
            },
            {
                "x": 5.9510297775268555,
                "y": 0.02465805970132351,
                "z": -349.38458251953125
            },
            {
                "x": 6.001636028289795,
                "y": 0.026600917801260948,
                "z": -349.23602294921875
            },
            {
                "x": 6.052301406860352,
                "y": 0.028828248381614685,
                "z": -349.087646484375
            },
            {
                "x": 6.103037357330322,
                "y": 0.03133952617645264,
                "z": -348.9394226074219
            },
            {
                "x": 6.154006481170654,
                "y": 0.03414434194564819,
                "z": -348.7907409667969
            },
            {
                "x": 6.204965591430664,
                "y": 0.03721817210316658,
                "z": -348.6423034667969
            },
            {
                "x": 6.255956172943115,
                "y": 0.04055851697921753,
                "z": -348.49395751953125
            },
            {
                "x": 6.307043552398682,
                "y": 0.04416748881340027,
                "z": -348.3456726074219
            },
            {
                "x": 6.358232498168945,
                "y": 0.04804474115371704,
                "z": -348.19744873046875
            },
            {
                "x": 6.409560203552246,
                "y": 0.05218305066227913,
                "z": -348.04901123046875
            },
            {
                "x": 6.46093225479126,
                "y": 0.056572433561086655,
                "z": -347.900634765625
            },
            {
                "x": 6.512303829193115,
                "y": 0.06120722368359566,
                "z": -347.75244140625
            },
            {
                "x": 6.563773155212402,
                "y": 0.06609374284744263,
                "z": -347.60430908203125
            },
            {
                "x": 6.6153411865234375,
                "y": 0.0712207555770874,
                "z": -347.4561462402344
            },
            {
                "x": 6.666968822479248,
                "y": 0.07658196985721588,
                "z": -347.3079833984375
            },
            {
                "x": 6.718707084655762,
                "y": 0.08218328654766083,
                "z": -347.1595764160156
            },
            {
                "x": 6.770390510559082,
                "y": 0.08800557255744934,
                "z": -347.0115966796875
            },
            {
                "x": 6.822174072265625,
                "y": 0.09405156970024109,
                "z": -346.86358642578125
            },
            {
                "x": 6.855680465698242,
                "y": 0.0980694368481636,
                "z": -346.7679748535156
            },
            {
                "x": 6.90762186050415,
                "y": 0.10448566824197769,
                "z": -346.6198425292969
            },
            {
                "x": 6.9595794677734375,
                "y": 0.11110973358154297,
                "z": -346.47174072265625
            },
            {
                "x": 7.011603355407715,
                "y": 0.11793921887874603,
                "z": -346.32366943359375
            },
            {
                "x": 7.063644886016846,
                "y": 0.12496509402990341,
                "z": -346.17578125
            },
            {
                "x": 7.115806579589844,
                "y": 0.1322026401758194,
                "z": -346.02777099609375
            },
            {
                "x": 7.168004989624023,
                "y": 0.13963457942008972,
                "z": -345.8797607421875
            },
            {
                "x": 7.220210552215576,
                "y": 0.14725235104560852,
                "z": -345.7318420410156
            },
            {
                "x": 7.272505283355713,
                "y": 0.15506047010421753,
                "z": -345.5838317871094
            },
            {
                "x": 7.324799537658691,
                "y": 0.16304627060890198,
                "z": -345.43603515625
            },
            {
                "x": 7.377187728881836,
                "y": 0.17121684551239014,
                "z": -345.2880859375
            },
            {
                "x": 7.4296064376831055,
                "y": 0.17955906689167023,
                "z": -345.1401672363281
            },
            {
                "x": 7.482023239135742,
                "y": 0.1880647987127304,
                "z": -344.99237060546875
            },
            {
                "x": 7.534550666809082,
                "y": 0.1967490315437317,
                "z": -344.84442138671875
            },
            {
                "x": 7.587018013000488,
                "y": 0.2055763304233551,
                "z": -344.6967468261719
            },
            {
                "x": 7.639605522155762,
                "y": 0.21457286179065704,
                "z": -344.54888916015625
            },
            {
                "x": 7.692200660705566,
                "y": 0.22371788322925568,
                "z": -344.4009704589844
            },
            {
                "x": 7.744797706604004,
                "y": 0.23300643265247345,
                "z": -344.2533264160156
            },
            {
                "x": 7.797443389892578,
                "y": 0.2424418032169342,
                "z": -344.1055603027344
            },
            {
                "x": 7.850181579589844,
                "y": 0.2520257532596588,
                "z": -343.9576721191406
            },
            {
                "x": 7.9028801918029785,
                "y": 0.2617327570915222,
                "z": -343.8099670410156
            },
            {
                "x": 7.955564022064209,
                "y": 0.2715652287006378,
                "z": -343.6623229980469
            },
            {
                "x": 8.008317947387695,
                "y": 0.2815341353416443,
                "z": -343.5146179199219
            },
            {
                "x": 8.06104850769043,
                "y": 0.29161450266838074,
                "z": -343.3670349121094
            },
            {
                "x": 8.113903999328613,
                "y": 0.3018288016319275,
                "z": -343.21917724609375
            },
            {
                "x": 8.166708946228027,
                "y": 0.31214505434036255,
                "z": -343.071533203125
            },
            {
                "x": 8.219536781311035,
                "y": 0.32257428765296936,
                "z": -342.9238586425781
            },
            {
                "x": 8.2723970413208,
                "y": 0.33311110734939575,
                "z": -342.776123046875
            },
            {
                "x": 8.325240135192871,
                "y": 0.34373852610588074,
                "z": -342.6285095214844
            },
            {
                "x": 8.37818431854248,
                "y": 0.3544802963733673,
                "z": -342.4806823730469
            },
            {
                "x": 8.431071281433105,
                "y": 0.36530250310897827,
                "z": -342.3330383300781
            },
            {
                "x": 8.483917236328125,
                "y": 0.3762010931968689,
                "z": -342.1855163574219
            },
            {
                "x": 8.536874771118164,
                "y": 0.38720065355300903,
                "z": -342.0377502441406
            },
            {
                "x": 8.589791297912598,
                "y": 0.39827173948287964,
                "z": -341.8901062011719
            },
            {
                "x": 8.64273738861084,
                "y": 0.4094276428222656,
                "z": -341.7423400878906
            },
            {
                "x": 8.695664405822754,
                "y": 0.4206480383872986,
                "z": -341.5946350097656
            },
            {
                "x": 8.748579025268555,
                "y": 0.4319297969341278,
                "z": -341.4469909667969
            },
            {
                "x": 8.80151081085205,
                "y": 0.4432780146598816,
                "z": -341.2992858886719
            },
            {
                "x": 8.854455947875977,
                "y": 0.45468568801879883,
                "z": -341.1515808105469
            },
            {
                "x": 8.907362937927246,
                "y": 0.4661425054073334,
                "z": -341.0039367675781
            },
            {
                "x": 8.960321426391602,
                "y": 0.4776592254638672,
                "z": -340.8560791015625
            },
            {
                "x": 9.013225555419922,
                "y": 0.4892081916332245,
                "z": -340.7084045410156
            },
            {
                "x": 9.066110610961914,
                "y": 0.500798225402832,
                "z": -340.5607604980469
            },
            {
                "x": 9.100301742553711,
                "y": 0.5083116888999939,
                "z": -340.46533203125
            },
            {
                "x": 9.153154373168945,
                "y": 0.5199548602104187,
                "z": -340.3176574707031
            },
            {
                "x": 9.20605754852295,
                "y": 0.531640350818634,
                "z": -340.16986083984375
            },
            {
                "x": 9.25894546508789,
                "y": 0.5433504581451416,
                "z": -340.0220947265625
            },
            {
                "x": 9.311790466308594,
                "y": 0.5550761818885803,
                "z": -339.87432861328125
            },
            {
                "x": 9.364639282226562,
                "y": 0.5668234825134277,
                "z": -339.7264709472656
            },
            {
                "x": 9.417414665222168,
                "y": 0.5785717964172363,
                "z": -339.57879638671875
            },
            {
                "x": 9.470181465148926,
                "y": 0.5903278589248657,
                "z": -339.43109130859375
            },
            {
                "x": 9.523022651672363,
                "y": 0.6021063327789307,
                "z": -339.28314208984375
            },
            {
                "x": 9.575757026672363,
                "y": 0.6138696074485779,
                "z": -339.1354064941406
            },
            {
                "x": 9.6284818649292,
                "y": 0.6256345510482788,
                "z": -338.9875183105469
            },
            {
                "x": 9.681159973144531,
                "y": 0.6373831629753113,
                "z": -338.8396911621094
            },
            {
                "x": 9.73381233215332,
                "y": 0.6491140127182007,
                "z": -338.69195556640625
            },
            {
                "x": 9.786532402038574,
                "y": 0.6608502864837646,
                "z": -338.5438537597656
            },
            {
                "x": 9.839136123657227,
                "y": 0.672549843788147,
                "z": -338.3959655761719
            },
            {
                "x": 9.891677856445312,
                "y": 0.6842166185379028,
                "z": -338.24810791015625
            },
            {
                "x": 9.94422435760498,
                "y": 0.6958597898483276,
                "z": -338.10015869140625
            },
            {
                "x": 9.996722221374512,
                "y": 0.7074626088142395,
                "z": -337.9523010253906
            },
            {
                "x": 10.049248695373535,
                "y": 0.7190415859222412,
                "z": -337.80413818359375
            },
            {
                "x": 10.1016845703125,
                "y": 0.7305693626403809,
                "z": -337.6560974121094
            },
            {
                "x": 10.154045104980469,
                "y": 0.7420413494110107,
                "z": -337.50811767578125
            },
            {
                "x": 10.206369400024414,
                "y": 0.7534581422805786,
                "z": -337.3601989746094
            },
            {
                "x": 10.258691787719727,
                "y": 0.7648277282714844,
                "z": -337.2121276855469
            },
            {
                "x": 10.31097412109375,
                "y": 0.7761407494544983,
                "z": -337.0639343261719
            },
            {
                "x": 10.363234519958496,
                "y": 0.787397027015686,
                "z": -336.9156188964844
            },
            {
                "x": 10.4153470993042,
                "y": 0.7985643744468689,
                "z": -336.76751708984375
            },
            {
                "x": 10.467459678649902,
                "y": 0.8096652030944824,
                "z": -336.619384765625
            },
            {
                "x": 10.519543647766113,
                "y": 0.8206954002380371,
                "z": -336.4710693359375
            },
            {
                "x": 10.571524620056152,
                "y": 0.8316341638565063,
                "z": -336.3228454589844
            },
            {
                "x": 10.62351131439209,
                "y": 0.842502236366272,
                "z": -336.1744079589844
            },
            {
                "x": 10.67536735534668,
                "y": 0.853259801864624,
                "z": -336.02618408203125
            },
            {
                "x": 10.72721004486084,
                "y": 0.8639292120933533,
                "z": -335.87786865234375
            },
            {
                "x": 10.779031753540039,
                "y": 0.8745099306106567,
                "z": -335.72930908203125
            },
            {
                "x": 10.83072280883789,
                "y": 0.884978175163269,
                "z": -335.58087158203125
            },
            {
                "x": 10.882372856140137,
                "y": 0.8953406810760498,
                "z": -335.4324035644531
            },
            {
                "x": 10.933967590332031,
                "y": 0.9055880904197693,
                "z": -335.283935546875
            },
            {
                "x": 10.98551082611084,
                "y": 0.9157204031944275,
                "z": -335.1353759765625
            },
            {
                "x": 11.037008285522461,
                "y": 0.9257438778877258,
                "z": -334.986572265625
            },
            {
                "x": 11.088350296020508,
                "y": 0.9356308579444885,
                "z": -334.8379821777344
            },
            {
                "x": 11.1395902633667,
                "y": 0.9453785419464111,
                "z": -334.6894226074219
            },
            {
                "x": 11.190882682800293,
                "y": 0.955007791519165,
                "z": -334.5406188964844
            },
            {
                "x": 11.24207878112793,
                "y": 0.9644986391067505,
                "z": -334.3918151855469
            },
            {
                "x": 11.293111801147461,
                "y": 0.9738438129425049,
                "z": -334.24298095703125
            },
            {
                "x": 11.326067924499512,
                "y": 0.9798036813735962,
                "z": -334.14678955078125
            },
            {
                "x": 11.376934051513672,
                "y": 0.9888926148414612,
                "z": -333.99810791015625
            },
            {
                "x": 11.42780590057373,
                "y": 0.9978353977203369,
                "z": -333.8492431640625
            },
            {
                "x": 11.478669166564941,
                "y": 1.0066378116607666,
                "z": -333.7000732421875
            },
            {
                "x": 11.529358863830566,
                "y": 1.0152629613876343,
                "z": -333.551025390625
            },
            {
                "x": 11.579935073852539,
                "y": 1.0237209796905518,
                "z": -333.4019775390625
            },
            {
                "x": 11.630410194396973,
                "y": 1.03200101852417,
                "z": -333.2529602050781
            },
            {
                "x": 11.6808500289917,
                "y": 1.0401153564453125,
                "z": -333.1037902832031
            },
            {
                "x": 11.731269836425781,
                "y": 1.0480598211288452,
                "z": -332.9543151855469
            },
            {
                "x": 11.781455993652344,
                "y": 1.0558052062988281,
                "z": -332.8050842285156
            },
            {
                "x": 11.831524848937988,
                "y": 1.063358187675476,
                "z": -332.6559143066406
            },
            {
                "x": 11.881569862365723,
                "y": 1.0707253217697144,
                "z": -332.506591796875
            },
            {
                "x": 11.931513786315918,
                "y": 1.0778892040252686,
                "z": -332.35723876953125
            },
            {
                "x": 11.981444358825684,
                "y": 1.0848685503005981,
                "z": -332.2074279785156
            },
            {
                "x": 12.031112670898438,
                "y": 1.091625690460205,
                "z": -332.0579833984375
            },
            {
                "x": 12.080665588378906,
                "y": 1.098170518875122,
                "z": -331.9085693359375
            },
            {
                "x": 12.130220413208008,
                "y": 1.1045045852661133,
                "z": -331.7589111328125
            },
            {
                "x": 12.179643630981445,
                "y": 1.1106204986572266,
                "z": -331.60919189453125
            },
            {
                "x": 12.228937149047852,
                "y": 1.116516351699829,
                "z": -331.4593200683594
            },
            {
                "x": 12.278082847595215,
                "y": 1.122183084487915,
                "z": -331.3094787597656
            },
            {
                "x": 12.327037811279297,
                "y": 1.1276018619537354,
                "z": -331.1598815917969
            },
            {
                "x": 12.376020431518555,
                "y": 1.1327931880950928,
                "z": -331.0099792480469
            },
            {
                "x": 12.424846649169922,
                "y": 1.1377469301223755,
                "z": -330.8600158691406
            },
            {
                "x": 12.473490715026855,
                "y": 1.1424548625946045,
                "z": -330.71002197265625
            },
            {
                "x": 12.522049903869629,
                "y": 1.1469112634658813,
                "z": -330.559814453125
            },
            {
                "x": 12.570460319519043,
                "y": 1.151105523109436,
                "z": -330.40985107421875
            },
            {
                "x": 12.618812561035156,
                "y": 1.1550488471984863,
                "z": -330.2596435546875
            },
            {
                "x": 12.667014122009277,
                "y": 1.1587344408035278,
                "z": -330.1092529296875
            },
            {
                "x": 12.71497917175293,
                "y": 1.1621417999267578,
                "z": -329.9590148925781
            },
            {
                "x": 12.76286792755127,
                "y": 1.1652758121490479,
                "z": -329.8086853027344
            },
            {
                "x": 12.81063175201416,
                "y": 1.1681348085403442,
                "z": -329.65838623046875
            },
            {
                "x": 12.858307838439941,
                "y": 1.170719861984253,
                "z": -329.5078430175781
            },
            {
                "x": 12.905814170837402,
                "y": 1.1730177402496338,
                "z": -329.3571472167969
            },
            {
                "x": 12.953043937683105,
                "y": 1.1750156879425049,
                "z": -329.2066955566406
            },
            {
                "x": 13.000219345092773,
                "y": 1.1767246723175049,
                "z": -329.05615234375
            },
            {
                "x": 13.047319412231445,
                "y": 1.1781399250030518,
                "z": -328.9053955078125
            },
            {
                "x": 13.094252586364746,
                "y": 1.1792502403259277,
                "z": -328.7545166015625
            },
            {
                "x": 13.140959739685059,
                "y": 1.1800470352172852,
                "z": -328.60357666015625
            },
            {
                "x": 13.187437057495117,
                "y": 1.180535078048706,
                "z": -328.4529113769531
            },
            {
                "x": 13.233827590942383,
                "y": 1.180710792541504,
                "z": -328.3022155761719
            },
            {
                "x": 13.28022289276123,
                "y": 1.180564284324646,
                "z": -328.15087890625
            },
            {
                "x": 13.326305389404297,
                "y": 1.180095911026001,
                "z": -327.99969482421875
            },
            {
                "x": 13.3721342086792,
                "y": 1.179319977760315,
                "z": -327.84869384765625
            },
            {
                "x": 13.401664733886719,
                "y": 1.1786608695983887,
                "z": -327.7512512207031
            },
            {
                "x": 13.44728946685791,
                "y": 1.1773760318756104,
                "z": -327.6002502441406
            },
            {
                "x": 13.492851257324219,
                "y": 1.1757903099060059,
                "z": -327.44879150390625
            },
            {
                "x": 13.53818130493164,
                "y": 1.1739110946655273,
                "z": -327.29730224609375
            },
            {
                "x": 13.583229064941406,
                "y": 1.1717441082000732,
                "z": -327.14605712890625
            },
            {
                "x": 13.628138542175293,
                "y": 1.169282078742981,
                "z": -326.9947814941406
            },
            {
                "x": 13.67293643951416,
                "y": 1.166537880897522,
                "z": -326.84332275390625
            },
            {
                "x": 13.717570304870605,
                "y": 1.1635135412216187,
                "z": -326.6916809082031
            },
            {
                "x": 13.761980056762695,
                "y": 1.1602141857147217,
                "z": -326.539794921875
            },
            {
                "x": 13.806066513061523,
                "y": 1.1566474437713623,
                "z": -326.388427734375
            },
            {
                "x": 13.850058555603027,
                "y": 1.1528159379959106,
                "z": -326.2369384765625
            },
            {
                "x": 13.893964767456055,
                "y": 1.1487171649932861,
                "z": -326.08502197265625
            },
            {
                "x": 13.937625885009766,
                "y": 1.1443617343902588,
                "z": -325.9330139160156
            },
            {
                "x": 13.981019973754883,
                "y": 1.1397473812103271,
                "z": -325.7810974121094
            },
            {
                "x": 14.024166107177734,
                "y": 1.1348985433578491,
                "z": -325.6294250488281
            },
            {
                "x": 14.067216873168945,
                "y": 1.1298024654388428,
                "z": -325.47760009765625
            },
            {
                "x": 14.110136985778809,
                "y": 1.1244564056396484,
                "z": -325.32525634765625
            },
            {
                "x": 14.15273380279541,
                "y": 1.1188716888427734,
                "z": -325.1730041503906
            },
            {
                "x": 14.19504451751709,
                "y": 1.113069772720337,
                "z": -325.02105712890625
            },
            {
                "x": 14.23724365234375,
                "y": 1.1070410013198853,
                "z": -324.8689880371094
            },
            {
                "x": 14.279291152954102,
                "y": 1.1007853746414185,
                "z": -324.7167053222656
            },
            {
                "x": 14.321084022521973,
                "y": 1.0942986011505127,
                "z": -324.56414794921875
            },
            {
                "x": 14.362550735473633,
                "y": 1.087611436843872,
                "z": -324.4118347167969
            },
            {
                "x": 14.40377140045166,
                "y": 1.0807301998138428,
                "z": -324.2597351074219
            },
            {
                "x": 14.444954872131348,
                "y": 1.0736260414123535,
                "z": -324.107177734375
            },
            {
                "x": 14.485908508300781,
                "y": 1.0663113594055176,
                "z": -323.9544372558594
            },
            {
                "x": 14.5265531539917,
                "y": 1.058800458908081,
                "z": -323.8016662597656
            },
            {
                "x": 14.56687068939209,
                "y": 1.0511189699172974,
                "z": -323.6491394042969
            },
            {
                "x": 14.607025146484375,
                "y": 1.0432558059692383,
                "z": -323.4967041015625
            },
            {
                "x": 14.647089004516602,
                "y": 1.0351791381835938,
                "z": -323.3437194824219
            },
            {
                "x": 14.686851501464844,
                "y": 1.0269235372543335,
                "z": -323.19061279296875
            },
            {
                "x": 14.726261138916016,
                "y": 1.0185075998306274,
                "z": -323.0377197265625
            },
            {
                "x": 14.76540470123291,
                "y": 1.009937047958374,
                "z": -322.885009765625
            },
            {
                "x": 14.804400444030762,
                "y": 1.0011950731277466,
                "z": -322.7321472167969
            },
            {
                "x": 14.843257904052734,
                "y": 0.9922619462013245,
                "z": -322.5787353515625
            },
            {
                "x": 14.881767272949219,
                "y": 0.9831768274307251,
                "z": -322.42535400390625
            },
            {
                "x": 14.919896125793457,
                "y": 0.9739698171615601,
                "z": -322.2723693847656
            },
            {
                "x": 14.957855224609375,
                "y": 0.9646103978157043,
                "z": -322.1192932128906
            },
            {
                "x": 14.995662689208984,
                "y": 0.9550915360450745,
                "z": -321.9659423828125
            },
            {
                "x": 15.033194541931152,
                "y": 0.9454212188720703,
                "z": -321.8122863769531
            },
            {
                "x": 15.07040023803711,
                "y": 0.9356160759925842,
                "z": -321.6585388183594
            },
            {
                "x": 15.107216835021973,
                "y": 0.9257228374481201,
                "z": -321.5054626464844
            },
            {
                "x": 15.1439208984375,
                "y": 0.9156829714775085,
                "z": -321.35205078125
            },
            {
                "x": 15.167546272277832,
                "y": 0.9091204404830933,
                "z": -321.252685546875
            },
            {
                "x": 15.203829765319824,
                "y": 0.898859977722168,
                "z": -321.0987548828125
            },
            {
                "x": 15.239739418029785,
                "y": 0.8884899616241455,
                "z": -320.94488525390625
            },
            {
                "x": 15.275338172912598,
                "y": 0.8780385255813599,
                "z": -320.7913818359375
            },
            {
                "x": 15.310790061950684,
                "y": 0.8674700260162354,
                "z": -320.63763427734375
            },
            {
                "x": 15.346049308776855,
                "y": 0.8567662239074707,
                "z": -320.4833679199219
            },
            {
                "x": 15.38086986541748,
                "y": 0.8459767699241638,
                "z": -320.3291931152344
            },
            {
                "x": 15.415312767028809,
                "y": 0.8351225256919861,
                "z": -320.17535400390625
            },
            {
                "x": 15.449605941772461,
                "y": 0.824171245098114,
                "z": -320.0213623046875
            },
            {
                "x": 15.483675003051758,
                "y": 0.8131242990493774,
                "z": -319.86712646484375
            },
            {
                "x": 15.517440795898438,
                "y": 0.8019701838493347,
                "z": -319.7124938964844
            },
            {
                "x": 15.550765037536621,
                "y": 0.7907646894454956,
                "z": -319.5580749511719
            },
            {
                "x": 15.583751678466797,
                "y": 0.77951979637146,
                "z": -319.404052734375
            },
            {
                "x": 15.616634368896484,
                "y": 0.7681796550750732,
                "z": -319.2496032714844
            },
            {
                "x": 15.649229049682617,
                "y": 0.7567551732063293,
                "z": -319.0948486328125
            },
            {
                "x": 15.68140983581543,
                "y": 0.7452781796455383,
                "z": -318.9400329589844
            },
            {
                "x": 15.713214874267578,
                "y": 0.7337689399719238,
                "z": -318.7854309082031
            },
            {
                "x": 15.74476146697998,
                "y": 0.7222307324409485,
                "z": -318.631103515625
            },
            {
                "x": 15.776130676269531,
                "y": 0.7106040120124817,
                "z": -318.4761657714844
            },
            {
                "x": 15.807145118713379,
                "y": 0.6989179253578186,
                "z": -318.32086181640625
            },
            {
                "x": 15.837693214416504,
                "y": 0.6872283220291138,
                "z": -318.1659240722656
            },
            {
                "x": 15.867905616760254,
                "y": 0.6755359172821045,
                "z": -318.0113525390625
            },
            {
                "x": 15.89794635772705,
                "y": 0.663793683052063,
                "z": -317.8564147949219
            },
            {
                "x": 15.927694320678711,
                "y": 0.6519957780838013,
                "z": -317.7010498046875
            },
            {
                "x": 15.957045555114746,
                "y": 0.6401656866073608,
                "z": -317.54541015625
            },
            {
                "x": 15.985919952392578,
                "y": 0.6283756494522095,
                "z": -317.3904113769531
            },
            {
                "x": 16.014583587646484,
                "y": 0.6165728569030762,
                "z": -317.2353515625
            },
            {
                "x": 16.04301643371582,
                "y": 0.6047284603118896,
                "z": -317.0798034667969
            },
            {
                "x": 16.071043014526367,
                "y": 0.592868447303772,
                "z": -316.9239501953125
            },
            {
                "x": 16.098630905151367,
                "y": 0.5810238122940063,
                "z": -316.7682800292969
            },
            {
                "x": 16.125839233398438,
                "y": 0.569226861000061,
                "z": -316.6130065917969
            },
            {
                "x": 16.152841567993164,
                "y": 0.5574265718460083,
                "z": -316.4575500488281
            },
            {
                "x": 16.179569244384766,
                "y": 0.5455898642539978,
                "z": -316.30133056640625
            },
            {
                "x": 16.20578956604004,
                "y": 0.5337918400764465,
                "z": -316.1453552246094
            },
            {
                "x": 16.231599807739258,
                "y": 0.5220414400100708,
                "z": -315.98956298828125
            },
            {
                "x": 16.25713348388672,
                "y": 0.5103325843811035,
                "z": -315.8339538574219
            },
            {
                "x": 16.28241539001465,
                "y": 0.4986189603805542,
                "z": -315.677734375
            },
            {
                "x": 16.307281494140625,
                "y": 0.4869183301925659,
                "z": -315.52117919921875
            },
            {
                "x": 16.33163070678711,
                "y": 0.47529667615890503,
                "z": -315.3650207519531
            },
            {
                "x": 16.355628967285156,
                "y": 0.46374934911727905,
                "z": -315.209228515625
            },
            {
                "x": 16.379438400268555,
                "y": 0.4522104263305664,
                "z": -315.0528869628906
            },
            {
                "x": 16.40285873413086,
                "y": 0.4407045841217041,
                "z": -314.89617919921875
            },
            {
                "x": 16.425748825073242,
                "y": 0.4292677640914917,
                "z": -314.739501953125
            },
            {
                "x": 16.4403018951416,
                "y": 0.4219346344470978,
                "z": -314.6385192871094
            },
            {
                "x": 16.462583541870117,
                "y": 0.4106481671333313,
                "z": -314.482421875
            },
            {
                "x": 16.48464012145996,
                "y": 0.39939039945602417,
                "z": -314.32574462890625
            },
            {
                "x": 16.506271362304688,
                "y": 0.3881765305995941,
                "z": -314.1685485839844
            },
            {
                "x": 16.527339935302734,
                "y": 0.3770711421966553,
                "z": -314.0116271972656
            },
            {
                "x": 16.548017501831055,
                "y": 0.3660779595375061,
                "z": -313.85516357421875
            },
            {
                "x": 16.56845474243164,
                "y": 0.35516148805618286,
                "z": -313.69854736328125
            },
            {
                "x": 16.588539123535156,
                "y": 0.3442941904067993,
                "z": -313.541259765625
            },
            {
                "x": 16.60810089111328,
                "y": 0.3335118889808655,
                "z": -313.3836975097656
            },
            {
                "x": 16.627140045166016,
                "y": 0.3228811025619507,
                "z": -313.2268371582031
            },
            {
                "x": 16.645889282226562,
                "y": 0.312360942363739,
                "z": -313.0701599121094
            },
            {
                "x": 16.66436195373535,
                "y": 0.30190908908843994,
                "z": -312.91278076171875
            },
            {
                "x": 16.682323455810547,
                "y": 0.2915538549423218,
                "z": -312.7550354003906
            },
            {
                "x": 16.69975471496582,
                "y": 0.2813287675380707,
                "z": -312.5975036621094
            },
            {
                "x": 16.71677589416504,
                "y": 0.2712692618370056,
                "z": -312.44061279296875
            },
            {
                "x": 16.733543395996094,
                "y": 0.26130980253219604,
                "z": -312.2832946777344
            },
            {
                "x": 16.74989128112793,
                "y": 0.2514389753341675,
                "z": -312.12530517578125
            },
            {
                "x": 16.76565170288086,
                "y": 0.24171584844589233,
                "z": -311.9673767089844
            },
            {
                "x": 16.780933380126953,
                "y": 0.23216363787651062,
                "z": -311.81005859375
            },
            {
                "x": 16.795949935913086,
                "y": 0.22274819016456604,
                "z": -311.65264892578125
            },
            {
                "x": 16.810585021972656,
                "y": 0.21345221996307373,
                "z": -311.4946594238281
            },
            {
                "x": 16.824661254882812,
                "y": 0.20429490506649017,
                "z": -311.3363952636719
            },
            {
                "x": 16.838178634643555,
                "y": 0.195320263504982,
                "z": -311.1785888671875
            },
            {
                "x": 16.85133934020996,
                "y": 0.186529278755188,
                "z": -311.0213317871094
            },
            {
                "x": 16.86421775817871,
                "y": 0.17786122858524323,
                "z": -310.8631286621094
            },
            {
                "x": 16.876569747924805,
                "y": 0.16934357583522797,
                "z": -310.7046203613281
            },
            {
                "x": 16.888328552246094,
                "y": 0.16100916266441345,
                "z": -310.54632568359375
            },
            {
                "x": 16.899625778198242,
                "y": 0.1528805047273636,
                "z": -310.3885498046875
            },
            {
                "x": 16.910621643066406,
                "y": 0.14493340253829956,
                "z": -310.2307434082031
            },
            {
                "x": 16.921205520629883,
                "y": 0.13712307810783386,
                "z": -310.07196044921875
            },
            {
                "x": 16.93117332458496,
                "y": 0.12950703501701355,
                "z": -309.9132995605469
            },
            {
                "x": 16.940589904785156,
                "y": 0.12211105227470398,
                "z": -309.7552185058594
            },
            {
                "x": 16.949665069580078,
                "y": 0.11492264270782471,
                "z": -309.59722900390625
            },
            {
                "x": 16.9583740234375,
                "y": 0.10791177302598953,
                "z": -309.43878173828125
            },
            {
                "x": 16.966520309448242,
                "y": 0.10108017176389694,
                "z": -309.2796936035156
            },
            {
                "x": 16.974050521850586,
                "y": 0.09447623789310455,
                "z": -309.1210632324219
            },
            {
                "x": 16.98114585876465,
                "y": 0.08811748772859573,
                "z": -308.9631042480469
            },
            {
                "x": 16.987934112548828,
                "y": 0.08195570111274719,
                "z": -308.80462646484375
            },
            {
                "x": 16.994190216064453,
                "y": 0.0759923979640007,
                "z": -308.6455383300781
            },
            {
                "x": 16.999813079833984,
                "y": 0.07025732100009918,
                "z": -308.486572265625
            },
            {
                "x": 17.004911422729492,
                "y": 0.06477464735507965,
                "z": -308.328125
            },
            {
                "x": 17.00968360900879,
                "y": 0.05953369289636612,
                "z": -308.16986083984375
            },
            {
                "x": 17.014007568359375,
                "y": 0.05450394004583359,
                "z": -308.0108947753906
            },
            {
                "x": 17.016481399536133,
                "y": 0.051374152302742004,
                "z": -307.9079895019531
            },
            {
                "x": 17.019744873046875,
                "y": 0.04675149917602539,
                "z": -307.7489929199219
            },
            {
                "x": 17.022560119628906,
                "y": 0.04239076003432274,
                "z": -307.5906677246094
            },
            {
                "x": 17.025054931640625,
                "y": 0.03827184438705444,
                "z": -307.4320373535156
            },
            {
                "x": 17.02701759338379,
                "y": 0.03439490124583244,
                "z": -307.2727966308594
            },
            {
                "x": 17.028287887573242,
                "y": 0.030782558023929596,
                "z": -307.1134033203125
            },
            {
                "x": 17.029014587402344,
                "y": 0.027449611574411392,
                "z": -306.9548645019531
            },
            {
                "x": 17.029401779174805,
                "y": 0.02438482642173767,
                "z": -306.7964782714844
            },
            {
                "x": 17.02934455871582,
                "y": 0.021574530750513077,
                "z": -306.6371765136719
            },
            {
                "x": 17.028596878051758,
                "y": 0.019045449793338776,
                "z": -306.4776916503906
            },
            {
                "x": 17.0272216796875,
                "y": 0.016801275312900543,
                "z": -306.3186950683594
            },
            {
                "x": 17.025453567504883,
                "y": 0.014845380559563637,
                "z": -306.1603698730469
            },
            {
                "x": 17.023303985595703,
                "y": 0.013171159662306309,
                "z": -306.0015563964844
            },
            {
                "x": 17.0205078125,
                "y": 0.011788565665483475,
                "z": -305.8418884277344
            },
            {
                "x": 17.017030715942383,
                "y": 0.010702868923544884,
                "z": -305.6826477050781
            },
            {
                "x": 17.013059616088867,
                "y": 0.009917199611663818,
                "z": -305.52423095703125
            },
            {
                "x": 17.008745193481445,
                "y": 0.009432362392544746,
                "z": -305.36566162109375
            },
            {
                "x": 17.00387191772461,
                "y": 0.009258540347218513,
                "z": -305.2064208984375
            },
            {
                "x": 16.99827766418457,
                "y": 0.009249985218048096,
                "z": -305.046875
            },
            {
                "x": 16.992090225219727,
                "y": 0.009245052933692932,
                "z": -304.8880615234375
            },
            {
                "x": 16.98554801940918,
                "y": 0.009240180253982544,
                "z": -304.7298278808594
            },
            {
                "x": 16.978534698486328,
                "y": 0.009235255420207977,
                "z": -304.5708923339844
            },
            {
                "x": 16.970821380615234,
                "y": 0.009230278432369232,
                "z": -304.4114990234375
            },
            {
                "x": 16.962434768676758,
                "y": 0.009225405752658844,
                "z": -304.25250244140625
            },
            {
                "x": 16.95360565185547,
                "y": 0.009220488369464874,
                "z": -304.0941162109375
            },
            {
                "x": 16.944385528564453,
                "y": 0.009215563535690308,
                "z": -303.9356689453125
            },
            {
                "x": 16.93452262878418,
                "y": 0.009210653603076935,
                "z": -303.7763671875
            },
            {
                "x": 16.923921585083008,
                "y": 0.009205713868141174,
                "z": -303.6171569824219
            },
            {
                "x": 16.91279411315918,
                "y": 0.009200803935527802,
                "z": -303.4588928222656
            },
            {
                "x": 16.901290893554688,
                "y": 0.009195894002914429,
                "z": -303.30059814453125
            },
            {
                "x": 16.889244079589844,
                "y": 0.00919102132320404,
                "z": -303.14178466796875
            },
            {
                "x": 16.876447677612305,
                "y": 0.009186066687107086,
                "z": -302.98260498046875
            },
            {
                "x": 16.863008499145508,
                "y": 0.009181149303913116,
                "z": -302.8240051269531
            },
            {
                "x": 16.849172592163086,
                "y": 0.009176254272460938,
                "z": -302.6661682128906
            },
            {
                "x": 16.834884643554688,
                "y": 0.009171321988105774,
                "z": -302.5078430175781
            },
            {
                "x": 16.81987762451172,
                "y": 0.009166426956653595,
                "z": -302.3487548828125
            },
            {
                "x": 16.804149627685547,
                "y": 0.009161479771137238,
                "z": -302.1900939941406
            },
            {
                "x": 16.787927627563477,
                "y": 0.009156554937362671,
                "z": -302.0322265625
            },
            {
                "x": 16.771350860595703,
                "y": 0.009151667356491089,
                "z": -301.87451171875
            },
            {
                "x": 16.754131317138672,
                "y": 0.009146764874458313,
                "z": -301.71600341796875
            },
            {
                "x": 16.736106872558594,
                "y": 0.009141802787780762,
                "z": -301.5570983886719
            },
            {
                "x": 16.717506408691406,
                "y": 0.009136945009231567,
                "z": -301.3992919921875
            },
            {
                "x": 16.69855499267578,
                "y": 0.009132020175457,
                "z": -301.2419738769531
            },
            {
                "x": 16.686063766479492,
                "y": 0.009128838777542114,
                "z": -301.1400146484375
            },
            {
                "x": 16.666080474853516,
                "y": 0.009123899042606354,
                "z": -300.98162841796875
            },
            {
                "x": 16.645313262939453,
                "y": 0.009119011461734772,
                "z": -300.82330322265625
            },
            {
                "x": 16.624040603637695,
                "y": 0.009114131331443787,
                "z": -300.66583251953125
            },
            {
                "x": 16.602439880371094,
                "y": 0.009109169244766235,
                "z": -300.5087890625
            },
            {
                "x": 16.580184936523438,
                "y": 0.009104236960411072,
                "z": -300.35089111328125
            },
            {
                "x": 16.55712890625,
                "y": 0.009099319577217102,
                "z": -300.1927795410156
            },
            {
                "x": 16.533443450927734,
                "y": 0.009094417095184326,
                "z": -300.0353698730469
            },
            {
                "x": 16.50937843322754,
                "y": 0.009089559316635132,
                "z": -299.8785400390625
            },
            {
                "x": 16.484844207763672,
                "y": 0.009084612131118774,
                "z": -299.7214660644531
            },
            {
                "x": 16.459510803222656,
                "y": 0.009079709649085999,
                "z": -299.5637512207031
            },
            {
                "x": 16.433425903320312,
                "y": 0.009074732661247253,
                "z": -299.4062805175781
            },
            {
                "x": 16.40690040588379,
                "y": 0.009069874882698059,
                "z": -299.2497863769531
            },
            {
                "x": 16.37997817993164,
                "y": 0.009064897894859314,
                "z": -299.09332275390625
            },
            {
                "x": 16.35239028930664,
                "y": 0.009060010313987732,
                "z": -298.936279296875
            },
            {
                "x": 16.323965072631836,
                "y": 0.009055092930793762,
                "z": -298.7789611816406
            },
            {
                "x": 16.294931411743164,
                "y": 0.00905018299818039,
                "z": -298.6223449707031
            },
            {
                "x": 16.265602111816406,
                "y": 0.009045213460922241,
                "z": -298.4667053222656
            },
            {
                "x": 16.23569679260254,
                "y": 0.009040310978889465,
                "z": -298.31036376953125
            },
            {
                "x": 16.204978942871094,
                "y": 0.009035415947437286,
                "z": -298.1534423828125
            },
            {
                "x": 16.17353057861328,
                "y": 0.00903051346540451,
                "z": -297.9969482421875
            },
            {
                "x": 16.141666412353516,
                "y": 0.009025618433952332,
                "z": -297.8415222167969
            },
            {
                "x": 16.10943031311035,
                "y": 0.009020708501338959,
                "z": -297.6861877441406
            },
            {
                "x": 16.076473236083984,
                "y": 0.009015753865242004,
                "z": -297.5301513671875
            },
            {
                "x": 16.04262351989746,
                "y": 0.009010858833789825,
                "z": -297.37371826171875
            },
            {
                "x": 16.008264541625977,
                "y": 0.009005948901176453,
                "z": -297.2183837890625
            },
            {
                "x": 15.973573684692383,
                "y": 0.009001016616821289,
                "z": -297.063720703125
            },
            {
                "x": 15.93832015991211,
                "y": 0.008996143937110901,
                "z": -296.9085388183594
            },
            {
                "x": 15.902235984802246,
                "y": 0.008991219103336334,
                "z": -296.7528381347656
            },
            {
                "x": 15.865373611450195,
                "y": 0.00898626446723938,
                "z": -296.5974426269531
            },
            {
                "x": 15.828174591064453,
                "y": 0.00898134708404541,
                "z": -296.4432067871094
            },
            {
                "x": 15.790604591369629,
                "y": 0.008976481854915619,
                "z": -296.2890625
            },
            {
                "x": 15.752251625061035,
                "y": 0.00897156447172165,
                "z": -296.1341552734375
            },
            {
                "x": 15.713072776794434,
                "y": 0.008966624736785889,
                "z": -295.9791564941406
            },
            {
                "x": 15.673293113708496,
                "y": 0.008961707353591919,
                "z": -295.8249206542969
            },
            {
                "x": 15.633255004882812,
                "y": 0.008956782519817352,
                "z": -295.6715087890625
            },
            {
                "x": 15.592698097229004,
                "y": 0.008951880037784576,
                "z": -295.51776123046875
            },
            {
                "x": 15.55123233795166,
                "y": 0.008946925401687622,
                "z": -295.3633728027344
            },
            {
                "x": 15.509037017822266,
                "y": 0.008942030370235443,
                "z": -295.2094421386719
            },
            {
                "x": 15.466484069824219,
                "y": 0.008937127888202667,
                "z": -295.05645751953125
            },
            {
                "x": 15.42353630065918,
                "y": 0.008932225406169891,
                "z": -294.9035949707031
            },
            {
                "x": 15.379915237426758,
                "y": 0.008927270770072937,
                "z": -294.7503356933594
            },
            {
                "x": 15.335408210754395,
                "y": 0.008922375738620758,
                "z": -294.5968322753906
            },
            {
                "x": 15.30632209777832,
                "y": 0.008919194340705872,
                "z": -294.4979553222656
            },
            {
                "x": 15.261091232299805,
                "y": 0.008914239704608917,
                "z": -294.345947265625
            },
            {
                "x": 15.215457916259766,
                "y": 0.008909367024898529,
                "z": -294.19384765625
            },
            {
                "x": 15.169037818908691,
                "y": 0.008904464542865753,
                "z": -294.04119873046875
            },
            {
                "x": 15.12180233001709,
                "y": 0.008899502456188202,
                "z": -293.8885803222656
            },
            {
                "x": 15.073979377746582,
                "y": 0.008894644677639008,
                "z": -293.7365417480469
            },
            {
                "x": 15.025921821594238,
                "y": 0.008889742195606232,
                "z": -293.5855407714844
            },
            {
                "x": 14.977388381958008,
                "y": 0.008884802460670471,
                "z": -293.4342956542969
            },
            {
                "x": 14.927924156188965,
                "y": 0.008879892528057098,
                "z": -293.2822570800781
            },
            {
                "x": 14.877762794494629,
                "y": 0.008874967694282532,
                "z": -293.13067626953125
            },
            {
                "x": 14.827186584472656,
                "y": 0.008870087563991547,
                "z": -292.98004150390625
            },
            {
                "x": 14.776337623596191,
                "y": 0.008865125477313995,
                "z": -292.829833984375
            },
            {
                "x": 14.724838256835938,
                "y": 0.008860267698764801,
                "z": -292.67926025390625
            },
            {
                "x": 14.672372817993164,
                "y": 0.008855342864990234,
                "z": -292.5280456542969
            },
            {
                "x": 14.619325637817383,
                "y": 0.008850440382957458,
                "z": -292.377685546875
            },
            {
                "x": 14.56605339050293,
                "y": 0.00884554535150528,
                "z": -292.2283630371094
            },
            {
                "x": 14.51235580444336,
                "y": 0.008840620517730713,
                "z": -292.0789794921875
            },
            {
                "x": 14.457887649536133,
                "y": 0.008835703134536743,
                "z": -291.9290771484375
            },
            {
                "x": 14.40256118774414,
                "y": 0.008828192949295044,
                "z": -291.7791748046875
            },
            {
                "x": 14.34669017791748,
                "y": 0.008592981845140457,
                "z": -291.62994384765625
            },
            {
                "x": 14.290674209594727,
                "y": 0.007781140506267548,
                "z": -291.481689453125
            },
            {
                "x": 14.234193801879883,
                "y": 0.006384023930877447,
                "z": -291.3332214355469
            },
            {
                "x": 14.176801681518555,
                "y": 0.004379287362098694,
                "z": -291.18426513671875
            },
            {
                "x": 14.118654251098633,
                "y": 0.0018051506485790014,
                "z": -291.0356140136719
            },
            {
                "x": 14.060110092163086,
                "y": -0.0013135462068021297,
                "z": -290.8877258300781
            },
            {
                "x": 14.001449584960938,
                "y": -0.004959419369697571,
                "z": -290.7405700683594
            },
            {
                "x": 13.94209098815918,
                "y": -0.009174451231956482,
                "z": -290.5929870605469
            },
            {
                "x": 13.881864547729492,
                "y": -0.013932446949183941,
                "z": -290.445068359375
            },
            {
                "x": 13.821015357971191,
                "y": -0.019196057692170143,
                "z": -290.2976989746094
            },
            {
                "x": 13.759845733642578,
                "y": -0.024938547983765602,
                "z": -290.1511535644531
            },
            {
                "x": 13.698519706726074,
                "y": -0.031167205423116684,
                "z": -290.0051574707031
            },
            {
                "x": 13.636478424072266,
                "y": -0.03790818154811859,
                "z": -289.8587646484375
            },
            {
                "x": 13.573548316955566,
                "y": -0.045143820345401764,
                "z": -289.71209716796875
            },
            {
                "x": 13.510174751281738,
                "y": -0.052811309695243835,
                "z": -289.566162109375
            },
            {
                "x": 13.44663143157959,
                "y": -0.060901738703250885,
                "z": -289.4211730957031
            },
            {
                "x": 13.382736206054688,
                "y": -0.0694369226694107,
                "z": -289.2762145996094
            },
            {
                "x": 13.318122863769531,
                "y": -0.07842771708965302,
                "z": -289.1308898925781
            },
            {
                "x": 13.252821922302246,
                "y": -0.08784209936857224,
                "z": -288.9857482910156
            },
            {
                "x": 13.187257766723633,
                "y": -0.09762832522392273,
                "z": -288.8414306640625
            },
            {
                "x": 13.1216402053833,
                "y": -0.10776888579130173,
                "z": -288.69793701171875
            },
            {
                "x": 13.05543041229248,
                "y": -0.1183336153626442,
                "z": -288.55389404296875
            },
            {
                "x": 12.988643646240234,
                "y": -0.1292804777622223,
                "z": -288.409912109375
            },
            {
                "x": 12.921500205993652,
                "y": -0.14056527614593506,
                "z": -288.2665100097656
            },
            {
                "x": 12.878135681152344,
                "y": -0.1480158269405365,
                "z": -288.1743469238281
            },
            {
                "x": 12.810714721679688,
                "y": -0.1598333716392517,
                "z": -288.0315856933594
            },
            {
                "x": 12.742711067199707,
                "y": -0.17201608419418335,
                "z": -287.88861083984375
            },
            {
                "x": 12.674433708190918,
                "y": -0.18450160324573517,
                "z": -287.74609375
            },
            {
                "x": 12.606075286865234,
                "y": -0.19726493954658508,
                "z": -287.6040954589844
            },
            {
                "x": 12.537276268005371,
                "y": -0.21034443378448486,
                "z": -287.4618835449219
            },
            {
                "x": 12.468591690063477,
                "y": -0.2236383855342865,
                "z": -287.3205871582031
            },
            {
                "x": 12.399731636047363,
                "y": -0.2372281551361084,
                "z": -287.17919921875
            },
            {
                "x": 12.330671310424805,
                "y": -0.2510828673839569,
                "z": -287.0378723144531
            },
            {
                "x": 12.261761665344238,
                "y": -0.2651408314704895,
                "z": -286.8970642089844
            },
            {
                "x": 12.192647933959961,
                "y": -0.27946171164512634,
                "z": -286.7559814453125
            },
            {
                "x": 12.123502731323242,
                "y": -0.29400378465652466,
                "z": -286.61517333984375
            },
            {
                "x": 12.054250717163086,
                "y": -0.30876871943473816,
                "z": -286.47430419921875
            },
            {
                "x": 11.98490047454834,
                "y": -0.3237408399581909,
                "z": -286.3335266113281
            },
            {
                "x": 11.915541648864746,
                "y": -0.3388955593109131,
                "z": -286.1928405761719
            },
            {
                "x": 11.846097946166992,
                "y": -0.3542368412017822,
                "z": -286.0522766113281
            },
            {
                "x": 11.776604652404785,
                "y": -0.3697512149810791,
                "z": -285.91180419921875
            },
            {
                "x": 11.707099914550781,
                "y": -0.3854191303253174,
                "z": -285.7713623046875
            },
            {
                "x": 11.637495040893555,
                "y": -0.40124842524528503,
                "z": -285.6309509277344
            },
            {
                "x": 11.56767463684082,
                "y": -0.41724368929862976,
                "z": -285.49029541015625
            },
            {
                "x": 11.49797534942627,
                "y": -0.4333283305168152,
                "z": -285.3501281738281
            },
            {
                "x": 11.428155899047852,
                "y": -0.44954854249954224,
                "z": -285.2098693847656
            },
            {
                "x": 11.358360290527344,
                "y": -0.46585771441459656,
                "z": -285.0697937011719
            },
            {
                "x": 11.288466453552246,
                "y": -0.48227551579475403,
                "z": -284.9296875
            },
            {
                "x": 11.218411445617676,
                "y": -0.4988081455230713,
                "z": -284.7893371582031
            },
            {
                "x": 11.148449897766113,
                "y": -0.5153798460960388,
                "z": -284.6494140625
            },
            {
                "x": 11.07839584350586,
                "y": -0.5320338606834412,
                "z": -284.5093688964844
            },
            {
                "x": 11.008346557617188,
                "y": -0.5487303733825684,
                "z": -284.3694152832031
            },
            {
                "x": 10.938199043273926,
                "y": -0.5654836893081665,
                "z": -284.22943115234375
            },
            {
                "x": 10.868009567260742,
                "y": -0.5822746753692627,
                "z": -284.08941650390625
            },
            {
                "x": 10.797819137573242,
                "y": -0.5990763306617737,
                "z": -283.94952392578125
            },
            {
                "x": 10.72760009765625,
                "y": -0.6158875226974487,
                "z": -283.8097229003906
            },
            {
                "x": 10.657339096069336,
                "y": -0.6327059268951416,
                "z": -283.6698303222656
            },
            {
                "x": 10.587058067321777,
                "y": -0.6495133638381958,
                "z": -283.530029296875
            },
            {
                "x": 10.516735076904297,
                "y": -0.6662976741790771,
                "z": -283.3902282714844
            },
            {
                "x": 10.446390151977539,
                "y": -0.683056116104126,
                "z": -283.25042724609375
            },
            {
                "x": 10.37614631652832,
                "y": -0.6997504830360413,
                "z": -283.11083984375
            },
            {
                "x": 10.305713653564453,
                "y": -0.7164255976676941,
                "z": -282.9709167480469
            },
            {
                "x": 10.23541259765625,
                "y": -0.7330056428909302,
                "z": -282.831298828125
            },
            {
                "x": 10.165115356445312,
                "y": -0.7495147585868835,
                "z": -282.69171142578125
            },
            {
                "x": 10.094719886779785,
                "y": -0.7659602165222168,
                "z": -282.5519104003906
            },
            {
                "x": 10.024319648742676,
                "y": -0.7823156118392944,
                "z": -282.4120788574219
            },
            {
                "x": 9.953929901123047,
                "y": -0.7985472679138184,
                "z": -282.27239990234375
            },
            {
                "x": 9.908493041992188,
                "y": -0.8089703321456909,
                "z": -282.18218994140625
            },
            {
                "x": 9.838119506835938,
                "y": -0.825006365776062,
                "z": -282.04248046875
            },
            {
                "x": 9.767704010009766,
                "y": -0.8409145474433899,
                "z": -281.9026794433594
            },
            {
                "x": 9.69735336303711,
                "y": -0.8566684722900391,
                "z": -281.76300048828125
            },
            {
                "x": 9.627021789550781,
                "y": -0.872270941734314,
                "z": -281.6233215332031
            },
            {
                "x": 9.556681632995605,
                "y": -0.8877094984054565,
                "z": -281.4835205078125
            },
            {
                "x": 9.486479759216309,
                "y": -0.9029439687728882,
                "z": -281.3439636230469
            },
            {
                "x": 9.416214942932129,
                "y": -0.9180140495300293,
                "z": -281.20416259765625
            },
            {
                "x": 9.345967292785645,
                "y": -0.9328900575637817,
                "z": -281.0643005371094
            },
            {
                "x": 9.275736808776855,
                "y": -0.947559118270874,
                "z": -280.9244079589844
            },
            {
                "x": 9.205612182617188,
                "y": -0.9619874954223633,
                "z": -280.7845764160156
            },
            {
                "x": 9.135501861572266,
                "y": -0.976194441318512,
                "z": -280.6446838378906
            },
            {
                "x": 9.065485000610352,
                "y": -0.9901517629623413,
                "z": -280.5049133300781
            },
            {
                "x": 8.995321273803711,
                "y": -1.0038915872573853,
                "z": -280.36468505859375
            },
            {
                "x": 8.925420761108398,
                "y": -1.0173232555389404,
                "z": -280.224853515625
            },
            {
                "x": 8.855568885803223,
                "y": -1.030484676361084,
                "z": -280.0848693847656
            },
            {
                "x": 8.785612106323242,
                "y": -1.0433878898620605,
                "z": -279.94464111328125
            },
            {
                "x": 8.71586799621582,
                "y": -1.055973768234253,
                "z": -279.80462646484375
            },
            {
                "x": 8.646161079406738,
                "y": -1.0682473182678223,
                "z": -279.6645812988281
            },
            {
                "x": 8.576521873474121,
                "y": -1.080212116241455,
                "z": -279.5243225097656
            },
            {
                "x": 8.506983757019043,
                "y": -1.091841459274292,
                "z": -279.38409423828125
            },
            {
                "x": 8.437518119812012,
                "y": -1.1031385660171509,
                "z": -279.24383544921875
            },
            {
                "x": 8.368165969848633,
                "y": -1.114066481590271,
                "z": -279.1036376953125
            },
            {
                "x": 8.29890251159668,
                "y": -1.1246371269226074,
                "z": -278.9632568359375
            },
            {
                "x": 8.229618072509766,
                "y": -1.134856104850769,
                "z": -278.8226318359375
            },
            {
                "x": 8.16053295135498,
                "y": -1.1446788311004639,
                "z": -278.6821594238281
            },
            {
                "x": 8.091480255126953,
                "y": -1.1541063785552979,
                "z": -278.5415344238281
            },
            {
                "x": 8.02263355255127,
                "y": -1.1631147861480713,
                "z": -278.40093994140625
            },
            {
                "x": 7.9538445472717285,
                "y": -1.1717160940170288,
                "z": -278.2602233886719
            },
            {
                "x": 7.88516902923584,
                "y": -1.1798956394195557,
                "z": -278.1194152832031
            },
            {
                "x": 7.8166327476501465,
                "y": -1.187628984451294,
                "z": -277.9785461425781
            },
            {
                "x": 7.7482590675354,
                "y": -1.194900631904602,
                "z": -277.8377685546875
            },
            {
                "x": 7.679935455322266,
                "y": -1.2017254829406738,
                "z": -277.6966247558594
            },
            {
                "x": 7.611865997314453,
                "y": -1.2080714702606201,
                "z": -277.55572509765625
            },
            {
                "x": 7.543788433074951,
                "y": -1.213942527770996,
                "z": -277.4144287109375
            },
            {
                "x": 7.475947856903076,
                "y": -1.2193028926849365,
                "z": -277.27325439453125
            },
            {
                "x": 7.408282279968262,
                "y": -1.2241628170013428,
                "z": -277.1319885253906
            },
            {
                "x": 7.34071683883667,
                "y": -1.2285139560699463,
                "z": -276.9906311035156
            },
            {
                "x": 7.273355960845947,
                "y": -1.2323333024978638,
                "z": -276.84918212890625
            },
            {
                "x": 7.206155776977539,
                "y": -1.2356019020080566,
                "z": -276.70782470703125
            },
            {
                "x": 7.139092922210693,
                "y": -1.238330364227295,
                "z": -276.5660705566406
            },
            {
                "x": 7.072230339050293,
                "y": -1.2405028343200684,
                "z": -276.4244689941406
            },
            {
                "x": 7.005635738372803,
                "y": -1.2420997619628906,
                "z": -276.2828369140625
            },
            {
                "x": 6.962671756744385,
                "y": -1.2428109645843506,
                "z": -276.19122314453125
            },
            {
                "x": 6.896397590637207,
                "y": -1.2434446811676025,
                "z": -276.04949951171875
            },
            {
                "x": 6.830193042755127,
                "y": -1.2434829473495483,
                "z": -275.90740966796875
            },
            {
                "x": 6.7642669677734375,
                "y": -1.2429016828536987,
                "z": -275.7654113769531
            },
            {
                "x": 6.698525905609131,
                "y": -1.241736650466919,
                "z": -275.6232604980469
            },
            {
                "x": 6.63300895690918,
                "y": -1.24000084400177,
                "z": -275.48114013671875
            },
            {
                "x": 6.567646503448486,
                "y": -1.2376981973648071,
                "z": -275.3387756347656
            },
            {
                "x": 6.502674579620361,
                "y": -1.2348270416259766,
                "z": -275.1966857910156
            },
            {
                "x": 6.437707901000977,
                "y": -1.23140549659729,
                "z": -275.0539855957031
            },
            {
                "x": 6.373199462890625,
                "y": -1.2274689674377441,
                "z": -274.9117736816406
            },
            {
                "x": 6.308773040771484,
                "y": -1.2230031490325928,
                "z": -274.76904296875
            },
            {
                "x": 6.244690418243408,
                "y": -1.2180150747299194,
                "z": -274.62652587890625
            },
            {
                "x": 6.180870056152344,
                "y": -1.2125290632247925,
                "z": -274.4837951660156
            },
            {
                "x": 6.117161750793457,
                "y": -1.2065526247024536,
                "z": -274.34088134765625
            },
            {
                "x": 6.053788185119629,
                "y": -1.2001070976257324,
                "z": -274.197998046875
            },
            {
                "x": 5.990697860717773,
                "y": -1.193183183670044,
                "z": -274.05511474609375
            },
            {
                "x": 5.927891731262207,
                "y": -1.1858034133911133,
                "z": -273.91204833984375
            },
            {
                "x": 5.865273475646973,
                "y": -1.1779799461364746,
                "z": -273.7688903808594
            },
            {
                "x": 5.803019046783447,
                "y": -1.169735312461853,
                "z": -273.6257629394531
            },
            {
                "x": 5.740952968597412,
                "y": -1.1610453128814697,
                "z": -273.48236083984375
            },
            {
                "x": 5.679290771484375,
                "y": -1.1519584655761719,
                "z": -273.3390808105469
            },
            {
                "x": 5.617830753326416,
                "y": -1.1424689292907715,
                "z": -273.19561767578125
            },
            {
                "x": 5.556746959686279,
                "y": -1.1326045989990234,
                "z": -273.0522155761719
            },
            {
                "x": 5.495867729187012,
                "y": -1.1223399639129639,
                "z": -272.9085388183594
            },
            {
                "x": 5.435301780700684,
                "y": -1.1117067337036133,
                "z": -272.7647705078125
            },
            {
                "x": 5.374975681304932,
                "y": -1.100719690322876,
                "z": -272.6208801269531
            },
            {
                "x": 5.315088272094727,
                "y": -1.089409351348877,
                "z": -272.4771423339844
            },
            {
                "x": 5.2553534507751465,
                "y": -1.077735185623169,
                "z": -272.3329772949219
            },
            {
                "x": 5.196117401123047,
                "y": -1.0657665729522705,
                "z": -272.1891174316406
            },
            {
                "x": 5.136963367462158,
                "y": -1.0534459352493286,
                "z": -272.044677734375
            },
            {
                "x": 5.078319549560547,
                "y": -1.0408689975738525,
                "z": -271.90057373046875
            },
            {
                "x": 5.019847393035889,
                "y": -1.027968168258667,
                "z": -271.7560729980469
            },
            {
                "x": 4.9618401527404785,
                "y": -1.0148124694824219,
                "z": -271.61175537109375
            },
            {
                "x": 4.904071807861328,
                "y": -1.001368761062622,
                "z": -271.46710205078125
            },
            {
                "x": 4.846690654754639,
                "y": -0.9876918792724609,
                "z": -271.32257080078125
            },
            {
                "x": 4.789562702178955,
                "y": -0.9737377762794495,
                "z": -271.1775817871094
            },
            {
                "x": 4.732843399047852,
                "y": -0.9595740437507629,
                "z": -271.0329284667969
            },
            {
                "x": 4.6763811111450195,
                "y": -0.9451605081558228,
                "z": -270.8877868652344
            },
            {
                "x": 4.62034273147583,
                "y": -0.9305687546730042,
                "z": -270.7429504394531
            },
            {
                "x": 4.564597129821777,
                "y": -0.9157495498657227,
                "z": -270.5976867675781
            },
            {
                "x": 4.509127616882324,
                "y": -0.9007279872894287,
                "z": -270.45233154296875
            },
            {
                "x": 4.454135894775391,
                "y": -0.8855483531951904,
                "z": -270.3070373535156
            },
            {
                "x": 4.3993940353393555,
                "y": -0.8701885938644409,
                "z": -270.16156005859375
            },
            {
                "x": 4.364299774169922,
                "y": -0.8601980209350586,
                "z": -270.06768798828125
            },
            {
                "x": 4.310129642486572,
                "y": -0.8445667028427124,
                "z": -269.921875
            },
            {
                "x": 4.256418704986572,
                "y": -0.8288308382034302,
                "z": -269.7763671875
            },
            {
                "x": 4.202916145324707,
                "y": -0.8129137754440308,
                "z": -269.63018798828125
            },
            {
                "x": 4.1499128341674805,
                "y": -0.7969275712966919,
                "z": -269.48443603515625
            },
            {
                "x": 4.0971550941467285,
                "y": -0.7807830572128296,
                "z": -269.338134765625
            },
            {
                "x": 4.0448198318481445,
                "y": -0.7645763158798218,
                "z": -269.19207763671875
            },
            {
                "x": 3.992861747741699,
                "y": -0.748269259929657,
                "z": -269.0457763671875
            },
            {
                "x": 3.941132068634033,
                "y": -0.7318634390830994,
                "z": -268.899169921875
            },
            {
                "x": 3.8899197578430176,
                "y": -0.7154150009155273,
                "z": -268.7527160644531
            },
            {
                "x": 3.838963508605957,
                "y": -0.6988959312438965,
                "z": -268.60601806640625
            },
            {
                "x": 3.7884631156921387,
                "y": -0.6823416352272034,
                "z": -268.45928955078125
            },
            {
                "x": 3.738224744796753,
                "y": -0.6657423973083496,
                "z": -268.3123474121094
            },
            {
                "x": 3.6884605884552,
                "y": -0.6491237878799438,
                "z": -268.16534423828125
            },
            {
                "x": 3.6389594078063965,
                "y": -0.6324712634086609,
                "z": -268.01806640625
            },
            {
                "x": 3.5899670124053955,
                "y": -0.6158571839332581,
                "z": -267.8710632324219
            },
            {
                "x": 3.541172981262207,
                "y": -0.5991928577423096,
                "z": -267.723388671875
            },
            {
                "x": 3.4929068088531494,
                "y": -0.5826027989387512,
                "z": -267.5761413574219
            },
            {
                "x": 3.444892406463623,
                "y": -0.5659898519515991,
                "z": -267.42828369140625
            },
            {
                "x": 3.3972675800323486,
                "y": -0.5494416952133179,
                "z": -267.2806396484375
            },
            {
                "x": 3.3500876426696777,
                "y": -0.532939612865448,
                "z": -267.13275146484375
            },
            {
                "x": 3.303213119506836,
                "y": -0.5165010690689087,
                "z": -266.98486328125
            },
            {
                "x": 3.2568039894104004,
                "y": -0.5001396536827087,
                "z": -266.8368225097656
            },
            {
                "x": 3.210667848587036,
                "y": -0.483842670917511,
                "z": -266.6886291503906
            },
            {
                "x": 3.1649563312530518,
                "y": -0.4676355719566345,
                "z": -266.5402526855469
            },
            {
                "x": 3.1195297241210938,
                "y": -0.4515109658241272,
                "z": -266.3916015625
            },
            {
                "x": 3.0746071338653564,
                "y": -0.43553951382637024,
                "z": -266.2431640625
            },
            {
                "x": 3.029942512512207,
                "y": -0.41964662075042725,
                "z": -266.09423828125
            },
            {
                "x": 2.9857594966888428,
                "y": -0.4039306342601776,
                "z": -265.9455871582031
            },
            {
                "x": 2.9418296813964844,
                "y": -0.38830143213272095,
                "z": -265.79632568359375
            },
            {
                "x": 2.8983616828918457,
                "y": -0.37287411093711853,
                "z": -265.6473083496094
            },
            {
                "x": 2.8553147315979004,
                "y": -0.35760629177093506,
                "z": -265.4981384277344
            },
            {
                "x": 2.8124840259552,
                "y": -0.34248146414756775,
                "z": -265.34857177734375
            },
            {
                "x": 2.7701950073242188,
                "y": -0.32758083939552307,
                "z": -265.19927978515625
            },
            {
                "x": 2.7281196117401123,
                "y": -0.31283509731292725,
                "z": -265.0494384765625
            },
            {
                "x": 2.6865715980529785,
                "y": -0.2983422577381134,
                "z": -264.89990234375
            },
            {
                "x": 2.6453099250793457,
                "y": -0.28402918577194214,
                "z": -264.7498779296875
            },
            {
                "x": 2.604452610015869,
                "y": -0.2699670195579529,
                "z": -264.60003662109375
            },
            {
                "x": 2.563965082168579,
                "y": -0.2561253309249878,
                "z": -264.44976806640625
            },
            {
                "x": 2.5238420963287354,
                "y": -0.24255476891994476,
                "z": -264.2997131347656
            },
            {
                "x": 2.484113931655884,
                "y": -0.22922423481941223,
                "z": -264.14923095703125
            },
            {
                "x": 2.444667339324951,
                "y": -0.2161543220281601,
                "z": -263.9986572265625
            },
            {
                "x": 2.4057717323303223,
                "y": -0.2034057378768921,
                "z": -263.8483581542969
            },
            {
                "x": 2.3807523250579834,
                "y": -0.19529974460601807,
                "z": -263.75079345703125
            },
            {
                "x": 2.3423287868499756,
                "y": -0.18300949037075043,
                "z": -263.6000061035156
            },
            {
                "x": 2.304330587387085,
                "y": -0.17102527618408203,
                "z": -263.4491271972656
            },
            {
                "x": 2.266602039337158,
                "y": -0.15935684740543365,
                "z": -263.29791259765625
            },
            {
                "x": 2.2293944358825684,
                "y": -0.14804615080356598,
                "z": -263.1470031738281
            },
            {
                "x": 2.1924023628234863,
                "y": -0.1370319128036499,
                "z": -262.99542236328125
            },
            {
                "x": 2.155881404876709,
                "y": -0.1264028549194336,
                "z": -262.8442077636719
            },
            {
                "x": 2.119724750518799,
                "y": -0.11612517386674881,
                "z": -262.692626953125
            },
            {
                "x": 2.0838441848754883,
                "y": -0.10621462762355804,
                "z": -262.5408630371094
            },
            {
                "x": 2.0484681129455566,
                "y": -0.09670325368642807,
                "z": -262.3892517089844
            },
            {
                "x": 2.013298273086548,
                "y": -0.08755247294902802,
                "z": -262.23712158203125
            },
            {
                "x": 1.978629469871521,
                "y": -0.07884754985570908,
                "z": -262.0853576660156
            },
            {
                "x": 1.9442451000213623,
                "y": -0.0705355629324913,
                "z": -261.9330749511719
            },
            {
                "x": 1.910205364227295,
                "y": -0.06265217810869217,
                "z": -261.7808837890625
            },
            {
                "x": 1.8765933513641357,
                "y": -0.055202048271894455,
                "z": -261.6285705566406
            },
            {
                "x": 1.8432559967041016,
                "y": -0.04820527881383896,
                "z": -261.4761047363281
            },
            {
                "x": 1.8103933334350586,
                "y": -0.04168042540550232,
                "z": -261.32373046875
            },
            {
                "x": 1.7777841091156006,
                "y": -0.035603106021881104,
                "z": -261.1709289550781
            },
            {
                "x": 1.7455915212631226,
                "y": -0.030014049261808395,
                "z": -261.0184326171875
            },
            {
                "x": 1.7137467861175537,
                "y": -0.02491292729973793,
                "z": -260.8654479980469
            },
            {
                "x": 1.6822218894958496,
                "y": -0.020321056246757507,
                "z": -260.7125549316406
            },
            {
                "x": 1.651141881942749,
                "y": -0.016239449381828308,
                "z": -260.5596923828125
            },
            {
                "x": 1.6203044652938843,
                "y": -0.012664826586842537,
                "z": -260.4064636230469
            },
            {
                "x": 1.5899126529693604,
                "y": -0.009640375152230263,
                "z": -260.25360107421875
            },
            {
                "x": 1.559804081916809,
                "y": -0.0071544647216796875,
                "z": -260.1000671386719
            },
            {
                "x": 1.5300347805023193,
                "y": -0.005220927298069,
                "z": -259.94677734375
            },
            {
                "x": 1.5006989240646362,
                "y": -0.0038459226489067078,
                "z": -259.7934875488281
            },
            {
                "x": 1.471580982208252,
                "y": -0.0030510048381984234,
                "z": -259.63970947265625
            },
            {
                "x": 1.442915916442871,
                "y": -0.002829788252711296,
                "z": -259.4864196777344
            },
            {
                "x": 1.414536476135254,
                "y": -0.002830512821674347,
                "z": -259.33251953125
            },
            {
                "x": 1.3864814043045044,
                "y": -0.002831406891345978,
                "z": -259.1788024902344
            },
            {
                "x": 1.3588674068450928,
                "y": -0.0028322115540504456,
                "z": -259.02520751953125
            },
            {
                "x": 1.3314907550811768,
                "y": -0.002833046019077301,
                "z": -258.87109375
            },
            {
                "x": 1.3045095205307007,
                "y": -0.0028338730335235596,
                "z": -258.7173767089844
            },
            {
                "x": 1.2778617143630981,
                "y": -0.0028347820043563843,
                "z": -258.56329345703125
            },
            {
                "x": 1.2514705657958984,
                "y": -0.002835586667060852,
                "z": -258.4091491699219
            },
            {
                "x": 1.2255486249923706,
                "y": -0.0028364285826683044,
                "z": -258.2552795410156
            },
            {
                "x": 1.1998491287231445,
                "y": -0.00283726304769516,
                "z": -258.100830078125
            },
            {
                "x": 1.1745003461837769,
                "y": -0.0028381049633026123,
                "z": -257.9468078613281
            },
            {
                "x": 1.149540662765503,
                "y": -0.002838917076587677,
                "z": -257.7926025390625
            },
            {
                "x": 1.1247843503952026,
                "y": -0.0028397738933563232,
                "z": -257.637939453125
            },
            {
                "x": 1.1004643440246582,
                "y": -0.0028406307101249695,
                "z": -257.4837951660156
            },
            {
                "x": 1.0763574838638306,
                "y": -0.0028417841531336308,
                "z": -257.3291931152344
            },
            {
                "x": 1.0610325336456299,
                "y": -0.002841956913471222,
                "z": -257.2293701171875
            },
            {
                "x": 1.037562370300293,
                "y": -0.002842828631401062,
                "z": -257.0750732421875
            },
            {
                "x": 1.0143523216247559,
                "y": -0.0028436779975891113,
                "z": -256.9202575683594
            },
            {
                "x": 0.9914199113845825,
                "y": -0.0028445422649383545,
                "z": -256.7655944824219
            },
            {
                "x": 0.9689170718193054,
                "y": -0.002845354378223419,
                "z": -256.6110534667969
            },
            {
                "x": 0.9466184377670288,
                "y": -0.002846166491508484,
                "z": -256.4559631347656
            },
            {
                "x": 0.9246612191200256,
                "y": -0.0028470084071159363,
                "z": -256.3013610839844
            },
            {
                "x": 0.9030656218528748,
                "y": -0.002847813069820404,
                "z": -256.14654541015625
            },
            {
                "x": 0.8816617727279663,
                "y": -0.0028487220406532288,
                "z": -255.9913330078125
            },
            {
                "x": 0.8606562614440918,
                "y": -0.0028495267033576965,
                "z": -255.8366241455078
            },
            {
                "x": 0.8399311900138855,
                "y": -0.002850368618965149,
                "z": -255.68145751953125
            },
            {
                "x": 0.8194459080696106,
                "y": -0.002851225435733795,
                "z": -255.52633666992188
            },
            {
                "x": 0.799363374710083,
                "y": -0.002852015197277069,
                "z": -255.37147521972656
            },
            {
                "x": 0.779489278793335,
                "y": -0.002852894365787506,
                "z": -255.2159423828125
            },
            {
                "x": 0.7599185705184937,
                "y": -0.002853699028491974,
                "z": -255.06088256835938
            },
            {
                "x": 0.740712583065033,
                "y": -0.002854563295841217,
                "z": -254.9058074951172
            },
            {
                "x": 0.7217071056365967,
                "y": -0.0028553977608680725,
                "z": -254.7501983642578
            },
            {
                "x": 0.7030342221260071,
                "y": -0.002856239676475525,
                "z": -254.59512329101562
            },
            {
                "x": 0.6846797466278076,
                "y": -0.0028570666909217834,
                "z": -254.43972778320312
            },
            {
                "x": 0.6665194630622864,
                "y": -0.002857893705368042,
                "z": -254.28407287597656
            },
            {
                "x": 0.6487216949462891,
                "y": -0.002858757972717285,
                "z": -254.12890625
            },
            {
                "x": 0.6312218904495239,
                "y": -0.0028595775365829468,
                "z": -253.97340393066406
            },
            {
                "x": 0.6139219999313354,
                "y": -0.0028604045510292053,
                "z": -253.8178253173828
            },
            {
                "x": 0.5969683527946472,
                "y": -0.0028612613677978516,
                "z": -253.66258239746094
            },
            {
                "x": 0.5802698135375977,
                "y": -0.002862118184566498,
                "z": -253.50672912597656
            },
            {
                "x": 0.5637988448143005,
                "y": -0.0028629377484321594,
                "z": -253.35110473632812
            },
            {
                "x": 0.5476658344268799,
                "y": -0.002863757312297821,
                "z": -253.19561767578125
            },
            {
                "x": 0.5317760705947876,
                "y": -0.0028646662831306458,
                "z": -253.03973388671875
            },
            {
                "x": 0.5161188840866089,
                "y": -0.0028654634952545166,
                "z": -252.88404846191406
            },
            {
                "x": 0.5007843971252441,
                "y": -0.002866297960281372,
                "z": -252.72833251953125
            },
            {
                "x": 0.48569634556770325,
                "y": -0.0028671100735664368,
                "z": -252.57240295410156
            },
            {
                "x": 0.4708319306373596,
                "y": -0.002867981791496277,
                "z": -252.41665649414062
            },
            {
                "x": 0.4562983512878418,
                "y": -0.0028688162565231323,
                "z": -252.2609100341797
            },
            {
                "x": 0.4419894218444824,
                "y": -0.002869635820388794,
                "z": -252.1048583984375
            },
            {
                "x": 0.4278983175754547,
                "y": -0.0028704479336738586,
                "z": -251.94894409179688
            },
            {
                "x": 0.4141350984573364,
                "y": -0.0028713271021842957,
                "z": -251.7931365966797
            },
            {
                "x": 0.4005933403968811,
                "y": -0.002872169017791748,
                "z": -251.6370391845703
            },
            {
                "x": 0.3872683644294739,
                "y": -0.002872943878173828,
                "z": -251.4810333251953
            },
            {
                "x": 0.37426936626434326,
                "y": -0.0028737932443618774,
                "z": -251.32521057128906
            },
            {
                "x": 0.36147138476371765,
                "y": -0.0028746649622917175,
                "z": -251.1690216064453
            },
            {
                "x": 0.34888529777526855,
                "y": -0.0028755217790603638,
                "z": -251.0128631591797
            },
            {
                "x": 0.3366277813911438,
                "y": -0.0028763338923454285,
                "z": -250.85694885253906
            },
            {
                "x": 0.3245653510093689,
                "y": -0.002877178369089961,
                "z": -250.70069885253906
            },
            {
                "x": 0.31688037514686584,
                "y": -0.0028776973485946655,
                "z": -250.59986877441406
            },
            {
                "x": 0.305240273475647,
                "y": -0.002878546714782715,
                "z": -250.44395446777344
            },
            {
                "x": 0.29384317994117737,
                "y": -0.0028793737292289734,
                "z": -250.28765869140625
            },
            {
                "x": 0.282612681388855,
                "y": -0.0028802528977394104,
                "z": -250.1312713623047
            },
            {
                "x": 0.27167394757270813,
                "y": -0.0028811097145080566,
                "z": -249.97531127929688
            },
            {
                "x": 0.26099061965942383,
                "y": -0.0028819143772125244,
                "z": -249.81895446777344
            },
            {
                "x": 0.25047609210014343,
                "y": -0.0028827786445617676,
                "z": -249.66259765625
            },
            {
                "x": 0.24022245407104492,
                "y": -0.0028835758566856384,
                "z": -249.50656127929688
            },
            {
                "x": 0.2302267849445343,
                "y": -0.0028843954205513,
                "z": -249.35008239746094
            },
            {
                "x": 0.2204078733921051,
                "y": -0.002885274589061737,
                "z": -249.19366455078125
            },
            {
                "x": 0.21082362532615662,
                "y": -0.002886071801185608,
                "z": -249.0374755859375
            },
            {
                "x": 0.20151463150978088,
                "y": -0.0028869733214378357,
                "z": -248.8811492919922
            },
            {
                "x": 0.1923779547214508,
                "y": -0.0028877630829811096,
                "z": -248.72463989257812
            },
            {
                "x": 0.18344339728355408,
                "y": -0.002888604998588562,
                "z": -248.56817626953125
            },
            {
                "x": 0.17479681968688965,
                "y": -0.0028894543647766113,
                "z": -248.41192626953125
            },
            {
                "x": 0.16632553935050964,
                "y": -0.0028902962803840637,
                "z": -248.25535583496094
            },
            {
                "x": 0.15803688764572144,
                "y": -0.002891138195991516,
                "z": -248.09890747070312
            },
            {
                "x": 0.15003320574760437,
                "y": -0.0028919652104377747,
                "z": -247.942626953125
            },
            {
                "x": 0.14222079515457153,
                "y": -0.002892829477787018,
                "z": -247.7859649658203
            },
            {
                "x": 0.13456621766090393,
                "y": -0.0028936266899108887,
                "z": -247.62936401367188
            },
            {
                "x": 0.12717613577842712,
                "y": -0.002894476056098938,
                "z": -247.4730682373047
            },
            {
                "x": 0.12001791596412659,
                "y": -0.002895347774028778,
                "z": -247.3165740966797
            },
            {
                "x": 0.11299934983253479,
                "y": -0.0028961747884750366,
                "z": -247.15992736816406
            },
            {
                "x": 0.10621073842048645,
                "y": -0.002897001802921295,
                "z": -247.00360107421875
            },
            {
                "x": 0.09966319799423218,
                "y": -0.0028978511691093445,
                "z": -246.84690856933594
            },
            {
                "x": 0.09327420592308044,
                "y": -0.0028986558318138123,
                "z": -246.6902313232422
            },
            {
                "x": 0.08707621693611145,
                "y": -0.0028995051980018616,
                "z": -246.53375244140625
            },
            {
                "x": 0.08113113045692444,
                "y": -0.00290033221244812,
                "z": -246.37725830078125
            },
            {
                "x": 0.07535982131958008,
                "y": -0.0029011815786361694,
                "z": -246.22048950195312
            },
            {
                "x": 0.06974366307258606,
                "y": -0.002902016043663025,
                "z": -246.0637664794922
            },
            {
                "x": 0.06437721848487854,
                "y": -0.0029028207063674927,
                "z": -245.90733337402344
            },
            {
                "x": 0.0592133104801178,
                "y": -0.002903662621974945,
                "z": -245.75064086914062
            },
            {
                "x": 0.054179757833480835,
                "y": -0.002904534339904785,
                "z": -245.5938262939453
            },
            {
                "x": 0.04936838150024414,
                "y": -0.0029053837060928345,
                "z": -245.4373321533203
            },
            {
                "x": 0.04478546977043152,
                "y": -0.002906225621700287,
                "z": -245.2806396484375
            },
            {
                "x": 0.04034370183944702,
                "y": -0.002907015383243561,
                "z": -245.12376403808594
            },
            {
                "x": 0.036071598529815674,
                "y": -0.002907894551753998,
                "z": -244.96719360351562
            },
            {
                "x": 0.03204280138015747,
                "y": -0.00290873646736145,
                "z": -244.81056213378906
            },
            {
                "x": 0.02819076180458069,
                "y": -0.002909541130065918,
                "z": -244.6537628173828
            },
            {
                "x": 0.024468183517456055,
                "y": -0.002910397946834564,
                "z": -244.49700927734375
            },
            {
                "x": 0.020954012870788574,
                "y": -0.0029112622141838074,
                "z": -244.34031677246094
            },
            {
                "x": 0.01766619086265564,
                "y": -0.002912066876888275,
                "z": -244.18362426757812
            },
            {
                "x": 0.014505773782730103,
                "y": -0.0029129162430763245,
                "z": -244.0268096923828
            },
            {
                "x": 0.012540251016616821,
                "y": -0.0029134079813957214,
                "z": -243.92559814453125
            },
            {
                "x": 0.009697675704956055,
                "y": -0.0029143020510673523,
                "z": -243.76905822753906
            },
            {
                "x": 0.007049590349197388,
                "y": -0.0029151439666748047,
                "z": -243.61219787597656
            },
            {
                "x": 0.004522114992141724,
                "y": -0.0029159486293792725,
                "z": -243.4552764892578
            },
            {
                "x": 0.002165883779525757,
                "y": -0.0029167532920837402,
                "z": -243.29864501953125
            },
            {
                "x": 3.674626350402832e-05,
                "y": -0.002917639911174774,
                "z": -243.14187622070312
            },
            {
                "x": -0.001942366361618042,
                "y": -0.0029184669256210327,
                "z": -242.98495483398438
            },
            {
                "x": -0.003795534372329712,
                "y": -0.002919316291809082,
                "z": -242.8282012939453
            },
            {
                "x": -0.005455344915390015,
                "y": -0.002920188009738922,
                "z": -242.67137145996094
            },
            {
                "x": -0.006923854351043701,
                "y": -0.002920985221862793,
                "z": -242.5145263671875
            },
            {
                "x": -0.008281201124191284,
                "y": -0.0029218122363090515,
                "z": -242.35757446289062
            },
            {
                "x": -0.009493052959442139,
                "y": -0.0029226839542388916,
                "z": -242.2007598876953
            },
            {
                "x": -0.010545432567596436,
                "y": -0.002923525869846344,
                "z": -242.04391479492188
            },
            {
                "x": -0.011508941650390625,
                "y": -0.0029243677854537964,
                "z": -241.88665771484375
            },
            {
                "x": -0.012389838695526123,
                "y": -0.002925187349319458,
                "z": -241.7296905517578
            },
            {
                "x": -0.013181895017623901,
                "y": -0.0029260367155075073,
                "z": -241.57261657714844
            },
            {
                "x": -0.013977676630020142,
                "y": -0.002926863729953766,
                "z": -241.4151153564453
            },
            {
                "x": -0.01483890414237976,
                "y": -0.002927713096141815,
                "z": -241.25778198242188
            },
            {
                "x": -0.015716373920440674,
                "y": -0.0029285624623298645,
                "z": -241.10032653808594
            },
            {
                "x": -0.016706645488739014,
                "y": -0.002929389476776123,
                "z": -240.94252014160156
            },
            {
                "x": -0.01789340376853943,
                "y": -0.0029302090406417847,
                "z": -240.7847442626953
            },
            {
                "x": -0.01923888921737671,
                "y": -0.002931036055088043,
                "z": -240.6271514892578
            },
            {
                "x": -0.02076619863510132,
                "y": -0.0029319003224372864,
                "z": -240.46923828125
            },
            {
                "x": -0.022578895092010498,
                "y": -0.002932727336883545,
                "z": -240.3112335205078
            },
            {
                "x": -0.024635300040245056,
                "y": -0.002933584153652191,
                "z": -240.15322875976562
            },
            {
                "x": -0.02687646448612213,
                "y": -0.002934373915195465,
                "z": -239.99539184570312
            },
            {
                "x": -0.02941976487636566,
                "y": -0.002885989146307111,
                "z": -239.837158203125
            },
            {
                "x": -0.03227955102920532,
                "y": -0.002613107906654477,
                "z": -239.67916870117188
            },
            {
                "x": -0.03533847630023956,
                "y": -0.00209363317117095,
                "z": -239.521484375
            },
            {
                "x": -0.0386439710855484,
                "y": -0.0013195490464568138,
                "z": -239.3632049560547
            },
            {
                "x": -0.04229608178138733,
                "y": -0.0003009133506566286,
                "z": -239.20509338378906
            },
            {
                "x": -0.04621785879135132,
                "y": 0.0009528854861855507,
                "z": -239.0473175048828
            },
            {
                "x": -0.05033004283905029,
                "y": 0.0024420469999313354,
                "z": -238.88937377929688
            },
            {
                "x": -0.05475367605686188,
                "y": 0.004171507433056831,
                "z": -238.73123168945312
            },
            {
                "x": -0.05952289700508118,
                "y": 0.006132478825747967,
                "z": -238.57318115234375
            },
            {
                "x": -0.06449927389621735,
                "y": 0.00831359252333641,
                "z": -238.41542053222656
            },
            {
                "x": -0.0697098970413208,
                "y": 0.010718980804085732,
                "z": -238.25746154785156
            },
            {
                "x": -0.0752863734960556,
                "y": 0.013352017849683762,
                "z": -238.0992431640625
            },
            {
                "x": -0.08113935589790344,
                "y": 0.016195401549339294,
                "z": -237.94155883789062
            },
            {
                "x": -0.08718718588352203,
                "y": 0.019250908866524696,
                "z": -237.78378295898438
            },
            {
                "x": -0.0935581624507904,
                "y": 0.022524092346429825,
                "z": -237.6255340576172
            },
            {
                "x": -0.10026946663856506,
                "y": 0.02599906735122204,
                "z": -237.4676971435547
            },
            {
                "x": -0.10719074308872223,
                "y": 0.029673747718334198,
                "z": -237.31008911132812
            },
            {
                "x": -0.11178481578826904,
                "y": 0.03215405344963074,
                "z": -237.2081298828125
            },
            {
                "x": -0.11919872462749481,
                "y": 0.03616291284561157,
                "z": -237.05010986328125
            },
            {
                "x": -0.12694045901298523,
                "y": 0.040365319699048996,
                "z": -236.8922882080078
            },
            {
                "x": -0.13487692177295685,
                "y": 0.044752586632966995,
                "z": -236.734619140625
            },
            {
                "x": -0.1431037187576294,
                "y": 0.049331869930028915,
                "z": -236.5767364501953
            },
            {
                "x": -0.1517018973827362,
                "y": 0.05409768223762512,
                "z": -236.41879272460938
            },
            {
                "x": -0.16052886843681335,
                "y": 0.05903492495417595,
                "z": -236.2613067626953
            },
            {
                "x": -0.16959582269191742,
                "y": 0.064154714345932,
                "z": -236.1035919189453
            },
            {
                "x": -0.1790417730808258,
                "y": 0.06945905834436417,
                "z": -235.9455108642578
            },
            {
                "x": -0.18875974416732788,
                "y": 0.07491403073072433,
                "z": -235.7880401611328
            },
            {
                "x": -0.19869323074817657,
                "y": 0.08054399490356445,
                "z": -235.63047790527344
            },
            {
                "x": -0.20897552371025085,
                "y": 0.08634871244430542,
                "z": -235.47256469726562
            },
            {
                "x": -0.21958348155021667,
                "y": 0.09229888021945953,
                "z": -235.31504821777344
            },
            {
                "x": -0.23040741682052612,
                "y": 0.09840504080057144,
                "z": -235.1575164794922
            },
            {
                "x": -0.2415352165699005,
                "y": 0.10467734932899475,
                "z": -234.99981689453125
            },
            {
                "x": -0.2530260682106018,
                "y": 0.11109447479248047,
                "z": -234.8422393798828
            },
            {
                "x": -0.26475170254707336,
                "y": 0.1176467016339302,
                "z": -234.6848907470703
            },
            {
                "x": -0.27672624588012695,
                "y": 0.12434841692447662,
                "z": -234.52735900878906
            },
            {
                "x": -0.2891027331352234,
                "y": 0.13120466470718384,
                "z": -234.36965942382812
            },
            {
                "x": -0.3017423450946808,
                "y": 0.1381782591342926,
                "z": -234.2123565673828
            },
            {
                "x": -0.3145962655544281,
                "y": 0.14528393745422363,
                "z": -234.0550537109375
            },
            {
                "x": -0.3278164565563202,
                "y": 0.15253055095672607,
                "z": -233.89747619628906
            },
            {
                "x": -0.3413655459880829,
                "y": 0.15989291667938232,
                "z": -233.74026489257812
            },
            {
                "x": -0.35511571168899536,
                "y": 0.16737151145935059,
                "z": -233.5831756591797
            },
            {
                "x": -0.36922627687454224,
                "y": 0.1749948263168335,
                "z": -233.42555236816406
            },
            {
                "x": -0.3836694359779358,
                "y": 0.1827143430709839,
                "z": -233.26832580566406
            },
            {
                "x": -0.3983311057090759,
                "y": 0.19053874909877777,
                "z": -233.11135864257812
            },
            {
                "x": -0.41331106424331665,
                "y": 0.19849060475826263,
                "z": -232.95399475097656
            },
            {
                "x": -0.42865774035453796,
                "y": 0.20654110610485077,
                "z": -232.79678344726562
            },
            {
                "x": -0.44424158334732056,
                "y": 0.21468393504619598,
                "z": -232.63978576660156
            },
            {
                "x": -0.46010398864746094,
                "y": 0.22293540835380554,
                "z": -232.4825897216797
            },
            {
                "x": -0.4763544201850891,
                "y": 0.23128479719161987,
                "z": -232.325439453125
            },
            {
                "x": -0.49285292625427246,
                "y": 0.23970915377140045,
                "z": -232.16859436035156
            },
            {
                "x": -0.5096006989479065,
                "y": 0.24822843074798584,
                "z": -232.01162719726562
            },
            {
                "x": -0.526759147644043,
                "y": 0.2568482756614685,
                "z": -231.85443115234375
            },
            {
                "x": -0.5441805124282837,
                "y": 0.26552775502204895,
                "z": -231.6976776123047
            },
            {
                "x": -0.5618294477462769,
                "y": 0.2742859125137329,
                "z": -231.5408935546875
            },
            {
                "x": -0.5798816680908203,
                "y": 0.28313949704170227,
                "z": -231.38375854492188
            },
            {
                "x": -0.5982103943824768,
                "y": 0.29203569889068604,
                "z": -231.2271728515625
            },
            {
                "x": -0.6167704463005066,
                "y": 0.3010038733482361,
                "z": -231.070556640625
            },
            {
                "x": -0.6357369422912598,
                "y": 0.31006354093551636,
                "z": -230.9134521484375
            },
            {
                "x": -0.6549767255783081,
                "y": 0.3191511929035187,
                "z": -230.75697326660156
            },
            {
                "x": -0.6744428873062134,
                "y": 0.328296959400177,
                "z": -230.60047912597656
            },
            {
                "x": -0.6872237920761108,
                "y": 0.3342468738555908,
                "z": -230.49920654296875
            },
            {
                "x": -0.7072974443435669,
                "y": 0.3434891700744629,
                "z": -230.3426055908203
            },
            {
                "x": -0.7275917530059814,
                "y": 0.35276514291763306,
                "z": -230.186279296875
            },
            {
                "x": -0.7482228875160217,
                "y": 0.36211004853248596,
                "z": -230.02960205078125
            },
            {
                "x": -0.7692108154296875,
                "y": 0.3714856803417206,
                "z": -229.87310791015625
            },
            {
                "x": -0.7904309034347534,
                "y": 0.38088494539260864,
                "z": -229.71690368652344
            },
            {
                "x": -0.8119418621063232,
                "y": 0.3903314471244812,
                "z": -229.56044006347656
            },
            {
                "x": -0.8338478803634644,
                "y": 0.39980894327163696,
                "z": -229.40406799316406
            },
            {
                "x": -0.8559951782226562,
                "y": 0.40930336713790894,
                "z": -229.24790954589844
            },
            {
                "x": -0.8784254789352417,
                "y": 0.4188305139541626,
                "z": -229.09158325195312
            },
            {
                "x": -0.9012405872344971,
                "y": 0.42837971448898315,
                "z": -228.935302734375
            },
            {
                "x": -0.9242801666259766,
                "y": 0.4379242956638336,
                "z": -228.7794189453125
            },
            {
                "x": -0.9476252794265747,
                "y": 0.44749972224235535,
                "z": -228.6232452392578
            },
            {
                "x": -0.9713772535324097,
                "y": 0.45709526538848877,
                "z": -228.4669647216797
            },
            {
                "x": -0.9952983856201172,
                "y": 0.46666231751441956,
                "z": -228.31126403808594
            },
            {
                "x": -1.019561767578125,
                "y": 0.47625505924224854,
                "z": -228.1552276611328
            },
            {
                "x": -1.0442063808441162,
                "y": 0.48585015535354614,
                "z": -227.99923706054688
            },
            {
                "x": -1.0690388679504395,
                "y": 0.49541589617729187,
                "z": -227.8436279296875
            },
            {
                "x": -1.0942200422286987,
                "y": 0.5050009489059448,
                "z": -227.6876220703125
            },
            {
                "x": -1.1197724342346191,
                "y": 0.5145679116249084,
                "z": -227.53179931640625
            },
            {
                "x": -1.1455061435699463,
                "y": 0.5240979790687561,
                "z": -227.37635803222656
            },
            {
                "x": -1.1715903282165527,
                "y": 0.5336322784423828,
                "z": -227.22061157226562
            },
            {
                "x": -1.1980113983154297,
                "y": 0.5431350469589233,
                "z": -227.06503295898438
            },
            {
                "x": -1.2246346473693848,
                "y": 0.5525988340377808,
                "z": -226.9097442626953
            },
            {
                "x": -1.2516663074493408,
                "y": 0.5620688199996948,
                "z": -226.75392150878906
            },
            {
                "x": -1.2789744138717651,
                "y": 0.5714787244796753,
                "z": -226.59860229492188
            },
            {
                "x": -1.3064916133880615,
                "y": 0.5808495283126831,
                "z": -226.443359375
            },
            {
                "x": -1.3344066143035889,
                "y": 0.5902037620544434,
                "z": -226.28781127929688
            },
            {
                "x": -1.3625915050506592,
                "y": 0.5994911789894104,
                "z": -226.13265991210938
            },
            {
                "x": -1.3910343647003174,
                "y": 0.6087440252304077,
                "z": -225.97738647460938
            },
            {
                "x": -1.419832468032837,
                "y": 0.6179543733596802,
                "z": -225.82203674316406
            },
            {
                "x": -1.4488862752914429,
                "y": 0.6270883083343506,
                "z": -225.66712951660156
            },
            {
                "x": -1.4782030582427979,
                "y": 0.6361761689186096,
                "z": -225.5120391845703
            },
            {
                "x": -1.5079020261764526,
                "y": 0.6452133059501648,
                "z": -225.3568878173828
            },
            {
                "x": -1.5378172397613525,
                "y": 0.6541674137115479,
                "z": -225.2020721435547
            },
            {
                "x": -1.5680242776870728,
                "y": 0.6630684733390808,
                "z": -225.04705810546875
            },
            {
                "x": -1.5985897779464722,
                "y": 0.6718943119049072,
                "z": -224.89215087890625
            },
            {
                "x": -1.629363775253296,
                "y": 0.6806343197822571,
                "z": -224.7375030517578
            },
            {
                "x": -1.6604340076446533,
                "y": 0.6893078684806824,
                "z": -224.5826873779297
            },
            {
                "x": -1.6918442249298096,
                "y": 0.6978964805603027,
                "z": -224.4280242919922
            },
            {
                "x": -1.7234820127487183,
                "y": 0.7063950896263123,
                "z": -224.27342224121094
            },
            {
                "x": -1.7554413080215454,
                "y": 0.7148152589797974,
                "z": -224.11871337890625
            },
            {
                "x": -1.787672996520996,
                "y": 0.723129391670227,
                "z": -223.96434020996094
            },
            {
                "x": -1.8085883855819702,
                "y": 0.7284444570541382,
                "z": -223.86468505859375
            },
            {
                "x": -1.8412768840789795,
                "y": 0.7366081476211548,
                "z": -223.71017456054688
            },
            {
                "x": -1.8742856979370117,
                "y": 0.7446683645248413,
                "z": -223.55580139160156
            },
            {
                "x": -1.9074771404266357,
                "y": 0.7526170611381531,
                "z": -223.40159606933594
            },
            {
                "x": -1.9410185813903809,
                "y": 0.7604638338088989,
                "z": -223.24725341796875
            },
            {
                "x": -1.9748269319534302,
                "y": 0.768190860748291,
                "z": -223.09310913085938
            },
            {
                "x": -2.0088369846343994,
                "y": 0.7758010625839233,
                "z": -222.9390411376953
            },
            {
                "x": -2.0432088375091553,
                "y": 0.7833026647567749,
                "z": -222.78489685058594
            },
            {
                "x": -2.0778136253356934,
                "y": 0.7906690239906311,
                "z": -222.63095092773438
            },
            {
                "x": -2.1126604080200195,
                "y": 0.7979128956794739,
                "z": -222.4769744873047
            },
            {
                "x": -2.147839069366455,
                "y": 0.805030345916748,
                "z": -222.32302856445312
            },
            {
                "x": -2.1831812858581543,
                "y": 0.812004566192627,
                "z": -222.16934204101562
            },
            {
                "x": -2.218858003616333,
                "y": 0.8188503384590149,
                "z": -222.01547241210938
            },
            {
                "x": -2.254828929901123,
                "y": 0.8255534172058105,
                "z": -221.8616943359375
            },
            {
                "x": -2.290940523147583,
                "y": 0.8321040868759155,
                "z": -221.70816040039062
            },
            {
                "x": -2.327409029006958,
                "y": 0.8385200500488281,
                "z": -221.55445861816406
            },
            {
                "x": -2.3640871047973633,
                "y": 0.8447721004486084,
                "z": -221.40101623535156
            },
            {
                "x": -2.4009928703308105,
                "y": 0.8508712649345398,
                "z": -221.24755859375
            },
            {
                "x": -2.4382362365722656,
                "y": 0.8568190336227417,
                "z": -221.0940399169922
            },
            {
                "x": -2.475632667541504,
                "y": 0.8625984787940979,
                "z": -220.9407958984375
            },
            {
                "x": -2.5133235454559326,
                "y": 0.8682152032852173,
                "z": -220.7874298095703
            },
            {
                "x": -2.5512444972991943,
                "y": 0.8736546039581299,
                "z": -220.63433837890625
            },
            {
                "x": -2.5893502235412598,
                "y": 0.8789229393005371,
                "z": -220.48126220703125
            },
            {
                "x": -2.6277711391448975,
                "y": 0.8840233683586121,
                "z": -220.32806396484375
            },
            {
                "x": -2.6664183139801025,
                "y": 0.8889391422271729,
                "z": -220.17503356933594
            },
            {
                "x": -2.7052595615386963,
                "y": 0.8936694860458374,
                "z": -220.02203369140625
            },
            {
                "x": -2.744375705718994,
                "y": 0.8982152938842773,
                "z": -219.8690643310547
            },
            {
                "x": -2.783649206161499,
                "y": 0.9025686979293823,
                "z": -219.71633911132812
            },
            {
                "x": -2.8232200145721436,
                "y": 0.906732439994812,
                "z": -219.56341552734375
            },
            {
                "x": -2.8630223274230957,
                "y": 0.9106936454772949,
                "z": -219.41062927246094
            },
            {
                "x": -2.90297269821167,
                "y": 0.9144535064697266,
                "z": -219.25796508789062
            },
            {
                "x": -2.9431982040405273,
                "y": 0.9180130958557129,
                "z": -219.10533142089844
            },
            {
                "x": -2.9835894107818604,
                "y": 0.9213600754737854,
                "z": -218.95281982421875
            },
            {
                "x": -3.0242245197296143,
                "y": 0.9244950413703918,
                "z": -218.8002166748047
            },
            {
                "x": -3.06508207321167,
                "y": 0.9274156093597412,
                "z": -218.64779663085938
            },
            {
                "x": -3.106092929840088,
                "y": 0.9301198720932007,
                "z": -218.495361328125
            },
            {
                "x": -3.1473588943481445,
                "y": 0.932601273059845,
                "z": -218.3429718017578
            },
            {
                "x": -3.1887617111206055,
                "y": 0.9348495602607727,
                "z": -218.19082641601562
            },
            {
                "x": -3.2303738594055176,
                "y": 0.936873197555542,
                "z": -218.03858947753906
            },
            {
                "x": -3.27219820022583,
                "y": 0.9386659860610962,
                "z": -217.88644409179688
            },
            {
                "x": -3.3142101764678955,
                "y": 0.9402225017547607,
                "z": -217.73426818847656
            },
            {
                "x": -3.356412887573242,
                "y": 0.9415333271026611,
                "z": -217.5822296142578
            },
            {
                "x": -3.398754119873047,
                "y": 0.9426020383834839,
                "z": -217.4303741455078
            },
            {
                "x": -3.4261934757232666,
                "y": 0.9431676864624023,
                "z": -217.3322296142578
            },
            {
                "x": -3.468867778778076,
                "y": 0.9438257217407227,
                "z": -217.18032836914062
            },
            {
                "x": -3.511688232421875,
                "y": 0.9442334175109863,
                "z": -217.028564453125
            },
            {
                "x": -3.5546875,
                "y": 0.9443880319595337,
                "z": -216.87667846679688
            },
            {
                "x": -3.597848892211914,
                "y": 0.9442858695983887,
                "z": -216.72503662109375
            },
            {
                "x": -3.6411452293395996,
                "y": 0.943917989730835,
                "z": -216.57337951660156
            },
            {
                "x": -3.6846442222595215,
                "y": 0.9432998895645142,
                "z": -216.4217071533203
            },
            {
                "x": -3.7282347679138184,
                "y": 0.9424358606338501,
                "z": -216.27029418945312
            },
            {
                "x": -3.7720532417297363,
                "y": 0.9413254261016846,
                "z": -216.11859130859375
            },
            {
                "x": -3.815978527069092,
                "y": 0.9399662017822266,
                "z": -215.9672088623047
            },
            {
                "x": -3.8600144386291504,
                "y": 0.9383700489997864,
                "z": -215.81585693359375
            },
            {
                "x": -3.904229164123535,
                "y": 0.9365404844284058,
                "z": -215.6644744873047
            },
            {
                "x": -3.94851016998291,
                "y": 0.93448406457901,
                "z": -215.51336669921875
            },
            {
                "x": -3.9930226802825928,
                "y": 0.9321854710578918,
                "z": -215.36187744140625
            },
            {
                "x": -4.037600994110107,
                "y": 0.9296690821647644,
                "z": -215.2107696533203
            },
            {
                "x": -4.082257270812988,
                "y": 0.926935076713562,
                "z": -215.05975341796875
            },
            {
                "x": -4.127105236053467,
                "y": 0.9239813089370728,
                "z": -214.90855407714844
            },
            {
                "x": -4.171985149383545,
                "y": 0.9208115339279175,
                "z": -214.75767517089844
            },
            {
                "x": -4.217041015625,
                "y": 0.917427659034729,
                "z": -214.60658264160156
            },
            {
                "x": -4.2621941566467285,
                "y": 0.9138414859771729,
                "z": -214.45562744140625
            },
            {
                "x": -4.307382106781006,
                "y": 0.9100574254989624,
                "z": -214.3048553466797
            },
            {
                "x": -4.352715492248535,
                "y": 0.9060639142990112,
                "z": -214.15399169921875
            },
            {
                "x": -4.398105144500732,
                "y": 0.9018787145614624,
                "z": -214.00328063964844
            },
            {
                "x": -4.443591117858887,
                "y": 0.8975012302398682,
                "z": -213.85255432128906
            },
            {
                "x": -4.489213943481445,
                "y": 0.8929324150085449,
                "z": -213.70172119140625
            },
            {
                "x": -4.534833908081055,
                "y": 0.8881789445877075,
                "z": -213.5511474609375
            },
            {
                "x": -4.580574989318848,
                "y": 0.883240282535553,
                "z": -213.40048217773438
            },
            {
                "x": -4.626363754272461,
                "y": 0.8781274557113647,
                "z": -213.2499237060547
            },
            {
                "x": -4.672208309173584,
                "y": 0.8728418350219727,
                "z": -213.09939575195312
            },
            {
                "x": -4.7181572914123535,
                "y": 0.8673762679100037,
                "z": -212.94879150390625
            },
            {
                "x": -4.764096736907959,
                "y": 0.8617478013038635,
                "z": -212.79835510253906
            },
            {
                "x": -4.810107231140137,
                "y": 0.8559569120407104,
                "z": -212.64793395996094
            },
            {
                "x": -4.8561601638793945,
                "y": 0.8500060439109802,
                "z": -212.49752807617188
            },
            {
                "x": -4.902244567871094,
                "y": 0.8438944816589355,
                "z": -212.34713745117188
            },
            {
                "x": -4.948380470275879,
                "y": 0.8376283645629883,
                "z": -212.19679260253906
            },
            {
                "x": -4.9945502281188965,
                "y": 0.8312126994132996,
                "z": -212.04640197753906
            },
            {
                "x": -5.040708541870117,
                "y": 0.8246579170227051,
                "z": -211.89620971679688
            },
            {
                "x": -5.086916446685791,
                "y": 0.8179513812065125,
                "z": -211.74586486816406
            },
            {
                "x": -5.133111953735352,
                "y": 0.8111103177070618,
                "z": -211.59568786621094
            },
            {
                "x": -5.179315090179443,
                "y": 0.8041349649429321,
                "z": -211.44552612304688
            },
            {
                "x": -5.225583553314209,
                "y": 0.7970199584960938,
                "z": -211.29519653320312
            },
            {
                "x": -5.27178955078125,
                "y": 0.7897824048995972,
                "z": -211.1450653076172
            },
            {
                "x": -5.317992687225342,
                "y": 0.7824195623397827,
                "z": -210.9949493408203
            },
            {
                "x": -5.347830295562744,
                "y": 0.7776006460189819,
                "z": -210.8980255126953
            },
            {
                "x": -5.3939971923828125,
                "y": 0.7700424194335938,
                "z": -210.74795532226562
            },
            {
                "x": -5.440195560455322,
                "y": 0.7623598575592041,
                "z": -210.5977783203125
            },
            {
                "x": -5.486352443695068,
                "y": 0.7545682191848755,
                "z": -210.4476776123047
            },
            {
                "x": -5.5324602127075195,
                "y": 0.7466731071472168,
                "z": -210.29762268066406
            },
            {
                "x": -5.578561305999756,
                "y": 0.7386667728424072,
                "z": -210.1475067138672
            },
            {
                "x": -5.624602317810059,
                "y": 0.7305601835250854,
                "z": -209.99746704101562
            },
            {
                "x": -5.670595645904541,
                "y": 0.7223583459854126,
                "z": -209.8474578857422
            },
            {
                "x": -5.716568946838379,
                "y": 0.7140542268753052,
                "z": -209.69729614257812
            },
            {
                "x": -5.762475967407227,
                "y": 0.7056653499603271,
                "z": -209.54721069335938
            },
            {
                "x": -5.808310031890869,
                "y": 0.6971869468688965,
                "z": -209.39718627929688
            },
            {
                "x": -5.854091644287109,
                "y": 0.6886225938796997,
                "z": -209.24708557128906
            },
            {
                "x": -5.899771213531494,
                "y": 0.6799866557121277,
                "z": -209.09715270996094
            },
            {
                "x": -5.945446014404297,
                "y": 0.671258270740509,
                "z": -208.94691467285156
            },
            {
                "x": -5.990980625152588,
                "y": 0.6624667048454285,
                "z": -208.79689025878906
            },
            {
                "x": -6.036417484283447,
                "y": 0.6536074876785278,
                "z": -208.64691162109375
            },
            {
                "x": -6.081817626953125,
                "y": 0.6446719169616699,
                "z": -208.4967041015625
            },
            {
                "x": -6.127070903778076,
                "y": 0.6356849074363708,
                "z": -208.34671020507812
            },
            {
                "x": -6.172274589538574,
                "y": 0.6266251802444458,
                "z": -208.19650268554688
            },
            {
                "x": -6.21736478805542,
                "y": 0.6175147294998169,
                "z": -208.04635620117188
            },
            {
                "x": -6.262316703796387,
                "y": 0.6083554029464722,
                "z": -207.89625549316406
            },
            {
                "x": -6.3071608543396,
                "y": 0.599149763584137,
                "z": -207.74618530273438
            },
            {
                "x": -6.351841449737549,
                "y": 0.5898990631103516,
                "z": -207.59609985351562
            },
            {
                "x": -6.396441459655762,
                "y": 0.5806000232696533,
                "z": -207.44590759277344
            },
            {
                "x": -6.440932273864746,
                "y": 0.5712583065032959,
                "z": -207.29562377929688
            },
            {
                "x": -6.485259056091309,
                "y": 0.5618857145309448,
                "z": -207.1453399658203
            },
            {
                "x": -6.529436111450195,
                "y": 0.5524851083755493,
                "z": -206.99513244628906
            },
            {
                "x": -6.573451042175293,
                "y": 0.543052613735199,
                "z": -206.8448486328125
            },
            {
                "x": -6.617345333099365,
                "y": 0.5335954427719116,
                "z": -206.69451904296875
            },
            {
                "x": -6.661078453063965,
                "y": 0.5241150856018066,
                "z": -206.5441131591797
            },
            {
                "x": -6.704654693603516,
                "y": 0.5146157741546631,
                "z": -206.3936767578125
            },
            {
                "x": -6.748017311096191,
                "y": 0.5051140189170837,
                "z": -206.24339294433594
            },
            {
                "x": -6.791261196136475,
                "y": 0.4955863654613495,
                "z": -206.09280395507812
            },
            {
                "x": -6.83430814743042,
                "y": 0.4860619902610779,
                "z": -205.9423828125
            },
            {
                "x": -6.877146244049072,
                "y": 0.47653061151504517,
                "z": -205.79185485839844
            },
            {
                "x": -6.919860363006592,
                "y": 0.4669922888278961,
                "z": -205.64120483398438
            },
            {
                "x": -6.962300777435303,
                "y": 0.4574705958366394,
                "z": -205.49073791503906
            },
            {
                "x": -7.004621505737305,
                "y": 0.4479385018348694,
                "z": -205.33990478515625
            },
            {
                "x": -7.046682357788086,
                "y": 0.4384351372718811,
                "z": -205.18934631347656
            },
            {
                "x": -7.088525772094727,
                "y": 0.42893779277801514,
                "z": -205.03860473632812
            },
            {
                "x": -7.130241870880127,
                "y": 0.41944772005081177,
                "z": -204.88771057128906
            },
            {
                "x": -7.171627521514893,
                "y": 0.4099947214126587,
                "z": -204.7369842529297
            },
            {
                "x": -7.21291971206665,
                "y": 0.40055179595947266,
                "z": -204.58602905273438
            },
            {
                "x": -7.239351272583008,
                "y": 0.3944792151451111,
                "z": -204.48866271972656
            },
            {
                "x": -7.280145168304443,
                "y": 0.38509345054626465,
                "z": -204.33775329589844
            },
            {
                "x": -7.32081413269043,
                "y": 0.3757270574569702,
                "z": -204.18658447265625
            },
            {
                "x": -7.361136436462402,
                "y": 0.36641359329223633,
                "z": -204.0355987548828
            },
            {
                "x": -7.40126895904541,
                "y": 0.35713011026382446,
                "z": -203.88441467285156
            },
            {
                "x": -7.441129207611084,
                "y": 0.34789803624153137,
                "z": -203.73330688476562
            },
            {
                "x": -7.480746269226074,
                "y": 0.33870455622673035,
                "z": -203.58200073242188
            },
            {
                "x": -7.520102500915527,
                "y": 0.3295716643333435,
                "z": -203.4307861328125
            },
            {
                "x": -7.559171676635742,
                "y": 0.32048526406288147,
                "z": -203.2793731689453
            },
            {
                "x": -7.598023414611816,
                "y": 0.31145262718200684,
                "z": -203.1278839111328
            },
            {
                "x": -7.63653564453125,
                "y": 0.3024931848049164,
                "z": -202.97650146484375
            },
            {
                "x": -7.674838542938232,
                "y": 0.2935817837715149,
                "z": -202.8247833251953
            },
            {
                "x": -7.712817192077637,
                "y": 0.28475746512413025,
                "z": -202.67333984375
            },
            {
                "x": -7.750527381896973,
                "y": 0.2759867012500763,
                "z": -202.52151489257812
            },
            {
                "x": -7.78798770904541,
                "y": 0.26729485392570496,
                "z": -202.36973571777344
            },
            {
                "x": -7.825042724609375,
                "y": 0.25869789719581604,
                "z": -202.2181396484375
            },
            {
                "x": -7.861907958984375,
                "y": 0.25015974044799805,
                "z": -202.06607055664062
            },
            {
                "x": -7.898393154144287,
                "y": 0.24172791838645935,
                "z": -201.91432189941406
            },
            {
                "x": -7.934604644775391,
                "y": 0.23336553573608398,
                "z": -201.76217651367188
            },
            {
                "x": -7.970555305480957,
                "y": 0.22510062158107758,
                "z": -201.6100616455078
            },
            {
                "x": -8.00606918334961,
                "y": 0.21694433689117432,
                "z": -201.45806884765625
            },
            {
                "x": -8.041365623474121,
                "y": 0.20887210965156555,
                "z": -201.30575561523438
            },
            {
                "x": -8.076252937316895,
                "y": 0.20091819763183594,
                "z": -201.15370178222656
            },
            {
                "x": -8.110865592956543,
                "y": 0.19305419921875,
                "z": -201.00123596191406
            },
            {
                "x": -8.145190238952637,
                "y": 0.18530255556106567,
                "z": -200.8487548828125
            },
            {
                "x": -8.179081916809082,
                "y": 0.17767030000686646,
                "z": -200.69635009765625
            },
            {
                "x": -8.212747573852539,
                "y": 0.17014282941818237,
                "z": -200.5436553955078
            },
            {
                "x": -8.245957374572754,
                "y": 0.16275086998939514,
                "z": -200.39122009277344
            },
            {
                "x": -8.278891563415527,
                "y": 0.15546855330467224,
                "z": -200.23834228515625
            },
            {
                "x": -8.311478614807129,
                "y": 0.1483173966407776,
                "z": -200.0855712890625
            },
            {
                "x": -8.34365463256836,
                "y": 0.1412956714630127,
                "z": -199.93270874023438
            },
            {
                "x": -8.375554084777832,
                "y": 0.13440634310245514,
                "z": -199.77978515625
            },
            {
                "x": -8.407002449035645,
                "y": 0.1276620328426361,
                "z": -199.6268768310547
            },
            {
                "x": -8.438170433044434,
                "y": 0.1210453063249588,
                "z": -199.4736328125
            },
            {
                "x": -8.468934059143066,
                "y": 0.11458262801170349,
                "z": -199.3206329345703
            },
            {
                "x": -8.49931812286377,
                "y": 0.10825729370117188,
                "z": -199.16729736328125
            },
            {
                "x": -8.52937126159668,
                "y": 0.10209161043167114,
                "z": -199.0140380859375
            },
            {
                "x": -8.558969497680664,
                "y": 0.0960797443985939,
                "z": -198.86073303222656
            },
            {
                "x": -8.588282585144043,
                "y": 0.09021566063165665,
                "z": -198.70716857910156
            },
            {
                "x": -8.617133140563965,
                "y": 0.08452627807855606,
                "z": -198.5539093017578
            },
            {
                "x": -8.645648956298828,
                "y": 0.07898557186126709,
                "z": -198.40003967285156
            },
            {
                "x": -8.673782348632812,
                "y": 0.07362435758113861,
                "z": -198.24649047851562
            },
            {
                "x": -8.70144271850586,
                "y": 0.06843376159667969,
                "z": -198.09291076660156
            },
            {
                "x": -8.719159126281738,
                "y": 0.06516724824905396,
                "z": -197.99342346191406
            },
            {
                "x": -8.746233940124512,
                "y": 0.06026812270283699,
                "z": -197.8397674560547
            },
            {
                "x": -8.772872924804688,
                "y": 0.05554070696234703,
                "z": -197.6858673095703
            },
            {
                "x": -8.799225807189941,
                "y": 0.0509888119995594,
                "z": -197.5316925048828
            },
            {
                "x": -8.825023651123047,
                "y": 0.04664473980665207,
                "z": -197.37796020507812
            },
            {
                "x": -8.850515365600586,
                "y": 0.042473163455724716,
                "z": -197.22360229492188
            },
            {
                "x": -8.875594139099121,
                "y": 0.038503486663103104,
                "z": -197.06959533691406
            },
            {
                "x": -8.900192260742188,
                "y": 0.03472618758678436,
                "z": -196.9154052734375
            },
            {
                "x": -8.924510955810547,
                "y": 0.031146541237831116,
                "z": -196.7608184814453
            },
            {
                "x": -8.948280334472656,
                "y": 0.02778192237019539,
                "z": -196.6067352294922
            },
            {
                "x": -8.97170639038086,
                "y": 0.024610791355371475,
                "z": -196.4520721435547
            },
            {
                "x": -8.994730949401855,
                "y": 0.021653685718774796,
                "z": -196.29769897460938
            },
            {
                "x": -9.017244338989258,
                "y": 0.018915187567472458,
                "z": -196.14321899414062
            },
            {
                "x": -9.039473533630371,
                "y": 0.016385890543460846,
                "z": -195.98828125
            },
            {
                "x": -9.061161041259766,
                "y": 0.014083340764045715,
                "z": -195.83389282226562
            },
            {
                "x": -9.08246898651123,
                "y": 0.011994868516921997,
                "z": -195.678955078125
            },
            {
                "x": -9.103389739990234,
                "y": 0.010141209699213505,
                "z": -195.52426147460938
            },
            {
                "x": -9.123771667480469,
                "y": 0.008518355898559093,
                "z": -195.3695068359375
            },
            {
                "x": -9.1438570022583,
                "y": 0.00712162721902132,
                "z": -195.21438598632812
            },
            {
                "x": -9.163442611694336,
                "y": 0.0059620472602546215,
                "z": -195.05958557128906
            },
            {
                "x": -9.182578086853027,
                "y": 0.005045543424785137,
                "z": -194.90447998046875
            },
            {
                "x": -9.201347351074219,
                "y": 0.004372878465801477,
                "z": -194.74948120117188
            },
            {
                "x": -9.219585418701172,
                "y": 0.003943391144275665,
                "z": -194.59454345703125
            },
            {
                "x": -9.237494468688965,
                "y": 0.0037591150030493736,
                "z": -194.43917846679688
            },
            {
                "x": -9.254936218261719,
                "y": 0.0037482231855392456,
                "z": -194.2840576171875
            },
            {
                "x": -9.271880149841309,
                "y": 0.0037441477179527283,
                "z": -194.1287384033203
            },
            {
                "x": -9.288496017456055,
                "y": 0.0037401244044303894,
                "z": -193.97337341308594
            },
            {
                "x": -9.30457592010498,
                "y": 0.0037360936403274536,
                "z": -193.8182373046875
            },
            {
                "x": -9.320267677307129,
                "y": 0.0037320703268051147,
                "z": -193.66256713867188
            },
            {
                "x": -9.335550308227539,
                "y": 0.003728032112121582,
                "z": -193.50714111328125
            },
            {
                "x": -9.35029411315918,
                "y": 0.003724008798599243,
                "z": -193.3517303466797
            },
            {
                "x": -9.364714622497559,
                "y": 0.0037199407815933228,
                "z": -193.19606018066406
            },
            {
                "x": -9.37862491607666,
                "y": 0.0037159323692321777,
                "z": -193.0406951904297
            },
            {
                "x": -9.392074584960938,
                "y": 0.003711886703968048,
                "z": -192.88494873046875
            },
            {
                "x": -9.40517807006836,
                "y": 0.0037078633904457092,
                "z": -192.729248046875
            },
            {
                "x": -9.41773796081543,
                "y": 0.0037038102746009827,
                "z": -192.57373046875
            },
            {
                "x": -9.429916381835938,
                "y": 0.00369977205991745,
                "z": -192.4177703857422
            },
            {
                "x": -9.441662788391113,
                "y": 0.003695756196975708,
                "z": -192.26214599609375
            },
            {
                "x": -9.452885627746582,
                "y": 0.003691732883453369,
                "z": -192.10643005371094
            },
            {
                "x": -9.46377944946289,
                "y": 0.0036876872181892395,
                "z": -191.95046997070312
            },
            {
                "x": -9.474173545837402,
                "y": 0.0036836713552474976,
                "z": -191.7947540283203
            },
            {
                "x": -9.484087944030762,
                "y": 0.003679633140563965,
                "z": -191.6387481689453
            },
            {
                "x": -9.493677139282227,
                "y": 0.0036752279847860336,
                "z": -191.48284912109375
            },
            {
                "x": -9.499565124511719,
                "y": 0.003672979772090912,
                "z": -191.38233947753906
            },
            {
                "x": -9.508309364318848,
                "y": 0.0036689341068267822,
                "z": -191.22630310058594
            },
            {
                "x": -9.516724586486816,
                "y": 0.0036648958921432495,
                "z": -191.07020568847656
            },
            {
                "x": -9.524612426757812,
                "y": 0.00366085022687912,
                "z": -190.91439819335938
            },
            {
                "x": -9.532081604003906,
                "y": 0.003656834363937378,
                "z": -190.75814819335938
            },
            {
                "x": -9.539166450500488,
                "y": 0.003652811050415039,
                "z": -190.60215759277344
            },
            {
                "x": -9.545711517333984,
                "y": 0.0036487653851509094,
                "z": -190.44625854492188
            },
            {
                "x": -9.551901817321777,
                "y": 0.00364471971988678,
                "z": -190.28994750976562
            },
            {
                "x": -9.557671546936035,
                "y": 0.0036406666040420532,
                "z": -190.1339111328125
            },
            {
                "x": -9.562897682189941,
                "y": 0.003636687994003296,
                "z": -189.97779846191406
            },
            {
                "x": -9.567801475524902,
                "y": 0.003632582724094391,
                "z": -189.8214874267578
            },
            {
                "x": -9.57223129272461,
                "y": 0.0036285370588302612,
                "z": -189.6655731201172
            },
            {
                "x": -9.576179504394531,
                "y": 0.003624565899372101,
                "z": -189.50930786132812
            },
            {
                "x": -9.579797744750977,
                "y": 0.0036204904317855835,
                "z": -189.35287475585938
            },
            {
                "x": -9.582901954650879,
                "y": 0.003616444766521454,
                "z": -189.19696044921875
            },
            {
                "x": -9.585577011108398,
                "y": 0.003612414002418518,
                "z": -189.0406036376953
            },
            {
                "x": -9.58791732788086,
                "y": 0.003608398139476776,
                "z": -188.88433837890625
            },
            {
                "x": -9.589709281921387,
                "y": 0.0036043748259544373,
                "z": -188.72836303710938
            },
            {
                "x": -9.591111183166504,
                "y": 0.0036003366112709045,
                "z": -188.5718231201172
            },
            {
                "x": -9.59215259552002,
                "y": 0.0035963058471679688,
                "z": -188.41563415527344
            },
            {
                "x": -9.592658042907715,
                "y": 0.0035922229290008545,
                "z": -188.2595977783203
            },
            {
                "x": -9.592782020568848,
                "y": 0.0035882070660591125,
                "z": -188.10313415527344
            },
            {
                "x": -9.592514038085938,
                "y": 0.0035841986536979675,
                "z": -187.94715881347656
            },
            {
                "x": -9.591708183288574,
                "y": 0.003580145537853241,
                "z": -187.79103088378906
            },
            {
                "x": -9.590555191040039,
                "y": 0.003576114773750305,
                "z": -187.63441467285156
            },
            {
                "x": -9.588947296142578,
                "y": 0.0035720989108085632,
                "z": -187.47850036621094
            },
            {
                "x": -9.586812973022461,
                "y": 0.003568023443222046,
                "z": -187.32228088378906
            },
            {
                "x": -9.584343910217285,
                "y": 0.00356399267911911,
                "z": -187.16590881347656
            },
            {
                "x": -9.581403732299805,
                "y": 0.003559976816177368,
                "z": -187.01007080078125
            },
            {
                "x": -9.57793140411377,
                "y": 0.003555968403816223,
                "z": -186.85357666015625
            },
            {
                "x": -9.574136734008789,
                "y": 0.003551967442035675,
                "z": -186.6973876953125
            },
            {
                "x": -9.56983470916748,
                "y": 0.0035475329495966434,
                "z": -186.54153442382812
            },
            {
                "x": -9.565061569213867,
                "y": 0.003395406762138009,
                "z": -186.3850860595703
            },
            {
                "x": -9.5599365234375,
                "y": 0.0030037695541977882,
                "z": -186.22906494140625
            },
            {
                "x": -9.554269790649414,
                "y": 0.0023962771520018578,
                "z": -186.0730743408203
            },
            {
                "x": -9.548184394836426,
                "y": 0.0015739115187898278,
                "z": -185.9167022705078
            },
            {
                "x": -9.541735649108887,
                "y": 0.0005445932038128376,
                "z": -185.76080322265625
            },
            {
                "x": -9.534709930419922,
                "y": -0.0007027355022728443,
                "z": -185.6047821044922
            },
            {
                "x": -9.52731990814209,
                "y": -0.0021565877832472324,
                "z": -185.44854736328125
            },
            {
                "x": -9.51951789855957,
                "y": -0.0038069491274654865,
                "z": -185.29281616210938
            },
            {
                "x": -9.511165618896484,
                "y": -0.005661410745233297,
                "z": -185.13661193847656
            },
            {
                "x": -9.502477645874023,
                "y": -0.0077184936963021755,
                "z": -184.9805450439453
            },
            {
                "x": -9.493317604064941,
                "y": -0.009963642805814743,
                "z": -184.82492065429688
            },
            {
                "x": -9.487123489379883,
                "y": -0.011515280231833458,
                "z": -184.72418212890625
            },
            {
                "x": -9.477256774902344,
                "y": -0.01408111397176981,
                "z": -184.56813049316406
            },
            {
                "x": -9.466940879821777,
                "y": -0.016828566789627075,
                "z": -184.41249084472656
            },
            {
                "x": -9.456107139587402,
                "y": -0.019765615463256836,
                "z": -184.25643920898438
            },
            {
                "x": -9.444960594177246,
                "y": -0.022877659648656845,
                "z": -184.1006317138672
            },
            {
                "x": -9.433297157287598,
                "y": -0.026167387142777443,
                "z": -183.94508361816406
            },
            {
                "x": -9.421172142028809,
                "y": -0.029642121866345406,
                "z": -183.7891387939453
            },
            {
                "x": -9.40871810913086,
                "y": -0.03327846899628639,
                "z": -183.6335906982422
            },
            {
                "x": -9.395716667175293,
                "y": -0.03708665817975998,
                "z": -183.47792053222656
            },
            {
                "x": -9.382326126098633,
                "y": -0.0410684309899807,
                "z": -183.32208251953125
            },
            {
                "x": -9.368544578552246,
                "y": -0.04520365223288536,
                "z": -183.16671752929688
            },
            {
                "x": -9.354231834411621,
                "y": -0.04950517788529396,
                "z": -183.01112365722656
            },
            {
                "x": -9.339593887329102,
                "y": -0.053962353616952896,
                "z": -182.8555450439453
            },
            {
                "x": -9.324479103088379,
                "y": -0.058571018278598785,
                "z": -182.70016479492188
            },
            {
                "x": -9.308886528015137,
                "y": -0.06334017217159271,
                "z": -182.54461669921875
            },
            {
                "x": -9.292981147766113,
                "y": -0.06824788451194763,
                "z": -182.38934326171875
            },
            {
                "x": -9.276556968688965,
                "y": -0.07330037653446198,
                "z": -182.23410034179688
            },
            {
                "x": -9.259727478027344,
                "y": -0.07850519567728043,
                "z": -182.07864379882812
            },
            {
                "x": -9.242528915405273,
                "y": -0.08384004235267639,
                "z": -181.92355346679688
            },
            {
                "x": -9.224803924560547,
                "y": -0.08931773155927658,
                "z": -181.76829528808594
            },
            {
                "x": -9.206758499145508,
                "y": -0.0949266329407692,
                "z": -181.61309814453125
            },
            {
                "x": -9.18828296661377,
                "y": -0.10065296292304993,
                "z": -181.45831298828125
            },
            {
                "x": -9.169303894042969,
                "y": -0.1065264493227005,
                "z": -181.30316162109375
            },
            {
                "x": -9.15002727508545,
                "y": -0.11251305043697357,
                "z": -181.1482391357422
            },
            {
                "x": -9.130237579345703,
                "y": -0.11862295866012573,
                "z": -180.9933319091797
            },
            {
                "x": -9.110058784484863,
                "y": -0.12486030161380768,
                "z": -180.8382568359375
            },
            {
                "x": -9.089532852172852,
                "y": -0.13119737803936005,
                "z": -180.68365478515625
            },
            {
                "x": -9.06849193572998,
                "y": -0.1376573145389557,
                "z": -180.5288543701172
            },
            {
                "x": -9.047138214111328,
                "y": -0.14422467350959778,
                "z": -180.37411499023438
            },
            {
                "x": -9.025333404541016,
                "y": -0.15089315176010132,
                "z": -180.2195281982422
            },
            {
                "x": -9.003080368041992,
                "y": -0.15767830610275269,
                "z": -180.0647735595703
            },
            {
                "x": -8.980530738830566,
                "y": -0.16454900801181793,
                "z": -179.91036987304688
            },
            {
                "x": -8.957481384277344,
                "y": -0.17152099311351776,
                "z": -179.7559356689453
            },
            {
                "x": -8.934078216552734,
                "y": -0.17859460413455963,
                "z": -179.6013641357422
            },
            {
                "x": -8.91030216217041,
                "y": -0.1857469081878662,
                "z": -179.4471893310547
            },
            {
                "x": -8.88603687286377,
                "y": -0.1930018961429596,
                "z": -179.29275512695312
            },
            {
                "x": -8.861492156982422,
                "y": -0.2003326117992401,
                "z": -179.13851928710938
            },
            {
                "x": -8.836509704589844,
                "y": -0.20773956179618835,
                "z": -178.9844970703125
            },
            {
                "x": -8.811102867126465,
                "y": -0.2152421474456787,
                "z": -178.83023071289062
            },
            {
                "x": -8.785402297973633,
                "y": -0.22280311584472656,
                "z": -178.67636108398438
            },
            {
                "x": -8.759190559387207,
                "y": -0.2304535210132599,
                "z": -178.52224731445312
            },
            {
                "x": -8.73270034790039,
                "y": -0.23816843330860138,
                "z": -178.3682403564453
            },
            {
                "x": -8.705821990966797,
                "y": -0.24593612551689148,
                "z": -178.21466064453125
            },
            {
                "x": -8.688199996948242,
                "y": -0.2509995698928833,
                "z": -178.115234375
            },
            {
                "x": -8.66071605682373,
                "y": -0.2588832378387451,
                "z": -177.9614715576172
            },
            {
                "x": -8.632814407348633,
                "y": -0.2668195962905884,
                "z": -177.8079071044922
            },
            {
                "x": -8.604486465454102,
                "y": -0.2748313546180725,
                "z": -177.65406799316406
            },
            {
                "x": -8.57591438293457,
                "y": -0.28287288546562195,
                "z": -177.5006866455078
            },
            {
                "x": -8.54686164855957,
                "y": -0.29097509384155273,
                "z": -177.34718322753906
            },
            {
                "x": -8.517495155334473,
                "y": -0.2991298735141754,
                "z": -177.19363403320312
            },
            {
                "x": -8.48780345916748,
                "y": -0.307309627532959,
                "z": -177.04052734375
            },
            {
                "x": -8.457630157470703,
                "y": -0.3155587613582611,
                "z": -176.88693237304688
            },
            {
                "x": -8.42724609375,
                "y": -0.32382315397262573,
                "z": -176.73382568359375
            },
            {
                "x": -8.396411895751953,
                "y": -0.33212631940841675,
                "z": -176.5807342529297
            },
            {
                "x": -8.365242958068848,
                "y": -0.34047257900238037,
                "z": -176.42747497558594
            },
            {
                "x": -8.333795547485352,
                "y": -0.3488253057003021,
                "z": -176.2747039794922
            },
            {
                "x": -8.301861763000488,
                "y": -0.357232928276062,
                "z": -176.1214599609375
            },
            {
                "x": -8.269723892211914,
                "y": -0.36564308404922485,
                "z": -175.9686279296875
            },
            {
                "x": -8.237186431884766,
                "y": -0.3740677535533905,
                "z": -175.81597900390625
            },
            {
                "x": -8.204267501831055,
                "y": -0.38253191113471985,
                "z": -175.66297912597656
            },
            {
                "x": -8.171123504638672,
                "y": -0.39098483324050903,
                "z": -175.51048278808594
            },
            {
                "x": -8.137527465820312,
                "y": -0.3994666635990143,
                "z": -175.3577423095703
            },
            {
                "x": -8.10367488861084,
                "y": -0.40795260667800903,
                "z": -175.205078125
            },
            {
                "x": -8.069490432739258,
                "y": -0.41643011569976807,
                "z": -175.05276489257812
            },
            {
                "x": -8.034966468811035,
                "y": -0.42492324113845825,
                "z": -174.90020751953125
            },
            {
                "x": -8.000195503234863,
                "y": -0.43339791893959045,
                "z": -174.74806213378906
            },
            {
                "x": -7.965000629425049,
                "y": -0.4418795108795166,
                "z": -174.5957489013672
            },
            {
                "x": -7.929523944854736,
                "y": -0.4503623843193054,
                "z": -174.44338989257812
            },
            {
                "x": -7.8937668800354,
                "y": -0.4588140845298767,
                "z": -174.29139709472656
            },
            {
                "x": -7.857644081115723,
                "y": -0.4672725200653076,
                "z": -174.13909912109375
            },
            {
                "x": -7.821298122406006,
                "y": -0.47569596767425537,
                "z": -173.98721313476562
            },
            {
                "x": -7.784571170806885,
                "y": -0.4841066002845764,
                "z": -173.83523559570312
            },
            {
                "x": -7.747563362121582,
                "y": -0.49250513315200806,
                "z": -173.68313598632812
            },
            {
                "x": -7.710303783416748,
                "y": -0.5008571147918701,
                "z": -173.53146362304688
            },
            {
                "x": -7.672695636749268,
                "y": -0.5091950297355652,
                "z": -173.3795623779297
            },
            {
                "x": -7.634857177734375,
                "y": -0.5174911618232727,
                "z": -173.22787475585938
            },
            {
                "x": -7.596669673919678,
                "y": -0.5257560610771179,
                "z": -173.0762176513672
            },
            {
                "x": -7.558241844177246,
                "y": -0.5339882969856262,
                "z": -172.92449951171875
            },
            {
                "x": -7.519525527954102,
                "y": -0.5421662330627441,
                "z": -172.77304077148438
            },
            {
                "x": -7.480510234832764,
                "y": -0.5503110885620117,
                "z": -172.62144470214844
            },
            {
                "x": -7.441281795501709,
                "y": -0.5583987832069397,
                "z": -172.4700927734375
            },
            {
                "x": -7.401721954345703,
                "y": -0.5664404630661011,
                "z": -172.31874084472656
            },
            {
                "x": -7.361950874328613,
                "y": -0.5744255781173706,
                "z": -172.16741943359375
            },
            {
                "x": -7.321857452392578,
                "y": -0.5823568105697632,
                "z": -172.01612854003906
            },
            {
                "x": -7.281518936157227,
                "y": -0.5902299284934998,
                "z": -171.86485290527344
            },
            {
                "x": -7.241007328033447,
                "y": -0.5980290174484253,
                "z": -171.71388244628906
            },
            {
                "x": -7.214635848999023,
                "y": -0.6030333638191223,
                "z": -171.6162872314453
            },
            {
                "x": -7.173645973205566,
                "y": -0.6107309460639954,
                "z": -171.46519470214844
            },
            {
                "x": -7.132442951202393,
                "y": -0.6183513402938843,
                "z": -171.3142547607422
            },
            {
                "x": -7.090915203094482,
                "y": -0.6259065866470337,
                "z": -171.16317749023438
            },
            {
                "x": -7.049254894256592,
                "y": -0.6333707571029663,
                "z": -171.0123748779297
            },
            {
                "x": -7.007272243499756,
                "y": -0.640762209892273,
                "z": -170.86151123046875
            },
            {
                "x": -6.965106010437012,
                "y": -0.6480706930160522,
                "z": -170.710693359375
            },
            {
                "x": -6.922743797302246,
                "y": -0.6552813053131104,
                "z": -170.5601043701172
            },
            {
                "x": -6.88004732131958,
                "y": -0.6624179482460022,
                "z": -170.40921020507812
            },
            {
                "x": -6.837254524230957,
                "y": -0.6694470047950745,
                "z": -170.25863647460938
            },
            {
                "x": -6.7941718101501465,
                "y": -0.6763857007026672,
                "z": -170.10804748535156
            },
            {
                "x": -6.750899791717529,
                "y": -0.6832260489463806,
                "z": -169.9574432373047
            },
            {
                "x": -6.707448959350586,
                "y": -0.6899526715278625,
                "z": -169.80711364746094
            },
            {
                "x": -6.663685321807861,
                "y": -0.696590781211853,
                "z": -169.6564178466797
            },
            {
                "x": -6.619851589202881,
                "y": -0.7031058669090271,
                "z": -169.50611877441406
            },
            {
                "x": -6.5757527351379395,
                "y": -0.7095118165016174,
                "z": -169.35577392578125
            },
            {
                "x": -6.531472206115723,
                "y": -0.715803861618042,
                "z": -169.2053985595703
            },
            {
                "x": -6.487028121948242,
                "y": -0.7219706773757935,
                "z": -169.0552215576172
            },
            {
                "x": -6.442333221435547,
                "y": -0.7280281782150269,
                "z": -168.90484619140625
            },
            {
                "x": -6.397524356842041,
                "y": -0.7339522242546082,
                "z": -168.7546844482422
            },
            {
                "x": -6.352496147155762,
                "y": -0.7397462129592896,
                "z": -168.60450744628906
            },
            {
                "x": -6.3073506355285645,
                "y": -0.7454084157943726,
                "z": -168.45443725585938
            },
            {
                "x": -6.262009620666504,
                "y": -0.75093674659729,
                "z": -168.304443359375
            },
            {
                "x": -6.216490268707275,
                "y": -0.7563318610191345,
                "z": -168.1543426513672
            },
            {
                "x": -6.170797348022461,
                "y": -0.7615825533866882,
                "z": -168.0042724609375
            },
            {
                "x": -6.124939918518066,
                "y": -0.7666893005371094,
                "z": -167.85427856445312
            },
            {
                "x": -6.078972816467285,
                "y": -0.7716488838195801,
                "z": -167.70433044433594
            },
            {
                "x": -6.032832622528076,
                "y": -0.776458740234375,
                "z": -167.55445861816406
            },
            {
                "x": -5.986545085906982,
                "y": -0.781111478805542,
                "z": -167.40452575683594
            },
            {
                "x": -5.940093517303467,
                "y": -0.7856103181838989,
                "z": -167.2545623779297
            },
            {
                "x": -5.893538951873779,
                "y": -0.7899484038352966,
                "z": -167.10475158691406
            },
            {
                "x": -5.846881866455078,
                "y": -0.7941229343414307,
                "z": -166.95498657226562
            },
            {
                "x": -5.80002498626709,
                "y": -0.7981283068656921,
                "z": -166.80514526367188
            },
            {
                "x": -5.753100872039795,
                "y": -0.8019636869430542,
                "z": -166.65541076660156
            },
            {
                "x": -5.706029891967773,
                "y": -0.8056285977363586,
                "z": -166.50564575195312
            },
            {
                "x": -5.658823490142822,
                "y": -0.8091208934783936,
                "z": -166.35585021972656
            },
            {
                "x": -5.611555576324463,
                "y": -0.8124233484268188,
                "z": -166.2062225341797
            },
            {
                "x": -5.564126491546631,
                "y": -0.8155485391616821,
                "z": -166.0564727783203
            },
            {
                "x": -5.516646862030029,
                "y": -0.8184874057769775,
                "z": -165.90687561035156
            },
            {
                "x": -5.469059944152832,
                "y": -0.8212395906448364,
                "z": -165.75729370117188
            },
            {
                "x": -5.421322345733643,
                "y": -0.8237959146499634,
                "z": -165.6074981689453
            },
            {
                "x": -5.373574256896973,
                "y": -0.8261544704437256,
                "z": -165.45797729492188
            },
            {
                "x": -5.325695514678955,
                "y": -0.8283177614212036,
                "z": -165.30836486816406
            },
            {
                "x": -5.294760227203369,
                "y": -0.8296077847480774,
                "z": -165.21177673339844
            },
            {
                "x": -5.246778964996338,
                "y": -0.8314329385757446,
                "z": -165.06228637695312
            },
            {
                "x": -5.198680877685547,
                "y": -0.8330554962158203,
                "z": -164.91262817382812
            },
            {
                "x": -5.15054178237915,
                "y": -0.8344685435295105,
                "z": -164.7630615234375
            },
            {
                "x": -5.102335453033447,
                "y": -0.8356626033782959,
                "z": -164.613525390625
            },
            {
                "x": -5.054068565368652,
                "y": -0.8366403579711914,
                "z": -164.4639434814453
            },
            {
                "x": -5.005754470825195,
                "y": -0.8373997211456299,
                "z": -164.31446838378906
            },
            {
                "x": -4.957395076751709,
                "y": -0.8379383087158203,
                "z": -164.16494750976562
            },
            {
                "x": -4.908938884735107,
                "y": -0.8382463455200195,
                "z": -164.01531982421875
            },
            {
                "x": -4.860475540161133,
                "y": -0.8383230566978455,
                "z": -163.86578369140625
            },
            {
                "x": -4.811982154846191,
                "y": -0.8381714820861816,
                "z": -163.71629333496094
            },
            {
                "x": -4.763452529907227,
                "y": -0.8377944231033325,
                "z": -163.56678771972656
            },
            {
                "x": -4.714884281158447,
                "y": -0.8371865749359131,
                "z": -163.41726684570312
            },
            {
                "x": -4.666248321533203,
                "y": -0.8363549709320068,
                "z": -163.267578125
            },
            {
                "x": -4.617670059204102,
                "y": -0.8353075385093689,
                "z": -163.11807250976562
            },
            {
                "x": -4.569072723388672,
                "y": -0.8340471982955933,
                "z": -162.96864318847656
            },
            {
                "x": -4.520404815673828,
                "y": -0.8325685262680054,
                "z": -162.8190155029297
            },
            {
                "x": -4.47179651260376,
                "y": -0.8308798670768738,
                "z": -162.66954040527344
            },
            {
                "x": -4.42313814163208,
                "y": -0.8289858102798462,
                "z": -162.51995849609375
            },
            {
                "x": -4.374480724334717,
                "y": -0.8268907070159912,
                "z": -162.37034606933594
            },
            {
                "x": -4.325858116149902,
                "y": -0.8245933055877686,
                "z": -162.22080993652344
            },
            {
                "x": -4.277263641357422,
                "y": -0.8220970630645752,
                "z": -162.0712432861328
            },
            {
                "x": -4.228693008422852,
                "y": -0.8194096088409424,
                "z": -161.92172241210938
            },
            {
                "x": -4.180121898651123,
                "y": -0.8165334463119507,
                "z": -161.7721405029297
            },
            {
                "x": -4.131525039672852,
                "y": -0.8134634494781494,
                "z": -161.62237548828125
            },
            {
                "x": -4.083010673522949,
                "y": -0.8102096319198608,
                "z": -161.47276306152344
            },
            {
                "x": -4.034529209136963,
                "y": -0.8067773580551147,
                "z": -161.32310485839844
            },
            {
                "x": -3.9860668182373047,
                "y": -0.8031672239303589,
                "z": -161.17337036132812
            },
            {
                "x": -3.9376912117004395,
                "y": -0.7993831634521484,
                "z": -161.02374267578125
            },
            {
                "x": -3.8892762660980225,
                "y": -0.7954185009002686,
                "z": -160.87384033203125
            },
            {
                "x": -3.8409929275512695,
                "y": -0.7912919521331787,
                "z": -160.72413635253906
            },
            {
                "x": -3.7927746772766113,
                "y": -0.7870040535926819,
                "z": -160.57444763183594
            },
            {
                "x": -3.744553327560425,
                "y": -0.7825464010238647,
                "z": -160.42449951171875
            },
            {
                "x": -3.6964643001556396,
                "y": -0.7779327630996704,
                "z": -160.2747344970703
            },
            {
                "x": -3.6483893394470215,
                "y": -0.773160457611084,
                "z": -160.12477111816406
            },
            {
                "x": -3.6004204750061035,
                "y": -0.7682384252548218,
                "z": -159.97486877441406
            },
            {
                "x": -3.5525496006011963,
                "y": -0.7631691694259644,
                "z": -159.82496643066406
            },
            {
                "x": -3.504739761352539,
                "y": -0.7579460144042969,
                "z": -159.67495727539062
            },
            {
                "x": -3.4570717811584473,
                "y": -0.7525871396064758,
                "z": -159.52500915527344
            },
            {
                "x": -3.40946102142334,
                "y": -0.7470872402191162,
                "z": -159.37501525878906
            },
            {
                "x": -3.3619225025177,
                "y": -0.7414447069168091,
                "z": -159.2248077392578
            },
            {
                "x": -3.3145177364349365,
                "y": -0.7356723546981812,
                "z": -159.07473754882812
            },
            {
                "x": -3.2672359943389893,
                "y": -0.7297690510749817,
                "z": -158.9246063232422
            },
            {
                "x": -3.2367751598358154,
                "y": -0.7258946299552917,
                "z": -158.8276824951172
            },
            {
                "x": -3.1896584033966064,
                "y": -0.7197826504707336,
                "z": -158.67747497558594
            },
            {
                "x": -3.1426703929901123,
                "y": -0.7135465145111084,
                "z": -158.5271759033203
            },
            {
                "x": -3.0957796573638916,
                "y": -0.7071932554244995,
                "z": -158.3768310546875
            },
            {
                "x": -3.0490565299987793,
                "y": -0.7007263898849487,
                "z": -158.22647094726562
            },
            {
                "x": -3.002473831176758,
                "y": -0.6941448450088501,
                "z": -158.07608032226562
            },
            {
                "x": -2.9560019969940186,
                "y": -0.6874520778656006,
                "z": -157.9256134033203
            },
            {
                "x": -2.909731149673462,
                "y": -0.6806598901748657,
                "z": -157.77517700195312
            },
            {
                "x": -2.863504409790039,
                "y": -0.6737542748451233,
                "z": -157.62449645996094
            },
            {
                "x": -2.8175086975097656,
                "y": -0.6667514443397522,
                "z": -157.473876953125
            },
            {
                "x": -2.7716739177703857,
                "y": -0.6596561670303345,
                "z": -157.32327270507812
            },
            {
                "x": -2.7259602546691895,
                "y": -0.6524611711502075,
                "z": -157.1724853515625
            },
            {
                "x": -2.6804800033569336,
                "y": -0.6451863050460815,
                "z": -157.0218048095703
            },
            {
                "x": -2.6350595951080322,
                "y": -0.6378058195114136,
                "z": -156.87078857421875
            },
            {
                "x": -2.58992075920105,
                "y": -0.6303535103797913,
                "z": -156.719970703125
            },
            {
                "x": -2.544935941696167,
                "y": -0.6228216886520386,
                "z": -156.56907653808594
            },
            {
                "x": -2.5000948905944824,
                "y": -0.6152015924453735,
                "z": -156.41790771484375
            },
            {
                "x": -2.4555282592773438,
                "y": -0.6075197458267212,
                "z": -156.26702880859375
            },
            {
                "x": -2.411062717437744,
                "y": -0.5997509956359863,
                "z": -156.11572265625
            },
            {
                "x": -2.366863250732422,
                "y": -0.5919214487075806,
                "z": -155.9645233154297
            },
            {
                "x": -2.3228330612182617,
                "y": -0.5840282440185547,
                "z": -155.8132781982422
            },
            {
                "x": -2.2790496349334717,
                "y": -0.5760693550109863,
                "z": -155.6619110107422
            },
            {
                "x": -2.2354788780212402,
                "y": -0.5680573582649231,
                "z": -155.51065063476562
            },
            {
                "x": -2.192091226577759,
                "y": -0.5599809288978577,
                "z": -155.35911560058594
            },
            {
                "x": -2.1489293575286865,
                "y": -0.5518519878387451,
                "z": -155.20751953125
            },
            {
                "x": -2.105975866317749,
                "y": -0.5436732769012451,
                "z": -155.05589294433594
            },
            {
                "x": -2.063307046890259,
                "y": -0.5354490280151367,
                "z": -154.90420532226562
            },
            {
                "x": -2.0208353996276855,
                "y": -0.5271823406219482,
                "z": -154.75247192382812
            },
            {
                "x": -1.9786144495010376,
                "y": -0.5188708305358887,
                "z": -154.60057067871094
            },
            {
                "x": -1.936623454093933,
                "y": -0.5105226039886475,
                "z": -154.44863891601562
            },
            {
                "x": -1.89487624168396,
                "y": -0.5021364688873291,
                "z": -154.29656982421875
            },
            {
                "x": -1.8534495830535889,
                "y": -0.4937286376953125,
                "z": -154.14459228515625
            },
            {
                "x": -1.8121895790100098,
                "y": -0.4852839410305023,
                "z": -153.9923858642578
            },
            {
                "x": -1.7712582349777222,
                "y": -0.476816326379776,
                "z": -153.84011840820312
            },
            {
                "x": -1.730571985244751,
                "y": -0.4683290719985962,
                "z": -153.68785095214844
            },
            {
                "x": -1.6901237964630127,
                "y": -0.4598121643066406,
                "z": -153.53530883789062
            },
            {
                "x": -1.6500333547592163,
                "y": -0.45129555463790894,
                "z": -153.38296508789062
            },
            {
                "x": -1.6101148128509521,
                "y": -0.4427524209022522,
                "z": -153.2303009033203
            },
            {
                "x": -1.5705865621566772,
                "y": -0.4342080354690552,
                "z": -153.0777130126953
            },
            {
                "x": -1.5312989950180054,
                "y": -0.42565998435020447,
                "z": -152.9250946044922
            },
            {
                "x": -1.4922561645507812,
                "y": -0.41708773374557495,
                "z": -152.7720184326172
            },
            {
                "x": -1.4536046981811523,
                "y": -0.4085415005683899,
                "z": -152.61932373046875
            },
            {
                "x": -1.4151816368103027,
                "y": -0.3999808430671692,
                "z": -152.4662628173828
            },
            {
                "x": -1.3905811309814453,
                "y": -0.39445918798446655,
                "z": -152.36740112304688
            },
            {
                "x": -1.3527129888534546,
                "y": -0.3859241008758545,
                "z": -152.21446228027344
            },
            {
                "x": -1.3151086568832397,
                "y": -0.37737974524497986,
                "z": -152.06106567382812
            },
            {
                "x": -1.277888298034668,
                "y": -0.3688647747039795,
                "z": -151.90785217285156
            },
            {
                "x": -1.2409172058105469,
                "y": -0.3603595197200775,
                "z": -151.75442504882812
            },
            {
                "x": -1.2043384313583374,
                "y": -0.3518751859664917,
                "z": -151.60092163085938
            },
            {
                "x": -1.1680530309677124,
                "y": -0.34342095255851746,
                "z": -151.4474639892578
            },
            {
                "x": -1.1321171522140503,
                "y": -0.3349839448928833,
                "z": -151.29373168945312
            },
            {
                "x": -1.0965099334716797,
                "y": -0.32658031582832336,
                "z": -151.14002990722656
            },
            {
                "x": -1.0612037181854248,
                "y": -0.31820160150527954,
                "z": -150.986083984375
            },
            {
                "x": -1.0263512134552002,
                "y": -0.3098708987236023,
                "z": -150.83224487304688
            },
            {
                "x": -0.9917535185813904,
                "y": -0.30157241225242615,
                "z": -150.67823791503906
            },
            {
                "x": -0.9575780034065247,
                "y": -0.29331523180007935,
                "z": -150.5240936279297
            },
            {
                "x": -0.923711359500885,
                "y": -0.28510332107543945,
                "z": -150.36990356445312
            },
            {
                "x": -0.8902051448822021,
                "y": -0.2769337594509125,
                "z": -150.2154998779297
            },
            {
                "x": -0.8571538925170898,
                "y": -0.26883333921432495,
                "z": -150.0613555908203
            },
            {
                "x": -0.824341893196106,
                "y": -0.2607676684856415,
                "z": -149.90675354003906
            },
            {
                "x": -0.7920090556144714,
                "y": -0.252766489982605,
                "z": -149.75221252441406
            },
            {
                "x": -0.7600079774856567,
                "y": -0.2448308765888214,
                "z": -149.59767150878906
            },
            {
                "x": -0.7283684015274048,
                "y": -0.23694346845149994,
                "z": -149.44271850585938
            },
            {
                "x": -0.6971921920776367,
                "y": -0.22914311289787292,
                "z": -149.2881317138672
            },
            {
                "x": -0.6663104295730591,
                "y": -0.22139683365821838,
                "z": -149.1331329345703
            },
            {
                "x": -0.6359291672706604,
                "y": -0.21373248100280762,
                "z": -148.9782257080078
            },
            {
                "x": -0.6058777570724487,
                "y": -0.20614591240882874,
                "z": -148.82327270507812
            },
            {
                "x": -0.5762088298797607,
                "y": -0.19861772656440735,
                "z": -148.6678009033203
            },
            {
                "x": -0.5470142960548401,
                "y": -0.19119615852832794,
                "z": -148.51278686523438
            },
            {
                "x": -0.5181349515914917,
                "y": -0.18383954465389252,
                "z": -148.35723876953125
            },
            {
                "x": -0.48978710174560547,
                "y": -0.1765855997800827,
                "z": -148.20187377929688
            },
            {
                "x": -0.4617609977722168,
                "y": -0.16942012310028076,
                "z": -148.0464324951172
            },
            {
                "x": -0.4341720938682556,
                "y": -0.1623341590166092,
                "z": -147.89056396484375
            },
            {
                "x": -0.40703821182250977,
                "y": -0.15536780655384064,
                "z": -147.735107421875
            },
            {
                "x": -0.38027992844581604,
                "y": -0.14848648011684418,
                "z": -147.5791778564453
            },
            {
                "x": -0.3540295958518982,
                "y": -0.14171838760375977,
                "z": -147.4234161376953
            },
            {
                "x": -0.3281116485595703,
                "y": -0.13505029678344727,
                "z": -147.26744079589844
            },
            {
                "x": -0.302707314491272,
                "y": -0.12848791480064392,
                "z": -147.11129760742188
            },
            {
                "x": -0.2777229845523834,
                "y": -0.12205224484205246,
                "z": -146.95533752441406
            },
            {
                "x": -0.2531563639640808,
                "y": -0.11571890860795975,
                "z": -146.79898071289062
            },
            {
                "x": -0.2290971875190735,
                "y": -0.10951456427574158,
                "z": -146.642822265625
            },
            {
                "x": -0.20538930594921112,
                "y": -0.10342420637607574,
                "z": -146.48641967773438
            },
            {
                "x": -0.18225228786468506,
                "y": -0.09746544808149338,
                "z": -146.3300018310547
            },
            {
                "x": -0.15947534143924713,
                "y": -0.09163280576467514,
                "z": -146.17349243164062
            },
            {
                "x": -0.13717851042747498,
                "y": -0.08592478930950165,
                "z": -146.01675415039062
            },
            {
                "x": -0.11540640145540237,
                "y": -0.08036433160305023,
                "z": -145.86038208007812
            },
            {
                "x": -0.10152553766965866,
                "y": -0.07684379816055298,
                "z": -145.75914001464844
            },
            {
                "x": -0.08047608286142349,
                "y": -0.07149915397167206,
                "z": -145.6022186279297
            },
            {
                "x": -0.05989747494459152,
                "y": -0.06630536168813705,
                "z": -145.44557189941406
            },
            {
                "x": -0.03972160816192627,
                "y": -0.06124722212553024,
                "z": -145.2884063720703
            },
            {
                "x": -0.020146027207374573,
                "y": -0.05634941905736923,
                "z": -145.1315460205078
            },
            {
                "x": -0.0009274035692214966,
                "y": -0.05159702152013779,
                "z": -144.9744873046875
            },
            {
                "x": 0.017750203609466553,
                "y": -0.046993572264909744,
                "z": -144.81723022460938
            },
            {
                "x": 0.03592275083065033,
                "y": -0.042564377188682556,
                "z": -144.6603240966797
            },
            {
                "x": 0.053706392645835876,
                "y": -0.03827788680791855,
                "z": -144.50274658203125
            },
            {
                "x": 0.07088044285774231,
                "y": -0.03416626527905464,
                "z": -144.34555053710938
            },
            {
                "x": 0.08768688142299652,
                "y": -0.030216582119464874,
                "z": -144.18824768066406
            },
            {
                "x": 0.10392306745052338,
                "y": -0.026435304433107376,
                "z": -144.03057861328125
            },
            {
                "x": 0.11965534090995789,
                "y": -0.02283826470375061,
                "z": -143.8733673095703
            },
            {
                "x": 0.13498839735984802,
                "y": -0.019400831311941147,
                "z": -143.71548461914062
            },
            {
                "x": 0.14969924092292786,
                "y": -0.01615053229033947,
                "z": -143.55799865722656
            },
            {
                "x": 0.1640109270811081,
                "y": -0.013085582293570042,
                "z": -143.40045166015625
            },
            {
                "x": 0.1777687668800354,
                "y": -0.01019906997680664,
                "z": -143.2424774169922
            },
            {
                "x": 0.1910088062286377,
                "y": -0.007507899776101112,
                "z": -143.0850067138672
            },
            {
                "x": 0.20383457839488983,
                "y": -0.0049963355995714664,
                "z": -142.9269561767578
            },
            {
                "x": 0.21602416038513184,
                "y": -0.0026863091625273228,
                "z": -142.7690887451172
            },
            {
                "x": 0.22780150175094604,
                "y": -0.0005765128880739212,
                "z": -142.61135864257812
            },
            {
                "x": 0.23902224004268646,
                "y": 0.0013400281313806772,
                "z": -142.45326232910156
            },
            {
                "x": 0.2497163712978363,
                "y": 0.0030513000674545765,
                "z": -142.2955780029297
            },
            {
                "x": 0.2599780261516571,
                "y": 0.004557962529361248,
                "z": -142.13743591308594
            },
            {
                "x": 0.2696146070957184,
                "y": 0.005854187533259392,
                "z": -141.97921752929688
            },
            {
                "x": 0.27882394194602966,
                "y": 0.0069387829862535,
                "z": -141.8213348388672
            },
            {
                "x": 0.2874906063079834,
                "y": 0.007814278826117516,
                "z": -141.66297912597656
            },
            {
                "x": 0.295585036277771,
                "y": 0.008467129431664944,
                "z": -141.50503540039062
            },
            {
                "x": 0.3032571077346802,
                "y": 0.008898422122001648,
                "z": -141.3468017578125
            },
            {
                "x": 0.310308039188385,
                "y": 0.009102565236389637,
                "z": -141.18836975097656
            },
            {
                "x": 0.3169088065624237,
                "y": 0.009110398590564728,
                "z": -141.03041076660156
            },
            {
                "x": 0.3229776620864868,
                "y": 0.009102679789066315,
                "z": -140.8719482421875
            },
            {
                "x": 0.3284415304660797,
                "y": 0.009094886481761932,
                "z": -140.7137908935547
            },
            {
                "x": 0.33350008726119995,
                "y": 0.00908716768026352,
                "z": -140.55557250976562
            },
            {
                "x": 0.33794105052948,
                "y": 0.00907938927412033,
                "z": -140.3970489501953
            },
            {
                "x": 0.3418893814086914,
                "y": 0.00907166302204132,
                "z": -140.23898315429688
            },
            {
                "x": 0.3453454375267029,
                "y": 0.00906389206647873,
                "z": -140.0804901123047
            },
            {
                "x": 0.34819209575653076,
                "y": 0.009056158363819122,
                "z": -139.9221954345703
            },
            {
                "x": 0.3506361246109009,
                "y": 0.009048432111740112,
                "z": -139.76406860351562
            },
            {
                "x": 0.3525146543979645,
                "y": 0.00904063880443573,
                "z": -139.60565185546875
            },
            {
                "x": 0.3539291322231293,
                "y": 0.00903293490409851,
                "z": -139.447509765625
            },
            {
                "x": 0.35496586561203003,
                "y": 0.00902518630027771,
                "z": -139.2893524169922
            },
            {
                "x": 0.35556864738464355,
                "y": 0.009017124772071838,
                "z": -139.1314697265625
            },
            {
                "x": 0.3558535575866699,
                "y": 0.009012363851070404,
                "z": -139.0296630859375
            },
            {
                "x": 0.35608357191085815,
                "y": 0.009004659950733185,
                "z": -138.87188720703125
            },
            {
                "x": 0.35610201954841614,
                "y": 0.00899689644575119,
                "z": -138.71432495117188
            },
            {
                "x": 0.3560637831687927,
                "y": 0.008989125490188599,
                "z": -138.55685424804688
            },
            {
                "x": 0.355936199426651,
                "y": 0.008981399238109589,
                "z": -138.39947509765625
            },
            {
                "x": 0.35577258467674255,
                "y": 0.008973643183708191,
                "z": -138.24212646484375
            },
            {
                "x": 0.3556012511253357,
                "y": 0.008965902030467987,
                "z": -138.08485412597656
            },
            {
                "x": 0.35541290044784546,
                "y": 0.008958138525485992,
                "z": -137.9276123046875
            },
            {
                "x": 0.3552219867706299,
                "y": 0.008950404822826385,
                "z": -137.77017211914062
            },
            {
                "x": 0.3550281524658203,
                "y": 0.008942656219005585,
                "z": -137.6129150390625
            },
            {
                "x": 0.3548312187194824,
                "y": 0.008934885263442993,
                "z": -137.4556427001953
            },
            {
                "x": 0.3546329140663147,
                "y": 0.008927151560783386,
                "z": -137.29835510253906
            },
            {
                "x": 0.3544323444366455,
                "y": 0.008919410407543182,
                "z": -137.14111328125
            },
            {
                "x": 0.3542296588420868,
                "y": 0.008911654353141785,
                "z": -136.98367309570312
            },
            {
                "x": 0.3540254831314087,
                "y": 0.00890391319990158,
                "z": -136.82644653320312
            },
            {
                "x": 0.3538190722465515,
                "y": 0.00889616459608078,
                "z": -136.66921997070312
            },
            {
                "x": 0.3536109924316406,
                "y": 0.00888841599225998,
                "z": -136.51185607910156
            },
            {
                "x": 0.35340097546577454,
                "y": 0.008880667388439178,
                "z": -136.3546142578125
            },
            {
                "x": 0.35318881273269653,
                "y": 0.008872918784618378,
                "z": -136.19729614257812
            },
            {
                "x": 0.352975070476532,
                "y": 0.00886516273021698,
                "z": -136.03994750976562
            },
            {
                "x": 0.3527590036392212,
                "y": 0.008857429027557373,
                "z": -135.88272094726562
            },
            {
                "x": 0.3525414764881134,
                "y": 0.008849672973155975,
                "z": -135.72549438476562
            },
            {
                "x": 0.3523217737674713,
                "y": 0.008841924369335175,
                "z": -135.56825256347656
            },
            {
                "x": 0.35210010409355164,
                "y": 0.008834190666675568,
                "z": -135.4110107421875
            },
            {
                "x": 0.35187649726867676,
                "y": 0.008826442062854767,
                "z": -135.25360107421875
            },
            {
                "x": 0.35165083408355713,
                "y": 0.00881868600845337,
                "z": -135.0963592529297
            },
            {
                "x": 0.3514235019683838,
                "y": 0.008810929954051971,
                "z": -134.93905639648438
            },
            {
                "x": 0.35119402408599854,
                "y": 0.008803188800811768,
                "z": -134.78175354003906
            },
            {
                "x": 0.3509626090526581,
                "y": 0.00879545509815216,
                "z": -134.62452697753906
            },
            {
                "x": 0.35072916746139526,
                "y": 0.008787699043750763,
                "z": -134.4670867919922
            },
            {
                "x": 0.35049378871917725,
                "y": 0.008779950439929962,
                "z": -134.3098602294922
            },
            {
                "x": 0.35025686025619507,
                "y": 0.008772209286689758,
                "z": -134.1526336669922
            },
            {
                "x": 0.3500173091888428,
                "y": 0.008764445781707764,
                "z": -133.9952850341797
            },
            {
                "x": 0.34977614879608154,
                "y": 0.00875670462846756,
                "z": -133.83802795410156
            },
            {
                "x": 0.34953296184539795,
                "y": 0.008748956024646759,
                "z": -133.68067932128906
            },
            {
                "x": 0.3492876887321472,
                "y": 0.008741207420825958,
                "z": -133.5233612060547
            },
            {
                "x": 0.34904083609580994,
                "y": 0.008733458817005157,
                "z": -133.3661346435547
            },
            {
                "x": 0.3487915098667145,
                "y": 0.008725710213184357,
                "z": -133.2087860107422
            },
            {
                "x": 0.34854060411453247,
                "y": 0.008717954158782959,
                "z": -133.0515594482422
            },
            {
                "x": 0.34828758239746094,
                "y": 0.008710220456123352,
                "z": -132.89431762695312
            },
            {
                "x": 0.34803229570388794,
                "y": 0.00871131382882595,
                "z": -132.7368927001953
            },
            {
                "x": 0.347775399684906,
                "y": 0.008952807635068893,
                "z": -132.5796661376953
            },
            {
                "x": 0.3475206792354584,
                "y": 0.009584148414433002,
                "z": -132.42245483398438
            },
            {
                "x": 0.34734708070755005,
                "y": 0.010194351896643639,
                "z": -132.32090759277344
            },
            {
                "x": 0.34708482027053833,
                "y": 0.011461174115538597,
                "z": -132.1636962890625
            },
            {
                "x": 0.34682032465934753,
                "y": 0.013095756992697716,
                "z": -132.00636291503906
            },
            {
                "x": 0.3465540409088135,
                "y": 0.015088831074535847,
                "z": -131.84906005859375
            },
            {
                "x": 0.34628555178642273,
                "y": 0.017438678070902824,
                "z": -131.69187927246094
            },
            {
                "x": 0.34601539373397827,
                "y": 0.02013886347413063,
                "z": -131.53457641601562
            },
            {
                "x": 0.3457428514957428,
                "y": 0.023168694227933884,
                "z": -131.3773956298828
            },
            {
                "x": 0.345468670129776,
                "y": 0.02652149088680744,
                "z": -131.22021484375
            },
            {
                "x": 0.3451920449733734,
                "y": 0.030201241374015808,
                "z": -131.0628204345703
            },
            {
                "x": 0.34491363167762756,
                "y": 0.034189000725746155,
                "z": -130.90565490722656
            },
            {
                "x": 0.34463322162628174,
                "y": 0.03847486525774002,
                "z": -130.7484588623047
            },
            {
                "x": 0.3443506956100464,
                "y": 0.04304899647831917,
                "z": -130.5912322998047
            },
            {
                "x": 0.34406644105911255,
                "y": 0.04790663346648216,
                "z": -130.43409729003906
            },
            {
                "x": 0.34377944469451904,
                "y": 0.05304962396621704,
                "z": -130.27674865722656
            },
            {
                "x": 0.3434910774230957,
                "y": 0.058446504175662994,
                "z": -130.11964416503906
            },
            {
                "x": 0.3432004451751709,
                "y": 0.06409665942192078,
                "z": -129.96249389648438
            },
            {
                "x": 0.3429078161716461,
                "y": 0.07000022381544113,
                "z": -129.80526733398438
            },
            {
                "x": 0.3426131010055542,
                "y": 0.07614178955554962,
                "z": -129.64816284179688
            },
            {
                "x": 0.34231632947921753,
                "y": 0.0825139656662941,
                "z": -129.49098205566406
            },
            {
                "x": 0.3420175313949585,
                "y": 0.0891048014163971,
                "z": -129.33380126953125
            },
            {
                "x": 0.3417167067527771,
                "y": 0.09590385854244232,
                "z": -129.17672729492188
            },
            {
                "x": 0.34141406416893005,
                "y": 0.10290993750095367,
                "z": -129.01966857910156
            },
            {
                "x": 0.341109037399292,
                "y": 0.1101081371307373,
                "z": -128.86260986328125
            },
            {
                "x": 0.3408023416996002,
                "y": 0.11748911440372467,
                "z": -128.70553588867188
            },
            {
                "x": 0.340492844581604,
                "y": 0.12505635619163513,
                "z": -128.54830932617188
            },
            {
                "x": 0.3401818871498108,
                "y": 0.13278651237487793,
                "z": -128.39125061035156
            },
            {
                "x": 0.3398686647415161,
                "y": 0.14067551493644714,
                "z": -128.23416137695312
            },
            {
                "x": 0.339553564786911,
                "y": 0.14871251583099365,
                "z": -128.07711791992188
            },
            {
                "x": 0.33923619985580444,
                "y": 0.15688812732696533,
                "z": -127.92011260986328
            },
            {
                "x": 0.3389166295528412,
                "y": 0.1652102768421173,
                "z": -127.76290893554688
            },
            {
                "x": 0.3385951519012451,
                "y": 0.17364463210105896,
                "z": -127.60590362548828
            },
            {
                "x": 0.3382717967033386,
                "y": 0.1821936070919037,
                "z": -127.44889068603516
            },
            {
                "x": 0.3379460573196411,
                "y": 0.19085323810577393,
                "z": -127.29177856445312
            },
            {
                "x": 0.33761852979660034,
                "y": 0.1996062844991684,
                "z": -127.13481140136719
            },
            {
                "x": 0.33728861808776855,
                "y": 0.2084522247314453,
                "z": -126.97775268554688
            },
            {
                "x": 0.336956650018692,
                "y": 0.21737827360630035,
                "z": -126.8206787109375
            },
            {
                "x": 0.33662280440330505,
                "y": 0.22636987268924713,
                "z": -126.66368865966797
            },
            {
                "x": 0.33628660440444946,
                "y": 0.23543134331703186,
                "z": -126.5066146850586
            },
            {
                "x": 0.3359486162662506,
                "y": 0.24453991651535034,
                "z": -126.3496322631836
            },
            {
                "x": 0.33560842275619507,
                "y": 0.2536931037902832,
                "z": -126.19265747070312
            },
            {
                "x": 0.3352659046649933,
                "y": 0.2628927230834961,
                "z": -126.03551483154297
            },
            {
                "x": 0.33492138981819153,
                "y": 0.27210989594459534,
                "z": -125.87853240966797
            },
            {
                "x": 0.33457687497138977,
                "y": 0.28134477138519287,
                "z": -125.7215805053711
            },
            {
                "x": 0.334349125623703,
                "y": 0.28731563687324524,
                "z": -125.62019348144531
            },
            {
                "x": 0.3339993953704834,
                "y": 0.296562522649765,
                "z": -125.46322631835938
            },
            {
                "x": 0.3336469531059265,
                "y": 0.3058107793331146,
                "z": -125.30616760253906
            },
            {
                "x": 0.33329281210899353,
                "y": 0.3150448799133301,
                "z": -125.14910125732422
            },
            {
                "x": 0.3329364061355591,
                "y": 0.32425203919410706,
                "z": -124.99214172363281
            },
            {
                "x": 0.33257806301116943,
                "y": 0.333434522151947,
                "z": -124.83506774902344
            },
            {
                "x": 0.3322174549102783,
                "y": 0.34257006645202637,
                "z": -124.67809295654297
            },
            {
                "x": 0.331854909658432,
                "y": 0.35165905952453613,
                "z": -124.52112579345703
            },
            {
                "x": 0.3314896821975708,
                "y": 0.36070311069488525,
                "z": -124.36392974853516
            },
            {
                "x": 0.3311230540275574,
                "y": 0.36966878175735474,
                "z": -124.20695495605469
            },
            {
                "x": 0.33075380325317383,
                "y": 0.37856167554855347,
                "z": -124.04991912841797
            },
            {
                "x": 0.330382764339447,
                "y": 0.3873729109764099,
                "z": -123.89286041259766
            },
            {
                "x": 0.33000943064689636,
                "y": 0.39608973264694214,
                "z": -123.73587036132812
            },
            {
                "x": 0.32963377237319946,
                "y": 0.4047163128852844,
                "z": -123.57866668701172
            },
            {
                "x": 0.3292562961578369,
                "y": 0.41322052478790283,
                "z": -123.42163848876953
            },
            {
                "x": 0.32887667417526245,
                "y": 0.42160701751708984,
                "z": -123.2646255493164
            },
            {
                "x": 0.3284948468208313,
                "y": 0.4298735558986664,
                "z": -123.10749816894531
            },
            {
                "x": 0.328110933303833,
                "y": 0.4380001127719879,
                "z": -122.95045471191406
            },
            {
                "x": 0.3277248442173004,
                "y": 0.44598132371902466,
                "z": -122.79331970214844
            },
            {
                "x": 0.3273363709449768,
                "y": 0.45381155610084534,
                "z": -122.63616943359375
            },
            {
                "x": 0.3269462585449219,
                "y": 0.4614761769771576,
                "z": -122.47911071777344
            },
            {
                "x": 0.32655391097068787,
                "y": 0.46897071599960327,
                "z": -122.32205963134766
            },
            {
                "x": 0.3261594772338867,
                "y": 0.4762798547744751,
                "z": -122.16500091552734
            },
            {
                "x": 0.3257627785205841,
                "y": 0.4834030866622925,
                "z": -122.00790405273438
            },
            {
                "x": 0.3253636360168457,
                "y": 0.49033892154693604,
                "z": -121.85062408447266
            },
            {
                "x": 0.3249627947807312,
                "y": 0.49706247448921204,
                "z": -121.69351959228516
            },
            {
                "x": 0.3245597183704376,
                "y": 0.5035653114318848,
                "z": -121.53634643554688
            },
            {
                "x": 0.3241545557975769,
                "y": 0.5098461508750916,
                "z": -121.37918853759766
            },
            {
                "x": 0.32374727725982666,
                "y": 0.5158950686454773,
                "z": -121.22203826904297
            },
            {
                "x": 0.3233376741409302,
                "y": 0.5217124223709106,
                "z": -121.06470489501953
            },
            {
                "x": 0.3229261636734009,
                "y": 0.5272636413574219,
                "z": -120.90754699707031
            },
            {
                "x": 0.322512686252594,
                "y": 0.5325572490692139,
                "z": -120.7503890991211
            },
            {
                "x": 0.3220967948436737,
                "y": 0.5375893115997314,
                "z": -120.59310150146484
            },
            {
                "x": 0.3216790556907654,
                "y": 0.5423442125320435,
                "z": -120.43592071533203
            },
            {
                "x": 0.321259081363678,
                "y": 0.5468072295188904,
                "z": -120.27864837646484
            },
            {
                "x": 0.3208368420600891,
                "y": 0.5509763956069946,
                "z": -120.12134552001953
            },
            {
                "x": 0.32041293382644653,
                "y": 0.5548428297042847,
                "z": -119.96414184570312
            },
            {
                "x": 0.3199867308139801,
                "y": 0.5584028363227844,
                "z": -119.80682373046875
            },
            {
                "x": 0.3195585012435913,
                "y": 0.5616304874420166,
                "z": -119.64961242675781
            },
            {
                "x": 0.3191284239292145,
                "y": 0.564528226852417,
                "z": -119.49238586425781
            },
            {
                "x": 0.31869569420814514,
                "y": 0.5670937895774841,
                "z": -119.3349609375
            },
            {
                "x": 0.3182615637779236,
                "y": 0.5693122148513794,
                "z": -119.1777114868164
            },
            {
                "x": 0.31782519817352295,
                "y": 0.571165144443512,
                "z": -119.0204849243164
            },
            {
                "x": 0.3175414204597473,
                "y": 0.5721670389175415,
                "z": -118.91891479492188
            },
            {
                "x": 0.3171018958091736,
                "y": 0.5734213590621948,
                "z": -118.76165008544922
            },
            {
                "x": 0.31665992736816406,
                "y": 0.5742906332015991,
                "z": -118.60430145263672
            },
            {
                "x": 0.31621628999710083,
                "y": 0.5747659206390381,
                "z": -118.44693756103516
            },
            {
                "x": 0.3157707452774048,
                "y": 0.574847400188446,
                "z": -118.2896957397461
            },
            {
                "x": 0.31532299518585205,
                "y": 0.5745327472686768,
                "z": -118.13233184814453
            },
            {
                "x": 0.31487369537353516,
                "y": 0.5738207101821899,
                "z": -117.9750747680664
            },
            {
                "x": 0.3144223690032959,
                "y": 0.5727192163467407,
                "z": -117.81781768798828
            },
            {
                "x": 0.31396859884262085,
                "y": 0.5712449550628662,
                "z": -117.6603775024414
            },
            {
                "x": 0.3135136365890503,
                "y": 0.5694100856781006,
                "z": -117.50313568115234
            },
            {
                "x": 0.3130565881729126,
                "y": 0.5672134160995483,
                "z": -117.3458480834961
            },
            {
                "x": 0.3125976622104645,
                "y": 0.564661979675293,
                "z": -117.18853759765625
            },
            {
                "x": 0.31213709712028503,
                "y": 0.5617756843566895,
                "z": -117.03131866455078
            },
            {
                "x": 0.3116742670536041,
                "y": 0.5585582852363586,
                "z": -116.8739013671875
            },
            {
                "x": 0.31121009588241577,
                "y": 0.5550198554992676,
                "z": -116.71669006347656
            },
            {
                "x": 0.3107442855834961,
                "y": 0.551162838935852,
                "z": -116.55950164794922
            },
            {
                "x": 0.31027641892433167,
                "y": 0.5470020174980164,
                "z": -116.40220642089844
            },
            {
                "x": 0.3098072409629822,
                "y": 0.5425518751144409,
                "z": -116.24501037597656
            },
            {
                "x": 0.3093360662460327,
                "y": 0.5378099679946899,
                "z": -116.08773803710938
            },
            {
                "x": 0.3088633418083191,
                "y": 0.532785177230835,
                "z": -115.93045806884766
            },
            {
                "x": 0.308389276266098,
                "y": 0.5274971723556519,
                "z": -115.77330780029297
            },
            {
                "x": 0.30791378021240234,
                "y": 0.5219522714614868,
                "z": -115.61615753173828
            },
            {
                "x": 0.30743682384490967,
                "y": 0.5161556005477905,
                "z": -115.45902252197266
            },
            {
                "x": 0.30695825815200806,
                "y": 0.51011061668396,
                "z": -115.30188751220703
            },
            {
                "x": 0.3064778447151184,
                "y": 0.5038272142410278,
                "z": -115.14456939697266
            },
            {
                "x": 0.30599653720855713,
                "y": 0.4973291754722595,
                "z": -114.98746490478516
            },
            {
                "x": 0.305513858795166,
                "y": 0.4906134605407715,
                "z": -114.83031463623047
            },
            {
                "x": 0.3050299882888794,
                "y": 0.4836846888065338,
                "z": -114.67317962646484
            },
            {
                "x": 0.30454498529434204,
                "y": 0.47656238079071045,
                "z": -114.5160903930664
            },
            {
                "x": 0.30405837297439575,
                "y": 0.46924370527267456,
                "z": -114.35883331298828
            },
            {
                "x": 0.30357128381729126,
                "y": 0.46175432205200195,
                "z": -114.20175170898438
            },
            {
                "x": 0.303083211183548,
                "y": 0.4540877044200897,
                "z": -114.04470825195312
            },
            {
                "x": 0.30259397625923157,
                "y": 0.4462541341781616,
                "z": -113.88754272460938
            },
            {
                "x": 0.3021041750907898,
                "y": 0.4382740557193756,
                "z": -113.73049926757812
            },
            {
                "x": 0.301613450050354,
                "y": 0.43014493584632874,
                "z": -113.57337951660156
            },
            {
                "x": 0.30112195014953613,
                "y": 0.42187386751174927,
                "z": -113.416259765625
            },
            {
                "x": 0.3006304204463959,
                "y": 0.4134818911552429,
                "z": -113.25924682617188
            },
            {
                "x": 0.3001382052898407,
                "y": 0.40496623516082764,
                "z": -113.10213470458984
            },
            {
                "x": 0.29964590072631836,
                "y": 0.3963475823402405,
                "z": -112.94513702392578
            },
            {
                "x": 0.29915356636047363,
                "y": 0.3876231908798218,
                "z": -112.78813171386719
            },
            {
                "x": 0.2986606955528259,
                "y": 0.37879636883735657,
                "z": -112.63094329833984
            },
            {
                "x": 0.29816848039627075,
                "y": 0.36989742517471313,
                "z": -112.47396087646484
            },
            {
                "x": 0.29767662286758423,
                "y": 0.3609243333339691,
                "z": -112.3169937133789
            },
            {
                "x": 0.2973582148551941,
                "y": 0.35508978366851807,
                "z": -112.21559143066406
            },
            {
                "x": 0.2968672513961792,
                "y": 0.3460102081298828,
                "z": -112.0586166381836
            },
            {
                "x": 0.2963770627975464,
                "y": 0.3368731737136841,
                "z": -111.90154266357422
            },
            {
                "x": 0.29588794708251953,
                "y": 0.32769322395324707,
                "z": -111.74449920654297
            },
            {
                "x": 0.295400470495224,
                "y": 0.3184835910797119,
                "z": -111.58753204345703
            },
            {
                "x": 0.29491427540779114,
                "y": 0.30924203991889954,
                "z": -111.43047332763672
            },
            {
                "x": 0.2944304943084717,
                "y": 0.29999014735221863,
                "z": -111.27352905273438
            },
            {
                "x": 0.2939488887786865,
                "y": 0.29072925448417664,
                "z": -111.11656188964844
            },
            {
                "x": 0.29346954822540283,
                "y": 0.28145694732666016,
                "z": -110.95941162109375
            },
            {
                "x": 0.29299384355545044,
                "y": 0.2722064256668091,
                "z": -110.8024673461914
            },
            {
                "x": 0.29252150654792786,
                "y": 0.2629702091217041,
                "z": -110.64546966552734
            },
            {
                "x": 0.29205334186553955,
                "y": 0.25375962257385254,
                "z": -110.48847198486328
            },
            {
                "x": 0.2915901839733124,
                "y": 0.24458925426006317,
                "z": -110.33152770996094
            },
            {
                "x": 0.2911319136619568,
                "y": 0.23545071482658386,
                "z": -110.17437744140625
            },
            {
                "x": 0.2906801998615265,
                "y": 0.22637537121772766,
                "z": -110.01741790771484
            },
            {
                "x": 0.2902356684207916,
                "y": 0.21736246347427368,
                "z": -109.86046600341797
            },
            {
                "x": 0.28979918360710144,
                "y": 0.2084159255027771,
                "z": -109.70340728759766
            },
            {
                "x": 0.2893720865249634,
                "y": 0.199552983045578,
                "z": -109.54644012451172
            },
            {
                "x": 0.2889552116394043,
                "y": 0.1907716989517212,
                "z": -109.38936614990234
            },
            {
                "x": 0.28855058550834656,
                "y": 0.18208666145801544,
                "z": -109.2322998046875
            },
            {
                "x": 0.28816068172454834,
                "y": 0.1735163778066635,
                "z": -109.07534790039062
            },
            {
                "x": 0.2877870798110962,
                "y": 0.1650591492652893,
                "z": -108.91838073730469
            },
            {
                "x": 0.28743237257003784,
                "y": 0.15672358870506287,
                "z": -108.76141357421875
            },
            {
                "x": 0.2870999574661255,
                "y": 0.1485186666250229,
                "z": -108.60446166992188
            },
            {
                "x": 0.28679490089416504,
                "y": 0.14044936001300812,
                "z": -108.44729614257812
            },
            {
                "x": 0.2865220904350281,
                "y": 0.1325378566980362,
                "z": -108.29032897949219
            },
            {
                "x": 0.2862764596939087,
                "y": 0.12477552145719528,
                "z": -108.13321685791016
            },
            {
                "x": 0.2858600318431854,
                "y": 0.11713655292987823,
                "z": -107.9752197265625
            },
            {
                "x": 0.284517765045166,
                "y": 0.10962648689746857,
                "z": -107.81609344482422
            },
            {
                "x": 0.2819535732269287,
                "y": 0.10228823870420456,
                "z": -107.65665435791016
            },
            {
                "x": 0.278215616941452,
                "y": 0.0951591208577156,
                "z": -107.49755096435547
            },
            {
                "x": 0.27337557077407837,
                "y": 0.08823876082897186,
                "z": -107.3386001586914
            },
            {
                "x": 0.26745539903640747,
                "y": 0.08154061436653137,
                "z": -107.1796875
            },
            {
                "x": 0.2605697512626648,
                "y": 0.07507370412349701,
                "z": -107.02102661132812
            },
            {
                "x": 0.25277790427207947,
                "y": 0.0688374936580658,
                "z": -106.8624496459961
            },
            {
                "x": 0.24415454268455505,
                "y": 0.06284350901842117,
                "z": -106.70398712158203
            },
            {
                "x": 0.23474660515785217,
                "y": 0.057114116847515106,
                "z": -106.54581451416016
            },
            {
                "x": 0.22462517023086548,
                "y": 0.051641758531332016,
                "z": -106.3876724243164
            },
            {
                "x": 0.21386760473251343,
                "y": 0.046439554542303085,
                "z": -106.22976684570312
            },
            {
                "x": 0.20253711938858032,
                "y": 0.04151219129562378,
                "z": -106.07202911376953
            },
            {
                "x": 0.19064319133758545,
                "y": 0.036871761083602905,
                "z": -105.91419219970703
            },
            {
                "x": 0.1782912313938141,
                "y": 0.03253196179866791,
                "z": -105.75670623779297
            },
            {
                "x": 0.1655265837907791,
                "y": 0.02849082089960575,
                "z": -105.59932708740234
            },
            {
                "x": 0.15708041191101074,
                "y": 0.026042208075523376,
                "z": -105.49772644042969
            },
            {
                "x": 0.14372241497039795,
                "y": 0.0225210003554821,
                "z": -105.34053039550781
            },
            {
                "x": 0.1300601065158844,
                "y": 0.019317803904414177,
                "z": -105.18330383300781
            },
            {
                "x": 0.11614976823329926,
                "y": 0.016443736851215363,
                "z": -105.02621459960938
            },
            {
                "x": 0.10202886909246445,
                "y": 0.013915766030550003,
                "z": -104.86927795410156
            },
            {
                "x": 0.0877186730504036,
                "y": 0.011740198358893394,
                "z": -104.71232604980469
            },
            {
                "x": 0.07327772676944733,
                "y": 0.009919453412294388,
                "z": -104.55554962158203
            },
            {
                "x": 0.05872981250286102,
                "y": 0.008460038341581821,
                "z": -104.3988265991211
            },
            {
                "x": 0.04408169537782669,
                "y": 0.007377197965979576,
                "z": -104.24198150634766
            },
            {
                "x": 0.02940305322408676,
                "y": 0.006684725638478994,
                "z": -104.08538055419922
            },
            {
                "x": 0.014691650867462158,
                "y": 0.006379019469022751,
                "z": -103.92876434326172
            },
            {
                "x": -2.0816922187805176e-05,
                "y": 0.006349794566631317,
                "z": -103.77217864990234
            },
            {
                "x": -0.014705322682857513,
                "y": 0.006342623382806778,
                "z": -103.61569213867188
            },
            {
                "x": -0.029363714158535004,
                "y": 0.006335459649562836,
                "z": -103.45902252197266
            },
            {
                "x": -0.04394179582595825,
                "y": 0.0063282884657382965,
                "z": -103.30259704589844
            },
            {
                "x": -0.05844105780124664,
                "y": 0.006321132183074951,
                "z": -103.14619445800781
            },
            {
                "x": -0.07285428047180176,
                "y": 0.006313983350992203,
                "z": -102.98970031738281
            },
            {
                "x": -0.08714675903320312,
                "y": 0.006306789815425873,
                "z": -102.83332061767578
            },
            {
                "x": -0.10132136940956116,
                "y": 0.006299637258052826,
                "z": -102.67687225341797
            },
            {
                "x": -0.11535952240228653,
                "y": 0.006292469799518585,
                "z": -102.52041625976562
            },
            {
                "x": -0.12924085557460785,
                "y": 0.006285309791564941,
                "z": -102.36407470703125
            },
            {
                "x": -0.14295929670333862,
                "y": 0.006278149783611298,
                "z": -102.2077407836914
            },
            {
                "x": -0.1565118283033371,
                "y": 0.006271004676818848,
                "z": -102.05139923095703
            },
            {
                "x": -0.1698891669511795,
                "y": 0.006263818591833115,
                "z": -101.89505767822266
            },
            {
                "x": -0.18309921026229858,
                "y": 0.0062566474080085754,
                "z": -101.738525390625
            },
            {
                "x": -0.19609332084655762,
                "y": 0.006249479949474335,
                "z": -101.5821762084961
            },
            {
                "x": -0.2088967263698578,
                "y": 0.006242323666810989,
                "z": -101.42577362060547
            },
            {
                "x": -0.22149915993213654,
                "y": 0.006235174834728241,
                "z": -101.26937103271484
            },
            {
                "x": -0.23388642072677612,
                "y": 0.006227992475032806,
                "z": -101.11300659179688
            },
            {
                "x": -0.24606908857822418,
                "y": 0.0062208399176597595,
                "z": -100.95642852783203
            },
            {
                "x": -0.2580186128616333,
                "y": 0.006213661283254623,
                "z": -100.80005645751953
            },
            {
                "x": -0.269751638174057,
                "y": 0.006206493824720383,
                "z": -100.64366149902344
            },
            {
                "x": -0.2812671959400177,
                "y": 0.006199341267347336,
                "z": -100.48713684082031
            },
            {
                "x": -0.2925403118133545,
                "y": 0.0061921775341033936,
                "z": -100.33070373535156
            },
            {
                "x": -0.30359336733818054,
                "y": 0.006185021251440048,
                "z": -100.17418670654297
            },
            {
                "x": -0.31441831588745117,
                "y": 0.006177835166454315,
                "z": -100.01764678955078
            },
            {
                "x": -0.3250035345554352,
                "y": 0.006170690059661865,
                "z": -99.86119079589844
            },
            {
                "x": -0.3353496789932251,
                "y": 0.0061635226011276245,
                "z": -99.70460510253906
            },
            {
                "x": -0.34545767307281494,
                "y": 0.006156332790851593,
                "z": -99.5481185913086
            },
            {
                "x": -0.35533076524734497,
                "y": 0.00614919513463974,
                "z": -99.3916244506836
            },
            {
                "x": -0.36497992277145386,
                "y": 0.006142031401395798,
                "z": -99.23490142822266
            },
            {
                "x": -0.37437233328819275,
                "y": 0.0061348602175712585,
                "z": -99.07838439941406
            },
            {
                "x": -0.3835287094116211,
                "y": 0.006127700209617615,
                "z": -98.92184448242188
            },
            {
                "x": -0.3893219232559204,
                "y": 0.006123058497905731,
                "z": -98.82073211669922
            },
            {
                "x": -0.39808428287506104,
                "y": 0.006115850061178207,
                "z": -98.6641616821289
            },
            {
                "x": -0.4066163897514343,
                "y": 0.006108693778514862,
                "z": -98.50748443603516
            },
            {
                "x": -0.41491177678108215,
                "y": 0.006101541221141815,
                "z": -98.3508071899414
            },
            {
                "x": -0.4229664206504822,
                "y": 0.006094388663768768,
                "z": -98.19419860839844
            },
            {
                "x": -0.4307839870452881,
                "y": 0.006087210029363632,
                "z": -98.03746032714844
            },
            {
                "x": -0.43835997581481934,
                "y": 0.00609551090747118,
                "z": -97.88082122802734
            },
            {
                "x": -0.445705384016037,
                "y": 0.006234876811504364,
                "z": -97.72419738769531
            },
            {
                "x": -0.4528288245201111,
                "y": 0.006540725473314524,
                "z": -97.56732940673828
            },
            {
                "x": -0.4597012996673584,
                "y": 0.007015495095402002,
                "z": -97.41067504882812
            },
            {
                "x": -0.46634572744369507,
                "y": 0.007651268504559994,
                "z": -97.25395202636719
            },
            {
                "x": -0.4727635085582733,
                "y": 0.008443127386271954,
                "z": -97.09719848632812
            },
            {
                "x": -0.4789513349533081,
                "y": 0.009387297555804253,
                "z": -96.94049072265625
            },
            {
                "x": -0.48491060733795166,
                "y": 0.010487956926226616,
                "z": -96.78358459472656
            },
            {
                "x": -0.49063754081726074,
                "y": 0.01173488236963749,
                "z": -96.6268539428711
            },
            {
                "x": -0.49614155292510986,
                "y": 0.013124275952577591,
                "z": -96.47013854980469
            },
            {
                "x": -0.5014253258705139,
                "y": 0.01465408131480217,
                "z": -96.31329345703125
            },
            {
                "x": -0.5064796209335327,
                "y": 0.016323648393154144,
                "z": -96.15654754638672
            },
            {
                "x": -0.5113168954849243,
                "y": 0.01812853291630745,
                "z": -95.99969482421875
            },
            {
                "x": -0.5159358978271484,
                "y": 0.020062904804944992,
                "z": -95.84281921386719
            },
            {
                "x": -0.5203376412391663,
                "y": 0.02212182618677616,
                "z": -95.68605041503906
            },
            {
                "x": -0.5245192050933838,
                "y": 0.024307239800691605,
                "z": -95.52926635742188
            },
            {
                "x": -0.5284832119941711,
                "y": 0.026613593101501465,
                "z": -95.37248229980469
            },
            {
                "x": -0.5322368741035461,
                "y": 0.02903577871620655,
                "z": -95.2156753540039
            },
            {
                "x": -0.535785973072052,
                "y": 0.03157352656126022,
                "z": -95.05867767333984
            },
            {
                "x": -0.5391142964363098,
                "y": 0.034220561385154724,
                "z": -94.90186309814453
            },
            {
                "x": -0.5422365069389343,
                "y": 0.0369759276509285,
                "z": -94.74500274658203
            },
            {
                "x": -0.545154333114624,
                "y": 0.03983341529965401,
                "z": -94.58814239501953
            },
            {
                "x": -0.5478694438934326,
                "y": 0.04278881847858429,
                "z": -94.43132019042969
            },
            {
                "x": -0.5503826141357422,
                "y": 0.045846547931432724,
                "z": -94.2742919921875
            },
            {
                "x": -0.5526857376098633,
                "y": 0.04899431765079498,
                "z": -94.11747741699219
            },
            {
                "x": -0.554792046546936,
                "y": 0.05223081260919571,
                "z": -93.96063232421875
            },
            {
                "x": -0.5567021369934082,
                "y": 0.055555135011672974,
                "z": -93.8036880493164
            },
            {
                "x": -0.5584129095077515,
                "y": 0.058960940688848495,
                "z": -93.6468505859375
            },
            {
                "x": -0.5599302053451538,
                "y": 0.06244935840368271,
                "z": -93.48992156982422
            },
            {
                "x": -0.5612552165985107,
                "y": 0.06601320952177048,
                "z": -93.33296203613281
            },
            {
                "x": -0.5623899102210999,
                "y": 0.06964683532714844,
                "z": -93.17610931396484
            },
            {
                "x": -0.5633276700973511,
                "y": 0.07335281372070312,
                "z": -93.0191650390625
            },
            {
                "x": -0.564075231552124,
                "y": 0.077122762799263,
                "z": -92.86231994628906
            },
            {
                "x": -0.5646277666091919,
                "y": 0.08095359802246094,
                "z": -92.70550537109375
            },
            {
                "x": -0.5649585723876953,
                "y": 0.0848459005355835,
                "z": -92.54856872558594
            },
            {
                "x": -0.5649814605712891,
                "y": 0.08878649771213531,
                "z": -92.39196014404297
            },
            {
                "x": -0.5646207928657532,
                "y": 0.09277500212192535,
                "z": -92.23554992675781
            },
            {
                "x": -0.5641472935676575,
                "y": 0.09537605196237564,
                "z": -92.13456726074219
            },
            {
                "x": -0.5630030632019043,
                "y": 0.09944111108779907,
                "z": -91.97824096679688
            },
            {
                "x": -0.5613142251968384,
                "y": 0.10355222225189209,
                "z": -91.82188415527344
            },
            {
                "x": -0.5591121315956116,
                "y": 0.1077028140425682,
                "z": -91.66555786132812
            },
            {
                "x": -0.5563886761665344,
                "y": 0.11188749969005585,
                "z": -91.50934600830078
            },
            {
                "x": -0.5531387329101562,
                "y": 0.11610917001962662,
                "z": -91.3530044555664
            },
            {
                "x": -0.5493241548538208,
                "y": 0.12035958468914032,
                "z": -91.19677734375
            },
            {
                "x": -0.5449787378311157,
                "y": 0.12463586032390594,
                "z": -91.04058837890625
            },
            {
                "x": -0.5400931239128113,
                "y": 0.1289406716823578,
                "z": -90.88422393798828
            },
            {
                "x": -0.5346808433532715,
                "y": 0.13325923681259155,
                "z": -90.72811889648438
            },
            {
                "x": -0.5287109613418579,
                "y": 0.13759778439998627,
                "z": -90.5719223022461
            },
            {
                "x": -0.5221944451332092,
                "y": 0.14194944500923157,
                "z": -90.41575622558594
            },
            {
                "x": -0.5151414275169373,
                "y": 0.14630916714668274,
                "z": -90.25968170166016
            },
            {
                "x": -0.5075291991233826,
                "y": 0.15068113803863525,
                "z": -90.10340881347656
            },
            {
                "x": -0.49936485290527344,
                "y": 0.1550498902797699,
                "z": -89.9474105834961
            },
            {
                "x": -0.4906633198261261,
                "y": 0.1594182550907135,
                "z": -89.79142761230469
            },
            {
                "x": -0.48141029477119446,
                "y": 0.16378632187843323,
                "z": -89.6353759765625
            },
            {
                "x": -0.4716280400753021,
                "y": 0.16814427077770233,
                "z": -89.47943878173828
            },
            {
                "x": -0.46126070618629456,
                "y": 0.1724943071603775,
                "z": -89.32344055175781
            },
            {
                "x": -0.4503509998321533,
                "y": 0.17683005332946777,
                "z": -89.16748809814453
            },
            {
                "x": -0.4389076828956604,
                "y": 0.1811460554599762,
                "z": -89.01165771484375
            },
            {
                "x": -0.42692068219184875,
                "y": 0.18544110655784607,
                "z": -88.85588073730469
            },
            {
                "x": -0.4143759310245514,
                "y": 0.18971097469329834,
                "z": -88.70014190673828
            },
            {
                "x": -0.40129512548446655,
                "y": 0.1939534693956375,
                "z": -88.54443359375
            },
            {
                "x": -0.3876577317714691,
                "y": 0.19817006587982178,
                "z": -88.38858795166016
            },
            {
                "x": -0.3735074996948242,
                "y": 0.20234736800193787,
                "z": -88.23297882080078
            },
            {
                "x": -0.35879695415496826,
                "y": 0.20648735761642456,
                "z": -88.07733154296875
            },
            {
                "x": -0.343555748462677,
                "y": 0.21058540046215057,
                "z": -87.92173767089844
            },
            {
                "x": -0.3277982473373413,
                "y": 0.2146376669406891,
                "z": -87.76625061035156
            },
            {
                "x": -0.31150022149086,
                "y": 0.21864716708660126,
                "z": -87.610595703125
            },
            {
                "x": -0.2946813404560089,
                "y": 0.22259783744812012,
                "z": -87.4552230834961
            },
            {
                "x": -0.2773483395576477,
                "y": 0.22649340331554413,
                "z": -87.29985809326172
            },
            {
                "x": -0.25949543714523315,
                "y": 0.23033374547958374,
                "z": -87.14446258544922
            },
            {
                "x": -0.24115362763404846,
                "y": 0.23410990834236145,
                "z": -86.98920440673828
            },
            {
                "x": -0.222288578748703,
                "y": 0.23782014846801758,
                "z": -86.83391571044922
            },
            {
                "x": -0.20293039083480835,
                "y": 0.24146148562431335,
                "z": -86.67865753173828
            },
            {
                "x": -0.18309786915779114,
                "y": 0.24502871930599213,
                "z": -86.52354431152344
            },
            {
                "x": -0.16277551651000977,
                "y": 0.24852275848388672,
                "z": -86.3683853149414
            },
            {
                "x": -0.1419849395751953,
                "y": 0.25193342566490173,
                "z": -86.2133560180664
            },
            {
                "x": -0.12073221802711487,
                "y": 0.2552603483200073,
                "z": -86.05839538574219
            },
            {
                "x": -0.09899412095546722,
                "y": 0.2585057020187378,
                "z": -85.90328216552734
            },
            {
                "x": -0.07684095948934555,
                "y": 0.2616579830646515,
                "z": -85.74839782714844
            },
            {
                "x": -0.05424349382519722,
                "y": 0.26471495628356934,
                "z": -85.59355163574219
            },
            {
                "x": -0.039416395127773285,
                "y": 0.2666374146938324,
                "z": -85.49356842041016
            },
            {
                "x": -0.0161232128739357,
                "y": 0.2695345878601074,
                "z": -85.33879089355469
            },
            {
                "x": 0.007599860429763794,
                "y": 0.2723294496536255,
                "z": -85.18396759033203
            },
            {
                "x": 0.0317305251955986,
                "y": 0.27501624822616577,
                "z": -85.02919006347656
            },
            {
                "x": 0.05622772127389908,
                "y": 0.27759265899658203,
                "z": -84.87454223632812
            },
            {
                "x": 0.08111222088336945,
                "y": 0.28005924820899963,
                "z": -84.71981048583984
            },
            {
                "x": 0.1063474789261818,
                "y": 0.2824059724807739,
                "z": -84.56523895263672
            },
            {
                "x": 0.1319403201341629,
                "y": 0.2846304178237915,
                "z": -84.41069793701172
            },
            {
                "x": 0.15790048241615295,
                "y": 0.28673499822616577,
                "z": -84.25598907470703
            },
            {
                "x": 0.18414339423179626,
                "y": 0.2887112498283386,
                "z": -84.10150909423828
            },
            {
                "x": 0.2107047736644745,
                "y": 0.29055672883987427,
                "z": -83.94699096679688
            },
            {
                "x": 0.23756757378578186,
                "y": 0.29226499795913696,
                "z": -83.79249572753906
            },
            {
                "x": 0.2646937370300293,
                "y": 0.293836385011673,
                "z": -83.63809204101562
            },
            {
                "x": 0.2921101450920105,
                "y": 0.2952699661254883,
                "z": -83.4834976196289
            },
            {
                "x": 0.3197403848171234,
                "y": 0.29655638337135315,
                "z": -83.32909393310547
            },
            {
                "x": 0.3476073145866394,
                "y": 0.2976910471916199,
                "z": -83.17472076416016
            },
            {
                "x": 0.37570106983184814,
                "y": 0.2986763119697571,
                "z": -83.0202407836914
            },
            {
                "x": 0.4039679169654846,
                "y": 0.2995072603225708,
                "z": -82.86588287353516
            },
            {
                "x": 0.4324280917644501,
                "y": 0.30017948150634766,
                "z": -82.71141815185547
            },
            {
                "x": 0.4610527753829956,
                "y": 0.30068516731262207,
                "z": -82.55695343017578
            },
            {
                "x": 0.4897974133491516,
                "y": 0.30102628469467163,
                "z": -82.40258026123047
            },
            {
                "x": 0.518660306930542,
                "y": 0.3011196255683899,
                "z": -82.24819946289062
            },
            {
                "x": 0.5476288199424744,
                "y": 0.3007535934448242,
                "z": -82.09379577636719
            },
            {
                "x": 0.5766798853874207,
                "y": 0.299898236989975,
                "z": -81.93936920166016
            },
            {
                "x": 0.6058269739151001,
                "y": 0.29857900738716125,
                "z": -81.78474426269531
            },
            {
                "x": 0.6349844336509705,
                "y": 0.2968076169490814,
                "z": -81.6302719116211
            },
            {
                "x": 0.6641682982444763,
                "y": 0.2945874333381653,
                "z": -81.47573852539062
            },
            {
                "x": 0.6933585405349731,
                "y": 0.29191410541534424,
                "z": -81.32118225097656
            },
            {
                "x": 0.7225162386894226,
                "y": 0.288815438747406,
                "z": -81.1666259765625
            },
            {
                "x": 0.7516732811927795,
                "y": 0.28529512882232666,
                "z": -81.01187133789062
            },
            {
                "x": 0.7807348966598511,
                "y": 0.28136804699897766,
                "z": -80.8572769165039
            },
            {
                "x": 0.8097164630889893,
                "y": 0.2770242691040039,
                "z": -80.70262908935547
            },
            {
                "x": 0.8386224508285522,
                "y": 0.2722862958908081,
                "z": -80.54782104492188
            },
            {
                "x": 0.8673839569091797,
                "y": 0.2671700119972229,
                "z": -80.39309692382812
            },
            {
                "x": 0.8960198163986206,
                "y": 0.26167649030685425,
                "z": -80.23822021484375
            },
            {
                "x": 0.9244877696037292,
                "y": 0.25580161809921265,
                "z": -80.08328247070312
            },
            {
                "x": 0.9527527093887329,
                "y": 0.24957609176635742,
                "z": -79.92839050292969
            },
            {
                "x": 0.9808386564254761,
                "y": 0.24299991130828857,
                "z": -79.77334594726562
            },
            {
                "x": 1.0086822509765625,
                "y": 0.2360905259847641,
                "z": -79.61834716796875
            },
            {
                "x": 1.036273717880249,
                "y": 0.22883659601211548,
                "z": -79.46329498291016
            },
            {
                "x": 1.0636392831802368,
                "y": 0.221253901720047,
                "z": -79.3079833984375
            },
            {
                "x": 1.090688943862915,
                "y": 0.21336959302425385,
                "z": -79.15279388427734
            },
            {
                "x": 1.117435097694397,
                "y": 0.20518383383750916,
                "z": -78.99755859375
            },
            {
                "x": 1.1345367431640625,
                "y": 0.19972798228263855,
                "z": -78.89723205566406
            },
            {
                "x": 1.160744547843933,
                "y": 0.1910528838634491,
                "z": -78.74185943603516
            },
            {
                "x": 1.186618685722351,
                "y": 0.18209409713745117,
                "z": -78.5863265991211
            },
            {
                "x": 1.2121189832687378,
                "y": 0.172855943441391,
                "z": -78.43070220947266
            },
            {
                "x": 1.2372140884399414,
                "y": 0.1633579432964325,
                "z": -78.27510833740234
            },
            {
                "x": 1.2619231939315796,
                "y": 0.153600811958313,
                "z": -78.11933898925781
            },
            {
                "x": 1.2861961126327515,
                "y": 0.1436074823141098,
                "z": -77.96360778808594
            },
            {
                "x": 1.31002676486969,
                "y": 0.13337162137031555,
                "z": -77.80777740478516
            },
            {
                "x": 1.3334308862686157,
                "y": 0.12289202213287354,
                "z": -77.65168762207031
            },
            {
                "x": 1.3563361167907715,
                "y": 0.1122092604637146,
                "z": -77.49571228027344
            },
            {
                "x": 1.3787713050842285,
                "y": 0.10131387412548065,
                "z": -77.33961486816406
            },
            {
                "x": 1.4007021188735962,
                "y": 0.09021346271038055,
                "z": -77.18342590332031
            },
            {
                "x": 1.422104001045227,
                "y": 0.0789211243391037,
                "z": -77.02721405029297
            },
            {
                "x": 1.4430159330368042,
                "y": 0.06743200868368149,
                "z": -76.87073516845703
            },
            {
                "x": 1.4633673429489136,
                "y": 0.05578388273715973,
                "z": -76.71435546875
            },
            {
                "x": 1.4831622838974,
                "y": 0.04396982118487358,
                "z": -76.55792236328125
            },
            {
                "x": 1.5023902654647827,
                "y": 0.03198574483394623,
                "z": -76.40129089355469
            },
            {
                "x": 1.5210427045822144,
                "y": 0.019863028079271317,
                "z": -76.24469757080078
            },
            {
                "x": 1.5391300916671753,
                "y": 0.007594853639602661,
                "z": -76.08794403076172
            },
            {
                "x": 1.5566211938858032,
                "y": -0.004803682677447796,
                "z": -75.93109893798828
            },
            {
                "x": 1.5734748840332031,
                "y": -0.01731986552476883,
                "z": -75.7742919921875
            },
            {
                "x": 1.589725136756897,
                "y": -0.029946161434054375,
                "z": -75.617431640625
            },
            {
                "x": 1.6053646802902222,
                "y": -0.04267580434679985,
                "z": -75.46048736572266
            },
            {
                "x": 1.620377540588379,
                "y": -0.05549885705113411,
                "z": -75.30349731445312
            },
            {
                "x": 1.634748935699463,
                "y": -0.06842659413814545,
                "z": -75.146240234375
            },
            {
                "x": 1.6484671831130981,
                "y": -0.08141481876373291,
                "z": -74.98910522460938
            },
            {
                "x": 1.661549687385559,
                "y": -0.09447315335273743,
                "z": -74.83186340332031
            },
            {
                "x": 1.6739815473556519,
                "y": -0.10758920013904572,
                "z": -74.6745834350586
            },
            {
                "x": 1.68572998046875,
                "y": -0.12075205147266388,
                "z": -74.51728820800781
            },
            {
                "x": 1.6968321800231934,
                "y": -0.13397234678268433,
                "z": -74.3597412109375
            },
            {
                "x": 1.707260251045227,
                "y": -0.1472058892250061,
                "z": -74.20236206054688
            },
            {
                "x": 1.7170180082321167,
                "y": -0.16046211123466492,
                "z": -74.04492950439453
            },
            {
                "x": 1.7260990142822266,
                "y": -0.17374180257320404,
                "z": -73.88733673095703
            },
            {
                "x": 1.7344969511032104,
                "y": -0.1870158314704895,
                "z": -73.72981262207031
            },
            {
                "x": 1.742223858833313,
                "y": -0.20029227435588837,
                "z": -73.57217407226562
            },
            {
                "x": 1.749276876449585,
                "y": -0.2135566920042038,
                "z": -73.41447448730469
            },
            {
                "x": 1.755643367767334,
                "y": -0.22678864002227783,
                "z": -73.2568588256836
            },
            {
                "x": 1.7613170146942139,
                "y": -0.23999565839767456,
                "z": -73.09911346435547
            },
            {
                "x": 1.7663099765777588,
                "y": -0.25315386056900024,
                "z": -72.94144439697266
            },
            {
                "x": 1.7706327438354492,
                "y": -0.266262412071228,
                "z": -72.78373718261719
            },
            {
                "x": 1.7742748260498047,
                "y": -0.27932578325271606,
                "z": -72.62583923339844
            },
            {
                "x": 1.777206540107727,
                "y": -0.29230406880378723,
                "z": -72.4681167602539
            },
            {
                "x": 1.779451608657837,
                "y": -0.3052053451538086,
                "z": -72.31037139892578
            },
            {
                "x": 1.7805888652801514,
                "y": -0.31349682807922363,
                "z": -72.20844268798828
            },
            {
                "x": 1.781738519668579,
                "y": -0.3262484669685364,
                "z": -72.0506820678711
            },
            {
                "x": 1.782214641571045,
                "y": -0.33890673518180847,
                "z": -71.89281463623047
            },
            {
                "x": 1.7820299863815308,
                "y": -0.3514547049999237,
                "z": -71.73494720458984
            },
            {
                "x": 1.7811803817749023,
                "y": -0.3638765215873718,
                "z": -71.5771713256836
            },
            {
                "x": 1.7796237468719482,
                "y": -0.3761773407459259,
                "z": -71.41924285888672
            },
            {
                "x": 1.7773829698562622,
                "y": -0.38833296298980713,
                "z": -71.26141357421875
            },
            {
                "x": 1.7744451761245728,
                "y": -0.4003443717956543,
                "z": -71.10356140136719
            },
            {
                "x": 1.7707881927490234,
                "y": -0.41221871972084045,
                "z": -70.94548797607422
            },
            {
                "x": 1.7663990259170532,
                "y": -0.423910915851593,
                "z": -70.78760528564453
            },
            {
                "x": 1.7612590789794922,
                "y": -0.4354321360588074,
                "z": -70.6296615600586
            },
            {
                "x": 1.7553640604019165,
                "y": -0.44677460193634033,
                "z": -70.4717025756836
            },
            {
                "x": 1.748710036277771,
                "y": -0.4579235315322876,
                "z": -70.31379699707031
            },
            {
                "x": 1.7412538528442383,
                "y": -0.468883752822876,
                "z": -70.15569305419922
            },
            {
                "x": 1.7329893112182617,
                "y": -0.4796171188354492,
                "z": -69.997802734375
            },
            {
                "x": 1.7239187955856323,
                "y": -0.49013400077819824,
                "z": -69.83992004394531
            },
            {
                "x": 1.7140216827392578,
                "y": -0.5004345774650574,
                "z": -69.68192291259766
            },
            {
                "x": 1.7032811641693115,
                "y": -0.5104894638061523,
                "z": -69.5240478515625
            },
            {
                "x": 1.6916520595550537,
                "y": -0.5202982425689697,
                "z": -69.36612701416016
            },
            {
                "x": 1.679150104522705,
                "y": -0.5298553705215454,
                "z": -69.20821380615234
            },
            {
                "x": 1.6657730340957642,
                "y": -0.5391451120376587,
                "z": -69.05042266845703
            },
            {
                "x": 1.6514872312545776,
                "y": -0.5481616854667664,
                "z": -68.89268493652344
            },
            {
                "x": 1.6362552642822266,
                "y": -0.5568879842758179,
                "z": -68.73499298095703
            },
            {
                "x": 1.6200883388519287,
                "y": -0.5653252601623535,
                "z": -68.57734680175781
            },
            {
                "x": 1.6029458045959473,
                "y": -0.5734758377075195,
                "z": -68.41957092285156
            },
            {
                "x": 1.5848476886749268,
                "y": -0.5813063979148865,
                "z": -68.2620620727539
            },
            {
                "x": 1.565722942352295,
                "y": -0.5888110399246216,
                "z": -68.10456848144531
            },
            {
                "x": 1.5455960035324097,
                "y": -0.5959905385971069,
                "z": -67.9471664428711
            },
            {
                "x": 1.5244535207748413,
                "y": -0.6028337478637695,
                "z": -67.78990936279297
            },
            {
                "x": 1.5022380352020264,
                "y": -0.6093410849571228,
                "z": -67.6325454711914
            },
            {
                "x": 1.4789460897445679,
                "y": -0.6154724359512329,
                "z": -67.47550201416016
            },
            {
                "x": 1.4545867443084717,
                "y": -0.6212424039840698,
                "z": -67.31858825683594
            },
            {
                "x": 1.4291164875030518,
                "y": -0.6266471147537231,
                "z": -67.16166687011719
            },
            {
                "x": 1.4025580883026123,
                "y": -0.6316679120063782,
                "z": -67.00503540039062
            },
            {
                "x": 1.3747930526733398,
                "y": -0.6362859010696411,
                "z": -66.84844970703125
            },
            {
                "x": 1.3458808660507202,
                "y": -0.6405071020126343,
                "z": -66.69202423095703
            },
            {
                "x": 1.3158329725265503,
                "y": -0.644320011138916,
                "z": -66.53589630126953
            },
            {
                "x": 1.2845890522003174,
                "y": -0.647721529006958,
                "z": -66.3798599243164
            },
            {
                "x": 1.2521069049835205,
                "y": -0.6506808996200562,
                "z": -66.22415924072266
            },
            {
                "x": 1.2184176445007324,
                "y": -0.6533029079437256,
                "z": -66.06864929199219
            },
            {
                "x": 1.1834574937820435,
                "y": -0.6556546688079834,
                "z": -65.91320037841797
            },
            {
                "x": 1.147301197052002,
                "y": -0.6577237844467163,
                "z": -65.75820922851562
            },
            {
                "x": 1.1098361015319824,
                "y": -0.6594948172569275,
                "z": -65.60346221923828
            },
            {
                "x": 1.0849671363830566,
                "y": -0.6604843139648438,
                "z": -65.50367736816406
            },
            {
                "x": 1.0454316139221191,
                "y": -0.6617757081985474,
                "z": -65.34944152832031
            },
            {
                "x": 1.004536747932434,
                "y": -0.662756085395813,
                "z": -65.19544982910156
            },
            {
                "x": 0.9623205661773682,
                "y": -0.6634246110916138,
                "z": -65.04175567626953
            },
            {
                "x": 0.9188309907913208,
                "y": -0.6637793183326721,
                "z": -64.88850402832031
            },
            {
                "x": 0.8740078806877136,
                "y": -0.6638152599334717,
                "z": -64.73553466796875
            },
            {
                "x": 0.8278639912605286,
                "y": -0.6635211706161499,
                "z": -64.58308410644531
            },
            {
                "x": 0.7803707718849182,
                "y": -0.6629077196121216,
                "z": -64.4310073852539
            },
            {
                "x": 0.7314989566802979,
                "y": -0.6619843244552612,
                "z": -64.27912902832031
            },
            {
                "x": 0.6813868880271912,
                "y": -0.6607595682144165,
                "z": -64.12789916992188
            },
            {
                "x": 0.6298872232437134,
                "y": -0.6592284440994263,
                "z": -63.97710037231445
            },
            {
                "x": 0.5770646333694458,
                "y": -0.6574012041091919,
                "z": -63.82673263549805
            },
            {
                "x": 0.5229820013046265,
                "y": -0.6552903652191162,
                "z": -63.67692565917969
            },
            {
                "x": 0.4675305187702179,
                "y": -0.6528976559638977,
                "z": -63.527400970458984
            },
            {
                "x": 0.4108658730983734,
                "y": -0.6502274870872498,
                "z": -63.37857437133789
            },
            {
                "x": 0.3529314398765564,
                "y": -0.6472864151000977,
                "z": -63.23028564453125
            },
            {
                "x": 0.293736070394516,
                "y": -0.644082248210907,
                "z": -63.0823860168457
            },
            {
                "x": 0.23341581225395203,
                "y": -0.6406279802322388,
                "z": -62.9351921081543
            },
            {
                "x": 0.1718597412109375,
                "y": -0.6369158625602722,
                "z": -62.78837203979492
            },
            {
                "x": 0.10918337106704712,
                "y": -0.6329584121704102,
                "z": -62.64216613769531
            },
            {
                "x": 0.045485176146030426,
                "y": -0.6287680864334106,
                "z": -62.496559143066406
            },
            {
                "x": -0.019238781183958054,
                "y": -0.6243493556976318,
                "z": -62.35148239135742
            },
            {
                "x": -0.0849156379699707,
                "y": -0.6197041273117065,
                "z": -62.20697784423828
            },
            {
                "x": -0.15151606500148773,
                "y": -0.6148375272750854,
                "z": -62.06298065185547
            },
            {
                "x": -0.21901610493659973,
                "y": -0.6097555756568909,
                "z": -61.9193229675293
            },
            {
                "x": -0.2871645987033844,
                "y": -0.6044772863388062,
                "z": -61.776336669921875
            },
            {
                "x": -0.3560168147087097,
                "y": -0.5989965796470642,
                "z": -61.63376998901367
            },
            {
                "x": -0.42543289065361023,
                "y": -0.5933210849761963,
                "z": -61.491676330566406
            },
            {
                "x": -0.4952898919582367,
                "y": -0.5874637365341187,
                "z": -61.35003662109375
            },
            {
                "x": -0.5655958652496338,
                "y": -0.581421434879303,
                "z": -61.208580017089844
            },
            {
                "x": -0.6360494494438171,
                "y": -0.5752135515213013,
                "z": -61.067665100097656
            },
            {
                "x": -0.7066183686256409,
                "y": -0.5688359141349792,
                "z": -60.92703628540039
            },
            {
                "x": -0.7772173285484314,
                "y": -0.5622954964637756,
                "z": -60.78654098510742
            },
            {
                "x": -0.8475820422172546,
                "y": -0.5556094646453857,
                "z": -60.6463508605957
            },
            {
                "x": -0.9176943302154541,
                "y": -0.5487703084945679,
                "z": -60.50617599487305
            },
            {
                "x": -0.9872962236404419,
                "y": -0.5417885780334473,
                "z": -60.36608123779297
            },
            {
                "x": -1.0562032461166382,
                "y": -0.5346784591674805,
                "z": -60.22606658935547
            },
            {
                "x": -1.1243293285369873,
                "y": -0.5274386405944824,
                "z": -60.08589172363281
            },
            {
                "x": -1.1913913488388062,
                "y": -0.5200825929641724,
                "z": -59.945655822753906
            },
            {
                "x": -1.2571927309036255,
                "y": -0.5126111507415771,
                "z": -59.805213928222656
            },
            {
                "x": -1.3216627836227417,
                "y": -0.5050246715545654,
                "z": -59.664302825927734
            },
            {
                "x": -1.384434700012207,
                "y": -0.49734973907470703,
                "z": -59.52322006225586
            },
            {
                "x": -1.4453836679458618,
                "y": -0.4895826280117035,
                "z": -59.38169860839844
            },
            {
                "x": -1.483609676361084,
                "y": -0.48451775312423706,
                "z": -59.29002380371094
            },
            {
                "x": -1.5410404205322266,
                "y": -0.47661423683166504,
                "z": -59.14765548706055
            },
            {
                "x": -1.596426248550415,
                "y": -0.46860554814338684,
                "z": -59.00413513183594
            },
            {
                "x": -1.6503565311431885,
                "y": -0.46045902371406555,
                "z": -58.859039306640625
            },
            {
                "x": -1.7030665874481201,
                "y": -0.452221155166626,
                "z": -58.713233947753906
            },
            {
                "x": -1.7546167373657227,
                "y": -0.4439014792442322,
                "z": -58.566837310791016
            },
            {
                "x": -1.8049700260162354,
                "y": -0.43551743030548096,
                "z": -58.420074462890625
            },
            {
                "x": -1.8541477918624878,
                "y": -0.4270673394203186,
                "z": -58.272857666015625
            },
            {
                "x": -1.9022774696350098,
                "y": -0.4185471832752228,
                "z": -58.12502670288086
            },
            {
                "x": -1.949280858039856,
                "y": -0.40998587012290955,
                "z": -57.97698974609375
            },
            {
                "x": -1.9952547550201416,
                "y": -0.40137526392936707,
                "z": -57.82852554321289
            },
            {
                "x": -2.040173292160034,
                "y": -0.39272239804267883,
                "z": -57.67969512939453
            },
            {
                "x": -2.084062099456787,
                "y": -0.3840378224849701,
                "z": -57.53057861328125
            },
            {
                "x": -2.1270363330841064,
                "y": -0.375312864780426,
                "z": -57.380943298339844
            },
            {
                "x": -2.1690053939819336,
                "y": -0.36657559871673584,
                "z": -57.23119354248047
            },
            {
                "x": -2.2100167274475098,
                "y": -0.3578195571899414,
                "z": -57.08113479614258
            },
            {
                "x": -2.250110626220703,
                "y": -0.3490467667579651,
                "z": -56.93071746826172
            },
            {
                "x": -2.2892813682556152,
                "y": -0.3402727246284485,
                "z": -56.780113220214844
            },
            {
                "x": -2.327594518661499,
                "y": -0.33149242401123047,
                "z": -56.6291618347168
            },
            {
                "x": -2.365017890930176,
                "y": -0.3227171301841736,
                "z": -56.47796630859375
            },
            {
                "x": -2.401546001434326,
                "y": -0.31395190954208374,
                "z": -56.32662582397461
            },
            {
                "x": -2.4372241497039795,
                "y": -0.3050883412361145,
                "z": -56.17506408691406
            },
            {
                "x": -2.472079277038574,
                "y": -0.2960771918296814,
                "z": -56.02328109741211
            },
            {
                "x": -2.5061023235321045,
                "y": -0.2869291305541992,
                "z": -55.871315002441406
            },
            {
                "x": -2.539336681365967,
                "y": -0.2776375412940979,
                "z": -55.71894073486328
            },
            {
                "x": -2.571727752685547,
                "y": -0.26823925971984863,
                "z": -55.56658935546875
            },
            {
                "x": -2.60335111618042,
                "y": -0.25872620940208435,
                "z": -55.41400146484375
            },
            {
                "x": -2.634180784225464,
                "y": -0.24911010265350342,
                "z": -55.26127624511719
            },
            {
                "x": -2.6642045974731445,
                "y": -0.239397794008255,
                "z": -55.108394622802734
            },
            {
                "x": -2.693511724472046,
                "y": -0.22958675026893616,
                "z": -54.955177307128906
            },
            {
                "x": -2.72202205657959,
                "y": -0.2197105884552002,
                "z": -54.80201721191406
            },
            {
                "x": -2.749788999557495,
                "y": -0.20976200699806213,
                "z": -54.648685455322266
            },
            {
                "x": -2.7768077850341797,
                "y": -0.19974243640899658,
                "z": -54.4951171875
            },
            {
                "x": -2.803071975708008,
                "y": -0.1896756887435913,
                "z": -54.34150695800781
            },
            {
                "x": -2.8286361694335938,
                "y": -0.17955660820007324,
                "z": -54.18768310546875
            },
            {
                "x": -2.8534719944000244,
                "y": -0.16940048336982727,
                "z": -54.03373718261719
            },
            {
                "x": -2.8775532245635986,
                "y": -0.15921811759471893,
                "z": -53.87974166870117
            },
            {
                "x": -2.900938034057617,
                "y": -0.14900946617126465,
                "z": -53.725555419921875
            },
            {
                "x": -2.92360258102417,
                "y": -0.13879269361495972,
                "z": -53.57133483886719
            },
            {
                "x": -2.9455738067626953,
                "y": -0.12857212126255035,
                "z": -53.41702651977539
            },
            {
                "x": -2.966841220855713,
                "y": -0.11834106594324112,
                "z": -53.26240539550781
            },
            {
                "x": -2.9873924255371094,
                "y": -0.1081322580575943,
                "z": -53.107872009277344
            },
            {
                "x": -3.0072519779205322,
                "y": -0.0974397361278534,
                "z": -52.95323181152344
            },
            {
                "x": -3.019719123840332,
                "y": -0.08988594263792038,
                "z": -52.853336334228516
            },
            {
                "x": -3.03841495513916,
                "y": -0.07717342674732208,
                "z": -52.69870376586914
            },
            {
                "x": -3.05643892288208,
                "y": -0.06334389746189117,
                "z": -52.54396057128906
            },
            {
                "x": -3.073770761489868,
                "y": -0.04850172996520996,
                "z": -52.389259338378906
            },
            {
                "x": -3.0904016494750977,
                "y": -0.03272634744644165,
                "z": -52.234642028808594
            },
            {
                "x": -3.10634183883667,
                "y": -0.016094248741865158,
                "z": -52.079959869384766
            },
            {
                "x": -3.1216025352478027,
                "y": 0.0012607998214662075,
                "z": -51.92536926269531
            },
            {
                "x": -3.136185884475708,
                "y": 0.0192553848028183,
                "z": -51.77079772949219
            },
            {
                "x": -3.1501216888427734,
                "y": 0.03783005475997925,
                "z": -51.61602783203125
            },
            {
                "x": -3.163337230682373,
                "y": 0.05685504525899887,
                "z": -51.461463928222656
            },
            {
                "x": -3.175905704498291,
                "y": 0.07625459879636765,
                "z": -51.30681610107422
            },
            {
                "x": -3.187805652618408,
                "y": 0.09592746198177338,
                "z": -51.15216827392578
            },
            {
                "x": -3.1990487575531006,
                "y": 0.11578011512756348,
                "z": -50.9975471496582
            },
            {
                "x": -3.2096152305603027,
                "y": 0.13575732707977295,
                "z": -50.842689514160156
            },
            {
                "x": -3.219513416290283,
                "y": 0.1557098776102066,
                "z": -50.68800735473633
            },
            {
                "x": -3.2287518978118896,
                "y": 0.17557711899280548,
                "z": -50.533260345458984
            },
            {
                "x": -3.237342596054077,
                "y": 0.1952797770500183,
                "z": -50.378360748291016
            },
            {
                "x": -3.2452609539031982,
                "y": 0.21469977498054504,
                "z": -50.223487854003906
            },
            {
                "x": -3.2525084018707275,
                "y": 0.2337605208158493,
                "z": -50.068458557128906
            },
            {
                "x": -3.2591052055358887,
                "y": 0.2523711621761322,
                "z": -49.9133415222168
            },
            {
                "x": -3.2650346755981445,
                "y": 0.27042901515960693,
                "z": -49.75823974609375
            },
            {
                "x": -3.2703094482421875,
                "y": 0.28785064816474915,
                "z": -49.603057861328125
            },
            {
                "x": -3.274893045425415,
                "y": 0.30451908707618713,
                "z": -49.44776916503906
            },
            {
                "x": -3.278817653656006,
                "y": 0.32036495208740234,
                "z": -49.29239273071289
            },
            {
                "x": -3.2820851802825928,
                "y": 0.33532005548477173,
                "z": -49.13670349121094
            },
            {
                "x": -3.2846763134002686,
                "y": 0.3492511510848999,
                "z": -48.98113250732422
            },
            {
                "x": -3.2865803241729736,
                "y": 0.36204004287719727,
                "z": -48.825401306152344
            },
            {
                "x": -3.2877981662750244,
                "y": 0.3736247420310974,
                "z": -48.669593811035156
            },
            {
                "x": -3.2882864475250244,
                "y": 0.38390272855758667,
                "z": -48.51396942138672
            },
            {
                "x": -3.2878010272979736,
                "y": 0.3927886486053467,
                "z": -48.358482360839844
            },
            {
                "x": -3.285984992980957,
                "y": 0.40012073516845703,
                "z": -48.2034797668457
            },
            {
                "x": -3.282775402069092,
                "y": 0.40593087673187256,
                "z": -48.0484733581543
            },
            {
                "x": -3.2781052589416504,
                "y": 0.4109310507774353,
                "z": -47.89342498779297
            },
            {
                "x": -3.2719595432281494,
                "y": 0.41488197445869446,
                "z": -47.73859405517578
            },
            {
                "x": -3.2642035484313965,
                "y": 0.41754433512687683,
                "z": -47.58381271362305
            },
            {
                "x": -3.2548317909240723,
                "y": 0.41902703046798706,
                "z": -47.42912292480469
            },
            {
                "x": -3.2438390254974365,
                "y": 0.4194291830062866,
                "z": -47.274723052978516
            },
            {
                "x": -3.231147050857544,
                "y": 0.4188327491283417,
                "z": -47.12041091918945
            },
            {
                "x": -3.2166848182678223,
                "y": 0.4172912836074829,
                "z": -46.966392517089844
            },
            {
                "x": -3.2004456520080566,
                "y": 0.4149055480957031,
                "z": -46.81261444091797
            },
            {
                "x": -3.1823923587799072,
                "y": 0.4117674231529236,
                "z": -46.65890884399414
            },
            {
                "x": -3.1625444889068604,
                "y": 0.4079652428627014,
                "z": -46.50565719604492
            },
            {
                "x": -3.1408042907714844,
                "y": 0.40355974435806274,
                "z": -46.352699279785156
            },
            {
                "x": -3.1257576942443848,
                "y": 0.40043404698371887,
                "z": -46.25404739379883
            },
            {
                "x": -3.1009767055511475,
                "y": 0.3952406048774719,
                "z": -46.1015739440918
            },
            {
                "x": -3.074305295944214,
                "y": 0.38966473937034607,
                "z": -45.94929885864258
            },
            {
                "x": -3.045761823654175,
                "y": 0.3837895095348358,
                "z": -45.79733657836914
            },
            {
                "x": -3.015444278717041,
                "y": 0.3777078688144684,
                "z": -45.645755767822266
            },
            {
                "x": -2.983358144760132,
                "y": 0.37148940563201904,
                "z": -45.494354248046875
            },
            {
                "x": -2.9495811462402344,
                "y": 0.36522024869918823,
                "z": -45.34332275390625
            },
            {
                "x": -2.9141345024108887,
                "y": 0.35897791385650635,
                "z": -45.19254684448242
            },
            {
                "x": -2.877113103866577,
                "y": 0.352832555770874,
                "z": -45.04177474975586
            },
            {
                "x": -2.8387186527252197,
                "y": 0.34687677025794983,
                "z": -44.8913688659668
            },
            {
                "x": -2.7989885807037354,
                "y": 0.3411813974380493,
                "z": -44.741031646728516
            },
            {
                "x": -2.758042097091675,
                "y": 0.3358401656150818,
                "z": -44.59079360961914
            },
            {
                "x": -2.7160801887512207,
                "y": 0.3309222161769867,
                "z": -44.4406623840332
            },
            {
                "x": -2.6731815338134766,
                "y": 0.3264988660812378,
                "z": -44.290313720703125
            },
            {
                "x": -2.629610776901245,
                "y": 0.3226673901081085,
                "z": -44.14010238647461
            },
            {
                "x": -2.5854721069335938,
                "y": 0.3195275068283081,
                "z": -43.98977279663086
            },
            {
                "x": -2.540923833847046,
                "y": 0.31713569164276123,
                "z": -43.83918380737305
            },
            {
                "x": -2.4961934089660645,
                "y": 0.31557774543762207,
                "z": -43.6884765625
            },
            {
                "x": -2.4513938426971436,
                "y": 0.314941942691803,
                "z": -43.537452697753906
            },
            {
                "x": -2.4067282676696777,
                "y": 0.3153546154499054,
                "z": -43.386138916015625
            },
            {
                "x": -2.362377166748047,
                "y": 0.3168596029281616,
                "z": -43.234615325927734
            },
            {
                "x": -2.3184711933135986,
                "y": 0.31954142451286316,
                "z": -43.08277130126953
            },
            {
                "x": -2.275158643722534,
                "y": 0.3231393098831177,
                "z": -42.930660247802734
            },
            {
                "x": -2.232581853866577,
                "y": 0.3267248868942261,
                "z": -42.77815628051758
            },
            {
                "x": -2.190779447555542,
                "y": 0.33021560311317444,
                "z": -42.6251106262207
            },
            {
                "x": -2.1499507427215576,
                "y": 0.33359938859939575,
                "z": -42.47187042236328
            },
            {
                "x": -2.110114097595215,
                "y": 0.33687788248062134,
                "z": -42.318214416503906
            },
            {
                "x": -2.071425676345825,
                "y": 0.3400411903858185,
                "z": -42.16415023803711
            },
            {
                "x": -2.033907413482666,
                "y": 0.3430892527103424,
                "z": -42.009788513183594
            },
            {
                "x": -1.997551679611206,
                "y": 0.3460232615470886,
                "z": -41.854888916015625
            },
            {
                "x": -1.9624929428100586,
                "y": 0.34883201122283936,
                "z": -41.699832916259766
            },
            {
                "x": -1.9287883043289185,
                "y": 0.3515095114707947,
                "z": -41.544464111328125
            },
            {
                "x": -1.8963662385940552,
                "y": 0.35405969619750977,
                "z": -41.38868713378906
            },
            {
                "x": -1.865282416343689,
                "y": 0.3564750552177429,
                "z": -41.232749938964844
            },
            {
                "x": -1.8355095386505127,
                "y": 0.35875582695007324,
                "z": -41.07643508911133
            },
            {
                "x": -1.8071343898773193,
                "y": 0.36089006066322327,
                "z": -40.91987228393555
            },
            {
                "x": -1.7800980806350708,
                "y": 0.36287859082221985,
                "z": -40.76321792602539
            },
            {
                "x": -1.754357099533081,
                "y": 0.3647214472293854,
                "z": -40.6062126159668
            },
            {
                "x": -1.7299376726150513,
                "y": 0.3664122223854065,
                "z": -40.44916915893555
            },
            {
                "x": -1.7068442106246948,
                "y": 0.36794254183769226,
                "z": -40.29191207885742
            },
            {
                "x": -1.6850003004074097,
                "y": 0.36931586265563965,
                "z": -40.13435363769531
            },
            {
                "x": -1.6644102334976196,
                "y": 0.37052664160728455,
                "z": -39.9768180847168
            },
            {
                "x": -1.6450245380401611,
                "y": 0.37157267332077026,
                "z": -39.819210052490234
            },
            {
                "x": -1.6332011222839355,
                "y": 0.37215349078178406,
                "z": -39.71730422973633
            },
            {
                "x": -1.615803837776184,
                "y": 0.37291625142097473,
                "z": -39.55951690673828
            },
            {
                "x": -1.5995429754257202,
                "y": 0.37350642681121826,
                "z": -39.40153121948242
            },
            {
                "x": -1.5844024419784546,
                "y": 0.37391412258148193,
                "z": -39.24355697631836
            },
            {
                "x": -1.5702747106552124,
                "y": 0.3741384744644165,
                "z": -39.08567428588867
            },
            {
                "x": -1.557213544845581,
                "y": 0.3741801381111145,
                "z": -38.92728042602539
            },
            {
                "x": -1.5453641414642334,
                "y": 0.37403756380081177,
                "z": -38.76887893676758
            },
            {
                "x": -1.534834384918213,
                "y": 0.3737080693244934,
                "z": -38.61017990112305
            },
            {
                "x": -1.5257704257965088,
                "y": 0.3731952905654907,
                "z": -38.45099639892578
            },
            {
                "x": -1.518309235572815,
                "y": 0.3725076913833618,
                "z": -38.29176712036133
            },
            {
                "x": -1.512560248374939,
                "y": 0.3716472387313843,
                "z": -38.13225555419922
            },
            {
                "x": -1.5086872577667236,
                "y": 0.3706130385398865,
                "z": -37.97257614135742
            },
            {
                "x": -1.5067650079727173,
                "y": 0.36941012740135193,
                "z": -37.81284713745117
            },
            {
                "x": -1.5068018436431885,
                "y": 0.3680436313152313,
                "z": -37.65284729003906
            },
            {
                "x": -1.508834958076477,
                "y": 0.3665205240249634,
                "z": -37.49302673339844
            },
            {
                "x": -1.5129157304763794,
                "y": 0.36483946442604065,
                "z": -37.33327102661133
            },
            {
                "x": -1.5190348625183105,
                "y": 0.36300337314605713,
                "z": -37.173492431640625
            },
            {
                "x": -1.5271003246307373,
                "y": 0.3610224425792694,
                "z": -37.01396942138672
            },
            {
                "x": -1.5370782613754272,
                "y": 0.35889726877212524,
                "z": -36.854522705078125
            },
            {
                "x": -1.5489463806152344,
                "y": 0.3566302955150604,
                "z": -36.695281982421875
            },
            {
                "x": -1.5626276731491089,
                "y": 0.35422664880752563,
                "z": -36.5363883972168
            },
            {
                "x": -1.5780073404312134,
                "y": 0.3516923189163208,
                "z": -36.37774658203125
            },
            {
                "x": -1.5950106382369995,
                "y": 0.34903067350387573,
                "z": -36.21937561035156
            },
            {
                "x": -1.613585114479065,
                "y": 0.34624260663986206,
                "z": -36.061279296875
            },
            {
                "x": -1.6336866617202759,
                "y": 0.3433278799057007,
                "z": -35.90327835083008
            },
            {
                "x": -1.6551460027694702,
                "y": 0.34029996395111084,
                "z": -35.745765686035156
            },
            {
                "x": -1.6779145002365112,
                "y": 0.3371581435203552,
                "z": -35.58847427368164
            },
            {
                "x": -1.701937198638916,
                "y": 0.3339041471481323,
                "z": -35.43146514892578
            },
            {
                "x": -1.7271462678909302,
                "y": 0.3305421471595764,
                "z": -35.274803161621094
            },
            {
                "x": -1.753477931022644,
                "y": 0.32707250118255615,
                "z": -35.118194580078125
            },
            {
                "x": -1.7808010578155518,
                "y": 0.32350754737854004,
                "z": -34.962059020996094
            },
            {
                "x": -1.809108853340149,
                "y": 0.319844514131546,
                "z": -34.806175231933594
            },
            {
                "x": -1.838372826576233,
                "y": 0.3160823583602905,
                "z": -34.650421142578125
            },
            {
                "x": -1.868476152420044,
                "y": 0.3122328519821167,
                "z": -34.49501419067383
            },
            {
                "x": -1.8994032144546509,
                "y": 0.3082942068576813,
                "z": -34.339744567871094
            },
            {
                "x": -1.931099534034729,
                "y": 0.30427056550979614,
                "z": -34.1846809387207
            },
            {
                "x": -1.9635233879089355,
                "y": 0.3001655340194702,
                "z": -34.02992630004883
            },
            {
                "x": -1.996645450592041,
                "y": 0.29598069190979004,
                "z": -33.875274658203125
            },
            {
                "x": -2.0303823947906494,
                "y": 0.2917243242263794,
                "z": -33.720916748046875
            },
            {
                "x": -2.0647270679473877,
                "y": 0.28739625215530396,
                "z": -33.56674575805664
            },
            {
                "x": -2.0997095108032227,
                "y": 0.28299152851104736,
                "z": -33.412540435791016
            },
            {
                "x": -2.1351873874664307,
                "y": 0.2785278558731079,
                "z": -33.25870895385742
            },
            {
                "x": -2.1712193489074707,
                "y": 0.2740035355091095,
                "z": -33.10506057739258
            },
            {
                "x": -2.194658041000366,
                "y": 0.27104929089546204,
                "z": -33.005924224853516
            },
            {
                "x": -2.2311065196990967,
                "y": 0.2664426565170288,
                "z": -32.852996826171875
            },
            {
                "x": -2.267267942428589,
                "y": 0.26179149746894836,
                "z": -32.70040512084961
            },
            {
                "x": -2.303004026412964,
                "y": 0.25709009170532227,
                "z": -32.5478515625
            },
            {
                "x": -2.3382139205932617,
                "y": 0.2523408532142639,
                "z": -32.395362854003906
            },
            {
                "x": -2.37290620803833,
                "y": 0.2475435435771942,
                "z": -32.24272537231445
            },
            {
                "x": -2.4069607257843018,
                "y": 0.2427082061767578,
                "z": -32.09016036987305
            },
            {
                "x": -2.440340280532837,
                "y": 0.23783448338508606,
                "z": -31.937530517578125
            },
            {
                "x": -2.4729747772216797,
                "y": 0.23291820287704468,
                "z": -31.784643173217773
            },
            {
                "x": -2.504732370376587,
                "y": 0.2279767394065857,
                "z": -31.631868362426758
            },
            {
                "x": -2.5355989933013916,
                "y": 0.22300522029399872,
                "z": -31.478961944580078
            },
            {
                "x": -2.5654845237731934,
                "y": 0.2180091142654419,
                "z": -31.325958251953125
            },
            {
                "x": -2.5942628383636475,
                "y": 0.21299253404140472,
                "z": -31.172901153564453
            },
            {
                "x": -2.6219353675842285,
                "y": 0.2079516351222992,
                "z": -31.019535064697266
            },
            {
                "x": -2.648374319076538,
                "y": 0.20290249586105347,
                "z": -30.866243362426758
            },
            {
                "x": -2.673553466796875,
                "y": 0.19784194231033325,
                "z": -30.712818145751953
            },
            {
                "x": -2.697380781173706,
                "y": 0.1927693486213684,
                "z": -30.55914306640625
            },
            {
                "x": -2.7198002338409424,
                "y": 0.18769578635692596,
                "z": -30.405433654785156
            },
            {
                "x": -2.7408151626586914,
                "y": 0.18261754512786865,
                "z": -30.2514705657959
            },
            {
                "x": -2.760378360748291,
                "y": 0.17754104733467102,
                "z": -30.09735679626465
            },
            {
                "x": -2.7784006595611572,
                "y": 0.17247293889522552,
                "z": -29.943178176879883
            },
            {
                "x": -2.794907331466675,
                "y": 0.16741327941417694,
                "z": -29.788843154907227
            },
            {
                "x": -2.8099141120910645,
                "y": 0.16236522793769836,
                "z": -29.634357452392578
            },
            {
                "x": -2.823423385620117,
                "y": 0.15731583535671234,
                "z": -29.479726791381836
            },
            {
                "x": -2.835411310195923,
                "y": 0.15141385793685913,
                "z": -29.324832916259766
            },
            {
                "x": -2.84588885307312,
                "y": 0.14419610798358917,
                "z": -29.170047760009766
            },
            {
                "x": -2.8549325466156006,
                "y": 0.135761097073555,
                "z": -29.015125274658203
            },
            {
                "x": -2.8625717163085938,
                "y": 0.12619906663894653,
                "z": -28.86014175415039
            },
            {
                "x": -2.8688113689422607,
                "y": 0.11557772755622864,
                "z": -28.70515251159668
            },
            {
                "x": -2.873711109161377,
                "y": 0.10397527366876602,
                "z": -28.54991912841797
            },
            {
                "x": -2.8773369789123535,
                "y": 0.09153389930725098,
                "z": -28.39484405517578
            },
            {
                "x": -2.879746437072754,
                "y": 0.07832860946655273,
                "z": -28.23973274230957
            },
            {
                "x": -2.880971670150757,
                "y": 0.06442658603191376,
                "z": -28.08448028564453
            },
            {
                "x": -2.8810489177703857,
                "y": 0.04993531480431557,
                "z": -27.9293155670166
            },
            {
                "x": -2.8800711631774902,
                "y": 0.03494524210691452,
                "z": -27.774032592773438
            },
            {
                "x": -2.8780887126922607,
                "y": 0.019553054124116898,
                "z": -27.618728637695312
            },
            {
                "x": -2.8751418590545654,
                "y": 0.004163276869803667,
                "z": -27.463424682617188
            },
            {
                "x": -2.8712503910064697,
                "y": -0.00986463949084282,
                "z": -27.30782127380371
            },
            {
                "x": -2.866499185562134,
                "y": -0.02244514226913452,
                "z": -27.152162551879883
            },
            {
                "x": -2.860936403274536,
                "y": -0.033656589686870575,
                "z": -26.996370315551758
            },
            {
                "x": -2.8545897006988525,
                "y": -0.04357675835490227,
                "z": -26.840322494506836
            },
            {
                "x": -2.8473634719848633,
                "y": -0.05218536779284477,
                "z": -26.68460464477539
            },
            {
                "x": -2.839216709136963,
                "y": -0.059641480445861816,
                "z": -26.528871536254883
            },
            {
                "x": -2.8334836959838867,
                "y": -0.06389398872852325,
                "z": -26.4283504486084
            },
            {
                "x": -2.8236827850341797,
                "y": -0.06958164274692535,
                "z": -26.272859573364258
            },
            {
                "x": -2.812736988067627,
                "y": -0.07430272549390793,
                "z": -26.11739730834961
            },
            {
                "x": -2.8006227016448975,
                "y": -0.07814139872789383,
                "z": -25.962051391601562
            },
            {
                "x": -2.7873027324676514,
                "y": -0.0811697468161583,
                "z": -25.806947708129883
            },
            {
                "x": -2.772686243057251,
                "y": -0.08344277739524841,
                "z": -25.651914596557617
            },
            {
                "x": -2.7567617893218994,
                "y": -0.08504901081323624,
                "z": -25.497154235839844
            },
            {
                "x": -2.7394890785217285,
                "y": -0.0860743597149849,
                "z": -25.34259033203125
            },
            {
                "x": -2.7207956314086914,
                "y": -0.08659213036298752,
                "z": -25.18805503845215
            },
            {
                "x": -2.7006595134735107,
                "y": -0.08666183054447174,
                "z": -25.03398895263672
            },
            {
                "x": -2.679003953933716,
                "y": -0.08636751770973206,
                "z": -24.880096435546875
            },
            {
                "x": -2.655810832977295,
                "y": -0.08578871935606003,
                "z": -24.72650718688965
            },
            {
                "x": -2.631072759628296,
                "y": -0.08499820530414581,
                "z": -24.573305130004883
            },
            {
                "x": -2.6046252250671387,
                "y": -0.08427658677101135,
                "z": -24.420215606689453
            },
            {
                "x": -2.5765419006347656,
                "y": -0.08482901751995087,
                "z": -24.267763137817383
            },
            {
                "x": -2.546747922897339,
                "y": -0.08643803000450134,
                "z": -24.11558723449707
            },
            {
                "x": -2.5152056217193604,
                "y": -0.08713410794734955,
                "z": -23.963695526123047
            },
            {
                "x": -2.481862783432007,
                "y": -0.08637435734272003,
                "z": -23.812292098999023
            },
            {
                "x": -2.446700096130371,
                "y": -0.08425980806350708,
                "z": -23.661279678344727
            },
            {
                "x": -2.4097282886505127,
                "y": -0.08102273941040039,
                "z": -23.5107479095459
            },
            {
                "x": -2.3709235191345215,
                "y": -0.07788422703742981,
                "z": -23.360485076904297
            },
            {
                "x": -2.330747127532959,
                "y": -0.07529585063457489,
                "z": -23.2093448638916
            },
            {
                "x": -2.2899770736694336,
                "y": -0.07319334894418716,
                "z": -23.058259963989258
            },
            {
                "x": -2.2486424446105957,
                "y": -0.07148535549640656,
                "z": -22.907329559326172
            },
            {
                "x": -2.2066810131073,
                "y": -0.07009056210517883,
                "z": -22.756380081176758
            },
            {
                "x": -2.1641697883605957,
                "y": -0.06893759220838547,
                "z": -22.605789184570312
            },
            {
                "x": -2.1210436820983887,
                "y": -0.06793782860040665,
                "z": -22.455289840698242
            },
            {
                "x": -2.0773496627807617,
                "y": -0.06700727343559265,
                "z": -22.30491065979004
            },
            {
                "x": -2.033141851425171,
                "y": -0.06606760621070862,
                "z": -22.1546688079834
            },
            {
                "x": -1.9883778095245361,
                "y": -0.06503167748451233,
                "z": -22.004295349121094
            },
            {
                "x": -1.9432522058486938,
                "y": -0.06382231414318085,
                "z": -21.85413932800293
            },
            {
                "x": -1.8977888822555542,
                "y": -0.0623619444668293,
                "z": -21.7039737701416
            },
            {
                "x": -1.8520375490188599,
                "y": -0.06056623533368111,
                "z": -21.553638458251953
            },
            {
                "x": -1.8061680793762207,
                "y": -0.05839148908853531,
                "z": -21.403318405151367
            },
            {
                "x": -1.7602332830429077,
                "y": -0.05588887259364128,
                "z": -21.252765655517578
            },
            {
                "x": -1.7143765687942505,
                "y": -0.0529877170920372,
                "z": -21.102041244506836
            },
            {
                "x": -1.6687601804733276,
                "y": -0.04959749057888985,
                "z": -20.95119285583496
            },
            {
                "x": -1.6234445571899414,
                "y": -0.04564845561981201,
                "z": -20.799983978271484
            },
            {
                "x": -1.5786128044128418,
                "y": -0.04108428582549095,
                "z": -20.64861297607422
            },
            {
                "x": -1.5343562364578247,
                "y": -0.03582150861620903,
                "z": -20.4969482421875
            },
            {
                "x": -1.4907675981521606,
                "y": -0.029759550467133522,
                "z": -20.344768524169922
            },
            {
                "x": -1.4480279684066772,
                "y": -0.023045580834150314,
                "z": -20.192487716674805
            },
            {
                "x": -1.4061709642410278,
                "y": -0.01694163866341114,
                "z": -20.039875030517578
            },
            {
                "x": -1.3796764612197876,
                "y": -0.01363417413085699,
                "z": -19.941078186035156
            },
            {
                "x": -1.3394681215286255,
                "y": -0.009475810453295708,
                "z": -19.787818908691406
            },
            {
                "x": -1.3003132343292236,
                "y": -0.006605897564440966,
                "z": -19.634092330932617
            },
            {
                "x": -1.2623413801193237,
                "y": -0.005193830002099276,
                "z": -19.480018615722656
            },
            {
                "x": -1.225542664527893,
                "y": -0.005000028759241104,
                "z": -19.32570457458496
            },
            {
                "x": -1.1899020671844482,
                "y": -0.004999998956918716,
                "z": -19.170948028564453
            },
            {
                "x": -1.1555320024490356,
                "y": -0.005000002682209015,
                "z": -19.016048431396484
            },
            {
                "x": -1.1223695278167725,
                "y": -0.005000006407499313,
                "z": -18.86089515686035
            },
            {
                "x": -1.0903595685958862,
                "y": -0.005000006407499313,
                "z": -18.705310821533203
            },
            {
                "x": -1.0595462322235107,
                "y": -0.004999998956918716,
                "z": -18.549747467041016
            },
            {
                "x": -1.029913067817688,
                "y": -0.00500001385807991,
                "z": -18.3939208984375
            },
            {
                "x": -1.0013632774353027,
                "y": -0.00500001385807991,
                "z": -18.237974166870117
            },
            {
                "x": -0.9738736748695374,
                "y": -0.004999995231628418,
                "z": -18.081937789916992
            },
            {
                "x": -0.9473459124565125,
                "y": -0.005000006407499313,
                "z": -17.925613403320312
            },
            {
                "x": -0.9218325614929199,
                "y": -0.004999998956918716,
                "z": -17.769405364990234
            },
            {
                "x": -0.8971731662750244,
                "y": -0.004999995231628418,
                "z": -17.613113403320312
            },
            {
                "x": -0.8733060359954834,
                "y": -0.005000002682209015,
                "z": -17.45669174194336
            },
            {
                "x": -0.8502252697944641,
                "y": -0.004999998956918716,
                "z": -17.30034637451172
            },
            {
                "x": -0.8277977108955383,
                "y": -0.005000006407499313,
                "z": -17.143871307373047
            },
            {
                "x": -0.8059650659561157,
                "y": -0.005000002682209015,
                "z": -16.987407684326172
            },
            {
                "x": -0.7846728563308716,
                "y": -0.005000002682209015,
                "z": -16.831071853637695
            },
            {
                "x": -0.7638481855392456,
                "y": -0.005000002682209015,
                "z": -16.67475700378418
            },
            {
                "x": -0.7433963418006897,
                "y": -0.005000010132789612,
                "z": -16.518468856811523
            },
            {
                "x": -0.7232415080070496,
                "y": -0.005000006407499313,
                "z": -16.36223793029785
            },
            {
                "x": -0.7032842636108398,
                "y": -0.005000006407499313,
                "z": -16.20586585998535
            },
            {
                "x": -0.6835019588470459,
                "y": -0.005000002682209015,
                "z": -16.049776077270508
            },
            {
                "x": -0.6637741923332214,
                "y": -0.005000006407499313,
                "z": -15.893749237060547
            },
            {
                "x": -0.6440179944038391,
                "y": -0.005000002682209015,
                "z": -15.73755168914795
            },
            {
                "x": -0.6246446371078491,
                "y": -0.005000002682209015,
                "z": -15.580570220947266
            },
            {
                "x": -0.6061557531356812,
                "y": -0.005000006407499313,
                "z": -15.4232759475708
            },
            {
                "x": -0.588448703289032,
                "y": -0.004999995231628418,
                "z": -15.266291618347168
            },
            {
                "x": -0.5713368654251099,
                "y": -0.005000006407499313,
                "z": -15.109395980834961
            },
            {
                "x": -0.5546757578849792,
                "y": -0.005000006407499313,
                "z": -14.952486038208008
            },
            {
                "x": -0.5383663773536682,
                "y": -0.005000017583370209,
                "z": -14.795809745788574
            },
            {
                "x": -0.5222529768943787,
                "y": -0.004999995231628418,
                "z": -14.63915729522705
            },
            {
                "x": -0.5062355995178223,
                "y": -0.005000002682209015,
                "z": -14.482565879821777
            },
            {
                "x": -0.4902859330177307,
                "y": -0.005000010132789612,
                "z": -14.326093673706055
            },
            {
                "x": -0.4743618965148926,
                "y": -0.00500001385807991,
                "z": -14.169536590576172
            },
            {
                "x": -0.458465576171875,
                "y": -0.005000006407499313,
                "z": -14.013102531433105
            },
            {
                "x": -0.44257089495658875,
                "y": -0.005000006407499313,
                "z": -13.856684684753418
            },
            {
                "x": -0.42664390802383423,
                "y": -0.005000002682209015,
                "z": -13.700084686279297
            },
            {
                "x": -0.41071373224258423,
                "y": -0.005000006407499313,
                "z": -13.543697357177734
            },
            {
                "x": -0.3947484493255615,
                "y": -0.004999995231628418,
                "z": -13.387324333190918
            },
            {
                "x": -0.3844144940376282,
                "y": -0.005000006407499313,
                "z": -13.286324501037598
            },
            {
                "x": -0.36837318539619446,
                "y": -0.005000002682209015,
                "z": -13.129975318908691
            },
            {
                "x": -0.35226523876190186,
                "y": -0.004999995231628418,
                "z": -12.97353458404541
            },
            {
                "x": -0.3360993266105652,
                "y": -0.005000002682209015,
                "z": -12.817106246948242
            },
            {
                "x": -0.3198849558830261,
                "y": -0.005000006407499313,
                "z": -12.660780906677246
            },
            {
                "x": -0.3035978674888611,
                "y": -0.004999995231628418,
                "z": -12.504355430603027
            },
            {
                "x": -0.2872608006000519,
                "y": -0.005000006407499313,
                "z": -12.348045349121094
            },
            {
                "x": -0.27086305618286133,
                "y": -0.004999995231628418,
                "z": -12.191741943359375
            },
            {
                "x": -0.254384309053421,
                "y": -0.004999998956918716,
                "z": -12.035243034362793
            },
            {
                "x": -0.23786957561969757,
                "y": -0.005000006407499313,
                "z": -11.878954887390137
            },
            {
                "x": -0.22121036052703857,
                "y": -0.005000002682209015,
                "z": -11.723090171813965
            },
            {
                "x": -0.20387232303619385,
                "y": -0.005000006407499313,
                "z": -11.567666053771973
            },
            {
                "x": -0.18576458096504211,
                "y": -0.00500001385807991,
                "z": -11.412317276000977
            },
            {
                "x": -0.16690878570079803,
                "y": -0.004999998956918716,
                "z": -11.256775856018066
            },
            {
                "x": -0.14744749665260315,
                "y": -0.005000010132789612,
                "z": -11.101432800292969
            },
            {
                "x": -0.1274234801530838,
                "y": -0.005000010132789612,
                "z": -10.946081161499023
            },
            {
                "x": -0.10687289386987686,
                "y": -0.004999998956918716,
                "z": -10.790610313415527
            },
            {
                "x": -0.08590152859687805,
                "y": -0.00500001385807991,
                "z": -10.63522720336914
            },
            {
                "x": -0.06455585360527039,
                "y": -0.005000010132789612,
                "z": -10.479714393615723
            },
            {
                "x": -0.042914018034935,
                "y": -0.004999998956918716,
                "z": -10.324169158935547
            },
            {
                "x": -0.021044772118330002,
                "y": -0.004999998956918716,
                "z": -10.168427467346191
            },
            {
                "x": 0.0004910556599497795,
                "y": -0.004999995231628418,
                "z": -10.011877059936523
            },
            {
                "x": 0.021281493827700615,
                "y": -0.005000010132789612,
                "z": -9.855168342590332
            },
            {
                "x": 0.04130365699529648,
                "y": -0.005000006407499313,
                "z": -9.698355674743652
            },
            {
                "x": 0.06056071072816849,
                "y": -0.005000002682209015,
                "z": -9.541243553161621
            },
            {
                "x": 0.07903102785348892,
                "y": -0.005000006407499313,
                "z": -9.384243965148926
            },
            {
                "x": 0.09674569219350815,
                "y": -0.004999995231628418,
                "z": -9.227099418640137
            },
            {
                "x": 0.11367271095514297,
                "y": -0.005000002682209015,
                "z": -9.06987476348877
            },
            {
                "x": 0.12982366979122162,
                "y": -0.005000006407499313,
                "z": -8.912630081176758
            },
            {
                "x": 0.14524374902248383,
                "y": -0.005000006407499313,
                "z": -8.755121231079102
            },
            {
                "x": 0.15989962220191956,
                "y": -0.004999998956918716,
                "z": -8.597748756408691
            },
            {
                "x": 0.17378677427768707,
                "y": -0.005000002682209015,
                "z": -8.440326690673828
            },
            {
                "x": 0.1869664043188095,
                "y": -0.005000006407499313,
                "z": -8.282740592956543
            },
            {
                "x": 0.1994350254535675,
                "y": -0.005000006407499313,
                "z": -8.125237464904785
            },
            {
                "x": 0.2112143635749817,
                "y": -0.004999995231628418,
                "z": -7.967608451843262
            },
            {
                "x": 0.22231635451316833,
                "y": -0.005000008270144463,
                "z": -7.809958457946777
            },
            {
                "x": 0.23278339207172394,
                "y": -0.005000006407499313,
                "z": -7.6524128913879395
            },
            {
                "x": 0.24269913136959076,
                "y": -0.005000004544854164,
                "z": -7.494857311248779
            },
            {
                "x": 0.25218573212623596,
                "y": -0.004999998956918716,
                "z": -7.337571144104004
            },
            {
                "x": 0.26143544912338257,
                "y": -0.005000000819563866,
                "z": -7.180459022521973
            },
            {
                "x": 0.270633727312088,
                "y": -0.005000000819563866,
                "z": -7.023336887359619
            },
            {
                "x": 0.2799328863620758,
                "y": -0.004999998956918716,
                "z": -6.866622447967529
            },
            {
                "x": 0.2895486056804657,
                "y": -0.005000006407499313,
                "z": -6.7101359367370605
            },
            {
                "x": 0.29600176215171814,
                "y": -0.005000000819563866,
                "z": -6.60906982421875
            },
            {
                "x": 0.30611246824264526,
                "y": -0.005000000819563866,
                "z": -6.451572895050049
            },
            {
                "x": 0.314922958612442,
                "y": -0.004999998956918716,
                "z": -6.292511463165283
            },
            {
                "x": 0.32180196046829224,
                "y": -0.004999995231628418,
                "z": -6.133241653442383
            },
            {
                "x": 0.3267800807952881,
                "y": -0.0050000157207250595,
                "z": -5.974093914031982
            },
            {
                "x": 0.32994434237480164,
                "y": -0.005000006407499313,
                "z": -5.8150739669799805
            },
            {
                "x": 0.332059383392334,
                "y": -0.005000004544854164,
                "z": -5.657433986663818
            },
            {
                "x": 0.33399054408073425,
                "y": -0.005000004544854164,
                "z": -5.500060558319092
            },
            {
                "x": 0.3357948958873749,
                "y": -0.005000000819563866,
                "z": -5.342503547668457
            },
            {
                "x": 0.3374735414981842,
                "y": -0.005000004544854164,
                "z": -5.18515157699585
            },
            {
                "x": 0.33898037672042847,
                "y": -0.005000004544854164,
                "z": -5.027349472045898
            },
            {
                "x": 0.3393873870372772,
                "y": -0.005000008270144463,
                "z": -4.868446350097656
            },
            {
                "x": 0.3382822573184967,
                "y": -0.005000002682209015,
                "z": -4.709706783294678
            },
            {
                "x": 0.3358597159385681,
                "y": -0.004999995231628418,
                "z": -4.550998687744141
            },
            {
                "x": 0.33229929208755493,
                "y": -0.005000002682209015,
                "z": -4.392746448516846
            },
            {
                "x": 0.32786086201667786,
                "y": -0.005000004544854164,
                "z": -4.234736442565918
            },
            {
                "x": 0.3227442502975464,
                "y": -0.004999995231628418,
                "z": -4.076854705810547
            },
            {
                "x": 0.3171558380126953,
                "y": -0.005000008270144463,
                "z": -3.9193174839019775
            },
            {
                "x": 0.3112892508506775,
                "y": -0.005000002682209015,
                "z": -3.7619237899780273
            },
            {
                "x": 0.30537864565849304,
                "y": -0.005000000819563866,
                "z": -3.604752779006958
            },
            {
                "x": 0.29951223731040955,
                "y": -0.004999998956918716,
                "z": -3.447486639022827
            },
            {
                "x": 0.29329913854599,
                "y": -0.005000000819563866,
                "z": -3.289968490600586
            },
            {
                "x": 0.28676697611808777,
                "y": -0.005000008270144463,
                "z": -3.1326215267181396
            },
            {
                "x": 0.2800806760787964,
                "y": -0.005000006407499313,
                "z": -2.9754464626312256
            },
            {
                "x": 0.2733931243419647,
                "y": -0.005000002682209015,
                "z": -2.8182363510131836
            },
            {
                "x": 0.26687148213386536,
                "y": -0.004999997094273567,
                "z": -2.661395788192749
            },
            {
                "x": 0.2606910467147827,
                "y": -0.004999997094273567,
                "z": -2.504661798477173
            },
            {
                "x": 0.25497955083847046,
                "y": -0.005000006407499313,
                "z": -2.3479809761047363
            },
            {
                "x": 0.2496594935655594,
                "y": -0.005000000819563866,
                "z": -2.1911563873291016
            },
            {
                "x": 0.24451982975006104,
                "y": -0.005000006407499313,
                "z": -2.033905267715454
            },
            {
                "x": 0.23936405777931213,
                "y": -0.004999995231628418,
                "z": -1.8766345977783203
            },
            {
                "x": 0.23399008810520172,
                "y": -0.004999998956918716,
                "z": -1.7191764116287231
            },
            {
                "x": 0.22821654379367828,
                "y": -0.005000000819563866,
                "z": -1.5614323616027832
            },
            {
                "x": 0.2218872606754303,
                "y": -0.005000004544854164,
                "z": -1.4036678075790405
            },
            {
                "x": 0.2148227095603943,
                "y": -0.005000000819563866,
                "z": -1.2456969022750854
            },
            {
                "x": 0.20694828033447266,
                "y": -0.005000008270144463,
                "z": -1.087680459022522
            },
            {
                "x": 0.19836610555648804,
                "y": -0.004999995231628418,
                "z": -0.9302560091018677
            },
            {
                "x": 0.1897602379322052,
                "y": -0.005000000819563866,
                "z": -0.7733073234558105
            },
            {
                "x": 0.18143999576568604,
                "y": -0.005000000819563866,
                "z": -0.6167094707489014
            },
            {
                "x": 0.17371179163455963,
                "y": -0.005000002682209015,
                "z": -0.4605211913585663
            },
            {
                "x": 0.1671331375837326,
                "y": -0.005000000819563866,
                "z": -0.3048765957355499
            },
            {
                "x": 0.16275468468666077,
                "y": -0.005000011995434761,
                "z": -0.15083977580070496
            },
            {
                "x": 0.16238558292388916,
                "y": -0.004999998956918716,
                "z": 0.0017955949297174811
            }
        ]
    }
}